webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(5);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(10);
	
	var _app = __webpack_require__(12);
	
	var _auth = __webpack_require__(13);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(25);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _admin = __webpack_require__(42);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _navbar = __webpack_require__(46);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(48);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _main = __webpack_require__(50);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _app2 = __webpack_require__(14);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(16);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _bcnavbar = __webpack_require__(53);
	
	var _bcnavbar2 = _interopRequireDefault(_bcnavbar);
	
	var _messagesidebar = __webpack_require__(55);
	
	var _messagesidebar2 = _interopRequireDefault(_messagesidebar);
	
	var _sidebarnav = __webpack_require__(57);
	
	var _sidebarnav2 = _interopRequireDefault(_sidebarnav);
	
	var _sidebarfooter = __webpack_require__(59);
	
	var _sidebarfooter2 = _interopRequireDefault(_sidebarfooter);
	
	var _mainheaderauth = __webpack_require__(61);
	
	var _mainheaderauth2 = _interopRequireDefault(_mainheaderauth);
	
	var _sidebaractivity = __webpack_require__(63);
	
	var _sidebaractivity2 = _interopRequireDefault(_sidebaractivity);
	
	var _furtherguidance = __webpack_require__(65);
	
	var _furtherguidance2 = _interopRequireDefault(_furtherguidance);
	
	var _mapsidebar = __webpack_require__(67);
	
	var _mapsidebar2 = _interopRequireDefault(_mapsidebar);
	
	var _maptoolbar = __webpack_require__(69);
	
	var _maptoolbar2 = _interopRequireDefault(_maptoolbar);
	
	var _selecthousingpolicies = __webpack_require__(71);
	
	var _selecthousingpolicies2 = _interopRequireDefault(_selecthousingpolicies);
	
	var _maintocselection = __webpack_require__(73);
	
	var _maintocselection2 = _interopRequireDefault(_maintocselection);
	
	var _maintocselectiondensity = __webpack_require__(75);
	
	var _maintocselectiondensity2 = _interopRequireDefault(_maintocselectiondensity);
	
	var _note = __webpack_require__(77);
	
	var _note2 = _interopRequireDefault(_note);
	
	var _pageintro = __webpack_require__(79);
	
	var _pageintro2 = _interopRequireDefault(_pageintro);
	
	var _statuspills = __webpack_require__(81);
	
	var _statuspills2 = _interopRequireDefault(_statuspills);
	
	var _submissionsectionsubmit = __webpack_require__(83);
	
	var _submissionsectionsubmit2 = _interopRequireDefault(_submissionsectionsubmit);
	
	var _submissionsectionconfirmation = __webpack_require__(85);
	
	var _submissionsectionconfirmation2 = _interopRequireDefault(_submissionsectionconfirmation);
	
	var _handsontable = __webpack_require__(87);
	
	var _handsontable2 = _interopRequireDefault(_handsontable);
	
	var _tablesortbuttons = __webpack_require__(89);
	
	var _tablesortbuttons2 = _interopRequireDefault(_tablesortbuttons);
	
	var _dropdown = __webpack_require__(91);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _notificationmessages = __webpack_require__(93);
	
	var _notificationmessages2 = _interopRequireDefault(_notificationmessages);
	
	var _tabmodal = __webpack_require__(95);
	
	var _tabmodal2 = _interopRequireDefault(_tabmodal);
	
	var _parking = __webpack_require__(97);
	
	var _parking2 = _interopRequireDefault(_parking);
	
	var _parking_requirements = __webpack_require__(100);
	
	var _parking_requirements2 = _interopRequireDefault(_parking_requirements);
	
	var _vehicle_parking = __webpack_require__(103);
	
	var _vehicle_parking2 = _interopRequireDefault(_vehicle_parking);
	
	var _parking_policies = __webpack_require__(106);
	
	var _parking_policies2 = _interopRequireDefault(_parking_policies);
	
	var _bicycle_parking = __webpack_require__(109);
	
	var _bicycle_parking2 = _interopRequireDefault(_bicycle_parking);
	
	var _data = __webpack_require__(112);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _map = __webpack_require__(115);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _dashboard = __webpack_require__(119);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _myaccount = __webpack_require__(122);
	
	var _myaccount2 = _interopRequireDefault(_myaccount);
	
	var _density = __webpack_require__(125);
	
	var _density2 = _interopRequireDefault(_density);
	
	var _density_requirements = __webpack_require__(128);
	
	var _density_requirements2 = _interopRequireDefault(_density_requirements);
	
	var _density_compliance = __webpack_require__(131);
	
	var _density_compliance2 = _interopRequireDefault(_density_compliance);
	
	var _commercial_uses = __webpack_require__(134);
	
	var _commercial_uses2 = _interopRequireDefault(_commercial_uses);
	
	var _residential_uses = __webpack_require__(137);
	
	var _residential_uses2 = _interopRequireDefault(_residential_uses);
	
	var _housing = __webpack_require__(140);
	
	var _housing2 = _interopRequireDefault(_housing);
	
	var _housing_requirements = __webpack_require__(143);
	
	var _housing_requirements2 = _interopRequireDefault(_housing_requirements);
	
	var _guidance = __webpack_require__(146);
	
	var _guidance2 = _interopRequireDefault(_guidance);
	
	var _commercial_stabilization = __webpack_require__(149);
	
	var _commercial_stabilization2 = _interopRequireDefault(_commercial_stabilization);
	
	var _housing_preservation = __webpack_require__(152);
	
	var _housing_preservation2 = _interopRequireDefault(_housing_preservation);
	
	var _housing_production = __webpack_require__(155);
	
	var _housing_production2 = _interopRequireDefault(_housing_production);
	
	var _housing_protection = __webpack_require__(158);
	
	var _housing_protection2 = _interopRequireDefault(_housing_protection);
	
	var _manageusers = __webpack_require__(161);
	
	var _manageusers2 = _interopRequireDefault(_manageusers);
	
	var _stations = __webpack_require__(164);
	
	var _stations2 = _interopRequireDefault(_stations);
	
	var _stationaccess = __webpack_require__(167);
	
	var _stationaccess2 = _interopRequireDefault(_stationaccess);
	
	var _station_requirements = __webpack_require__(170);
	
	var _station_requirements2 = _interopRequireDefault(_station_requirements);
	
	var _analysis_improvement_program = __webpack_require__(173);
	
	var _analysis_improvement_program2 = _interopRequireDefault(_analysis_improvement_program);
	
	var _complete_streets = __webpack_require__(176);
	
	var _complete_streets2 = _interopRequireDefault(_complete_streets);
	
	var _mobility_hub = __webpack_require__(179);
	
	var _mobility_hub2 = _interopRequireDefault(_mobility_hub);
	
	var _project_prioritization = __webpack_require__(182);
	
	var _project_prioritization2 = _interopRequireDefault(_project_prioritization);
	
	var _feedback = __webpack_require__(185);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _compliance = __webpack_require__(188);
	
	var _compliance2 = _interopRequireDefault(_compliance);
	
	var _submissions = __webpack_require__(191);
	
	var _submissions2 = _interopRequireDefault(_submissions);
	
	var _jurisdictions = __webpack_require__(194);
	
	var _jurisdictions2 = _interopRequireDefault(_jurisdictions);
	
	var _station_areas = __webpack_require__(197);
	
	var _station_areas2 = _interopRequireDefault(_station_areas);
	
	var _toc_policy = __webpack_require__(200);
	
	var _toc_policy2 = _interopRequireDefault(_toc_policy);
	
	var _documents = __webpack_require__(203);
	
	var _documents2 = _interopRequireDefault(_documents);
	
	var _registerSuccess = __webpack_require__(206);
	
	var _registerSuccess2 = _interopRequireDefault(_registerSuccess);
	
	var _accountNotActive = __webpack_require__(209);
	
	var _accountNotActive2 = _interopRequireDefault(_accountNotActive);
	
	var _messages = __webpack_require__(212);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _messageDetail = __webpack_require__(316);
	
	var _messageDetail2 = _interopRequireDefault(_messageDetail);
	
	var _message = __webpack_require__(318);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _zoning_updatesComponent = __webpack_require__(321);
	
	var _zoning_updatesComponent2 = _interopRequireDefault(_zoning_updatesComponent);
	
	var _baseConfig = __webpack_require__(397);
	
	var _baseConfig2 = _interopRequireDefault(_baseConfig);
	
	var _users = __webpack_require__(398);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _feedbackService = __webpack_require__(399);
	
	var _feedbackService2 = _interopRequireDefault(_feedbackService);
	
	var _navService = __webpack_require__(400);
	
	var _navService2 = _interopRequireDefault(_navService);
	
	var _fetch = __webpack_require__(401);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _lookup = __webpack_require__(402);
	
	var _lookup2 = _interopRequireDefault(_lookup);
	
	var _map3 = __webpack_require__(403);
	
	var _map4 = _interopRequireDefault(_map3);
	
	var _fileUploadService = __webpack_require__(404);
	
	var _fileUploadService2 = _interopRequireDefault(_fileUploadService);
	
	var _angularfire = __webpack_require__(405);
	
	var _angularfire2 = _interopRequireDefault(_angularfire);
	
	var _angularSmartTable = __webpack_require__(413);
	
	var _angularSmartTable2 = _interopRequireDefault(_angularSmartTable);
	
	__webpack_require__(415);
	
	__webpack_require__(433);
	
	__webpack_require__(435);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('tocApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _account2.default, _admin2.default, 'validation.match', _navbar2.default, _footer2.default, _main2.default, _app3.default, _util2.default, _parking2.default, _data2.default, _map2.default, _dashboard2.default, _myaccount2.default, _zoning_updatesComponent2.default, _stationaccess2.default, _compliance2.default, _jurisdictions2.default, _station_areas2.default, _submissions2.default, _commercial_stabilization2.default, _housing_preservation2.default, _housing_production2.default, _housing_protection2.default, _registerSuccess2.default, _accountNotActive2.default, _density2.default, _commercial_uses2.default, _parking_requirements2.default, _station_requirements2.default, _density_requirements2.default, _housing_requirements2.default, _density_compliance2.default, _residential_uses2.default, _housing2.default, _vehicle_parking2.default, _parking_policies2.default, _bicycle_parking2.default, _analysis_improvement_program2.default, _guidance2.default, _mobility_hub2.default, _project_prioritization2.default, _complete_streets2.default, _toc_policy2.default, _documents2.default, _manageusers2.default, _feedback2.default, _stations2.default, _baseConfig2.default, _users2.default, _feedbackService2.default, _navService2.default, _bcnavbar2.default, _sidebarnav2.default, _sidebarfooter2.default, _mainheaderauth2.default, _messagesidebar2.default, _sidebaractivity2.default, _mapsidebar2.default, _maptoolbar2.default, _selecthousingpolicies2.default, _maintocselection2.default, _maintocselectiondensity2.default, _note2.default, _tabmodal2.default, _pageintro2.default, _statuspills2.default, _submissionsectionsubmit2.default, _submissionsectionconfirmation2.default, _handsontable2.default, _tablesortbuttons2.default, _messages2.default, _message2.default, _messageDetail2.default, _dropdown2.default, 'firebase', _angularSmartTable2.default, _fetch2.default, _fileUploadService2.default, _lookup2.default, _map4.default, _notificationmessages2.default]).config(_app.routeConfig).run(function ($rootScope, $location, Auth, FB, $cookies, navService, $timeout) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!$cookies.get('token') && next.authenticate) {
	      $location.path('/login');
	    }
	  });
	});
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['tocApp'], {
	    strictDi: false
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(11);
	module.exports = 'validation.match';


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/*!
	 * angular-validation-match
	 * Checks if one input matches another
	 * @version v1.9.0
	 * @link https://github.com/TheSharpieOne/angular-validation-match
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, angular, undefined){'use strict';
	
	match.$inject = ["$parse"];
	angular.module('validation.match', []);
	
	angular.module('validation.match').directive('match', match);
	
	function match ($parse) {
	    return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function(scope, elem, attrs, ctrl) {
	            if(!ctrl || !attrs.match) {
	                return;
	            }
	
	            var matchGetter = $parse(attrs.match);
	            var caselessGetter = $parse(attrs.matchCaseless);
	            var noMatchGetter = $parse(attrs.notMatch);
	            var matchIgnoreEmptyGetter = $parse(attrs.matchIgnoreEmpty);
	
	            scope.$watch(getMatchValue, function(){
	                ctrl.$$parseAndValidate();
	            });
	
	            ctrl.$validators.match = function(modelValue, viewValue){
	              var matcher = modelValue || viewValue;
	              var match = getMatchValue();
	              var notMatch = noMatchGetter(scope);
	              var value;
	
	              if (matchIgnoreEmptyGetter(scope) && !viewValue) {
	                return true;
	              }
	
	              if(caselessGetter(scope)){
	                value = angular.lowercase(matcher) === angular.lowercase(match);
	              }else{
	                value = matcher === match;
	              }
	              /*jslint bitwise: true */
	              value ^= notMatch;
	              /*jslint bitwise: false */
	              return !!value;
	            };
	
	            function getMatchValue(){
	                var match = matchGetter(scope);
	                if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
	                    match = match.$viewValue;
	                }
	                return match;
	            }
	        }
	    };
	}
	})(window, window.angular);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(14);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(16);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(18);
	
	var _router = __webpack_require__(19);
	
	var _auth = __webpack_require__(20);
	
	var _firebase = __webpack_require__(23);
	
	var _user = __webpack_require__(24);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('tocApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('FB', _firebase.FirebaseService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tocApp.constants', []).constant('appConfig', __webpack_require__(15)).name;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin']
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tocApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	
	      if (config.url.includes('X-Amz-Signature') || config.url.includes('AWSAccessKeyId') || config.url.includes('.s3.') || config.url.includes('amazonaws.com')) {
	        return config;
	      }
	
	      var token = $cookies.get('token');
	      if (token) {
	        config.headers.Authorization = 'Bearer ' + token;
	      }
	
	      config.headers['Content-Type'] = 'application/json';
	
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401 && !response.config.skipAuthRedirect) {
	        var currentPath = $injector.get('$location').path();
	
	        if (currentPath !== '/') {
	          (state || (state = $injector.get('$state'))).go('login');
	
	          $cookies.remove('token');
	        }
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth, $cookies) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (next.authenticate) {
	      if ($cookies.getAll().token) {
	        return;
	      } else {
	        event.preventDefault();
	        $state.go('login');
	      }
	    }
	  });
	}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthService = AuthService;
	
	var _lodash = __webpack_require__(21);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	  _classCallCheck(this, _User);
	
	  this._id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User, $firebaseAuth) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = appConfig.userRoles || [];
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $firebaseAuth.$signInWithEmailAndPassword(email, password).then(function (res) {
	        $cookies.put('token', res.Dd);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token');
	      currentUser = new _User();
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var is = _.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return Auth.hasRole(Reflect.apply([].concat, ['admin'], args));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('admin');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FirebaseService = FirebaseService;
	
	var _lodash = __webpack_require__(21);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function FirebaseService($location, $http, $cookies, $q, appConfig, Util, User, $firebaseAuth, $rootScope, baseConfigService) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = {};
	  var role;
	  var userRoles = appConfig.userRoles || [];
	  var adminBaseURL = baseConfigService.getAdminBaseURL();
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  if ($cookies.get('token') && $location.path() !== '/logout') {
	    $http.get(adminBaseURL + '/users/me/toc_app').then(function (user) {
	      currentUser = user.data;
	      role = currentUser.role;
	    }).catch(function (err) {
	      console.log(err);
	      $location.path('/');
	      $cookies.remove('token');
	      $rootScope.currentUser = {};
	    });
	  }
	
	  var FB = {
	    login: function login(_ref, callback) {
	      var _this = this;
	
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $firebaseAuth().$signInWithEmailAndPassword(email, password).then(function (res) {
	        $cookies.put('token', res.Dd);
	        return $http.get(adminBaseURL + '/firebase/callback').then(function (response) {
	          $cookies.remove('token');
	          console.log("the login response: ", response.data);
	          if (response.data) {
	            $cookies.put('token', response.data);
	            return _this.getCurrentUser();
	          } else {
	            var message = 'This user is not active. Please contact us...';
	
	            $rootScope.login_error = message;
	            return $q.reject(new Error(message));
	          }
	        }).catch(function (err) {
	          console.log("the error: ", err);
	        });
	      }).catch(function (err) {
	        console.log('the error before logout', err);
	        $rootScope.login_error = err.message || err;
	        FB.logout();
	        safeCb(callback)(err);
	        return $q.reject(err);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token');
	      $firebaseAuth().$signOut();
	      currentUser = {};
	    },
	    createUser: function createUser(user, callback) {
	      return $firebaseAuth().$createUserWithEmailAndPassword(user.email, user.password).then(function (firebaseUser) {
	        firebaseUser.sendEmailVerification().catch(function (error) {
	          var errorCode = error.code;
	
	          var errorMessage = error.message;
	        });
	
	        var socrataUser = {
	          id: firebaseUser.uid,
	          email: firebaseUser.email,
	          firstname: user.firstname,
	          lastname: user.lastname,
	          organization: user.organization
	        };
	
	        return $http.post(adminBaseURL + '/users/new', socrataUser).then(function (response) {}).catch(function (err) {
	          console.log(err);
	        });
	      }).catch(function (error) {
	        console.error("Error creating user:", error);
	
	        throw error;
	      });
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    setCurrentUser: function setCurrentUser(userData) {
	      console.log('Setting current user:', userData);
	
	      return new Promise(function (resolve, reject) {
	        if (userData) {
	          currentUser = userData;
	          $rootScope.currentUser = userData;
	          $rootScope.$broadcast('userDataUpdated', userData);
	          return resolve(currentUser);
	        }
	
	        $http.get(adminBaseURL + '/users/me/toc_app').then(function (response) {
	          console.log('User data fetched:', response.data);
	
	          currentUser = response.data;
	          $rootScope.currentUser = currentUser;
	
	          $cookies.putObject('user', currentUser);
	
	          $rootScope.$broadcast('userDataUpdated', currentUser);
	
	          resolve(currentUser);
	        }).catch(function (err) {
	          console.error('Error setting current user:', err);
	          reject(err);
	        });
	      });
	    },
	    getCurrentUser: function getCurrentUser() {
	      if (currentUser) {
	        return Promise.resolve(currentUser);
	      }
	
	      return this.setCurrentUser();
	    },
	    clearCurrentUser: function clearCurrentUser() {
	      currentUser = null;
	      $rootScope.currentUser = null;
	      $cookies.remove('user');
	      $rootScope.$broadcast('userDataUpdated', null);
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return FB.getCurrentUser(undefined).then(function (user) {
	        var is = _.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return FB.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return FB.hasRole(Reflect.apply([].concat, ['Administrator'], args));
	    },
	    isAdminSync: function isAdminSync() {
	      return FB.hasRoleSync('User');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    }
	  };
	
	  return FB;
	}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('/api/users/:id/:controller', {
	    id: '@_id'
	  }, {
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    }
	  });
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(26);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _login = __webpack_require__(32);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _forgotPassword = __webpack_require__(34);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _resetPassword = __webpack_require__(36);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _settings = __webpack_require__(38);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _signup = __webpack_require__(40);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tocApp.account', [_angularUiRouter2.default, _login2.default, _forgotPassword2.default, _resetPassword2.default, _settings2.default, _signup2.default]).config(_account2.default).run(function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}).name;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('login', {
	    url: '/login',
	    template: __webpack_require__(27),
	    controller: 'LoginController',
	    controllerAs: 'vm'
	  }).state('logout', {
	    url: '/logout?referrer',
	    referrer: 'main',
	    template: '',
	    controller: function controller($state, FB) {
	      'ngInject';
	
	      var referrer = $state.params.referrer || $state.current.referrer || 'main';
	      FB.logout();
	      $state.go(referrer);
	    }
	  }).state('signup', {
	    url: '/signup',
	    template: __webpack_require__(28),
	    controller: 'SignupController',
	    controllerAs: 'vm'
	  }).state('forgot-password', {
	    url: '/forgot-password',
	    template: __webpack_require__(29),
	    controller: 'ForgotPasswordController',
	    controllerAs: 'vm'
	  }).state('reset-password', {
	    url: '/reset-password?token',
	    template: __webpack_require__(30),
	    controller: 'ResetPasswordController',
	    controllerAs: 'vm'
	  }).state('settings', {
	    url: '/settings',
	    template: __webpack_require__(31),
	    controller: 'SettingsController',
	    controllerAs: 'vm',
	    authenticate: true
	  });
	}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  .button--microsoft {\n    background-color: #2F2F2F;\n    color: white;\n    margin-top: 10px;\n  }\n\n  .button--microsoft:hover {\n    background-color: #1E1E1E;\n  }\n\n  .button--microsoft i {\n    margin-right: 8px;\n  }\n\n  .login-divider {\n  text-align: center;\n  margin: 20px 0;\n  position: relative;\n}\n\n.login-divider:before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  border-top: 1px solid #ddd;\n}\n\n.login-divider span {\n  background: #fff;\n  padding: 0 10px;\n  color: #666;\n  position: relative;\n}\n\n.sso-button-container {\n  margin-bottom: 20px;\n}\n</style>\n<section class=\"login\">\n  <div class=\"page-wrapper\">\n    <div class=\"row\">\n      <div class=\"login--image-panel col-md-6\">\n      </div>\n      <div class=\"login--form-panel col-md-6\">\n        <div class=\"login--form-panel--head\">\n          <img class=\"login-form-panel--logo\" src=\"./../../../assets/images/dots.svg\" alt=\"\" role=\"presentation\" />\n          <div class=\"h2\">Bay Area TOC Policy Submission&nbsp;Portal</div>\n        </div>\n        <div class=\"login--form-panel--content\">\n          <div class=\"login-form-panel--title\">\n            <h1>Log In</h1>\n            <a href=\"/signup\" class=\"link link--register\">Register</a>\n          </div>\n          <div class=\"login-form-panel--form\">\n              <form name=\"loginForm\" novalidate>\n              <div class=\"form-item form-item--email\">\n                <label for=\"email\" class=\"form-required\">Email Address</label>\n                <input type=\"email\" id=\"email\" name=\"email\" ng-model=\"vm.user.email\" value=\"\"\n                  placeholder=\"name@email.com\" size=\"60\" maxlength=\"254\" class=\"form-email required\" required\n                  aria-required=\"true\" ng-change=\"vm.clearLoginError()\" />\n              </div>\n              <div ng-if=\"!vm.isMetroEmail(vm.user.email)\">\n              <div class=\"form-item form-item--password\">\n                <label for=\"password\" class=\"form-required\">Password</label>\n                <input type=\"password\" id=\"password\" name=\"password\" ng-model=\"vm.user.password\" size=\"60\"\n                  maxlength=\"128\" class=\"form-text required\" placeholder=\"password\"\n                  required aria-required=\"true\" ng-change=\"vm.clearLoginError()\" />\n                <div class=\"form-item--description\">\n                  <a class=\"link link--forgot-password\" href=\"/forgot-password\">Forgot password?</a>\n                </div>\n              </div>\n              </div>\n              <div class=\"form-group has-error\">\n                <p class=\"help-block\" ng-show=\"vm.submitted && loginForm.email.$error.required\">\n                  Please enter a valid email.\n                </p>\n                <p class=\"help-block\" ng-show=\"vm.submitted && (loginForm.email.$error.email || loginForm.email.$error.pattern)\">\n                  Please enter a valid email.\n                </p>\n                <p class=\"help-block\" ng-show=\"vm.submitted && loginForm.password.$error.required\">\n                  Please enter a password.\n                </p>\n                <p class=\"help-block\">{{ vm.errors.login }}</p>\n              </div>\n              <div class=\"form-item form-item--submit\">\n                <div ng-if=\"!vm.isMetroEmail(vm.user.email)\">\n                <button type=\"submit\" id=\"login-submit\" name=\"login\" class=\"button button--arrow\"\n                  ng-click=\"vm.login(loginForm)\">\n                  <i ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Log In\n                </button>\n                </div>\n                <!-- <button type=\"submit\" id=\"sso-submit\" name=\"login\" class=\"button button--arrow\"\n                  ng-click=\"vm.ssoLogin(loginForm)\">\n                  <i ng-show=\"savingSSO\" class=\"fa-solid fa-cog fa-spin\"></i> SSO\n                </button> -->\n                <div ng-if=\"vm.isMetroEmail(vm.user.email)\">\n                  <button type=\"button\"\n                          id=\"sso-submit\"\n                          name=\"login\"\n                          class=\"button button--arrow button--microsoft\"\n                          ng-click=\"vm.ssoLogin(loginForm)\"\n                          ng-disabled=\"savingSSO\">\n                    <i ng-show=\"savingSSO\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    <i ng-hide=\"savingSSO\" class=\"fa-brands fa-windows\"></i>\n                    Sign in with Microsoft\n                  </button>\n                </div>\n              </div>\n            </form>\n          </div>\n          <div class=\"login-form-panel--footer\">\n            <img class=\"footer-logo\" src=\"./../../../assets/images/mtc_logo.svg\"\n              alt=\"Metropolitan Transportation Commission Logo\" />\n            <img class=\"footer-logo\" src=\"./../../../assets/images/abag_logo.svg\"\n              alt=\"Association of Bay Area Governments Logo\" />\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"login\">\n  <div class=\"page-wrapper\">\n    <div class=\"row\">\n      <div class=\"login--image-panel col-md-6\"></div>\n      <div class=\"login--form-panel col-md-6\">\n        <div class=\"login--form-panel--head\">\n          <img class=\"login-form-panel--logo\" src=\"./../../../assets/images/dots.svg\" alt=\"\" role=\"presentation\" />\n          <div class=\"h2\">Bay Area TOC Policy Submission&nbsp;Portal</div>\n        </div>\n        <div class=\"login--form-panel--content\">\n          <div class=\"login-form-panel--title\">\n            <h1>Register</h1>\n            <a href=\"/login\" class=\"link link--register\">Login</a>\n          </div>\n          <div class=\"login-form-panel--form\">\n            <form name=\"form\" ng-submit=\"vm.register(form)\" novalidate>\n              <div class=\"form-item form-item--text\">\n                <label for=\"firstname\">First Name</label>\n                <input type=\"text\" id=\"firstname\" name=\"firstname\" value=\"\" ng-model=\"vm.user.firstname\"\n                  placeholder=\"First Name\" size=\"60\" maxlength=\"254\" class=\"form-text required\" required=\"required\"\n                  aria-required=\"true\" />\n              </div>\n              <div class=\"form-item form-item--text\">\n                <label for=\"lastname\">Last Name</label>\n                <input type=\"text\" id=\"lastname\" name=\"lastname\" value=\"\" ng-model=\"vm.user.lastname\"\n                  placeholder=\"Last Name\" size=\"60\" maxlength=\"254\" class=\"form-text required\" required=\"required\"\n                  aria-required=\"true\" />\n              </div>\n              <div class=\"form-item form-item--select\">\n                <label for=\"organization\">Jurisdiction</label>\n                <select name=\"organization\" id=\"organization\" ng-model=\"vm.user.organization\">\n                  <option value=\"CTA\">CTA</option>\n                  <option value=\"County Collaborative\">County Collaborative</option>\n                  <option ng-repeat=\"item in jurisdictions\" ng-value=\"item.jurisdiction\">\n                    {{item.jurisdiction}}\n                  </option>\n                </select>\n              </div>\n              <div class=\"form-item form-item--email\">\n                <label for=\"email\" class=\"form-required\">Email Address</label>\n                <input type=\"email\" id=\"email\" name=\"email\" value=\"\" ng-model=\"vm.user.email\"\n                  placeholder=\"name@email.com\" size=\"60\" maxlength=\"254\" class=\"form-email required\" required=\"required\"\n                  aria-required=\"true\" />\n              </div>\n              <div ng-if=\"!vm.isMetroEmail(vm.user.email)\">\n              <div class=\"form-item form-item--password\">\n                <label for=\"password\" class=\"form-required\">Password</label>\n                <input type=\"password\" id=\"password\" name=\"password\" ng-model=\"vm.user.password\" size=\"60\"\n                  maxlength=\"128\" class=\"form-text required\" placeholder=\"password\" required=\"required\"\n                  aria-required=\"true\" />\n              </div>\n              <div class=\"form-item form-item--password\">\n                <label for=\"confirm\" class=\"form-required\">Confirm Password</label>\n                <input type=\"password\" id=\"confirm\" name=\"confirm-password\" ng-model=\"vm.user.confirmpassword\" size=\"60\"\n                  maxlength=\"128\" class=\"form-text required\" placeholder=\"password\" required=\"required\"\n                  aria-required=\"true\" />\n              </div>\n              <div ng-show=\"vm.error\" class=\"form-group alert alert-danger\" role=\"alert\">\n                <p class=\"help-block\">\n                  {{ vm.errorMessage }}\n                </p>\n              </div>\n              <div class=\"form-item form-item--submit\">\n                <button type=\"submit\" id=\"register-submit\" name=\"register\" class=\"button button--arrow\">\n                  Register\n                </button>\n              </div>\n              </div>\n              <div ng-if=\"vm.isMetroEmail(vm.user.email)\" >\n              <div class=\"form-group alert alert-info\" role=\"alert\">\n                MTC and ABAG employees please contact an administrator to create an account or log in if you are already registered to use this application.\n              </div>\n              <button type=\"button\"\n                      id=\"sso-submit\"\n                      name=\"login\"\n                      class=\"button button--arrow button--microsoft\"\n                      ng-click=\"vm.ssoLogin(loginForm)\"\n                      ng-disabled=\"savingSSO\">\n                <i ng-show=\"savingSSO\" class=\"fa-solid fa-cog fa-spin\"></i>\n                <i ng-hide=\"savingSSO\" class=\"fa-brands fa-windows\"></i>\n                Sign in with Microsoft\n              </button>\n              </div>\n            </form>\n          </div>\n          <div class=\"login-form-panel--footer\">\n            <img class=\"footer-logo\" src=\"./../../../assets/images/mtc_logo.svg\"\n              alt=\"Metropolitan Transportation Commission Logo\" />\n            <img class=\"footer-logo\" src=\"./../../../assets/images/abag_logo.svg\"\n              alt=\"Association of Bay Area Governments Logo\" />\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"login\">\n  <div class=\"page-wrapper\">\n    <div class=\"row\">\n      <div class=\"login--image-panel col-md-6\"></div>\n      <div class=\"login--form-panel col-md-6\">\n        <div class=\"login--form-panel--head\">\n          <img class=\"login-form-panel--logo\" src=\"./../../../assets/images/dots.svg\" alt=\"\" role=\"presentation\" />\n          <div class=\"h2\">Bay Area TOC Policy Submission&nbsp;Portal</div>\n        </div>\n        <div class=\"login--form-panel--content\">\n          <div class=\"login-form-panel--title\">\n            <h1>Forgot Password</h1>\n            <a href=\"/login\" class=\"link link--register\">Login</a>\n          </div>\n          <div class=\"login-form-panel--form\">\n            <form name=\"form\" ng-submit=\"vm.submit(form)\" novalidate>\n              <div class=\"form-item form-item--email\">\n                <label for=\"email\" class=\"form-required\">Email Address</label>\n                <input type=\"email\" id=\"email\" name=\"email\" ng-model=\"vm.user.email\"\n                  placeholder=\"name@email.com\" size=\"60\" maxlength=\"254\" class=\"form-email required\" required\n                  aria-required=\"true\" autocomplete=\"username\" />\n              </div>\n\n              <div class=\"form-group has-error\">\n                <p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">\n                  Please enter your email address.\n                </p>\n                <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\n                  Please enter a valid email.\n                </p>\n                <p class=\"help-block\" ng-show=\"vm.error\">{{ vm.error }}</p>\n              </div>\n\n              <div class=\"form-group\" ng-if=\"vm.sent\">\n                <p class=\"help-block\">\n                  A password reset link has been sent if an account exists for that email.\n                </p>\n              </div>\n\n              <div class=\"form-item form-item--submit\">\n                <button type=\"submit\" id=\"forgot-password-submit\" class=\"button button--arrow\" ng-disabled=\"vm.sending\">\n                  <i ng-show=\"vm.sending\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Send Reset Link\n                </button>\n              </div>\n            </form>\n          </div>\n          <div class=\"login-form-panel--footer\">\n            <img class=\"footer-logo\" src=\"./../../../assets/images/mtc_logo.svg\"\n              alt=\"Metropolitan Transportation Commission Logo\" />\n            <img class=\"footer-logo\" src=\"./../../../assets/images/abag_logo.svg\"\n              alt=\"Association of Bay Area Governments Logo\" />\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"login\">\n  <div class=\"page-wrapper\">\n    <div class=\"row\">\n      <div class=\"login--image-panel col-md-6\"></div>\n      <div class=\"login--form-panel col-md-6\">\n        <div class=\"login--form-panel--head\">\n          <img class=\"login-form-panel--logo\" src=\"./../../../assets/images/dots.svg\" alt=\"\" role=\"presentation\" />\n          <div class=\"h2\">Bay Area TOC Policy Submission&nbsp;Portal</div>\n        </div>\n        <div class=\"login--form-panel--content\">\n          <div class=\"login-form-panel--title\">\n            <h1>Reset Password</h1>\n            <a href=\"/login\" class=\"link link--register\">Login</a>\n          </div>\n\n          <!-- Loading state -->\n          <div ng-if=\"vm.verifying\" class=\"alert alert-info\">\n            Verifying your reset link…\n          </div>\n\n          <!-- Error state -->\n          <div ng-if=\"!vm.verifying && vm.error && !vm.resendSent\" class=\"alert alert-danger\">\n            {{ vm.error }}\n          </div>\n\n          <div ng-if=\"!vm.verifying && vm.error\" class=\"login-form-panel--form\">\n            <div class=\"alert alert-success\" ng-if=\"vm.resendSuccessMessage\">\n              {{ vm.resendSuccessMessage }}\n            </div>\n\n            <form name=\"resendForm\" ng-submit=\"vm.resendResetLink(resendForm)\" novalidate>\n              <div class=\"form-item form-item--email\">\n                <label for=\"resendEmail\" class=\"form-required\">Email Address</label>\n                <input type=\"email\" id=\"resendEmail\" name=\"resendEmail\" ng-model=\"vm.resendEmail\"\n                  placeholder=\"name@email.com\" size=\"60\" maxlength=\"254\" class=\"form-email required\" required\n                  aria-required=\"true\" autocomplete=\"username\" />\n                <p class=\"help-block\" ng-show=\"resendForm.resendEmail.$error.required && vm.resendSubmitted\">\n                  Please enter your email address.\n                </p>\n                <p class=\"help-block\" ng-show=\"resendForm.resendEmail.$error.email && vm.resendSubmitted\">\n                  Please enter a valid email.\n                </p>\n              </div>\n\n              <div class=\"form-group has-error\">\n                <p class=\"help-block\" ng-show=\"vm.resendError\">{{ vm.resendError }}</p>\n              </div>\n\n              <div class=\"form-item form-item--submit\">\n                <button type=\"submit\" id=\"resend-reset-link-submit\" class=\"button button--arrow\"\n                  ng-disabled=\"vm.resendSending\">\n                  <i ng-show=\"vm.resendSending\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Send Another Reset Link\n                </button>\n              </div>\n            </form>\n          </div>\n\n          <!-- Reset form -->\n          <div ng-if=\"!vm.verifying && vm.verified\" class=\"login-form-panel--form\">\n            <form name=\"form\" ng-submit=\"vm.submit(form)\" novalidate>\n              <div class=\"form-item form-item--password\">\n                <label for=\"password\" class=\"form-required\">New Password</label>\n                <input type=\"password\" id=\"password\" name=\"password\" ng-model=\"vm.password\"\n                  size=\"60\" maxlength=\"128\" class=\"form-text required\"\n                  placeholder=\"Enter new password\" required aria-required=\"true\"\n                  autocomplete=\"new-password\" />\n                <p class=\"help-block\" ng-show=\"form.password.$error.required && vm.submitted\">\n                  Please enter a password.\n                </p>\n              </div>\n\n              <div class=\"form-item form-item--password\">\n                <label for=\"confirmPassword\" class=\"form-required\">Confirm Password</label>\n                <input type=\"password\" id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\"\n                  size=\"60\" maxlength=\"128\" class=\"form-text required\"\n                  placeholder=\"Confirm new password\" required aria-required=\"true\"\n                  autocomplete=\"new-password\" />\n                <p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required && vm.submitted\">\n                  Please confirm your password.\n                </p>\n                <p class=\"help-block\" ng-show=\"vm.passwordMismatch\">\n                  Passwords do not match. Please try again.\n                </p>\n              </div>\n\n              <div class=\"form-group has-error\">\n                <p class=\"help-block\" ng-show=\"vm.resetError\">{{ vm.resetError }}</p>\n              </div>\n\n              <div class=\"form-item form-item--submit\">\n                <button type=\"submit\" id=\"reset-password-submit\" class=\"button button--arrow\"\n                  ng-disabled=\"vm.resetting\">\n                  <i ng-show=\"vm.resetting\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Update Password\n                </button>\n              </div>\n            </form>\n          </div>\n\n          <div class=\"login-form-panel--footer\">\n            <img class=\"footer-logo\" src=\"./../../../assets/images/mtc_logo.svg\"\n              alt=\"Metropolitan Transportation Commission Logo\" />\n            <img class=\"footer-logo\" src=\"./../../../assets/images/abag_logo.svg\"\n              alt=\"Association of Bay Area Governments Logo\" />\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n\n<!-- Success Modal -->\n<div class=\"modal fade reset-success-modal\" id=\"resetSuccessModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"resetSuccessLabel\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content text-center\">\n      <div class=\"modal-header justify-content-center\">\n        <h5 class=\"modal-title\" id=\"resetSuccessLabel\">Password Updated</h5>\n      </div>\n      <div class=\"modal-body text-center\">\n        Your password has been updated successfully. You can now log in with your new password.\n      </div>\n      <div class=\"modal-footer justify-content-center\">\n        <button type=\"button\" class=\"button button--arrow\" ng-click=\"vm.closeSuccessModal()\">\n          Go to Login\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<style>\n  .reset-success-modal .modal-dialog {\n    max-width: 560px;\n    margin: 1.75rem auto;\n  }\n\n  .reset-success-modal .modal-content {\n    border: 0;\n    border-radius: 16px;\n    background: #f2f4f5;\n    overflow: hidden;\n  }\n\n  .reset-success-modal .modal-header,\n  .reset-success-modal .modal-body,\n  .reset-success-modal .modal-footer {\n    background: #f2f4f5;\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n\n  .reset-success-modal .modal-header {\n    border-bottom: 0;\n    padding-top: 44px;\n    padding-bottom: 8px;\n  }\n\n  .reset-success-modal .modal-title {\n    width: 100%;\n    margin: 0;\n  }\n\n  .reset-success-modal .modal-body {\n    border-top: 0;\n    padding-top: 24px;\n    padding-bottom: 32px;\n    line-height: 1.6;\n    font-size: 1.05rem;\n  }\n\n  .reset-success-modal .modal-footer {\n    border-top: 0;\n    padding-top: 0;\n    padding-bottom: 40px;\n  }\n\n  .reset-success-modal .modal-footer .button {\n    min-width: 240px;\n  }\n</style>\n"

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Change Password</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.changePassword(form)\" novalidate>\n\n        <div class=\"form-group\">\n          <label>Current Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.oldPassword\"\n                 mongoose-error/>\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n              {{ vm.errors.other }}\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>New Password</label>\n\n          <input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required/>\n          <p class=\"help-block\"\n             ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\n            Password must be at least 3 characters.\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Confirm New Password</label>\n\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\n                 match=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required=\"\"/>\n          <p class=\"help-block\"\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n            Passwords must match.\n          </p>\n\n        </div>\n\n        <p class=\"help-block\"> {{ vm.message }} </p>\n\n        <button class=\"btn btn-lg btn-primary\" type=\"submit\">Save changes</button>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(33);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tocApp.login', []).controller('LoginController', _login2.default).name;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	
	  /*@ngInject*/
	  function LoginController(FB, $state, $http, $cookies, $stateParams, baseConfigService, $rootScope, $location, $scope) {
	    _classCallCheck(this, LoginController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	
	    this.FB = FB;
	    this.$state = $state;
	    this.$http = $http;
	    this.$cookies = $cookies;
	    this.baseConfigService = baseConfigService;
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.$scope.saving = false;
	    this.$scope.savingSSO = false;
	
	    this.checkUrlToken();
	  }
	
	  _createClass(LoginController, [{
	    key: 'isMetroEmail',
	    value: function isMetroEmail(email) {
	      if (!email) return false;
	      return email.toLowerCase().endsWith('@bayareametro.gov');
	    }
	  }, {
	    key: 'clearLoginError',
	    value: function clearLoginError() {
	      this.errors.login = undefined;
	      this.$scope.saving = false;
	      this.submitted = false;
	    }
	  }, {
	    key: 'checkEmailDomain',
	    value: function checkEmailDomain() {
	      this.showSSOButton = this.isMetroEmail(this.user.email);
	    }
	  }, {
	    key: 'checkUrlToken',
	    value: function checkUrlToken() {
	      var _this = this;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      var token = this.$location.search().token;
	
	      console.log(this.$location.search().token);
	
	      console.log('Checking URL for token:', token);
	
	      if (token) {
	        console.log('Token found in URL, processing...');
	        this.$cookies.put('token', token);
	
	        this.$http.get(adminBaseURL + '/users/me/toc_app').then(function (user) {
	          console.log("user: ", user.data);
	          if (user.data) {
	            var userInfo = user.data;
	            return _this.FB.setCurrentUser(userInfo).then(function (userData) {
	              console.log('User data set:', userData);
	
	              _this.$location.path('/account/dashboard');
	            });
	          }
	        }).catch(function (err) {
	          console.log("login error: ", err);
	          _this.$location.path('/login');
	        });
	      }
	    }
	  }, {
	    key: 'login',
	    value: function login(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      this.$scope.saving = true;
	      this.errors.login = undefined;
	
	      if (form.$valid) {
	
	        this.FB.login({
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this2.$scope.saving = false;
	
	          var token = _this2.$cookies.get('token');
	          if (token) {
	            _this2.$location.path('/account/dashboard');
	          } else {
	            console.log("Token not found");
	          }
	        }).catch(function (err) {
	          var errCode = err.code;
	          if (errCode === 'auth/user-not-found' || errCode === 'auth/wrong-password') {
	            _this2.errors.login = "Invalid email and/or password";
	          } else {
	            console.log("Login err:", err);
	            _this2.errors.login = _this2.$rootScope.login_error;
	          }
	
	          _this2.$scope.saving = false;
	        });
	      } else {
	        console.log("form errors", form.$error);
	        this.errors.login = form.$error.errors;
	        this.$scope.saving = false;
	      }
	    }
	  }, {
	    key: 'ssoLogin',
	    value: function ssoLogin(form) {
	      this.$scope.savingSSO = true;
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	
	      try {
	        var currentUrl = window.location.href;
	        var returnUrl = '' + window.location.origin;
	        sessionStorage.setItem('loginRedirectUrl', currentUrl);
	
	        setTimeout(function () {
	          var loginUrl = adminBaseURL + '/login?redirect_uri=' + encodeURIComponent(currentUrl) + '&frontend_url=' + encodeURIComponent(returnUrl);
	
	          console.log('Redirecting to:', loginUrl);
	          window.location.href = loginUrl;
	        }, 500);
	      } catch (err) {
	        this.$scope.savingSSO = false;
	        console.error('SSO redirect error:', err);
	        this.errors = {
	          login: 'Failed to initiate SSO login. Please try again.'
	        };
	      }
	    }
	  }, {
	    key: 'checkToken',
	    value: function checkToken() {
	      var token = this.$cookies.get('token');
	      if (!token) {
	        return false;
	      }
	
	      var expiry = this.$cookies.get('token_expiry');
	      if (expiry && new Date(expiry) < new Date()) {
	        this.clearAuthCookies();
	        return false;
	      }
	
	      return true;
	    }
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _forgotPassword = __webpack_require__(35);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tocApp.forgotPassword', []).controller('ForgotPasswordController', _forgotPassword2.default).name;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ForgotPasswordController = function () {
	
	  /*@ngInject*/
	  function ForgotPasswordController($http, baseConfigService, $state, $timeout, $scope) {
	    var _this = this;
	
	    _classCallCheck(this, ForgotPasswordController);
	
	    this.user = {
	      email: ''
	    };
	    this.submitted = false;
	    this.sending = false;
	    this.sent = false;
	    this.error = '';
	    this.redirectPromise = null;
	
	    this.$http = $http;
	    this.baseConfigService = baseConfigService;
	    this.$state = $state;
	    this.$timeout = $timeout;
	
	    $scope.$on('$destroy', function () {
	      if (_this.redirectPromise) {
	        _this.$timeout.cancel(_this.redirectPromise);
	      }
	    });
	  }
	
	  _createClass(ForgotPasswordController, [{
	    key: 'submit',
	    value: function submit(form) {
	      var _this2 = this;
	
	      if (this.sending) {
	        return;
	      }
	
	      this.submitted = true;
	      this.error = '';
	
	      if (!form.$valid) {
	        return;
	      }
	
	      this.sending = true;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      var resetCallbackUrl = window.location.origin + '/reset-password';
	
	      this.$http.post(adminBaseURL + '/email/sendReset', {
	        to_email: this.user.email,
	        reply_to_email: 'trodriguez@bayareametro.gov',
	        subject: 'Reset Your Password',
	        reset_callback_url: resetCallbackUrl
	      }, {
	        skipAuthRedirect: true
	      }).then(function () {
	        _this2.sent = true;
	        _this2.sending = false;
	        _this2.scheduleLoginRedirect();
	      }).catch(function (err) {
	        _this2.sending = false;
	
	        _this2.sent = true;
	        _this2.scheduleLoginRedirect();
	      });
	    }
	  }, {
	    key: 'scheduleLoginRedirect',
	    value: function scheduleLoginRedirect() {
	      var _this3 = this;
	
	      if (this.redirectPromise) {
	        this.$timeout.cancel(this.redirectPromise);
	      }
	
	      this.redirectPromise = this.$timeout(function () {
	        _this3.$state.go('main');
	      }, 7000);
	    }
	  }]);
	
	  return ForgotPasswordController;
	}();
	
	exports.default = ForgotPasswordController;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _resetPassword = __webpack_require__(37);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tocApp.resetPassword', []).controller('ResetPasswordController', _resetPassword2.default).name;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResetPasswordController = function () {
	  /*@ngInject*/
	  function ResetPasswordController($http, $stateParams, $state, $timeout, $scope, baseConfigService) {
	    var _this = this;
	
	    _classCallCheck(this, ResetPasswordController);
	
	    this.$http = $http;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.baseConfigService = baseConfigService;
	
	    this.token = $stateParams.token;
	    this.verified = false;
	    this.verifying = true;
	    this.error = '';
	    this.resetError = '';
	    this.resendError = '';
	    this.password = '';
	    this.confirmPassword = '';
	    this.resendEmail = '';
	    this.resendSubmitted = false;
	    this.resendSending = false;
	    this.resendSent = false;
	    this.resendSuccessMessage = '';
	    this.redirectPromise = null;
	    this.submitted = false;
	    this.resetting = false;
	    this.passwordMismatch = false;
	
	    $scope.$on('$destroy', function () {
	      if (_this.redirectPromise) {
	        _this.$timeout.cancel(_this.redirectPromise);
	      }
	    });
	
	    this.verifyToken();
	  }
	
	  _createClass(ResetPasswordController, [{
	    key: 'verifyToken',
	    value: function verifyToken() {
	      var _this2 = this;
	
	      if (!this.token) {
	        this.verifying = false;
	        this.error = 'No reset token provided. Please request a new password reset link.';
	        return;
	      }
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      this.$http.post(adminBaseURL + '/email/verifyResetToken', { token: this.token }, {
	        skipAuthRedirect: true
	      }).then(function (res) {
	        if (res.data.valid) {
	          _this2.email = res.data.email;
	          _this2.resendEmail = res.data.email;
	        } else {
	          _this2.error = 'This reset link is invalid or has expired. Please request a new one.';
	        }
	        _this2.verified = true;
	        _this2.verifying = false;
	      }).catch(function () {
	        _this2.verifying = false;
	        _this2.error = 'This reset link is invalid or has expired. Please request a new one.';
	      });
	    }
	  }, {
	    key: 'resendResetLink',
	    value: function resendResetLink(form) {
	      var _this3 = this;
	
	      if (this.resendSending) {
	        return;
	      }
	
	      this.resendSubmitted = true;
	      this.resendError = '';
	      this.resendSuccessMessage = '';
	
	      if (!form.$valid) {
	        return;
	      }
	
	      this.resendSending = true;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      var resetCallbackUrl = window.location.origin + '/reset-password';
	
	      this.$http.post(adminBaseURL + '/email/sendReset', {
	        to_email: this.resendEmail,
	        reply_to_email: 'trodriguez@bayareametro.gov',
	        subject: 'Reset Your Password',
	        reset_callback_url: resetCallbackUrl
	      }, {
	        skipAuthRedirect: true
	      }).then(function () {
	        _this3.resendSending = false;
	        _this3.resendSent = true;
	        _this3.resendSuccessMessage = 'If an account exists for that email, a password reset link has been sent.';
	        _this3.scheduleHomeRedirect();
	      }).catch(function () {
	        _this3.resendSending = false;
	        _this3.resendSent = true;
	        _this3.resendSuccessMessage = 'If an account exists for that email, a password reset link has been sent.';
	        _this3.scheduleHomeRedirect();
	      });
	    }
	  }, {
	    key: 'scheduleHomeRedirect',
	    value: function scheduleHomeRedirect() {
	      var _this4 = this;
	
	      if (this.redirectPromise) {
	        this.$timeout.cancel(this.redirectPromise);
	      }
	
	      this.redirectPromise = this.$timeout(function () {
	        _this4.$state.go('main');
	      }, 7000);
	    }
	  }, {
	    key: 'submit',
	    value: function submit(form) {
	      var _this5 = this;
	
	      this.submitted = true;
	      this.resetError = '';
	      this.passwordMismatch = false;
	
	      if (!form.$valid || this.password !== this.confirmPassword) {
	        if (this.password !== this.confirmPassword) {
	          this.passwordMismatch = true;
	        }
	        return;
	      }
	
	      this.resetting = true;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      this.$http.post(adminBaseURL + '/users/update-pwd-tp', {
	        token: this.token,
	        newPassword: this.password
	      }, {
	        skipAuthRedirect: true
	      }).then(function () {
	        _this5.resetting = false;
	        var $modal = $('#resetSuccessModal');
	
	        _this5.registerSuccessModalCleanup($modal, true);
	
	        $modal.modal('show');
	      }).catch(function (err) {
	        _this5.resetting = false;
	        _this5.resetError = 'Failed to reset password. Please try again or request a new link.';
	      });
	    }
	  }, {
	    key: 'registerSuccessModalCleanup',
	    value: function registerSuccessModalCleanup($modal, goToLogin) {
	      var _this6 = this;
	
	      $modal.off('hidden.bs.modal').one('hidden.bs.modal', function () {
	        $('.modal-backdrop').remove();
	        $('body').removeClass('modal-open').css('padding-right', '');
	
	        if (goToLogin) {
	          _this6.goToLogin();
	        }
	      });
	    }
	  }, {
	    key: 'closeSuccessModal',
	    value: function closeSuccessModal() {
	      var $modal = $('#resetSuccessModal');
	      this.registerSuccessModalCleanup($modal, true);
	      $modal.modal('hide');
	    }
	  }, {
	    key: 'goToLogin',
	    value: function goToLogin() {
	      this.$state.go('login');
	    }
	  }]);
	
	  return ResetPasswordController;
	}();
	
	exports.default = ResetPasswordController;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(39);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tocApp.settings', []).controller('SettingsController', _settings2.default).name;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  function SettingsController(Auth) {
	    _classCallCheck(this, SettingsController);
	
	    this.user = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = '';
	    this.submitted = false;
	
	    this.Auth = Auth;
	  }
	
	  _createClass(SettingsController, [{
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this.message = 'Password successfully changed.';
	        }).catch(function () {
	          form.password.$setValidity('mongoose', false);
	          _this.errors.other = 'Incorrect password';
	          _this.message = '';
	        });
	      }
	    }
	  }]);
	
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(41);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tocApp.signup', []).controller('SignupController', _signup2.default).name;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupController = function () {
	
	  /*@ngInject*/
	  function SignupController(FB, $state, $http, fetch, $scope, baseConfigService) {
	    _classCallCheck(this, SignupController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {};
	    this.submitted = false;
	    this.error = false;
	    this.errorMessage = '';
	
	    this.FB = FB;
	    this.$state = $state;
	    this.$http = $http;
	    this.fetch = fetch;
	    this.$scope = $scope;
	    this.baseConfigService = baseConfigService;
	  }
	
	  _createClass(SignupController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.getJurisdictionList();
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/list').then(function (response) {
	
	        _this.$scope.jurisdictions = response.data;
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'isMetroEmail',
	    value: function isMetroEmail(email) {
	      if (!email) return false;
	      return email.toLowerCase().endsWith('@bayareametro.gov');
	    }
	  }, {
	    key: 'register',
	    value: function register(form) {
	      var _this2 = this;
	
	      console.log(form);
	      this.submitted = true;
	      var user = {
	        firstname: this.user.firstname,
	        lastname: this.user.lastname,
	        email: this.user.email,
	        password: this.user.password,
	        organization: this.user.organization
	      };
	      if (form.$valid) {
	        this.$http.get(this.baseConfigService.getAdminBaseURL() + '/users/check-email/' + user.email).then(function (response) {
	          if (response.status === 200) {
	            _this2.error = true;
	            _this2.errorMessage = 'An account with this email already exists. Please use a different email or contact support to reset your password.';
	          } else {
	            _this2.error = true;
	            _this2.errorMessage = 'Error with checking email. Please try again.';
	            return true;
	          }
	        }).catch(function (err) {
	          console.log(err);
	          if (err.status === 404) {
	            return _this2.FB.createUser(user).then(function (data) {
	              console.log(data);
	
	              _this2.error = false;
	              _this2.errorMessage = '';
	              _this2.$state.go('register-success');
	            }).catch(function (err) {
	              console.log(err);
	              err = err.data || err;
	              _this2.errors = {};
	              _this2.error = true;
	              _this2.errorMessage = err.message || 'An error occurred during registration. Please try again.';
	            });
	          } else {
	            _this2.error = true;
	            _this2.errorMessage = 'An unexpected error occurred. Please try again.';
	          }
	        });
	      } else {
	        this.error = true;
	        this.errorMessage = 'Please fill in all required fields.';
	      }
	    }
	  }, {
	    key: 'ssoLogin',
	    value: function ssoLogin(form) {
	      this.$scope.savingSSO = true;
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	
	      try {
	        var currentUrl = window.location.href;
	        var returnUrl = window.location.origin + '/login';
	        sessionStorage.setItem('loginRedirectUrl', currentUrl);
	
	        setTimeout(function () {
	          var loginUrl = adminBaseURL + '/login?redirect_uri=' + encodeURIComponent(returnUrl) + '&frontend_url=' + encodeURIComponent('http://localhost:3000');
	
	          console.log('Redirecting to:', loginUrl);
	          window.location.href = loginUrl;
	        }, 500);
	      } catch (err) {
	        this.$scope.savingSSO = false;
	        console.error('SSO redirect error:', err);
	        this.errors = {
	          login: 'Failed to initiate SSO login. Please try again.'
	        };
	      }
	    }
	  }]);
	
	  return SignupController;
	}();
	
	exports.default = SignupController;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(43);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(45);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('tocApp.admin', ['tocApp.auth', 'ui.router']).config(_admin2.default).controller('AdminController', _admin4.default).name;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('admin', {
	    url: '/admin',
	    template: __webpack_require__(44),
	    controller: 'AdminController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  });
	}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <p>The delete user and user index api routes are restricted to users with the 'admin' role.</p>\n  <ul class=\"list-group user-list\">\n    <li class=\"list-group-item\" ng-repeat=\"user in admin.users\">\n\t    <div class=\"user-info\">\n\t        <strong>{{user.name}}</strong><br>\n\t        <span class=\"text-muted\">{{user.email}}</span>\n\t    </div>\n        <a ng-click=\"admin.delete(user)\" class=\"trash\"><span class=\"fa-solid fa-trash fa-2x\"></span></a>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminController = function () {
	  /*@ngInject*/
	  function AdminController(User) {
	    _classCallCheck(this, AdminController);
	
	    this.users = User.query();
	  }
	
	  _createClass(AdminController, [{
	    key: 'delete',
	    value: function _delete(user) {
	      user.$remove();
	      this.users.splice(this.users.indexOf(user), 1);
	    }
	  }]);
	
	  return AdminController;
	}();
	
	exports.default = AdminController;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = function () {
	  function NavbarComponent(FB, $firebaseAuth, $state, $cookies, $scope, $rootScope, userService) {
	    'ngInject';
	
	    _classCallCheck(this, NavbarComponent);
	
	    this.menu = [{
	      title: 'Home',
	      url: 'main'
	    }];
	    this.isCollapsed = true;
	    this.isLoggedIn = FB.isLoggedInSync;
	    this.userService = userService;
	    this.$scope = $scope;
	
	
	    this.getCurrentUser = FB.getCurrentUserSync;
	    this.$firebaseAuth = $firebaseAuth();
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.isAdmin = FB.isAdminSync;
	
	    $scope.menu = [{
	      title: 'Home',
	      url: '/',
	      dropdown: false,
	      show: 'allViews'
	
	    }, {
	      title: 'About',
	      url: '/about',
	      dropdown: false,
	      show: 'allViews'
	
	    }, {
	      title: 'Tools',
	      url: '/',
	      dropdown: true,
	      show: 'loggedIn',
	      subItem1: [{
	        title: 'Dashboard',
	        url: '/account/dashboard'
	
	      }, {
	        title: 'Map',
	        url: '/account/map'
	      }, {
	        title: 'Parking',
	        url: '/account/parking'
	      }, {
	        title: 'Density',
	        url: '/account/density'
	      }, {
	        title: 'Housing',
	        url: '/account/housing',
	        dropdown: true,
	        show: 'loggedIn',
	        subItem2: [{
	          title: 'Housing Preservation',
	          url: '/account/housing/housing_preservation'
	        }, {
	          title: 'Housing Production',
	          url: '/account/housing/housing_production'
	        }, {
	          title: 'Housing Protection',
	          url: '/account/housing/housing_protection'
	        }, {
	          title: 'Commercial Stabilization',
	          url: '/account/housing/commercial_stabilization'
	        }]
	      }, {
	        title: 'Stations',
	        url: '/account/stationaccess'
	      }]
	    }, {
	      title: 'Account',
	      url: '/',
	      dropdown: true,
	      show: 'loggedIn',
	      subItem1: [{
	        title: 'My Account',
	        url: '/account/myaccount'
	      }, {
	        title: 'Update Password',
	        url: '/account/password'
	      }, {
	        title: 'Logout',
	        url: '/logout?main'
	      }]
	    }];
	
	    $scope.adminMenu = [{
	      title: 'Admin Tools',
	      url: '/',
	      dropdown: true,
	      show: 'loggedIn',
	      admin: true,
	      subItem1: [{
	        title: 'Manage Users',
	        url: '/admin/manageusers',
	        subItem2: [{
	          title: 'Ultrabooks'
	        }, {
	          title: 'Macbooks',
	          subItem2: [{
	            title: 'Alexis'
	          }, {
	            title: 'aNDREY'
	          }]
	        }]
	      }, {
	        title: 'Manage Stations',
	        url: '/admin/stations'
	      }, {
	        title: 'Manage Feedback',
	        url: '/admin/feedback'
	      }]
	    }];
	  }
	
	  _createClass(NavbarComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }]);
	
	  return NavbarComponent;
	}();
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(47),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<header>\n  <!-- header start -->\n  <div class=\"header__branding\">\n    <div class=\"container\">\n      <div class=\"header__logo\">\n        <img class=\"logo\" src=\"../../assets/images/dots.svg\" width=\"40\" height=\"40\" alt=\"\" role=\"presentation\" />\n        <img class=\"logo--overlay\" src=\"../../assets/images/dots-white.svg\" width=\"40\" height=\"40\" alt=\"\"\n          role=\"presentation\" />\n        <div class=\"header__title\">\n          Bay Area TOC Policy Implementation Portal\n        </div>\n      </div>\n      <div class=\"header__actions\">\n        <div class=\"header__user\">\n          <div class=\"header__user-trigger\">\n            <button type=\"button\" class=\"toggle--user-nav\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarUserNav\"\n              aria-controls=\"navbarUserNav\" aria-expanded=\"false\">\n              <span class=\"visually-hidden\">Toggle User Account Navigation</span>\n            </button>\n          </div>\n          <nav class=\"navbar navbar-expand-md header__user-nav\">\n            <div class=\"collapse navbar-collapse\" id=\"navbarUserNav\">\n              <ul class=\"menu navbar-nav me-auto lg-2 mb-md-0\">\n                <li class=\"menu-item nav-item\"  ng-if=\"!currentUser.role\">\n                  <a class=\"nav-link active button header__register\" href=\"/signup\">Register</a>\n                </li>\n                <li class=\"menu-item nav-item\" ng-if=\"!currentUser.role\">\n                  <a class=\"nav-link button header__login\" href=\"/login\">Log In</a>\n                </li>\n                <li class=\"menu-item nav-item\" ng-if=\"currentUser.role\">\n                  <a class=\"nav-link button header__login\" href=\"/logout\">Log Out</a>\n                </li>\n                <li class=\"menu-item nav-item\" ng-if=\"currentUser.role\">\n                  <a class=\"nav-link button header__login\" href=\"/account/dashboard\">Dashboard</a>\n                </li>\n              </ul>\n            </div>\n          </nav>\n        </div>\n        <div class=\"header__menu-trigger\">\n          <button type=\"button\" class=\"toggle--main-nav\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarMainNav\"\n            aria-controls=\"navbarMainNav\" aria-expanded=\"false\">\n            <span class=\"visually-hidden\">Toggle Main Navigation</span>\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"header__navigation\">\n    <div class=\"container\">\n      <nav class=\"navbar navbar-expand-md\">\n        <div class=\"collapse navbar-collapse\" id=\"navbarMainNav\">\n          <ul class=\"navbar-nav me-auto lg-2 mb-md-0\">\n            <li class=\"nav-item\">\n              <a class=\"nav-link active\" aria-current=\"page\" href=\"/\">Home</a>\n            </li>\n            <!-- <li class=\"nav-item\">\n              <a class=\"nav-link\" href=\"/\">About</a>\n            </li> -->\n          </ul>\n        </div>\n      </nav>\n    </div>\n  </div>\n  <!-- header end -->\n</header>"

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = function FooterComponent() {
	  _classCallCheck(this, FooterComponent);
	};
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(49),
	  controller: FooterComponent
	}).name;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = "  <!-- footer start -->\n  <div class=\"container\">\n      <div class=\"row footer__top\">\n          <div class=\"col-lg-4 footer__agency\">\n              <p><a href=\"https://mtc.ca.gov\" title=\"Metropolitan Transportation Commission\" target=\"_blank\" rel=\"noopener noreferrer\"><img class=\"logo-mtc\" alt=\"Metropolitan Transportation Commission logo\" src=\"../../assets/images/mtc_footer_logo.svg\"></a></p>\n              <h3>Metropolitan Transportation Commission</h3>\n              <p>MTC is responsible for planning, financing and coordinating transportation for the nine-county San Francisco Bay Area.</p>\n              <p><a href=\"https://mtc.ca.gov\" class=\"ext\" data-extlink=\"\" target=\"_blank\" rel=\"noopener noreferrer\">mtc.ca.gov<span class=\"fa-ext extlink\"><span class=\"fa-solid fa-external-link\"><span class=\"visually-hidden\">(link is external, opens in a new window)</span></span></span></a></p>\n              <div class=\"footer__social\">\n                  <a class=\"social-icon social-icon--twitter\" href=\"https://twitter.com/mtcbata\" title=\"Find Metropolitan Transportation Commission on Twitter\" target=\"_blank\" rel=\"noopener noreferrer\" aria-label=\"Twitter\"><i class=\"fa-brands fa-x-twitter\"></i><span class=\"visually-hidden\">(link is external, opens in a new window)</span></a>\n                  <a class=\"social-icon social-icon--linkedin\" href=\"https://www.linkedin.com/company/metropolitan-transportation-commission\" title=\"Find Metropolitan Transportation Commission on LinkedIn\" target=\"_blank\" aria-label=\"Linkedin\" rel=\"noopener noreferrer\"><i class=\"fa-brands fa-linkedin-in\"></i><span class=\"visually-hidden\">(link is external, opens in a new window)</span></a>\n                  <a class=\"social-icon social-icon--facebook\" href=\"https://www.facebook.com/MTCBATA\" title=\"Find Metropolitan Transportation Commission on Facebook\" target=\"_blank\" aria-label=\"Facebook\" rel=\"noopener noreferrer\"><i class=\"fa-brands fa-facebook-square\"></i><span class=\"visually-hidden\">(link is external, opens in a new window)</span></a>\n                  <a class=\"social-icon social-icon--instagram\" href=\"https://instagram.com/mtcbata\" title=\"Find Metropolitan Transportation Commission on Instagram\" target=\"_blank\" aria-label=\"Instagram\" rel=\"noopener noreferrer\"><i class=\"fa-brands fa-instagram\"></i><span class=\"visually-hidden\">(link is external, opens in a new window)</span></a>\n                  <a class=\"social-icon social-icon--youtube\" href=\"https://www.youtube.com/user/mtcabaglibrary\" title=\"Find Metropolitan Transportation Commission on YouTube\" target=\"_blank\" aria-label=\"YouTube\" rel=\"noopener noreferrer\"><i class=\"fa-brands fa-youtube\"></i><span class=\"visually-hidden\">(link is external, opens in a new window)</span></a>\n              </div>\n          </div>\n          <div class=\"col-lg-4 footer__agency\">\n              <p><a href=\"https://abag.ca.gov/\" target=\"_blank\" rel=\"noopener noreferrer\"><img class=\"logo-abag\" title=\"Association of Bay Area Governments\" alt=\"Association of Bay Area Governments logo\" src=\"../../assets/images/abag_footer_logo.svg\"></a></p>\n              <h3>Association of Bay Area Governments</h3>\n              <p>ABAG supports regional planning and cooperation among the cities and counties of the San Francisco Bay Area.</p>\n              <p><a href=\"http://abag.ca.gov\" class=\"ext\" target=\"_blank\" rel=\"noopener noreferrer\">abag.ca.gov<span class=\"fa-ext extlink\"><span class=\"fa-solid fa-external-link\"><span class=\"visually-hidden\">(link is external, opens in a new window)</span></span></span></a></p>\n          </div>\n          <div class=\"col-lg-3 offset-lg-1 footer__contact\">\n              <h3>Contact Us</h3>\n              <p>Bay Area Metro Center<br>\n                  375 Beale Street<br>\n                  San Francisco, CA 94105</p>\n              <p>Main Phone Number: <a href=\"tel:1-415-778-6700\">(415) 778-6700</a><br>\n                  Public Information Line: <a href=\"tel:1-415-778-6757\">(415) 778-6757</a><br>\n                  Main Fax Number: <a href=\"tel:1-415-536-9800\">(415) 536-9800</a></p>\n              <p>\n                  <a href=\"mailto:info@bayareametro.gov\">info@bayareametro.gov</a>\n              </p>\n          </div>\n      </div>\n      <div class=\"row footer__bottom\">\n          <div class=\"col-lg-9\">\n              <div class=\"footer__legal\">\n                  <p>Copyright © 2023 Association of Bay Area Governments and Metropolitan Transportation Commission. All&nbsp;rights&nbsp;reserved.</p>\n              </div>\n          </div>\n          <div class=\"col-lg-3\">\n              <div class=\"back-to-top\">\n                  <button id=\"back-to-top\" class=\"button\" title=\"Back To Top\">Back To Top</button>\n              </div>\n          </div>\n      </div>\n  </div>\n  <!-- footer end -->\n\n"

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(51);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	    /*@ngInject*/
	    function MainController($http, $scope, baseConfigService) {
	        _classCallCheck(this, MainController);
	
	        this.awesomeThings = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.$scope = $scope;
	
	        this.baseConfigService = baseConfigService;
	    }
	
	    _createClass(MainController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.$scope.baseURL = this.baseConfigService.getBaseURL();
	
	            this.$http.get(this.$scope.baseURL + '/api/things').then(function (response) {
	                _this.awesomeThings = response.data;
	            });
	
	            function initTheme() {
	                var transparent = true;
	                var big_image;
	
	                var transparentDemo = true;
	                var fixedTop = false;
	
	                var navbar_initialized,
	                    backgroundOrange = false,
	                    toggle_initialized = false;
	
	                var nowuiKit, $navbar, $toggle, scroll_distance, oVal;
	
	                $(document).ready(function () {
	                    $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();
	
	                    if ($(".selectpicker").length != 0) {
	                        $(".selectpicker").selectpicker({
	                            iconBase: "now-ui-icons",
	                            tickIcon: "ui-1_check"
	                        });
	                    };
	
	                    if ($(window).width() >= 768) {
	                        big_image = $('.header[data-parallax="true"]');
	                        if (big_image.length != 0) {
	                            $(window).on('scroll', nowuiKit.checkScrollForParallax);
	                        }
	                    }
	
	                    $('[data-toggle="popover"]').each(function () {
	                        color_class = $(this).data('color');
	                        $(this).popover({
	                            template: '<div class="popover popover-' + color_class + '" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
	                        });
	                    });
	
	                    var tagClass = $('.tagsinput').data('color');
	
	                    if ($(".tagsinput").length != 0) {
	                        $('.tagsinput').tagsinput();
	                    }
	
	                    $('.bootstrap-tagsinput').addClass('badge-' + tagClass + '');
	
	                    nowuiKit.initNavbarImage();
	
	                    $('.navbar-collapse').addClass('show');
	
	                    $navbar = $('.navbar[color-on-scroll]');
	                    scroll_distance = 50;
	
	                    if ($('.navbar[color-on-scroll]').length != 0) {
	                        nowuiKit.checkScrollForTransparentNavbar();
	                        $(window).on('scroll', nowuiKit.checkScrollForTransparentNavbar);
	                    }
	
	                    $('.form-control').on("focus", function () {
	                        $(this).parent('.input-group').addClass("input-group-focus");
	                    }).on("blur", function () {
	                        $(this).parent(".input-group").removeClass("input-group-focus");
	                    });
	
	                    $('.bootstrap-switch').each(function () {
	                        $this = $(this);
	                        data_on_label = $this.data('on-label') || '';
	                        data_off_label = $this.data('off-label') || '';
	
	                        $this.bootstrapSwitch({
	                            onText: data_on_label,
	                            offText: data_off_label
	                        });
	                    });
	
	                    if ($(window).width() >= 992) {
	                        big_image = $('.page-header-image[data-parallax="true"]');
	
	                        $(window).on('scroll', nowuiKit.checkScrollForParallax);
	                    }
	                });
	
	                $(window).on('resize', function () {
	                    nowuiKit.initNavbarImage();
	                });
	
	                $(document).on('click', '.navbar-toggler', function () {
	                    var $toggle, div;
	                    $toggle = $(this);
	                    if (nowuiKit.misc.navbar_menu_visible == 1) {
	                        $('html').removeClass('nav-open');
	                        nowuiKit.misc.navbar_menu_visible = 0;
	                        $('#bodyClick').remove();
	                        setTimeout(function () {
	                            $toggle.removeClass('toggled');
	                        }, 550);
	                    } else {
	                        setTimeout(function () {
	                            $toggle.addClass('toggled');
	                        }, 580);
	                        div = '<div id="bodyClick"></div>';
	                        $(div).appendTo('body').click(function () {
	                            $('html').removeClass('nav-open');
	                            nowuiKit.misc.navbar_menu_visible = 0;
	                            setTimeout(function () {
	                                $toggle.removeClass('toggled');
	                                $('#bodyClick').remove();
	                            }, 550);
	                        });
	
	                        $('html').addClass('nav-open');
	                        nowuiKit.misc.navbar_menu_visible = 1;
	                    }
	                });
	
	                nowuiKit = {
	                    misc: {
	                        navbar_menu_visible: 0
	                    },
	
	                    checkScrollForTransparentNavbar: debounce(function () {
	                        if ($(document).scrollTop() > scroll_distance) {
	                            if (transparent) {
	                                transparent = false;
	                                $('.navbar[color-on-scroll]').removeClass('navbar-transparent');
	                            }
	                        } else {
	                            if (!transparent) {
	                                transparent = true;
	                                $('.navbar[color-on-scroll]').addClass('navbar-transparent');
	                            }
	                        }
	                    }, 17),
	
	                    initNavbarImage: function initNavbarImage() {
	                        var $navbar = $('.navbar').find('.navbar-translate').siblings('.navbar-collapse');
	                        var background_image = $navbar.data('nav-image');
	
	                        if (background_image != undefined) {
	                            if ($(window).width() < 991 || $('body').hasClass('burger-menu')) {
	                                $navbar.css('background', "url('" + background_image + "')").removeAttr('data-nav-image').css('background-size', "cover").addClass('has-image');
	                            } else {
	                                $navbar.css('background', "").attr('data-nav-image', '' + background_image + '').css('background-size', "").removeClass('has-image');
	                            }
	                        }
	                    }
	
	                };
	
	                function debounce(func, wait, immediate) {
	                    var timeout;
	                    return function () {
	                        var context = this,
	                            args = arguments;
	                        clearTimeout(timeout);
	                        timeout = setTimeout(function () {
	                            timeout = null;
	                            if (!immediate) func.apply(context, args);
	                        }, wait);
	                        if (immediate && !timeout) func.apply(context, args);
	                    };
	                };
	            }
	
	            initTheme();
	        }
	    }]);
	
	    return MainController;
	}();
	
	exports.default = _angular2.default.module('tocApp.main', [_angularUiRouter2.default]).config(_main2.default).component('main', {
	    template: __webpack_require__(52),
	    controller: MainController
	}).name;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/',
	    template: '<main></main>'
	  });
	}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"landing landing--about\">\n  <div class=\"page-wrapper\">\n    <!-- Navbar source ./components/navbar  -->\n    <navbar></navbar>\n    <div class=\"main\">\n      <div class=\"content container\">\n        <div class=\"section section--intro\">\n          <div class=\"row\">\n            <div class=\"col-12\">\n              <h1>About the TOC Policy Implementation Portal</h1>\n              <p class=\"intro-text\">\n                This website is where Bay Area local governments who have a stop\n                or station area that is subject to MTC’s\n                <a href=\"https://mtc.ca.gov/planning/land-use/transit-oriented-communities-toc-policy\" target=\"_blank\">Transit-Oriented\n                  Communities (TOC) Policy</a>\n                can submit documentation to demonstrate consistency with the\n                Policy’s standards.\n              </p>\n              <img class=\"image--intro\" src=\"../../assets/images/mockups/summary-image.png\"\n                alt=\"Person's hand pointing at a map\" height=\"380\" width=\"380\" />\n              <p>\n                The TOC Policy supports the region’s transit investments by\n                creating communities around transit stations and along transit\n                corridors that not only enable transit ridership, but also are\n                places where Bay Area residents of all abilities, income levels,\n                and racial and ethnic backgrounds can live, work, and access\n                services. Consistency with the TOC Policy is voluntary for\n                jurisdictions that want to advance the goals of\n                <a href=\"https://mtc.ca.gov/planning/long-range-planning/plan-bay-area-2050\" target=\"_blank\">Plan Bay Area 2050</a>\n                or to be eligible and/or competitive for some MTC discretionary\n                funding. Visit the TOC webpage for more information.\n              </p>\n              <!-- <a class=\"section__cta\" ui-sref=\"login\" ng-hide=\"isLoggedIn()\">Log in to get started</a> -->\n              <a class=\"section__cta\" ui-sref=\"login\">Log in to get started</a>\n            </div>\n          </div>\n        </div>\n        <div class=\"section section--map section--overflow section--orange\">\n          <div class=\"container\">\n            <div class=\"row\">\n              <div class=\"col-6\">\n                <h2>Review. Make Changes. Submit Updates.</h2>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-md-5\">\n                <img src=\"../../assets/images/mockups/map-section.png\" alt=\"\" height=\"380\" width=\"415\" />\n              </div>\n              <div class=\"col-md-7\">\n                <div class=\"icon icon--density\">\n                  <h3>Density</h3>\n                  <p>\n                    Minimum densities and maximum allowable densities for new\n                    residential and commercial office development.\n                  </p>\n                </div>\n                <div class=\"icon icon--housing\">\n                  <h3>Affordable Housing and Commercial Stabilization</h3>\n                  <p>\n                    Policies to produce and preserve affordable housing, protect\n                    tenants from displacement, and stabilize small businesses\n                    and non-profits.\n                  </p>\n                </div>\n                <div class=\"icon icon--parking\">\n                  <h3>Parking Management</h3>\n                  <p>\n                    Off-street auto and bicycle parking standards and TDM\n                    policies for new residential and commercial development.\n                  </p>\n                </div>\n                <div class=\"icon icon--station\">\n                  <h3>Transit Station Access and Circulation</h3>\n                  <p>\n                    Policies and plans to address access gaps and implement\n                    complete streets and mobility hubs.\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"section section--card-right\">\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <h2>Explore Documentation</h2>\n              <p class=\"intro-text\">\n                Learn more about the TOC Policy by reviewing the adopted\n                resolution and Administrative Guidance. Local jurisdictions and\n                project sponsors can download template letters or resolutions to\n                use for a transit extension needs an acknowledgement or commitment to TOC Policy\n                consistency to receive a funding allocation from MTC.\n              </p>\n              <ul class=\"list list--icons\">\n                <li>\n                  <a href=\"https://mtc.ca.gov/planning/land-use/transit-oriented-communities-toc-policy\"\n                    class=\"icon-list-item icon-list-item--document\">TOC Policy Website</a>\n                </li>\n                <li>\n                  <a href=\"https://mtc.ca.gov/digital-library/5023449-mtc-resolution-number-4530-transit-oriented-communities-policy\"\n                    class=\"icon-list-item icon-list-item--document\">MTC Resolution Number 4530 - TOC Policy</a>\n                </li>\n                <li>\n                  <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\"\n                    class=\"icon-list-item icon-list-item--document\">MTC Administrative Guidance: TOC Policy</a>\n                </li>\n                <li>\n                  <a href=\"https://mtc.ca.gov/digital-library/5026613-toc-templates-acknowledgement-letter-and-resolution-transit-extension-funding\"\n                    class=\"icon-list-item icon-list-item--document\">Templates for TOC Acknowledgement Letter or\n                    Resolution</a>\n                </li>\n                <li>\n                  <a href=\"https://mtc.ca.gov/digital-library/5026614-toc-templates-commitment-letter-and-resolution-transit-extension-funding\"\n                    class=\"icon-list-item icon-list-item--document\">Templates for TOC Commitment Letter or\n                    Resolution</a>\n                </li>\n              </ul>\n            </div>\n            <!-- <div class=\"col-md-6\">\n              <div class=\"card card--default\">\n                <div class=\"card__top\">\n                  <div class=\"card__image\">\n                    <img\n                      src=\"../../assets/images/mockups/card-sample.png\"\n                      alt=\"\"\n                      height=\"288\"\n                      width=\"510\"\n                    />\n                  </div>\n                </div>\n                <div class=\"card__bottom\">\n                  <div class=\"card__body\">\n                    <h2>Special Feature Card Title H2</h2>\n                    <p>\n                      Lorem ipsum dolor sit amet, consectetuer adipiscing elit,\n                      sed diam nonummy nibh euismod tincidunt ut laoreet dolore\n                      magna aliquam erat volutpat. Ut wisi enim ad minim veniam,\n                      quis nostrud exerci tation ullamcorper suscipit lobortis\n                      nisl ut aliquip ex ea commodo consequat.\n                    </p>\n                    <a class=\"card__cta\" href=\"#\">Call to Action Link</a>\n                  </div>\n                </div>\n              </div>\n            </div> -->\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- Footer source - ./components/footer  -->\n    <footer class=\"contentInfo\"></footer>\n  </div>\n</section>"

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var BCNavbarComponent = exports.BCNavbarComponent = function () {
	  function BCNavbarComponent(FB, $firebaseAuth, $state, $cookies, $scope, $rootScope, navService) {
	    'ngInject';
	
	    _classCallCheck(this, BCNavbarComponent);
	
	    this.menu = [{
	      title: 'Home',
	      url: 'main'
	    }];
	    this.isCollapsed = true;
	    this.isLoggedIn = FB.isLoggedInSync;
	    this.getCurrentUser = FB.getCurrentUserSync;
	    this.$firebaseAuth = $firebaseAuth();
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.isAdmin = FB.isAdminSync;
	    this.navService = navService;
	
	    $scope.breadcrumb = navService.getBreadCrumb();
	  }
	
	  _createClass(BCNavbarComponent, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return BCNavbarComponent;
	}();
	
	exports.default = angular.module('appApp.bcnavbar', []).directive('bcnavbar', function () {
	  return {
	    template: __webpack_require__(54),
	    controller: BCNavbarComponent,
	    controllerAs: 'bcnavbarCtrl',
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"breadcrumb-container\">\n    <nav aria-label=\"breadcrumb\">\n        <ol class=\"breadcrumb\">\n            <li class=\"breadcrumb-item\" aria-current=\"page\">\n                <a ng-if=\"breadcrumb[0].linkTitle !== 'Dashboard'\" href=\"/account/dashboard\">Dashboard</a>\n                <span ng-if=\"breadcrumb[0].linkTitle === 'Dashboard'\">Dashboard</span>\n            </li>\n            <li ng-if=\"breadcrumb[0].linkTitle && breadcrumb[0].linkTitle !=='Dashboard' && !breadcrumb[1].linkTitle1\" class=\"breadcrumb-item\" ng-class=\"{'active': !breadcrumb[1]}\" aria-current=\"page\">{{breadcrumb[0].linkTitle}}</li>\n            <li ng-if=\"breadcrumb[1].linkTitle1\" class=\"breadcrumb-item\" ng-class=\"{'active': !breadcrumb[1]}\"><a ng-href=\"{{breadcrumb[0].link1}}\">{{breadcrumb[0].linkTitle}}</a></li>\n            <li ng-if=\"breadcrumb[1].linkTitle1\" class=\"breadcrumb-item active\" aria-current=\"page\">{{breadcrumb[1].linkTitle1}}</li>\n        </ol>\n    </nav>\n</div>\n"

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var MessageSideBarComponent = exports.MessageSideBarComponent = function () {
	  function MessageSideBarComponent(FB, $firebaseAuth, $state, $stateParams, $cookies, $scope, $rootScope, navService, fetch, $timeout) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, MessageSideBarComponent);
	
	    this.menu = [{
	      title: 'Home',
	      url: 'main'
	    }];
	    this.isCollapsed = true;
	
	    this.toggleSidebar = function () {
	      _this.isOpen = !_this.isOpen;
	      if (_this.isOpen) {}
	    };
	
	    this.isLoggedIn = FB.isLoggedInSync;
	    this.getCurrentUser = FB.getCurrentUserSync;
	    this.$firebaseAuth = $firebaseAuth();
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.isAdmin = FB.isAdminSync;
	    this.navService = navService;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	
	    $scope.breadcrumb = navService.getBreadCrumb();
	  }
	
	  _createClass(MessageSideBarComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.isOpen = false;
	      this.messages = [];
	      this.unreadCount = 0;
	    }
	  }, {
	    key: 'submitReply',
	    value: function submitReply($event) {
	      var _this2 = this;
	
	      if ($event) {
	        $event.preventDefault();
	      }
	
	      var now = new Date();
	
	      if (!this.replyMessage) {
	        return;
	      }
	
	      if (!this.messageType || !this.replyMessage || this.replyMessage.length > 500) return;
	
	      var messageData = {
	        comment: this.replyMessage,
	        message_type: this.messageType,
	        to_jurisdiction: this.$scope.currentJurisdiction,
	        submission_id: this.$scope.submissionId,
	        created_at: now.toISOString()
	      };
	
	      console.log(messageData);
	
	      this.fetch.updateItem('api/messages', messageData).then(function (response) {
	        console.log('Reply sent:', response.data);
	        _this2.replyMessage = null;
	        _this2.messageType = null;
	
	        _this2.toggleSidebar();
	      }).catch(function (err) {
	        console.error('Error sending reply:', err);
	        _this2.$timeout(function () {
	          _this2.error = 'Failed to send reply';
	        });
	      });
	    }
	  }]);
	
	  return MessageSideBarComponent;
	}();
	
	exports.default = angular.module('appApp.messagesidebar', []).directive('messagesidebar', function () {
	  return {
	    template: __webpack_require__(56),
	    controller: MessageSideBarComponent,
	    controllerAs: 'messagesidebarCtrl',
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = "<!-- messagesidebar.html -->\n<div class=\"message-sidebar\" ng-class=\"{ 'is-open': messagesidebarCtrl.isOpen }\">\n    <!-- Toggle Button -->\n    <button class=\"message-toggle\" ng-click=\"messagesidebarCtrl.toggleSidebar()\">\n        <i class=\"fa-solid fa-comments\"></i>\n        <span class=\"badge badge-warning\" ng-if=\"messagesidebarCtrl.unreadCount > 0\">\n            {{messagesidebarCtrl.unreadCount}}\n        </span>\n    </button>\n\n    <!-- Sidebar Content -->\n    <div class=\"sidebar-content\">\n        <div class=\"sidebar-header\">\n            <h3>New Message</h3>\n            <button class=\"close-btn\" ng-click=\"messagesidebarCtrl.toggleSidebar()\">\n                <i class=\"fa-solid fa-times\"></i>\n            </button>\n        </div>\n\n        <!-- Loading State -->\n        <div class=\"loading-state\" ng-if=\"messagesidebarCtrl.loading\">\n            <i class=\"fa-solid fa-spinner fa-spin\"></i> Loading messages...\n        </div>\n\n        <!-- Error State -->\n        <div class=\"error-state\" ng-if=\"messagesidebarCtrl.error\">\n            <i class=\"fa-solid fa-exclamation-circle\"></i> {{messagesidebarCtrl.error}}\n        </div>\n\n        <!-- Messages List -->\n        <!-- Reply Form -->\n        <div class=\"message-form-container\">\n            <div class=\"alert alert-warning\">\n                Please fill in all fields before submitting.\n            </div>\n            <form ng-submit=\"messagesidebarCtrl.submitReply($event)\" class=\"message-form\" name=\"messageForm\">\n                <div class=\"form-group\">\n                    <select ng-model=\"messagesidebarCtrl.messageType\" class=\"form-control\" required>\n                        <option value=\"\" disabled selected>Select message type...</option>\n                        <option value=\"General\">General Comment</option>\n                        <option value=\"Submission Related\">Submission Related</option>\n                    </select>\n                </div>\n                \n                <!-- Jurisdiction Select - Only for Administrators -->\n                <div class=\"form-group\" ng-hide=\"currentUser.role === 'User'\">\n                    <select ng-model=\"currentJurisdiction\" ng-change=\"getStationAreaList(currentJurisdiction);\"\n                        class=\"form-control\" required>\n                        <option value=\"\" disabled selected>Select jurisdiction...</option>\n                        <option ng-repeat=\"org in jurisdictions\" value=\"{{org.jurisdiction}}\">\n                            {{org.jurisdiction}}\n                        </option>\n                    </select>\n                </div>\n\n                <div class=\"form-group\">\n                    <select ng-model=\"currentSelectedStationId\" ng-change=\"getStationbyID(currentSelectedStationId)\"\n                        class=\"form-control\" required>\n                        <option value=\"\" disabled selected>Select station...</option>\n                        <option ng-repeat=\"station in stationAreas\" value=\"{{station.sta_recid}}\">\n                            {{station.station_name}}\n                        </option>\n                    </select>\n                </div>\n\n\n                <div class=\"form-group\">\n                    <select ng-model=\"submissionId\" class=\"form-control\" required>\n                        <option value=\"\" disabled selected>Select policy...</option>\n                        <option ng-repeat=\"submission in submissionSummary\" value=\"{{submission.submission_id}}\">\n                            {{submission.submission_policy_name}}\n                        </option>\n                    </select>\n                </div>\n\n                <div class=\"form-group\">\n                    <textarea ng-model=\"messagesidebarCtrl.replyMessage\" class=\"form-control message-textarea\"\n                        placeholder=\"Write your message\" rows=\"4\" maxlength=\"500\" required></textarea>\n                    <small class=\"character-count\" ng-if=\"messagesidebarCtrl.replyMessage\">\n                        {{500 - messagesidebarCtrl.replyMessage.length}} characters remaining\n                    </small>\n                </div>\n                <div class=\"form-group button-container\">\n                    <button type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"messageForm.$invalid\">\n                        <i class=\"fa-solid fa-paper-plane\"></i>\n                        Send Message\n                    </button>\n                </div>\n            </form>\n        </div>\n\n        <!-- Empty State -->\n        <!-- <div class=\"no-messages\" ng-if=\"!messagesidebarCtrl.messages.length && !messagesidebarCtrl.loading\">\n            <i class=\"fa-solid fa-inbox\"></i>\n            <p>No messages to display</p>\n        </div> -->\n    </div>\n</div>\n\n<style>\n    .message-form-container {\n        padding: 20px;\n        /* Increased padding */\n        background: #f8f9fa;\n        border-bottom: 1px solid #dee2e6;\n    }\n\n    .message-form {\n        margin-bottom: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        /* Added gap between form elements */\n    }\n\n    .message-sidebar {\n        position: fixed;\n        right: 0;\n        top: 60%;\n        transform: translateY(-50%);\n        z-index: 1000;\n        display: flex;\n    }\n\n    .message-toggle {\n        position: relative;\n        width: 50px;\n        height: 50px;\n        border-radius: 25px 0 0 25px;\n        background: #021830;\n        border: none;\n        color: white;\n        cursor: pointer;\n        box-shadow: -2px 2px 5px rgba(0, 0, 0, 0.2);\n    }\n\n    .message-toggle .badge {\n        position: absolute;\n        top: -5px;\n        right: -5px;\n    }\n\n    .sidebar-content {\n        width: 0;\n        height: 80vh;\n        background: white;\n        transition: width 0.3s ease;\n        overflow: hidden;\n        box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);\n    }\n\n    .message-sidebar.is-open .sidebar-content {\n        width: 300px;\n        padding: 15px;\n    }\n\n    .sidebar-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding-bottom: 15px;\n        border-bottom: 1px solid #eee;\n    }\n\n    .messages-container {\n        overflow-y: auto;\n        height: calc(100% - 60px);\n    }\n\n    .message-thread {\n        padding: 10px;\n        border-bottom: 1px solid #eee;\n        cursor: pointer;\n    }\n\n    .message-thread:hover {\n        background: #f8f9fa;\n    }\n\n    .thread-header.unread {\n        font-weight: bold;\n    }\n\n    .thread-meta {\n        font-size: 0.85em;\n        color: #666;\n    }\n\n    .close-btn {\n        background: none;\n        border: none;\n        font-size: 20px;\n        cursor: pointer;\n    }\n\n    .loading-state,\n    .error-state,\n    .no-messages {\n        text-align: center;\n        padding: 20px;\n        color: #666;\n    }\n\n    .error-state {\n        color: #dc3545;\n    }\n</style>"

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var SideNavbarComponent = exports.SideNavbarComponent = function () {
	  function SideNavbarComponent(FB, $firebaseAuth, $state, $cookies, $scope, $rootScope, navService, $location) {
	    'ngInject';
	
	    _classCallCheck(this, SideNavbarComponent);
	
	    this.isLoggedIn = FB.isLoggedInSync;
	    this.getCurrentUser = FB.getCurrentUserSync;
	    this.$firebaseAuth = $firebaseAuth();
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.isAdmin = FB.isAdminSync;
	    this.$scope = $scope;
	    this.$location = $location;
	    this.$rootScope = $rootScope;
	
	    this.navService = navService;
	
	    $scope.isActive = function (viewLocation) {
	      return viewLocation === $location.path();
	    };
	
	    $scope.navigateTo = function (item) {
	      $location.path(item.url);
	    };
	  }
	
	  _createClass(SideNavbarComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$scope.menu = this.navService.getSideBarNav();
	
	      for (var index = 0; index < this.$scope.menu.length; index++) {
	        var element = this.$scope.menu[index];
	        var path = this.$location.path();
	        if (element.url === path && !element.subItem1) {
	          element.ariaCurrent = true;
	        }
	        if (element.url === path) {
	          element.expanded = true;
	          this.navService.setPage(element);
	          this.navService.setBreadCrumb(element);
	        } else {
	          element.expanded = false;
	        }
	
	        if (element.subItem1) {
	          var activeSubItem = _.filter(element.subItem1, {
	            url: path
	          });
	          if (activeSubItem.length > 0) {
	            element.expanded = true;
	            this.navService.setPage(element);
	            this.navService.setBreadCrumb(element, activeSubItem[0]);
	            this.subNavActive(activeSubItem[0]);
	          }
	        } else {
	          element.expanded = false;
	        }
	      }
	    }
	  }, {
	    key: 'gotoPage',
	    value: function gotoPage(page, subPage) {
	      if (subPage) {
	        this.$location.url(subPage.url);
	        this.$rootScope.subItem = subPage;
	        this.subNavActive(subPage);
	        this.navService.setBreadCrumb(page, subPage);
	      } else {
	        this.$rootScope.page = page;
	        this.$rootScope.subItem = null;
	        this.$location.url(page.url);
	        this.navService.setBreadCrumb(page);
	      }
	    }
	  }, {
	    key: 'updateBreadcrumb',
	    value: function updateBreadcrumb(subItem, item) {
	      this.$rootScope.page = item;
	      this.$rootScope.subItem = subItem;
	      this.$location.url(subItem.url);
	      this.showSubNav(item);
	      this.subNavActive(item, subItem);
	    }
	  }, {
	    key: 'subNavActive',
	    value: function subNavActive(subPage) {
	      this.$scope.menu.forEach(function (element) {
	        if (element.subItem1) {
	          for (var index = 0; index < element.subItem1.length; index++) {
	            var checkUrl = element.subItem1[index].url;
	            if (checkUrl.url !== subPage.url) {
	              element.subItem1[index].active = false;
	            }
	          }
	        }
	      });
	      subPage.active = true;
	    }
	  }]);
	
	  return SideNavbarComponent;
	}();
	
	exports.default = angular.module('appApp.sidebarnav', []).directive('sidebarnav', function ($rootScope) {
	  return {
	    template: __webpack_require__(58),
	    controller: SideNavbarComponent,
	    controllerAs: 'sidebarnavCtrl',
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {
	      scope.$watch('page', function () {
	        scope.page = $rootScope.page;
	      });
	      scope.$watch('subItem', function () {
	        scope.subItem = $rootScope.subItem;
	      });
	    }
	  };
	}).name;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"header__branding\">\n    <div class=\"container\">\n        <div class=\"header__logo\">\n            <img class=\"logo\" src=\"../../../assets/images/dots.svg\" width=\"40\" height=\"40\" alt=\"\" role=\"presentation\" />\n            <div class=\"header__title\">\n                <a href=\"/\">Bay Area TOC Policy Submission Portal</a>\n                <h2>2.0.1</h2>\n            </div>\n        </div>\n    </div>\n    <div class=\"header__navigation\">\n        <nav aria-label=\"sidebar\" class=\"navbar navbar-expand-lg\">\n            <button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarNavDropdown\"\n                aria-controls=\"navbarNavDropdown\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n                <span class=\"navbar-toggler-icon\"></span>\n            </button>\n            <div class=\"navbar-collapse\" id=\"navbarNavDropdown\">\n                <div class=\"nav-heading\">Explore</div>\n                <ul class=\"nav nav--explore flex-column\">\n                    <li class=\"nav-item has-submenu\" ng-repeat=\"item in menu\"\n                        ng-if=\"item.show === 'loggedIn' && (item.role !== 'Administrator' || getCurrentUser().role === 'Administrator')\"\n                        ng-class=\"{ 'expanded': item.expanded }\"\n                        ng-attr-aria-current=\"{{ item.ariaCurrent ? 'page' : null }}\">\n\n                        <a href=\"#\" class=\"nav-link nav-link--icon {{item.navLinkIconClass}}\"\n                            ng-click=\"sidebarnavCtrl.gotoPage(item, null)\">\n                            {{ item.title }}\n                        </a>\n\n                        <button ng-if=\"item.subItem1\" type=\"button\" class=\"dropdown-toggle\"\n                            ng-class=\"{ 'collapsed': !item.expanded }\" data-bs-toggle=\"collapse\"\n                            data-bs-target=\"#item_{{$index}}_menu\" aria-expanded=\"false\">\n                            <span class=\"visually-hidden\" ng-if=\"!item.expanded\">Show submenu for {{ item.title\n                                }}</span>\n                            <span class=\"visually-hidden\" ng-if=\"item.expanded\">Hide submenu for {{ item.title }}</span>\n                        </button>\n\n                        <ul ng-if=\"item.subItem1\" class=\"collapse-menu collapse\" id=\"item_{{$index}}_menu\"\n                            ng-class=\"{ 'show': item.expanded }\">\n                            <li ng-repeat=\"subItem in item.subItem1\"\n                                ng-attr-aria-current=\"{{ subItem.active ? 'page' : null }}\">\n                                <a class=\"dropdown-item\" ng-class=\"{ 'active': subItem.active }\"\n                                    ng-href=\"{{subItem.url}}\" ng-click=\"sidebarnavCtrl.gotoPage(item, subItem)\">{{\n                                    subItem.title }}</a>\n                            </li>\n                        </ul>\n                    </li>\n                </ul>\n\n                <ul class=\"nav nav--tools flex-column\">\n                    <li class=\"nav-item has-submenu\">\n                        <a ui-sref=\"zoning_updates\" class=\"nav-link\">\n                            Jurisdiction Zoning Updates Form\n                        </a>\n                        <!-- <button type=\"button\" class=\"dropdown-toggle collapsed\" data-bs-target=\"#gettingcompliantMenu\"\n                            data-bs-toggle=\"collapse\" aria-expanded=\"false\">\n                            <span class=\"sr-only\">Show/hide submenu for Getting Compliant</span>\n                        </button>\n                        <ul class=\"collapse-menu collapse\" id=\"gettingcompliantMenu\">\n                            <li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n                            <li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n                            <li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n                        </ul> -->\n                    </li>\n                    <!-- <li class=\"nav-item has-submenu\">\n                        <a href=\"#\" class=\"nav-link\">\n                            Using the Tools\n                        </a>\n                        <button type=\"button\" class=\"dropdown-toggle collapsed\" data-bs-target=\"#toolsMenu\"\n                            data-bs-toggle=\"collapse\" aria-expanded=\"false\">\n                            <span class=\"sr-only\">Show/hide submenu for Using the Tools</span>\n                        </button>\n                        <ul class=\"collapse-menu collapse\" id=\"toolsMenu\">\n                            <li><a class=\"dropdown-item\" href=\"#\">Action</a></li>\n                            <li><a class=\"dropdown-item\" href=\"#\">Another action</a></li>\n                            <li><a class=\"dropdown-item\" href=\"#\">Something else here</a></li>\n                        </ul>\n                    </li> -->\n                </ul>\n            </div>\n        </nav>\n    </div>\n</div>"

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.sidebarfooter', []).directive('sidebarfooter', function () {
	  return {
	    template: __webpack_require__(60),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = "<!-- footer start -->\n<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <p>Powered by:</p>\n        </div>\n        <div class=\"col-6 col-lg-12\">\n            <p><a href=\"https://mtc.ca.gov\" title=\"Metropolitan Transportation Commission\" target=\"_blank\"\n                    rel=\"noopener noreferrer\"><img class=\"logo-mtc\" alt=\"Metropolitan Transportation Commission logo\"\n                        src=\"../../../assets/images/mtc_footer_logo.svg\"><img class=\"logo-mtc logo-mtc--dashboard-light\"\n                        alt=\"Metropolitan Transportation Commission logo\"\n                        src=\"../../../assets/images/mtc_logo.svg\"><span class=\"visually-hidden\">(link is external, opens\n                        in a new window)</span></a></p>\n        </div>\n        <div class=\"col-6 col-lg-12\">\n            <p><a href=\"https://abag.ca.gov/\" target=\"_blank\" rel=\"noopener noreferrer\"><img class=\"logo-abag\"\n                        title=\"Association of Bay Area Governments\" alt=\"Association of Bay Area Governments logo\"\n                        src=\"../../../assets/images/abag_footer_logo.svg\"><img\n                        class=\"logo-abag logo-abag--dashboard-light\" title=\"Association of Bay Area Governments\"\n                        alt=\"Association of Bay Area Governments logo\" src=\"../../../assets/images/abag_logo.svg\"><span\n                        class=\"visually-hidden\">(link is external, opens in a new window)</span></a></p>\n        </div>\n        <div class=\"col-6 col-lg-12\">\n            <br>\n            <p> Contact Us:\n                <a href=\"mailto:tocpolicy@bayareametro.gov\">tocpolicy@bayareametro.gov</a>\n            </p>\n        </div>\n    </div>\n</div>\n<!-- footer end -->"

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var MainHeaderAuthComponent = exports.MainHeaderAuthComponent = function () {
	  function MainHeaderAuthComponent(FB, $firebaseAuth, $state, $cookies, $scope, $rootScope, navService, $location, userService, $http, fetch) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, MainHeaderAuthComponent);
	
	    this.headerLinks = [{
	      title: 'Messages',
	      href: '/account/messages',
	      className: 'header__link--messages'
	    }];
	
	    this.updateBreadcrumb = function () {
	      if (_this.$scope.headerLinks) {
	        var _headerLinks$filter = _this.headerLinks.filter(function (headerLink) {
	          return _this.$location.path() === headerLink.href;
	        }),
	            _headerLinks$filter2 = _slicedToArray(_headerLinks$filter, 1),
	            activeHeaderLink = _headerLinks$filter2[0];
	
	        if (!activeHeaderLink) return;
	
	        _this.$rootScope.page = activeHeaderLink;
	      }
	    };
	
	    this.isLoggedIn = FB.isLoggedInSync;
	
	    this.$firebaseAuth = $firebaseAuth();
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.isAdmin = FB.isAdminSync;
	    this.navService = navService;
	    this.userService = userService;
	    this.$scope = $scope;
	    this.$scope.getCurrentUser = FB.getCurrentUserSync;
	    this.$location = $location;
	    this.$rootScope = $rootScope;
	    this.fetch = fetch;
	    this.$http = $http;
	
	    this.$scope.headerLinks = this.headerLinks;
	    this.$scope.unreadMessageCount = 0;
	
	    this.pollMessages();
	    this.pollInterval = setInterval(function () {
	      return _this.pollMessages();
	    }, 600000);
	  }
	
	  _createClass(MainHeaderAuthComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.locationChangeListener = this.$rootScope.$on('$locationChangeSuccess', this.updateBreadcrumb);
	
	      this.updateBreadcrumb();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      if (!this.locationChangeListener) return;
	
	      this.locationChangeListener();
	    }
	  }, {
	    key: 'pollMessages',
	    value: function pollMessages() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/messages/test/count').then(function (response) {
	        console.log('Unread message count:', response.data.unreadCount);
	        _this2.$scope.unreadMessageCount = response.data.unreadCount;
	        if (!_this2.$scope.$$phase) {}
	      }).catch(function (err) {
	        console.error('Error fetching unread message count:', err);
	      });
	    }
	  }]);
	
	  return MainHeaderAuthComponent;
	}();
	
	exports.default = angular.module('appApp.mainheaderauth', []).directive('mainheaderauth', function (FB) {
	  return {
	    template: __webpack_require__(62),
	    restrict: 'EA',
	    controller: MainHeaderAuthComponent,
	    controllerAs: 'mainHeadAuthCtrl',
	    link: function link(scope, element, attrs) {
	      FB.getCurrentUser().then(function (userData) {
	        scope.currentUser = userData;
	      }).catch(function (err) {
	        return console.error('Error getting user data:', err);
	      });
	
	      scope.$on('userDataUpdated', function (event, userData) {
	        console.log('listening for user data updates:', userData);
	        scope.currentUser = userData;
	        if (!scope.$$phase) {
	          scope.$apply();
	        }
	      });
	    }
	  };
	}).name;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = "<style>\n    /* Header badge styles */\n.header__link {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n}\n\n.header-badge {\n    position: absolute;\n    top: -8px;\n    right: 2px;\n    background-color: #b41449;\n    color: white;\n    font-size: 11px;\n    font-weight: 600;\n    min-width: 18px;\n    height: 18px;\n    border-radius: 9px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 5px;\n}\n\n/* Optional: Add animation for new messages */\n@keyframes scaleBadge {\n    0% { transform: scale(0); }\n    50% { transform: scale(1.2); }\n    100% { transform: scale(1); }\n}\n\n.header-badge {\n    animation: scaleBadge 0.3s ease-out;\n}\n\n/* Optional: Add a white border around badge */\n.header-badge {\n    border: 2px solid white;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.2);\n}\n\n</style>\n<div class=\"header__actions\">\n    <div class=\"header__links\">\n        <a href=\"#\" title=\"Help\" class=\"header__link header__link--help\">Help</a>\n        <a ng-repeat=\"item in headerLinks\" \n           href=\"{{item.href}}\" \n           title=\"{{item.title}}\" \n           class=\"header__link {{item.className}}\" \n           ng-class=\"{active: page === item}\">\n            {{item.title}}\n            <!-- Add badge for messages link -->\n            <span class=\"header-badge\" \n                  ng-if=\"item.title === 'Messages' && unreadMessageCount > 0\">\n                {{unreadMessageCount}}\n            </span>\n        </a>\n    </div>\n    <nav aria-label=\"header_account\" class=\"header__account-nav\">\n        <div class=\"dropdown\">\n            <button class=\"btn btn-secondary dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n                {{currentUser.firstname}} {{currentUser.lastname}}\n            </button>\n            <ul class=\"dropdown-menu\">\n                <li><span class=\"dropdown-item\">{{currentUser.email}}</span></li>\n                <li><a class=\"dropdown-item dropdown-item--icon dropdown-item--account\" href=\"/account/myaccount\">Account Settings</a></li>\n                <li ng-show=\"currentUser.role === 'Administrator'\"><a class=\"dropdown-item dropdown-item--icon dropdown-item--users\" href=\"/admin/manageusers\">Manage Users</a></li>\n                <li ng-show=\"currentUser.role === 'Administrator'\"><a class=\"dropdown-item dropdown-item--icon dropdown-item--stations\" href=\"#\">Manage Stations</a></li>\n                <li><a class=\"dropdown-item dropdown-item--icon dropdown-item--exit\" href=\"/logout\">Sign Out</a></li>\n            </ul>\n        </div>\n    </nav>\n</div>\n<bcnavbar></bcnavbar>\n"

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var SidebarActivityComponent = exports.SidebarActivityComponent = function () {
	  function SidebarActivityComponent($state, $scope, $rootScope, fetch) {
	    'ngInject';
	
	    _classCallCheck(this, SidebarActivityComponent);
	
	    this.menu = [{
	      title: 'Home',
	      url: 'main'
	    }];
	    this.isCollapsed = true;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.fetch = fetch;
	  }
	
	  _createClass(SidebarActivityComponent, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return SidebarActivityComponent;
	}();
	
	exports.default = angular.module('appApp.sidebaractivity', []).directive('sidebaractivity', function () {
	  return {
	    template: __webpack_require__(64),
	    restrict: 'EA',
	    controller: SidebarActivityComponent,
	    controllerAs: 'sidebarActivityCtrl',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"submissionActivity.length > 0\">\n  <div ng-repeat=\"item in submissionActivity\" class=\"section-content section-content--activities\">\n    <div class=\"section-subheader\">{{item.submitted_date | date}}</div>\n    <div class=\"section-row\">\n      <div class=\"user-icon\">\n        <i class=\"fa-light fa-circle-user\"></i>\n      </div>\n      <div class=\"section-column\">\n        <b>{{item.submitted_by}}</b> submitted <b>{{item.submission_policy_name}}</b>\n        <div class=\"section-column-subtext\">Status: {{item.status}}</div>\n      </div>\n    </div>\n  </div>\n</div>\n<div ng-if=\"submissionActivity.length === 0 || !submissionActivity\">\n  <div class=\"section-subheader\">No activity</div>\n</div>\n\n\n"

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.furtherguidance', []).directive('furtherguidance', function () {
	  return {
	    template: __webpack_require__(66),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"section-resources\">\n    <div class=\"section-resources__title\">Further Guidance</div>\n    <ul class=\"list list--resources\">\n        <li><a href=\"#\">Homeowner Repair or Rehabilitation</a></li>\n        <li><a href=\"#\">Preservation of Mobile Homes(Rent Stabilization Ordinance)</a></li>\n        <li><a href=\"#\">Inclusionary Housing Ordinance</a></li>\n        <li><a href=\"#\">Housing Overlay Zone</a></li>\n    </ul>\n</div>"

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var MapSidebarComponent = exports.MapSidebarComponent = function () {
	  function MapSidebarComponent($state, $scope, $rootScope, fetch) {
	    'ngInject';
	
	    _classCallCheck(this, MapSidebarComponent);
	
	    this.menu = [{
	      title: 'Home',
	      url: 'main'
	    }];
	    this.isCollapsed = true;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    $scope.showEditTools = true;
	
	    $scope.updateInfoBox = function (data) {
	      $scope.feature = data;
	      $scope.$apply();
	    };
	
	    $scope.$watch('selectedRecordDetails.length', function (newVal) {
	      if (newVal > 0) {
	        angular.element('#sidebar').addClass('show');
	      }
	    });
	
	    angular.element(document).ready(function () {
	      if (angular.element('#sidebar').hasClass('show')) {
	        angular.element('.map-tools__toggle').hide();
	      } else {
	        angular.element('.map-tools__toggle').show();
	      }
	    });
	  }
	
	  _createClass(MapSidebarComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$scope.$watch('selectedRecordDetails.length', function (newVal) {
	        if (newVal > 0) {
	          $('#sidebar').addClass('show');
	
	          $('.map-tools__toggle').hide();
	        }
	      });
	
	      $('#sidebar').on('hidden.bs.collapse', function () {
	        $('.map-tools__toggle').show();
	      });
	
	      $('#sidebar').on('shown.bs.collapse', function () {
	        $('.map-tools__toggle').hide();
	      });
	    }
	  }]);
	
	  return MapSidebarComponent;
	}();
	
	exports.default = angular.module('appApp.mapsidebar', []).directive('mapsidebar', function () {
	  return {
	    template: __webpack_require__(68),
	    restrict: 'EA',
	    controller: MapSidebarComponent,
	    controllerAs: 'mapSidebarCtrl',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"sidebar\" class=\"collapse collapse-horizontal\" role=\"tablist\" style=\"min-height: 100%;\">\n  <div class=\"parcels-container\" style=\"width: 360px;\" ng-if=\"!showParcelDetailsPanel\">\n    <div class=\"header\">\n      <div class=\"header-text\">Edit {{selectedRecordDetails.length}} Parcels</div>\n      <button type=\"button\" data-bs-target=\"#sidebar\" data-bs-toggle=\"collapse\" class=\"btn close-button-icon collapsed\"\n        aria-label=\"Close\">\n        <i class=\"fa-light fa-times\"></i>\n      </button>\n    </div>\n  \n    <!-- Tab Navigation -->\n    <ul class=\"nav nav-tabs\" id=\"parcelTab\" role=\"tablist\">\n      <li class=\"nav-item\" role=\"presentation\">\n        <a class=\"nav-link active\" id=\"parcel-list-tab\" data-bs-toggle=\"tab\" href=\"#parcel-list\" role=\"tab\"\n          aria-controls=\"parcel-list\" aria-selected=\"true\">Parcel List</a>\n      </li>\n      <li class=\"nav-item\" role=\"presentation\">\n        <a class=\"nav-link\" id=\"edit-tools-tab\" data-bs-toggle=\"tab\" href=\"#edit-tools\" role=\"tab\" aria-controls=\"edit-tools\"\n          aria-selected=\"false\">Edit Parcels</a>\n      </li>\n    </ul>\n  \n    <div class=\"tab-content\">\n      <!-- Parcel List Tab -->\n      <div class=\"tab-pane fade show active\" id=\"parcel-list\" role=\"tabpanel\" aria-labelledby=\"parcel-list-tab\">\n        <div class=\"parcels--no-results\" ng-class=\"{ 'show': selectedRecordDetails.length == 0 }\">\n          <div class=\"header-text\">No Parcels Selected</div>\n          <p>Select a parcel to view more details or begin editing.</p>\n        </div>\n  \n        <div class=\"parcels--updated\" ng-class=\"{'show': saved}\">\n          <div class=\"sections sections--scroll\" style=\"overflow: scroll;\">\n            <div class=\"header-text\"><i class=\"fa-light fa-circle-check\"></i> Parcels Updated</div>\n            <p>The following parcels have been updated:</p>\n            <ul class=\"parcels--list\">\n              <li ng-repeat=\"item in selectedRecordDetails\">\n                <div class=\"parcel-name\">APN: {{item.apn}}</div>\n              </li>\n            </ul>\n          </div>\n          <!-- <div class=\"sections sections--footer\">\n            <button type=\"button\" data-bs-target=\"#sidebar\" data-bs-toggle=\"collapse\" class=\"btn btn-submit\"\n              aria-label=\"Close\" ng-click=\"clearSelected()\">\n              Done\n            </button>\n          </div> -->\n        </div>\n  \n        <div class=\"parcels--edit\" ng-class=\"{ 'show': selectedRecordDetails.length > 0 }\">\n          <form>\n            <div class=\"sections sections--scroll\" style=\"overflow: scroll;\">\n              <div class=\"section\">\n                <div class=\"section-content\">\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">Jurisdiction</div>\n                    <div class=\"section-column\">{{currentJurisdiction}}</div>\n                  </div>\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">Station Area</div>\n                    <div class=\"section-column\">{{filter.station_name}}</div>\n                  </div>\n                </div>\n              </div>\n              \n              <div class=\"section\">\n                <div class=\"form-item form-item--checkboxes\" id=\"selectedParcels\">\n                  <div class=\"filter-heading\">Selected Parcels</div>\n                  <div class=\"form-row\" ng-repeat=\"item in selectedRecordDetails\">\n                    <div class=\"form-check\">\n                      <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"parcel_{{item.apn}}\"\n                        ng-change=\"updateCheckedParcels(item)\" ng-model=\"item.selected\">\n                      <label class=\"form-check-label\" for=\"parcel1\">\n                        <span class=\"parcel-name\">\n                          APN: {{item.apn}}\n                        </span>\n                        <span class=\"parcel-address\">\n                          Zoning Code: {{item.zn_code}}<br />\n                          Multi-Zone: {{item.multizone_flag ? 'Yes' : 'No'}}<br />\n                          Area (acres): {{item.ll_gisacre}}<br />\n                          Residential: {{item.allows_residential ? 'Yes' : 'No'}} <br />\n                          Commercial: {{item.allows_comm_office ? 'Yes' : 'No'}}\n                        </span>\n                      </label>\n                    </div>\n                    <div class=\"section-more\">\n                      <a class=\"link link--more\" href=\"#\" ng-click=\"showParcelDetails(item)\">\n                        More Info\n                      </a>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n  \n      <!-- Edit Tools Tab -->\n      <div class=\"tab-pane fade\" id=\"edit-tools\" role=\"tabpanel\" aria-labelledby=\"edit-tools-tab\">\n        <form>\n          <div class=\"sections sections--scroll\" style=\"overflow: scroll;\">\n            <div class=\"section\">\n              <div class=\"section-content\">\n                <div class=\"section-row\">\n                  <div class=\"section-column\">Assign Primary Zoning Code for ({{selectedRecordDetails.length}}) Selected Parcels:</div>\n                  <div class=\"section-column\">\n                    <select name=\"zoningCode\" id=\"zoningCode\" ng-model=\"parcels.zn_recid\">\n                      <option value=\"\"></option>\n                      <option ng-repeat=\"item in znCodes\" ng-value=\"item.zn_recid\">\n                        {{item.zn_code}}\n                      </option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n<!-- Primary Percent of Parcel -->\n            <div class=\"section\">\n              <div class=\"section-content\">\n                <div class=\"section-row\">\n                  <div class=\"section-column\">Assign Percentage of Parcel:</div>\n                  <div class=\"section-column\">\n                    <select name=\"percentOfParcel\" id=\"percentOfParcel\" ng-model=\"parcels.percentOfParcel\">\n                      <option value=\"\"></option>\n                      <option ng-value=10>10%</option>\n                      <option ng-value=20>20%</option>\n                      <option ng-value=30>30%</option>\n                      <option ng-value=40>40%</option>\n                      <option ng-value=50>50%</option>\n                      <option ng-value=60>60%</option>\n                      <option ng-value=70>70%</option>\n                      <option ng-value=80>80%</option>\n                      <option ng-value=90>90%</option>\n                      <option ng-value=100>100%</option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n               <!-- Second Zoning Code -->\n            <div class=\"section\">\n              <div class=\"section-content\">\n                <div class=\"section-row\">\n                  <div class=\"section-column\">Assign Secondary Zoning Code for ({{selectedRecordDetails.length}}) Selected Parcels:</div>\n                  <div class=\"section-column\">\n                    <select name=\"secondZoningCode\" id=\"secondZoningCode\" ng-model=\"parcels.secondZnRecid\">\n                      <option value=\"\"></option>\n                      <option ng-repeat=\"item in znCodes\" ng-value=\"item.zn_recid\">\n                        {{item.zn_code}}\n                      </option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"section\">\n              <div class=\"section-content\">\n                <div class=\"section-row\">\n                  <div class=\"section-column\">Assign Percentage of Parcel for Secondary Zoning Code:</div>\n                  <div class=\"section-column\">\n                    <select name=\"secondPercentOfParcel\" id=\"secondPercentOfParcel\" ng-model=\"parcels.secondPercentOfParcel\">\n                      <option value=\"\"></option>\n                      <option value=\"10\">10%</option>\n                      <option value=\"20\">20%</option>\n                      <option value=\"30\">30%</option>\n                      <option value=\"40\">40%</option>\n                      <option value=\"50\">50%</option>\n                      <option value=\"60\">60%</option>\n                      <option value=\"70\">70%</option>\n                      <option value=\"80\">80%</option>\n                      <option value=\"90\">90%</option>\n                      <option value=\"100\">100%</option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n         \n         \n\n     \n\n       \n  \n            <div class=\"section\">\n              <div class=\"section-content\">\n                <div class=\"section-row\">\n                  <div class=\"section-column\">Exclude Selection from Weighted Average Calculations?</div>\n                  <div class=\"section-column\">\n                    <select name=\"excludeFromAv\" id=\"excludeFromAv\" ng-model=\"parcels.exclude\">\n                      <option value=\"\"></option>\n                      <option value=\"0\">No</option>\n                      <option value=\"1\">Yes</option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n            </div>\n  \n            <span><bold>OR</bold></span>\n  \n            <div class=\"section\">\n              <div class=\"section-content\">\n                <div class=\"section-row\">\n                  <div class=\"section-column\">Exclude from Weighted Average Calculations by Zoning Code:</div>\n                  <div class=\"section-column\">\n                    <select name=\"excludeZoningCode\" id=\"excludeZoningCode\" ng-model=\"parcels.excludeZnCode\">\n                      <option value=\"\"></option>\n                      <option ng-repeat=\"item in znCodes\" ng-value=\"item.zn_recid\">\n                        {{item.zn_code}}\n                      </option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n            </div>\n  \n            <div class=\"sections sections--footer\">\n              <div class=\"section section--form-submit\">\n                <button type=\"submit\" class=\"button\" ng-click=\"updateParcels()\" style=\"padding:5px 10px\">\n                  <i ng-if=\"saving\" class=\"fa-solid fa-cog fa-spin\" style=\"font-weight: 400; padding-left: 0.25em; padding-right: 0.25em;\"></i>\n                  Save Edits\n                </button>\n                <button style=\"padding:5px 10px\" type=\"reset\" class=\"button\" ng-click=\"clearSelected()\">Clear Selection</button>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n  \n  <div class=\"property-details-container\" style=\"width: 360px;\" ng-if=\"showParcelDetailsPanel\">\n    <div class=\"tab-content\">\n      <div id=\"view-property-details\" class=\"tab-pane show\">\n        <div class=\"header\">\n          <button type=\"button\" ng-click=\"backToSelected()\" class=\"btn close-button-icon collapsed\"\n            aria-label=\"Back to Selected\">\n            <i class=\"fa-light fa-chevron-left\"></i>\n          </button>\n          <div class=\"header-text\">APN: {{parcel.apn ? parcel.apn : '--'}}</div>\n        </div>\n        <div class=\"sections\">\n          <div class=\"section\">\n            <div class=\"section-header\">\n              <div class=\"section-header-text dropdown\">\n                <a class=\"filter-heading section-header-text dropdown-toggle show\" type=\"button\"\n                  data-bs-toggle=\"collapse\" role=\"button\" data-bs-target=\"#parcelBasicInfo\"\n                  aria-controls=\"parcelBasicInfo\" aria-expanded=\"true\" aria-label=\"Toggle section\">\n                  Basic Information\n                </a>\n              </div>\n            </div>\n            <div class=\"section-content collapse show\" id=\"parcelBasicInfo\">\n              <div class=\"section-row\">\n                <div class=\"section-column\">County</div>\n                <div class=\"section-column\">\n                  <div>{{ parcel.county_name }}</div>\n                </div>\n              </div>\n              <div class=\"section-row\">\n                <div class=\"section-column\">Jurisdiction</div>\n                <div class=\"section-column\">\n                  <div>{{ parcel.jurisdiction ? parcel.jurisdiction : '--' }}</div>\n                </div>\n              </div>\n              <div class=\"section-row\">\n                <div class=\"section-column\">APN</div>\n                <div class=\"section-column\">{{ parcel.apn ? parcel.apn : '--'}}</div>\n              </div>\n              <!-- <div class=\"section-row\">\n                  <div class=\"section-column\">Street Address</div>\n                  <div class=\"section-column\">\n                    1800 San Pablo Ave Oakland 94612\n                  </div>\n                </div> -->\n              <!-- <div class=\"section-row\">\n                  <div class=\"section-column\">Zip Code</div>\n                  <div class=\"section-column\">94612.0</div>\n                </div> -->\n              <div class=\"section-row\">\n                <div class=\"section-column\">Parcel Size</div>\n                <div class=\"section-column\">{{ parcel.ll_gisacre ? parcel.ll_gisacre : '--' | number:2 }} acres</div>\n              </div>\n              <!-- <div class=\"section-row\">\n                  <div class=\"section-column\">Publicly Owner?</div>\n                  <div class=\"section-column\">YES - City-owned</div>\n                </div> -->\n              <div class=\"section-row\">\n                <div class=\"section-column\">Allows Residential?</div>\n                <div class=\"section-column\">{{ parcel.allows_residential ? 'YES' : 'NO'}}</div>\n              </div>\n              <div class=\"section-row\">\n                <div class=\"section-column\">Allows Commercial?</div>\n                <div class=\"section-column\">{{ parcel.allows_comm_office ? 'YES' : 'NO'}}</div>\n              </div>\n              <div class=\"section-row\">\n                <div class=\"section-column\">Excluded from Calculations?</div>\n                <div class=\"section-column\">{{ parcel.exclude ? 'YES' : 'NO'}}</div>\n              </div>\n            </div>\n          </div>\n          <div class=\"section\">\n            <div class=\"section-header\">\n              <div class=\"section-header-text dropdown\">\n                <a class=\"filter-heading section-header-text dropdown-toggle show\" type=\"button\"\n                  data-bs-toggle=\"collapse\" role=\"button\" data-bs-target=\"#parcelLandUse\" aria-controls=\"parcelLandUse\"\n                  aria-expanded=\"true\" aria-label=\"Toggle section\">\n                  Land Use Information\n                </a>\n              </div>\n            </div>\n            <div class=\"section-content collapse show\" id=\"parcelLandUse\">\n              <div class=\"section-content\">\n                <div class=\"section-subheader\">Source and Updates</div>\n                <div class=\"section-content\">\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">Land Use Data Source</div>\n                    <div class=\"section-column\">\n                      <a ng-href=\"{{parcel.zn_code_url}}\" target=\"_blank\" rel=\"noopener noreferrer\">Document Link</a>\n                    </div>\n                  </div>\n                  <!-- <div class=\"section-row\">\n                      <div class=\"section-column\">\n                        Land Use Data Last Updated\n                      </div>\n                      <div class=\"section-column\">January 23, 2022</div>\n                    </div> -->\n                </div>\n              </div>\n              <div class=\"section-content\">\n                <div class=\"section-subheader\">Zoning</div>\n                <div class=\"section-content\">\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">Primary Zoning Code</div>\n                    <div class=\"section-column\">{{parcel.zn_code}}</div>\n                  </div>\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">Primary Zoning Code Percentage</div>\n                    <div class=\"section-column\">{{parcelMultizoneDetails[0].percent_of_parcel ? parcelMultizoneDetails[0].percent_of_parcel : '100'}}%</div>\n                  </div>\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">Zoning Description</div>\n                    <div class=\"section-column\">\n                      {{parcel.zn_description}}\n                    </div>\n                  </div>\n                  <div class=\"section-row\" ng-show=\"parcelMultizoneDetails[1]\">\n                    <div class=\"section-column\">Secondary Zoning Code</div>\n                    <div class=\"section-column\">{{parcelMultizoneDetails[1].zn_recid}}</div>\n                  </div>\n                  <div class=\"section-row\"  ng-show=\"parcelMultizoneDetails[1]\">\n                    <div class=\"section-column\">Secondary Zoning Code Percentage</div>\n                    <div class=\"section-column\">{{parcelMultizoneDetails[1].percent_of_parcel}}%</div>\n                  </div>\n                  <div class=\"section-row\"  ng-show=\"parcelMultizoneDetails[1]\">\n                    <div class=\"section-column\">Secondary Zoning Description</div>\n                    <div class=\"section-column\">\n                      {{parcel.zn_description}}\n                    </div>\n                  </div>\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">Min DUA</div>\n                    <div class=\"section-column\">\n                      {{parcel.toc_min_dua ? parcel.toc_min_dua : '--'}}\n                    </div>\n                  </div>\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">Max DUA</div>\n                    <div class=\"section-column\">{{parcel.toc_max_dua ? parcel.toc_max_dua : '--'}}</div>\n                  </div>\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">\n                      Min FAR\n                    </div>\n                    <div class=\"section-column\">{{parcel.toc_min_far ? parcel.toc_min_far : '--'}}</div>\n                  </div>\n                  <div class=\"section-row\">\n                    <div class=\"section-column\">Max FAR</div>\n                    <div class=\"section-column\">{{parcel.toc_max_far ? parcel.toc_max_far : '--'}}</div>\n                  </div>\n                  <!-- <div class=\"section-row\">\n                      <div class=\"section-column\">Improvement Value</div>\n                      <div class=\"section-column\">$0.0</div>\n                    </div>\n                    <div class=\"section-row\">\n                      <div class=\"section-column\">Building Sqft</div>\n                      <div class=\"section-column\">0.0</div>\n                    </div> -->\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div id=\"activity\" class=\"tab-pane\">\n        <div class=\"sections\">\n          <div class=\"section\">\n            <div class=\"section-content section-content--activities\">\n              <div class=\"section-row\">\n                <button class=\"btn back-button active\" type=\"button\" data-bs-toggle=\"tab\"\n                  data-bs-target=\"#view-property-details\">\n                  <i class=\"fa-light fa-chevron-left\"></i>\n                </button>\n                <div class=\"section-column\">\n                  <div class=\"section-header-text\">Basic Information</div>\n                  <h3>Activity</h3>\n                </div>\n              </div>\n            </div>\n            <div w3-include-html=\"includes/map-sidebar-activity.html\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"map-tools row\">\n  <button type=\"button\" data-bs-target=\"#sidebar\" data-bs-toggle=\"collapse\" class=\"btn map-tools__toggle\"\n    aria-label=\"Edit Parcels\" title=\"Edit Parcels\">\n    <i class=\"fa-light fa-edit\"></i>\n  </button>\n  <!-- Clear Parcel Selection(s) -->\n  <!-- <button class=\"btn map-tools__clear\" type=\"button\" ng-click=\"clearParcelSelection()\"\n    aria-label=\"Clear Parcel Selection(s)\" title=\"Clear Parcel Selection(s)\" ng-show=\"selectedRecordDetails.length > 0\">\n    <i class=\"fa-light fa-eraser\"></i>\n  </button> -->\n</div>"

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.maptoolbar', []).directive('maptoolbar', function () {
	  return {
	    template: __webpack_require__(70),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = "<style>\n    .legendColor {\n        position: absolute;\n        left: 15px;\n        /* background-color: #FBAC18; */\n        width: 20px;\n        height: 20px;\n        content: '';\n    }\n</style>\n<div class=\"map-toolbar\">\n    <nav class=\"nav nav-tabs flex-column\">\n        <div ng-repeat=\"item in tabPanelTypes\">\n            <button type=\"button\" data-bs-target=\"#{{item.tab}}\" data-bs-toggle=\"collapse\" class=\"btn tab-button-icon\"\n                ng-class=\"{ 'collapsed': !item.active }\"\n            aria-label=\" Expand Filters Panel\" aria-expanded=\"false\" ng-click=\"manageTabPanels(item.tab)\">\n                <i class=\"fa-light {{item.icon}}\"></i> {{item.name}}\n            </button>\n        </div>\n        <!-- <button type=\"button\" data-bs-target=\"#filters\" data-bs-toggle=\"collapse\" class=\"btn tab-button-icon collapsed\"\n            aria-label=\"Expand Filters Panel\" aria-expanded=\"false\" ng-click=\"manageTabPanels(filters)\">\n            <i class=\"fa-light fa-filter\"></i> Filters\n        </button>\n        <button type=\"button\" data-bs-target=\"#basemap\" data-bs-toggle=\"collapse\" class=\"btn tab-button-icon collapsed\"\n            aria-label=\"Expand Basemap Panel\" aria-expanded=\"false\"  ng-click=\"manageTabPanels(basemap)\">\n            <i class=\"fa-light fa-grid-2\"></i> Basemap\n        </button>\n        <button type=\"button\" data-bs-target=\"#layers\" data-bs-toggle=\"collapse\" class=\"btn tab-button-icon collapsed\"\n            aria-label=\"Expand Layers Panel\" aria-expanded=\"false\"  ng-click=\"manageTabPanels(layers)\">\n            <i class=\"fa-light fa-layer-group\"></i> Layers\n        </button>\n        <button type=\"button\" data-bs-target=\"#legend\" data-bs-toggle=\"collapse\" class=\"btn tab-button-icon collapsed\"\n            aria-label=\"Expand Legend Panel\" aria-expanded=\"false\"  ng-click=\"manageTabPanels(legend)\">\n            <i class=\"fa-light fa-list\"></i> Legend\n        </button> -->\n        <!-- <button type=\"button\" data-bs-target=\"#tools\" data-bs-toggle=\"collapse\" class=\"btn tab-button-icon collapsed\"\n            aria-label=\"Expand Tools Panel\" aria-expanded=\"false\">\n            <i class=\"fa-light fa-cog\"></i> Tools\n        </button> -->\n\n\n    </nav>\n    <div style=\"min-height: 100%\" role=\"tabpanel\" id=\"filters\"\n        class=\"nav-item collapse collapse-horizontal map-toolbar__pane show\">\n        <div style=\"width: 310px;\">\n            <!-- <h2 class=\"pane-heading\">Filters <button type=\"button\" data-bs-target=\"#filters\" data-bs-toggle=\"collapse\"\n                    class=\"btn close-button-icon\" aria-label=\"Close\">\n                    <i class=\"fa-light fa-times\"></i>\n                </button></h2> -->\n            <form>\n                <div class=\"filter-section\">\n                    <div class=\"form-item form-item--select\" ng-show=\"getCurrentUser().role !== 'User'\">\n                        <label for=\"jurisdiction\">Jurisdiction</label>\n                        <select name=\"jurisdiction\" id=\"jurisdiction\" ng-model=\"filter.jurisdiction\"\n                            ng-change=\"getStationAreaList(filter.jurisdiction)\">\n                            <option ng-repeat=\"item in jurisdictions\" ng-value=\"item.jurisdiction\">\n                                {{item.jurisdiction}}\n                            </option>\n                        </select>\n                    </div>\n                    <div class=\"form-item form-item--select\">\n                        <label for=\"station\">Station Area</label>\n                        <select name=\"station\" id=\"station\" ng-model=\"filter.station_name\" ng-change=\"getStationbyID()\">\n                            <option value=\"\"></option>\n                            <option ng-repeat=\"item in stationAreas\" ng-value=\"item.station_name\">\n                                {{item.station_name}}\n                            </option>\n                            <!-- <option ng-repeat=\"item in stationAreas\" value=\"{{item.sta_id}}\">{{item.station}}</option> -->\n                        </select>\n                    </div>\n                    <div class=\"form-item form-item--checkboxes\">\n                        <div class=\"filter-heading\">Filters</div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                ng-model=\"filter.allows_residential\" />\n                            <label class=\"form-check-label\" for=\"foo\">\n                                Allows Residential\n                            </label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                ng-model=\"filter.allows_comm_office\" />\n                            <label class=\"form-check-label\" for=\"bar\">\n                                Allows Office\n                            </label>\n                        </div>\n                        <div class=\"form-item form-item--select\" style=\"padding-top: 10px\">\n                            <label for=\"station\">Zoning Code</label>\n                            <select name=\"station\" id=\"station\" ng-model=\"filter.zn_recid\">\n                                <option ng-repeat=\"item in znCodes\" ng-value=\"item.zn_recid\">\n                                    {{item.zn_code}}: <span style=\"font-size: smaller; color: #666;\">\n                                        {{item.zn_description}}</span>\n                                </option>\n                                <!-- <option ng-repeat=\"item in stationAreas\" value=\"{{item.sta_id}}\">{{item.station}}</option> -->\n                            </select>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"filter-section\">\n                    <button type=\"submit\" class=\"button\" ng-click=\"updateMap()\">\n                        <i ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Apply Filters\n                    </button>\n                    <button type=\"submit\" class=\"button\" ng-click=\"mapCtrl.resetFilters()\">\n                        Reset\n                    </button>\n                </div>\n        </div>\n        <div class=\"col d-flex flex-column gap-2 fs-1\" style=\"width: 100%; max-width: 255px;\">\n            <button class=\"button w-100\" ng-click=\"downloadShapefile()\">\n                <i class=\"fa-solid fa-download\"></i> TOC Shapefile\n            </button>\n            <button class=\"button w-100\" ng-click=\"downloadParcelData()\">\n                <i class=\"fa-solid fa-download\"></i> TOC Parcel Data\n            </button>\n        </div>\n        <div class=\"section-pin\" style=\"padding-left: 10px;margin-left:10px;\">\n            <strong>Note:</strong> To select multiple parcels within a station area on the map, hold down\n            <strong>shift key and left click</strong> on your mouse to drag the marquee box over desired parcels.\n            When satisfied with the selection, release the shift key and mouse button.\n        </div>\n        </form>\n    </div>\n</div>\n<div style=\"min-height: 100%\" role=\"tabpanel\" id=\"layers\"\n    class=\"nav-item collapse collapse-horizontal map-toolbar__pane\">\n    <div style=\"width: 310px;\">\n        <h2 class=\"pane-heading\">Layers <button type=\"button\" data-bs-target=\"#layers\" data-bs-toggle=\"collapse\"\n                class=\"btn close-button-icon\" aria-label=\"Close\">\n                <i class=\"fa-light fa-times\"></i>\n            </button></h2>\n        <form>\n            <div class=\"filter-section\">\n                <div class=\"form-item form-check form-switch\">\n                    <input class=\"form-check-input\" type=\"checkbox\" role=\"switch\" id=\"layerName2\"\n                        ng-model=\"stationAreaLayerToggle\" ng-change=\"mapCtrl.toggleMapLayer('stationAreaLayer')\">\n                    <label class=\"form-check-label\" for=\"layerName2\">Station Area/Corridor</label>\n                </div>\n                <div class=\"form-item form-check form-switch\">\n                    <input class=\"form-check-input\" type=\"checkbox\" role=\"switch\" id=\"layerName1\"\n                        ng-model=\"sphereofinfluenceLayerToggle\"\n                        ng-click=\"mapCtrl.toggleMapLayer('sphereofinfluenceLayer')\">\n                    <label class=\"form-check-label\" for=\"layerName1\">Jurisdiction Boundary</label>\n                </div>\n                <div class=\"form-item form-check form-switch\">\n                    <input class=\"form-check-input\" type=\"checkbox\" role=\"switch\" id=\"layerName2\"\n                        ng-model=\"urbanLayerToggle\" ng-change=\"mapCtrl.toggleMapLayer('urbanLayer')\">\n                    <label class=\"form-check-label\" for=\"layerName2\">Urban Area Footprint</label>\n                </div>\n                <div class=\"form-item form-check form-switch\">\n                    <input class=\"form-check-input\" type=\"checkbox\" role=\"switch\" id=\"layerName2\"\n                        ng-model=\"pdaLayerToggle\" ng-change=\"mapCtrl.toggleMapLayer('pdaLayer')\">\n                    <label class=\"form-check-label\" for=\"layerName2\">Priority Development Area</label>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n<div style=\"min-height: 100%\" role=\"tabpanel\" id=\"basemap\"\n    class=\"nav-item collapse collapse-horizontal map-toolbar__pane map-toolbar__pane--basemap\">\n    <div style=\"width: 310px;\">\n        <h2 class=\"pane-heading\">Basemap <button type=\"button\" data-bs-target=\"#basemap\" data-bs-toggle=\"collapse\"\n                class=\"btn close-button-icon\" aria-label=\"Close\">\n                <i class=\"fa-light fa-times\"></i>\n            </button></h2>\n        <form>\n            <div class=\"filter-section\">\n                <div class=\"form-check\">\n                    <input class=\"form-check-input visually-hidden\" type=\"radio\" name=\"basemap\" id=\"basemap1\"\n                        ng-click=\"updateBaseMap('light-v11')\" checked>\n                    <label class=\"form-check-label\" for=\"basemap1\">\n                        <img src=\"./../../../assets/images/basemap-light.png\" height=\"151\" width=\"271\" alt=\"\" />\n                        <span>Light</span>\n                    </label>\n                </div>\n                <div class=\"form-check\">\n                    <input class=\"form-check-input visually-hidden\" type=\"radio\" name=\"basemap\" id=\"basemap2\"\n                        ng-click=\"updateBaseMap('dark-v11')\">\n                    <label class=\"form-check-label\" for=\"basemap2\">\n                        <img src=\"./../../../assets/images/basemap-dark.png\" height=\"151\" width=\"271\" alt=\"\" />\n                        <span>Dark</span>\n                    </label>\n                </div>\n                <div class=\"form-check\">\n                    <input class=\"form-check-input visually-hidden\" type=\"radio\" name=\"basemap\" id=\"basemap3\"\n                        ng-click=\"updateBaseMap('streets-v12')\">\n                    <label class=\"form-check-label\" for=\"basemap3\">\n                        <img src=\"./../../../assets/images/basemap-streets.png\" height=\"151\" width=\"271\" alt=\"\" />\n                        <span>Streets</span>\n                    </label>\n                </div>\n                <div class=\"form-check\">\n                    <input class=\"form-check-input visually-hidden\" type=\"radio\" name=\"basemap\" id=\"basemap4\"\n                        ng-click=\"updateBaseMap('satellite-streets-v12')\">\n                    <label class=\"form-check-label\" for=\"basemap4\">\n                        <img src=\"./../../../assets/images/basemap-satellite.png\" height=\"151\" width=\"271\" alt=\"\" />\n                        <span>Satellite</span>\n                    </label>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n<div style=\"min-height: 100%\" role=\"tabpanel\" id=\"legend\"\n    class=\"nav-item collapse collapse-horizontal map-toolbar__pane map-toolbar__pane--legend\">\n    <div style=\"width: 310px;\">\n        <h2 class=\"pane-heading\">Legend <button type=\"button\" data-bs-target=\"#legend\" data-bs-toggle=\"collapse\"\n                class=\"btn close-button-icon\" aria-label=\"Close\">\n                <i class=\"fa-light fa-times\"></i>\n            </button></h2>\n        <form>\n            <div class=\"filter-section\">\n                <h3>Corridor/Station Area</h3>\n                <ul>\n                    <div class=\"legendColor\" style=\"background-color: yellow !important;\"></div>\n                    <li>Tier 1 Station</li>\n                    <div class=\"legendColor\" style=\"background-color: green !important;\"></div>\n                    <li>Tier 2 Station</li>\n                    <div class=\"legendColor\" style=\"background-color: red !important;\"></div>\n                    <li>Tier 3 Station</li>\n                    <div class=\"legendColor\" style=\"background-color: purple !important;\"></div>\n                    <li>Tier 4 Station</li>\n                </ul>\n\n            </div>\n        </form>\n    </div>\n</div>\n<div style=\"min-height: 100%\" role=\"tabpanel\" id=\"tools\"\n    class=\"nav-item collapse collapse-horizontal map-toolbar__pane map-toolbar__pane--tools\">\n    <div style=\"width: 310px;\">\n        <h2 class=\"pane-heading\">Tools <button type=\"button\" data-bs-target=\"#tools\" data-bs-toggle=\"collapse\"\n                class=\"btn close-button-icon\" aria-label=\"Close\">\n                <i class=\"fa-light fa-times\"></i>\n            </button></h2>\n        <form>\n            <div class=\"filter-section\">\n                <div class=\"form-item form-check form-switch\">\n                    <input class=\"form-check-input\" type=\"checkbox\" role=\"switch\" id=\"tool1\">\n                    <label class=\"form-check-label\" for=\"tool1\">Setting Toggle Label</label>\n                </div>\n                <div class=\"form-item form-check form-switch\">\n                    <input class=\"form-check-input\" type=\"checkbox\" role=\"switch\" id=\"tool2\" checked>\n                    <label class=\"form-check-label\" for=\"tool2\">Setting Toggle Label</label>\n                </div>\n                <div class=\"form-item form-check form-switch\">\n                    <input class=\"form-check-input\" type=\"checkbox\" role=\"switch\" id=\"tool3\">\n                    <label class=\"form-check-label\" for=\"tool3\">Setting Toggle Label</label>\n                </div>\n                <div class=\"form-item form-check form-switch\">\n                    <input class=\"form-check-input\" type=\"checkbox\" role=\"switch\" id=\"tool4\">\n                    <label class=\"form-check-label\" for=\"tool4\">Setting Toggle Label</label>\n                </div>\n            </div>\n            <div class=\"filter-section filter-section--border-top\">\n                <button type=\"reset\" class=\"button\">Reset Map</button>\n            </div>\n        </form>\n    </div>\n</div>\n</div>\n"

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.selecthousingpolicies', []).directive('selecthousingpolicies', function () {
	  return {
	    template: __webpack_require__(72),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"accordion\" id=\"accordionHousing3\" style=\"z-index: 1\">\n  <div class=\"accordion-item\">\n    <div class=\"accordion-header\" style=\"z-index: 1\">\n      <button style=\"z-index: 1\" class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\"\n        data-bs-target=\"#collapseTwo\" aria-expanded=\"false\" aria-controls=\"collapseTwo\">\n        <span ng-show=\"currentlySelectedPolicies.length === 0\" class=\"accordion-title\">Select Policies</span>\n        <span ng-show=\"currentlySelectedPolicies.length > 0\"\n          class=\"accordion-title\">{{currentlySelectedPolicies.length}} Policies Selected</span>\n        <span ng-show=\"currentlySelectedPolicies.length > 0\" class=\"accordion-compliance\"><a style=\"color: white\"\n            href=\"#\" class=\"button\"><i class=\"fa-solid fa-edit\"></i> Edit Selection</a>\n        </span>\n        <span class=\"sr-only\">Expand/collapse</span>\n      </button>\n    </div>\n    <div id=\"collapseTwo\" class=\"accordion-collapse collapse\" data-bs-parent=\"#accordionHousing3\">\n      <div class=\"accordion-body\">\n        <table class=\"table table--default table--compliance\">\n          <thead>\n            <tr>\n              <th scope=\"col\">Policy Name</th>\n              <th scope=\"col\">Selected?</th>\n              <th scope=\"col\">Policy Details</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"item in housingForms\">\n              <td style=\"width: 60%\">\n                <!-- <a href=\"#\" ng-click=\"goToForm(item)\">{{item.housing_policy_name}}</a> -->\n                {{item.housing_policy_name}}\n              </td>\n              <td style=\"width: 20%\">\n                <div class=\"form-check\">\n                  <input class=\"form-check-input\" type=\"checkbox\" ng-model=\"item.policy_selected\"\n                    ng-change=\"updateSelected(item)\"\n                    ng-disabled=\"checkPolicy1.housing_policy_name === item.housing_policy_name || checkPolicy2.housing_policy_name === item.housing_policy_name\" />\n                </div>\n              </td>\n              <td style=\"width: 20%\">\n                <button class=\"button\" ng-click=\"openPdf(item)\">More Info</button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var MainTOCSelectionComponent = exports.MainTOCSelectionComponent = function () {
	  function MainTOCSelectionComponent($state, $scope, $rootScope, fetch, lookup) {
	    'ngInject';
	
	    _classCallCheck(this, MainTOCSelectionComponent);
	
	    this.menu = [{
	      title: 'Home',
	      url: 'main'
	    }];
	    this.isCollapsed = true;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.fetch = fetch;
	
	    $scope.getJurisdictionList = function () {
	      fetch.getAllItems('api/data/jurisdictions/list').then(function (response) {
	
	        $scope.jurisdictions = response.data;
	        $scope.jurisdiction = response.data[0].jurisdiction;
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	  }
	
	  _createClass(MainTOCSelectionComponent, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return MainTOCSelectionComponent;
	}();
	
	exports.default = angular.module('appApp.maintocselection', []).directive('maintocselection', function () {
	  return {
	    template: __webpack_require__(74),
	    restrict: 'EA',
	    controller: MainTOCSelectionComponent,
	    controllerAs: 'mainTOCCtrl',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"toc-selection-container row\">\n    <div class=\"form-item form-item--status\">\n      You are currently editing / viewing:\n    </div>\n    <div class=\"form-item form-item--select\" ng-show=\"getCurrentUser().role !== 'User'\">\n      <label for=\"jurisdiction\">Jurisdiction</label>\n      <select name=\"jurisdiction\" id=\"jurisdiction\" ng-model=\"currentJurisdiction\"\n        ng-change=\"getStationAreaList(currentJurisdiction); getJursdictionFundingTier(currentJurisdiction)\">\n        <option ng-repeat=\"item in jurisdictions\" ng-value=\"item.jurisdiction\">\n          {{item.jurisdiction}}\n        </option>\n      </select>\n    </div>\n    <div class=\"form-item form-item--select\">\n\n      <label for=\"sta_recid\">{{getCurrentUser().organization}}</span> TOC Area</label>\n      <select name=\"sta_recid\" id=\"sta_recid\" ng-model=\"currentSelectedStationId\"\n        ng-change=\"getStationbyID(currentSelectedStationId)\">\n        <option ng-repeat=\"item in stationAreas\" ng-value=\"item.sta_recid\">\n\n          {{item.station_name}}\n        </option>\n      </select>\n    </div>\n  </form>"

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.maintocselectiondensity', []).directive('maintocselectiondensity', function () {
	  return {
	    template: __webpack_require__(76),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"toc-selection-container row\">\n  <div class=\"form-item form-item--status\">\n    You are currently editing / viewing:\n  </div>\n  <div class=\"form-item form-item--select\" ng-show=\"getCurrentUser().role !== 'User'\">\n    <label for=\"jurisdiction\">Jurisdiction</label>\n    <select name=\"jurisdiction\" id=\"jurisdiction\" ng-model=\"currentJurisdiction\"\n      ng-change=\"getStationAreaList(currentJurisdiction)\">\n      <option ng-repeat=\"item in jurisdictions\" ng-value=\"item.jurisdiction\">\n        {{item.jurisdiction}}\n      </option>\n    </select>\n  </div>\n  <div class=\"form-item form-item--select\">\n\n    <label for=\"sta_recid\"><span ng-show=\"getCurrentUser().role === 'User'\">{{getCurrentUser().organization}}</span>\n      TOC Area</label>\n    <select name=\"sta_recid\" id=\"sta_recid\" ng-model=\"currentSelectedStationId\" ng-change=\"getStationbyID(currentSelectedStationId)\">\n      <option ng-repeat=\"item in stationAreas\" ng-value=\"item.sta_recid\">\n\n        {{item.station_name}}\n      </option>\n    </select>\n  </div>\n</form>"

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.note', []).directive('note', function () {
	  return {
	    template: __webpack_require__(78),
	    restrict: 'EA',
	    scope: {
	      noteContent: '='
	    },
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"section-pin\">\n  <p ng-if=\"note\" ng-bind-html=\"note\"></p>\n</div>\n"

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.pageintro', []).directive('pageintro', function () {
	  return {
	    template: __webpack_require__(80),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = "<h1 class=\"page-title\">Page Title </h1>\n<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n"

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.statuspills', []).directive('statuspills', function () {
	  return {
	    template: __webpack_require__(82),
	    restrict: 'EA',
	    scope: {
	      status: '=',
	      rowData: '=',
	      onUpdate: '&',
	      userRole: '=' },
	    link: function link(scope, element, attrs) {
	      scope.getStatusClass = function (status) {
	        switch (status ? status.toLowerCase() : '') {
	          case 'consistent':
	            return 'status-pill--compliant';
	          case 'in review':
	            return 'status-pill--in-review';
	          case 'needs work':
	            return 'status-pill--needs-work';
	          case 'not consistent':
	            return 'status-pill--not-compliant';
	          default:
	            return 'status-pill--not-compliant';}
	      };
	
	      scope.isDisabled = function () {
	        return scope.userRole !== 'Administrator';
	      };
	
	      scope.formatStatus = function (status) {
	        if (!status) return 'Select Status';
	        return status.toLowerCase().split(' ').map(function (word) {
	          return word.charAt(0).toUpperCase() + word.slice(1);
	        }).join(' ');
	      };
	
	      scope.updateStatus = function (newStatus) {
	        if (scope.isDisabled()) {
	          return;
	        }
	
	        if (scope.status === newStatus) {
	          return;
	        }
	
	        scope.onUpdate({
	          row: scope.rowData,
	          newStatus: newStatus });
	      };
	    }
	  };
	}).name;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dropdown dropdown--status-pills\">\n  <!-- Read-only version for non-administrators -->\n  <button class=\"status-pill\" ng-class=\"getStatusClass(status)\" ng-if=\"isDisabled()\">\n    {{ formatStatus(status) }}\n  </button>\n  \n  <!-- Interactive version only for administrators -->\n  <button class=\"status-pill\" ng-class=\"getStatusClass(status)\" \n    data-bs-toggle=\"dropdown\"\n    aria-expanded=\"false\"\n    ng-if=\"!isDisabled()\">\n    {{ formatStatus(status) }}\n  </button>\n  \n  <!-- Dropdown menu only for administrators -->\n  <ul class=\"dropdown-menu\" ng-if=\"!isDisabled()\" style=\"\n      --bs-dropdown-min-width: 0;\n      --bs-dropdown-border-radius: 4px;\n      --bs-dropdown-border-color: #BFCBCF;\n      --bs-dropdown-link-hover-bg: #f2f5f5;\n      --bs-dropdown-link-hover-color: #072751;\n      --bs-dropdown-link-active-bg: #e5eaec;\n      --bs-dropdown-link-active-color: #072751;\n      --bs-dropdown-padding-y: 0;\n    \">\n    <li><button class=\"dropdown-item status-pill status-pill--in-review\" ng-click=\"updateStatus('In Review')\">In Review</button></li>\n    <li><button class=\"dropdown-item status-pill status-pill--needs-work\" ng-click=\"updateStatus('Needs Work')\">Needs Work</button></li>\n    <li><button class=\"dropdown-item status-pill status-pill--not-compliant\" ng-click=\"updateStatus('Not Consistent')\">Not Consistent</button></li>\n    <li><button class=\"dropdown-item status-pill status-pill--compliant\" ng-click=\"updateStatus('Consistent')\">Consistent</button></li>\n  </ul>\n</div>\n"

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var SubmissionSectionConfirmationComponent = exports.SubmissionSectionConfirmationComponent = function () {
	  function SubmissionSectionConfirmationComponent($state, $scope, $rootScope, fetch, lookup) {
	    'ngInject';
	
	    _classCallCheck(this, SubmissionSectionConfirmationComponent);
	
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.lookup = lookup;
	
	    $scope.submitDensity = function () {
	      if (!$scope.currentSelectedStationId && !$scope.submitDensityForReview) {
	        return;
	      }
	
	      $scope.saving = true;
	      var upsertData = [];
	
	      $scope.updateCurrentDensityPolicy();
	
	      fetch.getAllItems('api/data/submissionsbytype/' + $scope.currentJurisdiction + '/Density').then(function (response) {
	        var stationData = _.filter(response.data, { sta_recid: $scope.currentSelectedStationId });
	
	        stationData.forEach(function (element) {
	          if ($scope.densityType === 'Residential') {
	            if (element.submission_policy_name === 'Residential Uses Data Verification') {
	              console.log('Found Residential Uses policy record:', element);
	              console.log('Current $scope.submissions:', $scope.submissions);
	              console.log('Is "Residential Uses Data Verification" in submissions?', $scope.submissions ? $scope.submissions.includes('Residential Uses Data Verification') : 'submissions undefined');
	              console.log('Is element already submitted?', element.submitted);
	
	              if ($scope.submissions && $scope.submissions.includes('Residential Uses Data Verification') && !element.submitted) {
	                upsertData.push({
	                  submission_id: element.submission_id,
	                  density_residential_uses: true,
	                  submitted: true
	                });
	              }
	            } else if (element.submission_policy_name === 'Minimum Density Residential') {
	              if ($scope.currentStation.weighted_average_toc_min_dua >= 0) {
	                element.min_dua = $scope.currentStation.weighted_average_toc_min_dua;
	                element.submitted = true;
	                upsertData.push({
	                  submission_id: element.submission_id,
	                  min_dua: element.min_dua,
	                  submitted: true
	                });
	              }
	            } else if (element.submission_policy_name === 'Maximum Density Residential') {
	              if ($scope.currentStation.weighted_average_toc_max_dua >= 0) {
	                element.max_dua = $scope.currentStation.weighted_average_toc_max_dua;
	                element.submitted = true;
	                upsertData.push({
	                  submission_id: element.submission_id,
	                  max_dua: element.max_dua,
	                  submitted: true
	                });
	              }
	            }
	          }
	
	          if ($scope.densityType === 'Commercial') {
	            if (element.submission_policy_name === 'Commercial Office Uses Data Verification') {
	              console.log('Found Commercial Office Uses policy record:', element);
	              console.log('Current $scope.submissions:', $scope.submissions);
	              console.log('Is "Commercial Office Uses Data Verification" in submissions?', $scope.submissions ? $scope.submissions.includes('Commercial Office Uses Data Verification') : 'submissions undefined');
	              console.log('Is element already submitted?', element.submitted);
	              if ($scope.submissions && $scope.submissions.includes('Commercial Office Uses Data Verification') && !element.submitted) {
	                upsertData.push({
	                  submission_id: element.submission_id,
	                  density_commercial_uses: true,
	                  submitted: true
	                });
	              }
	            };
	
	            if (element.submission_policy_name === 'Minimum FAR Office') {
	              if ($scope.currentStation.weighted_average_toc_min_far >= 0) {
	                element.min_far = $scope.currentStation.weighted_average_toc_min_far;
	                element.submitted = true;
	                upsertData.push({
	                  submission_id: element.submission_id,
	                  min_far: element.min_far,
	                  submitted: true
	                });
	              }
	            } else if (element.submission_policy_name === 'Maximum FAR Office') {
	              if ($scope.currentStation.weighted_average_toc_max_far >= 0) {
	                element.max_far = $scope.currentStation.weighted_average_toc_max_far;
	                element.submitted = true;
	                upsertData.push({
	                  submission_id: element.submission_id,
	                  max_far: element.max_far,
	                  submitted: true
	                });
	              }
	            }
	          }
	        });
	
	        fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	          console.log('Submitted Policies:', response.data);
	
	          $scope.saving = false;
	          $scope.submitted = true;
	          $scope.saved = true;
	          $scope.pendingChanges = false;
	          setTimeout(function () {
	            $scope.submitmode = null;
	            $scope.saved = false;
	            $scope.$apply();
	          }, 2000);
	        }).catch(function (err) {
	          console.log(err);
	          if (err.status === 403) {
	            $state.go('login');
	          }
	        });
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.saveZoningCodes = function () {
	      $scope.saving = true;
	      fetch.updateItem('api/data/density/zoning/update', $scope.updateData).then(function (response) {
	        $scope.pendingChangesCount = {};
	        $scope.updateData = [];
	        $scope.pendingChanges = false;
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.success = true;
	        $scope.showPendingCount = false;
	        $scope.saveType = null;
	
	        $scope.getStationbyID();
	
	        setTimeout(function () {
	          $scope.$apply();
	        }, 100);
	
	        setTimeout(function () {
	          $scope.success = false;
	          $scope.savemode = null;
	          $scope.saved = false;
	          $scope.successMessage = null;
	          $scope.$apply();
	        }, 10000);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.cancelUpdates = function () {
	      $scope.pendingChanges = false;
	      $scope.pendingChangesCount = [];
	      $scope.savemode = null;
	      for (var index = 0; index < $scope.updateData.length; index++) {
	        $scope.hot.undo();
	      }
	    };
	
	    $scope.beforeSave = function () {
	      $scope.savemode = 'density';
	      $scope.saveType = 'Save Zoning Changes';
	      $scope.showPendingCount = true;
	      fetch.updateItem('api/data/parcels/zoning/counts/' + $scope.currentJurisdiction, $scope.updateData).then(function (response) {
	
	        $scope.pendingChangesCount = response.data;
	        $scope.pendingChanges = true;
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	  }
	
	  _createClass(SubmissionSectionConfirmationComponent, [{
	    key: 'gotoPage',
	    value: function gotoPage(page, subPage) {
	      if (subPage) {
	        this.$location.url(subPage.url);
	        this.$rootScope.subItem = subPage;
	        this.subNavActive(subPage);
	        this.navService.setBreadCrumb(page, subPage);
	      } else {
	        this.$rootScope.page = page;
	        this.$rootScope.subItem = null;
	        this.$location.url(page.url);
	        this.navService.setBreadCrumb(page);
	      }
	    }
	  }, {
	    key: 'updateBreadcrumb',
	    value: function updateBreadcrumb(subItem, item) {
	      this.$rootScope.page = item;
	      this.$rootScope.subItem = subItem;
	      this.$location.url(subItem.url);
	      this.showSubNav(item);
	      this.subNavActive(item, subItem);
	    }
	  }, {
	    key: 'subNavActive',
	    value: function subNavActive(subPage) {
	      this.$scope.menu.forEach(function (element) {
	        if (element.subItem1) {
	          for (var index = 0; index < element.subItem1.length; index++) {
	            var checkUrl = element.subItem1[index].url;
	            if (checkUrl.url !== subPage.url) {
	              element.subItem1[index].active = false;
	            }
	          }
	        }
	      });
	      subPage.active = true;
	    }
	  }]);
	
	  return SubmissionSectionConfirmationComponent;
	}();
	
	exports.default = angular.module('appApp.submissionsectionsubmit', []).directive('submissionsectionsubmit', function () {
	  return {
	    template: __webpack_require__(84),
	    restrict: 'EA',
	    controller: SubmissionSectionConfirmationComponent,
	    controllerAs: 'submissionSectionCtrl',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = "<!-- Submit button updates based on what is being saved/submitted  -->\n<!-- Density Save and Submit  -->\n<div class=\"form-actions form-footer\" ng-show=\"!editmode\">\n      <!-- No changes or saves in progress  -->\n</div>\n\n<!-- Density  -->\n<div class=\"form-actions form-footer\" ng-show=\"savemode === 'density'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Saved!</div>\n      <div class=\"form-item form-item--status\" ng-show=\"showPendingCount\"><i class=\"fa-light fa-info me-2\"></i>\n            Pending changes will update {{pendingChangesCount.length > 0 ? pendingChangesCount.length : 0}} parcels\n      </div>\n      <div class=\"form-item--submit\" style=\"padding-right:5px;\"><button class=\"button\" ng-click=\"saveZoningCodes()\"><i\n                        ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Save Changes</button></div>\n      <div class=\"form-item--submit\"><button class=\"button\" ng-click=\"cancelUpdates()\">Cancel</button></div>\n</div>\n\n\n<!-- Density  -->\n<div class=\"form-actions form-footer\" ng-show=\"savemode === 'validation'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Saved!</div>\n      <div class=\"form-item--submit\"><button class=\"button\" ng-click=\"updateCurrentDensityPolicy()\"><i ng-show=\"saving\"\n                        class=\"fa-solid fa-cog fa-spin\"></i> Save\n                  Changes</button></div>\n</div>\n\n<!-- <div class=\"form-actions form-footer\" ng-show=\"savemode === 'density'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Saved!</div>\n      <div class=\"form-item--submit\" ng-show=\"pendingChanges\"><button class=\"button\"\n                  ng-click=\"updateCurrentDensityPolicy()\"><i ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Save\n                  Changes</button></div>\n</div> -->\n\n<!-- Submit Density for review  -->\n<div class=\"form-actions form-footer\" ng-show=\"submitDensityForReview\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Submitted\n            successfully!\n      </div>\n      <div class=\"form-item--submit\" ng-show=\"!submitted\"><button class=\"button\" ng-click=\"submitDensity()\"><i\n                        ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Submit for Review</button></div>\n      <div class=\"form-item--submit\" ng-show=\"submitted\"><button class=\"button\" disabled><i ng-show=\"saving\"\n                        class=\"fa-solid fa-cog fa-spin\"></i> Submitted</button></div>\n</div>\n\n\n<!-- Housing Save and Submit  -->\n<!-- Submit  -->\n<div class=\"form-actions form-footer\" ng-show=\"submitmode === 'housing'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Submitted\n            successfully!\n      </div>\n      <div class=\"form-item--submit\" ng-show=\"!submitted\"><button class=\"button\" ng-click=\"submitPolicies()\"><i\n                        ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> {{submitType}}</button></div>\n</div>\n<!-- Save  -->\n<div class=\"form-actions form-footer\" ng-show=\"savemode === 'housing'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Saved!</div>\n      <div class=\"form-item--submit\" ng-show=\"pendingChanges\"><button class=\"button\"\n                  ng-click=\"updateCurrentPolicy(housingForm)\"><i ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Save\n                  Changes</button></div>\n</div>\n\n<!-- Jurisdiction Zoning Submissions  -->\n<!-- Submit  -->\n<div class=\"form-actions form-footer\" ng-show=\"submitmode === 'zoningUpdates'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Submitted\n            successfully!\n      </div>\n      <div class=\"form-item--submit\" ng-show=\"!submitted\"><button class=\"button\" ng-click=\"submitZoningUpdates()\"><i\n                        ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Submit for\n                  Review ({{submissions.length}})</button></div>\n      <div class=\"form-item--submit\" ng-show=\"submitted\"><button class=\"button\" disabled><i ng-show=\"saving\"\n                        class=\"fa-solid fa-cog fa-spin\"></i> Submitted</button></div>\n</div>\n<!-- Save  -->\n<div class=\"form-actions form-footer\" ng-show=\"savemode === 'zoningUpdates'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Saved!</div>\n      <div class=\"form-item--submit\" ng-show=\"!submitted\"><button class=\"button\" ng-click=\"updateZoningForm()\"><i\n                        ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Save Changes</button></div>\n</div>\n\n\n<!-- Station Access  -->\n<!-- Submit  -->\n<div class=\"form-actions form-footer\" ng-show=\"submitmode === 'stationaccess'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Submitted\n            successfully!\n      </div>\n      <div class=\"form-item--submit\" ng-show=\"!submitted\"><button class=\"button\" ng-click=\"submitStationAccess()\"><i\n                        ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Submit for Review\n                  ({{submissions.length}})</button></div>\n      <div class=\"form-item--submit\" ng-show=\"submitted\"><button class=\"button\" disabled><i ng-show=\"saving\"\n                        class=\"fa-solid fa-cog fa-spin\"></i> Submitted</button></div>\n</div>\n<!-- Save  -->\n<div class=\"form-actions form-footer\" ng-show=\"savemode === 'stationaccess'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Saved!</div>\n      <div class=\"form-item--submit\" ng-show=\"!submitted\"><button class=\"button\"\n                  ng-click=\"updateCurrentStationPolicy()\"><i ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Save\n                  Changes</button></div>\n</div>\n<!-- Station Access  -->\n<!-- Submit  -->\n<div class=\"form-actions form-footer\" ng-show=\"submitmode === 'parking'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Submitted\n            successfully!\n      </div>\n      <div class=\"form-item--submit\" ng-show=\"!submitted\"><button class=\"button\" ng-click=\"submitParking()\"><i\n                        ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Submit for Review\n                  ({{submissions.length}})</button></div>\n      <div class=\"form-item--submit\" ng-show=\"submitted\"><button class=\"button\" disabled><i ng-show=\"saving\"\n                        class=\"fa-solid fa-cog fa-spin\"></i> Submitted</button></div>\n</div>\n<!-- Save  -->\n<div class=\"form-actions form-footer\" ng-show=\"savemode === 'parking'\">\n      <div class=\"form-item form-item--status\" ng-show=\"saved\"><i class=\"fa-light fa-check me-2\"></i>Saved!</div>\n      <div class=\"form-item--submit\" ng-show=\"!submitted\"><button class=\"button\"\n                  ng-click=\"updateCurrentParkingPolicy()\"><i ng-show=\"saving\" class=\"fa-solid fa-cog fa-spin\"></i> Save\n                  Changes</button></div>\n</div>"

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.submissionsectionconfirmation', []).directive('submissionsectionconfirmation', function () {
	  return {
	    template: __webpack_require__(86),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"form-confirmation\">\n    <div class=\"form-confirmation__header\">\n        <p>You submitted</p>\n        <p class=\"h2\" style=\"padding-top:20px;\" ng-repeat=\"item in submissionList\">{{item}}</p>\n    </div>\n    <div class=\"form-confirmation__message\">\n        <p>Your submissions have been received by MTC and are currently in review. We will contact you should any questions arise or any further information be required.</p>\n    </div>\n</div>\n"

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.handsontable', []).directive('handsontable', function () {
	  return {
	    template: __webpack_require__(88),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"example\" class=\"hot\"></div>\n<!-- <div data-preset-type=\"hot\" data-example-id=\"example\">\n    <div id=\"example\" dir=\"ltr\" class=\"ht__manualRowMove handsontable htRowHeaders htColumnHeaders\"\n        style=\"height: 450px; overflow: hidden;\" data-originalstyle=\"height: 450px; overflow: hidden;\">\n        <div class=\"ht_master handsontable\" dir=\"ltr\">\n            <div class=\"wtHolder\">\n                <div class=\"wtHider\">\n                    <div class=\"wtSpreader\">\n                        <table class=\"htCore\">\n                            <colgroup>\n                                <col class=\"rowHeader\" style=\"width: 50px;\">\n                                <col style=\"width: 140px;\">\n                                <col style=\"width: 192px;\">\n                                <col style=\"width: 100px;\">\n                                <col style=\"width: 90px;\">\n                                <col style=\"width: 90px;\">\n                            </colgroup>\n                            <thead>\n                                <tr>\n                                    <th class=\"\" style=\"height: 25px;\">\n                                        <div class=\"relative\">\n                                            <span class=\"colHeader cornerHeader\">Zoning Designation</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Acres within Zone</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Acres of Existing\n                                                Residential Excluded</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Minimum Density</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Total Units Per Zone Based\n                                                on Maximum</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Total Units Per Zone Based\n                                                on Maximum</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr class=\"odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">1</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Tagcat</td>\n                                    <td class=\"\">Classic Vest</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>11/10/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"0\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">172</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 20px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★</td>\n                                    <td class=\"\">01-2331942</td>\n                                    <td class=\"\">United Kingdom</td>\n                                </tr>\n                                <tr class=\"selected\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">2</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Zoomzone</td>\n                                    <td class=\"\">Cycling Cap</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>03/05/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"1\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">188</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 60px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★</td>\n                                    <td class=\"\">88-2768633</td>\n                                    <td class=\"\">Indonesia</td>\n                                </tr>\n                                <tr class=\"selected odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">3</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Meeveo</td>\n                                    <td class=\"\">Full-Finger Gloves</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>27/03/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"2\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">162</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 10px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★</td>\n                                    <td class=\"\">51-6775945</td>\n                                    <td class=\"\">United States</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">4</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Buzzdog</td>\n                                    <td class=\"\">HL Mountain Frame</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>29/08/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"3\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">133</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 70px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★</td>\n                                    <td class=\"\">44-4028109</td>\n                                    <td class=\"\">Philippines</td>\n                                </tr>\n                                <tr class=\"selected odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">5</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Katz</td>\n                                    <td class=\"\">Half-Finger Gloves</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>02/10/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"4\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">87</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 10px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★</td>\n                                    <td class=\"\">08-2758492</td>\n                                    <td class=\"\">India</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">6</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Jaxbean</td>\n                                    <td class=\"\">HL Road Frame</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>28/09/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"5\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">26</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 80px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★</td>\n                                    <td class=\"\">84-3557705</td>\n                                    <td class=\"\">China</td>\n                                </tr>\n                                <tr class=\"odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">7</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Wikido</td>\n                                    <td class=\"\">HL Touring Frame</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>24/06/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"6\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">110</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 40px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★</td>\n                                    <td class=\"\">20-9397637</td>\n                                    <td class=\"\">Brazil</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">8</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Browsedrive</td>\n                                    <td class=\"\">LL Mountain Frame</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>13/03/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"7\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">50</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 40px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★★</td>\n                                    <td class=\"\">36-0079556</td>\n                                    <td class=\"\">United States</td>\n                                </tr>\n                                <tr class=\"odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">9</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Twinder</td>\n                                    <td class=\"\">LL Road Frame</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>06/04/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"8\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">160</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 60px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★</td>\n                                    <td class=\"\">41-1489542</td>\n                                    <td class=\"\">United Kingdom</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">10</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Jetwire</td>\n                                    <td class=\"\">LL Touring Frame</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>01/02/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"9\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">30</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 80px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★★★</td>\n                                    <td class=\"\">37-1531629</td>\n                                    <td class=\"\">China</td>\n                                </tr>\n                                <tr class=\"odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">11</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Chatterpoint</td>\n                                    <td class=\"\">Long-Sleeve Logo Jersey</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>14/07/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"10\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">39</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 70px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★</td>\n                                    <td class=\"\">25-5083429</td>\n                                    <td class=\"\">China</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">12</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Twinder</td>\n                                    <td class=\"\">Men's Bib-Shorts</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>31/08/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"11\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">96</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 60px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★</td>\n                                    <td class=\"\">04-4281278</td>\n                                    <td class=\"\">Egypt</td>\n                                </tr>\n                                <tr class=\"odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">13</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Midel</td>\n                                    <td class=\"\">Men's Sports Shorts</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>27/06/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"12\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">108</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 100px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★</td>\n                                    <td class=\"\">55-1711908</td>\n                                    <td class=\"\">United States</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">14</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Yodo</td>\n                                    <td class=\"\">ML Mountain Frame</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>16/03/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"13\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">46</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 10px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★</td>\n                                    <td class=\"\">58-8360815</td>\n                                    <td class=\"\">India</td>\n                                </tr>\n                                <tr class=\"odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">15</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Camido</td>\n                                    <td class=\"\">ML Mountain Frame-W</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>13/09/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"14\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">97</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 80px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★</td>\n                                    <td class=\"\">10-3786104</td>\n                                    <td class=\"\">Russia</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">16</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Eire</td>\n                                    <td class=\"\">ML Road Frame</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>10/04/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"15\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">161</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 10px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★★</td>\n                                    <td class=\"\">45-1186054</td>\n                                    <td class=\"\">Thailand</td>\n                                </tr>\n                                <tr class=\"odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">17</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Vinte</td>\n                                    <td class=\"\">ML Road Frame-W</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>22/01/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"16\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">58</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 40px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★</td>\n                                    <td class=\"\">62-6202742</td>\n                                    <td class=\"\">United Kingdom</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">18</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Twitterlist</td>\n                                    <td class=\"\">Mountain Bike Socks</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>09/11/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"17\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">92</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 80px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★</td>\n                                    <td class=\"\">88-9646223</td>\n                                    <td class=\"\">China</td>\n                                </tr>\n                                <tr class=\"odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">19</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Eidel</td>\n                                    <td class=\"\">Mountain-100</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>19/09/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"18\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">5</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 60px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★★★</td>\n                                    <td class=\"\">45-5588112</td>\n                                    <td class=\"\">Bangladesh</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">20</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Trunyx</td>\n                                    <td class=\"\">Mountain-200</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>09/03/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"19\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">158</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 40px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★</td>\n                                    <td class=\"\">66-6271819</td>\n                                    <td class=\"\">Nigeria</td>\n                                </tr>\n                                <tr class=\"odd\">\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">21</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Katz</td>\n                                    <td class=\"\">Mountain-300</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>05/03/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"20\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">121</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 50px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★★</td>\n                                    <td class=\"\">38-9245023</td>\n                                    <td class=\"\">Turkey</td>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">22</span>\n                                        </div>\n                                    </th>\n                                    <td class=\"\">Kaymbo</td>\n                                    <td class=\"\">Mountain-400-W</td>\n                                    <td class=\"htAutocomplete\">\n                                        <div class=\"htAutocompleteArrow\">▼</div>24/12/2020\n                                    </td>\n                                    <td class=\"htCenter\">\n                                        <input class=\"htCheckboxRendererInput\" type=\"checkbox\" autocomplete=\"off\"\n                                            tabindex=\"-1\" data-row=\"21\" data-col=\"3\">\n                                    </td>\n                                    <td class=\"htRight htNumeric\" dir=\"ltr\">61</td>\n                                    <td class=\"htMiddle\">\n                                        <div class=\"progressBar\" style=\"width: 50px;\">\n                                        </div>\n                                    </td>\n                                    <td class=\"star htCenter htDimmed\">★★★★</td>\n                                    <td class=\"\">44-5916927</td>\n                                    <td class=\"\">United States</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                        <div class=\"htBorders\">\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 192px; display: none; top: 26px; left: 189px;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 23px; width: 2px; display: none; top: 26px; left: 189px;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 192px; display: none; top: 48px; left: 189px;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 24px; width: 2px; display: none; top: 26px; left: 380px;\">\n                                </div>\n                                <div class=\"wtBorder current corner\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill corner\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 192px; display: none; top: 26px; left: 189px;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 506px; width: 1px; display: none; top: 26px; left: 189px;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 192px; display: none; top: 532px; left: 189px;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 507px; width: 1px; display: none; top: 26px; left: 381px;\">\n                                </div>\n                                <div class=\"wtBorder area corner\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"ht_clone_top handsontable\" dir=\"ltr\"\n            style=\"position: absolute; top: 0px; overflow: visible; left: 0px; width: 740px; height: 26px;\">\n            <div class=\"wtHolder\" style=\"position: relative; width: 740px; height: 29px;\">\n                <div class=\"wtHider\" style=\"width: 1095px;\">\n                    <div class=\"wtSpreader\" style=\"position: relative; left: 0px;\">\n                        <table class=\"htCore\">\n                            <colgroup>\n                                <col class=\"rowHeader\" style=\"width: 50px;\">\n                                <col style=\"width: 140px;\">\n                                <col style=\"width: 192px;\">\n                                <col style=\"width: 100px;\">\n                                <col style=\"width: 90px;\">\n                                <col style=\"width: 90px;\">\n                            </colgroup>\n                            <thead>\n                                <tr>\n                                    <th class=\"\" style=\"height: 25px;\">\n                                        <div class=\"relative\">\n                                            <span class=\"colHeader cornerHeader\">Zoning Designation</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Acres within Zone</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Acres of Existing\n                                                Residential Excluded</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Minimum Density</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Total Units Per Zone Based\n                                                on Maximum</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"\">\n                                        <div class=\"relative htLeft\">\n                                            <button class=\"changeType\" type=\"button\">\n                                            </button>\n                                            <span class=\"colHeader columnSorting sortAction\">Total Units Per Zone Based\n                                                on Maximum</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                            </tbody>\n                        </table>\n                        <div class=\"htBorders\">\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current corner\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill corner\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area corner\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"ht_clone_bottom handsontable\" dir=\"ltr\">\n            <div class=\"wtHolder\">\n                <div class=\"wtHider\">\n                    <div class=\"wtSpreader\">\n                        <table class=\"htCore\">\n                            <colgroup>\n                            </colgroup>\n                            <thead>\n                            </thead>\n                            <tbody>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"ht_clone_inline_start ht_clone_left handsontable\" dir=\"ltr\"\n            style=\"position: absolute; top: 0px; overflow: visible; left: 0px; height: 450px; width: 50px;\">\n            <div class=\"wtHolder\">\n                <div class=\"wtHider\">\n                    <div class=\"wtSpreader\">\n                        <table class=\"htCore\">\n                            <colgroup>\n                                <col class=\"rowHeader\" style=\"width: 50px;\">\n                            </colgroup>\n                            <thead>\n                                <tr>\n                                    <th class=\"\" style=\"height: 25px;\">\n                                        <div class=\"relative\">\n                                            <span class=\"colHeader cornerHeader\">Zoning Designation</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">Direct</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">Call In</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">Direct</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">Paid Search</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">Organic Search</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">Eamil</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">Referral</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">8</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">Proposal</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">Marketing Campaign</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">11</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">12</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">13</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">14</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">15</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">16</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">17</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">18</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">19</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">20</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">21</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                                <tr>\n                                    <th class=\"\">\n                                        <div class=\"relative\">\n                                            <span class=\"rowHeader\">22</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                            </tbody>\n                        </table>\n                        <div class=\"htBorders\">\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current corner\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill corner\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area corner\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"ht_clone_top_inline_start_corner ht_clone_top_left_corner handsontable\" dir=\"ltr\"\n            style=\"position: absolute; top: 0px; overflow: visible; left: 0px; height: 26px; width: 50px;\">\n            <div class=\"wtHolder\" style=\"position: relative;\">\n                <div class=\"wtHider\">\n                    <div class=\"wtSpreader\" style=\"position: relative;\">\n                        <table class=\"htCore\">\n                            <colgroup>\n                                <col class=\"rowHeader\" style=\"width: 50px;\">\n                            </colgroup>\n                            <thead>\n                                <tr>\n                                    <th class=\"\" style=\"height: 25px;\">\n                                        <div class=\"relative\">\n                                            <span class=\"colHeader cornerHeader\">&nbsp;</span>\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                            </tbody>\n                        </table>\n                        <div class=\"htBorders\">\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 2px; width: 2px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder current corner\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder fill corner\"\n                                    style=\"background-color: rgb(255, 0, 0); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                            <div style=\"position: absolute; top: 0px; left: 0px;\">\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 1px; width: 1px; display: none;\">\n                                </div>\n                                <div class=\"wtBorder area corner\"\n                                    style=\"background-color: rgb(75, 137, 255); height: 6px; width: 6px; border: 1px solid rgb(255, 255, 255); display: none;\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"ht_clone_bottom_inline_start_corner ht_clone_bottom_left_corner handsontable\" dir=\"ltr\"\n            style=\"position: absolute; overflow: visible; left: 0px; bottom: 0px; height: 0px; width: 0px;\">\n            <div class=\"wtHolder\" style=\"position: relative;\">\n                <div class=\"wtHider\">\n                    <div class=\"wtSpreader\" style=\"position: relative;\">\n                        <table class=\"htCore\">\n                            <colgroup>\n                            </colgroup>\n                            <thead>\n                            </thead>\n                            <tbody>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"handsontableInputHolder ht_editor_hidden\"\n            style=\"top: 26px; left: 189px; right: auto; opacity: 0; height: 1px;\">\n            <textarea data-hot-input=\"\" tabindex=\"-1\" class=\"handsontableInput\"\n                style=\"width: 183px; height: 23px; font-size: 13px; font-family: -apple-system, &quot;system-ui&quot;, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, &quot;Helvetica Neue&quot;, Arial, sans-serif; resize: none; min-width: 183px; max-width: 541px; overflow-y: visible;\">\n                                    </textarea>\n        </div>\n    </div>\n</div> -->"

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.tablesortbuttons', []).directive('tablesortbuttons', function () {
	  return {
	    template: __webpack_require__(90),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"d-inline-flex flex-column\">\n    <button type=\"button\" class=\"btn\" style=\"\n        --bs-btn-color: var(--bs-table-color);\n        --bs-btn-padding-x: 0;\n        --bs-btn-padding-y: 0;\n        --bs-btn-font-size: unset;\n        --bs-btn-line-height: 0;\n        --bs-border-width: 0;\n      \">\n        <i class=\"fa-solid fa-caret-up\" style=\"line-height: 0.37; font-size: 22px;\"></i>\n    </button>\n    <button type=\"button\" class=\"btn\" style=\"\n        --bs-btn-color: var(--bs-table-color);\n        --bs-btn-padding-x: 0;\n        --bs-btn-padding-y: 0;\n        --bs-btn-font-size: unset;\n        --bs-btn-line-height: 0;\n        --bs-border-width: 0;\n      \">\n        <i class=\"fa-solid fa-caret-down\" style=\"line-height: 0.37; font-size: 22px;\"></i>\n    </button>\n</div>"

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.dropdown', []).directive('dropdown', function () {
	  return {
	    template: __webpack_require__(92),
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dropdown\">\n    <button type=\"button\" class=\"btn\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n        <i class=\"fa-solid fa-ellipsis\"></i>\n    </button>\n    <ul class=\"dropdown-menu\" style=\"\n        --bs-dropdown-border-radius: 0;\n        --bs-dropdown-border-color: #00303f;\n        --bs-dropdown-bg: #f2f4f5;\n        --bs-dropdown-link-color: #00303f;\n        --bs-dropdown-link-hover-bg: #ffffff;\n        --bs-dropdown-link-hover-color: #00303f;\n        --bs-dropdown-font-size: small;\n      \">\n        <li>\n            <button class=\"dropdown-item\">\n                <i class=\"fa-light fa-pencil\"></i>\n                <span>Edit/Change Status</span>\n            </button>\n        </li>\n        <li>\n            <button class=\"dropdown-item\">\n                <i class=\"fa-light fa-ban\"></i>\n                <span>Close/Archive</span>\n            </button>\n        </li>\n    </ul>\n</div>\n"

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var NotificationMessagesComponent = exports.NotificationMessagesComponent = function () {
	  function NotificationMessagesComponent($state, $scope, $rootScope, fetch, lookup) {
	    'ngInject';
	
	    _classCallCheck(this, NotificationMessagesComponent);
	
	    this.menu = [{
	      title: 'Home',
	      url: 'main'
	    }];
	    this.isCollapsed = true;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.fetch = fetch;
	  }
	
	  _createClass(NotificationMessagesComponent, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return NotificationMessagesComponent;
	}();
	
	exports.default = angular.module('appApp.notificationmessages', []).directive('notificationmessages', function () {
	  return {
	    template: __webpack_require__(94),
	    restrict: 'EA',
	    controller: NotificationMessagesComponent,
	    controllerAs: 'notificationMessagesCtrl',
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = "<!-- Error alert for selected station area  -->\n<!-- <div class=\"row\" ng-show=\"!currentSelectedStationId\" style=\"padding-top:5px;padding-bottom:5px;\">\n  <div class=\"col\">\n    <div class=\"alert alert-danger fade show\" role=\"alert\">\n      <strong>Please select a station</strong> in order to see weighted averages.\n    </div>\n  </div>\n</div> -->\n\n<!-- Error alert if no station area selected  -->\n<div class=\"row\" ng-show=\"!currentSelectedStationId\" style=\"padding-top:5px;padding-bottom:5px;\">\n  <div class=\"col\">\n    <div class=\"alert alert-danger fade show\" role=\"alert\">\n      <strong>Please select a station area... </strong> \n    </div>\n  </div>\n</div>\n\n<!-- Error alert for housing policies  -->\n<div class=\"row\" ng-show=\"currentlySelectedPolicies.length === 0\" style=\"padding-top:5px;padding-bottom:5px;\">\n  <div class=\"col\">\n    <div class=\"alert alert-danger fade show\" role=\"alert\">\n      <strong>Please select at least one (1) policy</strong> from the list below to get started.\n    </div>\n  </div>\n</div>\n\n<!-- Loading policies alert  -->\n<div class=\"row\" ng-show=\"loadingPolicies\" style=\"padding-top:5px;padding-bottom:5px;\">\n  <div class=\"col\">\n    <div class=\"alert alert-info alert-dismissible fade show\" role=\"alert\">\n      <i class=\"fa-solid fa-cog fa-spin\" style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>  Loading Policies for this station area...\n      <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n    </div>\n  </div>\n</div>\n\n\n\n<!-- Success alert  -->\n<div class=\"row\" ng-show=\"success\" style=\"padding-top:5px;padding-bottom:5px;\">\n  <div class=\"col\">\n    <div class=\"alert alert-success alert-dismissible fade show\" role=\"alert\">\n      {{successMessage}}\n      <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n    </div>\n  </div>\n</div>\n\n<!-- Needs Work alert — shown when admin flags a submission -->\n<div class=\"row\" ng-show=\"needsWorkNotice\" style=\"padding-top:5px;padding-bottom:5px;\">\n  <div class=\"col\">\n    <div class=\"alert alert-warning alert-dismissible fade show\" role=\"alert\">\n      <strong>Needs Work:</strong> This submission has been flagged by MTC and requires corrections. Please review, make your changes, and resubmit.\n      <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n    </div>\n  </div>\n</div>\n\n<!-- Withdrawn alert — shown after a user withdraws their submission -->\n<div class=\"row\" ng-show=\"withdrawnNotice\" style=\"padding-top:5px;padding-bottom:5px;\">\n  <div class=\"col\">\n    <div class=\"alert alert-info alert-dismissible fade show\" role=\"alert\">\n      <strong>Submission Withdrawn.</strong> Your submission has been withdrawn and the form has been cleared. Please make your changes and resubmit via the Review and Submit section.\n      <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n    </div>\n  </div>\n</div>\n\n<!-- Loading or info alert  -->\n<div class=\"row\" ng-show=\"loadingTable\" style=\"padding-top:5px;padding-bottom:5px;\">\n  <div class=\"col\">\n    <div class=\"alert alert-info alert-dismissible fade show\" role=\"alert\">\n      <i class=\"fa-solid fa-cog fa-spin\" style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>  Updating Table...\n      <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var angular = __webpack_require__(1);
	
	exports.default = angular.module('appApp.tabmodal', []).directive('tabmodal', function () {
	  return {
	    template: __webpack_require__(96),
	    restrict: 'EA',
	    scope: {
	      tabmodalContent: '='
	    },
	    link: function link(scope, element, attrs) {}
	  };
	}).name;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = "<!-- add zoning code modal  -->\n<div\n  class=\"modal fade\"\n  id=\"addZoningCodeModal\"\n  tabindex=\"-1\"\n  aria-labelledby=\"addZoningCodeModalTitle\"\n  style=\"display: none\"\n  aria-hidden=\"true\"\n>\n  <div class=\"modal-dialog modal-lg\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button\n          type=\"button\"\n          class=\"btn-close\"\n          data-bs-dismiss=\"modal\"\n          aria-label=\"Close\"\n        ></button>\n        <h1 class=\"modal-title\" id=\"addZoningCodeModalTitle\">\n          Add New Zoning Code\n        </h1>\n      </div>\n      <div class=\"modal-body\" style=\"padding-left: 10%\">\n        <form\n          class=\"row test-validation-styling\"\n          name=\"housingForm\"\n          ng-class=\"{'was-validated': formSubmitted}\"\n          novalidate\n        >\n          <!-- Zoning Code Name  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_code\">Zoning Code:</label>\n            <input\n              type=\"text\"\n              id=\"zn_code\"\n              name=\"zn_code\"\n              placeholder=\"\"\n              value=\"\"\n              ng-model=\"addCode.zn_code\"\n              required\n            />\n            <div\n              class=\"invalid-feedback\"\n              ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_code.$error.required && formSubmitted\"\n            >\n              Please choose a valid response.\n            </div>\n          </div>\n          <!-- Zoning Code Description  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_description\">Zoning Code Description:</label>\n            <input\n              id=\"zn_description\"\n              name=\"zn_description\"\n              type=\"text\"\n              placeholder=\"\"\n              required\n              ng-model=\"addCode.zn_description\"\n            />\n            <div\n              class=\"invalid-feedback\"\n              ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_description.$error.required && formSubmitted\"\n            >\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Type  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_type\">Zoning Type:</label>\n            <select\n              id=\"zn_type\"\n              name=\"zn_type\"\n              ng-model=\"addCode.zoning_type\"\n              required\n            >\n              <option value=\"\">Select Zoning Type</option>\n              <option value=\"Residential\">Residential</option>\n              <option value=\"Commercial\">Commercial</option>\n              <option value=\"Mixed Use\">Mixed Use</option>\n              <!-- Add more options as needed -->\n            </select>\n            <div\n              class=\"invalid-feedback\"\n              ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_type.$error.required && formSubmitted\"\n            >\n              Please choose a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Min DUA  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_min_dua\">Minimum DUA:</label>\n            <input\n              id=\"zn_min_dua\"\n              name=\"zn_min_dua\"\n              type=\"number\"\n              placeholder=\"\"\n              required\n              ng-model=\"addCode.zn_min_dua\"\n            />\n            <div\n              class=\"invalid-feedback\"\n              ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_min_dua.$error.required && formSubmitted\"\n            >\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Max DUA  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_max_dua\">Maximum DUA:</label>\n            <input\n              id=\"zn_max_dua\"\n              name=\"zn_max_dua\"\n              type=\"number\"\n              placeholder=\"\"\n              required\n              ng-model=\"addCode.zn_max_dua\"\n            />\n            <div\n              class=\"invalid-feedback\"\n              ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_max_dua.$error.required && formSubmitted\"\n            >\n              Please provide a valid response.\n            </div>\n          </div>\n          <!-- Zoning Min FAR  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_min_far\">Minimum FAR:</label>\n            <input\n              id=\"zn_min_far\"\n              name=\"zn_min_far\"\n              type=\"number\"\n              placeholder=\"\"\n              required\n              ng-model=\"addCode.zn_min_far\"\n            />\n            <div\n              class=\"invalid-feedback\"\n              ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_min_far.$error.required && formSubmitted\"\n            >\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Max FAR  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_max_far\">Maximum FAR:</label>\n            <input\n              id=\"zn_max_far\"\n              name=\"zn_max_far\"\n              type=\"number\"\n              placeholder=\"\"\n              required\n              ng-model=\"addCode.zn_max_far\"\n            />\n            <div\n              class=\"invalid-feedback\"\n              ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_max_far.$error.required && formSubmitted\"\n            >\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Documentation URL  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_code_url\">Supporting Documentation:</label>\n            <input\n              id=\"zn_code_url\"\n              name=\"zn_code_url\"\n              type=\"url\"\n              placeholder=\"\"\n              required\n              ng-model=\"addCode.zn_code_url\"\n            />\n            <div\n              class=\"invalid-feedback\"\n              ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_code_url.$error.required && formSubmitted\"\n            >\n              Please provide a valid response.\n            </div>\n          </div>\n          <!-- Zoning Allows Residential  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"allows_residential\">Allows Residential:</label>\n            <div style=\"display: flex; align-items: left !important\">\n              <input\n                type=\"checkbox\"\n                id=\"allows_residential\"\n                name=\"allows_residential\"\n                ng-model=\"addCode.allows_residential\"\n              />\n            </div>\n          </div>\n\n          <!-- Zoning Allows Commercial Office  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"allows_comm_office\">Allows Commercial Office:</label>\n            <div style=\"display: flex; align-items: left !important\">\n              <input\n                type=\"checkbox\"\n                id=\"allows_comm_office\"\n                name=\"allows_comm_office\"\n                ng-model=\"addCode.allows_comm_office\"\n              />\n            </div>\n          </div>\n\n          <div class=\"form-item col-lg-8\" style=\"padding-top: 20px\">\n            <button\n              type=\"submit\"\n              class=\"btn btn-primary btn-lg\"\n              ng-click=\"addZoningCode()\"\n            >\n              <span ng-if=\"!saving\">Save Code</span>\n              <span ng-if=\"saving\"\n                ><i\n                  class=\"fa-solid fa-cog fa-spin\"\n                  style=\"\n                    font-weight: 400;\n                    padding-left: 0.25em;\n                    padding-right: 0.25em;\n                  \"\n                ></i\n                >Saving...</span\n              >\n            </button>\n            <button\n              type=\"button\"\n              class=\"btn btn-secondary btn-lg\"\n              data-bs-dismiss=\"modal\"\n            >\n              Cancel\n            </button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- delete zoning code modal  -->\n<div\n  class=\"modal fade\"\n  id=\"deleteZoningCodeModal\"\n  tabindex=\"-1\"\n  aria-labelledby=\"deleteZoningCodeModalTitle\"\n  style=\"display: none\"\n  aria-hidden=\"true\"\n>\n  <div class=\"modal-dialog modal-lg\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button\n          type=\"button\"\n          class=\"btn-close\"\n          data-bs-dismiss=\"modal\"\n          aria-label=\"Close\"\n        ></button>\n        <h1 class=\"modal-title\" id=\"deleteZoningCodeModalTitle\">\n          Delete Zoning Code\n        </h1>\n        <p>\n          Select one or more zoning codes to delete. Note that deleting a zoning\n          code will also potentially delete any current assignment of that code\n          to parcels. This can impact weighted average calculations.\n        </p>\n      </div>\n      <div class=\"modal-body\">\n        <table class=\"table table--data-table table-borderless table-striped\">\n          <thead class=\"table-dark\">\n            <tr>\n              <th>\n                <div class=\"th-inner\">Select</div>\n              </th>\n              <th>\n                <div class=\"th-inner\">Zoning Code</div>\n              </th>\n              <th>\n                <div class=\"th-inner\">Zoning Description</div>\n              </th>\n              <th style=\"display: none\">\n                <div class=\"th-inner\">Application ID</div>\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"item in znCodes track by $index\">\n              <td>\n                <input type=\"checkbox\" ng-model=\"item.selected\" />\n              </td>\n              <td>{{item.zn_code}}</td>\n              <td>{{item.zn_description}}</td>\n              <td style=\"display: none;\">\n                <input type=\"hidden\" ng-model=\"item.rec_id\" />\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <div class=\"form-item col-lg-8\" style=\"padding-top: 20px\">\n          <button\n            type=\"button\"\n            class=\"btn btn-danger btn-lg\"\n            ng-click=\"deleteZoningCodes()\"\n          >\n            <span ng-if=\"!saving\">Delete Code(s)</span>\n            <span ng-if=\"saving\"\n              ><i\n                class=\"fa-solid fa-cog fa-spin\"\n                style=\"\n                  font-weight: 400;\n                  padding-left: 0.25em;\n                  padding-right: 0.25em;\n                \"\n              ></i\n              >Deleting...</span\n            >\n          </button>\n          <button\n            type=\"button\"\n            class=\"btn btn-secondary btn-lg\"\n            data-bs-dismiss=\"modal\"\n          >\n            Cancel\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ParkingComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parking = __webpack_require__(98);
	
	var _parking2 = _interopRequireDefault(_parking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ParkingComponent = exports.ParkingComponent = function () {
	  /*@ngInject*/
	  function ParkingComponent($state, $scope, $rootScope, fetch, lookup, userService, $stateParams) {
	    _classCallCheck(this, ParkingComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$stateParams = $stateParams;
	    this.userService = userService;
	
	    $scope.currentlySelectedPolicies = [];
	    $scope.activityType = 'Parking';
	
	    $scope.getStationbyID = function (station) {
	      $scope.loadingData = true;
	      if (station) {
	        lookup.setCurrentStation(station);
	      }
	
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	      fetch.getItem('api/data/density/averages/' + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	        $scope.currentStation = response.data[0];
	
	        $scope.loadingData = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	      $scope.getActivity();
	    }.bind(this);
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	        if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getActivity = function () {
	      var activityData = [];
	      fetch.getAllItems('api/data/submission/activity/' + $scope.currentSelectedStationId + '/' + $scope.activityType).then(function (response) {
	
	        $scope.submissionActivity = response.data;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	  }
	
	  _createClass(ParkingComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.submissionActivity = [];
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.getJurisdictionList();
	        _this.$scope.housingProductionForms = [];
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Compliant' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Compliant' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Compliant' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Compliant' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return ParkingComponent;
	}();
	
	exports.default = angular.module('appApp.parking', [uiRouter]).config(_parking2.default).component('parking', {
	  template: __webpack_require__(99),
	  controller: ParkingComponent,
	  controllerAs: 'parkingCtrl'
	}).name;

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('parking', {
	    url: '/account/parking',
	    template: '<parking></parking>',
	    authenticate: true
	  });
	};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--content dashboard--page--submission dashboard--density-compliance\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <!-- Sidebarnav source components/directives/sidebarnav  -->\n      <sidebarnav></sidebarnav>\n    </div>\n    <div class=\"main\">\n      <!-- mainheaderauth source components/directives/mainheaderauth  -->\n      <mainheaderauth></mainheaderauth>\n      <breadcrumbnav></breadcrumbnav>\n      <maintocselection />\n      <div class=\"container\" style=\"margin-left:242px;max-width: calc(100vw-242);\">\n        <div class=\"row content--style\">\n          <div class=\"col-lg-8\">\n            <h1 class=\"page-title\">Parking</h1>\n            <p>\n              The TOC Policy seeks to reduce automobile trips and prioritize the limited land area near transit for\n              other shared transportation modes and active transportation. Parking management is a key complement to\n              residential and commercial density increases that support higher transit ridership.\n            </p>\n            <p>\n              To demonstrate consistency with the TOC Policy, a jurisdiction must document its vehicle parking standards\n              for new residential and commercial uses and its secure bicycle parking standards for new residential and\n              office development in locations subject to the TOC Policy, citing the municipal code or ordinance that\n              codifies such standards. To be consistent with the TOC Policy, a jurisdiction must also adopt an\n              additional parking management policy. For the purposes of TOC Policy consistency, the parcels in a TOC\n              area that a jurisdiction has determined are subject to Government Code Section 65863.2 are also subject to\n              all TOC Policy parking management standards. See the <a\n                href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\"\n                target=\"_blank\">TOC Policy Administrative Guidance</a> for more details.\n            </p>\n\n            <div class=\"tab-content\">\n              <!-- Automobile Parking Section -->\n              <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\">\n                <div class=\"row mb-3\">\n                  <div class=\"col\">\n                    <p ng-if=\"currentStation\">\n                      The table below shows the required TOC Policy vehicle and bicycle parking standards for\n                      <span style=\"font-weight: bold\">{{currentStation.station_name}}</span>, a Tier\n                      {{currentStation.service_tier}} station.\n                      <i class=\"fa-solid fa-chart-simple\"></i>\n                    </p>\n                  </div>\n                </div>\n                <div class=\"row mb-2\">\n                  <div class=\"col\">\n                    <h3>Vehicle Parking Compliance Standards</h3>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Minimum for New Residential Uses\n                            </div>\n                            <div class=\"fs-1 lh-1\">\n                              <p style=\"font-size: 24px; font-weight: 500;\"\n                                ng-if=\"currentStation.service_tier === 1 || currentStation.service_tier === 2 || currentStation.service_tier === 3 \">\n                                No Minimum Allowed</p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 4\">\n                                *\n                              </p>\n                              <p ng-if=\"!currentStation\"> --\n                              </p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Maximum for New Residential Uses\n                            </div>\n                            <div class=\"fs-1 lh-1\">\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 1\">\n                                0.375 spaces per\n                                unit or lower.</p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 2\">\n                                0.5 spaces per\n                                unit or lower.\n                              </p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 3\">\n                                1.0 spaces per\n                                unit or lower.\n                              </p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 4\">\n                                1.5 spaces per\n                                unit or lower.\n                              </p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"!currentStation\"> --\n                              </p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Minimum for New Commercial Uses\n                            </div>\n                            <div class=\"fs-1 lh-1\">\n                              <p style=\"font-size: 24px; font-weight: 500;\"\n                                ng-if=\"currentStation.service_tier === 1 || currentStation.service_tier === 2 || currentStation.service_tier === 3 \">\n                                No Minimum Allowed</p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 4\">\n                                *\n                              </p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"!currentStation\"> --\n                              </p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-betweenalign-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Maximum for New Commercial Uses\n                            </div>\n                            <div class=\"fs-1 lh-1\">\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 1\">\n                                0.25 spaces per\n                                1,000 s.f. or lower.</p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 2\">\n                                1.6 spaces per 1,000\n                                s.f. or lower.\n                              </p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 3\">\n                                2.5 spaces per 1,000\n                                s.f. or lower.\n                              </p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation.service_tier === 4\">\n                                4.0 spaces per 1,000\n                                s.f. or lower.\n                              </p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"!currentStation\"> --\n                              </p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <!-- Parking Policies  -->\n                <p ng-show=\"currentStation.service_tier === 4\" style=\"font-style: italic;\">&#42;The TOC Policy does not\n                  have a standard related to minimum automobile parking for Tier 4 TOC areas. However, jurisdictions\n                  must comply with applicable state law, such as <a href=\"#\">AB 2097</a>.\n                </p>\n\n                <!-- Bicycle Section  -->\n                <div class=\"row mb-2\">\n                  <div class=\"col\">\n                    <h3>Bicycle Parking Compliance Standards</h3>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Minimum Secured Bicycle Parking for New Residential Uses\n                            </div>\n                            <div class=\"fs-1 lh-1\">\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"!currentStation\"> --\n                              </p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation\">\n                                1 per unit\n                              </p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Minimum Secured Bicycle Parking for New Office Uses\n                            </div>\n                            <div class=\"fs-1 lh-1\">\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"!currentStation\"> --\n                              </p>\n                              <p style=\"font-size: 24px; font-weight: 500;\" ng-if=\"currentStation\"> 1 per 5,000 occupied\n                                s.f.\n                              </p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <p>\n                  Note: For a single building with more than 100 units, the jurisdiction can apply a ratio of one secure\n                  bicycle parking space for every four units to the number of units above 100. For example, a 140-unit\n                  building would need 110 bicycle parking spaces (100 + 0.25*40). Additionally, the jurisdiction can\n                  exempt developments with fewer than 10 units from bicycle parking requirements.\n                </p>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-lg-4\" style=\"margin-top:60px;\">\n            <div class=\"right-content\">\n              <h2>Activity</h2>\n              <sidebaractivity></sidebaractivity>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n        <sidebarfooter></sidebarfooter>\n      </div>\n    </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ParkingRequirementsComponent = undefined;
	
	var _parking_requirements = __webpack_require__(101);
	
	var _parking_requirements2 = _interopRequireDefault(_parking_requirements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ParkingRequirementsComponent =
	/*@ngInject*/
	exports.ParkingRequirementsComponent = function ParkingRequirementsComponent() {
	  _classCallCheck(this, ParkingRequirementsComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.parking_requirements', [uiRouter]).config(_parking_requirements2.default).component('parkingRequirements', {
	  template: __webpack_require__(102),
	  controller: ParkingRequirementsComponent,
	  controllerAs: 'parkingRequirementsCtrl'
	}).name;

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('parking_requirements', {
	    url: '/account/parking/parking_requirements',
	    template: '<parking-requirements></parking-requirements>'
	  });
	};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--content--housing\">\n  <div class=\"page-wrapper\">\n      <div class=\"dashboard-header\">\n        <!-- Sidebarnav source components/directives/sidebarnav  -->\n          <sidebarnav></sidebarnav>\n      </div>\n      <div class=\"main\">\n        <!-- mainheaderauth source components/directives/mainheaderauth  -->\n          <mainheaderauth></mainheaderauth>\n          <div class=\"content container\">\n              <div class=\"row\">\n                  <div class=\"col-lg-8\">\n                      <h1 class=\"page-title\">Parking Requirements </h1>\n                      <div class=\"page-summary\">Affordable Housing Production, Preservation, and Protection and Commercial Stabilization</div>\n                      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                      <figure>\n                          <img class=\"image--full\" src=\"../../../assets/images/mockups/dashboard-content-image.jpg\" alt=\"Person wearing a mask and helmet on a bike\" height=\"730\" width=\"410\"/>\n                          <figcaption>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. <span class=\"image-credit\">Credit: Sergio Ruiz</span></figcaption>\n                      </figure>\n\n                      <h2><a href=\"#\">Further Guidance H2</a></h2>\n                      <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n\n                      <h2><a href=\"#\">Affordable Housing Production Policy</a></h2>\n                      <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                  </div>\n                 \n              </div>\n          </div>\n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n          <sidebarfooter></sidebarfooter>\n      </div>\n  </div>\n</section>\n"

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VehicleParkingComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vehicle_parking = __webpack_require__(104);
	
	var _vehicle_parking2 = _interopRequireDefault(_vehicle_parking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var VehicleParkingComponent = exports.VehicleParkingComponent = function () {
	  /*@ngInject*/
	
	  /*@ngInject*/
	  function VehicleParkingComponent($state, $scope, $rootScope, fetch, lookup, userService, $timeout, baseConfigService, $http, $stateParams) {
	    _classCallCheck(this, VehicleParkingComponent);
	
	    this.$scope = $scope;
	    this.$state = $state;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$stateParams = $stateParams;
	    this.userService = userService;
	    this.$timeout = $timeout;
	    this.$http = $http;
	    this.baseConfigService = baseConfigService;
	
	    $scope.adminUnlocked = false;
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.submissions = [];
	    $scope.savemode = null;
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.vehicleParkingMinCheck = false;
	    $scope.submitmode = null;
	    $scope.initialLoad = true;
	
	    $scope.parking = {};
	
	    $scope.policy_name = 'Vehicle Parking Minimum';
	
	    $scope.pendingChanges = false;
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.setPending = function () {
	      console.log('set pending ran');
	      console.log($scope.initialLoad);
	      if (!$scope.initialLoad) {
	        $scope.savemode = 'parking';
	        $scope.pendingChanges = true;
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentParkingPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.parkingStatus) {
	        for (var i = 0; i < $scope.parkingStatus.length; i++) {
	          if ($scope.parkingStatus[i].submission_policy_name === $scope.policy_name) {
	            submission = $scope.parkingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentParkingPolicy;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.parkingStatus && $scope.policy_name) {
	        var sub = _.find($scope.parkingStatus, { submission_policy_name: $scope.policy_name });
	        if (sub && sub.submitted && sub.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('parkingStatus', function () {
	      if (!$scope.currentParkingPolicy) return;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm('Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.');
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.parkingStatus) {
	        for (var i = 0; i < $scope.parkingStatus.length; i++) {
	          if ($scope.parkingStatus[i].submission_policy_name === $scope.policy_name) {
	            submission = $scope.parkingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error('No matching submission found to withdraw');
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', payload).then(function () {
	        submission.submitted = false;
	        submission.status = null;
	
	        if ($scope.checkParking1 && $scope.checkParking1.submission_id === submission.submission_id) {
	          $scope.checkParking1 = null;
	          $scope.vehicleParkingMinCheck = false;
	          $scope.parking.vehicleParkingMinCheck = false;
	          if ($scope.vehicleParkingMinimum) {
	            $scope.vehicleParkingMinimum.forEach(function (el) {
	              el.submitted = false;
	            });
	          }
	        }
	
	        if ($scope.checkParking2 && $scope.checkParking2.submission_id === submission.submission_id) {
	          $scope.checkParking2 = null;
	          $scope.vehicleParkingMaxCheck = false;
	          $scope.parking.vehicleParkingMaxCheck = false;
	          if ($scope.vehicleParkingMaximum) {
	            $scope.vehicleParkingMaximum.forEach(function (el) {
	              el.submitted = false;
	            });
	          }
	        }
	
	        $scope.formReadOnly = false;
	
	        var formId = $scope.currentParkingPolicy ? $scope.currentParkingPolicy.parking_form_id : null;
	        $scope.currentParkingPolicy = { parking_form_id: formId };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	      }).catch(function (err) {
	        console.error('Withdraw failed:', err);
	        alert('There was an error withdrawing the submission. Please try again.');
	      });
	    };
	
	    $scope.onVehicleParkingMinCheckboxChange = function (type) {
	      if (type === 'confirmationCompliance' && $scope.currentParkingPolicy.parking_confirmation_compliance_checked) {
	        $scope.currentParkingPolicy.parking_resolution_compliance_checked = false;
	        $scope.currentParkingPolicy.remove_vehicle_park_mins_checked = false;
	      }
	      if (type === 'resolutionCompliance' && $scope.currentParkingPolicy.parking_resolution_compliance_checked) {
	        $scope.currentParkingPolicy.parking_confirmation_compliance_checked = false;
	        $scope.currentParkingPolicy.remove_vehicle_park_mins_checked = false;
	      }
	      if (type === 'removeVehicleParkingMins' && $scope.currentParkingPolicy.remove_vehicle_park_mins_checked) {
	        $scope.currentParkingPolicy.parking_confirmation_compliance_checked = false;
	        $scope.currentParkingPolicy.parking_resolution_compliance_checked = false;
	      }
	    };
	
	    $scope.onVehicleParkingMaxCheckboxChange = function (type) {
	      if (type === 'overlayZone' && $scope.currentParkingPolicy.vehicle_park_max_overlay_zone_checked) {
	        $scope.currentParkingPolicy.vehicle_park_max_limit_park_method_checked = false;
	      }
	      if (type === 'limitParkMethod' && $scope.currentParkingPolicy.vehicle_park_max_limit_park_method_checked) {
	        $scope.currentParkingPolicy.vehicle_park_max_overlay_zone_checked = false;
	      }
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	      console.log($scope.submissions);
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'parking';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Parking').then(function (response) {
	        $scope.parkingStatus = response.data;
	
	        $scope.checkParking1 = _.filter(response.data, {
	          submission_policy_name: 'Vehicle Parking Minimum',
	          submitted: true
	        })[0];
	
	        $scope.checkParking2 = _.filter(response.data, {
	          submission_policy_name: 'Vehicle Parking Maximum',
	          submitted: true
	        })[0];
	
	        $scope.vehicleParkingMinCheck = !!($scope.checkParking1 && $scope.checkParking1.submitted);
	        $scope.vehicleParkingMaxCheck = !!($scope.checkParking2 && $scope.checkParking2.submitted);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.getStationbyID = function (station) {
	
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	      $scope.getSubmissionStatus();
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Parking').then(function (response) {
	
	        $scope.currentStation = response.data[0];
	
	        $scope.complementaryParking = _.filter(response.data, { submission_policy_name: 'Complementary Parking Management Policy' });
	        if ($scope.complementaryParking.length > 0) {
	          $scope.complementaryParking.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.complementaryParkCheck = true;
	            }
	          });
	        }
	        $scope.unbundledParking = _.filter(response.data, { submission_policy_name: 'Unbundled Parking' });
	        if ($scope.unbundledParking.length > 0) {
	          $scope.unbundledParking.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.unbundledParkCheck = true;
	            }
	          });
	        }
	        $scope.sharedParking = _.filter(response.data, { submission_policy_name: 'Shared Parking' });
	        if ($scope.sharedParking.length > 0) {
	          $scope.sharedParking.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.sharedParkCheck = true;
	            }
	          });
	        }
	        $scope.vehicleParkingMaximum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Maximum' });
	        if ($scope.vehicleParkingMaximum.length > 0) {
	          $scope.vehicleParkingMaximum.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.vehicleParkingMaxCheck = true;
	            }
	          });
	        }
	        $scope.vehicleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Minimum' });
	        if ($scope.vehicleParkingMinimum.length > 0) {
	          $scope.vehicleParkingMinimum.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.vehicleParkingMinCheck = true;
	            }
	          });
	        }
	        $scope.bicycleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Bicycle Parking Minimum' });
	        if ($scope.bicycleParkingMinimum.length > 0) {
	          $scope.bicycleParkingMinimum.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.bicycleParkingMinCheck = true;
	            }
	          });
	        }
	        $scope.getStationTier($scope.currentSelectedStationId);
	
	        var requestedPolicyName = $stateParams.policyName;
	
	        if (requestedPolicyName) {
	          $scope.policy_name = requestedPolicyName;
	          console.log('Vehicle Parking: Setting policy_name to:', $scope.policy_name);
	
	          $timeout(function () {
	            var targetTab = void 0;
	            if (requestedPolicyName === 'Vehicle Parking Minimum') {
	              targetTab = '#section-1';
	            } else if (requestedPolicyName === 'Vehicle Parking Maximum') {
	              targetTab = '#section-2';
	            }
	
	            if (targetTab) {
	              document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (tab) {
	                tab.classList.remove('active');
	              });
	              document.querySelectorAll('.tab-pane').forEach(function (pane) {
	                pane.classList.remove('show', 'active');
	              });
	
	              var tabTrigger = document.querySelector('[data-bs-target="' + targetTab + '"]');
	              if (tabTrigger) {
	                tabTrigger.classList.add('active');
	                var tabPane = document.querySelector(targetTab);
	                if (tabPane) {
	                  tabPane.classList.add('show', 'active');
	                }
	              }
	            }
	          }, 100);
	        } else {}
	
	        return $scope.getCurrentParkingPolicy($scope.policy_name);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationTier = function (station) {
	      if (station) {
	        $scope.loadingData = true;
	      }
	      fetch.getItem('api/data/parking/station-tiers/' + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	        $scope.currentStation = response.data[0];
	        $scope.loadingData = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getCurrentParkingPolicy = function (policy_name) {
	      if (policy_name) {
	        $scope.policy_name = policy_name;
	      }
	      console.log('policy_name:', policy_name);
	
	      fetch.getAllItems('api/data/getParkingForm/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + encodeURIComponent($scope.policy_name)).then(function (response) {
	
	        $scope.currentParkingPolicy = response.data[0];
	
	        console.log('parking_form_id:', $scope.currentParkingPolicy.parking_form_id);
	        if (policy_name === 'Vehicle Parking Maximum') {
	          $scope.currentParkingPolicy.vehicle_park_max_overlay_zone_checked = !!($scope.currentParkingPolicy.vehicle_park_max_overlay_zone_municipal || $scope.currentParkingPolicy.vehicle_park_max_overlay_zone_equivalency);
	          $scope.currentParkingPolicy.vehicle_park_max_limit_park_method_checked = !!($scope.currentParkingPolicy.vehicle_park_max_park_management || $scope.currentParkingPolicy.vehicle_park_max_limit_park_equivalency || $scope.currentParkingPolicy.vehicle_park_max_off_street_park_calculation);
	        }
	        if (policy_name === 'Vehicle Parking Minimum') {
	          $scope.currentParkingPolicy.parking_confirmation_compliance_checked = !!$scope.currentParkingPolicy.parking_confirmation_compliance;
	          $scope.currentParkingPolicy.parking_resolution_compliance_checked = !!$scope.currentParkingPolicy.parking_resolution_compliance;
	          $scope.currentParkingPolicy.remove_vehicle_park_mins_checked = !!$scope.currentParkingPolicy.remove_vehicle_park_mins;
	        }
	        $scope.initialLoad = false;
	        console.log($scope.initialLoad);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	    $scope.updateCurrentParkingPolicy = function () {
	
	      $scope.formSubmitted = true;
	      if (parkingForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      Object.keys($scope.currentParkingPolicy).forEach(function (key) {
	        if ($scope.currentParkingPolicy[key] === "" || $scope.currentParkingPolicy[key] === undefined) {
	          $scope.currentParkingPolicy[key] = null;
	        }
	      });
	
	      $scope.currentParkingPolicy.parking_form_id = $scope.currentParkingPolicy.parking_form_id;
	
	      console.log("Payload being sent:", $scope.currentParkingPolicy);
	      fetch.updateItem('api/data/parking/forms/update', $scope.currentParkingPolicy).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.saved = false;
	          $scope.savemode = null;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.submitParking = function () {
	      console.log($scope.parking.vehicleParkingMaxCheck);
	      $scope.formSubmitted = true;
	      $scope.saving = true;
	      var upsertData = [];
	
	      $scope.upsertData = [];
	
	      console.log("submissing", $scope.parking.vehicleParkingMaxCheck, $scope.vehicleParkingMaximum.length);
	      if ($scope.parking.complementaryParkCheck && $scope.complementaryParking.length > 0) {
	        $scope.complementaryParking.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              complementary_parking_management: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.unbundledParkCheck && $scope.unbundledParking.length > 0) {
	        $scope.unbundledParking.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              unbundled_parking: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.sharedParkCheck && $scope.sharedParking.length > 0) {
	        $scope.sharedParking.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              shared_parking: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.vehicleParkingMaxCheck && $scope.vehicleParkingMaximum.length > 0) {
	        $scope.vehicleParkingMaximum.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              vehicle_parking_maximum: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.vehicleParkingMinCheck && $scope.vehicleParkingMinimum.length > 0) {
	        $scope.vehicleParkingMinimum.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              vehicle_parking_minimum: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.bicycleParkingMinCheck && $scope.bicycleParkingMinimum.length > 0) {
	        $scope.bicycleParkingMinimum.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              bicycle_parking_minimum: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saving = false;
	        $scope.submissions = [];
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        $scope.getSubmissionStatus();
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 2000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        }
	
	        if ($scope.currentSelectedStationId) {
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById('fileInput' + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
	            alert('Please select a PDF, Word document, or Excel file.');
	            element.value = '';
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById('' + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope[ngmodel] = '';
	        $scope[ngmodel + '_preview'] = '';
	        $scope['fileUploading_' + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope['fileUploading_' + ngmodelfile] = true;
	      var file = document.getElementById('' + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentParkingPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentParkingPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'parking';
	      $scope.pendingChanges = true;
	    };
	  }
	
	  _createClass(VehicleParkingComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.currentParkingPolicy = {};
	        return _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }]);
	
	  return VehicleParkingComponent;
	}();
	
	exports.default = angular.module('appApp.vehicle_parking', [uiRouter]).config(_vehicle_parking2.default).component('vehicleParking', {
	  template: __webpack_require__(105),
	  controller: VehicleParkingComponent,
	  controllerAs: 'vehicleParkingCtrl'
	}).name;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('vehicle_parking', {
	    url: '/account/parking/vehicle_parking?jurisdiction&sta_recid&policyName',
	    template: '<vehicle-parking></vehicle-parking>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null,
	      policyName: null
	    }
	  });
	};

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n    <div class=\"page-wrapper\">\n        <div class=\"dashboard-header\">\n            <sidebarnav></sidebarnav>\n        </div>\n\n        <div class=\"main\">\n            <mainheaderauth></mainheaderauth>\n            <maintocselection />\n\n            <div class=\"content container\">\n                <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n                <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n                <div class=\"row mb-5\" style=\"padding-top:20px;\">\n                    <div class=\"col\">\n                        <h3 class=\"mb-2\" ng-if=\"currentStation\">\n                            {{currentStation.station_name}}: Tier Level {{currentStation.service_tier}}\n                            <i class=\"fa-solid fa-chart-simple\"></i>\n                        </h3>\n                        <table class=\"table table--data-table\">\n                            <thead class=\"table-dark\">\n                                <tr>\n                                    <th>\n                                        <div class=\"th-inner\" ng-if=\"policy_name === 'Vehicle Parking Minimum'\">Vehicle\n                                            Minimum Parking Standards</div>\n                                        <div class=\"th-inner\" ng-if=\"policy_name === 'Vehicle Parking Maximum'\">Vehicle\n                                            Maximum Parking Standards</div>\n                                    </th>\n                                    <th>\n                                        <div class=\"th-inner\">\n                                            TOC Policy Standards\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr>\n                                    <td><span ng-if=\"policy_name === 'Vehicle Parking Minimum'\"> Minimum for New\n                                            Residential\n                                            Uses</span>\n                                        <span ng-if=\"policy_name === 'Vehicle Parking Maximum'\"> Maximum for New\n                                            Residential\n                                            Uses</span>\n                                    </td>\n                                    <td>\n                                        <span ng-if=\"!loading && policy_name === 'Vehicle Parking Minimum'\"><span\n                                                ng-if=\"currentStation.service_tier === 1 || currentStation.service_tier === 2 || currentStation.service_tier === 3\">\n                                                No Minimum Allowed</span>\n                                            <span ng-if=\"currentStation.service_tier === 4\">*</span>\n                                        </span>\n                                        <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                                                style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                                        <span ng-if=\"!loading && policy_name === 'Vehicle Parking Maximum'\">\n                                            <span ng-if=\"currentStation.service_tier === 1\">0.375\n                                                spaces per unit or lower</span>\n                                            <span ng-if=\"currentStation.service_tier === 2\">0.5\n                                                spaces per unit or lower</span>\n                                            <span ng-if=\"currentStation.service_tier === 3\">1.0\n                                                spaces per unit or lower</span>\n                                            <span ng-if=\"currentStation.service_tier === 4\">1.5\n                                                spaces per unit or lower</span>\n                                        </span>\n\n\n                                    </td>\n                                </tr>\n                                <tr>\n                                    <td><span ng-if=\"policy_name === 'Vehicle Parking Minimum'\"> Minimum for New\n                                            Commercial\n                                            Uses</span>\n                                        <span ng-if=\"policy_name === 'Vehicle Parking Maximum'\"> Maximum for New\n                                            Commercial\n                                            Uses</span>\n                                    </td>\n                                    <td>\n                                        <span ng-if=\"!loading && policy_name === 'Vehicle Parking Minimum'\"><span\n                                                ng-if=\"currentStation.service_tier === 1 || currentStation.service_tier === 2 || currentStation.service_tier === 3\">\n                                                No Minimum Allowed</span>\n                                            <span ng-if=\"currentStation.service_tier === 4\">*</span>\n                                        </span>\n                                        <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                                                style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                                        <span ng-if=\"!loading && policy_name === 'Vehicle Parking Maximum'\">\n                                            <span ng-if=\"currentStation.service_tier === 1\">0.25 spaces per\n                                                1,000 s.f. or lower</span>\n                                            <span ng-if=\"currentStation.service_tier === 2\">1.6 spaces per 1,000\n                                                s.f. or lower</span>\n                                            <span ng-if=\"currentStation.service_tier === 3\">2.5 spaces per 1,000\n                                                s.f. or lower</span>\n                                            <span ng-if=\"currentStation.service_tier === 4\">4.0 spaces per 1,000\n                                                s.f. or lower</span>\n                                        </span>\n\n\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                        <p style=\"font-style: italic;\" ng-if=\"policy_name === 'Vehicle Parking Maximum'\">\n                            &#42;For parcels on which both residential and commercial development are allowed, the\n                            standard is the sum of the applicable maximum automobile parking per dwelling unit and the\n                            applicable maximum automobile parking per 1,000 square feet.\n                        </p>\n                        <p>\n                            &#42;&#42;<span style=\"font-weight: bold;\">Note:</span> Residential developments\n                            permitted in commercial zones through <a\n                                href=\"https://leginfo.legislature.ca.gov/faces/billTextClient.xhtml?bill_id=202120220AB2011\"\n                                target=\"_blank\" rel=\"noopener noreferrer\">AB 2011</a>\n                            should\n                            follow the\n                            applicable TOC standards for residential development, not commercial development.\n                        </p>     \n                        <p>\n                            A jurisdiction must show that its adopted parking maximums cover at least the ½-mile TOC area (if the policy does not apply jurisdiction-wide) and meet the TOC Policy’s standards for the TOC area’s transit tier. If the jurisdiction’s parking maximums are not expressed as parking spaces per unit (e.g., instead there are parking maximums per bedroom), a jurisdiction may propose an alternative method of demonstrating compliance consistency with the TOC standards subject to MTC staff approval. This alternative method may include, but is not limited to, proposing an equivalency calculation that translates the local maximum into spaces per unit. \n                        </p>                                                                                                                  \n                    </div>\n                </div>\n\n                <div class=\"section-nav\">\n                    <div class=\"menu--section-title\">In this section:</div>\n                    <ul class=\"menu menu--section\" role=\"tablist\">\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\" class=\"menu-item menu-item--section active\"\n                            ng-click=\"getCurrentParkingPolicy('Vehicle Parking Minimum')\">\n                            <span class=\"section-number\">I.</span>\n                            <a href=\"#\">Vehicle Minimum Parking Standards</a>\n                        </li>\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-2\" class=\"menu-item menu-item--section\"\n                            ng-click=\"getCurrentParkingPolicy('Vehicle Parking Maximum')\">\n                            <span class=\"section-number\">II.</span>\n                            <a href=\"#\">Vehicle Maximum Parking Standards</a>\n                        </li>\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit\"\n                            class=\"menu-item menu-item--section\" ng-click=\"reviewAndSubmit\">\n                            <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n                        </li>\n                    </ul>\n                    <note ng-show=\"note\"></note>\n                    <furtherguidance></furtherguidance>\n                </div>\n                <div class=\"tab-content\">\n                    <!-- Vehicle Minimum Parking Standards Section -->\n                    <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\"\n                        ng-class=\"{'active show': showPanel === 'vehicleParkingMinimum'}\"\n                        ng-class=\"{'was-validated': formSubmitted}\">\n                                 <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin-top: 30px; padding-right: 10px\">I. Vehicle Minimum Parking Standards</h2>\n              <statuspills ng-repeat=\"submission in parkingStatus\" ng-if=\"submission.submission_policy_name === currentParkingPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0] && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n                        <h3 style=\"padding-top: 15px\">\n                            Choose one of the options below to meet the minimum parking standard:\n                        </h3>\n\n                        <form class=\"row test-validation-styling\" name=\"parkingForm\" id=\"parkingForm\" novalidate>\n                            <div class=\"form-item col-lg-12\" style=\"padding-left: 18px\">\n                                <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkConfirmationCompliance\"\n                                            ng-model=\"currentParkingPolicy.parking_confirmation_compliance_checked\"\n                                            ng-change=\"onVehicleParkingMinCheckboxChange('confirmationCompliance')\"\n                                            ng-disabled=\"((currentParkingPolicy.parking_resolution_compliance_checked || currentParkingPolicy.remove_vehicle_park_mins_checked) && !currentParkingPolicy.parking_confirmation_compliance_checked) || formReadOnly\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label class=\"form-check-label\" for=\"checkConfirmationCompliance\"><span\n                                                ng-class=\"{'boldFont': parking_confirmation_compliance_checked}\">Confirmation\n                                                of Compliance with <a href=\"https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=202120220AB2097\" target=\"_blank\" rel=\"noopener noreferrer\">AB\n                                            2097 (2022)</a>:</span></label> <label class=\"form-check-label\" for=\"checkConfirmationCompliance\">Local jurisdiction staff can attest that their\n                                            jurisdiction complies with AB 2097 by checking this box. A jurisdiction that complies with AB 2097 meets the TOC Policy’s standard related to minimum vehicle parking. </label>\n                                    </div>\n                                    <div class=\"row align-items-center\"\n                                        ng-show=\"currentParkingPolicy.parking_confirmation_compliance_checked\">\n                                        <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                                            <label>Additional Details <i>(Optional)</i>:</label>\n                                            <textarea id=\"parking_confirmation_compliance_details\"\n                                                placeholder=\"Enter response\" ng-disabled=\"formReadOnly\"\n                                                ng-disabled=\"formReadOnly\"\n                                                name=\"parking_confirmation_compliance_details\" rows=\"4\" style=\"width: 100%;\"\n                                                ng-model=\"currentParkingPolicy.parking_confirmation_compliance_details\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkRemoveVehicleParkMins\"\n                                            ng-model=\"currentParkingPolicy.remove_vehicle_park_mins_checked\"\n                                            ng-change=\"onVehicleParkingMinCheckboxChange('removeVehicleParkingMins')\"\n                                            ng-disabled=\"((currentParkingPolicy.parking_confirmation_compliance_checked || currentParkingPolicy.parking_resolution_compliance_checked) && !currentParkingPolicy.remove_vehicle_park_mins_checked) || formReadOnly\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label class=\"form-check-label\" for=\"checkRemoveVehicleParkMins\"\n                                            ng-class=\"{'boldFont': remove_vehicle_park_mins_checked}\"><span\n                                                ng-class=\"{'boldFont': parking_confirmation_compliance_checked}\">Proof of No Parking Minimums:</span>\n                                            \n                                        </label><label class=\"form-check-label\" for=\"checkRemoveVehicleParkMins\">\n                                            A jurisdiction can provide an adopted ordinance that removes and/or prohibits minimum vehicle parking requirements for new development in Tier 1, Tier 2, and Tier 3 TOC areas, or cite relevant municipal code, overlay zone, or parking use table/chapter prohibiting such minimum vehicle parking requirements. \n                                        </label>\n                                    </div>\n                                    <div class=\"row align-items-center\"\n                                        ng-show=\"currentParkingPolicy.remove_vehicle_park_mins_checked\">\n\n                                        <div class=\"col-lg-7 col-md-6\">\n                                            <textarea\n                                                ng-if=\"!checkSubstring(currentParkingPolicy.remove_vehicle_park_mins)\"\n                                                ng-model=\" currentParkingPolicy.remove_vehicle_park_mins\"\n                                                id=\"remove_vehicle_park_mins\" placeholder=\"Enter response or URL\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\"\n                                                name=\"remove_vehicle_park_mins\" rows=\"4\" style=\"width: 100%;\" required\n                                                ng-disabled=\"formReadOnly\">\n                  </textarea>\n                                            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                ng-show=\"parkingForm.remove_vehicle_park_mins.$error.required && formSubmitted\">\n                                                Please provide a valid URL.\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"!checkSubstring(currentParkingPolicy.remove_vehicle_park_mins)\"\n                                            class=\"col-lg-1\">\n                                            <b>OR</b>\n                                        </div>\n                                        <!-- File upload remove_vehicle_park_mins -->\n                                        <div class=\"col-md-5\"\n                                            ng-if=\"checkSubstring(currentParkingPolicy.remove_vehicle_park_mins)\"\n                                            style=\"padding-bottom: 10px\">\n                                            <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                                                    ng-href=\"{{currentParkingPolicy.remove_vehicle_park_mins}}\">Uploaded\n                                                    Documentation</a></span>\n                                            <button class=\"button button--attach\" ng-if=\"!formReadOnly\"\n                                                ng-click=\"removeFile('remove_vehicle_park_mins')\">\n                                                <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Remove\n                                            </button>\n                                        </div>\n                                        <div class=\"row align-items-center\"\n                                            style=\"padding-top: 20px; padding-bottom: 20px\"\n                                            ng-if=\"!checkSubstring(currentParkingPolicy.remove_vehicle_park_mins)\">\n                                            <div class=\"col-lg-2\"><label for=\"remove_vehicle_park_mins_file_abcd\">Upload\n                                                    No Parking Minimums Ordinance Documentation</label></div>\n                                            <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n\n                                                <input type=\"file\" ng-model=\"remove_vehicle_park_mins_file_abcd\"\n                                                    id=\"remove_vehicle_park_mins_file_abcd\"\n                                                    name=\"remove_vehicle_park_mins_file_abcd\"\n                                                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\" />\n                                            </div>\n                                            <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                                <button class=\"button button--attach\"\n                                                    ng-click=\"uploadFile('remove_vehicle_park_mins_file_abcd')\">\n                                                    <i ng-show=\"fileUploading_remove_vehicle_park_mins_file_abcd\"\n                                                        class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Upload File\n                                                </button>\n                                                <button type=\"button\" class=\"button button--clear\"\n                                                    ng-click=\"clearFile('remove_vehicle_park_mins_file_abcd')\">\n                                                    Clear\n                                                </button>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                                            <label>Additional Details <i>(Optional)</i>:</label>\n                                            <textarea id=\"remove_vehicle_park_mins_details\" placeholder=\"Enter response\"\n                                                name=\"remove_vehicle_park_mins_details\" rows=\"4\" style=\"width: 100%;\" \n                                                ng-disabled=\"formReadOnly\"\n                                                ng-model=\"currentParkingPolicy.remove_vehicle_park_mins_details\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <submissionsectionsubmit></submissionsectionsubmit>\n                        </form>\n                    </div>\n                    <!-- Vehicle Maximum Parking Standards Section -->\n                    <div id=\"section-2\" role=\"tabpanel\" class=\"section tab-pane\"\n                        ng-class=\"{'active show': showPanel === 'vehicleParkingMaximum'}\"\n                        ng-class=\"{'was-validated': formSubmitted}\">\n                         <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\"> II. Vehicle Maximum Parking Standards</h2>\n              <statuspills ng-repeat=\"submission in parkingStatus\" ng-if=\"submission.submission_policy_name === currentParkingPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0] && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n                        <h3 style=\"padding-top: 15px\">\n                            There are two options for meeting the TOC Policy’s maximum parking standards (Choose one):\n                        </h3>\n\n                        <form class=\"row test-validation-styling\" name=\"parkingForm\" novalidate>\n                            <div class=\"form-item col-lg-12\" style=\"padding-left: 18px\">\n                                <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkAdoptedOverlayZone\"\n                                            ng-model=\"currentParkingPolicy.vehicle_park_max_overlay_zone_checked\"\n                                            ng-change=\"onVehicleParkingMaxCheckboxChange('overlayZone')\"\n                                            ng-disabled=\"currentParkingPolicy.vehicle_park_max_limit_park_method_checked || formReadOnly\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label class=\"form-check-label\" for=\"checkAdoptedOverlayZone\">\n                                            <span ng-class=\"{'boldFont': vehicle_park_max_overlay_zone_checked}\">Adopt\n                                                an overlay zone or updates to a parking use table or chapter:</span> A jurisdiction can provide an adopted ordinance that includes parking maximums for residential and commercial uses that meet TOC standards and that clearly defines the geography to which the standards apply. Defining the geography and maximum parking standards can be done by creating an overlay zone or by amending the jurisdiction’s parking use table or chapter for development within TOC areas. As the TOC Policy parking maximum standards vary by Tier, a jurisdiction with multiple TOC areas may need to specify several combinations of geography/parking maximums. \n                                                <p>\n                                                A jurisdiction choosing this approach must provide municipal code citations for the adopted overlay zone or parking use table/chapter that clearly demonstrate that the vehicle parking maximums for residential and commercial uses meet TOC standards for the TOC area’s Tier and that those standards apply to, at minimum, the entire ½-mile TOC area. \n                                                </p>\n                                        </label>\n\n\n                                    </div>\n                                    <div ng-show=\"currentParkingPolicy.vehicle_park_max_overlay_zone_checked\">\n                                        <div class=\"row align-items-center\">\n                                            <div class=\"form-item col-lg-6\"\n                                                style=\"padding-left: 30px; margin-top: 20px;\">\n                                                <label for=\"vehicle_park_max_parking_per_unit_allowed\">State the parking\n                                                    maximum per dwelling unit that the jurisdiction will allow in this\n                                                    TOC area:</label>\n                                                <input\n                                                    ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_parking_per_unit_allowed)\"\n                                                    ng-model=\" currentParkingPolicy.vehicle_park_max_parking_per_unit_allowed\"\n                                                    id=\"vehicle_park_max_parking_per_unit_allowed\"\n                                                    placeholder=\"Enter number\" type=\"number\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                                    name=\"vehicle_park_max_parking_per_unit_allowed\" required>\n                                                </input>\n                                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                    ng-show=\"parkingForm.vehicle_park_max_parking_per_unit_allowed.$error.required && formSubmitted\">\n                                                    Please provide a valid\n                                                    URL.</div>\n                                            </div>\n                                            <div class=\"form-item col-lg-6\"\n                                                style=\"padding-left: 30px; margin-top: 20px;\">\n                                                <label for=\"vehicle_park_max_parking_per_1000_sqft_commercial\">State the\n                                                    parking maximum per 1,000 square feet commercial the jurisdiction\n                                                    will allow in this TOC area:</label>\n                                                <input\n                                                    ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_parking_per_1000_sqft_commercial)\"\n                                                    ng-model=\" currentParkingPolicy.vehicle_park_max_parking_per_1000_sqft_commercial\"\n                                                    id=\"vehicle_park_max_parking_per_1000_sqft_commercial\"\n                                                    placeholder=\"Enter number\" type=\"number\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                                    name=\"vehicle_park_max_parking_per_1000_sqft_commercial\" required>\n                                                </input>\n                                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                    ng-show=\"parkingForm.vehicle_park_max_parking_per_1000_sqft_commercial.$error.required && formSubmitted\">\n                                                    Please provide a valid\n                                                    value.</div>\n                                            </div>\n                                            <div class=\"form-item col-lg-9\"\n                                                style=\"padding-left: 30px; margin-top: 20px;\">\n                                                <label for=\"vehicle_park_max_overlay_zone_municipal\">Municipal code\n                                                    citation(s)\n                                                    for an\n                                                    adopted overlay zone or parking use\n                                                    table/chapter for maximum vehicle parking standards.</label>\n                                                <textarea\n                                                    ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_overlay_zone_municipal)\"\n                                                    ng-model=\" currentParkingPolicy.vehicle_park_max_overlay_zone_municipal\"\n                                                    id=\"vehicle_park_max_overlay_zone_municipal\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    placeholder=\"Enter response or URL\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                                    name=\"vehicle_park_max_overlay_zone_municipal\" rows=\"4\" style=\"width: 100%;\" \n                                                    required>\n                  </textarea>\n                                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                    ng-show=\"parkingForm.vehicle_park_max_overlay_zone_municipal.$error.required && formSubmitted\">\n                                                    Please provide a valid\n                                                    URL.</div>\n                                            </div>\n                                            <!-- File Upload vehicle_park_max_overlay_zone_municipal -->\n                                            <div ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_overlay_zone_municipal)\"\n                                                class=\"col-lg-1\" style=\"margin-top: 45px;\"><b>OR</b>\n                                            </div>\n                                            <div class=\"col-md-5\"\n                                                ng-if=\"checkSubstring(currentParkingPolicy.vehicle_park_max_overlay_zone_municipal)\"\n                                                style=\"padding-bottom:10px;\">\n                                                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                        ng-href=\"{{currentParkingPolicy.vehicle_park_max_overlay_zone_municipal}}\">Uploaded\n                                                        Documentation</a></span>\n                                                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                    ng-click=\"removeFile('vehicle_park_max_overlay_zone_municipal')\"><i\n                                                        ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Remove</button>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row align-items-center\"\n                                            style=\"padding-top: 10px; padding-left: 15px; padding-bottom:20px;\"\n                                            ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_overlay_zone_municipal)\">\n                                            <div class=\"col-lg-2\"><label\n                                                    for=\"vehicle_park_max_overlay_zone_municipal_file_abcd\">Upload\n                                                    Citation\n                                                    Documentation</label></div>\n                                            <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                                <input type=\"file\" ng-disabled=\"formReadOnly\"\n                                                    ng-model=\"vehicle_park_max_overlay_zone_municipal_file_abcd\"\n                                                    id=\"vehicle_park_max_overlay_zone_municipal_file_abcd\"\n                                                    name=\"vehicle_park_max_overlay_zone_municipal_file_abcd\"\n                                                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\" />\n                                            </div>\n                                            <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                                <button class=\"button button--attach\"\n                                                    ng-click=\"uploadFile('vehicle_park_max_overlay_zone_municipal_file_abcd')\"><i\n                                                        ng-show=\"fileUploading_vehicle_park_max_overlay_zone_municipal_file_abcd\"\n                                                        class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Upload File</button>\n                                                <button type=\"button\" class=\"button button--clear\"\n                                                    ng-click=\"clearFile('vehicle_park_max_overlay_zone_municipal_file_abcd')\">\n                                                    Clear\n                                                </button>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row align-items-center\">\n                                            <div class=\"form-item col-lg-9\"\n                                                style=\"padding-left: 30px; margin-top: 20px;\"\n                                                ng-show=\"currentParkingPolicy.vehicle_park_max_overlay_zone_checked\">\n                                                <label for=\"vehicle_park_max_overlay_zone_equivalency\">If the\n                                                    jurisdiction’s\n                                                    parking maximums\n                                                    are expressed differently than in spaces per unit, provide\n                                                    documentation\n                                                    of\n                                                    the equivalency calculation that translates the local maximum into parking\n                                                    spaces\n                                                    per unit.</label>\n                                                <textarea\n                                                    ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_overlay_zone_equivalency)\"\n                                                    ng-model=\" currentParkingPolicy.vehicle_park_max_overlay_zone_equivalency\"\n                                                    id=\"vehicle_park_max_overlay_zone_equivalency\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                                    name=\"vehicle_park_max_overlay_zone_equivalency\" rows=\"4\" style=\"width: 100%;\" \n                                                    placeholder=\"Enter response or URL\" required>\n                  </textarea>\n                                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                    ng-show=\"parkingForm.vehicle_park_max_overlay_zone_equivalency.$error.required && formSubmitted\">\n                                                    Please provide a valid response or URL.</div>\n\n                                            </div>\n                                            <!-- File Upload vehicle_park_max_overlay_zone_equivalency-->\n                                            <div ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_overlay_zone_equivalency)\"\n                                                style=\"margin-top: 45px\" class=\"col-lg-1\"><b>OR</b>\n                                            </div>\n                                            <div class=\"col-md-5\"\n                                                ng-if=\"checkSubstring(currentParkingPolicy.vehicle_park_max_overlay_zone_equivalency)\"\n                                                style=\"padding-bottom:10px;\">\n                                                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                        ng-href=\"{{currentParkingPolicy.vehicle_park_max_overlay_zone_equivalency}}\">Uploaded\n                                                        Documentation</a></span>\n                                                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                    ng-click=\"removeFile('vehicle_park_max_overlay_zone_equivalency')\"><i\n                                                        ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Remove</button>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row align-items-center\"\n                                            style=\"padding-top: 15px; padding-left: 15px; padding-bottom:20px;\"\n                                            ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_overlay_zone_equivalency)\">\n                                            <div class=\"col-lg-2\"><label\n                                                    for=\"vehicle_park_max_overlay_zone_equivalency_file_abcd\">Upload\n                                                    Equivalency\n                                                    Documentation</label></div>\n                                            <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                                <input type=\"file\" ng-disabled=\"formReadOnly\"\n                                                    ng-model=\"vehicle_park_max_overlay_zone_equivalency_file_abcd\"\n                                                    id=\"vehicle_park_max_overlay_zone_equivalency_file_abcd\"\n                                                    name=\"vehicle_park_max_overlay_zone_equivalency_file_abcd\"\n                                                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\" />\n                                            </div>\n                                            <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                                <button class=\"button button--attach\"\n                                                    ng-click=\"uploadFile('vehicle_park_max_overlay_zone_equivalency_file_abcd')\"><i\n                                                        ng-show=\"fileUploading_vehicle_park_max_overlay_zone_equivalency_file_abcd\"\n                                                        class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Upload File</button>\n                                                <button type=\"button\" class=\"button button--clear\"\n                                                    ng-click=\"clearFile('vehicle_park_max_overlay_zone_equivalency_file_abcd')\">\n                                                    Clear\n                                                </button>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkLimitParkingMethod\"\n                                            ng-model=\"currentParkingPolicy.vehicle_park_max_limit_park_method_checked\"\n                                            ng-change=\"onVehicleParkingMaxCheckboxChange('limitParkMethod')\"\n                                            ng-disabled=\"currentParkingPolicy.vehicle_park_max_overlay_zone_checked || formReadOnly\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label class=\"form-check-label\" for=\"checkLimitParkingMethod\">\n                                            <span ng-class=\"{'boldFont': vehicle_park_max_limit_park_method_checked}\">Adopt an areawide cap that limits parking:</span> A jurisdiction can set an areawide cap on total parking buildout in line with the TOC standards. For example, a specific or area plan may determine an overall total amount of new, off-street parking that may be constructed in the area. Some development projects may provide more off-street parking, while others may provide less off-street parking, as long as the total amount of new private off-street parking to be built does not exceed the TOC Policy’s parking maximum standards.\n                                            <br><br>\n                                            A jurisdiction choosing this approach must provide any relevant plans or policies as well as calculations showing the approach will result in creation of the same or less new off-street parking than the TOC Policy’s required parking maximum standards within the TOC area. The calculations should use assumptions about future buildout (e.g., from a recently completed plan and/or EIR) and the parking permitted in the district to allow for a comparison to the TOC Policy parking maximum standards. Jurisdictions should also consider how to monitor changes in parking supply and remaining capacity within the district over time. \n                                        </label>\n                                    </div>\n\n                                    <div ng-show=\"currentParkingPolicy.vehicle_park_max_limit_park_method_checked\">\n                                        <div class=\"row align-items-center\"\n                                            style=\"padding-left: 30px; margin-top: 20px;\">\n                                            <div class=\"form-item col-lg-12\">\n                                                <label for=\"vehicle_park_max_parking_allowed_jurisdiction\">State the\n                                                    total amount of parking that the jurisdiction will allow to be built\n                                                    in this TOC area:</label>\n                                                <input\n                                                    ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_parking_allowed_jurisdiction)\"\n                                                    ng-model=\" currentParkingPolicy.vehicle_park_max_parking_allowed_jurisdiction\"\n                                                    id=\"vehicle_park_max_parking_allowed_jurisdiction\"\n                                                    placeholder=\"Enter number\" type=\"number\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                                    name=\"vehicle_park_max_parking_allowed_jurisdiction\" required>\n                                                </input>\n                                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                    ng-show=\"parkingForm.vehicle_park_max_parking_allowed_jurisdiction.$error.required && formSubmitted\">\n                                                    Please provide a valid number.</div>\n                                            </div>\n                                            <div class=\"form-item col-lg-12\">\n                                                <label for=\"vehicle_park_max_parking_allowed_toc\">State the total amount\n                                                    of\n                                                    parking allowed to be built in this TOC area under the TOC Policy\n                                                    standards for this Tier (see Table 11 of the Administrative\n                                                    Guidance):</label>\n\n                                                <input\n                                                    ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_parking_allowed_toc)\"\n                                                    ng-model=\" currentParkingPolicy.vehicle_park_max_parking_allowed_toc\"\n                                                    id=\"vehicle_park_max_parking_allowed_toc\" placeholder=\"Enter number\"\n                                                    type=\"number\" ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                                    name=\"vehicle_park_max_parking_allowed_toc\" required>\n                                                </input>\n                                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                    ng-show=\"parkingForm.vehicle_park_max_parking_allowed_toc.$error.required && formSubmitted\">\n                                                    Please provide a valid number.</div>\n                                            </div>\n                                            <div class=\"form-item col-lg-9\">\n                                                <label for=\"vehicle_park_max_park_management\">Citation(s) for adopted\n                                                    plans or policies for a parking district or area-wide approach to\n                                                    parking management. For all documents submitted, include only the\n                                                    relevant pages of the plan(s) or provide specific page numbers under\n                                                    \"Additional Details.\"</label>\n                                                <textarea\n                                                    ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_park_management)\"\n                                                    ng-model=\" currentParkingPolicy.vehicle_park_max_park_management\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    id=\"vehicle_park_max_park_management\"\n                                                    placeholder=\"Enter response or URL\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                                    name=\"vehicle_park_max_park_management\" rows=\"4\" style=\"width: 100%;\"  required>\n                  </textarea>\n                                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                    ng-show=\"parkingForm.vehicle_park_max_park_management.$error.required && formSubmitted\">\n                                                    Please provide a valid response or URL.</div>\n                                            </div>\n                                            <!-- File Upload vehicle_park_max_park_management -->\n                                            <div ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_park_management)\"\n                                                style=\"margin-top: 45px\" class=\"col-lg-1\"><b>OR</b>\n                                            </div>\n                                            <div class=\"col-md-5\"\n                                                ng-if=\"checkSubstring(currentParkingPolicy.vehicle_park_max_park_management)\"\n                                                style=\"padding-bottom:10px;\">\n                                                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                        ng-href=\"{{currentParkingPolicy.vehicle_park_max_park_management}}\">Uploaded\n                                                        Documentation</a></span>\n                                                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                    ng-click=\"removeFile('vehicle_park_max_park_management')\"><i\n                                                        ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Remove</button>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row align-items-center\"\n                                            style=\"padding-bottom:20px; padding-left: 30px; margin-top: 10px;\"\n                                            ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_park_management)\">\n                                            <div class=\"col-lg-2\"><label\n                                                    for=\"vehicle_park_max_park_management_file_abcd\">Upload Parking\n                                                    Management\n                                                    Citation\n                                                    Documentation</label></div>\n                                            <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                                <input type=\"file\" ng-model=\"vehicle_park_max_park_management_file_abcd\"\n                                                    id=\"vehicle_park_max_park_management_file_abcd\"\n                                                    name=\"vehicle_park_max_park_management_file_abcd\"\n                                                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\" />\n                                            </div>\n                                            <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                                <button class=\"button button--attach\"\n                                                    ng-click=\"uploadFile('vehicle_park_max_park_management_file_abcd')\"><i\n                                                        ng-show=\"fileUploading_vehicle_park_max_park_management_file_abcd\"\n                                                        class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Upload File</button>\n                                                <button type=\"button\" class=\"button button--clear\"\n                                                    ng-click=\"clearFile('vehicle_park_max_park_management_file_abcd')\">\n                                                    Clear\n                                                </button>\n                                            </div>\n                                            <div class=\"form-item col-lg-12\"\n                                                style=\"padding-top: 15px; padding-left: 15px\">\n                                                <label>Additional Details <i>(Optional)</i>:</label>\n                                                <textarea id=\"vehicle_park_max_park_management_details\"\n                                                    placeholder=\"Enter response\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    name=\"vehicle_park_max_park_management_details\" rows=\"4\" style=\"width: 100%;\" \n                                                    ng-model=\"currentParkingPolicy.vehicle_park_max_park_management_details\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row align-items-center\"\n                                            style=\"padding-left: 30px; margin-top: 20px\">\n                                            <div class=\"form-item col-lg-9\">\n                                                <label for=\"vehicle_park_max_limit_park_equivalency\">If the\n                                                    jurisdiction’s\n                                                    parking maximums\n                                                    are expressed differently than in spaces per unit, provide\n                                                    documentation\n                                                    of\n                                                    the equivalency calculation that translates the local maximum into\n                                                    spaces\n                                                    per unit.</label>\n                                                <textarea\n                                                    ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_limit_park_equivalency)\"\n                                                    ng-model=\" currentParkingPolicy.vehicle_park_max_limit_park_equivalency\"\n                                                    id=\"vehicle_park_max_limit_park_equivalency\"\n                                                    placeholder=\"Enter response or URL\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                                    name=\"vehicle_park_max_limit_park_equivalency\" rows=\"4\" style=\"width: 100%;\" \n                                                    required>\n                  </textarea>\n                                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                    ng-show=\"parkingForm.vehicle_park_max_limit_park_equivalency.$error.required && formSubmitted\">\n                                                    Please provide a valid response or URL.</div>\n\n                                            </div>\n                                            <!-- File Upload vehicle_park_max_limit_park_equivalency-->\n                                            <div ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_limit_park_equivalency)\"\n                                                style=\"margin-top: 25px\" class=\"col-lg-1\"><b>OR</b></div>\n                                            <div class=\"col-md-5\"\n                                                ng-if=\"checkSubstring(currentParkingPolicy.vehicle_park_max_limit_park_equivalency)\"\n                                                style=\"padding-bottom:10px;\">\n                                                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                        ng-href=\"{{currentParkingPolicy.vehicle_park_max_limit_park_equivalency}}\">Uploaded\n                                                        Documentation</a></span>\n                                                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                    ng-click=\"removeFile('vehicle_park_max_limit_park_equivalency')\"><i\n                                                        ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Remove</button>\n                                            </div>\n\n                                        </div>\n\n                                        <div class=\"row align-items-center\"\n                                            style=\"padding-top: 20px; padding-left: 30px; padding-bottom:20px;\"\n                                            ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_limit_park_equivalency)\">\n                                            <div class=\"col-lg-2\"><label\n                                                    for=\"vehicle_park_max_limit_park_equivalency_file_abcd\">Upload\n                                                    Equivalency\n                                                    Documentation</label></div>\n                                            <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                                <input type=\"file\"\n                                                    ng-model=\"vehicle_park_max_limit_park_equivalency_file_abcd\"\n                                                    id=\"vehicle_park_max_limit_park_equivalency_file_abcd\"\n                                                    name=\"vehicle_park_max_limit_park_equivalency_file_abcd\"\n                                                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\" />\n                                            </div>\n                                            <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                                <button class=\"button button--attach\"\n                                                    ng-click=\"uploadFile('vehicle_park_max_limit_park_equivalency_file_abcd')\"><i\n                                                        ng-show=\"fileUploading_vehicle_park_max_limit_park_equivalency_file_abcd\"\n                                                        class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Upload File</button>\n                                                <button type=\"button\" class=\"button button--clear\"\n                                                    ng-click=\"clearFile('vehicle_park_max_limit_park_equivalency_file_abcd')\">\n                                                    Clear\n                                                </button>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row align-items-center\"\n                                            style=\"padding-left: 30px; margin-top: 20px\">\n                                            <div class=\"form-item col-lg-9\"\n                                                ng-show=\"currentParkingPolicy.vehicle_park_max_limit_park_method_checked\">\n                                                <label for=\"vehicle_park_max_off_street_park_calculation\">Calculations\n                                                    showing\n                                                    the\n                                                    approach will result in creation of the same or less new off-street\n                                                    parking\n                                                    than the TOC Policy’s parking maximum standards. The calculations\n                                                    should\n                                                    use assumptions about future buildout (e.g., from a recently\n                                                    completed\n                                                    plan\n                                                    and/or EIR) and the parking permitted in the district to allow for a\n                                                    comparison to the TOC Policy parking maximum standards.</label>\n                                                <textarea\n                                                    ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_off_street_park_calculation)\"\n                                                    ng-model=\"currentParkingPolicy.vehicle_park_max_off_street_park_calculation\"\n                                                    id=\"vehicle_park_max_off_street_park_calculation\"\n                                                    placeholder=\"Enter response or URL\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                                    name=\"vehicle_park_max_off_street_park_calculation\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                    ng-show=\"parkingForm.vehicle_park_max_off_street_park_calculation.$error.required && formSubmitted\">\n                                                    Please provide a valid response or URL.</div>\n\n                                            </div>\n                                            <!-- File Upload vehicle_park_max_off_street_park_calculation-->\n                                            <div ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_off_street_park_calculation)\"\n                                                style=\"margin-top: 65px\" class=\"col-lg-1\"><b>OR</b>\n                                            </div>\n                                            <div class=\"col-md-5\"\n                                                ng-if=\"checkSubstring(currentParkingPolicy.vehicle_park_max_off_street_park_calculation)\"\n                                                style=\"padding-bottom:10px;\">\n                                                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                        ng-href=\"{{currentParkingPolicy.vehicle_park_max_off_street_park_calculation}}\">Uploaded\n                                                        Documentation</a></span>\n                                                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                    ng-click=\"removeFile('vehicle_park_max_off_street_park_calculation')\"><i\n                                                        ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Remove</button>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"row align-items-center\"\n                                            style=\"padding-top: 20px; padding-left: 30px; padding-bottom:20px;\"\n                                            ng-if=\"!checkSubstring(currentParkingPolicy.vehicle_park_max_off_street_park_calculation)\">\n                                            <div class=\"col-lg-2\"><label\n                                                    for=\"vehicle_park_max_off_street_park_calculation_file_abcd\">Upload\n                                                    Off-Street Parking\n                                                    Documentation</label></div>\n                                            <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                                <input type=\"file\" ng-disabled=\"formReadOnly\"\n                                                    ng-model=\"vehicle_park_max_off_street_park_calculation_file_abcd\"\n                                                    id=\"vehicle_park_max_off_street_park_calculation_file_abcd\"\n                                                    name=\"vehicle_park_max_off_street_park_calculation_file_abcd\"\n                                                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                                    ng-disabled=\"formReadOnly\"\n                                                    onchange=\"angular.element(this).scope().setPending(this)\" />\n                                            </div>\n                                            <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                                <button class=\"button button--attach\"\n                                                    ng-click=\"uploadFile('vehicle_park_max_off_street_park_calculation_file_abcd')\"><i\n                                                        ng-show=\"fileUploading_vehicle_park_max_off_street_park_calculation_file_abcd\"\n                                                        class=\"fa-solid fa-cog fa-spin\"></i>\n                                                    Upload File</button>\n                                                <button type=\"button\" class=\"button button--clear\"\n                                                    ng-click=\"clearFile('vehicle_park_max_off_street_park_calculation_file_abcd')\">\n                                                    Clear\n                                                </button>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <submissionsectionsubmit></submissionsectionsubmit>\n                        </form>\n                    </div>\n                    <!-- Review and submit  -->\n                    <div id=\"section-review-submit\" role=\"tabpanel\" class=\"section tab-pane\"\n                        ng-class=\"{'active show': reviewAndSubmit}\">\n                        <h2>Review and Submit</h2>\n                        <p>\n                            <span style=\"font-style: italic\">\n                                Select policies below to submit to MTC for review.</span>\n                        </p>\n\n                        <form class=\"row test-validation-styling\" novalidate style=\"margin-left: 2px\">\n                            <!-- Vehicle Parking Minimum  -->\n                            <div class=\"verification-container\">\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"foo\"\n                                        ng-model=\"parking.vehicleParkingMinCheck\"\n                                        ng-click=\"addToSubmissions('vehicleParkingMinimum')\"\n                                        ng-disabled=\"vehicleParkingMinCheck === true\"\n                                        ng-checked=\"vehicleParkingMinCheck\" />\n                                    <label class=\"form-check-label\" for=\"vehicleParkingMinCheck\"\n                                        ng-class=\"{'boldFont': parking.vehicleParkingMinCheck}\">\n                                        Vehicle Parking Minimum\n                                        <span ng-if=\"vehicleParkingMinCheck === true\"\n                                        class=\"badge badge--submitted\">Submitted</span>\n                                    </label>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"parking.vehicleParkingMinCheck\">\n                                    <p>\n                                        I have completed the\n                                        <a href=\"#\" ng-click=\"togglePanel('vehicleParkingMinimum')\">Compliance with\n                                            MTC's\n                                            Vehicle Parking Minimum Section</a>\n                                        and uploaded any relevant documentation.\n                                    </p>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"vehicleParkingMinimum[0].submitted\">\n                                    <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                                        <div class=\"col\">\n                                            <div class=\"alert alert-success fade show\" role=\"alert\">\n                                                This policy has been submitted and is under review.\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <!-- Vehicle Parking Maximum -->\n                            <div class=\"verification-container\">\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                        ng-model=\"parking.vehicleParkingMaxCheck\"\n                                        ng-click=\"addToSubmissions('vehicleParkingMaximum')\"\n                                        ng-disabled=\"vehicleParkingMaxCheck === true\"\n                                        ng-checked=\"vehicleParkingMaxCheck\" />\n                                    <label class=\"form-check-label\" for=\"vehicleParkingMaxCheck\"\n                                        ng-class=\"{'boldFont': parking.vehicleParkingMaxCheck}\">\n                                        Vehicle Parking Maximum\n                                        <span ng-if=\"vehicleParkingMaxCheck === true\"\n                                        class=\"badge badge--submitted\">Submitted</span>\n                                    </label>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"parking.vehicleParkingMaxCheck\">\n                                    <p>\n                                        I have completed the\n                                        <a href=\"#\" ng-click=\"togglePanel('vehicleParkingMaximum')\">Vehicle Parking\n                                            Maximum Section</a>\n                                        and uploaded any relevant documentation.\n                                    </p>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"vehicleParkingMaximum[0].submitted\">\n                                    <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                                        <div class=\"col\">\n                                            <div class=\"alert alert-success fade show\" role=\"alert\">\n                                                This policy has been submitted and is under review.\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </form>\n                        <submissionsectionsubmit></submissionsectionsubmit>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter></sidebarfooter>\n        </div>\n    </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ParkingPoliciesComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parking_policies = __webpack_require__(107);
	
	var _parking_policies2 = _interopRequireDefault(_parking_policies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ParkingPoliciesComponent = exports.ParkingPoliciesComponent = function () {
	  /*@ngInject*/
	  function ParkingPoliciesComponent($state, $scope, $rootScope, fetch, lookup, userService, $timeout, baseConfigService, $http, $stateParams) {
	    _classCallCheck(this, ParkingPoliciesComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$stateParams = $stateParams;
	    this.userService = userService;
	    this.$timeout = $timeout;
	    this.$http = $http;
	    this.baseConfigService = baseConfigService;
	
	    $scope.adminUnlocked = false;
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.submissions = [];
	    $scope.savemode = null;
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.parking = {};
	
	    $scope.unbundledParkCheck = false;
	
	    $scope.submitmode = null;
	
	    $scope.initialLoad = true;
	
	    $scope.policy_name = 'Unbundled Parking';
	
	    $scope.policyNotesMapping = {
	      'Unbundled Parking': '<strong>Note:</strong> Jurisdictions in Alameda County or Santa Clara County can meet the residential portion of this standard by confirming the jurisdiction complies with California Civil Code Section 1947.1 (AB 1317, 2023). However, a jurisdiction choosing this approach must still submit documentation explicitly allowing unbundled parking for new commercial development.',
	      'Shared Parking': '<strong>Note:</strong> AB 894 (2023) requires jurisdictions to allow entities with underutilized parking to share their underutilized parking spaces with the public, local agencies, or other entities, if those entities submit a shared parking agreement. See California Government Code Section 65863.1 for more information.',
	      'Complementary Parking Management Policy': ''
	    };
	
	    $scope.pendingChanges = false;
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.setPending = function () {
	      console.log('set pending ran');
	      console.log($scope.initialLoad);
	      if (!$scope.initialLoad) {
	        $scope.savemode = 'parking';
	        $scope.pendingChanges = true;
	      }
	    };
	
	    $scope.toggleUnbundledParking = function (value) {
	      if ($scope.currentParkingPolicy.unbundled_park_permitted === value) {
	        $scope.currentParkingPolicy.unbundled_park_permitted = null;
	      } else {
	        $scope.currentParkingPolicy.unbundled_park_permitted = value;
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentParkingPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.parkingStatus) {
	        for (var i = 0; i < $scope.parkingStatus.length; i++) {
	          if ($scope.parkingStatus[i].submission_policy_name === $scope.policy_name) {
	            submission = $scope.parkingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentParkingPolicy;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.parkingStatus && $scope.policy_name) {
	        var sub = _.find($scope.parkingStatus, { submission_policy_name: $scope.policy_name });
	        if (sub && sub.submitted && sub.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('parkingStatus', function () {
	      if (!$scope.currentParkingPolicy) return;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm('Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.');
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.parkingStatus) {
	        for (var i = 0; i < $scope.parkingStatus.length; i++) {
	          if ($scope.parkingStatus[i].submission_policy_name === $scope.policy_name) {
	            submission = $scope.parkingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error('No matching submission found to withdraw');
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', payload).then(function () {
	        submission.submitted = false;
	        submission.status = null;
	
	        if ($scope.checkParking1 && $scope.checkParking1.submission_id === submission.submission_id) {
	          $scope.checkParking1 = null;
	          $scope.unbundledParkCheck = false;
	          $scope.parking.unbundledParkCheck = false;
	          if ($scope.unbundledParking) {
	            $scope.unbundledParking.forEach(function (el) {
	              el.submitted = false;
	            });
	          }
	        } else if ($scope.checkParking2 && $scope.checkParking2.submission_id === submission.submission_id) {
	          $scope.checkParking2 = null;
	          $scope.sharedParkCheck = false;
	          $scope.parking.sharedParkCheck = false;
	          if ($scope.sharedParking) {
	            $scope.sharedParking.forEach(function (el) {
	              el.submitted = false;
	            });
	          }
	        } else if ($scope.checkParking3 && $scope.checkParking3.submission_id === submission.submission_id) {
	          $scope.checkParking3 = null;
	          $scope.complementaryParkCheck = false;
	          $scope.parking.complementaryParkCheck = false;
	
	          if ($scope.complementaryParking) {
	            $scope.complementaryParking.forEach(function (el) {
	              el.submitted = false;
	            });
	          }
	        }
	
	        $scope.formReadOnly = false;
	
	        var formId = $scope.currentParkingPolicy ? $scope.currentParkingPolicy.parking_form_id : null;
	        $scope.currentParkingPolicy = { parking_form_id: formId };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	      }).catch(function (err) {
	        console.error('Withdraw failed:', err);
	        alert('There was an error withdrawing the submission. Please try again.');
	      });
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'parking';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Parking').then(function (response) {
	        $scope.parkingStatus = response.data;
	        console.log('Parking status response:', response.data);
	        $scope.checkParking1 = _.filter(response.data, { submission_policy_name: 'Unbundled Parking', submitted: true })[0];
	        $scope.checkParking2 = _.filter(response.data, { submission_policy_name: 'Shared Parking', submitted: true })[0];
	        $scope.checkParking3 = _.filter(response.data, { submission_policy_name: 'Complementary Parking Management Policy', submitted: true })[0];
	        console.log('Loaded policy submissions:', $scope.parkingStatus);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	      $scope.getSubmissionStatus();
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Parking').then(function (response) {
	
	        $scope.currentStation = response.data[0];
	
	        $scope.complementaryParking = _.filter(response.data, { submission_policy_name: 'Complementary Parking Management Policy' });
	        if ($scope.complementaryParking.length > 0) {
	          $scope.complementaryParking.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.complementaryParkCheck = true;
	            }
	          });
	        }
	        $scope.unbundledParking = _.filter(response.data, { submission_policy_name: 'Unbundled Parking' });
	        if ($scope.unbundledParking.length > 0) {
	          $scope.unbundledParking.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.unbundledParkCheck = true;
	            }
	          });
	        }
	        $scope.sharedParking = _.filter(response.data, { submission_policy_name: 'Shared Parking' });
	        if ($scope.sharedParking.length > 0) {
	          $scope.sharedParking.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.sharedParkCheck = true;
	            }
	          });
	        }
	        $scope.vehicleParkingMaximum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Maximum' });
	        if ($scope.vehicleParkingMaximum.length > 0) {
	          $scope.vehicleParkingMaximum.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.vehicleParkingMaxCheck = true;
	            }
	          });
	        }
	        $scope.vehicleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Minimum' });
	        if ($scope.vehicleParkingMinimum.length > 0) {
	          $scope.vehicleParkingMinimum.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.vehicleParkingMinCheck = true;
	            }
	          });
	        }
	        $scope.bicycleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Bicycle Parking Minimum' });
	        if ($scope.bicycleParkingMinimum.length > 0) {
	          $scope.bicycleParkingMinimum.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.bicycleParkingMinCheck = true;
	            }
	          });
	        }
	
	        var requestedPolicyName = $stateParams.policyName;
	        if (requestedPolicyName) {
	          $scope.policy_name = requestedPolicyName;
	
	          $timeout(function () {
	            var targetTab = void 0;
	            if (requestedPolicyName === 'Unbundled Parking') {
	              targetTab = '#section-1';
	            } else if (requestedPolicyName === 'Shared Parking') {
	              targetTab = '#section-2';
	            } else if (requestedPolicyName === 'Complementary Parking Management Policy') {
	              targetTab = '#section-3';
	            }
	
	            if (targetTab) {
	              document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (tab) {
	                tab.classList.remove('active');
	              });
	              document.querySelectorAll('.tab-pane').forEach(function (pane) {
	                pane.classList.remove('show', 'active');
	              });
	
	              var tabTrigger = document.querySelector('[data-bs-target="' + targetTab + '"]');
	              if (tabTrigger) {
	                tabTrigger.classList.add('active');
	                var tabPane = document.querySelector(targetTab);
	                if (tabPane) {
	                  tabPane.classList.add('show', 'active');
	                }
	              }
	            }
	          }, 100);
	        } else {}
	
	        return $scope.getCurrentParkingPolicy($scope.policy_name);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getCurrentParkingPolicy = function (policy_name) {
	      if (policy_name) {
	        $scope.policy_name = policy_name;
	      }
	      console.log('policy_name:', policy_name);
	
	      fetch.getAllItems('api/data/getParkingForm/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + encodeURIComponent($scope.policy_name)).then(function (response) {
	
	        $scope.currentParkingPolicy = response.data[0];
	
	        console.log('parking_form_id:', $scope.currentParkingPolicy.parking_form_id);
	        if (policy_name === 'Complementary Parking Management Policy') {
	          if ($scope.currentParkingPolicy.tdm_policy_new_dev) {
	            $scope.tdm_policy_new_dev_checked = true;
	          }
	          if ($scope.currentParkingPolicy.curb_strategy_management) {
	            $scope.curb_strategy_management_checked = true;
	          }
	          if ($scope.currentParkingPolicy.parking_benefit_district) {
	            $scope.parking_benefit_district_checked = true;
	          }
	          if ($scope.currentParkingPolicy.demand_responsive_price) {
	            $scope.demand_responsive_price_checked = true;
	          }
	          if ($scope.currentParkingPolicy.priced_park) {
	            $scope.priced_park_checked = true;
	          }
	        }
	        $scope.initialLoad = false;
	        console.log($scope.initialLoad);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentParkingPolicy = function () {
	
	      $scope.formSubmitted = true;
	      if (parkingForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      Object.keys($scope.currentParkingPolicy).forEach(function (key) {
	        if ($scope.currentParkingPolicy[key] === "" || $scope.currentParkingPolicy[key] === undefined) {
	          $scope.currentParkingPolicy[key] = null;
	        }
	      });
	
	      $scope.currentParkingPolicy.parking_form_id = $scope.currentParkingPolicy.parking_form_id;
	
	      console.log("Payload being sent:", $scope.currentParkingPolicy);
	
	      fetch.updateItem('api/data/parking/forms/update', $scope.currentParkingPolicy).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.saved = false;
	          $scope.savemode = null;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.submitParking = function () {
	      console.log($scope.parking.sharedParkCheck);
	      $scope.formSubmitted = true;
	      $scope.saving = true;
	      var upsertData = [];
	
	      $scope.upsertData = [];
	
	      console.log("submissing", $scope.parking.sharedParkCheck, $scope.sharedParking.length);
	      if ($scope.parking.complementaryParkCheck && $scope.complementaryParking.length > 0) {
	        $scope.complementaryParking.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              complementary_parking_management: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.unbundledParkCheck && $scope.unbundledParking.length > 0) {
	        $scope.unbundledParking.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              unbundled_parking: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.sharedParkCheck && $scope.sharedParking.length > 0) {
	        $scope.sharedParking.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              shared_parking: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.vehicleParkingMaxCheck && $scope.VehicleParkingMaximum.length > 0) {
	        $scope.VehicleParkingMaximum.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              vehicle_parking_maximum: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.vehicleParkingMinCheck && $scope.vehicleParkingMinimum.length > 0) {
	        $scope.vehicleParkingMinimum.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              vehicle_parking_minimum: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.bicycleParkingMinCheck && $scope.bicycleParkingMinimum.length > 0) {
	        $scope.bicycleParkingMinimum.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              bicycle_parking_minimum: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saving = false;
	        $scope.submissions = [];
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        $scope.getSubmissionStatus();
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 2000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        }
	
	        if ($scope.currentSelectedStationId) {
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.selectedFile = null;
	
	    $scope.handleFileSelect = function (element) {
	      console.log(element);
	      $scope.setPending();
	      $scope.$apply(function () {
	        $scope.selectedFile = element.files[0];
	      });
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	
	      var file = $scope.selectedFile;
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      $scope['fileUploading_' + ngmodelfile] = true;
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentParkingPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	        $scope.selectedFile = null;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	        $scope['fileUploading_' + ngmodelfile] = false;
	      });
	    };
	
	    $scope.clearFile = function (ngmodelfile) {
	      var fileInput = document.getElementById(ngmodelfile);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope.selectedFile = null;
	      }
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentParkingPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'parking';
	      $scope.pendingChanges = true;
	    };
	  }
	
	  _createClass(ParkingPoliciesComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.submissionActivity = [];
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.currentParkingPolicy = {};
	        return _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	      this.$scope.note = '<strong>Note:</strong> For jurisdictions in Alameda County or Santa Clara County, AB 1317 (2023) requires unbundled parking in new residential developments with 16 or more units that are issued a certificated of occupancy after January 1, 2025. See California Civil Code Section 1947.1 for more information.';
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return ParkingPoliciesComponent;
	}();
	
	exports.default = angular.module('appApp.parking_policies', [uiRouter]).config(_parking_policies2.default).component('parkingPolicies', {
	  template: __webpack_require__(108),
	  controller: ParkingPoliciesComponent,
	  controllerAs: 'parkingPoliciesCtrl'
	}).name;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('parking_policies', {
	    url: '/account/parking/parking_policies?jurisdiction&sta_recid&policyName',
	    template: '<parking-policies></parking-policies>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null,
	      policyName: null
	    }
	  });
	};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n    <div class=\"page-wrapper\">\n        <div class=\"dashboard-header\">\n            <sidebarnav></sidebarnav>\n        </div>\n\n        <div class=\"main\">\n            <mainheaderauth></mainheaderauth>\n            <maintocselection />\n\n            <div class=\"content container\">\n                <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n                <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n                <div class=\"section-nav\">\n                    <div class=\"menu--section-title\">In this section:</div>\n                    <ul class=\"menu menu--section\" role=\"tablist\">\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\" class=\"menu-item menu-item--section active\"\n                            ng-click=\"getCurrentParkingPolicy('Unbundled Parking'); note = policyNotesMapping['Unbundled Parking']\">\n                            <span class=\"section-number\">I.</span>\n                            <a href=\"#\">Unbundled Parking</a>\n                        </li>\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-2\" class=\"menu-item menu-item--section\"\n                            ng-click=\"getCurrentParkingPolicy('Shared Parking'); note = policyNotesMapping['Shared Parking']\">\n                            <span class=\"section-number\">II.</span>\n                            <a href=\"#\">Shared Parking</a>\n                        </li>\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-3\" class=\"menu-item menu-item--section\"\n                            ng-click=\"getCurrentParkingPolicy('Complementary Parking Management Policy'); note = policyNotesMapping['Complementary Parking Management Policy']\">\n                            <span class=\"section-number\">III.</span>\n                            <a href=\"#\">Complementary Parking Management Policy</a>\n                        </li>\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit\"\n                            class=\"menu-item menu-item--section\" ng-click=\"reviewAndSubmit\">\n                            <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n                        </li>\n                    </ul>\n                    <note class=\"section-pin\" ng-if=\"note\" ng-bind-html=\"note\"></note>\n                    <furtherguidance></furtherguidance>\n                </div>\n                <div class=\"tab-content\">\n                    <!-- Unbundled and Shared Parking Section -->\n                    <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\"\n                        ng-class=\"{'active show': showPanel === 'unbundledParking'}\" ng-class=\"{'was-validated': formSubmitted}\">\n                                 <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Unbundled Parking</h2>\n              <statuspills ng-repeat=\"submission in parkingStatus\" ng-if=\"submission.submission_policy_name === currentParkingPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0] && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.submission_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n                        <br>\n                        <p>\n                            To meet the TOC Policy standard for unbundled parking, a jurisdiction must provide citations for the adopted plans, policies, and/or municipal code or ordinance that explicitly allows unbundled parking for new residential and commercial development. Further detail on unbundled parking is provided in the <a\n                                href=\"https://abag.ca.gov/sites/default/files/documents/2021-10/Parking_Policy_Playbook_compiled_vF20211020.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">MTC/ABAG\n                                MTC/ABAG Parking Policy Playbook.</a>\n                        </p>\n                        <div ng-if=\"currentStation && (currentStation.county_name === 'Alameda' || currentStation.county_name === 'Santa Clara')\">\n                        <p>\n                            For jurisdictions in Alameda County or Santa Clara County ONLY and for the residential portion of the standard ONLY:\n\n                            <ul>\n                                <li>\n                                    Local jurisdiction staff can attest that their jurisdiction complies with Civil Code Section 1947.1 by checking this box. A jurisdiction that complies with Civil Code Section 1947.1 meets the TOC Policy standard for unbundled parking. \n                                </li>\n                            </ul>\n                        </p>\n                        </div>\n                       \n\n                        <form class=\"row\" name=\"parkingForm\" novalidate>\n\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"unbundled_park_permitted\">Is unbundled parking explicitly permitted by\n                                    the jurisdiction across the TOC area? \n                                    <span ng-if=\"currentStation && (currentStation.county_name === 'Alameda' || currentStation.county_name === 'Santa Clara')\">\n                                        Jurisdictions in Alameda County or Santa Clara County that selected “yes” above should still provide documentation of unbundled parking for commercial development here. \n                                    </span></label>\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"radio\"\n                                        id=\"unbundled_park_permitted_yes\"\n                                        name=\"unbundled_park_permitted\"\n                                        ng-disabled=\"formReadOnly\"\n                                        ng-model=\"currentParkingPolicy.unbundled_park_permitted\"\n                                        ng-value=\"true\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\" />\n                                    <label class=\"form-check-label\" for=\"unbundled_park_permitted_yes\">\n                                        <span ng-class=\"{'boldFont': currentParkingPolicy.unbundled_park_permitted === true}\">Yes</span>\n                                    </label>\n                                </div>\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"radio\"\n                                        id=\"unbundled_park_permitted_no\"\n                                        name=\"unbundled_park_permitted\"\n                                        ng-disabled=\"formReadOnly\"\n                                        ng-model=\"currentParkingPolicy.unbundled_park_permitted\" \n                                        ng-value=\"false\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\" />\n                                    <label class=\"form-check-label\" for=\"unbundled_park_permitted_no\">\n                                        <span ng-class=\"{'boldFont': currentParkingPolicy.unbundled_park_permitted === false}\">No</span>\n                                    </label>\n                                </div>\n                            </div>\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"allow_unbundled_park_citation\">Citation(s) for adopted plans, policies,\n                                    and/or municipal code or ordinance allowing unbundled parking. For all documents\n                                    submitted, include only the relevant pages of the plan(s) or provide specific\n                                    page numbers under \"Additional Details.\" </label>\n\n                            </div>\n                            <div class=\"row align-items-center\" style=\"padding-bottom: 15px;\">\n                                <div class=\"col-lg-7 col-md-6\" style=\"margin-top: 20px;\">\n                                    <textarea ng-if=\"!checkSubstring(currentParkingPolicy.allow_unbundled_park_citation)\" ng-model=\" currentParkingPolicy.allow_unbundled_park_citation\"\n                                        id=\"allow_unbundled_park_citation\" placeholder=\"Enter response or URL\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"\n                                        ng-disabled=\"formReadOnly\"\n                                        name=\"allow_unbundled_park_citation\" rows=\"4\" style=\"width: 100%;\" required>\n                          </textarea>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"parkingForm.allow_unbundled_park_citation.$error.required && formSubmitted\">\n                                        Please provide a valid response or\n                                        URL.</div>\n                                </div>\n                                <!-- File Upload allow_unbundled_park_citation -->\n                                <div ng-if=\"!checkSubstring(currentParkingPolicy.allow_unbundled_park_citation)\"\n                                    style=\"margin-top: 5px; text-align: center; display: flex; align-items: center; justify-content: center;\" class=\"col-lg-1 col-md-1\" style=\"display: flex; align-items: center; justify-content: center; height: 100px;\"><b>OR</b></div>\n                            </div>\n                            <div class=\"col-md-5\"\n                                ng-if=\"checkSubstring(currentParkingPolicy.allow_unbundled_park_citation)\"\n                                style=\"padding-bottom:10px;\">\n                                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                        ng-href=\"{{currentParkingPolicy.allow_unbundled_park_citation}}\">Uploaded\n                                        Documentation</a></span>\n                                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                    ng-click=\"removeFile('allow_unbundled_park_citation')\"><i ng-show=\"fileUploading\"\n                                        class=\"fa-solid fa-cog fa-spin\"></i>\n                                    Remove</button>\n                            </div>\n                            <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                                ng-if=\"!checkSubstring(currentParkingPolicy.allow_unbundled_park_citation)\">\n                                <div class=\"col-lg-2\"><label for=\"allow_unbundled_park_citation_file_abcd\">Municipal\n                                        Code\n                                        Citation\n                                        Documentation</label></div>\n                                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                    <input type=\"file\" ng-model=\"allow_unbundled_park_citation_file_abcd\"\n                                        id=\"allow_unbundled_park_citation_file_abcd\"\n                                        name=\"allow_unbundled_park_citation_file_abcd\"\n                                        accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                        ng-disabled=\"formReadOnly\"\n                                        onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                                </div>\n                                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                    <button class=\"button button--attach\"\n                                        ng-click=\"uploadFile('allow_unbundled_park_citation_file_abcd')\"><i\n                                            ng-show=\"fileUploading_allow_unbundled_park_citation_file_abcd\"\n                                            class=\"fa-solid fa-cog fa-spin\"></i>\n                                        Upload File</button>\n                                    <button type=\"button\" class=\"button button--clear\"\n                                        ng-click=\"clearFile('allow_unbundled_park_citation_file_abcd')\">\n                                        Clear\n                                    </button>\n                                </div>\n                            </div>\n                            <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                                <label>Additional Details (Optional):</label>\n                                <textarea id=\"allow_unbundled_park_citation_details\" placeholder=\"Enter response\"\n                                    name=\"allow_unbundled_park_citation_details\" rows=\"4\" style=\"width: 100%;\"\n                                    ng-model=\"currentParkingPolicy.allow_unbundled_park_citation_details\" ng-disabled=\"formReadOnly\"\n                                    onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                            </div>\n\n                            <submissionsectionsubmit></submissionsectionsubmit>\n                        </form>\n                    </div>\n                    <!-- Shared Parking Section -->\n                    <div id=\"section-2\" role=\"tabpanel\" class=\"section tab-pane\"\n                        ng-class=\"{'active show': showPanel === 'sharedParking'}\" ng-class=\"{'was-validated': formSubmitted}\">\n                        <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Shared Parking</h2>\n              <statuspills ng-repeat=\"submission in parkingStatus\" ng-if=\"submission.submission_policy_name === currentParkingPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0] && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n                        <br>\n                        <p>\n                            To meet the TOC Policy standard for shared parking, a local jurisdiction can provide confirmation that the jurisdiction complies with California Government Code Section 65863.1 (AB 894, 2023). Alternatively, a jurisdiction can provide citations for the adopted plans, policies, and/or municipal code or ordinance that explicitly allows shared parking for new residential and commercial development. Further detail on shared parking is provided in the <a\n                                href=\"https://abag.ca.gov/sites/default/files/documents/2021-10/Parking_Policy_Playbook_compiled_vF20211020.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">MTC/ABAG\n                                Parking Policy Playbook.</a>\n                        </p>\n\n                        <p>\n                            Choose one of the options below to meet the shared parking standard:\n                        </p>\n\n                        <form class=\"row\" name=\"parkingForm\" novalidate>\n                            <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkGovernmentCodeCompliance\"\n                                            ng-disabled=\"formReadOnly || currentParkingPolicy.allow_shared_parking_citation_checked\"\n                                            ng-model=\"currentParkingPolicy.government_code_compliance_checked\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label for=\"checkGovernmentCodeCompliance\"><span style=\"font-weight: bold;\"> Confirmation of Compliance with Government Code Section 65863.1</span>: \nLocal jurisdiction staff can attest that their jurisdiction complies with Government Code Section 65863.1 by checking this box. A jurisdiction that complies with Government Code Section 65863.1 meets the TOC Policy standard for shared parking.</label>\n                                    </div>\n                                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\"\n                                        ng-show=\"currentParkingPolicy.government_code_compliance_checked\">\n                                        <label>Additional Details (Optional):</label>\n                                        <textarea id=\"government_code_compliance_details\" name=\"government_code_compliance_details\"\n                                            rows=\"4\" style=\"width: 100%;\"\n                                            ng-model=\"currentParkingPolicy.government_code_compliance_details\" ng-disabled=\"formReadOnly\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                    </div>\n                            </div>\n                            <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkAllowSharedParking\"\n                                            ng-disabled=\"formReadOnly || currentParkingPolicy.government_code_compliance_checked\"\n                                            ng-model=\"currentParkingPolicy.allow_shared_parking_citation_checked\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label for=\"checkAllowSharedParking\">Citation(s) for adopted plans, policies,\n                                    and/or municipal code or ordinance that explicitly allows shared parking. For all\n                                    documents\n                                    submitted, include only the relevant pages of the plan(s) or provide specific page\n                                    numbers under \"Additional Details.\"</label>\n                                    </div>\n                                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\"\n                                        ng-show=\"currentParkingPolicy.allow_shared_parking_citation_checked\">\n                                        <label>Additional Details (Optional):</label>\n                                        <textarea id=\"allow_shared_parking_citation_details\" name=\"allow_shared_parking_citation_details\"\n                                            rows=\"4\" style=\"width: 100%;\"\n                                            ng-model=\"currentParkingPolicy.allow_shared_parking_citation_details\" ng-disabled=\"formReadOnly\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                    </div>\n                            </div>\n                            <submissionsectionsubmit></submissionsectionsubmit>\n                        </form>\n                    </div>\n                    <!-- Complementary Parking Management Policy Section -->\n                    <div id=\"section-3\" role=\"tabpanel\" class=\"section tab-pane\"\n                        ng-class=\"{'active show': showPanel === 'complementaryParking'}\"\n                        ng-class=\"{'was-validated': formSubmitted}\">\n                          <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"padding-right: 10px\">Complementary Parking Management Policy</h2>\n              <statuspills ng-repeat=\"submission in parkingStatus\" ng-if=\"submission.submission_policy_name === currentParkingPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0] && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n                        <p>\n                            To meet the TOC Policy’s standard related to complementary policies for parking management, a jurisdiction must document and provide citations for the adopted plans, policies, and/or municipal code or ordinance for one or more of the policies or programs from the  <a\n                                href=\"https://abag.ca.gov/technical-assistance/parking-policy-playbook#:%7E:text=The%20Parking%20Policy%20Playbook%20is,the%20challenges%20of%20policy%20change.\" target=\"_blank\" rel=\"noopener noreferrer\">MTC/ABAG’s\n                                Parking Policy Playbook</a> listed below that apply either to the geographic area where the TOC Policy applies or jurisdiction-wide.\n                            <br><br>\n                            <span style=\"font-weight: bold;\">TDM Policy for New Development</span>: Require provision and enforcement of transportation demand management (TDM). \n                            <br><br>\n                            <span style=\"font-weight: bold;\">Curb Strategy/Management</span>: Priority curb access based on variable need.  \n                            <br><br>\n                            <span style=\"font-weight: bold;\">Parking Benefit District (PBD)</span>: Invest parking revenues into a PBD to fund streetscape, safety, and TDM programs. \n                            <br><br>\n                            <span style=\"font-weight: bold;\">Demand-Responsive Pricing</span>: Price parking according to level of convenience and demand. \n                            <br><br>\n                            <span style=\"font-weight: bold;\">Priced Parking</span>: Adding priced parking where it used to be free.\n                        </p>\n                        <p>\n                           Up to three policies can earn consistency credit. For all documents submitted, include only the relevant pages of the plan(s) or provide specific page numbers under \"Additional Details.\" \n                        </p>\n\n                        <form class=\"row\" name=\"parkingForm\" novalidate>\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"complementary_adopted_policies\">Is at least one of the below policies or\n                                    programs adopted by the jurisdiction in the TOC area?</label>\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"radio\"\n                                        id=\"complementary_adopted_policies_yes\"\n                                        name=\"complementary_adopted_policies\"\n                                        ng-model=\"currentParkingPolicy.complementary_adopted_policies\"\n                                        ng-value=\"true\"\n                                        ng-disabled=\"formReadOnly\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\" />\n                                    <label class=\"form-check-label\" for=\"complementary_adopted_policies_yes\">\n                                        <span ng-class=\"{'boldFont': currentParkingPolicy.complementary_adopted_policies === true}\">Yes</span>\n                                    </label>\n                                </div>\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"radio\"\n                                        id=\"complementary_adopted_policies_no\"\n                                        name=\"complementary_adopted_policies\"\n                                        ng-model=\"currentParkingPolicy.complementary_adopted_policies\"\n                                        ng-value=\"false\"\n                                        ng-disabled=\"formReadOnly\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"/>\n                                    <label class=\"form-check-label\" for=\"complementary_adopted_policies_no\">\n                                        <span ng-class=\"{'boldFont': currentParkingPolicy.complementary_adopted_policies === false}\">No</span>\n                                    </label>\n                                </div>\n                            </div>\n                            <div class=\"form-item col-lg-12\" style=\"padding-left: 2%;\">\n                                <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkTdmPolicyNewDev\"\n                                            ng-disabled=\"formReadOnly\"\n                                            ng-model=\"currentParkingPolicy.tdm_policy_new_dev_checked\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label class=\"form-check-label\" for=\"checkTdmPolicyNewDev\">\n                                            <span ng-class=\"{'boldFont': tdm_policy_new_dev_checked}\">TDM\n                                                Policy\n                                                for New Development:</span> require provision and enforcement of\n                                            transportation demand management (TDM).\n                                        </label>\n                                    </div>\n                                    \n                                    <div class=\"row align-items-center\"\n                                        ng-show=\"currentParkingPolicy.tdm_policy_new_dev_checked\"\n                                        style=\"padding-left: 2%; margin-top: 20px;\">\n                                        <div class=\"col-lg-7 col-md-6\">\n                                            <textarea ng-if=\"!checkSubstring(currentParkingPolicy.tdm_policy_new_dev)\" ng-model=\"currentParkingPolicy.tdm_policy_new_dev\"\n                                                id=\"tdm_policy_new_dev\" placeholder=\"Enter response or URL\" ng-disabled=\"formReadOnly\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\"\n                                                name=\"tdm_policy_new_dev\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                                            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                ng-show=\"parkingForm.tdm_policy_new_dev.$error.required && formSubmitted\">\n                                                Please provide a valid response or URL.\n                                            </div>\n                                        </div>\n                                        <!-- File Upload tdm_policy_new_dev -->\n                                        <div ng-if=\"!checkSubstring(currentParkingPolicy.tdm_policy_new_dev)\" style=\"margin-top: 5px; text-align: center; display: flex; align-items: center; justify-content: center;\" class=\"col-lg-1 col-md-1;\"><b>OR</b>\n                                        </div>\n                                        <div class=\"col-md-5\"\n                                            ng-if=\"checkSubstring(currentParkingPolicy.tdm_policy_new_dev)\"\n                                            style=\"padding-bottom:10px;\">\n                                            <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                    ng-href=\"{{currentParkingPolicy.tdm_policy_new_dev}}\">Uploaded\n                                                    Documentation</a></span>\n                                            <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                ng-click=\"removeFile('tdm_policy_new_dev')\"><i ng-show=\"fileUploading\"\n                                                    class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Remove</button>\n                                        </div>\n                                    </div>\n                                    <div class=\"row align-items-center\"\n                                        style=\"padding-bottom:20px; padding-left: 2%\"\n                                        ng-if=\"!checkSubstring(currentParkingPolicy.tdm_policy_new_dev) && currentParkingPolicy.tdm_policy_new_dev_checked\">\n                                        <div class=\"col-lg-2\"><label for=\"tdm_policy_new_dev_file_abcd\">TDM Policy\n                                                Documentation</label></div>\n                                        <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                            <input type=\"file\" ng-model=\"tdm_policy_new_dev_file_abcd\"\n                                                id=\"tdm_policy_new_dev_file_abcd\" name=\"tdm_policy_new_dev_file_abcd\"\n                                                accept=\".pdf, .doc, .docx, .xls, .xlsx\" ng-disabled=\"formReadOnly\"\n                                                onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                                        </div>\n                                        <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                            <button class=\"button button--attach\"\n                                                ng-click=\"uploadFile('tdm_policy_new_dev_file_abcd')\"><i\n                                                    ng-show=\"fileUploading_tdm_policy_new_dev_file_abcd\"\n                                                    class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Upload File</button>\n                                            <button type=\"button\" class=\"button button--clear\"\n                                                ng-click=\"clearFile('tdm_policy_new_dev_file_abcd')\">\n                                                Clear\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\"\n                                        ng-show=\"currentParkingPolicy.tdm_policy_new_dev_checked\">\n                                        <label>Additional Details (Optional):</label>\n                                        <textarea id=\"tdm_policy_new_dev_details\" name=\"tdm_policy_new_dev_details\"\n                                            rows=\"4\" style=\"width: 100%;\"\n                                            ng-model=\"currentParkingPolicy.tdm_policy_new_dev_details\" ng-disabled=\"formReadOnly\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                    </div>\n                                </div>\n\n                                <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkCurbStrategyManagement\"\n                                            ng-disabled=\"formReadOnly\"\n                                            ng-model=\"currentParkingPolicy.curb_strategy_management_checked\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label class=\"form-check-label\" for=\"checkCurbStrategyManagement\">\n                                            <span ng-class=\"{'boldFont': curb_strategy_management_checked}\">Curb\n                                                Strategy/Management: </span>Priority curb access based on variable\n                                            need.\n                                        </label>\n                                    </div>\n                                    <!-- File Upload curb_strategy_management -->\n                                    <div class=\"row align-items-center\"\n                                    ng-show=\"currentParkingPolicy.curb_strategy_management_checked\"\n                                        style=\"padding-left: 2%; margin-top: 20px\">\n                                        <div class=\"col-lg-7 col-md-6\">\n                                            <textarea\n                                                ng-if=\"!checkSubstring(currentParkingPolicy.curb_strategy_management)\"\n                                                ng-model=\" currentParkingPolicy.curb_strategy_management\" ng-disabled=\"formReadOnly\"\n                                                id=\"curb_strategy_management\" placeholder=\"Enter response or URL\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\"\n                                                name=\"curb_strategy_management\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                                            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                ng-show=\"parkingForm.curb_strategy_management.$error.required && formSubmitted\">\n                                                Please provide a valid URL.\n                                            </div>\n                                        </div>\n                                         <!-- File Upload curb_strategy_management -->\n                                        <div ng-if=\"!checkSubstring(currentParkingPolicy.curb_strategy_management)\"\n                                            style=\"margin-top: 5px; text-align: center; display: flex; align-items: center; justify-content: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b>\n                                        </div>\n                                        <div class=\"col-md-5\"\n                                        ng-if=\"checkSubstring(currentParkingPolicy.curb_strategy_management)\"\n                                            style=\"padding-bottom:10px;\">\n                                            <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                    ng-href=\"{{currentParkingPolicy.curb_strategy_management}}\">Uploaded\n                                                    Documentation</a></span>\n                                            <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                ng-click=\"removeFile('curb_strategy_management')\"><i\n                                                    ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Remove</button>\n                                        </div>\n                                    </div>\n                                    <div class=\"row align-items-center\"\n                                        style=\"padding-bottom:20px; margin-top: 10px; padding-left: 2%\"\n                                        ng-if=\"!checkSubstring(currentParkingPolicy.curb_strategy_management) && currentParkingPolicy.curb_strategy_management_checked\">\n                                        <div class=\"col-lg-2\"><label for=\"curb_strategy_management_file_abcd\">Curb\n                                                Strategy/ Management\n                                                Documentation</label></div>\n                                        <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                            <input type=\"file\" ng-model=\"curb_strategy_management_file_abcd\"\n                                                id=\"curb_strategy_management_file_abcd\"\n                                                name=\"curb_strategy_management_file_abcd\"\n                                                accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                                ng-disabled=\"formReadOnly\"\n                                                onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                                        </div>\n                                        <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                            <button class=\"button button--attach\"\n                                                ng-click=\"uploadFile('curb_strategy_management_file_abcd')\"><i\n                                                    ng-show=\"fileUploading_curb_strategy_management_file_abcd\"\n                                                    class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Upload File</button>\n                                            <button type=\"button\" class=\"button button--clear\"\n                                                ng-click=\"clearFile('curb_strategy_management_file_abcd')\">\n                                                Clear\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px;\"\n                                        ng-show=\"currentParkingPolicy.curb_strategy_management_checked\">\n                                        <label>Additional Details (Optional):</label>\n                                        <textarea id=\"curb_strategy_management_details\" ng-disabled=\"formReadOnly\"\n                                            name=\"curb_strategy_management_details\" rows=\"4\" style=\"width: 100%;\" cols=\"95\"\n                                            ng-model=\"currentParkingPolicy.curb_strategy_management_details\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                    </div>\n                                </div>\n                                <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkParkingBenefitDistrict\"\n                                            ng-disabled=\"formReadOnly\"\n                                            ng-model=\"currentParkingPolicy.parking_benefit_district_checked\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label class=\"form-check-label\" for=\"checkParkingBenefitDistrict\">\n                                            <span ng-class=\"{'boldFont': parking_benefit_district_checked}\">Parking\n                                                Benefit\n                                                District (PBD): </span>Invest parking revenues into a PBD to fund\n                                            streetscape,\n                                            safety, and TDM programs.\n                                        </label>\n                                    </div>\n                                    <div class=\"row align-items-center\"\n                                    ng-show=\"currentParkingPolicy.parking_benefit_district_checked\"\n                                        style=\"padding-left: 2%; margin-top: 20px\">\n                                        <div class=\"col-lg-7 col-md-6\">\n                                            <textarea\n                                                ng-if=\"!checkSubstring(currentParkingPolicy.parking_benefit_district)\"\n                                                ng-model=\"currentParkingPolicy.parking_benefit_district\"\n                                                id=\"parking_benefit_district_file_abcd\"\n                                                placeholder=\"Enter response or URL\"\n                                                ng-disabled=\"formReadOnly\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\"\n                                                name=\"parking_benefit_district\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                                            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                ng-show=\"parkingForm.curb_strategy_management.$error.required && formSubmitted\">\n                                                Please provide a valid response or URL.\n                                            </div>\n                                        </div>\n                                         <!-- File Upload parking_benefit_district -->\n                                        <div ng-if=\"!checkSubstring(currentParkingPolicy.parking_benefit_district)\"\n                                            style=\"margin-top: 5px; text-align: center; display: flex; align-items: center; justify-content: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b>\n                                        </div>\n                                        <div class=\"col-md-5\"\n                                            ng-if=\"checkSubstring(currentParkingPolicy.parking_benefit_district)\"\n                                            style=\"padding-bottom:10px;\">\n                                            <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                    ng-href=\"{{currentParkingPolicy.parking_benefit_district}}\">Uploaded\n                                                    Documentation</a></span>\n                                            <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                ng-click=\"removeFile('parking_benefit_district')\"><i\n                                                    ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Remove</button>\n                                        </div>\n                                    </div>\n                                    <div class=\"row align-items-center\"\n                                        style=\"padding-bottom:20px; margin-top: 10px; padding-left: 2%;\"\n                                        ng-if=\"!checkSubstring(currentParkingPolicy.parking_benefit_district) && currentParkingPolicy.parking_benefit_district_checked\">\n                                        <div class=\"col-lg-2\"><label for=\"parking_benefit_district_file_abcd\">Upload\n                                                PBD\n                                                Documentation</label></div>\n                                        <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                            <input type=\"file\" ng-model=\"parking_benefit_district_file_abcd\"\n                                                id=\"parking_benefit_district_file_abcd\"\n                                                ng-disabled=\"formReadOnly\"\n                                                name=\"parking_benefit_district_file_abcd\"\n                                                accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                                onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                                        </div>\n                                        <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                            <button class=\"button button--attach\"\n                                                ng-click=\"uploadFile('parking_benefit_district_file_abcd')\"><i\n                                                    ng-show=\"fileUploading_parking_benefit_district_file_abcd\"\n                                                    class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Upload File</button>\n                                            <button type=\"button\" class=\"button button--clear\"\n                                                ng-click=\"clearFile('parking_benefit_district_file_abcd')\">\n                                                Clear\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\"\n                                        ng-show=\"parking_benefit_district_checked\">\n                                        <label>Additional Details (Optional):</label>\n                                        <textarea id=\"parking_benefit_district_details\" ng-disabled=\"formReadOnly\"\n                                            name=\"parking_benefit_district_details\" rows=\"4\" style=\"width: 100%;\" cols=\"95\"\n                                            ng-model=\"currentParkingPolicy.parking_benefit_district_details\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                    </div>\n                                </div>\n                                <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                            id=\"checkDemandResponsivePrice\"\n                                            ng-disabled=\"formReadOnly\"\n                                            ng-model=\"currentParkingPolicy.demand_responsive_price_checked\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label class=\"form-check-label\" for=\"checkDemandResponsivePrice\">\n                                            <span\n                                                ng-class=\"{'boldFont': demand_responsive_price_checked}\">Demand-Responsive\n                                                Pricing: </span>Price parking according to level of convenience and\n                                            demand.\n                                        </label>\n                                    </div>\n                                    <!-- File Upload demand_responsive_price -->\n                                    <div class=\"row align-items-center\"\n                                    ng-show=\"currentParkingPolicy.demand_responsive_price_checked\"\n                                        style=\"margin-top: 20px; padding-left: 2%\">\n\n                                        <div class=\"col-lg-7 col-md-6\">\n                                            <textarea\n                                                ng-if=\"!checkSubstring(currentParkingPolicy.demand_responsive_price)\"\n                                                ng-model=\"currentParkingPolicy.demand_responsive_price\"\n                                                id=\"demand_responsive_price\"\n                                                ng-disabled=\"formReadOnly\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\"\n                                                name=\"demand_responsive_price\" rows=\"4\" style=\"width: 100%;\"\n                                                placeholder=\"Enter response or URL\" required>\n                  </textarea>\n                                            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                ng-show=\"parkingForm.demand_responsive_price.$error.required && formSubmitted\">\n                                                Please provide a valid response or URL.\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"!checkSubstring(currentParkingPolicy.demand_responsive_price)\"\n                                            style=\"margin-top: 5px; text-align: center; display: flex; align-items: center; justify-content: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b>\n                                        </div>\n                                        <div class=\"col-md-5\"\n                                            ng-if=\"checkSubstring(currentParkingPolicy.demand_responsive_price)\"\n                                            style=\"padding-bottom:10px;\">\n                                            <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                    ng-href=\"{{currentParkingPolicy.demand_responsive_price}}\">Uploaded\n                                                    Documentation</a></span>\n                                            <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                ng-click=\"removeFile('demand_responsive_price')\"><i\n                                                    ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Remove</button>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"row align-items-center\"\n                                    style=\"padding-bottom:20px; margin-top: 10px; padding-left: 2%\"\n                                    ng-if=\"!checkSubstring(currentParkingPolicy.demand_responsive_price) && currentParkingPolicy.demand_responsive_price_checked\">\n                                    <div class=\"col-lg-2\"><label for=\"demand_responsive_price_file_abcd\">Upload\n                                            Demand-Responsive Pricing\n                                            Documentation</label></div>\n                                    <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                        <input type=\"file\" ng-model=\"demand_responsive_price_file_abcd\"\n                                            id=\"demand_responsive_price_file_abcd\"\n                                            ng-disabled=\"formReadOnly\"\n                                            name=\"demand_responsive_price_file_abcd\"\n                                            accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                            onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                                    </div>\n                                    <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                        <button class=\"button button--attach\"\n                                            ng-click=\"uploadFile('demand_responsive_price_file_abcd')\"><i\n                                                ng-show=\"fileUploading_demand_responsive_price_file_abcd\"\n                                                class=\"fa-solid fa-cog fa-spin\"></i>\n                                            Upload File</button>\n                                        <button type=\"button\" class=\"button button--clear\"\n                                            ng-click=\"clearFile('demand_responsive_price_file_abcd')\">\n                                            Clear\n                                        </button>\n                                    </div>\n                                </div>\n                                <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\"\n                                    ng-show=\"demand_responsive_price_checked\">\n                                    <label>Additional Details (Optional):</label>\n                                    <textarea id=\"demand_responsive_price_details\" ng-disabled=\"formReadOnly\"\n                                        name=\"demand_responsive_price_details\" rows=\"4\" style=\"width: 100%;\" cols=\"95\"\n                                        ng-model=\"currentParkingPolicy.demand_responsive_price_details\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                </div>\n                                <div class=\"verification-container\">\n                                    <div class=\"form-check\">\n                                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkPricedPark\"\n                                            ng-model=\"priced_park_checked\"\n                                            ng-disabled=\"formReadOnly\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\" />\n                                        <label class=\"form-check-label\" for=\"checkPricedPark\">\n                                            <span ng-class=\"{'boldFont': priced_park_checked}\">Priced\n                                                Parking:\n                                            </span>Adding priced parking where it used to be free.\n                                        </label>\n                                    </div>\n                                    <!-- File Upload priced_park -->\n                                    <div class=\"row align-items-center\"\n                                        ng-show=\"priced_park_checked\"\n                                        style=\"padding-left: 2%; margin-top: 20px\">\n                                        <div class=\"col-lg-7 col-md-6\">\n                                            <textarea ng-if=\"!checkSubstring(currentParkingPolicy.priced_park)\"\n                                                ng-model=\"currentParkingPolicy.priced_park\" id=\"priced_park\"\n                                                placeholder=\"Enter response or URL\"\n                                                ng-disabled=\"formReadOnly\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\"\n                                                name=\"priced_park\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                                            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                ng-show=\"parkingForm.priced_park.$error.required && formSubmitted\">\n                                                Please provide a valid response or URL.\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"!checkSubstring(currentParkingPolicy.priced_park)\"\n                                            style=\"margin-top: 5px; text-align: center; display: flex; align-items: center; justify-content: center;\" class=\"col-lg-1 col-md-1\" style=\"display: flex; align-items: center; justify-content: center; height: 100px;\"><b>OR</b></div>\n                                        <div class=\"col-md-5\" ng-if=\"checkSubstring(currentParkingPolicy.priced_park)\"\n                                            style=\"padding-bottom:10px;\">\n                                            <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                                    ng-href=\"{{currentParkingPolicy.priced_park}}\">Uploaded\n                                                    Documentation</a></span>\n                                            <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                                                ng-click=\"removeFile('priced_park')\"><i ng-show=\"fileUploading\"\n                                                    class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Remove</button>\n                                        </div>\n                                    </div>\n                                    <div class=\"row align-items-center\"\n                                        style=\"margin-top: 20px; padding-bottom:20px; padding-left: 2%\"\n                                        ng-if=\"!checkSubstring(currentParkingPolicy.priced_park) && priced_park_checked\">\n                                        <div class=\"col-lg-2\"><label for=\"priced_park_file_abcd\">Upload Priced\n                                                Parking\n                                                Documentation</label></div>\n                                        <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                            <input type=\"file\" ng-model=\"priced_park_file_abcd\"\n                                                ng-disabled=\"formReadOnly\"\n                                                id=\"priced_park_file_abcd\" name=\"priced_park_file_abcd\"\n                                                accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                                onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                                        </div>\n                                        <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                            <button class=\"button button--attach\"\n                                                ng-click=\"uploadFile('priced_park_file_abcd')\"><i\n                                                    ng-show=\"fileUploading_priced_park_file_abcd\"\n                                                    class=\"fa-solid fa-cog fa-spin\"></i>\n                                                Upload File</button>\n                                            <button type=\"button\" class=\"button button--clear\"\n                                                ng-click=\"clearFile('priced_park_file_abcd')\">\n                                                Clear\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\"\n                                        ng-show=\"priced_park_checked\">\n                                        <label>Additional Details (Optional):</label>\n                                        <textarea id=\"priced_park_details\" name=\"priced_park_details\" rows=\"4\" style=\"width: 100%;\" cols=\"85\"\n                                            ng-model=\"currentParkingPolicy.priced_park_details\" ng-disabled=\"formReadOnly\"\n                                            onchange=\"angular.element(this).scope().setPending(this)\">\n                        </textarea>\n                                    </div>\n                                </div>\n                            </div>\n                            <submissionsectionsubmit></submissionsectionsubmit>\n                        </form>\n                    </div>\n                    <!-- Review and submit  -->\n                    <div id=\"section-review-submit\" role=\"tabpanel\" class=\"section tab-pane\"\n                        ng-class=\"{'active show': reviewAndSubmit}\">\n                        <h2>Review and Submit</h2>\n                        <p>\n                            <span style=\"font-style: italic\">\n                                Select policies below to submit to MTC for review.</span>\n                        </p>\n\n                        <form class=\"row test-validation-styling\" novalidate style=\"margin-left: 2px\">\n                            <!-- Unbundled Parking  -->\n                            <div class=\"verification-container\">\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"unbundledParkCheck\"\n                                        ng-model=\"parking.unbundledParkCheck\"\n                                        ng-checked=\"unbundledParkCheck\"\n                                        ng-click=\"addToSubmissions('unbundledParking')\"\n                                        ng-disabled=\"checkParking1 && checkParking1.submitted === true\" />\n                                    <label class=\"form-check-label\" for=\"unbundledParkCheck\"\n                                        ng-class=\"{'boldFont': parking.unbundledParkCheck}\">\n                                        Unbundled Parking\n                                        <span ng-if=\"checkParking1 && checkParking1.submitted === true\"\n      class=\"badge badge--submitted\">Submitted</span>\n                                    </label>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"parking.unbundledParkCheck\">\n                                    <p>\n                                        I have completed the\n                                        <a href=\"#\" ng-click=\"togglePanel('unbundledParking')\">Compliance with MTC's\n                                            Unbundled Parking Section</a>\n                                        and uploaded any relevant documentation.\n                                    </p>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"unbundledParking[0].submitted\">\n                                    <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                                        <div class=\"col\">\n                                            <div class=\"alert alert-success fade show\" role=\"alert\">\n                                                This policy has been submitted and is under review.\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <!-- Shared Parking  -->\n                            <div class=\"verification-container\">\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"sharedParkCheck\"\n                                        ng-model=\"parking.sharedParkCheck\" ng-click=\"addToSubmissions('sharedParking')\"\n                                        ng-disabled=\"checkParking2 && checkParking2.submitted === true\" \n                                        ng-checked=\"sharedParkCheck\"/>\n                                    <label class=\"form-check-label\" for=\"sharedParkCheck\"\n                                        ng-class=\"{'boldFont': parking.sharedParkCheck}\">\n                                        Shared Parking\n                                        <span ng-if=\"checkParking2 && checkParking2.submitted === true\"\n      class=\"badge badge--submitted\">Submitted</span>\n                                    </label>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"parking.sharedParkCheck\">\n                                    <p>\n                                        I have completed the\n                                        <a href=\"#\" ng-click=\"togglePanel('sharedParking')\">Compliance with MTC's\n                                            Shared Parking Section</a>\n                                        and uploaded any relevant documentation.\n                                    </p>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"sharedParking[0].submitted\">\n                                    <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                                        <div class=\"col\">\n                                            <div class=\"alert alert-success fade show\" role=\"alert\">\n                                                This policy has been submitted and is under review.\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <!-- Complementary Parking Management -->\n                            <div class=\"verification-container\">\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"complementaryParkCheck\"\n                                        ng-model=\"parking.complementaryParkCheck\"\n                                        ng-click=\"addToSubmissions('complementaryParking')\"\n                                        ng-disabled=\"checkParking3 && checkParking3.submitted === true\"\n                                        ng-checked=\"complementaryParkCheck\" />\n                                    <label class=\"form-check-label\" for=\"complementaryParkCheck\"\n                                        ng-class=\"{'boldFont': parking.complementaryParkCheck}\">\n                                        Complementary Parking Management\n                                        <span ng-if=\"checkParking3 && checkParking3.submitted === true\"\n                                        class=\"badge badge--submitted\">Submitted</span>\n                                    </label>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"parking.complementaryParkCheck\">\n                                    <p>\n                                        I have completed the\n                                        <a href=\"#\" ng-click=\"togglePanel('complementaryParking')\">Compliance with\n                                            MTC's\n                                            Complementary Parking Management Section</a>\n                                        and uploaded any relevant documentation.\n                                    </p>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"complementaryParking[0].submitted\">\n                                    <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                                        <div class=\"col\">\n                                            <div class=\"alert alert-success fade show\" role=\"alert\">\n                                                This policy has been submitted and is under review.\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </form>\n                        <submissionsectionsubmit></submissionsectionsubmit>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n    <div class=\"footer\" role=\"contentinfo\">\n        <sidebarfooter></sidebarfooter>\n    </div>\n    </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BicycleParkingComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bicycle_parking = __webpack_require__(110);
	
	var _bicycle_parking2 = _interopRequireDefault(_bicycle_parking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var BicycleParkingComponent = exports.BicycleParkingComponent = function () {
	  /*@ngInject*/
	  function BicycleParkingComponent($state, $scope, $rootScope, fetch, lookup, userService, $timeout, baseConfigService, $http, $stateParams) {
	    _classCallCheck(this, BicycleParkingComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$stateParams = $stateParams;
	    this.userService = userService;
	    this.$timeout = $timeout;
	    this.$http = $http;
	    this.baseConfigService = baseConfigService;
	
	    $scope.adminUnlocked = false;
	    $scope.policy_name = 'Bicycle Parking Minimum';
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.submissions = [];
	    $scope.savemode = null;
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.bicycleParkingMinimum = false;
	    $scope.initialLoad = true;
	    $scope.parking = {};
	    $scope.submitmode = null;
	
	    $scope.pendingChanges = false;
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.setPending = function () {
	      console.log('set pending ran');
	      console.log($scope.initialLoad);
	      if (!$scope.initialLoad) {
	        $scope.savemode = 'parking';
	        $scope.pendingChanges = true;
	      }
	    };
	
	    $scope.getStationTier = function (station) {
	      if (station) {
	        $scope.loadingData = true;
	      }
	      fetch.getItem('api/data/parking/station-tiers/' + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	        $scope.currentStation = response.data[0];
	        $scope.loadingData = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentParkingPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.parkingStatus) {
	        for (var i = 0; i < $scope.parkingStatus.length; i++) {
	          if ($scope.parkingStatus[i].submission_policy_name === $scope.currentParkingPolicy.policy_name) {
	            submission = $scope.parkingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentParkingPolicy;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.parkingStatus && $scope.policy_name) {
	        var sub = _.find($scope.parkingStatus, { submission_policy_name: $scope.policy_name });
	        if (sub && sub.submitted && sub.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('parkingStatus', function () {
	      if (!$scope.currentParkingPolicy) return;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm('Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.');
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.parkingStatus) {
	        for (var i = 0; i < $scope.parkingStatus.length; i++) {
	          if ($scope.parkingStatus[i].submission_policy_name === $scope.policy_name) {
	            submission = $scope.parkingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error('No matching submission found to withdraw');
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', payload).then(function () {
	        submission.submitted = false;
	        submission.status = null;
	
	        if ($scope.checkParking && $scope.checkParking.submission_id === submission.submission_id) {
	          $scope.checkParking = null;
	          $scope.bicycleParkingMinCheck = false;
	          $scope.parking.bicycleParkingMinCheck = false;
	          if ($scope.bicycleParkingMinimum) {
	            $scope.bicycleParkingMinimum.forEach(function (el) {
	              el.submitted = false;
	            });
	          }
	        };
	
	        $scope.formReadOnly = false;
	
	        var formId = $scope.currentParkingPolicy ? $scope.currentParkingPolicy.parking_form_id : null;
	        $scope.currentParkingPolicy = { parking_form_id: formId };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	      }).catch(function (err) {
	        console.error('Withdraw failed:', err);
	        alert('There was an error withdrawing the submission. Please try again.');
	      });
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'parking';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Parking').then(function (response) {
	        $scope.parkingStatus = response.data;
	        console.log('Parking status response:', response.data);
	        $scope.checkParking = _.filter(response.data, { submission_policy_name: 'Bicycle Parking Minimum', submitted: true })[0];
	
	        console.log('Loaded policy submissions:', $scope.parkingStatus);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	      $scope.getSubmissionStatus();
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Parking').then(function (response) {
	
	        $scope.currentStation = response.data[0];
	
	        $scope.complementaryParking = _.filter(response.data, { submission_policy_name: 'Complementary Parking Management Policy' });
	        if ($scope.complementaryParking.length > 0) {
	          $scope.complementaryParking.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.complementaryParkCheck = true;
	            }
	          });
	        }
	        $scope.unbundledParking = _.filter(response.data, { submission_policy_name: 'Unbundled Parking' });
	        if ($scope.unbundledParking.length > 0) {
	          $scope.unbundledParking.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.unbundledParkCheck = true;
	            }
	          });
	        }
	        $scope.sharedParking = _.filter(response.data, { submission_policy_name: 'Shared Parking' });
	        if ($scope.sharedParking.length > 0) {
	          $scope.sharedParking.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.sharedParkCheck = true;
	            }
	          });
	        }
	        $scope.vehicleParkingMaximum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Maximum' });
	        if ($scope.vehicleParkingMaximum.length > 0) {
	          $scope.vehicleParkingMaximum.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.vehicleParkingMaxCheck = true;
	            }
	          });
	        }
	        $scope.vehicleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Vehicle Parking Minimum' });
	        if ($scope.vehicleParkingMinimum.length > 0) {
	          $scope.vehicleParkingMinimum.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.vehicleParkingMinCheck = true;
	            }
	          });
	        }
	        $scope.bicycleParkingMinimum = _.filter(response.data, { submission_policy_name: 'Bicycle Parking Minimum' });
	        if ($scope.bicycleParkingMinimum.length > 0) {
	          $scope.bicycleParkingMinimum.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.bicycleParkingMinCheck = true;
	            }
	          });
	        }
	        $scope.getStationTier($scope.currentSelectedStationId);
	        return $scope.getCurrentParkingPolicy($scope.policy_name);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getCurrentParkingPolicy = function (policy_name) {
	      if (policy_name) {
	        $scope.policy_name = policy_name;
	      }
	      fetch.getAllItems('api/data/getParkingForm/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + encodeURIComponent($scope.policy_name)).then(function (response) {
	
	        $scope.currentParkingPolicy = response.data[0];
	
	        console.log('parking_form_id:', $scope.currentParkingPolicy.parking_form_id);
	        $scope.initialLoad = false;
	        console.log($scope.initialLoad);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentParkingPolicy = function () {
	      $scope.formSubmitted = true;
	      if ($scope.parkingForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      Object.keys($scope.currentParkingPolicy).forEach(function (key) {
	        if ($scope.currentParkingPolicy[key] === "" || $scope.currentParkingPolicy[key] === undefined) {
	          $scope.currentParkingPolicy[key] = null;
	        }
	      });
	
	      $scope.currentParkingPolicy.parking_form_id = $scope.currentParkingPolicy.parking_form_id;
	
	      console.log("Payload being sent:", $scope.currentParkingPolicy);
	
	      fetch.updateItem('api/data/parking/forms/update', $scope.currentParkingPolicy).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.saved = false;
	          $scope.savemode = null;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.submitParking = function () {
	      console.log($scope.parking.bicycleParkingMinCheck);
	      $scope.formSubmitted = true;
	      $scope.saving = true;
	      var upsertData = [];
	
	      $scope.upsertData = [];
	
	      if ($scope.parking.complementaryParkCheck && $scope.complementaryParking.length > 0) {
	        $scope.complementaryParking.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              complementary_parking_management: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.unbundledParkCheck && $scope.unbundledParking.length > 0) {
	        $scope.unbundledParking.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              unbundled_parking: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.sharedParkCheck && $scope.sharedParking.length > 0) {
	        $scope.sharedParking.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              shared_parking: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.vehicleParkingMaxCheck && $scope.VehicleParkingMaximum.length > 0) {
	        $scope.VehicleParkingMaximum.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              vehicle_parking_maximum: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.vehicleParkingMinCheck && $scope.vehicleParkingMinimum.length > 0) {
	        $scope.vehicleParkingMinimum.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              vehicle_parking_minimum: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.parking.bicycleParkingMinCheck && $scope.bicycleParkingMinimum.length > 0) {
	        $scope.bicycleParkingMinimum.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              bicycle_parking_minimum: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saving = false;
	        $scope.submissions = [];
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        $scope.getSubmissionStatus();
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 2000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        }
	
	        if ($scope.currentSelectedStationId) {
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById('fileInput' + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
	            alert('Please select a PDF, Word document, or Excel file.');
	            element.value = '';
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById('' + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope[ngmodel] = '';
	        $scope[ngmodel + '_preview'] = '';
	        $scope['fileUploading_' + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope['fileUploading_' + ngmodelfile] = true;
	      var file = document.getElementById('' + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentParkingPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentParkingPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'parking';
	      $scope.pendingChanges = true;
	    };
	  }
	
	  _createClass(BicycleParkingComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.submissionActivity = [];
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.currentParkingPolicy = {};
	        return _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return BicycleParkingComponent;
	}();
	
	exports.default = angular.module('appApp.bicycle_parking', [uiRouter]).config(_bicycle_parking2.default).component('bicycleParking', {
	  template: __webpack_require__(111),
	  controller: BicycleParkingComponent,
	  controllerAs: 'bicycleParkingCtrl'
	}).name;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('bicycle_parking', {
	    url: '/account/parking/bicycle_parking?jurisdiction&sta_recid',
	    template: '<bicycle-parking></bicycle-parking>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null
	    }
	  });
	};

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n    <div class=\"page-wrapper\">\n        <div class=\"dashboard-header\">\n            <sidebarnav></sidebarnav>\n        </div>\n\n        <div class=\"main\">\n            <mainheaderauth></mainheaderauth>\n            <maintocselection />\n\n            <div class=\"content container\">\n                <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n                <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n                <div class=\"row mb-5\" style=\"padding-top:20px;\" ng-show=\"currentSelectedStationId\">\n                    <div class=\"col\">\n                        <h3 class=\"mb-2\">\n                            {{currentStation.station_name}}: Tier Level {{currentStation.service_tier}}\n                            <i class=\"fa-solid fa-chart-simple\"></i>\n                        </h3>\n                        <table class=\"table table--data-table\">\n                            <thead class=\"table-dark\">\n                                <tr>\n                                    <th>\n                                        <div class=\"th-inner\">Minimum Bicycle Parking Standards</div>\n                                    </th>\n                                    <th>\n                                        <div class=\"th-inner\">\n                                            TOC Policy Standards\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr>\n                                    <td>Secured Bicycle Parking for New Residential Uses</td>\n                                    <td>\n                                        <span ng-if=\"!loading\"><span> 1 per unit</span>\n                                        </span>\n                                        <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                                                style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                                    </td>\n                                </tr>\n                                <tr>\n                                    <td>Secured Bicycle Parking for New Office Uses</td>\n                                    <td><span ng-if=\"!loading\">1 per 5,000 occupied s.f.</span>\n                                        <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                                                style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                        <p>\n                            <span style=\"font-weight: bold;\">Note:</span> For parcels on which both residential and\n                            commercial development are allowed, the\n                            standard is at least the sum of one secure bicycle parking space per dwelling unit plus one\n                            secure bicycle parking space per 5,000 occupied square feet for <span\n                                class=\"bold-text\">commercial office</span>.\n                        </p>\n                        <p>\n                            A local jurisdiction must provide municipal code citations for an adopted overlay zone or\n                            parking use table/chapter that clearly demonstrate that the minimum bicycle parking\n                            standards for residential and commercial office uses meet TOC thresholds for, at minimum,\n                            the entire ½-mile TOC area.\n                        </p>\n                        <p>\n                            Secured bicycle parking should follow the Association of Pedestrian and Bicycle\n                            Professionals’ <a href=\"https://www.apbp.org/assets/docs/EssentialsofBikeParking_FINA.pdf\"\n                                target=\"_blank\" rel=\"noopener noreferrer\">Essentials of Bike Parking Guidelines</a> as well as HCD’s forthcoming\n                            update to\n                            the California Green Building Standards Code, per AB 2863 (2022).\n                        </p>\n\n                        <p class=\"italics\"><span class=\"bold-text\">Note:</span> For a single building with more than 100 units, the jurisdiction can apply a ratio of one secure bicycle parking space for every four units to the number of units above 100. For example, a 140-unit building would need 110 bicycle parking spaces (100 + 0.25*40). Additionally, the jurisdiction can exempt developments with fewer than 10 units from bicycle parking requirements. \n                        </p>\n                    </div>\n                </div>\n\n                <div class=\"section-nav\">\n                    <div class=\"menu--section-title\">In this section:</div>\n                    <ul class=\"menu menu--section\" role=\"tablist\">\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\" class=\"menu-item menu-item--section active\"\n                            ng-click=\"getCurrentParkingPolicy('Bicycle Parking Minimum')\">\n                            <span class=\"section-number\">I.</span>\n                            <a href=\"#\">Minimum Bicycle Parking Standards</a>\n                        </li>\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit\"\n                            class=\"menu-item menu-item--section\" ng-click=\"reviewAndSubmit\">\n                            <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n                        </li>\n                    </ul>\n                    <note ng-show=\"note\"></note>\n                    <furtherguidance></furtherguidance>\n                </div>\n                <div class=\"tab-content\">\n                    <!-- Minimum Bicycle Parking Standards Section -->\n                    <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\"\n                        ng-class=\"{'active show': showPanel === 'bicycleParkingMinimum'}\">\n                        <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Minimum Bicycle Parking Standards</h2>\n              <statuspills ng-repeat=\"submission in parkingStatus\" ng-if=\"submission.submission_policy_name === currentParkingPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, submitted: true})[0] && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(parkingStatus | filter:{submission_policy_name: currentParkingPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n                        <form class=\"row test-validation-styling\" name=\"parkingForm\" novalidate>\n                            <div class=\"form-item col-lg-8\">\n                                <label for=\"bicycle_park_overlay_zone_municipal\">Municipal code citation(s) for adopted\n                                    overlay zone or parking use table/chapter for minimum bicycle parking\n                                    standards:</label>\n                                <textarea\n                                    ng-if=\"!checkSubstring(currentParkingPolicy.bicycle_park_overlay_zone_municipal)\"\n                                    ng-model=\"currentParkingPolicy.bicycle_park_overlay_zone_municipal\"\n                                    id=\"bicycle_park_overlay_zone_municipal\"\n                                    ng-disabled=\"formReadOnly\"\n                                    onchange=\"angular.element(this).scope().setPending(this)\"\n                                    name=\"bicycle_park_overlay_zone_municipal\" rows=\"4\" style=\"width: 100%;\"cols=\"63\"\n                                    placeholder=\"Enter response or URL\" required>\n                  </textarea>\n                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                    ng-show=\"parkingForm.bicycle_park_overlay_zone_municipal.$error.required && formSubmitted\">\n                                    Please provide a valid response or\n                                    URL.</div>\n                            </div>\n                            <!-- File Upload bicycle_park_overlay_zone_municipal -->\n                            <div ng-if=\"!checkSubstring(currentParkingPolicy.bicycle_park_overlay_zone_municipal)\"\n                                style=\"margin-top: 80px\" class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n                            <div class=\"col-md-5\"\n                                ng-if=\"checkSubstring(currentParkingPolicy.bicycle_park_overlay_zone_municipal)\"\n                                style=\"padding-bottom:10px;\">\n                                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                        ng-href=\"{{currentParkingPolicy.bicycle_park_overlay_zone_municipal}}\">Uploaded\n                                        Documentation</a></span>\n                                <button class=\"button button--attach\" ng-if=\"!formReadOnly\"\n                                    ng-click=\"removeFile('bicycle_park_overlay_zone_municipal')\"><i\n                                        ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                    Remove</button>\n                            </div>\n                            <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                                ng-if=\"!checkSubstring(currentParkingPolicy.bicycle_park_overlay_zone_municipal)\">\n                                <div class=\"col-lg-2\"><label\n                                        for=\"bicycle_park_overlay_zone_municipal_file_abcd\">Municipal\n                                        Code\n                                        Citation\n                                        Documentation</label></div>\n                                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                    <input type=\"file\" ng-model=\"bicycle_park_overlay_zone_municipal_file_abcd\"\n                                        id=\"bicycle_park_overlay_zone_municipal_file_abcd\"\n                                        name=\"bicycle_park_overlay_zone_municipal_file_abcd\"\n                                        accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\" />\n                                </div>\n                                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                                    <button class=\"button button--attach\"\n                                        ng-click=\"uploadFile('bicycle_park_overlay_zone_municipal_file_abcd')\"><i\n                                            ng-show=\"fileUploading_bicycle_park_overlay_zone_municipal_file_abcd\"\n                                            class=\"fa-solid fa-cog fa-spin\"></i>\n                                        Upload File</button>\n                                    <button type=\"button\" class=\"button button--clear\"\n                                        ng-click=\"clearFile('bicycle_park_overlay_zone_municipal_file_abcd')\">\n                                        Clear\n                                    </button>\n                                </div>\n                            </div>\n                            <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                                <label>Additional Details (Optional):</label>\n                                <textarea id=\"bicycle_park_overlay_zone_municipal_details\"\n                                    name=\"bicycle_park_overlay_zone_municipal_details\" rows=\"4\" style=\"width: 100%;\" cols=\"93\"\n                                    ng-model=\"currentParkingPolicy.bicycle_park_overlay_zone_municipal_details\" ng-disabled=\"formReadOnly\"\n                                    onchange=\"angular.element(this).scope().setPending(this)\">\n                    </textarea>\n                            </div>\n                            <submissionsectionsubmit></submissionsectionsubmit>\n                        </form>\n                    </div>\n                    <!-- Review and submit  -->\n                    <div id=\"section-review-submit\" role=\"tabpanel\" class=\"section tab-pane\"\n                        ng-class=\"{'active show': reviewAndSubmit}\">\n                        <h2>Review and Submit</h2>\n                        <p>\n                            <span style=\"font-style: italic\">\n                                Select policies below to submit to MTC for review.</span>\n                        </p>\n\n                        <form class=\"row test-validation-styling\" novalidate style=\"margin-left: 2px\">\n                            <!-- Review & Submit  -->\n                            <div class=\"verification-container\">\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"bicycleParkingMinCheck\"\n                                        ng-model=\"parking.bicycleParkingMinCheck\"\n                                        ng-click=\"addToSubmissions('bicycleParkingMinimum')\"\n                                        ng-disabled=\"bicycleParkingMinCheck === true\"\n                                        ng-checked=\"bicycleParkingMinCheck\" />\n                                    <label class=\"form-check-label\" for=\"bicycleParkingMinCheck\"\n                                        ng-class=\"{'boldFont': parking.bicycleParkingMinCheck}\">\n                                        Minimum Bicycle Parking\n                                        <span ng-if=\"bicycleParkingMinCheck === true\"\n      class=\"badge badge--submitted\">Submitted</span>\n                                    </label>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"parking.bicycleParkingMinCheck\">\n                                    <p>\n                                        I have completed the\n                                        <a href=\"#\" ng-click=\"togglePanel('bicycleParkingMinimum')\">compliance with\n                                            MTC's\n                                            Minimum Bicycle Parking section</a>\n                                        and uploaded any relevant documentation\n                                    </p>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"bicycleParkingMinimum[0].submitted\">\n                                    <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                                        <div class=\"col\">\n                                            <div class=\"alert alert-success fade show\" role=\"alert\">\n                                                This policy has been submitted and is under review.\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </form>\n                        <submissionsectionsubmit></submissionsectionsubmit>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter></sidebarfooter>\n        </div>\n    </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DataComponent = undefined;
	
	var _data = __webpack_require__(113);
	
	var _data2 = _interopRequireDefault(_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var DataComponent =
	/*@ngInject*/
	exports.DataComponent = function DataComponent() {
	  _classCallCheck(this, DataComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.data', [uiRouter]).config(_data2.default).component('data', {
	  template: __webpack_require__(114),
	  controller: DataComponent,
	  controllerAs: 'dataCtrl'
	}).name;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('data', {
	    url: '/account/data',
	    template: '<data></data>'
	  });
	};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = "<div>This is the data view.</div>\n"

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MapComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(116);
	
	var _map = __webpack_require__(117);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var MapComponent = exports.MapComponent = function () {
	  /*@ngInject*/
	  function MapComponent($state, $scope, navService, fetch, $http, mapService, userService, lookup, $stateParams) {
	    _classCallCheck(this, MapComponent);
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$state = $state;
	    this.navService = navService;
	    this.mapService = mapService;
	    this.userService = userService;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$stateParams = $stateParams;
	
	    $scope.selectedRecordDetails = [];
	    $scope.selectedRecords = [];
	    $scope.filter = {};
	    $scope.parcels = {};
	    $scope.basemap = {};
	    $scope.saved = false;
	    $scope.saving = false;
	    $scope.showParcelDetailsPanel = false;
	    $scope.tabPanelTypes = [{
	      tab: 'filters',
	      name: 'Filters',
	      active: false,
	      icon: 'fa-filter'
	    }, {
	      tab: 'basemap',
	      name: 'Basemap',
	      active: false,
	      icon: 'fa-grid-2'
	    }, {
	      tab: 'legend',
	      name: 'Legend',
	      active: false,
	      icon: 'fa-list'
	    }, {
	      tab: 'layers',
	      name: 'Layers',
	      active: false,
	      icon: 'fa-layer-group'
	    }];
	
	    $scope.getStationbyID = function (stationId) {
	      console.log($scope.filter);
	      if (stationId) {
	        $scope.currentSelectedStationId = stationId;
	      } else if ($scope.filter.station_name) {
	        $scope.currentSelectedStationId = _.filter($scope.stationAreas, { station_name: $scope.filter.station_name })[0].sta_recid;
	      }
	
	      $scope.updateMap();
	      lookup.setCurrentStation($scope.currentSelectedStationId);
	
	      $scope.loading = true;
	
	      setTimeout(function () {
	        fetch.getItem('api/data/density/averages/' + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	          $scope.currentStation = response.data[0];
	          $scope.loading = false;
	        }).catch(function (err) {
	          console.log(err);
	          if (err.status === 403) {
	            $state.go('login');
	          }
	        });
	      }, 2000);
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      console.log(jurisdiction);
	      if (jurisdiction) {
	        $scope.currentJurisdiction = jurisdiction;
	        lookup.setJurisdiction(jurisdiction);
	      }
	
	      $scope.getZoningCodes($scope.currentJurisdiction);
	
	      fetch.getAllItems('api/data/stationareas/' + $scope.currentJurisdiction).then(function (response) {
	        $scope.stationAreas = response.data;
	        if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	          $scope.filter.station_name = _.filter($scope.stationAreas, { sta_recid: $scope.currentSelectedStationId })[0].station_name;
	        } else {
	          $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
	          $scope.filter.station_name = $scope.stationAreas[0].station_name;
	        }
	
	        lookup.setCurrentStation($scope.currentSelectedStationId);
	        if (!$scope.map) {
	          $scope.loadMap();
	        }
	        $scope.zoomToStation($scope.filter.station_name);
	        $scope.getStationbyID($scope.currentSelectedStationId);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.downloadShapefile = function () {
	      var downloadUrl = 'https://mtcdrive.box.com/s/131xc8gotpkdyfa8nvrtq0oq3qgubkr6';
	
	      window.location.href = downloadUrl;
	    };
	
	    $scope.escapeCSVValue = function (value) {
	      if (value == null) return '';
	      value = value.toString();
	
	      if (value.includes(',') || value.includes('"') || value.includes('\n')) {
	        value = '"' + value.replace(/"/g, '""') + '"';
	      }
	
	      return value;
	    };
	
	    $scope.downloadParcelData = function () {
	      var headers = ['Jurisdiction ID', 'Jurisdiction', 'County ID', 'County Name', 'Station ID', 'APN', 'Acres Within Station Area', 'Total Parcels Area', 'Zone Code', 'Zone Description', 'TOC Min DUA', 'TOC Max DUA', 'TOC Min FAR', 'TOC Max FAR', 'Allows Commercial Office', 'Allows Residential'];
	      var keys = ['jurisdiction_id', 'jurisdiction', 'county_id', 'county_name', 'sta_recid', 'apn', 'acres_within_station_area', 'total_parcels_area', 'zn_code', 'zn_description', 'toc_min_dua', 'toc_max_dua', 'toc_min_far', 'toc_max_far', 'allows_comm_office', 'allows_residential'];
	
	      fetch.getAllItems('api/data/parcelsData/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId).then(function (response) {
	        var data = response.data;
	        console.log(data);
	
	        var csv = '';
	        csv += headers.join(',') + '\n';
	
	        data.forEach(function (row) {
	          var rowValues = keys.map(function (key) {
	            return $scope.escapeCSVValue(row[key]);
	          });
	          csv += rowValues.join(',') + '\n';
	        });
	
	        var filename = prompt("Enter a filename for the CSV file:", 'parcels_data_' + $scope.currentJurisdiction + '.csv');
	        if (filename === null) return;
	
	        var link = document.createElement('a');
	        link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
	        link.download = filename;
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	      }).catch(function (error) {
	        console.error('Error exporting CSV:', error);
	        alert('There was a problem exporting the data. Please try again.');
	      });
	    };
	
	    $scope.loadMap = function () {
	      var map;
	
	      var selectedRecords = [];
	      var selectedRecordDetails = [];
	      var loadMapLayers = function loadMapLayers(map) {
	        map.target.addSource("parcelsSource", {
	          type: "vector",
	          url: "mapbox://mtc-basis.toc_parcels_v24d" });
	
	        map.target.addSource("stationAreaLayerSource", {
	          type: "geojson",
	          data: stationAreasGeojson
	        });
	
	        map.target.addSource("jurisdictionBoundarySource", {
	          type: "geojson",
	          data: placesGeoJSON
	        });
	
	        if (!map.target.getLayer("parcels")) {
	          map.target.addLayer({
	            id: "parcels",
	            type: "fill",
	            source: "parcelsSource",
	            "source-layer": "toc_parcels_v24d",
	            'paint': {
	              "fill-outline-color": "black",
	              'fill-color': "white",
	              'fill-opacity': 0.5
	            }
	
	          });
	        }
	
	        if (!map.target.getLayer("stationAreaLayer")) {
	          map.target.addLayer({
	            id: "stationAreaLayer",
	            type: "fill",
	            source: "stationAreaLayerSource",
	            'paint': {
	              "fill-outline-color": "white",
	              'fill-color': {
	                'property': 'service_tier',
	                'type': 'categorical',
	                'stops': [[1, 'yellow'], [2, 'green'], [3, 'red'], [4, 'purple']],
	                'default': 'white'
	              },
	              'fill-opacity': 0.5
	            },
	            'layout': {
	              'visibility': 'visible'
	            }
	
	          }, 'parcels');
	        }
	
	        if (!map.target.getLayer("jurisdiction-boundary")) {
	          map.target.addLayer({
	            id: "jurisdiction-boundary",
	            type: "line",
	            source: "jurisdictionBoundarySource",
	            paint: {
	              "line-color": "black",
	              "line-width": 2
	            },
	            'layout': {
	              'visibility': "visible" },
	            filter: ["in", "NAME", ""]
	          });
	        }
	
	        if (!map.target.getLayer("parcels-highlighted")) {
	          map.target.addLayer({
	            id: "parcels-highlighted",
	            type: "fill",
	            source: "parcelsSource",
	            "source-layer": "toc_parcels_v24d",
	            paint: {
	              "fill-outline-color": "darkgray",
	              "fill-color": "#00fffa",
	              "fill-opacity": 0.75
	            },
	            filter: ["in", "parcel_id", ""]
	          });
	        }
	
	        fetch.getAllItems('api/data/excludedparcels/' + $scope.currentJurisdiction).then(function (response) {
	
	          var array1 = ['in', 'parcel_id'];
	          var array2 = response.data;
	
	          var array3 = array1.concat(array2);
	
	          if (!map.target.getLayer("parcels-excluded")) {
	            map.target.addLayer({
	              id: "parcels-excluded",
	              type: "fill",
	              source: "parcelsSource",
	              "source-layer": "toc_parcels_v24d",
	              paint: {
	                "fill-outline-color": "white",
	                "fill-color": "#000444",
	                "fill-opacity": 0.75
	              },
	              filter: array3
	            }, 'parcels');
	          }
	        }).catch(function (err) {
	          console.log(err);
	          if (err.status === 403) {
	            $state.go('login');
	          }
	        });
	
	        if (!map.target.getLayer("parcel-selected")) {
	          map.target.addLayer({
	            id: "parcel-selected",
	            type: "line",
	            source: "parcelsSource",
	            "source-layer": "toc_parcels_v24d",
	            'paint': {
	              'line-color': '#888',
	              'line-width': 6
	            },
	            filter: ["in", "parcel_id", ""]
	          });
	        }
	
	        $scope.mapLayers.forEach(function (element) {
	          if (element.name === 'countyLayer') {
	            map.target.addSource(element.name + 'Source', {
	              type: 'geojson',
	
	              data: element.url
	            });
	
	            map.target.addLayer({
	              id: element.name,
	              type: "line",
	              source: element.name + 'Source',
	              paint: element.paint,
	              'layout': {
	                'visibility': 'none'
	              }
	            });
	          }
	        }, "parcels");
	      };
	
	
	      var updateInfoBox = this.updateInfoBox;
	
	      mapboxgl.accessToken = "pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNranVpYWNqeTFtMHEyeXRjdjFnN2lldTUifQ.09JACeDB27_PEaebVWA9rA";
	      map = new mapboxgl.Map({
	        container: "map",
	        style: "mapbox://styles/mapbox/light-v10",
	        zoom: 9,
	        center: [-122.275051, 37.796966] });
	
	      map.addControl(new MapboxGeocoder({
	        accessToken: mapboxgl.accessToken,
	
	        countries: "us",
	
	        filter: function filter(item) {
	          return item.context.map(function (i) {
	            return i.id.split(".").shift() === "region" && i.text === "California";
	          }).reduce(function (acc, cur) {
	            return acc || cur;
	          });
	        },
	        mapboxgl: mapboxgl
	      }));
	
	      map.addControl(new mapboxgl.NavigationControl());
	
	      map.boxZoom.disable();
	
	      var canvas = map.getCanvasContainer();
	
	      var start;
	
	      var current;
	
	      var box;
	      var draw = new MapboxDraw({
	        displayControlsDefault: false,
	        controls: {
	          polygon: false,
	          trash: false
	        }
	      });
	      map.addControl(draw);
	
	      map.on("click", "parcels", function (e) {
	        var coordinates = e.lngLat;
	        selectedRecords = $scope.selectedRecords;
	        selectedRecordDetails = $scope.selectedRecordDetails;
	
	        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
	          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
	        }
	
	        var bbox = [[e.point.x - 5, e.point.y - 5], [e.point.x + 5, e.point.y + 5]];
	        var features = map.queryRenderedFeatures(bbox, {
	          layers: ["parcels"]
	        });
	
	        var feature = features[0];
	
	
	        var checkParcelId = feature.properties.parcel_id;
	        var checkIndex = selectedRecords.indexOf(checkParcelId);
	        var checkIndexDetails = selectedRecordDetails.indexOf(checkParcelId);
	
	        if (checkIndex > -1) {
	          selectedRecords.splice(checkIndex, 1);
	          selectedRecordDetails.splice(checkIndexDetails, 1);
	        } else {
	          selectedRecords.push(feature.properties.parcel_id);
	          console.log(selectedRecords);
	          feature.properties.selected = true;
	          var parcelDetails = {};
	          fetch.getItem('api/data/parcels', features[0].properties.parcel_id).then(function (response) {
	            parcelDetails = response.data[0];
	            parcelDetails.selected = true;
	            selectedRecordDetails.push(parcelDetails);
	            console.log(response);
	          }).catch(function (error) {
	            console.log(error);
	          });
	        }
	
	        $scope.selectedRecords = selectedRecords;
	        var array1 = ["in", "parcel_id"];
	        var array2 = $scope.selectedRecords;
	
	        var array3 = array1.concat(array2);
	
	        map.setFilter("parcels-highlighted", array3);
	        map.selectedFilter = array3;
	
	        $scope.updateInfoBox(e.features[0].properties);
	
	        $scope.$apply();
	      });
	
	      map.on('mouseenter', 'parcels', function () {
	        map.getCanvas().style.cursor = "pointer";
	      });
	
	      map.on('mouseleave', 'parcels', function () {
	        map.getCanvas().style.cursor = '';
	      });
	
	      canvas.addEventListener('mousedown', mouseDown, true);
	
	      function mousePos(e) {
	        var rect = canvas.getBoundingClientRect();
	        return new mapboxgl.Point(e.clientX - rect.left - canvas.clientLeft, e.clientY - rect.top - canvas.clientTop);
	      }
	
	      function mouseDown(e) {
	        if (!(e.shiftKey && e.button === 0)) return;
	
	        map.dragPan.disable();
	
	        document.addEventListener('mousemove', onMouseMove);
	        document.addEventListener('mouseup', onMouseUp);
	        document.addEventListener('keydown', onKeyDown);
	
	        start = mousePos(e);
	      }
	
	      function onMouseMove(e) {
	        current = mousePos(e);
	
	        if (!box) {
	          box = document.createElement('div');
	          box.classList.add('boxdraw');
	          canvas.appendChild(box);
	        }
	
	        var minX = Math.min(start.x, current.x),
	            maxX = Math.max(start.x, current.x),
	            minY = Math.min(start.y, current.y),
	            maxY = Math.max(start.y, current.y);
	
	        var pos = 'translate(' + minX + 'px,' + minY + 'px)';
	        box.style.transform = pos;
	        box.style.WebkitTransform = pos;
	        box.style.width = maxX - minX + 'px';
	        box.style.height = maxY - minY + 'px';
	      }
	
	      function onMouseUp(e) {
	        finish([start, mousePos(e)]);
	      }
	
	      function onKeyDown(e) {
	        if (e.keyCode === 27) finish();
	      }
	
	      function finish(bbox) {
	        document.removeEventListener('mousemove', onMouseMove);
	        document.removeEventListener('keydown', onKeyDown);
	        document.removeEventListener('mouseup', onMouseUp);
	        selectedRecordDetails = $scope.selectedRecordDetails;
	
	        if (box) {
	          box.parentNode.removeChild(box);
	          box = null;
	        }
	
	        if (bbox) {
	          var features = map.queryRenderedFeatures(bbox, {
	            layers: ['parcels']
	          });
	
	          if (features.length >= 1000) {
	            return window.alert('Select a smaller number of features');
	          }
	
	          selectedRecords = $scope.selectedRecords;
	
	          var filter = features.reduce(function (memo, feature) {
	            memo.push(feature.properties.parcel_id);
	
	            var checkParcelId = feature.properties.parcel_id;
	            var checkIndex = selectedRecords.indexOf(checkParcelId);
	            var checkIndexDetails = selectedRecordDetails.indexOf(checkParcelId);
	            if (checkIndex > -1) {
	              selectedRecords.splice(checkIndex, 1);
	              selectedRecordDetails.splice(checkIndexDetails, 1);
	            } else {
	              selectedRecords.push(feature.properties.parcel_id);
	
	              feature.properties.selected = true;
	              var parcelDetails = {};
	              fetch.getItem('api/data/parcels', feature.properties.parcel_id).then(function (response) {
	                parcelDetails = response.data[0];
	                parcelDetails.selected = true;
	                selectedRecordDetails.push(parcelDetails);
	              }).catch(function (error) {
	                console.log(error);
	              });
	            }
	            return memo;
	          }, ['in', 'parcel_id']);
	          $scope.selectedRecords = selectedRecords;
	          if ($scope.type === 'zoning') {
	            $('#parcelZNCount').html('Update Parcels (' + $scope.selectedRecords.length + ')');
	          } else if ($scope.type === 'lu') {
	            $('#parcelGPCount').html('Update Parcels (' + $scope.selectedRecords.length + ')');
	          }
	
	          var array1 = ['in', 'parcel_id'];
	          var array2 = $scope.selectedRecords;
	
	          var array3 = array1.concat(array2);
	
	          map.setFilter("parcels-highlighted", array3);
	        }
	      }
	
	      map.on('draw.create', function (e) {
	
	        var userPolygon = e.features[0];
	
	        var polygonBoundingBox = turf.bbox(userPolygon);
	
	        var southWest = [polygonBoundingBox[0], polygonBoundingBox[1]];
	        var northEast = [polygonBoundingBox[2], polygonBoundingBox[3]];
	
	        var northEastPointPixel = map.project(northEast);
	        var southWestPointPixel = map.project(southWest);
	
	        var features = map.queryRenderedFeatures([southWestPointPixel, northEastPointPixel], {
	          layers: ['parcels']
	        });
	
	        var filter = selectedRecords.reduce(function (memo, feature) {
	
	          if (!(undefined === turf.intersect(feature, userPolygon))) {
	
	            memo.push(feature.properties.parcel_id);
	            selectedRecords.push(feature.properties.parcel_id);
	          }
	          return memo;
	        }, ['in', 'parcel_id']);
	
	        var array1 = ['in', 'parcel_id'];
	        var array2 = selectedRecords;
	
	        var array3 = array1.concat(array2);
	
	        map.setFilter("parcels-highlighted", array3);
	      });
	
	      map.on('style.load', function (map) {
	        loadMapLayers(map);
	      });
	
	      $scope.map = map;
	      $scope.stationAreaLayerToggle = true;
	    };
	
	    $scope.updateMap = function () {
	      $scope.saving = true;
	      var filters = ["all"];
	      console.log($scope.filter);
	      fetch.updateItem('api/data/parcels/map/filter', $scope.filter).then(function (response) {
	        console.log(response);
	        if (response.data.length > 0) {
	          var filteredParcels = [];
	          response.data.forEach(function (element) {
	            filteredParcels.push(element.parcel_id);
	          });
	          var array1 = ["in", "parcel_id"];
	          var array2 = filteredParcels;
	
	          var array3 = array1.concat(array2);
	          $scope.map.setFilter('parcels', array3);
	
	          $scope.clearSelected();
	
	          if ($scope.map.getFilter('sphereofinfluenceLayer')) {
	            $scope.map.setFilter("sphereofinfluenceLayer", ["match", ["get", "jurisdiction"], [$scope.filter.jurisdiction], true, false]);
	          }
	
	          if ($scope.map && $scope.filter.station_name) {
	            $scope.zoomToStation($scope.filter.station_name);
	          }
	
	          $scope.saving = false;
	        } else if (response.data.length == 0) {
	          $scope.map.setFilter('parcels', ["in", "parcel_id", ""]);
	          $scope.saving = false;
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.zoomToStation = function (station_name) {
	      var zoomToFeature = _.filter(stationAreasGeojson.features, function (item) {
	        return item.properties.station_name === station_name;
	      });
	
	      var bbox = turf.extent(zoomToFeature[0].geometry);
	      $scope.map.fitBounds(bbox, {
	        padding: -150
	      });
	    };
	
	    $scope.getZoningCodes = function (jurisdiction) {
	      fetch.getAllItems('api/data/density/zoning/' + jurisdiction).then(function (response) {
	
	        $scope.znCodes = response.data;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.clearSelected = function () {
	      $scope.map.setFilter('parcel-selected', ["in", "parcel_id", ""]);
	      $scope.map.setFilter('parcels-highlighted', ["in", "parcel_id", ""]);
	      $scope.selectedRecords = [];
	      $scope.selectedRecordDetails = [];
	      $scope.parcels = {
	        zn_recid: '',
	        percentOfParcel: '',
	        secondZnRecid: '',
	        secondPercentOfParcel: '',
	        exclude: '',
	        excludeZnCode: ''
	      };
	    };
	
	    $scope.clearParcelSelection = function () {
	      $scope.selectedRecordDetails = [];
	      $scope.map.setFilter('parcels-highlighted', ["in", "parcel_id", ""]);
	    };
	
	    $scope.updateCheckedParcels = function (item) {
	      if (!$scope.parcelSelected) {
	        $scope.selectedRecordDetails = _.remove($scope.selectedRecordDetails, function (e) {
	          return e.parcel_id != item.parcel_id;
	        });
	        var checkIndex = $scope.selectedRecords.indexOf(item.parcel_id);
	        $scope.selectedRecords.splice(checkIndex, 1);
	        var array1 = ["in", "parcel_id"];
	        var array2 = $scope.selectedRecords;
	        var array3 = array1.concat(array2);
	
	        $scope.map.setFilter("parcels-highlighted", array3);
	        $scope.map.selectedFilter = array3;
	      }
	    };
	
	    $scope.updateParcels = function () {
	      $scope.saving = true;
	      $scope.pendingParcelUpdates = [];
	      console.log($scope.parcels);
	
	      if ($scope.parcels.excludeZnCode && $scope.parcels.excludeZnCode !== '') {
	        $scope.pendingParcelUpdates.push({
	          zn_recid: $scope.parcels.excludeZnCode,
	          type: 'exclude_by_zoning_code'
	        });
	      } else {
	        $scope.selectedRecordDetails.forEach(function (element) {
	          if ($scope.parcels.zn_recid && $scope.parcels.zn_recid !== '') {
	            console.log('check 1');
	            var updateData = {
	              parcel_id: element.parcel_id,
	              zn_recid: $scope.parcels.zn_recid,
	              type: 'primary_zoning'
	            };
	            if ($scope.parcels.percentOfParcel && $scope.parcels.percentOfParcel !== '') {
	              updateData.percent_of_parcel = $scope.parcels.percentOfParcel;
	            }
	            if ($scope.parcels.exclude && $scope.parcels.exclude !== '') {
	              updateData.exclude = $scope.parcels.exclude;
	            }
	            $scope.pendingParcelUpdates.push(updateData);
	          }
	
	          if ($scope.parcels.secondZnRecid && $scope.parcels.secondZnRecid !== '') {
	            console.log('check 2');
	            var updateData = {
	              parcel_id: element.parcel_id,
	              zn_recid: $scope.parcels.secondZnRecid,
	              type: 'secondary_zoning'
	            };
	            if ($scope.parcels.secondPercentOfParcel && $scope.parcels.secondPercentOfParcel !== '') {
	              updateData.percent_of_parcel = $scope.parcels.secondPercentOfParcel;
	            }
	            if ($scope.parcels.exclude && $scope.parcels.exclude !== '') {
	              updateData.exclude = $scope.parcels.exclude;
	            }
	            $scope.pendingParcelUpdates.push(updateData);
	          }
	
	          if ($scope.parcels.exclude && $scope.parcels.exclude !== '' && (!$scope.parcels.zn_recid || $scope.parcels.zn_recid == undefined || $scope.parcels.zn_recid === '')) {
	            console.log('check 3');
	            $scope.pendingParcelUpdates.push({
	              parcel_id: element.parcel_id,
	              exclude: $scope.parcels.exclude,
	              type: 'primary_zoning'
	            });
	          }
	        });
	      }
	
	      console.log($scope.pendingParcelUpdates);
	
	      fetch.updateItem('api/data/parcels', $scope.pendingParcelUpdates).then(function (response) {
	        $scope.pendingParcelUpdates = [];
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.parcels = {};
	        $scope.updateExcludedParcelsLayer();
	
	        var parcelListTab = angular.element('#parcel-list-tab');
	        var tabButton = angular.element('#parcel-list');
	        angular.element('.nav-link').removeClass('active');
	        parcelListTab.addClass('active');
	        angular.element('.tab-pane').removeClass('show active');
	        tabButton.addClass('show active');
	
	        setTimeout(function () {
	          $scope.saved = false;
	          $scope.clearSelected();
	          $scope.$apply();
	        }, 3000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateExcludedParcelsLayer = function () {
	      fetch.getAllItems('api/data/excludedparcels/' + $scope.currentJurisdiction).then(function (response) {
	        if (response.data.length > 0) {
	          $scope.excludedParcels = response.data;
	          var array1 = ["in", "parcel_id"];
	          var array2 = $scope.excludedParcels;
	          var array3 = array1.concat(array2);
	
	          $scope.map.setFilter('parcels-excluded', array3);
	        } else {
	          $scope.map.setFilter('parcels-excluded', ["in", "parcel_id", ""]);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.manageLayers = function (layer) {};
	
	    $scope.manageTabPanels = function (type) {
	      $scope.tabPanelTypes.forEach(function (element) {
	        if (element.tab === type) {
	          $('#' + element.tab).addClass('show');
	          element.active = true;
	        } else {
	          $('#' + element.tab).removeClass('show');
	          element.active = false;
	        }
	      });
	    };
	
	    $scope.updateBaseMap = function (type) {
	      $scope.currentLayers = $scope.map.getStyle().layers;
	
	      $scope.map.setStyle('mapbox://styles/mapbox/' + type);
	
	      $scope.loadMapLayers();
	    };
	
	    $scope.loadMapLayers = function () {
	      if (!$scope.map.getSource("parcelsSource")) {
	        $scope.map.addSource("parcelsSource", {
	          type: "vector",
	          url: "mapbox://mtc-basis.toc_parcels_v24d" });
	      }
	
	      if (!$scope.map.getSource("stationAreaLayerSource")) {
	        $scope.map.addSource("stationAreaLayerSource", {
	          type: "geojson",
	          data: stationAreasGeojson
	        });
	      }
	
	      if (!$scope.map.getSource("jurisdictionBoundarySource")) {
	        $scope.map.addSource("jurisdictionBoundarySource", {
	          type: "geojson",
	          data: placesGeoJSON
	        });
	      }
	
	      if ($scope.map.getLayer("parcels")) {
	        $scope.map.removeLayer("parcels");
	      }
	
	      $scope.map.addLayer({
	        id: "parcels",
	        type: "fill",
	        source: "parcelsSource",
	        "source-layer": "toc_parcels_v24d",
	        'paint': {
	          "fill-outline-color": "black",
	          'fill-color': "white",
	          'fill-opacity': 0.5
	        }
	
	      });
	
	      if (!$scope.map.getLayer("stationAreaLayer")) {
	        $scope.map.addLayer({
	          id: "stationAreaLayer",
	          type: "fill",
	          source: "stationAreaLayerSource",
	          'paint': {
	            "fill-outline-color": "white",
	            'fill-color': {
	              'property': 'service_tier',
	              'type': 'categorical',
	              'stops': [[1, 'yellow'], [2, 'orange'], [3, 'green'], [4, 'blue']],
	              'default': 'white'
	            },
	            'fill-opacity': 0.5
	          },
	          'layout': {
	            'visibility': 'visible'
	          }
	
	        }, 'parcels');
	      }
	
	      if (!$scope.map.getLayer("jurisdiction-boundary")) {
	        $scope.map.addLayer({
	          id: "jurisdiction-boundary",
	          type: "line",
	          source: "jurisdictionBoundarySource",
	          paint: {
	            "line-color": "black",
	            "line-width": 0.75
	          },
	          filter: ["in", "NAME", ""]
	        });
	      }
	
	      if (!map.target.getLayer("parcels-excluded")) {
	        map.target.addLayer({
	          id: "parcels-excluded",
	          type: "fill",
	          source: "parcelsSource",
	          "source-layer": "toc_parcels_v24d",
	          paint: {
	            "fill-outline-color": "white",
	            "fill-color": "darkgray",
	            "fill-opacity": 0.75
	          },
	          filter: ["in", "parcel_id", ""]
	        });
	      }
	
	      fetch.getAllItems('api/data/excludedparcels', $scope.currentJurisdiction).then(function (response) {}).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	
	      if (!$scope.map.getLayer("parcels-highlighted")) {
	        $scope.map.addLayer({
	          id: "parcels-highlighted",
	          type: "fill",
	          source: "parcelsSource",
	          "source-layer": "toc_parcels_v24d",
	          paint: {
	            "fill-outline-color": "darkgray",
	            "fill-color": "#00fffa",
	            "fill-opacity": 0.75
	          },
	          filter: ["in", "parcel_id", ""]
	        });
	      }
	
	      if (!$scope.map.getLayer("parcel-selected")) {
	        $scope.map.addLayer({
	          id: "parcel-selected",
	          type: "line",
	          source: "parcelsSource",
	          "source-layer": "toc_parcels_v24d",
	          'paint': {
	            'line-color': '#888',
	            'line-width': 6
	          },
	          filter: ["in", "parcel_id", ""]
	        });
	      }
	
	      $scope.mapLayers.forEach(function (element) {
	        if (element.name === 'countyLayer') {
	          $scope.map.addSource(element.name + 'Source', {
	            type: 'geojson',
	
	            data: element.url
	          });
	
	          $scope.map.addLayer({
	            id: element.name,
	            type: "line",
	            source: element.name + 'Source',
	            paint: element.paint,
	            'layout': {
	              'visibility': 'none'
	            }
	          });
	        }
	      }, "parcels");
	
	      $scope.updateMap();
	    };
	
	    $scope.showParcelDetails = function (parcel) {
	      $scope.showParcelDetailsPanel = true;
	      $scope.parcel = parcel;
	      fetch.getItem('api/data/multizone/parcels', parcel.parcel_id).then(function (response) {
	        console.log(response);
	        $scope.parcelMultizoneDetails = response.data;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.backToSelected = function () {
	      $scope.showParcelDetailsPanel = false;
	    };
	  }
	
	  _createClass(MapComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	
	      this.$scope.mapLayers = this.mapService.getMapLayers();
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.filter.jurisdiction = _this2.$scope.currentJurisdiction;
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getZoningCodes(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      for (var key in this.$scope.filter) {
	        if (key === 'allows_comm_office' || key === 'allows_residential' || key === 'zn_code' || key === 'zn_recid') {
	          delete this.$scope.filter[key];
	        }
	      }
	
	      this.$scope.updateMap();
	
	      console.log(this.$scope.filter.station_name);
	      this.$scope.zoomToStation(this.$scope.filter.station_name);
	    }
	  }, {
	    key: 'toggleMapLayer',
	    value: function toggleMapLayer(layerName) {
	      var _this3 = this;
	
	      this.$scope.visibleLayer = layerName;
	      var visibility;
	      this.$scope.loadingDiv = true;
	      var type;
	
	      if (layerName === 'stationAreaLayer') {
	        if (this.$scope.map.getSource('stationAreaLayerSource')) {
	          visibility = this.$scope.map.getLayoutProperty(layerName, "visibility");
	
	          if (visibility === "visible") {
	            this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
	            this.$scope.visibleLayer = null;
	            this.className = "";
	          } else {
	            this.className = "active";
	            this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
	          }
	          this.$scope.loadingDiv = false;
	        }
	      }
	
	      var _loop = function _loop(index) {
	        var element = _this3.$scope.mapLayers[index];
	        if (element.name === layerName) {
	          if (_this3.$scope.map.getSource(element.source)) {
	            visibility = _this3.$scope.map.getLayoutProperty(element.name, "visibility");
	
	            if (visibility === "visible") {
	              _this3.$scope.map.setLayoutProperty(element.name, "visibility", "none");
	              _this3.$scope.visibleLayer = element.name;
	              _this3.className = "";
	            } else {
	              _this3.className = "active";
	              _this3.$scope.map.setLayoutProperty(element.name, "visibility", "visible");
	            }
	            _this3.$scope.loadingDiv = false;
	          } else {
	            $scope = _this3.$scope;
	
	            $.ajax({
	              url: element.url,
	              method: "GET",
	              dataType: "json",
	              success: function success(data, status, jqxhr) {
	                var layerData = data;
	                var paint = {};
	
	                if (element.type === 'mapbox') {
	                  paint = {
	                    "fill-outline-color": "white",
	                    "fill-color": element.fillColor,
	                    "fill-opacity": 0.4
	                  };
	
	                  $scope.map.addSource(element.source, {
	                    type: layerData.sources.composite.type,
	                    url: layerData.sources.composite.url
	                  });
	                } else if (element.type === 'socrata') {
	                  if (element.style === 'numerical' || element.style === 'circle') {
	                    layerData.features.forEach(function (data) {
	                      data.properties[element.property] = parseFloat(data.properties[element.property]);
	                    });
	                  }
	                  paint = element.paint;
	                  $scope.map.addSource(element.source, {
	                    type: "geojson",
	                    data: layerData
	                  });
	                }
	
	                if (element.type === 'mapbox') {
	                  if (layerData.layers[0].filter) {
	                    $scope.map.addLayer({
	                      id: element.name,
	                      type: layerData.layers[0].type,
	                      source: element.source,
	                      "source-layer": layerData.layers[0]["source-layer"],
	                      paint: layerData.layers[0].paint,
	                      filter: layerData.layers[0].filter
	                    }, "parcels");
	                  } else {
	                    $scope.map.addLayer({
	                      id: element.name,
	                      type: layerData.layers[0].type,
	                      source: element.source,
	                      "source-layer": layerData.layers[0]["source-layer"],
	                      paint: layerData.layers[0].paint
	                    }, "parcels");
	                  }
	                } else if (element.type === 'socrata') {
	                  type = element.style === 'circle' ? 'circle' : 'fill';
	                  $scope.map.addLayer({
	                    id: element.name,
	                    type: type,
	                    source: element.source,
	                    paint: element.paint
	                  }, 'parcels');
	                }
	
	                $scope.map.setLayoutProperty(element.name, "visibility", "visible");
	
	                if (element.name !== 'sphereofinfluenceLayer' && element.type === 'mapbox') {
	                  $scope.map.setPaintProperty(element.name, "fill-opacity", 0.5);
	                }
	
	                if (element.name === 'znLayer' || element.name === 'gpLayer') {
	                  $scope.map.setFilter(element.name, ["in", "jurisdiction", $scope.jurisdiction]);
	                }
	
	                if (element.name === 'sphereofinfluenceLayer') {
	                  $scope.map.setFilter(element.name, ["match", ["get", "jurisdiction"], [$scope.jurisdiction], true, false]);
	                }
	
	                $scope.loadingDiv = false;
	              },
	              error: function error(jqxhr, status, _error) {
	                console.log("Something went wrong!");
	                console.log(status, _error);
	                $scope.loadingDiv = false;
	              }
	            });
	          }
	        } else {
	          if (_this3.$scope.map.getSource(element.source)) {
	            _this3.$scope.map.setLayoutProperty(element.name, "visibility", "none");
	            _this3.$scope[element.name + "Toggle"] = false;
	            _this3.$scope.loadingDiv = false;
	          }
	        }
	        _this3.$scope.loadingDiv = true;
	      };
	
	      for (var index = 0; index < this.$scope.mapLayers.length; index++) {
	        var $scope;
	
	        _loop(index);
	      }
	    }
	  }]);
	
	  return MapComponent;
	}();
	
	exports.default = angular.module('appApp.map', [uiRouter]).config(_map2.default).component('map', {
	  template: __webpack_require__(118),
	  controller: MapComponent,
	  controllerAs: 'mapCtrl'
	}).name;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var pop = arr.pop;
	
	
	var sort = arr.sort;
	
	
	var splice = arr.splice;
	
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	
	
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	
	
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('map', {
	    url: '/account/map',
	    template: '<map></map>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null }
	  });
	};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports = "    <section class=\"dashboard dashboard--page dashboard--map\">\n        <div class=\"page-wrapper\">\n\n            <div class=\"dashboard-header\">\n                <sidebarnav />\n            </div>\n\n            <div class=\"main\">\n                <mainheaderauth />\n                <div class=\"content container\">\n                    <div class=\"row\">\n                        <div class=\"col-12\">\n                            <h1 class=\"page-title\">Map </h1>\n                            <div class=\"map-disclaimer\">\n                                For the best experience, access this map on a laptop or larger device.\n                            </div>\n                            <div class=\"map-container\">\n                                <maptoolbar />\n                                <div id=\"map\" class=\"map baytrail-map mapboxgl-map\"></div>\n                                <mapsidebar />\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"footer\" role=\"contentinfo\">\n                <sidebarfooter />\n            </div>\n        </div>\n    </section>\n"

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DashboardComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dashboard = __webpack_require__(120);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var DashboardComponent = exports.DashboardComponent = function () {
	  /*@ngInject*/
	  function DashboardComponent(FB, $firebaseAuth, baseConfigService, $state, $cookies, $scope, $stateParams, $rootScope, userService, navService, fetch, lookup, $timeout) {
	    'ngInject';
	
	    _classCallCheck(this, DashboardComponent);
	
	    var vm = this;
	
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	
	    this.navService = navService;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.userService = userService;
	    this.baseConfigService = baseConfigService;
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    this.$scope.stationAreas = [];
	
	    this.excludedPolicies = ['Commercial Office Uses Data Verification', 'Residential Uses Data Verification'];
	
	    $scope.recalculateCategoryTotals = function () {
	      $scope.totalScore_density = _.sumBy($scope.densitySubmissions, function (o) {
	        return Number(o.score) || 0;
	      });
	      $scope.totalScore_housing = _.sumBy($scope.housingPolicySubmissions, function (o) {
	        return Number(o.score) || 0;
	      });
	      $scope.totalScore_parking = _.sumBy($scope.parkingSubmissions, function (o) {
	        return Number(o.score) || 0;
	      });
	      $scope.totalScore_stationAccess = _.sumBy($scope.stationAccessSubmissions, function (o) {
	        return Number(o.score) || 0;
	      });
	    };
	
	    $scope.validateScore = function (item) {
	      if (item.score < 0) {
	        item.score = 0;
	      }
	      if (item.score > item.max_score) {
	        item.score = item.max_score;
	        console.warn('Score cannot exceed ' + item.max_score);
	      }
	      $scope.recalculateCategoryTotals();
	    };
	
	    $scope.updateScore = function (item) {
	      if (item.excludeFromScoring || !item.submitted_date) {
	        console.log('Skipping update - excluded or no submission');
	        return;
	      }
	      if (!$scope.currentUser || !$scope.currentUser.firstname || !$scope.currentUser.lastname) {
	        console.error('Current user not available');
	        return;
	      }
	
	      var scoreData = {
	        submission_id: item.submission_id,
	        score: parseInt(item.score) || 0,
	        score_last_updated_by: $scope.currentUser.firstname + ' ' + $scope.currentUser.lastname
	      };
	
	      fetch.updateItem('api/data/submissions/update-score', scoreData).then(function (response) {
	        vm.$timeout(function () {
	          if (response.data && response.data.updatedRecord) {
	            item.score = response.data.updatedRecord.score;
	            item.score_last_updated_by = response.data.updatedRecord.score_last_updated_by;
	            item.score_last_updated_date = response.data.updatedRecord.score_last_updated_date;
	          } else {
	            console.warn('No updatedRecord in response, updating manually');
	            item.score = scoreData.score;
	            item.score_last_updated_by = scoreData.score_last_updated_by;
	            item.score_last_updated_date = new Date();
	          }
	          $scope.recalculateCategoryTotals();
	        });
	      }).catch(function (err) {
	        console.error('Error updating score:', err);
	        console.error('Error details:', err.data);
	        vm.$timeout(function () {
	          $scope.error = 'Failed to update score';
	        });
	      });
	    };
	
	    $scope.showMessages = function (row) {
	      console.log(row);
	      $state.go('message-detail', {
	        submissionId: row.submission_id,
	        messageData: 'dashboard',
	        data: row
	      });
	    };
	
	    $scope.toggleStatusDropdown = function (event, item) {
	      event.stopPropagation();
	
	      item.showStatusDropdown = !item.showStatusDropdown;
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	      if ($scope.currentUser.role !== 'Administrator') {
	        return;
	      }
	      row.originalStatus = row.status;
	      row.originalUpdatedBy = row.status_last_updated_by;
	      row.originalUpdatedDate = row.status_last_updated_date;
	      row.status = newStatus;
	      row.showStatusDropdown = false;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          row.status_last_updated_by = $scope.currentUser.firstname + ' ' + $scope.currentUser.lastname;
	          row.status_last_updated_date = new Date();
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = row.originalStatus;
	          row.status_last_updated_by = row.originalUpdatedBy;
	          row.status_last_updated_date = row.originalUpdatedDate;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.showStatusDropdown = function (item) {
	      if ($scope.currentUser.role !== 'Administrator') {
	        return;
	      }
	      if (item.hideTimeout) {
	        $timeout.cancel(item.hideTimeout);
	        item.hideTimeout = null;
	      }
	
	      item.showStatusDropdown = true;
	    };
	
	    $scope.hideStatusDropdown = function (item) {
	      item.hideTimeout = $timeout(function () {
	        item.showStatusDropdown = false;
	        item.hideTimeout = null;
	      }, 200);
	    };
	
	    $scope.getStationbyID = function (station) {
	      console.log(station);
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        } else {
	          $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
	        }
	
	        lookup.setCurrentStation($scope.currentSelectedStationId);
	        $scope.getStationbyID();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	    angular.element(document).on('click', function (event) {
	      if (!event.target.closest('.status-pills')) {
	        $scope.$apply(function () {
	          if (!$scope.housingPolicySubmissions) return;
	          $scope.housingPolicySubmissions.forEach(function (item) {
	            item.showDropdown = false;
	          });
	        });
	      }
	    });
	  }
	
	  _createClass(DashboardComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.loading = true;
	
	      this.$timeout(function () {
	        _this.userService.getCurrentUser().then(function (response) {
	          _this.$scope.currentUser = response.data;
	          _this.userService.setCurrentUser(response.data);
	
	          return _this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list');
	        }).then(function (response) {
	          if (!Array.isArray(response.data)) {
	            console.error('Unexpected response for jurisdiction-list:', response.data);
	            _this.$state.go('login');
	            return;
	          }
	          _this.$scope.jurisdictions = response.data;
	
	          if (_this.$scope.currentUser.role === 'Administrator') {
	            var jurisdictionParam = _this.$stateParams.jurisdiction;
	            if (jurisdictionParam) {
	              _this.$scope.currentJurisdiction = jurisdictionParam;
	            } else if (_this.lookup.getJurisdiction()) {
	              _this.$scope.currentJurisdiction = _this.lookup.getJurisdiction();
	            } else {
	              _this.$scope.currentJurisdiction = _this.$scope.jurisdictions[0].jurisdiction;
	            }
	          } else {
	            _this.$scope.currentJurisdiction = _this.lookup.getJurisdiction() || _this.$scope.jurisdictions[0].jurisdiction;
	          }
	          _this.lookup.setJurisdiction(_this.$scope.currentJurisdiction);
	          _this.$scope.msg_selectedJurisdiction = _this.$scope.currentJurisdiction;
	          return _this.fetch.getItem('api/data/stationareas', _this.$scope.currentJurisdiction);
	        }).then(function (response) {
	          _this.$scope.loading = false;
	          _this.$scope.stationAreas = response.data;
	
	          var staRecIdParam = _this.$stateParams.sta_recid;
	
	          if (staRecIdParam) {
	            _this.$scope.currentSelectedStationId = staRecIdParam;
	            _this.lookup.setCurrentStation(staRecIdParam);
	            return _this.getStationAreaSubmissionSummary(staRecIdParam);
	          }
	
	          _this.$scope.currentSelectedStationId = null;
	          _this.lookup.setCurrentStation(null);
	          return _this.getJurisdictionScoreSummary(_this.$scope.currentJurisdiction);
	        }).then(function () {
	          _this.navService.getPage();
	        }).catch(function (err) {
	          console.error('Error in initialization:', err);
	          _this.$scope.loading = false;
	          if (err.status === 403) {
	            _this.$state.go('login');
	          }
	        });
	      }, 1000);
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        if (!Array.isArray(response.data)) {
	          console.error('Unexpected response for jurisdiction-list:', response.data);
	          _this2.$state.go('login');
	          return;
	        }
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.getStationAreas(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreas',
	    value: function getStationAreas(jurisdiction, noStationArea) {
	      var _this3 = this;
	
	      this.$scope.loading = true;
	      var stationId;
	      this.$scope.currentJurisdiction = jurisdiction;
	      this.lookup.setJurisdiction(jurisdiction);
	      this.fetch.getItem('api/data/stationareas', jurisdiction).then(function (response) {
	        _this3.$scope.loading = false;
	        _this3.$scope.stationAreas = response.data;
	        console.log(_this3.$scope.stationAreas[0].sta_recid);
	        stationId = _this3.$scope.stationAreas[0].sta_recid;
	        if (noStationArea) {
	          _this3.$scope.currentSelectedStationId = stationId;
	        } else if (_this3.lookup.getCurrentStation()) {
	          _this3.$scope.currentSelectedStationId = _this3.lookup.getCurrentStation();
	        } else {
	          _this3.$scope.currentSelectedStationId = stationId;
	        }
	        console.log(_this3.currentSelectedStationId);
	        _this3.lookup.setCurrentStation(_this3.$scope.currentSelectedStationId);
	
	        _this3.getStationAreaSubmissionSummary(_this3.$scope.currentSelectedStationId);
	
	        _this3.$scope.msg_selectedStation = '3470ed7a-19cf-5dd4-b827-c52ba8c61bff';
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'initializeSubmissions',
	    value: function initializeSubmissions(submissions) {
	      var vm = this;
	      return submissions.map(function (item) {
	        item.excludeFromScoring = vm.excludedPolicies.includes(item.submission_policy_name);
	        if (item.score === null || item.score === undefined) {
	          item.score = 0;
	        }
	        return item;
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this4 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this4.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this4.$scope.submissionSummary = response.data;
	          _this4.lookup.setSubmissionPolicies(response.data);
	          console.log("submission summary: ", _this4.$scope.submissionSummary);
	
	          _this4.$scope.densitySubmissions = _this4.initializeSubmissions(_.filter(response.data, { submission_policy_type: "Density" }));
	          _this4.$scope.totalNewMessages_density = _this4.$scope.currentUser.organization === "MTC" ? _.sumBy(_this4.$scope.densitySubmissions, function (o) {
	            return Number(o.mtc_newmessages_count);
	          }) : _.sumBy(_this4.$scope.densitySubmissions, function (o) {
	            return Number(o.newmessages_count);
	          });
	          _this4.$scope.totalScore_density = _.sumBy(_this4.$scope.densitySubmissions, function (o) {
	            return Number(o.score);
	          });
	          _this4.$scope.densitySubmitted = _.filter(_this4.$scope.densitySubmissions, { submitted: true });
	          _this4.$scope.densityCompliant = _.filter(_this4.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this4.$scope.housingPolicySubmissions = _this4.initializeSubmissions(_.filter(response.data, { submission_policy_type: "Housing Production Policy" }));
	          _this4.$scope.housingPolicySubmissions = _.union(_this4.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this4.$scope.totalNewMessages_housing = _this4.$scope.currentUser.organization === "MTC" ? _.sumBy(_this4.$scope.housingPolicySubmissions, function (o) {
	            return Number(o.mtc_newmessages_count);
	          }) : _.sumBy(_this4.$scope.housingPolicySubmissions, function (o) {
	            return Number(o.newmessages_count);
	          });
	          _this4.$scope.totalScore_housing = _.sumBy(_this4.$scope.housingPolicySubmissions, function (o) {
	            return Number(o.score);
	          });
	          _this4.$scope.housingPolicySubmitted = _.filter(_this4.$scope.housingPolicySubmissions, { submitted: true });
	          _this4.$scope.housingPolicyCompliant = _.filter(_this4.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this4.$scope.parkingSubmissions = _this4.initializeSubmissions(_.filter(response.data, { submission_policy_type: "Parking" }));
	          _this4.$scope.totalNewMessages_parking = _this4.$scope.currentUser.organization === "MTC" ? _.sumBy(_this4.$scope.parkingSubmissions, function (o) {
	            return Number(o.mtc_newmessages_count);
	          }) : _.sumBy(_this4.$scope.parkingSubmissions, function (o) {
	            return Number(o.newmessages_count);
	          });
	          _this4.$scope.totalScore_parking = _.sumBy(_this4.$scope.parkingSubmissions, function (o) {
	            return Number(o.score);
	          });
	          _this4.$scope.parkingSubmitted = _.filter(_this4.$scope.parkingSubmissions, { submitted: true });
	          _this4.$scope.parkingCompliant = _.filter(_this4.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this4.$scope.stationAccessSubmissions = _this4.initializeSubmissions(_.filter(response.data, { submission_policy_type: "Station Area Access" }));
	          _this4.$scope.totalNewMessages_stationAccess = _this4.$scope.currentUser.organization === "MTC" ? _.sumBy(_this4.$scope.stationAccessSubmissions, function (o) {
	            return Number(o.mtc_newmessages_count);
	          }) : _.sumBy(_this4.$scope.stationAccessSubmissions, function (o) {
	            return Number(o.newmessages_count);
	          });
	          _this4.$scope.totalScore_stationAccess = _.sumBy(_this4.$scope.stationAccessSubmissions, function (o) {
	            return Number(o.score);
	          });
	          _this4.$scope.stationAccessSubmitted = _.filter(_this4.$scope.stationAccessSubmissions, { submitted: true });
	          _this4.$scope.stationAccessCompliant = _.filter(_this4.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }, {
	    key: 'getJurisdictionScoreSummary',
	    value: function getJurisdictionScoreSummary(jurisdiction) {
	      var _this5 = this;
	
	      this.$scope.loading = true;
	      return this.fetch.getAllItems('api/data/policies/' + jurisdiction).then(function (response) {
	        var submissions = _this5.initializeSubmissions(response.data);
	        var grouped = _.groupBy(submissions, 'sta_recid');
	
	        _this5.$scope.stationCards = _this5.$scope.stationAreas.map(function (station) {
	          var items = (grouped[station.sta_recid] || []).filter(function (item) {
	            return !item.excludeFromScoring;
	          });
	          var score = _.sumBy(items, function (o) {
	            return Number(o.score) || 0;
	          });
	          var max_score = _.sumBy(items, function (o) {
	            return Number(o.max_score) || 0;
	          }) || 100;
	
	          return { sta_recid: station.sta_recid, station_name: station.station_name, score: score, max_score: max_score };
	        });
	
	        var scored = _this5.$scope.stationCards.filter(function (c) {
	          return c.max_score > 0;
	        });
	        _this5.$scope.jurisdictionAverageScore = scored.length ? Math.round(_.sumBy(scored, 'score') / scored.length) : 0;
	        _this5.$scope.jurisdictionMaxScore = scored.length ? Math.round(_.meanBy(scored, 'max_score')) : 100;
	
	
	        _this5.$scope.loading = false;
	      }).catch(function (err) {
	        console.error('Error loading jurisdiction score summary:', err);
	        _this5.$scope.loading = false;
	      });
	    }
	  }, {
	    key: 'getComplianceIcon',
	    value: function getComplianceIcon(score, maxScore) {
	      var pct = maxScore ? score / maxScore * 100 : 0;
	      if (pct >= 80) return { class: 'fa-solid fa-circle-check', color: '#2e7d32' };
	      if (pct >= 50) return { class: 'fa-solid fa-triangle-exclamation', color: '#f2994a' };
	      return { class: 'fa-solid fa-triangle-exclamation', color: '#d32f2f' };
	    }
	  }, {
	    key: 'selectStationCard',
	    value: function selectStationCard(staRecId) {
	      this.$scope.currentSelectedStationId = staRecId;
	      this.lookup.setCurrentStation(staRecId);
	      this.$state.go('dashboard', { sta_recid: staRecId }, { location: 'replace', notify: false });
	      this.getStationAreaSubmissionSummary(staRecId);
	    }
	  }, {
	    key: 'clearStationSelection',
	    value: function clearStationSelection() {
	      this.$scope.currentSelectedStationId = null;
	      this.lookup.setCurrentStation(null);
	      this.$state.go('dashboard', { sta_recid: null }, { location: 'replace', notify: false });
	      this.getJurisdictionScoreSummary(this.$scope.currentJurisdiction);
	    }
	  }, {
	    key: 'onJurisdictionChange',
	    value: function onJurisdictionChange(jurisdiction) {
	      var _this6 = this;
	
	      this.$scope.loading = true;
	      this.$scope.currentJurisdiction = jurisdiction;
	      this.lookup.setJurisdiction(jurisdiction);
	      this.$scope.currentSelectedStationId = null;
	      this.lookup.setCurrentStation(null);
	
	      this.fetch.getItem('api/data/stationareas', jurisdiction).then(function (response) {
	        _this6.$scope.stationAreas = response.data;
	        return _this6.getJurisdictionScoreSummary(jurisdiction);
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    }
	  }, {
	    key: 'setActive',
	    value: function setActive(subItem, item) {
	      var subItemTitle = subItem.title;
	      item.subItem1.forEach(function (element) {
	        if (element.title === subItemTitle) {
	          element.active = true;
	        } else {
	          element.active = false;
	        }
	      });
	    }
	  }]);
	
	  return DashboardComponent;
	}();
	
	exports.default = angular.module('appApp.dashboard', [uiRouter]).config(_dashboard2.default).component('dashboard', {
	  template: __webpack_require__(121),
	  controller: DashboardComponent,
	  controllerAs: 'dashboardCtrl'
	}).name;

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('dashboard', {
	    url: '/account/dashboard?sta_recid',
	    template: '<dashboard></dashboard>',
	    authenticate: true
	  });
	};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports = "<style>\n.dashboard-top-banner {\n  background: #06192c;\n  border-radius: 8px;\n  display: flex;\n  gap: 24px;\n  align-items: flex-end;\n  padding: 16px 24px;\n  color: #fff;\n  margin: 16px 0;\n}\n.banner-field select {\n  min-width: 220px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: 1px solid #ced4da;\n}\n\n.score-banner {\n  background: #fff;\n  /* color: #fff; */\n  border-radius: 8px;\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 20px;\n  margin: 16px 0;\n}\n.score-banner-value i { margin-left: 8px; }\n\n.station-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  padding: 6px 12px;\n  max-width: 320px;\n  margin-bottom: 20px;\n}\n.station-search input { border: none; outline: none; width: 100%; }\n\n.station-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n}\n.station-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  cursor: pointer;\n  transition: box-shadow 0.15s ease;\n}\n.station-card:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.12); }\n.station-card-name { font-weight: 600; margin-bottom: 8px; }\n.station-card-score { color: #495057; }\n\n.category-score-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin: 16px 0 24px;\n}\n.category-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n  font-weight: 600;\n}\n.category-card div {\n  font-size: 20px;\n  margin-top: 6px;\n  font-weight: 700;\n  color: #06192c;\n}\n.category-card .icon {\n  display: inline-block;\n  width: 20px;\n  font-family: \"Font Awesome 6 Pro\";\n  font-weight: 300;\n  font: var(--fa-font-light);\n  color: #06192c;\n  font-size: 18px;\n}\n.category-card .icon--density:before { content: '\\e603'; }\n.category-card .icon--housing:before { content: '\\e1b1'; }\n.category-card .icon--parking:before { content: '\\f540'; }\n.category-card .icon--station:before { content: '\\f5b6'; }\n\n.status-pills {\n    position: relative;\n  }\n\n  .status-pill-popup {\n    display: none;\n    position: absolute;\n    z-index: 9999;\n    /* Ensure it's above other elements */\n    background-color: white;\n    border: 1px solid #ccc;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    top: 100%;\n    /* Position below the status pill */\n    left: 0;\n    margin-top: -1px; /* Eliminate gap between button and dropdown */\n  }\n\n  .status-pill-popup.show {\n    display: block;\n  }\n\n  .accordion-body {\n    overflow: visible !important;\n    /* Prevent clipping */\n  }\n  \n  .tab-content,\n  .juridiction-container {\n    overflow: visible !important;\n  }\n  \n  .table--compliance td {\n    overflow: visible !important;\n  }\n\n  .message-indicator {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    color: #495057;\n  }\n\n  .message-indicator i[class*='fa-'] {\n    font-size: 16px;\n  }\n\n  .message-badge {\n    position: absolute;\n    top: -8px;\n    right: -12px;\n    background-color: #ff4081;\n    color: white;\n    font-size: 11px;\n    font-weight: 600;\n    min-width: 18px;\n    height: 18px;\n    border-radius: 9px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 5px;\n    border: 2px solid white;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  }\n\n  .score-input-group {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.score-input {\n  width: 60px;\n  padding: 4px 8px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.score-input:focus {\n  outline: none;\n  border-color: #06192c;\n  box-shadow: 0 0 0 0.2rem rgba(6, 25, 44, 0.1);\n}\n\n.score-input.invalid {\n  border-color: #dc3545;\n}\n\n.score-separator {\n  font-weight: 600;\n  color: #495057;\n}\n\n.max-score {\n  font-weight: 600;\n  color: #6c757d;\n}\n\n  /* Optional: Add animation for new messages */\n  @keyframes scaleBadge {\n    0% {\n      transform: scale(0);\n    }\n\n    50% {\n      transform: scale(1.2);\n    }\n\n    100% {\n      transform: scale(1);\n    }\n  }\n\n  .message-badge {\n    animation: scaleBadge 0.3s ease-out;\n  }\n\n  td .message-indicator {\n    padding: 4px 8px;\n    margin: -4px -8px;\n  }\n\n  .message-indicator .fa-envelope.text-muted {\n    opacity: 0.7;\n  }\n\n  .message-indicator .fa-envelope.text-primary {\n    color: #007bff;\n  }\n\n  .loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.7);\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .loading-spinner {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .loading-spinner i {\n    font-size: 24px;\n    color: #06192c;\n  }\n\n  .loading-spinner span {\n    color: #495057;\n    font-size: 16px;\n  }\n\n  .submission-info,\n  .status-updated-info {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .submitted-by,\n  .status-updated-by {\n    /* color: #495057; */\n    /* font-size: 14px; */\n    line-height: 1.4;\n  }\n\n  .submitted-date-badge,\n  .status-updated-date-badge {\n    display: inline-block;\n    padding: 3px 8px;\n    background-color: #D9E0E2; \n    /* color: #00303F;  */\n    font-size: 11px;\n    font-weight: 600;\n    border-radius: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    align-self: flex-start;\n  }\n\n  .submitted-date-badge i,\n  .status-updated-date-badge i {\n    font-size: 10px;\n    margin-right: 4px;\n    opacity: 0.7;\n  }\n</style>\n<section class=\"dashboard dashboard--page dashboard--compliance dashboard--compliance--jurisdiction\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav />\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth />\n      <breadcrumbnav />\n\n      <div class=\"content container\">\n        <div ng-show=\"loading\" class=\"loading-overlay\">\n          <div class=\"loading-spinner\">\n            <i class=\"fa-solid fa-circle-notch fa-spin\"></i>\n            <span>Loading submissions...</span>\n          </div>\n        </div>\n\n\n        <div class=\"row\">\n          <form class=\"dashboard-top-banner\">\n  <div class=\"banner-field\" style=\"padding-left: 16px;\">\n    <label>Jurisdiction</label>\n    <select ng-model=\"currentJurisdiction\"\n            ng-change=\"dashboardCtrl.onJurisdictionChange(currentJurisdiction)\"\n            ng-disabled=\"getCurrentUser().role === 'User'\">\n      <option ng-repeat=\"item in jurisdictions\" ng-value=\"item.jurisdiction\">\n        {{item.jurisdiction}}\n      </option>\n    </select>\n  </div>\n  <div class=\"banner-field\">\n    <label>Station Area</label>\n    <select ng-model=\"currentSelectedStationId\"\n            ng-change=\"currentSelectedStationId ? dashboardCtrl.selectStationCard(currentSelectedStationId) : dashboardCtrl.clearStationSelection()\">\n      <option ng-value=\"null\">Please select station area</option>\n      <option ng-repeat=\"area in stationAreas\" ng-value=\"area.sta_recid\">\n        {{area.station_name}}\n      </option>\n    </select>\n  </div>\n</form>\n          <div ng-if=\"!currentSelectedStationId\" class=\"jurisdiction-overview\">\n            <div class=\"score-banner\">\n              <span class=\"score-banner-label\">{{currentJurisdiction}} Average Score:</span>\n              <span class=\"score-banner-value\">\n                {{jurisdictionAverageScore}} / {{jurisdictionMaxScore}}\n                <!-- <i ng-class=\"jurisdictionComplianceIcon.class\"\n                  ng-style=\"{color: jurisdictionComplianceIcon.color}\"></i> -->\n              </span>\n            </div>\n            <p class=\"jurisdiction-intro\">\n              Jurisdiction average score and station area scores reflect completed submissions. Click below or select a station area from the drop-down menu above to find more information on individual submissions. \n            </p>\n            <div class=\"station-search\">\n              <i class=\"fa-solid fa-magnifying-glass\"></i>\n              <input type=\"text\" ng-model=\"stationSearchQuery\" placeholder=\"Search station areas...\">\n            </div>\n            <div class=\"station-card-grid\">\n              <div class=\"station-card\" ng-repeat=\"card in stationCards | filter: stationSearchQuery\"\n                  ng-click=\"dashboardCtrl.selectStationCard(card.sta_recid)\">\n                <div class=\"station-card-name\">{{card.station_name}}</div>\n                <div class=\"station-card-score\">Score: <strong>{{card.score}}</strong></div>\n                <div class=\"station-card-link\">View Station Area <i class=\"fa-solid fa-arrow-right\"></i></div>\n              </div>\n            </div>\n          </div>         \n          <div class=\"tab-content\" ng-if=\"currentSelectedStationId\">\n              <button type=\"button\" class=\"btn btn-link btn-sm ps-0\" ng-click=\"dashboardCtrl.clearStationSelection()\">\n  <i class=\"fa-solid fa-arrow-left\"></i> Back to Station List\n</button>\n              <div class=\"category-score-cards\">\n                <div class=\"category-card\">\n                  <i class=\"icon icon--density\"></i> Density\n                  <div>{{totalScore_density}} / 25</div>\n                </div>\n                <div class=\"category-card\">\n                  <i class=\"icon icon--housing\"></i> Housing\n                  <div>{{totalScore_housing}} / 25</div>\n                </div>\n                <div class=\"category-card\">\n                  <i class=\"icon icon--parking\"></i> Parking\n                  <div>{{totalScore_parking}} / 25</div>\n                </div>\n                <div class=\"category-card\">\n                  <i class=\"icon icon--station\"></i> Station Access\n                  <div>{{totalScore_stationAccess}} / 25</div>\n                </div>\n              </div>\n\n              <div id=\"complianceStatusTab\" role=\"tabpanel\" class=\"tab-pane show active\">\n                <div class=\"tab-pane-title\">{{stationAreaTitle}}</div>\n                <div class=\"section\">\n                  <h2 class=\"icon icon--density\">Density</h2>\n                  <div class=\"accordion\" id=\"accordionDensityOne\">\n                    <div class=\"accordion-item\">\n                      <div class=\"accordion-header\">\n                        <button class=\"accordion-button\" type=\"button\" data-bs-toggle=\"collapse\"\n                          data-bs-target=\"#accordionDensity1collapseOne\" aria-expanded=\"true\"\n                          aria-controls=\"accordionDensity1collapseOne\">\n                          <span class=\"accordion-title\">Summary</span>\n                          <span class=\"accordion-compliance\">Submitted:\n                            <span class=\"badge\">{{densitySubmitted.length}} of\n                              {{densitySubmissions.length}}</span></span>\n                          <span class=\"accordion-compliance\">Consistent with TOC Standards:\n                            <span class=\"badge\">{{densityCompliant.length}} of\n                              {{densitySubmissions.length}}</span></span>\n                           <span class=\"accordion-compliance\">Score:\n                            <span class=\"badge\">{{totalScore_density}}</span></span>\n                          <span class=\"accordion-compliance\">New Messages:\n                            <span class=\"badge\">{{totalNewMessages_density}}</span></span>\n                          <span class=\"sr-only\">Expand/collapse</span>\n                        </button>\n                      </div>\n                      <div id=\"accordionDensity1collapseOne\" class=\"accordion-collapse collapse show\"\n                        data-bs-parent=\"#accordionDensity1\">\n                        <div class=\"accordion-body\">\n                          <table class=\"table table--default table--compliance\">\n                            <thead>\n                              <tr>\n                                <th scope=\"col\">Policy Name</th>\n                                <th scope=\"col\">Submitted By</th>\n                                <th scope=\"col\">Status</th>\n                                <th scope=\"col\">Status Updated By</th>\n                                <th scope=\"col\">Score</th>\n                                <th scope=\"col\">Messages</th>\n                              </tr>\n                            </thead>\n                            <tbody>\n                              <tr ng-repeat=\"item in densitySubmissions\">\n                                <td><a href=\"/account/density\">{{item.submission_policy_name}}</a></td>\n                                <td>\n                                  <div class=\"submission-info\">\n                                    <span class=\"submitted-by\">{{item.submitted_by ? item.submitted_by : '--'}}</span>\n                                    <span class=\"submitted-date-badge\" ng-if=\"item.submitted_date\">\n                                      <i class=\"fa-solid fa-calendar\"></i>{{item.submitted_date | date:'mediumDate'}}\n                                    </span>\n                                  </div>\n                                </td>\n                                \n                                <td>\n                                  <div class=\"status-pills\" ng-mouseenter=\"showStatusDropdown(item)\" ng-mouseleave=\"hideStatusDropdown(item)\">\n                                    <button ng-if=\"item.status === 'In Review'\"\n                                      class=\"status-pill status-pill--in-review status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Needs Work'\"\n                                      class=\"status-pill status-pill--needs-work status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Not Consistent'\"\n                                      class=\"status-pill status-pill--not-compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Pending'\"\n                                      class=\"status-pill status-pill--not-compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Consistent'\"\n                                      class=\"status-pill status-pill--compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <div class=\"status-pill-popup\" ng-if=\"currentUser.role === 'Administrator'\" ng-class=\"{'show': item.showStatusDropdown}\">\n                                      <button class=\"status-pill status-pill--in-review\"\n                                        ng-click=\"updateSubmissionStatus(item, 'In Review')\">\n                                        In Review\n                                      </button>\n                                      <button class=\"status-pill status-pill--needs-work\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Needs Work')\">\n                                        Needs Work\n                                      </button>\n                                      <button class=\"status-pill status-pill--not-compliant\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Not Consistent')\">\n                                        Not Consistent\n                                      </button>\n                                      <button class=\"status-pill status-pill--compliant\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Consistent')\">\n                                        Consistent\n                                      </button>\n                                    </div>\n                                  </div>\n                                </td>\n                                <td>\n                                  <div class=\"status-updated-info\">\n                                    <span class=\"status-updated-by\">{{item.status_last_updated_by ? item.status_last_updated_by : '--'}}</span>\n                                    <span class=\"status-updated-date-badge\" ng-if=\"item.status_last_updated_date\">\n                                      <i class=\"fa-solid fa-calendar\"></i>{{item.status_last_updated_date | date:'mediumDate'}}\n                                    </span>\n                                  </div>\n                                </td>\n                               <td>\n                                <div ng-if=\"!item.excludeFromScoring && item.submitted_date\">\n                                  <span ng-if=\"currentUser.role !== 'Administrator'\">\n                                    {{item.score || '--'}}/{{item.max_score}}\n                                  </span>\n                                  <div ng-if=\"currentUser.role === 'Administrator'\" class=\"score-input-group\">\n                                    <input type=\"number\" \n                                          ng-model=\"item.score\" \n                                          ng-change=\"validateScore(item)\"\n                                          min=\"0\" \n                                          max=\"{{item.max_score}}\"\n                                          ng-blur=\"updateScore(item)\"\n                                          ng-keyup.enter=\"updateScore(row)\"\n                                          class=\"form-control score-input\"\n                                          placeholder=\"0\">\n                                    <span class=\"score-separator\">/</span>\n                                    <span class=\"max-score\">{{item.max_score}}</span>\n                                  </div>\n                                </div>\n                                <span ng-if=\"item.excludeFromScoring || !item.submitted_date\">--</span>\n                              </td>\n                                <td>\n                                  <div class=\"message-indicator\">\n                                    <a href=\"#\" ng-click=\"showMessages(item)\" class=\"message-indicator\"\n                                      title=\"View Messages\">\n                                      <i class=\"fa-solid\" ng-class=\"{\n                                              'fa-regular fa-envelope': !item.hasmessage,\n                                             'fa-solid fa-envelope': item.messages_count > 0,\n                                             'text-primary': (currentUser.organization === 'MTC' ? item.mtc_newmessages_count > 0 : item.newmessages_count > 0),\n                                             'text-muted': item.messages_count > 0 && (currentUser.organization === 'MTC' ? item.mtc_newmessages_count === 0 : item.newmessages_count === 0)\n                                           }\">\n                                      </i>\n                                      <span class=\"message-badge\" ng-if=\"(currentUser.organization === 'MTC' ? item.mtc_newmessages_count > 0 : item.newmessages_count > 0)\">\n                                        {{(currentUser.organization === 'MTC' ? item.mtc_newmessages_count : item.newmessages_count) | number}}\n                                      </span>\n                                    </a>\n                                  </div>\n                                </td>\n                              </tr>\n                            </tbody>\n                          </table>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"section\">\n                  <h2 class=\"icon icon--housing\">\n                    Affordable Housing and Commercial Stabilization\n                  </h2>\n                  <div class=\"accordion\" id=\"accordionHousingOne\">\n                    <div class=\"accordion-item\">\n                      <div class=\"accordion-header\">\n                        <button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\"\n                          data-bs-target=\"#accordionHousing1collapseTwo\" aria-expanded=\"false\"\n                          aria-controls=\"accordionHousing1collapseTwo\">\n                          <span class=\"accordion-title\">Summary</span>\n                          <span class=\"accordion-compliance\">Submitted:\n                            <span class=\"badge\">{{housingPolicySubmitted.length}} of\n                              {{housingPolicySubmissions.length}}</span></span>\n                          <span class=\"accordion-compliance\">Consistent with TOC Standards:\n                            <span class=\"badge\">{{housingPolicyCompliant.length}} of\n                              {{housingPolicySubmissions.length}}</span></span>\n                          <span class=\"accordion-compliance\">Score:\n                            <span class=\"badge\">{{totalScore_housing}}</span></span>\n                          <span class=\"accordion-compliance\">New Messages:\n                            <span class=\"badge\">{{totalNewMessages_housing}}</span></span>\n                          <span class=\"sr-only\">Expand/collapse</span>\n                        </button>\n                      </div>\n                      <div id=\"accordionHousing1collapseTwo\" class=\"accordion-collapse collapse\"\n                        data-bs-parent=\"#accordionHousing1\">\n                        <div class=\"accordion-body\">\n                          <table class=\"table table--default table--compliance\">\n                            <thead>\n                              <tr>\n                                <th scope=\"col\">Policy Name</th>\n                                <th scope=\"col\">Submitted By</th>\n                                <th scope=\"col\">Status</th>\n                                <th scope=\"col\">Status Updated By</th>\n                                <th scope=\"col\">Score</th>\n                                <th scope=\"col\">Messages</th>\n                              </tr>\n                            </thead>\n                            <tbody>\n                              <tr ng-repeat=\"item in housingPolicySubmissions\">\n                                <td><a href=\"/account/housing\">{{item.submission_policy_name}}</a></td>\n                                <td>\n                                  <div class=\"submission-info\">\n                                    <span class=\"submitted-by\">{{item.submitted_by ? item.submitted_by : '--'}}</span>\n                                    <span class=\"submitted-date-badge\" ng-if=\"item.submitted_date\">\n                                      <i class=\"fa-solid fa-calendar\"></i>{{item.submitted_date | date:'mediumDate'}}\n                                    </span>\n                                  </div>\n                                </td>\n                                <td>\n                                  <div class=\"status-pills\" ng-mouseenter=\"showStatusDropdown(item)\" ng-mouseleave=\"hideStatusDropdown(item)\">\n                                    <button ng-if=\"item.status === 'In Review'\"\n                                      class=\"status-pill status-pill--in-review status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Needs Work'\"\n                                      class=\"status-pill status-pill--needs-work status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Not Consistent'\"\n                                      class=\"status-pill status-pill--not-compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Pending'\"\n                                      class=\"status-pill status-pill--not-compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Consistent'\"\n                                      class=\"status-pill status-pill--compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n              \n                                    <div class=\"status-pill-popup\" ng-if=\"currentUser.role === 'Administrator'\" ng-class=\"{'show': item.showStatusDropdown}\">\n                                      <button class=\"status-pill status-pill--in-review\"\n                                        ng-click=\"updateSubmissionStatus(item, 'In Review')\">\n                                        In Review\n                                      </button>\n                                      <button class=\"status-pill status-pill--needs-work\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Needs Work')\">\n                                        Needs Work\n                                      </button>\n                                      <button class=\"status-pill status-pill--not-compliant\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Not Consistent')\">\n                                        Not Consistent\n                                      </button>\n                                      <button class=\"status-pill status-pill--compliant\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Consistent')\">\n                                        Consistent\n                                      </button>\n                                    </div>\n                                  </div>\n                                  \n\n                                </td>\n                                <td>\n                                  <div class=\"status-updated-info\">\n                                    <span class=\"status-updated-by\">{{item.status_last_updated_by ? item.status_last_updated_by : '--'}}</span>\n                                    <span class=\"status-updated-date-badge\" ng-if=\"item.status_last_updated_date\">\n                                      <i class=\"fa-solid fa-calendar\"></i>{{item.status_last_updated_date | date:'mediumDate'}}\n                                    </span>\n                                  </div>\n                                </td>\n                                <td>\n                                <div ng-if=\"!item.excludeFromScoring && item.submitted_date\">\n                                  <span ng-if=\"currentUser.role !== 'Administrator'\">\n                                    {{item.score || '--'}}/{{item.max_score}}\n                                  </span>\n                                  <div ng-if=\"currentUser.role === 'Administrator'\" class=\"score-input-group\">\n                                    <input type=\"number\" \n                                          ng-model=\"item.score\" \n                                          ng-change=\"validateScore(item)\"\n                                          min=\"0\" \n                                          max=\"{{item.max_score}}\"\n                                          ng-blur=\"updateScore(item)\"\n                                          ng-keyup.enter=\"updateScore(item)\"\n                                          class=\"form-control score-input\"\n                                          placeholder=\"0\">\n                                    <span class=\"score-separator\">/</span>\n                                    <span class=\"max-score\">{{item.max_score}}</span>\n                                  </div>\n                                </div>\n                                <span ng-if=\"item.excludeFromScoring || !item.submitted_date\">--</span>\n                              </td>\n                                <td>\n                                  <div class=\"message-indicator\">\n                                    <a ng-click=\"showMessages(item)\" class=\"message-indicator\" title=\"View Messages\">\n                                      <i class=\"fa-solid\" ng-class=\"{\n                                              'fa-regular fa-envelope': !item.hasmessage,\n                                             'fa-solid fa-envelope': item.messages_count > 0,\n                                             'text-primary': (currentUser.organization === 'MTC' ? item.mtc_newmessages_count > 0 : item.newmessages_count > 0),\n                                             'text-muted': item.messages_count > 0 && (currentUser.organization === 'MTC' ? item.mtc_newmessages_count === 0 : item.newmessages_count === 0)\n                                           }\">\n                                      </i>\n                                      <span class=\"message-badge\" ng-if=\"(currentUser.organization === 'MTC' ? item.mtc_newmessages_count > 0 : item.newmessages_count > 0)\">\n                                        {{(currentUser.organization === 'MTC' ? item.mtc_newmessages_count : item.newmessages_count) | number}}\n                                      </span>\n                                    </a>\n                                  </div>\n                                </td>\n                              </tr>\n                            </tbody>\n                          </table>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"section\">\n                  <h2 class=\"icon icon--parking\">Parking</h2>\n                  <div class=\"accordion\" id=\"accordionParkingOne\">\n                    <div class=\"accordion-item\">\n                      <div class=\"accordion-header\">\n                        <button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\"\n                          data-bs-target=\"#accordionParking1collapseSeven\" aria-expanded=\"false\"\n                          aria-controls=\"accordionParking1collapseSeven\">\n                          <span class=\"accordion-title\">Summary</span>\n                          <span class=\"accordion-compliance\">Submitted:\n                            <span class=\"badge\">{{parkingSubmitted.length}} of\n                              {{parkingSubmissions.length}}</span></span>\n                          <span class=\"accordion-compliance\">Consistent with TOC Standards:\n                            <span class=\"badge\">{{parkingCompliant.length}} of\n                              {{parkingSubmissions.length}}</span></span>\n                              <span class=\"accordion-compliance\">Score:\n                            <span class=\"badge\">{{totalScore_parking}}</span></span>\n                          <span class=\"accordion-compliance\">New Messages:\n                            <span class=\"badge\">{{totalNewMessages_parking}}</span></span>\n                          <span class=\"sr-only\">Expand/collapse</span>\n                        </button>\n                      </div>\n                      <div id=\"accordionParking1collapseSeven\" class=\"accordion-collapse collapse\"\n                        data-bs-parent=\"#accordionParking1\">\n                        <div class=\"accordion-body\">\n                          <table class=\"table table--default table--compliance\">\n                            <thead>\n                              <tr>\n                                <th scope=\"col\">Policy Name</th>\n                                <th scope=\"col\">Submitted By</th>\n                                <th scope=\"col\">Status</th>\n                                <th scope=\"col\">Status Updated By</th>\n                                <th scope=\"col\">Score</th>\n                                <th scope=\"col\">Messages</th>\n                              </tr>\n                            </thead>\n                            <tbody>\n                              <tr ng-repeat=\"item in parkingSubmissions\">\n                                <td><a href=\"/account/parking\">{{item.submission_policy_name}}</a></td>\n                                <td>\n                                  <div class=\"submission-info\">\n                                    <span class=\"submitted-by\">{{item.submitted_by ? item.submitted_by : '--'}}</span>\n                                    <span class=\"submitted-date-badge\" ng-if=\"item.submitted_date\">\n                                      <i class=\"fa-solid fa-calendar\"></i>{{item.submitted_date | date:'mediumDate'}}\n                                    </span>\n                                  </div>\n                                </td>\n                                <td>\n                                  <div class=\"status-pills\" ng-mouseenter=\"showStatusDropdown(item)\" ng-mouseleave=\"hideStatusDropdown(item)\">\n                                    <button ng-if=\"item.status === 'In Review'\"\n                                      class=\"status-pill status-pill--in-review status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Needs Work'\"\n                                      class=\"status-pill status-pill--needs-work status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Not Consistent'\"\n                                      class=\"status-pill status-pill--not-compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Pending'\"\n                                      class=\"status-pill status-pill--not-compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Consistent'\"\n                                      class=\"status-pill status-pill--compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <div class=\"status-pill-popup\" ng-if=\"currentUser.role === 'Administrator'\" ng-class=\"{'show': item.showStatusDropdown}\">\n                                      <button class=\"status-pill status-pill--in-review\"\n                                        ng-click=\"updateSubmissionStatus(item, 'In Review')\">\n                                        In Review\n                                      </button>\n                                      <button class=\"status-pill status-pill--needs-work\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Needs Work')\">\n                                        Needs Work\n                                      </button>\n                                      <button class=\"status-pill status-pill--not-compliant\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Not Consistent')\">\n                                        Not Consistent\n                                      </button>\n                                      <button class=\"status-pill status-pill--compliant\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Consistent')\">\n                                        Consistent\n                                      </button>\n                                    </div>\n                                  </div>\n                                  \n\n                                </td>\n                                <td>\n                                  <div class=\"status-updated-info\">\n                                    <span class=\"status-updated-by\">{{item.status_last_updated_by ? item.status_last_updated_by : '--'}}</span>\n                                    <span class=\"status-updated-date-badge\" ng-if=\"item.status_last_updated_date\">\n                                      <i class=\"fa-solid fa-calendar\"></i>{{item.status_last_updated_date | date:'mediumDate'}}\n                                    </span>\n                                  </div>\n                                </td>\n                                <td>\n                                <div ng-if=\"!item.excludeFromScoring && item.submitted_date\">\n                                  <span ng-if=\"currentUser.role !== 'Administrator'\">\n                                    {{item.score || '--'}}/{{item.max_score}}\n                                  </span>\n                                  <div ng-if=\"currentUser.role === 'Administrator'\" class=\"score-input-group\">\n                                    <input type=\"number\" \n                                          ng-model=\"item.score\" \n                                          ng-change=\"validateScore(item)\"\n                                          min=\"0\" \n                                          max=\"{{item.max_score}}\"\n                                          ng-blur=\"updateScore(item)\"\n                                          ng-keyup.enter=\"updateScore(item)\"\n                                          class=\"form-control score-input\"\n                                          placeholder=\"0\">\n                                    <span class=\"score-separator\">/</span>\n                                    <span class=\"max-score\">{{item.max_score}}</span>\n                                  </div>\n                                </div>\n                                <span ng-if=\"item.excludeFromScoring || !item.submitted_date\">--</span>\n                              </td>\n                                <td>\n                                  <div class=\"message-indicator\">\n                                    <a ng-click=\"showMessages(item)\" class=\"message-indicator\" title=\"View Messages\">\n                                      <i class=\"fa-solid\" ng-class=\"{\n                                              'fa-regular fa-envelope': !item.hasmessage,\n                                             'fa-solid fa-envelope': item.messages_count > 0,\n                                             'text-primary': (currentUser.organization === 'MTC' ? item.mtc_newmessages_count > 0 : item.newmessages_count > 0),\n                                             'text-muted': item.messages_count > 0 && (currentUser.organization === 'MTC' ? item.mtc_newmessages_count === 0 : item.newmessages_count === 0)\n                                           }\">\n                                      </i>\n                                      <span class=\"message-badge\" ng-if=\"(currentUser.organization === 'MTC' ? item.mtc_newmessages_count > 0 : item.newmessages_count > 0)\">\n                                        {{(currentUser.organization === 'MTC' ? item.mtc_newmessages_count : item.newmessages_count) | number}}\n                                      </span>\n                                    </a>\n                                  </div>\n                                </td>\n                              </tr>\n                            </tbody>\n                          </table>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"section\">\n                  <h2 class=\"icon icon--station\">Station Access</h2>\n                  <div class=\"accordion\" id=\"accordionStationAccessOne\">\n                    <div class=\"accordion-item\">\n                      <div class=\"accordion-header\">\n                        <button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\"\n                          data-bs-target=\"#accordionStation1collapseEleven\" aria-expanded=\"false\"\n                          aria-controls=\"accordionStation1collapseEleven\">\n                          <span class=\"accordion-title\">Summary</span>\n                          <span class=\"accordion-compliance\">Submitted:\n                            <span class=\"badge\">{{stationAccessSubmitted.length}} of\n                              {{stationAccessSubmissions.length}}</span></span>\n                          <span class=\"accordion-compliance\">Consistent with TOC Standards:\n                            <span class=\"badge\">{{stationAccessCompliant.length}} of\n                              {{stationAccessSubmissions.length}}</span></span>\n                            <span class=\"accordion-compliance\">Score:\n                            <span class=\"badge\">{{totalScore_stationAccess}}</span></span>\n                          <span class=\"accordion-compliance\">New Messages:\n                            <span class=\"badge\">{{totalNewMessages_stationAccess}}</span></span>\n                          <span class=\"sr-only\">Expand/collapse</span>\n                        </button>\n                      </div>\n                      <div id=\"accordionStation1collapseEleven\" class=\"accordion-collapse collapse\"\n                        data-bs-parent=\"#accordionStationAccessOne\">\n                        <div class=\"accordion-body\">\n                          <table class=\"table table--default table--compliance\">\n                            <thead>\n                              <tr>\n                                <th scope=\"col\">Policy Name</th>\n                                <th scope=\"col\">Submitted By</th>\n                                <th scope=\"col\">Status</th>\n                                <th scope=\"col\">Status Updated By</th>\n                                <th scope=\"col\">Score</th>\n                                <th scope=\"col\">Messages</th>\n                              </tr>\n                            </thead>\n                            <tbody>\n                              <tr ng-repeat=\"item in stationAccessSubmissions\">\n                                <td><a href=\"/account/stationaccess\">{{item.submission_policy_name}}</a></td>\n                                <td>\n                                  <div class=\"submission-info\">\n                                    <span class=\"submitted-by\">{{item.submitted_by ? item.submitted_by : '--'}}</span>\n                                    <span class=\"submitted-date-badge\" ng-if=\"item.submitted_date\">\n                                      <i class=\"fa-solid fa-calendar\"></i>{{item.submitted_date | date:'mediumDate'}}\n                                    </span>\n                                  </div>\n                                </td>\n                                <td>\n                                  <div class=\"status-pills\" ng-mouseenter=\"showStatusDropdown(item)\" ng-mouseleave=\"hideStatusDropdown(item)\">\n                                    <button ng-if=\"item.status === 'In Review'\"\n                                      class=\"status-pill status-pill--in-review status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Needs Work'\"\n                                      class=\"status-pill status-pill--needs-work status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Not Consistent'\"\n                                      class=\"status-pill status-pill--not-compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Pending'\"\n                                      class=\"status-pill status-pill--not-compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <button ng-if=\"item.status === 'Consistent'\"\n                                      class=\"status-pill status-pill--compliant status-pill--selected\">\n                                      {{item.status}}\n                                    </button>\n                                    <div class=\"status-pill-popup\" ng-if=\"currentUser.role === 'Administrator'\" ng-class=\"{'show': item.showStatusDropdown}\">\n                                      <button class=\"status-pill status-pill--in-review\"\n                                        ng-click=\"updateSubmissionStatus(item, 'In Review')\">\n                                        In Review\n                                      </button>\n                                      <button class=\"status-pill status-pill--needs-work\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Needs Work')\">\n                                        Needs Work\n                                      </button>\n                                      <button class=\"status-pill status-pill--not-compliant\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Not Consistent')\">\n                                        Not Consistent\n                                      </button>\n                                      <button class=\"status-pill status-pill--compliant\"\n                                        ng-click=\"updateSubmissionStatus(item, 'Consistent')\">\n                                        Consistent\n                                      </button>\n                                    </div>\n                                  </div>\n                                  \n                                \n                                </td>\n                                <td>\n                                  <div class=\"status-updated-info\">\n                                    <span class=\"status-updated-by\">{{item.status_last_updated_by ? item.status_last_updated_by : '--'}}</span>\n                                    <span class=\"status-updated-date-badge\" ng-if=\"item.status_last_updated_date\">\n                                      <i class=\"fa-solid fa-calendar\"></i>{{item.status_last_updated_date | date:'mediumDate'}}\n                                    </span>\n                                  </div>\n                                </td>\n                                  <td>\n                                <div ng-if=\"!item.excludeFromScoring && item.submitted_date\">\n                                  <span ng-if=\"currentUser.role !== 'Administrator'\">\n                                    {{item.score || '--'}}/{{item.max_score}}\n                                  </span>\n                                  <div ng-if=\"currentUser.role === 'Administrator'\" class=\"score-input-group\">\n                                    <input type=\"number\" \n                                          ng-model=\"item.score\" \n                                          ng-change=\"validateScore(item)\"\n                                          min=\"0\" \n                                          max=\"{{item.max_score}}\"\n                                          ng-blur=\"updateScore(item)\"\n                                          ng-keyup.enter=\"updateScore(item)\"\n                                          class=\"form-control score-input\"\n                                          placeholder=\"0\">\n                                    <span class=\"score-separator\">/</span>\n                                    <span class=\"max-score\">{{item.max_score}}</span>\n                                  </div>\n                                </div>\n                                <span ng-if=\"item.excludeFromScoring || !item.submitted_date\">--</span>\n                              </td>\n                                <td>\n                                  <div class=\"message-indicator\">\n                                    <a ng-click=\"showMessages(item)\" class=\"message-indicator\" title=\"View Messages\">\n                                      <i class=\"fa-solid\" ng-class=\"{\n                                              'fa-regular fa-envelope': !item.hasmessage,\n                                             'fa-solid fa-envelope': item.messages_count > 0,\n                                             'text-primary': (currentUser.organization === 'MTC' ? item.mtc_newmessages_count > 0 : item.newmessages_count > 0),\n                                             'text-muted': item.messages_count > 0 && (currentUser.organization === 'MTC' ? item.mtc_newmessages_count === 0 : item.newmessages_count === 0)\n                                           }\">\n                                      </i>\n                                      <span class=\"message-badge\" ng-if=\"(currentUser.organization === 'MTC' ? item.mtc_newmessages_count > 0 : item.newmessages_count > 0)\">\n                                        {{(currentUser.organization === 'MTC' ? item.mtc_newmessages_count : item.newmessages_count) | number}}\n                                      </span>\n                                    </a>\n                                  </div>\n                                </td>\n                              </tr>\n                            </tbody>\n                          </table>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n          </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"footer\" role=\"contentinfo\">\n      <sidebarfooter />\n    </div>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>\n"

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MyaccountComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _myaccount = __webpack_require__(123);
	
	var _myaccount2 = _interopRequireDefault(_myaccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var MyaccountComponent = exports.MyaccountComponent = function () {
	  /*@ngInject*/
	  function MyaccountComponent(navService, $scope, userService, $timeout, $state, baseConfigService, $http) {
	    _classCallCheck(this, MyaccountComponent);
	
	    this.navService = navService;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.userService = userService;
	    this.baseConfigService = baseConfigService;
	    this.$http = $http;
	    this.$scope.updateUserP = {};
	  }
	
	  _createClass(MyaccountComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$timeout(function () {
	        _this.userService.getCurrentUser().then(function (response) {
	          console.log(response);
	          _this.$scope.currentUser = response.data;
	          _this.userService.setCurrentUser(response.data);
	          _this.navService.getPage();
	
	          var userName = _this.$scope.currentUser.firstname || "";
	          _this.$scope.avatarLetter = userName.charAt(0).toUpperCase();
	        }).catch(function (err) {
	          console.log(err);
	          if (err.status === 403) {
	            _this.$state.go('login');
	          }
	        });
	      }, 1000);
	    }
	  }, {
	    key: 'updateUser',
	    value: function updateUser() {
	      var _this2 = this;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      console.log(this.$scope.currentUser);
	      var updateData = this.$scope.currentUser;
	      this.$scope.saving = true;
	
	      this.$http.post(adminBaseURL + '/users/update', updateData).then(function (responseReport) {
	        console.log(responseReport);
	        _this2.$scope.saving = false;
	      }).catch(function (err) {
	        console.log(err);
	        _this2.$scope.saving = false;
	        if (err.response === 403) {
	          _this2.$state.go('/login');
	        }
	      });
	    }
	  }, {
	    key: 'updateUserPwd',
	    value: function updateUserPwd() {
	      var _this3 = this;
	
	      console.log(this.$scope.updateUserP);
	      console.log(this.$scope.confirmPassword);
	
	      if (this.$scope.updateUserP.newPassword !== this.$scope.updateUserP.confirmPassword) {
	        return;
	      }
	
	      this.$scope.saving = true;
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      console.log(this.$scope.currentUser);
	      var updateData = {
	        uid: this.$scope.currentUser.id,
	        newPassword: this.$scope.updateUserP.newPassword
	      };
	
	      this.$http.post(adminBaseURL + '/users/update-pwd', updateData).then(function (responseReport) {
	        console.log(responseReport);
	        _this3.$scope.updateUserP = {};
	        _this3.$scope.saving = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.response === 403) {
	          _this3.$state.go('/login');
	        }
	      });
	    }
	  }]);
	
	  return MyaccountComponent;
	}();
	
	exports.default = angular.module('appApp.myaccount', [uiRouter]).config(_myaccount2.default).component('myaccount', {
	  template: __webpack_require__(124),
	  controller: MyaccountComponent,
	  controllerAs: 'myaccountCtrl'
	}).name;

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('myaccount', {
	    url: '/account/myaccount',
	    template: '<myaccount></myaccount>',
	    authenticate: true
	  });
	};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--account\">\n    <div class=\"page-wrapper\">\n        <div class=\"dashboard-header\">\n            <sidebarnav />\n        </div>\n        <div class=\"main\">\n            <mainheaderauth />\n\n            <div id=\"maincontent\" class=\"content container\">\n                <div class=\"row\">\n                    <div class=\"col-lg-8\">\n                        <h1 class=\"page-title--account\">Account Settings </h1>\n                        <div class=\"card account__content\">\n                            <div class=\"account__header\">\n                                <div class=\"account__avatar\">{{avatarLetter}}</div>\n                                <div class=\"account__user-details\">\n                                    <div class=\"account__name\">{{currentUser.firstname}} {{currentUser.lastname}}</div>\n                                    <div class=\"account__email\">{{currentUser.email}}</div>\n                                </div>\n                            </div>\n                            <div class=\"account__section\">\n                                <h2>Personal Details</h2>\n                                <div class=\"account__row\">\n                                    <div class=\"account__row--details\">\n                                        <h3>Name</h3>\n                                        <div class=\"link link--edit\">\n                                            <button class=\"button--inline-link\" data-bs-toggle=\"collapse\" data-bs-target=\"#accountName\" aria-expanded=\"false\" aria-controls=\"accountTitle\">Edit</button>\n                                        </div>\n                                    </div>\n                                    <div class=\"account__row--description\">\n                                        Edit the name that appears across the platform.\n                                    </div>\n                                    <div class=\"account__row--inputs collapse\" id=\"accountName\">\n                                        <form class=\"row test-validation-styling\" novalidate>\n                                            <div class=\"form-item col-lg-6\">\n                                                <label for=\"first_name\">First name:</label>\n                                                <input type=\"text\" placeholder=\"First name\" id=\"first_name\" ng-model=\"currentUser.firstname\" required>\n                                            </div>\n                                            <div class=\"form-item col-lg-6\">\n                                                <label for=\"last_name\">Last name:</label>\n                                                <input type=\"text\" placeholder=\"Last name\" id=\"last_name\" ng-model=\"currentUser.lastname\" required>\n                                            </div>\n                                            <div class=\"col-lg-12\">\n                                                <div class=\"form-item--submit\"><button type=\"submit\" class=\"button\" ng-click=\"myaccountCtrl.updateUser()\"><i class=\"fa-solid fa-cog fa-spin\" ng-show=\"saving\"></i> Save</button></div>\n                                            </div>\n                                        </form>\n                                    </div>\n                                </div>\n                                <div class=\"account__row\">\n                                    <div class=\"account__row--details\">\n                                        <h3>Title</h3>\n                                        <div class=\"link link--edit\">\n                                            <button class=\"button--inline-link\" data-bs-toggle=\"collapse\" data-bs-target=\"#accountTitle\" aria-expanded=\"false\" aria-controls=\"accountTitle\">Edit</button>\n                                        </div>\n                                    </div>\n                                    <div class=\"account__row--description\">\n                                        {{currentUser.title}}\n                                    </div>\n                                    <div class=\"account__row--inputs collapse\" id=\"accountTitle\">\n                                        <form class=\"row test-validation-styling\" novalidate>\n                                            <div class=\"form-item col-lg-12\">\n                                                <!-- <label for=\"title\">Title:</label> -->\n                                                <input type=\"text\" placeholder=\"Title\" id=\"title\" ng-model=\"currentUser.title\" required>\n                                            </div>\n                                            <div class=\"col-lg-12\">\n                                                <div class=\"form-item--submit\"><button type=\"submit\" class=\"button\" ng-click=\"myaccountCtrl.updateUser()\"><i class=\"fa-solid fa-cog fa-spin\" ng-show=\"saving\"></i> Save</button></div>\n                                            </div>\n                                        </form>\n                                    </div>\n                                </div>\n                                <div class=\"account__row\">\n                                    <div class=\"account__row--details\">\n                                        <h3>Organization</h3>\n                                        <!-- <div class=\"link link--edit\">\n                                            <button class=\"button--inline-link\" href=\"#\">Edit</button>\n                                        </div> -->\n                                    </div>\n                                    <div class=\"account__row--description\">\n                                        {{currentUser.organization}}\n                                    </div>\n                                </div>\n                                <div class=\"account__row\">\n                                    <div class=\"account__row--details\">\n                                        <h3>Phone</h3>\n                                        <div class=\"link link--edit\">\n                                            <button class=\"button--inline-link\" data-bs-toggle=\"collapse\" data-bs-target=\"#accountPhone\" aria-expanded=\"false\" aria-controls=\"accountPhone\">Edit</button>\n                                        </div>\n                                    </div>\n                                    <div class=\"account__row--description\">\n                                        {{currentUser.phone}}\n                                    </div>\n                                    <div class=\"account__row--inputs collapse\" id=\"accountPhone\">\n                                        <form class=\"row test-validation-styling\" novalidate ng-submit=\"updatePhone()\">\n                                            <div class=\"form-item col-lg-6\">\n                                                <!-- <label for=\"phone\">Phone:</label> -->\n                                                <input type=\"text\" id=\"phone\" ng-model=\"currentUser.phone\" placeholder=\"Phone number\" required>\n                                            </div>\n                                            <div class=\"col-lg-12\">\n                                                <div class=\"form-item--submit\">\n                                                    <div class=\"form-item--submit\"><button type=\"submit\" class=\"button\" ng-click=\"myaccountCtrl.updateUser()\"><i class=\"fa-solid fa-cog fa-spin\" ng-show=\"saving\"></i> Save</button></div>\n                                                </div>\n                                            </div>\n                                        </form>\n                                    </div>\n                                </div>\n                                \n                            </div>\n                            <div class=\"account__section\" ng-if=\"!currentUser.email.endsWith('@bayareametro.gov')\">\n                                <h2>Manage Account</h2>\n                                <div class=\"account__row\">\n                                    <div class=\"account__row--details\">\n                                        <h3>Email</h3>\n                                        <!-- <div class=\"link link--edit\">\n                                            <button class=\"button--inline-link\" href=\"#\">Edit</button>\n                                        </div> -->\n                                    </div>\n                                    <div class=\"account__row--description\">\n                                        {{currentUser.email}}\n                                    </div>\n                                </div>\n                                <div class=\"account__row\">\n                                    <div class=\"account__row--details\">\n                                        <h3>Password</h3>\n                                        <div class=\"link link--edit\">\n                                            <button class=\"button--inline-link\" data-bs-toggle=\"collapse\" data-bs-target=\"#accountPassword\" aria-expanded=\"false\" aria-controls=\"accountPassword\">Edit</button>\n                                        </div>\n                                    </div>\n                                    <div class=\"account__row--description\">\n                                        ••••••••\n                                    </div>\n                                    <div class=\"account__row--inputs collapse\" id=\"accountPassword\">\n                                        \n                                        <form class=\"row test-validation-styling\" novalidate>\n                                            <div class=\"form-item col-lg-6\">\n                                                <label for=\"new_password\">New Password:</label>\n                                                <input type=\"password\" id=\"new_password\" ng-model=\"updateUserP.newPassword\" placeholder=\"New Password\" required>\n                                            </div>\n                                            <div class=\"form-item col-lg-6\">\n                                                <label for=\"confirm_password\">Confirm Password:</label>\n                                                <input type=\"password\" id=\"confirm_password\" ng-model=\"updateUserP.confirmPassword\" placeholder=\"Confirm New Password\" required>\n                                            </div>\n                                             <!-- Error message block that will be shown if passwords do not match -->\n                                            <div ng-if=\"updateUserP.newPassword && updateUserP.confirmPassword && updateUserP.newPassword !== updateUserP.confirmPassword\" class=\"error-message\">\n                                                <p style=\"color: red; font-size: 14px;\">Passwords must match.</p>\n                                            </div>\n                                            \n                                            <div class=\"col-lg-12\">\n                                                <div class=\"form-item--submit\">\n                                                    <button type=\"submit\" class=\"button\" ng-click=\"myaccountCtrl.updateUserPwd()\"><i class=\"fa-solid fa-cog fa-spin\" ng-show=\"saving\"></i> Save</button>\n                                                </div>\n                                            </div>\n                                        </form>\n                                    </div>\n                                </div>\n                            </div>\n                            \n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter />\n        </div>\n    </div>\n</section>"

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DensityComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _density = __webpack_require__(126);
	
	var _density2 = _interopRequireDefault(_density);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var DensityComponent = exports.DensityComponent = function () {
	  /*@ngInject*/
	  function DensityComponent($state, $scope, $rootScope, fetch, lookup, userService, $stateParams) {
	    _classCallCheck(this, DensityComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.userService = userService;
	    this.$stateParams = $stateParams;
	    this.$scope.loadingData = true;
	
	    $scope.activityType = 'Density';
	    $scope.showTierOverride = false;
	
	    $scope.tier4Corridors = ["Bayshore Caltrain", "Orinda BART", "Lafayette BART", "Belmont Caltrain", "San Carlos Caltrain"];
	
	    $scope.dataDictionary = [{
	      "ID": 1,
	      "Field": "zn_recid",
	      "Field Alias": "Zoning Code ID"
	    }, {
	      "ID": 2,
	      "Field": "zn_county",
	      "Field Alias": "Zoning County"
	    }, {
	      "ID": 3,
	      "Field": "zn_jurisdiction",
	      "Field Alias": "Zoning Jurisdiction"
	    }, {
	      "ID": 4,
	      "Field": "zn_code",
	      "Field Alias": "Zoning Code"
	    }, {
	      "ID": 5,
	      "Field": "zn_description",
	      "Field Alias": "Zoning Description"
	    }, {
	      "ID": 6,
	      "Field": "zn_regional_code",
	      "Field Alias": "Zoning Regional Code"
	    }, {
	      "ID": 7,
	      "Field": "zn_regional_description",
	      "Field Alias": "Zoning Regional Description"
	    }, {
	      "ID": 8,
	      "Field": "allows_comm_office",
	      "Field Alias": "Allows Office"
	    }, {
	      "ID": 9,
	      "Field": "allows_residential",
	      "Field Alias": "Allows Residential"
	    }, {
	      "ID": 10,
	      "Field": "toc_min_dua",
	      "Field Alias": "Minimum Density"
	    }, {
	      "ID": 11,
	      "Field": "toc_max_dua",
	      "Field Alias": "Maximum Density"
	    }, {
	      "ID": 12,
	      "Field": "toc_max_far",
	      "Field Alias": "Maximum FAR"
	    }, {
	      "ID": 13,
	      "Field": "toc_min_far",
	      "Field Alias": "Minimum FAR"
	    }];
	
	    $scope.thresholds = [{
	      'tier': '1',
	      'threshold': {
	        toc_min_dua: 100,
	        toc_max_dua: 150,
	        toc_min_far: 4,
	        toc_max_far: 8
	      }
	    }, {
	      'tier': '2',
	      'threshold': {
	        toc_min_dua: 75,
	        toc_max_dua: 100,
	        toc_min_far: 3,
	        toc_max_far: 6
	      }
	    }, {
	      'tier': '3',
	      'threshold': {
	        toc_min_dua: 50,
	        toc_max_dua: 75,
	        toc_min_far: 2,
	        toc_max_far: 4
	      }
	    }, {
	      'tier': '4',
	      'threshold': {
	        toc_min_dua: 25,
	        toc_max_dua: 35,
	        toc_min_far: 1,
	        toc_max_far: 3
	      }
	    }];
	
	    $scope.note = '<strong>Note: Measurement units</strong><br/> DUA = Dwelling Units per Acre. <br/>FAR = Floor Area Ratio<br>';
	
	    $scope.getStationbyID = function (station) {
	      $scope.loadingData = true;
	      if (station) {
	        lookup.setCurrentStation(station);
	      }
	      fetch.getItem('api/data/density/averages/' + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	        $scope.currentStation = response.data[0];
	
	        $scope.overrideTierForSpecificCorridors($scope.currentStation);
	
	        if ($scope.currentStation && $scope.currentStation.service_tier) {
	          var tier = $scope.currentStation.service_tier.toString();
	          $scope.complianceThresholds = _.filter($scope.thresholds, { 'tier': tier })[0].threshold;
	        }
	
	        vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	        console.log("submission summary: ", $scope.submissionSummary);
	
	        $scope.loadingData = false;
	        console.log($scope.loadingData);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	
	      $scope.getActivity();
	    }.bind(this);
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        } else {
	          $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
	        }
	
	        lookup.setCurrentStation($scope.currentSelectedStationId);
	
	        $scope.getStationbyID();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getActivity = function () {
	      var activityData = [];
	      fetch.getAllItems('api/data/submission/activity/' + $scope.currentSelectedStationId + '/' + $scope.activityType).then(function (response) {
	        $scope.submissionActivity = response.data;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.overrideTierForSpecificCorridors = function (currentStation) {
	      console.log(currentStation);
	      if (currentStation) {
	        if ($scope.tier4Corridors.includes($scope.currentStation.station_name)) {
	          $scope.showTierOverride = true;
	
	          currentStation.service_tier = 4;
	
	          $scope.complianceThresholds = _.filter($scope.thresholds, { 'tier': '4' })[0].threshold;
	          $scope.complianceThresholdsTier3 = _.filter($scope.thresholds, { 'tier': '3' })[0].threshold;
	
	          $scope.complianceThresholds.toc_min_far = $scope.complianceThresholdsTier3.toc_min_far;
	          $scope.complianceThresholds.toc_max_far = $scope.complianceThresholdsTier3.toc_max_far;
	        } else {
	          $scope.showTierOverride = false;
	        }
	      }
	    }.bind(this);
	  }
	
	  _createClass(DensityComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	          _this3.lookup.setSubmissionPolicies(_this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Compliant' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Compliant' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Compliant' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Compliant' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return DensityComponent;
	}();
	
	exports.default = angular.module('appApp.density', [uiRouter]).config(_density2.default).component('density', {
	  template: __webpack_require__(127),
	  controller: DensityComponent,
	  controllerAs: 'densityCtrl'
	}).name;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('density', {
	    url: '/account/density',
	    template: '<density></density>',
	    authenticate: true
	  });
	};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--page dashboard--page--submission\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <breadcrumbnav></breadcrumbnav>\n      <maintocselection />\n      <!-- <maintocselectiondensity /> -->\n\n      <div class=\"container\" style=\"margin-left:242px;max-width: calc(100vw-242);\">\n        <div class=\"row\">\n          <div class=\"col-lg-8\">\n            <h1 class=\"page-title\">{{breadcrumb[0].linkTitle}}</h1>\n            <p>\n              The TOC Policy seeks to ensure local planning policies and zoning\n              regulations enable new development in TOC areas to be built at\n              sufficiently high densities to support transit ridership and\n              increase the proportion of trips taken by transit.\n            </p>\n\n            <div class=\"section-nav\"></div>\n            <div class=\"tab-content\">\n              <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\">\n                <div class=\"row mb-3\">\n                  <div class=\"col\">\n                    <p ng-if=\"currentStation && !showTierOverride\">\n                      There are four calculations of average density/intensity\n                      for the TOC area. The table below compares the average\n                      density/intensity for\n                      <span style=\"font-weight: bold\">\n                        {{currentStation.station_name}}\n                      </span>\n                      to the TOC Policy thresholds for a\n                      <span style=\"font-weight: bold\">Tier {{currentStation.service_tier}} station </span>.\n                    </p>\n                    <p ng-if=\"currentStation && showTierOverride\">\n                      There are four calculations of average density/intensity for the TOC area. As\n                      <strong>{{currentJurisdiction}}</strong> is a jurisdiction with less than 30,000 residents,\n                      the table below compares the average density/intensity for\n                      <strong>{{currentStation.station_name}}</strong> to the TOC Policy thresholds for residential\n                      density for a\n                      <strong>Tier 4 station</strong> and for commercial office intensity for a <strong>Tier 3\n                        station</strong>.\n                    </p>\n                  </div>\n                </div>\n\n                <div class=\"row mb-2\">\n                  <div class=\"col\">\n                    <h3>\n                      Average Density/Intensity Compared to TOC Policy\n                      Thresholds\n                    </h3>\n                  </div>\n                </div>\n                <!-- Notifications  -->\n                <div class=\"row mb-2\">\n                  <div class=\"col\">\n                    <div ng-show=\"!currentSelectedStationId\" class=\"alert alert-danger\" role=\"alert\">\n                      Please Select a Station Area!\n                    </div>\n                  </div>\n                </div>\n                <div class=\"row\" ng-show=\"loadingData\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                  <div class=\"col\">\n                    <div class=\"alert alert-info alert-dismissible fade show\" role=\"alert\">\n                      <i class=\"fa-solid fa-cog fa-spin\" style=\"\n                          font-weight: 400;\n                          padding-left: 0.25em;\n                          padding-right: 0.25em;\n                        \"></i>\n                      Updating Summaries...\n                      <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Residential Minimum Density\n                            </div>\n                            <div class=\"row\">\n                              <div class=\"col-md-8\">\n                                <div class=\"fs-1 lh-1\">\n                                  <!-- {{currentStation.weighted_average_toc_min_dua !== 'NaN' ?\n                                  currentStation.weighted_average_toc_min_dua : '--'}} -->\n                                  {{currentSelectedStationId ? (currentStation.weighted_average_toc_min_dua &&\n                                  currentStation.weighted_average_toc_min_dua !== 'NaN' ?\n                                  currentStation.weighted_average_toc_min_dua : '--') : '--'}}\n                                </div>\n                              </div>\n                              <div class=\"col-md-12\">\n                                <span>\n                                  Min:\n                                  <span ng-if=\"densityCtrl.tier4Corridors.includes(currentStation.station_name)\">\n                                    {{densityCtrl.overrideTierForSpecificCorridors(currentStation).toc_min_dua |\n                                    number:1}}\n                                  </span>\n                                  <span ng-if=\"!densityCtrl.tier4Corridors.includes(currentStation.station_name)\">\n                                    {{complianceThresholds.toc_min_dua | number:1}}\n                                  </span>\n                                  DUA\n                                </span>\n                              </div>\n                            </div>\n                          </div>\n                          <!-- <div class=\"d-flex align-items-end\">\n                            <i ng-if=\"currentStation.weighted_average_toc_min_dua >= (densityCtrl.tier4Corridors.includes(currentStation.station_name) ? densityCtrl.overrideTierForSpecificCorridors(currentStation).toc_min_dua : complianceThresholds.toc_min_dua)\"\n                              class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                            <i ng-if=\"currentStation.weighted_average_toc_min_dua < (densityCtrl.tier4Corridors.includes(currentStation.station_name) ? densityCtrl.overrideTierForSpecificCorridors(currentStation).toc_min_dua : complianceThresholds.toc_min_dua)\"\n                              class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                          </div> -->\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Residential Allowable Maximum*\n                            </div>\n                            <div class=\"row\">\n                              <div class=\"col-md-8\">\n                                <div class=\"fs-1 lh-1\">\n                                  <!-- {{currentStation.weighted_average_toc_max_dua !== 'NaN' ? currentStation.weighted_average_toc_max_dua : '--'}} -->\n                                  {{currentSelectedStationId ? (currentStation.weighted_average_toc_max_dua &&\n                                  currentStation.weighted_average_toc_max_dua !== 'NaN' ?\n                                  currentStation.weighted_average_toc_max_dua : '--') : '--'}}\n                                </div>\n                              </div>\n                              <div class=\"col-md-12\">\n                                <span>\n                                  Min:\n                                  <span ng-if=\"densityCtrl.tier4Corridors.includes(currentStation.station_name)\">\n                                    {{densityCtrl.overrideTierForSpecificCorridors(currentStation).toc_max_dua |\n                                    number:1}}\n                                  </span>\n                                  <span ng-if=\"!densityCtrl.tier4Corridors.includes(currentStation.station_name)\">\n                                    {{complianceThresholds.toc_max_dua | number:1}}\n                                  </span>\n                                  DUA\n                                </span>\n                              </div>\n                            </div>\n                          </div>\n                          <!-- <div class=\"d-flex align-items-end\">\n                            <i ng-if=\"currentStation.weighted_average_toc_max_dua >= (densityCtrl.tier4Corridors.includes(currentStation.station_name) ? densityCtrl.overrideTierForSpecificCorridors(currentStation).toc_max_dua : complianceThresholds.toc_max_dua)\"\n                              class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                            <i ng-if=\"currentStation.weighted_average_toc_max_dua < (densityCtrl.tier4Corridors.includes(currentStation.station_name) ? densityCtrl.overrideTierForSpecificCorridors(currentStation).toc_max_dua : complianceThresholds.toc_max_dua)\"\n                              class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                          </div> -->\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Office Minimum FAR\n                            </div>\n                            <div class=\"row\">\n                              <div class=\"col-md-8\">\n                                <div class=\"fs-1 lh-1\">\n                                  <!-- {{currentStation.weighted_average_toc_min_far !== 'NaN' ?\n                                  currentStation.weighted_average_toc_min_far : '--'}} -->\n                                  {{currentSelectedStationId ? (currentStation.weighted_average_toc_min_far &&\n                                  currentStation.weighted_average_toc_min_far !== 'NaN' ?\n                                  currentStation.weighted_average_toc_min_far : '--') : '--'}}\n                                </div>\n                              </div>\n                              <div class=\"col-md-12\">\n                                <span>Min: {{complianceThresholds.toc_min_far | number:1}} FAR</span>\n                              </div>\n                            </div>\n                          </div>\n                          <!-- <div class=\"d-flex align-items-end\">\n                            <i ng-if=\"currentStation.weighted_average_toc_min_far >= complianceThresholds.toc_min_far\"\n                              class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                            <i ng-if=\"currentStation.weighted_average_toc_min_far < complianceThresholds.toc_min_far\"\n                              class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                          </div> -->\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Office Allowable Maximum FAR*\n                            </div>\n                            <div class=\"row\">\n                              <div class=\"col-md-8\">\n                                <div class=\"fs-1 lh-1\">\n                                  <!-- {{currentStation.weighted_average_toc_max_far !== 'NaN' ?\n                                  currentStation.weighted_average_toc_max_far : '--'}} -->\n                                  {{currentSelectedStationId ? (currentStation.weighted_average_toc_max_far &&\n                                  currentStation.weighted_average_toc_max_far !== 'NaN' ?\n                                  currentStation.weighted_average_toc_max_far : '--') : '--'}}\n                                </div>\n                              </div>\n                              <div class=\"col-md-12\">\n                                <span>Min: {{complianceThresholds.toc_max_far | number:1}} FAR</span>\n                              </div>\n                            </div>\n                          </div>\n                          <!-- <div class=\"d-flex align-items-end\">\n                            <i ng-if=\"currentStation.weighted_average_toc_max_far >= complianceThresholds.toc_max_far\"\n                              class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                            <i ng-if=\"currentStation.weighted_average_toc_max_far < complianceThresholds.toc_max_far\"\n                              class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                          </div> -->\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n                <p style=\"font-style: italic\">\n                  &#42; A jurisdiction is not required to adopt maximum\n                  allowable density/intensity standards. However, if it does, it\n                  must meet or exceed the TOC Policy’s thresholds.\n                </p>\n                <p>\n                  Jurisdictions should review data about the\n                  <a ui-sref=\"residential_uses\">residential</a> and\n                  <a ui-sref=\"commercial_uses\">commercial office</a> zoning and\n                  update it as needed. Review\n                  <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\"\n                    target=\"_blank\" rel=\"noopener noreferrer\">Section 1 of\n                    the TOC Policy Administrative Guidance<span class=\"visually-hidden\">(link is external, opens in a\n                      new window)</span></a>\n                  for the full details about TOC Policy standards, an\n                  overview of the average density calculations, instructions for\n                  determining density/intensity equivalencies if a zoning\n                  district does not use these metrics to regulate development,\n                  and guidance for how to handle mixed-use zones and other\n                  special circumstances.\n                </p>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-lg-3\" style=\"padding-top: 40px\">\n            <div class=\"right-content\">\n              <h2>Activity</h2>\n              <!-- sidebaractivity source /components/directives/sidebaractivity  -->\n              <sidebaractivity></sidebaractivity>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- <submissionsectionsubmit /> -->\n    <div class=\"footer\" role=\"contentinfo\">\n      <sidebarfooter />\n    </div>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DensityRequirementsComponent = undefined;
	
	var _density_requirements = __webpack_require__(129);
	
	var _density_requirements2 = _interopRequireDefault(_density_requirements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var DensityRequirementsComponent =
	/*@ngInject*/
	exports.DensityRequirementsComponent = function DensityRequirementsComponent() {
	  _classCallCheck(this, DensityRequirementsComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('websiteApp.density_requirements', [uiRouter]).config(_density_requirements2.default).component('densityRequirements', {
	  template: __webpack_require__(130),
	  controller: DensityRequirementsComponent,
	  controllerAs: 'densityRequirementsCtrl'
	}).name;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('density_requirements', {
	    url: '/account/density/density_requirements',
	    template: '<density-requirements></density-requirements>',
	    authenticate: true
	  });
	};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = "<section\n  class=\"dashboard dashboard--page dashboard--page--submission dashboard--density-compliance\"\n>\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <breadcrumbnav></breadcrumbnav>\n      <maintocselection></maintocselection>\n\n      <div class=\"content container\">\n        <div class=\"row\">\n          <div class=\"col-lg-8\">\n            <pageintro></pageintro>\n            <div class=\"section-nav\">\n              <div class=\"menu--section-title\">In this section:</div>\n              <ul class=\"menu menu--section\" role=\"tablist\">\n                <li\n                  data-bs-toggle=\"tab\"\n                  data-bs-target=\"#section-1\"\n                  class=\"menu-item menu-item--section active\"\n                >\n                  <span class=\"section-number\">I.</span\n                  ><a href=\"#\">TOC Policy Density Requirements</a\n                  ><span class=\"icon icon--status icon--status--in-progress\"\n                    ><i\n                      class=\"fa-light fa-clock\"\n                      data-bs-toggle=\"tooltip\"\n                      data-bs-title='<i class=\"fa-light fa-clock me-2\"></i>In Progress'\n                      data-bs-html=\"true\"\n                      data-bs-offset=\"0,8\"\n                      data-bs-custom-class=\"menu-item-tooltip\"\n                    ></i\n                  ></span>\n                </li>\n              </ul>\n              <note ng-if=\"note\" ng-bind-html=\"note\"></note>\n            </div>\n            <div class=\"tab-content\">\n              <div\n                id=\"section-1\"\n                role=\"tabpanel\"\n                class=\"section tab-pane active\"\n              >\n                <div class=\"row mb-5\">\n                  <div class=\"col\">\n                    <h2>I. TOC Policy Density Requirements</h2>\n                    <statuspills />\n                    <p>\n                      Sum dolor sit amet, cons ectetuer adipiscing elit, sed\n                      diam nonummy nibh euismod tincidunt ut laoreet dolore\n                      magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n                    </p>\n                  </div>\n                </div>\n                <div class=\"row mb-5\">\n                  <div class=\"col\">\n                    <h3 class=\"mb-2\">\n                      Lake Merritt BART: Tier Level 2\n                      <i class=\"fa-solid fa-chart-simple\"></i>\n                    </h3>\n                    <table class=\"table table--data-table\">\n                      <thead class=\"table-dark\">\n                        <tr>\n                          <th>\n                            <div class=\"th-inner\">Land Use Type</div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">Minimum Density</div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Allowable Maximum Density\n                            </div>\n                          </th>\n                        </tr>\n                      </thead>\n                      <tbody>\n                        <tr>\n                          <td>Residential</td>\n                          <td>50</td>\n                          <td>80</td>\n                        </tr>\n                        <tr>\n                          <td>Commercial Office</td>\n                          <td>10</td>\n                          <td>30</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n                <div class=\"row mb-2\">\n                  <div class=\"col\">\n                    <h3>Current Density Compliance</h3>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex flex-row align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Average Minimum Density for Residential<br /><br />\n                            </div>\n                            <div class=\"fs-1 lh-1\">47</div>\n                          </div>\n                          <i class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex flex-row align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Average Allowable Maximum Density for Residential\n                            </div>\n                            <div class=\"fs-1 lh-1\">75</div>\n                          </div>\n                          <i class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex flex-row align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Average Minimum Density for Commercial Office\n                            </div>\n                            <div class=\"fs-1 lh-1\">8</div>\n                          </div>\n                          <i class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex flex-row align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Average Allowable Maximum Density for Commercial\n                              Office\n                            </div>\n                            <div class=\"fs-1 lh-1\">20</div>\n                          </div>\n                          <i class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-lg-4\" style=\"padding-top: 40px\">\n            <div class=\"right-content\">\n              <h2>Activity</h2>\n              <!-- sidebaractivity source /components/directives/sidebaractivity  -->\n              <sidebaractivity></sidebaractivity>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- <submissionsectionsubmit /> -->\n    <div class=\"footer\" role=\"contentinfo\">\n      <sidebarfooter />\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DensityComplianceComponent = undefined;
	
	var _density_compliance = __webpack_require__(132);
	
	var _density_compliance2 = _interopRequireDefault(_density_compliance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var DensityComplianceComponent =
	/*@ngInject*/
	exports.DensityComplianceComponent = function DensityComplianceComponent() {
	  _classCallCheck(this, DensityComplianceComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.density_compliance', [uiRouter]).config(_density_compliance2.default).component('densityCompliance', {
	  template: __webpack_require__(133),
	  controller: DensityComplianceComponent,
	  controllerAs: 'densityComplianceCtrl'
	}).name;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('density_compliance', {
	    url: '/account/density/density_compliance',
	    template: '<density-compliance></density-compliance>',
	    authenticate: true
	  });
	};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--content--housing\">\n  <div class=\"page-wrapper\">\n      <div class=\"dashboard-header\">\n        <!-- Sidebarnav source components/directives/sidebarnav  -->\n          <sidebarnav></sidebarnav>\n      </div>\n      <div class=\"main\">\n        <!-- mainheaderauth source components/directives/mainheaderauth  -->\n          <mainheaderauth></mainheaderauth>\n          <div class=\"content container\">\n              <div class=\"row\">\n                  <div class=\"col-lg-8\">\n                      <h1 class=\"page-title\">Density Compliance </h1>\n                      <div class=\"page-summary\">Affordable Housing Production, Preservation, and Protection and Commercial Stabilization</div>\n                      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                      <figure>\n                          <img class=\"image--full\" src=\"../../../assets/images/mockups/dashboard-content-image.jpg\" alt=\"Person wearing a mask and helmet on a bike\" height=\"730\" width=\"410\"/>\n                          <figcaption>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. <span class=\"image-credit\">Credit: Sergio Ruiz</span></figcaption>\n                      </figure>\n\n                      <h2><a href=\"#\">Further Guidance H2</a></h2>\n                      <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n\n                      <h2><a href=\"#\">Affordable Housing Production Policy</a></h2>\n                      <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                  </div>\n                 \n              </div>\n          </div>\n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n          <sidebarfooter></sidebarfooter>\n      </div>\n  </div>\n</section>\n"

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CommercialUsesComponent = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(116);
	
	var _commercial_uses = __webpack_require__(135);
	
	var _commercial_uses2 = _interopRequireDefault(_commercial_uses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var CommercialUsesComponent = exports.CommercialUsesComponent = function () {
	  /*@ngInject*/
	  function CommercialUsesComponent($state, $scope, $rootScope, fetch, lookup, userService, $http, baseConfigService, $location, $stateParams, $timeout) {
	    _classCallCheck(this, CommercialUsesComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$state = $state;
	    this.userService = userService;
	    this.$location = $location;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	    this.$http = $http;
	    $scope.savemode = null;
	    $scope.densityType = 'Commercial';
	    $scope.showTierException = false;
	    $scope.updateData = [];
	    $scope.initialLoad = true;
	    $scope.density = {};
	
	    $scope.adminUnlocked = false;
	    $scope.submitDensityForReview = false;
	    $scope.pendingChanges = false;
	    $scope.commercialUsesCheck = false;
	    $scope.submitmode = null;
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.submissions = [];
	    $scope.baseUrl = baseConfigService.getBaseURL();
	    $scope.policy_name = 'Commercial Office Uses Data Verification';
	
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.scrollToTop = function () {
	      window.scrollTo(0, 0);
	    };
	
	    $scope.commercial_density_no_changes_checked = false;
	    $scope.commercial_density_table_changes_checked = false;
	
	    $scope.setPending = function () {
	      console.log('set pending ran');
	      console.log($scope.initialLoad);
	      if (!$scope.initialLoad) {
	        $scope.savemode = 'validation';
	        $scope.pendingChanges = true;
	      }
	    };
	
	    $scope.thresholds = [{
	      'tier': '1',
	      'threshold': {
	        toc_min_dua: 100,
	        toc_max_dua: 150,
	        toc_min_far: 4,
	        toc_max_far: 8
	      }
	    }, {
	      'tier': '2',
	      'threshold': {
	        toc_min_dua: 75,
	        toc_max_dua: 100,
	        toc_min_far: 3,
	        toc_max_far: 6
	      }
	    }, {
	      'tier': '3',
	      'threshold': {
	        toc_min_dua: 50,
	        toc_max_dua: 75,
	        toc_min_far: 2,
	        toc_max_far: 4
	      }
	    }, {
	      'tier': '4',
	      'threshold': {
	        toc_min_dua: 25,
	        toc_max_dua: 35,
	        toc_min_far: 1,
	        toc_max_far: 3
	      }
	    }];
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentDensityPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.stationStatus) {
	        for (var i = 0; i < $scope.stationStatus.length; i++) {
	          if ($scope.stationStatus[i].submission_policy_name === $scope.policy_name) {
	            submission = $scope.stationStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentDensityPolicy;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.stationStatus && $scope.policy_name) {
	        var sub = _.find($scope.stationStatus, { submission_policy_name: $scope.policy_name });
	        if (sub && sub.submitted && sub.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('stationStatus', function () {
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm("Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.");
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.stationStatus) {
	        for (var i = 0; i < $scope.stationStatus.length; i++) {
	          if ($scope.stationStatus[i].submission_policy_name === $scope.policy_name) {
	            submission = $scope.stationStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error("No matching submission found to withdraw");
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', payload).then(function () {
	        submission.submitted = false;
	        submission.status = null;
	
	        if ($scope.policy_name === 'Residential Uses Data Verification') {
	          $scope.residentialUsesCheck = false;
	          $scope.density.residentialUsesCheck = false;
	        } else if ($scope.policy_name === 'Commercial Office Uses Data Verification') {
	          $scope.commercialUsesCheck = false;
	          $scope.density.commercialUsesCheck = false;
	        } else if ($scope.policy_name === 'Minimum FAR Office') {
	          $scope.minFAR = false;
	        } else if ($scope.policy_name === 'Maximum FAR Office') {
	          $scope.maxFAR = false;
	        }
	
	        if (!$scope.minFAR && !$scope.maxFAR && !$scope.residentialUsesCheck && !$scope.commercialUsesCheck) {
	          $scope.submitted = false;
	        }
	
	        $scope.submissions = $scope.submissions.filter(function (s) {
	          return s.submission_id !== submission.submission_id;
	        });
	
	        if ($scope.submissions.length === 0) {
	          $scope.submitmode = null;
	        }
	
	        var formId = $scope.currentDensityPolicy ? $scope.currentDensityPolicy.density_form_id : null;
	        $scope.currentDensityPolicy = { density_form_id: formId };
	        if ($scope.hot) {
	          $scope.hot.loadData([]);
	        }
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	
	        $scope.formReadOnly = false;
	      }).catch(function (err) {
	        console.error('Withdraw failed:', err);
	        alert('There was an error withdrawing the submission. Please try again.');
	      });
	    };
	
	    $scope.onCommercialCheckboxChange = function (type) {
	      if (type === 'noChanges' && $scope.currentDensityPolicy.commercial_density_no_changes_checked) {
	        $scope.currentDensityPolicy.commercial_density_table_changes_checked = false;
	      }
	      if (type === 'tableChanges' && $scope.currentDensityPolicy.commercial_density_table_changes_checked) {
	        $scope.currentDensityPolicy.commercial_density_no_changes_checked = false;
	      }
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	      console.log($scope.submissions);
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'density';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getZoningCodes = function (jurisdiction) {
	      var _this = this;
	
	      $scope.loadingTable = true;
	      $scope.currentJurisdiction = jurisdiction;
	      lookup.setJurisdiction($scope.currentJurisdiction);
	      fetch.getAllItems('api/data/density/zoning/' + jurisdiction).then(function (response) {
	        $scope.znCodes = response.data;
	        $scope.loadingTable = false;
	        $scope.initialLoad = false;
	        $scope.znCodes.forEach(function (element) {
	
	          element.last_edited = moment(element.last_edited).format('L');
	
	          if (element.zn_code_url) {
	            element.zn_code_url = '<a href=\'' + element.zn_code_url + '\' target=\'_blank\'>' + element.zn_code_url + '</a>';
	          }
	        });
	        $scope.znCodes = _.orderBy($scope.znCodes, 'allows_comm_office', 'desc');
	        $scope.loadTable($scope.znCodes);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    };
	
	    $scope.loadTable = function (data) {
	      var container = document.querySelector('#handsOnTable');
	
	      function strip_tags(input, allowed) {
	        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
	            commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
	
	        allowed = (((allowed || "") + "").toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
	
	        return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
	          return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
	        });
	      }
	
	      function safeHtmlRenderer(instance, td, row, col, prop, value, cellProperties) {
	        var escaped = Handsontable.helper.stringify(value);
	        escaped = strip_tags(escaped, '<em><b><strong><a><big>');
	        td.innerHTML = escaped;
	
	        return td;
	      }
	
	      if (typeof $scope.hot !== 'undefined') {
	        $scope.hot.loadData(data);
	        $scope.hot.render();
	      } else {
	        var _ref;
	
	        $scope.hot = new Handsontable(container, (_ref = {
	          data: data,
	          colHeaders: false,
	          nestedHeaders: [['ID', 'Zoning ID', 'Jurisdiction', 'Zoning Code', 'Description', 'Allows <br> Office', "Min FAR", "Max FAR", "Calculated Using <br> Height", "Acres <br> Within Zone", "Acres of Existing <br> Commercial Office Excluded", "Documentation", "Last Edited", "Editor"]],
	          allowInsertRow: true,
	          manualColumnResize: true,
	          height: 600,
	          overflow: 'auto',
	          colWidths: [null, null, null, 40, 150, 50, 30, 30, 60, 60, 180],
	          stretchH: 'all',
	          autoWrapRow: true,
	          rowHeaders: true,
	          filters: true,
	
	          dropdownMenu: ["filter_by_condition", "filter_by_value", "filter_action_bar"],
	          manualColumnMove: true,
	          manualColumnFreeze: true }, _defineProperty(_ref, 'manualColumnResize', true), _defineProperty(_ref, 'multiColumnSorting', {
	          indicator: true
	        }), _defineProperty(_ref, 'columns', [{ data: 'rec_id' }, { data: 'zn_recid' }, {
	          data: 'jurisdiction',
	          type: 'text'
	        }, { data: 'zn_code' }, { data: 'zn_description' }, {
	          data: 'allows_comm_office',
	          type: "checkbox",
	          className: "htCenter"
	        }, {
	          data: 'toc_min_far',
	          type: 'numeric'
	        }, {
	          data: 'toc_max_far',
	          type: 'numeric'
	        }, {
	          data: 'use_height',
	          type: 'checkbox',
	          className: "htCenter"
	        }, {
	          data: 'acres_within_zone',
	          editor: false
	        }, {
	          data: 'acres_excluded',
	          editor: false
	        }, {
	          data: 'zn_code_url',
	          renderer: 'html'
	        }, {
	          data: 'last_edited',
	          type: 'date',
	          dateFormat: 'MM/DD/YYYY',
	          correctFormat: true,
	          defaultDate: '01/01/1900',
	
	          datePickerConfig: {
	            firstDay: 0,
	            showWeekNumber: true,
	            disableDayFn: function disableDayFn(date) {
	              return date.getDay() === 0 || date.getDay() === 6;
	            }
	          }
	        }, {
	          data: 'editor_id',
	          editor: false
	        }]), _defineProperty(_ref, 'hiddenColumns', {
	          columns: [0, 1, 2],
	          indicators: true
	        }), _defineProperty(_ref, 'minSpareRows', 1), _defineProperty(_ref, 'licenseKey', 'non-commercial-and-evaluation'), _defineProperty(_ref, 'readOnly', !!$scope.formReadOnly), _defineProperty(_ref, 'afterValidate', function afterValidate(isValid, value, row, prop, source) {}), _ref));
	
	        $scope.hot.addHook("afterChange", function (changes, source) {
	
	          if (changes && source !== 'UndoRedo.undo') {
	            changes.forEach(function (_ref2) {
	              var _$scope$updateData$pu;
	
	              var _ref3 = _slicedToArray(_ref2, 4),
	                  row = _ref3[0],
	                  prop = _ref3[1],
	                  oldValue = _ref3[2],
	                  newValue = _ref3[3];
	
	              if (newValue === '') {
	                newValue = null;
	              }
	              var handsonUpdate = $scope.hot.getDataAtRow(row);
	              $scope.updateData.push((_$scope$updateData$pu = {
	                rec_id: handsonUpdate[0],
	                zn_recid: handsonUpdate[1]
	              }, _defineProperty(_$scope$updateData$pu, prop, newValue), _defineProperty(_$scope$updateData$pu, prop + '_old', oldValue), _$scope$updateData$pu));
	            });
	            $scope.beforeSave();
	          }
	        });
	      }
	      $scope.$watch('formReadOnly', function (newVal) {
	        if ($scope.hot) {
	          $scope.hot.updateSettings({
	            readOnly: !!newVal
	          });
	          $scope.hot.render();
	        }
	      });
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	      console.log($scope.submissions);
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'density';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      $scope.getZoningCodes(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        }
	
	        $scope.getStationbyID();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationbyID = function () {
	      $scope.pendingAverages = false;
	      lookup.setCurrentStation($scope.currentSelectedStationId);
	      $scope.loading = true;
	      $scope.loadingTable = true;
	      setTimeout(function () {
	        fetch.getItem('api/data/density/averages/' + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	          $scope.currentStation = response.data[0];
	
	          $scope.loading = false;
	          $scope.getSubmissionStatus($scope.currentSelectedStationId);
	          $scope.getZoningCodesByParcel($scope.currentSelectedStationId);
	
	          if ($scope.currentStation && $scope.currentStation.service_tier) {
	            var tier = $scope.currentStation.service_tier.toString();
	            $scope.complianceThresholds = _.filter($scope.thresholds, { 'tier': tier })[0].threshold;
	          }
	
	          vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	          return $scope.getCurrentDensityPolicy($scope.policy_name);
	        }).catch(function (err) {
	          console.log(err);
	          if (err.status === 403) {
	            $state.go('login');
	          }
	        });
	      }, 2000);
	    };
	
	    $scope.getCurrentDensityPolicy = function (policy_name) {
	
	      if (policy_name) {
	        $scope.policy_name = policy_name;
	      }
	      console.log('policy_name:', policy_name);
	
	      fetch.getAllItems('api/data/getDensityForm/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + encodeURIComponent($scope.policy_name)).then(function (response) {
	
	        if (response.data && response.data.length > 0) {
	          $scope.currentDensityPolicy = response.data[0];
	
	          console.log('density_form_id:', $scope.currentDensityPolicy.density_form_id);
	          if (policy_name === 'Residential Uses Data Verification') {
	            if ($scope.residential_density_no_changes_checked) {
	              $scope.residential_density_no_changes_checked = true;
	            }
	            if ($scope.residential_density_table_changes_checked) {
	              $scope.residential_density_table_changes_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_density_equivalency_table) {
	              $scope.residential_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_density_equivalency_table) {
	              $scope.residential_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_density_exclude_parcels) {
	              $scope.residential_density_exclude_parcels_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_density_adopted_plan) {
	              $scope.residential_density_adopted_plan_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_exclude_parcels_additional_details) {
	              $scope.residential_density_exclude_parcels_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_equivalency_table_additional_details) {
	              $scope.residential_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_adopted_plan_additional_details) {
	              $scope.residential_density_adopted_plan_checked = true;
	            }
	          }
	          if (policy_name === 'Commercial Office Uses Data Verification') {
	            if ($scope.currentDensityPolicy.commercial_density_equivalency_table) {
	              $scope.commercial_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_density_adopted_plan) {
	              $scope.commercial_density_adopted_plan_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_density_exclude_parcels) {
	              $scope.commercial_density_exclude_parcels_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_exclude_parcels_additional_details) {
	              $scope.commercial_density_exclude_parcels_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_equivalency_table_additional_details) {
	              $scope.commercial_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_adopted_plan_additional_details) {
	              $scope.commercial_density_adopted_plan_checked = true;
	            }
	          }
	          $scope.initialLoad = false;
	          console.log($scope.initialLoad);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentDensityPolicy = function () {
	
	      $scope.formSubmitted = true;
	      if (densityForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      Object.keys($scope.currentDensityPolicy).forEach(function (key) {
	        if ($scope.currentDensityPolicy[key] === "" || $scope.currentDensityPolicy[key] === undefined) {
	          $scope.currentDensityPolicy[key] = null;
	        }
	      });
	
	      console.log("Payload being sent:", $scope.currentDensityPolicy);
	      fetch.updateItem('api/data/density/forms/update', $scope.currentDensityPolicy).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.saved = false;
	          $scope.savemode = null;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getSubmissionStatus = function (stationId) {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + stationId, 'Density').then(function (response) {
	        $scope.stationStatus = response.data;
	
	        var minFARResult = _.filter($scope.stationStatus, { submission_policy_name: 'Minimum FAR Office' });
	        $scope.minFAR = minFARResult.length > 0 ? minFARResult[0].submitted : false;
	
	        var maxFARResult = _.filter($scope.stationStatus, { submission_policy_name: 'Maximum FAR Office' });
	        $scope.maxFAR = maxFARResult.length > 0 ? maxFARResult[0].submitted : false;
	
	        var commercialUses = _.filter($scope.stationStatus, { submission_policy_name: 'Commercial Office Uses Data Verification' });
	        if (commercialUses.length > 0) {
	          commercialUses.forEach(function (element) {
	            if (element.submitted === true) {
	              $scope.commercialUsesCheck = true;
	            }
	          });
	        }
	
	        if ($scope.minFAR || $scope.maxFAR || $scope.commercialUsesCheck) {
	          $scope.submitted = true;
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getZoningCodesByParcel = function (station) {
	      fetch.getAllItems('api/data/density/zoningcodes/' + $scope.densityType + '/' + $scope.currentJurisdiction + '/' + encodeURIComponent(station), $scope.znCodes).then(function (response) {
	        $scope.znCodes.forEach(function (element) {
	          var znCodeAreaInclude = _.filter(response.data, { zn_code: element.zn_code, exclude: false })[0];
	          if (znCodeAreaInclude && znCodeAreaInclude.total_gisacre) {
	            element.acres_within_zone = parseFloat(znCodeAreaInclude.total_gisacre).toFixed(2);
	          }
	
	          var znCodeAreaExclude = _.filter(response.data, { zn_code: element.zn_code, exclude: true })[0];
	          if (znCodeAreaExclude && znCodeAreaExclude.total_gisacre) {
	            element.acres_excluded = parseFloat(znCodeAreaExclude.total_gisacre).toFixed(2);
	          }
	        });
	
	        var highlightedZnCodes = new Set(response.data.map(function (item) {
	          return item.zn_code;
	        }));
	
	        var highlightedRows = [];
	        var nonHighlightedRows = [];
	
	        $scope.znCodes.forEach(function (row) {
	          if (highlightedZnCodes.has(row.zn_code)) {
	            highlightedRows.push(row);
	          } else {
	            nonHighlightedRows.push(row);
	          }
	        });
	
	        var sortedZnCodes = highlightedRows.concat(nonHighlightedRows);
	
	        $scope.hot.updateSettings({
	          data: sortedZnCodes,
	          cells: function cells(row, col) {
	            var cellProperties = {};
	            var znCode = $scope.hot.getDataAtCell(row, 3);
	
	            if (highlightedZnCodes.has(znCode)) {
	              if (col === 5 || col === 8) {
	                cellProperties.className = 'highlightRow htCenter';
	              } else {
	                cellProperties.className = 'highlightRow';
	              }
	            }
	
	            return cellProperties;
	          }
	        });
	
	        $scope.loadingTable = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById('fileInput' + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
	            alert('Please select a PDF, Word document, or Excel file.');
	            element.value = '';
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById('' + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope[ngmodel] = '';
	        $scope[ngmodel + '_preview'] = '';
	        $scope['fileUploading_' + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope['fileUploading_' + ngmodelfile] = true;
	      var file = document.getElementById('' + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentDensityPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentDensityPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'validation';
	      $scope.pendingChanges = true;
	    };
	
	    $scope.deleteZoningCodes = function () {
	      $scope.saving = true;
	
	      $scope.updateData = [];
	      $scope.znCodes.forEach(function (element) {
	        if (element.selected) {
	          $scope.updateData.push(element);
	        }
	      });
	      $scope.saving = true;
	      fetch.updateItem('api/data/density/zoning/delete', $scope.updateData).then(function (response) {
	
	        $scope.znCodes = _.filter($scope.znCodes, function (o) {
	          return !o.selected;
	        });
	        $scope.saving = false;
	        $scope.updateData = [];
	        $scope.hot.loadData($scope.znCodes);
	        $('#deleteZoningCodeModal').modal('toggle');
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.addZoningCode = function () {
	      $scope.saving = true;
	      $scope.addCode.rec_id = lookup.getUUID();
	      if ($scope.jurisdictionDetail) {
	        $scope.addCode.jurisdiction_id = $scope.jurisdictionDetail.jurisdiction_id;
	        $scope.addCode.county_id = $scope.jurisdictionDetail.county_id;
	      }
	
	      $scope.addCode.zn_recid = $scope.currentJurisdiction + '-' + $scope.addCode.zn_code;
	
	      if ($scope.addCode.zn_min_dua) {
	        $scope.addCode.toc_min_dua = $scope.addCode.zn_min_dua;
	      } else {
	        $scope.addCode.toc_min_dua = null;
	        $scope.addCode.zn_min_dua = null;
	      }
	      if ($scope.addCode.zn_max_dua) {
	        $scope.addCode.toc_max_dua = $scope.addCode.zn_max_dua;
	      } else {
	        $scope.addCode.toc_max_dua = null;
	        $scope.addCode.zn_max_dua = null;
	      }
	      if ($scope.addCode.zn_min_far) {
	        $scope.addCode.toc_min_far = $scope.addCode.zn_min_far;
	      } else {
	        $scope.addCode.toc_min_far = null;
	        $scope.addCode.zn_min_far = null;
	      }
	      if ($scope.addCode.zn_max_far) {
	        $scope.addCode.toc_max_far = $scope.addCode.zn_max_far;
	      } else {
	        $scope.addCode.toc_max_far = null;
	        $scope.addCode.zn_max_far = null;
	      }
	      if (!$scope.addCode.allows_residential) {
	        $scope.addCode.allows_residential = null;
	      }
	      if (!$scope.addCode.allows_residential) {
	        $scope.addCode.allows_residential = null;
	      }
	      if (!$scope.addCode.allows_comm_office) {
	        $scope.addCode.allows_comm_office = null;
	      }
	      if (!$scope.addCode.zn_code_url) {
	        $scope.addCode.zn_code_url = null;
	      }
	
	      fetch.createItem('api/data/density/zoning/create', $scope.addCode).then(function (response) {
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.success = true;
	
	        var index = $scope.znCodes.findIndex(function (code) {
	          return code.zn_code > $scope.addCode.zn_code;
	        });
	
	        if (index > -1) {
	          $scope.znCodes.splice(index, 0, $scope.addCode);
	        } else {
	          $scope.znCodes.push($scope.addCode);
	        }
	
	        $scope.hot.loadData($scope.znCodes);
	
	        $scope.addCode = {};
	
	        $scope.notificationMessage = '';
	
	        $('#addZoningCodeModal').modal('toggle');
	      }).catch(function (error) {
	        console.log(error);
	        if (error.status === 403) {
	          $state.go('login');
	        }
	        if (error.data && error.data.message && error.data.message.includes("duplicate key value violates unique constraint")) {
	          console.log("This zoning code already exists");
	          $scope.notificationMessage = 'The zoning code ' + $scope.addCode.zn_code + ' already exists in the table!';
	        } else {
	          console.log("An error occurred:", error);
	          $scope.notificationMessage = "An error occurred: " + (error.data && error.data.message ? error.data.message : 'Unknown error');
	        }
	        $scope.saving = false;
	        $scope.addCode = {};
	
	        $timeout(function () {
	          $scope.notificationMessage = '';
	        }, 5000);
	      });
	    };
	
	    $scope.exportToCSV = function () {
	      var data = $scope.hot.getData();
	
	      var csv = '';
	      var headers = ['ID', 'Zoning ID', 'Jurisdiction', 'Zoning Code', 'Description', 'Allows Commercial Office', 'Min FAR', 'Max FAR', 'Calculated Using Height', 'Acres Within Zone', 'Acres of Existing Commercial Office Excluded', 'Documentation', 'Last Edited', 'Editor'];
	
	      csv += headers.join(',') + '\n';
	
	      data.forEach(function (row) {
	        csv += row.join(',') + '\n';
	      });
	
	      var filename = prompt("Enter a filename for the CSV file:", "zoning_data.csv");
	
	      if (filename === null) {
	        return;
	      }
	
	      var link = document.createElement('a');
	      link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
	      link.download = filename;
	
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    };
	
	    $scope.getJurisdictionDetail = function () {
	      if ($scope.currentJurisdiction) {
	        fetch.getItem('api/data/jurisdiction/detail', encodeURIComponent($scope.currentJurisdiction)).then(function (response) {
	          $scope.jurisdictionDetail = response.data[0];
	        }).catch(function (err) {
	          console.log(err);
	          if (err.status === 403) {
	            $state.go('login');
	          }
	        });
	      }
	    };
	  }
	
	  _createClass(CommercialUsesComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this2.$scope.currentUser = response.data;
	
	        _this2.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this2.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this3 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this3.$scope.loading = false;
	        _this3.$scope.jurisdictions = response.data;
	
	        if (_this3.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this3.$stateParams.jurisdiction;
	          console.log(_this3.$stateParams);
	          if (jurisdictionParam) {
	            _this3.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this3.lookup.getJurisdiction()) {
	            _this3.$scope.currentJurisdiction = _this3.lookup.getJurisdiction();
	          } else {
	            _this3.$scope.currentJurisdiction = _this3.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this3.lookup.getJurisdiction()) {
	            _this3.$scope.currentJurisdiction = _this3.lookup.getJurisdiction();
	          } else {
	            _this3.$scope.currentJurisdiction = _this3.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	        console.log(_this3.$scope.currentJurisdiction);
	        _this3.lookup.setJurisdiction(_this3.$scope.currentJurisdiction);
	        _this3.$scope.getStationAreaList(_this3.$scope.currentJurisdiction);
	        _this3.$scope.getZoningCodes(_this3.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this4 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this4.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this4.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this4.$scope.submissionSummary);
	          _this4.lookup.setSubmissionPolicies(_this4.$scope.submissionSummary);
	
	          _this4.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this4.$scope.densitySubmitted = _.filter(_this4.$scope.densitySubmissions, { submitted: true });
	          _this4.$scope.densityCompliant = _.filter(_this4.$scope.densitySubmissions, { status: 'Compliant' });
	
	          _this4.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this4.$scope.housingPolicySubmissions = _.union(_this4.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this4.$scope.housingPolicySubmitted = _.filter(_this4.$scope.housingPolicySubmissions, { submitted: true });
	          _this4.$scope.housingPolicyCompliant = _.filter(_this4.$scope.housingPolicySubmissions, { status: 'Compliant' });
	
	          _this4.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this4.$scope.parkingSubmitted = _.filter(_this4.$scope.parkingSubmissions, { submitted: true });
	          _this4.$scope.parkingCompliant = _.filter(_this4.$scope.parkingSubmissions, { status: 'Compliant' });
	
	          _this4.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this4.$scope.stationAccessSubmitted = _.filter(_this4.$scope.stationAccessSubmissions, { submitted: true });
	          _this4.$scope.stationAccessCompliant = _.filter(_this4.$scope.stationAccessSubmissions, { status: 'Compliant' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return CommercialUsesComponent;
	}();
	
	exports.default = angular.module('appApp.commercial_uses', [uiRouter]).config(_commercial_uses2.default).component('commercialUses', {
	  template: __webpack_require__(136),
	  controller: CommercialUsesComponent,
	  controllerAs: 'commercialUsesCtrl'
	}).name;

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('commercial_uses', {
	    url: '/account/density/commercial_uses?jurisdiction&sta_recid',
	    template: '<commercial-uses></commercial-uses>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null }
	  });
	};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <maintocselectiondensity />\n\n      <div class=\"content container\">\n        <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <div class=\"row\">\n          <div class=\"section-nav\">\n            <div class=\"menu--section-title\">In this section:</div>\n            <ul class=\"menu menu--section\" role=\"tablist\">\n              <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\" class=\"menu-item menu-item--section active\">\n                <span class=\"section-number\">I.</span><a href=\"#\">Intensity for Commercial Office Uses</a>\n              </li>\n              <li data-bs-toggle=\"tab\" data-bs-target=\"#section-2\" class=\"menu-item menu-item--section\"\n                ng-click=\"getCurrentDensityPolicy('Commercial Office Uses Data Verification')\">\n                <span class=\"section-number\">II.</span><a href=\"#\">Commercial Office Uses Data Verification</a>\n              </li>\n              <li data-bs-toggle=\"tab\" data-bs-target=\"#section-3\" class=\"menu-item menu-item--section\">\n                <span class=\"section-number\">III.</span><a href=\"#\">Review and Submit</a>\n              </li>\n            </ul>\n            <!-- <note></note> -->\n          </div>\n\n          <div class=\"tab-content\">\n            <!-- Minimum Density Calculation Table Section-->\n            <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane show active\">\n              <div>\n                       <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"padding-right: 10px\">I. Floor Area Ratio (Min/Max)</h2>\n              <!-- <statuspills ng-repeat=\"submission in stationStatus\" ng-if=\"submission.submission_policy_name === currentDensityPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills> -->\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, submitted: true})[0] && !(stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n                <br>\n                <h3> General Instructions</h3>\n                <br>\n                <ul>\n                  <li>\n                    The table below shows the jurisdiction's zoning designations. Please review the data and update\n                    as needed.\n                  </li>\n                  <li>\n                    Highlighted rows represent zones that fall within the selected TOC area.\n                  </li>\n                  <li>\n                    In the “Allows Office” column, check the box to indicate zones where commercial office\n                    development is a permitted use (i.e., with no use permit required). Only these zones will be\n                    included in the average commercial intensity calculations. These zones could include commercial\n                    zones and mixed-use zones where office is a permitted use, as well as any residential zones that\n                    allow 100% office uses.\n                  </li>\n                  <li>\n                    All industrial zones may be excluded from the average commercial intensity calculation at a\n                    jurisdiction’s discretion, even where office is listed as a permitted use. Accordingly, a\n                    jurisdiction\n                    can choose to leave the “Allows Office” box unchecked for these zones.\n                  </li>\n                  <li>\n                    In the “Min FAR” and “Max FAR” columns, verify if the existing values are correct. If the current\n                    values are inaccurate, enter the values for minimum and maximum intensity from the\n                    jurisdiction’s zoning code.\n                  </li>\n                  <li>\n                    The “Acres Within Zone” and “Acres of Existing Dwelling Units Excluded” columns are\n                    automatically calculated using the <a ui-sref=\"map\">Portal’s map</a>. Do not make any changes to\n                    these values in the\n                    table.\n                  </li>\n                  <li>\n                    In the “Documentation” column, include a link to the section of the jurisdiction’s zoning\n                    ordinance that provides the information for the applicable zoning district.\n                  </li>\n                </ul>\n                </p>\n                <h3>Converting to FAR from Height</h3>\n                <p>\n                <ul>\n                  <li>\n                    If a jurisdiction’s zoning code uses height to define commercial intensity, jurisdictions can use\n                    the <a\n                      href=\"https://dsa-public-files.s3.us-west-2.amazonaws.com/MTC_TOC_Policy_Density_Equivalency_Tables.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">equivalency\n                      tables from the TOC Policy Administrative Guidance</a>\n                    to convert these values to\n                    FAR.\n                  </li>\n                  <li>\n                    Jurisdictions may also use their own equivalency calculations based on actual projects in their\n                    TOC area or nearby, subject to approval by MTC staff.\n                  </li>\n                  <li>\n                    If a zoning district’s minimum or maximum FAR values are calculated using equivalencies for\n                    height, check the box in the “Calculated Using Height” column.\n                  </li>\n                </ul>\n                </p>\n                <h3>Overlay Zones/Specific Plan</h3>\n                <p>\n                <ul>\n                  <li>\n                    For overlay zones and specific plans, please create a row for each zone or sub-category within\n                    the overlay or specific plan which establishes different development or density standards.\n                  </li>\n                  <li>\n                    For example, for a Downtown Specific Plan which includes Mixed Use and Commercial Office you\n                    would create a row for each:\n                    <ul>\n                      <li>\n                        Zoning Code: DSP – MX | Description: Downtown Specific Plan – Mixed Use\n                      </li>\n                      <li>\n                        Zoning Code: DSP – CO | Description: Downtown Specific Plan – Commercial Office\n                      </li>\n                    </ul>\n                  </li>\n                </ul>\n                </p>\n\n                <h3>Excluding Parcels with Existing Dwelling Units from Density Calculations</h3>\n                <p>\n                <ul>\n                  <li>\n                    A jurisdiction may exclude parcels with existing dwelling units from the intensity calculations\n                    (“Option B” in the Administrative Guidance). To do this, view the Map and select parcels with\n                    existing dwelling units. Parcels can be selected individually or as a group. Click the “Edit\n                    Parcels”\n                    icon, select “Yes” in the “Exclude from Weighted Average Calculations” dropdown menu, and\n                    then click “Save Edits”.\n                  </li>\n\n                  <li>\n                    \"Existing dwelling units\" are those that received a building permit prior to January 1, 2024.\n                  </li>\n                  <li>\n                    If the parcel was counted as a Housing Opportunity Site in the jurisdiction’s 6th Cycle Housing\n                    Element and assumed to produce one or more units of housing, it may not be excluded.\n                  </li>\n                </ul>\n                </p>\n                <!-- <div>\n                  <p>\n                    Please check the box to indicate zones where commercial office is a permitted use (i.e., with no use\n                    permit required). This includes office zones, commercial and mixed-use zones where office is a\n                    permitted use, and any residential zones that allow 100% office uses (zones that only allow office\n                    as an ancillary use are excluded). Subject to approval by MTC staff, zoning\n                    districts in which offices are permitted uses but are ancillary to industrial\n                    activities (such as manufacturing, warehousing, production, distribution,\n                    repair, etc.) may be excluded. Only these zones will be included in the calculations.\n                  </p>\n                  <p>\n                    For overlay zones and specific plans, please create a row for each zone or sub-category within the\n                    overlay or specific plan which establishes different development or intensity standards. For\n                    example, for a Downtown Specific Plan which includes Mixed Use and Commercial Office you would\n                    create a row for each:\n                  <ul>\n                    <li>Zoning Code: DSP – MX | Description: Downtown Specific Plan – Mixed Use</li>\n                    <li>Zoning Code: DSP – HDR | Description: Downtown Specific Plan – Commercial Office</li>\n                  </ul>\n                  </p>\n                </div> -->\n              </div>\n              <!-- <div style=\"padding-bottom:10px;padding-top:10px;\" class=\"collapse\" id=\"commercialOfficeUsesMore\"> -->\n              <!-- <div style=\"padding-bottom:10px;padding-top:10px;\">\n                <p>\n                  If a jurisdictions has zoning districts in which mixed-use or residential projects are subject to\n                  higher minimum intensity standards than projects that are 100% office, the higher minimum may be used\n                  when preparing the calculations.\n                </p>\n\n                <p>View <a\n                    href=\"https://dsa-public-files.s3.us-west-2.amazonaws.com/MTC_TOC_Policy_Density_Equivalency_Tables.pdf\"\n                    target=\"_blank\">Density/Intensity Equivalency Tables</a></p>\n                <br>\n                <p>\n                  If intensity is expressed using height rather than FAR, jurisdictions can use\n                  the equivalency tables from the TOC Policy Administrative Guidance. Jurisdictions may also use their\n                  own\n                  equivalency tables based on actual projects in their TOC area or nearby, subject to approval by MTC.\n                </p>\n                <p>\n                  A jurisdiction may exclude parcels with existing dwelling units from the intensity\n                  calculations (“Option B” in the Administrative Guidance). However,\n                  if the parcel was counted as a Housing Opportunity Site in the jurisdiction’s\n                  Housing Element and assumed to produce one or more units of housing, it\n                  may not be excluded. “Existing dwelling units” are\n                  those that received a building permit prior to January 1, 2024. To do\n                  this, view the <a href=\"../../map/\">Map</a> and select parcels with existing dwelling units. Parcels\n                  can be selected\n                  individually or as a group. Click the box that says, “Exclude parcels.”\n                </p>\n              </div> -->\n              <!-- <a ng-model=\"expanded\" ng-click=\"expanded = true\" ng-show=\"!expanded\" type=\"button\" href=\"#\"\n                data-bs-toggle=\"collapse\" data-bs-target=\"#commercialOfficeUsesMore\"\n                aria-controls=\"commercialOfficeUsesMore\" aria-expanded=\"false\" aria-label=\"Toggle more content\">Read\n                More...</a>\n              <a ng-mode=\"expanded\" ng-click=\"expanded = false\" ng-show=\"expanded\" type=\"button\" href=\"#\"\n                data-bs-toggle=\"collapse\" data-bs-target=\"#commercialOfficeUsesMore\"\n                aria-controls=\"commercialOfficeUsesMore\" aria-expanded=\"false\" aria-label=\"Toggle more content\">Read\n                Less...</a> -->\n              <!-- <div class=\"filter-pane\" style=\"padding-bottom:10px;\">\n                <button ng-model=\"expanded\" ng-click=\"expanded = true\" ng-show=\"!expanded\"\n                  class=\"button button--more collapsed\" type=\"button\" data-bs-toggle=\"collapse\"\n                  data-bs-target=\"#commercialOfficeUsesMore\" aria-controls=\"commercialOfficeUsesMore\"\n                  aria-expanded=\"false\" aria-label=\"Toggle more content\">Read More</button>\n                <button ng-model=\"expanded\" ng-click=\"expanded = false\" ng-show=\"expanded\"\n                  class=\"button button--less collapsed\" type=\"button\" data-bs-toggle=\"collapse\"\n                  data-bs-target=\"#commercialOfficeUsesMore\" aria-controls=\"commercialOfficeUsesMore\"\n                  aria-expanded=\"false\" aria-label=\"Toggle more content\">Read Less</button>\n              </div> -->\n              <!-- Notification Messages  -->\n              <div class=\"row\" ng-show=\"!currentSelectedStationId\" style=\"padding-top:5px;padding-bottom:5px;\">\n                <div class=\"col\">\n                  <div class=\"alert alert-danger fade show\" role=\"alert\">\n                    <strong>Please select a station</strong> in order to see weighted averages.\n                  </div>\n                </div>\n              </div>\n\n              <!-- Notifications for table updates  -->\n              <div ng-if=\"notificationMessage\" class=\"alert alert-danger\" role=\"alert\">\n                {{notificationMessage}}\n              </div>\n\n              <div class=\"row\" ng-show=\"loadingTable\" style=\"padding-top:5px;padding-bottom:5px;\">\n                <div class=\"col\">\n                  <div class=\"alert alert-info alert-dismissible fade show\" role=\"alert\">\n                    <i class=\"fa-solid fa-cog fa-spin\" style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>\n                    Updating Table...\n                    <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n                  </div>\n                </div>\n              </div>\n              <!-- <notificationmessages /> -->\n\n              <div class=\"row mb-5\" style=\"padding-top:20px;\" ng-show=\"currentSelectedStationId\">\n                <div class=\"col\">\n                  <h3 class=\"mb-2\">\n                    {{currentStation.station_name}}: Tier Level {{currentStation.service_tier}}\n                    <i class=\"fa-solid fa-chart-simple\"></i>\n                  </h3>\n                  <table class=\"table table--data-table\">\n                    <thead class=\"table-dark\">\n                      <tr>\n                        <th>\n                          <div class=\"th-inner\">Land Use Type</div>\n                        </th>\n                        <th>\n                          <div class=\"th-inner\">Average Minimum Floor Area</div>\n                        </th>\n                        <th>\n                          <div class=\"th-inner\">\n                            Average Maximum Floor Area\n                          </div>\n                        </th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr>\n                        <td>Commercial Office</td>\n                        <td>\n                          <span ng-if=\"!loading\">{{currentStation.weighted_average_toc_min_far &&\n                            currentStation.weighted_average_toc_min_far !== 'NaN' ?\n                            currentStation.weighted_average_toc_min_far : '--'}}</span>\n                          <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                              style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                        </td>\n                        <td><span ng-if=\"!loading\">{{currentStation.weighted_average_toc_max_far &&\n                            currentStation.weighted_average_toc_max_far !== 'NaN' ?\n                            currentStation.weighted_average_toc_max_far : '--'}}</span>\n                          <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                              style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>Tier {{currentStation.service_tier}} Commercial <br>Intensity Thresholds</td>\n                        <td><span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                              style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                          <span ng-if=\"!loading\">{{complianceThresholds.toc_min_far}}\n                          </span>\n                        </td>\n                        <td><span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                              style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                          <span ng-if=\"!loading\">{{complianceThresholds.toc_max_far}}\n                          </span>\n                        </td>\n                      </tr>\n\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n\n              <!-- <handsontable></handsontable> -->\n               <div class=\"row\">\n                <div class=\"col-12 text-end\">\n                  <div class=\"mb-2\">\n                    <button data-bs-toggle=\"modal\" class=\"btn btn-primary\" ng-click=\"exportToCSV()\">\n                      <i class=\"fa-solid fa-download\"></i> Download Table\n                    </button>\n                    <button ng-disabled=\"formReadOnly\" ng-click=\"getJurisdictionDetail()\" data-bs-toggle=\"modal\" data-bs-target=\"#addZoningCodeModal\"\n                      href=\"#addZoningCodeModal\" class=\"btn btn-primary\"><i class=\"fa-solid fa-plus\"></i> Add New Code</button>\n                    <button ng-disabled=\"formReadOnly\" data-bs-toggle=\"modal\" data-bs-target=\"#deleteZoningCodeModal\" href=\"#deleteZoningCodeModal\"\n                      class=\"btn btn-danger\"><i class=\"fa-solid fa-minus\"></i> Delete Code</button>\n                  </div>\n                  \n                </div>\n               </div>\n              \n              <div id=\"handsOnTable\" class=\"hot\" style=\"z-index: 1;\"></div>\n\n              <submissionsectionsubmit></submissionsectionsubmit>\n              <!-- <submissionsectionconfirmation></submissionsectionconfirmation> -->\n            </div>\n\n            <!-- Commercial Data Verification Section  -->\n            <div id=\"section-2\" role=\"tabpanel\" name=\"densityForm\" id=\"densityForm\" class=\"section tab-pane\" ng-class=\"{'active show': showPanel === 'commercialUses'}\" ng-class=\"{'was-validated': formSubmitted}\">\n                              <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"padding-right: 10px\">II. Commercial Office Data Verification</h2>\n              <!-- <statuspills ng-repeat=\"submission in stationStatus\" ng-if=\"submission.submission_policy_name === currentDensityPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills> -->\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, submitted: true})[0] && !(stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n              <p>\n                Use this page to submit documentation for any\n                changes to the jurisdiction’s commercial office intensity information or to\n                explain how the jurisdiction’s commercial office intensity information was\n                derived.\n              </p>\n              <form class=\"row test-validation-styling\" name=\"densityForm\" id=\"densityForm\" novalidate>\n                <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                  <div class=\"verification-container\">\n                    <div class=\"form-check\">\n                      <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkCommercialNoChanges\"\n                        ng-model=\"currentDensityPolicy.commercial_density_no_changes_checked\"\n                        ng-change=\"onCommercialCheckboxChange('noChanges')\"\n                        ng-disabled=\"currentDensityPolicy.commercial_density_table_changes_checked || formReadOnly\"\n                        onchange=\"angular.element(this).scope().setPending(this)\">\n                      <label class=\"form-check-label\" for=\"checkCommercialNoChanges\"\n                        ng-class=\"{'boldFont': commercial_density_no_changes_checked}\">\n                        No changes were made to commercial office density information.\n                      </label>\n                    </div>\n                  </div>\n                  <div class=\"verification-container\">\n                    <div class=\"form-check\">\n                      <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkCommercialTableChanges\"\n                        ng-model=\"currentDensityPolicy.commercial_density_table_changes_checked\"\n                        ng-change=\"onCommercialCheckboxChange('tableChanges')\"\n                        ng-disabled=\"currentDensityPolicy.commercial_density_no_changes_checked || formReadOnly\"\n                        onchange=\"angular.element(this).scope().setPending(this)\">\n                      <label class=\"form-check-label\" for=\"checkCommercialTableChanges\"\n                        ng-class=\"{'boldFont': commercial_density_table_changes_checked}\">\n                        Changes to commercial office intensity data, and associated\n                        documentation, were provided in the commercial office intensity table.\n                      </label>\n                    </div>\n                  </div>\n                </div>\n\n                <p>\n                  A jurisdiction must provide documentation for the following:\n                </p>\n\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkCommercialEquivalencyTable\"\n                      ng-model=\"currentDensityPolicy.commercial_density_equivalency_table_checked\" ng-disabled=\"formReadOnly\"\n                      onchange=\"angular.element(this).scope().setPending(this)\">\n                    <label class=\"form-check-label\" for=\"checkCommercialEquivalencyTable\"\n                      ng-class=\"{'boldFont': commercial_density_equivalency_table_checked}\">\n                      Using its own equivalency table where the jurisdiction does not use FAR to\n                      regulate intensity.\n                    </label>\n                    <br>\n                    <p>View <a href=\"https://toc.mtcanalytics.org/public/density_intensity_equivalency_tables.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">Density/Intensity\n                        Equivalency Tables</a></p>\n\n                    <p>The standards in equivalency tables from the <a\n                        href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\"\n                        target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance<span\n                          class=\"visually-hidden\">(link is external, opens in a new window)</span></a> are based on\n                      sample projects. Jurisdictions are encouraged to develop their own equivalency tables based on\n                      actual projects within their TOC area or nearby, subject to approval by MTC.</p>\n                  </div>\n                  <div class=\"row align-items-center\"\n                    ng-show=\"currentDensityPolicy.commercial_density_equivalency_table_checked\">\n                    <div class=\"col-lg-2\">\n                      <label for=\"commercial_density_equivalency_table\">URL</label>\n                    </div>\n                    <div class=\"col-lg-5\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.commercial_density_equivalency_table)\">\n                      <input id=\"commercial_density_equivalency_table\"\n                        ng-model=\"currentDensityPolicy.commercial_density_equivalency_table\" type=\"text\"\n                        placeholder=\"Enter your response here\" value=\"\" required />\n                    </div>\n                    <!-- File upload commercial_density_equivalency_table -->\n                    <div ng-if=\"!checkSubstring(currentDensityPolicy.commercial_density_equivalency_table)\"\n                      style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div>\n                    <div class=\"col-md-5\"\n                      ng-if=\"checkSubstring(currentDensityPolicy.commercial_density_equivalency_table)\"\n                      style=\"padding-bottom:10px;\">\n                      <span style=\"padding-right:10px;\"><a\n                          ng-href=\"{{currentDensityPolicy.commercial_density_equivalency_table}}\">Uploaded\n                          Documentation</a></span>\n                      <button class=\"button button--attach\" ng-if=\"!formReadOnly\"\n                        ng-click=\"removeFile('commercial_density_equivalency_table')\"><i ng-show=\"fileUploading\"\n                          class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom:20px;padding-top:20px;\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.commercial_density_equivalency_table)\">\n                      <!-- <div class=\"col-lg-5\" style=\"margin-left:5px;\"> -->\n                      <div class=\"col-lg-2\"><label for=\"commercial_density_equivalency_table_file_abcd\">Upload\n                          Equivalency Table\n                          Documentation</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\"><input type=\"file\"\n                          ng-model=\"commercial_density_equivalency_table_file_abcd\"\n                          id=\"commercial_density_equivalency_table_file_abcd\"\n                          name=\"commercial_density_equivalency_table_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" /></div>\n                      <div class=\"col-lg-5\" ng-if=\"!formReadOnly\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('commercial_density_equivalency_table_file_abcd')\"><i\n                            ng-show=\"fileUploading_commercial_density_equivalency_table_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File</button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('commercial_density_equivalency_table_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n                    <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                      <label for=\"commercial_equivalency_table_additional_details\">Additional Details <i>(Optional)</i>:</label>\n                      <textarea ng-model=\"currentDensityPolicy.commercial_equivalency_table_additional_details\"\n                        id=\"commercial_equivalency_table_additional_details\" ng-disabled=\"formReadOnly\"\n                        onchange=\"angular.element(this).scope().setPending(this)\"\n                        name=\"commercial_equivalency_table_additional_details\" rows=\"4\" style=\"width: 100%;\">\n                        </textarea>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkCommercialAdoptedPlan\"\n                      ng-model=\"currentDensityPolicy.commercial_density_adopted_plan_checked\" ng-disabled=\"formReadOnly\"\n                      onchange=\"angular.element(this).scope().setPending(this)\">\n                    <label class=\"form-check-label\" for=\"checkCommercialAdoptedPlan\"\n                      ng-class=\"{'boldFont': commercial_density_adopted_plan_checked}\">\n                      Relying on an adopted plan for minimum intensities.\n                    </label>\n                    <p>A jurisdiction without minimum commercial office\n                      zoning standards may use the minimums identified in an adopted General Plan, Specific Plan, or\n                      Area\n                      Plan to the extent that the Plan requires that\n                      new development <strong>must</strong> occur at or above a minimum threshold.</p>\n                  </div>\n                  <div class=\"row align-items-center\"\n                    ng-show=\"currentDensityPolicy.commercial_density_adopted_plan_checked\">\n                    <div class=\"col-lg-1\">\n                      <label for=\"commercial_density_adopted_plan\">URL</label>\n                    </div>\n                    <div ng-if=\"!checkSubstring(currentDensityPolicy.commercial_density_adopted_plan)\" class=\"col-lg-5\">\n                      <input id=\"commercial_density_adopted_plan\"\n                        ng-model=\"currentDensityPolicy.commercial_density_adopted_plan\" type=\"text\"\n                        placeholder=\"Enter URL\" value=\"\" required />\n                    </div>\n                    <!-- File upload commercial_density_adopted_plan -->\n                    <div ng-if=\"!checkSubstring(currentDensityPolicy.commercial_density_adopted_plan)\" style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div>\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentDensityPolicy.commercial_density_adopted_plan)\"\n                      style=\"padding-bottom:10px;\">\n                      <span style=\"padding-right:10px;\"><a\n                          ng-href=\"{{currentDensityPolicy.commercial_density_adopted_plan}}\">Uploaded\n                          Documentation</a></span>\n                      <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('commercial_density_adopted_plan')\"><i\n                          ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n                    </div>\n                    <div class=\"row\" style=\"padding-bottom:20px;padding-top:20px;\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.commercial_density_adopted_plan)\">\n                      <div class=\"col-lg-2\"><label for=\"commercial_density_adopted_plan_file_abcd\">Upload Adopted Plan\n                          Documentation</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                        <input type=\"file\" ng-model=\"commercial_density_adopted_plan_file_abcd\"\n                          id=\"commercial_density_adopted_plan_file_abcd\"\n                          name=\"commercial_density_adopted_plan_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('commercial_density_adopted_plan_file_abcd')\"><i\n                            ng-show=\"fileUploading_commercial_density_adopted_plan_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File</button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('commercial_density_adopted_plan_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n                    <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                      <label for=\"commercial_adopted_plan_additional_details\">Additional Details <i>(Optional)</i>:</label>\n                      <textarea ng-model=\"currentDensityPolicy.commercial_adopted_plan_additional_details\"\n                        onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                        id=\"commercial_adopted_plan_additional_details\"\n                        name=\"commercial_adopted_plan_additional_details\" rows=\"4\" style=\"width: 100%;\">\n                  </textarea>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkCommercialExcludeParcels\"\n                      ng-model=\"currentDensityPolicy.commercial_density_exclude_parcels_checked\" ng-disabled=\"formReadOnly\"\n                      onchange=\"angular.element(this).scope().setPending(this)\">\n                    <label class=\"form-check-label\" for=\"checkCommercialExcludeParcels\"\n                      ng-class=\"{'boldFont': commercial_density_exclude_parcels_checked}\">\n                      Excluding parcels from density calculations.\n                    </label>\n                    <p>Parcels with existing dwelling units may be excluded from the commercial office calculations UNLESS the parcel was counted as a Housing Opportunity Site in the jurisdiction’s Housing Element and assumed to produce one or more units of housing. For the TOC Policy, “existing dwelling units” are residential units that received a building permit prior to January 1, 2024. For any excluded parcel, the jurisdiction must document the assessor parcel number (APN), acreage, existing zoning, and existing land use. Most of this information can be exported from this Portal by clicking on the \"TOC Parcel Data\" button on the Map page. However, jurisdictions will need to add information about the existing land uses for parcels to the spreadsheet that is exported.</p>\n                  </div>\n                  <div class=\"row align-items-center\"\n                    ng-show=\"currentDensityPolicy.commercial_density_exclude_parcels_checked\">\n                    <div class=\"col-lg-1\">\n                      <label for=\"commercial_density_exclude_parcels\">URL</label>\n                    </div>\n                    <div ng-if=\"!checkSubstring(currentDensityPolicy.commercial_density_exclude_parcels)\"\n                      class=\"col-lg-5\">\n                      <input id=\"commercial_density_exclude_parcels\"\n                        ng-model=\"currentDensityPolicy.commercial_density_exclude_parcels\" type=\"text\"\n                        placeholder=\"Enter URL\" value=\"\" required />\n                    </div>\n                    <!-- File upload density_adopted_plan -->\n                    <div ng-if=\"!checkSubstring(currentDensityPolicy.commercial_density_exclude_parcels)\"\n                      style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div>\n                    <div class=\"col-md-5\"\n                      ng-if=\"checkSubstring(currentDensityPolicy.commercial_density_exclude_parcels)\"\n                      style=\"padding-bottom:10px;\">\n                      <span style=\"padding-right:10px;\"><a\n                          ng-href=\"{{currentDensityPolicy.commercial_density_exclude_parcels}}\">Uploaded\n                          Documentation</a></span>\n                      <button class=\"button button--attach\" ng-if=\"!formReadOnly\"\n                        ng-click=\"removeFile('commercial_density_exclude_parcels')\"><i ng-show=\"fileUploading\"\n                          class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom:20px;padding-top:20px;\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.commercial_density_exclude_parcels)\">\n                      <div class=\"col-lg-2\"><label for=\"commercial_density_exclude_parcels_file_abcd\">Upload Excluded\n                          Parcels\n                          Documentation</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left:0 !important;\">\n                        <input type=\"file\" ng-model=\"commercial_density_exclude_parcels_file_abcd\"\n                          id=\"commercial_density_exclude_parcels_file_abcd\"\n                          name=\"commercial_density_exclude_parcels_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('commercial_density_exclude_parcels_file_abcd')\"><i\n                            ng-show=\"fileUploading_commercial_density_exclude_parcels_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File</button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('commercial_density_exclude_parcels_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n                    <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                      <label for=\"commercial_exclude_parcels_additional_details\">Additional Details <i>(Optional)</i>:</label>\n                      <textarea ng-model=\"currentDensityPolicy.commercial_exclude_parcels_additional_details\"\n                        id=\"commercial_exclude_parcels_additional_details\" ng-disabled=\"formReadOnly\"\n                        onchange=\"angular.element(this).scope().setPending(this)\"\n                        name=\"commercial_exclude_parcels_additional_details\" rows=\"4\" style=\"width: 100%;\">\n                  </textarea>\n                    </div>\n                  </div>\n                </div>\n              </form>\n              <submissionsectionsubmit></submissionsectionsubmit>\n            </div>\n            <!-- Commercial Data Submission Page  -->\n            <div id=\"section-3\" role=\"tabpanel\" class=\"section tab-pane\">\n              <h2>III. Review and Submit</h2>\n              <p>\n                Use this page to submit changes to commercial office zoning information.\n                Jurisdiction staff must complete the “Commercial Office Data Verification”\n                form prior to submitting changes.\n              </p>\n              <div class=\"row\" style=\"padding-top:5px;padding-bottom:5px;\" ng-show=\"submitted\">\n                <div class=\"col\">\n                  <div style=\"background-color: white;\">\n                    <div class=\"form-confirmation__header\">\n                      <p>You submitted</p>\n                      <p class=\"h2\" style=\"padding-top:20px;\" ng-repeat=\"item in submissionList\">{{item}}</p>\n                    </div>\n                    <div class=\"form-confirmation__message\" style=\"padding:20px;\">\n                      <p>Your submissions have been received by MTC and are currently in review. We will contact you\n                        should any questions arise or any further information be required.</p>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div ng-show=\"!submitted\">\n                <p>\n                  You are submitting the following office zones for review by MTC:\n                </p>\n                <div class=\"row\">\n                  <div class=\"col-lg-12\">\n                    <table class=\"table table--data-table table-borderless table-striped\">\n                      <thead class=\"table-dark\">\n                        <tr>\n                          <th>\n                            <div class=\"th-inner\">\n                              Code\n                              <tablesortbuttons />\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Description\n                              <tablesortbuttons />\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Minimum FAR\n                              <tablesortbuttons />\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Maximum FAR\n                              <tablesortbuttons />\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Updated By\n                              <tablesortbuttons />\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Update Date\n                              <tablesortbuttons />\n                            </div>\n                          </th>\n                        </tr>\n                      </thead>\n                      <tbody>\n                        <tr ng-repeat=\"item in znCodes\">\n                          <td>{{item.zn_code}}</td>\n                          <td>{{item.zn_description}}</td>\n                          <td>{{item.toc_min_far}}</td>\n                          <td>{{item.toc_max_far}}</td>\n                          <td>{{item.editor_id}}</td>\n                          <td>{{item.last_edited}}</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n                <form class=\"row\" novalidate>\n                  <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                    <div class=\"verification-container\">\n                      <div class=\"form-check\">\n                        <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"submitDensityForReview\"\n                          ng-model=\"density.commercialUsesCheck\" ng-disabled=\"commercialUsesCheck === true\"\n                          ng-click=\"addToSubmissions('Commercial Office Uses Data Verification'); submitDensityForReview = true\">\n                        <label ng-class=\"{'boldFont': submitDensityForReview}\">\n                          I confirm I have already submitted the relevant\n                          information and/or explanation to document any changes to data about\n                          commercial office zones/intensities including the <a href=\"#\"\n                            ng-click=\"togglePanel('commercialUses'); scrollToTop()\">Commercial Data Verification Form</a>. <span ng-if=\"commercialUsesCheck === true\"\n                                        class=\"badge badge--submitted\">Submitted</span>\n                        </label>\n                      </div>\n                    </div>\n                  </div>\n                </form>\n              </div>\n              <submissionsectionsubmit></submissionsectionsubmit>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n        <sidebarfooter></sidebarfooter>\n      </div>\n    </div>\n</section>\n\n<!-- MODALS  -->\n\n<!-- add zoning code modal  -->\n<div class=\"modal fade\" id=\"addZoningCodeModal\" tabindex=\"-1\" aria-labelledby=\"addZoningCodeModalTitle\"\n  style=\"display: none;\" aria-hidden=\"true\">\n  <div class=\"modal-dialog modal-lg\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n        <h1 class=\"modal-title\" id=\"addZoningCodeModalTitle\">Add New Zoning Code</h1>\n      </div>\n      <div class=\"modal-body\" style=\"padding-left:10%;\">\n        <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n          novalidate>\n          <!-- Zoning Code Name  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_code\">Zoning Code:</label>\n            <input type=\"text\" id=\"zn_code\" name=\"zn_code\" placeholder=\"\" value=\"\" ng-model=\"addCode.zn_code\"\n              required />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_code.$error.required && formSubmitted\">\n              Please choose a valid response.\n            </div>\n          </div>\n          <!-- Zoning Code Description  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_description\">Zoning Code Description:</label>\n            <input id=\"zn_description\" name=\"zn_description\" type=\"text\" placeholder=\"\" required\n              ng-model=\"addCode.zn_description\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_description.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Code URL  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_code_url\">Zoning Code Documentation URL:</label>\n            <input id=\"zn_code_url\" name=\"zn_code_url\" type=\"text\" placeholder=\"\" required\n              ng-model=\"addCode.zn_code_url\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_code_url.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n\n\n          <!-- Zoning Min DUA  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_min_dua\">Minimum DUA:</label>\n            <input id=\"zn_min_dua\" name=\"zn_min_dua\" type=\"number\" placeholder=\"\" required\n              ng-model=\"addCode.zn_min_dua\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_min_dua.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Max DUA  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_max_dua\">Maximum DUA:</label>\n            <input id=\"zn_max_dua\" name=\"zn_max_dua\" type=\"number\" placeholder=\"\" required\n              ng-model=\"addCode.zn_max_dua\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_max_dua.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n          <!-- Zoning Min FAR  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_min_far\">Minimum FAR:</label>\n            <input id=\"zn_min_far\" name=\"zn_min_far\" type=\"number\" placeholder=\"\" required\n              ng-model=\"addCode.zn_min_far\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_min_far.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Max FAR  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_max_far\">Maximum FAR:</label>\n            <input id=\"zn_max_far\" name=\"zn_max_far\" type=\"number\" placeholder=\"\" required\n              ng-model=\"addCode.zn_max_far\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_max_far.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n\n          <!-- Zoning Allows Residential  -->\n          <div class=\"form-item form-check col-lg-8\">\n            <input class=\"form-check-input\" type=\"checkbox\" id=\"allows_residential\" name=\"allows_residential\"\n              ng-model=\"addCode.allows_residential\" />\n            <label class=\"form-check-label\" for=\"allows_residential\">Allows Residential</label>\n          </div>\n\n          <!-- Zoning Allows Commercial Office  -->\n          <div class=\"form-item form-check col-lg-8\">\n            <input class=\"form-check-input\" type=\"checkbox\" id=\"allows_comm_office\" name=\"allows_comm_office\"\n              ng-model=\"addCode.allows_comm_office\" />\n            <label class=\"form-check-label\" for=\"allows_comm_office\">Allows Commercial Office</label>\n          </div>\n\n          <!-- Notifications for table updates  -->\n          <div ng-if=\"notificationMessage\" class=\"alert alert-danger\" role=\"alert\">\n            {{notificationMessage}}\n          </div>\n\n          <div class=\"form-item col-lg-8\" style=\"padding-top: 20px;\">\n            <button type=\"submit\" class=\"btn btn-primary btn-lg\" ng-click=\"addZoningCode()\">\n              <span ng-if=\"!saving\">Save Code</span>\n              <span ng-if=\"saving\"><i class=\"fa-solid fa-cog fa-spin\"\n                  style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>Saving...</span>\n            </button>\n            <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-bs-dismiss=\"modal\">Cancel</button>\n          </div>\n\n        </form>\n\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- delete zoning code modal  -->\n<div class=\"modal fade\" id=\"deleteZoningCodeModal\" tabindex=\"-1\" aria-labelledby=\"deleteZoningCodeModalTitle\"\n  style=\"display: none;\" aria-hidden=\"true\">\n  <div class=\"modal-dialog modal-lg\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n        <h1 class=\"modal-title\" id=\"deleteZoningCodeModalTitle\">Delete Zoning Code</h1>\n        <p>\n          Select one or more zoning codes to delete. Note that deleting a zoning code will also potentially\n          delete any current assignment of that code to parcels. This can impact weighted average calculations.\n        </p>\n      </div>\n      <div class=\"modal-body\">\n        <table class=\"table table--data-table table-borderless table-striped\">\n          <thead class=\"table-dark\">\n            <tr>\n              <th>\n                <div class=\"th-inner\">\n                  Select\n                </div>\n              </th>\n              <th>\n                <div class=\"th-inner\">\n                  Zoning Code\n                </div>\n              </th>\n              <th>\n                <div class=\"th-inner\">\n                  Zoning Description\n                </div>\n              </th>\n              <th style=\"display: none;\">\n                <div class=\"th-inner\">\n                  Application ID\n                </div>\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"item in znCodes track by $index\">\n              <td>\n                <input type=\"checkbox\" ng-model=\"item.selected\" />\n              </td>\n              <td>{{item.zn_code}}</td>\n              <td>{{item.zn_description}}</td>\n              <td style=\"display: none;\">\n                <input type=\"hidden\" ng-model=\"item.rec_id\" />\n              </td>\n            </tr>\n\n          </tbody>\n        </table>\n        <div class=\"form-item col-lg-8\" style=\"padding-top: 20px;\">\n          <button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"deleteZoningCodes()\">\n            <span ng-if=\"!saving\">Delete Code(s)</span>\n            <span ng-if=\"saving\"><i class=\"fa-solid fa-cog fa-spin\"\n                style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>Deleting...</span>\n          </button>\n          <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-bs-dismiss=\"modal\">Cancel</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResidentialUsesComponent = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _residential_uses = __webpack_require__(138);
	
	var _residential_uses2 = _interopRequireDefault(_residential_uses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ResidentialUsesComponent = exports.ResidentialUsesComponent = function () {
	  /*@ngInject*/
	  function ResidentialUsesComponent($state, $scope, $rootScope, fetch, lookup, userService, $http, baseConfigService, $stateParams, $timeout) {
	    _classCallCheck(this, ResidentialUsesComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$state = $state;
	    this.userService = userService;
	    this.baseConfigService = baseConfigService;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	    this.$http = $http;
	
	    $scope.submitDensityForReview = false;
	    $scope.savemode = null;
	    $scope.densityType = 'Residential';
	    $scope.pendingAverage = false;
	    $scope.updateData = [];
	    $scope.showTierOverride = false;
	
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.submissions = [];
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.adminUnlocked = false;
	    $scope.residentialUsesCheck = false;
	    $scope.submitmode = null;
	    $scope.initialLoad = true;
	
	    $scope.density = {};
	
	    $scope.policy_name = 'Residential Uses Data Verification';
	
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.scrollToTop = function () {
	      window.scrollTo(0, 0);
	    };
	
	    $scope.residential_density_no_changes_checked = false;
	    $scope.residential_density_table_changes_checked = false;
	
	    $scope.setPending = function () {
	      console.log('set pending ran');
	      console.log($scope.initialLoad);
	      if (!$scope.initialLoad) {
	        $scope.savemode = 'validation';
	        $scope.pendingChanges = true;
	      }
	    };
	
	    $scope.tier4Corridors = ["Bayshore Caltrain", "Orinda BART", "Lafayette BART", "Belmont Caltrain", "San Carlos Caltrain"];
	
	    $scope.thresholds = [{
	      'tier': '1',
	      'threshold': {
	        toc_min_dua: 100,
	        toc_max_dua: 150,
	        toc_min_far: 4,
	        toc_max_far: 8
	      }
	    }, {
	      'tier': '2',
	      'threshold': {
	        toc_min_dua: 75,
	        toc_max_dua: 100,
	        toc_min_far: 3,
	        toc_max_far: 6
	      }
	    }, {
	      'tier': '3',
	      'threshold': {
	        toc_min_dua: 50,
	        toc_max_dua: 75,
	        toc_min_far: 2,
	        toc_max_far: 4
	      }
	    }, {
	      'tier': '4',
	      'threshold': {
	        toc_min_dua: 25,
	        toc_max_dua: 35,
	        toc_min_far: 1,
	        toc_max_far: 3
	      }
	    }];
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentDensityPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.stationStatus) {
	        for (var i = 0; i < $scope.stationStatus.length; i++) {
	          if ($scope.stationStatus[i].submission_policy_name === $scope.policy_name) {
	            submission = $scope.stationStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentDensityPolicy;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.stationStatus && $scope.policy_name) {
	        var sub = _.find($scope.stationStatus, { submission_policy_name: $scope.policy_name });
	        if (sub && sub.submitted && sub.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('stationStatus', function () {
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm("Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.");
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.stationStatus) {
	        for (var i = 0; i < $scope.stationStatus.length; i++) {
	          if ($scope.stationStatus[i].submission_policy_name === $scope.policy_name) {
	            submission = $scope.stationStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error("No matching submission found to withdraw");
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', payload).then(function () {
	        submission.submitted = false;
	        submission.status = null;
	
	        if ($scope.policy_name === 'Residential Uses Data Verification') {
	          $scope.residentialUsesCheck = false;
	          $scope.density.residentialUsesCheck = false;
	        } else if ($scope.policy_name === 'Commercial Office Uses Data Verification') {
	          $scope.commercialUsesCheck = false;
	          $scope.density.commercialUsesCheck = false;
	        } else if ($scope.policy_name === 'Minimum Density Residential') {
	          $scope.minDUA = false;
	        } else if ($scope.policy_name === 'Maximum Density Residential') {
	          $scope.maxDUA = false;
	        }
	
	        if (!$scope.minDUA && !$scope.maxDUA && !$scope.residentialUsesCheck && !$scope.commercialUsesCheck) {
	          $scope.submitted = false;
	        }
	
	        $scope.submissions = $scope.submissions.filter(function (s) {
	          return s.submission_id !== submission.submission_id;
	        });
	
	        if ($scope.submissions.length === 0) {
	          $scope.submitmode = null;
	        }
	
	        $scope.formReadOnly = false;
	
	        var formId = $scope.currentDensityPolicy ? $scope.currentDensityPolicy.density_form_id : null;
	        $scope.currentDensityPolicy = { density_form_id: formId };
	        if ($scope.hot) {
	          $scope.hot.loadData([]);
	        }
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	      }).catch(function (err) {
	        console.error('Withdraw failed:', err);
	        alert('There was an error withdrawing the submission. Please try again.');
	      });
	    };
	
	    $scope.onResidentialCheckboxChange = function (type) {
	      if (type === 'noChanges' && $scope.currentDensityPolicy.residential_density_no_changes_checked) {
	        $scope.currentDensityPolicy.residential_density_table_changes_checked = false;
	      }
	      if (type === 'tableChanges' && $scope.currentDensityPolicy.residential_density_table_changes_checked) {
	        $scope.currentDensityPolicy.residential_density_no_changes_checked = false;
	      }
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	      console.log($scope.submissions);
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'density';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getZoningCodes = function (jurisdiction) {
	      $scope.loadingTable = true;
	      $scope.currentJurisdiction = jurisdiction;
	      lookup.setJurisdiction($scope.currentJurisdiction);
	      fetch.getAllItems('api/data/density/zoning/' + $scope.currentJurisdiction).then(function (response) {
	        $scope.znCodes = response.data;
	        $scope.loadingTable = false;
	        $scope.znCodes.forEach(function (element) {
	
	          element.last_edited = moment(element.last_edited).format('L');
	          if (element.zn_code_url) {
	            element.zn_code_url = '<a href=\'' + element.zn_code_url + '\' target=\'_blank\'>' + element.zn_code_url + '</a>';
	          }
	        });
	        $scope.znCodes = _.orderBy($scope.znCodes, 'allows_residential', 'desc');
	        $scope.loadTable($scope.znCodes);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.loadTable = function (data) {
	      var container = document.querySelector('#handsOnTable');
	      data = data.filter(function (item) {
	        return item.zn_recid !== null && item.zn_recid !== undefined;
	      });
	      if ($scope.hot) {
	        $scope.hot.loadData(data);
	        $scope.hot.render();
	      } else {
	        var _ref;
	
	        $scope.hot = new Handsontable(container, (_ref = {
	          data: data,
	          colHeaders: false,
	          nestedHeaders: [['ID', 'Zoning ID', 'Jurisdiction', 'Zoning Code', 'Description', 'Allows <br> Residential', "Min DUA", "Max DUA", "Calculated Using <br> FAR or Height", "Acres <br> Within Zone", "Acres of Existing <br> Dwelling Units Excluded", "Documentation", "Last Edited", "Editor"]],
	          allowInsertRow: true,
	          manualColumnResize: true,
	          height: 600,
	          overflow: 'auto',
	          autoWrapRow: true,
	          rowHeaders: true,
	          colWidths: [null, null, null, 40, 150, 50, 30, 30, 60, 60, 180],
	          stretchH: 'all',
	          filters: true,
	
	          dropdownMenu: ["filter_by_condition", "filter_by_value", "filter_action_bar"],
	          manualColumnMove: true,
	          manualColumnFreeze: true }, _defineProperty(_ref, 'manualColumnResize', true), _defineProperty(_ref, 'multiColumnSorting', {
	          indicator: true
	        }), _defineProperty(_ref, 'columns', [{ data: 'rec_id' }, { data: 'zn_recid' }, { data: 'jurisdiction' }, { data: 'zn_code' }, { data: 'zn_description' }, {
	          data: 'allows_residential',
	          type: "checkbox",
	          className: "htCenter"
	        }, {
	          data: 'toc_min_dua',
	          type: 'numeric'
	        }, {
	          data: 'toc_max_dua',
	          type: 'numeric'
	        }, {
	          data: 'far_or_height',
	          type: "checkbox",
	          className: "htCenter"
	        }, {
	          data: 'acres_within_zone',
	          editor: false
	        }, {
	          data: 'acres_excluded',
	          editor: false
	        }, {
	          data: 'zn_code_url',
	          renderer: 'html'
	        }, {
	          data: 'last_edited',
	          type: 'date',
	          dateFormat: 'MM/DD/YYYY',
	          correctFormat: true,
	          defaultDate: '01/01/1900',
	
	          datePickerConfig: {
	            firstDay: 0,
	            showWeekNumber: true,
	            disableDayFn: function disableDayFn(date) {
	              return date.getDay() === 0 || date.getDay() === 6;
	            }
	          }
	        }, {
	          data: 'editor_id',
	          editor: false
	        }]), _defineProperty(_ref, 'hiddenColumns', {
	          columns: [0, 1, 2],
	          indicators: true
	        }), _defineProperty(_ref, 'minSpareRows', 1), _defineProperty(_ref, 'licenseKey', 'non-commercial-and-evaluation'), _defineProperty(_ref, 'readOnly', !!$scope.formReadOnly), _defineProperty(_ref, 'readOnlyCellClassName', 'htDimmed'), _defineProperty(_ref, 'afterValidate', function afterValidate(isValid, value, row, prop, source) {}), _ref));
	        $scope.hot.addHook("afterChange", function (changes, source) {
	
	          if (changes && source !== 'UndoRedo.undo') {
	            changes.forEach(function (_ref2) {
	              var _$scope$updateData$pu;
	
	              var _ref3 = _slicedToArray(_ref2, 4),
	                  row = _ref3[0],
	                  prop = _ref3[1],
	                  oldValue = _ref3[2],
	                  newValue = _ref3[3];
	
	              if (newValue === '') {
	                newValue = null;
	              }
	              var handsonUpdate = $scope.hot.getDataAtRow(row);
	              $scope.updateData.push((_$scope$updateData$pu = {
	                rec_id: handsonUpdate[0],
	                zn_recid: handsonUpdate[1]
	              }, _defineProperty(_$scope$updateData$pu, prop, newValue), _defineProperty(_$scope$updateData$pu, prop + '_old', oldValue), _$scope$updateData$pu));
	            });
	            $scope.beforeSave();
	          }
	        });
	      }
	      $scope.$watch('formReadOnly', function (newVal) {
	        if ($scope.hot) {
	          $scope.hot.updateSettings({
	            readOnly: !!newVal
	          });
	          $scope.hot.render();
	        }
	      });
	    };
	
	    $scope.exportToCSV = function () {
	      var data = $scope.hot.getData();
	
	      var csv = '';
	      var headers = ['ID', 'Zoning ID', 'Jurisdiction', 'Zoning Code', 'Description', 'Allows Residential', 'Min DUA', 'Max DUA', 'Calculated Using FAR or Height', 'Acres Within Zone', 'Acres of Existing Dwelling Units Excluded', 'Documentation', 'Last Edited', 'Editor'];
	
	      csv += headers.join(',') + '\n';
	
	      data.forEach(function (row) {
	        csv += row.join(',') + '\n';
	      });
	
	      var filename = prompt("Enter a filename for the CSV file:", "zoning_data.csv");
	
	      if (filename === null) {
	        return;
	      }
	
	      var link = document.createElement('a');
	      link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
	      link.download = filename;
	
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      $scope.getZoningCodes(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        }
	
	        $scope.getStationbyID();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationbyID = function () {
	      $scope.pendingAverages = false;
	      lookup.setCurrentStation($scope.currentSelectedStationId);
	      $scope.loading = true;
	      $scope.loadingTable = true;
	      setTimeout(function () {
	        fetch.getItem('api/data/density/averages/' + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	          $scope.currentStation = response.data[0];
	          $scope.loading = false;
	          $scope.getSubmissionStatus($scope.currentSelectedStationId);
	          $scope.getZoningCodesByParcel($scope.currentSelectedStationId);
	
	          $scope.overrideTierForSpecificCorridors($scope.currentStation);
	
	          if ($scope.currentStation && $scope.currentStation.service_tier) {
	            var tier = $scope.currentStation.service_tier.toString();
	            $scope.complianceThresholds = _.filter($scope.thresholds, { 'tier': tier })[0].threshold;
	          }
	
	          vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	          return $scope.getCurrentDensityPolicy($scope.policy_name);
	        }).catch(function (err) {
	          console.log(err);
	          if (err.status === 403) {
	            $state.go('login');
	          }
	        });
	      }, 2000);
	    };
	
	    $scope.getSubmissionStatus = function (station) {
	      if (!$scope.currentSelectedStationId) {
	        $scope.currentSelectedStationId = station;
	      }
	
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Density').then(function (response) {
	        $scope.stationStatus = response.data;
	        var minDUAResult = _.filter($scope.stationStatus, { submission_policy_name: 'Minimum Density Residential', submitted: true });
	        $scope.minDUA = minDUAResult.length > 0;
	
	        var maxDUAResult = _.filter($scope.stationStatus, { submission_policy_name: 'Maximum Density Residential', submitted: true });
	        $scope.maxDUA = maxDUAResult.length > 0;
	
	        var residentialUses = _.filter($scope.stationStatus, { submission_policy_name: 'Residential Uses Data Verification', submitted: true });
	        if (residentialUses.length > 0) {
	          residentialUses.forEach(function (element) {
	            if (element.submitted === true) {
	              $scope.residentialUsesCheck = true;
	            }
	          });
	        }
	
	        var commercialUses = _.filter($scope.stationStatus, { submission_policy_name: 'Commercial Office Uses', submitted: true });
	        if (commercialUses.length > 0) {
	          commercialUses.forEach(function (element) {
	            if (element.submitted === true) {
	              $scope.commercialUsesCheck = true;
	            }
	          });
	        }
	
	        $scope.submitted = $scope.minDUA || $scope.maxDUA || $scope.residentialUsesCheck || $scope.commercialUsesCheck;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.overrideTierForSpecificCorridors = function (currentStation) {
	      console.log(currentStation);
	      if (currentStation) {
	        if ($scope.tier4Corridors.includes($scope.currentStation.station_name)) {
	          $scope.showTierOverride = true;
	
	          currentStation.service_tier = 4;
	
	          $scope.complianceThresholds = _.filter($scope.thresholds, { 'tier': '4' })[0].threshold;
	          $scope.complianceThresholdsTier3 = _.filter($scope.thresholds, { 'tier': '3' })[0].threshold;
	
	          $scope.complianceThresholds.toc_min_far = $scope.complianceThresholdsTier3.toc_min_far;
	          $scope.complianceThresholds.toc_max_far = $scope.complianceThresholdsTier3.toc_max_far;
	        } else {
	          $scope.showTierOverride = false;
	        }
	      }
	    }.bind(this);
	
	    $scope.getZoningCodesByParcel = function (station) {
	      fetch.getAllItems('api/data/density/zoningcodes/' + $scope.densityType + '/' + $scope.currentJurisdiction + '/' + encodeURIComponent(station), $scope.znCodes).then(function (response) {
	        $scope.znCodes.forEach(function (element) {
	          var znCodeAreaInclude = _.filter(response.data, { zn_code: element.zn_code, exclude: false })[0];
	          if (znCodeAreaInclude && znCodeAreaInclude.total_gisacre) {
	            element.acres_within_zone = parseFloat(znCodeAreaInclude.total_gisacre).toFixed(2);
	          }
	
	          var znCodeAreaExclude = _.filter(response.data, { zn_code: element.zn_code, exclude: true })[0];
	          if (znCodeAreaExclude && znCodeAreaExclude.total_gisacre) {
	            element.acres_excluded = parseFloat(znCodeAreaExclude.total_gisacre).toFixed(2);
	          }
	        });
	
	        var highlightedZnCodes = new Set(response.data.map(function (item) {
	          return item.zn_code;
	        }));
	
	        var highlightedRows = [];
	        var nonHighlightedRows = [];
	
	        $scope.znCodes.forEach(function (row) {
	          if (highlightedZnCodes.has(row.zn_code)) {
	            highlightedRows.push(row);
	          } else {
	            nonHighlightedRows.push(row);
	          }
	        });
	
	        var sortedZnCodes = highlightedRows.concat(nonHighlightedRows);
	
	        $scope.hot.updateSettings({
	          data: sortedZnCodes,
	          cells: function cells(row, col) {
	            var cellProperties = {};
	            var znCode = $scope.hot.getDataAtCell(row, 3);
	
	            if (highlightedZnCodes.has(znCode)) {
	              if (col === 5 || col === 8) {
	                cellProperties.className = 'highlightRow htCenter';
	              } else {
	                cellProperties.className = 'highlightRow';
	              }
	            }
	
	            return cellProperties;
	          }
	        });
	
	        $scope.loadingTable = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.selectedFile = null;
	
	    $scope.handleFileSelect = function (element) {
	      console.log(element);
	      $scope.setPending();
	      $scope.$apply(function () {
	        $scope.selectedFile = element.files[0];
	      });
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	
	      var file = $scope.selectedFile;
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      $scope['fileUploading_' + ngmodelfile] = true;
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentDensityPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	        $scope.selectedFile = null;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	        $scope['fileUploading_' + ngmodelfile] = false;
	      });
	    };
	
	    $scope.clearFile = function (ngmodelfile) {
	      var fileInput = document.getElementById(ngmodelfile);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope.selectedFile = null;
	      }
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentDensityPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'validation';
	      $scope.pendingChanges = true;
	    };
	
	    $scope.getCurrentDensityPolicy = function (policy_name) {
	
	      if (policy_name) {
	        $scope.policy_name = policy_name;
	      }
	      console.log('policy_name:', policy_name);
	
	      fetch.getAllItems('api/data/getDensityForm/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + encodeURIComponent($scope.policy_name)).then(function (response) {
	
	        if (response.data && response.data.length > 0) {
	          $scope.currentDensityPolicy = response.data[0];
	          $scope.initialLoad = false;
	          console.log('density_form_id:', $scope.currentDensityPolicy.density_form_id);
	          if (policy_name === 'Residential Uses Data Verification') {
	            if ($scope.residential_density_no_changes_checked) {
	              $scope.residential_density_no_changes_checked = true;
	            }
	            if ($scope.residential_density_table_changes_checked) {
	              $scope.residential_density_table_changes_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_density_equivalency_table) {
	              $scope.residential_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_density_equivalency_table) {
	              $scope.residential_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_density_exclude_parcels) {
	              $scope.residential_density_exclude_parcels_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_density_adopted_plan) {
	              $scope.residential_density_adopted_plan_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_exclude_parcels_additional_details) {
	              $scope.residential_density_exclude_parcels_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_equivalency_table_additional_details) {
	              $scope.residential_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.residential_adopted_plan_additional_details) {
	              $scope.residential_density_adopted_plan_checked = true;
	            }
	          }
	          if (policy_name === 'Commercial Office Uses Data Verification') {
	            if ($scope.currentDensityPolicy.commercial_density_equivalency_table) {
	              $scope.commercial_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_density_adopted_plan) {
	              $scope.commercial_density_adopted_plan_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_density_exclude_parcels) {
	              $scope.commercial_density_exclude_parcels_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_exclude_parcels_additional_details) {
	              $scope.commercial_density_exclude_parcels_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_equivalency_table_additional_details) {
	              $scope.commercial_density_equivalency_table_checked = true;
	            }
	            if ($scope.currentDensityPolicy.commercial_adopted_plan_additional_details) {
	              $scope.commercial_density_adopted_plan_checked = true;
	            }
	          }
	          $scope.initialLoad = false;
	          console.log($scope.initialLoad);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentDensityPolicy = function () {
	
	      $scope.formSubmitted = true;
	      if (densityForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      Object.keys($scope.currentDensityPolicy).forEach(function (key) {
	        if ($scope.currentDensityPolicy[key] === "" || $scope.currentDensityPolicy[key] === undefined) {
	          $scope.currentDensityPolicy[key] = null;
	        }
	      });
	
	      console.log("Payload being sent:", $scope.currentDensityPolicy);
	      fetch.updateItem('api/data/density/forms/update', $scope.currentDensityPolicy).then(function (response) {
	        $scope.saving = false;
	        $scope.saved = true;
	
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.saved = false;
	          $scope.savemode = null;
	          $scope.successMessage = null;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.saveZoningCodes = function () {
	      $scope.saving = true;
	      $scope.upsertData = _.filter($scope.stationStatus, function (o) {
	        if (o.policy === 'Minimum Density Residential' || o.policy === 'Maximum Density Residential') {
	          return o;
	        }
	      });
	
	      fetch.updateItem('api/data/submissions/update', $scope.upsertData).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.success = true;
	        $scope.getStationbyID();
	        setTimeout(function () {
	          $scope.success = false;
	          $scope.savemode = null;
	          $scope.saved = false;
	          $scope.successMessage = null;
	          $scope.$apply();
	        }, 10000);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.deleteZoningCodes = function () {
	      $scope.saving = true;
	
	      $scope.updateData = [];
	      $scope.znCodes.forEach(function (element) {
	        if (element.selected) {
	          $scope.updateData.push(element);
	        }
	      });
	      $scope.saving = true;
	      fetch.updateItem('api/data/density/zoning/delete', $scope.updateData).then(function (response) {
	
	        $scope.znCodes = _.filter($scope.znCodes, function (o) {
	          return !o.selected && o.zn_recid !== null;
	        });
	        $scope.saving = false;
	        $scope.updateData = [];
	        $scope.hot.loadData($scope.znCodes);
	        $('#deleteZoningCodeModal').modal('toggle');
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.addZoningCode = function () {
	      $scope.saving = true;
	      console.log($scope.addCode);
	      $scope.addCode.rec_id = lookup.getUUID();
	      if ($scope.jurisdictionDetail) {
	        $scope.addCode.jurisdiction_id = $scope.jurisdictionDetail.jurisdiction_id;
	        $scope.addCode.county_id = $scope.jurisdictionDetail.county_id;
	      }
	
	      $scope.addCode.zn_recid = $scope.currentJurisdiction + '-' + $scope.addCode.zn_code;
	
	      if ($scope.addCode.zn_min_dua || $scope.addCode.zn_min_dua === 0) {
	        $scope.addCode.toc_min_dua = $scope.addCode.zn_min_dua;
	      } else {
	        $scope.addCode.toc_min_dua = null;
	        $scope.addCode.zn_min_dua = null;
	      }
	      if ($scope.addCode.zn_max_dua || $scope.addCode.zn_max_dua === 0) {
	        $scope.addCode.toc_max_dua = $scope.addCode.zn_max_dua;
	      } else {
	        $scope.addCode.toc_max_dua = null;
	        $scope.addCode.zn_max_dua = null;
	      }
	      if ($scope.addCode.zn_min_far || $scope.addCode.zn_min_far === 0) {
	        $scope.addCode.toc_min_far = $scope.addCode.zn_min_far;
	      } else {
	        $scope.addCode.toc_min_far = null;
	        $scope.addCode.zn_min_far = null;
	      }
	      if ($scope.addCode.zn_max_far || $scope.addCode.zn_max_far === 0) {
	        $scope.addCode.toc_max_far = $scope.addCode.zn_max_far;
	      } else {
	        $scope.addCode.toc_max_far = null;
	        $scope.addCode.zn_max_far = null;
	      }
	      if (!$scope.addCode.allows_residential) {
	        $scope.addCode.allows_residential = null;
	      }
	      if (!$scope.addCode.allows_residential) {
	        $scope.addCode.allows_residential = null;
	      }
	      if (!$scope.addCode.allows_comm_office) {
	        $scope.addCode.allows_comm_office = null;
	      }
	      if (!$scope.addCode.zn_code_url) {
	        $scope.addCode.zn_code_url = null;
	      }
	
	      fetch.createItem('api/data/density/zoning/create', $scope.addCode).then(function (response) {
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.success = true;
	
	        var index = $scope.znCodes.findIndex(function (code) {
	          return code.zn_code > $scope.addCode.zn_code;
	        });
	
	        if (index > -1) {
	          $scope.znCodes.splice(index, 0, $scope.addCode);
	        } else {
	          $scope.znCodes.push($scope.addCode);
	        }
	
	        $scope.hot.loadData($scope.znCodes);
	
	        $scope.getZoningCodesByParcel($scope.currentSelectedStationId);
	
	        $scope.addCode = {};
	
	        console.log('Success:', response);
	        $scope.notificationMessage = '';
	        $('#addZoningCodeModal').modal('toggle');
	      }).catch(function (error) {
	        if (error.status === 403) {
	          $state.go('login');
	        }
	        if (error.data && error.data.message && error.data.message.includes("duplicate key value violates unique constraint")) {
	          console.log("This zoning code already exists");
	          $scope.notificationMessage = 'The zoning code ' + $scope.addCode.zn_code + ' already exists in the table!';
	        } else {
	          console.log("An error occurred:", error);
	          $scope.notificationMessage = "An error occurred: " + (error.data && error.data.message ? error.data.message : 'Unknown error');
	        }
	        $scope.saving = false;
	        $scope.addCode = {};
	
	        $timeout(function () {
	          $scope.notificationMessage = '';
	        }, 5000);
	      });
	    };
	
	    $scope.getJurisdictionDetail = function () {
	      if ($scope.currentJurisdiction) {
	        fetch.getItem('api/data/jurisdiction/detail', encodeURIComponent($scope.currentJurisdiction)).then(function (response) {
	          $scope.jurisdictionDetail = response.data[0];
	        }).catch(function (err) {
	          console.log(err);
	          if (err.status === 403) {
	            $state.go('login');
	          }
	        });
	      }
	    };
	  }
	
	  _createClass(ResidentialUsesComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	
	        return _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getZoningCodes(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	          _this3.lookup.setSubmissionPolicies(_this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Compliant' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Compliant' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Compliant' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Compliant' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return ResidentialUsesComponent;
	}();
	
	exports.default = angular.module('appApp.residential_uses', [uiRouter]).config(_residential_uses2.default).component('residentialUses', {
	  template: __webpack_require__(139),
	  controller: ResidentialUsesComponent,
	  controllerAs: 'residentialUsesCtrl'
	}).name;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('residential_uses', {
	    url: '/account/density/residential_uses?jurisdiction&sta_recid',
	    template: '<residential-uses></residential-uses>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null }
	  });
	};

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <!-- Directive  -->\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <!-- Directives  -->\n      <mainheaderauth></mainheaderauth>\n      <maintocselectiondensity />\n\n      <div class=\"content container\">\n        <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <div class=\"row\">\n          <div class=\"section-nav\">\n            <div class=\"menu--section-title\">In this section:</div>\n            <ul class=\"menu menu--section\" role=\"tablist\">\n              <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\" class=\"menu-item menu-item--section active\">\n                <span class=\"section-number\">I.</span><a href=\"#\">Residential Density (Min/Max)</a>\n              </li>\n              <li data-bs-toggle=\"tab\" data-bs-target=\"#section-2\" class=\"menu-item menu-item--section\"\n                ng-click=\"getCurrentDensityPolicy('Residential Uses Data Verification')\">\n                <span class=\"section-number\">II.</span><a href=\"#\">Residential Data Verification</a>\n              </li>\n              <li data-bs-toggle=\"tab\" data-bs-target=\"#section-3\" class=\"menu-item menu-item--section\">\n                <span class=\"section-number\">III.</span><a href=\"#\">Review and Submit</a>\n              </li>\n            </ul>\n            <!-- Directive  -->\n            <!-- <note></note> -->\n          </div>\n          <div class=\"tab-content\">\n            <!-- Minimum Density Calculation Table Section-->\n            <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane show active\">\n               <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"padding-right: 10px\">I. Density for Residential Uses (Min/Max)</h2>\n              <!-- <statuspills ng-repeat=\"submission in stationStatus\" ng-if=\"submission.submission_policy_name === currentDensityPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills> -->\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, submitted: true})[0] && !(stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n              <br>\n              <h3> General Instructions</h3>\n              <br>\n              <ul>\n                <li>\n                  All TOC areas subject to Senate Bill 79 (SB 79) will receive full credit for the Maximum Allowable Residential Density standard. Jurisdictions should confirm on the Residential Data Verification Page that the TOC is subject to SB 79, the jurisdiction is in compliance with SB 79, and the jurisdiction is relying on SB 79 to receive credit for the Maximum Allowable Residential Density standard. \n                </li>\n                <li>\n                  The table below shows the jurisdiction's zoning designations. Please review the data and update as\n                  needed.\n                </li>\n                <li>\n                  Highlighted rows represent zones that fall within the selected TOC area.\n                </li>\n                <li>\n                  In the “Allows Residential” column, check the box to indicate zones where residential\n                  development is a permitted use (i.e., with no use permit required). Only these zones will be\n                  included in the average residential density calculations. These zones could include single-family\n                  zones, multi-family zones, mixed-use zones where housing is a permitted use, and non-\n                  residential districts that specifically identify housing as a permitted use.\n                </li>\n                <li>\n                  Zones that are intended to conserve land for open space or agriculture should be excluded from\n                  the average residential density calculation, even where residential is listed as a permitted use.\n                  Accordingly, leave the “Allows Residential” box unchecked for these zones.\n                </li>\n                <li>\n                  In the “Min DUA” and “Max DUA” columns, verify if the existing values are correct. If the current\n                  values are inaccurate, enter the values for minimum and maximum residential density from the\n                  jurisdiction’s zoning code.\n                </li>\n                <li>\n                  The “Acres Within Zone” and “Acres of Existing Dwelling Units Excluded” columns are\n                  automatically calculated using the <a ui-sref=\"map\">Portal’s map</a>. Do not make any changes to\n                  these\n                  values in the\n                  table.\n                </li>\n                <li>\n                  In the “Documentation” column, include a link to the section of the jurisdiction’s zoning\n                  ordinance that provides the information for the applicable zoning district.\n                </li>\n              </ul>\n              </p>\n              <h3>Converting to DUA from FAR or Height</h3>\n              <p>\n              <ul>\n                <li>\n                  If a jurisdiction’s zoning code uses floor area ratio (FAR) or height to define residential density,\n                  jurisdictions can use the <a\n                    href=\"https://dsa-public-files.s3.us-west-2.amazonaws.com/MTC_TOC_Policy_Density_Equivalency_Tables.pdf\">equivalency\n                    tables from the TOC Policy Administrative Guidance</a> to\n                  convert these values to DUA.\n                </li>\n                <li>\n                  Jurisdictions may also use their own equivalency calculations based on actual projects in their\n                  TOC area or nearby, subject to approval by MTC staff.\n                </li>\n                <li>\n                  If a zoning district’s minimum or maximum DUA values are calculated using equivalencies for FAR\n                  or height, check the box in the “Calculated Using FAR or Height” column.\n                </li>\n              </ul>\n              </p>\n              <h3>Overlay Zones/Specific Plan</h3>\n              <p>\n              <ul>\n                <li>\n                  For overlay zones and specific plans, please create a row for each zone or sub-category within\n                  the overlay or specific plan which establishes different development or density standards.\n                </li>\n                <li>\n                  For example, for a Downtown Specific Plan which includes Mixed Use and High-Density\n                  Residential you would create a row for each:\n                  <ul>\n                    <li>\n                      Zoning Code: DSP – MX | Description: Downtown Specific Plan – Mixed Use\n                    </li>\n                    <li>\n                      Zoning Code: DSP – HDR | Description: Downtown Specific Plan – High Density Residential\n                    </li>\n                  </ul>\n                </li>\n              </ul>\n              </p>\n              <h3> Excluding Parcels with Existing Dwelling Units from Density Calculations</h3>\n              <p>\n              <ul>\n                <li>\n                  A jurisdiction may exclude parcels with existing dwelling units from the density calculations\n                  (“Option B” in the Administrative Guidance). To do this, view the <a ui-sref=\"map\">Map</a> and\n                  select\n                  parcels with\n                  existing dwelling units. Parcels can be selected individually or as a group. Click the “Edit Parcels”\n                  icon, select “Yes” in the “Exclude from Weighted Average Calculations” dropdown menu, and\n                  then click “Save Edits”.\n                </li>\n                <li>\n                  “Existing dwelling units” are those that received a building permit prior to January 1, 2024.\n                </li>\n                <li>\n                  If the parcel was counted as a Housing Opportunity Site in the jurisdiction’s 6th Cycle Housing\n                  Element and assumed to produce one or more units of housing, it may not be excluded.\n                </li>\n              </ul>\n              </p>\n              <!-- <div>\n                <p>\n                  Please check the box to indicate zones where residential is a permitted use (i.e., with no use permit\n                  required). This includes single-family zones, multi-family zones, mixed-use zones where housing is a\n                  permitted use, and non-residential districts that specifically identify housing as a permitted use.\n                  Zones that are intended to conserve land for open space or agriculture\n                  should be excluded from the average residential density calculation, even\n                  where residential is listed as a permitted use. Only these zones will be included in the calculations.\n                </p>\n                <p>\n                  For overlay zones and specific plans, please create a row for each zone or sub-category within the\n                  overlay or specific plan which establishes different\n                  development or density standards. For example, for a Downtown Specific Plan which includes Mixed Use\n                  and High-Density Residential you would create a row for each:\n                <ul>\n                  <li>Zoning Code: DSP – MX | Description: Downtown Specific Plan – Mixed Use</li>\n                  <li>Zoning Code: DSP – HDR | Description: Downtown Specific Plan – High Density Residential</li>\n                </ul>\n                </p>\n\n                <p>View <a\n                    href=\"https://dsa-public-files.s3.us-west-2.amazonaws.com/MTC_TOC_Policy_Density_Equivalency_Tables.pdf\"\n                    target=\"_blank\">Density/Intensity\n                    Equivalency Tables</a></p>\n                <br>\n              </div> -->\n\n              <!-- <div style=\"padding-bottom:10px;\" class=\"collapse\" id=\"residentialUsesMore\"> -->\n              <!-- <div style=\"padding-bottom:10px;\">\n                <p>\n                  If density is expressed using floor area ratio (FAR) or height, jurisdictions can use the equivalency\n                  tables from the TOC Policy Administrative Guidance. Jurisdictions may also use their own equivalency\n                  tables based on actual projects in their TOC area or nearby, subject to approval by MTC.\n                </p>\n                <p>\n                  A jurisdiction may exclude parcels with existing dwelling units from the density calculations (“Option\n                  B” in the Administrative Guidance). However, if\n                  the parcel was counted as a Housing Opportunity Site in the jurisdiction’s\n                  Housing Element and assumed to produce one or more units of housing, it\n                  may not be excluded. “Existing dwelling units” are those that received a building\n                  permit prior to January 1, 2024. To do this, view the <a href=\"/account/map\">Map</a> and select\n                  parcels with existing dwelling units. Parcels can be selected\n                  individually or as a group. Click the box that says, \"Exclude parcels.\"\n                </p>\n              </div> -->\n              <!-- <div class=\"filter-pane\" style=\"padding-bottom:10px;\">\n                <button ng-model=\"expanded\" ng-click=\"expanded = true\" ng-show=\"!expanded\"\n                  class=\"button button--more collapsed\" type=\"button\" data-bs-toggle=\"collapse\"\n                  data-bs-target=\"#residentialUsesMore\" aria-controls=\"residentialUsesMore\" aria-expanded=\"false\"\n                  aria-label=\"Toggle more content\">Read More</button>\n                <button ng-model=\"expanded\" ng-click=\"expanded = false\" ng-show=\"expanded\"\n                  class=\"button button--less collapsed\" type=\"button\" data-bs-toggle=\"collapse\"\n                  data-bs-target=\"#residentialUsesMore\" aria-controls=\"residentialUsesMore\" aria-expanded=\"false\"\n                  aria-label=\"Toggle more content\">Read Less</button>\n              </div> -->\n              <!-- Notification messages  -->\n              <div class=\"row\" ng-show=\"!currentSelectedStationId\" style=\"padding-top:5px;padding-bottom:5px;\">\n                <div class=\"col\">\n                  <div class=\"alert alert-danger fade show\" role=\"alert\">\n                    <strong>Please select a station</strong> in order to see weighted averages.\n                  </div>\n                </div>\n              </div>\n\n              <!-- Notifications for table updates  -->\n              <div ng-if=\"notificationMessage\" class=\"alert alert-danger\" role=\"alert\">\n                {{notificationMessage}}\n              </div>\n\n              <div class=\"row\" ng-show=\"loadingTable\" style=\"padding-top:5px;padding-bottom:5px;\">\n                <div class=\"col\">\n                  <div class=\"alert alert-info alert-dismissible fade show\" role=\"alert\">\n                    <i class=\"fa-solid fa-cog fa-spin\" style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>\n                    Updating Table...\n                    <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n                  </div>\n                </div>\n              </div>\n              <!-- <notificationmessages /> -->\n\n              <div class=\"row mb-5\" style=\"padding-top:20px;\" ng-show=\"currentSelectedStationId\">\n                <div class=\"col\">\n                  <h3 class=\"mb-2\">\n                    {{currentStation.station_name}}: Tier Level {{currentStation.service_tier}}\n                    <i class=\"fa-solid fa-chart-simple\"></i>\n                  </h3>\n                  <table class=\"table table--data-table\">\n                    <thead class=\"table-dark\">\n                      <tr>\n                        <th>\n                          <div class=\"th-inner\">Land Use Type</div>\n                        </th>\n                        <th>\n                          <div class=\"th-inner\">Average Minimum Density</div>\n                        </th>\n                        <th>\n                          <div class=\"th-inner\">\n                            Average Allowable Maximum Density\n                          </div>\n                        </th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr>\n                        <td>Residential</td>\n                        <td>\n                          <span ng-if=\"!loading\">{{currentStation.weighted_average_toc_min_dua &&\n                            currentStation.weighted_average_toc_min_dua !== 'NaN' ?\n                            currentStation.weighted_average_toc_min_dua : '--'}}</span>\n                          <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                              style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                        </td>\n                        <td><span ng-if=\"!loading\">{{currentStation.weighted_average_toc_max_dua &&\n                            currentStation.weighted_average_toc_max_dua !== 'NaN' ?\n                            currentStation.weighted_average_toc_max_dua : '--'}}</span>\n                          <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                              style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>Tier {{currentStation.service_tier}} Residential <br>Density Thresholds</td>\n                        <td><span ng-if=\"!loading\"><span\n                              ng-if=\"residentialUsesCtrl.tier4Corridors.includes(currentStation.station_name)\">{{residentialUsesCtrl.overrideTierForSpecificCorridors(currentStation).toc_min_dua\n                              |\n                              number:1}}</span>\n                            <span\n                              ng-if=\"!residentialUsesCtrl.tier4Corridors.includes(currentStation.station_name)\">{{complianceThresholds.toc_min_dua\n                              |\n                              number:1}}</span></span>\n                          <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                              style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n                        </td>\n                        <td>\n                          <span ng-if=\"!loading\">\n                            <span ng-if=\"residentialUsesCtrl.tier4Corridors.includes(currentStation.station_name)\">\n                              {{residentialUsesCtrl.overrideTierForSpecificCorridors(currentStation).toc_max_dua |\n                              number:1}}\n                            </span>\n                            <span ng-if=\"!residentialUsesCtrl.tier4Corridors.includes(currentStation.station_name)\">\n                              {{complianceThresholds.toc_max_dua | number:1}}\n                            </span>\n                          </span>\n                          <span ng-if=\"loading\"><i class=\"fa-solid fa-cog fa-spin\"\n                              style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i></span>\n\n                        </td>\n                      </tr>\n\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n              <br>\n\n              <!-- <handsontable></handsontable> -->\n               <div class=\"row\">\n                <div class=\"col-12 text-end\">\n                  <div class=\"mb-2\">\n                    <button data-bs-toggle=\"modal\" class=\"btn btn-primary\" ng-click=\"exportToCSV()\">\n                      <i class=\"fa-solid fa-download\"></i> Download Table\n                    </button>\n                    <button ng-disabled=\"formReadOnly\"ng-click=\"getJurisdictionDetail()\" data-bs-toggle=\"modal\" data-bs-target=\"#addZoningCodeModal\"\n                      href=\"#addZoningCodeModal\" class=\"btn btn-primary\"><i class=\"fa-solid fa-plus\"></i> Add New Code</button>\n                    <button ng-disabled=\"formReadOnly\" data-bs-toggle=\"modal\" data-bs-target=\"#deleteZoningCodeModal\" href=\"#deleteZoningCodeModal\"\n                      class=\"btn btn-danger\"><i class=\"fa-solid fa-minus\"></i> Delete Code</button>\n                  </div>\n                </div>\n               </div>\n              \n\n              <div id=\"handsOnTable\" class=\"hot\" style=\"z-index: 1;\"></div>\n              <submissionsectionsubmit></submissionsectionsubmit>\n            </div>\n            <!-- Residential Data Verification Section  -->\n            <div id=\"section-2\" role=\"tabpanel\" class=\"section tab-pane\"\n              ng-class=\"{'active show': showPanel === 'residentialUses'}\" ng-class=\"{'was-validated': formSubmitted}\">\n <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"padding-right: 10px\">II. Residential Data Verification</h2>\n              <!-- <statuspills ng-repeat=\"submission in stationStatus\" ng-if=\"submission.submission_policy_name === currentDensityPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                            on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n                        </statuspills> -->\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, submitted: true})[0] && !(stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(stationStatus | filter:{submission_policy_name: currentDensityPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n              <!-- <statuspills ng-repeat=\"submission in densityStatus\" ng-if=\"submission.submission_policy_name === currentDensityPolicy\n              .policy_name && submission.submitted === true\" status=\"submission.status\" row-data=\"submission\"\n                on-update=\"updateSubmissionStatus(row, newStatus)\">\n              </statuspills> -->\n\n              <p>\n                Use this page to submit documentation for any changes to the jurisdiction’s\n                residential density information or to explain how the jurisdiction’s residential\n                density information was derived.\n              </p>\n              <form class=\"row test-validation-styling\" name=\"densityForm\" id=\"densityForm\" novalidate>\n                <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                  <div class=\"verification-container\">\n                    <div class=\"form-check\">\n                      <input id=\"checkResidentialNoChanges\"\n                             class=\"form-check-input\"\n                             type=\"checkbox\"\n                             ng-model=\"currentDensityPolicy.residential_density_no_changes_checked\"\n                             ng-change=\"onResidentialCheckboxChange('noChanges')\"\n                             ng-disabled=\"currentDensityPolicy.residential_density_table_changes_checked || formReadOnly\"\n                             onchange=\"angular.element(this).scope().setPending(this)\">\n                      <label class=\"form-check-label\" for=\"checkResidentialNoChanges\"\n                             ng-class=\"{'boldFont': currentDensityPolicy.residential_density_no_changes_checked}\">\n                        No changes were made to residential density information.\n                      </label>\n                    </div>\n                  </div>\n                  <div class=\"verification-container\">\n                    <div class=\"form-check\">\n                      <input id=\"checkResidentialTableChanges\"\n                             class=\"form-check-input\"\n                             type=\"checkbox\"\n                             ng-model=\"currentDensityPolicy.residential_density_table_changes_checked\"\n                             ng-change=\"onResidentialCheckboxChange('tableChanges')\"\n                             ng-disabled=\"currentDensityPolicy.residential_density_no_changes_checked || formReadOnly\"\n                             onchange=\"angular.element(this).scope().setPending(this)\">\n                      <label class=\"form-check-label\" for=\"checkResidentialTableChanges\"\n                             ng-class=\"{'boldFont': currentDensityPolicy.residential_density_table_changes_checked}\">\n                        Changes to residential density data, and associated documentation, were provided in the residential density table.\n                      </label>\n                    </div>\n                  </div>\n                  <div class=\"verification-container\">\n                    <div class=\"form-check\">\n                      <input id=\"checkResidentialSB79\"\n                             class=\"form-check-input\"\n                             type=\"checkbox\"\n                             ng-model=\"currentDensityPolicy.residential_density_sb79_checked\"\n                             ng-change=\"onResidentialCheckboxChange('sb79')\"\n                             ng-disabled=\"currentDensityPolicy.residential_density_no_changes_checked || currentDensityPolicy.residential_density_table_changes_checked || formReadOnly\"\n                             onchange=\"angular.element(this).scope().setPending(this)\">\n                      <label class=\"form-check-label\" for=\"checkResidentialSB79\"\n                             ng-class=\"{'boldFont': currentDensityPolicy.residential_density_sb79_checked}\">\n                        The TOC is subject to SB 79, the jurisdiction is in compliance with SB 79, and the jurisdiction is relying on SB 79 to receive credit for the Maximum Allowable Residential Density standard.  \n                      </label>\n                    </div>\n                  </div>\n                </div>\n                <p>\n                  A jurisdiction must provide documentation for any of the following:\n                </p>\n\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkResidentialEquivalencyTable\"\n                      ng-model=\"currentDensityPolicy.residential_density_equivalency_table_checked\" ng-disabled=\"formReadOnly\"\n                      onchange=\"angular.element(this).scope().setPending(this)\">\n                    <label class=\"form-check-label\" for=\"checkResidentialEquivalencyTable\"\n                      ng-class=\"{'boldFont': residential_density_equivalency_table_checked}\">\n                      Using its own equivalency table where the jurisdiction does not use\n                      dwelling units per acre to regulate density.\n                    </label>\n                    <br>\n                    <p>View <a href=\"https://mtcdrive.box.com/s/zp6ed6k97hxz62cxmq7wsmft21escmn3\"\n                        target=\"_blank\" rel=\"noopener noreferrer\">Density/Intensity Equivalency Tables</a></p>\n\n                    <p>The standards in equivalency tables from the <a\n                        href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\"\n                        target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative\n                        Guidance<span class=\"visually-hidden\">(link is external, opens in a new window)</span></a> are\n                      based on\n                      sample projects. Jurisdictions are encouraged to develop their own equivalency tables based on\n                      actual projects within their TOC area or nearby, subject to approval by MTC. MTC staff will\n                      automatically approve jurisdiction-developed equivalency tables or density calculation\n                      methodologies that were accepted by the California Department of Housing and Community\n                      Development (HCD) in a certified Housing Element from the 6th Cycle or later.</p>\n                  </div>\n                  <div class=\"row align-items-center\"\n                    ng-show=\"currentDensityPolicy.residential_density_equivalency_table_checked\">\n                    <div class=\"col-lg-1\">\n                      <label for=\"residential_density_equivalency_table\">URL</label>\n                    </div>\n                    <div class=\"col-lg-5\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_equivalency_table)\">\n                      <input id=\"residential_density_equivalency_table\"\n                        ng-model=\"currentDensityPolicy.residential_density_equivalency_table\" type=\"text\"\n                        placeholder=\"Enter response or URL\" value=\"\" required />\n                    </div>\n                    <!-- File upload density_equivalency_table -->\n                    <div ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_equivalency_table)\"\n                      style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div>\n                    <div class=\"col-md-5\"\n                      ng-if=\"checkSubstring(currentDensityPolicy.residential_density_equivalency_table)\"\n                      style=\"padding-bottom:10px;\">\n                      <span style=\"padding-right:10px;\"><a\n                          ng-href=\"{{currentDensityPolicy.residential_density_equivalency_table}}\">Uploaded\n                          Documentation</a></span>\n                      <button class=\"button button--attach\" ng-if=\"!formReadOnly\"\n                        ng-click=\"removeFile('residential_density_equivalency_table')\"><i ng-show=\"fileUploading\"\n                          class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom:20px;padding-top:20px;\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_equivalency_table)\">\n                      <div class=\"col-lg-2\"><label for=\"residential_density_equivalency_table_file_abcd\">Upload\n                          Equivalency Table\n                          Documentation</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left:0 !important;\">\n                        <input type=\"file\" ng-model=\"residential_density_equivalency_table_file_abcd\"\n                          id=\"residential_density_equivalency_table_file_abcd\"\n                          name=\"residential_density_equivalency_table_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                      </div>\n                      <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('residential_density_equivalency_table_file_abcd')\"><i\n                            ng-show=\"fileUploading_residential_density_equivalency_table_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File</button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('residential_density_equivalency_table_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n                    <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                      <label for=\"residential_equivalency_table_additional_details\">Additional Details <i>(Optional)</i>:</label>\n                      <textarea ng-model=\"currentDensityPolicy.residential_equivalency_table_additional_details\"\n                        id=\"residential_equivalency_table_additional_details\" ng-disabled=\"formReadOnly\"\n                        onchange=\"angular.element(this).scope().setPending(this)\"\n                        name=\"residential_equivalency_table_additional_details\" rows=\"4\" style=\"width: 100%;\">\n                    </textarea>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkResidentialAdoptedPlan\"\n                      ng-model=\"currentDensityPolicy.residential_density_adopted_plan_checked\"\n                      ng-disabled=\"formReadOnly\"\n                      onchange=\"angular.element(this).scope().setPending(this)\">\n                    <label class=\"form-check-label\" for=\"checkResidentialAdoptedPlan\"\n                      ng-class=\"{'boldFont': residential_density_adopted_plan_checked}\">\n                      Relying on an adopted plan for minimum densities.\n                    </label>\n                    <p>A jurisdiction without minimum residential\n                      zoning standards may use the minimums identified in an adopted General Plan, Specific Plan, or\n                      Area\n                      Plan to the extent that the Plan requires that\n                      new development <strong>must</strong> occur at or above a minimum threshold.</p>\n                  </div>\n                  <div class=\"row align-items-center\"\n                    ng-show=\"currentDensityPolicy.residential_density_adopted_plan_checked\">\n                    <div class=\"col-lg-1\">\n                      <label for=\"residential_density_adopted_plan\">URL</label>\n                    </div>\n                    <div class=\"col-lg-5\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_adopted_plan)\">\n                      <input id=\"residential_density_adopted_plan\"\n                        ng-model=\"currentDensityPolicy.residential_density_adopted_plan\" type=\"text\"\n                        placeholder=\"Enter response or URL\" value=\"\" required />\n                    </div>\n                    <!-- File upload residential_density_adopted_plan -->\n                    <!-- <div ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_adopted_plan)\"\n                      style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div>\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentDensityPolicy.residential_density_adopted_plan)\"\n                      style=\"padding-bottom:10px;\">\n                      <span style=\"padding-right:10px;\"><a\n                          ng-href=\"{{currentDensityPolicy.residential_density_adopted_plan}}\">Uploaded\n                          Documentation</a></span>\n                      <button class=\"button button--attach\" ng-click=\"removeFile('residential_density_adopted_plan')\"><i\n                          ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n                    </div>\n                    <div class=\"row\" style=\"padding-bottom:20px;padding-top:20px;\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_adopted_plan)\">\n                      <div class=\"col-lg-2\"><label for=\"residential_density_adopted_plan_file_abcd\">Upload Adopted Plan\n                          Documentation</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                        <input type=\"file\" ng-model=\"residential_density_adopted_plan_file_abcd\"\n                          id=\"residential_density_adopted_plan_file_abcd\"\n                          name=\"residential_density_adopted_plan_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-5\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('residential_density_adopted_plan_file_abcd')\"><i\n                            ng-show=\"fileUploading_residential_density_adopted_plan_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File</button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('residential_density_adopted_plan_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n                    <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                      <label for=\"residential_adopted_plan_additional_details\">Additional Details (Optional)</label>\n                      <textarea ng-model=\"currentDensityPolicy.residential_adopted_plan_additional_details\"\n                        onchange=\"angular.element(this).scope().setPending(this)\"\n                        id=\"residential_adopted_plan_additional_details\"\n                        name=\"residential_adopted_plan_additional_details\" rows=\"4\" style=\"width: 100%;\">\n                        </textarea>\n                    </div> -->\n                    <div ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_adopted_plan)\"\n                      style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div>\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentDensityPolicy.residential_density_adopted_plan)\"\n                      style=\"padding-bottom:10px;\">\n                      <span style=\"padding-right:10px;\"><a\n                          ng-href=\"{{currentDensityPolicy.residential_density_adopted_plan}}\">Uploaded\n                          Documentation</a></span>\n                      <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('residential_density_adopted_plan')\"><i\n                          ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n                    </div>\n                    <div class=\"row\" style=\"padding-bottom:20px;padding-top:20px;\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_adopted_plan)\">\n                      <div class=\"col-lg-2\"><label for=\"residential_density_adopted_plan_file_abcd\">Upload Adopted Plan\n                          Documentation</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                        <input type=\"file\" ng-model=\"residential_density_adopted_plan_file_abcd\"\n                          id=\"residential_density_adopted_plan_file_abcd\"\n                          name=\"residential_density_adopted_plan_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                      </div>\n                      <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('residential_density_adopted_plan_file_abcd')\"><i\n                            ng-show=\"fileUploading_residential_density_adopted_plan_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File</button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('residential_density_adopted_plan_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n                    <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                      <label for=\"residential_adopted_plan_additional_details\">Additional Details <i>(Optional)</i>:</label>\n                      <textarea ng-model=\"currentDensityPolicy.residential_adopted_plan_additional_details\"\n                        onchange=\"angular.element(this).scope().setPending(this)\"\n                        id=\"residential_adopted_plan_additional_details\"\n                        name=\"residential_adopted_plan_additional_details\" rows=\"4\" style=\"width: 100%;\">\n                  </textarea>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkResidentialExcludeParcels\"\n                      ng-model=\"currentDensityPolicy.residential_density_exclude_parcels_checked\" ng-disabled=\"formReadOnly\"\n                      onchange=\"angular.element(this).scope().setPending(this)\">\n                    <label class=\"form-check-label\" for=\"checkResidentialExcludeParcels\"\n                      ng-class=\"{'boldFont': residential_density_exclude_parcels_checked}\">\n                      Excluding parcels from density calculations.\n                    </label>\n                    <p>Parcels with existing dwelling units may be excluded from the residential calculations UNLESS the parcel was counted as a Housing Opportunity Site in the jurisdiction’s Housing Element and assumed to produce one or more units of housing. For the TOC Policy, “existing dwelling units” are residential units that received a building permit prior to January 1, 2024. For any excluded parcel, the jurisdiction must document the assessor parcel number (APN), acreage, existing zoning, and existing land use. Most of this information can be exported from this Portal by clicking on the \"TOC Parcel Data\" button on the Map page. However, jurisdictions will need to add information about the existing land uses for parcels to the spreadsheet that is exported.</p>\n                  </div>\n                  <div class=\"row align-items-center\"\n                    ng-show=\"currentDensityPolicy.residential_density_exclude_parcels_checked\">\n                    <div class=\"col-lg-1\">\n                      <label for=\"residential_density_exclude_parcels\">URL</label>\n                    </div>\n                    <div class=\"col-lg-5\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_exclude_parcels)\">\n                      <input id=\"residential_density_exclude_parcels\"\n                        ng-model=\"currentDensityPolicy.residential_density_exclude_parcels\" type=\"text\"\n                        placeholder=\"Enter response or URL\" value=\"\" required />\n                    </div>\n                    <!-- File upload residential_density_exclude_parcels -->\n                    <div ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_exclude_parcels)\"\n                      style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div>\n                    <div class=\"col-md-5\"\n                      ng-if=\"checkSubstring(currentDensityPolicy.residential_density_exclude_parcels)\"\n                      style=\"padding-bottom:10px;\">\n                      <span style=\"padding-right:10px;\"><a\n                          ng-href=\"{{currentDensityPolicy.residential_density_exclude_parcels}}\">Uploaded\n                          Documentation</a></span>\n                      <button class=\"button button--attach\" ng-if=\"!formReadOnly\"\n                        ng-click=\"removeFile('residential_density_exclude_parcels')\"><i ng-show=\"fileUploading\"\n                          class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n                    </div>\n                    <div class=\"row\" style=\"padding-bottom:20px;padding-top:20px;\"\n                      ng-if=\"!checkSubstring(currentDensityPolicy.residential_density_exclude_parcels)\">\n                      <div class=\"col-lg-2\">\n                        <label for=\"residential_density_exclude_parcels_file_abcd\">Upload Excluded Parcels\n                          Documentation</label>\n                      </div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                        <input type=\"file\" ng-model=\"residential_density_exclude_parcels_file_abcd\"\n                          id=\"residential_density_exclude_parcels_file_abcd\"\n                          name=\"residential_density_exclude_parcels_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                      </div>\n                      <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('residential_density_exclude_parcels_file_abcd')\"><i\n                            ng-show=\"fileUploading_residential_density_exclude_parcels_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File</button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('residential_density_exclude_parcels_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                      <label for=\"residential_exclude_parcels_additional_details\">Additional Details <i>(Optional)</i>:</label>\n                      <textarea ng-model=\"currentDensityPolicy.residential_exclude_parcels_additional_details\"\n                        id=\"residential_exclude_parcels_additional_details\" ng-disabled=\"formReadOnly\"\n                        onchange=\"angular.element(this).scope().setPending(this)\"\n                        name=\"residential_exclude_parcels_additional_details\" rows=\"4\" style=\"width: 100%;\">\n                        </textarea>\n                    </div>\n                  </div>\n                </div>\n              </form>\n              <submissionsectionsubmit></submissionsectionsubmit>\n            </div>\n\n            <!-- Residential Data Submission Page  -->\n            <div id=\"section-3\" role=\"tabpanel\" class=\"section tab-pane\" ng-class=\"{'active show': reviewAndSubmit}\">\n              <h2>III. Review and Submit</h2>\n              <div class=\"row\" style=\"padding-top:5px;padding-bottom:5px;\" ng-show=\"submitted\">\n                <div class=\"col\">\n                  <div style=\"background-color: white;\">\n                    <div class=\"form-confirmation__header\">\n                      <p>You submitted</p>\n                      <p class=\"h2\" style=\"padding-top:20px;\" ng-repeat=\"item in submissionList\">{{item}}</p>\n                    </div>\n                    <div class=\"form-confirmation__message\" style=\"padding:20px;\">\n                      <p>Your submissions have been received by MTC and are currently in review. We will contact you\n                        should any questions arise or any further information be required.</p>\n                    </div>\n                    <div class=\"row align-items-center\" ng-show=\"density.residentialUsesCheck\">\n                      <p>\n                        I have completed the\n                        <a href=\"#\" ng-click=\"togglePanel('residentialUses'); scrollToTop()\">Compliance with\n                          MTC's\n                          Residential Data Verification Section</a>\n                        and uploaded any relevant documentation.\n                      </p>\n                    </div>\n                    <div class=\"row align-items-center\" ng-show=\"residentialUses[0].submitted\">\n                      <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                        <div class=\"col\">\n                          <div class=\"alert alert-success fade show\" role=\"alert\">\n                            This section has been submitted and is under review.\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div ng-show=\"!submitted\">\n                <div class=\"status-pills\">\n                </div>\n                <p>\n                  Use this page to submit changes to residential\n                  zoning information. Jurisdiction staff must complete the “Residential Data Verification” form\n                  prior to\n                  submitting changes.\n                </p>\n                <p>\n                  You are submitting the following residential zones for review by MTC:\n                </p>\n                <div class=\"row\">\n                  <div class=\"col-lg-12\">\n                    <table class=\"table table--data-table table-borderless table-striped\">\n                      <thead class=\"table-dark\">\n                        <tr>\n                          <th>\n                            <div class=\"th-inner\">\n                              Code\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Description\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Minimum DUA\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Maximum DUA\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Updated By\n                            </div>\n                          </th>\n                          <th>\n                            <div class=\"th-inner\">\n                              Update Date\n                            </div>\n                          </th>\n                        </tr>\n                      </thead>\n                      <tbody>\n                        <tr ng-repeat=\"item in znCodes\">\n                          <td>{{item.zn_code}}</td>\n                          <td>{{item.zn_description}}</td>\n                          <td>{{item.toc_min_dua}}</td>\n                          <td>{{item.toc_max_dua}}</td>\n                          <td>{{item.editor_id}}</td>\n                          <td>{{item.last_edited}}</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n                <form class=\"row\" novalidate>\n                  <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                    <div class=\"verification-container\">\n                      <div class=\"form-check\">\n                        <input id=\"submitDensityForReview\" class=\"form-check-input\" type=\"checkbox\"\n                          ng-model=\"density.residentialUsesCheck\" ng-disabled=\"residentialUsesCheck === true\"\n                          ng-click=\"addToSubmissions('Residential Uses Data Verification'); submitDensityForReview = true\">\n                        <label ng-class=\"{'boldFont': submitDensityForReview}\">\n                          I confirm I have already submitted the relevant information and/or explanation to document\n                          any changes to data about residential zones/densities including the <a href=\"#\"\n                            ng-click=\"togglePanel('residentialUses'); scrollToTop()\">Residential Data Verification Form</a>. <span ng-if=\"residentialUsesCheck === true\"\n                                        class=\"badge badge--submitted\">Submitted</span>\n                        </label>\n                      </div>\n                    </div>\n                  </div>\n                </form>\n              </div>\n              <submissionsectionsubmit></submissionsectionsubmit>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n        <sidebarfooter></sidebarfooter>\n      </div>\n    </div>\n</section>\n\n<!-- add zoning code modal  -->\n<div class=\"modal fade\" id=\"addZoningCodeModal\" tabindex=\"-1\" aria-labelledby=\"addZoningCodeModalTitle\"\n  style=\"display: none;\" aria-hidden=\"true\">\n  <div class=\"modal-dialog modal-lg\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n        <h1 class=\"modal-title\" id=\"addZoningCodeModalTitle\">Add New Zoning Code</h1>\n      </div>\n      <div class=\"modal-body\" style=\"padding-left:10%;\">\n        <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n          novalidate>\n          <!-- Zoning Code Name  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_code\">Zoning Code:</label>\n            <input type=\"text\" id=\"zn_code\" name=\"zn_code\" placeholder=\"\" value=\"\" ng-model=\"addCode.zn_code\"\n              required />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_code.$error.required && formSubmitted\">\n              Please choose a valid response.\n            </div>\n          </div>\n          <!-- Zoning Code Description  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_description\">Zoning Code Description:</label>\n            <input id=\"zn_description\" name=\"zn_description\" type=\"text\" placeholder=\"\" required\n              ng-model=\"addCode.zn_description\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_description.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Code URL  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_code_url\">Zoning Code Documentation URL:</label>\n            <input id=\"zn_code_url\" name=\"zn_code_url\" type=\"text\" placeholder=\"\" required\n              ng-model=\"addCode.zn_code_url\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_code_url.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n\n          <!-- Zoning Min DUA  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_min_dua\">Minimum DUA:</label>\n            <input id=\"zn_min_dua\" name=\"zn_min_dua\" type=\"number\" placeholder=\"\" required\n              ng-model=\"addCode.zn_min_dua\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_min_dua.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Max DUA  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_max_dua\">Maximum DUA:</label>\n            <input id=\"zn_max_dua\" name=\"zn_max_dua\" type=\"number\" placeholder=\"\" required\n              ng-model=\"addCode.zn_max_dua\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_max_dua.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n          <!-- Zoning Min FAR  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_min_far\">Minimum FAR:</label>\n            <input id=\"zn_min_far\" name=\"zn_min_far\" type=\"number\" placeholder=\"\" required\n              ng-model=\"addCode.zn_min_far\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_min_far.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n          <!-- Zoning Max FAR  -->\n          <div class=\"form-item col-lg-8\">\n            <label for=\"zn_max_far\">Maximum FAR:</label>\n            <input id=\"zn_max_far\" name=\"zn_max_far\" type=\"number\" placeholder=\"\" required\n              ng-model=\"addCode.zn_max_far\" />\n            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n              ng-show=\"form.zn_max_far.$error.required && formSubmitted\">\n              Please provide a valid response.\n            </div>\n          </div>\n\n\n          <!-- Zoning Allows Residential  -->\n          <div class=\"form-item form-check col-lg-8\">\n            <input class=\"form-check-input\" type=\"checkbox\" id=\"allows_residential\" name=\"allows_residential\"\n              ng-model=\"addCode.allows_residential\" />\n            <label class=\"form-check-label\" for=\"allows_residential\">Allows Residential</label>\n          </div>\n\n\n          <!-- Zoning Allows Commercial Office  -->\n          <div class=\"form-item form-check col-lg-8\">\n            <input class=\"form-check-input\" type=\"checkbox\" id=\"allows_comm_office\" name=\"allows_comm_office\"\n              ng-model=\"addCode.allows_comm_office\" />\n            <label class=\"form-check-label\" for=\"allows_comm_office\">Allows Commercial Office</label>\n          </div>\n\n          <!-- Notifications for table updates  -->\n          <div ng-if=\"notificationMessage\" class=\"alert alert-danger\" role=\"alert\">\n            {{notificationMessage}}\n          </div>\n\n\n          <div class=\"form-item col-lg-8\" style=\"padding-top: 20px;\">\n            <button type=\"submit\" class=\"btn btn-primary btn-lg\" ng-click=\"addZoningCode()\">\n              <span ng-if=\"!saving\">Save Code</span>\n              <span ng-if=\"saving\"><i class=\"fa-solid fa-cog fa-spin\"\n                  style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>Saving...</span>\n            </button>\n            <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-bs-dismiss=\"modal\">Cancel</button>\n          </div>\n\n        </form>\n\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- delete zoning code modal  -->\n<div class=\"modal fade\" id=\"deleteZoningCodeModal\" tabindex=\"-1\" aria-labelledby=\"deleteZoningCodeModalTitle\"\n  style=\"display: none;\" aria-hidden=\"true\">\n  <div class=\"modal-dialog modal-lg\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n        <h1 class=\"modal-title\" id=\"deleteZoningCodeModalTitle\">Delete Zoning Code</h1>\n        <p>\n          Select one or more zoning codes to delete. Note that deleting a zoning code will also potentially\n          delete any current assignment of that code to parcels. This can impact weighted average calculations.\n        </p>\n      </div>\n      <div class=\"modal-body\">\n        <table class=\"table table--data-table table-borderless table-striped\">\n          <thead class=\"table-dark\">\n            <tr>\n              <th>\n                <div class=\"th-inner\">\n                  Select\n                </div>\n              </th>\n              <th>\n                <div class=\"th-inner\">\n                  Zoning Code\n                </div>\n              </th>\n              <th>\n                <div class=\"th-inner\">\n                  Zoning Description\n                </div>\n              </th>\n              <th style=\"display: none;\">\n                <div class=\"th-inner\">\n                  Rec ID\n                </div>\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"item in znCodes track by $index\">\n              <td>\n                <input type=\"checkbox\" ng-model=\"item.selected\" />\n              </td>\n              <td>{{item.zn_code}}</td>\n              <td>{{item.zn_description}}</td>\n              <td style=\"display: none;\">\n                <input type=\"hidden\" ng-model=\"item.rec_id\" />\n              </td>\n            </tr>\n\n          </tbody>\n        </table>\n        <div class=\"form-item col-lg-8\" style=\"padding-top: 20px;\">\n          <button type=\"button\" class=\"btn btn-danger btn-lg\" ng-click=\"deleteZoningCodes()\">\n            <span ng-if=\"!saving\">Delete Code(s)</span>\n            <span ng-if=\"saving\"><i class=\"fa-solid fa-cog fa-spin\"\n                style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>Deleting...</span>\n          </button>\n          <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-bs-dismiss=\"modal\">Cancel</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HousingComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _housing = __webpack_require__(141);
	
	var _housing2 = _interopRequireDefault(_housing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var HousingComponent = exports.HousingComponent = function () {
	  /*@ngInject*/
	  function HousingComponent($state, $scope, $rootScope, fetch, lookup, userService, $stateParams) {
	    _classCallCheck(this, HousingComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$stateParams = $stateParams;
	    this.userService = userService;
	
	    $scope.currentlySelectedPolicies = [];
	    $scope.productionCount = 0;
	    $scope.preservationCount = 0;
	    $scope.protectionCount = 0;
	    $scope.commercialCount = 0;
	    $scope.activityType = 'Housing';
	
	    $scope.getProductionSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Housing Production Policy').then(function (response) {
	        $scope.housingProductionStatus = _.filter(response.data, 'housing_policy_name');
	        if (response.data.length > 0) {
	          $scope.productionCount = _.uniq(_.map($scope.housingProductionStatus, 'housing_policy_name')).length;
	        } else {
	          $scope.productionCount = 0;
	        }
	        $scope.loadingSummaries = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getProtectionSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Housing Protection Policy').then(function (response) {
	        $scope.housingProtectionStatus = response.data;
	        $scope.housingProtectionStatus = _.filter(response.data, 'housing_policy_name');
	        if (response.data.length > 0) {
	          $scope.protectionCount = _.uniq(_.map($scope.housingProtectionStatus, 'housing_policy_name')).length;
	        } else {
	          $scope.protectionCount = 0;
	        }
	        $scope.loadingSummaries = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getPreservationSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Housing Preservation Policy').then(function (response) {
	        $scope.housingPreservationStatus = response.data;
	        $scope.housingPreservationStatus = _.filter(response.data, 'housing_policy_name');
	        if (response.data.length > 0) {
	          $scope.preservationCount = _.uniq(_.map($scope.housingPreservationStatus, 'housing_policy_name')).length;
	        } else {
	          $scope.preservationCount = 0;
	        }
	        $scope.loadingSummaries = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getCommercialSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Housing Commercial Policy').then(function (response) {
	        $scope.housingCommercialStatus = response.data;
	        $scope.housingCommercialStatus = _.filter(response.data, 'housing_policy_name');
	        if (response.data.length > 0) {
	          $scope.commercialCount = _.uniq(_.map($scope.housingcCommercialStatus, 'housing_policy_name')).length;
	        } else {
	          $scope.commercialCount = 0;
	        }
	        $scope.loadingSummaries = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationbyID = function (station) {
	      $scope.loadingSummaries = true;
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	        $scope.getProductionSubmissionStatus();
	        $scope.getCommercialSubmissionStatus();
	        $scope.getProtectionSubmissionStatus();
	        $scope.getPreservationSubmissionStatus();
	        $scope.getActivity();
	
	        vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	      }
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	        if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getActivity = function () {
	      var activityData = [];
	      fetch.getAllItems('api/data/submission/activity/' + $scope.currentSelectedStationId + '/' + $scope.activityType).then(function (response) {
	
	        $scope.submissionActivity = response.data;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	  }
	
	  _createClass(HousingComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$scope.submissionActivity = [];
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.getJurisdictionList();
	        _this.$scope.housingProductionForms = [];
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getHousingPreservationForms',
	    value: function getHousingPreservationForms() {
	      var _this3 = this;
	
	      this.fetch.getAllItems('api/data/housing/forms/Alameda/Preservation').then(function (response) {
	
	        response.data.forEach(function (element) {
	          if (element.policy_selected) {
	            _this3.$scope.currentlySelectedPolicies.push(element);
	          }
	        });
	        _this3.$scope.housingPreservationForms = response.data;
	        _this3.getSelectedCount();
	      });
	    }
	  }, {
	    key: 'getHousingProtectionForms',
	    value: function getHousingProtectionForms() {
	      var _this4 = this;
	
	      this.fetch.getAllItems('api/data/housing/forms/Alameda/Protection').then(function (response) {
	        response.data.forEach(function (element) {
	          if (element.policy_selected) {
	            _this4.$scope.currentlySelectedPolicies.push(element);
	          }
	        });
	        _this4.$scope.housingProtectionForms = response.data;
	        _this4.getSelectedCount();
	      });
	    }
	  }, {
	    key: 'getHousingProductionForms',
	    value: function getHousingProductionForms() {
	      var _this5 = this;
	
	      this.fetch.getAllItems('api/data/housing/forms/Alameda/Production').then(function (response) {
	
	        response.data.forEach(function (element) {
	          if (element.policy_selected) {
	            _this5.$scope.currentlySelectedPolicies.push(element);
	          }
	        });
	        _this5.$scope.housingProductionForms = response.data;
	        _this5.getSelectedCount();
	      });
	    }
	  }, {
	    key: 'getHousingCommercialForms',
	    value: function getHousingCommercialForms() {
	      var _this6 = this;
	
	      this.fetch.getAllItems('api/data/housing/forms/Alameda/Commercial').then(function (response) {
	
	        _this6.$scope.housingCommercialForms = response.data;
	        _this6.getSelectedCount();
	      });
	    }
	  }, {
	    key: 'updateSelected',
	    value: function updateSelected(item) {
	      var _this7 = this;
	
	      if (item.policy_selected) {
	        this.$scope.currentlySelectedPolicies.push(item);
	      } else {
	        for (var i = 0; i < this.$scope.currentlySelectedPolicies.length; i++) {
	          if (this.$scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
	            this.$scope.currentlySelectedPolicies.splice(i, 1);
	          }
	        }
	      }
	      var upsertData = {
	        policy_selected: item.policy_selected,
	        housing_form_id: item.housing_form_id
	      };
	      this.fetch.updateItem('api/data/housing/forms/update', upsertData).then(function (response) {
	        var selectedCheck = _.filter(_this7.$scope.currentlySelectedPolicies, { 'housing_form_id': item.housing_form_id });
	        _this7.getSelectedCount();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this7.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getSelectedCount',
	    value: function getSelectedCount() {
	      this.$scope.productionSelected = _.filter(this.$scope.housingProductionForms, { policy_selected: true });
	      this.$scope.protectionSelected = _.filter(this.$scope.housingProtectionForms, { policy_selected: true });
	      this.$scope.preservationSelected = _.filter(this.$scope.housingPreservationForms, { policy_selected: true });
	      this.$scope.commercialSelected = _.filter(this.$scope.housingCommercialForms, { policy_selected: true });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this8 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this8.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this8.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this8.$scope.submissionSummary);
	          _this8.lookup.setSubmissionPolicies(_this8.$scope.submissionSummary);
	
	          _this8.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this8.$scope.densitySubmitted = _.filter(_this8.$scope.densitySubmissions, { submitted: true });
	          _this8.$scope.densityCompliant = _.filter(_this8.$scope.densitySubmissions, { status: 'Compliant' });
	
	          _this8.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this8.$scope.housingPolicySubmissions = _.union(_this8.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this8.$scope.housingPolicySubmitted = _.filter(_this8.$scope.housingPolicySubmissions, { submitted: true });
	          _this8.$scope.housingPolicyCompliant = _.filter(_this8.$scope.housingPolicySubmissions, { status: 'Compliant' });
	
	          _this8.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this8.$scope.parkingSubmitted = _.filter(_this8.$scope.parkingSubmissions, { submitted: true });
	          _this8.$scope.parkingCompliant = _.filter(_this8.$scope.parkingSubmissions, { status: 'Compliant' });
	
	          _this8.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this8.$scope.stationAccessSubmitted = _.filter(_this8.$scope.stationAccessSubmissions, { submitted: true });
	          _this8.$scope.stationAccessCompliant = _.filter(_this8.$scope.stationAccessSubmissions, { status: 'Compliant' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return HousingComponent;
	}();
	
	exports.default = angular.module('appApp.housing', [uiRouter]).config(_housing2.default).component('housing', {
	  template: __webpack_require__(142),
	  controller: HousingComponent,
	  controllerAs: 'housingCtrl'
	}).name;

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('housing', {
	    url: '/account/housing',
	    template: '<housing></housing>'
	  });
	};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--page dashboard--page--submission\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <breadcrumbnav></breadcrumbnav>\n      <maintocselection />\n\n      <div class=\"container\" style=\"margin-left:242px;max-width: calc(100vw-242);\">\n        <div class=\"row content--style\">\n          <div class=\"col-lg-8\">\n            <h1 class=\"page-title\">Affordable Housing and Commercial Stabilization</h1>\n            <p>Production of all housing is a key goal of the TOC Policy but providing more affordable housing as\n              well as protecting and preserving existing affordable housing in locations near transit is an important\n              means of advancing equity in the region. </p>\n            <p>Given the region’s diverse needs and housing and land use contexts, the TOC Policy provides a “menu” of\n              policy options so jurisdictions can choose the policies that best meet local needs. </p>\n            <p>\n              To be consistent with the TOC Policy, a jurisdiction must adopt at least:\n            <ul>\n              <li>\n                <span style=\"font-weight: bold;\">Two policies for <span class=\"underlined\">each</span> of the\n                  “3Ps”</span>—affordable housing\n                production, preservation, and protection.\n              </li>\n              <li>\n                <span style=\"font-weight: bold;\">One policy related to commercial stabilization</span>.\n              </li>\n            </ul>\n            </p>\n            <div id=\"moreHousingContent\" style=\"padding-bottom:15px;\">\n              <p>A jurisdiction may meet the standards with existing adopted policies or, as needed, adopt new\n                policies. Policies may be implemented jurisdiction-wide, or as an\n                overlay in TOC areas. </p>\n              <p>\n                Review <a\n                  href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\"\n                  target=\"_blank\">Section 2 of the TOC Policy Administrative Guidance<span class=\"visually-hidden\">(link\n                    is external, opens in a new window)</span></a> for an overview of the TOC\n                Policy requirements for affordable housing and commercial stabilization. <span\n                  style=\"font-weight: bold;\">Appendix A</span> of the <a\n                  href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\"\n                  target=\"_blank\">Guidance<span class=\"visually-hidden\">(link is external,\n                    opens in a new window)</span></a> describes each policy option and the minimum standards a\n                policy must meet to be consistent with the TOC\n                Policy. Consistency with TOC housing policy standards should be completed in conformance\n                with relevant federal and state laws, including a jurisdiction’s duty to affirmatively further fair\n                housing.\n              </p>\n            </div>\n\n            <div class=\"tab-content\">\n\n              <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\">\n\n                <div class=\"row mb-2\">\n                  <div class=\"col\">\n                    <h3>\n                      Adopted Housing Policies Submitted for Review\n                    </h3>\n                  </div>\n                </div>\n                <!-- Notifications  -->\n                <div class=\"row\" ng-show=\"!currentSelectedStationId\" style=\"padding-top:5px;padding-bottom:15px;\">\n                  <div class=\"col\">\n                    <div class=\"alert alert-danger fade show\" role=\"alert\">\n                      <strong>Please select a station area... </strong>\n                    </div>\n                  </div>\n                </div>\n\n                <!-- Loading policies alert  -->\n                <div class=\"row\" ng-show=\"loadingSummaries\" style=\"padding-top:5px;padding-bottom:15px;\">\n                  <div class=\"col\">\n                    <div class=\"alert alert-info alert-dismissible fade show\" role=\"alert\">\n                      <i class=\"fa-solid fa-cog fa-spin\"\n                        style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i> Loading Policies for\n                      this station area...\n                      <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"row\">\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Affordable Housing Production\n                            </div>\n                            <div class=\"row\">\n                              <div class=\"col-md-8\">\n                                <div class=\"fs-1 lh-1\">\n                                  {{currentSelectedStationId ? (productionCount || '0') :'--'}}\n                                </div>\n                              </div>\n                              <div class=\"col-md-12\">\n                                <span>Min: 2 Policies</span>\n                              </div>\n                            </div>\n                          </div>\n                          <!-- <div class=\"d-flex align-items-end\">\n                            <i ng-if=\"productionCount === 2\" class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                            <i ng-if=\"productionCount < 2\" class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                          </div> -->\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Affordable Housing Preservation\n                            </div>\n                            <div class=\"row\">\n                              <div class=\"col-md-8\">\n                                <div class=\"fs-1 lh-1\">\n                                  {{currentSelectedStationId ? (preservationCount || '0') :'--'}}\n                                </div>\n                              </div>\n                              <div class=\"col-md-12\">\n                                <span>Min: 2 Policies</span>\n                              </div>\n                            </div>\n                          </div>\n                          <!-- <div class=\"d-flex align-items-end\">\n                            <i ng-if=\"preservationCount === 2\" class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                            <i ng-if=\"preservationCount < 2\" class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                          </div> -->\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Affordable Housing Protection\n                            </div>\n                            <div class=\"row\">\n                              <div class=\"col-md-8\">\n                                <div class=\"fs-1 lh-1\">\n                                  {{currentSelectedStationId ? (protectionCount || '0') :'--'}}\n                                </div>\n                              </div>\n                              <div class=\"col-md-12\">\n                                <span>Min: 2 Policies</span>\n                              </div>\n                            </div>\n                          </div>\n                          <!-- <div class=\"d-flex align-items-end\">\n                            <i ng-if=\"protectionCount === 2\" class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                            <i ng-if=\"protectionCount < 2\" class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                          </div> -->\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"col-lg-6 mb-4\">\n                    <div class=\"card card--density-position-tile\">\n                      <div class=\"card-body\">\n                        <div class=\"d-flex justify-content-between align-items-end\">\n                          <div class=\"flex-1\">\n                            <div class=\"fs-5 mb-2\">\n                              Commercial Stabilization\n                            </div>\n                            <div class=\"row\">\n                              <div class=\"col-md-8\">\n                                <div class=\"fs-1 lh-1\">\n                                  {{currentSelectedStationId ? (commercialCount || '0') :'--'}}\n                                </div>\n                              </div>\n                              <div class=\"col-md-12\">\n                                <span>Min: 1 Policy</span>\n                              </div>\n                            </div>\n                          </div>\n                          <!-- <div class=\"d-flex align-items-end\">\n                            <i ng-if=\"commericalCount === 1\" class=\"fa-solid fa-check-circle text-success fs-1\"></i>\n                            <i ng-if=\"commericalCount < 1\" class=\"fa-solid fa-triangle-exclamation text-danger fs-1\"></i>\n                          </div> -->\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-lg-3\" style=\"padding-top: 40px\">\n            <div class=\"right-content\">\n              <h2>Activity</h2>\n              <!-- sidebaractivity source /components/directives/sidebaractivity  -->\n              <sidebaractivity></sidebaractivity>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- <submissionsectionsubmit /> -->\n    <div class=\"footer\" role=\"contentinfo\">\n      <sidebarfooter />\n    </div>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HousingRequirementsComponent = undefined;
	
	var _housing_requirements = __webpack_require__(144);
	
	var _housing_requirements2 = _interopRequireDefault(_housing_requirements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var HousingRequirementsComponent =
	/*@ngInject*/
	exports.HousingRequirementsComponent = function HousingRequirementsComponent() {
	  _classCallCheck(this, HousingRequirementsComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.housing_requirements', [uiRouter]).config(_housing_requirements2.default).component('housingRequirements', {
	  template: __webpack_require__(145),
	  controller: HousingRequirementsComponent,
	  controllerAs: 'housingRequirementsCtrl'
	}).name;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('housing_requirements', {
	    url: '/account/housing/housing_requirements',
	    template: '<housing-requirements></housing-requirements>',
	    authenticate: true
	  });
	};

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--content--housing\">\n  <div class=\"page-wrapper\">\n      <div class=\"dashboard-header\">\n        <!-- Sidebarnav source components/directives/sidebarnav  -->\n          <sidebarnav></sidebarnav>\n      </div>\n      <div class=\"main\">\n        <!-- mainheaderauth source components/directives/mainheaderauth  -->\n          <mainheaderauth></mainheaderauth>\n          <div class=\"content container\">\n              <div class=\"row\">\n                  <div class=\"col-lg-8\">\n                      <h1 class=\"page-title\">Housing Policy Requirements </h1>\n                      <div class=\"page-summary\">Affordable Housing Production, Preservation, and Protection and Commercial Stabilization</div>\n                      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                      <figure>\n                          <img class=\"image--full\" src=\"../../../assets/images/mockups/dashboard-content-image.jpg\" alt=\"Person wearing a mask and helmet on a bike\" height=\"730\" width=\"410\"/>\n                          <figcaption>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. <span class=\"image-credit\">Credit: Sergio Ruiz</span></figcaption>\n                      </figure>\n\n                      <h2><a href=\"#\">Further Guidance H2</a></h2>\n                      <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n\n                      <h2><a href=\"#\">Affordable Housing Production Policy</a></h2>\n                      <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                  </div>\n                 \n              </div>\n          </div>\n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n          <sidebarfooter></sidebarfooter>\n      </div>\n  </div>\n</section>\n"

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GuidanceComponent = undefined;
	
	var _guidance = __webpack_require__(147);
	
	var _guidance2 = _interopRequireDefault(_guidance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var GuidanceComponent =
	/*@ngInject*/
	exports.GuidanceComponent = function GuidanceComponent() {
	  _classCallCheck(this, GuidanceComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('websiteApp.guidance', [uiRouter]).config(_guidance2.default).component('guidance', {
	  template: __webpack_require__(148),
	  controller: GuidanceComponent,
	  controllerAs: 'guidanceCtrl'
	}).name;

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('guidance', {
	    url: '/account/housing/guidance',
	    template: '<guidance></guidance>',
	    authenticate: true
	  });
	};

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--content--housing\">\n    <div class=\"page-wrapper\">\n        <div class=\"dashboard-header\">\n          <!-- Sidebarnav source components/directives/sidebarnav  -->\n            <sidebarnav></sidebarnav>\n        </div>\n        <div class=\"main\">\n          <!-- mainheaderauth source components/directives/mainheaderauth  -->\n            <mainheaderauth></mainheaderauth>\n            <div class=\"content container\">\n                <div class=\"row\">\n                    <div class=\"col-lg-8\">\n                        <h1 class=\"page-title\">Housing Policy Further Guidance </h1>\n                        <div class=\"page-summary\">Affordable Housing Production, Preservation, and Protection and Commercial Stabilization</div>\n                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                        <figure>\n                            <img class=\"image--full\" src=\"../../../assets/images/mockups/dashboard-content-image.jpg\" alt=\"Person wearing a mask and helmet on a bike\" height=\"730\" width=\"410\"/>\n                            <figcaption>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. <span class=\"image-credit\">Credit: Sergio Ruiz</span></figcaption>\n                        </figure>\n  \n                        <h2><a href=\"#\">Further Guidance H2</a></h2>\n                        <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n  \n                        <h2><a href=\"#\">Affordable Housing Production Policy</a></h2>\n                        <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                    </div>\n                   \n                </div>\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter></sidebarfooter>\n        </div>\n    </div>\n  </section>\n  "

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CommercialStabilizationComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _commercial_stabilization = __webpack_require__(150);
	
	var _commercial_stabilization2 = _interopRequireDefault(_commercial_stabilization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var CommercialStabilizationComponent = exports.CommercialStabilizationComponent = function () {
	  /*@ngInject*/
	  function CommercialStabilizationComponent($state, $scope, $rootScope, fetch, lookup, userService, $timeout, $http, baseConfigService, $stateParams) {
	    _classCallCheck(this, CommercialStabilizationComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.$state = $state;
	    this.lookup = lookup;
	    this.$timeout = $timeout;
	    this.userService = userService;
	    this.baseConfigService = baseConfigService;
	    this.$stateParams = $stateParams;
	    this.$http = $http;
	    this.$scope.checkPolicy1 = null;
	
	    $scope.adminUnlocked = false;
	    $scope.formsSubmitData = [];
	    $scope.currentlySelectedPolicies = [];
	    $scope.pdfUrls = {
	      'Small Business Advocate Office': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Small_Biz_Advocate.pdf',
	      'Small Business and Non-Profit Overlay': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Small_Biz_Non-Profit_Overlay.pdf',
	      'Small Business and Non-Profit Preference Policy': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Small_Biz_Non-Profit_Preference.pdf',
	      'Small Business and Non-Profit Financial Assistance Program': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Small_Biz_Non-Profit_Financial_Assistance.pdf'
	    };
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.pendingChanges = false;
	    $scope.savemode = 'housing';
	    $scope.housingType = 'Commercial';
	    $scope.note = '<strong>Note:</strong> A jurisdiction must enter information for all fields for each affordable housing preservation policy they are using to demonstrate TOC Policy compliance. If any field is not relevant to a jurisdiction, enter “N/A".';
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.setPending = function () {
	      $scope.savemode = 'housing';
	      $scope.pendingChanges = true;
	    };
	
	    $scope.openPdf = function (item) {
	      var pdfUrl = $scope.pdfUrls[item.housing_policy_name];
	
	      if (pdfUrl) {
	        window.open(pdfUrl, '_blank');
	      } else {
	        console.error('PDF URL not found for policy: ' + item.housing_policy_name);
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.housingStatus) {
	        for (var i = 0; i < $scope.housingStatus.length; i++) {
	          if ($scope.housingStatus[i].housing_policy_name === $scope.currentPolicy.housing_policy_name) {
	            submission = $scope.housingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentPolicy && $scope.currentPolicy.housing_policy_name;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.housingStatus && $scope.currentPolicy && $scope.currentPolicy.housing_policy_name) {
	        var currentSubmission = _.find($scope.housingStatus, { housing_policy_name: $scope.currentPolicy.housing_policy_name });
	        if (currentSubmission && currentSubmission.submitted && currentSubmission.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('housingStatus', function () {
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm("Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.");
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.housingStatus) {
	        for (var i = 0; i < $scope.housingStatus.length; i++) {
	          if ($scope.housingStatus[i].housing_policy_name === $scope.currentPolicy.housing_policy_name) {
	            submission = $scope.housingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error("No matching submission found to withdraw");
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem("api/data/submissions/update-status", payload).then(function () {
	        var matchingPolicy = $scope.currentlySelectedPolicies.find(function (p) {
	          return p.housing_policy_name === $scope.currentPolicy.housing_policy_name;
	        });
	        if (matchingPolicy) {
	          matchingPolicy.include_in_submission = false;
	        }
	        submission.submitted = false;
	        submission.status = null;
	
	        if ($scope.checkPolicy1 && $scope.checkPolicy1.submission_id === submission.submission_id) {
	          $scope.checkPolicy1 = null;
	        }
	
	        $scope.formsSubmitData = $scope.formsSubmitData.filter(function (p) {
	          return p.housing_policy_name !== $scope.currentPolicy.housing_policy_name;
	        });
	
	        $scope.submitType = 'Submit Housing Policies for Review (' + $scope.formsSubmitData.length + ')';
	
	        var policyName = $scope.currentPolicy.housing_policy_name;
	        var formId = $scope.currentPolicy.housing_form_id;
	        $scope.currentPolicy = { housing_policy_name: policyName, housing_form_id: formId };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	
	        $scope.formReadOnly = false;
	      }).catch(function (err) {
	        console.error("Withdraw failed:", err);
	        alert("There was an error withdrawing the submission. Please try again.");
	      });
	    };$scope.addToSubmissions = function (policy) {
	      $scope.savemode = null;
	      if (_.filter($scope.formsSubmitData, { 'housing_policy_name': policy.housing_policy_name }).length === 1) {
	        $scope.formsSubmitData = _.remove($scope.formsSubmitData, function (n) {
	          return n.housing_policy_name !== policy.housing_policy_name;
	        });
	      } else {
	        $scope.formsSubmitData.push(policy);
	      }
	
	      $scope.submitmode = 'housing';
	      $scope.submitType = 'Submit Housing Policies for Review (' + $scope.formsSubmitData.length + ')';
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Housing ' + $scope.housingType + ' Policy').then(function (response) {
	
	        $scope.housingStatus = response.data;
	        console.log($scope.housingStatus);
	
	        $scope.checkPolicy1 = _.filter(response.data, {
	          submission_policy_name: 'Commercial Stabilization Policy',
	          submitted: true
	        })[0];
	
	        if ($scope.currentlySelectedPolicies) {
	          $scope.currentlySelectedPolicies.forEach(function (policy) {
	            if ($scope.checkPolicy1 && $scope.checkPolicy1.submitted === true && $scope.checkPolicy1.housing_policy_name === policy.housing_policy_name) {
	              policy.include_in_submission = true;
	            }
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.submitPolicies = function () {
	      $scope.saving = true;
	      var upsertData = [];
	      if ($scope.formsSubmitData.length === 1) {
	        var data = $scope.formsSubmitData[0];
	        if (!$scope.checkPolicy1) {
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === 'Commercial Stabilization Policy' && element.sta_recid === data.sta_recid) {
	              element.housing_policy_name = data.housing_policy_name;
	              element.submitted = true;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        }
	      }
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.getSubmissionStatus();
	          $scope.$apply();
	        }, 3000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updatePoliciesJurisdiction = function (jurisdiction) {
	      $scope.currentlySelectedPolicies = [];
	      lookup.setJurisdiction(jurisdiction);
	      $scope.currentJurisdiction = jurisdiction;
	      $scope.getStationbyID();
	      $scope.getSubmissionStatus();
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	      $scope.getSubmissionStatus();
	      $scope.currentlySelectedPolicies = [];
	      $scope.loadingPolicies = true;
	      fetch.getAllItems('api/data/housing/forms/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + $scope.housingType).then(function (response) {
	
	        $scope.currentStation = response.data[0];
	
	        response.data.forEach(function (element) {
	          if (element.policy_selected) {
	            $scope.currentlySelectedPolicies.push(element);
	          }
	        });
	
	        var requestedPolicyName = $stateParams.policyName;
	        var policyToSelect = null;
	
	        if (requestedPolicyName && $scope.currentlySelectedPolicies.length > 0) {
	          policyToSelect = $scope.currentlySelectedPolicies.find(function (p) {
	            return p.housing_policy_name === requestedPolicyName;
	          });
	        }
	
	        if (policyToSelect) {
	          policyToSelect.active = true;
	          $scope.currentPolicy = policyToSelect;
	
	          $scope.setCurrentPolicy($scope.currentPolicy);
	        } else if ($scope.currentlySelectedPolicies.length > 0) {
	          $scope.currentlySelectedPolicies[0].active = true;
	          $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
	          $scope.setCurrentPolicy($scope.currentPolicy);
	        }
	
	        $scope.housingForms = response.data;
	        $scope.loadingPolicies = false;
	      });
	    };
	
	    $scope.updateSelected = function (item) {
	      if ($scope.currentlySelectedPolicies.length > 0) {
	        $scope.currentlySelectedPolicies.forEach(function (element) {
	          element.active = false;
	        });
	      }
	
	      if (item.policy_selected) {
	        $scope.currentlySelectedPolicies.push(item);
	      } else {
	        for (var i = 0; i < $scope.currentlySelectedPolicies.length; i++) {
	          if ($scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
	            $scope.currentlySelectedPolicies.splice(i, 1);
	          }
	        }
	      }
	      if ($scope.currentlySelectedPolicies.length > 0) {
	        $scope.currentlySelectedPolicies[0].active = true;
	        $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
	      } else {
	        $scope.currentPolicy = {};
	      }
	      var upsertData = {
	        policy_selected: item.policy_selected,
	        housing_form_id: item.housing_form_id
	      };
	
	      console.log(upsertData);
	      fetch.updateItem('api/data/housing/forms/update', upsertData).then(function (response) {}).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.setCurrentPolicy = function (item) {
	      if (item === 'reviewAndSubmit') {
	        $scope.currentPolicy = {};
	        $scope.reviewAndSubmit = true;
	        $scope.note = '';
	      } else if (!item) {
	        $scope.reviewAndSubmit = false;
	        $scope.note = '<strong>Note:</strong> A jurisdiction must enter information for all fields for each affordable housing preservation policy they are using to demonstrate TOC Policy compliance. If any field is not relevant to a jurisdiction, enter “N/A".';
	      } else {
	        $scope.reviewAndSubmit = false;
	        $scope.currentPolicy = item;
	      }
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        } else {
	          $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
	        }
	
	        lookup.setCurrentStation($scope.currentSelectedStationId);
	
	        $scope.getStationbyID();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentPolicy = function (form) {
	      $scope.formSubmitted = true;
	      $scope.form = form;
	      $scope.saving = true;
	      if ($scope.currentPolicy.active) {
	        delete $scope.currentPolicy.active;
	      }
	
	      console.log('Saving currentPolicy:', angular.copy($scope.currentPolicy));
	      fetch.updateItem('api/data/housing/forms/update', $scope.currentPolicy).then(function (response) {
	
	        $scope.saving = false;
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.savemode = null;
	          $scope.saved = false;
	          $scope.currentPolicy.active = true;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getHousingForm = function () {
	      var currentPolicy = $scope.currentPolicy;
	      if (currentPolicy && currentPolicy.housing_form_id) {
	        fetch.getAllItems('api/data/getForm/' + currentPolicy.housing_form_id).then(function (response) {
	          $scope.currentPolicy = response.data[0];
	        }).catch(function (error) {
	          console.error('Error fetching currentPolicy for the current policy:', error);
	
	          $scope.currentPolicy = {};
	        });
	      } else {
	        console.warn('current policy is not defined or is missing a housing_form_id.');
	
	        $scope.currentPolicy = {};
	      }
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById('fileInput' + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
	            alert('Please select a PDF, Word document, or Excel file.');
	            element.value = '';
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById('' + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope[ngmodel] = '';
	        $scope[ngmodel + '_preview'] = '';
	        $scope['fileUploading_' + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope['fileUploading_' + ngmodelfile] = true;
	      var file = document.getElementById('' + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'housing';
	      $scope.pendingChanges = true;
	    };
	  }
	
	  _createClass(CommercialStabilizationComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.housingForms = [];
	        return _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        if (!Array.isArray(response.data)) {
	          console.error('Unexpected response for jurisdiction-list:', response.data);
	          _this2.$state.go('login');
	          return;
	        }
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	          _this3.lookup.setSubmissionPolicies(_this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return CommercialStabilizationComponent;
	}();
	
	exports.default = angular.module('appApp.commercial_stabilization', [uiRouter]).config(_commercial_stabilization2.default).component('commercialStabilization', {
	  template: __webpack_require__(151),
	  controller: CommercialStabilizationComponent,
	  controllerAs: 'commercialStabilizationCtrl'
	}).name;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('commercial_stabilization', {
	    url: '/account/housing/commercial_stabilization?jurisdiction&sta_recid&policyName',
	    template: '<commercial-stabilization></commercial-stabilization>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null,
	      policyName: null }
	  });
	};

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = "<section\n  class=\"dashboard dashboard--page dashboard--page--submission dashboard--compliance dashboard--compliance--jurisdiction\"\n>\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <maintocselection />\n\n      <div class=\"content container\">\n        <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <p>\n          To comply with the TOC Policy, a jurisdiction must adopt\n          <strong>at least one</strong> commercial stabilization policy unless\n          the jurisdiction can document there are no potential impacts to small\n          businesses and/or community non-profits. Appendix A of the\n          <a\n            href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\"\n            >TOC Policy Administrative Guidance</a\n          >\n          describes the four policy options in more detail and outlines the\n          minimum standards a jurisdiction's policy must meet to comply with the\n          TOC Policy.\n        </p>\n        <div class=\"section\">\n          <h2 class=\"icon icon--housing\">\n            Commercial Stabilization Policy Options\n          </h2>\n          <notificationmessages />\n          <selecthousingpolicies />\n        </div>\n        <div class=\"section-nav\">\n          <div class=\"menu--section-title\">In this section:</div>\n          <ul class=\"menu menu--section\" role=\"tablist\">\n            <li\n              ng-repeat=\"item in currentlySelectedPolicies\"\n              data-bs-toggle=\"tab\"\n              class=\"menu-item menu-item--section\"\n              ng-class=\"{ 'active': item.active }\"\n              ng-click=\"setCurrentPolicy(item)\"\n            >\n              <span class=\"section-number\">{{$index + 1}}.</span\n              ><a href=\"#\">{{ item.housing_policy_name }}</a>\n            </li>\n            <li\n              data-bs-toggle=\"tab\"\n              data-bs-target=\"#section-review-submit-housing\"\n              class=\"menu-item menu-item--section\"\n              ng-click=\"setCurrentPolicy('reviewAndSubmit')\"\n            >\n              <span class=\"section-number\"></span\n              ><a href=\"#\">Review and Submit</a>\n            </li>\n          </ul>\n          <note\n            class=\"section-pin\"\n            style=\"padding-left: 20px\"\n            ng-if=\"note\"\n            ng-bind-html=\"note\"\n          ></note>\n          <furtherguidance></furtherguidance>\n        </div>\n        <div class=\"tab-content\">\n          <!-- Review and Submit -->\n          <div\n            id=\"section-review-submit-housing\"\n            role=\"tabpanel\"\n            class=\"section tab-pane\"\n            ng-class=\"{'active show': reviewAndSubmit}\"\n          >\n            <h2>Review and Submit Commercial Stabilization Policies</h2>\n            <p>\n              <span style=\"font-style: italic\">\n                Select policies below to submit to MTC for review.</span\n              >\n            </p>\n\n            <form\n              class=\"row test-validation-styling\"\n              novalidate\n              style=\"margin-left: 2px\"\n            >\n              <div\n                class=\"verification-container\"\n                ng-repeat=\"item in currentlySelectedPolicies\"\n              >\n                <div class=\"form-check\">\n                  <input\n                    class=\"form-check-input\"\n                    type=\"checkbox\"\n                    value=\"\"\n                    ng-checked=\"(checkPolicy1 && checkPolicy1.housing_policy_name === item.housing_policy_name)\"\n                    ng-model=\"item.include_in_submission\"\n                    ng-click=\"addToSubmissions(item)\"\n                    ng-disabled=\"checkPolicy1.submitted === true && checkPolicy1.housing_policy_name === item.housing_policy_name\">\n                  />\n                  <label\n                    class=\"form-check-label\"\n                    for=\"foo\"\n                    ng-class=\"{'boldFont': item.include_in_submission || checkPolicy1.housing_policy_name === item.housing_policy_name}\"\n                  >\n                    {{item.housing_policy_name}}\n                  </label>\n                </div>\n                <div\n                  class=\"row align-items-center\"\n                  ng-show=\"checkPolicy1.housing_policy_name === item.housing_policy_name\"\n                >\n                  <div\n                    class=\"row\"\n                    style=\"padding-top: 5px; padding-bottom: 5px\"\n                  >\n                    <div class=\"col\">\n                      <div class=\"alert alert-success fade show\" role=\"alert\">\n                        This policy has been submitted and is under review.\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </form>\n          </div>\n          <!-- Small Business and Non-Profit Financial Assistance Program Housing -->\n          <div\n            id=\"section-4\"\n            role=\"tabpanel\"\n            class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Small Business and Non-Profit Financial Assistance Program'}\"\n          >\n             <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Small Business and Non-Profit Financial Assistance Program</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Dedicated funding\n                program for any impacted small business and community-serving\n                non-profits.</span\n              >\n            </p>\n            <form\n              class=\"row test-validation-styling\"\n              name=\"housingForm\"\n              ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate\n            >\n              <div class=\"form-item col-lg-12\">\n                <label>Link to adopted program:</label>\n                <textarea\n                  ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  id=\"adopted_program_policy_link_sbnp\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-disabled=\"formReadOnly\"\n                  name=\"adopted_program_policy_link_sbnp\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label>Does program apply jurisdiction-wide?</label>\n                <select\n                  id=\"jurisdiction_wide_sbnp\"\n                  name=\"jurisdiction_wide_sbnp\"\n                  ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label\n                  >Does policy define “small business” and “community-serving\n                  non-profit” to establish minimum requirements to qualify for\n                  assistance?</label\n                >\n                <select\n                  id=\"small_biz_comm_serv_np_assist\"\n                  name=\"small_biz_comm_serv_np_assist\"\n                  ng-model=\"currentPolicy.small_biz_comm_serv_np_assist\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.small_biz_comm_serv_np_assist.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label\n                  >Does program provide technical assistance and up-to-date\n                  information online regarding funding opportunities and\n                  deadlines?</label\n                >\n                <select\n                  id=\"ta_fund_opp_deadlines\"\n                  name=\"ta_fund_opp_deadlines\"\n                  ng-model=\"currentPolicy.ta_fund_opp_deadlines\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.ta_fund_opp_deadlines.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label\n                  >Program terms if not in ordinance or documentation\n                  establishing policy:</label\n                >\n                <textarea\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                  ng-model=\" currentPolicy.program_policy_terms\"\n                  id=\"program_policy_terms_sbnp\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_terms_sbnp\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  cols=\"63\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"margin-top: 65px\"\n                class=\"col-lg-1\"\n              >\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div\n                class=\"col-md-5\"\n                ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\"\n              >\n                <span style=\"padding-right: 10px\"\n                  ><a\n                    target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\"\n                    >Uploaded Documentation</a\n                  ></span\n                >\n                <button\n                  class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\"\n                  ng-if=\"!formReadOnly\"\n                >\n                  <i\n                    ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"\n                  ></i>\n                  Remove\n                </button>\n              </div>\n              <div\n                class=\"row align-items-center\"\n                style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n              >\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_sbnp\"\n                    >Upload Policy Terms Documentation</label\n                  >\n                </div>\n                <div\n                  class=\"col-lg-5 adjust-padding\"\n                  style=\"margin-left: 0 !important\"\n                >\n                  <input\n                    type=\"file\"\n                    ng-model=\"program_policy_terms_file_sbnp\"\n                    id=\"program_policy_terms_file_sbnp\"\n                    ng-disabled=\"formReadOnly\"\n                    name=\"program_policy_terms_file_sbnp\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().setPending(this)\"\n                  />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button\n                    class=\"button button--attach\"\n                    ng-click=\"uploadFile('program_policy_terms_file_sbnp')\"\n                  >\n                    <i\n                      ng-show=\"fileUploading_program_policy_terms_file_sbnp\"\n                      class=\"fa-solid fa-cog fa-spin\"\n                    ></i>\n                    Upload File\n                  </button>\n                  <button\n                    type=\"button\"\n                    class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_sbnp')\"\n                  >\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label\n                  >Documentation that jurisdiction has \"secured funding\"\n                  consistent with TOC Policy requirements, including\n                  identification of fund source(s):</label\n                >\n                <textarea\n                  ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\"\n                  ng-model=\" currentPolicy.secured_funding_docs\"\n                  id=\"secured_funding_docs_sbnp\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"secured_funding_docs_sbnp\"\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  cols=\"63\"\n                  ng-disabled=\"attachmentData['SecuredFunding'].isFileSelected || formReadOnly\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.secured_funding_docs.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <!-- File upload secured_funding_docs -->\n              <div\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"margin-top: 75px\"\n                class=\"col-lg-1\"\n              >\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div\n                class=\"col-md-5\"\n                ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"padding-bottom: 10px\"\n              >\n                <span style=\"padding-right: 10px\"\n                  ><a\n                    target=\"_blank\"\n                    ng-href=\"{{currentPolicy.secured_funding_docs}}\"\n                    >Uploaded Documentation</a\n                  ></span\n                >\n                <button\n                  class=\"button button--attach\"\n                  ng-click=\"removeFile('secured_funding_docs')\"\n                  ng-if=\"!formReadOnly\"\n                >\n                  <i\n                    ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"\n                  ></i>\n                  Remove\n                </button>\n              </div>\n              <div\n                class=\"row align-items-center\"\n                style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\"\n              >\n                <div class=\"col-lg-2\">\n                  <label for=\"secured_funding_docs_file_sbnp\"\n                    >Upload Secured Funding Documentation</label\n                  >\n                </div>\n                <div\n                  class=\"col-lg-5 adjust-padding\"\n                  style=\"margin-left: 0 !important\"\n                >\n                  <input\n                    type=\"file\"\n                    ng-model=\"secured_funding_docs_file_sbnp\"\n                    id=\"secured_funding_docs_file_sbnp\"\n                    name=\"secured_funding_docs_file_sbnp\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\"\n                  />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button\n                    class=\"button button--attach\"\n                    ng-click=\"uploadFile('secured_funding_docs_file_sbnp')\"\n                  >\n                    <i\n                      ng-show=\"fileUploading_secured_funding_docs_file_sbnp\"\n                      class=\"fa-solid fa-cog fa-spin\"\n                    ></i>\n                    Upload File\n                  </button>\n                  <button\n                    type=\"button\"\n                    class=\"button button--clear\"\n                    ng-click=\"clearFile('secured_funding_docs_file_sbnp')\"\n                  >\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label> Amount of anticipated funding for four-year period ($): :</label>\n                <input\n                  id=\"anticipated_funding_2026_sbnp\"\n                  name=\"anticipated_funding_2026_sbnp\"\n                  type=\"text\"\n                  placeholder=\"$\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.anticipated_funding_2026\"\n                  required\n                />\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.anticipated_funding_2026.$error.required && formSubmitted\"\n                >\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label\n                  >Schedule of expected funding allocated to the program:</label\n                >\n                <textarea\n                  ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                  placeholder=\"Enter URL\"\n                  ng-model=\" currentPolicy.expected_fund_schedule_2026\"\n                  id=\"expected_fund_schedule_2026_sbnp\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"expected_fund_schedule_2026_sbnp\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  cols=\"63\"\n                  ng-disabled=\"attachmentData['ExpectedFunding'].isFileSelected || formReadOnly\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.expected_fund_schedule_2026.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <!-- File upload expected_fund_schedule_2026 -->\n              <div\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"margin-top: 75px\"\n                class=\"col-lg-1\"\n              >\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div\n                class=\"col-md-5\"\n                ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"padding-bottom: 10px\"\n              >\n                <span style=\"padding-right: 10px\"\n                  ><a\n                    target=\"_blank\"\n                    ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\"\n                    >Uploaded Documentation</a\n                  ></span\n                >\n                <button\n                  class=\"button button--attach\"\n                  ng-click=\"removeFile('expected_fund_schedule_2026')\"\n                  ng-if=\"!formReadOnly\"\n                >\n                  <i\n                    ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"\n                  ></i>\n                  Remove\n                </button>\n              </div>\n              <div\n                class=\"row align-items-center\"\n                style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n              >\n                <div class=\"col-lg-2\">\n                  <label for=\"expected_fund_schedule_2026_file_sbnp\"\n                    >Expected Fund Schedule Documentation</label\n                  >\n                </div>\n                <div\n                  class=\"col-lg-5 adjust-padding\"\n                  style=\"margin-left: 0 !important\"\n                >\n                  <input\n                    type=\"file\"\n                    ng-model=\"expected_fund_schedule_2026_file_sbnp\"\n                    ng-disabled=\"formReadOnly\"\n                    id=\"expected_fund_schedule_2026_file_sbnp\"\n                    name=\"expected_fund_schedule_2026_file_sbnp\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().setPending(this)\"\n                  />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button\n                    class=\"button button--attach\"\n                    ng-click=\"uploadFile('expected_fund_schedule_2026_file_sbnp')\"\n                  >\n                    <i\n                      ng-show=\"fileUploading_expected_fund_schedule_2026_file_sbnp\"\n                      class=\"fa-solid fa-cog fa-spin\"\n                    ></i>\n                    Upload File\n                  </button>\n                  <button\n                    type=\"button\"\n                    class=\"button button--clear\"\n                    ng-click=\"clearFile('expected_fund_schedule_2026_file_sbnp')\"\n                  >\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label>Comments/Notes:</label>\n                <textarea\n                  ng-model=\" currentPolicy.comments\"\n                  id=\"comments_sbnp\"\n                  placeholder=\"Enter response\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"comments_sbnp\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                >\n                </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n          <!-- Small Business Advocate Office -->\n          <div\n            id=\"section-5\"\n            role=\"tabpanel\"\n            class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Small Business Advocate Office'}\"\n          >\n                  <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Small Business Advocate Office</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Provide a single point\n                of contact for small business owners and/or a small business\n                alliance.\n              </span>\n            </p>\n            <form\n              class=\"row test-validation-styling\"\n              name=\"housingForm\"\n              ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate\n            >\n              <div class=\"form-item col-lg-12\">\n                <label>Link to adopted policy:</label>\n                <textarea\n                  ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  id=\"adopted_program_policy_link_sbao\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"adopted_program_policy_link_sbao\"\n                  ng-disabled=\"formReadOnly\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label>Does policy apply jurisdiction-wide?</label>\n                <select\n                  id=\"jurisdiction_wide_sbao\"\n                  name=\"jurisdiction_wide_sbao\"\n                  ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label\n                  >Does policy provide a single point of contact for small\n                  business owners to connect with a technical support\n                  resource?</label\n                >\n                <select\n                  id=\"poc_small_biz_own\"\n                  name=\"poc_small_biz_own\"\n                  ng-model=\"currentPolicy.poc_small_biz_own\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.poc_small_biz_own.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label\n                  >If an outside contractor is point of contact, describe\n                  jurisdiction’s approach for oversight of the\n                  contractor.</label\n                >\n                <textarea\n                  ng-model=\" currentPolicy.cont_oversight\"\n                  id=\"cont_oversight\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"cont_oversight\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  placeholder=\"Enter response\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.cont_oversight.$error.required && formSubmitted\"\n                >\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label\n                  >Policy terms if not in ordinance or documentation\n                  establishing policy:</label\n                >\n                <textarea\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                  ng-model=\" currentPolicy.program_policy_terms\"\n                  id=\"program_policy_terms_sbao\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_terms_sbao\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  cols=\"63\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"margin-top: 75px\"\n                class=\"col-lg-1\"\n              >\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div\n                class=\"col-md-5\"\n                ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\"\n              >\n                <span style=\"padding-right: 10px\"\n                  ><a\n                    target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\"\n                    >Uploaded Documentation</a\n                  ></span\n                >\n                <button\n                  class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\"\n                  ng-if=\"!formReadOnly\"\n                >\n                  <i\n                    ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"\n                  ></i>\n                  Remove\n                </button>\n              </div>\n              <div\n                class=\"row align-items-center\"\n                style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n              >\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_sbao\"\n                    >Upload Policy Terms Documentation</label\n                  >\n                </div>\n                <div\n                  class=\"col-lg-5 adjust-padding\"\n                  style=\"margin-left: 0 !important\"\n                >\n                  <input\n                    type=\"file\"\n                    ng-model=\"program_policy_terms_file_sbao\"\n                    id=\"program_policy_terms_file_sbao\"\n                    name=\"program_policy_terms_file_sbao\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\"\n                  />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button\n                    class=\"button button--attach\"\n                    ng-click=\"uploadFile('program_policy_terms_file_sbao')\"\n                  >\n                    <i\n                      ng-show=\"fileUploading_program_policy_terms_file_sbao\"\n                      class=\"fa-solid fa-cog fa-spin\"\n                    ></i>\n                    Upload File\n                  </button>\n                  <button\n                    type=\"button\"\n                    class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_sbao')\"\n                  >\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label>Comments/Notes:</label>\n                <textarea\n                  ng-model=\" currentPolicy.comments\"\n                  id=\"comments_sbao\"\n                  placeholder=\"Enter response\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"comments_sbao\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                >\n                </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n          <!-- Small Business and Non-Profit Overlay Section -->\n          <div\n            id=\"section-1\"\n            role=\"tabpanel\"\n            class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Small Business and Non-Profit Overlay'}\"\n          >\n             <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Small Business and Non-Profit Overlay</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Establish boundaries\n                designated for an overlay, triggering a set of protections and\n                benefits should development impact small businesses (including\n                public markets) or community-serving non-profits.\n              </span>\n            </p>\n            <form\n              class=\"row test-validation-styling\"\n              name=\"housingForm\"\n              ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate\n            >\n              <div class=\"form-item col-lg-12\">\n                <label>Link to adopted policy:</label>\n                <textarea\n                  ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  id=\"adopted_program_policy_link_sbnpo\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"adopted_program_policy_link_sbnpo\"\n                  ng-disabled=\"formReadOnly\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label>Does policy apply jurisdiction-wide?</label>\n                <select\n                  id=\"jurisdiction_wide_sbnpo\"\n                  name=\"jurisdiction_wide_sbnpo\"\n                  ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label\n                  >Does policy define “small business” and “community-serving\n                  non-profit” to establish minimum requirements to qualify for\n                  protections?</label\n                >\n                <select\n                  id=\"small_biz_comm_serv_np_prot\"\n                  name=\"small_biz_comm_serv_np_prot\"\n                  ng-model=\"currentPolicy.small_biz_comm_serv_np_prot\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.small_biz_comm_serv_np_prot.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label>\n                  Does policy offer at least one protection or benefit specific\n                  to the community and expected to prevent displacement?</label\n                >\n                <select\n                  id=\"comm_benefit_protect\"\n                  name=\"comm_benefit_protect\"\n                  ng-model=\"currentPolicy.comm_benefit_protect\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.comm_benefit_protect.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label\n                  >Policy terms if not in ordinance or documentation\n                  establishing policy:</label\n                >\n                <textarea\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                  ng-model=\" currentPolicy.program_policy_terms\"\n                  id=\"program_policy_terms_sbnpo\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_terms_sbnpo\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  cols=\"63\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"margin-top: 75px\"\n                class=\"col-lg-1\"\n              >\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div\n                class=\"col-md-5\"\n                ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\"\n              >\n                <span style=\"padding-right: 10px\"\n                  ><a\n                    target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\"\n                    >Uploaded Documentation</a\n                  ></span\n                >\n                <button\n                  class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\"\n                  ng-if=\"!formReadOnly\"\n                >\n                  <i\n                    ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"\n                  ></i>\n                  Remove\n                </button>\n              </div>\n              <div\n                class=\"row align-items-center\"\n                style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n              >\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_npos\"\n                    >Upload Policy Terms Documentation</label\n                  >\n                </div>\n                <div\n                  class=\"col-lg-5 adjust-padding\"\n                  style=\"margin-left: 0 !important\"\n                >\n                  <input\n                    type=\"file\"\n                    ng-model=\"program_policy_terms_file_npos\"\n                    id=\"program_policy_terms_file_npos\"\n                    name=\"program_policy_terms_file_npos\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\"\n                  />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button\n                    class=\"button button--attach\"\n                    ng-click=\"uploadFile('program_policy_terms_file_npos')\"\n                  >\n                    <i\n                      ng-show=\"fileUploading_program_policy_terms_file_npos\"\n                      class=\"fa-solid fa-cog fa-spin\"\n                    ></i>\n                    Upload File\n                  </button>\n                  <button\n                    type=\"button\"\n                    class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_npos')\"\n                  >\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label>Comments/Notes:</label>\n                <textarea\n                  ng-model=\" currentPolicy.comments\"\n                  id=\"comments_sbnpo\"\n                  placeholder=\"Enter response\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"comments_sbnpo\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                >\n                </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n          <!-- Small Business and Non-Profit Preference Policy Section -->\n          <div\n            id=\"section-2\"\n            role=\"tabpanel\"\n            class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Small Business and Non-Profit Preference Policy'}\"\n          >\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Small Business and Non-Profit Preference Policy</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Give priority and a\n                right of first offer to local small businesses and/or\n                community-serving non-profits when selecting a tenant for new\n                market-rate commercial space.\n              </span>\n            </p>\n            <form\n              class=\"row test-validation-styling\"\n              name=\"housingForm\"\n              ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate\n            >\n              <div class=\"form-item col-lg-12\">\n                <label>Link to adopted policy:</label>\n                <textarea\n                  ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  id=\"adopted_program_policy_link_sbnpp\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"adopted_program_policy_link_sbnpp\"\n                  ng-disabled=\"formReadOnly\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label>Does policy apply jurisdiction-wide?</label>\n                <select\n                  id=\"jurisdiction_wide_sbnpp\"\n                  name=\"jurisdiction_wide_sbnpp\"\n                  ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label\n                  >Does policy define “small business” and “community-serving\n                  non-profit” to establish minimum requirements to qualify for\n                  preferences?</label\n                >\n                <select\n                  id=\"small_biz_comm_serv_np_pref\"\n                  name=\"small_biz_comm_serv_np_pref\"\n                  ng-model=\"currentPolicy.small_biz_comm_serv_np_pref\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.small_biz_comm_serv_np_pref.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label\n                  >Does policy give small businesses and non-profits the right\n                  of first offer when selecting new tenants?</label\n                >\n                <select\n                  id=\"small_biz_non_prof_first_offer_right\"\n                  name=\"small_biz_non_prof_first_offer_right\"\n                  ng-model=\"currentPolicy.small_biz_non_prof_first_offer_right\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  required\n                >\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.small_biz_non_prof_first_offer_right.$error.required && formSubmitted\"\n                >\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label\n                  >Policy terms if not in ordinance or documentation\n                  establishing policy:</label\n                >\n                <textarea\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                  ng-model=\" currentPolicy.program_policy_terms\"\n                  id=\"program_policy_terms\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_terms\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  cols=\"63\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\"\n                  placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\"\n                  required\n                >\n                </textarea>\n                <div\n                  class=\"invalid-feedback\"\n                  ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms.$error.required && formSubmitted\"\n                >\n                  Please provide a valid URL or enter 'N/A'.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"margin-top: 75px\"\n                class=\"col-lg-1\"\n              >\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div\n                class=\"col-md-5\"\n                ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\"\n              >\n                <span style=\"padding-right: 10px\"\n                  ><a\n                    target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\"\n                    >Uploaded Documentation</a\n                  ></span\n                >\n                <button\n                  class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\"\n                  ng-if=\"!formReadOnly\"\n                >\n                  <i\n                    ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"\n                  ></i>\n                  Remove\n                </button>\n              </div>\n              <div\n                class=\"row align-items-center\"\n                style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n              >\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_nppp\"\n                    >Upload Policy Terms Documentation</label\n                  >\n                </div>\n                <div\n                  class=\"col-lg-5 adjust-padding\"\n                  style=\"margin-left: 0 !important\"\n                >\n                  <input\n                    type=\"file\"\n                    ng-model=\"program_policy_terms_file_nppp\"\n                    id=\"program_policy_terms_file_nppp\"\n                    name=\"program_policy_terms_file_nppp\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\"\n                  />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button\n                    class=\"button button--attach\"\n                    ng-click=\"uploadFile('program_policy_terms_file_nppp')\"\n                  >\n                    <i\n                      ng-show=\"fileUploading_program_policy_terms_file_nppp\"\n                      class=\"fa-solid fa-cog fa-spin\"\n                    ></i>\n                    Upload File\n                  </button>\n                  <button\n                    type=\"button\"\n                    class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_nppp')\"\n                  >\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label>Comments/Notes:</label>\n                <textarea\n                  ng-model=\" currentPolicy.comments\"\n                  id=\"comments_sbnpp\"\n                  placeholder=\"Enter response\"\n                  ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"comments_sbnpp\"\n                  required\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                  style=\"width: 100%\"\n                >\n                </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n        </div>\n      </div>\n      <submissionsectionsubmit></submissionsectionsubmit>\n    </div>\n  </div>\n  <div class=\"footer\" role=\"contentinfo\">\n    <sidebarfooter></sidebarfooter>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>\n"

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HousingPreservationComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _housing_preservation = __webpack_require__(153);
	
	var _housing_preservation2 = _interopRequireDefault(_housing_preservation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var HousingPreservationComponent = exports.HousingPreservationComponent = function () {
	  /*@ngInject*/
	  function HousingPreservationComponent($state, $scope, $rootScope, fetch, lookup, $timeout, userService, $http, baseConfigService, $stateParams) {
	    _classCallCheck(this, HousingPreservationComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$timeout = $timeout;
	    this.userService = userService;
	    this.baseConfigService = baseConfigService;
	    this.$stateParams = $stateParams;
	
	    $scope.adminUnlocked = false;
	    $scope.formsSubmitData = [];
	
	    $scope.currentlySelectedPolicies = [];
	    $scope.pdfUrls = {
	      'Funding to Preserve Unsubsidized Affordable Housing': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Preservation_Funding.pdf',
	      'Tenant/Community Opportunity to Purchase': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/TOPA_COPA.pdf',
	      'Single-Room Occupancy (SRO) Preservation': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/SROs.pdf',
	      'Condominium Conversion Restrictions': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Condo_Conversions.pdf',
	      'Public/Community Land Trusts (Preservation)': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Preservation_Land_Trusts.pdf',
	      'Funding to Support Preservation Capacity': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Funding_Preservation_Capacity.pdf',
	      'Mobile Home Preservation': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Mobile_Home_Preservation.pdf',
	      'Preventing Displacement from Substandard Conditions and Associated Code Enforcement Activities': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Preservation_Substandard_Conditions.pdf'
	    };
	    $scope.attachmentData = $scope.attachmentData || {};
	
	    $scope.pendingChanges = false;
	    $scope.savemode = 'housing';
	    $scope.page = 'preservation_';
	    $scope.housingType = 'Preservation';
	    $scope.policyNotesMapping = {
	      'Public/Community Land Trusts (Preservation)': "<strong>Note:</strong> A jurisdiction can receive credit for both Preservation Policy 5 (Public/Community Land Trusts) and Preservation Policy 1 (Funding to Preserve Unsubsidized Affordable Housing) only if the funding program that meets the standards for Preservation Policy 1 has set asides for public/community land trusts that meet the funding listed in Appendix B. For example, a Tier A jurisdiction with a preservation program with $1,000,000 in funding could receive credit for both Preservation Policy 1 and Preservation Policy 5 if the program has a set aside for CLTs of $500,000, as these amounts meet the $500,000 minimum for both policies.",
	      'Funding to Support Preservation Capacity': "<strong>Note:</strong> If a jurisdiction establishes a preservation funding program that meets the standards for Preservation Policy 1 (Funding to Preserve Unsubsidized Affordable Housing) and/or Preservation Policy 5 (Public/Community Land Trusts), the jurisdiction can use this program to also receive credit for Preservation Policy 6 (Funding to Support Preservation Capacity) if the program additionally has a set aside for capacity building that meets the standards described in the  <a href='https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy'>TOC Policy Administrative Guidance</a>."
	    };
	    $scope.preservationPolicyOrder = ['Funding to Preserve Unsubsidized Affordable Housing', 'Tenant/Community Opportunity to Purchase', 'Single-Room Occupancy (SR) Preservation', 'Condominium Conversion Restrictions', 'Public/Community Land Trusts', 'Funding to Support Preservation Capacity', 'Mobile Home Preservation', 'Preventing Displacement from Substandard Conditions and Associated Code Enforcement Activities'];
	
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.setPending = function () {
	      $scope.savemode = 'housing';
	      $scope.pendingChanges = true;
	    };
	
	    $scope.openPdf = function (item) {
	      var pdfUrl = $scope.pdfUrls[item.housing_policy_name];
	
	      if (pdfUrl) {
	        window.open(pdfUrl, '_blank');
	      } else {
	        console.error('PDF URL not found for policy: ' + item.housing_policy_name);
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.housingStatus) {
	        for (var i = 0; i < $scope.housingStatus.length; i++) {
	          if ($scope.housingStatus[i].housing_policy_name === $scope.currentPolicy.housing_policy_name) {
	            submission = $scope.housingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentPolicy && $scope.currentPolicy.housing_policy_name;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.housingStatus && $scope.currentPolicy && $scope.currentPolicy.housing_policy_name) {
	        var currentSubmission = _.find($scope.housingStatus, { housing_policy_name: $scope.currentPolicy.housing_policy_name });
	        if (currentSubmission && currentSubmission.submitted && currentSubmission.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('housingStatus', function () {
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm("Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.");
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.housingStatus) {
	        for (var i = 0; i < $scope.housingStatus.length; i++) {
	          if ($scope.housingStatus[i].housing_policy_name === $scope.currentPolicy.housing_policy_name) {
	            submission = $scope.housingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error("No matching submission found to withdraw");
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem("api/data/submissions/update-status", payload).then(function () {
	        var matchingPolicy = $scope.currentlySelectedPolicies.find(function (p) {
	          return p.housing_policy_name === $scope.currentPolicy.housing_policy_name;
	        });
	        if (matchingPolicy) {
	          matchingPolicy.include_in_submission = false;
	        }
	        submission.submitted = false;
	        submission.status = null;
	
	        if ($scope.checkPolicy1 && $scope.checkPolicy1.submission_id === submission.submission_id) {
	          $scope.checkPolicy1 = null;
	        } else if ($scope.checkPolicy2 && $scope.checkPolicy2.submission_id === submission.submission_id) {
	          $scope.checkPolicy2 = null;
	        }
	
	        $scope.formsSubmitData = $scope.formsSubmitData.filter(function (p) {
	          return p.housing_policy_name !== $scope.currentPolicy.housing_policy_name;
	        });
	
	        $scope.submitType = 'Submit Housing Policies for Review (' + $scope.formsSubmitData.length + ')';
	
	        var policyName = $scope.currentPolicy.housing_policy_name;
	        var formId = $scope.currentPolicy.housing_form_id;
	        $scope.currentPolicy = { housing_policy_name: policyName, housing_form_id: formId };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	
	        $scope.formReadOnly = false;
	      }).catch(function (err) {
	        console.error("Withdraw failed:", err);
	        alert("There was an error withdrawing the submission. Please try again.");
	      });
	    };
	
	    $scope.addToSubmissions = function (policy) {
	      $scope.savemode = null;
	      if (_.filter($scope.formsSubmitData, { 'housing_policy_name': policy.housing_policy_name }).length === 1) {
	        $scope.formsSubmitData = _.remove($scope.formsSubmitData, function (n) {
	          return n.housing_policy_name !== policy.housing_policy_name;
	        });
	      } else {
	        $scope.formsSubmitData.push(policy);
	      }
	
	      $scope.submitmode = 'housing';
	      $scope.submitType = 'Submit Housing Policies for Review (' + $scope.formsSubmitData.length + ')';
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Housing ' + $scope.housingType + ' Policy').then(function (response) {
	        $scope.housingStatus = response.data;
	        console.log('Housing status response:', response.data);
	        $scope.checkPolicy1 = _.filter(response.data, {
	          submission_policy_name: 'Affordable Housing ' + $scope.housingType + ' Policy 1',
	          submitted: true
	        })[0];
	        $scope.checkPolicy2 = _.filter(response.data, {
	          submission_policy_name: 'Affordable Housing ' + $scope.housingType + ' Policy 2',
	          submitted: true
	        })[0];
	
	        if ($scope.currentlySelectedPolicies) {
	          $scope.currentlySelectedPolicies.forEach(function (policy) {
	            if ($scope.checkPolicy1 && $scope.checkPolicy1.submitted === true && $scope.checkPolicy1.housing_policy_name === policy.housing_policy_name || $scope.checkPolicy2 && $scope.checkPolicy2.submitted === true && $scope.checkPolicy2.housing_policy_name === policy.housing_policy_name) {
	              policy.include_in_submission = true;
	            } else {
	              policy.include_in_submission = false;
	            }
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.submitPolicies = function () {
	      $scope.saving = true;
	      var upsertData = [];
	
	      if ($scope.formsSubmitData.length === 2) {
	        for (var index = 0; index < $scope.formsSubmitData.length; index++) {
	          var counter = index + 1;
	          var data = $scope.formsSubmitData[index];
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === 'Affordable Housing ' + $scope.housingType + ' Policy ' + counter && element.sta_recid === data.sta_recid) {
	              element.housing_policy_name = data.housing_policy_name;
	              element.submitted = true;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        }
	      } else if ($scope.formsSubmitData.length === 1) {
	        var data = $scope.formsSubmitData[0];
	
	        if (!$scope.checkPolicy1) {
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === 'Affordable Housing ' + $scope.housingType + ' Policy 1' && element.sta_recid === data.sta_recid) {
	              element.housing_policy_id = data.housing_policy_id;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        } else if (!$scope.checkPolicy2) {
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === 'Affordable Housing ' + $scope.housingType + ' Policy 2' && element.sta_recid === data.sta_recid) {
	              element.housing_policy_id = data.housing_policy_id;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        }
	      }
	
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.getSubmissionStatus();
	          $scope.$apply();
	        }, 3000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updatePoliciesJurisdiction = function (jurisdiction) {
	      $scope.currentlySelectedPolicies = [];
	      lookup.setJurisdiction(jurisdiction);
	      $scope.currentJurisdiction = jurisdiction;
	      $scope.getStationbyID();
	      $scope.getSubmissionStatus();
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	      $scope.getSubmissionStatus();
	      $scope.currentlySelectedPolicies = [];
	      $scope.loadingPolicies = true;
	      fetch.getAllItems('api/data/housing/forms/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + $scope.housingType).then(function (response) {
	
	        $scope.currentStation = response.data[0];
	
	        response.data.forEach(function (element) {
	          if (element.policy_selected) {
	            $scope.currentlySelectedPolicies.push(element);
	          }
	        });
	
	        var requestedPolicyName = $stateParams.policyName;
	        var policyToSelect = null;
	
	        if (requestedPolicyName && $scope.currentlySelectedPolicies.length > 0) {
	          policyToSelect = $scope.currentlySelectedPolicies.find(function (p) {
	            return p.housing_policy_name === requestedPolicyName;
	          });
	        }
	
	        if (policyToSelect) {
	          policyToSelect.active = true;
	          $scope.currentPolicy = policyToSelect;
	
	          $scope.setCurrentPolicy($scope.currentPolicy);
	        } else if ($scope.currentlySelectedPolicies.length > 0) {
	          $scope.currentlySelectedPolicies[0].active = true;
	          $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
	          $scope.setCurrentPolicy($scope.currentPolicy);
	        }
	
	        $scope.housingForms = response.data;
	        $scope.loadingPolicies = false;
	        $scope.getJurisdictionFundingTier($scope.currentSelectedStationId);
	      });
	    };
	
	    $scope.updateSelected = function (item) {
	      if ($scope.currentlySelectedPolicies.length > 0) {
	        $scope.currentlySelectedPolicies.forEach(function (element) {
	          element.active = false;
	        });
	      }
	
	      if (item.policy_selected) {
	        $scope.currentlySelectedPolicies.push(item);
	      } else {
	        for (var i = 0; i < $scope.currentlySelectedPolicies.length; i++) {
	          if ($scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
	            $scope.currentlySelectedPolicies.splice(i, 1);
	          }
	        }
	      }
	      if ($scope.currentlySelectedPolicies.length > 0) {
	        $scope.currentlySelectedPolicies[0].active = true;
	        $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
	      } else {
	        $scope.currentPolicy = {};
	      }
	      var upsertData = {
	        policy_selected: item.policy_selected,
	        housing_form_id: item.housing_form_id
	      };
	
	      fetch.updateItem('api/data/housing/forms/update', upsertData).then(function (response) {}).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.setCurrentPolicy = function (item) {
	      if (item === 'reviewAndSubmit') {
	        $scope.currentPolicy = {};
	        $scope.reviewAndSubmit = true;
	        $scope.note = '';
	      } else if (!item) {
	        $scope.reviewAndSubmit = false;
	        $scope.note = '<strong>Note:</strong> A jurisdiction must enter information for all fields for each affordable housing production policy they are using to demonstrate TOC Policy compliance. If any field is not relevant to a jurisdiction, enter “N/A".';
	      } else {
	        $scope.reviewAndSubmit = false;
	        $scope.currentPolicy = item;
	
	        if ($scope.policyNotesMapping.hasOwnProperty(item.housing_policy_name)) {
	          $scope.note = $scope.policyNotesMapping[item.housing_policy_name];
	        } else {
	          $scope.note = '<strong>Note:</strong> A jurisdiction must enter information for all fields for each affordable housing preservation policy they are using to demonstrate TOC Policy compliance. If any field is not relevant to a jurisdiction, enter “N/A".';
	        }
	      }
	    };
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        } else {
	          $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
	        }
	
	        lookup.setCurrentStation($scope.currentSelectedStationId);
	
	        $scope.getStationbyID();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentPolicy = function (form) {
	      $scope.formSubmitted = true;
	      $scope.form = form;
	      $scope.saving = true;
	      if ($scope.currentPolicy.active) {
	        delete $scope.currentPolicy.active;
	      }
	
	      console.log('Saving currentPolicy:', angular.copy($scope.currentPolicy));
	      fetch.updateItem('api/data/housing/forms/update', $scope.currentPolicy).then(function (response) {
	        $scope.saving = false;
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.savemode = null;
	          $scope.saved = false;
	          $scope.currentPolicy.active = true;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getHousingForm = function () {
	      var currentPolicy = $scope.currentPolicy;
	
	      if (currentPolicy && currentPolicy.housing_form_id) {
	        fetch.getAllItems('api/data/getForm/' + currentPolicy.housing_form_id).then(function (response) {
	          $scope.currentPolicy = response.data[0];
	        }).catch(function (error) {
	          console.error('Error fetching currentPolicy for the current policy:', error);
	
	          $scope.currentPolicy = {};
	        });
	      } else {
	        console.warn('current policy is not defined or is missing a housing_form_id.');
	
	        $scope.currentPolicy = {};
	      }
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById('fileInput' + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
	            alert('Please select a PDF, Word document, or Excel file.');
	            element.value = '';
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById('' + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope[ngmodel] = '';
	        $scope[ngmodel + '_preview'] = '';
	        $scope['fileUploading_' + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope['fileUploading_' + ngmodelfile] = true;
	      var file = document.getElementById('' + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'housing';
	      $scope.pendingChanges = true;
	    };
	
	    $scope.getJurisdictionFundingTier = function (station) {
	      if (station) {
	        $scope.loadingData = true;
	      }
	      fetch.getItem('api/data/housing/fundingtiers/' + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	        $scope.fundingLevels = response.data[0];
	        $scope.loadingData = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	  }
	
	  _createClass(HousingPreservationComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.housingForms = [];
	        _this.$scope.getJurisdictionFundingTier();
	        return _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	        _this2.$scope.tier = _this2.lookup.getTier() || 'N/A';
	        _this2.$scope.getJurisdictionFundingTiers();
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'updateSelected',
	    value: function updateSelected(item) {
	      if (this.$scope.currentlySelectedPolicies.length > 0) {
	        this.$scope.currentlySelectedPolicies.forEach(function (element) {
	          element.active = false;
	        });
	      }
	
	      if (item.policy_selected) {
	        this.$scope.currentlySelectedPolicies.push(item);
	      } else {
	        for (var i = 0; i < this.$scope.currentlySelectedPolicies.length; i++) {
	          if (this.$scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
	            this.$scope.currentlySelectedPolicies.splice(i, 1);
	          }
	        }
	      }
	      if (this.$scope.currentlySelectedPolicies.length > 0) {
	        this.$scope.currentlySelectedPolicies[0].active = true;
	        this.$scope.currentPolicy = this.$scope.currentlySelectedPolicies[0];
	      } else {
	        this.$scope.currentPolicy = {};
	      }
	      var upsertData = {
	        policy_selected: item.policy_selected,
	        housing_form_id: item.housing_form_id
	      };
	
	      this.fetch.updateItem('api/data/housing/forms/update', upsertData).then(function (response) {}).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	          _this3.lookup.setSubmissionPolicies(_this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return HousingPreservationComponent;
	}();
	
	exports.default = angular.module('appApp.housing_preservation', [uiRouter]).config(_housing_preservation2.default).component('housingPreservation', {
	  template: __webpack_require__(154),
	  controller: HousingPreservationComponent,
	  controllerAs: 'housingPreservationCtrl'
	}).name;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('housing_preservation', {
	    url: '/account/housing/housing_preservation?jurisdiction&sta_recid&policyName',
	    template: '<housing-preservation></housing-preservation>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null,
	      policyName: null }
	  });
	};

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = "<section\n  class=\"dashboard dashboard--page dashboard--page--submission dashboard--compliance dashboard--compliance--jurisdiction\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <maintocselection />\n\n      <div class=\"content container\">\n        <h1 id=\"housing-preservation-title\" class=\"page-title\">\n          {{breadcrumb[1].linkTitle1}}\n        </h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <p>\n          To be consistent with the TOC Policy, a jurisdiction must adopt\n          <span class=\"bold-text\">at least two</span> affordable housing\n          preservation policies. Appendix A of the\n          <a\n            href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC\n            Policy Administrative Guidance</a>\n          describes the eight policy options in more detail and outlines the\n          minimum standards a jurisdiction's policy must meet to be consistent with the\n          TOC Policy. You can also download a\n          <a href=\"https://dsa-public-files.s3.us-west-2.amazonaws.com/MTC_TOC_Policies_Checklist_v3.docx\" target=\"_blank\" rel=\"noopener noreferrer\">checklist</a>\n          that summarizes the minimum standards for each policy.\n        </p>\n\n        <div class=\"section\">\n          <h2 class=\"icon icon--housing\">Housing Policy Options</h2>\n          <notificationmessages />\n          <selecthousingpolicies />\n        </div>\n\n        <nav class=\"section-nav\">\n          <div class=\"menu--section-title\">In this section:</div>\n          <ul class=\"menu menu--section\" role=\"tablist\">\n            <!-- Get list of preservation policies  -->\n            <li ng-repeat=\"item in currentlySelectedPolicies track by $index\" data-bs-toggle=\"tab\"\n              class=\"menu-item menu-item--section\" ng-class=\"{ 'active': item.active }\"\n              ng-click=\"setCurrentPolicy(item)\">\n              <span class=\"section-number\">{{$index + 1}}.</span><a href=\"#\">{{ item.housing_policy_name }}</a>\n            </li>\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit-housing\"\n              class=\"menu-item menu-item--section\" ng-click=\"setCurrentPolicy('reviewAndSubmit')\">\n              <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n            </li>\n          </ul>\n          <note class=\"section-pin\" ng-if=\"note\" ng-bind-html=\"note\"></note>\n          <furtherguidance></furtherguidance>\n        </nav>\n        <div class=\"tab-content\">\n          <!-- Review and Submit -->\n          <div id=\"section-review-submit-housing\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': reviewAndSubmit}\">\n            <h2>Review and Submit Affordable Housing Preservation Policies</h2>\n            <p>\n              <span style=\"font-style: italic\">\n                Select policies below to submit to MTC for review.</span>\n            </p>\n\n            <form class=\"row\" style=\"margin-left: 2px\">\n              <div class=\"verification-container\" ng-repeat=\"item in currentlySelectedPolicies\">\n                <div class=\"form-check\">\n                  <input class=\"form-check-input\" id=\"include_in_submission_check_{{$index}}\" ng-disabled=\"formReadOnly\"\n                    name=\"include_in_submission_check_{{$index}}\" type=\"checkbox\" value=\"\"\n                    ng-checked=\"(checkPolicy1 && checkPolicy1.housing_policy_name === item.housing_policy_name) || (checkPolicy2 && checkPolicy2.housing_policy_name === item.housing_policy_name)\"\n                    ng-model=\"item.include_in_submission\" ng-click=\"addToSubmissions(item)\" ng-disabled=\"(checkPolicy1.submitted === true && checkPolicy1.housing_policy_name === item.housing_policy_name) || \n                    (checkPolicy2.submitted === true && checkPolicy2.housing_policy_name === item.housing_policy_name)\">\n                  <label class=\"form-check-label\" for=\"include_in_submission_check_{{$index}}\"\n                    ng-class=\"{'boldFont': item.include_in_submission || checkPolicy1.housing_policy_name === item.housing_policy_name || checkPolicy2.housing_policy_name === item.housing_policy_name}\">\n                    {{item.housing_policy_name}}\n                  </label>\n                </div>\n                <!-- <div class=\"row align-items-center\" ng-show=\"item.include_in_submission && !(checkPolicy1.housing_policy_name === item.housing_policy_name || checkPolicy2.housing_policy_name === item.housing_policy_name)\">\n                  <p>\n                    This affordable housing policy applies to all TOC areas in\n                    my jurisdiction.\n                  </p>\n                </div> -->\n                <div class=\"row align-items-center\"\n                  ng-show=\"checkPolicy1.housing_policy_name === item.housing_policy_name || checkPolicy2.housing_policy_name === item.housing_policy_name\">\n                  <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                    <div class=\"col\">\n                      <div class=\"alert alert-success fade show\" role=\"alert\">\n                        This policy has been submitted and is under review.\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Funding to Preserve Unsubsidized Affordable Housing Section -->\n          <div id=\"section-Funding-to-Preserve-Unsubsidized-Affordable-Housing\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Funding to Preserve Unsubsidized Affordable Housing'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Funding to Preserve Unsubsidized Affordable Housing</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p class=\"italics\">\n              Description from TOC Policy Resolution: Public investments to\n              preserve unsubsidized housing affordable to lower- or\n              moderate-income residents (sometimes referred to as \"naturally\n              occurring affordable housing”) as permanently affordable.\n            </p>\n            <div class=\"row mb-3\">\n              <div class=\"col\" ng-if=\"!loading && fundingLevels\">\n                <p>\n                  <strong aria-label=\"Jurisdiction Name\">\n                    {{fundingLevels.jurisdiction}}\n                  </strong>\n                  is in\n                  <strong aria-label=\"Funding Tier\">\n                    funding tier {{fundingLevels.funding_tier}}</strong>. It must demonstrate there is a program with funding above\n                  <strong aria-label=\"Preservation Requirement\">\n                    {{fundingLevels.preservation_ | currency}}\n                  </strong>\n                  for this policy over a four-year period if it chooses to use this policy to achieve TOC Policy consistency. For more information about required funding amounts and sources, see section “Policy Options With Funding Commitments” of the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance</a>.\n                </p>\n              </div>\n            </div>\n\n            <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_fpua\">Link to adopted program:</label>\n                <!-- <input id=\"adopted_program_policy_link_fpua\" name=\"adopted_program_policy_link_fpua\" type=\"url\"\n                  placeholder=\"Enter URL\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.adopted_program_policy_link\" required /> -->\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"_fpua\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"_fpua\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" cols=\"90\" placeholder=\"Enter URL\" type=\"text\" required>\n                </textarea>\n                <div class=\"invalid-feedback\"\n                  ng-show=\"housingForm.adopted_program_policy_link_fpua.$error.required && formSubmitted\">\n                  Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_fpua\">Does program apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_fpua\" name=\"jurisdiction_wide_fpua\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_fpua.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"policy_meets_toc_standards_fpua\">Does the program meet TOC Policy standards for income\n                  limits/affordability levels and the required affordability\n                  period, and identify a legal mechanism for enforcement?\n                </label>\n                <select id=\"policy_meets_toc_standards_fpua\" name=\"policy_meets_toc_standards_fpua\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards_fpua.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_fpua\">\n                  Program terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <!-- <input id=\"program_policy_terms_fpua\" name=\"program_policy_terms_fpua\" type=\"url\"\n                  placeholder=\"Enter URL\" ng-model=\"currentPolicy.program_policy_terms\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required /> -->\n                <textarea ng-model=\" currentPolicy.program_policy_terms\" id=\"program_policy_terms_fpua\"\n                  ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_terms_fpua\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\"\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" placeholder=\"Enter URL or 'N/A'\"\n                  type=\"text\" style=\"width: 100%\" required>\n                </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_fpua.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 55px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_fpua\">Upload Program Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_fpua\" id=\"program_policy_terms_file_fpua\"\n                    name=\"program_policy_terms_file_fpua\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_fpua')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_fpua\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_fpua')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"anticipated_funding_2026_fpua\">Amount of anticipated funding for four-year period ($):</label>\n                <input id=\"anticipated_funding_2026_fpua\" name=\"anticipated_funding_2026_fpua\" type=\"number\"\n                  placeholder=\"$\" ng-model=\"currentPolicy.anticipated_funding_2026\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required />\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_fpua.$error.number && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"secured_funding_docs_fpua\">Documentation that jurisdiction has \"secured funding\"\n                  consistent with TOC Policy requirements, including\n                  identification of fund source(s):</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" id=\"secured_funding_docs_fpua\"\n                  name=\"secured_funding_docs_fpua\" type=\"text\" placeholder=\"Enter your response here\"\n                  ng-model=\"currentPolicy.secured_funding_docs\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\"\n                  ng-model=\" currentPolicy.secured_funding_docs\" id=\"secured_funding_docs_fpua\"\n                  placeholder=\"Enter response\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"secured_funding_docs_fpua\"\n                  ng-disabled=\"attachmentData['SecuredFunding'].isFileSelected || formReadOnly\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\" required>\n                </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.secured_funding_docs_fpua.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload secured_funding_docs  -->\n              <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 55px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('secured_funding_docs')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 10px\"\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"secured_funding_docs_file_fpua\">Upload Secured Funding Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"secured_funding_docs_file_fpua\" id=\"secured_funding_docs_file_fpua\"\n                    name=\"secured_funding_docs_file_fpua\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_fpua')\">\n                    <i ng-show=\"fileUploading_secured_funding_docs_file_fpua\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('secured_funding_docs_file_fpua')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"expected_fund_schedule_2026_fpua\">Schedule of expected funding allocated to the program:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                  ng-model=\" currentPolicy.expected_fund_schedule_2026\" id=\"expected_fund_schedule_2026_fpua\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"expected_fund_schedule_2026_fpua\"\n                  ng-disabled=\"attachmentData['ExpectedFunding'].isFileSelected || formReadOnly\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\" required>\n                </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.expected_fund_schedule_2026_fpua.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload expected_fund_schedule_2026 -->\n              <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 55px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('expected_fund_schedule_2026')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"expected_fund_schedule_2026_file_fpua\">Upload Expected Funding Schedule\n                    Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_fpua\" ng-disabled=\"formReadOnly\"\n                    id=\"expected_fund_schedule_2026_file_fpua\" name=\"expected_fund_schedule_2026_file_fpua\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('expected_fund_schedule_2026_file_fpua')\">\n                    <i ng-show=\"fileUploading_expected_fund_schedule_2026_file_fpua\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('expected_fund_schedule_2026_file_fpua')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_fpua\">How does program address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <!-- <input id=\"program_policy_rhna_housing_fpua\" name=\"program_policy_rhna_housing_fpua\" type=\"text\"\n                  placeholder=\"Enter your response here\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.program_policy_rhna_housing\" required /> -->\n                <textarea ng-model=\" currentPolicy.program_policy_rhna_housing\" id=\"program_policy_rhna_housing_fpua\"\n                  ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_rhna_housing_fpua\" placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" required>\n                </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_fpua.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_fpua\">Comments/Notes</label>\n                <!-- <input id=\"comments_fpua\" name=\"comments_fpua\" type=\"text\" placeholder=\"Enter your response here\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.comments\" /> -->\n                <textarea ng-model=\" currentPolicy.comments\" id=\"comments_fpua\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_fpua\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" cols=\"90\" placeholder=\"Enter response\">\n                </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Tenant/Community Opportunity to Purchase Section -->\n          <div id=\"section-Tenant-Community-Opportunity-to-Purchase\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Tenant/Community Opportunity to Purchase'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Tenant/Community Opportunity to Purchase</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Policies or programs\n                that provide tenants or mission-driven nonprofits the right of\n                first refusal to purchase a property at the market price when it\n                is offered for sale, retaining existing residents and ensuring\n                long-term affordability of the units by requiring resale\n                restrictions to maintain affordability.\n              </span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_tcop\">Link to adopted policy:</label>\n                <!-- <input id=\"adopted_program_policy_link_tcop\" name=\"adopted_program_policy_link_tcop\" type=\"url\"\n                  placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.adopted_program_policy_link\" required /> -->\n                <textarea ng-model=\" currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link_tcop\"\n                  ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"adopted_program_policy_link_tcop\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\"\n                  style=\"width: 100%\" placeholder=\"Enter URL\" type=\"text\" required>\n                </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_tcop.$error.required && formSubmitted\">\n                  Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_tcop\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_tcop\" name=\"jurisdiction_wide_tcop\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_tcop.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"topa_policy_type_select_tcop\">Type of policy:</label>\n                <select id=\"topa_policy_type_select_tcop\" name=\"topa_policy_type_select_tcop\"\n                  ng-model=\"currentPolicy.topa_policy_type_select\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"topa\">TOPA (for tenants)</option>\n                  <option value=\"copa\">COPA (for non-profits)</option>\n                  <option value=\"both\">both</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.topa_policy_type_select_tcop.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"prop_nonprof_timelines_tcop\">Does policy define eligible and exempt properties; establish\n                  the legal right of first refusal for tenants and/or\n                  nonprofits; and establish timelines for notice of sale, offer\n                  period, time to close, and time to counter-offer?</label>\n\n                <select id=\"prop_nonprof_timelines_tcop\" name=\"prop_nonprof_timelines_tcop\"\n                  ng-model=\"currentPolicy.prop_nonprof_timelines\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.prop_nonprof_timelines_tcop.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_tcop\">Policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_tcop\"\n                  name=\"program_policy_terms_tcop\" type=\"url\" placeholder=\"Enter URL\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.program_policy_terms\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                  ng-model=\" currentPolicy.program_policy_terms\" id=\"program_policy_terms_tcop\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_terms_tcop\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" cols=\"63\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\" required>\n                </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_tcop.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 55px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_tcop\">Upload Policy Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_tcop\" id=\"program_policy_terms_file_tcop\"\n                    ng-disabled=\"formReadOnly\" name=\"program_policy_terms_file_tcop\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_tcop')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_tcop\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_tcop')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_tcop\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\" currentPolicy.program_policy_rhna_housing\" id=\"program_policy_rhna_housing_tcop\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_tcop\"\n                  ng-disabled=\"formReadOnly\" placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" placeholder=\"Enter response\" required>\n                </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_tcop.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_tcop\">Comments/Notes:</label>\n                <!-- <input type=\"text\" placeholder=\"Enter your response here\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.comments\" /> -->\n                <textarea ng-model=\" currentPolicy.comments\" id=\"comments_tcop\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_tcop\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" cols=\"90\" placeholder=\"Enter response\">\n                </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Single Room Occupancy Preservation Section -->\n          <div id=\"section-Single-Room-Occupancy-SRO-Preservation\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Single-Room Occupancy (SRO) Preservation'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Single Room Occupancy (SRO) Preservation</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Limits the conversion of\n                occupied SRO rental units to condominiums or other uses that\n                could result in displacement of existing residents.\n              </span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_srop\">Link to adopted policy:</label>\n                <textarea ng-model=\" currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link_srop\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_srop\"\n                  ng-disabled=\"formReadOnly\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\"\n                  placeholder=\"Enter URL\" type=\"text\" required>\n                </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_srop.$error.required && formSubmitted\">\n                  Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_srop\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_srop\" name=\"jurisdiction_wide_srop\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_srop.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"sro_units_priv_ent_owned_srop\">Documentation of SRO units owned by private entities other\n                  than mission-driven nonprofit organizations:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.sro_units_priv_ent_owned)\"\n                  id=\"sro_units_priv_ent_owned_srop\" name=\"sro_units_priv_ent_owned_srop\" type=\"text\"\n                  placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.sro_units_priv_ent_owned\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.sro_units_priv_ent_owned)\"\n                  ng-model=\" currentPolicy.sro_units_priv_ent_owned\" id=\"sro_units_priv_ent_owned_srop\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"sro_units_priv_ent_owned_srop\"\n                  rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" cols=\"63\"\n                  ng-disabled=\"attachmentData['sroUnitsOwnedPrivEnt'].isFileSelected || formReadOnly\"\n                  placeholder=\"Enter response\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.sro_units_priv_ent_owned_srop.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload sro_units_priv_ent_owned -->\n              <div ng-if=\"!checkSubstring(currentPolicy.sro_units_priv_ent_owned)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.sro_units_priv_ent_owned)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.sro_units_priv_ent_owned}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('sro_units_priv_ent_owned')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.sro_units_priv_ent_owned)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"sro_units_priv_ent_owned_file_abcd\">Upload SRO Units Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"sro_units_priv_ent_owned_file_abcd\" ng-disabled=\"formReadOnly\"\n                    id=\"sro_units_priv_ent_owned_file_abcd\" name=\"sro_units_priv_ent_owned_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('sro_units_priv_ent_owned_file_abcd')\">\n                    <i ng-show=\"fileUploading_sro_units_priv_ent_owned_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('sro_units_priv_ent_owned_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"sro_unit_limit_converted_srop\">Does policy limit number of SRO units converted in a year to\n                  the number of equivalent rental units completed the previous\n                  year, consistent with TOC Policy standard?</label>\n                <select id=\"sro_unit_limit_converted_srop\" name=\"sro_unit_limit_converted_srop\"\n                  ng-model=\"currentPolicy.sro_unit_limit_converted\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.sro_unit_limit_converted_srop.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"sro_building_conv_aff_housing_srop\">Does policy allow exemption for conversion of SRO\n                  buildings\n                  to 100% affordable units, consistent with TOC Policy\n                  standards?</label>\n                <select id=\"sro_building_conv_aff_housing_srop\" name=\"sro_building_conv_aff_housing_srop\"\n                  ng-model=\"currentPolicy.sro_building_conv_aff_housing\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.sro_building_conv_aff_housing_srop.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"req_tenant_relocation_assist_srop\">Does policy require submittal of Tenant Relocation\n                  Assistance\n                  Plan at time of application for conversion that spells out\n                  tenant protections, benefits and required relocation payments\n                  for any temporarily or permanently displaced residents,\n                  consistent with TOC Policy standards?</label>\n                <select id=\"req_tenant_relocation_assist_srop\" name=\"req_tenant_relocation_assist_srop\"\n                  ng-model=\"currentPolicy.req_tenant_relocation_assist\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.req_tenant_relocation_assist_srop.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_srop\">Policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                  ng-model=\" currentPolicy.program_policy_terms\" id=\"program_policy_terms_srop\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_terms_srop\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" cols=\"63\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_srop.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 55px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_srop\">Upload Policy Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_srop\" id=\"program_policy_terms_file_srop\"\n                    name=\"program_policy_terms_file_srop\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_srop')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_srop\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_srop')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_srop\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"program_policy_rhna_housing_srop\"\n                  ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_rhna_housing_srop\" placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_srop.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_srop\">Comments/Notes:</label>\n                <textarea ng-model=\" currentPolicy.comments\" id=\"comments_srop\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_srop\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" cols=\"90\" placeholder=\"Enter response\"></textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Condominium Conversion Restrictions Section -->\n          <div id=\"section-Condominium-Conversion-Restrictions\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Condominium Conversion Restrictions'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Condominium Conversion Restrictions</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Require that units\n                converted to condominiums be replaced 1:1 with comparable rental\n                units, unless purchased by current long-term tenants or\n                converted to permanently affordable housing with protections for\n                existing tenants.\n              </span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_ccrs\">Link to adopted policy:</label>\n                <textarea ng-model=\" currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link_ccrs\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_ccrs\"\n                  ng-disabled=\"formReadOnly\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\"\n                  placeholder=\"Enter URL\" type=\"text\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_ccrs.$error.required && formSubmitted\">\n                  Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_ccrs\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_ccrs\" name=\"jurisdiction_wide_ccrs\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_ccrs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"replace_ex_units_comp_rent_ccrs\">Does the policy require 1-for-1 replacement of existing\n                  units\n                  with comparable rental units, consistent with TOC Policy\n                  standards? A program may allow replacement units to be\n                  provided by paying an in-lieu fee per unit being\n                  converted.</label>\n                <select id=\"replace_ex_units_comp_rent_ccrs\" name=\"replace_ex_units_comp_rent_ccrs\"\n                  ng-model=\"currentPolicy.replace_ex_units_comp_rent\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.replace_ex_units_comp_rent_ccrs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"amount_per_unit_in_lieu_ccrs\">If policy allows an in-lieu fee, what is amount per\n                  unit?</label>\n                <input id=\"amount_per_unit_in_lieu_ccrs\" name=\"amount_per_unit_in_lieu_ccrs\" type=\"number\"\n                  ng-disabled=\"formReadOnly\" placeholder=\"$\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  placeholder=\"$\" ng-model=\"currentPolicy.amount_per_unit_in_lieu\" required />\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"in_lieu_determination_ccrs\">If policy allows an in-lieu fee, provide a brief explanation\n                  describing how the jurisdiction determined the in-lieu fee\n                  amount, including a justification for why the fee is\n                  sufficient to mitigate the loss of rental housing.\n                </label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.in_lieu_determination)\"\n                  ng-model=\" currentPolicy.in_lieu_determination\" id=\"in_lieu_determination_ccrs\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"in_lieu_determination_ccrs\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" cols=\"63\"\n                  ng-disabled=\"attachmentData['InLieuDetermination'].isFileSelected || formReadOnly\"\n                  required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.in_lieu_determination_ccrs$error.required && formSubmitted\">\n                  Please enter a valid response or 'N/A'.\n                </div>\n              </div>\n              <!-- File upload in_lieu_determination -->\n              <div ng-if=\"!checkSubstring(currentPolicy.in_lieu_determination)\" style=\"margin-top: 95px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.in_lieu_determination)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.in_lieu_determination}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('in_lieu_determination')\">\n                  <i ng-show=\"fileUploading_in_lieu_determination\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.in_lieu_determination)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"in_lieu_determination_file_ccrs\">Upload In Lieu Determination Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"in_lieu_determination_file_ccrs\" id=\"in_lieu_determination_file_ccrs\"\n                    name=\"in_lieu_determination_file_ccrs\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('in_lieu_determination_file_ccrs')\">\n                    <i ng-show=\"fileUploading_in_lieu_determination_file_ccrs\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('in_lieu_determination_file_ccrs')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"exempt_consistent_with_toc_ccrs\">If policy allows exemptions to 1-for-1 requirement, are\n                  they\n                  consistent with TOC Policy standards?\n                </label>\n                <select id=\"exempt_consistent_with_toc_ccrs\" name=\"exempt_consistent_with_toc_ccrs\"\n                  ng-model=\"currentPolicy.exempt_consistent_with_toc\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"first_right_to_purchase_ccrs\">Does the policy provide existing tenants first right to\n                  purchase a unit at the same price offered to the general\n                  public?</label>\n                <select id=\"first_right_to_purchase_ccrs\" name=\"first_right_to_purchase_ccrs\"\n                  ng-model=\"currentPolicy.first_right_to_purchase\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.first_right_to_purchase_ccrs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"tenant_relocation_assistance_ccrs\">Does policy require submittal of Tenant Relocation\n                  Assistance\n                  Plan at time of application for conversion that spells out\n                  tenant protections, benefits and required relocation payments\n                  for any temporarily or permanently displaced residents,\n                  consistent with TOC Policy standards?</label>\n                <select id=\"tenant_relocation_assistance_ccrs\" name=\"tenant_relocation_assistance_ccrs\"\n                  ng-model=\"currentPolicy.tenant_relocation_assistance\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.tenant_relocation_assistance_ccrs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_ccrs\">Policy terms if not in ordinance or documentation\n                  establishing policy:\n                </label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                  ng-model=\" currentPolicy.program_policy_terms\" id=\"program_policy_terms_ccrs\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_terms_ccrs\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" cols=\"63\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_ccrs$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 55px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading_program_policy_terms\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_ccrs\">Upload Policy Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_ccrs\" id=\"program_policy_terms_file_ccrs\"\n                    name=\"program_policy_terms_file_ccrs\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_ccrs')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_ccrs\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_ccrs')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_ccrs\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?\n                </label>\n                <textarea ng-model=\" currentPolicy.program_policy_rhna_housing\" id=\"program_policy_rhna_housing_ccrs\"\n                  ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_rhna_housing_ccrs\" placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_ccrs.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_ccrs\">Comments/Notes:</label>\n                <textarea ng-model=\" currentPolicy.comments\" id=\"comments_ccrs\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_ccrs\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" placeholder=\"Enter response\" style=\"width: 100%\"></textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Public/Community Land Trusts Section -->\n          <div id=\"section-Public-Community-Land-Trusts-Preservation\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Public/Community Land Trusts (Preservation)'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Public/Community Land Trusts</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              Description from TOC Policy Resolution: Investments or policies to\n              expand the amount of land held by public- and non-profit entities\n              such as co- operatives, community land trusts, and land banks with\n              permanent affordability protections.\n              <u>This policy may be used to fulfill either the housing\n                production or preservation requirement, but not both.</u>\n            </p>\n            <div class=\"col\" ng-if=\"!loading && fundingLevels\">\n              <p>\n                <strong aria-label=\"Jurisdiction Name\">\n                  {{fundingLevels.jurisdiction}}\n                </strong>\n                is in\n                <strong aria-label=\"Funding Tier\">\n                  <span ng-if=\"fundingLevels && fundingLevels.funding_tier\">\n                    funding tier {{fundingLevels.funding_tier}}</span></strong>. It must demonstrate there is a program with funding above\n                <strong aria-label=\"Preservation Requirement\">\n                  {{fundingLevels.preservation_ | currency}}\n                </strong>\n                for this policy over a four-year period if it chooses to use this policy to achieve TOC Policy consistency. For more information about required funding amounts and sources, see section “Policy Options With Funding Commitments” of the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance</a>.\n              </p>\n            </div>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_pclt\">Link to adopted program:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link_pclt\"\n                  ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"adopted_program_policy_link_pclt\" placeholder=\"Enter URL\" type=\"text\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_pclt.$error.required && formSubmitted\">\n                  Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_pclt\">Does program apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_pclt\" name=\"jurisdiction_wide_pclt\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_pclt.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"policy_meets_toc_standards_pclt\">Does program meet TOC Policy standards for income\n                  limits/affordability levels and the required affordability\n                  period, and identify a legal mechanism for enforcement?</label>\n                <select id=\"policy_meets_toc_standards_pclt\" name=\"policy_meets_toc_standards_pclt\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards_pclt.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_pclt\">Program terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                  ng-model=\"currentPolicy.program_policy_terms\" id=\"program_policy_terms_pclt\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_terms_pclt\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" cols=\"63\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_pclt.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 55px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_pclt\">Upload Program Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_pclt\" id=\"program_policy_terms_file_pclt\"\n                    name=\"program_policy_terms_file_pclt\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_pclt')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_pclt\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_pclt')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"anticipated_funding_2026_pclt\">Amount of anticipated funding for four-year period ($):</label>\n                <input ng-model=\"currentPolicy.anticipated_funding_2026\" type=\"number\" ng-disabled=\"formReadOnly\"\n                  id=\"anticipated_funding_2026_pclt\" name=\"anticipated_funding_2026_pclt\" type=\"number\" placeholder=\"$\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"anticipated_funding_2026\"\n                  required />\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.anticipated_funding_2026_pclt.$error.number && formSubmitted\">\n                  Please provide a valid value.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"secured_funding_docs_pclt\">Documentation that jurisdiction has \"secured funding\"\n                  consistent with TOC Policy requirements, including\n                  identification of fund source(s):</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\"\n                  ng-model=\"currentPolicy.secured_funding_docs\" id=\"secured_funding_docs_pclt\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"secured_funding_docs_pclt\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" placeholder=\"Enter URL or 'N/A'\" type=\"text\" cols=\"63\"\n                  ng-disabled=\"attachmentData['SecuredFunding'].isFileSelected || formReadOnly\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.secured_funding_docs_pclt.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload secured_funding_docs -->\n              <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('secured_funding_docs')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"secured_funding_docs_file_pclt\">Upload Secured Funding Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"secured_funding_docs_file_pclt\" id=\"secured_funding_docs_file_pclt\"\n                    name=\"secured_funding_docs_file_pclt\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_pclt')\">\n                    <i ng-show=\"fileUploading_secured_funding_docs_file_pclt\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('secured_funding_docs_file_pclt')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"expected_fund_schedule_2026_pclt\">Schedule of expected funding allocated to the program:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                  ng-model=\"currentPolicy.expected_fund_schedule_2026\" id=\"expected_fund_schedule_2026_pclt\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"expected_fund_schedule_2026_pclt\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" cols=\"63\"\n                  ng-disabled=\"attachmentData['ExpectedFunding'].isFileSelected || formReadOnly\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.expected_fund_schedule_2026_pclt.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload expected_fund_schedule_2026 -->\n              <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('expected_fund_schedule_2026')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"expected_fund_schedule_2026_file_pclt\">Upload Expected Fund Schedule Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_pclt\" ng-disabled=\"formReadOnly\"\n                    id=\"expected_fund_schedule_2026_file_pclt\" name=\"expected_fund_schedule_2026_file_pclt\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('expected_fund_schedule_2026_file_pclt')\">\n                    <i ng-show=\"fileUploading_expected_fund_schedule_2026_file_pclt\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('expected_fund_schedule_2026_file_pclt')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_pclt\">How does program address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"program_policy_rhna_housing_pclt\"\n                  placeholder=\"Enter response\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-disabled=\"formReadOnly\" name=\"program_policy_rhna_housing_pclt\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_pclt.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_pclt\">Comments/Notes:</label>\n                <!-- <input type=\"text\" placeholder=\"Enter your response here\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.comments\" /> -->\n                <textarea ng-model=\"currentPolicy.comments\" id=\"comments_pclt\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_pclt\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" placeholder=\"Enter response\" style=\"width: 100%\"></textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Funding to Support Preservation Capacity Section-->\n          <div id=\"section-Funding-to-Support-Preservation-Capacity\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Funding to Support Preservation Capacity'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Funding to Support Preservation Capacity</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Dedicated local funding\n                for capacity building or other material support for community\n                land trusts (CLTs) or other community-based organizations (CBOs)\n                engaged in affordable housing preservation.</span>\n            </p>\n            <div class=\"col\" ng-if=\"!loading && fundingLevels\">\n              <p>\n                <strong aria-label=\"Jurisdiction Name\">\n                  {{fundingLevels.jurisdiction}}\n                </strong>\n                is in\n                <strong aria-label=\"Funding Tier\">\n                  funding tier {{fundingLevels.funding_tier}}</strong>. It must demonstrate there is a program with funding above\n                <strong aria-label=\"Preservation Requirement\">\n                  {{fundingLevels.preservation_ | currency}}\n                </strong>\n                for this policy over a four-year period if it chooses to use this policy to achieve TOC Policy consistency. For more information about required funding amounts and sources, see section “Policy Options With Funding Commitments” of the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance</a>.\n              </p>\n            </div>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_fspc\">Link to adopted policy:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link_fspc\"\n                  ng-disabled=\"formReadOnly\" placeholder=\"Enter URL\" type=\"text\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_fspc\"\n                  rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_fspc.$error.required && formSubmitted\">\n                  Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_fspc\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_fspc\" name=\"jurisdiction_wide_fspc\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_fspc.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"staffing_methodology_fspc\">Methodology used to determine funding needed to maintain\n                  project management staffing, consistent with TOC Policy\n                  standards:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.staffing_methodology)\"\n                  ng-model=\"currentPolicy.staffing_methodology\" id=\"staffing_methodology_fspc\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"staffing_methodology_fspc\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\"\n                  ng-disabled=\"attachmentData['StaffingMethodology'].isFileSelected || formReadOnly\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" cols=\"63\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.staffing_methodology_fspc.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload staffing_methodology -->\n              <div ng-if=\"!checkSubstring(currentPolicy.staffing_methodology)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.staffing_methodology)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.staffing_methodology}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('staffing_methodology')\" ng-if=\"!formReadOnly\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.staffing_methodology)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"staffing_methodology_file_abcd\">Upload Staff Funding Methodology Documentation</label>\n                </div>\n                <div class=\"col-lg-5\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"staffing_methodology_file_abcd\" id=\"staffing_methodology_file_abcd\"\n                    name=\"staffing_methodology_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('staffing_methodology_file_abcd')\">\n                    <i ng-show=\"fileUploading_staffing_methodology_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('staffing_methodology_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_eligible_fspc\">Policy eligibility criteria if not in ordinance or documents\n                  establishing policy:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_eligible)\"\n                  ng-model=\"currentPolicy.program_policy_eligible\" id=\"program_policy_eligible_fspc\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_eligible_fspc\"\n                  placeholder=\"Enter response\"\n                  ng-disabled=\"attachmentData['ProgramPolicyEligible'].isFileSelected || formReadOnly\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_eligible_fspc.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload program_policy_eligible -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_eligible)\" style=\"margin-top: 55px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_eligible)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_eligible}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_eligible')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_eligible)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_eligible_file_abcd\">Upload Policy Eligibility Criteria\n                    Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_eligible_file_abcd\" id=\"program_policy_eligible_file_abcd\"\n                    name=\"program_policy_eligible_file\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_eligible_file_abcd')\">\n                    <i ng-show=\"fileUploading_program_policy_eligible_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_eligible_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"anticipated_funding_2026_fspc\">Amount of anticipated funding for four-year period ($):</label>\n                <input id=\"anticipated_funding_2026_fspc\" name=\"anticipated_funding_2026_fspc\" type=\"text\"\n                  ng-disabled=\"formReadOnly\" placeholder=\"$\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.anticipated_funding_2026 || formReadOnly\" required />\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.anticipated_funding_2026_fspc.$error.required && formSubmitted\">\n                  Please provide a valid value.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"secured_funding_docs_fspc\">Documentation that jurisdiction has \"secured funding\"\n                  consistent with TOC Policy requirements, including\n                  identification of fund source(s):</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\"\n                  ng-model=\"currentPolicy.secured_funding_docs\" id=\"secured_funding_docs_fspc\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"secured_funding_docs_fspc\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\"\n                  ng-disabled=\"attachmentData['SecuredFunding'].isFileSelected || formReadOnly\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.secured_funding_docs_fspc.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload secured_funding_docs -->\n              <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('secured_funding_docs')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"secured_funding_docs_file_fspc\">Upload Secured Funding Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"secured_funding_docs_file_fspc\" id=\"secured_funding_docs_file_fspc\"\n                    name=\"secured_funding_docs_file_fspc\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_fspc')\">\n                    <i ng-show=\"fileUploading_secured_funding_docs_file_fspc\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('secured_funding_docs_file_fspc')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"expected_fund_schedule_2026_fspc\">Schedule of expected funding allocated to the program:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                  ng-model=\"currentPolicy.expected_fund_schedule_2026\" id=\"expected_fund_schedule_2026_fspc\"\n                  placeholder=\"Enter URL or 'N/A'\" type=\"text\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"expected_fund_schedule_2026_fspc\"\n                  ng-disabled=\"attachmentData['ExpectedFunding'].isFileSelected || formReadOnly\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.expected_fund_schedule_2026_fspc.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload expected_fund_schedule_2026 -->\n              <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 60px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('expected_fund_schedule_2026')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"expected_fund_schedule_2026_file_fspc\">Upload Expected Fund Schedule Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_fspc\" ng-disabled=\"formReadOnly\"\n                    id=\"expected_fund_schedule_2026_file_fspc\" name=\"expected_fund_schedule_2026_file_fspc\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('expected_fund_schedule_2026_file_fspc')\">\n                    <i ng-show=\"fileUploading_expected_fund_schedule_2026_file_fspc\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('expected_fund_schedule_2026_file_fspc')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_fspc\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"program_policy_rhna_housing_fspc\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_fspc\"\n                  ng-disabled=\"formReadOnly\" placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_fspc.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_fspc\">Comments/Notes:</label>\n                <textarea ng-model=\"currentPolicy.comments\" id=\"comments_fspc\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_fspc\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" placeholder=\"Enter response\" style=\"width: 100%\"></textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Mobile Home Preservation Section -->\n          <div id=\"section-Mobile-Home-Preservation\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Mobile Home Preservation'}\">\n            <div style=\"\n                display: flex;\n                align-items: center;\n                gap: 16px;\n                flex-wrap: wrap;\n                margin-bottom: 8px;\n              \">\n              <h2 style=\"margin: 0\">Mobile Home Preservation</h2>\n              <div\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\">\n                <button class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\">\n                  <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                  {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n                </button>\n                <span ng-if=\"adminUnlocked\" style=\"margin-left: 10px; color: #b8520a; font-style: italic\">\n                  Form is unlocked for editing.\n                </span>\n              </div>\n            </div>\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Policy or program to\n                preserve mobile homes from conversion to other uses that may\n                result in displacement of existing residents.\n              </span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_mhp\">Link to adopted policy:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link_mhp\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_mhp\"\n                  ng-disabled=\"formReadOnly\" placeholder=\"Enter URL\" type=\"text\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_mhp.$error.required && formSubmitted\">\n                  Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_mhp\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_mhp\" name=\"jurisdiction_wide_mhp\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_mhp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"mobile_home_park_docs_mhp\">Documentation of at least one mobile home park in the\n                  jurisdiction:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.mobile_home_park_docs)\"\n                  ng-model=\"currentPolicy.mobile_home_park_docs\" id=\"mobile_home_park_docs_mhp\"\n                  placeholder=\"Enter response\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"mobile_home_park_docs_mhp\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" cols=\"63\"\n                  ng-disabled=\"attachmentData['MobileHome'].isFileSelected || formReadOnly\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.mobile_home_park_docs_mhp.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload mobile_home_park_docs -->\n              <div ng-if=\"!checkSubstring(currentPolicy.mobile_home_park_docs)\" style=\"margin-top: 45px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.mobile_home_park_docs)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.mobile_home_park_docs}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('mobile_home_park_docs')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.mobile_home_park_docs)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"mobile_home_park_docs_file_abcd\">Upload Mobile Home Park Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"mobile_home_park_docs_file_abcd\" id=\"mobile_home_park_docs_file_abcd\"\n                    name=\"mobile_home_park_docs_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('mobile_home_park_docs_file_abcd')\">\n                    <i ng-show=\"fileUploading_mobile_home_park_docs_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('mobile_home_park_docs_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"mobile_home_policy_type_mhp\">Type of Policy:</label>\n                <select id=\"mobile_home_policy_type_mhp\" name=\"mobile_home_policy_type_mhp\"\n                  ng-model=\"currentPolicy.mobile_home_policy_type\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"zone\">\n                    Mobile Home Zoning District/Overlay Zone\n                  </option>\n                  <option value=\"close\">Mobile Home Closure Ordinance</option>\n                  <option value=\"both\">Both</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.mobile_home_policy_type_mhp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"dist_overlay_redev_affordable_mhp\"><span class=\"bold-text\">District/Overlay:</span> If the\n                  policy allows redevelopment for 100% affordable housing, are\n                  the requirements for redevelopment consistent with TOC Policy\n                  standards?</label>\n                <select id=\"dist_overlay_redev_affordable_mhp\" name=\"dist_overlay_redev_affordable_mhp\"\n                  ng-model=\"currentPolicy.dist_overlay_redev_affordable\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.dist_overlay_redev_affordable_mhp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"closure_ord_req_relo_assist_cond_app_mhp\"><span class=\"bold-text\">Closure Ordinance:</span>\n                  Does policy\n                  require relocation assistance and conditional approval after\n                  public hearings?</label>\n                <select id=\"closure_ord_req_relo_assist_cond_app_mhp\" name=\"closure_ord_req_relo_assist_cond_app_mhp\"\n                  ng-model=\"currentPolicy.closure_ord_req_relo_assist_cond_app\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.closure_ord_req_relo_assist_cond_app_mhp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"req_tenant_relocation_assist\"><span class=\"bold-text\">Closure Ordinance:</span> Does policy\n                  require submittal of a Tenant Relocation Assistance Plan at\n                  time of application for closure that spells out tenant\n                  protections, benefits and required relocation payments for any\n                  temporarily or permanently displaced residents, consistent\n                  with TOC Policy standards?\n                </label>\n                <select id=\"req_tenant_relocation_assist_mhp\" name=\"req_tenant_relocation_assist_mhp\"\n                  ng-model=\"currentPolicy.req_tenant_relocation_assist\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.req_tenant_relocation_assist_mhp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_mhp\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"program_policy_rhna_housing_mhp\"\n                  ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"program_policy_rhna_housing_mhp\" placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_mhp.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_mhp\">Comments/Notes:</label>\n                <textarea ng-model=\"currentPolicy.comments\" id=\"comments_mhp\" placeholder=\"Enter response\"\n                  ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"comments_mhp\" rows=\"4\" style=\"width: 100%\" style=\"width: 100%\" style=\"width: 100%\"></textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Preventing Displacement from Substandard Conditions and Associated Code Enforcement Activities Section -->\n          <div\n            id=\"section-Preventing-Displacement-from-Substandard-Conditions-and-Associated-Code-Enforcement-Activities\"\n            role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.type === 'Preservation' && currentPolicy.housing_policy_name === 'Preventing Displacement from Substandard Conditions and Associated Code Enforcement Activities'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Preventing Displacement from Substandard Conditions and\n                Associated\n                Code Enforcement Activities (Preservation)</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Policies, programs, or\n                procedures designed to minimize the risk of displacement caused\n                by substandard conditions including through local code\n                enforcement activities. This may include proactive rental\n                inspection programs and assistance to landlords for property\n                improvements in exchange for anti-displacement commitments.\n                <span class=\"underlined\">This policy may be used to fulfill either the housing\n                  preservation or protection requirement, but not both.</span>\n              </span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_preventing_displacement\">Link to adopted program:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\"\n                  id=\"adopted_program_policy_link_preventing_displacement\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" placeholder=\"Enter URL\" type=\"text\"\n                  name=\"adopted_program_policy_link_preventing_displacement\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_preventing_displacement$error.required && formSubmitted\">\n                  Please enter a valid URL..\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_preventing_displacement\">Does program apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_preventing_displacement\" name=\"jurisdiction_wide_preventing_displacement\"\n                  ng-disabled=\"formReadOnly\" ng-model=\"currentPolicy.jurisdiction_wide\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_preventing_displacement.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"subst_condition_policy_type_preventing_displacement\">Type of program:</label>\n                <select id=\"subst_condition_policy_type_preventing_displacement\" ng-disabled=\"formReadOnly\"\n                  name=\"subst_condition_policy_type_preventing_displacement\"\n                  ng-model=\"currentPolicy.subst_condition_policy_type\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"amnesty\">Amnesty Program</option>\n                  <option value=\"rehab\">Home Rehabilitiation Program</option>\n                  <option value=\"both\">Both</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.subst_condition_policy_type_preventing_displacement.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"subst_condition_tenant_hab_preventing_displacement\"><span class=\"bold-text\">Amnesty\n                    Program:</span> Provide\n                  template tenant habitability plan or document outlining\n                  details that must be included in such a plan, consistent with\n                  TOC Policy standards.</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.subst_condition_tenant_hab)\"\n                  ng-model=\"currentPolicy.subst_condition_tenant_hab\"\n                  id=\"subst_condition_tenant_hab_preventing_displacement\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"subst_condition_tenant_hab_preventing_displacement\" placeholder=\"Enter response\"\n                  ng-disabled=\"attachmentData['TenantHabitability'].isFileSelected || formReadOnly\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" cols=\"63\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.subst_condition_tenant_hab_preventing_displacement.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload subst_condition_tenant_hab -->\n              <div ng-if=\"!checkSubstring(currentPolicy.subst_condition_tenant_hab)\" style=\"margin-top: 95px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.subst_condition_tenant_hab)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.subst_condition_tenant_hab}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('subst_condition_tenant_hab')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.subst_condition_tenant_hab)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"subst_condition_tenant_hab_file_scth\">Upload Tenant Habitability Plan Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"subst_condition_tenant_hab_file_scth\" ng-disabled=\"formReadOnly\"\n                    id=\"subst_condition_tenant_hab_file_scth\" name=\"subst_condition_tenant_hab_file_scth\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('subst_condition_tenant_hab_file_scth')\">\n                    <i ng-show=\"fileUploading_subst_condition_tenant_hab_file_scth\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('subst_condition_tenant_hab_file_scth')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"amnesty_rent_continual_preventing_displacement\"><span class=\"bold-text\">Amnesty\n                    Program:</span> Does the\n                  program require the property owner to continue renting to the\n                  existing tenant, consistent with TOC Policy standards?</label>\n                <select id=\"amnesty_rent_continual_preventing_displacement\" ng-disabled=\"formReadOnly\"\n                  name=\"amnesty_rent_continual_preventing_displacement\" ng-model=\"currentPolicy.amnesty_rent_continual\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.amnesty_rent_continual_preventing_displacement.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"home_rehab_limit_funds_preventing_displacement\"><span class=\"bold-text\">Home Rehabilitation\n                    Program:</span>\n                  Does the program limit funding to property owners who are below 80%\n                  of AMI,\n                  consistent with TOC Policy standards?</label>\n                <select id=\"home_rehab_limit_funds_preventing_displacement\" ng-disabled=\"formReadOnly\"\n                  name=\"home_rehab_limit_funds_preventing_displacement\" ng-model=\"currentPolicy.home_rehab_limit_funds\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.home_rehab_limit_funds_preventing_displacement.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"home_rehab_program_eligible_preventing_displacement\"><span class=\"bold-text\">Home\n                    Rehabilitation Program:</span>\n                  Provide program eligibility requirements and financing terms,\n                  consistent with TOC Policy standards.</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.home_rehab_program_eligible)\"\n                  ng-model=\"currentPolicy.home_rehab_program_eligible\"\n                  id=\"home_rehab_program_eligible_preventing_displacement\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" placeholder=\"Enter response\"\n                  name=\"home_rehab_program_eligible_preventing_displacement\"\n                  ng-disabled=\"attachmentData['HomeRehabilitation'].isFileSelected || formReadOnly\" rows=\"4\"\n                  style=\"width: 100%\" style=\"width: 100%\" cols=\"63\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.home_rehab_program_eligible_preventing_displacement.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload home_rehab_program_eligible -->\n              <div ng-if=\"!checkSubstring(currentPolicy.home_rehab_program_eligible)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.home_rehab_program_eligible)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.home_rehab_program_eligible}}\">Uploaded Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('home_rehab_program_eligible')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.home_rehab_program_eligible)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"home_rehab_program_eligible_file_prev\">Upload Home Rehabilitation Program\n                    Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"home_rehab_program_eligible_file_prev\" ng-disabled=\"formReadOnly\"\n                    id=\"home_rehab_program_eligible_file_prev\" name=\"home_rehab_program_eligible_file_prev\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('home_rehab_program_eligible_file_prev')\">\n                    <i ng-show=\"fileUploading_home_rehab_program_eligible_file_prev\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('home_rehab_program_eligible_file_prev')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_preventing_displacement\">How does program address jurisdiction's\n                  RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\"\n                  id=\"program_policy_rhna_housing_preventing_displacement\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" placeholder=\"Enter response\"\n                  name=\"program_policy_rhna_housing_preventing_displacement\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\" required></textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_preventing_displacement.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_preventing_displacement\">Comments/Notes:</label>\n                <textarea ng-model=\"currentPolicy.comments\" id=\"comments_preventing_displacement\"\n                  ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"comments_preventing_displacement\" placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%\"\n                  style=\"width: 100%\" style=\"width: 100%\"></textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n        </div>\n        <submissionsectionsubmit></submissionsectionsubmit>\n      </div>\n    </div>\n    <div class=\"footer\" role=\"contentinfo\">\n      <sidebarfooter></sidebarfooter>\n    </div>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HousingProductionComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _housing_production = __webpack_require__(156);
	
	var _housing_production2 = _interopRequireDefault(_housing_production);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var HousingProductionComponent = exports.HousingProductionComponent = function () {
	  /*@ngInject*/
	  function HousingProductionComponent($state, $scope, $rootScope, FileUploadService, fetch, lookup, $timeout, userService, $http, baseConfigService, $stateParams) {
	    _classCallCheck(this, HousingProductionComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.$state = $state;
	    this.lookup = lookup;
	    this.$timeout = $timeout;
	    this.userService = userService;
	    this.baseConfigService = baseConfigService;
	    this.$stateParams = $stateParams;
	    this.FileUploadService = FileUploadService;
	    this.$http = $http;
	
	    $scope.adminUnlocked = false;
	    $scope.formsSubmitData = [];
	    $scope.currentlySelectedPolicies = [];
	    $scope.pdfUrls = {
	      "Public/Community Land Trusts (Production)": "https://dsa-public-files.s3.us-west-2.amazonaws.com/Production_Land_Trusts.pdf",
	      "Affordable Housing Funding": "https://dsa-public-files.s3.us-west-2.amazonaws.com/Affordable_Housing_Funding.pdf",
	      "Affordable Housing Overlay Zones": "https://dsa-public-files.s3.us-west-2.amazonaws.com/Affordable_Housing_Overlay_Zones.pdf",
	      "Public Land for Affordable Housing": "https://dsa-public-files.s3.us-west-2.amazonaws.com/Public_Land.pdf",
	      "Ministerial Approval": "https://dsa-public-files.s3.us-west-2.amazonaws.com/Ministerial_Approval.pdf",
	      "Development Certainty and Streamlined Entitlement Process": "https://dsa-public-files.s3.us-west-2.amazonaws.com/Development_Certainty.pdf",
	      "Inclusionary Zoning": "https://dsa-public-files.s3.us-west-2.amazonaws.com/Inclusionary_Zoning.pdf"
	    };
	    $scope.attachmentData = $scope.attachmenetData || {};
	    $scope.pendingChanges = false;
	    $scope.savemode = "housing";
	    $scope.housingType = "Production";
	    $scope.page = "production_";
	    $scope.globalPolicyNote = '<strong>Note:</strong> A jurisdiction must enter information for all fields for each affordable housing production policy they are using to demonstrate TOC Policy compliance. If any field is not relevant to a jurisdiction, enter “N/A".';
	    $scope.policyNotesMapping = {
	      'Public/Community Land Trusts (Production)': "<strong>Note:</strong> A jurisdiction can receive credit for both Production Policy 6 (Public/Community Land Trusts) and Production Policy 2 (Affordable Housing Funding) only if the funding program that meets the standards for Production Policy 2 has set asides for public/community land trusts that meet the funding listed in Appendix B. For example, a Tier A jurisdiction with a production program with $2,000,000 in funding could receive credit for both Production Policy 2 and Production Policy 6 if the program has a set aside for CLTs of $1,000,000, as these amounts meet the $1,000,000 minimum for both policies."
	    };
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.setPending = function () {
	      $scope.savemode = "housing";
	      $scope.pendingChanges = true;
	    };
	
	    $scope.openPdf = function (item) {
	      var pdfUrl = $scope.pdfUrls[item.housing_policy_name];
	
	      if (pdfUrl) {
	        window.open(pdfUrl, "_blank");
	      } else {
	        console.error("PDF URL not found for policy: " + item.housing_policy_name);
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.housingStatus) {
	        for (var i = 0; i < $scope.housingStatus.length; i++) {
	          if ($scope.housingStatus[i].housing_policy_name === $scope.currentPolicy.housing_policy_name) {
	            submission = $scope.housingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentPolicy && $scope.currentPolicy.housing_policy_name;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.housingStatus && $scope.currentPolicy && $scope.currentPolicy.housing_policy_name) {
	        var currentSubmission = _.find($scope.housingStatus, {
	          housing_policy_name: $scope.currentPolicy.housing_policy_name
	        });
	        if (currentSubmission && currentSubmission.submitted && currentSubmission.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch("housingStatus", function () {
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm("Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.");
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.housingStatus) {
	        for (var i = 0; i < $scope.housingStatus.length; i++) {
	          if ($scope.housingStatus[i].housing_policy_name === $scope.currentPolicy.housing_policy_name) {
	            submission = $scope.housingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error("No matching submission found to withdraw");
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem("api/data/submissions/update-status", payload).then(function () {
	        submission.submitted = false;
	        submission.status = null;
	
	        if ($scope.checkPolicy1 && $scope.checkPolicy1.submission_id === submission.submission_id) {
	          $scope.checkPolicy1 = null;
	        } else if ($scope.checkPolicy2 && $scope.checkPolicy2.submission_id === submission.submission_id) {
	          $scope.checkPolicy2 = null;
	        }
	
	        var matchingPolicy = $scope.currentlySelectedPolicies.find(function (p) {
	          return p.housing_policy_name === $scope.currentPolicy.housing_policy_name;
	        });
	        if (matchingPolicy) {
	          matchingPolicy.include_in_submission = false;
	        }
	
	        $scope.formsSubmitData = $scope.formsSubmitData.filter(function (p) {
	          return p.housing_policy_name !== $scope.currentPolicy.housing_policy_name;
	        });
	
	        $scope.submitType = "Submit Housing Policies for Review (" + $scope.formsSubmitData.length + ")";
	
	        var policyName = $scope.currentPolicy.housing_policy_name;
	        var formId = $scope.currentPolicy.housing_form_id;
	        $scope.currentPolicy = {
	          housing_policy_name: policyName,
	          housing_form_id: formId
	        };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	
	        $scope.formReadOnly = false;
	      }).catch(function (err) {
	        console.error("Withdraw failed:", err);
	        alert("There was an error withdrawing the submission. Please try again.");
	      });
	    };
	
	    $scope.addToSubmissions = function (policy) {
	      $scope.savemode = null;
	      if (_.filter($scope.formsSubmitData, {
	        housing_policy_name: policy.housing_policy_name
	      }).length === 1) {
	        $scope.formsSubmitData = _.remove($scope.formsSubmitData, function (n) {
	          return n.housing_policy_name !== policy.housing_policy_name;
	        });
	      } else {
	        $scope.formsSubmitData.push(policy);
	      }
	
	      $scope.submitmode = "housing";
	      $scope.submitType = "Submit Housing Policies for Review (" + $scope.formsSubmitData.length + ")";
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem("api/data/submissions/" + $scope.currentJurisdiction + "/" + $scope.currentSelectedStationId, "Housing " + $scope.housingType + " Policy").then(function (response) {
	        $scope.housingStatus = response.data;
	        $scope.checkPolicy1 = _.filter(response.data, {
	          submission_policy_name: "Affordable Housing " + $scope.housingType + " Policy 1",
	          submitted: true
	        })[0];
	        $scope.checkPolicy2 = _.filter(response.data, {
	          submission_policy_name: "Affordable Housing " + $scope.housingType + " Policy 2",
	          submitted: true
	        })[0];
	
	        if ($scope.currentlySelectedPolicies) {
	          $scope.currentlySelectedPolicies.forEach(function (policy) {
	            if ($scope.checkPolicy1 && $scope.checkPolicy1.submitted === true && $scope.checkPolicy1.housing_policy_name === policy.housing_policy_name || $scope.checkPolicy2 && $scope.checkPolicy2.submitted === true && $scope.checkPolicy2.housing_policy_name === policy.housing_policy_name) {
	              policy.include_in_submission = true;
	            } else {
	              policy.include_in_submission = false;
	            }
	          });
	        }
	
	        $scope.needsWorkNotice = false;
	        $scope.withdrawnNotice = false;
	        if ($scope.currentPolicy && $scope.currentPolicy.housing_policy_name) {
	          var currentSubmission = _.find(response.data, {
	            housing_policy_name: $scope.currentPolicy.housing_policy_name
	          });
	          if (currentSubmission && currentSubmission.submitted && currentSubmission.status === 'Needs Work') {
	            $scope.needsWorkNotice = true;
	          }
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go("login");
	        }
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	      if (!row || !row.submission_id) {
	        console.error("submission_id is missing:", row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log("Updating submission:", {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem("api/data/submissions/update-status", updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = "Status updated successfully";
	        });
	      }).catch(function (err) {
	        console.error("Error updating status:", err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = "Failed to update status";
	        });
	      });
	    };
	
	    $scope.submitPolicies = function () {
	      $scope.saving = true;
	      var upsertData = [];
	
	      if ($scope.formsSubmitData.length === 2) {
	        for (var index = 0; index < $scope.formsSubmitData.length; index++) {
	          var counter = index + 1;
	          var data = $scope.formsSubmitData[index];
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === "Affordable Housing " + $scope.housingType + " Policy " + counter && element.sta_recid === data.sta_recid) {
	              element.housing_policy_name = data.housing_policy_name;
	              element.submitted = true;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        }
	      } else if ($scope.formsSubmitData.length === 1) {
	        var data = $scope.formsSubmitData[0];
	
	        if (!$scope.checkPolicy1) {
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === "Affordable Housing " + $scope.housingType + " Policy 1" && element.sta_recid === data.sta_recid) {
	              element.housing_policy_id = data.housing_policy_id;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        } else if (!$scope.checkPolicy2) {
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === "Affordable Housing " + $scope.housingType + " Policy 2" && element.sta_recid === data.sta_recid) {
	              element.housing_policy_id = data.housing_policy_id;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        }
	      }
	
	      fetch.updateItem("api/data/submissions/update", upsertData).then(function (response) {
	        $scope.saved = true;
	        $scope.saving = false;
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.getSubmissionStatus();
	          $scope.$apply();
	        }, 3000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go("login");
	        }
	      });
	    };
	
	    $scope.updatePoliciesJurisdiction = function (jurisdiction) {
	      $scope.currentlySelectedPolicies = [];
	      lookup.setJurisdiction(jurisdiction);
	      $scope.currentJurisdiction = jurisdiction;
	      $scope.getStationbyID();
	      $scope.getSubmissionStatus();
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	      $scope.getSubmissionStatus();
	      $scope.currentlySelectedPolicies = [];
	      $scope.loadingPolicies = true;
	
	      fetch.getAllItems("api/data/housing/forms/" + $scope.currentJurisdiction + "/" + $scope.currentSelectedStationId + "/" + $scope.housingType).then(function (formResponse) {
	        return fetch.getItem("api/data/policies/" + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (policyResponse) {
	          $scope.currentStation = policyResponse.data[0];
	
	          formResponse.data.forEach(function (form) {
	            var policyMatch = policyResponse.data.find(function (p) {
	              return p.policy_type === form.policy_type;
	            });
	
	            if (form.policy_selected) {
	              $scope.currentlySelectedPolicies.push(form);
	            }
	          });
	
	          var requestedPolicyName = $stateParams.policyName;
	
	          var policyToSelect = null;
	
	          if (requestedPolicyName && $scope.currentlySelectedPolicies.length > 0) {
	            policyToSelect = $scope.currentlySelectedPolicies.find(function (p) {
	              var matches = p.housing_policy_name === requestedPolicyName;
	
	              return matches;
	            });
	          }
	
	          if (policyToSelect) {
	            policyToSelect.active = true;
	            $scope.currentPolicy = policyToSelect;
	
	            $scope.setCurrentPolicy($scope.currentPolicy);
	          } else if ($scope.currentlySelectedPolicies.length > 0) {
	            $scope.currentlySelectedPolicies[0].active = true;
	            $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
	
	            $scope.setCurrentPolicy($scope.currentPolicy);
	          } else {
	            $scope.currentPolicy = null;
	
	            $scope.setCurrentPolicy(null);
	          }
	
	          $scope.housingForms = formResponse.data;
	          $scope.loadingPolicies = false;
	          $scope.getJurisdictionFundingTier($scope.currentSelectedStationId);
	        });
	      }).catch(function (error) {
	        console.error("Error loading data:", error);
	        $scope.loadingPolicies = false;
	      });
	    };
	
	    $scope.updateSelected = function (item) {
	      if ($scope.currentlySelectedPolicies.length > 0) {
	        $scope.currentlySelectedPolicies.forEach(function (element) {
	          element.active = false;
	        });
	      }
	
	      if (item.policy_selected) {
	        $scope.currentlySelectedPolicies.push(item);
	      } else {
	        for (var i = 0; i < $scope.currentlySelectedPolicies.length; i++) {
	          if ($scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
	            $scope.currentlySelectedPolicies.splice(i, 1);
	          }
	        }
	      }
	      if ($scope.currentlySelectedPolicies.length > 0) {
	        $scope.currentlySelectedPolicies[0].active = true;
	        $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
	      } else {
	        $scope.currentPolicy = {};
	      }
	      var upsertData = {
	        policy_selected: item.policy_selected,
	        housing_form_id: item.housing_form_id
	      };
	
	      fetch.updateItem("api/data/housing/forms/update", upsertData).then(function (response) {}).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go("login");
	        }
	      });
	    };
	
	    $scope.setCurrentPolicy = function (item) {
	      if (item === "reviewAndSubmit") {
	        $scope.currentPolicy = {};
	        $scope.reviewAndSubmit = true;
	        $scope.note = "";
	      } else {
	        $scope.reviewAndSubmit = false;
	        $scope.currentPolicy = item || null;
	
	        var policyName = item && (item.submission_policy_name || item.housing_policy_name);
	        $scope.note = policyName && $scope.policyNotesMapping[policyName] || $scope.globalPolicyNote || "";
	      }
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems("api/data/stationareas/" + jurisdiction).then(function (response) {
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        } else {
	          $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
	        }
	
	        lookup.setCurrentStation($scope.currentSelectedStationId);
	
	        $scope.getStationbyID();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go("login");
	        }
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (policyItem, newStatus) {
	      console.log("--- updateSubmissionStatus Called ---");
	      console.log("Received policyItem:", angular.copy(policyItem));
	      console.log("Received newStatus:", newStatus);
	
	      if (!policyItem) {
	        console.error("No policy item provided");
	        return;
	      }
	      if (!policyItem.submission_id) {
	        console.error("No submission_id provided");
	        return;
	      }
	
	      var originalStatus = policyItem.status;
	      policyItem.status = newStatus;
	
	      var updateData = {
	        submission_id: policyItem.submission_id,
	        status: newStatus
	      };
	
	      fetch.updateItem("api/data/submissions/update-status", updateData).catch(function (err) {
	        policyItem.status = originalStatus;
	        console.error("Update failed:", err);
	      });
	    };
	
	    $scope.updateCurrentPolicy = function (form) {
	      $scope.formSubmitted = true;
	      $scope.form = form;
	      $scope.saving = true;
	      if ($scope.currentPolicy.active) {
	        delete $scope.currentPolicy.active;
	      }
	      console.log('Saving currentPolicy:', angular.copy($scope.currentPolicy));
	      fetch.updateItem("api/data/housing/forms/update", $scope.currentPolicy).then(function (response) {
	        $scope.saving = false;
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.savemode = null;
	          $scope.saved = false;
	          $scope.currentPolicy.active = true;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go("login");
	        }
	      });
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById("fileInput" + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== "application/pdf" && file.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document" && file.type !== "application/msword" && file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && file.type !== "application/vnd.ms-excel") {
	            alert("Please select a PDF, Word document, or Excel file.");
	            element.value = "";
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById("" + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = "";
	        $scope[ngmodel] = "";
	        $scope[ngmodel + "_preview"] = "";
	        $scope["fileUploading_" + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope["fileUploading_" + ngmodelfile] = true;
	      var file = document.getElementById("" + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error("No file selected");
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem("api/data/get-signed-url", fileUpload).then(function (response) {
	        console.log("Signed URL:", response.data.signedUrl);
	        console.log("Public URL:", response.data.publicUrl);
	
	        return $http({
	          method: "PUT",
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            "Content-Type": file.type
	          }
	        }).then(function () {
	          $scope.currentPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log("Upload successful");
	        console.log("Public URL:", publicUrl);
	
	        $scope["fileUploading_" + ngmodelfile] = false;
	        $scope["" + ngmodelfile] = "";
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error("Error:", error);
	        alert("Upload failed");
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === "http";
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentPolicy[ngmodel] = "";
	      $scope.setPending();
	      $scope.savemode = "housing";
	      $scope.pendingChanges = true;
	    };
	
	    $scope.getJurisdictionFundingTier = function (station) {
	      if (station) {
	        $scope.loadingData = true;
	      }
	      fetch.getItem("api/data/housing/fundingtiers/" + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	        $scope.fundingLevels = response.data[0];
	        $scope.loadingData = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go("login");
	        }
	      });
	    };
	  }
	
	  _createClass(HousingProductionComponent, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.housingForms = [];
	        _this.$scope.getJurisdictionFundingTier();
	        return _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go("login");
	        }
	      });
	    }
	  }, {
	    key: "getJurisdictionList",
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems("api/data/jurisdictions/jurisdiction-list").then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === "Administrator") {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: "updateSelected",
	    value: function updateSelected(item) {
	      var _this3 = this;
	
	      if (this.$scope.currentlySelectedPolicies.length > 0) {
	        this.$scope.currentlySelectedPolicies.forEach(function (element) {
	          element.active = false;
	        });
	      }
	
	      if (item.policy_selected) {
	        this.$scope.currentlySelectedPolicies.push(item);
	      } else {
	        for (var i = 0; i < this.$scope.currentlySelectedPolicies.length; i++) {
	          if (this.$scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
	            this.$scope.currentlySelectedPolicies.splice(i, 1);
	          }
	        }
	      }
	      if (this.$scope.currentlySelectedPolicies.length > 0) {
	        this.$scope.currentlySelectedPolicies[0].active = true;
	        this.$scope.currentPolicy = this.$scope.currentlySelectedPolicies[0];
	      } else {
	        this.$scope.currentPolicy = {};
	      }
	      var upsertData = {
	        policy_selected: item.policy_selected,
	        housing_form_id: item.housing_form_id
	      };
	
	      this.fetch.updateItem("api/data/housing/forms/update", upsertData).then(function (response) {}).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this3.$state.go("login");
	        }
	      });
	    }
	  }, {
	    key: "getStationAreaSubmissionSummary",
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this4 = this;
	
	      console.log("Getting summary for station:", stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this4.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem("api/data/policies/" + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log("Policy data:", response);
	          _this4.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this4.$scope.submissionSummary);
	          _this4.lookup.setSubmissionPolicies(_this4.$scope.submissionSummary);
	
	          _this4.$scope.densitySubmissions = _.filter(response.data, {
	            submission_policy_type: "Density"
	          });
	          _this4.$scope.densitySubmitted = _.filter(_this4.$scope.densitySubmissions, { submitted: true });
	          _this4.$scope.densityCompliant = _.filter(_this4.$scope.densitySubmissions, { status: "Consistent" });
	
	          _this4.$scope.housingPolicySubmissions = _.filter(response.data, {
	            submission_policy_type: "Housing Production Policy"
	          });
	          _this4.$scope.housingPolicySubmissions = _.union(_this4.$scope.housingPolicySubmissions, _.filter(response.data, {
	            submission_policy_type: "Housing Preservation Policy"
	          }), _.filter(response.data, {
	            submission_policy_type: "Housing Protection Policy"
	          }), _.filter(response.data, {
	            submission_policy_type: "Housing Commercial Policy"
	          }));
	          _this4.$scope.housingPolicySubmitted = _.filter(_this4.$scope.housingPolicySubmissions, { submitted: true });
	          _this4.$scope.housingPolicyCompliant = _.filter(_this4.$scope.housingPolicySubmissions, { status: "Consistent" });
	
	          _this4.$scope.parkingSubmissions = _.filter(response.data, {
	            submission_policy_type: "Parking"
	          });
	          _this4.$scope.parkingSubmitted = _.filter(_this4.$scope.parkingSubmissions, { submitted: true });
	          _this4.$scope.parkingCompliant = _.filter(_this4.$scope.parkingSubmissions, { status: "Consistent" });
	
	          _this4.$scope.stationAccessSubmissions = _.filter(response.data, {
	            submission_policy_type: "Station Area Access"
	          });
	          _this4.$scope.stationAccessSubmitted = _.filter(_this4.$scope.stationAccessSubmissions, { submitted: true });
	          _this4.$scope.stationAccessCompliant = _.filter(_this4.$scope.stationAccessSubmissions, { status: "Consistent" });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = "--";
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return HousingProductionComponent;
	}();
	
	exports.default = angular.module("appApp.housing_production", [uiRouter]).config(_housing_production2.default).component("housingProduction", {
	  template: __webpack_require__(157),
	  controller: HousingProductionComponent,
	  controllerAs: "housingProductionCtrl"
	}).name;

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('housing_production', {
	    url: '/account/housing/housing_production?jurisdiction&sta_recid&policyName',
	    template: '<housing-production></housing-production>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null,
	      policyName: null }
	  });
	};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports = "<section\n  class=\"dashboard dashboard--page dashboard--page--submission dashboard--compliance dashboard--compliance--jurisdiction\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <maintocselection />\n\n      <div class=\"content container\">\n        <h1 id=\"housing-production-title\" class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <p>\n          To be consistent with the TOC Policy, a jurisdiction must adopt <strong>at least two</strong> affordable housing\n          production policies.\n          Appendix A of the <a\n            href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC\n            Policy Administrative Guidance</a> describes the seven policy options in\n          more detail and outlines the minimum standards a jurisdiction’s policy must meet to be consistent with the TOC\n          Policy. You can also download a <a\n            href=\"https://dsa-public-files.s3.us-west-2.amazonaws.com/MTC_TOC_Policies_Checklist_v3.docx\" target=\"_blank\" rel=\"noopener noreferrer\">checklist</a>\n          that\n          summarizes the minimum standards for each policy.\n          <!-- {{pendingChanges}} -->\n        </p>\n\n        <div class=\"section\">\n          <h2 class=\"icon icon--housing\">Housing Policy Options</h2>\n          <notificationmessages />\n          <selecthousingpolicies />\n        </div>\n\n        <nav aria-label=\"Policy Sections\" class=\"section-nav\">\n          <div class=\"menu--section-title\">In this section:</div>\n          <ul class=\"menu menu--section\" role=\"tablist\">\n            <li ng-repeat=\"item in currentlySelectedPolicies\" data-bs-toggle=\"tab\" class=\"menu-item menu-item--section\"\n              ng-class=\"{ 'active': item.active }\" ng-click=\"setCurrentPolicy(item)\">\n              <span class=\"section-number\">{{$index + 1}}.</span><a href=\"#\">{{\n                item.housing_policy_name }}</a>\n            </li>\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit-housing\"\n              class=\"menu-item menu-item--section\" ng-click=\"setCurrentPolicy('reviewAndSubmit')\">\n              <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n            </li>\n          </ul>\n          <note class=\"section-pin\" ng-if=\"note\" ng-bind-html=\"note\">A jurisdiction must enter information for all fields for each affordable housing production policy they are using to demonstrate TOC Policy consistency. If any field is not relevant to a jurisdiction, enter “N/A\".</note>\n          <furtherguidance></furtherguidance>\n        </nav>\n        <div class=\"tab-content\">\n          <!-- Inclusionary Zoning Section -->\n          <div id=\"section-Inclusionary Zoning\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Inclusionary Zoning'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Inclusionary Zoning</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <!-- <div\n              ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-warning\" style=\"margin-bottom: 12px;\">\n              This submission has been flagged as <strong>Needs Work</strong>. Please make your corrections and\n              resubmit.\n            </div> -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Requires that 15% of\n                units in new residential development projects above a certain\n                number of units be deed-restricted affordable to low-income\n                households. A lower percentage may be adopted if it can be\n                demonstrated by a satisfactory financial feasibility analysis\n                that a 15% requirement is not feasible.\n              </span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\"\n              novalidate>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"adopted_program_policy_link\">Link to adopted policy:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link\"\n                  placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter URL\" type=\"text\"\n                  required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\">Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide\" name=\"jurisdiction_wide\" ng-model=\"currentPolicy.jurisdiction_wide\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide.$error.required && formSubmitted\">Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"applies_to_projects_11_units\">\n                  Does policy apply to all projects with 11 or more\n                  units (with possible exemptions consistent with TOC Policy\n                  standards)?</label>\n                <select id=\"applies_to_projects_11_units\" name=\"applies_to_projects_11_units\"\n                  ng-model=\"currentPolicy.applies_to_projects_11_units\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.applies_to_projects_11_units.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"policy_meets_toc_standards\">\n                  Does the policy meet TOC Policy standards for income\n                  limits/affordability levels and the required affordability\n                  period, and identify a legal mechanism for enforcement?</label>\n                <select id=\"policy_meets_toc_standards\" name=\"policy_meets_toc_standards\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"deed_restricted_affordable_hsng\">\n                  Does the policy require that at least 15% of units are deed-restricted affordable housing?</label>\n                <select id=\"deed_restricted_affordable_hsng\" name=\"deed_restricted_affordable_hsng\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.deed_restricted_affordable_hsng\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.deed_restricted_affordable_hsng.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-8\" ng-if=\"currentPolicy.deed_restricted_affordable_hsng === false\">\n                <label for=\"affordability_required_15\">If policy requires less than 15% affordability, an\n                  analysis showing requirement is equivalent to 15% standard\n                  <strong>OR</strong> a financial feasibility analysis finding 15%\n                  requirement is infeasible. MTC has developed a <a\n                    href=\"https://abag.ca.gov/tools-resources/digital-library/tocamiconversionxlsx\" target=\"_blank\" rel=\"noopener noreferrer\">spreadsheet\n                    illustrating the analysis of economic\n                    equivalency</a> . Jurisdictions may fill in the template spreadsheet or create/commission a\n                  comparable analysis to show that the jurisdiction’s requirements are comparable to the\n                  cost of providing 15% of rental units affordable to 80% of AMI and/or 15% or\n                  ownership units to 120% of AMI.</label>\n                <textarea ng-model=\"currentPolicy.affordability_required_15\" id=\"affordability_required_15\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"affordability_required_15\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter response\" cols=\"63\"\n                  placeholder=\"Enter response\" ng-if=\"!checkSubstring(currentPolicy.affordability_required_15)\"\n                  ng-disabled=\"attachmentData['Affordability15Percent'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.affordability_required_15.$error.required && formSubmitted\">Please provide a valid\n                  response.</div>\n              </div>\n              <!-- File upload affordability_required_15 -->\n              <div\n                ng-if=\"!checkSubstring(currentPolicy.affordability_required_15) && currentPolicy.deed_restricted_affordable_hsng === false\"\n                style=\"margin-top: 175px\" class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.affordability_required_15)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.affordability_required_15}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('affordability_required_15')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.affordability_required_15) && currentPolicy.deed_restricted_affordable_hsng === false\">\n                <div class=\"col-lg-2\"><label for=\"affordability_required_15_file_abcd\">Upload Analysis\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"affordability_required_15_file_abcd\"\n                    id=\"affordability_required_15_file_abcd\" name=\"affordability_required_15_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('affordability_required_15_file_abcd')\"><i\n                      ng-show=\"fileUploading_affordability_required_15_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('affordability_required_15_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"in_lieu_fee_above_below_100k\">If policy allows an in-lieu fee, provide documentation that\n                  fee\n                  will typically exceed $100,000 per required onsite affordable unit. If the fee is typically less than\n                  $100,000 per affordable unit, an analysis showing the fee will produce at least as many affordable\n                  units as would have been required for onsite compliance. MTC has developed a\n                  spreadsheet to help determine whether an in-lieu fee is equivalent to at least\n                  <a\n                    href=\"https://abag.ca.gov/tools-resources/digital-library/inclusionaryzoningfeeinlieufeecalculatorxlsx\" target=\"_blank\" rel=\"noopener noreferrer\">$100,000\n                    per required onsite affordable unit</a>.</label>\n                <textarea ng-model=\"currentPolicy.in_lieu_fee_above_below_100k\" id=\"in_lieu_fee_above_below_100k\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"in_lieu_fee_above_below_100k\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter response\" cols=\"63\"\n                  placeholder=\"Enter response\" ng-if=\"!checkSubstring(currentPolicy.in_lieu_fee_above_below_100k)\"\n                  ng-disabled=\"attachmentData['InLieuFee'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.in_lieu_fee_above_below_100k.$error.required && formSubmitted\">Please provide a valid\n                  response.</div>\n              </div>\n              <!-- File upload in_lieu_fee_above_below_100k -->\n              <div ng-if=\"!checkSubstring(currentPolicy.in_lieu_fee_above_below_100k)\" style=\"margin-top: 165px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.in_lieu_fee_above_below_100k)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.in_lieu_fee_above_below_100k}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('in_lieu_fee_above_below_100k')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.in_lieu_fee_above_below_100k)\">\n                <div class=\"col-lg-2\"><label for=\"in_lieu_fee_above_below_100k_file_abcd\">Upload In-Lieu Fee\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input ng-disabled=\"formReadOnly\" type=\"file\" ng-model=\"in_lieu_fee_above_below_100k_file_abcd\"\n                    id=\"in_lieu_fee_above_below_100k_file_abcd\" name=\"in_lieu_fee_above_below_100k_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\"\n                    ng-click=\"uploadFile('in_lieu_fee_above_below_100k_file_abcd')\"><i\n                      ng-show=\"fileUploading_in_lieu_fee_above_below_100k_file_abcd\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('in_lieu_fee_above_below_100k_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"income_eligible_management\">Management plan with procedures for annual monitoring to ensure\n                  residents are income-eligible and rents are consistent with\n                  program guidelines.</label>\n                <textarea ng-model=\"currentPolicy.income_eligible_management\" id=\"income_eligible_management\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"income_eligible_management\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.income_eligible_management)\"\n                  ng-disabled=\"attachmentData['IncomeEligible'].isFileSelected || formReadOnly\" placeholder=\"Enter response or URL\"\n                  type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.income_eligible_management.$error.required && formSubmitted\">Please provide a valid\n                  URL or enter N/A.</div>\n              </div>\n              <!-- File upload income_eligible_management -->\n              <div ng-if=\"!checkSubstring(currentPolicy.income_eligible_management)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.income_eligible_management)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.income_eligible_management}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('income_eligible_management')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.income_eligible_management)\">\n                <div class=\"col-lg-2\"><label for=\"income_eligible_management_file_abcd\">Upload Management Plan\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input ng-disabled=\"formReadOnly\" type=\"file\" ng-model=\"income_eligible_management_file_abcd\"\n                    id=\"income_eligible_management_file_abcd\" name=\"income_eligible_management_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('income_eligible_management_file_abcd')\"><i\n                      ng-show=\"fileUploading_income_eligible_management_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('income_eligible_management_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"iz_program_policy_rhna_housing\">How does policy address jurisdiction's RHNA and/or\n                  other housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"iz_program_policy_rhna_housing\"\n                  placeholder=\"Enter response\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  placeholder=\"Enter response\" name=\"iz_program_policy_rhna_housing\" rows=\"4\" style=\"width: 100%;\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" ng-disabled=\"formReadOnly\" required>\n                  </textarea>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"commentsInclusionaryZoning\">Comments/Notes:</label>\n                <textarea ng-model=\"currentPolicy.comments\" id=\"commentsInclusionaryZoning\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\" name=\"commentsInclusionaryZoning\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter response\" style=\"width: 100%;\">\n                  </textarea>\n              </div>\n\n            </form>\n          </div>\n          <!-- Affordable Housing Funding Section -->\n          <div id=\"section-Affordable Housing Funding\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Affordable Housing Funding'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Affordable Housing Funding</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <!-- <div\n              ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-warning\" style=\"margin-bottom: 12px;\">\n              This submission has been flagged as <strong>Needs Work</strong>. Please make your corrections and\n              resubmit.\n            </div> -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Dedicated local funding\n                for production of deed-restricted affordable housing.</span>\n            </p>\n            <div class=\"col\" ng-if=\"!loading && fundingLevels\">\n              <p>\n                <strong aria-label=\"Jurisdiction Name\">\n                  {{fundingLevels.jurisdiction}}\n                </strong>\n                is in\n                <strong aria-label=\"Funding Tier\">\n                  funding tier {{fundingLevels.funding_tier}}</strong>. It must demonstrate there is a program with funding above\n                <strong aria-label=\"Production Requirement\">\n                  {{fundingLevels.production_ | currency: \"$\"}}\n                </strong> over a four-year period if it\n                chooses to use this policy to achieve TOC Policy\n                consistency. For more information about required funding amounts and sources, see section \"Policy Options With Funding Commitments\" of the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Adminsistrative Guidance</a>.\n              </p>\n            </div>\n            <div ng-if=\"loading\">Loading funding tier information...</div>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" novalidate\n              ng-class=\"{'was-validated': formSubmitted}\">\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"ahfs_adopted_program_policy_link\">Link to adopted policy:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"ahfs_adopted_program_policy_link\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"ahfs_adopted_program_policy_link\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter URL\"\n                  type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\">Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"afhs_jurisdiction_wide\">Does program apply jurisdiction-wide?</label>\n                <select id=\"afhs_jurisdiction_wide\" name=\"afhs_jurisdiction_wide\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.jurisdiction_wide\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide.$error.required && formSubmitted\">Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"afhs_policy_meets_toc_standards\">Does the program meet TOC Policy standards for income\n                  limits/affordability levels and the required affordability\n                  period, and identify a legal mechanism for enforcement?</label>\n                <select id=\"afhs_policy_meets_toc_standards\" name=\"afhs_policy_meets_toc_standards\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"afhs_program_policy_terms\">Program terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <textarea ng-model=\"currentPolicy.program_policy_terms\" id=\"afhs_program_policy_terms\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"afhs_program_policy_terms\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\" \n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" placeholder=\"Enter response or URL\"\n                  type=\"text\" ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms.$error.required && formSubmitted\">Please enter a valid response or\n                  URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\"><label for=\"program_policy_terms_file_ahfs\">Upload Program Terms\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left:0 !important;\">\n                  <input ng-disabled=\"formReadOnly\" type=\"file\" ng-model=\"program_policy_terms_file_ahfs\"\n                    id=\"program_policy_terms_file_ahfs\" name=\"program_policy_terms_file_ahfs\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_ahfs')\"><i\n                      ng-show=\"fileUploading_program_policy_terms_file_ahfs\" class=\"fa-solid fa-cog fa-spin\"></i> Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_ahfs')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"afhs_anticipated_funding_2026\">Amount of anticipated funding for four-year period ($):</label>\n                <input id=\"afhs_anticipated_funding_2026\" name=\"afhs_anticipated_funding_2026\" type=\"number\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" placeholder=\"$\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.anticipated_funding_2026\" />\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.anticipated_funding_2026.$error.number && formSubmitted\">Please enter a valid dollar\n                  amount, e.g. 200000.</div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"afhs_secured_funding_docs\">Documentation that jurisdiction has \"secured\n                  funding\" consistent with TOC Policy requirements, including identification of fund source(s):</label>\n                <textarea ng-model=\"currentPolicy.secured_funding_docs\" id=\"afhs_secured_funding_docs\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"afhs_secured_funding_docs\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\"\n                  ng-disabled=\"attachmentData['SecuredFunding'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.secured_funding_docs.$error.required && formSubmitted\">Please provide a valid\n                  URL or enter N/A.\n                </div>\n              </div>\n              <!-- File upload secured_funding_docs -->\n              <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('secured_funding_docs')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                <div class=\"col-lg-2\"><label for=\"secured_funding_docs_file_ahfs\">Upload Secured Funding\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left:0 !important;\">\n                  <input type=\"file\" ng-model=\"secured_funding_docs_file_ahfs\" id=\"secured_funding_docs_file_ahfs\"\n                    name=\"secured_funding_docs_file_ahfs\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_ahfs')\"><i\n                      ng-show=\"fileUploading_secured_funding_docs_file_ahfs\" class=\"fa-solid fa-cog fa-spin\"></i> Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('secured_funding_docs_file_ahfs')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"afhs_expected_fund_schedule_2026\">Schedule of expected funding allocated to the program:</label>\n                <textarea ng-model=\"currentPolicy.expected_fund_schedule_2026\" id=\"afhs_expected_fund_schedule_2026\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"afhs_expected_fund_schedule_2026\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" placeholder=\"Enter response or URL\"\n                  type=\"text\" ng-disabled=\"attachmentData['ExpectedFunding'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards.$error.required && formSubmitted\">Please provide a valid\n                  URL or enter N/A.</div>\n              </div>\n              <!-- File upload expected_fund_schedule_2026 -->\n              <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('expected_fund_schedule_2026')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                <div class=\"col-lg-2\"><label for=\"expected_fund_schedule_2026_file_ahfs\">Upload Expected Funding\n                    Schedule Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left:0 !important;\">\n                  <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_ahfs\" ng-disabled=\"formReadOnly\"\n                    id=\"expected_fund_schedule_2026_file_ahfs\" name=\"expected_fund_schedule_2026_file_ahfs\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\"\n                    ng-click=\"uploadFile('expected_fund_schedule_2026_file_ahfs')\"><i\n                      ng-show=\"fileUploading_expected_fund_schedule_2026_file_ahfs\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('expected_fund_schedule_2026_file_ahfs')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"afhs_program_policy_rhna_housing\">How does policy address jurisdiction's RHNA and/or\n                  other housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"afhs_program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"afhs_program_policy_rhna_housing\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\"\n                  required>\n                  </textarea>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"afhs_comments\">Comments/Notes:</label>\n                <textarea ng-model=\"currentPolicy.comments\" id=\"afhs_comments\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"afhs_comments\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"90\" placeholder=\"Enter response\">\n                  </textarea>\n              </div>\n            </form>\n          </div>\n          <!-- Affordable Housing Overlay Zones Section-->\n          <div id=\"section-Affordable Housing Overlay Zones\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Affordable Housing Overlay Zones'}\">\n               <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Affordable Housing Overlay Zones</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <!-- <div\n              ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-warning\" style=\"margin-bottom: 12px;\">\n              This submission has been flagged as <strong>Needs Work</strong>. Please make your corrections and\n              resubmit.\n            </div> -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Area-specific\n                incentives, such as density bonuses and streamlined\n                environmental review, for development projects that include at\n                least 15% of units as deed-restricted affordable housing;\n                exceeds any jurisdiction-wide inclusionary requirements or\n                benefits from state density bonus.</span>\n            </p>\n\n\n            <form class=\"row test-validation-styling\" name=\"affordableHousingOverlayZonesForm\" novalidate\n              ng-class=\"{'was-validated': formSubmitted}\">\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"ahoz_adopted_program_policy_link\">Link to adopted policy:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"ahoz_adopted_program_policy_link\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"ahoz_adopted_program_policy_link\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter URL\"\n                  type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\">Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"ahoz_jurisdiction_wide\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"ahoz_jurisdiction_wide\" name=\"ahoz_jurisdiction_wide\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.jurisdiction_wide\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction-wide.$error.required && formSubmitted\">Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"ahoz_policy_geography_not\">If not jurisdiction-wide, describe geography where\n                  policy applies:</label>\n                <textarea ng-model=\"currentPolicy.policy_geography_not\" id=\"ahoz_policy_geography_not\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"ahoz_policy_geography_not\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter response\">\n                  </textarea>\n\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"ahoz_affordable_units_exceed\">Does policy’s required share of affordable units exceed\n                  jurisdiction-wide inclusionary zoning requirements and what is\n                  otherwise incentivized by state law for any given income\n                  category?</label>\n                <select id=\"ahoz_affordable_units_exceed\" name=\"ahoz_affordable_units_exceed\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.affordable_units_exceed\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.affordable_units_exceed.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label>Does policy offer greater residential density and at least\n                  one additional incentive or concession than what is available\n                  under state law?</label>\n                <select id=\"greater_residential_density\" name=\"greater_residential_density\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.greater_residential_density\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.greater_residential_density.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"ahoz_policy_meets_toc_standards\">Does policy meet TOC Policy standards for income\n                  limits/affordability levels and the required affordability\n                  period, and identify a legal mechanism for enforcement?</label>\n                <select id=\"ahoz_policy_meets_toc_standards\" name=\"ahoz_policy_meets_toc_standards\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"ahoz_program_policy_terms\">Policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <textarea ng-model=\"currentPolicy.program_policy_terms\" id=\"ahoz_program_policy_terms\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"ahoz_program_policy_terms\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" placeholder=\"Enter response or URL\"\n                  type=\"text\" ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms.$error.required && formSubmitted\">Please enter a valid response or\n                  URL.\n                </div>\n              </div>\n\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\"><label for=\"program_policy_terms_file_ahoz\">Upload Policy Terms\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left:0 !important;\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_ahoz\" id=\"program_policy_terms_file_ahoz\"\n                    name=\"program_policy_terms_file_ahoz\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    ng-disabled=\"formReadOnly\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_ahoz')\"><i\n                      ng-show=\"fileUploading_program_policy_terms_file_ahoz\" class=\"fa-solid fa-cog fa-spin\"></i> Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_ahoz')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"ahoz_program_policy_rhna_housing\">How does policy address jurisdiction's RHNA and/or\n                  other housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"ahoz_program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"ahoz_program_policy_rhna_housing\" ng-disabled=\"formReadOnly\"\n                  placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" style=\"width: 100%;\"\n                  required>\n                  </textarea>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"ahoz_comments\">Comments/Notes:</label>\n                <textarea ng-model=\"currentPolicy.comments\" id=\"ahoz_comments\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"ahoz_comments\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"90\" placeholder=\"Enter response\">\n                  </textarea>\n              </div>\n            </form>\n          </div>\n          <!-- Public Land for Affordable Housing Section -->\n          <div id=\"section-Public Land for Affordable Housing\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Public Land for Affordable Housing'}\">\n                <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Public Land for Affordable Housing</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <div\n              ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-warning\" style=\"margin-bottom: 12px;\">\n              This submission has been flagged as <strong>Needs Work</strong>. Please make your corrections and\n              resubmit.\n            </div>\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Area-specific\n                incentives, such as density bonuses and streamlined\n                environmental review, for development projects that include at\n                least 15% of units as deed-restricted affordable housing;\n                exceeds any jurisdiction-wide inclusionary requirements or\n                benefits from state density bonus.\n              </span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" novalidate\n              ng-class=\"{'was-validated': formSubmitted}\">\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"plah_adopted_program_policy_link\">Link to adopted program/policy:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"plah_adopted_program_policy_link\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"plah_adopted_program_policy_link\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter URL\"\n                  type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\">Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"plah_jurisdiction-wide\">Does program/policy apply jurisdiction-wide?</label>\n                <select id=\"plah_jurisdiction-wide\" name=\"plah_jurisdiction-wide\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.jurisdiction_wide\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction-wide.$error.required && formSubmitted\">Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"plah_he_or_public_lands_policy\">Documentation of a Housing Element policy for\n                  redevelopment of public land <span class=\"bold-text\">OR</span> adopted public lands policy\n                  that meets TOC Policy standards:</label>\n                <textarea ng-model=\"currentPolicy.he_or_public_lands_policy\" id=\"plah_he_or_public_lands_policy\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"plah_he_or_public_lands_policy\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.he_or_public_lands_policy)\" placeholder=\"Enter response\"\n                  ng-disabled=\"attachmentData['RedevAdoptPubLands'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.plah_he_or_public_lands_policy.$error.required && formSubmitted\">Please provide a valid\n                  response.\n                </div>\n              </div>\n              <!-- File upload he_or_public_lands_policy -->\n              <div ng-if=\"!checkSubstring(currentPolicy.he_or_public_lands_policy)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.he_or_public_lands_policy)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.he_or_public_lands_policy}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('he_or_public_lands_policy')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.he_or_public_lands_policy)\">\n                <div class=\"col-lg-2\"><label for=\"he_or_public_lands_policy_file_abcd\">Upload Policy\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"he_or_public_lands_policy_file_abcd\" ng-disabled=\"formReadOnly\"\n                    id=\"he_or_public_lands_policy_file_abcd\" name=\"he_or_public_lands_policy_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('he_or_public_lands_policy_file_abcd')\"><i\n                      ng-show=\"fileUploading_he_or_public_lands_policy_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('he_or_public_lands_policy_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"plah_public_lands_housing_dev\">Evidence of recent, ongoing, or planned housing development\n                  on public lands that meets TOC standards <span class=\"bold-text\">OR</span> evidence\n                  jurisdiction has at least one publicly owned site suitable for\n                  affordable housing development:</label>\n                <textarea ng-model=\"currentPolicy.public_lands_housing_dev\" id=\"plah_public_lands_housing_dev\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"plah_public_lands_housing_dev\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.public_lands_housing_dev)\" placeholder=\"Enter response\"\n                  ng-disabled=\"attachmentData['PubLandsHsngDev'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.public_lands_housing_dev.$error.required && formSubmitted\">Please provide a valid\n                  response.\n                </div>\n              </div>\n              <!-- File upload public_lands_housing_dev -->\n              <div ng-if=\"!checkSubstring(currentPolicy.public_lands_housing_dev)\" style=\"margin-top: 105px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.public_lands_housing_dev)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.public_lands_housing_dev}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('public_lands_housing_dev')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.public_lands_housing_dev)\">\n                <div class=\"col-lg-2\"><label for=\"public_lands_housing_dev_file_abcd\">Upload Evidence\n                    Documentation</label> </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"public_lands_housing_dev_file_abcd\" ng-disabled=\"formReadOnly\"\n                    id=\"public_lands_housing_dev_file_abcd\" name=\"public_lands_housing_dev_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('public_lands_housing_dev_file_abcd')\"><i\n                      ng-show=\"fileUploading_public_lands_housing_dev_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('public_lands_housing_dev_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"plah_public_lands_financial_support\">Evidence of the jurisdiction’s commitment to prioritizing the reuse of publicly owned land for affordable housing beyond what is required to secure a Surplus Land Act that meets TOC Policy standards:</label>\n                <textarea ng-model=\"currentPolicy.public_lands_financial_support\"\n                  id=\"plah_public_lands_financial_support\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"plah_public_lands_financial_support\" rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\"\n                  cols=\"63\" placeholder=\"Enter response\" \n                  ng-if=\"!checkSubstring(currentPolicy.public_lands_financial_support)\"\n                  ng-disabled=\"attachmentData['PubLandsFinanceSupport'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.public_lands_financial_support.$error.required && formSubmitted\">Please provide a valid\n                  response.\n                </div>\n              </div>\n              <!-- File upload public_lands_financial_support -->\n              <div ng-if=\"!checkSubstring(currentPolicy.public_lands_financial_support)\" style=\"margin-top: 115px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.public_lands_financial_support)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.public_lands_financial_support}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('public_lands_financial_support')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.public_lands_financial_support)\">\n                <div class=\"col-lg-2\"><label for=\"public_lands_financial_support_file_abcd\">Upload Evidence\n                    Documentation</label> </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"public_lands_financial_support_file_abcd\" ng-disabled=\"formReadOnly\"\n                    id=\"public_lands_financial_support_file_abcd\" name=\"public_lands_financial_support_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\"\n                    ng-click=\"uploadFile('public_lands_financial_support_file_abcd')\"><i\n                      ng-show=\"fileUploading_public_lands_financial_support_file_abcd\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('public_lands_financial_support_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"plah_policy_meets_toc_standards\">Does program/policy meet TOC Policy standards for income\n                  limits/affordability levels and the required affordability\n                  period, and identify a legal mechanism for enforcement?</label>\n                <select id=\"plah_policy_meets_toc_standards\" name=\"plah_policy_meets_toc_standards\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards.$error.required && formSubmitted\">Please provide a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"plah_program_policy_terms\">Program/policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <textarea ng-model=\"currentPolicy.plah_program_policy_terms\" id=\"plah_program_policy_terms\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"plah_program_policy_terms\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\" \n                  ng-if=\"!checkSubstring(currentPolicy.plah_program_policy_terms)\" placeholder=\"Enter response or URL\"\n                  type=\"text\" ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms.$error.required && formSubmitted\">Please enter a valid response or\n                  URL.\n                </div>\n              </div>\n              <!-- File upload plah_program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.plah_program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1 align-items-center\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.plah_program_policy_terms)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.plah_program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('plah_program_policy_terms')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.plah_program_policy_terms)\">\n                <div class=\"col-lg-2\"><label for=\"plah_program_policy_terms_file_abcd\"> Upload Program/Policy Terms\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"plah_program_policy_terms_file_abcd\"\n                    id=\"plah_program_policy_terms_file_abcd\" name=\"plah_program_policy_terms_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('plah_program_policy_terms_file_abcd')\"><i\n                      ng-show=\"fileUploading_plah_program_policy_terms_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('plah_program_policy_terms_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"plah_publicly_owned_sites_inventory\">Comprehensive inventory of publicly owned sites that\n                  includes\n                  both “surplus” land and other currently underutilized sites\n                  owned by the jurisdiction and other public agencies:</label>\n                <textarea ng-model=\"currentPolicy.publicly_owned_sites_inventory\"\n                  id=\"plah_publicly_owned_sites_inventory\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"plah_publicly_owned_sites_inventory\" rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\"\n                  cols=\"63\" placeholder=\"Enter response\"\n                  ng-if=\"!checkSubstring(currentPolicy.publicly_owned_sites_inventory)\"\n                  ng-disabled=\"attachmentData['PubOwnedSites'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.publicly_owned_sites_inventory.$error.required && formSubmitted\">Please provide a valid\n                  response.</div>\n              </div>\n\n              <!-- File upload publicly_owned_sites_inventory -->\n              <div ng-if=\"!checkSubstring(currentPolicy.publicly_owned_sites_inventory)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1 align-items-center\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.publicly_owned_sites_inventory)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.publicly_owned_sites_inventory}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('publicly_owned_sites_inventory')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.publicly_owned_sites_inventory)\">\n                <div class=\"col-lg-2\"><label for=\"publicly_owned_sites_inventory_file_abcd\">Upload Inventory\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"publicly_owned_sites_inventory_file_abcd\"\n                    id=\"publicly_owned_sites_inventory_file_abcd\" name=\"publicly_owned_sites_inventory_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\"\n                    ng-click=\"uploadFile('publicly_owned_sites_inventory_file_abcd')\"><i\n                      ng-show=\"fileUploading_publicly_owned_sites_inventory_file_abcd\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('publicly_owned_sites_inventory_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"plah_staff_consultant_documentation\">Documentation of dedicated staff or consultant for\n                  monitoring\n                  and advancing program, including anticipated FTE:</label>\n                <textarea ng-model=\"currentPolicy.staff_consultant_documentation\"\n                  id=\"plah_staff_consultant_documentation\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"plah_staff_consultant_documentation\" rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\"\n                  cols=\"63\" placeholder=\"Enter response or URL\" type=\"text\"\n                  ng-if=\"!checkSubstring(currentPolicy.staff_consultant_documentation)\"\n                  ng-disabled=\"attachmentData['DedicatedStaff'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.staff_consultant_documentation.$error.required && formSubmitted\">Please provide a valid\n                  URL or enter N/A.</div>\n\n              </div>\n              <!-- File upload staff_consultant_documentation -->\n              <div ng-if=\"!checkSubstring(currentPolicy.staff_consultant_documentation)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.staff_consultant_documentation)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.staff_consultant_documentation}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('staff_consultant_documentation')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.staff_consultant_documentation)\">\n                <div class=\"col-lg-2\"><label for=\"staff_consultant_documentation_file_abcd\">Upload Staff/Consultant\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"staff_consultant_documentation_file_abcd\"\n                    id=\"staff_consultant_documentation_file_abcd\" name=\"staff_consultant_documentation_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\"\n                    ng-click=\"uploadFile('staff_consultant_documentation_file_abcd')\"><i\n                      ng-show=\"fileUploading_staff_consultant_documentation_file_abcd\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('staff_consultant_documentation_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"plah_program_policy_rhna_housing\">How does program/policy address jurisdiction's RHNA and/or\n                  other housing needs identified in the Housing Element?</label>\n                <!-- <input id=\"plah_program_policy_rhna_housing\" name=\"plah_program_policy_rhna_housing\" type=\"text\"\n                  placeholder=\"Enter your response here\" value=\"\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.program_policy_rhna_housing\" required /> -->\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"plah_program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"plah_program_policy_rhna_housing\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter response\"\n                  required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing.$error.required && formSubmitted\">Please provide a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"plah_comments\">Comments/Notes:</label>\n                <textarea ng-model=\"currentPolicy.comments\" id=\"plah_comments\" placeholder=\"Enter response\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"plah_comments\" rows=\"4\" ng-disabled=\"formReadOnly\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"90\" placeholder=\"Enter response\">\n                  </textarea>\n              </div>\n            </form>\n          </div>\n          <!-- Ministerial Approval Section -->\n          <div id=\"section-Ministerial Approval\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Ministerial Approval'}\">\n              <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Ministerial Approval</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <div\n              ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-warning\" style=\"margin-bottom: 12px;\">\n              This submission has been flagged as <strong>Needs Work</strong>. Please make your corrections and\n              resubmit.\n            </div>\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Grant ministerial\n                approval of residential developments that include, at a minimum,\n                15% affordable units if projects have 11 or more units, or that\n                exceed inclusionary or density bonus affordability requirements\n                and do not exceed 0.5 parking spaces per unit.\n              </span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" novalidate\n              ng-class=\"{'was-validated': formSubmitted}\">\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"mas_adopted_program_policy_link\">Link to adopted policy:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"mas_adopted_program_policy_link\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"mas_adopted_program_policy_link\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter URL\"\n                  type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\">Please enter a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"mas_jurisdiction-wide\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"mas_jurisdiction-wide\" name=\"mas_jurisdiction-wide\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.jurisdiction_wide\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction-wide.$error.required && formSubmitted\">Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"mas_applies_to_projects_11_units\">Does policy apply to all projects with 11 or more\n                  units?</label>\n                <select id=\"mas_applies_to_projects_11_units\" name=\"mas_applies_to_projects_11_units\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.applies_to_projects_11_units\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.applies_to_projects_11_units.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"mas_least_15_percent_local_inc\">Does policy apply to all projects with at least 15%\n                  affordable units <span class=\"bold-text\">OR</span> all projects whose share of affordable\n                  units exceeds local inclusionary zoning requirements and\n                  provides more affordable units or deeper affordability than\n                  required under state density bonus rules?</label>\n                <select id=\"mas_least_15_percent_local_inc\" name=\"mas_least_15_percent_local_inc\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.least_15_percent_local_inc\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.least_15_percent_local_inc.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"mas_policy_meets_toc_standards\">Does policy meet TOC Policy standards for income\n                  limits/affordability levels and the required affordability\n                  period, and identify a legal mechanism for enforcement?</label>\n                <select id=\"mas_policy_meets_toc_standards\" name=\"mas_policy_meets_toc_standards\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"mas_ministerial_app_park_max\">For projects granted ministerial approval, does the\n                  policy have parking maximums consistent with TOC\n                  Policy requirements?</label>\n                <select id=\"mas_ministerial_app_park_max\" name=\"mas_ministerial_app_park_max\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.ministerial_app_park_max\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.ministerial_app_park_max.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"mas_program_policy_terms\">Policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <textarea ng-model=\"currentPolicy.program_policy_terms\" id=\"mas_program_policy_terms\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"mas_program_policy_terms\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" placeholder=\"Enter response or URL\"\n                  type=\"text\" ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms.$error.required && formSubmitted\">Please enter a valid response or\n                  URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\"><label for=\"program_policy_terms_file_mase\">Upload Policy Terms\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left:0 !important;\">\n\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_mase\" id=\"program_policy_terms_file_mase\"\n                    name=\"program_policy_terms_file_mase\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_mase')\"><i\n                      ng-show=\"fileUploading_program_policy_terms_file_mase\" class=\"fa-solid fa-cog fa-spin\"></i> Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_mase')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"mas_program_policy_rhna_housing\">How does policy address jurisdiction's RHNA and/or\n                  other housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"mas_program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"mas_program_policy_rhna_housing\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter response\"\n                  required>\n                  </textarea>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"mas_comments\">Comments/Notes:</label>\n                <textarea ng-model=\"currentPolicy.comments\" id=\"mas_comments\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"mas_comments\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"90\" placeholder=\"Enter response\">\n                  </textarea>\n              </div>\n            </form>\n          </div>\n          <!-- Public/Community Land Trusts -->\n          <div id=\"section-Public/Community Land Trusts (Production)\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Public/Community Land Trusts (Production)'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Public/Community Land Trusts</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <div\n              ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-warning\" style=\"margin-bottom: 12px;\">\n              This submission has been flagged as <strong>Needs Work</strong>. Please make your corrections and\n              resubmit.\n            </div>\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Investments or policies\n                to expand the amount of land held by public- and non-profit\n                entities such as co-operatives, community land trusts, and land\n                banks with permanent affordability protections. <span class=\"underlined\">This policy may\n                  be used to fulfill either the housing production or preservation\n                  requirement, but not both.</span>\n              </span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" novalidate\n              ng-class=\"{'was-validated': formSubmitted}\">\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"pclt_adopted_program_policy_link\">Link to adopted policy:</label>\n                <textarea ng-model=\"currentPolicy.adopted_program_policy_link\" id=\"pclt_adopted_program_policy_link\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"pclt_adopted_program_policy_link\"\n                  placeholder=\"Enter URL\" type=\"text\" rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" ng-disabled=\"formReadOnly\"\n                  required>\n                      </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link.$error.required && formSubmitted\">Please enter a valid URL.\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"pclt_jurisdiction_wide\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"pclt_jurisdiction_wide\" name=\"pclt_jurisdiction_wide\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.jurisdiction_wide\"\n                  ng-disabled=\"formReadOnly\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide.$error.required && formSubmitted\">Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"pclt_policy_meets_toc_standards\">Does policy meet TOC Policy standards for income\n                  limits/affordability levels and the required affordability\n                  period, and identify a legal mechanism for enforcement?</label>\n                <select id=\"pclt_policy_meets_toc_standards\" name=\"pclt_policy_meets_toc_standards\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"pclt_program_policy_terms\">Policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <textarea ng-model=\"currentPolicy.program_policy_terms\" id=\"pclt_program_policy_terms\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"pclt_program_policy_terms\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" placeholder=\"Enter response or URL\"\n                  type=\"text\" ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms.$error.required && formSubmitted\">Please enter a valid response or\n                  URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('program_policy_terms')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\"><label for=\"program_policy_terms_file_pclt\">Upload Policy Terms\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_pclt\" id=\"program_policy_terms_file_pclt\"\n                    name=\"program_policy_terms_file_pclt\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_pclt')\"><i\n                      ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i> Upload File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_pclt')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"pclt_used_program_funds_select\">How will program funds be used?</label>\n                <select id=\"pclt_used_program_funds_select\" name=\"pclt_used_program_funds_select\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.used_program_funds_select\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"reserved\">\n                    Reserved for CLTs and/or cooperatives\n                  </option>\n                  <option value=\"used\">\n                    Used by jurisidiction or other public entities\n                  </option>\n                  <option value=\"both\">Both</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.used_program_funds_select.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"pclt_anticipated_funding_2026\">Amount of anticipated funding for four-year period ($):</label>\n                <input id=\"pclt_anticipated_funding_2026\" name=\"pclt_anticipated_funding_2026\" type=\"number\"\n                  placeholder=\"$\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.anticipated_funding_2026\" required />\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.anticipated_funding_2026.$error.number && formSubmitted\">Please provide a valid\n                  response.</div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"pclt_secured_funding_docs\">Documentation that jurisdiction has \"secured\n                  funding\" consistent with TOC Policy requirements, including identification of fund\n                  source(s):</label>\n                <textarea ng-model=\"currentPolicy.secured_funding_docs\" id=\"pclt_secured_funding_docs\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"pclt_secured_funding_docs\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" placeholder=\"Enter response or URL\"\n                  type=\"text\" ng-disabled=\"attachmentData['SecuredFunding'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.secured_funding_docs.$error.required && formSubmitted\">Please provide a valid\n                  URL or enter N/A.\n                </div>\n              </div>\n\n              <!-- File upload secured_funding_docs -->\n              <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('secured_funding_docs')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                <div class=\"col-lg-2\"><label for=\"secured_funding_docs_file_pclt\">Upload Secured Funding\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"secured_funding_docs_file_pclt\" id=\"secured_funding_docs_file_pclt\"\n                    name=\"secured_funding_docs_file_pclt\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_pclt')\"><i\n                      ng-show=\"fileUploading_secured_funding_docs_file_pclt\" class=\"fa-solid fa-cog fa-spin\"></i> Upload\n                    File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('secured_funding_docs_file_pclt')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"pclt_expected_fund_schedule_2026\">Schedule of expected funding allocated to the program:</label>\n                <textarea ng-model=\"currentPolicy.expected_fund_schedule_2026\" id=\"pclt_expected_fund_schedule_2026\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"pclt_expected_fund_schedule_2026\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" cols=\"63\"\n                  ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" placeholder=\"Enter response or URL\"\n                  type=\"text\" ng-disabled=\"attachmentData['ExpectedFunding'].isFileSelected || formReadOnly\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.expected_fund_schedule_2026.$error.required && formSubmitted\">Please provide a valid\n                  URL or enter N/A.</div>\n              </div>\n              <!-- File upload expected_fund_schedule_2026 -->\n              <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 40px\"\n                class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"padding-bottom:10px;\">\n                <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\"\n                  ng-click=\"removeFile('expected_fund_schedule_2026')\"><i ng-show=\"fileUploading\"\n                    class=\"fa-solid fa-cog fa-spin\"></i> Remove</button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                <div class=\"col-lg-2\"><label for=\"expected_fund_schedule_2026_file_pclt\">Upload Expected Fund\n                    Schedule Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                  <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_pclt\"\n                    id=\"expected_fund_schedule_2026_file_pclt\" name=\"expected_fund_schedule_2026_file_pclt\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\"\n                    ng-click=\"uploadFile('expected_fund_schedule_2026_file_pclt')\"><i\n                      ng-show=\"fileUploading_expected_fund_schedule_2026_file_pclt\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File</button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('expected_fund_schedule_2026_file_pclt')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"pclt_program_policy_rhna_housing\">How does policy address jurisdiction's RHNA and/or\n                  other housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\"currentPolicy.program_policy_rhna_housing\" id=\"pclt_program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"pclt_program_policy_rhna_housing\"\n                  rows=\"4\" style=\"width: 100%;\" style=\"width: 100%;\" placeholder=\"Enter response\"\n                  ng-disabled=\"formReadOnly\" required>\n                      </textarea>\n              </div>\n              <div class=\"form-item col-lg-12\" style=\"padding-top:15px;\">\n                <label for=\"pclt_comments\">Comments/Notes:</label>\n                <textarea ng-model=\"currentPolicy.comments\" id=\"pclt_comments\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"pclt_comments\" rows=\"4\"\n                  style=\"width: 100%;\" style=\"width: 100%;\" cols=\"90\" placeholder=\"Enter response\">\n                  </textarea>\n              </div>\n            </form>\n          </div>\n          <!-- Development Certainty and Streamlined Entitlement Process -->\n          <div id=\"section-Development Certainty and Streamlined Entitlement Process\" role=\"tabpanel\"\n            class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Development Certainty and Streamlined Entitlement Process'}\">\n           <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Development Certainty and Streamlined Entitlement Process</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <div\n              ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-warning\" style=\"margin-bottom: 12px;\">\n              This submission has been flagged as <strong>Needs Work</strong>. Please make your corrections and\n              resubmit.\n            </div>\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Include the vested\n                rights and five hearing limit provisions currently outlined in\n                SB330 (2019, Skinner) without a sunset date.</span>\n            </p>\n            <form class=\"row test-validation-styling\" name=\"housingForm\" novalidate\n              ng-class=\"{'was-validated': formSubmitted}\">\n            \n              \n              <p>Since MTC adopted the TOC Policy in September 2022, state law has changed and there is no longer a sunset date for the Housing Crisis Act of 2019, which was originally established by SB 330 (2019) and SB 8 (2021). Accordingly, state law now requires that local jurisdictions provide the vested rights and five hearing limit provisions outlined in SB330 (2019, Skinner) without a sunset date. Therefore, local jurisdictions can receive TOC Policy credit for Production Policy 7 by providing confirmation that the jurisdiction complies with state law. Jurisdictions do not need to adopt any additional local ordinances.</p>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"dcsep_adopted_protection_policy\">Does the jurisdiction comply with AB 130/SB 131?</span>\n                </label>\n                <select id=\"dcsep_adopted_protection_policy\" name=\"dcsep_adopted_protection_policy\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.adopted_protection_policy\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_protection_policy.$error.required && formSubmitted\">Please choose a valid\n                  response.</div>\n              </div>\n            </form>\n          </div>\n          <!-- Review and Submit -->\n          <div id=\"section-review-submit-housing\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': reviewAndSubmit}\">\n            <h2>Review and Submit Affordable Housing Production Policies</h2>\n            <p>\n              <span style=\"font-style: italic\">\n                Select policies below to submit to MTC for review.</span>\n            </p>\n\n            <form class=\"row\" name=\"housingForm\" style=\"margin-left:2px;\">\n              <div class=\"verification-container\" ng-repeat=\"item in currentlySelectedPolicies\">\n                <div class=\"form-check\">\n                  <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"include_in_submission_check_{{$index}}\"\n                    name=\"include_in_submission_check_{{$index}}\"\n                    ng-checked=\"(checkPolicy1 && checkPolicy1.housing_policy_name === item.housing_policy_name) || (checkPolicy2 && checkPolicy2.housing_policy_name === item.housing_policy_name)\"\n                    ng-model=\"item.include_in_submission\" ng-click=\"addToSubmissions(item)\"\n                    ng-disabled=\"(checkPolicy1.submitted === true && checkPolicy1.housing_policy_name === item.housing_policy_name) || \n                    (checkPolicy2.submitted === true && checkPolicy2.housing_policy_name === item.housing_policy_name)\">\n                  <label for=\"include_in_submission_check_{{$index}}\" class=\"form-check-label\"\n                    ng-class=\"{'boldFont': item.include_in_submission || checkPolicy1.housing_policy_name === item.housing_policy_name || checkPolicy2.housing_policy_name === item.housing_policy_name}\">\n                    {{item.housing_policy_name}}\n                  </label>\n                </div>\n                <div class=\"row align-items-center\"\n                  ng-show=\"(checkPolicy1 && checkPolicy1.housing_policy_name === item.housing_policy_name && checkPolicy1.submitted === true) || (checkPolicy2 && checkPolicy2.housing_policy_name === item.housing_policy_name && checkPolicy2.submitted === true)\">\n                  <div class=\"row\" style=\"padding-top:5px;padding-bottom:5px;\">\n                    <div class=\"col\">\n                      <div class=\"alert alert-success fade show\" role=\"alert\">\n                        This policy has been submitted and is under review.\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </form>\n          </div>\n        </div>\n        <submissionsectionsubmit></submissionsectionsubmit>\n      </div>\n    </div>\n  </div>\n  <div class=\"footer\" role=\"contentinfo\">\n    <sidebarfooter></sidebarfooter>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HousingProtectionComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _housing_protection = __webpack_require__(159);
	
	var _housing_protection2 = _interopRequireDefault(_housing_protection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var HousingProtectionComponent = exports.HousingProtectionComponent = function () {
	  /*@ngInject*/
	  function HousingProtectionComponent($state, $scope, $rootScope, fetch, lookup, FileUploadService, userService, $timeout, $http, baseConfigService, $stateParams) {
	    _classCallCheck(this, HousingProtectionComponent);
	
	    this.$scope = $scope;
	    var vm = this;
	    this.fetch = fetch;
	    this.$state = $state;
	    this.lookup = lookup;
	    this.$timeout = $timeout;
	    this.userService = userService;
	    this.baseConfigService = baseConfigService;
	    this.$stateParams = $stateParams;
	    this.FileUploadService = FileUploadService;
	    this.$http = $http;
	
	    $scope.adminUnlocked = false;
	    $scope.formsSubmitData = [];
	    $scope.currentlySelectedPolicies = [];
	    $scope.pdfUrls = {
	      'Tenant Anti-Harassment Protections': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Tenant_Anti-Harassment_Protections.pdf',
	      'Just Cause Eviction': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Just_Cause.pdf',
	      'No Net Loss and Right to Return to Demolished Homes': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/No_Net_Loss.pdf',
	      'Legal Assistance for Tenants': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Legal_Assistance.pdf',
	      'Foreclosure Assistance': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Foreclosure_Assistance.pdf',
	      'Rental Assistance Program': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Rental_Assistance.pdf',
	      'Rent Stabilization': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Rent_Stabilization.pdf',
	      'Preventing Displacement from Substandard Condition (Protection)': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Protection_Substandard_Conditions.pdf',
	      'Tenant Relocation Assistance': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Tenant_Relocation.pdf'
	    };
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.pendingChanges = false;
	    $scope.savemode = 'housing';
	    $scope.housingType = 'Protection';
	    $scope.policyNotesMapping = {
	      'Development Certainty and Streamlined Entitlement Process': '<strong>Note:</strong> Production Policy 3 (Affordable Housing Overlay Zones), Production Policy 5 (Ministerial Approval), and Production Policy 7 (Development Certainty and Streamlined Entitlement Process) are related and contain overlapping requirements. As a result, jurisdictions may only count one of these policies for the purpose of TOC compliance for production policies. However, if a jurisdiction implements all provisions from SB 330/SB 8 without a sunset date, then the jurisdiction meets the standards required by and can claim credit for both Production Policy 7 (Development Certainty and Streamlined Entitlement Process) and Protection Policy 2 (No Net Loss and Right to Return to Demolished Homes)',
	      'Affordable Housing Overlay Zone': '<strong>Note:</strong> Production Policy 3 (Affordable Housing Overlay Zones), Production Policy 5 (Ministerial Approval), and Production Policy 7 (Development Certainty and Streamlined Entitlement Process) are related and contain overlapping requirements. As a result, jurisdictions may only count one of these policies for the purpose of TOC compliance for production policies.',
	      'Affordable Housing Funding': '<strong>Note:</strong> A jurisdiction whose policy meets the minimum requirements above cannot also count this policy for credit for Production Policy 2 (Affordable Housing Funding). However, if a jurisdiction establishes a funding program that meets requirements for Production Policy 2, and if this program additionally has set asides for public/community land trusts that meet the funding listed in Appendix B, then the program can also receive credit toward Production Policy 6 (Public/Community Land Trusts). For example, a Tier A jurisdiction that has a production program with $2,000,000 in secured funding during the relevant four-year OBAG cycle would receive credit for both Production Policy 1 and Production Policy 6 if the program has a set aside for CLTs of $1,000,000, as these amounts meet the $1,000,000 four-year minimum for both policies.',
	      'Public/Community Land Trusts': '<strong>Note:</strong> A jurisdiction whose policy meets the minimum requirements above cannot also count this policy for credit for Production Policy 2 (Affordable Housing Funding). However, if a jurisdiction establishes a funding program that meets requirements for Production Policy 2, and if this program additionally has set asides for public/community land trusts that meet the funding listed in Appendix B, then the program can also receive credit toward Production Policy 6 (Public/Community Land Trusts). For example, a Tier A jurisdiction that has a production program with $2,000,000 in secured funding during the relevant four-year OBAG cycle would receive credit for both Production Policy 1 and Production Policy 6 if the program has a set aside for CLTs of $1,000,000, as these amounts meet the $1,000,000 four-year minimum for both policies.',
	      'Ministerial Approval': '<strong>Note:</strong> Production Policy 3 (Affordable Housing Overlay Zones), Production Policy 5 (Ministerial Approval), and Production Policy 7 (Development Certainty and Streamlined Entitlement Process) are related and contain overlapping requirements. As a result, jurisdictions may only count one of these policies for the purpose of TOC compliance for production policies.'
	    };
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.setPending = function () {
	      $scope.savemode = 'housing';
	      $scope.pendingChanges = true;
	    };
	
	    $scope.openPdf = function (item) {
	      var pdfUrl = $scope.pdfUrls[item.housing_policy_name];
	
	      if (pdfUrl) {
	        window.open(pdfUrl, '_blank');
	      } else {
	        console.error('PDF URL not found for policy: ' + item.housing_policy_name);
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.housingStatus) {
	        for (var i = 0; i < $scope.housingStatus.length; i++) {
	          if ($scope.housingStatus[i].housing_policy_name === $scope.currentPolicy.housing_policy_name) {
	            submission = $scope.housingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentPolicy && $scope.currentPolicy.housing_policy_name;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.housingStatus && $scope.currentPolicy && $scope.currentPolicy.housing_policy_name) {
	        var currentSubmission = _.find($scope.housingStatus, { housing_policy_name: $scope.currentPolicy.housing_policy_name });
	        if (currentSubmission && currentSubmission.submitted && currentSubmission.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('housingStatus', function () {
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm("Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.");
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.housingStatus) {
	        for (var i = 0; i < $scope.housingStatus.length; i++) {
	          if ($scope.housingStatus[i].housing_policy_name === $scope.currentPolicy.housing_policy_name) {
	            submission = $scope.housingStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error("No matching submission found to withdraw");
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem("api/data/submissions/update-status", payload).then(function () {
	        var matchingPolicy = $scope.currentlySelectedPolicies.find(function (p) {
	          return p.housing_policy_name === $scope.currentPolicy.housing_policy_name;
	        });
	        if (matchingPolicy) {
	          matchingPolicy.include_in_submission = false;
	        }
	        submission.submitted = false;
	        submission.status = null;
	
	        if ($scope.checkPolicy1 && $scope.checkPolicy1.submission_id === submission.submission_id) {
	          $scope.checkPolicy1 = null;
	        } else if ($scope.checkPolicy2 && $scope.checkPolicy2.submission_id === submission.submission_id) {
	          $scope.checkPolicy2 = null;
	        }
	
	        $scope.formsSubmitData = $scope.formsSubmitData.filter(function (p) {
	          return p.housing_policy_name !== $scope.currentPolicy.housing_policy_name;
	        });
	
	        $scope.submitType = 'Submit Housing Policies for Review (' + $scope.formsSubmitData.length + ')';
	
	        var policyName = $scope.currentPolicy.housing_policy_name;
	        var formId = $scope.currentPolicy.housing_form_id;
	        $scope.currentPolicy = { housing_policy_name: policyName, housing_form_id: formId };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	
	        $scope.formReadOnly = false;
	      }).catch(function (err) {
	        console.error("Withdraw failed:", err);
	        alert("There was an error withdrawing the submission. Please try again.");
	      });
	    };
	
	    $scope.addToSubmissions = function (policy) {
	      $scope.savemode = null;
	      if (_.filter($scope.formsSubmitData, { 'housing_policy_name': policy.housing_policy_name }).length === 1) {
	        $scope.formsSubmitData = _.remove($scope.formsSubmitData, function (n) {
	          return n.housing_policy_name !== policy.housing_policy_name;
	        });
	      } else {
	        $scope.formsSubmitData.push(policy);
	      }
	
	      $scope.submitmode = 'housing';
	      $scope.submitType = 'Submit Housing Policies for Review (' + $scope.formsSubmitData.length + ')';
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Housing ' + $scope.housingType + ' Policy').then(function (response) {
	        $scope.housingStatus = response.data;
	        $scope.checkPolicy1 = _.filter(response.data, {
	          submission_policy_name: 'Affordable Housing ' + $scope.housingType + ' Policy 1',
	          submitted: true
	        })[0];
	        console.log($scope.checkPolicy1);
	        $scope.checkPolicy2 = _.filter(response.data, {
	          submission_policy_name: 'Affordable Housing ' + $scope.housingType + ' Policy 2',
	          submitted: true
	        })[0];
	
	        if ($scope.currentlySelectedPolicies) {
	          $scope.currentlySelectedPolicies.forEach(function (policy) {
	            if ($scope.checkPolicy1 && $scope.checkPolicy1.submitted === true && $scope.checkPolicy1.housing_policy_name === policy.housing_policy_name || $scope.checkPolicy2 && $scope.checkPolicy2.submitted === true && $scope.checkPolicy2.housing_policy_name === policy.housing_policy_name) {
	              policy.include_in_submission = true;
	            } else {
	              policy.include_in_submission = false;
	            }
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.submitPolicies = function () {
	      $scope.saving = true;
	      var upsertData = [];
	
	      if ($scope.formsSubmitData.length === 2) {
	        for (var index = 0; index < $scope.formsSubmitData.length; index++) {
	          var counter = index + 1;
	          var data = $scope.formsSubmitData[index];
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === 'Affordable Housing ' + $scope.housingType + ' Policy ' + counter && element.sta_recid === data.sta_recid) {
	              element.housing_policy_name = data.housing_policy_name;
	              element.submitted = true;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        }
	      } else if ($scope.formsSubmitData.length === 1) {
	        var data = $scope.formsSubmitData[0];
	
	        if (!$scope.checkPolicy1) {
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === 'Affordable Housing ' + $scope.housingType + ' Policy 1' && element.sta_recid === data.sta_recid) {
	              element.housing_policy_id = data.housing_policy_id;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        } else if (!$scope.checkPolicy2) {
	          $scope.housingStatus.forEach(function (element) {
	            if (element.submission_policy_name === 'Affordable Housing ' + $scope.housingType + ' Policy 2' && element.sta_recid === data.sta_recid) {
	              element.housing_policy_id = data.housing_policy_id;
	              upsertData.push({
	                submission_id: element.submission_id,
	                housing_policy_id: data.housing_policy_id,
	                submitted: true
	              });
	            }
	          });
	        }
	      }
	
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.getSubmissionStatus();
	          $scope.$apply();
	        }, 3000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updatePoliciesJurisdiction = function (jurisdiction) {
	      $scope.currentlySelectedPolicies = [];
	      lookup.setJurisdiction(jurisdiction);
	      $scope.currentJurisdiction = jurisdiction;
	      $scope.getStationbyID();
	      $scope.getSubmissionStatus();
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	      $scope.getSubmissionStatus();
	      $scope.currentlySelectedPolicies = [];
	      $scope.loadingPolicies = true;
	      fetch.getAllItems('api/data/housing/forms/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + $scope.housingType).then(function (response) {
	
	        $scope.currentStation = response.data[0];
	
	        response.data.forEach(function (element) {
	          if (element.policy_selected) {
	            $scope.currentlySelectedPolicies.push(element);
	          }
	        });
	
	        var requestedPolicyName = $stateParams.policyName;
	        var policyToSelect = null;
	
	        if (requestedPolicyName && $scope.currentlySelectedPolicies.length > 0) {
	          policyToSelect = $scope.currentlySelectedPolicies.find(function (p) {
	            return p.housing_policy_name === requestedPolicyName;
	          });
	        }
	
	        if (policyToSelect) {
	          policyToSelect.active = true;
	          $scope.currentPolicy = policyToSelect;
	
	          $scope.setCurrentPolicy($scope.currentPolicy);
	        } else if ($scope.currentlySelectedPolicies.length > 0) {
	          $scope.currentlySelectedPolicies[0].active = true;
	          $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
	          $scope.setCurrentPolicy($scope.currentPolicy);
	        }
	
	        $scope.housingForms = response.data;
	        $scope.loadingPolicies = false;
	        $scope.getJurisdictionFundingTier($scope.currentSelectedStationId);
	      });
	    };
	
	    $scope.updateSelected = function (item) {
	      if ($scope.currentlySelectedPolicies.length > 0) {
	        $scope.currentlySelectedPolicies.forEach(function (element) {
	          element.active = false;
	        });
	      }
	
	      if (item.policy_selected) {
	        $scope.currentlySelectedPolicies.push(item);
	      } else {
	        for (var i = 0; i < $scope.currentlySelectedPolicies.length; i++) {
	          if ($scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
	            $scope.currentlySelectedPolicies.splice(i, 1);
	          }
	        }
	      }
	      if ($scope.currentlySelectedPolicies.length > 0) {
	        $scope.currentlySelectedPolicies[0].active = true;
	        $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
	      } else {
	        $scope.currentPolicy = {};
	      }
	      var upsertData = {
	        policy_selected: item.policy_selected,
	        housing_form_id: item.housing_form_id
	      };
	      fetch.updateItem('api/data/housing/forms/update', upsertData).then(function (response) {}).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.setCurrentPolicy = function (item) {
	      if (item === 'reviewAndSubmit') {
	        $scope.currentPolicy = {};
	        $scope.reviewAndSubmit = true;
	        $scope.note = '';
	      } else if (!item) {
	        $scope.reviewAndSubmit = false;
	        $scope.note = '<strong>Note:</strong> Complete two policies in this section for submission to MTC for review.';
	      } else {
	        $scope.reviewAndSubmit = false;
	        $scope.currentPolicy = item;
	
	        if ($scope.policyNotesMapping.hasOwnProperty(item.housing_policy_name)) {
	          $scope.note = $scope.policyNotesMapping[item.housing_policy_name];
	        } else {
	          $scope.note = '<strong>Note:</strong> A jurisdiction must enter information for all fields for each affordable housing production policy they are using to demonstrate TOC Policy compliance. If any field is not relevant to a jurisdiction, enter “N/A".';
	        }
	      }
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        } else {
	          $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
	        }
	
	        lookup.setCurrentStation($scope.currentSelectedStationId);
	
	        $scope.getStationbyID();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentPolicy = function (form) {
	      $scope.formSubmitted = true;
	      $scope.form = form;
	      $scope.saving = true;
	      if ($scope.currentPolicy.active) {
	        delete $scope.currentPolicy.active;
	      }
	
	      console.log('Saving currentPolicy:', angular.copy($scope.currentPolicy));
	
	      fetch.updateItem('api/data/housing/forms/update', $scope.currentPolicy).then(function (response) {
	
	        $scope.saving = false;
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.savemode = null;
	          $scope.saved = false;
	          $scope.currentPolicy.active = true;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getHousingForm = function () {
	      var currentPolicy = $scope.currentPolicy;
	
	      if (currentPolicy && currentPolicy.housing_form_id) {
	        fetch.getAllItems('api/data/getForm/' + currentPolicy.housing_form_id).then(function (response) {
	          $scope.currentPolicy = response.data[0];
	        }).catch(function (error) {
	          console.error('Error fetching currentPolicy for the current policy:', error);
	
	          $scope.currentPolicy = {};
	        });
	      } else {
	        console.warn('current policy is not defined or is missing a housing_form_id.');
	
	        $scope.currentPolicy = {};
	      }
	    };
	
	    $scope.selectedFile = null;
	
	    $scope.handleFileSelect = function (element) {
	      console.log(element);
	      $scope.setPending();
	      $scope.$apply(function () {
	        $scope.selectedFile = element.files[0];
	      });
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	
	      var file = $scope.selectedFile;
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      $scope['fileUploading_' + ngmodelfile] = true;
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	        $scope.selectedFile = null;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	        $scope['fileUploading_' + ngmodelfile] = false;
	      });
	    };
	
	    $scope.clearFile = function (ngmodelfile) {
	      var fileInput = document.getElementById(ngmodelfile);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope.selectedFile = null;
	      }
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'housing';
	      $scope.pendingChanges = true;
	    };
	
	    $scope.getJurisdictionFundingTier = function (station) {
	      if (station) {
	        $scope.loadingData = true;
	      }
	      fetch.getItem('api/data/housing/fundingtiers/' + $scope.currentJurisdiction, $scope.currentSelectedStationId).then(function (response) {
	        $scope.fundingLevels = response.data[0];
	        $scope.loadingData = false;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	  }
	
	  _createClass(HousingProtectionComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.housingForms = [];
	        _this.$scope.getJurisdictionFundingTier();
	        return _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'updateSelected',
	    value: function updateSelected(item) {
	      var _this3 = this;
	
	      if (this.$scope.currentlySelectedPolicies.length > 0) {
	        this.$scope.currentlySelectedPolicies.forEach(function (element) {
	          element.active = false;
	        });
	      }
	
	      if (item.policy_selected) {
	        this.$scope.currentlySelectedPolicies.push(item);
	      } else {
	        for (var i = 0; i < this.$scope.currentlySelectedPolicies.length; i++) {
	          if (this.$scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
	            this.$scope.currentlySelectedPolicies.splice(i, 1);
	          }
	        }
	      }
	      if (this.$scope.currentlySelectedPolicies.length > 0) {
	        this.$scope.currentlySelectedPolicies[0].active = true;
	        this.$scope.currentPolicy = this.$scope.currentlySelectedPolicies[0];
	      } else {
	        this.$scope.currentPolicy = {};
	      }
	      var upsertData = {
	        policy_selected: item.policy_selected,
	        housing_form_id: item.housing_form_id
	      };
	
	      this.fetch.updateItem('api/data/housing/forms/update', upsertData).then(function (response) {}).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this3.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this4 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this4.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this4.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this4.$scope.submissionSummary);
	          _this4.lookup.setSubmissionPolicies(_this4.$scope.submissionSummary);
	
	          _this4.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this4.$scope.densitySubmitted = _.filter(_this4.$scope.densitySubmissions, { submitted: true });
	          _this4.$scope.densityCompliant = _.filter(_this4.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this4.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this4.$scope.housingPolicySubmissions = _.union(_this4.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this4.$scope.housingPolicySubmitted = _.filter(_this4.$scope.housingPolicySubmissions, { submitted: true });
	          _this4.$scope.housingPolicyCompliant = _.filter(_this4.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this4.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this4.$scope.parkingSubmitted = _.filter(_this4.$scope.parkingSubmissions, { submitted: true });
	          _this4.$scope.parkingCompliant = _.filter(_this4.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this4.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this4.$scope.stationAccessSubmitted = _.filter(_this4.$scope.stationAccessSubmissions, { submitted: true });
	          _this4.$scope.stationAccessCompliant = _.filter(_this4.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return HousingProtectionComponent;
	}();
	
	;
	
	exports.default = angular.module('appApp.housing_protection', [uiRouter]).config(_housing_protection2.default).component('housingProtection', {
	  template: __webpack_require__(160),
	  controller: HousingProtectionComponent,
	  controllerAs: 'housingProtectionCtrl'
	}).name;

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('housing_protection', {
	    url: '/account/housing/housing_protection?jurisdiction&sta_recid&policyName',
	    template: '<housing-protection></housing-protection>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null,
	      policyName: null }
	  });
	};

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	module.exports = "<section\n  class=\"dashboard dashboard--page dashboard--page--submission dashboard--compliance dashboard--compliance--jurisdiction\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <maintocselection />\n      <div class=\"content container\">\n        <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <p>\n          To be consistent with the TOC Policy, a jurisdiction must adopt <span class=\"bold-text\">at least two</span>\n          affordable housing protection policies. Appendix A of the <a\n            href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC\n            Policy\n            Administrative Guidance</a> describes the 11 policy\n          options in more detail and outlines the minimum standards a\n          jurisdiction’s policy must meet to be consistent with the TOC Policy. You can also download a <a\n            href=\"https://dsa-public-files.s3.us-west-2.amazonaws.com/MTC_TOC_Policies_Checklist_v3.docx\">checklist</a>\n          that\n          summarizes the minimum standards for each policy.\n        </p>\n        <div class=\"section\">\n          <h2 class=\"icon icon--housing\">Housing Policy Options</h2>\n          <notificationmessages />\n          <selecthousingpolicies />\n        </div>\n        <nav aria-label=\"Policy Sections\" class=\"section-nav\">\n          <div class=\"menu--section-title\">In this section:</div>\n          <ul class=\"menu menu--section\" role=\"tablist\">\n            <li ng-repeat=\"item in currentlySelectedPolicies\" data-bs-toggle=\"tab\" class=\"menu-item menu-item--section\"\n              ng-class=\"{ 'active': item.active }\" ng-click=\"setCurrentPolicy(item)\">\n              <span class=\"section-number\">{{$index + 1}}.</span><a href=\"#\">{{\n                item.housing_policy_name }}</a>\n            </li>\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit-housing\"\n              class=\"menu-item menu-item--section\" ng-click=\"setCurrentPolicy('reviewAndSubmit')\">\n              <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n            </li>\n          </ul>\n          <note class=\"section-pin\" ng-if=\"note\" ng-bind-html=\"note\"></note>\n          <furtherguidance></furtherguidance>\n        </nav>\n        <div class=\"tab-content\">\n          <!-- Review and Submit -->\n          <div id=\"section-review-submit-housing\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': reviewAndSubmit}\">\n            <h2>Review and Submit Affordable Housing Protection Policies</h2>\n            <p>\n              <span style=\"font-style: italic\">\n                Select polices below to submit to MTC for review.</span>\n            </p>\n\n            <form class=\"row\" style=\"margin-left: 2px\">\n              <div class=\"verification-container\" ng-repeat=\"item in currentlySelectedPolicies\">\n                <div class=\"form-check\">\n                  <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"include_in_submission_check_{{$index}}\"\n                    name=\"include_in_submission_check_{{$index}}\" ng-model=\"item.include_in_submission\"\n                    ng-checked=\"(checkPolicy1 && checkPolicy1.housing_policy_name === item.housing_policy_name) || (checkPolicy2 && checkPolicy2.housing_policy_name === item.housing_policy_name)\"\n                    ng-click=\"addToSubmissions(item)\"\n                    ng-disabled=\"(checkPolicy1.submitted === true && checkPolicy1.housing_policy_name === item.housing_policy_name) || \n                    (checkPolicy2.submitted === true && checkPolicy2.housing_policy_name === item.housing_policy_name)\">\n                  <label class=\"form-check-label\" for=\"include_in_submission_check_{{$index}}\"\n                    ng-class=\"{'boldFont': item.include_in_submission || checkPolicy1.housing_policy_name === item.housing_policy_name || checkPolicy2.housing_policy_name === item.housing_policy_name}\">\n                    {{item.housing_policy_name}}\n                  </label>\n                </div>\n                <!-- <div class=\"row align-items-center\" ng-show=\"item.include_in_submission && !(checkPolicy1.housing_policy_name === item.housing_policy_name || checkPolicy2.housing_policy_name === item.housing_policy_name)\">\n                  <p>\n                    This affordable housing policy applies to all TOC areas in\n                    my jurisdiction.\n                  </p>\n                </div> -->\n                <div class=\"row align-items-center\"\n                  ng-show=\"checkPolicy1.housing_policy_name === item.housing_policy_name || checkPolicy2.housing_policy_name === item.housing_policy_name\">\n                  <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                    <div class=\"col\">\n                      <div class=\"alert alert-success fade show\" role=\"alert\">\n                        This policy has been submitted and is under review.\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Tenant Anti-Harassment Protections Section -->\n          <div id=\"section-Tenant-Anti-Harassment-Protections\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Tenant Anti-Harassment Protections'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Tenant Anti-Harassment Protections</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Policy or program that\n                grants tenants legal protection from unreasonable, abusive, or\n                coercive landlord behavior.\n              </span>\n            </p>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_tahp\">Link to adopted policy:</label>\n                <textarea ng-model=\" currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link_tahp\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_tahp\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter URL\" type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_tahp.$error.required && formSubmitted\">\n                  Please provide a valid URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_tahp\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_tahp\" name=\"jurisdiction_wide_tahp\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_tahp.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"harassing_behaviors_tahp\">Does policy define harassing behaviors, consistent with TOC\n                  Policy standards?</label>\n                <select id=\"harassing_behaviors_tahp\" name=\"harassing_behaviors_tahp\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.harassing_behaviors\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.harassing_behaviors_tahp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"civil_action_injunction_tahp\">Does policy allow jurisdiction and/or impacted tenant to\n                  bring a civil action or request an injunction?</label>\n                <select id=\"civil_action_injunction_tahp\" name=\"civil_action_injunction_tahp\"\n                  ng-model=\"currentPolicy.civil_action_injunction\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.civil_action_injunction_tahp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"landlord_penalties_violations_tahp\">Does policy establish penalties for landlords found to\n                  be in\n                  violation?</label>\n                <select id=\"landlord_penalties_violations_tahp\" name=\"landlord_penalties_violations_tahp\"\n                  ng-model=\"currentPolicy.landlord_penalties_violations\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.landlord_penalties_violations_tahp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"violation_ordinance_affirmative_defense_tahp\">Does policy define violation of ordinance as\n                  an affirmative\n                  defense for a tenant in an eviction proceeding?</label>\n                <select id=\"violation_ordinance_affirmative_defense_tahp\"\n                  name=\"violation_ordinance_affirmative_defense_tahp\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.violation_ordinance_affirmative_defense\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.violation_ordinance_affirmative_defense_tahp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"landlord_noticing_req_tahp\">Does policy establish noticing requirements for landlords,\n                  consistent with TOC Policy standards?</label>\n                <select id=\"landlord_noticing_req_tahp\" name=\"landlord_noticing_req_tahp\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.landlord_noticing_req\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.landlord_noticing_req_tahp.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_tahp\">Policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\"\n                  ng-model=\"currentPolicy.program_policy_terms\" id=\"program_policy_terms_tahp\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_tahp\" rows=\"4\"\n                  style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_tahp.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_tahp\">Upload Policy Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_tahp\" id=\"program_policy_terms_file_tahp\"\n                    name=\"program_policy_terms_file_tahp\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_tahp')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_tahp\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_tahp')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_tahp\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\" currentPolicy.program_policy_rhna_housing\" id=\"program_policy_rhna_housing_tahp\"\n                  placeholder=\"Enter response\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  name=\"program_policy_rhna_housing_tahp\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_tahp.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_tahp\">Comments/Notes:</label>\n                <!-- <input type=\"text\" placeholder=\"Enter your response here\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.comments\" /> -->\n                <textarea ng-model=\" currentPolicy.comments\" id=\"comments_tahp\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_tahp\" rows=\"4\"\n                  style=\"width:100%;\" placeholder=\"Enter response\">\n                  </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- 'Just Cause' Eviction Section -->\n          <div id=\"section-Just-Cause-Eviction\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Just Cause Eviction'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">\"Just Cause\" Eviction</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Defines the\n                circumstances for evictions, such as nonpayment of rent,\n                violation of lease terms, or permanent removal of a dwelling\n                from the rental market, with provisions that are more protective\n                of tenants than those established by\n                <a href=\"https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=201920200AB1482\" target=\"_blank\" rel=\"noopener noreferrer\">AB 1482\n                  (2019, Chiu)</a>.\n              </span>\n            </p>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_jce\">Link to adopted ordinance:</label>\n                <textarea ng-model=\" currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link_jce\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_jce\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_jce.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_jce\">Does ordinance apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_jce\" name=\"jurisdiction_wide_jce\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.jurisdiction_wide\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_jce.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"sunset_date_jce\">Does ordinance have a sunset date?\n                </label>\n                <select id=\"sunset_date_jce\" name=\"sunset_date_jce\" ng-model=\"currentPolicy.sunset_date\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.sunset_date_jce.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"notice_of_term_tenancy_jce\">\n                  Does ordinance require landlords to file notices of\n                  termination of tenancy with a designated local government\n                  agency?</label>\n                <select id=\"notice_of_term_tenancy_jce\" name=\"notice_of_term_tenancy_jce\"\n                  ng-model=\"currentPolicy.notice_of_term_tenancy\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.notice_of_term_tenancy_jce.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"file_notices_failure_jce\">Does ordinance make failure to file notices an affirmative\n                  defense for tenant in an eviction case?</label>\n                <select id=\"file_notices_failure_jce\" name=\"file_notices_failure_jce\"\n                  ng-model=\"currentPolicy.file_notices_failure\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.file_notices_failure_jce.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"state_wide_protection_exp_jce\">How does ordinance expand upon statewide protections?\n                </label>\n                <select id=\"state_wide_protection_exp_jce\" name=\"state_wide_protection_exp_jce\"\n                  ng-model=\"currentPolicy.state_wide_protection_exp\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"limit\">\n                    Limit legally recognized causes for eviction\n                  </option>\n                  <option value=\"expand\">\n                    Expand types of housing and tenancies covered\n                  </option>\n                  <option value=\"both\">Both</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.state_wide_protection_exp_jce.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_jce\">How does ordinance address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea ng-model=\" currentPolicy.program_policy_rhna_housing\" id=\"program_policy_rhna_housing_jce\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_jce\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_jce.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_jce\">Comments/Notes:</label>\n                <!-- <input type=\"text\" placeholder=\"Enter your response here\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.comments\" /> -->\n                <textarea ng-model=\" currentPolicy.comments\" id=\"comments_jce\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_jce\" rows=\"4\"\n                  style=\"width:100%;\" placeholder=\"Enter response\">\n                  </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- No Net Loss and Right to Return to Demolished Homes Section -->\n         <div id=\"section-No-Net-Loss-and-Right-to-Return-to-Demolished-Homes\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'No Net Loss and Right to Return to Demolished Homes'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">No Net Loss and Right to Return to Demolished Homes</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Include the no net loss\n                provisions currently outlined in <a\n                  href=\"https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=201920200SB330\">SB 330\n                  (2019, Skinner)</a> without\n                a sunset date. Require one-to-one replacement of units that\n                applies the same or a deeper level of affordability, the same\n                number of bedrooms and bathrooms, and comparable square footage\n                to the units demolished. Provide displaced tenants with right of\n                first refusal to rent new comparable units at the same rent as\n                demolished units.</span>\n            </p>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_nnlr\">Link to adopted policy:</label>\n                <!-- <input id=\"adopted_program_policy_link_nnlr\" name=\"adopted_program_policy_link_nnlr\" type=\"url\"\n                  placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.adopted_program_policy_link\" required /> -->\n                <textarea ng-model=\" currentPolicy.adopted_program_policy_link\" id=\"adopted_program_policy_link_nnlr\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_nnlr\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter URL\" type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_nnlr.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_nnlr\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_nnlr\" name=\"jurisdiction_wide_nnlr\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_nnlr.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"sunset_date_nnlr\">Does policy have a sunset date?\n                </label>\n                <select id=\"sunset_date_nnlr\" name=\"sunset_date_nnlr\" ng-model=\"currentPolicy.sunset_date\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.sunset_date_nnlr.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"rep_dem_units_nnlr\">Does policy require replacing all demolished units with units\n                  of equivalent size and replacing demolished protected units\n                  with units affordable to low-income households?</label>\n                <select id=\"rep_dem_units_nnlr\" name=\"rep_dem_units_nnlr\" ng-model=\"currentPolicy.rep_dem_units\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.rep_dem_units_nnlr.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"relocation_assist_disp_low_nnlr\">Does policy require providing displaced lower-income\n                  tenants\n                  with relocation assistance and right of first refusal to a\n                  comparable unit at an affordable rent?</label>\n                <select id=\"relocation_assist_disp_low_nnlr\" name=\"relocation_assist_disp_low_nnlr\"\n                  ng-model=\"currentPolicy.relocation_assist_disp_low\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.relocation_assist_disp_low_nnlr.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_nnlr\">Policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_nnlr\"\n                  name=\"program_policy_terms_nnlr\" type=\"url\" placeholder=\"Enter URL\" value=\"\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.program_policy_terms\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_nnlr\"\n                  ng-model=\" currentPolicy.program_policy_terms\" id=\"program_policy_terms_nnlr\"\n                  placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_nnlr\" rows=\"4\"\n                  style=\"width: 100%;\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_nnlr.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_nnlr\">Upload Policy Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_nnlr\" id=\"program_policy_terms_file_nnlr\"\n                    name=\"program_policy_terms_file_nnlr\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_nnlr')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_nnlr\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_nnlr')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_nnlr\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <!-- <input id=\"program_policy_rhna_housing_nnlr\" name=\"program_policy_rhna_housing_nnlr\" type=\"text\"\n                  placeholder=\"Enter your response here\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.program_policy_rhna_housing\" required /> -->\n                <textarea id=\"program_policy_terms_nnlr\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                  id=\"program_policy_rhna_housing_nnlr\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  placeholder=\"Enter response\" name=\"program_policy_rhna_housing_nnlr\" rows=\"4\" style=\"width: 100%;\"\n                  required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_nnlr.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_nnlr\">Comments/Notes:</label>\n                <!-- <input type=\"text\" placeholder=\"Enter your response here\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.comments\" /> -->\n                <textarea id=\"comments_nnlr\" ng-model=\" currentPolicy.comments\" id=\"comments_nnlr\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_nnlr\" rows=\"4\"\n                  style=\"width:100%;\" placeholder=\"Enter response\" ng-disabled=\"formReadOnly\">\n                  </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n          <!-- Legal Assistance for Tenants Section -->\n          <div id=\"section-Legal-Assistance-for-Tenants\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Legal Assistance for Tenants'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Legal Assistance for Tenants</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Investments or programs\n                that expand access to legal assistance for tenants threatened\n                with displacement. This could range from a “right to counsel” to\n                dedicated public funding for tenant legal assistance.\n              </span>\n            </p>\n            <div class=\"col\" ng-if=\"!loading && fundingLevels\">\n              <p>\n                <strong aria-label=\"Jurisdiction Name\">\n                  {{fundingLevels.jurisdiction}}\n                </strong>\n                is in\n                <strong aria-label=\"Funding Tier\">\n                  <span ng-if=\"fundingLevels && fundingLevels.funding_tier\">\n                    funding tier {{fundingLevels.funding_tier}}</span></strong>. It must demonstrate there is a program with funding above\n                <strong aria-label=\"Protection Requirement\">\n                  {{fundingLevels.protection_ | currency}}\n                </strong>\n                for this policy over a four-year period if it chooses to use this policy to achieve TOC Policy consistency. For more information about required funding amounts and sources, see section “Policy Options With Funding Commitments” of the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance</a>.\n              </p>\n            </div>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_lats\">Link to adopted program:</label>\n                <textarea id=\"adopted_program_policy_link_lats\" ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  id=\"adopted_program_policy_link_lats\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  placeholder=\"Enter response or URL\" type=\"text\" name=\"adopted_program_policy_link_lats\" rows=\"4\"\n                  style=\"width: 100%;\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_lats.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_lats\">Does program apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_lats\" name=\"jurisdiction_wide_lats\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_lats.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"policy_meets_toc_standards_lats\">Does program meet TOC Policy standards for eligibility\n                  criteria and services provided?</label>\n                <select id=\"policy_meets_toc_standards_lats\" name=\"policy_meets_toc_standards_lats\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards_lats.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_lats\">Program terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_lats\"\n                  ng-model=\" currentPolicy.program_policy_terms\" id=\"program_policy_terms_lats\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_lats\" rows=\"4\"\n                  placeholder=\"Enter response\" style=\"width: 100%;\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_lats.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\" ng-if=\"!formReadOnly\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_lats\">Upload Program Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_lats\" id=\"program_policy_terms_file_lats\"\n                    name=\"program_policy_terms_file_lats\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_lats')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_lats\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_lats')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"legal_services_org_contract_lats\">Documents demonstrating jurisdiction has contracted or\n                  will\n                  contract with one or more legal services organizations:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\" ng-disabled=\"formReadOnly\"\n                  id=\"legal_services_org_contract_lats\" ng-model=\" currentPolicy.legal_services_org_contract\"\n                  id=\"legal_services_org_contract\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"legal_services_org_contract\" rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\"\n                  required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.legal_services_org_contract_lats.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload legal_services_org_contract -->\n              <div ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.legal_services_org_contract)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.legal_services_org_contract}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('legal_services_org_contract')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"legal_services_org_contract_file_lats\">Upload Legal Services Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"legal_services_org_contract_file_lats\"\n                    id=\"legal_services_org_contract_file_lats\" name=\"legal_services_org_contract_file_lats\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('legal_services_org_contract_file_lats')\">\n                    <i ng-show=\"fileUploading_legal_services_org_contract_file_lats\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('legal_services_org_contract_file_lats')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"public_program_link_lats\">Link to website where program information is publicly\n                  available.</label>\n                <!-- <input type=\"url\" placeholder=\"Enter URL\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.public_program_link\" required /> -->\n                <textarea id=\"public_program_link_lats\" ng-model=\" currentPolicy.public_program_link\"\n                  id=\"public_program_link_lats\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  placeholder=\"Enter response or URL\" type=\"text\" name=\"public_program_link_lats\" rows=\"4\"\n                  style=\"width:100%;\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.public_program_link.$error.number && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"anticipated_funding_2026_lats\">Amount of anticipated funding for four-year period ($):</label>\n                <input type=\"number\" placeholder=\"$\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.anticipated_funding_2026\" ng-disabled=\"formReadOnly\" required />\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.anticipated_funding_2026_lats.$error.number && formSubmitted\">\n                  Please provide a valid value.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"secured_funding_docs_lats\">Documentation that jurisdiction has \"secured funding\"\n                  consistent with TOC Policy requirements, including\n                  identification of fund source(s):</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" id=\"secured_funding_docs_lats\"\n                  ng-model=\" currentPolicy.secured_funding_docs\" id=\"secured_funding_docs_lats\" ng-disabled=\"formReadOnly\"\n                  placeholder=\"Enter response\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"secured_funding_docs_lats\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.secured_funding_docs_lats.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload secured_funding_docs -->\n              <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('secured_funding_docs')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"secured_funding_docs_file_lats\">Upload Secured Funding Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"secured_funding_docs_file_lats\" id=\"secured_funding_docs_file_lats\"\n                    name=\"secured_funding_docs_file_lats\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_lats')\">\n                    <i ng-show=\"fileUploading_secured_funding_docs_file_lats\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('secured_funding_docs_file_lats')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"expected_fund_schedule_2026_lats\">Schedule of expected funding allocated to the program:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                  id=\"expected_fund_schedule_2026_lats\" ng-model=\" currentPolicy.expected_fund_schedule_2026\" ng-disabled=\"formReadOnly\"\n                  id=\"expected_fund_schedule_2026_lats\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"expected_fund_schedule_2026_lats\" rows=\"4\" cols=\"63\" placeholder=\"Enter response or URL\"\n                  type=\"text\" required>\n                  </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.expected_fund_schedule_2026_lats.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload expected_fund_schedule_2026 -->\n              <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('expected_fund_schedule_2026')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"expected_fund_schedule_2026_file_lats\">Upload Expected Fund Schedule Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_lats\"\n                    id=\"expected_fund_schedule_2026_file_lats\" name=\"expected_fund_schedule_2026_file_lats\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('expected_fund_schedule_2026_file_lats')\">\n                    <i ng-show=\"fileUploading_expected_fund_schedule_2026_file_lats\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('expected_fund_schedule_2026_file_lats')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_lats\">How does program address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea id=\"program_policy_rhna_housing_lats\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                  id=\"program_policy_rhna_housing_lats\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  placeholder=\"Enter response\" name=\"program_policy_rhna_housing_lats\" rows=\"4\" style=\"width: 100%;\"\n                  required>\n                  </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_lats\">Comments/Notes:</label>\n                <textarea id=\"comments_lats\" ng-model=\" currentPolicy.comments\" id=\"comments_lats\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_lats\" rows=\"4\"\n                  style=\"width:100%;\" placeholder=\"Enter response\">\n                  </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n\n              </div>\n            </form>\n          </div>\n          <!-- Foreclosure Assistance Section -->\n          <div id=\"section-Foreclosure-Assistance\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Foreclosure Assistance'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Foreclosure Assistance</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Provide a dedicated\n                funding source to support owner-occupied homeowners (up to 120%\n                of Area Median Income (AMI)) at-risk of foreclosure, including\n                direct financial assistance (e.g., mortgage assistance, property\n                tax delinquency, HOA dues, etc.), foreclosure prevention\n                counseling, legal assistance, and/or outreach.\n              </span>\n            </p>\n            <div class=\"col\" ng-if=\"!loading && fundingLevels\">\n              <p>\n                <strong aria-label=\"Jurisdiction Name\">\n                  {{fundingLevels.jurisdiction}}\n                </strong>\n                is in\n                <strong aria-label=\"Funding Tier\">\n                  <span ng-if=\"fundingLevels && fundingLevels.funding_tier\">\n                    funding tier {{fundingLevels.funding_tier}}</span></strong>. It must demonstrate there is a program with funding above\n                <strong aria-label=\"Protection Requirement\">\n                  {{fundingLevels.protection_ | currency}}\n                </strong>\n                for this policy over a four-year period if it chooses to use this policy to achieve TOC Policy consistency. For more information about required funding amounts and sources, see section “Policy Options With Funding Commitments” of the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance</a>.\n              </p>\n              <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"adopted_program_policy_link_fase\">Link to adopted program:</label>\n                  <!-- <input id=\"adopted_program_policy_link_fase\" name=\"adopted_program_policy_link_fase\" type=\"text\"\n                  placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.adopted_program_policy_link\" required /> -->\n                  <textarea id=\"adopted_program_policy_link_fase\" ng-model=\" currentPolicy.adopted_program_policy_link\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_fase\" ng-disabled=\"formReadOnly\"\n                    rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.adopted_program_policy_link_fase.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"jurisdiction_wide_fase\">Does program apply jurisdiction-wide?</label>\n                  <select id=\"jurisdiction_wide_fase\" name=\"jurisdiction_wide_fase\" ng-disabled=\"formReadOnly\"\n                    ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                    required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.jurisdiction_wide_fase.$error.required && formSubmitted\">\n                    Please choose a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"policy_meets_toc_standards_fase\">Does program meet TOC Policy standards for eligibility\n                    criteria and services provided?</label>\n                  <select id=\"policy_meets_toc_standards_fase\" name=\"policy_meets_toc_standards_fase\"\n                    ng-model=\"currentPolicy.policy_meets_toc_standards\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.policy_meets_toc_standards_fase.$error.required && formSubmitted\">\n                    Please choose a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-8\">\n                  <label for=\"program_policy_terms_fase\">Program terms if not in ordinance or documentation\n                    establishing program:</label>\n                  <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_fase\"\n                    ng-model=\" currentPolicy.program_policy_terms\" placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_fase\" rows=\"4\"\n                    style=\"width: 100%;\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.program_policy_terms_fase.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <!-- File upload program_policy_terms -->\n                <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 75px\"\n                  class=\"col-lg-1\">\n                  <b class=\"or-label\">OR</b>\n                </div>\n                <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                  style=\"padding-bottom: 10px\">\n                  <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                      ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                      Documentation</a></span>\n                  <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\">\n                    <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Remove\n                  </button>\n                </div>\n                <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                  <div class=\"col-lg-2\">\n                    <label for=\"program_policy_terms_file_fase\">Upload Program Terms Documentation</label>\n                  </div>\n                  <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                    <input type=\"file\" ng-model=\"program_policy_terms_file_fase\" id=\"program_policy_terms_file_fase\"\n                      name=\"program_policy_terms_file_fase\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                      onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                  </div>\n                  <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                    <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_fase')\">\n                      <i ng-show=\"fileUploading_program_policy_terms_file_fase\" class=\"fa-solid fa-cog fa-spin\"></i>\n                      Upload File\n                    </button>\n                    <button type=\"button\" class=\"button button--clear\"\n                      ng-click=\"clearFile('program_policy_terms_file_fase')\">\n                      Clear\n                    </button>\n                  </div>\n                </div>\n\n                <div class=\"form-item col-lg-8\">\n                  <label for=\"legal_services_org_contract_fase\">Documents demonstrating jurisdiction has contracted or\n                    will\n                    contract with one or more foreclosure assistance providers:</label>\n                  <textarea ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\" ng-disabled=\"formReadOnly\"\n                    id=\"legal_services_org_contract_fase\" ng-model=\" currentPolicy.legal_services_org_contract\"\n                    placeholder=\"Enter response\" onchange=\"angular.element(this).scope().setPending(this)\"\n                    name=\"legal_services_org_contract_fase\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.legal_services_org_contract_fase.$error.required && formSubmitted\">\n                    Please provide a valid response.\n                  </div>\n                </div>\n                <!-- File upload legal_services_org_contract -->\n                <div ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\" style=\"margin-top: 75px\"\n                  class=\"col-lg-1\">\n                  <b class=\"or-label\">OR</b>\n                </div>\n                <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.legal_services_org_contract)\"\n                  style=\"padding-bottom: 10px\">\n                  <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                      ng-href=\"{{currentPolicy.legal_services_org_contract}}\">Uploaded\n                      Documentation</a></span>\n                  <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('legal_services_org_contract')\">\n                    <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Remove\n                  </button>\n                </div>\n                <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                  ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\">\n                  <div class=\"col-lg-2\">\n                    <label for=\"legal_services_org_contract_file_fase\">Upload Contract Documentation</label>\n                  </div>\n                  <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                    <input type=\"file\" ng-model=\"legal_services_org_contract_file_fase\"\n                      id=\"legal_services_org_contract_file_fase\" name=\"legal_services_org_contract_file_fase\"\n                      accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                      onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                  </div>\n                  <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                    <button class=\"button button--attach\"\n                      ng-click=\"uploadFile('legal_services_org_contract_file_fase')\">\n                      <i ng-show=\"fileUploading_legal_services_org_contract_file_fase\"\n                        class=\"fa-solid fa-cog fa-spin\"></i>\n                      Upload File\n                    </button>\n                    <button type=\"button\" class=\"button button--clear\"\n                      ng-click=\"clearFile('legal_services_org_contract_file_fase')\">\n                      Clear\n                    </button>\n                  </div>\n                </div>\n\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"public_program_link_fase\">Link to website where program information is publicly\n                    available.</label>\n                  <textarea id=\"public_program_link_fase\" ng-model=\" currentPolicy.public_program_link\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"public_program_link_fase\" rows=\"4\"\n                    style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.public_program_link_fase.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-8\">\n                  <label for=\"secured_funding_docs_fase\">Documentation that jurisdiction has \"secured funding\"\n                    consistent with TOC Policy requirements, including\n                    identification of fund source(s):</label>\n                  <textarea ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" id=\"secured_funding_docs_fase\"\n                    ng-model=\" currentPolicy.secured_funding_docs\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"secured_funding_docs_fase\" rows=\"4\"\n                    style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.secured_funding_docs_fase.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <!-- File upload secured_funding_docs -->\n                <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 75px\"\n                  class=\"col-lg-1\">\n                  <b class=\"or-label\">OR</b>\n                </div>\n                <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                  style=\"padding-bottom: 10px\">\n                  <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                      ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded\n                      Documentation</a></span>\n                  <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('secured_funding_docs')\">\n                    <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Remove\n                  </button>\n                </div>\n                <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                  ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                  <div class=\"col-lg-2\">\n                    <label for=\"secured_funding_docs_file_fase\">Upload Secured Funding Documentation</label>\n                  </div>\n                  <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                    <input type=\"file\" ng-model=\"secured_funding_docs_file_fase\" id=\"secured_funding_docs_file_fase\"\n                      name=\"secured_funding_docs_file_fase\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                      onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                  </div>\n                  <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                    <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_fase')\">\n                      <i ng-show=\"fileUploading_secured_funding_docs_file_fase\" class=\"fa-solid fa-cog fa-spin\"></i>\n                      Upload File\n                    </button>\n                    <button type=\"button\" class=\"button button--clear\"\n                      ng-click=\"clearFile('secured_funding_docs_file_fase')\">\n                      Clear\n                    </button>\n                  </div>\n                </div>\n\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"anticipated_funding_2026_fase\">Amount of anticipated funding for four-year period ($):</label>\n                  <input id=\"anticipated_funding_2026_fase\" name=\"anticipated_funding_2026_fase\" type=\"number\"\n                    placeholder=\"$\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                    ng-model=\"currentPolicy.anticipated_funding_2026\" required />\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.anticipated_funding_2026_fase.$error.number && formSubmitted\">\n                    Please provide a valid value.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-8\">\n                  <label for=\"expected_fund_schedule_2026_fase\">Schedule of expected funding allocated to the program:</label>\n\n                  <textarea ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" \n                    id=\"expected_fund_schedule_2026_fase\" ng-model=\" currentPolicy.expected_fund_schedule_2026\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"expected_fund_schedule_2026_fase\"\n                    rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required\n                    ng-disabled=\"formReadOnly\">\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.expected_fund_schedule_2026_fase.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <!-- File upload expected_fund_schedule_2026 -->\n                <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 65px\"\n                  class=\"col-lg-1\">\n                  <b class=\"or-label\">OR</b>\n                </div>\n                <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                  style=\"padding-bottom: 10px\">\n                  <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                      ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded\n                      Documentation</a></span>\n                  <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('expected_fund_schedule_2026')\">\n                    <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Remove\n                  </button>\n                </div>\n                <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                  ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                  <div class=\"col-lg-2\">\n                    <label for=\"expected_fund_schedule_2026_file_fase\">Upload Expected Fund Schedule\n                      Documentation</label>\n                  </div>\n                  <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                    <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_fase\"\n                      id=\"expected_fund_schedule_2026_file_fase\" name=\"expected_fund_schedule_2026_file_fase\"\n                      accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                      onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                  </div>\n                  <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                    <button class=\"button button--attach\"\n                      ng-click=\"uploadFile('expected_fund_schedule_2026_file_fase')\">\n                      <i ng-show=\"fileUploading_expected_fund_schedule_2026_file_fase\"\n                        class=\"fa-solid fa-cog fa-spin\"></i>\n                      Upload File\n                    </button>\n                    <button type=\"button\" class=\"button button--clear\"\n                      ng-click=\"clearFile('expected_fund_schedule_2026_file_fase')\">\n                      Clear\n                    </button>\n                  </div>\n                </div>\n\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"program_policy_rhna_housing_fase\">How does program address jurisdiction's RHNA and/or\n                    other\n                    housing needs identified in the Housing Element?</label>\n                  <!-- <input id=\"program_policy_rhna_housing_fase\" name=\"program_policy_rhna_housing_fase\" type=\"text\"\n                  placeholder=\"Enter your response here\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.program_policy_rhna_housing\" required /> -->\n                  <textarea id=\"program_policy_rhna_housing_fase\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_fase\" ng-disabled=\"formReadOnly\"\n                    rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.program_policy_rhna_housing.$error.required && formSubmitted\">\n                    Please provide a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"comments_fase\">Comments/Notes:</label>\n                  <!-- <input id=\"comments_fase\" name=\"comments_fase\" type=\"text\" placeholder=\"Enter your response here\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.comments\" /> -->\n                  <textarea id=\"comments_fase\" ng-model=\" currentPolicy.comments\" placeholder=\"Enter response\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_fase\" rows=\"4\"\n                    style=\"width: 100%;\">\n                  </textarea>\n                  <div class=\"valid-feedback\">Looks good!</div>\n                </div>\n              </form>\n            </div>\n\n            <!-- Rental Assistance Program Section -->\n            <div id=\"section-Rental-Assistance-Program\" role=\"tabpanel\" class=\"section tab-pane\"\n              ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Rental Assistance Program'}\">\n              <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n                <h2 style=\"margin: 0; padding-right: 10px\">Rental Assistance Program</h2>\n                <statuspills ng-repeat=\"submission in housingStatus\"\n                  ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                  status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                  user-role=\"currentUser.role\">\n                </statuspills>\n              </div>\n              <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n                <!-- Admin: Unlock to Edit button (only when submitted) -->\n                <button\n                  ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                  class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                  style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                  <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                  {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n                </button>\n                <!-- Non-admin: Withdraw Submission button -->\n                <button\n                  ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                  class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                  <i class=\"fa-solid fa-rotate-left\"></i>\n                  Withdraw Submission\n                </button>\n              </div>\n              <!-- Admin unlocked confirmation -->\n              <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n                style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n                Form is unlocked for editing.\n              </div>\n              <!-- Non-admin read-only notice: submitted and not Needs Work -->\n              <div\n                ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n                This form has been submitted and is read-only. To make changes, click <strong>Withdraw\n                  Submission</strong>\n                above. You will need to resubmit after making your changes.\n              </div>\n              <!-- Non-admin editable notice: status is Needs Work -->\n              <p>\n                <span class=\"italics\">\n                  Description from TOC Policy Resolution: Provide a dedicated\n                  funding source and program for rental assistance to low-income\n                  households.</span>\n              </p>\n              <div class=\"col\" ng-if=\"!loading && fundingLevels\">\n                <p>\n                  <strong aria-label=\"Jurisdiction Name\">\n                    {{fundingLevels.jurisdiction}}\n                  </strong>\n                  is in\n                  <strong aria-label=\"Funding Tier\">\n                    <span ng-if=\"fundingLevels && fundingLevels.funding_tier\">\n                      funding tier {{fundingLevels.funding_tier}}</span></strong>. It must demonstrate there is a program with funding above\n                  <strong aria-label=\"Protection Requirement\">\n                    {{fundingLevels.protection_ | currency}}\n                  </strong>\n                  for this policy over a four-year period if it chooses to use this policy to achieve TOC Policy consistency. For more information about required funding amounts and sources, see section “Policy Options With Funding Commitments” of the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance</a>.\n                </p>\n              </div>\n              <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"adopted_program_policy_link_raps\">Link to adopted program:</label>\n                  <!-- <input id=\"adopted_program_policy_link_raps\" name=\"adopted_program_policy_link_raps\" type=\"text\"\n                  placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.adopted_program_policy_link\" required /> -->\n                  <textarea id=\"adopted_program_policy_link_raps\" ng-model=\" currentPolicy.adopted_program_policy_link\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_raps\"\n                    rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.adopted_program_policy_link_raps.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"jurisdiction_wide_raps\">Does program apply jurisdiction-wide?</label>\n                  <select id=\"jurisdiction_wide_raps\" name=\"jurisdiction_wide_raps\"\n                    ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                    ng-disabled=\"formReadOnly\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.jurisdiction_wide_raps.$error.required && formSubmitted\">\n                    Please choose a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"policy_meets_toc_standards_raps\">Does program meet TOC Policy standards for eligibility\n                    criteria and services provided?</label>\n                  <select id=\"policy_meets_toc_standards_raps\" name=\"policy_meets_toc_standards_raps\"\n                    ng-model=\"currentPolicy.policy_meets_toc_standards\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.policy_meets_toc_standards_raps.$error.required && formSubmitted\">\n                    Please choose a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-8\">\n                  <label for=\"program_policy_terms_raps\">Program terms if not in ordinance or documentation\n                    establishing policy:</label>\n                  <!-- <input ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_raps\"\n                  name=\"program_policy_terms_raps\" type=\"url\" placeholder=\"Enter URL\" value=\"\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.program_policy_terms\"\n                  ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected\" required /> -->\n                  <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_raps\"\n                    ng-model=\" currentPolicy.program_policy_terms\" placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_raps\" rows=\"4\"\n                    style=\"width: 100%;\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.program_policy_terms_raps.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <!-- File upload program_policy_terms -->\n                <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                  class=\"col-lg-1\">\n                  <b class=\"or-label\">OR</b>\n                </div>\n                <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                  style=\"padding-bottom: 10px\">\n                  <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                      ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                      Documentation</a></span>\n                  <button class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\" ng-if=\"!formReadOnly\">\n                    <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Remove\n                  </button>\n                </div>\n                <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                  ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                  <div class=\"col-lg-2\">\n                    <label for=\"program_policy_terms_file_raps\">Upload Program Terms Documentation</label>\n                  </div>\n                  <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                    <input type=\"file\" ng-model=\"program_policy_terms_file_raps\" id=\"program_policy_terms_file_raps\"\n                      name=\"program_policy_terms_file_raps\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                      onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                  </div>\n                  <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                    <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_raps')\">\n                      <i ng-show=\"fileUploading_program_policy_terms_file_raps\" class=\"fa-solid fa-cog fa-spin\"></i>\n                      Upload File\n                    </button>\n                    <button type=\"button\" class=\"button button--clear\"\n                      ng-click=\"clearFile('program_policy_terms_file_raps')\">\n                      Clear\n                    </button>\n                  </div>\n                </div>\n\n                <div class=\"form-item col-lg-8\">\n                  <label for=\"legal_services_org_contract_raps\">Documents demonstrating jurisdiction has contracted or\n                    will\n                    contract with one or more rental assistance providers:</label>\n                  <!-- <input ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\"\n                  id=\"legal_services_org_contract_raps\" name=\"legal_services_org_contract_raps\" type=\"text\"\n                  placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  ng-model=\"currentPolicy.legal_services_org_contract\"\n                  ng-disabled=\"attachmentData['LegalServices'].isFileSelected\" required /> -->\n                  <textarea ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\" ng-disabled=\"formReadOnly\"\n                    id=\"legal_services_org_contract_raps\" ng-model=\" currentPolicy.legal_services_org_contract\"\n                    placeholder=\"Enter response\" onchange=\"angular.element(this).scope().setPending(this)\"\n                    name=\"legal_services_org_contract_raps\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.legal_services_org_contract_raps.$error.required && formSubmitted\">\n                    Please provide a valid response.\n                  </div>\n                </div>\n                <!-- File upload legal_services_org_contract -->\n                <div ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\" style=\"margin-top: 65px\"\n                  class=\"col-lg-1\">\n                  <b class=\"or-label\">OR</b>\n                </div>\n                <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.legal_services_org_contract)\"\n                  style=\"padding-bottom: 10px\">\n                  <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                      ng-href=\"{{currentPolicy.legal_services_org_contract}}\">Uploaded\n                      Documentation</a></span>\n                  <button class=\"button button--attach\" ng-click=\"removeFile('legal_services_org_contract')\" ng-if=\"!formReadOnly\">\n                    <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Remove\n                  </button>\n                </div>\n                <div class=\"row\" style=\"padding-bottom: 20px\"\n                  ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\">\n                  <div class=\"col-lg-2\">\n                    <label for=\"legal_services_org_contract_file_raps\">Upload Rental Assistance Program Documentation</label>\n                  </div>\n                  <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                    <input type=\"file\" ng-model=\"legal_services_org_contract_file_raps\"\n                      id=\"legal_services_org_contract_file_raps\" name=\"legal_services_org_contract_file_raps\"\n                      accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                      onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                  </div>\n                  <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                    <button class=\"button button--attach\"\n                      ng-click=\"uploadFile('legal_services_org_contract_file_raps')\">\n                      <i ng-show=\"fileUploading_legal_services_org_contract_file_raps\"\n                        class=\"fa-solid fa-cog fa-spin\"></i>\n                      Upload File\n                    </button>\n                    <button type=\"button\" class=\"button button--clear\"\n                      ng-click=\"clearFile('legal_services_org_contract_file_raps')\">\n                      Clear\n                    </button>\n                  </div>\n                </div>\n\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"public_program_link_raps\">Link to website where program information is publicly\n                    available.</label>\n                  <textarea id=\"public_program_link_raps\" ng-model=\" currentPolicy.public_program_link\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"public_program_link_raps\" rows=\"4\"\n                    placeholder=\"Enter URL\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\"\n                    required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.public_program_link_raps.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-8\">\n                  <label for=\"secured_funding_docs_raps\">Documentation that jurisdiction has \"secured funding\"\n                    consistent with TOC Policy requirements, including\n                    identification of fund source(s):</label>\n                  <textarea ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" id=\"secured_funding_docs_raps\"\n                    ng-model=\" currentPolicy.secured_funding_docs\" placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"secured_funding_docs_raps\" rows=\"4\"\n                    style=\"width: 100%;\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.secured_funding_docs_raps.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <!-- File upload secured_funding_docs -->\n                <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 75px\"\n                  class=\"col-lg-1\">\n                  <b class=\"or-label\">OR</b>\n                </div>\n                <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                  style=\"padding-bottom: 10px\">\n                  <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                      ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded\n                      Documentation</a></span>\n                  <button  class=\"button button--attach\" ng-click=\"removeFile('secured_funding_docs')\" ng-if=\"!formReadOnly\">\n                    <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Remove\n                  </button>\n                </div>\n                <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                  ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                  <div class=\"col-lg-2\">\n                    <label for=\"secured_funding_docs_file_raps\">Upload Secure Funding Documentation</label>\n                  </div>\n                  <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                    <input type=\"file\" ng-model=\"secured_funding_docs_file_raps\" id=\"secured_funding_docs_file_raps\"\n                      name=\"secured_funding_docs_file_raps\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                      onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                  </div>\n                  <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                    <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_raps')\">\n                      <i ng-show=\"fileUploading_secured_funding_docs_file_raps\" class=\"fa-solid fa-cog fa-spin\"></i>\n                      Upload File\n                    </button>\n                    <button type=\"button\" class=\"button button--clear\"\n                      ng-click=\"clearFile('secured_funding_docs_file_raps')\">\n                      Clear\n                    </button>\n                  </div>\n                </div>\n\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"anticipated_funding_2026_raps\">Amount of anticipated funding for four-year period ($):</label>\n                  <input id=\"anticipated_funding_2026_raps\" name=\"anticipated_funding_2026_raps\" type=\"number\"\n                    placeholder=\"$\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                    ng-model=\"currentPolicy.anticipated_funding_2026\" required />\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.anticipated_funding_2026_raps.$error.number && formSubmitted\">\n                    Please provide a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-8\">\n                  <label for=\"expected_fund_schedule_2026_raps\">Schedule of expected funding allocated to the program:</label>\n                  <textarea ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" \n                    id=\"expected_fund_schedule_2026_raps\" ng-model=\" currentPolicy.expected_fund_schedule_2026\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"expected_fund_schedule_2026_raps\"\n                    rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required ng-disabled=\"formReadOnly\">\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.expected_fund_schedule_2026_raps.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <!-- File upload expected_fund_schedule_2026 -->\n                <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 65px\"\n                  class=\"col-lg-1\">\n                  <b class=\"or-label\">OR</b>\n                </div>\n                <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                  style=\"padding-bottom: 10px\">\n                  <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                      ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded\n                      Documentation</a></span>\n                  <button class=\"button button--attach\" ng-click=\"removeFile('expected_fund_schedule_2026')\" ng-if=\"!formReadOnly\">\n                    <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Remove\n                  </button>\n                </div>\n                <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                  ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                  <div class=\"col-lg-2\">\n                    <label for=\"expected_fund_schedule_2026_file_raps\">Upload Expected Fund Schedule\n                      Documentation</label>\n                  </div>\n                  <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                    <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_raps\"\n                      id=\"expected_fund_schedule_2026_file_raps\" name=\"expected_fund_schedule_2026_file_raps\"\n                      accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                      onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                  </div>\n                  <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                    <button class=\"button button--attach\"\n                      ng-click=\"uploadFile('expected_fund_schedule_2026_file_raps')\">\n                      <i ng-show=\"fileUploading_expected_fund_schedule_2026_file_raps\"\n                        class=\"fa-solid fa-cog fa-spin\"></i>\n                      Upload File\n                    </button>\n\n                    <button type=\"button\" class=\"button button--clear\"\n                      ng-click=\"clearFile('expected_fund_schedule_2026_file_raps')\">\n                      Clear\n                    </button>\n                  </div>\n                </div>\n\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"program_policy_rhna_housing_raps\">How does program address jurisdiction's RHNA and/or\n                    other\n                    housing needs identified in the Housing Element?</label>\n                  <textarea id=\"program_policy_rhna_housing_raps\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_raps\" ng-disabled=\"formReadOnly\"\n                    placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%;\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.program_policy_rhna_housing.$error.required && formSubmitted\">\n                    Please provide a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"comments_raps\">Comments/Notes:</label>\n                  <textarea id=\"comments_raps\" ng-model=\" currentPolicy.comments\" placeholder=\"Enter response\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_raps\" rows=\"4\"\n                    style=\"width: 100%;\">\n                  </textarea>\n                  <div class=\"valid-feedback\">Looks good!</div>\n                </div>\n              </form>\n            </div>\n            <!-- Rent Stabilization Section-->\n            <div id=\"section-Rent-Stabilization\" role=\"tabpanel\" class=\"section tab-pane\"\n              ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Rent Stabilization'}\">\n              <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n                <h2 style=\"margin: 0; padding-right: 10px\">Rent Stabilization</h2>\n                <statuspills ng-repeat=\"submission in housingStatus\"\n                  ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                  status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                  user-role=\"currentUser.role\">\n                </statuspills>\n              </div>\n              <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n                <!-- Admin: Unlock to Edit button (only when submitted) -->\n                <button\n                  ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                  class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                  style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                  <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                  {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n                </button>\n                <!-- Non-admin: Withdraw Submission button -->\n                <button\n                  ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                  class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                  <i class=\"fa-solid fa-rotate-left\"></i>\n                  Withdraw Submission\n                </button>\n              </div>\n              <!-- Admin unlocked confirmation -->\n              <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n                style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n                Form is unlocked for editing.\n              </div>\n              <!-- Non-admin read-only notice: submitted and not Needs Work -->\n              <div\n                ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n                This form has been submitted and is read-only. To make changes, click <strong>Withdraw\n                  Submission</strong>\n                above. You will need to resubmit after making your changes.\n              </div>\n              <!-- Non-admin editable notice: status is Needs Work -->\n              <p>\n                <span class=\"italics\">\n                  Description from TOC Policy Resolution: Restricts annual rent\n                  increases based upon a measure of inflation or other metric,\n                  with provisions exceeding those established by <a\n                    href=\"https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=201920200AB1482\">AB 1482\n                    (2019,\n                    Chiu)</a>.</span>\n              </p>\n              <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"adopted_program_policy_link_rs\">Link to adopted policy:</label>\n                  <textarea id=\"adopted_program_policy_link_rs\" ng-model=\" currentPolicy.adopted_program_policy_link\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_rs\" ng-disabled=\"formReadOnly\"\n                    rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter URL\" type=\"text\" required>\n                  </textarea>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.adopted_program_policy_link_rs.$error.required && formSubmitted\">\n                    Please enter a valid response or URL.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"jurisdiction_wide_rs\">Does policy apply jurisdiction-wide?</label>\n                  <select id=\"jurisdiction_wide_rs\" name=\"jurisdiction_wide_rs\" ng-disabled=\"formReadOnly\"\n                    ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                    required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.jurisdiction_wide_rs.$error.required && formSubmitted\">\n                    Please provide a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"sunset_date_rs\">Does policy have a sunset date?</label>\n                  <select id=\"sunset_date_rs\" name=\"sunset_date_rs\" ng-model=\"currentPolicy.sunset_date\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.sunset_date_rs.$error.required && formSubmitted\">\n                    Please choose a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"multifam_rent_housing_costa_rs\">Does policy apply to multifamily rental housing with three\n                    or\n                    more units while adhering to Costa-Hawkins Rental Housing\n                    Act?</label>\n                  <select id=\"multifam_rent_housing_costa_rs\" name=\"multifam_rent_housing_costa_rs\"\n                    ng-model=\"currentPolicy.multifam_rent_housing_costa\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.multifam_rent_housing_costa_rs.$error.required && formSubmitted\">\n                    Please choose a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"special_housing_type_exempt_rs\">Does policy allow exemptions for special housing\n                    types?</label>\n                  <select id=\"special_housing_type_exempt_rs\" name=\"special_housing_type_exempt_rs\"\n                    ng-model=\"currentPolicy.special_housing_type_exempt\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.special_housing_type_exempt_rs.$error.required && formSubmitted\">\n                    Please choose a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"max_annual_rent_inc_limit_rs\">Does policy limit maximum annual rent increases to be less\n                    than those allowed under state law?</label>\n                  <select id=\"max_annual_rent_inc_limit_rs\" name=\"max_annual_rent_inc_limit_rs\"\n                    ng-model=\"currentPolicy.max_annual_rent_inc_limit\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.max_annual_rent_inc_limit_rs.$error.required && formSubmitted\">\n                    Please choose a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"enforce_mech_rent_inc_dispute_rs\">Does policy have an enforcement mechanism (such as a\n                    rent\n                    board or administrative hearing) whereby tenants can dispute\n                    rent increases that exceed legally allowed maximums?</label>\n                  <select id=\"enforce_mech_rent_inc_dispute_rs\" name=\"enforce_mech_rent_inc_dispute_rs\"\n                    ng-model=\"currentPolicy.enforce_mech_rent_inc_dispute\" ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"form.enforce_mech_rent_inc_dispute_rs.$error.required && formSubmitted\">\n                    Please choose a valid response.\n                  </div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"program_policy_rhna_housing_rs\">How does policy address jurisdiction's RHNA and/or other\n                    housing needs identified in the Housing Element?</label>\n                  <!-- <input id=\"program_policy_rhna_housing_rs\" name=\"program_policy_rhna_housing_rs\" type=\"text\"\n                  placeholder=\"Enter your response here\" ng-model=\"program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required /> -->\n                  <textarea id=\"program_policy_rhna_housing_rs\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_rs\" ng-disabled=\"formReadOnly\"\n                    rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\" required>\n                  </textarea>\n                  <div class=\"valid-feedback\">Looks good!</div>\n                </div>\n                <div class=\"form-item col-lg-12\">\n                  <label for=\"comments_rs\">Comments/Notes:</label>\n                  <!-- <input type=\"text\" ng-model=\"currentPolicy.comments\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" placeholder=\"Enter your response here\" /> -->\n                  <textarea id=\"comments_rs\" ng-model=\" currentPolicy.comments\" ng-disabled=\"formReadOnly\n                    onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_rs\" rows=\"4\"\n                    style=\"width:100%\" placeholder=\"Enter response\">\n                  </textarea>\n                  <div class=\"valid-feedback\">Looks good!</div>\n                </div>\n              </form>\n            </div>\n\n\n\n\n          </div>\n          <!-- Rental Assistance Program Section -->\n          <div id=\"section-Rental-Assistance-Program\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Rental Assistance Program'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Rental Assistance Program</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Provide a dedicated\n                funding source and program for rental assistance to low-income\n                households.</span>\n            </p>\n            <div class=\"col\" ng-if=\"fundingLevels\">\n              <p>\n                <strong aria-label=\"Jurisdiction Name\">\n                  {{fundingLevels.jurisdiction}}\n                </strong>\n                is in\n                <strong aria-label=\"Funding Tier\">\n                  <span ng-if=\"fundingLevels && fundingLevels.funding_tier\">\n                    funding tier {{fundingLevels.funding_tier}}\n                  </span>\n                  <span ng-if=\"!fundingLevels || !fundingLevels.funding_tier\">\n                    *funding tier not available for this jurisdiction*\n                  </span></strong>. It must provide\n                <strong aria-label=\"Protection Requirement\">\n                  {{fundingLevels.protection_ | currency}}\n                </strong>\n                for this policy over a four-year period if it chooses to use this policy to achieve TOC Policy consistency.For more information about required funding amounts and sources, see section “Policy Options With Funding Commitments” of the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance</a>.\n              </p>\n            </div>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_raps\">Link to adopted program:</label>\n                <!-- <input id=\"adopted_program_policy_link_raps\" name=\"adopted_program_policy_link_raps\" type=\"text\"\n                       placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.adopted_program_policy_link\" required /> -->\n                <textarea id=\"adopted_program_policy_link_raps\" ng-model=\" currentPolicy.adopted_program_policy_link\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_raps\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_raps.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_raps\">Does program apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_raps\" name=\"jurisdiction_wide_raps\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_raps.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"policy_meets_toc_standards_raps\">Does program meet TOC Policy standards for eligibility\n                  criteria and services provided?</label>\n                <select id=\"policy_meets_toc_standards_raps\" name=\"policy_meets_toc_standards_raps\"\n                  ng-model=\"currentPolicy.policy_meets_toc_standards\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.policy_meets_toc_standards_raps.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_raps\">Program terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_raps\"\n                       name=\"program_policy_terms_raps\" type=\"url\" placeholder=\"Enter URL\" value=\"\"\n                       onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.program_policy_terms\"\n                       ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_raps\"\n                  ng-model=\" currentPolicy.program_policy_terms\" placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_raps\" rows=\"4\"\n                  style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_raps.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_raps\">Upload Program Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_raps\" id=\"program_policy_terms_file_raps\"\n                    name=\"program_policy_terms_file_raps\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_raps')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_raps\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_raps')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"legal_services_org_contract_raps\">Documents demonstrating jurisdiction has contracted or\n                  will\n                  contract with one or more rental assistance providers:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\"\n                       id=\"legal_services_org_contract_raps\" name=\"legal_services_org_contract_raps\" type=\"text\"\n                       placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.legal_services_org_contract\"\n                       ng-disabled=\"attachmentData['LegalServices'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\"\n                  id=\"legal_services_org_contract_raps\" ng-model=\" currentPolicy.legal_services_org_contract\"\n                  placeholder=\"Enter response\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  name=\"legal_services_org_contract_raps\" rows=\"4\" style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.legal_services_org_contract_raps.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <!-- File upload legal_services_org_contract -->\n              <div ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.legal_services_org_contract)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.legal_services_org_contract}}\">Uploaded\n                    Documentation</a></span>\n                <button class=\"button button--attach\" ng-click=\"removeFile('legal_services_org_contract')\" ng-if=\"!formReadOnly\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.legal_services_org_contract)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"legal_services_org_contract_file_raps\">Upload Legal Services Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"legal_services_org_contract_file_raps\"\n                    id=\"legal_services_org_contract_file_raps\" name=\"legal_services_org_contract_file_raps\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('legal_services_org_contract_file_raps')\">\n                    <i ng-show=\"fileUploading_legal_services_org_contract_file_raps\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('legal_services_org_contract_file_raps')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"public_program_link_raps\">Link to website where program information is publicly\n                  available.</label>\n                <!-- <input id=\"public_program_link_raps\" name=\"public_program_link_raps\" type=\"text\" placeholder=\"Enter URL\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.public_program_link\"\n                       required /> -->\n                <textarea id=\"public_program_link_raps\" ng-model=\" currentPolicy.public_program_link\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"public_program_link_raps\" rows=\"4\"\n                  placeholder=\"Enter URL\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.public_program_link_raps.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"secured_funding_docs_raps\">Documentation that jurisdiction has \"secured funding\"\n                  consistent with TOC Policy requirements, including\n                  identification of fund source(s):</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" id=\"secured_funding_docs_raps\"\n                       name=\"secured_funding_docs_raps\" type=\"url\" placeholder=\"Enter URL\" value=\"\"\n                       onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.secured_funding_docs\"\n                       ng-disabled=\"attachmentData['SecuredFunding'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" id=\"secured_funding_docs_raps\"\n                  ng-model=\" currentPolicy.secured_funding_docs\" placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"secured_funding_docs_raps\" rows=\"4\"\n                  style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.secured_funding_docs_raps.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload secured_funding_docs -->\n              <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('secured_funding_docs')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"secured_funding_docs_file_raps\">Upload Secure Funding Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"secured_funding_docs_file_raps\" id=\"secured_funding_docs_file_raps\"\n                    name=\"secured_funding_docs_file_raps\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_raps')\">\n                    <i ng-show=\"fileUploading_secured_funding_docs_file_raps\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('secured_funding_docs_file_raps')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"anticipated_funding_2026_raps\">Amount of anticipated funding for 2026-2030:</label>\n                <input id=\"anticipated_funding_2026_raps\" name=\"anticipated_funding_2026_raps\" type=\"number\"\n                  placeholder=\"$\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.anticipated_funding_2026\" required />\n                <!-- <textarea id=\"anticipated_funding_2026_raps\" ng-model=\" currentPolicy.anticipated_funding_2026\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" name=\"anticipated_funding_2026_raps\"\n                       rows=\"4\" style=\"width: 100%;\" required>\n                       </textarea> -->\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.anticipated_funding_2026_raps.$error.number && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"expected_fund_schedule_2026_raps\">Schedule of expected funding allocated to the program for\n                  2026-2030:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                       id=\"expected_fund_schedule_2026_raps\" name=\"expected_fund_schedule_2026_raps\" type=\"url\"\n                       placeholder=\"Enter URL\" onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.expected_fund_schedule_2026\"\n                       ng-disabled=\"attachmentData['ExpectedFunding'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                  id=\"expected_fund_schedule_2026_raps\" ng-model=\" currentPolicy.expected_fund_schedule_2026\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"expected_fund_schedule_2026_raps\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.expected_fund_schedule_2026_raps.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload expected_fund_schedule_2026 -->\n              <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('expected_fund_schedule_2026')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"expected_fund_schedule_2026_file_raps\">Upload Expected Fund Schedule Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_raps\"\n                    id=\"expected_fund_schedule_2026_file_raps\" name=\"expected_fund_schedule_2026_file_raps\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('expected_fund_schedule_2026_file_raps')\">\n                    <i ng-show=\"fileUploading_expected_fund_schedule_2026_file_raps\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('expected_fund_schedule_2026_file_raps')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_raps\">How does program address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <!-- <input id=\"program_policy_rhna_housing_raps\" name=\"program_policy_rhna_housing_raps\" type=\"text\"\n                       placeholder=\"Enter your response here\" onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.program_policy_rhna_housing\" /> -->\n                <textarea id=\"program_policy_rhna_housing_raps\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_raps\" ng-disabled=\"formReadOnly\"\n                  placeholder=\"Enter response\" rows=\"4\" style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_raps\">Comments/Notes:</label>\n                <!-- <input id=\"comments_raps\" name=\"comments_raps\" type=\"text\" placeholder=\"Enter your response here\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.comments\" /> -->\n                <textarea id=\"comments_raps\" ng-model=\" currentPolicy.comments\" placeholder=\"Enter response\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_raps\" rows=\"4\"\n                  style=\"width: 100%;\">\n                       </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n          <!-- Rent Stabilization Section-->\n          <div id=\"section-Rent-Stabilization\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Rent Stabilization'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Rent Stabilization</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Restricts annual rent\n                increases based upon a measure of inflation or other metric,\n                with provisions exceeding those established by <a\n                  href=\"https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=201920200AB1482\" target=\"_blank\" rel=\"noopener noreferrer\">AB 1482\n                  (2019,\n                  Chiu)</a>.</span>\n            </p>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_rs\">Link to adopted policy:</label>\n                <!-- <input id=\"adopted_program_policy_link_rs\" name=\"adopted_program_policy_link_rs\" type=\"text\"\n                       ng-model=\"currentPolicy.adopted_program_policy_link\" placeholder=\"Enter URL\" value=\"\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required /> -->\n                <textarea id=\"adopted_program_policy_link_rs\" ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_rs\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_rs.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_rs\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_rs\" name=\"jurisdiction_wide_rs\" ng-model=\"currentPolicy.jurisdiction_wide\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_rs.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"sunset_date_rs\">Does policy have a sunset date?</label>\n                <select id=\"sunset_date_rs\" name=\"sunset_date_rs\" ng-model=\"currentPolicy.sunset_date\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\"  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.sunset_date_rs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"multifam_rent_housing_costa_rs\">Does policy apply to multifamily rental housing with three\n                  or\n                  more units while adhering to Costa-Hawkins Rental Housing\n                  Act?</label>\n                <select id=\"multifam_rent_housing_costa_rs\" name=\"multifam_rent_housing_costa_rs\"\n                  ng-model=\"currentPolicy.multifam_rent_housing_costa\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.multifam_rent_housing_costa_rs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"special_housing_type_exempt_rs\">Does policy allow exemptions for special housing\n                  types?</label>\n                <select id=\"special_housing_type_exempt_rs\" name=\"special_housing_type_exempt_rs\"\n                  ng-model=\"currentPolicy.special_housing_type_exempt\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.special_housing_type_exempt_rs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"max_annual_rent_inc_limit_rs\">Does policy limit maximum annual rent increases to be less\n                  than those allowed under state law?</label>\n                <select id=\"max_annual_rent_inc_limit_rs\" name=\"max_annual_rent_inc_limit_rs\"\n                  ng-model=\"currentPolicy.max_annual_rent_inc_limit\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.max_annual_rent_inc_limit_rs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"enforce_mech_rent_inc_dispute_rs\">Does policy have an enforcement mechanism (such as a rent\n                  board or administrative hearing) whereby tenants can dispute\n                  rent increases that exceed legally allowed maximums?</label>\n                <select id=\"enforce_mech_rent_inc_dispute_rs\" name=\"enforce_mech_rent_inc_dispute_rs\"\n                  ng-model=\"currentPolicy.enforce_mech_rent_inc_dispute\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.enforce_mech_rent_inc_dispute_rs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_rs\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <!-- <input id=\"program_policy_rhna_housing_rs\" name=\"program_policy_rhna_housing_rs\" type=\"text\"\n                       placeholder=\"Enter your response here\" ng-model=\"program_policy_rhna_housing\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required /> -->\n                <textarea id=\"program_policy_rhna_housing_rs\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_rs\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\" required>\n                       </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_rs\">Comments/Notes:</label>\n                <!-- <input type=\"text\" ng-model=\"currentPolicy.comments\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" placeholder=\"Enter your response here\" /> -->\n                <textarea id=\"comments_rs\" ng-model=\" currentPolicy.comments\" ng-disabled=\"formReadOnly\" \n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_rs\" rows=\"4\"\n                  style=\"width:100%;\" placeholder=\"Enter response\">\n                       </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Preventing Displacement from Substandard Conditions and Associated Code Enforcement Activities Section -->\n          <div\n            id=\"section-Preventing-Displacement-from-Substandard-Conditions-and-Associated-Code-Enforcement-Activities\"\n            role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.type === 'Protection' && currentPolicy.housing_policy_name === 'Preventing Displacement from Substandard Conditions and Associated Code Enforcement Activities'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Preventing Displacement from Substandard Conditions and\n                Associated\n                Code Enforcement Activities (Protection)</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Policies, programs, or\n                procedures designed to minimize the risk of displacement caused\n                by substandard conditions including through local code\n                enforcement activities. This may include proactive rental\n                inspection programs and assistance to landlords for property\n                improvements in exchange for anti-displacement commitments.\n                <span class=\"underlined\">This policy may be used to fulfill either the housing\n                  preservation or protection requirement, but not both.</span></span>\n            </p>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_pdsc\">Link to adopted program/policy:</label>\n                <!-- <input id=\"adopted_program_policy_link_pdsc\" name=\"adopted_program_policy_link_pdsc\" type=\"url\"\n                       ng-model=\"currentPolicy.adopted_program_policy_link\" placeholder=\"Enter URL\" value=\"\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required /> -->\n                <textarea id=\"adopted_program_policy_link_pdsc\" ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_pdsc\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_pdsc.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_pdsc\">Does program/policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_pdsc\" name=\"jurisdiction_wide_pdsc\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_pdsc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"subst_condition_program_type_pdsc\">Type of program/policy:</label>\n                <select id=\"subst_condition_program_type_pdsc\" name=\"subst_condition_program_type_pdsc\"\n                  ng-model=\"currentPolicy.subst_condition_program_type\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"grants\">Grants or interest-free loans</option>\n                  <option value=\"escrow\">Rental escrow program</option>\n                  <option value=\"tenant\">\n                    Requires tenant habitability plan\n                  </option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.subst_condition_program_type_pdsc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"rent_post_repairs_existing_tenant_pdsc\"><span class=\"bold-text\">Grants/Loans:</span> Does\n                  program/policy require landlords\n                  to\n                  continue renting to the existing tenant after repairs are\n                  complete with reasonable limits on rent increases for that\n                  tenant?</label>\n                <select id=\"rent_post_repairs_existing_tenant_pdsc\" name=\"rent_post_repairs_existing_tenant_pdsc\"\n                  ng-model=\"currentPolicy.rent_post_repairs_existing_tenant\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.rent_post_repairs_existing_tenant_pdsc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"rent_post_repairs_existing_tenant_pdsc\"><span class=\"bold-text\">Grants/Loans:</span> Is the\n                  landlord required to complete a tenant habitability plan prior to\n                  making repairs?</label>\n                <select id=\"landlord_tenant_hab_plan_pdsc\" name=\"landlord_tenant_hab_plan_pdsc\"\n                  ng-model=\"currentPolicy.landlord_tenant_hab_plan\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.landlord_tenant_hab_plan_pdsc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"tenant_red_rent_habit_issues_pdsc\"><span class=\"bold-text\">Escrow:</span> Does\n                  program/policy reduce\n                  rent for tenants experiencing\n                  persistent habitability issues and define circumstances in\n                  which a tenant can safely withhold or reduce rent without fear\n                  of eviction?</label>\n                <select id=\"tenant_red_rent_habit_issues_pdsc\" name=\"tenant_red_rent_habit_issues_pdsc\"\n                  ng-model=\"currentPolicy.tenant_red_rent_habit_issues\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.tenant_red_rent_habit_issues_pdsc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"landlord_acc_escrow_funds_pdsc\"><span class=\"bold-text\">Escrow:</span> Does program/policy\n                  limit landlord access to funds\n                  in\n                  escrow solely for repairs, tenant relocation assistance, and\n                  other qualifying expenses?</label>\n                <select id=\"landlord_acc_escrow_funds_pdsc\" name=\"landlord_acc_escrow_funds_pdsc\"\n                  ng-model=\"currentPolicy.landlord_acc_escrow_funds\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.landlord_acc_escrow_funds_pdsc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"landlord_tenant_hab_plan_pdsc_esc\"><span class=\"bold-text\">Escrow:</span> Is the landlord\n                  required to complete a tenant habitability plan prior to making\n                  repairs?</label>\n                <select id=\"landlord_acc_escrow_funds_pdsc_esc\" name=\"landlord_tenant_hab_plan_pdsc_esc\"\n                  ng-model=\"currentPolicy.landlord_tenant_hab_plan\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"N/A\">N/A</option>\n                  <option value=\"Yes\">Yes</option>\n                  <option value=\"No\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.landlord_tenant_hab_plan_pdsc_esc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"subst_condition_tenant_hab_pdsc\"><span class=\"bold-text\">Tenant Habitability Plan:</span> As\n                  part of permitting process for\n                  repairs to address code issues, does program/policy require\n                  landlords to complete a tenant habitability plan that\n                  describes how the landlord will maintain habitability for\n                  tenant and any adjacent units while repairs are being\n                  performed?\n                </label>\n                <select id=\"subst_condition_tenant_hab_pdsc\" name=\"subst_condition_tenant_hab_pdsc\"\n                  ng-model=\"currentPolicy.subst_condition_tenant_hab\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.subst_condition_tenant_hab_pdsc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"temp_relo_landlord_asst_pdsc\">If a tenant needs to be relocated for repairs, does the\n                  program/policy require landlord\n                  to assist with temporary relocation, consistent with TOC Policy standards?\n                </label>\n                <select id=\"temp_relo_landlord_asst_pdsc\" name=\"temp_relo_landlord_asst_pdsc\"\n                  ng-model=\"currentPolicy.temp_relo_landlord_asst\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.temp_relo_landlord_asst_pdsc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"tenant_right_to_occupy_pdsc\">Does program/policy ensure the tenant has the right to reoccupy\n                  the unit after repairs\n                  are complete?\n                </label>\n                <select id=\"tenant_right_to_occupy_pdsc\" name=\"tenant_right_to_occupy_pdsc\"\n                  ng-model=\"currentPolicy.tenant_right_to_occupy\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.tenant_right_to_occupy_pdsc.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <!-- <div class=\"form-item col-lg-12\">\n                     <label for=\"landlord_assist_temp_relo_pdsc\">Does policy require landlord to assist with temporary\n                       relocation, consistent with TOC Policy standards?\n                     </label>\n                     <select id=\"landlord_assist_temp_relo_pdsc\" name=\"landlord_assist_temp_relo_pdsc\"\n                       ng-model=\"currentPolicy.landlord_assist_temp_relo\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required>\n                       <option selected disabled value=\"\">Choose...</option>\n                       <option ng-value=\"true\">Yes</option>\n                       <option ng-value=\"false\">No</option>\n                     </select>\n                     <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                       ng-show=\"form.landlord_assist_temp_relo_pdsc.$error.required && formSubmitted\">\n                       Please choose a valid response.\n                     </div>\n                   </div>\n                   <div class=\"form-item col-lg-12\">\n                     <label for=\"landlord_rent_ex_tenant_pdsc\">Does policy require landlord to pay for moving expenses and\n                       temporary housing if a tenant needs to be relocated while\n                       repairs are completed?\n                     </label>\n                     <select id=\"landlord_rent_ex_tenant_pdsc\" name=\"landlord_rent_ex_tenant_pdsc\"\n                       ng-model=\"currentPolicy.landlord_rent_ex_tenant\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required>\n                       <option selected disabled value=\"\">Choose...</option>\n                       <option ng-value=\"true\">Yes</option>\n                       <option ng-value=\"false\">No</option>\n                     </select>\n                     <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                       ng-show=\"form.landlord_rent_ex_tenant_pdsc.$error.required && formSubmitted\">\n                       Please choose a valid response.\n                     </div>\n                   </div> -->\n              <div class=\"form-item col-lg-8\">\n                <label for=\"tenant_hab_plan_template_pdsc\">Template of the tenant habitability plan or a document\n                  outlining the details that must\n                  be included in such a plan:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.tenant_hab_plan_template)\"\n                       id=\"tenant_hab_plan_template_pdsc\" name=\"tenant_hab_plan_template_pdsc\" type=\"text\"\n                       placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.tenant_hab_plan_template\"\n                       ng-disabled=\"attachmentData['TenantHabPlanTemplate'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.tenant_hab_plan_template)\" ng-disabled=\"formReadOnly\"\n                  id=\"tenant_hab_plan_template_pdsc\" ng-model=\" currentPolicy.tenant_hab_plan_template\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"tenant_hab_plan_template_pdsc\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.tenant_hab_plan_template_pdsc.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload tenant_hab_plan_template -->\n              <div ng-if=\"!checkSubstring(currentPolicy.tenant_hab_plan_template)\" style=\"margin-top: 80px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.tenant_hab_plan_template)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.tenant_hab_plan_template}}\">Uploaded\n                    Documentation</a></span>\n                <button class=\"button button--attach\" ng-click=\"removeFile('tenant_hab_plan_template')\" ng-if=\"!formReadOnly\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.tenant_hab_plan_template)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_pdsc\">\n                    Upload Tenant Habitability Plan Template Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"tenant_hab_plan_template_file_pdsc\"\n                    id=\"tenant_hab_plan_template_file_pdsc\" name=\"tenant_hab_plan_template_file_pdsc\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('tenant_hab_plan_template_file_pdsc')\">\n                    <i ng-show=\"fileUploading_tenant_hab_plan_template_file_pdsc\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_pdsc')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <!-- <div class=\"form-item col-lg-12\">\n                     <label for=\"landlord_assist_temp_relo_pdsc\">Does policy require landlord to assist with temporary\n                       relocation, consistent with TOC Policy standards?\n                     </label>\n                     <select id=\"landlord_assist_temp_relo_pdsc\" name=\"landlord_assist_temp_relo_pdsc\"\n                       ng-model=\"currentPolicy.landlord_assist_temp_relo\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required>\n                       <option selected disabled value=\"\">Choose...</option>\n                       <option ng-value=\"true\">Yes</option>\n                       <option ng-value=\"false\">No</option>\n                     </select>\n                     <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                       ng-show=\"form.landlord_assist_temp_relo_pdsc.$error.required && formSubmitted\">\n                       Please choose a valid response.\n                     </div>\n                   </div>\n                   <div class=\"form-item col-lg-12\">\n                     <label for=\"landlord_rent_ex_tenant_pdsc\">Does policy require landlord to pay for moving expenses and\n                       temporary housing if a tenant needs to be relocated while\n                       repairs are completed?\n                     </label>\n                     <select id=\"landlord_rent_ex_tenant_pdsc\" name=\"landlord_rent_ex_tenant_pdsc\"\n                       ng-model=\"currentPolicy.landlord_rent_ex_tenant\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required>\n                       <option selected disabled value=\"\">Choose...</option>\n                       <option ng-value=\"true\">Yes</option>\n                       <option ng-value=\"false\">No</option>\n                     </select>\n                     <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                       ng-show=\"form.landlord_rent_ex_tenant_pdsc.$error.required && formSubmitted\">\n                       Please choose a valid response.\n                     </div>\n                   </div> -->\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_pdsc\">Program/policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_pdsc\"\n                       name=\"program_policy_terms_pdsc\" type=\"url\" placeholder=\"Enter URL\" value=\"\"\n                       onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.program_policy_terms\"\n                       ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_pdsc\"\n                  ng-model=\" currentPolicy.program_policy_terms\" placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_pdsc\" rows=\"4\"\n                  style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_pdsc.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_pdsc\">\n                    Upload Program/Policy Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_pdsc\" id=\"program_policy_terms_file_pdsc\"\n                    name=\"program_policy_terms_file_pdsc\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_pdsc')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_pdsc\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_pdsc')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_pdsc\">How does program/policy address jurisdiction's RHNA and/or\n                  other\n                  housing needs identified in the Housing Element?</label>\n                <!-- <input id=\"program_policy_rhna_housing_pdsc\" name=\"program_policy_rhna_housing_pdsc\" type=\"text\"\n                       placeholder=\"Enter your response here\" ng-model=\"currentPolicy.program_policy_rhna_housing\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required /> -->\n                <textarea id=\"program_policy_rhna_housing_pdsc\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_pdsc\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_pdsc.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_pdsc\">Comments/Notes:</label>\n                <!-- <input type=\"text\" placeholder=\"Enter your response here\" ng-model=\"currentPolicy.comments\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" /> -->\n                <textarea id=\"comments_pdsc\" ng-model=\" currentPolicy.comments\" placeholder=\"Enter response\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_pdsc\" rows=\"4\"\n                  style=\"width: 100%;\">\n                       </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Tenant Relocation Assistance Section -->\n          <div id=\"section-Tenant-Relocation-Assistance\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Tenant Relocation Assistance'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Tenant Relocation Assistance</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span class=\"italics\">\n                Description from TOC Policy Resolution: Policy or program that\n                provides relocation assistance (financial and/or other services)\n                to tenants displaced through no fault of their own, with\n                assistance exceeding that required under state law.\n              </span>\n            </p>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_tras\">Link to adopted policy:</label>\n                <!-- <input id=\"adopted_program_policy_link_tras\" name=\"adopted_program_policy_link_tras\" type=\"url\"\n                       placeholder=\"Enter URL\" value=\"\" ng-model=\"currentPolicy.adopted_program_policy_link\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required /> -->\n                <textarea id=\"adopted_program_policy_link_tras\" ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_tras\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_tras.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_tras\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_tras\" name=\"jurisdiction_wide_tras\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_tras.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"landlord_relocation_pay_no_tras\">Does policy require landlords to make relocation payments\n                  for\n                  all no-cause or no-fault evictions?</label>\n                <select id=\"landlord_relocation_pay_no_tras\" name=\"landlord_relocation_pay_no_tras\"\n                  ng-model=\"currentPolicy.landlord_relocation_pay_no\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.landlord_relocation_pay_no_tras.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"tenant_relocation_spec_pop_tras\">Does policy target specific populations (e.g., % of AMI,\n                  senior, formerly homeless, veteran, etc.)?</label>\n                <select id=\"tenant_relocation_spec_pop_tras\" name=\"tenant_relocation_spec_pop_tras\"\n                  ng-model=\"currentPolicy.tenant_relocation_spec_pop\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.tenant_relocation_spec_pop_tras.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"relo_assist_3_month_fmr_tras\">Does policy require relocation assistance equal to at least 3\n                  months’ fair market rent unless another law requires a higher\n                  minimum amount?</label>\n                <select id=\"relo_assist_3_month_fmr_tras\" name=\"relo_assist_3_month_fmr_tras\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.relo_assist_3_month_fmr\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.relo_assist_3_month_fmr_tras.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_tras\">Policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_tras\"\n                       name=\"program_policy_terms_tras\" type=\"url\" placeholder=\"Enter URL\" value=\"\"\n                       onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.program_policy_terms\"\n                       ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_tras\"\n                  ng-model=\" currentPolicy.program_policy_terms\" placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_tras\" rows=\"4\"\n                  style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_tras.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button  class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\" ng-if=\"!formReadOnly\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_tras\">Upload Policy Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_tras\" id=\"program_policy_terms_file_tras\"\n                    name=\"program_policy_terms_file_tras\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_tras')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_tras\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_tras')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_tras\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <!-- <input id=\"program_policy_rhna_housing_tras\" name=\"program_policy_rhna_housing_tras\" type=\"text\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" placeholder=\"Enter your response here\"\n                       ng-model=\"currentPolicy.program_policy_rhna_housing\" required /> -->\n                <textarea id=\"program_policy_rhna_housing_tras\" ng-model=\" currentPolicy.program_policy_rhna_housing\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_tras\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_tras.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_tras\">Comments/Notes:</label>\n                <!-- <input type=\"text\" placeholder=\"Enter your response here\" ng-model=\"currentPolicy.comments\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" /> -->\n                <textarea id=\"comments_tras\" ng-model=\" currentPolicy.comments\" placeholder=\"Enter response\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_tras\" rows=\"4\"\n                  style=\"width: 100%;\">\n                       </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n\n          <!-- Mobile Home Rent Stabilization Section -->\n          <div id=\"section-Mobile-Home-Rent-Stabilization\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Mobile Home Rent Stabilization'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Mobile Home Rent Stabilization</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Restricts annual rent\n                increases on mobile home residents based upon a measure of\n                inflation or another metric.</span>\n            </p>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_mhrs\">Link to adopted policy:</label>\n                <!-- <input id=\"adopted_program_policy_link_mhrs\" name=\"adopted_program_policy_link_mhrs\"\n                       ng-model=\"currentPolicy.adopted_program_policy_link\" type=\"url\" placeholder=\"Enter URL\" value=\"\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" required /> -->\n                <textarea id=\"adopted_program_policy_link_mhrs\" ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_mhrs\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter URL\" placeholder=\"Enter response or URL\" type=\"text\"\n                  required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_mhrs.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_mhrs\">Does policy apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_mhrs\" name=\"jurisdiction_wide_mhrs\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_mhrs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"jurisdiction_mobile_home_mhrs\">Documentation of at least one mobile home park in the\n                  jurisdiction:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.jurisdiction_mobile_home)\"\n                       id=\"jurisdiction_mobile_home_mhrs\" name=\"jurisdiction_mobile_home_mhrs\" type=\"text\"\n                       placeholder=\"Enter URL\" onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.jurisdiction_mobile_home\"\n                       ng-disabled=\"attachmentData['MobileHomePark'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.jurisdiction_mobile_home)\" ng-disabled=\"formReadOnly\"\n                  id=\"jurisdiction_mobile_home_mhrs\" ng-model=\" currentPolicy.jurisdiction_mobile_home\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"jurisdiction_mobile_home_mhrs\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_mobile_home_mhrs.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload jurisdiction_mobile_home -->\n              <div ng-if=\"!checkSubstring(currentPolicy.jurisdiction_mobile_home)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.jurisdiction_mobile_home)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.jurisdiction_mobile_home}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('jurisdiction_mobile_home')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.jurisdiction_mobile_home)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"jurisdiction_mobile_home_file_mhrs\">Upload Mobile Home Documentation mz</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"jurisdiction_mobile_home_file_mhrs\"\n                    id=\"jurisdiction_mobile_home_file_mhrs\" name=\"jurisdiction_mobile_home_file_mhrs\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('jurisdiction_mobile_home_file_mhrs')\">\n                    <i ng-show=\"fileUploading_jurisdiction_mobile_home_file_mhrs\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('jurisdiction_mobile_home_file_mhrs')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"limit_max_annual_rent_inc_mhrs\">Does policy limit maximum annual rent increases consistent\n                  with TOC Policy standards?</label>\n                <select id=\"limit_max_annual_rent_inc_mhrs\" name=\"limit_max_annual_rent_inc_mhrs\"\n                  ng-model=\"currentPolicy.limit_max_annual_rent_inc\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.limit_max_annual_rent_inc_mhrs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"vacancy_control_mhrs\">Does policy have some form of vacancy control within constitutional\n                  limits?</label>\n                <select id=\"vacancy_control_mhrs\" name=\"vacancy_control_mhrs\" ng-model=\"currentPolicy.vacancy_control\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.vacancy_control_mhrs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"enforce_mech_rent_inc_dispute_mhrs\">Does policy have an enforcement mechanism (such as a\n                  rent\n                  board or administrative hearing) whereby mobile home residents can dispute\n                  rent increases that exceed legally allowed maximums?</label>\n                <select id=\"enforce_mech_rent_inc_dispute_mhrs\" name=\"enforce_mech_rent_inc_dispute_mhrs\"\n                  ng-model=\"currentPolicy.enforce_mech_rent_inc_dispute\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.enforce_mech_rent_inc_dispute_mhrs.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_mhrs\">Policy terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_mhrs\"\n                       name=\"program_policy_terms_mhrs\" type=\"url\" placeholder=\"Enter URL\" value=\"\"\n                       onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.program_policy_terms\"\n                       ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_mhrs\"\n                  ng-model=\" currentPolicy.program_policy_terms\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_mhrs\" rows=\"4\"\n                  style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_mhrs.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_mhrs\">Upload Policy Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_mhrs\" id=\"program_policy_terms_file_mhrs\"\n                    name=\"program_policy_terms_file_mhrs\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_mhrs')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_mhrs\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_mhrs')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_mhrs\">How does policy address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <!-- <input id=\"program_policy_rhna_housing_mhrs\" name=\"program_policy_terms\" type=\"text\"\n                       placeholder=\"Enter your response here\" onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.program_policy_rhna_housing\" required /> -->\n                <textarea id=\"program_policy_rhna_housing_mhrs\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_mhrs\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing_mhrs.$error.required && formSubmitted\">\n                  Please provide a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_mhrs\">Comments/Notes:</label>\n                <!-- <input type=\"text\" placeholder=\"Enter your response here\"\n                       onchange=\"angular.element(this).scope().setPending(this)\" ng-model=\"currentPolicy.comments\" /> -->\n                <textarea id=\"comments_mhrs\" ng-model=\" currentPolicy.comments\" placeholder=\"Enter response\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_mhrs\" rows=\"4\"\n                  style=\"width: 100%;\">\n                       </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n          <!-- Fair Housing Enforcement Section -->\n          <div id=\"section-Fair-Housing-Enforcement\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': currentPolicy.housing_policy_name === 'Fair Housing Enforcement'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Fair Housing Enforcement</h2>\n              <statuspills ng-repeat=\"submission in housingStatus\"\n                ng-if=\"submission.housing_policy_name === currentPolicy.housing_policy_name && submission.submitted === true\"\n                status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\"\n                user-role=\"currentUser.role\">\n              </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, submitted: true})[0] && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(housingStatus | filter:{housing_policy_name: currentPolicy.housing_policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n              <span style=\"font-style: italic\">\n                Description from TOC Policy Resolution: Policy, program, or\n                investments that support fair housing testing, compliance\n                monitoring, and enforcement.</span>\n            </p>\n            <div class=\"col\" ng-if=\"fundingLevels\">\n              <p>\n                <strong aria-label=\"Jurisdiction Name\">\n                  {{fundingLevels.jurisdiction}}\n                </strong>\n                is in\n                <strong aria-label=\"Funding Tier\">\n                  <span ng-if=\"fundingLevels && fundingLevels.funding_tier\">\n                    funding tier {{fundingLevels.funding_tier}}</span></strong>. It must demonstrate there is a program with funding above\n                <strong aria-label=\"Protection Requirement\">\n                  {{fundingLevels.protection_ | currency}}\n                </strong>\n                for this policy over a four-year period if it chooses to use this policy to achieve TOC Policy consistency. For more information about required funding amounts and sources, see section “Policy Options With Funding Commitments” of the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance</a>.\n              </p>\n            </div>\n            <form class=\"row\" name=\"housingForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"adopted_program_policy_link_fhes\">Link to adopted program:</label>\n                <!-- <input id=\"adopted_program_policy_link_fhes\" name=\"adopted_program_policy_link_fhes\" type=\"text\"\n                       placeholder=\"Enter URL\" value=\"\" onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.adopted_program_policy_link\" required /> -->\n                <textarea id=\"adopted_program_policy_link_fhes\" ng-model=\" currentPolicy.adopted_program_policy_link\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_program_policy_link_fhes\" ng-disabled=\"formReadOnly\"\n                  placeholder=\"Enter response or URL\" type=\"text\" rows=\"4\" style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.adopted_program_policy_link_fhes.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"jurisdiction_wide_fhes\">Does program apply jurisdiction-wide?</label>\n                <select id=\"jurisdiction_wide_fhes\" name=\"jurisdiction_wide_fhes\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.jurisdiction_wide\" onchange=\"angular.element(this).scope().setPending(this)\"\n                  required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option ng-value=\"true\">Yes</option>\n                  <option ng-value=\"false\">No</option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.jurisdiction_wide_fhes.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"fair_housing_program_type_fhes\">Type of program:</label>\n                <select id=\"fair_housing_program_type_fhes\" name=\"fair_housing_program_type_fhes\"\n                  ng-model=\"currentPolicy.fair_housing_program_type\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" required>\n                  <option selected disabled value=\"\">Choose...</option>\n                  <option value=\"contract\">\n                    Contract with service providers\n                  </option>\n                  <option value=\"testing\">\n                    Jurisdiction testing and enforcement program\n                  </option>\n                </select>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.fair_housing_program_type_fhes.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"program_policy_terms_fhes\">Program terms if not in ordinance or documentation\n                  establishing policy:</label>\n                <!-- <input ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_fhes\"\n                       name=\"program_policy_terms_fhes\" type=\"url\" placeholder=\"Enter URL\" value=\"\"\n                       onchange=\"angular.element(this).scope().setPending(this)\"\n                       ng-model=\"currentPolicy.program_policy_terms\"\n                       ng-disabled=\"attachmentData['PolicyTerms'].isFileSelected\" required /> -->\n                <textarea ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" id=\"program_policy_terms_fhes\"\n                  ng-model=\" currentPolicy.program_policy_terms\" placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_terms_fhes\" rows=\"4\"\n                  style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_terms_fhes.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload program_policy_terms -->\n              <div ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.program_policy_terms)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.program_policy_terms}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('program_policy_terms')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.program_policy_terms)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"program_policy_terms_file_fhes\">Upload Program Terms Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"program_policy_terms_file_fhes\" id=\"program_policy_terms_file_fhes\"\n                    name=\"program_policy_terms_file_fhes\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('program_policy_terms_file_fhes')\">\n                    <i ng-show=\"fileUploading_program_policy_terms_file_fhes\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('program_policy_terms_file_fhes')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"fair_hsng_enforce_org_contract_fhes\"><span class=\"bold-text\">Contract with Service\n                    Providers:</span>\n                  Documents\n                  demonstrating jurisdiction has contracted or will contract with\n                  one or more organizations to provide fair housing\n                  enforcement.</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.fair_hsng_enforce_org_contract)\" ng-disabled=\"formReadOnly\"\n                  id=\"fair_hsng_enforce_org_contract_fhes\" ng-model=\" currentPolicy.fair_hsng_enforce_org_contract\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"fair_hsng_enforce_org_contract_fhes\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.fair_hsng_enforce_org_contract_fhes.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload fair_hsng_enforce_org_contract -->\n              <div ng-if=\"!checkSubstring(currentPolicy.fair_hsng_enforce_org_contract)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.fair_hsng_enforce_org_contract)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.fair_hsng_enforce_org_contract}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('fair_hsng_enforce_org_contract')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.fair_hsng_enforce_org_contract)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"fair_hsng_enforce_org_contract_file_fhes\">Upload Contract Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"fair_hsng_enforce_org_contract_file_fhes\"\n                    id=\"fair_hsng_enforce_org_contract_file_fhes\" name=\"fair_hsng_enforce_org_contract_file_fhes\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\"\n                    ng-click=\"uploadFile('fair_hsng_enforce_org_contract_file_fhes')\">\n                    <i ng-show=\"fileUploading_fair_hsng_enforce_org_contract_file_fhes\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('fair_hsng_enforce_org_contract_file_fhes')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"public_program_link_fhes\">Link to website where program information is publicly\n                  available.</label>\n                <textarea id=\"public_program_link_fhes\" ng-model=\" currentPolicy.public_program_link\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"public_program_link_fhes\" rows=\"4\"\n                  style=\"width: 100%;\" placeholder=\"Enter response or URL\" type=\"text\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.public_program_link_fhes.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"anticipated_funding_2026_fhes\">Amount of anticipated funding for four-year period ($):</label>\n                <input id=\"anticipated_funding_2026_fhes\" name=\"anticipated_funding_2026_fhes\" type=\"number\"\n                  placeholder=\"$\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                  ng-model=\"currentPolicy.anticipated_funding_2026\" required />\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.anticipated_funding_2026_fhes.$error.required && formSubmitted\">\n                  Please provide a valid amount.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-8\">\n                <label for=\"secured_funding_docs_fhes\">Documentation that jurisdiction has \"secured funding\"\n                  consistent with TOC Policy requirements, including\n                  identification of fund source(s):</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" id=\"secured_funding_docs_fhes\"\n                  ng-model=\" currentPolicy.secured_funding_docs\" placeholder=\"Enter response or URL\" type=\"text\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"secured_funding_docs_fhes\" rows=\"4\"\n                  style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.secured_funding_docs_fhes.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload secured_funding_docs -->\n              <div ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\" style=\"margin-top: 75px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.secured_funding_docs)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.secured_funding_docs}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('secured_funding_docs')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.secured_funding_docs)\">\n                <div class=\"col-lg-2\">\n                  <label for=\"secured_funding_docs_file_fhes\">Upload Secured Funding Documentation</label>\n                </div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"secured_funding_docs_file_fhes\" id=\"secured_funding_docs_file_fhes\"\n                    name=\"secured_funding_docs_file_fhes\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('secured_funding_docs_file_fhes')\">\n                    <i ng-show=\"fileUploading_secured_funding_docs_file_fhes\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('secured_funding_docs_file_fhes')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-8\">\n                <label for=\"expected_fund_schedule_2026_fhes\">Schedule of expected funding allocated to the program:</label>\n                <textarea ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" ng-disabled=\"formReadOnly\"\n                  id=\"expected_fund_schedule_2026_fhes\" ng-model=\" currentPolicy.expected_fund_schedule_2026\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"expected_fund_schedule_2026_fhes\"\n                  placeholder=\"Enter response or URL\" type=\"text\" rows=\"4\" style=\"width: 100%;\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.expected_fund_schedule_2026_fhes.$error.required && formSubmitted\">\n                  Please enter a valid response or URL.\n                </div>\n              </div>\n              <!-- File upload expected_fund_schedule_2026 -->\n              <div ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\" style=\"margin-top: 65px\"\n                class=\"col-lg-1\">\n                <b class=\"or-label\">OR</b>\n              </div>\n              <div class=\"col-md-5\" ng-if=\"checkSubstring(currentPolicy.expected_fund_schedule_2026)\"\n                style=\"padding-bottom: 10px\">\n                <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                    ng-href=\"{{currentPolicy.expected_fund_schedule_2026}}\">Uploaded\n                    Documentation</a></span>\n                <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('expected_fund_schedule_2026')\">\n                  <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                  Remove\n                </button>\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentPolicy.expected_fund_schedule_2026)\">\n                <div class=\"col-lg-2\"><label for=\"expected_fund_schedule_2026_file_fhes\">Upload Expected Fund Schedule\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"expected_fund_schedule_2026_file_fhes\"\n                    id=\"expected_fund_schedule_2026_file_fhes\" name=\"expected_fund_schedule_2026_file_fhes\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                    onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-disabled=\"formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('expected_fund_schedule_2026_file_fhes')\">\n                    <i ng-show=\"fileUploading_expected_fund_schedule_2026_file_fhes\"\n                      class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('expected_fund_schedule_2026_file_fhes')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"form-item col-lg-12\">\n                <label for=\"program_policy_rhna_housing_fhes\">How does program address jurisdiction's RHNA and/or other\n                  housing needs identified in the Housing Element?</label>\n                <textarea id=\"program_policy_rhna_housing_fhes\" ng-model=\" currentPolicy.program_policy_rhna_housing\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"program_policy_rhna_housing_fhes\" ng-disabled=\"formReadOnly\"\n                  rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response\" required>\n                       </textarea>\n                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                  ng-show=\"form.program_policy_rhna_housing.$error.required && formSubmitted\">\n                  Please choose a valid response.\n                </div>\n              </div>\n              <div class=\"form-item col-lg-12\">\n                <label for=\"comments_fhes\">Comments/Notes:</label>\n                <textarea id=\"comments_fhes\" ng-model=\" currentPolicy.comments\" ng-disabled=\"formReadOnly\"\n                  onchange=\"angular.element(this).scope().setPending(this)\" name=\"comments_fhes\" rows=\"4\"\n                  style=\"width:100%;\" placeholder=\"Enter response\">\n                       </textarea>\n                <div class=\"valid-feedback\">Looks good!</div>\n              </div>\n            </form>\n          </div>\n        </div>\n        <submissionsectionsubmit></submissionsectionsubmit>\n      </div>\n    </div>\n    <div class=\"footer\" role=\"contentinfo\">\n      <sidebarfooter></sidebarfooter>\n    </div>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ManageusersComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _manageusers = __webpack_require__(162);
	
	var _manageusers2 = _interopRequireDefault(_manageusers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ManageusersComponent = exports.ManageusersComponent = function () {
	  /*@ngInject*/
	  function ManageusersComponent($scope, $http, userService, baseConfigService, fetch, $state) {
	    _classCallCheck(this, ManageusersComponent);
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$state = $state;
	    this.fetch = fetch;
	
	    this.userService = userService;
	    this.baseConfigService = baseConfigService;
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    this.$scope.updateUserP = {};
	    this.$scope.updateUser = {};
	    this.$scope.delUser = {};
	    this.$scope.newUser = {};
	    this.$scope.organizations = [];
	    this.$scope.sponsors = [];
	    $scope.getJurisdictionList = function () {
	      fetch.getAllItems('api/data/jurisdictions/list').then(function (response) {
	
	        $scope.organizations = response.data;
	        console.log($scope.organizations);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.getSponsorList = function () {
	      fetch.getAllItems('api/data/sponsors/list').then(function (response) {
	        $scope.sponsors = response.data;
	        console.log('Sponsors loaded:', $scope.sponsors);
	      }).catch(function (err) {
	        console.log('Error loading sponsors:', err);
	      });
	    };
	
	    $scope.saveSelection = function () {
	      $scope.saving = true;
	
	      var selectedJurisdictions = $scope.organizations.filter(function (item) {
	        return item.selected;
	      }).map(function (item) {
	        return item.jurisdiction_id;
	      });
	      var data = {
	        userId: $scope.updateUser.id,
	        jurisdictionIds: selectedJurisdictions
	      };
	      console.log(data);
	
	      fetch.updateItem('api/data/users/save-user-jurisdictions', data).then(function (response) {
	        console.log('Jurisdictions saved successfully:', response.data);
	        $scope.saving = false;
	        $('#updateUsersModal').modal('toggle');
	      }).catch(function (error) {
	        console.error('Error saving jurisdictions:', error);
	        $scope.saving = false;
	      });
	    };
	
	    $scope.saveSponsorSelection = function () {
	      $scope.savingSponsors = true;
	
	      var selectedSponsors = $scope.sponsors.filter(function (item) {
	        return item.selected;
	      }).map(function (item) {
	        return item.sponsor_id;
	      });
	      var data = {
	        userId: $scope.updateUser.id,
	        sponsorIds: selectedSponsors
	      };
	      console.log('Saving sponsors:', data);
	
	      fetch.updateItem('api/data/users/save-user-sponsors', data).then(function (response) {
	        console.log('Sponsors saved successfully:', response.data);
	        $scope.savingSponsors = false;
	        $('#updateUsersModal').modal('toggle');
	      }).catch(function (error) {
	        console.error('Error saving sponsors:', error);
	        $scope.savingSponsors = false;
	      });
	    };
	
	    $scope.cancelSelection = function () {};
	
	    $scope.escapeCSVValue = function (value) {
	      if (value === null || typeof value === 'undefined') {
	        return '';
	      }
	
	      if (typeof value === 'boolean') {
	        return value ? 'Yes' : 'No';
	      }
	
	      value = String(value);
	      if (value.includes(',') || value.includes('"') || value.includes('\n') || value.includes('\r')) {
	        return '"' + value.replace(/"/g, '""') + '"';
	      }
	      return value;
	    };
	
	    $scope.exportToCSV = function () {
	      var data = $scope.filteredCollection;
	
	      var headers = ['First', 'Last', 'Jurisdiction', 'Email', 'Role', 'Active'];
	      var keys = ['firstname', 'lastname', 'organization', 'email', 'role', 'active'];
	
	      var csv = '';
	
	      csv += headers.join(',') + '\n';
	
	      csv += headers.join(',') + '\n';
	
	      data.forEach(function (row) {
	        var rowValues = keys.map(function (key) {
	          return $scope.escapeCSVValue(row[key]);
	        });
	        csv += rowValues.join(',') + '\n';
	      });
	
	      var filename = prompt("Enter a filename for the CSV file:", "toc_users.csv");
	
	      if (filename === null) {
	        return;
	      }
	
	      var link = document.createElement('a');
	      link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
	      link.download = filename;
	
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    };
	  }
	
	  _createClass(ManageusersComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.getAllUsers();
	        _this.$scope.getJurisdictionList();
	        _this.$scope.getSponsorList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getAllUsers',
	    value: function getAllUsers() {
	      var _this2 = this;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	
	      this.userService.getAllUsers().then(function (users) {
	        _this2.$scope.rowCollection = users.data;
	
	        var data = users.data;
	        console.log(data);
	
	        var thisIsValid = _this2.$scope.thisIsValid;
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser(id) {
	      this.userService.getUser(id).then(function (user) {
	        console.log(user);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'updateModal',
	    value: function updateModal(data) {
	      var _this3 = this;
	
	      this.$scope.updateUser = data;
	      console.log(data);
	
	      this.fetch.getAllItems('api/data/users/get-users-jurisdictions/' + data.id).then(function (response) {
	        console.log('User jurisdictions:', response.data);
	
	        var jurisdictionIds = response.data.jurisdictionIds;
	        _this3.$scope.organizations.forEach(function (item) {
	          item.selected = jurisdictionIds.includes(item.jurisdiction_id);
	        });
	
	        console.log(_this3.$scope.organizations);
	      }).catch(function (err) {
	        console.log(err);
	      });
	
	      this.fetch.getAllItems('api/data/users/get-users-sponsors/' + data.id).then(function (response) {
	        console.log('User sponsors:', response.data);
	
	        var sponsorIds = response.data.map(function (item) {
	          return item.sponsor_id;
	        });
	
	        _this3.$scope.sponsors.forEach(function (item) {
	          item.selected = sponsorIds.includes(item.sponsor_id);
	        });
	
	        console.log('Updated sponsors:', _this3.$scope.sponsors);
	      }).catch(function (err) {
	        console.log('Error fetching user sponsors:', err);
	      });
	    }
	  }, {
	    key: 'updatePModal',
	    value: function updatePModal(id) {
	      console.log(id);
	      this.$scope.updateUserP.id = id;
	    }
	  }, {
	    key: 'deleteModal',
	    value: function deleteModal(id) {
	      console.log(id);
	      this.$scope.delUser.id = id;
	    }
	  }, {
	    key: 'updateUser',
	    value: function updateUser(id) {
	      var _this4 = this;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      console.log(this.$scope.updateUser);
	      var updateData = this.$scope.updateUser;
	      this.$scope.saving = true;
	
	      this.$http.post(adminBaseURL + '/users/update', updateData).then(function (responseReport) {
	        console.log(responseReport);
	        _this4.$scope.updateUser = {};
	
	        $('#updateUsersModal').modal('toggle');
	        _this4.$scope.saving = false;
	      }).catch(function (err) {
	        console.log(err);
	        _this4.$scope.saving = false;
	        if (err.response === 403) {
	          _this4.$state.go('/login');
	        }
	      });
	    }
	  }, {
	    key: 'updateUserPwd',
	    value: function updateUserPwd() {
	      var _this5 = this;
	
	      this.$scope.saving = true;
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      console.log(this.$scope.updateUserP);
	      var updateData = {
	        uid: this.$scope.updateUserP.id,
	        newPassword: this.$scope.updateUserP.newPassword
	      };
	
	      this.$http.post(adminBaseURL + '/users/update-pwd', updateData).then(function (responseReport) {
	        console.log(responseReport);
	        _this5.$scope.updateUserP = {};
	        _this5.$scope.saving = false;
	
	        $('#updatePasswordModal').modal('toggle');
	      }).catch(function (err) {
	        console.log(err);
	        if (err.response === 403) {
	          _this5.$state.go('/login');
	        }
	      });
	    }
	  }, {
	    key: 'deleteUser',
	    value: function deleteUser() {
	      var _this6 = this;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      var id = this.$scope.delUser.id;
	
	      this.$http.delete(adminBaseURL + '/users/delete-user/' + id).then(function (response) {
	        _this6.$scope.rowCollection = _this6.$scope.rowCollection.filter(function (user) {
	          return user.id !== id;
	        });
	
	        $('#deleteUserModal').modal('hide');
	
	        _this6.$scope.delUser = {};
	
	        _this6.$scope.successMessage = 'User successfully deleted';
	
	        if (!_this6.$scope.$$phase) {
	          _this6.$scope.$apply();
	        }
	      }).catch(function (err) {
	        console.error('Error deleting user:', err);
	        if (err.status === 403) {
	          _this6.$state.go('login');
	        } else {
	          _this6.$scope.errorMessage = 'Failed to delete user';
	        }
	      });
	    }
	  }, {
	    key: 'createUser',
	    value: function createUser() {
	      var _this7 = this;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      var newUserData = this.$scope.newUser;
	      this.$scope.saving = true;
	      this.$http.post(adminBaseURL + '/users/create-user', newUserData).then(function (responseReport) {
	        console.log(responseReport);
	        _this7.$scope.saving = false;
	        _this7.$scope.newUser = {};
	        _this7.$scope.rowCollection.push(newUserData);
	        _this7.getAllUsers();
	        $('#createUserModal').modal('toggle');
	      }).catch(function (err) {
	        console.log(err);
	
	        _this7.$scope.saving = false;
	        if (err.response && err.response.status === 403) {
	          _this7.$state.go('/login');
	        } else {
	          alert('An error occurred while creating the user.');
	        }
	      });
	    }
	  }, {
	    key: 'resetSearch',
	    value: function resetSearch() {
	      console.log("resetting");
	
	      this.$scope.search = '';
	      this.$scope.active = '';
	      this.$scope.role = '';
	      this.getAllUsers();
	    }
	  }]);
	
	  return ManageusersComponent;
	}();
	
	exports.default = angular.module('appApp.manageusers', [uiRouter]).config(_manageusers2.default).component('manageusers', {
	  template: __webpack_require__(163),
	  controller: ManageusersComponent,
	  controllerAs: 'manageusersCtrl'
	}).directive("stFilteredCollection", function () {
	  return {
	    require: "^stTable",
	    link: function link(scope, element, attr, ctrl) {
	      scope.$watch(ctrl.getFilteredCollection, function (val) {
	        scope.filteredCollection = val;
	        scope.currentPage = 0;
	        scope.pageSize = 10;
	        scope.numberOfPages = function () {
	          return Math.ceil(scope.filteredCollection.length / scope.pageSize);
	        };
	      });
	    }
	  };
	}).name;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('manageusers', {
	    url: '/admin/manageusers',
	    template: '<manageusers></manageusers>',
	    authenticate: true
	  });
	};

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--compliance dashboard--compliance--landing\">\n    <div class=\"page-wrapper\">\n\n        <div class=\"dashboard-header\">\n            <sidebarnav />\n        </div>\n\n        <div class=\"main\">\n            <mainheaderauth />\n\n            <div id=\"maincontent\" class=\"content container\">\n                <h1 class=\"page-title\">Compliance</h1>\n                <div class=\"section col-lg-12\">\n                    <div class=\"section-header\">\n                        <h2>Manage Users</h2>\n                    </div>\n                </div>\n                <div class=\"section\" style=\"padding-top:0;\" st-table=\"displayedCollection\" st-safe-src=\"rowCollection\"\n                    st-filtered-collection>\n\n                    <div class=\"container-fluid\">\n                        <div class=\"row\">\n                            <div class=\"col-md-2\" style=\"padding:5px;border-right: solid lightgray 1px;\">\n                                <!-- Filters Tab  -->\n                                <div id=\"filtersTabPanel\" style=\"padding-left:2%;padding-right:2%;\">\n                                    <div class=\"tabFilters\">\n                                        <h6 style=\"padding-left:10px;padding-top:5px;\">Quick Filters <a href=\"/sources\">\n                                                <i class=\"pl-1 fa-solid fa-info-circle\" data-toggle=\"tooltip\"\n                                                    data-placement=\"top\"\n                                                    title=\"These attributes are used by the HESS Pre-screening Methodology. See Methods and Source page for more details.\"></i>\n                                            </a>\n                                        </h6>\n                                        <div class=\"tabFilterItems\">\n                                            <div class=\"panel-body\">\n                                                <form id=\"filterForm\">\n                                                    <table class=\"view-table-search\" style=\"width:90%;margin:auto;\">\n                                                        <tr>\n                                                            <td colspan=\"2\" class=\"pad-top-s filterFonts\">\n                                                                Search\n                                                            </td>\n                                                        </tr>\n                                                        <tr>\n                                                            <td colspan=\"2\">\n                                                                <input type=\"text\" ng-model=\"search\"\n                                                                    class=\"form-control\"\n                                                                    placeholder=\"Search Inventory...\" st-search>\n                                                            </td>\n                                                        </tr>\n                                                        <tr>\n                                                            <td colspan=\"2\" class=\"pad-top-s filterFonts\">\n                                                                Activated\n                                                            </td>\n                                                        </tr>\n                                                        <tr>\n                                                            <td colspan=\"2\">\n                                                                <select st-search=\"active\" ng-model=\"active\"\n                                                                    class=\"input-sm form-control\"\n                                                                    st-input-event=\"change\">\n                                                                    <option value=\"\">All</option>\n                                                                    <option value=\"true\">Activated</option>\n                                                                    <option value=\"false\">Not Activated</option>\n\n                                                                </select>\n                                                            </td>\n                                                        </tr>\n                                                        <tr>\n                                                            <td colspan=\"2\" class=\"pad-top-s filterFonts\">\n                                                                Role\n                                                            </td>\n                                                        </tr>\n                                                        <tr>\n                                                            <td colspan=\"2\">\n                                                                <select st-search=\"role\" class=\"input-sm form-control\"\n                                                                    st-input-event=\"change\">\n                                                                    <option value=\"\">All</option>\n                                                                    <option value=\"user\">User</option>\n                                                                    <option value=\"consultant\">Consultant</option>\n                                                                    <option value=\"cta\">CTA</option>\n                                                                    <option value=\"admin\">Administrator</option>\n\n                                                                </select>\n                                                            </td>\n                                                        </tr>\n\n                                                        <tr>\n                                                            <td colspan=\"2\" class=\"pad-top-m filterFonts\"\n                                                                style=\"text-align:center;\">\n                                                                <button st-reset-search class=\"btn btn-primary btn-sm\"\n                                                                    ng-click=\"manageusersCtrl.resetSearch()\">\n                                                                    <i class=\"fa-solid fa-arrows-rotate\"></i> Clear Filters</button>\n                                                            </td>\n                                                        </tr>\n                                                    </table>\n                                                </form>\n                                            </div>\n                                        </div>\n\n\n                                    </div>\n                                </div>\n\n                                <!-- <ul class=\"nav nav-pills nav-pills-primary nav-pills-icons responsive\" role=\"tablist\">\n                        <li class=\"nav-item\" style=\"margin-left:2px;\">\n                          <a id=\"filtersTabNav\" class=\"nav-link active\" data-toggle=\"tab\" href=\"#filtersTabPanel\" role=\"tablist\"\n                            style=\"margin-right:0 !important;\">\n                            <i class=\"now-ui-icons design_bullet-list-67\"></i> Filters\n                          </a>\n                        </li>\n                        <li class=\"nav-item\" style=\"margin-left:2px;\">\n                          <a id=\"myListTabNav\" class=\"nav-link\" data-toggle=\"tab\" href=\"#myListTabPanel\" role=\"tablist\"\n                            style=\"margin-right:0 !important;\" ng-click=\"getMyList()\">\n                            <i class=\"fa-solid fa-list-ol\"></i> My List\n                          </a>\n                        </li>\n                      </ul> -->\n\n\n\n                            </div>\n\n                            <div class=\"col-md-10\" style=\"min-height:60vh;\">\n                                <div class=\"row\" ng-show=\"!rowCollection\"\n                                    style=\"margin-right:15px;margin-left:15px; padding-bottom:10px;\">\n                                    <div class=\"col-md-12\">\n                                        <i class=\"fa-solid fa-cog fa-spin\" style=\"font-size:20px;\"></i><span\n                                            style=\"font-size:15px;padding-left:10px;\">Loading Users...</span>\n                                    </div>\n                                </div>\n                                <div class=\"row\" style=\"margin-right:15px;margin-left:15px;\">\n                                    <div class=\"table-responsive\">\n                                        <div class=\"text-end\" style=\"padding-bottom:10px;\">\n                                            <!-- Aligns content to the right -->\n                                            <button type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"modal\"\n                                                data-bs-target=\"#createUserModal\">\n                                                <i class=\"fa-solid fa-plus\"></i> Add User\n                                            </button>\n                                            <button class=\"btn btn-primary\" ng-click=\"exportToCSV()\">\n                                                <i class=\"fa-solid fa-download\"></i> Download Table\n                                            </button>\n                                        </div>\n                                        <table\n                                            class=\"table table--data-table table--compliance table-borderless table-striped\">\n                                            <thead class=\"table-dark\">\n                                                <tr>\n                                                    <th class=\"text-left\">\n                                                        First\n                                                    </th>\n                                                    <th class=\"text-left\">\n                                                        Last\n                                                    </th>\n                                                    <th>\n                                                        Jurisdiction\n                                                    </th>\n                                                    <th>\n                                                        Title\n                                                    </th>\n\n                                                    <th>\n                                                        Email\n                                                    </th>\n                                                    <th>\n                                                        Role\n                                                    </th>\n                                                    <th>\n                                                        Active\n                                                    </th>\n                                                    <!-- <th class=\"text-center\">\n                                  Max DUA\n                                </th> -->\n\n                                                    <th class=\"text-right\">\n                                                        Actions\n                                                    </th>\n                                                </tr>\n                                            </thead>\n                                            <tbody>\n                                                <tr ng-repeat=\"row in displayedCollection.slice(currentPage * pageSize, (currentPage + 1) * pageSize)\"\n                                                    ng-class=\"row.isSelected ? 'st-selected' : ''\">\n\n                                                    <td>{{row.firstname}}</td>\n                                                    <td>{{row.lastname}}</td>\n                                                    <td>{{row.organization}}</td>\n                                                    <td>{{row.title}}</td>\n                                                    <td>{{row.email}}</td>\n                                                    <td>{{row.role}}</td>\n                                                    <td>{{row.active ? 'Yes' : 'No'}}</td>\n\n                                                    </td>\n\n                                                    <td class=\"text-right\">\n                                                        <button class=\"btn btn-primary btn-sm btn-info\"\n                                                            style=\"padding: 6px 8px\" data-bs-target=\"#updateUsersModal\"\n                                                            href=\"#updateUsersModal\" data-bs-toggle=\"modal\"\n                                                            ng-click=\"manageusersCtrl.updateModal(row)\"\n                                                            tooltip-placement=\"top\" uib-tooltip=\"Tooltip\">\n                                                            <i class=\"fa-solid fa-edit\"\n                                                                style=\"font-weight:bold;font-size:15px;\"></i>\n                                                        </button>\n                                                        <button type=\"button\" rel=\"tooltip\"\n                                                            data-bs-target=\"#updatePasswordModal\"\n                                                            href=\"#updatePasswordModal\" data-bs-toggle=\"modal\"\n                                                            ng-click=\"manageusersCtrl.updatePModal(row.id)\"\n                                                            class=\"btn btn-warning btn-icon btn-sm\"\n                                                            ng-class=\"{'btn-disabled': row.email.endsWith('@bayareametro.gov')}\"\n                                                            ng-disabled=\"row.email.endsWith('@bayareametro.gov')\"\n                                                            data-original-title=\"\" title=\"\">\n                                                            <i class=\"fa-solid fa-lock\"\n                                                                style=\"font-weight:bold;font-size:15px;\"></i>\n                                                        </button>\n\n                                                        <button type=\"button\" rel=\"tooltip\"\n                                                            class=\"btn btn-danger btn-icon btn-sm\"\n                                                            data-bs-target=\"#deleteUserModal\" href=\"#deleteUserModal\"\n                                                            data-bs-toggle=\"modal\"\n                                                            ng-click=\"manageusersCtrl.deleteModal(row.id)\"\n                                                            data-original-title=\"\" title=\"\">\n                                                            <i class=\"fa-solid fa-trash\"\n                                                                style=\"font-weight:bold;font-size:15px;\"></i>\n                                                        </button>\n                                                    </td>\n                                                </tr>\n                                            </tbody>\n                                        </table>\n                                        <div class=\"row\">\n                                            <div class=\"col-md-6\">\n                                                <div class=\"pagination\" style=\"text-align: center; margin-top: 10px;\">\n                                                    <button class=\"btn btn-secondary me-2\"\n                                                        ng-disabled=\"currentPage === 0\" ng-click=\"currentPage = 0\">\n                                                        First\n                                                    </button>\n                                                    <button class=\"btn btn-secondary me-2\"\n                                                        ng-disabled=\"currentPage === 0\"\n                                                        ng-click=\"currentPage = currentPage - 1\">\n                                                        <i class=\"fa-solid fa-angle-left\"></i> Previous\n                                                    </button>\n                                                    <span class=\"mx-3\" style=\"font-weight: bold;\">\n                                                        Page {{currentPage + 1}} of {{numberOfPages()}}\n                                                    </span>\n                                                    <button class=\"btn btn-secondary me-2\"\n                                                        ng-disabled=\"currentPage >= numberOfPages() - 1\"\n                                                        ng-click=\"currentPage = currentPage + 1\">\n                                                        Next <i class=\"fa-solid fa-angle-right\"></i>\n                                                    </button>\n                                                    <button class=\"btn btn-secondary\"\n                                                        ng-disabled=\"currentPage >= numberOfPages() - 1\"\n                                                        ng-click=\"currentPage = numberOfPages() - 1\">\n                                                        Last\n                                                    </button>\n                                                </div>\n\n                                            </div>\n                                            <div class=\"col-md-6\">\n                                                <div style=\"float:right;\">\n                                                    <form class=\"d-inline-flex justify-content-center\"\n                                                        style=\"gap: 16px\">\n                                                        <div class=\"form-item form-item--select\">\n                                                            <select ng-model=\"pageSize\" ng-change=\"currentPage = 0\">\n                                                                <option value=\"10\" selected>10</option>\n                                                                <option value=\"20\" selected>20</option>\n                                                                <option value=\"50\">50</option>\n                                                                <option value=\"100\">100</option>\n                                                            </select>\n                                                        </div>\n                                                        <!-- <div class=\"d-inline-flex align-items-center\">\n                                                            <small>per page</small>\n                                                        </div> -->\n                                                    </form>\n                                                    <span style=\"padding-right:10px;margin:0;font-weight: bold;\">Total\n                                                        Records: {{filteredCollection.length}}</span>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter />\n        </div>\n    </div>\n</section>\n\n<!-- Users Modal -->\n<div class=\"modal fade\" id=\"updateUsersModal\" tabindex=\"-1\" aria-labelledby=\"updateUsersModalTitle\"\n    style=\"display: none;\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-body\">\n                <div class=\"tab-list-wrapper\">\n                    <nav>\n                        <div class=\"nav nav-tabs\" id=\"nav-tab\" role=\"tablist\" style=\"width: 100%;padding-left:20px;\">\n                            <button class=\"nav-link active\" id=\"user-details-tab\" data-bs-toggle=\"tab\"\n                                data-bs-target=\"#user-details\" type=\"button\" role=\"tab\" aria-controls=\"user-details\"\n                                aria-selected=\"true\">Update User</button>\n                            <button class=\"nav-link\" id=\"user-jurisdictions-tab\" data-bs-toggle=\"tab\"\n                                data-bs-target=\"#user-jurisdictions\" type=\"button\" role=\"tab\"\n                                aria-controls=\"user-jurisdictions\" aria-selected=\"false\">Jurisdictions</button>\n                        </div>\n                    </nav>\n                </div>\n\n                <div class=\"tab-content\" id=\"nav-tabContent\">\n                    <div class=\"tab-pane fade show active\" id=\"user-details\" role=\"tabpanel\"\n                        aria-labelledby=\"user-details-tab\" tabindex=\"0\">\n                        <form class=\"row test-validation-styling\" name=\"housingForm\"\n                            ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n                            <!-- First Name  -->\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"zn_code\">First Name:</label>\n                                <input type=\"text\" id=\"firstname\" name=\"firstname\" placeholder=\"\" value=\"\"\n                                    ng-model=\"updateUser.firstname\" required />\n                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                    ng-show=\"form.firstname.$error.required && formSubmitted\">\n                                    Please choose a valid response.\n                                </div>\n                            </div>\n                            <!-- Last Name  -->\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"lastname\">Last Name:</label>\n                                <input id=\"lastname\" name=\"lastname\" type=\"text\" placeholder=\"\" required\n                                    ng-model=\"updateUser.lastname\" />\n                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                    ng-show=\"form.lastname.$error.required && formSubmitted\">\n                                    Please provide a valid response.\n                                </div>\n                            </div>\n\n                            <!-- Organization  -->\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"organization\">Organization:</label>\n                                <select name=\"organization\" id=\"organization\" ng-model=\"updateUser.organization\">\n                                    <option value=\"MTC\">MTC</option>\n                                    <option ng-repeat=\"item in organizations\" ng-value=\"item.jurisdiction\">\n                                        {{item.jurisdiction}}\n                                    </option>\n                                </select>\n                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                    ng-show=\"form.organization.$error.required && formSubmitted\">\n                                    Please choose a valid response.\n                                </div>\n                            </div>\n                            <!-- Project Sponsor  -->\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"projectSponsor\">Project Sponsor:</label>\n                                <select name=\"projectSponsor\" id=\"projectSponsor\" ng-model=\"updateUser.project_sponsor\">\n                                    <option ng-repeat=\"item in sponsors\" ng-value=\"item.sponsor_name\">\n                                        {{item.sponsor_name}}\n                                    </option>\n                                </select>\n                            </div>\n\n                            <!-- Title  -->\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"title\">Title:</label>\n                                <input id=\"title\" name=\"title\" type=\"text\" placeholder=\"\" required\n                                    ng-model=\"updateUser.title\" />\n                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                    ng-show=\"form.title.$error.required && formSubmitted\">\n                                    Please provide a valid response.\n                                </div>\n                            </div>\n\n                            <!-- Phone  -->\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"phone\">Phone:</label>\n                                <input id=\"phone\" name=\"phone\" type=\"text\" placeholder=\"\" required\n                                    ng-model=\"updateUser.phone\" />\n                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                    ng-show=\"form.phone.$error.required && formSubmitted\">\n                                    Please provide a valid response.\n                                </div>\n                            </div>\n\n                            <!-- Role  -->\n                            <div class=\"form-item col-lg-12\">\n                                <label for=\"role\">Role:</label>\n                                <select name=\"role\" id=\"role\" ng-model=\"updateUser.role\">\n                                    <option value=\"Administrator\">Administrator</option>\n                                    <option value=\"CTA\">CTA</option>\n                                    <option value=\"Consultant\">Consultant</option>\n                                    <option value=\"User\">User</option>\n                                </select>\n                                <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                    ng-show=\"form.organization.$error.required && formSubmitted\">\n                                    Please choose a valid response.\n                                </div>\n                            </div>\n\n                            <div style=\"padding-left:30px;\">\n\n                                <!-- Active  -->\n                                <div class=\"form-item form-check col-lg-12\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" id=\"active\" name=\"active\"\n                                        ng-model=\"updateUser.active\" />\n                                    <label class=\"form-check-label\" for=\"active\">Activated?</label>\n                                </div>\n\n                                <!-- Basis   -->\n                                <div class=\"form-item form-check col-lg-12\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" id=\"basis_app\" name=\"basis_app\"\n                                        ng-model=\"updateUser.basis_app\" />\n                                    <label class=\"form-check-label\" for=\"basis_app\">BASIS Access</label>\n                                </div>\n\n                                <!-- TOC App  -->\n                                <div class=\"form-item form-check col-lg-12\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" id=\"toc_app\" name=\"toc_app\"\n                                        ng-model=\"updateUser.toc_app\" />\n                                    <label class=\"form-check-label\" for=\"toc_app\">TOC Access</label>\n                                </div>\n\n                                 <!-- CS App  -->\n                                 <div class=\"form-item form-check col-lg-12\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" id=\"cs_app\" name=\"cs_app\"\n                                        ng-model=\"updateUser.cs_app\" />\n                                    <label class=\"form-check-label\" for=\"cs_app\">Complete Streets Access</label>\n                                </div>\n\n                            </div>\n                            <div class=\"form-item col-lg-12\" style=\"padding-top: 20px;\">\n                                <button type=\"submit\" class=\"btn btn-primary btn-lg\"\n                                    ng-click=\"manageusersCtrl.updateUser(updateUsersForm)\">\n                                    <span ng-if=\"!saving\">Save User</span>\n                                    <span ng-if=\"saving\"><i class=\"fa-solid fa-cog fa-spin\"\n                                            style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>Saving...</span>\n                                </button>\n                                <button type=\"button\" class=\"btn btn-secondary btn-lg\"\n                                    data-bs-dismiss=\"modal\">Cancel</button>\n                            </div>\n\n                        </form>\n                    </div>\n                    <div class=\"tab-pane fade\" id=\"user-jurisdictions\" role=\"tabpanel\"\n                        aria-labelledby=\"user-jurisdictions-tab\" tabindex=\"0\">\n                        <table class=\"table table--data-table table--compliance table-borderless table-striped\">\n                            <thead class=\"table-dark\">\n                                <tr>\n                                    <th>Select</th>\n                                    <th>Jurisdiction</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in organizations\">\n                                    <td><input type=\"checkbox\" ng-model=\"item.selected\" ng-value=\"item.jurisdiction_id\">\n                                    </td>\n                                    <td>{{item.jurisdiction}}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n\n                        <div class=\"d-flex justify-content-end mt-3\">\n                            <button class=\"btn btn-primary me-2\" ng-click=\"saveSelection()\">\n                                <span ng-if=\"!saving\">Save Jurisdictions</span>\n                                <span ng-if=\"saving\"><i class=\"fa-solid fa-cog fa-spin\"\n                                        style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>\n                                    Saving...</span>\n                            </button>\n                            <button class=\"btn btn-secondary\" data-bs-dismiss=\"modal\">Cancel</button>\n                        </div>\n                    </div>\n                    <div class=\"tab-pane fade\" id=\"user-projectSponsor\" role=\"tabpanel\"\n                        aria-labelledby=\"user-projectSponsor-tab\" tabindex=\"0\">\n                        <table class=\"table table--data-table table--compliance table-borderless table-striped\">\n                            <thead class=\"table-dark\">\n                                <tr>\n                                    <th>Select</th>\n                                    <th>Sponsor</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in sponsors\">\n                                    <td><input type=\"checkbox\" ng-model=\"item.selected\" ng-value=\"item.sponsor_id\">\n                                    </td>\n                                    <td>{{item.sponsor_name}}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n\n                        <div class=\"d-flex justify-content-end mt-3\">\n                            <button class=\"btn btn-primary me-2\" ng-click=\"saveSponsorSelection()\">\n                                <span ng-if=\"!savingSponsors\">Save Sponsors</span>\n                                <span ng-if=\"savingSponsors\"><i class=\"fa-solid fa-cog fa-spin\"\n                                        style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>\n                                    Saving...</span>\n                            </button>\n                            <button class=\"btn btn-secondary\" data-bs-dismiss=\"modal\">Cancel</button>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n\n        </div>\n    </div>\n</div>\n\n\n<!-- Update Password -->\n<div class=\"modal fade\" id=\"updatePasswordModal\" tabindex=\"-1\" aria-labelledby=\"updatePasswordModalTitle\"\n    style=\"display: none;\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-body\">\n                <form name=\"updatePwdForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n                    <!-- New Password -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"newPassword\">New Password:</label>\n                        <input type=\"password\" id=\"newPassword\" name=\"newPassword\" placeholder=\"\"\n                            ng-model=\"updateUserP.newPassword\" required />\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"updatePwdForm.newPassword.$error.required && formSubmitted\">\n                            Please enter a new password.\n                        </div>\n                    </div>\n\n                    <!-- Confirm New Password -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"confirmPassword\">Confirm New Password:</label>\n                        <input type=\"password\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"\"\n                            ng-model=\"updateUserP.confirmPassword\" required />\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"updatePwdForm.confirmPassword.$error.required && formSubmitted\">\n                            Please confirm your new password.\n                        </div>\n                        <div class=\"invalid-feedback\"\n                            ng-show=\"updateUserP.newPassword !== updateUserP.confirmPassword && formSubmitted\">\n                            Passwords do not match.\n                        </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 20px;\">\n                        <button type=\"submit\" class=\"btn btn-primary btn-lg\" ng-click=\"manageusersCtrl.updateUserPwd()\"\n                            ng-disabled=\"updatePwdForm.$invalid || updateUser.newPassword !== updateUser.confirmPassword\">\n                            <span ng-if=\"!saving\">Update Password</span>\n                            <span ng-if=\"saving\"><i class=\"fa-solid fa-cog fa-spin\"\n                                    style=\"font-weight: 400;padding-left:0.25em;padding-right:0.25em;\"></i>\n                                Updating...</span>\n                        </button>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-bs-dismiss=\"modal\">Cancel</button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!-- Delete User Confirmation -->\n<div class=\"modal fade\" id=\"deleteUserModal\" tabindex=\"-1\" aria-labelledby=\"deleteUserModalTitle\" style=\"display: none;\"\n    aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" id=\"deleteUserModalTitle\">Confirm Deletion</h5>\n                <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n            </div>\n            <div class=\"modal-body\" style=\"padding:20px;\">\n                <p>Are you sure you want to delete this user? This action cannot be undone.</p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-secondary\" data-bs-dismiss=\"modal\">Cancel</button>\n                <button type=\"button\" class=\"btn btn-danger\" ng-click=\"manageusersCtrl.deleteUser()\">Delete\n                    User</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!-- Create User Modal -->\n<div class=\"modal fade\" id=\"createUserModal\" tabindex=\"-1\" aria-labelledby=\"createUserModalTitle\" style=\"display: none;\"\n    aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" id=\"createUserModalTitle\">Create New User</h5>\n                <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n            </div>\n            <div class=\"modal-body\">\n                <form name=\"createUserForm\" ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n                    <!-- Email -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"email\">Email:</label>\n                        <input type=\"email\" id=\"email\" name=\"email\" ng-model=\"newUser.email\" required />\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"createUserForm.email.$error.required && formSubmitted\">\n                            Please enter an email address.\n                        </div>\n                    </div>\n\n                    <!-- Password -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"password\">Password:</label>\n                        <input type=\"password\" id=\"password\" name=\"password\" ng-model=\"newUser.password\" required />\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"createUserForm.password.$error.required && formSubmitted\">\n                            Please enter a password.\n                        </div>\n                    </div>\n\n                    <!-- First Name -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"firstname\">First Name:</label>\n                        <input type=\"text\" id=\"firstname\" name=\"firstname\" ng-model=\"newUser.firstname\" required />\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"createUserForm.firstname.$error.required && formSubmitted\">\n                            Please enter a first name.\n                        </div>\n                    </div>\n\n                    <!-- Last Name -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"lastname\">Last Name:</label>\n                        <input type=\"text\" id=\"lastname\" name=\"lastname\" ng-model=\"newUser.lastname\" required />\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"createUserForm.lastname.$error.required && formSubmitted\">\n                            Please enter a last name.\n                        </div>\n                    </div>\n\n                    <!-- Organization  -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"add-organization\">Organization:</label>\n                        <select name=\"add-organization\" id=\"add-organization\" ng-model=\"newUser.organization\">\n                            <option value=\"MTC\">MTC</option>\n                            <option ng-repeat=\"item in organizations\" ng-value=\"item.jurisdiction\">\n                                {{item.jurisdiction}}\n                            </option>\n                        </select>\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"form.organization.$error.required && formSubmitted\">\n                            Please choose a valid response.\n                        </div> \n                    </div>\n\n                    <!-- Project Sponsor  -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"add-projectSponsor\">Project Sponsor (<i>Complete Streets only</i>):</label>\n                        <select name=\"add-projectSponsor\" id=\"add-projectSponsor\" ng-model=\"newUser.project_sponsor\">\n                            <option ng-repeat=\"item in sponsors\" ng-value=\"item.sponsor_name\">\n                                {{item.sponsor_name}}\n                            </option>\n                        </select>\n                    </div>\n\n                    <!-- Role  -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"add-role\">Role:</label>\n                        <select name=\"add-role\" id=\"add-role\" ng-model=\"newUser.role\">\n                            <option value=\"Administrator\">Administrator</option>\n                            <option value=\"CTA\">CTA</option>\n                            <option value=\"Consultant\">Consultant</option>\n                            <option value=\"User\">User</option>\n                        </select>\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"form.add-role.$error.required && formSubmitted\">\n                            Please choose a valid response.\n                        </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 20px;\">\n                        <button type=\"submit\" class=\"btn btn-primary btn-lg\"\n                            ng-click=\"manageusersCtrl.createUser(newUser)\" ng-disabled=\"createUserForm.$invalid\">\n                            <span ng-if=\"!saving\">Create User</span>\n                            <span ng-if=\"saving\"><i class=\"fa-solid fa-cog fa-spin\"\n                                    style=\"font-weight: 400; padding-left: 0.25em; padding-right: 0.25em;\"></i>Creating...</span>\n                        </button>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-bs-dismiss=\"modal\">Cancel</button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StationsComponent = undefined;
	
	var _stations = __webpack_require__(165);
	
	var _stations2 = _interopRequireDefault(_stations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var StationsComponent =
	/*@ngInject*/
	exports.StationsComponent = function StationsComponent() {
	  _classCallCheck(this, StationsComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.stations', [uiRouter]).config(_stations2.default).component('stations', {
	  template: __webpack_require__(166),
	  controller: StationsComponent,
	  controllerAs: 'stationsCtrl'
	}).name;

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('stations', {
	    url: '/admin/stations',
	    template: '<stations></stations>'
	  });
	};

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports = "<div>This is the stations view.</div>\n"

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StationaccessComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _stationaccess = __webpack_require__(168);
	
	var _stationaccess2 = _interopRequireDefault(_stationaccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var StationaccessComponent = exports.StationaccessComponent = function () {
	  /*@ngInject*/
	  function StationaccessComponent($state, $scope, navService, lookup, fetch, userService, $stateParams) {
	    _classCallCheck(this, StationaccessComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.navService = navService;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$stateParams = $stateParams;
	    this.userService = userService;
	    this.$scope.activityType = 'Station Area Access';
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	        if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	
	    $scope.getStationbyID = function (station) {
	      $scope.loadingSummaries = true;
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Station Area Access').then(function (response) {
	
	        $scope.stationCompleteStreets = _.filter(response.data, { 'submission_policy_name': 'Complete Streets Policy' });
	        $scope.stationGapAnalysis = _.filter(response.data, { 'submission_policy_name': 'Gap Analysis' });
	        $scope.stationProjectPrioritization = _.filter(response.data, { 'submission_policy_name': 'Project Prioritization' });
	        $scope.stationMobilityHubPlanning = _.filter(response.data, { 'submission_policy_name': 'Mobility Hub Planning' });
	        $scope.loadingSummaries = false;
	        $scope.getActivity();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getActivity = function () {
	      var activityData = [];
	      fetch.getAllItems('api/data/submission/activity/' + $scope.currentSelectedStationId + '/' + $scope.activityType).then(function (response) {
	
	        $scope.submissionActivity = response.data;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	  }
	
	  _createClass(StationaccessComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Compliant' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Compliant' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Compliant' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Compliant' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return StationaccessComponent;
	}();
	
	exports.default = angular.module('websiteApp.stationaccess', [uiRouter]).config(_stationaccess2.default).component('stationaccess', {
	  template: __webpack_require__(169),
	  controller: StationaccessComponent,
	  controllerAs: 'stationaccessCtrl'
	}).name;

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('stationaccess', {
	    url: '/account/stationaccess?jurisdiction&sta_recid',
	    template: '<stationaccess></stationaccess>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null }
	  });
	};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--page dashboard--page--submission\">\n    <div class=\"page-wrapper\">\n        <div class=\"dashboard-header\">\n            <!-- Sidebarnav source components/directives/sidebarnav  -->\n            <sidebarnav></sidebarnav>\n        </div>\n        <div class=\"main\">\n            <mainheaderauth></mainheaderauth>\n            <breadcrumbnav></breadcrumbnav>\n            <maintocselection />\n\n            <div class=\"container\" style=\"margin-left:242px;max-width: calc(100vw-242);\">\n                <div class=\"row content--style\">\n                    <div class=\"col-lg-8\">\n                        <h1 class=\"page-title\">Station Access and Circulation</h1>\n\n                        <!-- Notifications  -->\n                        <div class=\"row\" ng-show=\"!currentSelectedStationId\"\n                            style=\"padding-top:5px;padding-bottom:15px;\">\n                            <div class=\"col\">\n                                <div class=\"alert alert-danger fade show\" role=\"alert\">\n                                    <strong>Please select a station area... </strong>\n                                </div>\n                            </div>\n                        </div>\n                        <p>The TOC Policy seeks to facilitate robust multi-modal access to transit stations. This\n                            supports increased residential and commercial density in TOC areas and enables people living\n                            or working outside the TOC area to use the region’s transit network for more of their trips.\n                        </p>\n\n                        <p>To advance these goals, a jurisdiction must take the following actions in its TOC areas to meet TOC standards:</p>\n\n                        <h3>Complete Streets and Active Transportation</h3>\n                        <p>\n                        <ul>\n                            <li>\n                                Adopt a jurisdiction-wide Complete Streets Policy.\n                            </li>\n                            <li>\n                                Prioritize implementation of “All Ages and Abilities” active transportation projects\n                                on the regional\n                                <a href=\"https://mtc.maps.arcgis.com/apps/mapviewer/index.html?webmap=8c0efbb322804b06ba8820f1672bd79f\"\n                                    ttarget=\"_blank\" rel=\"noopener noreferrer\">Active Transportation Network <span class=\"visually-hidden\">(link is\n                                        external, opens in a new window)</span></a>\n                                and/or any relevant\n                                <a href=\"https://mtc.ca.gov/planning/transportation/access-equity-mobility/community-based-transportation-plans-cbtps\"\n                                    target=\"_blank\" rel=\"noopener noreferrer\">Community Based Transportation Plans<span\n                                        class=\"visually-hidden\">(link is external, opens in a new window)</span></a>\n                                within the TOC area in its\n                                capital improvement program (CIP).\n                            </li>\n                        </ul>\n                        </p>\n                        <h3>Access Gap Analysis</h3>\n                        <p>Complete an access gap analysis and accompanying capital and/or service improvement\n                            program for station access from destinations within a 10-minute travel time (accounting\n                            for\n                            differences in travel speed and time for people who use wheelchairs or other mobility\n                            aids), and 15-minute bicycle or bus/shuttle trip. </p>\n\n                        <h3>Mobility Hubs</h3>\n                        <p>Identify opportunities for Mobility Hub planning and implementation as described in the\n                            <a href=\"https://mtc.ca.gov/sites/default/files/MTC Mobility Hub Implementation Playbook_4-30-21.pdf\"\n                                target=\"_blank\">Mobility Hub Implementation Playbook.<span class=\"visually-hidden\">(link\n                                    is external, opens in a new window)</span></a>\n                        </p>\n                        <p>\n                        See the <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" target=\"_blank\" rel=\"noopener noreferrer\">TOC Policy Administrative Guidance</a> for more details. To assist with the submittal, several template forms are available at this <a href=\"https://abag.ca.gov/technical-assistance/transit-oriented-communities-toc-jurisdiction-staff-resources\">webpage</a>.  \n                        </p>\n\n                        <p>Review <a\n                                href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\"\n                                target=\"_blank\" rel=\"noopener noreferrer\" >Section 3 of the TOC Policy Administrative Guidance<span\n                                    class=\"visually-hidden\">(link is external, opens in a new window)</span></a> for\n                            the full\n                            details about TOC Policy requirements for station access and circulation.</p>\n                    </div>\n                    <div class=\"col-lg-4\" style=\"padding-top: 40px\">\n                        <div class=\"right-content\">\n                            <h2>Activity</h2>\n                            <!-- sidebaractivity source /components/directives/sidebaractivity  -->\n                            <sidebaractivity></sidebaractivity>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n            <div class=\"footer\" role=\"contentinfo\">\n                <sidebarfooter></sidebarfooter>\n            </div>\n        </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StationRequirementsComponent = undefined;
	
	var _station_requirements = __webpack_require__(171);
	
	var _station_requirements2 = _interopRequireDefault(_station_requirements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var StationRequirementsComponent =
	/*@ngInject*/
	exports.StationRequirementsComponent = function StationRequirementsComponent() {
	  _classCallCheck(this, StationRequirementsComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.station_requirements', [uiRouter]).config(_station_requirements2.default).component('stationRequirements', {
	  template: __webpack_require__(172),
	  controller: StationRequirementsComponent,
	  controllerAs: 'stationRequirementsCtrl'
	}).name;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('station_requirements', {
	    url: '/account/stationaccess/station_requirements',
	    template: '<station-requirements></station-requirements>',
	    authenticate: true
	  });
	};

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--content--housing\">\n  <div class=\"page-wrapper\">\n      <div class=\"dashboard-header\">\n        <!-- Sidebarnav source components/directives/sidebarnav  -->\n          <sidebarnav></sidebarnav>\n      </div>\n      <div class=\"main\">\n        <!-- mainheaderauth source components/directives/mainheaderauth  -->\n          <mainheaderauth></mainheaderauth>\n          <div class=\"content container\">\n              <div class=\"row\">\n                  <div class=\"col-lg-8\">\n                      <h1 class=\"page-title\">Station Area Requirements </h1>\n                      <div class=\"page-summary\">Affordable Housing Production, Preservation, and Protection and Commercial Stabilization</div>\n                      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                      <figure>\n                          <img class=\"image--full\" src=\"../../../assets/images/mockups/dashboard-content-image.jpg\" alt=\"Person wearing a mask and helmet on a bike\" height=\"730\" width=\"410\"/>\n                          <figcaption>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. <span class=\"image-credit\">Credit: Sergio Ruiz</span></figcaption>\n                      </figure>\n\n                      <h2><a href=\"#\">Further Guidance H2</a></h2>\n                      <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n\n                      <h2><a href=\"#\">Affordable Housing Production Policy</a></h2>\n                      <p>Sum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                  </div>\n                 \n              </div>\n          </div>\n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n          <sidebarfooter></sidebarfooter>\n      </div>\n  </div>\n</section>\n"

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnalysisImprovementProgramComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _analysis_improvement_program = __webpack_require__(174);
	
	var _analysis_improvement_program2 = _interopRequireDefault(_analysis_improvement_program);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var AnalysisImprovementProgramComponent = exports.AnalysisImprovementProgramComponent = function () {
	  /*@ngInject*/
	  function AnalysisImprovementProgramComponent($state, $scope, $rootScope, fetch, lookup, userService, $timeout, baseConfigService, $http, $stateParams) {
	    _classCallCheck(this, AnalysisImprovementProgramComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.$state = $state;
	    this.lookup = lookup;
	    this.userService = userService;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$http = $http;
	    this.baseConfigService = baseConfigService;
	
	    $scope.adminUnlocked = false;
	    $scope.submissions = [];
	    $scope.stationaccess = {};
	    $scope.attachmentData = $scope.attachmentData || {};
	
	    $scope.savemode = null;
	
	    $scope.initialLoad = true;
	
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.submitmode = null;
	
	    $scope.type = 'Access Gap Analysis';
	
	    $scope.pendingChanges = false;
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.setPending = function () {
	      console.log('set pending ran');
	      console.log($scope.initialLoad);
	      if (!$scope.initialLoad) {
	        $scope.savemode = 'stationaccess';
	        $scope.pendingChanges = true;
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentStationPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.stationAccessStatus) {
	        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
	          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
	            submission = $scope.stationAccessStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentStationPolicy;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.stationAccessStatus && $scope.currentStationPolicy && $scope.currentStationPolicy.policy_name) {
	        var sub = _.find($scope.stationAccessStatus, { submission_policy_name: $scope.currentStationPolicy.policy_name });
	        if (sub && sub.submitted && sub.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('stationAccessStatus', function () {
	      if (!$scope.currentStationPolicy) return;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm('Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.');
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.stationAccessStatus) {
	        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
	          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
	            submission = $scope.stationAccessStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error('No matching submission found to withdraw');
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', payload).then(function () {
	
	        submission.submitted = false;
	        submission.status = null;
	
	        var formId = $scope.currentStationPolicy ? $scope.currentStationPolicy.stationaccess_form_id : null;
	        var policyName = $scope.currentStationPolicy ? $scope.currentStationPolicy.policy_name : null;
	        $scope.currentStationPolicy = { stationaccess_form_id: formId, policy_name: policyName };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	
	        $scope.formReadOnly = false;
	      }).catch(function (err) {
	        console.error('Withdraw failed:', err);
	        alert('There was an error withdrawing the submission. Please try again.');
	      });
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'stationaccess';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Station Area Access').then(function (response) {
	        $scope.stationAccessStatus = response.data;
	        console.log('Station Access status response:', response.data);
	        $scope.checkStationAccess = _.filter(response.data, { submission_policy_name: 'Gap Analysis' })[0];
	
	        console.log('Loaded policy submissions:', $scope.stationAccessStatus);
	
	        $scope.stationGapAnalysisCheck = !!_.filter(response.data, {
	          submission_policy_name: 'Gap Analysis', submitted: true
	        })[0];
	
	        if ($scope.stationaccess) {
	          $scope.stationaccess.stationGapAnalysisCheck = $scope.stationGapAnalysisCheck;
	        }
	
	        $scope.formReadOnly = !$scope.isFormEditable();
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	      $scope.getSubmissionStatus();
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Station Area Access').then(function (response) {
	
	        $scope.currentStation = response.data[0];
	
	        $scope.stationCompleteStreets = _.filter(response.data, { submission_policy_name: 'Complete Streets Policy' });
	        if ($scope.stationCompleteStreets.length > 0) {
	          $scope.stationCompleteStreets.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.completeStreetsCheck = true;
	            }
	          });
	        }
	        $scope.stationGapAnalysis = _.filter(response.data, { submission_policy_name: 'Gap Analysis' });
	        if ($scope.stationGapAnalysis.length > 0) {
	          $scope.stationGapAnalysis.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.stationGapAnalysisCheck = true;
	            }
	          });
	        }
	        $scope.stationProjectPrioritization = _.filter(response.data, { submission_policy_name: 'Project Prioritization' });
	        if ($scope.stationProjectPrioritization.length > 0) {
	          $scope.stationProjectPrioritization.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.projectCheck = true;
	            }
	          });
	        }
	        $scope.stationMobilityHubPlanning = _.filter(response.data, { submission_policy_name: 'Mobility Hub Planning' });
	        if ($scope.stationMobilityHubPlanning.length > 0) {
	          $scope.stationMobilityHubPlanning.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.mobilityCheck = true;
	            }
	          });
	        }
	        return $scope.getCurrentStationPolicy($scope.type);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        }
	
	        if ($scope.currentSelectedStationId) {
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getCurrentStationPolicy = function (type) {
	      if (type) {
	        $scope.type = type;
	      }
	
	      fetch.getAllItems('api/data/getAccessForm/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + encodeURIComponent($scope.type)).then(function (response) {
	
	        console.log(response);
	
	        $scope.currentStationPolicy = response.data[0];
	
	        console.log('stationaccess_form_id:', $scope.currentStationPolicy.stationaccess_form_id);
	        if (type === 'Access Gap Analysis') {
	          if ($scope.currentStationPolicy.transit_agency_plan) {
	            $scope.transit_agency_plan_checked = true;
	          }
	          if ($scope.currentStationPolicy.adopted_pda_precise_specific) {
	            $scope.adopted_pda_precise_specific_checked = true;
	          }
	          if ($scope.currentStationPolicy.adopted_active_transit_bike) {
	            $scope.adopted_active_transit_bike_checked = true;
	          }
	          if ($scope.currentStationPolicy.gen_plan_circulation_element) {
	            $scope.gen_plan_circulation_element_checked = true;
	          }
	        }
	        $scope.initialLoad = false;
	        console.log($scope.initialLoad);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentStationPolicy = function () {
	
	      $scope.formSubmitted = true;
	      if (stationAccessForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      $scope.currentStationPolicy.jurisdiction = $scope.currentJurisdiction;
	      $scope.currentStationPolicy.sta_recid = $scope.currentSelectedStationId;
	      $scope.currentStationPolicy.type = $scope.type;
	
	      if (!$scope.currentStationPolicy.stationaccess_form_id) {
	        console.error('stationaccess_form_id is missing');
	        return;
	      }
	
	      console.log('Payload being sent:', $scope.currentStationPolicy);
	
	      fetch.updateItem('api/data/access/forms/update', $scope.currentStationPolicy).then(function (response) {
	        $scope.saved = true;
	        $scope.saving = false;
	        setTimeout(function () {
	          $scope.savemode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.submitStationAccess = function () {
	      console.log($scope.stationaccess.completeStreetsCheck);
	      $scope.formSubmitted = true;
	      $scope.saving = true;
	      var upsertData = [];
	
	      $scope.upsertData = [];
	
	      console.log("submissing", $scope.stationaccess.mobilityCheck, $scope.stationMobilityHubPlanning.length);
	      if ($scope.stationaccess.mobilityCheck && $scope.stationMobilityHubPlanning.length > 0) {
	        $scope.stationMobilityHubPlanning.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_mobility_hub_planning: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      console.log(upsertData);
	
	      if ($scope.stationaccess.projectCheck && $scope.stationProjectPrioritization.length > 0) {
	        $scope.stationProjectPrioritization.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_project_prioritization: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.stationaccess.stationGapAnalysisCheck && $scope.stationGapAnalysis.length > 0) {
	        $scope.stationGapAnalysis.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_gap_analysis: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.stationaccess.completeStreetsCheck && $scope.stationCompleteStreets.length > 0) {
	        $scope.stationCompleteStreets.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_complete_streets: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saving = false;
	        $scope.submissions = [];
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	
	        $scope.getSubmissionStatus();
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 2000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById('fileInput' + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
	            alert('Please select a PDF, Word document, or Excel file.');
	            element.value = '';
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById('' + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope[ngmodel] = '';
	        $scope[ngmodel + '_preview'] = '';
	        $scope['fileUploading_' + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope['fileUploading_' + ngmodelfile] = true;
	      var file = document.getElementById('' + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentStationPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentStationPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'stationaccess';
	      $scope.pendingChanges = true;
	    };
	  }
	
	  _createClass(AnalysisImprovementProgramComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return AnalysisImprovementProgramComponent;
	}();
	
	exports.default = angular.module('appApp.analysis_improvement_program', [uiRouter]).config(_analysis_improvement_program2.default).component('analysisImprovementProgram', {
	  template: __webpack_require__(175),
	  controller: AnalysisImprovementProgramComponent,
	  controllerAs: 'analysisImprovementProgramCtrl'
	}).name;

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('analysis_improvement_program', {
	    url: '/account/stationaccess/analysis_improvement_program?jurisdiction&sta_recid',
	    template: '<analysis-improvement-program></analysis-improvement-program>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null }
	  });
	};

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <maintocselection />\n\n      <div class=\"content container\">\n        <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <p>\n          The TOC Policy seeks to facilitate robust multi-modal access to\n          transit stations. This supports increased residential and commercial\n          density in TOC areas and enables people living or working outside the\n          TOC area to use the region’s transit network for more of their trips.\n        </p>\n\n        <p>\n          Jurisdiction-wide or county-wide documents such as active transportation, bicycle, pedestrian plans or General Plan Circulation Elements may only be submitted as evidence of compliance if they include details for specific improvements within the TOC area and should be noted upon submittal. \n        </p>\n\n        <div class=\"alert alert-warning\" ng-if=\"!currentSelectedStationId\" role=\"alert\">\n          Please select a station area\n        </div>\n\n        <div class=\"section-nav\">\n          <div class=\"menu--section-title\">In this section:</div>\n          <ul class=\"menu menu--section\" role=\"tablist\">\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\" class=\"menu-item menu-item--section active\">\n              <span class=\"section-number\">I.</span>\n              <a href=\"#\">Access Gap Analysis and Capital and/or Service Improvement\n                Program</a>\n            </li>\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit\" class=\"menu-item menu-item--section\"\n              ng-click=\"reviewAndSubmit == true\">\n              <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n            </li>\n          </ul>\n          <note ng-show=\"note\"></note>\n          <furtherguidance></furtherguidance>\n        </div>\n        <div class=\"tab-content\" ng-if=\"currentSelectedStationId\">\n          <!-- Access Gap Analysis and Capital/Service Improvement Program Section -->\n          <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\"\n            ng-class=\"{'active show': showPanel === 'stationGapAnalysis'}\" ng-class=\"{'was-validated': formSubmitted}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Access Gap Analysis and Capital and/or Service Improvement Program</h2>\n              <statuspills ng-repeat=\"submission in stationAccessStatus\"\n              ng-if=\"submission.submission_policy_name === currentStationPolicy.policy_name && submission.submitted === true\"\n              status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n            </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, submitted: true})[0] && !(stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p style=\"padding-top: 15px\">\n              <b>MTC staff have created a <a target=\"_blank\" href=\"https://abag.ca.gov/tools-resources/digital-library/access-gap-analysis-submission-formdocx\" rel=\"noopener noreferrer\">template\n              form</a> to help local jurisdictions with organizing the required documentation.</b> Please download\n              the template, follow the instructions included, and fill out all applicable fields within the\n              template form. After completing the form, click on the checkbox below to upload it.\n            </p>\n\n            <form class=\"row test-validation-styling\" name=\"stationAccessForm\" novalidate>\n              <div class=\"form-item col-lg-12\" style=\"padding-left: 18px\">\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkAdoptedPda\"\n                      ng-model=\"adopted_pda_precise_specific_checked\" ng-disabled=\"formReadOnly\"\n                      onchange=\"angular.element(this).scope().setPending(this)\" />\n                    <label class=\"form-check-label\" for=\"checkAdoptedPda\"\n                      ng-class=\"{'boldFont': adopted_pda_precise_specific_checked}\">\n                      Click to submit completed Access Gap Analysis Submission Template Form\n                    </label>\n                  </div>\n                  <div class=\"row align-items-center\" ng-show=\"adopted_pda_precise_specific_checked\">\n                    <!-- <div class=\"col-lg-1\" style=\"padding-top: 20px\"\n                      ng-if=\"!checkSubstring(currentStationPolicy.adopted_pda_precise_specific)\">\n                      <label>URL</label>\n                    </div>\n                    <div class=\"col-lg-7 col-md-6\" ng-if=\"!checkSubstring(currentStationPolicy.adopted_pda_precise_specific)\">\n                    \n                      <textarea ng-model=\"currentStationPolicy.adopted_pda_precise_specific\"\n                        id=\"adopted_pda_precise_specific\" onchange=\"angular.element(this).scope().setPending(this)\"\n                        name=\"adopted_pda_precise_specific\" rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\"\n                        required>\n                        </textarea>\n                      <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                        ng-show=\"stationAccessForm.adopted_pda_precise_specific.$error.required && formSubmitted\">\n                        Please provide a valid response or URL.\n                      </div>\n                    </div>\n                    <div ng-if=\"!checkSubstring(currentStationPolicy.adopted_pda_precise_specific)\" style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"\n                      style=\"padding-left: 50px;\"><b>OR</b></div> -->\n                    <!-- File upload adopted_pda_precise_specific -->\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentStationPolicy.adopted_pda_precise_specific)\"\n                      style=\"padding-bottom: 10px\">\n                      <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                          ng-href=\"{{currentStationPolicy.adopted_pda_precise_specific}}\">Uploaded\n                          Template Form</a></span>\n                      <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('adopted_pda_precise_specific')\">\n                        <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                        Remove\n                      </button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom: 20px; padding-top: 20px\"\n                      ng-if=\"!checkSubstring(currentStationPolicy.adopted_pda_precise_specific)\">\n                      <div class=\"col-lg-3\"><label for=\"adopted_pda_precise_specific_file_abcd\">Upload Access Gap Analysis Submission Template Form</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n\n                        <input type=\"file\" ng-model=\"adopted_pda_precise_specific_file_abcd\"\n                          id=\"adopted_pda_precise_specific_file_abcd\" name=\"adopted_pda_precise_specific_file_abcd\"\n                          accept=\".pdf, .doc, .docx, .xls, .xlsx\" ng-disabled=\"formReadOnly\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-4\" ng-if=\"!formReadOnly\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('adopted_pda_precise_specific_file_abcd')\">\n                          <i ng-show=\"fileUploading_adopted_pda_precise_specific_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File\n                        </button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('adopted_pda_precise_specific_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                      <label>Additional Details <i>(Optional)</i>:</label>\n                      <textarea id=\"adopted_pda_precise_specific_details\" name=\"adopted_pda_precise_specific_details\" ng-disabled=\"formReadOnly\"\n                        rows=\"4\" style=\"width: 100%\" ng-model=\"currentStationPolicy.adopted_pda_precise_specific_details\"\n                        onchange=\"angular.element(this).scope().setPending(this)\">\n                      </textarea>\n                    </div>\n                  </div>\n                </div>\n                <!-- <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" id=\"checkTransitAgency\"\n                      ng-model=\"transit_agency_plan_checked\"\n                      onchange=\"angular.element(this).scope().setPending(this)\" />\n                    <label class=\"form-check-label\" for=\"checkTransitAgency\"\n                      ng-class=\"{'boldFont': transit_agency_plan_checked}\">\n                      Transit agency station access plans.\n                    </label>\n                  </div>\n                  <div class=\"row align-items-center\" ng-show=\"transit_agency_plan_checked\">\n                    <div class=\"col-lg-1\" ng-if=\"!checkSubstring(currentStationPolicy.transit_agency_plan)\">\n                      <label>URL</label>\n                    </div>\n                    <div class=\"col-lg-7 col-md-6\" ng-if=\"!checkSubstring(currentStationPolicy.transit_agency_plan)\">\n                     \n                      <textarea ng-model=\"currentStationPolicy.transit_agency_plan\" id=\"transit_agency_plan\"\n                        onchange=\"angular.element(this).scope().setPending(this)\" name=\"transit_agency_plan\" rows=\"4\"\n                        style=\"width: 100%;\" placeholder=\"Enter response or URL\" required>\n                        </textarea>\n                      <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                        ng-show=\"stationAccessForm.transit_agency_plan.$error.required && formSubmitted\">\n                        Please provide a valid response or URL.\n                      </div>\n                    </div>\n                    <div ng-if=\"!checkSubstring(currentStationPolicy.transit_agency_plan)\" style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"\n                      style=\"padding-left: 50px\"><b>OR</b></div>\n                    File upload transit_agency_plan\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentStationPolicy.transit_agency_plan)\"\n                      style=\"padding-bottom: 10px\">\n                      <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                          ng-href=\"{{currentStationPolicy.transit_agency_plan}}\">Uploaded Documentation</a></span>\n                      <button class=\"button button--attach\" ng-click=\"removeFile('transit_agency_plan')\">\n                        <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                        Remove\n                      </button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom: 20px; padding-top: 20px\"\n                      ng-if=\"!checkSubstring(currentStationPolicy.transit_agency_plan)\">\n                      <div class=\"col-lg-3\"><label for=\"transit_agency_plan_file_abcd\">Upload Access Gap Analysis Submission Template Form</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n\n                        <input type=\"file\" ng-model=\"transit_agency_plan_file_abcd\" id=\"transit_agency_plan_file_abcd\"\n                          name=\"transit_agency_plan_file_abcd\" accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-4\">\n                        <button class=\"button button--attach\" ng-click=\"uploadFile('transit_agency_plan_file_abcd')\">\n                          <i ng-show=\"fileUploading_transit_agency_plan_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File\n                        </button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('transit_agency_plan_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                      <label>Additional Details <i>(Optional)</i>:</label>\n                      <textarea id=\"transit_agency_plan_details\" name=\"transit_agency_plan_details\" rows=\"4\" style=\"width: 100%;\"\n                        ng-model=\"currentStationPolicy.transit_agency_plan_details\"\n                        onchange=\"angular.element(this).scope().setPending(this)\">\n                      </textarea>\n                    </div>\n                  </div>\n                </div> -->\n              </div>\n            </form>\n            <!-- <h3>\n              However, if these plans haven't been completed for the TOC area, a\n              jurisdiction may submit:\n            </h3>\n            <form class=\"row test-validation-styling\" name=\"stationAccessForm\" novalidate>\n              <div class=\"form-item col-lg-12\" style=\"padding-left: 18px\">\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" id=\"checkAdoptedActiveTransit\"\n                      ng-model=\"adopted_active_transit_bike_checked\"\n                      onchange=\"angular.element(this).scope().setPending(this)\" />\n                    <label class=\"form-check-label\" for=\"checkAdoptedActiveTransit\"\n                      ng-class=\"{'boldFont': adopted_active_transit_bike_checked}\">\n                      Adopted active transportation, bicycle or pedestrian\n                      plan(s) that include recommended access improvements\n                      to/from the TOC area.\n                    </label>\n                  </div>\n                  <div class=\"row align-items-center\" ng-show=\"adopted_active_transit_bike_checked\">\n                    <div class=\"col-lg-1\" ng-if=\"!checkSubstring(currentStationPolicy.adopted_active_transit_bike)\">\n                      <label>URL</label>\n                    </div>\n                    <div class=\"col-lg-7 col-md-6\" ng-if=\"!checkSubstring(currentStationPolicy.adopted_active_transit_bike)\">\n                   \n                      <textarea ng-model=\"currentStationPolicy.adopted_active_transit_bike\"\n                        id=\"adopted_active_transit_bike\" placeholder=\"Enter response or URL\"\n                        onchange=\"angular.element(this).scope().setPending(this)\" name=\"adopted_active_transit_bike\"\n                        rows=\"4\" style=\"width: 100%;\" required>\n                        </textarea>\n                      <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                        ng-show=\"stationAccessForm.adopted_active_transit_bike.$error.required && formSubmitted\">\n                        Please provide a valid response or URL.\n                      </div>\n                    </div>\n                    <div ng-if=\"!checkSubstring(currentStationPolicy.adopted_active_transit_bike)\" style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"\n                      style=\"padding-left: 50px;\"><b>OR</b></div>\n                    File upload adopted_active_transit_bike\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentStationPolicy.adopted_active_transit_bike)\"\n                      style=\"padding-bottom: 10px\">\n                      <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                          ng-href=\"{{currentStationPolicy.adopted_active_transit_bike}}\">Uploaded\n                          Template Form</a></span>\n                      <button class=\"button button--attach\" ng-click=\"removeFile('adopted_active_transit_bike')\">\n                        <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                        Remove\n                      </button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom: 20px; padding-top: 20px\"\n                      ng-if=\"!checkSubstring(currentStationPolicy.adopted_active_transit_bike)\">\n                      <div class=\"col-lg-3\"><label for=\"adopted_active_transit_bike_file_abcd\">Upload Access Gap Analysis Submission Template Form</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                        <input type=\"file\" ng-model=\"adopted_active_transit_bike_file_abcd\"\n                          id=\"adopted_active_transit_bike_file_abcd\" name=\"adopted_active_transit_bike_file_abcd\"\n                          accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-4\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('adopted_active_transit_bike_file_abcd')\">\n                          <i ng-show=\"fileUploading_adopted_active_transit_bike_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File\n                        </button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('adopted_active_transit_bike_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                      <label>Additional Details <i>(Optional)</i>:</label>\n                      <textarea id=\"adopted_active_transit_bike_details\" name=\"adopted_active_transit_bike_details\"\n                        ng-model=\"currentStationPolicy.adopted_active_transit_bike_details\"\n                        onchange=\"angular.element(this).scope().setPending(this)\" rows=\"4\" style=\"width: 100%;\">\n                      </textarea>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" id=\"checkApplicableSections\"\n                      ng-model=\"gen_plan_circulation_element_checked\"\n                      onchange=\"angular.element(this).scope().setPending(this)\" />\n                    <label class=\"form-check-label\" for=\"checkApplicableSections\"\n                      ng-class=\"{'boldFont': gen_plan_circulation_element_checked}\">\n                      Applicable sections of General Plan Circulation Element\n                      that highlight specific elements that guide or inform\n                      station access improvements\n                    </label>\n                  </div>\n                  <div class=\"row align-items-center\" ng-show=\"gen_plan_circulation_element_checked\">\n                    <div class=\"col-lg-1\" ng-if=\"!checkSubstring(currentStationPolicy.gen_plan_circulation_element)\">\n                      <label>URL</label>\n                    </div>\n                    <div class=\"col-lg-7 col-md-6\" ng-if=\"!checkSubstring(currentStationPolicy.gen_plan_circulation_element)\">\n                      \n                      <textarea ng-model=\"currentStationPolicy.gen_plan_circulation_element\"\n                        id=\"gen_plan_circulation_element\" placeholder=\"Enter response or URL\"\n                        onchange=\"angular.element(this).scope().setPending(this)\" name=\"gen_plan_circulation_element\"\n                        rows=\"4\" style=\"width: 100%;\" required>\n                        </textarea>\n                      <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                        ng-show=\"stationAccessForm.gen_plan_circulation_element.$error.required && formSubmitted\">\n                        Please provide a valid response or URL.\n                      </div>\n                    </div>\n                    <div ng-if=\"!checkSubstring(currentStationPolicy.gen_plan_circulation_element)\" style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"\n                      style=\"padding-left: 50px;\"><b>OR</b></div>\n                    File upload gen_plan_circulation_element\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentStationPolicy.gen_plan_circulation_element)\"\n                      style=\"padding-bottom: 10px\">\n                      <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                          ng-href=\"{{currentStationPolicy.gen_plan_circulation_element}}\">Uploaded\n                          Template Form</a></span>\n                      <button class=\"button button--attach\" ng-click=\"removeFile('gen_plan_circulation_element')\">\n                        <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                        Remove\n                      </button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom: 20px; padding-top: 20px\"\n                      ng-if=\"!checkSubstring(currentStationPolicy.gen_plan_circulation_element)\">\n                      <div class=\"col-lg-3\"><label for=\"gen_plan_circulation_element_file_abcd\">Upload Access Gap Analysis Submission Template Form</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                        <input type=\"file\" ng-model=\"gen_plan_circulation_element_file_abcd\"\n                          id=\"gen_plan_circulation_element_file_abcd\" name=\"gen_plan_circulation_element_file_abcd\"\n                          accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-4\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('gen_plan_circulation_element_file_abcd')\">\n                          <i ng-show=\"fileUploading_gen_plan_circulation_element_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File\n                        </button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('gen_plan_circulation_element_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                      <label>Additional Details <i>(Optional)</i>:</label>\n                      <textarea id=\"gen_plan_circulation_element_details\" name=\"gen_plan_circulation_element_details\"\n                        rows=\"4\" style=\"width: 100%;\" onchange=\"angular.element(this).scope().setPending(this)\"\n                        ng-model=\"currentStationPolicy.gen_plan_circulation_element_details\">\n                      </textarea>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <submissionsectionsubmit></submissionsectionsubmit>\n            </form> -->\n          </div>\n\n          <!-- Review and submit  -->\n          <div id=\"section-review-submit\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': reviewAndSubmit}\">\n            <h2>Review and Submit</h2>\n            <p>\n              <span style=\"font-style: italic\">\n                Select policies below to submit to MTC for review.</span>\n            </p>\n\n            <form class=\"row test-validation-styling\" novalidate style=\"margin-left: 2px\">\n              <!-- Complete Streets  -->\n              <div class=\"verification-container\">\n                <div class=\"form-check\">\n                  <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"stationGapAnalysisCheck\"\n                    ng-model=\"stationaccess.stationGapAnalysisCheck\" ng-click=\"addToSubmissions('stationGapAnalysis')\"\n                    ng-disabled=\"stationaccess.stationGapAnalysisCheck === true\" />\n                  <label class=\"form-check-label\" for=\"stationGapAnalysisCheck\"\n                    ng-class=\"{'boldFont': stationaccess.stationGapAnalysisCheck}\">\n                    Access Gap Analysis and Capital and/or Service Improvement\n                    Program <span ng-if=\"stationaccess.stationGapAnalysisCheck === true\"\n                                        class=\"badge badge--submitted\">Submitted</span>\n                  </label>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"stationaccess.stationGapAnalysisCheck\">\n                  <p>\n                    I have completed the Compliance with MTC's <a href=\"#\"\n                      ng-click=\"togglePanel('stationGapAnalysis')\">Access Gap\n                      Analysis and Capital and/or Service Improvement Program Section</a>\n                    and uploaded any relevant documentation.\n                  </p>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"stationGapAnalysis[0].submitted\">\n                  <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                    <div class=\"col\">\n                      <div class=\"alert alert-success fade show\" role=\"alert\">\n                        This policy has been submitted and is under review.\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </form>\n            <submissionsectionsubmit></submissionsectionsubmit>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"footer\" role=\"contentinfo\">\n    <sidebarfooter></sidebarfooter>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompleteStreetsComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _complete_streets = __webpack_require__(177);
	
	var _complete_streets2 = _interopRequireDefault(_complete_streets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var CompleteStreetsComponent = exports.CompleteStreetsComponent = function () {
	  /*@ngInject*/
	  function CompleteStreetsComponent($state, $scope, $rootScope, fetch, lookup, userService, $timeout, $http, baseConfigService, $stateParams) {
	    _classCallCheck(this, CompleteStreetsComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.userService = userService;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$http = $http;
	    this.baseConfigService = baseConfigService;
	
	    $scope.adminUnlocked = false;
	    $scope.submissions = [];
	    $scope.stationaccess = {};
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.savemode = null;
	
	    $scope.initialLoad = true;
	
	    $scope.baseUrl = baseConfigService.getBaseURL();
	    $scope.completeStreetsCheck = false;
	
	    $scope.submitmode = null;
	
	    $scope.type = 'Complete Streets';
	
	    $scope.pendingChanges = false;
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.setPending = function () {
	      console.log('set pending ran');
	      console.log($scope.initialLoad);
	      if (!$scope.initialLoad) {
	        $scope.savemode = 'stationaccess';
	        $scope.pendingChanges = true;
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentStationPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.stationAccessStatus) {
	        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
	          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
	            submission = $scope.stationAccessStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentStationPolicy;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.stationAccessStatus && $scope.currentStationPolicy && $scope.currentStationPolicy.policy_name) {
	        var sub = _.find($scope.stationAccessStatus, { submission_policy_name: $scope.currentStationPolicy.policy_name });
	        if (sub && sub.submitted && sub.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('stationAccessStatus', function () {
	      if (!$scope.currentStationPolicy) return;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm('Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.');
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.stationAccessStatus) {
	        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
	          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
	            submission = $scope.stationAccessStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error('No matching submission found to withdraw');
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', payload).then(function () {
	
	        submission.submitted = false;
	        submission.status = null;
	
	        var formId = $scope.currentStationPolicy ? $scope.currentStationPolicy.stationaccess_form_id : null;
	        var policyName = $scope.currentStationPolicy ? $scope.currentStationPolicy.policy_name : null;
	        $scope.currentStationPolicy = { stationaccess_form_id: formId, policy_name: policyName };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	
	        $scope.formReadOnly = false;
	      }).catch(function (err) {
	        console.error('Withdraw failed:', err);
	        alert('There was an error withdrawing the submission. Please try again.');
	      });
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'stationaccess';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Station Area Access').then(function (response) {
	        $scope.stationAccessStatus = response.data;
	        console.log('Station Access status response:', response.data);
	        $scope.checkParking1 = _.filter(response.data, { submission_policy_name: 'Complete Streets Policy' })[0];
	
	        console.log('Loaded policy submissions:', $scope.stationAccessStatus);
	
	        $scope.completeStreetsCheck = !!_.filter(response.data, {
	          submission_policy_name: 'Complete Streets Policy', submitted: true
	        })[0];
	
	        if ($scope.stationaccess) {
	          $scope.stationaccess.completeStreetsCheck = $scope.completeStreetsCheck;
	        }
	
	        $scope.formReadOnly = !$scope.isFormEditable();
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	      $scope.getSubmissionStatus();
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Station Area Access').then(function (response) {
	        console.log(response);
	
	        $scope.currentStation = response.data[0];
	
	        $scope.stationCompleteStreets = _.filter(response.data, { 'submission_policy_name': 'Complete Streets Policy' });
	        if ($scope.stationCompleteStreets.length > 0) {
	          console.log($scope.stationCompleteStreets);
	          $scope.stationCompleteStreets.forEach(function (element) {
	            console.log(element.submitted, "element submitted");
	            if (element.submitted && element.submitted === true) {
	              $scope.completeStreetsCheck = true;
	            }
	          });
	        }
	        $scope.stationGapAnalysis = _.filter(response.data, { 'submission_policy_name': 'Gap Analysis' });
	        if ($scope.stationGapAnalysis.length > 0) {
	          $scope.stationGapAnalysis.forEach(function (element) {
	            if (element.submitted && element.submitted === true) {
	              $scope.stationGapAnalysisCheck = true;
	            }
	          });
	        }
	        $scope.stationProjectPrioritization = _.filter(response.data, { 'submission_policy_name': 'Project Prioritization' });
	        if ($scope.stationProjectPrioritization.length > 0) {
	          $scope.stationProjectPrioritization.forEach(function (element) {
	            if (element.submitted && element.submitted === true) {
	              $scope.projectCheck = true;
	            }
	          });
	        }
	        $scope.stationMobilityHubPlanning = _.filter(response.data, { 'submission_policy_name': 'Mobility Hub Planning' });
	        if ($scope.stationMobilityHubPlanning.length > 0) {
	          $scope.stationMobilityHubPlanning.forEach(function (element) {
	            if (element.submitted && element.submitted === true) {
	              $scope.mobilityCheck = true;
	            }
	          });
	        }
	
	        var requestedPolicyName = $stateParams.policyName;
	        if (requestedPolicyName) {
	          $scope.type = requestedPolicyName;
	
	          $timeout(function () {
	            var targetTab = void 0;
	            if (requestedPolicyName === 'Complete Streets Policy') {
	              targetTab = '#section-1';
	            } else if (requestedPolicyName === 'Project Prioritization') {
	              targetTab = '#section-2';
	            }
	
	            if (targetTab) {
	              document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (tab) {
	                tab.classList.remove('active');
	              });
	              document.querySelectorAll('.tab-pane').forEach(function (pane) {
	                pane.classList.remove('show', 'active');
	              });
	
	              var tabTrigger = document.querySelector('[data-bs-target="' + targetTab + '"]');
	              if (tabTrigger) {
	                tabTrigger.classList.add('active');
	                var tabPane = document.querySelector(targetTab);
	                if (tabPane) {
	                  tabPane.classList.add('show', 'active');
	                }
	              }
	            }
	          }, 100);
	        }
	
	        return $scope.getCurrentStationPolicy($scope.type);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        }
	
	        if ($scope.currentSelectedStationId) {
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getCurrentStationPolicy = function (type) {
	      if (type) {
	        $scope.type = type;
	      }
	      fetch.getAllItems('api/data/getAccessForm/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + encodeURIComponent($scope.type)).then(function (response) {
	
	        console.log(response);
	
	        $scope.currentStationPolicy = response.data[0];
	
	        console.log('stationaccess_form_id:', $scope.currentStationPolicy.stationaccess_form_id);
	        if (type === 'Project Prioritization') {
	          if ($scope.currentStationPolicy.capital_improvement_program) {
	            $scope.capital_improvement_program_checked = true;
	          }
	          if ($scope.currentStationPolicy.projects_submitted_funded) {
	            $scope.projects_submitted_funded_checked = true;
	          }
	          if ($scope.currentStationPolicy.other_fund_implementation) {
	            $scope.other_fund_implementation_checked = true;
	          }
	        }
	        $scope.initialLoad = false;
	        console.log($scope.initialLoad);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentStationPolicy = function () {
	      console.log($scope.currentStationPolicy);
	
	      $scope.formSubmitted = true;
	      if (stationAccessForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      $scope.currentStationPolicy.jurisdiction = $scope.currentJurisdiction;
	      $scope.currentStationPolicy.sta_recid = $scope.currentSelectedStationId;
	      $scope.currentStationPolicy.type = $scope.type;
	
	      if (!$scope.currentStationPolicy.stationaccess_form_id) {
	        console.error('stationaccess_form_id is missing');
	        return;
	      }
	
	      console.log('Payload being sent:', $scope.currentStationPolicy);
	
	      fetch.updateItem('api/data/access/forms/update', $scope.currentStationPolicy).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        setTimeout(function () {
	          $scope.saved = false;
	          $scope.savemode = null;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.submitStationAccess = function () {
	      console.log($scope.stationaccess.completeStreetsCheck);
	      $scope.formSubmitted = true;
	      $scope.saving = true;
	      var upsertData = [];
	
	      $scope.upsertData = [];
	
	      console.log("submissing", $scope.stationaccess.completeStreetsCheck, $scope.stationCompleteStreets.length);
	      if ($scope.stationaccess.completeStreetsCheck && $scope.stationCompleteStreets.length > 0) {
	        $scope.stationCompleteStreets.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_complete_streets: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      console.log(upsertData);
	
	      if ($scope.stationaccess.projectCheck && $scope.stationProjectPrioritization.length > 0) {
	        $scope.stationProjectPrioritization.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_project_prioritization: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.stationaccess.stationGapAnalysisCheck && $scope.stationGapAnalysis.length > 0) {
	        $scope.stationGapAnalysis.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_gap_analysis: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.stationaccess.mobilityCheck && $scope.stationMobilityHubPlanning.length > 0) {
	        $scope.stationMobilityHubPlanning.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_mobility_hub_planning: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saving = false;
	        $scope.submissions = [];
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 2000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById('fileInput' + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
	            alert('Please select a PDF, Word document, or Excel file.');
	            element.value = '';
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById('' + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope[ngmodel] = '';
	        $scope[ngmodel + '_preview'] = '';
	        $scope['fileUploading_' + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope['fileUploading_' + ngmodelfile] = true;
	      var file = document.getElementById('' + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentStationPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentStationPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'stationaccess';
	      $scope.pendingChanges = true;
	    };
	  }
	
	  _createClass(CompleteStreetsComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.currentStationPolicy = {};
	        _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return CompleteStreetsComponent;
	}();
	
	exports.default = angular.module('appApp.complete_streets', [uiRouter]).config(_complete_streets2.default).component('completeStreets', {
	  template: __webpack_require__(178),
	  controller: CompleteStreetsComponent,
	  controllerAs: 'completeStreetsCtrl'
	}).name;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('complete_streets', {
	    url: '/account/stationaccess/complete_streets?jurisdiction&sta_recid&policyName',
	    template: '<complete-streets></complete-streets>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null,
	      policyName: null }
	  });
	};

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <maintocselection />\n\n      <div class=\"content container\">\n        <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <p>\n          The TOC Policy seeks to facilitate robust multi-modal access to\n          transit stations. This supports increased residential and commercial\n          density in TOC areas and enables people living or working outside the\n          TOC area to use the region’s transit network for more of their trips.\n        </p>\n\n        <div class=\"alert alert-warning\" ng-if=\"!currentSelectedStationId\" role=\"alert\">\n          Please select a station area\n        </div>\n\n        <div class=\"section-nav\">\n          <div class=\"menu--section-title\">In this section:</div>\n          <ul class=\"menu menu--section\" role=\"tablist\">\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\" class=\"menu-item menu-item--section active\"\n              ng-click=\"getCurrentStationPolicy('Complete Streets')\">\n              <span class=\"section-number\">I.</span><a href=\"#\">Compliance with MTC's Complete Streets Policy</a>\n            </li>\n            <!-- <li data-bs-toggle=\"tab\" data-bs-target=\"#section-2\" class=\"menu-item menu-item--section\"\n              ng-click=\"getCurrentStationPolicy('Project Prioritization')\">\n              <span class=\"section-number\">II.</span><a href=\"#\">Project Prioritization and Implementation</a>\n            </li> -->\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit\" class=\"menu-item menu-item--section\"\n              ng-click=\"reviewAndSubmit\">\n              <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n            </li>\n          </ul>\n          <note ng-show=\"note\"></note>\n          <furtherguidance></furtherguidance>\n        </div>\n        <div class=\"tab-content\" ng-if=\"currentSelectedStationId\">\n          <!-- Complete Streets Policy Section -->\n          <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\"\n            ng-class=\"{'active show': showPanel === 'stationCompleteStreets'}\"\n            ng-class=\"{'was-validated': formSubmitted}\">\n                      <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Complete Streets Policy</h2>\n              <statuspills ng-repeat=\"submission in stationAccessStatus\"\n              ng-if=\"submission.submission_policy_name === currentStationPolicy.policy_name && submission.submitted === true\"\n              status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n            </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, submitted: true})[0] && !(stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p style=\"padding-top: 10px\">\n              <strong>A jurisdiction with an adopted Complete Streets (CS) Policy is\n                considered compliant for this complete streets policy\n                requirement.</strong>\n              MTC has documented jurisdiction CS Policies through its One Bay\n              Area Grant (OBAG) Program, most recently compiled in 2015. <b>If your\n              jurisdiction adopted its CS Policy <i>before</i> 2015</b>, please answer “Yes” to the first question below. No additional\n              information is needed.\n            </p>\n            <p>\n              <b>If your jurisdiction adopted its CS Policy <i>after</i> 2015</b>, answer “No” to the first question below\n              and “Yes” to the second question. Then either provide a link to the jurisdiction’s CS Policy <i>or</i>\n              upload a copy of the policy.\n            </p>\n\n            <form class=\"row test-validation-styling\" name=\"stationAccessForm\" id=\"stationAccessForm\" novalidate>\n              <div class=\"row\" style=\"padding-left: 15px; padding-bottom: 20px\">\n                <div class=\"form-item col-lg-12\">\n                  <label>Has MTC already collected jurisdiction's Complete Streets\n                    Policy (adopted prior to 2015)?</label>\n                  <select id=\"complete_streets_collect\" name=\"complete_streets_collect\"\n                    ng-model=\"currentStationPolicy.complete_streets_collect\"\n                    ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"stationAccessForm.complete_streets_collect.$error.required && formSubmitted\">\n                    Please select a valid response.\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\" style=\"padding-left: 15px; padding-bottom: 20px\">\n                <div class=\"form-item col-lg-12\">\n                  <label>Is jurisdiction submitting a Complete Streets Policy that\n                    was adopted after 2015?</label>\n                  <select id=\"complete_streets_submit_after\" name=\"complete_streets_submit_after\"\n                    ng-model=\"currentStationPolicy.complete_streets_submit_after\"\n                    ng-disabled=\"formReadOnly\"\n                    onchange=\"angular.element(this).scope().setPending(this)\" required>\n                    <option selected disabled value=\"\">Choose...</option>\n                    <option ng-value=\"true\">Yes</option>\n                    <option ng-value=\"false\">No</option>\n\n                  </select>\n                  <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                    ng-show=\"stationAccessForm.complete_streets_submit_after.$error.required && formSubmitted\">\n                    Please select a valid response.\n                  </div>\n                </div>\n                <div class=\"row align-items-center\">\n                  <!-- <input ng-if=\"!checkSubstring(currentStationPolicy.adopted_program_policy_link)\"\n                    id=\"adopted_program_policy_link\" name=\"adopted_program_policy_link\" type=\"url\"\n                    placeholder=\"Enter your response here\" ng-model=\"currentStationPolicy.adopted_program_policy_link\"\n                    ng-disabled=\"attachmentData['AdoptedPolicyAfter2015'].isFileSelected\" /> -->\n                  <div class=\"form-item col-lg-8\" style=\"padding-top:15px;\">\n                    <label for=\"adopted_program_policy_link\">If yes, link to adopted policy:</label>\n                    <textarea ng-model=\"currentStationPolicy.adopted_program_policy_link\" ng-disabled=\"formReadOnly\"\n                      ng-if=\"!checkSubstring(currentStationPolicy.adopted_program_policy_link)\"\n                      id=\"adopted_program_policy_link\" onchange=\"angular.element(this).scope().setPending(this)\"\n                      name=\"adopted_program_policy_link\" rows=\"4\" style=\"width: 100%;\" placeholder=\"Enter response or URL\"\n                      required>\n                        </textarea>\n                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                      ng-show=\"stationAccessForm.adopted_program_policy_link.$error.required && formSubmitted\">Please\n                      provide a valid response or\n                      URL.</div>\n                  </div>\n\n\n                  <!-- File upload adopted_program_policy_link -->\n                  <div ng-if=\"!checkSubstring(currentStationPolicy.adopted_program_policy_link)\"\n                    style=\"margin-top: 25px\" class=\"col-lg-1\">\n                    <b class=\"or-label\" style=\"padding-left: 50px\">OR</b>\n                  </div>\n\n                  <div class=\"col-md-5\" ng-if=\"checkSubstring(currentStationPolicy.adopted_program_policy_link)\"\n                    style=\"padding-bottom: 10px\">\n                    <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                        ng-href=\"{{currentStationPolicy.adopted_program_policy_link}}\">Uploaded Documentation</a></span>\n                    <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('adopted_program_policy_link')\">\n                      <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                      Remove\n                    </button>\n                  </div>\n                </div>\n\n              </div>\n              <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                ng-if=\"!checkSubstring(currentStationPolicy.adopted_program_policy_link)\">\n                <div class=\"col-lg-2\"><label for=\"adopted_program_policy_link_file_abcd\">Upload Policy\n                    Documentation</label></div>\n                <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                  <input type=\"file\" ng-model=\"adopted_program_policy_link_file_abcd\" ng-disabled=\"formReadOnly\"\n                    id=\"adopted_program_policy_link_file_abcd\" name=\"adopted_program_policy_link_file_abcd\"\n                    accept=\".pdf, .doc, .docx, .xls, .xlsx\" onchange=\"angular.element(this).scope().setPending(this)\" />\n                </div>\n                <div class=\"col-md-5\" ng-if=\"!formReadOnly\">\n                  <button class=\"button button--attach\" ng-click=\"uploadFile('adopted_program_policy_link_file_abcd')\">\n                    <i ng-show=\"fileUploading_adopted_program_policy_link_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                    Upload File\n                  </button>\n                  <button type=\"button\" class=\"button button--clear\"\n                    ng-click=\"clearFile('adopted_program_policy_link_file_abcd')\">\n                    Clear\n                  </button>\n                </div>\n              </div>\n              <submissionsectionsubmit></submissionsectionsubmit>\n            </form>\n          </div>\n\n          <!-- Review and submit  -->\n          <div id=\"section-review-submit\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': reviewAndSubmit}\">\n            <h2>Review and Submit</h2>\n            <p>\n              <span style=\"font-style: italic\">\n                Select policies below to submit to MTC for review.</span>\n            </p>\n\n            <form class=\"row test-validation-styling\" novalidate style=\"margin-left: 2px\">\n              <!-- Complete Streets  -->\n              <div class=\"verification-container\">\n                <div class=\"form-check\">\n                  <input class=\"form-check-input\" id=\"completeStreetsCheck\" type=\"checkbox\" ng-model=\"stationaccess.completeStreetsCheck\"\n                    ng-click=\"addToSubmissions('stationCompleteStreets')\" ng-disabled=\"completeStreetsCheck === true\" />\n                  <label class=\"form-check-label\" for=\"completeStreetsCheck\" ng-class=\"{'boldFont': stationaccess.completeStreetsCheck}\">\n                    Complete Streets Policy <span ng-if=\"completeStreetsCheck === true\"\n                                        class=\"badge badge--submitted\">Submitted</span>\n                  </label>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"stationaccess.completeStreetsCheck\">\n                  <p>\n                    I have completed the Compliance with MTC's <a href=\"#\"\n                      ng-click=\"togglePanel('stationCompleteStreets')\">Complete Streets Section </a>\n                    and uploaded any relevant documentation.\n                  </p>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"stationCompleteStreets[0].submitted\">\n                  <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                    <div class=\"col\">\n                      <div class=\"alert alert-success fade show\" role=\"alert\">\n                        This policy has been submitted and is under review.\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <!-- <div class=\"verification-container\">\n                <div class=\"form-check\">\n                  <input\n                    class=\"form-check-input\"\n                    type=\"checkbox\"\n                    value=\"\"\n                    ng-model=\"projectCheck\"\n                    ng-click=\"addToSubmissions('projectPrioritization')\"\n                    ng-disabled=\"stationProjectPrioritization[0].submitted\"\n                  />\n                  <label class=\"form-check-label\" for=\"foo\" ng-class=\"{'boldFont': projectCheck}\">\n                    Project Prioritization and Implementation\n                  </label>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"completeStreetsCheck\">\n                  <p>\n                    I have completed the <a href=\"#\" ng-click=\"showPanel === 'projectPrioritization'\">Compliance with MTC's Complete Streets Section</a> and uploaded any relevant documentation.\n                  </p>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"stationProjectPrioritization[0].submitted\">\n                  <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\" >\n                    <div class=\"col\">\n                      <div class=\"alert alert-success fade show\" role=\"alert\">\n                        This policy has been submitted and is under review.\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div> -->\n            </form>\n            <submissionsectionsubmit></submissionsectionsubmit>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"footer\" role=\"contentinfo\">\n    <sidebarfooter></sidebarfooter>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MobilityHubComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mobility_hub = __webpack_require__(180);
	
	var _mobility_hub2 = _interopRequireDefault(_mobility_hub);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var MobilityHubComponent = exports.MobilityHubComponent = function () {
	  /*@ngInject*/
	  function MobilityHubComponent($state, $scope, $rootScope, fetch, lookup, userService, $timeout, $http, baseConfigService, $stateParams) {
	    _classCallCheck(this, MobilityHubComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.userService = userService;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$http = $http;
	    this.baseConfigService = baseConfigService;
	
	    $scope.adminUnlocked = false;
	    $scope.submissions = [];
	    $scope.attachmentData = $scope.attachmentData || {};
	
	    $scope.stationaccess = {};
	
	    $scope.initialLoad = true;
	
	    $scope.savemode = null;
	
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.submitmode = null;
	
	    $scope.type = 'Mobility Hubs';
	
	    $scope.pendingChanges = false;
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.setPending = function () {
	      console.log('set pending ran');
	      console.log($scope.initialLoad);
	      if (!$scope.initialLoad) {
	        $scope.savemode = 'stationaccess';
	        $scope.pendingChanges = true;
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentStationPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.stationAccessStatus) {
	        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
	          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
	            submission = $scope.stationAccessStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentStationPolicy;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.stationAccessStatus && $scope.currentStationPolicy && $scope.currentStationPolicy.policy_name) {
	        var sub = _.find($scope.stationAccessStatus, { submission_policy_name: $scope.currentStationPolicy.policy_name });
	        if (sub && sub.submitted && sub.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('stationAccessStatus', function () {
	      if (!$scope.currentStationPolicy) return;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm('Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.');
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.stationAccessStatus) {
	        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
	          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
	            submission = $scope.stationAccessStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error('No matching submission found to withdraw');
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', payload).then(function () {
	
	        submission.submitted = false;
	        submission.status = null;
	
	        var formId = $scope.currentStationPolicy ? $scope.currentStationPolicy.stationaccess_form_id : null;
	        var policyName = $scope.currentStationPolicy ? $scope.currentStationPolicy.policy_name : null;
	        $scope.currentStationPolicy = { stationaccess_form_id: formId, policy_name: policyName };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	
	        $scope.formReadOnly = false;
	      }).catch(function (err) {
	        console.error('Withdraw failed:', err);
	        alert('There was an error withdrawing the submission. Please try again.');
	      });
	    };
	
	    $scope.onMobilityHubsCheckboxChange = function (type) {
	      if (type === 'relevantPlans' && $scope.relevant_plans_projects_checked) {
	        $scope.mobility_hub_current_prior_checked = false;
	      }
	      if (type === 'currentPrior' && $scope.mobility_hub_current_prior_checked) {
	        $scope.relevant_plans_projects_checked = false;
	      }
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'stationaccess';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Station Area Access').then(function (response) {
	        $scope.stationAccessStatus = response.data;
	        console.log('Station Access status response:', response.data);
	        $scope.checkStationAccess = _.filter(response.data, { submission_policy_name: 'Mobility Hub Planning' })[0];
	
	        console.log('Loaded policy submissions:', $scope.stationAccessStatus);
	
	        $scope.mobilityCheck = !!_.filter(response.data, {
	          submission_policy_name: 'Mobility Hub Planning', submitted: true
	        })[0];
	
	        if ($scope.stationaccess) {
	          $scope.stationaccess.mobilityCheck = $scope.mobilityCheck;
	        }
	
	        $scope.formReadOnly = !$scope.isFormEditable();
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	      $scope.getSubmissionStatus();
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Station Area Access').then(function (response) {
	
	        $scope.currentStation = response.data[0];
	
	        $scope.stationCompleteStreets = _.filter(response.data, { 'submission_policy_name': 'Complete Streets Policy' });
	        if ($scope.stationCompleteStreets.length > 0) {
	          $scope.stationCompleteStreets.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.completeStreetsCheck = true;
	            }
	          });
	        }
	        $scope.stationGapAnalysis = _.filter(response.data, { 'submission_policy_name': 'Gap Analysis' });
	        if ($scope.stationGapAnalysis.length > 0) {
	          $scope.stationGapAnalysis.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.stationGapAnalysisCheck = true;
	            }
	          });
	        }
	        $scope.stationProjectPrioritization = _.filter(response.data, { 'submission_policy_name': 'Project Prioritization' });
	        if ($scope.stationProjectPrioritization.length > 0) {
	          $scope.stationProjectPrioritization.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.projectCheck = true;
	            }
	          });
	        }
	        $scope.stationMobilityHubPlanning = _.filter(response.data, { 'submission_policy_name': 'Mobility Hub Planning' });
	        if ($scope.stationMobilityHubPlanning.length > 0) {
	          $scope.stationMobilityHubPlanning.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.mobilityCheck = true;
	            }
	          });
	        }
	        return $scope.getCurrentStationPolicy($scope.type);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        }
	
	        if ($scope.currentSelectedStationId) {
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getCurrentStationPolicy = function (type) {
	      if (type) {
	        $scope.type = type;
	      }
	      fetch.getAllItems('api/data/getAccessForm/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + encodeURIComponent($scope.type)).then(function (response) {
	
	        console.log(response);
	
	        $scope.currentStationPolicy = response.data[0];
	
	        console.log('stationaccess_form_id:', $scope.currentStationPolicy.stationaccess_form_id);
	        if (type === 'Mobility Hubs') {
	          if ($scope.currentStationPolicy.relevant_plans_projects) {
	            $scope.relevant_plans_projects_checked = true;
	          }
	          if ($scope.currentStationPolicy.mobility_hub_current_prior) {
	            $scope.mobility_hub_current_prior_checked = true;
	          }
	          if ($scope.currentStationPolicy.mobility_hub_submission_date) {
	            $scope.currentStationPolicy.mobility_hub_submission_date = new Date(moment($scope.currentStationPolicy.mobility_hub_submission_date).format('L'));
	          }
	        }
	        $scope.initialLoad = false;
	        console.log($scope.initialLoad);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentStationPolicy = function () {
	
	      $scope.formSubmitted = true;
	      if (stationAccessForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      $scope.currentStationPolicy.jurisdiction = $scope.currentJurisdiction;
	      $scope.currentStationPolicy.sta_recid = $scope.currentSelectedStationId;
	      $scope.currentStationPolicy.type = $scope.type;
	
	      console.log('Payload being sent:', $scope.currentStationPolicy);
	
	      fetch.updateItem('api/data/access/forms/update', $scope.currentStationPolicy).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        setTimeout(function () {
	          $scope.saved = false;
	          $scope.savemode = null;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.submitStationAccess = function () {
	      console.log($scope.stationaccess.completeStreetsCheck);
	      $scope.formSubmitted = true;
	      $scope.saving = true;
	      var upsertData = [];
	
	      $scope.upsertData = [];
	
	      console.log("submissing", $scope.stationaccess.completeStreetsCheck, $scope.stationCompleteStreets.length);
	      if ($scope.stationaccess.completeStreetsCheck && $scope.stationCompleteStreets.length > 0) {
	        $scope.stationCompleteStreets.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_complete_streets: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      console.log(upsertData);
	
	      if ($scope.stationaccess.projectCheck && $scope.stationProjectPrioritization.length > 0) {
	        $scope.stationProjectPrioritization.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_project_prioritization: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.stationaccess.stationGapAnalysisCheck && $scope.stationGapAnalysis.length > 0) {
	        $scope.stationGapAnalysis.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_gap_analysis: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.stationaccess.mobilityCheck && $scope.stationMobilityHubPlanning.length > 0) {
	        $scope.stationMobilityHubPlanning.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_mobility_hub_planning: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saving = false;
	        $scope.submissions = [];
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 2000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById('fileInput' + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
	            alert('Please select a PDF, Word document, or Excel file.');
	            element.value = '';
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById('' + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope[ngmodel] = '';
	        $scope[ngmodel + '_preview'] = '';
	        $scope['fileUploading_' + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope['fileUploading_' + ngmodelfile] = true;
	      var file = document.getElementById('' + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentStationPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentStationPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'housing';
	      $scope.pendingChanges = true;
	    };
	  }
	
	  _createClass(MobilityHubComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.currentStationPolicy = {};
	        _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return MobilityHubComponent;
	}();
	
	exports.default = angular.module('appApp.mobility_hub', [uiRouter]).config(_mobility_hub2.default).component('mobilityHub', {
	  template: __webpack_require__(181),
	  controller: MobilityHubComponent,
	  controllerAs: 'mobilityHubCtrl'
	}).name;

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('mobility_hub', {
	    url: '/account/stationaccess/mobility_hub?jurisdiction&sta_recid',
	    template: '<mobility-hub></mobility-hub>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null }
	  });
	};

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <maintocselection />\n\n      <div class=\"content container\">\n        <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <p>\n          The TOC Policy seeks to facilitate robust multi-modal access to\n          transit stations. This supports increased residential and commercial\n          density in TOC areas and enables people living or working outside the\n          TOC area to use the region’s transit network for more of their trips.\n        </p>\n\n        <div class=\"alert alert-warning\" ng-if=\"!currentSelectedStationId\" role=\"alert\">\n          Please select a station area\n        </div>\n\n        <div class=\"section-nav\">\n          <div class=\"menu--section-title\">In this section:</div>\n          <ul class=\"menu menu--section\" role=\"tablist\">\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\" ng-click=\"getCurrentStationPolicy('Mobility Hubs')\"\n              class=\"menu-item menu-item--section active\">\n              <span class=\"section-number\">I.</span><a href=\"#\">Opportunities for Mobility Hub Planning and\n                Implementation</a>\n            </li>\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit\" class=\"menu-item menu-item--section\"\n              ng-click=\"reviewAndSubmit == true\">\n              <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n            </li>\n          </ul>\n          <note ng-show=\"note\"></note>\n          <furtherguidance></furtherguidance>\n        </div>\n        <div class=\"tab-content\" ng-if=\"currentSelectedStationId\">\n          <!-- Mobility Hub Planning and Implementation Section -->\n          <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\"\n            ng-class=\"{'active show': showPanel === 'stationMobilityHubPlanning'}\"\n            ng-class=\"{'was-validated': formSubmitted}\">\n                 <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Mobility Hub Planning and Implementation</h2>\n           <statuspills ng-repeat=\"submission in stationAccessStatus\"\n              ng-if=\"submission.submission_policy_name === currentStationPolicy.policy_name && submission.submitted === true\"\n              status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\" user-role=\"currentUser.role\">\n            </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, submitted: true})[0] && !(stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p>\n            <b>MTC staff have created a <a target=\"_blank\" href=\"https://abag.ca.gov/tools-resources/digital-library/mobility-hubs-submission-formdocx\" rel=\"noopener noreferrer\">template form</a> to help local jurisdictions\n            with organizing the required documentation.</b> Please download the template, follow the\n            instructions included, and fill out all applicable fields within the template form. After completing\n            the form, click on the checkbox below to upload it.\n            </p>\n\n            <form class=\"row test-validation-styling\" name=\"stationAccessForm\" novalidate>\n              <div class=\"form-item col-lg-12\" style=\"padding-left: 18px\">\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"checkRelevantPlansProjects\"\n                      ng-model=\"currentStationPolicy.relevant_plans_projects_checked\"\n                      ng-change=\"onMobilityHubsCheckboxChange('relevantPlans')\"\n                      ng-disabled=\"currentStationPolicy.mobility_hub_current_prior_checked || formReadOnly\" \n                      onchange=\"angular.element(this).scope().setPending(this)\" />\n                    <label class=\"form-check-label\" for=\"checkRelevantPlansProjects\"\n                      ng-class=\"{'boldFont': relevant_plans_projects_checked}\">\n                      Click to submit completed Mobility Hub Submission Template Form\n                    </label>\n                  </div>\n                  <div class=\"row align-items-center\" ng-show=\"currentStationPolicy.relevant_plans_projects_checked\">\n                    <!-- <div class=\"col-lg-1\" ng-if=\"!checkSubstring(currentStationPolicy.relevant_plans_projects)\">\n                      <label>URL</label>\n                    </div>\n                    <div class=\"col-lg-5\" ng-if=\"!checkSubstring(currentStationPolicy.relevant_plans_projects)\">\n                      <input id=\"relevant_plans_projects\" name=\"relevant_plans_projects\"\n                        placeholder=\"Enter response or URL\" ng-model=\"currentStationPolicy.relevant_plans_projects\"\n                        onchange=\"angular.element(this).scope().setPending(this)\" required />\n                      <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                        ng-show=\"stationAccessForm.relevant_plans_projects.$error.required && formSubmitted\">\n                        Please provide a valid response or URL.\n                      </div>\n                    </div>\n                    <div ng-if=\"!checkSubstring(currentStationPolicy.relevant_plans_projects)\" style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div> -->\n                    <!-- File upload relevant_plans_projects -->\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentStationPolicy.relevant_plans_projects)\"\n                      style=\"padding-bottom: 10px\">\n                      <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                          ng-href=\"{{currentStationPolicy.relevant_plans_projects}}\">Uploaded Template Form</a></span>\n                      <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('relevant_plans_projects')\">\n                        <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                        Remove\n                      </button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                      ng-if=\"!checkSubstring(currentStationPolicy.relevant_plans_projects)\">\n                      <div class=\"col-lg-3\"><label for=\"relevant_plans_projects_file_abcd\">Upload Mobility Hub Submission Template Form</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n\n                        <input type=\"file\" ng-model=\"relevant_plans_projects_file_abcd\"\n                          id=\"relevant_plans_projects_file_abcd\" name=\"relevant_plans_projects_file_abcd\"\n                          accept=\".pdf, .doc, .docx, .xls, .xlsx\" ng-disabled=\"formReadOnly\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-4\" ng-if=\"!formReadOnly\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('relevant_plans_projects_file_abcd')\">\n                          <i ng-show=\"fileUploading_relevant_plans_projects_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File\n                        </button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('relevant_plans_projects_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                      <label>Additional Details <i>(Optional)</i>:</label>\n                      <textarea id=\"relevant_plans_projects_details\" name=\"relevant_plans_projects_details\"\n                        ng-model=\"currentStationPolicy.relevant_plans_projects_details\" ng-disabled=\"formReadOnly\"\n                        onchange=\"angular.element(this).scope().setPending(this)\" rows=\"4\" style=\"width: 100%;\">\n                      </textarea>\n                    </div>\n                  </div>\n                </div>\n                <!-- <h2>\n                  OR\n                </h2>\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" id=\"checkMobilityHub\"\n                      ng-model=\"currentStationPolicy.mobility_hub_current_prior_checked\"\n                      ng-change=\"onMobilityHubsCheckboxChange('currentPrior')\"\n                      ng-disabled=\"currentStationPolicy.relevant_plans_projects_checked\"\n                      onchange=\"angular.element(this).scope().setPending(this)\" />\n                    <label class=\"form-check-label\" for=\"checkMobilityHub\"\n                      ng-class=\"{'boldFont': mobility_hub_current_prior_checked}\">\n                      List any current or prior funding application for MTC's\n                      Mobility Hub Program for the transit stop/station area:\n                    </label>\n                  </div>\n                  <div class=\"row align-items-center\" ng-show=\"currentStationPolicy.mobility_hub_current_prior_checked\">\n                    <div class=\"col-lg-1\" ng-if=\"!checkSubstring(currentStationPolicy.mobility_hub_current_prior)\">\n                      <label>URL</label>\n                    </div>\n                    <div class=\"col-lg-5\" ng-if=\"!checkSubstring(currentStationPolicy.mobility_hub_current_prior)\">\n                      <input id=\"mobility_hub_current_prior_checked\" name=\"mobility_hub_current_prior_checked\"\n                        placeholder=\"Enter your response here\" required\n                        ng-model=\"currentStationPolicy.mobility_hub_current_prior\"\n                        onchange=\"angular.element(this).scope().setPending(this)\" />\n                      <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                        ng-show=\"stationAccessForm.mobility_hub_current_prior_checked.$error.required && formSubmitted\">\n                        Please provide a valid response or URL.\n                      </div>\n                    </div>\n                    <div ng-if=\"!checkSubstring(currentStationPolicy.mobility_hub_current_prior)\" style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div>\n                    File upload mobility_hub_current_prior\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentStationPolicy.mobility_hub_current_prior)\"\n                      style=\"padding-bottom: 10px\">\n                      <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                          ng-href=\"{{currentStationPolicy.mobility_hub_current_prior}}\">Uploaded\n                          Template Form</a></span>\n                      <button class=\"button button--attach\" ng-click=\"removeFile('mobility_hub_current_prior')\">\n                        <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                        Remove\n                      </button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                      ng-if=\"!checkSubstring(currentStationPolicy.mobility_hub_current_prior)\">\n                      <div class=\"col-lg-3\"><label for=\"mobility_hub_current_prior_file_abcd\">Upload Mobility Hub Submission Template Form</div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n                        <input type=\"file\" ng-model=\"mobility_hub_current_prior_file_abcd\"\n                          id=\"mobility_hub_current_prior_file_abcd\" name=\"mobility_hub_current_prior_file_abcd\"\n                          accept=\".pdf, .doc, .docx, .xls, .xlsx\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-4\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('mobility_hub_current_prior_file_abcd')\">\n                          <i ng-show=\"fileUploading_mobility_hub_current_prior_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File\n                        </button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('mobility_hub_current_prior_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                      <label>Additional Details <i>(Optional)</i>:</label>\n                      <textarea id=\"mobility_hub_current_prior_details\" name=\"mobility_hub_current_prior_details\"\n                        rows=\"4\" style=\"width: 100%;\" ng-model=\"currentStationPolicy.mobility_hub_current_prior_details\"\n                        onchange=\"angular.element(this).scope().setPending(this)\">\n                      </textarea>\n                    </div>\n                    <div class=\"form-item col-lg-6\" style=\"padding-top: 15px\">\n                      <label>Date of Submission</label>\n                      <input type=\"date\" id=\"mobility_hub_submission_date\" name=\"mobility_hub_submission_date\"\n                        ng-model=\"currentStationPolicy.mobility_hub_submission_date\"\n                        onchange=\"angular.element(this).scope().setPending(this)\" />\n                    </div>\n                  </div>\n                </div> -->\n              </div>\n            </form>\n            <submissionsectionsubmit></submissionsectionsubmit>\n          </div>\n\n          <!-- Review and submit  -->\n          <div id=\"section-review-submit\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': reviewAndSubmit}\">\n            <h2>Review and Submit</h2>\n            <p>\n              <span style=\"font-style: italic\">\n                Select policies below to submit to MTC for review.</span>\n            </p>\n\n            <form class=\"row test-validation-styling\" novalidate style=\"margin-left: 2px\">\n              <!-- Complete Streets  -->\n              <div class=\"verification-container\">\n                <div class=\"form-check\">\n                  <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"mobilityCheck\"\n                    ng-model=\"stationaccess.mobilityCheck\" ng-click=\"addToSubmissions('stationMobilityHubPlanning')\"\n                    ng-disabled=\"mobilityCheck === true\" />\n                  <label class=\"form-check-label\" for=\"mobilityCheck\" ng-class=\"{'boldFont': stationaccess.mobilityCheck}\">\n                    Opportunities for Mobility Hub Planning and Implementation <span ng-if=\"mobilityCheck === true\"\n                                        class=\"badge badge--submitted\">Submitted</span>\n                  </label>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"stationaccess.mobilityCheck\">\n                  <p>\n                    I have completed the\n                    Compliance with MTC's <a href=\"#\" ng-click=\"togglePanel('stationMobilityHubPlanning')\">Opportunities\n                      for Mobility Hub Planning and Implementation Section </a>\n                    and uploaded any relevant documentation.\n                  </p>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"stationMobilityHubPlanning[0].submitted\">\n                  <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                    <div class=\"col\">\n                      <div class=\"alert alert-success fade show\" role=\"alert\">\n                        This policy has been submitted and is under review.\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </form>\n            <submissionsectionsubmit></submissionsectionsubmit>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"footer\" role=\"contentinfo\">\n    <sidebarfooter></sidebarfooter>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProjectPrioritizationComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _project_prioritization = __webpack_require__(183);
	
	var _project_prioritization2 = _interopRequireDefault(_project_prioritization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ProjectPrioritizationComponent = exports.ProjectPrioritizationComponent = function () {
	  /*@ngInject*/
	  function ProjectPrioritizationComponent($state, $scope, $rootScope, fetch, lookup, userService, $timeout, $http, baseConfigService, $stateParams) {
	    _classCallCheck(this, ProjectPrioritizationComponent);
	
	    var vm = this;
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.userService = userService;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$http = $http;
	    this.baseConfigService = baseConfigService;
	
	    $scope.adminUnlocked = false;
	    $scope.submissions = [];
	    $scope.stationaccess = {};
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.savemode = null;
	
	    $scope.initialLoad = true;
	
	    $scope.baseUrl = baseConfigService.getBaseURL();
	    $scope.projectPrioritizationCheck = false;
	
	    $scope.submitmode = null;
	
	    $scope.type = 'Project Prioritization';
	
	    $scope.pendingChanges = false;
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.setPending = function () {
	      console.log('set pending ran');
	      console.log($scope.initialLoad);
	      if (!$scope.initialLoad) {
	        $scope.savemode = 'stationaccess';
	        $scope.pendingChanges = true;
	      }
	    };
	
	    $scope.isFormEditable = function () {
	      if (!$scope.currentStationPolicy) return true;
	
	      var role = $scope.currentUser && $scope.currentUser.role;
	
	      var submission = null;
	      if ($scope.stationAccessStatus) {
	        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
	          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
	            submission = $scope.stationAccessStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submitted) return true;
	
	      if (role === 'Administrator') {
	        return $scope.adminUnlocked;
	      }
	
	      if (submission.status === 'Needs Work') return true;
	
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return $scope.currentStationPolicy;
	    }, function () {
	      $scope.adminUnlocked = false;
	      $scope.formReadOnly = !$scope.isFormEditable();
	      $scope.withdrawnNotice = false;
	      $scope.needsWorkNotice = false;
	      if ($scope.stationAccessStatus && $scope.currentStationPolicy && $scope.currentStationPolicy.policy_name) {
	        var sub = _.find($scope.stationAccessStatus, { submission_policy_name: $scope.currentStationPolicy.policy_name });
	        if (sub && sub.submitted && sub.status === 'Needs Work') {
	          $scope.needsWorkNotice = true;
	        }
	      }
	    });
	
	    $scope.$watch('stationAccessStatus', function () {
	      if (!$scope.currentStationPolicy) return;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    }, true);
	
	    $scope.toggleAdminUnlock = function () {
	      $scope.adminUnlocked = !$scope.adminUnlocked;
	      $scope.formReadOnly = !$scope.isFormEditable();
	    };
	
	    $scope.withdrawSubmission = function () {
	      var confirmWithdraw = window.confirm('Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.');
	      if (!confirmWithdraw) return;
	
	      var submission = null;
	      if ($scope.stationAccessStatus) {
	        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
	          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
	            submission = $scope.stationAccessStatus[i];
	            break;
	          }
	        }
	      }
	
	      if (!submission || !submission.submission_id) {
	        console.error('No matching submission found to withdraw');
	        return;
	      }
	
	      var payload = {
	        submission_id: submission.submission_id,
	        submitted: false,
	        status: null
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', payload).then(function () {
	
	        submission.submitted = false;
	        submission.status = null;
	
	        var formId = $scope.currentStationPolicy ? $scope.currentStationPolicy.stationaccess_form_id : null;
	        var policyName = $scope.currentStationPolicy ? $scope.currentStationPolicy.policy_name : null;
	        $scope.currentStationPolicy = { stationaccess_form_id: formId, policy_name: policyName };
	
	        $scope.withdrawnNotice = true;
	        $scope.needsWorkNotice = false;
	        $scope.success = false;
	
	        $scope.formReadOnly = false;
	      }).catch(function (err) {
	        console.error('Withdraw failed:', err);
	        alert('There was an error withdrawing the submission. Please try again.');
	      });
	    };
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'stationaccess';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getSubmissionStatus = function () {
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Station Area Access').then(function (response) {
	        $scope.stationAccessStatus = response.data;
	        console.log('Station Access status response:', response.data);
	
	        $scope.checkStationAccess1 = _.filter(response.data, { submission_policy_name: 'Project Prioritization', submitted: true })[0];
	        console.log('Loaded policy submissions:', $scope.stationAccessStatus);
	
	        $scope.projectPrioritizationCheck = !!_.filter(response.data, {
	          submission_policy_name: 'Project Prioritization', submitted: true
	        })[0];
	
	        if ($scope.stationaccess) {
	          $scope.stationaccess.projectPrioritizationCheck = $scope.projectPrioritizationCheck;
	        }
	
	        $scope.formReadOnly = !$scope.isFormEditable();
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	
	      if (!row || !row.submission_id) {
	        console.error('submission_id is missing:', row);
	        return;
	      }
	
	      var originalStatus = row.status;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      console.log('Updating submission:', {
	        id: row.submission_id,
	        status: newStatus
	      });
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = originalStatus;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.getStationbyID = function (station) {
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
	      $scope.getSubmissionStatus();
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId, 'Station Area Access').then(function (response) {
	        console.log(response);
	
	        $scope.currentStation = response.data[0];
	
	        $scope.stationCompleteStreets = _.filter(response.data, { 'submission_policy_name': 'Complete Streets Policy' });
	        if ($scope.stationCompleteStreets.length > 0) {
	          console.log($scope.stationCompleteStreets);
	          $scope.stationCompleteStreets.forEach(function (element) {
	            console.log(element.submitted, "element submitted");
	            if (element.submitted && element.submitted === true) {
	              $scope.stationCompleteStreetsCheck = true;
	            }
	          });
	        }
	        $scope.stationGapAnalysis = _.filter(response.data, { 'submission_policy_name': 'Gap Analysis' });
	        if ($scope.stationGapAnalysis.length > 0) {
	          $scope.stationGapAnalysis.forEach(function (element) {
	            if (element.submitted && element.submitted === true) {
	              $scope.stationGapAnalysisCheck = true;
	            }
	          });
	        }
	        $scope.stationProjectPrioritization = _.filter(response.data, { 'submission_policy_name': 'Project Prioritization' });
	        if ($scope.stationProjectPrioritization.length > 0) {
	          $scope.stationProjectPrioritization.forEach(function (element) {
	            if (element.submitted && element.submitted === true) {
	              $scope.projectPrioritizationCheck = true;
	            }
	          });
	        }
	        $scope.stationMobilityHubPlanning = _.filter(response.data, { 'submission_policy_name': 'Mobility Hub Planning' });
	        if ($scope.stationMobilityHubPlanning.length > 0) {
	          $scope.stationMobilityHubPlanning.forEach(function (element) {
	            if (element.submitted && element.submitted === true) {
	              $scope.mobilityCheck = true;
	            }
	          });
	        }
	        return $scope.getCurrentStationPolicy($scope.type);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      var staRecId = $stateParams.sta_recid;
	
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	
	        if (staRecId) {
	          $scope.currentSelectedStationId = staRecId;
	        } else if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	        }
	
	        if ($scope.currentSelectedStationId) {
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getCurrentStationPolicy = function (type) {
	      if (type) {
	        $scope.type = type;
	      }
	      fetch.getAllItems('api/data/getAccessForm/' + $scope.currentJurisdiction + '/' + $scope.currentSelectedStationId + '/' + encodeURIComponent($scope.type)).then(function (response) {
	
	        console.log(response);
	
	        $scope.currentStationPolicy = response.data[0];
	
	        console.log('stationaccess_form_id:', $scope.currentStationPolicy.stationaccess_form_id);
	        if (type === 'Project Prioritization') {
	          if ($scope.currentStationPolicy.capital_improvement_program) {
	            $scope.capital_improvement_program_checked = true;
	          }
	          if ($scope.currentStationPolicy.projects_submitted_funded) {
	            $scope.projects_submitted_funded_checked = true;
	          }
	          if ($scope.currentStationPolicy.other_fund_implementation) {
	            $scope.other_fund_implementation_checked = true;
	          }
	        }
	        $scope.initialLoad = false;
	        console.log($scope.initialLoad);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateCurrentStationPolicy = function () {
	      console.log($scope.currentStationPolicy);
	
	      $scope.formSubmitted = true;
	      if (stationAccessForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      $scope.currentStationPolicy.jurisdiction = $scope.currentJurisdiction;
	      $scope.currentStationPolicy.sta_recid = $scope.currentSelectedStationId;
	      $scope.currentStationPolicy.type = $scope.type;
	
	      if (!$scope.currentStationPolicy.stationaccess_form_id) {
	        console.error('stationaccess_form_id is missing');
	        return;
	      }
	
	      console.log('Payload being sent:', $scope.currentStationPolicy);
	
	      fetch.updateItem('api/data/access/forms/update', $scope.currentStationPolicy).then(function (response) {
	
	        $scope.saved = true;
	        $scope.saving = false;
	        setTimeout(function () {
	          $scope.saved = false;
	          $scope.savemode = null;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.submitStationAccess = function () {
	      console.log($scope.stationaccess.projectCheck);
	      $scope.formSubmitted = true;
	      $scope.saving = true;
	      var upsertData = [];
	
	      $scope.upsertData = [];
	
	      console.log("submissing", $scope.stationaccess.projectPrioritizationCheck, $scope.stationProjectPrioritization.length);
	      if ($scope.stationaccess.projectPrioritizationCheck && $scope.stationProjectPrioritization.length > 0) {
	        $scope.stationProjectPrioritization.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_project_prioritization: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      console.log(upsertData);
	
	      if ($scope.stationaccess.completeStreetsCheck && $scope.stationCompleteStreets.length > 0) {
	        $scope.stationCompleteStreets.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_complete_streets: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.stationaccess.stationGapAnalysisCheck && $scope.stationGapAnalysis.length > 0) {
	        $scope.stationGapAnalysis.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_gap_analysis: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      if ($scope.stationaccess.mobilityCheck && $scope.stationMobilityHubPlanning.length > 0) {
	        $scope.stationMobilityHubPlanning.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              station_access_mobility_hub_planning: true,
	              submitted: true
	            });
	          }
	        });
	      }
	
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saving = false;
	        $scope.submissions = [];
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	
	        $scope.getSubmissionStatus();
	
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 2000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.initializeField = function (fieldId) {
	      if (!$scope.attachmentData[fieldId]) {
	        $scope.attachmentData[fieldId] = {
	          fileName: null,
	          file: null,
	          isFileSelected: false
	        };
	      }
	    };
	
	    $scope.openFileDialog = function (fieldId) {
	      $timeout(function () {
	        document.getElementById('fileInput' + fieldId).click();
	      }, 0);
	    };
	
	    $scope.fileChanged = function (fieldId, element) {
	      $scope.initializeField(fieldId);
	
	      var file = element.files[0];
	      if (file) {
	        if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && file.type !== 'application/msword' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
	            alert('Please select a PDF, Word document, or Excel file.');
	            element.value = '';
	            return;
	          }
	
	        $scope.attachmentData[fieldId].fileName = file.name;
	        $scope.attachmentData[fieldId].file = file;
	        $scope.attachmentData[fieldId].isFileSelected = true;
	
	        $scope.$apply();
	      }
	    };
	
	    $scope.clearFile = function (ngmodel) {
	      console.log(ngmodel);
	      var fileInput = document.getElementById('' + ngmodel);
	      console.log(fileInput);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope[ngmodel] = '';
	        $scope[ngmodel + '_preview'] = '';
	        $scope['fileUploading_' + ngmodel] = false;
	
	        if ($scope.form && $scope.form[ngmodel]) {
	          $scope.form[ngmodel].$setPristine();
	          $scope.form[ngmodel].$setUntouched();
	        }
	      }
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	      $scope['fileUploading_' + ngmodelfile] = true;
	      var file = document.getElementById('' + ngmodelfile).files[0];
	
	      if (!file) {
	        console.error('No file selected');
	        return;
	      }
	
	      var fileUpload = {
	        fileName: file.name,
	        fileType: file.type
	      };
	
	      fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	        console.log('Signed URL:', response.data.signedUrl);
	        console.log('Public URL:', response.data.publicUrl);
	
	        return $http({
	          method: 'PUT',
	          url: response.data.signedUrl,
	          data: file,
	          headers: {
	            'Content-Type': file.type
	          }
	        }).then(function () {
	          $scope.currentStationPolicy[ngmodel] = response.data.publicUrl;
	          return response.data.publicUrl;
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	      });
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentStationPolicy[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'stationaccess';
	      $scope.pendingChanges = true;
	    };
	  }
	
	  _createClass(ProjectPrioritizationComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.currentStationPolicy = {};
	        _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getStationAreaSubmissionSummary',
	    value: function getStationAreaSubmissionSummary(stationId) {
	      var _this3 = this;
	
	      console.log('Getting summary for station:', stationId);
	      this.lookup.setCurrentStation(stationId);
	
	      if (this.$scope.stationAreas.length > 0) {
	        this.$scope.stationAreas.forEach(function (element) {
	          element.active = element.sta_recid === stationId;
	          if (element.active) {
	            _this3.$scope.stationAreaTitle = element.station_name;
	          }
	        });
	
	        return this.fetch.getItem('api/data/policies/' + this.$scope.currentJurisdiction, stationId).then(function (response) {
	          console.log('Policy data:', response);
	          _this3.$scope.submissionSummary = response.data;
	          console.log("submission summary: ", _this3.$scope.submissionSummary);
	
	          _this3.$scope.densitySubmissions = _.filter(response.data, { submission_policy_type: "Density" });
	          _this3.$scope.densitySubmitted = _.filter(_this3.$scope.densitySubmissions, { submitted: true });
	          _this3.$scope.densityCompliant = _.filter(_this3.$scope.densitySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.housingPolicySubmissions = _.filter(response.data, { submission_policy_type: "Housing Production Policy" });
	          _this3.$scope.housingPolicySubmissions = _.union(_this3.$scope.housingPolicySubmissions, _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }), _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }), _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" }));
	          _this3.$scope.housingPolicySubmitted = _.filter(_this3.$scope.housingPolicySubmissions, { submitted: true });
	          _this3.$scope.housingPolicyCompliant = _.filter(_this3.$scope.housingPolicySubmissions, { status: 'Consistent' });
	
	          _this3.$scope.parkingSubmissions = _.filter(response.data, { submission_policy_type: "Parking" });
	          _this3.$scope.parkingSubmitted = _.filter(_this3.$scope.parkingSubmissions, { submitted: true });
	          _this3.$scope.parkingCompliant = _.filter(_this3.$scope.parkingSubmissions, { status: 'Consistent' });
	
	          _this3.$scope.stationAccessSubmissions = _.filter(response.data, { submission_policy_type: "Station Area Access" });
	          _this3.$scope.stationAccessSubmitted = _.filter(_this3.$scope.stationAccessSubmissions, { submitted: true });
	          _this3.$scope.stationAccessCompliant = _.filter(_this3.$scope.stationAccessSubmissions, { status: 'Consistent' });
	        });
	
	        this.$scope.loading = false;
	      } else {
	        this.$scope.stationAreaTitle = '--';
	        return Promise.resolve();
	      }
	    }
	  }]);
	
	  return ProjectPrioritizationComponent;
	}();
	
	exports.default = angular.module('appApp.project_prioritization', [uiRouter]).config(_project_prioritization2.default).component('projectPrioritization', {
	  template: __webpack_require__(184),
	  controller: ProjectPrioritizationComponent,
	  controllerAs: 'projectPrioritizationCtrl'
	}).name;

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('project_prioritization', {
	    url: '/account/stationaccess/project_prioritization?jurisdiction&sta_recid',
	    template: '<project-prioritization></project-prioritization>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null
	    }
	  });
	};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <sidebarnav></sidebarnav>\n    </div>\n\n    <div class=\"main\">\n      <mainheaderauth></mainheaderauth>\n      <maintocselection />\n\n      <div class=\"content container\">\n        <h1 class=\"page-title\">{{breadcrumb[1].linkTitle1}}</h1>\n        <h2 style=\"color: #b8520a\">{{currentStation.station_name}}</h2>\n        <p>\n          The TOC Policy seeks to facilitate robust multi-modal access to\n          transit stations. This supports increased residential and commercial\n          density in TOC areas and enables people living or working outside the\n          TOC area to use the region’s transit network for more of their trips.\n        </p>\n\n        <div class=\"alert alert-warning\" ng-if=\"!currentSelectedStationId\" role=\"alert\">\n          Please select a station area\n        </div>\n\n        <div class=\"section-nav\">\n          <div class=\"menu--section-title\">In this section:</div>\n          <ul class=\"menu menu--section\" role=\"tablist\">\n            <!-- <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\" class=\"menu-item menu-item--section active\"\n              ng-click=\"getCurrentStationPolicy('Complete Streets')\">\n              <span class=\"section-number\">I.</span><a href=\"#\">Compliance with MTC's Complete Streets Policy</a>\n            </li> -->\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-2\" class=\"menu-item menu-item--section active\"\n              ng-click=\"getCurrentStationPolicy('Project Prioritization')\">\n              <span class=\"section-number\">I.</span><a href=\"#\">Project Prioritization and Implementation</a>\n            </li>\n            <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit\" class=\"menu-item menu-item--section\"\n              ng-click=\"reviewAndSubmit\">\n              <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n            </li>\n          </ul>\n          <note ng-show=\"note\"></note>\n          <furtherguidance></furtherguidance>\n        </div>\n        <div class=\"tab-content\" ng-if=\"currentSelectedStationId\">\n          <!-- Project Prioritization and Implementation Section  -->\n          <div id=\"section-2\" role=\"tabpanel\" class=\"section tab-pane active\"\n            ng-class=\"{'active show': showPanel === 'stationProjectPrioritization'}\">\n            <div style=\"display: flex; align-items: flex-end; gap: 5px; flex-wrap: nowrap; margin-bottom: 8px;\">\n              <h2 style=\"margin: 0; padding-right: 10px\">Project Prioritization and Implementation</h2>\n              <statuspills ng-repeat=\"submission in stationAccessStatus\"\n              ng-if=\"submission.submission_policy_name === currentStationPolicy.policy_name && submission.submitted === true\"\n              status=\"submission.status\" row-data=\"submission\" on-update=\"updateSubmissionStatus(row, newStatus)\">\n            </statuspills>\n            </div>\n            <div style=\"display: inline; flex-wrap: nowrap; gap: 12px;\">\n              <!-- Admin: Unlock to Edit button (only when submitted) -->\n              <button\n                ng-if=\"currentUser.role === 'Administrator' && (stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, submitted: true})[0]\"\n                class=\"button button--secondary\" ng-click=\"toggleAdminUnlock()\"\n                style=\"white-space: nowrap; margin-top: 12px; margin-bottom: 12px;\">\n                <i class=\"fa-solid\" ng-class=\"adminUnlocked ? 'fa-lock-open' : 'fa-lock'\"></i>\n                {{ adminUnlocked ? 'Lock Form' : 'Unlock to Edit' }}\n              </button>\n              <!-- Non-admin: Withdraw Submission button -->\n              <button\n                ng-if=\"currentUser.role !== 'Administrator' && (stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, submitted: true})[0] && !(stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, status: 'Needs Work'})[0]\"\n                class=\"button button--secondary\" ng-click=\"withdrawSubmission()\" style=\"white-space: nowrap;\">\n                <i class=\"fa-solid fa-rotate-left\"></i>\n                Withdraw Submission\n              </button>\n            </div>\n            <!-- Admin unlocked confirmation -->\n            <div ng-if=\"adminUnlocked && currentUser.role === 'Administrator'\"\n              style=\"margin-bottom: 12px; color: #b8520a; font-style: italic;\">\n              Form is unlocked for editing.\n            </div>\n            <!-- Non-admin read-only notice: submitted and not Needs Work -->\n            <div\n              ng-if=\"formReadOnly && currentUser.role !== 'Administrator' && !(stationAccessStatus | filter:{submission_policy_name: currentStationPolicy.policy_name, status: 'Needs Work'})[0]\"\n              class=\"alert alert-info\" style=\"margin-bottom: 12px; margin-top: 12px;\">\n              This form has been submitted and is read-only. To make changes, click <strong>Withdraw Submission</strong>\n              above. You will need to resubmit after making your changes.\n            </div>\n            <!-- Non-admin editable notice: status is Needs Work -->\n            <p style=\"padding-top: 15px\">\n              <b>MTC staff have created a <a target=\"_blank\" href=\"https://abag.ca.gov/tools-resources/digital-library/project-prioritization-submission-formdocx\" rel=\"noopener noreferrer\">template\n              form</a> to help local jurisdictions with organizing the required documentation.</b> Please download\n              the template, follow the instructions included, and fill out all applicable fields within the\n              template form. After completing the form, click on the checkbox below to upload it.\n            </p>\n\n            <form class=\"row test-validation-styling\" name=\"stationAccessForm\" novalidate>\n              <div class=\"form-item col-lg-12\" style=\"padding-left: 18px\">\n                <div class=\"verification-container\">\n                  <div class=\"form-check\">\n                    <input class=\"form-check-input\" type=\"checkbox\" id=\"checkCapitalImprovement\"\n                      ng-model=\"capital_improvement_program_checked\" ng-disabled=\"formReadOnly\"\n                      onchange=\"angular.element(this).scope().setPending(this)\" />\n                    <label class=\"form-check-label\" for=\"checkCapitalImprovement\"\n                      ng-class=\"{'boldFont': capital_improvement_program_checked}\">\n                      Click to submit completed Project Prioritization Submission Template Form\n                    </label>\n                  </div>\n                  <div class=\"row align-items-center\" ng-show=\"capital_improvement_program_checked\">\n                    <!-- <div class=\"col-lg-1\" ng-if=\"!checkSubstring(currentStationPolicy.capital_improvement_program)\">\n                      <label>URL</label>\n                    </div>\n                    <div class=\"col-lg-5\" ng-if=\"!checkSubstring(currentStationPolicy.capital_improvement_program)\">\n                      <input id=\"capital_improvement_program\" name=\"capital_improvement_program\"\n                        placeholder=\"Enter response or URL\" required\n                        onchange=\"angular.element(this).scope().setPending(this)\"\n                        ng-model=\"currentStationPolicy.capital_improvement_program\" />\n                      <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                        ng-show=\"stationAccessForm.capital_improvement_program.$error.required && formSubmitted\">\n                        Please provide a valid response or URL.\n                      </div>\n                    </div>\n                    <div ng-if=\"!checkSubstring(currentStationPolicy.capital_improvement_program)\" style=\"margin-top: 5px; text-align: center;\" class=\"col-lg-1 col-md-1\"><b>OR</b></div> -->\n                    <!-- File upload capital_improvement_program -->\n                    <div class=\"col-md-5\" ng-if=\"checkSubstring(currentStationPolicy.capital_improvement_program)\"\n                      style=\"padding-bottom: 10px\">\n                      <span style=\"padding-right: 10px\"><a target=\"_blank\"\n                          ng-href=\"{{currentStationPolicy.capital_improvement_program}}\">Uploaded\n                          Template Form</a></span>\n                      <button ng-if=\"!formReadOnly\" class=\"button button--attach\" ng-click=\"removeFile('capital_improvement_program')\">\n                        <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                        Remove\n                      </button>\n                    </div>\n                    <div class=\"row align-items-center\" style=\"padding-bottom: 20px\"\n                      ng-if=\"!checkSubstring(currentStationPolicy.capital_improvement_program)\">\n                      <div class=\"col-lg-3\"><label for=\"capital_improvement_program_file_abcd\">Project Prioritization Submission Template Form</label></div>\n                      <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important\">\n\n                        <input type=\"file\" ng-model=\"capital_improvement_program_file_abcd\"\n                          id=\"capital_improvement_program_file_abcd\" name=\"capital_improvement_program_file_abcd\"\n                          accept=\".pdf, .doc, .docx, .xls, .xlsx\" ng-disabled=\"formReadOnly\"\n                          onchange=\"angular.element(this).scope().setPending(this)\" />\n                      </div>\n                      <div class=\"col-md-4\" ng-if=\"!formReadOnly\">\n                        <button class=\"button button--attach\"\n                          ng-click=\"uploadFile('capital_improvement_program_file_abcd')\">\n                          <i ng-show=\"fileUploading_capital_improvement_program_file_abcd\"\n                            class=\"fa-solid fa-cog fa-spin\"></i>\n                          Upload File\n                        </button>\n                        <button type=\"button\" class=\"button button--clear\"\n                          ng-click=\"clearFile('capital_improvement_program_file_abcd')\">\n                          Clear\n                        </button>\n                      </div>\n                    </div>\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 15px\">\n                      <label>Additional Details <i>(Optional)</i>:</label>\n                      <textarea id=\"capital_improvement_program_details\" name=\"capital_improvement_program_details\"\n                        rows=\"4\" cols=\"50\" onchange=\"angular.element(this).scope().setPending(this)\" ng-disabled=\"formReadOnly\"\n                        ng-model=\"currentStationPolicy.capital_improvement_program_details\">\n                      </textarea>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <submissionsectionsubmit></submissionsectionsubmit>\n            </form>\n          </div>\n\n          <!-- Review and submit  -->\n          <div id=\"section-review-submit\" role=\"tabpanel\" class=\"section tab-pane\"\n            ng-class=\"{'active show': reviewAndSubmit}\">\n            <h2>Review and Submit</h2>\n            <p>\n              <span style=\"font-style: italic\">\n                Select policies below to submit to MTC for review.</span>\n            </p>\n\n            <form class=\"row test-validation-styling\" novalidate style=\"margin-left: 2px\">\n              <div class=\"verification-container\">\n                <div class=\"form-check\">\n                  <input class=\"form-check-input\" id=\"projectPrioritizationCheck\" type=\"checkbox\" value=\"\" ng-model=\"stationaccess.projectPrioritizationCheck\"\n                    ng-click=\"addToSubmissions('stationProjectPrioritization')\"\n                    ng-disabled=\"stationaccess.projectPrioritizationCheck === true\" />\n                  <label class=\"form-check-label\" for=\"projectPrioritizationCheck\" ng-class=\"{'boldFont': stationaccess.projectPrioritizationCheck}\">\n                    Project Prioritization and Implementation <span ng-if=\"stationaccess.projectPrioritizationCheck === true\"\n                                        class=\"badge badge--submitted\">Submitted</span>\n                  </label>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"stationaccess.projectPrioritizationCheck\">\n                  <p>\n                    I have completed the the Compliance with MTC's <a href=\"#\"\n                      ng-click=\"togglePanel('stationProjectPrioritization')\">Project Prioritization and Implementation\n                      Section</a>\n                    and uploaded any relevant documentation.\n                  </p>\n                </div>\n                <div class=\"row align-items-center\" ng-show=\"stationProjectPrioritization[0].submitted\">\n                  <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                    <div class=\"col\">\n                      <div class=\"alert alert-success fade show\" role=\"alert\">\n                        This policy has been submitted and is under review.\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </form>\n            <submissionsectionsubmit></submissionsectionsubmit>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"footer\" role=\"contentinfo\">\n    <sidebarfooter></sidebarfooter>\n  </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FeedbackComponent = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _feedback = __webpack_require__(186);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var FeedbackComponent = exports.FeedbackComponent = function () {
	  /*@ngInject*/
	  function FeedbackComponent(feedbackService, $scope, $http, baseConfigService) {
	    _classCallCheck(this, FeedbackComponent);
	
	    this.$scope = $scope;
	    this.$http = $http;
	
	    this.feedbackService = feedbackService;
	    this.baseConfigService = baseConfigService;
	  }
	
	  _createClass(FeedbackComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.getAllFeedback();
	    }
	  }, {
	    key: 'getAllFeedback',
	    value: function getAllFeedback() {
	      var _this = this;
	
	      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
	      function generateUUID() {
	        var d = new Date().getTime();
	
	        var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
	
	        uuid = uuid.replace(/[xy]/g, function (c) {
	          var r = (d + Math.random() * 16) % 16 | 0;
	
	          d = Math.floor(d / 16);
	
	          return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
	        });
	
	        return uuid;
	      }
	
	      this.feedbackService.getAllFeedback().then(function (feedback) {
	        var _ref;
	
	        _this.$scope.rowCollection = feedback.data;
	
	        var container = document.querySelector('#example5');
	        var data = feedback.data;
	
	        var thisIsValid = _this.$scope.thisIsValid;
	
	        _this.$scope.hot = new Handsontable(container, (_ref = {
	          data: data,
	          colHeaders: true,
	          allowInsertRow: true,
	          manualColumnResize: true,
	          height: 'auto',
	          stretchH: "all",
	          width: "100%",
	          autoWrapRow: true,
	          rowHeaders: true,
	          filters: true,
	          contextMenu: true,
	          dropdownMenu: ["filter_by_condition", "filter_by_value", "filter_action_bar"],
	          hiddenColumns: {
	            indicators: true
	          },
	          manualColumnMove: true,
	          manualColumnFreeze: true }, _defineProperty(_ref, 'manualColumnResize', true), _defineProperty(_ref, 'multiColumnSorting', {
	          indicator: true
	        }), _defineProperty(_ref, 'colHeaders', ["ID", "Type", "Comment", "Email", "Status", "Source", "Date", "Asana", "Github"]), _defineProperty(_ref, 'columns', [{ data: 'recid' }, { data: 'type' }, { data: 'comment' }, { data: 'email' }, { data: 'status',
	          type: "dropdown",
	          source: ["submitted", "reviewed"],
	          strict: true
	        }, { data: 'source' }, { data: 'date' }, { data: 'asana',
	          type: "checkbox",
	          className: "htCenter"
	        }, { data: 'github',
	          type: "checkbox",
	          className: "htCenter"
	        }]), _defineProperty(_ref, 'minSpareRows', 1), _defineProperty(_ref, 'licenseKey', 'non-commercial-and-evaluation'), _defineProperty(_ref, 'afterValidate', function afterValidate(isValid, value, row, prop, source) {
	          thisIsValid = isValid;
	        }), _ref));
	
	        var hot = _this.$scope.hot;
	        var http = _this.$http;
	        var feedbackService = _this.feedbackService;
	
	        hot.addHook("afterChange", function (changes, source) {
	          var updateData = [];
	          changes.forEach(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 1),
	                row = _ref3[0];
	
	            var handsonUpdate = hot.getDataAtRow(row);
	            updateData.push({
	              recid: handsonUpdate[0],
	              type: handsonUpdate[1],
	              comment: handsonUpdate[2],
	              email: handsonUpdate[3],
	              status: handsonUpdate[4],
	              source: handsonUpdate[5],
	              date: handsonUpdate[6],
	              asana: handsonUpdate[7],
	              github: handsonUpdate[8]
	            });
	          });
	          if (typeof thisIsValid === "undefined") {
	            http.post(adminBaseURL + '/feedback/update', updateData).then(function (responseReport) {}).catch(function (err) {
	              console.log(err);
	            });
	          } else if (!thisIsValid) {
	            console.log("its not valid");
	          } else {
	            http.post(adminBaseURL + '/feedback/update', updateData).then(function (responseReport) {}).catch(function (err) {
	              console.log(err);
	            });
	          }
	        });
	
	        hot.addHook("afterCreateRow", function (index, amount, source) {
	          data[index].recid = generateUUID();
	        });
	
	        hot.addHook("beforeRemoveRow", function (index, amount, physicalRows, source) {
	          feedbackService.deleteFeedback(data[index].recid).then(function (response) {}).catch(function (err) {
	            console.log(err);
	          });
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'getFeedback',
	    value: function getFeedback(id) {
	      this.feedbackService.getFeedback(id).then(function (feedback) {}).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'editFeedback',
	    value: function editFeedback(row) {
	      console.log(row);
	    }
	  }, {
	    key: 'updateFeedback',
	    value: function updateFeedback(id) {
	      this.feedbackService.updateFeedback(id).then(function (feedback) {
	        console.log(feedback);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'deleteFeedback',
	    value: function deleteFeedback(id) {
	      this.feedbackService.deleteFeedback(id).then(function (feedback) {
	        console.log(feedback);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }]);
	
	  return FeedbackComponent;
	}();
	
	exports.default = angular.module('appApp.feedback', [uiRouter]).config(_feedback2.default).component('feedback', {
	  template: __webpack_require__(187),
	  controller: FeedbackComponent,
	  controllerAs: 'feedbackCtrl'
	}).name;

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('feedback', {
	    url: '/admin/feedback',
	    template: '<feedback></feedback>'
	  });
	};

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = "\n\n<style>\n  .header__actions {\n      display: flex;\n      position: absolute;\n      justify-content: space-between;\n      top: 68px;\n      width: 100%;\n      height: 50px;\n      background: linear-gradient(90deg, #274a69 0%, #00303F 100%)\n  }\n  @media(min-width: 992px) {\n      .header__actions {\n          top: 8px;\n          right: 0;\n          background: transparent;\n          width: 375px;\n          z-index: 1\n      }\n  }\n  \n  .header__account-nav {\n      margin-left: 20px\n  }\n  @media(min-width: 992px) {\n      .header__account-nav {\n          margin-left: 0\n      }\n  }\n  .header__account-nav .dropdown-toggle {\n      position: relative;\n      display: flex;\n      align-items: center;\n      background: transparent;\n      border: 0;\n      border-radius: 0;\n      height: 50px;\n      font-size: 18px;\n      font-size: 1.125rem;\n      line-height: 1.5;\n      font-family: \"Nunito\", \"Helvetica Neue\", \"Arial\", sans-serif;\n      font-weight: 600;\n      width: 240px;\n      padding: 5px 15px 5px 40px\n  }\n  .header__account-nav .dropdown-toggle:before {\n      position: absolute;\n      left: 0;\n      border-left: 1px solid #E5F5FC;\n      padding-left: 12px;\n      width: 30px;\n      height: 30px;\n      font-family: \"Font Awesome 6 Pro\";\n      font-weight: 300;\n      font: var(--fa-font-light);\n      color: #E5F5FC;\n      font-size: 18px;\n      line-height: 1.5;\n      content: '\\f2bd'\n  }\n  .header__account-nav .dropdown-toggle:after {\n      position: absolute;\n      right: 0;\n      border: 0;\n      border-right: 1px solid #E5F5FC;\n      padding-right: 20px;\n      height: 30px;\n      font-family: \"Font Awesome 6 Pro\";\n      font: var(--fa-font-solid);\n      color: #fff;\n      font-size: 18px;\n      line-height: 1.5;\n      content: '\\f0d7'\n  }\n  .header__account-nav .dropdown-toggle.show:after {\n      content: '\\f0d8'\n  }\n  .header__account-nav .dropdown-toggle:hover:after,\n  .header__account-nav .dropdown-toggle:focus:after {\n      color: #fff\n  }\n  .header__account-nav .dropdown-toggle:hover,\n  .header__account-nav .dropdown-toggle:focus,\n  .header__account-nav .dropdown-toggle:active,\n  .header__account-nav .dropdown-toggle.show {\n      background: #00303F\n  }\n  .header__account-nav .dropdown-toggle:hover:before,\n  .header__account-nav .dropdown-toggle:hover:after,\n  .header__account-nav .dropdown-toggle:focus:before,\n  .header__account-nav .dropdown-toggle:focus:after,\n  .header__account-nav .dropdown-toggle:active:before,\n  .header__account-nav .dropdown-toggle:active:after,\n  .header__account-nav .dropdown-toggle.show:before,\n  .header__account-nav .dropdown-toggle.show:after {\n      border-color: transparent\n  }\n  .header__account-nav .dropdown-menu {\n      top: -2px !important;\n      background: #D9E0E2;\n      border-color: #00303F;\n      border-radius: 0 0 4px 4px;\n      min-width: 240px;\n      font-size: 16px;\n      font-size: 1rem;\n      line-height: 1.1875;\n      font-family: \"Nunito Sans\", \"Helvetica Neue\", \"Arial\", sans-serif;\n      font-weight: 400;\n      padding-top: 0\n  }\n  .header__account-nav .dropdown-menu .dropdown-item {\n      background: #00303F;\n      color: #fff;\n      padding: 15px 20px;\n      height: 50px\n  }\n  .header__account-nav .dropdown-menu .dropdown-item--icon {\n      background: transparent;\n      color: #00303F;\n      padding-left: 55px\n  }\n  .header__account-nav .dropdown-menu .dropdown-item--icon:before {\n      position: absolute;\n      left: 18px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 30px;\n      font-family: \"Font Awesome 6 Pro\";\n      font-weight: 300;\n      font: var(--fa-font-light);\n      color: #00303F;\n      font-size: 18px;\n      content: ''\n  }\n  .header__account-nav .dropdown-menu .dropdown-item--icon:hover,\n  .header__account-nav .dropdown-menu .dropdown-item--icon:active,\n  .header__account-nav .dropdown-menu .dropdown-item--icon:focus {\n      background: #fff;\n      color: #00303F\n  }\n  .header__account-nav .dropdown-menu .dropdown-item--account:before {\n      content: '\\f2bd'\n  }\n  .header__account-nav .dropdown-menu .dropdown-item--exit:before {\n      content: '\\f08b'\n  }\n  \n  .header__configuration-trigger {\n      width: 35px;\n      margin: 0 20px\n  }\n  @media(min-width: 992px) {\n      .header__configuration-trigger {\n          margin-right: 35px\n      }\n  }\n  \n  .toggle--configuration-nav {\n      position: absolute;\n      top: 8px;\n      border: 0;\n      border-radius: 50%;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      background-color: transparent;\n      width: 35px;\n      height: 35px;\n      padding: 3px 0;\n      cursor: pointer;\n      z-index: 3\n  }\n  .toggle--configuration-nav:after {\n      display: block;\n      width: 35px;\n      height: 35px;\n      font-family: \"Font Awesome 6 Pro\";\n      font-weight: 300;\n      font: var(--fa-font-light);\n      color: #BFCBCF;\n      font-size: 24px;\n      font-size: 1.5rem;\n      line-height: 1.125;\n      text-align: center;\n      content: '\\f013'\n  }\n  .toggle--configuration-nav:hover,\n  .toggle--configuration-nav:focus,\n  .toggle--configuration-nav.active {\n      background-color: transparent\n  }\n  .toggle--configuration-nav:hover:after,\n  .toggle--configuration-nav:focus:after,\n  .toggle--configuration-nav.active:after {\n      color: #fff\n  }\n  .toggle--configuration-nav:focus {\n      outline: none\n  }\n  .toggle--configuration-nav:focus-visible {\n      outline: -webkit-focus-ring-color auto 1px\n  }\n  \n  .dashboard__header__navigation {\n      z-index: 10\n  }\n  @media(min-width: 992px) {\n      .dashboard__header__navigation {\n          height: calc(100vh - 132px - 180px);\n          overflow-y: scroll;\n          z-index: 0\n      }\n  }\n  .dashboard__header__navigation .navigation,\n  .dashboard__header__navigation .navbar-collapse {\n      flex-direction: column;\n      align-items: flex-start;\n      background-color: #fff\n  }\n  .dashboard__header__navigation .navbar-collapse.show {\n      position: absolute;\n      top: 0;\n      width: 100%;\n      padding-bottom: 20px;\n      z-index: 5\n  }\n  .dashboard__header__navigation .nav {\n      width: 100%\n  }\n  .dashboard__header__navigation .nav--tools {\n      position: relative;\n      margin-top: 16px\n  }\n  .dashboard__header__navigation .nav--tools:before {\n      position: absolute;\n      top: -8px;\n      left: 20px;\n      width: calc(100% - 40px);\n      height: 1px;\n      background-color: #597882;\n      content: ''\n  }\n  .dashboard__header__navigation .nav--tools .nav-item .dropdown-toggle {\n      font-weight: 700\n  }\n  .dashboard__header__navigation .nav-heading {\n      font-size: 14px;\n      font-size: 0.875rem;\n      line-height: 1.357143;\n      font-family: \"Nunito Sans\", \"Helvetica Neue\", \"Arial\", sans-serif;\n      font-weight: 700;\n      text-transform: uppercase;\n      margin-top: 12px;\n      padding: 8px 20px\n  }\n  .dashboard__header__navigation .nav-item {\n      position: relative\n  }\n  .dashboard__header__navigation .nav-item .nav-link {\n      font-size: 18px;\n      font-size: 1.125rem;\n      line-height: 1.055556;\n      font-family: \"Nunito Sans\", \"Helvetica Neue\", \"Arial\", sans-serif;\n      font-weight: 400;\n      display: block;\n      width: 100%;\n      padding: 11px 20px;\n      color: #00303F\n  }\n  .dashboard__header__navigation .nav-item .nav-link:hover,\n  .dashboard__header__navigation .nav-item .nav-link:focus,\n  .dashboard__header__navigation .nav-item .nav-link.active,\n  .dashboard__header__navigation .nav-item .nav-link.show {\n      background: #b8520a;\n      color: #fff;\n      text-decoration: none\n  }\n  .dashboard__header__navigation .nav-item .nav-link:hover:before,\n  .dashboard__header__navigation .nav-item .nav-link:hover:after,\n  .dashboard__header__navigation .nav-item .nav-link:focus:before,\n  .dashboard__header__navigation .nav-item .nav-link:focus:after,\n  .dashboard__header__navigation .nav-item .nav-link.active:before,\n  .dashboard__header__navigation .nav-item .nav-link.active:after,\n  .dashboard__header__navigation .nav-item .nav-link.show:before,\n  .dashboard__header__navigation .nav-item .nav-link.show:after {\n      color: #fff\n  }\n  .dashboard__header__navigation .nav-item .nav-link--icon {\n      padding: 11px 20px 11px 55px\n  }\n  .dashboard__header__navigation .nav-item .nav-link--icon:before {\n      position: absolute;\n      left: 18px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 30px;\n      font-family: \"Font Awesome 6 Pro\";\n      font-weight: 300;\n      font: var(--fa-font-light);\n      color: #00303F;\n      font-size: 18px;\n      content: ''\n  }\n  .dashboard__header__navigation .nav-item .nav-link--dashboard:before {\n      content: '\\f0db'\n  }\n  .dashboard__header__navigation .nav-item .nav-link--compliance:before {\n      content: '\\f46d'\n  }\n  .dashboard__header__navigation .nav-item .nav-link--policy:before {\n      content: '\\f15c'\n  }\n  .dashboard__header__navigation .nav-item .nav-link--density:before {\n      content: '\\e603'\n  }\n  .dashboard__header__navigation .nav-item .nav-link--housing:before {\n      content: '\\e1b1'\n  }\n  .dashboard__header__navigation .nav-item .nav-link--parking:before {\n      content: '\\f540'\n  }\n  .dashboard__header__navigation .nav-item .nav-link--station:before {\n      content: '\\f5b6'\n  }\n  .dashboard__header__navigation .nav-item .nav-link--map:before {\n      content: '\\f279'\n  }\n  .dashboard__header__navigation .dropdown-toggle:after {\n      position: absolute;\n      right: 20px;\n      border: 0;\n      font-family: \"Font Awesome 6 Pro\";\n      font-weight: 300;\n      font: var(--fa-font-light);\n      color: #00303F;\n      font-size: 18px;\n      content: '\\203a'\n  }\n  .dashboard__header__navigation .dropdown-toggle.show:after {\n      content: '\\f078'\n  }\n  .dashboard__header__navigation .dropdown-toggle:hover:after,\n  .dashboard__header__navigation .dropdown-toggle:focus:after {\n      color: #fff\n  }\n  .dashboard__header__navigation .dropdown-menu {\n      padding: 0;\n      margin: 0 0 20px\n  }\n  .dashboard__header__navigation .dropdown-menu.show {\n      position: static;\n      border: 0\n  }\n  @media(min-width: 992px) {\n      .dashboard__header__navigation .dropdown-menu.show {\n          width: 240px\n      }\n  }\n  .dashboard__header__navigation .dropdown-item {\n      font-size: 15px;\n      font-size: 0.9375rem;\n      line-height: 1.133333;\n      margin: 20px 0 15px;\n      padding: 0 20px 0 35px;\n      font-family: \"Nunito Sans\", \"Helvetica Neue\", \"Arial\", sans-serif;\n      font-weight: 400;\n      white-space: normal\n  }\n  .dashboard__header__navigation .dropdown-item:hover,\n  .dashboard__header__navigation .dropdown-item:focus {\n      text-decoration: underline\n  }\n  .dashboard__header__navigation .dropdown-item:hover,\n  .dashboard__header__navigation .dropdown-item:focus,\n  .dashboard__header__navigation .dropdown-item:active,\n  .dashboard__header__navigation .dropdown-item.active {\n      background-color: transparent;\n      color: #00303F\n  }\n  .dashboard__header__navigation .dropdown-item.active {\n      font-weight: 700\n  }\n  \n  .navbar {\n      padding: 0\n  }\n  .navbar-toggler {\n      display: none\n  }\n  \n  .breadcrumb-container {\n      position: absolute;\n      top: 118px;\n      background: #369;\n      min-height: 50px;\n      width: 100%\n  }\n  @media(min-width: 992px) {\n      .breadcrumb-container {\n          top: 8px;\n          background: linear-gradient(90deg, #369 0%, #00303F 100%);\n          height: 50px\n      }\n  }\n  .breadcrumb {\n      color: #fff;\n      align-items: center;\n      height: 50px;\n      margin: 0 20px\n  }\n  @media(min-width: 992px) {\n      .breadcrumb {\n          margin-left: 278px\n      }\n  }\n  .breadcrumb .breadcrumb-item {\n      font-size: 13px;\n      font-size: 0.8125rem;\n      line-height: 1.307692;\n      font-family: \"Nunito Sans\", \"Helvetica Neue\", \"Arial\", sans-serif;\n      font-weight: 400;\n      color: inherit\n  }\n  .breadcrumb .breadcrumb-item:first-child {\n      font-size: 18px;\n      font-weight: 700\n  }\n  .breadcrumb .breadcrumb-item a {\n      color: inherit;\n      border-bottom: 0\n  }\n  .breadcrumb .breadcrumb-item a:hover,\n  .breadcrumb .breadcrumb-item a:focus,\n  .breadcrumb .breadcrumb-item a:active {\n      border-bottom: 0;\n      color: inherit;\n      text-decoration: underline\n  }\n  .breadcrumb .breadcrumb-item+.breadcrumb-item::before {\n      color: inherit\n  }\n  \n  .dashboard {\n      background-color: #F2F4F5\n  }\n  .dashboard .container {\n      padding-left: 20px;\n      padding-right: 20px\n  }\n  .dashboard .main {\n      font-size: 17px;\n      font-size: 1.0625rem;\n      line-height: 1.588235;\n      padding: 135px 0 40px\n  }\n  @media(min-width: 992px) {\n      .dashboard main {\n          padding-top: 90px;\n          height: 100vh\n      }\n  }\n  .dashboard h1 {\n      font-size: 28px;\n      font-size: 1.75rem;\n      line-height: 1.142857\n  }\n  @media(min-width: 992px) {\n      .dashboard h1 {\n          font-size: 50px;\n          font-size: 3.125rem;\n          line-height: 1.08\n      }\n  }\n  .dashboard h2 {\n      margin: 9px 0 12px;\n      font-family: \"Nunito Sans\", \"Helvetica Neue\", \"Arial\", sans-serif;\n      font-weight: 400\n  }\n  .dashboard h3 {\n      font-size: 18px;\n      font-size: 1.125rem;\n      line-height: 1.5;\n      margin-bottom: 0\n  }\n  .dashboard .page-summary {\n      font-size: 19px;\n      font-size: 1.1875rem;\n      line-height: 1.263158;\n      margin-bottom: 14px;\n      font-weight: 300\n  }\n  @media(min-width: 992px) {\n      .dashboard .page-summary {\n          font-size: 24px;\n          font-size: 1.5rem;\n          line-height: 1.333333\n      }\n  }\n  .dashboard .image--full {\n      max-width: 730px;\n      overflow: hidden\n  }\n  @media(min-width: 544px) {\n      .dashboard .image--full {\n          border-radius: 4px\n      }\n  }\n  .dashboard figure {\n      margin: 20px -20px 40px\n  }\n  .dashboard figure figcaption {\n      padding: 0 20px\n  }\n  @media(min-width: 544px) {\n      .dashboard figure {\n          margin: 20px 0 40px\n      }\n      .dashboard figure figcaption {\n          padding: 0\n      }\n  }\n  .dashboard figcaption {\n      font-size: 14px;\n      font-size: 0.875rem;\n      line-height: 1.214286;\n      margin-top: 10px;\n      font-family: \"Nunito Sans\", \"Helvetica Neue\", \"Arial\", sans-serif;\n      font-weight: 600\n  }\n  .dashboard figcaption .image-credit {\n      font-size: 12px;\n      font-size: 0.75rem;\n      line-height: 1.416667;\n      font-weight: 300;\n      font-style: italic\n  }\n  @media(min-width: 992px) {\n      .dashboard .content {\n          margin-left: 255px\n      }\n  }\n  @media(min-width: 1200px) {\n      .dashboard .content {\n          margin-left: 285px\n      }\n  }\n  @media(min-width: 1440px) {\n      .dashboard .content {\n          margin-left: 315px\n      }\n  }\n  .dashboard .content a {\n      color: #b8520a;\n      border-bottom: 1px dashed #99acb2;\n      text-decoration: none;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      -ms-word-break: break-all;\n      word-break: break-all;\n      word-break: break-word;\n      -ms-hyphens: auto;\n      -moz-hyphens: auto;\n      -webkit-hyphens: auto;\n      hyphens: auto\n  }\n  .dashboard .content a:hover,\n  .dashboard .content a:active,\n  .dashboard .content a:focus {\n      color: #b8520a;\n      border-bottom: 1px solid #b8520a;\n      text-decoration: none\n  }\n  @media(min-width: 992px) {\n      .dashboard--content .content {\n          max-width: 1430px\n      }\n      .dashboard--content .content figure {\n          margin-right: -60px\n      }\n      .dashboard--content .content figure figcaption {\n          padding-right: 60px\n      }\n  }\n  \n  @media(min-width: 992px) {\n      .dashboard-header {\n          position: absolute;\n          top: 8px;\n          width: 240px;\n          height: 100vh;\n          z-index: 1;\n          box-shadow: 0 6px 6px rgba(0, 0, 0, 0.16)\n      }\n  }\n  \n  .dashboard-header {\n      background-color: #fff;\n  }\n  \n  .footer {\n      font-size: 14px;\n      font-size: 0.875rem;\n      line-height: 1.428571;\n      background-color: #00303F;\n      color: #fff\n  }\n  @media(min-width: 992px) {\n      .footer {\n          position: fixed;\n          bottom: 0;\n          z-index: 10;\n          width: 240px;\n          height: 180px\n      }\n  }\n  .footer a {\n      color: inherit\n  }\n  .footer .container {\n      padding-top: 35px;\n      padding-bottom: 35px\n  }\n  @media(min-width: 992px) {\n      .footer .container {\n          padding-top: 18px;\n          padding-bottom: 18px\n      }\n  }\n  .footer img {\n      margin-bottom: 20px;\n      width: auto;\n      height: 36px\n  }\n  \n  </style>\n  <section class=\"dashboard dashboard--content dashboard--content--housing\">\n      <div class=\"page-wrapper\">\n          <sidebarnav></sidebarnav>\n          \n          <div class=\"main\">\n              <bcnavbar></bcnavbar>\n              <div class=\"content container\" style=\"min-width: 1500px;\">\n                  <div class=\"row\">\n                      <div>\n                          <h1 class=\"page-title\">Manage Feedback</h1>\n                          <div class=\"col-md-12\" style=\"min-height:60vh;\">\n                            <div class=\"row\" ng-show=\"!rowCollection\" style=\"padding:5px;\">\n                              <div class=\"col-md-12\">\n                                <i class=\"fa-solid fa-cog fa-spin\" style=\"font-size:20px;\"></i><span\n                                  style=\"font-size:15px;padding-left:10px;\">Loading Users...</span>\n                              </div>\n                            </div>\n              \n                            <div class=\"row\"  style=\"margin-right:15px;margin-left:15px;\">\n                              <div class=\"table-responsive\">\n                                <div id=\"example5\" class=\"hot\"></div>\n                              </div>\n                              \n                            </div>\n                          </div>\n                          \n                      </div>\n                  </div>\n              </div>\n          </div>\n      \n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n          <!-- footer start -->\n          <div class=\"container\">\n              <div class=\"row\">\n                  <div class=\"col-12\">\n                      <p>Powered by:</p>\n                  </div>\n                  <div class=\"col-6 col-lg-12\">\n                      <p><a href=\"https://mtc.ca.gov\" title=\"Metropolitan Transportation Commission\" target=\"_blank\" rel=\"noopener noreferrer\"><img class=\"logo-mtc\" alt=\"Metropolitan Transportation Commission logo\" src=\"../assets/images/mtc_footer_logo.svg\"><span class=\"visually-hidden\">(link is external, opens in a new window)</span></a></p>\n                  </div>\n                  <div class=\"col-6 col-lg-12\">\n                      <p><a href=\"https://abag.ca.gov/\" target=\"_blank\" rel=\"noopener noreferrer\"><img class=\"logo-abag\" title=\"Association of Bay Area Governments\" alt=\"Association of Bay Area Governments logo\" src=\"../assets/images/abag_footer_logo.svg\"><span class=\"visually-hidden\">(link is external, opens in a new window)</span></a></p>\n                  </div>\n              </div>\n          </div>\n          <!-- footer end -->\n      </div>\n  </section>\n\n\n\n  \n  "

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ComplianceComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _compliance = __webpack_require__(189);
	
	var _compliance2 = _interopRequireDefault(_compliance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ComplianceComponent = exports.ComplianceComponent = function () {
	    /*@ngInject*/
	    function ComplianceComponent($scope, $http, userService, baseConfigService, fetch, $state, $location, $timeout) {
	        _classCallCheck(this, ComplianceComponent);
	
	        this.$scope = $scope;
	        this.$http = $http;
	        this.$state = $state;
	        this.fetch = fetch;
	        this.$location = $location;
	        this.$timeout = $timeout;
	
	        this.userService = userService;
	        this.baseConfigService = baseConfigService;
	        $scope.baseUrl = baseConfigService.getBaseURL();
	
	        $scope.rowCollection = [];
	        $scope.filteredCollection = [];
	
	        $scope.groupSubmissions = function (submissions) {
	            var grouped = {};
	
	            submissions.forEach(function (submission) {
	                var key = submission.jurisdiction + '|' + submission.station_name;
	
	                if (!grouped[key]) {
	                    grouped[key] = {
	                        jurisdiction: submission.jurisdiction,
	                        station_name: submission.station_name,
	                        count: 0,
	                        submissions: [],
	                        status: 'In Review' };
	                }
	
	                grouped[key].count += 1;
	                grouped[key].submissions.push(submission);
	            });
	
	            Object.values(grouped).forEach(function (group) {
	                var statuses = group.submissions.map(function (sub) {
	                    return sub.status;
	                });
	                if (statuses.every(function (status) {
	                    return status === statuses[0];
	                })) {
	                    group.status = statuses[0];
	                } else {
	                    group.status = 'In Review';
	                }
	            });
	
	            return Object.values(grouped);
	        };
	
	        $scope.groupSubmissions = function (submissions) {
	            var grouped = {};
	
	            submissions.forEach(function (submission) {
	                var key = submission.jurisdiction + '|' + submission.station_name;
	
	                if (!grouped[key]) {
	                    grouped[key] = {
	                        jurisdiction: submission.jurisdiction,
	                        station_name: submission.station_name,
	                        count: 0
	                    };
	                }
	
	                grouped[key].count += 1;
	            });
	
	            return Object.values(grouped);
	        };
	
	        $scope.filterTable = function (policyType) {
	            switch (policyType) {
	                case 'Density':
	                    $scope.filteredCollection = $scope.groupSubmissions($scope.densitySubmissions);
	                    break;
	                case 'Housing Policies':
	                    $scope.filteredCollection = $scope.groupSubmissions($scope.housingSubmissions);
	                    break;
	                case 'Parking':
	                    $scope.filteredCollection = $scope.groupSubmissions($scope.parkingSubmissions);
	                    break;
	                case 'Station Area Access':
	                    $scope.filteredCollection = $scope.groupSubmissions($scope.stationAreaAccessSubmissions);
	                    break;
	                default:
	                    $scope.filteredCollection = $scope.groupedCollection;}
	        };
	    }
	
	    _createClass(ComplianceComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.userService.getCurrentUser().then(function (response) {
	
	                _this.$scope.currentUser = response.data;
	                _this.userService.setCurrentUser(response.data);
	            }).catch(function (err) {
	                console.log(err);
	                if (err.status === 403) {
	                    _this.$state.go('login');
	                }
	            });
	
	            this.fetch.getAllItems('api/data/submissions/get-submission-summary').then(function (response) {
	
	                console.log(response);
	                _this.$scope.rowCollection = response.data;
	                _this.$scope.groupedCollection = _this.$scope.groupSubmissions(response.data);
	                _this.$scope.filteredCollection = [].concat(_this.$scope.groupedCollection);
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            this.fetch.getAllItems('api/data/submissions/get-submissions').then(function (response) {
	                console.log(response);
	                _this.$scope.rowCollection = response.data;
	                var submissions = response.data;
	                var housingPolicyTypes = ['Housing Commercial Policy', 'Housing Production Policy', 'Housing Preservation Policy', 'Commercial Stabilization Policy'];
	
	                _this.$scope.housingSubmissions = _.filter(submissions, function (submission) {
	                    return housingPolicyTypes.includes(submission.submission_policy_type);
	                });
	                _this.$scope.densitySubmissions = _.filter(submissions, { submission_policy_type: 'Density' });
	                _this.$scope.parkingSubmissions = _.filter(submissions, { submission_policy_type: 'Parking' });
	                _this.$scope.stationAreaAccessSubmissions = _.filter(submissions, { submission_policy_type: 'Station Area Access' });
	                _this.$scope.zoningUpdatesSubmissions = _.filter(submissions, { submission_policy_type: 'Jurisdiction Zoning Updates' });
	
	                _this.$scope.groupedCollection = _this.$scope.groupSubmissions(response.data);
	
	                _this.$scope.filteredCollection = [].concat(_this.$scope.groupedCollection);
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }]);
	
	    return ComplianceComponent;
	}();
	
	exports.default = angular.module('appApp.compliance', [uiRouter, 'smart-table']).config(_compliance2.default).component('compliance', {
	    template: __webpack_require__(190),
	    controller: ComplianceComponent,
	    controllerAs: 'complianceCtrl'
	}).name;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('compliance', {
	    url: '/account/compliance',
	    template: '<compliance></compliance>'
	  });
	};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--compliance dashboard--compliance--landing\">\n    <div class=\"page-wrapper\">\n\n        <div class=\"dashboard-header\">\n            <sidebarnav></sidebarnav>\n        </div>\n\n        <div class=\"main\">\n            <mainheaderauth></mainheaderauth>\n\n            <div class=\"content container\">\n                <h1 class=\"page-title\">Compliance</h1>\n                <div class=\"section col-lg-12\">\n                    <div class=\"section-header\">\n                        <h2>Submission Summary</h2>\n                        <!-- <div class=\"tab-nav\">\n                          <ul class=\"menu menu--tabs\" role=\"tablist\">\n                              <li data-bs-toggle=\"tab\" data-bs-target=\"#new\" class=\"menu-item menu-item--tab active\"><button type=\"button\" class=\"btn\">New</button></li>\n                              <li data-bs-toggle=\"tab\" data-bs-target=\"#in-review\" class=\"menu-item menu-item--tab\"><button type=\"button\" class=\"btn\">In Review</button></li>\n                              <li data-bs-toggle=\"tab\" data-bs-target=\"#pending\" class=\"menu-item menu-item--tab\"><button type=\"button\" class=\"btn\">Pending</button></li>\n                          </ul>\n                      </div> -->\n                        <div class=\"view-all\">\n                            <a ui-sref=\"submissions\" class=\"link--more\" title=\"View all submissions\"\n                                aria-label=\"View all submissions\">View All</a>\n                        </div>\n                    </div>\n                    <div class=\"table-responsive\">\n                        <div class=\"tab-content\">\n                            <div id=\"new\" role=\"tabpanel\" class=\"tab-pane show active\">\n                                <div class=\"card card--default col-lg-3\" style=\"padding:30px;\"\n                                    ng-click=\"filterTable('Density')\">\n                                    <div class=\"tag tag--icon tag--icon--density\">Density</div>\n                                    <div class=\"card__title\">\n                                        <h3>{{densitySubmissions.length ? densitySubmissions.length : '0'}} Submitted\n                                        </h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\" style=\"padding:30px;\"\n                                    ng-click=\"filterTable('housingPolicyTypes')\">\n                                    <div class=\"tag tag--icon tag--icon--housing\">Housing Policies</div>\n                                    <div class=\"card__title\">\n                                        <h3>{{housingSubmissions.length ? housingSubmissions.length : '0'}} Submitted\n                                        </h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\" style=\"padding:30px;\"\n                                    ng-click=\"filterTable('Parking')\">\n                                    <div class=\"tag tag--icon tag--icon--parking\">Parking</div>\n                                    <div class=\"card__title\">\n                                        <h3>{{parkingSubmissions.length ? parkingSubmissions.length : '0'}} Submitted\n                                        </h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n\n                                <div class=\"card card--default col-lg-3\" style=\"padding:30px;\"\n                                    ng-click=\"filterTable('Station Access')\">\n                                    <div class=\"tag tag--icon tag--icon--station\">Station Access</div>\n                                    <div class=\"card__title\">\n                                        <h3>{{stationAreaAccessSubmissions.length ? stationAreaAccessSubmissions.length\n                                            : '0'}} Submitted</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n\n                            </div>\n                            <div id=\"in-review\" role=\"tabpanel\" class=\"tab-pane\">\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--density\">Density</div>\n                                    <div class=\"card__title\">\n                                        <h3>In Review Various Sapien Suscipit Lipsum</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--housing\">Housing Policies</div>\n                                    <div class=\"card__title\">\n                                        <h3>Pellentesque Laoreet Lipsum Policy Name</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--parking\">Parking</div>\n                                    <div class=\"card__title\">\n                                        <h3>Policy Name Lorem Lipsum Parking</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--housing\">Housing Policies</div>\n                                    <div class=\"card__title\">\n                                        <h3>Curabitur Maximus Policy Name Lipsum</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--station\">Station Access</div>\n                                    <div class=\"card__title\">\n                                        <h3>Lorem Ipsum Station Access Policy Name</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--housing\">Housing Policies</div>\n                                    <div class=\"card__title\">\n                                        <h3>Quisque Tempus Lipsum Policy Name</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                            </div>\n                            <div id=\"pending\" role=\"tabpanel\" class=\"tab-pane\">\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--density\">Density</div>\n                                    <div class=\"card__title\">\n                                        <h3>Pending Various Sapien Suscipit Lipsum</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--housing\">Housing Policies</div>\n                                    <div class=\"card__title\">\n                                        <h3>Pellentesque Laoreet Lipsum Policy Name</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--parking\">Parking</div>\n                                    <div class=\"card__title\">\n                                        <h3>Policy Name Lorem Lipsum Parking</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--housing\">Housing Policies</div>\n                                    <div class=\"card__title\">\n                                        <h3>Curabitur Maximus Policy Name Lipsum</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--station\">Station Access</div>\n                                    <div class=\"card__title\">\n                                        <h3>Lorem Ipsum Station Access Policy Name</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                                <div class=\"card card--default col-lg-3\">\n                                    <div class=\"tag tag--icon tag--icon--housing\">Housing Policies</div>\n                                    <div class=\"card__title\">\n                                        <h3>Quisque Tempus Lipsum Policy Name</h3>\n                                    </div>\n                                    <div class=\"card__link\">\n                                        <a href=\"#\" title=\"Review [card title]\"\n                                            aria-label=\"Review [card title]\">Review</a>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"section col-lg-12\">\n                    <div class=\"section-header\">\n                        <h2>Jurisdictions</h2>\n                        <!-- <div class=\"view-all\">\n                            <a href=\"#\" class=\"link--more\" title=\"View all jurisdictions\"\n                                aria-label=\"View all jurisdictions\">View All</a>\n                        </div> -->\n                    </div>\n                    <div class=\"table-responsive\">\n                        <table class=\"table table--data-table table--compliance table-borderless table-striped\"\n                            st-table=\"filteredCollection\" st-safe-src=\"groupedCollection\">\n                            <thead class=\"table-dark\">\n                                <tr>\n                                    <th scope=\"col\" st-sort=\"jurisdiction\">\n                                        <div class=\"th-inner\">\n                                            Jurisdiction\n                                            <tablesortbuttons />\n                                        </div>\n                                    </th>\n                                    <th scope=\"col\" st-sort=\"station_name\">\n                                        <div class=\"th-inner\">\n                                            Station Areas\n                                            <tablesortbuttons />\n                                        </div>\n                                    </th>\n                                    <th scope=\"col\" st-sort=\"count\">\n                                        <div class=\"th-inner\">\n                                            Submissions\n                                            <tablesortbuttons />\n                                        </div>\n                                    </th>\n                                    <th scope=\"col\" st-sort=\"status\">\n                                        <div class=\"th-inner\">\n                                            Compliance\n                                            <tablesortbuttons />\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in filteredCollection\">\n                                    <td>{{item.jurisdiction}}</td>\n                                    <td>{{item.station_name}}</td>\n                                    <td>{{item.count}}</td>\n                                    <td>\n                                        <div class=\"status-pill\" ng-class=\"{\n                                            'status-pill--in-review': item.status === 'In Review',\n                                            'status-pill--needs-work': item.status === 'Needs Work',\n                                            'status-pill--not-compliant': item.status === 'Not Consistent',\n                                            'status-pill--compliant': item.status === 'Consistent'\n                                        }\">\n                                            {{item.status || 'In Review'}}\n                                        </div>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter></sidebarfooter>\n        </div>\n    </div>\n</section>"

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SubmissionsComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _submissions = __webpack_require__(192);
	
	var _submissions2 = _interopRequireDefault(_submissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var SubmissionsComponent = exports.SubmissionsComponent = function () {
	  /*@ngInject*/
	  function SubmissionsComponent($scope, $http, userService, baseConfigService, fetch, $state, $location, $timeout, $stateParams) {
	    _classCallCheck(this, SubmissionsComponent);
	
	    var vm = this;
	
	    this.$scope = $scope;
	    this.$http = $http;
	    this.$state = $state;
	    this.fetch = fetch;
	    this.$location = $location;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	
	    this.userService = userService;
	    this.baseConfigService = baseConfigService;
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.Math = Math;
	    $scope.pageSize = 10;
	    $scope.displayedCollection = [];
	
	    this.excludedPolicies = ['Commercial Office Data Verification', 'Residential Density Data Verification'];
	
	    $scope.updatePageSize = function () {
	      console.log('Page size changed to:', $scope.pageSize);
	      $scope.currentPage = 1;
	      $scope.setPage(1);
	    };
	
	    $scope.getTotalPages = function () {
	      if (!$scope.filteredResults) {
	        return 0;
	      }
	      return Math.ceil($scope.filteredResults.length / $scope.pageSize);
	    };
	
	    $scope.setPage = function (page) {
	      if (page >= 1 && page <= $scope.getTotalPages()) {
	        $scope.currentPage = page;
	
	        var start = ($scope.currentPage - 1) * $scope.pageSize;
	        var end = start + $scope.pageSize;
	        $scope.displayedCollection = $scope.filteredResults.slice(start, end);
	        console.log("displayedCollection:", $scope.displayedCollection);
	      }
	    };
	
	    $scope.nextPage = function () {
	      if ($scope.currentPage < $scope.getTotalPages()) {
	        $scope.setPage($scope.currentPage + 1);
	      }
	    };
	
	    $scope.prevPage = function () {
	      if ($scope.currentPage > 1) {
	        $scope.setPage($scope.currentPage - 1);
	      }
	    };
	
	    $scope.getPages = function () {
	      var pages = [];
	      for (var i = 1; i <= $scope.getTotalPages(); i++) {
	        pages.push(i);
	      }
	      return pages;
	    };
	
	    $scope.validateScore = function (item) {
	      if (item.score < 0) {
	        item.score = 0;
	      }
	      if (item.score > item.max_score) {
	        item.score = item.max_score;
	        console.warn('Score cannot exceed ' + item.max_score);
	      }
	    };
	
	    $scope.updateScore = function (item) {
	
	      if (item.excludeFromScoring || !item.submitted_date) {
	        console.log('Skipping update - excluded or no submission');
	        return;
	      }
	
	      if (!$scope.currentUser || !$scope.currentUser.firstname || !$scope.currentUser.lastname) {
	        console.error('Current user not available');
	        return;
	      }
	
	      var scoreData = {
	        submission_id: item.submission_id,
	        score: parseInt(item.score) || 0,
	        score_last_updated_by: $scope.currentUser.firstname + ' ' + $scope.currentUser.lastname
	      };
	
	      fetch.updateItem('api/data/submissions/update-score', scoreData).then(function (response) {
	
	        vm.$timeout(function () {
	          if (response.data && response.data.updatedRecord) {
	            item.score = response.data.updatedRecord.score;
	            item.score_last_updated_by = response.data.updatedRecord.score_last_updated_by;
	            item.score_last_updated_date = response.data.updatedRecord.score_last_updated_date;
	          } else {
	            console.warn('No updatedRecord in response, updating manually');
	
	            item.score = scoreData.score;
	            item.score_last_updated_by = scoreData.score_last_updated_by;
	            item.score_last_updated_date = new Date();
	          }
	          console.log('Item after update:', item);
	        });
	      }).catch(function (err) {
	        console.error('Error updating score:', err);
	        console.error('Error details:', err.data);
	        vm.$timeout(function () {
	          $scope.error = 'Failed to update score';
	        });
	      });
	    };
	
	    $scope.getJurisdictionList = function () {
	      fetch.getAllItems('api/data/jurisdictions/list').then(function (response) {
	
	        $scope.organizations = response.data;
	        console.log($scope.organizations);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    $scope.statuses = ['In Review', 'Needs Work', 'Not Compliant', 'Compliant', 'Pending'];
	    $scope.selectedStatuses = {};
	    $scope.selectedTypes = {};
	    $scope.selectedPolicies = {};
	    $scope.selectedJurisdictions = {};
	    $scope.selectedStations = {};
	    $scope.statusSearch = '';
	
	    $scope.getDisplayPolicyName = function (row) {
	      var housingPolicyTypes = ['Affordable Housing Protection Policy 1', 'Affordable Housing Protection Policy 2', 'Affordable Housing Preservation Policy 1', 'Affordable Housing Preservation Policy 2', 'Affordable Housing Production Policy 1', 'Affordable Housing Production Policy 2'];
	
	      if (housingPolicyTypes.includes(row.submission_policy_name) && row.housing_policy_name) {
	        return row.housing_policy_name;
	      }
	
	      return row.submission_policy_name;
	    };
	
	    $scope.showMoreInfo = function (row) {
	      console.log(row);
	      console.log("parking_form_id:", row.parking_form_id);
	      console.log("stationaccess_form_id:", row.stationaccess_form_id);
	      var stateName = void 0;
	      var policyName = row.housing_policy_name || row.submission_policy_name;
	
	      switch (row.submission_policy_type) {
	        case 'Parking':
	          if (row.submission_policy_name === 'Vehicle Parking Minimum') {
	            stateName = 'vehicle_parking';
	          } else if (row.submission_policy_name === 'Vehicle Parking Maximum') {
	            stateName = 'vehicle_parking';
	          } else if (row.submission_policy_name === 'Bicycle Parking Minimum') {
	            stateName = 'bicycle_parking';
	          } else if (row.submission_policy_name === 'Unbundled Parking') {
	            stateName = 'parking_policies';
	          } else if (row.submission_policy_name === 'Shared Parking') {
	            stateName = 'parking_policies';
	          } else if (row.submission_policy_name === 'Complementary Parking Management Policy') {
	            stateName = 'parking_policies';
	          } else {
	            console.error('Unknown parking policy name:', row.submission_policy_name);
	            return;
	          }
	          break;
	        case 'Housing Production Policy':
	          stateName = 'housing_production';
	          break;
	        case 'Housing Preservation Policy':
	          stateName = 'housing_preservation';
	          break;
	        case 'Housing Protection Policy':
	          stateName = 'housing_protection';
	          break;
	        case 'Housing Commercial Policy':
	          stateName = 'commercial_stabilization';
	          break;
	        case 'Zoning':
	          stateName = 'zoning_updates';
	          break;
	        case 'Station Area Access':
	          if (row.submission_policy_name === 'Complete Streets Policy') {
	            stateName = 'complete_streets';
	          } else if (row.submission_policy_name === 'Project Prioritization') {
	            stateName = 'complete_streets';
	          } else if (row.submission_policy_name === 'Gap Analysis') {
	            stateName = 'analysis_improvement_program';
	          } else if (row.submission_policy_name === 'Mobility Hub Planning') {
	            stateName = 'mobility_hub';
	          } else {
	            console.error('Unknown parking policy name:', row.submission_policy_name);
	            return;
	          }
	          break;
	        case 'Density':
	          if (row.submission_policy_name === 'Minimum FAR Office') {
	            stateName = 'commercial_uses';
	          } else if (row.submission_policy_name === 'Maximum FAR Office') {
	            stateName = 'commercial_uses';
	          } else if (row.submission_policy_name === 'Minimum Density Residential') {
	            stateName = 'residential_uses';
	          } else if (row.submission_policy_name === 'Maximum Density Residential') {
	            stateName = 'residential_uses';
	          } else if (row.submission_policy_name === 'Residential Uses Data Verification') {
	            stateName = 'residential_uses';
	          } else if (row.submission_policy_name === 'Commercial Office Uses Data Verification') {
	            stateName = 'commercial_uses';
	          } else {
	            console.error('Unknown parking policy name:', row.submission_policy_name);
	            return;
	          }
	          break;
	        default:
	          console.error('Unknown submission type:', row.submission_policy_type);
	          return;}
	
	      $scope.saveFilterState();
	
	      $state.go(stateName, {
	        jurisdiction: row.jurisdiction,
	        sta_recid: row.sta_recid,
	        policyName: policyName });
	    };
	
	    $scope.showChangeStatus = function (row) {
	      console.log(row);
	      $scope.updateMessage = row;
	      $('#updateMessagesModal').modal('toggle');
	    };
	
	    $scope.showMessages = function (row) {
	      console.log(row);
	      $state.go('message-detail', {
	        submissionId: row.submission_id,
	        messageData: 'submissions',
	        data: row
	      });
	    };
	
	    $scope.updateSubmissionStatus = function (row, newStatus) {
	      row.originalStatus = row.status;
	      row.originalUpdatedBy = row.status_last_updated_by;
	      row.originalUpdatedDate = row.status_last_updated_date;
	
	      row.status = newStatus;
	
	      var updateData = {
	        submission_id: row.submission_id,
	        status: newStatus
	      };
	
	      fetch.updateItem('api/data/submissions/update-status', updateData).then(function (response) {
	        $timeout(function () {
	          row.status_last_updated_by = $scope.currentUser.firstname + ' ' + $scope.currentUser.lastname;
	          row.status_last_updated_date = new Date();
	          $scope.successMessage = 'Status updated successfully';
	        });
	      }).catch(function (err) {
	        console.error('Error updating status:', err);
	        $timeout(function () {
	          row.status = row.originalStatus;
	          row.status_last_updated_by = row.originalUpdatedBy;
	          row.status_last_updated_date = row.originalUpdatedDate;
	          $scope.error = 'Failed to update status';
	        });
	      });
	    };
	
	    $scope.updateMessageFn = function (form) {
	      console.log($scope.updateMessage);
	
	      var updateData = $scope.updateMessage;
	      $scope.saving = true;
	
	      fetch.updateItem('api/data/update-message', updateData).then(function (responseReport) {
	        console.log(responseReport);
	        $scope.updateMessage = {};
	
	        $('#updateMessagesModal').modal('toggle');
	        $scope.saving = false;
	      }).catch(function (err) {
	        console.log(err);
	        $scope.saving = false;
	        if (err.response && err.response.status === 403) {
	          $state.go('/login');
	        }
	      });
	    };
	  }
	
	  _createClass(SubmissionsComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      var self = this;
	
	      this.loadSubmissions().then(function () {
	        try {
	          var savedFilterState = localStorage.getItem('submissionsFilterState');
	          if (savedFilterState) {
	            var filterState = JSON.parse(savedFilterState);
	
	            self.$scope.selectedStatuses = filterState.selectedStatuses || {};
	            self.$scope.selectedTypes = filterState.selectedTypes || {};
	            self.$scope.selectedPolicies = filterState.selectedPolicies || {};
	            self.$scope.selectedJurisdictions = filterState.selectedJurisdictions || {};
	            self.$scope.selectedStations = filterState.selectedStations || {};
	
	            self.$scope.statusSearch = filterState.statusSearch || '';
	            self.$scope.typeSearch = filterState.typeSearch || '';
	            self.$scope.policySearch = filterState.policySearch || '';
	            self.$scope.jurisdictionSearch = filterState.jurisdictionSearch || '';
	            self.$scope.stationSearch = filterState.stationSearch || '';
	
	            self.$scope.pageSize = filterState.pageSize || 10;
	
	            self.$scope.updateFilter();
	
	            self.$scope.setPage(filterState.currentPage || 1);
	          }
	        } catch (e) {
	          console.error('Error restoring filter state:', e);
	        }
	      });
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'loadSubmissions',
	    value: function loadSubmissions() {
	      var _this2 = this;
	
	      return this.fetch.getAllItems('api/data/submissions/get-submissions').then(function (response) {
	        console.log(response);
	        _this2.$scope.rowCollection = response.data;
	        _this2.$scope.rowCollection = _this2.initializeSubmissions(response.data);
	        _this2.$scope.filteredResults = response.data || [];
	        _this2.$scope.totalItems = _this2.$scope.filteredResults.length;
	
	        if (!localStorage.getItem('submissionsFilterState')) {
	          _this2.$scope.selectedStatuses = {};
	          _this2.$scope.selectedTypes = {};
	          _this2.$scope.selectedJurisdictions = {};
	          _this2.$scope.selectedStations = {};
	          _this2.$scope.selectedPolicies = {};
	        }
	
	        var extractUniqueValues = function extractUniqueValues(property) {
	          var uniqueMap = {};
	          _this2.$scope.rowCollection.forEach(function (item) {
	            if (item[property]) {
	              uniqueMap[item[property]] = true;
	            }
	          });
	          return Object.keys(uniqueMap);
	        };
	
	        _this2.$scope.allStatuses = extractUniqueValues('status');
	        _this2.$scope.allTypes = extractUniqueValues('submission_policy_type');
	        _this2.$scope.allPolicies = extractUniqueValues('submission_policy_name');
	        _this2.$scope.allJurisdictions = extractUniqueValues('jurisdiction');
	        _this2.$scope.allStations = extractUniqueValues('station_name');
	
	        _this2.$scope.statuses = _this2.$scope.allStatuses;
	        _this2.$scope.types = _this2.$scope.allTypes;
	        _this2.$scope.uniquePolicies = _this2.$scope.allPolicies;
	        _this2.$scope.uniqueJurisdictions = _this2.$scope.allJurisdictions;
	        _this2.$scope.uniqueStations = _this2.$scope.allStations;
	
	        var self = _this2;
	
	        _this2.$scope.handleCheckboxChange = function (filterType, value) {
	          if (!self.$scope[filterType][value]) {
	            delete self.$scope[filterType][value];
	          }
	
	          self.$scope.updateFilter();
	
	          self.$scope.saveFilterState();
	        };
	
	        _this2.$scope.saveFilterState = function () {
	          var filterState = {
	            selectedStatuses: self.$scope.selectedStatuses,
	            selectedTypes: self.$scope.selectedTypes,
	            selectedPolicies: self.$scope.selectedPolicies,
	            selectedJurisdictions: self.$scope.selectedJurisdictions,
	            selectedStations: self.$scope.selectedStations,
	            statusSearch: self.$scope.statusSearch,
	            typeSearch: self.$scope.typeSearch,
	            policySearch: self.$scope.policySearch,
	            jurisdictionSearch: self.$scope.jurisdictionSearch,
	            stationSearch: self.$scope.stationSearch,
	            currentPage: self.$scope.currentPage,
	            pageSize: self.$scope.pageSize
	          };
	
	          localStorage.setItem('submissionsFilterState', JSON.stringify(filterState));
	        };
	
	        _this2.$scope.clearFilters = function () {
	          self.$scope.selectedStatuses = {};
	          self.$scope.selectedTypes = {};
	          self.$scope.selectedPolicies = {};
	          self.$scope.selectedJurisdictions = {};
	          self.$scope.selectedStations = {};
	
	          self.$scope.statusSearch = '';
	          self.$scope.typeSearch = '';
	          self.$scope.policySearch = '';
	          self.$scope.jurisdictionSearch = '';
	          self.$scope.stationSearch = '';
	
	          self.$scope.selectedDate = null;
	
	          self.$scope.updateFilter();
	
	          self.$scope.setPage(1);
	
	          localStorage.removeItem('submissionsFilterState');
	        };
	
	        _this2.$scope.updateFilter = function () {
	          console.log('Updating filter...');
	          if (!self.$scope.rowCollection) {
	            self.$scope.filteredResults = [];
	            self.$scope.totalItems = 0;
	            self.$scope.setPage(1);
	            return;
	          }
	
	          self.$scope.filteredResults = self.$scope.rowCollection.filter(self.$scope.filterFunction);
	          self.$scope.totalItems = self.$scope.filteredResults.length;
	          self.$scope.setPage(1);
	          console.log('Filtered Results:', self.$scope.filteredResults);
	        };
	
	        _this2.$scope.filterFunction = function (item) {
	          if (Object.keys(self.$scope.selectedStatuses).length === 0 && Object.keys(self.$scope.selectedTypes).length === 0 && Object.keys(self.$scope.selectedPolicies).length === 0 && Object.keys(self.$scope.selectedJurisdictions).length === 0 && Object.keys(self.$scope.selectedStations).length === 0 && !self.$scope.selectedDate) {
	            return true;
	          }
	
	          var hasStatusFilter = Object.keys(self.$scope.selectedStatuses).length > 0;
	          var isStatusSelected = !hasStatusFilter || self.$scope.selectedStatuses[item.status] === true;
	
	          var hasTypeFilter = Object.keys(self.$scope.selectedTypes).length > 0;
	          var isTypeSelected = !hasTypeFilter || self.$scope.selectedTypes[item.submission_policy_type] === true;
	
	          var hasPolicyFilter = Object.keys(self.$scope.selectedPolicies).length > 0;
	          var isPolicySelected = !hasPolicyFilter || self.$scope.selectedPolicies[item.submission_policy_name] === true;
	
	          var hasJurisdictionFilter = Object.keys(self.$scope.selectedJurisdictions).length > 0;
	          var isJurisdictionSelected = !hasJurisdictionFilter || self.$scope.selectedJurisdictions[item.jurisdiction] === true;
	
	          var hasStationFilter = Object.keys(self.$scope.selectedStations).length > 0;
	          var isStationSelected = !hasStationFilter || self.$scope.selectedStations[item.station_name] === true;
	
	          var hasDateFilter = self.$scope.selectedDate !== undefined && self.$scope.selectedDate !== null;
	          var isDateMatch = !hasDateFilter || new Date(item.submitted_date).toDateString() === new Date(self.$scope.selectedDate).toDateString();
	
	          var hasSearchFilter = self.$scope.statusSearch && self.$scope.statusSearch.trim() !== '';
	          var isSearchMatch = !hasSearchFilter || item.name && item.name.toLowerCase().includes(self.$scope.statusSearch.toLowerCase());
	
	          return isStatusSelected && isTypeSelected && isPolicySelected && isJurisdictionSelected && isStationSelected && isDateMatch && isSearchMatch;
	        };
	
	        _this2.$scope.$watch('statusSearch', function (newValue) {
	          self.$scope.updateFilter();
	          self.$scope.saveFilterState();
	        });
	
	        _this2.$scope.$watch('selectedStatuses', function (newValue) {
	          self.$scope.updateFilter();
	          self.$scope.saveFilterState();
	        }, true);
	
	        _this2.$scope.$watch('selectedTypes', function (newValue) {
	          self.$scope.updateFilter();
	          self.$scope.saveFilterState();
	        }, true);
	
	        _this2.$scope.$watch('selectedPolicies', function (newValue) {
	          self.$scope.updateFilter();
	          self.$scope.saveFilterState();
	        }, true);
	
	        _this2.$scope.$watch('selectedJurisdictions', function (newValue) {
	          self.$scope.updateFilter();
	          self.$scope.saveFilterState();
	        }, true);
	
	        _this2.$scope.$watch('selectedStations', function (newValue) {
	          self.$scope.updateFilter();
	          self.$scope.saveFilterState();
	        }, true);
	
	        _this2.$scope.$watch('selectedDate', function (newValue) {
	          self.$scope.updateFilter();
	          self.$scope.saveFilterState();
	        });
	
	        _this2.$scope.updateFilter();
	
	        _this2.$scope.setPage(1);
	      }).catch(function (err) {
	        console.log(err);
	        _this2.$scope.filteredResults = [];
	
	        _this2.$scope.totalItems = 0;
	        _this2.$scope.setPage(1);
	      });
	    }
	  }, {
	    key: 'initializeSubmissions',
	    value: function initializeSubmissions(submissions) {
	      var vm = this;
	      return submissions.map(function (item) {
	        item.excludeFromScoring = vm.excludedPolicies.includes(item.submission_policy_name);
	        return item;
	      });
	    }
	  }]);
	
	  return SubmissionsComponent;
	}();
	
	exports.default = angular.module('appApp.submissions', [uiRouter, 'smart-table']).config(_submissions2.default).component('submissions', {
	  template: __webpack_require__(193),
	  controller: SubmissionsComponent,
	  controllerAs: 'submissionsCtrl'
	}).name;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('submissions', {
	    url: '/account/compliance/submissions',
	    template: '<submissions></submissions>'
	  });
	};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports = "<style>\n    .position-relative {\n        position: relative;\n    }\n\n    .position-absolute {\n        position: absolute;\n    }\n\n    .top-0 {\n        top: -8px;\n    }\n\n    .start-100 {\n        left: 80%;\n    }\n\n    .translate-middle {\n        transform: translate(-50%, -50%);\n    }\n\n    .badge {\n        padding: 0.35em 0.65em;\n        font-size: 0.75em;\n        font-weight: 700;\n        line-height: 1;\n        text-align: center;\n        white-space: nowrap;\n        vertical-align: baseline;\n        border-radius: 0.25rem;\n    }\n\n    .rounded-pill {\n        border-radius: 50rem;\n    }\n\n    .bg-danger {\n        background-color: #dc3545;\n        color: white;\n    }\n\n    .visually-hidden {\n        position: absolute;\n        width: 1px;\n        height: 1px;\n        padding: 0;\n        margin: -1px;\n        overflow: hidden;\n        clip: rect(0, 0, 0, 0);\n        border: 0;\n    }\n    .submission-info,\n    .status-updated-info {\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n    }\n\n    .submitted-by,\n    .status-updated-by {\n        line-height: 1.4;\n    }\n\n    .submitted-date-badge,\n    .status-updated-date-badge {\n        display: inline-block;\n        padding: 3px 8px;\n        background-color: #D9E0E2;\n        color: #00303F;\n        font-size: 11px;\n        font-weight: 600;\n        border-radius: 12px;\n        text-transform: uppercase;\n        letter-spacing: 0.3px;\n        align-self: flex-start;\n    }\n\n    .submitted-date-badge i,\n    .status-updated-date-badge i {\n        font-size: 10px;\n        margin-right: 4px;\n        opacity: 0.7;\n    }\n\n    .score-input-group {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n    }\n\n    .score-input {\n        width: 50px;\n        padding: 4px 6px;\n        border: 1px solid #ced4da;\n        border-radius: 4px;\n        font-size: 13px;\n    }\n\n    .score-input:focus {\n        outline: none;\n        border-color: #06192c;\n        box-shadow: 0 0 0 0.2rem rgba(6, 25, 44, 0.1);\n    }\n\n    .score-separator {\n        font-weight: 600;\n        color: #495057;\n        font-size: 13px;\n    }\n\n    .max-score {\n        font-weight: 600;\n        color: #6c757d;\n        font-size: 13px;\n    }\n    .submissions-pagination .pagination {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 6px;\n    padding: 0;\n    margin: 20px 0;\n    list-style: none;\n}\n\n.submissions-pagination .pagination > li > a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 40px;\n    min-height: 40px;\n    padding: 8px 12px;\n    border: 1px solid #bfcbcf;\n    border-radius: 4px;\n    background: #fff;\n    color: #072751;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.submissions-pagination .pagination > li > a:hover,\n.submissions-pagination .pagination > li > a:focus-visible {\n    background: #edf2f5;\n}\n\n.submissions-pagination .pagination > li.active > a {\n    background: #072751;\n    border-color: #072751;\n    color: #fff;\n}\n\n.submissions-pagination .pagination > li.disabled > a {\n    opacity: 0.45;\n    cursor: default;\n}\n</style>\n\n<section class=\"dashboard dashboard--page dashboard--submissions\">\n    <div class=\"page-wrapper\">\n\n        <div class=\"dashboard-header\">\n            <sidebarnav />\n        </div>\n\n        <div class=\"main\">\n            <mainheaderauth />\n\n            <div class=\"content container\"\n     st-table=\"displayedCollection\"\n     st-safe-src=\"filteredResults\">\n\n                <div class=\"row\">\n                    <div class=\"col-lg-12\">\n                        <h1 class=\"fs-3\">Submissions</h1>\n                    </div>\n                </div>\n                <div class=\"row mb-4\">\n                    <div class=\"col-12\">\n                        <div class=\"d-flex flex-wrap align-items-center\">\n                            <form class=\"me-3 mb-3\">\n                                <div class=\"filters\">\n                                    <div class=\"form-item form-item--search mb-0\">\n                                        <input type=\"text\" placeholder=\"Search submissions\" st-search />\n                                    </div>\n                                </div>\n                            </form>\n                            <div class=\"filters-row flex-grow-1\">\n                                <div class=\"filters-container d-flex\">\n                                    <div class=\"dropdown dropdown--filters\">\n                                        <button class=\"dropdown-toggle\" role=\"button\" data-bs-toggle=\"dropdown\"\n                                            data-bs-auto-close=\"outside\" aria-expanded=\"false\">\n                                            Status\n                                        </button>\n                                        <ul class=\"dropdown-menu\">\n                                            <form class=\"form--small input-container\" ng-submit=\"filterResults()\">\n                                                <div class=\"form-item form-item--search form-item--embedded\">\n                                                    <input type=\"text\" placeholder=\"Search\" ng-model=\"statusSearch\" />\n                                                </div>\n                                            </form>\n                                            <li>\n                                                <hr class=\"dropdown-divider\" />\n                                            </li>\n                                            <li class=\"dropdown-item\"\n                                                ng-repeat=\"status in allStatuses | filter: statusSearch\">\n                                                <label class=\"form-check-label\">\n                                                    <input class=\"form-check-input\" type=\"checkbox\"\n                                                        ng-model=\"selectedStatuses[status]\"\n                                                        ng-change=\"handleCheckboxChange('selectedStatuses', status)\" />\n                                                    {{status}}\n                                                </label>\n                                            </li>\n                                        </ul>\n                                    </div>\n\n                                    <div class=\"dropdown dropdown--filters\">\n                                        <button class=\"dropdown-toggle\" role=\"button\" data-bs-toggle=\"dropdown\"\n                                            data-bs-auto-close=\"outside\" aria-expanded=\"false\">\n                                            Topic\n                                        </button>\n                                        <ul class=\"dropdown-menu\">\n                                            <form class=\"form--small input-container\">\n                                                <div class=\"form-item form-item--search form-item--embedded\">\n                                                    <input type=\"text\" placeholder=\"Search\" ng-model=\"typeSearch\" />\n                                                </div>\n                                            </form>\n                                            <li>\n                                                <hr class=\"dropdown-divider\" />\n                                            </li>\n                                            <li class=\"dropdown-item\"\n                                                ng-repeat=\"submission_policy_type in allTypes | filter: typeSearch\">\n                                                <label class=\"form-check-label\">\n                                                    <input class=\"form-check-input\" type=\"checkbox\"\n                                                        ng-model=\"selectedTypes[submission_policy_type]\"\n                                                        ng-change=\"handleCheckboxChange('selectedTypes', submission_policy_type)\" />\n                                                    {{submission_policy_type}}\n                                                </label>\n                                            </li>\n                                        </ul>\n                                    </div>\n\n                                    <div class=\"dropdown dropdown--filters\">\n                                        <button class=\"dropdown-toggle\" role=\"button\" data-bs-toggle=\"dropdown\"\n                                            data-bs-auto-close=\"outside\" aria-expanded=\"false\">\n                                            Policy Name\n                                        </button>\n                                        <ul class=\"dropdown-menu\">\n                                            <form class=\"form--small input-container\">\n                                                <div class=\"form-item form-item--search form-item--embedded\">\n                                                    <input type=\"text\" placeholder=\"Search\" ng-model=\"policySearch\" />\n                                                </div>\n                                            </form>\n                                            <li>\n                                                <hr class=\"dropdown-divider\" />\n                                            </li>\n                                            <li class=\"dropdown-item\"\n                                                ng-repeat=\"submission_policy_name in allPolicies | filter: policySearch\">\n                                                <label class=\"form-check-label\">\n                                                    <input class=\"form-check-input\" type=\"checkbox\"\n                                                        ng-model=\"selectedPolicies[submission_policy_name]\"\n                                                        ng-change=\"handleCheckboxChange('selectedPolicies', submission_policy_name)\" />\n                                                    {{submission_policy_name}}\n                                                </label>\n                                            </li>\n                                        </ul>\n                                    </div>\n\n                                    <div class=\"dropdown dropdown--filters\">\n                                        <button class=\"dropdown-toggle\" role=\"button\" data-bs-toggle=\"dropdown\"\n                                            data-bs-auto-close=\"outside\" aria-expanded=\"false\">\n                                            Jurisdiction\n                                        </button>\n                                        <ul class=\"dropdown-menu\">\n                                            <form class=\"form--small input-container\">\n                                                <div class=\"form-item form-item--search form-item--embedded\">\n                                                    <input type=\"text\" placeholder=\"Search\"\n                                                        ng-model=\"jurisdictionSearch\" />\n                                                </div>\n                                            </form>\n                                            <li>\n                                                <hr class=\"dropdown-divider\" />\n                                            </li>\n                                            <li class=\"dropdown-item\"\n                                                ng-repeat=\"jurisdiction in allJurisdictions | filter: jurisdictionSearch\">\n                                                <label class=\"form-check-label\">\n                                                    <input class=\"form-check-input\" type=\"checkbox\"\n                                                        ng-model=\"selectedJurisdictions[jurisdiction]\"\n                                                        ng-change=\"handleCheckboxChange('selectedJurisdictions', jurisdiction)\" />\n                                                    {{jurisdiction}}\n                                                </label>\n                                            </li>\n                                        </ul>\n                                    </div>\n                                    <div class=\"dropdown dropdown--filters\">\n                                        <button class=\"dropdown-toggle\" role=\"button\" data-bs-toggle=\"dropdown\"\n                                            data-bs-auto-close=\"outside\" aria-expanded=\"false\">\n                                            Station Area\n                                        </button>\n                                        <ul class=\"dropdown-menu\">\n                                            <form class=\"form--small input-container\">\n                                                <div class=\"form-item form-item--search form-item--embedded\">\n                                                    <input type=\"text\" placeholder=\"Search\" ng-model=\"stationSearch\" />\n                                                </div>\n                                            </form>\n                                            <li>\n                                                <hr class=\"dropdown-divider\" />\n                                            </li>\n                                            <li class=\"dropdown-item\"\n                                                ng-repeat=\"station_name in allStations | filter: stationSearch\">\n                                                <label class=\"form-check-label\">\n                                                    <input class=\"form-check-input\" type=\"checkbox\"\n                                                        ng-model=\"selectedStations[station_name]\"\n                                                        ng-change=\"handleCheckboxChange('selectedStations', station_name)\" />\n                                                    {{station_name}}\n                                                </label>\n                                            </li>\n                                        </ul>\n                                    </div>\n\n                                    <div class=\"dropdown dropdown--filters\">\n                                        <button class=\"dropdown-toggle\" role=\"button\" data-bs-toggle=\"dropdown\"\n                                            data-bs-auto-close=\"outside\" aria-expanded=\"false\">\n                                            Date\n                                        </button>\n                                        <ul class=\"dropdown-menu\">\n                                            <form class=\"form--small input-container\">\n                                                <div class=\"form-item form-item--embedded\">\n                                                    <input type=\"date\" ng-model=\"selectedDate\"\n                                                        ng-change=\"updateFilter()\" />\n                                                </div>\n                                            </form>\n                                        </ul>\n                                    </div>\n\n                                    <div class=\"dropdown dropdown--filters\">\n                                        <button class=\"dropdown-toggle no-caret\" role=\"button\"\n                                            ng-click=\"clearFilters()\">\n                                            Clear Filters\n                                        </button>\n                                    </div>\n                                    <div class=\"per-page-container ms-auto\">\n                                        <form class=\"d-inline-flex justify-content-center\" style=\"gap: 16px\">\n                                            <div class=\"form-item form-item--select mb-0\">\n                                                <select ng-model=\"pageSize\">\n                                                    <option ng-value=\"10\" selected>10</option>\n                                                    <option ng-value=\"20\">20</option>\n                                                    <option ng-value=\"50\">50</option>\n                                                    <option ng-value=\"100\">100</option>\n                                                </select>\n                                            </div>\n                                            <div class=\"d-inline-flex align-items-center\">\n                                                <small>per page</small>\n                                            </div>\n                                        </form>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-lg-12\">\n                            <style>\n                                .table--data-table td {\n                                    word-wrap: break-word;\n                                    overflow-wrap: break-word;\n                                }\n\n                                .table--data-table td:nth-child(1) {\n                                    /* Status */\n                                    width: 10%;\n                                }\n\n                                .table--data-table td:nth-child(2) {\n                                    /* Topic */\n                                    width: 5%;\n                                }\n\n                                .table--data-table td:nth-child(3) {\n                                    /* Jurisdiction */\n                                    width: 10%;\n                                }\n\n                                .table--data-table td:nth-child(4) {\n                                    /* Station Area */\n                                    width: 18%;\n                                }\n\n                                .table--data-table td:nth-child(5) {\n                                    /* Policy Name */\n                                    width: 15%;\n                                    max-width: 300px;\n                                }\n\n                                .table--data-table td:nth-child(6) {\n                                    /* Submission Date */\n                                    width: 10%;\n                                }\n\n                                .table--data-table td:nth-child(7) {\n                                    /* Status Last Updated (combined) */\n                                    width: 15%;\n                                }\n\n                                .table--data-table td:nth-child(8) {\n                                    /* More Info */\n                                    width: 8%;\n                                }\n\n                                .table--data-table td:nth-child(8) .btn {\n                                    margin-right: 5px;\n                                    white-space: nowrap;\n                                }\n                                .table--data-table td:nth-child(9) .btn {\n                                    margin-right: 5px;\n                                    white-space: nowrap;\n                                }\n                            </style>\n                            <div style=\"overflow-x:auto;\">\n                                <table class=\"table table--data-table table-borderless table-striped\">\n                                    <thead class=\"table-dark\">\n                                        <tr>\n                                            <th st-sort=\"status\">\n                                                <div class=\"th-inner\">\n                                                    Status\n                                                    <tablesortbuttons />\n                                                </div>\n                                            </th>\n                                            <th st-sort=\"score\">\n                                                <div class=\"th-inner\">\n                                                    Score\n                                                    <tablesortbuttons />\n                                                </div>\n                                            </th>\n                                            <th st-sort=\"submission_policy_type\">\n                                                <div class=\"th-inner\">\n                                                    Topic\n                                                    <tablesortbuttons />\n                                                </div>\n                                            </th>\n                                            <th st-sort=\"jurisdiction\">\n                                                <div class=\"th-inner\">\n                                                    Jurisdiction\n                                                    <tablesortbuttons />\n                                                </div>\n                                            </th>\n                                            <th st-sort=\"station_name\">\n                                                <div class=\"th-inner\">\n                                                    Station Area\n                                                    <tablesortbuttons />\n                                                </div>\n                                            </th>\n                                            <th st-sort=\"submission_policy_name\">\n                                                <div class=\"th-inner\">\n                                                    Policy Name\n                                                    <tablesortbuttons />\n                                                </div>\n                                            </th>\n                                            <th st-sort=\"submitted_date\">\n                                                <div class=\"th-inner\">\n                                                    Submitted By\n                                                    <tablesortbuttons />\n                                                </div>\n                                            </th>\n                                            <th st-sort=\"status_last_updated_by\">\n                                                <div class=\"th-inner\">\n                                                    Status Updated By\n                                                    <tablesortbuttons />\n                                                </div>\n                                            </th>\n                                            <th>\n                                                <div class=\"th-inner\">\n                                                    More Info\n                                                </div>\n                                            </th>\n                                        </tr>\n                                    </thead>\n                                    <tbody>\n                                        <tr ng-repeat=\"row in displayedCollection\"\n                                            ng-class=\"row.isSelected ? 'st-selected' : ''\">\n                                            <td>\n                                                <div class=\"dropdown dropdown--status-pills\">\n                                                    <button class=\"status-pill\" ng-class=\"{\n                                              'status-pill--in-review': row.status === 'In Review',\n                                              'status-pill--needs-work': row.status === 'Needs Work',\n                                              'status-pill--not-compliant': row.status === 'Not Consistent',\n                                              'status-pill--compliant': row.status === 'Consistent'\n                                            }\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n                                                        {{ row.status || 'Not Consistent' }}\n                                                    </button>\n                                                    <ul class=\"dropdown-menu\" style=\"\n                                                --bs-dropdown-min-width: 0;\n                                                --bs-dropdown-border-radius: 4px;\n                                                --bs-dropdown-border-color: #BFCBCF;\n                                                --bs-dropdown-link-hover-bg: #f2f5f5;\n                                                --bs-dropdown-link-hover-color: #072751;\n                                                --bs-dropdown-link-active-bg: #e5eaec;\n                                                --bs-dropdown-link-active-color: #072751;\n                                                --bs-dropdown-padding-y: 0;\n                                            \">\n                                                        <li><button\n                                                                class=\"dropdown-item status-pill status-pill--in-review\"\n                                                                ng-click=\"updateSubmissionStatus(row, 'In Review')\">In\n                                                                Review</button></li>\n                                                        <li><button\n                                                                class=\"dropdown-item status-pill status-pill--needs-work\"\n                                                                ng-click=\"updateSubmissionStatus(row, 'Needs Work')\">Needs\n                                                                Work</button></li>\n                                                        <li><button\n                                                                class=\"dropdown-item status-pill status-pill--not-compliant\"\n                                                                ng-click=\"updateSubmissionStatus(row, 'Not Consistent')\">Not\n                                                                Consistent</button></li>\n                                                        <li><button\n                                                                class=\"dropdown-item status-pill status-pill--compliant\"\n                                                                ng-click=\"updateSubmissionStatus(row, 'Consistent')\">Consistent</button>\n                                                        </li>\n                                                    </ul>\n                                                </div>\n                                            </td>\n                                            <td>\n                                                <div ng-if=\"!row.excludeFromScoring && row.submitted_date\">\n                                                    <span ng-if=\"currentUser.role !== 'Administrator'\">\n                                                        {{row.score || '--'}}/{{row.max_score}}\n                                                    </span>\n                                                    <div ng-if=\"currentUser.role === 'Administrator'\"\n                                                        class=\"score-input-group\">\n                                                        <input type=\"number\" ng-model=\"row.score\"\n                                                            ng-change=\"validateScore(row)\" min=\"0\" ng-keyup.enter=\"updateScore(row)\"\n                                                            max=\"{{row.max_score}}\" ng-blur=\"updateScore(row)\"\n                                                            class=\"form-control score-input\" placeholder=\"0\">\n                                                        <span class=\"score-separator\">/</span>\n                                                        <span class=\"max-score\">{{row.max_score}}</span>\n                                                    </div>\n                                                </div>\n                                                <span ng-if=\"row.excludeFromScoring || !row.submitted_date\">--</span>\n                                            </td>\n                                            <td>{{row.submission_policy_type}}</td>\n                                            <td>{{row.jurisdiction}}</td>\n                                            <td>{{row.station_name}}</td>\n                                            <td>{{getDisplayPolicyName(row)}}</td>\n                                            <td>\n                                                <div class=\"submission-info\">\n                                                    <span class=\"submitted-by\">{{row.submitted_by ? row.submitted_by :\n                                                        '--'}}</span>\n                                                    <span class=\"submitted-date-badge\" ng-if=\"row.submitted_date\">\n                                                        <i class=\"fa fa-calendar\"></i>{{row.submitted_date |\n                                                        date:'mediumDate'}}\n                                                    </span>\n                                                </div>\n                                            </td>\n                                            <td>\n                                                <div class=\"status-updated-info\">\n                                                    <span class=\"status-updated-by\">{{row.status_last_updated_by ?\n                                                        row.status_last_updated_by : '--'}}</span>\n                                                    <span class=\"status-updated-date-badge\"\n                                                        ng-if=\"row.status_last_updated_date\">\n                                                        <i class=\"fa fa-calendar\"></i>{{row.status_last_updated_date |\n                                                        date:'mediumDate'}}\n                                                    </span>\n                                                </div>\n                                            </td>\n                                            <td>\n                                                <button class=\"btn btn-primary\" ng-click=\"showMoreInfo(row)\">\n                                                    <i class=\"fa-solid fa-info-circle\"></i>\n                                                </button>\n                                                <button class=\"btn btn-primary position-relative\"\n                                                    ng-click=\"showMessages(row)\">\n                                                    <i class=\"fa-solid fa-envelope\"></i>\n                                                    <span\n                                                        class=\"position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger\"\n                                                        ng-if=\"row.newmessages_count > 0\">\n                                                        {{row.newmessages_count}}\n                                                        <span class=\"visually-hidden\">unread messages</span>\n                                                    </span>\n                                                </button>\n                                            </td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n\n                            <div class=\"row\" style=\"margin-top: 12px;\">\n  <div class=\"submissions-pagination\"\n     st-pagination=\"\"\n     st-items-by-page=\"pageSize\"\n     st-displayed-pages=\"5\">\n</div>\n                        </div>\n                    </div>\n                </div>\n\n\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter />\n        </div>\n    </div>\n</section>\n\n\n\n<!-- Update Status -->\n<div class=\"modal fade\" id=\"updateMessagesModal\" tabindex=\"-1\" aria-labelledby=\"updateMessagesModalTitle\"\n    style=\"display: none;\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <h2>Update Status</h2>\n            <div class=\"modal-body\">\n\n                <form class=\"row test-validation-styling\" name=\"messagesForm\"\n                    ng-class=\"{'was-validated': formSubmitted}\" novalidate>\n                    <!-- To ID -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"to_id\">Addressed To:</label>\n                        <input id=\"to_id\" name=\"to_id\" type=\"text\" ng-model=\"updateMessage.submitted_by\" required />\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"form.to_id.$error.required && formSubmitted\">\n                            To ID is required.\n                        </div>\n                    </div>\n                    <!-- Status -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"status\">Status:</label>\n                        <select name=\"status\" id=\"status\" ng-model=\"updateMessage.status\" required>\n                            <option value=\"Pending\">Pending</option>\n                            <option value=\"In Review\">In Review</option>\n                            <option value=\"Needs Work\">Needs Work</option>\n                            <option value=\"Not Consistent\">Not Consistent</option>\n                            <option value=\"Consistent\">Consistent</option>\n                        </select>\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"form.status.$error.required && formSubmitted\">\n                            Please choose a valid status.\n                        </div>\n                    </div>\n                    <!-- Comment -->\n                    <div class=\"form-item col-lg-12\">\n                        <label for=\"comment\">Comment:</label>\n                        <textarea id=\"comment\" name=\"comment\" ng-model=\"updateMessage.comment\" required></textarea>\n                        <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                            ng-show=\"form.comment.$error.required && formSubmitted\">\n                            Comment is required.\n                        </div>\n                    </div>\n\n\n                    <div class=\"form-item col-lg-12\" style=\"padding-top: 20px;\">\n                        <button type=\"submit\" class=\"btn btn-primary btn-lg\" ng-click=\"updateMessageFn(messagesForm)\">\n                            <span ng-if=\"!saving\">Save Message</span>\n                            <span ng-if=\"saving\"><i class=\"fa-solid fa-cog fa-spin\"\n                                    style=\"font-weight: 400; padding-left:0.25em; padding-right:0.25em;\"></i>\n                                Saving...</span>\n                        </button>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-bs-dismiss=\"modal\">Cancel</button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JurisdictionsComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jurisdictions = __webpack_require__(195);
	
	var _jurisdictions2 = _interopRequireDefault(_jurisdictions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var JurisdictionsComponent = exports.JurisdictionsComponent = function () {
	  /*@ngInject*/
	  function JurisdictionsComponent($scope, lookup, fetch, userService) {
	    _classCallCheck(this, JurisdictionsComponent);
	
	    this.$scope = $scope;
	    this.lookup = lookup;
	    this.fetch = fetch;
	
	    this.userService = userService;
	
	    $scope.rowCollection = [];
	    $scope.filteredCollection = [];
	
	    $scope.updateTocActive = function (item) {
	      console.log('Current toc_active for', item.jurisdiction_id, ':', item.toc_active);
	      var data = {
	        jurisdiction_id: item.jurisdiction_id,
	        toc_active: item.toc_active
	      };
	
	
	      fetch.updateItem('api/data/jurisdictions/update-toc-active', data).then(function (response) {
	        console.log('Update successful:', response);
	      }).catch(function (error) {
	        console.error('Error updating toc_active:', error);
	      });
	    };
	  }
	
	  _createClass(JurisdictionsComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-admin').then(function (response) {
	        console.log(response.data);
	        _this2.$scope.rowCollection = response.data;
	        _this2.$scope.filteredCollection = _this2.$scope.rowCollection;
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this2.$state.go('login');
	        }
	      });
	    }
	  }]);
	
	  return JurisdictionsComponent;
	}();
	
	exports.default = angular.module('appApp.jurisdictions', [uiRouter, 'smart-table']).config(_jurisdictions2.default).component('jurisdictions', {
	  template: __webpack_require__(196),
	  controller: JurisdictionsComponent,
	  controllerAs: 'jurisdictionsCtrl'
	}).name;

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('jurisdictions', {
	    url: '/account/compliance/jurisdictions',
	    template: '<jurisdictions></jurisdictions>'
	  });
	};

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	module.exports = "<style>\n    .custom-checkbox {\n        width: 15px;\n        /* Set width */\n        height: 15px;\n        /* Set height */\n        cursor: pointer;\n        /* Change cursor on hover */\n    }\n\n    /* Style for the label */\n    .custom-checkbox-label {\n        display: inline-flex;\n        align-items: center;\n    }\n\n    /* Hide the default checkbox */\n    .custom-checkbox input[type=\"checkbox\"] {\n        display: none;\n        /* Hide the original checkbox */\n    }\n\n    /* Create a custom checkbox */\n    .custom-checkbox input[type=\"checkbox\"]+.checkbox-custom {\n        display: inline-block;\n        width: 24px;\n        height: 24px;\n        border: 2px solid #00303F;\n        /* Border color */\n        border-radius: 4px;\n        /* Rounded corners */\n        background-color: white;\n        /* Background color */\n        position: relative;\n    }\n\n    /* Checkmark style */\n    .custom-checkbox input[type=\"checkbox\"]:checked+.checkbox-custom {\n        background-color: #00303F;\n        /* Checked background color */\n        border-color: #00303F;\n        /* Checked border color */\n    }\n\n    /* Create the checkmark */\n    .custom-checkbox input[type=\"checkbox\"]:checked+.checkbox-custom::after {\n        content: '';\n        position: absolute;\n        left: 6px;\n        /* Adjust position */\n        top: 2px;\n        /* Adjust position */\n        width: 8px;\n        /* Checkmark width */\n        height: 12px;\n        /* Checkmark height */\n        border: solid white;\n        /* Checkmark color */\n        border-width: 0 2px 2px 0;\n        /* Checkmark dimensions */\n        transform: rotate(45deg);\n        /* Rotate to create checkmark */\n    }\n</style>\n<section class=\"dashboard dashboard--page dashboard--compliance dashboard--compliance--landing\">\n    <div class=\"page-wrapper\">\n\n        <div class=\"dashboard-header\">\n            <sidebarnav></sidebarnav>\n        </div>\n\n        <div class=\"main\">\n            <mainheaderauth></mainheaderauth>\n\n            <div class=\"content container\">\n                <h1 class=\"page-title\">Compliance</h1>\n\n                <div class=\"section col-lg-12\">\n                    <div class=\"section-header\">\n                        <h2>Jurisdictions</h2>\n\n                    </div>\n                    <div class=\"table-responsive\">\n                        <table st-table=\"filteredCollection\" st-safe-src=\"rowCollection\"\n                            class=\"table table--data-table table--compliance table-borderless table-striped\">\n                            <thead class=\"table-dark\">\n                                <tr>\n                                    <th st-sort=\"jurisdiction\">\n                                        <div class=\"th-inner\">\n                                            Jurisdiction\n                                            <tablesortbuttons></tablesortbuttons>\n                                        </div>\n                                    </th>\n                                    <th st-sort=\"county_id\">\n                                        <div class=\"th-inner\">\n                                            County\n                                            <tablesortbuttons></tablesortbuttons>\n                                        </div>\n                                    </th>\n                                    <th st-sort=\"funding_tier\">\n                                        <div class=\"th-inner\">\n                                            Funding Tier\n                                            <tablesortbuttons></tablesortbuttons>\n                                        </div>\n                                    </th>\n                                    <th scope=\"col\">\n                                        <div class=\"th-inner\">\n                                            Active?\n                                            <!-- <tablesortbuttons></tablesortbuttons> -->\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in filteredCollection\">\n                                    <td>{{item.jurisdiction}}</td>\n                                    <td>{{item.county_id}}</td>\n                                    <td>Tier {{item.funding_tier}}</td>\n                                    <td>\n                                        <label class=\"custom-checkbox\">\n                                            <input type=\"checkbox\" ng-model=\"item.toc_active\"\n                                                ng-change=\"updateTocActive(item)\" />\n                                            <span class=\"checkbox-custom\"></span>\n                                        </label>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter></sidebarfooter>\n        </div>\n    </div>\n</section>"

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StationAreasComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _station_areas = __webpack_require__(198);
	
	var _station_areas2 = _interopRequireDefault(_station_areas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var StationAreasComponent = exports.StationAreasComponent = function () {
	  /*@ngInject*/
	  function StationAreasComponent($scope, $state, $timeout, lookup, fetch, userService) {
	    _classCallCheck(this, StationAreasComponent);
	
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$state = $state;
	    this.$timeout = $timeout;
	
	    this.userService = userService;
	
	    $scope.rowCollection = [];
	    $scope.filteredCollection = [];
	
	    $scope.updateStationDetails = function (item) {
	      var _this = this;
	
	      if (!this.$scope.currentUser || !this.$scope.currentUser.firstname) {
	        item.updateError = true;
	        item.errorMessage = 'User information missing. Cannot save.';
	        this.$timeout(function () {
	          item.updateError = false;
	          item.errorMessage = '';
	        }, 5000);
	        return;
	      }
	
	      var editorName = this.$scope.currentUser.firstname + ' ' + this.$scope.currentUser.lastname;
	
	      console.log('Updating sta_recid: ' + item.sta_recid + ' with details:', {
	        active: item.active,
	        status: item.status,
	        service_tier: item.service_tier,
	        updated_by: editorName
	      });
	
	      item.savingStatus = true;
	      item.updateSuccess = false;
	      item.updateError = false;
	      item.errorMessage = '';
	
	      var payload = {
	        sta_recid: item.sta_recid,
	        active: item.active,
	        status: item.status,
	        service_tier: item.service_tier,
	        updated_by: editorName
	      };
	
	      fetch.updateItem('api/data/station-areas/update', payload).then(function (response) {
	        console.log('Update successful:', response);
	        item.updateSuccess = true;
	        _this.$timeout(function () {
	          item.updateSuccess = false;
	        }, 3000);
	      }).catch(function (err) {
	        console.error('Error updating station details:', err);
	        item.updateError = true;
	        item.errorMessage = err.data && err.data.error ? err.data.error : 'Save failed. Please try again.';
	
	        _this.$timeout(function () {
	          item.updateError = false;
	          item.errorMessage = '';
	        }, 5000);
	
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      }).finally(function () {
	        item.savingStatus = false;
	      });
	    }.bind(this);
	
	    $scope.editRow = function (itemInRow) {
	      console.log("editRow called for item:", itemInRow);
	      if (itemInRow) {
	
	        itemInRow.editing = true;
	        console.log("item.editing set to true");
	      } else {
	        console.error("editRow called with undefined item");
	      }
	    };
	
	    $scope.saveChanges = function (itemInRow) {
	      console.log("saveChanges called for item:", itemInRow);
	      $scope.updateStationDetails(itemInRow);
	    };
	
	    $scope.cancelEdit = function (itemInRow) {
	      console.log("cancelEdit called for item:", itemInRow);
	      if (itemInRow) {
	        itemInRow.editing = false;
	        itemInRow.updateSuccess = false;
	        itemInRow.updateError = false;
	        itemInRow.errorMessage = '';
	        console.log("item.editing set to false");
	      } else {
	        console.error("cancelEdit called with undefined item");
	      }
	    };
	  }
	
	  _createClass(StationAreasComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this2.$scope.currentUser = response.data;
	        _this2.userService.setCurrentUser(response.data);
	        _this2.getStationAreasList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this2.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getStationAreasList',
	    value: function getStationAreasList() {
	      this.fetch.getAllItems('api/data/stations/station-admin').then(function (response) {
	        if (response && response.data) {
	          var stationData = response.data;
	
	          for (var i = 0; i < stationData.length; i++) {
	            var item = stationData[i];
	
	            item.active = typeof item.active === 'string' ? item.active === 'true' : Boolean(item.active);
	
	            item.savingStatus = false;
	            item.updateSuccess = false;
	            item.updateError = false;
	            item.errorMessage = '';
	          }
	
	          this.$scope.rowCollection = stationData;
	
	          this.$scope.filteredCollection = this.$scope.rowCollection;
	        } else {
	          this.$scope.rowCollection = [];
	          this.$scope.filteredCollection = [];
	        }
	      }.bind(this)).catch(function (err) {
	
	        console.log(err);
	        if (err.status === 403) {
	
	          if (this.$state) {
	            this.$state.go('login');
	          } else {
	            console.error('$state service not available for redirection. Ensure it is injected in the constructor.');
	          }
	        }
	      }.bind(this));
	    }
	  }]);
	
	  return StationAreasComponent;
	}();
	
	exports.default = angular.module('appApp.station_areas', [uiRouter, 'smart-table']).config(_station_areas2.default).component('stationAreas', {
	  template: __webpack_require__(199),
	  controller: StationAreasComponent,
	  controllerAs: 'stationAreasCtrl'
	}).name;

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('station_areas', {
	    url: '/account/compliance/stationareas',
	    template: '<station-areas></station-areas>'
	  });
	};

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	module.exports = "<style>\n    .custom-checkbox {\n        width: 15px;\n        /* Set width */\n        height: 15px;\n        /* Set height */\n        cursor: pointer;\n        /* Change cursor on hover */\n    }\n\n    /* Style for the label */\n    .custom-checkbox-label {\n        display: inline-flex;\n        align-items: center;\n    }\n\n    /* Hide the default checkbox */\n    .custom-checkbox input[type=\"checkbox\"] {\n        display: none;\n        /* Hide the original checkbox */\n    }\n\n    /* Create a custom checkbox */\n    .custom-checkbox input[type=\"checkbox\"]+.checkbox-custom {\n        display: inline-block;\n        width: 24px;\n        height: 24px;\n        border: 2px solid #00303F;\n        /* Border color */\n        border-radius: 4px;\n        /* Rounded corners */\n        background-color: white;\n        /* Background color */\n        position: relative;\n    }\n\n    /* Checkmark style */\n    .custom-checkbox input[type=\"checkbox\"]:checked+.checkbox-custom {\n        background-color: #00303F;\n        /* Checked background color */\n        border-color: #00303F;\n        /* Checked border color */\n    }\n\n    /* Create the checkmark */\n    .custom-checkbox input[type=\"checkbox\"]:checked+.checkbox-custom::after {\n        content: '';\n        position: absolute;\n        left: 6px;\n        /* Adjust position */\n        top: 2px;\n        /* Adjust position */\n        width: 8px;\n        /* Checkmark width */\n        height: 12px;\n        /* Checkmark height */\n        border: solid white;\n        /* Checkmark color */\n        border-width: 0 2px 2px 0;\n        /* Checkmark dimensions */\n        transform: rotate(45deg);\n        /* Rotate to create checkmark */\n    }\n</style>\n<section class=\"dashboard dashboard--page dashboard--compliance dashboard--compliance--landing dashboard--submissions\">\n    <div class=\"page-wrapper\">\n\n        <div class=\"dashboard-header\">\n            <sidebarnav></sidebarnav>\n        </div>\n\n        <div class=\"main\">\n            <mainheaderauth></mainheaderauth>\n\n            <div class=\"content container\" st-table=\"filteredCollection\" st-safe-src=\"rowCollection\">\n                <h1 class=\"page-title\">Compliance</h1>\n\n                <div class=\"section col-lg-12\">\n                    <div class=\"section-header\">\n                        <h2>Station Areas</h2>\n\n                    </div>\n                    <div class=\"row mb-4\">\n                        <form class=\"col-lg-4\">\n                            <div class=\"filters\">\n                                <div class=\"form-item form-item--search\">\n                                    <input type=\"text\" placeholder=\"Search stations\" st-search />\n                                </div>\n                            </div>\n                        </form>\n\n\n                    </div>\n                    <div class=\"table-responsive\">\n                        <table class=\"table table--data-table table--compliance table-borderless table-striped\"\n                            st-table=\"filteredCollection\" st-safe-src=\"rowCollection\">\n                            <thead class=\"table-dark\">\n                                <tr>\n                                    <th st-sort=\"jurisdiction\">\n                                        <div class=\"th-inner\">\n                                            Jurisdiction\n                                            <tablesortbuttons></tablesortbuttons>\n                                        </div>\n                                    </th>\n                                    <th st-sort=\"station_name\">\n                                        <div class=\"th-inner\">\n                                            Station Area\n                                            <tablesortbuttons></tablesortbuttons>\n                                        </div>\n                                    </th>\n                                    <th st-sort=\"status\">\n                                        <div class=\"th-inner\">\n                                            Status\n                                            <tablesortbuttons></tablesortbuttons>\n                                        </div>\n                                    </th>\n                                    <th st-sort=\"service_tier\">\n                                        <div class=\"th-inner\">\n                                            Service Tier\n                                            <tablesortbuttons></tablesortbuttons>\n                                        </div>\n                                    </th>\n                                    <th st-sort=\"total_parcels\">\n                                        <div class=\"th-inner\">\n                                            Parcel Count\n                                            <tablesortbuttons></tablesortbuttons>\n                                        </div>\n                                    </th>\n                                    <th scope=\"col\">\n                                        <div class=\"th-inner\">\n                                            Active?\n                                            <!-- <tablesortbuttons></tablesortbuttons> -->\n                                        </div>\n                                    </th>\n                                    <th scope=\"col\">\n                                        <div class=\"th-inner\">\n                                            More Tools\n                                            <!-- <tablesortbuttons></tablesortbuttons> -->\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in filteredCollection\">\n                                    <td>\n                                        <!-- Jurisdiction - Assuming read-only for this scope -->\n                                        {{ item.jurisdiction }}\n                                    </td>\n                                    <td>\n                                        <!-- Station Name - Assuming read-only for this scope -->\n                                        {{ item.station_name }}\n                                    </td>\n                                    <td>\n                                        <!-- Status -->\n                                        <span ng-if=\"!item.editing\">{{ item.status }}</span>\n                                        <select ng-if=\"item.editing\" class=\"form-control form-control-sm\"\n                                            ng-model=\"item.status\" ng-disabled=\"item.savingStatus\">\n                                            <option value=\"\">-- Select Status --</option>\n                                            <option value=\"Existing/Built\">Existing/Built</option>\n                                            <option value=\"Planned\">Planned</option>\n                                            <option value=\"Under Construction\">Under Construction</option>\n\n                                        </select>\n                                    </td>\n                                    <td>\n                                        <!-- Service Tier -->\n                                        <span ng-if=\"!item.editing\">{{ item.service_tier }}</span>\n                                        <select ng-if=\"item.editing\" class=\"form-control form-control-sm\"\n                                            ng-model=\"item.service_tier\" ng-options=\"tier for tier in [1, 2, 3, 4]\"\n                                            ng-disabled=\"item.savingStatus\">\n                                            <option value=\"\">-- Select Tier --</option>\n                                        </select>\n                                        <!-- Or if it's a free text number input:\n                                        <input ng-if=\"item.editing\" type=\"number\" class=\"form-control form-control-sm\"\n                                            ng-model=\"item.service_tier\" ng-disabled=\"item.savingStatus\" />\n                                        -->\n                                    </td>\n                                    <td>\n                                        <!-- Parcel Count - Assuming read-only for this scope -->\n                                        {{ item.total_parcels }} parcels\n                                    </td>\n                                    <td>\n                                        <!-- Active? -->\n                                        <span ng-if=\"!item.editing\" class=\"custom-checkbox-label\">\n                                            <input type=\"checkbox\" ng-disabled=\"true\" ng-model=\"item.active\"\n                                                id=\"displayActive{{$index}}\">\n                                            <label class=\"checkbox-custom\" for=\"displayActive{{$index}}\"></label>\n                                        </span>\n                                        <span ng-if=\"item.editing\" class=\"custom-checkbox-label\">\n                                            <input type=\"checkbox\" ng-model=\"item.active\"\n                                                ng-disabled=\"item.savingStatus\" id=\"editActive{{$index}}\">\n                                            <label class=\"checkbox-custom\" for=\"editActive{{$index}}\"></label>\n                                        </span>\n                                    </td>\n                                    <td>\n                                        <!-- Action Buttons & Feedback -->\n                                        <div ng-if=\"!item.editing\">\n                                            <button class=\"btn btn-sm btn-primary\" ng-click=\"editRow(item)\">\n                                                Edit\n                                            </button>\n                                        </div>\n                                        <div ng-if=\"item.editing\">\n                                            <button class=\"btn btn-sm btn-success\" ng-click=\"saveChanges(item)\"\n                                                ng-disabled=\"item.savingStatus\">\n                                                <i ng-if=\"item.savingStatus\" class=\"fa-solid fa-spinner fa-spin\"></i>\n                                                Save\n                                            </button>\n                                            <button class=\"btn btn-sm btn-secondary\" ng-click=\"cancelEdit(item)\"\n                                                ng-disabled=\"item.savingStatus\">\n                                                Cancel\n                                            </button>\n                                            <span ng-if=\"item.updateSuccess\" class=\"text-success\"\n                                                style=\"margin-left: 5px;\">\n                                                <i class=\"fa-solid fa-check\"></i> Saved!\n                                            </span>\n                                            <span ng-if=\"item.updateError\" class=\"text-danger\"\n                                                style=\"margin-left: 5px;\">\n                                                <i class=\"fa-solid fa-times\"></i> {{item.errorMessage || 'Error!'}}\n                                            </span>\n                                        </div>\n                                    </td>\n                                </tr>\n                            </tbody>\n\n                        </table>\n                    </div>\n\n\n                </div>\n\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter></sidebarfooter>\n        </div>\n    </div>\n</section>"

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TocPolicyComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toc_policy = __webpack_require__(201);
	
	var _toc_policy2 = _interopRequireDefault(_toc_policy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var TocPolicyComponent = exports.TocPolicyComponent = function () {
	  /*@ngInject*/
	  function TocPolicyComponent($scope, navService) {
	    _classCallCheck(this, TocPolicyComponent);
	
	    this.$scope = $scope;
	    this.navService = navService;
	  }
	
	  _createClass(TocPolicyComponent, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return TocPolicyComponent;
	}();
	
	exports.default = angular.module('appApp.toc_policy', [uiRouter]).config(_toc_policy2.default).component('tocPolicy', {
	  template: __webpack_require__(202),
	  controller: TocPolicyComponent,
	  controllerAs: 'tocPolicyCtrl'
	}).name;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('toc_policy', {
	    url: '/account/toc_policy',
	    template: '<toc-policy></toc-policy>'
	  });
	};

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--content--housing\">\n  <div class=\"page-wrapper\">\n    <div class=\"dashboard-header\">\n      <!-- Sidebarnav source components/directives/sidebarnav  -->\n      <sidebarnav></sidebarnav>\n    </div>\n    <div class=\"main\">\n      <!-- mainheaderauth source components/directives/mainheaderauth  -->\n      <mainheaderauth></mainheaderauth>\n      <div class=\"content container\">\n        <div class=\"row\">\n          <div class=\"col-lg-8\">\n            <h1 class=\"page-title\">TOC Policy</h1>\n            <!-- <div class=\"page-summary\">\n              Affordable Housing Production, Preservation, and Protection and\n              Commercial Stabilization\n            </div> -->\n            <p>\n              In September 2022, MTC adopted the Transit-Oriented Communities\n              (TOC) Policy\n              <a\n                href=\"https://mtc.ca.gov/digital-library/5023449-mtc-resolution-number-4530-transit-oriented-communities-policy\">(MTC\n                Resolution 4530)</a>\n              to support the region’s transit investments by creating\n              communities around transit stations and along transit corridors\n              that not only enable transit ridership, but also are places where\n              Bay Area residents of all abilities, income levels, and racial and\n              ethnic backgrounds can live, work, and access services. The TOC\n              Policy focuses on the core elements of land use density,\n              affordable housing, parking management, and complete\n              streets/multimodal access to implement\n              <a href=\"https://mtc.ca.gov/planning/long-range-planning/plan-bay-area-2050\">Plan Bay Area 2050\n                strategies.</a>\n            </p>\n            <figure>\n              <img class=\"image--full\" src=\"../../../assets/images/mockups/dashboard-content-image.jpg\"\n                alt=\"Person wearing a mask and helmet on a bike\" height=\"730\" width=\"410\" />\n              <!-- <figcaption>\n                Ut wisi enim ad minim veniam, quis nostrud exerci tation\n                ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo\n                consequat. <span class=\"image-credit\">Credit: Sergio Ruiz</span>\n              </figcaption> -->\n            </figure>\n\n            <h2>Applicability</h2>\n            <p>\n              The TOC Policy applies to the half-mile area around existing and\n              planned fixed-guideway transit stops and stations (i.e., regional\n              rail, commuter rail, light-rail transit, bus rapid transit, and\n              ferries). Achieving consistency with the TOC Policy is voluntary for\n              jurisdictions that want to advance the goals of Plan Bay Area 2050\n              or to be eligible and/or competitive for some MTC discretionary\n              funding.\n            </p>\n\n            <h2>TOC Policy and Funding</h2>\n            <p>\n              In February 2026, the Metropolitan Transportation Commission adopted the TOC Incentive Program to encourage local governments to achieve consistency with the TOC Policy. Jurisdictions that achieve a minimum average score of 85 points jurisdiction-wide are eligible for the Incentive Program. <a href=\"https://mtc.ca.gov/digital-library/5136009-transit-oriented-communities-incentive-program-mtc-resolution-no-4754\" target=\"_blank\">MTC Resolution No. 4754</a> describes the TOC Incentive Program in more detail. \n            </p>\n            <p>\n              The TOC Policy also applies to transit extension projects. The Policy establishes different compliance\n              expectations for projects seeking endorsements or regional discretionary capital funding based on\n              the project’s delivery stage. Review the TOC Policy Administrative Guidance for more details.\n            </p>\n\n            <h2>Transit Tiers</h2>\n            <p>\n              Areas subject to the TOC Policy are categorized by tier according to level of transit service:\n            <ul class=\"square-bullets\">\n              <li>\n                <b>Tier 1:</b> Rail stations serving regional centers (i.e., Downtown San Francisco, Downtown Oakland,\n                and Downtown San José).\n              </li>\n              <li>\n                <b>Tier 2:</b> Stop/station served by two or more BART lines or BART and Caltrain.\n              </li>\n              <li>\n                <b>Tier 3:</b> Stop/station served by one BART line, Caltrain, light rail transit, or bus rapid transit.\n              </li>\n              <li>\n                <b>Tier 4:</b> Commuter rail (SMART, ACE, Capitol Corridor, Valley Link) stations, Caltrain stations\n                south of Tamien, or ferry terminals. \n              </li>\n            </ul>\n            </p>\n          </div>\n          <div class=\"col-lg-4\" style=\"padding-top:40px;\">\n            <div class=\"right-content\">\n              <h2>Resources</h2>\n              <!-- sidebaractivity source /components/directives/sidebaractivity  -->\n              <ul class=\"list list--icons\">\n                <li>\n                  <a href=\"https://mtc.ca.gov/planning/land-use/transit-oriented-communities-toc-policy\"\n                    class=\"icon-list-item icon-list-item--pdf\">TOC Policy Website</a>\n                  <p>This is the online hub for information related to the TOC Policy.</p>\n                </li>\n                <li>\n                  <a href=\"https://mtc.ca.gov/digital-library/5023449-transit-oriented-communities-policy-mtc-resolution-no-4530\"\n                    class=\"icon-list-item icon-list-item--document\">MTC Resolution Number 4530</a>\n                  <p>Review the TOC Policy resolution adopted by MTC in September 2022 and revised in May 2026.</p>\n                </li>\n                <li>\n                  <a href=\"https://mtc.ca.gov/digital-library/5136009-transit-oriented-communities-incentive-program-mtc-resolution-no-4754\"\n                    class=\"icon-list-item icon-list-item--document\">TOC Incentive Program (MTC Resolution No. 4754)</a>\n                  <p>Overview of the $45 million TOC Incentive Program, including the TOC Evaluation Framework and Program Guidelines, adopted in February 2026 as part of OBAG 4.</p>\n                </li>\n                <li>\n                  <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\"\n                    class=\"icon-list-item icon-list-item--document\">MTC Administrative Guidance: TOC Policy</a>\n                  <p>Guidance to local jurisdictions about how to demonstrate compliance consistency with the TOC Policy.</p>\n                </li>\n                <li>\n                  <a href=\"https://mtc.ca.gov/digital-library/5026613-toc-templates-acknowledgement-letter-and-resolution-transit-extension-funding\"\n                    class=\"icon-list-item icon-list-item--document\">TOC Acknowledgement Letter/Resolution</a>, <a href=\"https://mtc.ca.gov/digital-library/5026614-toc-templates-commitment-letter-and-resolution-transit-extension-funding\" target=\"_blank\">TOC Commitment Letter/Resolution</a>,\n                  <p>TOC Policy Consistency Work Plan, and Progress Report</p>\n                </li>\n                  <p> The TOC Policy establishes different consistency expectations\n                    based on a transit project’s delivery stage. Jurisdictions can use these templates if they need to\n                    submit a letter or resolution, TOC Policy Consistency Work Plan, or Progress Report in support of an endorsement or funding request for a transit extension.</p>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"footer\" role=\"contentinfo\">\n      <sidebarfooter></sidebarfooter>\n    </div>\n  </div>\n</section>"

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DocumentsComponent = undefined;
	
	var _documents = __webpack_require__(204);
	
	var _documents2 = _interopRequireDefault(_documents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var DocumentsComponent =
	/*@ngInject*/
	exports.DocumentsComponent = function DocumentsComponent() {
	  _classCallCheck(this, DocumentsComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.documents', [uiRouter]).config(_documents2.default).component('documents', {
	  template: __webpack_require__(205),
	  controller: DocumentsComponent,
	  controllerAs: 'documentsCtrl'
	}).name;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('documents', {
	    url: '/account/toc_policy/documents',
	    template: '<documents></documents>'
	  });
	};

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--content dashboard--content--housing\">\n    <div class=\"page-wrapper\">\n      <div class=\"dashboard-header\">\n        <!-- Sidebarnav source components/directives/sidebarnav  -->\n        <sidebarnav></sidebarnav>\n      </div>\n      <div class=\"main\">\n        <!-- mainheaderauth source components/directives/mainheaderauth  -->\n        <mainheaderauth></mainheaderauth>\n        <div class=\"content container\">\n          <div class=\"row\">\n            <div class=\"col-lg-8\">\n              <h1 class=\"page-title\">TOC Policy Documents</h1>\n              <!-- <div class=\"page-summary\">\n                Affordable Housing Production, Preservation, and Protection and\n                Commercial Stabilization\n              </div> -->\n              \n            <div class=\"col-lg-4\" style=\"padding-top:40px;\">\n              <div class=\"right-content\">\n                <h2>Resources</h2>\n                <!-- sidebaractivity source /components/directives/sidebaractivity  -->\n                <ul class=\"list list--icons\">\n                  <li>\n                    <a href=\"https://mtc.ca.gov/planning/land-use/transit-oriented-communities-toc-policy\" class=\"icon-list-item icon-list-item--pdf\">TOC Policy Website</a>\n                    <p>This is the online hub for information related to the TOC Policy.</p>\n                  </li>\n                  <li>\n                    <a href=\"https://mtc.ca.gov/digital-library/5023449-mtc-resolution-number-4530-transit-oriented-communities-policy\"\n                      class=\"icon-list-item icon-list-item--document\">MTC Resolution Number 4530 - TOC Policy</a>\n                      <p>Review the TOC Policy resolution adopted by MTC in September 2022 and revised in October 2023.</p>\n                  </li>\n                  <li>\n                    <a href=\"https://mtc.ca.gov/digital-library/5023804-mtc-administrative-guidance-transit-oriented-communities-policy\" class=\"icon-list-item icon-list-item--document\">MTC Administrative Guidance: Toc\n                      Policy</a>\n                      <p>Guidance to local jurisdictions about how to demonstrate compliance with the TOC Policy.</p>\n                  </li>\n                  <li>\n                    <a href=\"https://mtc.ca.gov/digital-library/5025135-transit-oriented-communities-toc-policy-overview\" class=\"icon-list-item icon-list-item--document\">TOC Policy Overview</a>\n                    <p>A 2-page handout that provides a high-level overview of the TOC Policy.</p>\n                  </li>\n                  <li>\n                    <a href=\"https://mtc.ca.gov/digital-library/5025116-summary-requirements-mtcs-transit-oriented-communities-toc-policy\" class=\"icon-list-item icon-list-item--document\">Summary of Requirements for MTC's TOC\n                      Policy</a>\n                      <p>A checklist of the TOC Policy requirements.</p>\n                  </li>\n                  <li>\n                    \n                    <a href=\"https://mtc.ca.gov/digital-library/5026613-toc-templates-acknowledgement-letter-and-resolution-transit-extension-funding\" class=\"icon-list-item icon-list-item--document\">Templates for TOC Acknowledgement Letter\n                      or Resolution</a> and<br>\n                      <a href=\"https://mtc.ca.gov/digital-library/5026614-toc-templates-commitment-letter-and-resolution-transit-extension-funding\" class=\"icon-list-item icon-list-item--document\">Templates for TOC Commitment Letter or\n                        Resolution</a>\n                        <p>Jurisdictions must comply with the TOC Policy in order for a fixed-guideway transit extension to receive regional discretionary funding. The TOC Policy establishes different compliance expectations based on the transit project’s delivery stage. Jurisdictions can use these templates if they need to submit a letter or resolution in support of a funding request for a transit extension</p>\n                  </li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n        <sidebarfooter></sidebarfooter>\n      </div>\n    </div>\n  </section>\n"

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegisterSuccessComponent = undefined;
	
	var _registerSuccess = __webpack_require__(207);
	
	var _registerSuccess2 = _interopRequireDefault(_registerSuccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var RegisterSuccessComponent =
	/*@ngInject*/
	exports.RegisterSuccessComponent = function RegisterSuccessComponent() {
	  _classCallCheck(this, RegisterSuccessComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.register-success', [uiRouter]).config(_registerSuccess2.default).component('registerSuccess', {
	  template: __webpack_require__(208),
	  controller: RegisterSuccessComponent,
	  controllerAs: 'registerSuccessCtrl'
	}).name;

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('register-success', {
	    url: '/register-success',
	    template: '<register-success></register-success>'
	  });
	};

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	module.exports = "<section>\n  <div class=\"page-wrapper\">\n    <div class=\"row\">\n      <div class=\"login--image-panel col-md-6\"></div>\n      <!-- @whitney Added this overflow style -- you can port it over to the css file and remove from here  -->\n      <div class=\"login--form-panel col-md-6\" style=\"overflow: scroll\">\n        <div class=\"login--form-panel--head\">\n          <img\n            class=\"login-form-panel--logo\"\n            src=\"./assets/images/dots.svg\"\n            alt=\"\"\n            role=\"presentation\"\n          />\n          <div class=\"h2\">Bay Area TOC Policy Submission&nbsp;Portal</div>\n        </div>\n        <div class=\"login--form-panel--content\">\n          <div class=\"login-form-panel--title\">\n            <h1>Thank you!</h1>\n            <a href=\"/login\" class=\"link link--register\">Login</a>\n          </div>\n          <div class=\"login-form-panel--form\">\n            <p>\n              Thank you for registering. Please check your email and click on\n              the link to confirm your account. Once your email is confirmed,\n              your account will be activated.\n              <br /><br />\n              For any questions or concerns, please email us at\n              TOCPolicy@bayareametro.gov.\n            </p>\n          </div>\n          <div class=\"login-form-panel--footer\">\n            <img\n              class=\"footer-logo\"\n              src=\"./assets/images/mtc_logo.svg\"\n              alt=\"Metropolitan Transportation Commission Logo\"\n            />\n            <img\n              class=\"footer-logo\"\n              src=\"./assets/images/abag_logo.svg\"\n              alt=\"Association of Bay Area Governments Logo\"\n            />\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountNotActiveComponent = undefined;
	
	var _accountNotActive = __webpack_require__(210);
	
	var _accountNotActive2 = _interopRequireDefault(_accountNotActive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var AccountNotActiveComponent =
	/*@ngInject*/
	exports.AccountNotActiveComponent = function AccountNotActiveComponent() {
	  _classCallCheck(this, AccountNotActiveComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.account-not-active', [uiRouter]).config(_accountNotActive2.default).component('accountNotActive', {
	  template: __webpack_require__(211),
	  controller: AccountNotActiveComponent,
	  controllerAs: 'accountNotActiveCtrl'
	}).name;

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('account-not-active', {
	    url: '/account-not-active',
	    template: '<account-not-active></account-not-active>'
	  });
	};

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = "<section>\n    <div class=\"page-wrapper\">\n      <div class=\"row\">\n          <div class=\"login--image-panel col-md-6\">\n          </div>\n          <!-- @whitney Added this overflow style -- you can port it over to the css file and remove from here  -->\n          <div class=\"login--form-panel col-md-6\" style=\"overflow: scroll;\">\n              <div class=\"login--form-panel--head\">\n                  <img class=\"login-form-panel--logo\" src=\"./assets/images/dots.svg\" alt=\"\" role=\"presentation\" />\n                  <div class=\"h2\">Bay Area TOC Policy Submission&nbsp;Portal</div>\n              </div>\n              <div class=\"login--form-panel--content\">\n                  <div class=\"login-form-panel--title\">\n                      <h1>Thank you!</h1>\n                      <a href=\"/login\" class=\"link link--register\">Login</a>\n                  </div>\n                  <div class=\"login-form-panel--form\">\n                      <p>\n                        Thank you for registering. Your account will be reviewed and activated within the next 24 hours.\n                        <br><br>\n                        For any questions or concerns, please email us at TOCPolicy@bayareametro.gov\n                      </p>\n                  </div>\n                  <div class=\"login-form-panel--footer\">\n                      <img class=\"footer-logo\" src=\"./assets/images/mtc_logo.svg\" alt=\"Metropolitan Transportation Commission Logo\" />\n                      <img class=\"footer-logo\" src=\"./assets/images/abag_logo.svg\" alt=\"Association of Bay Area Governments Logo\" />\n                  </div>\n              </div>\n          </div>\n      </div>\n    </div>\n  </section>"

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessagesComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _messages = __webpack_require__(213);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var MessagesComponent = exports.MessagesComponent = function () {
	  /*@ngInject*/
	  function MessagesComponent($state, $scope, $rootScope, fetch, lookup, userService, $stateParams) {
	    var _this2 = this;
	
	    _classCallCheck(this, MessagesComponent);
	
	    this.getJurisdictionList = function () {
	      var _this = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/list').then(function (response) {
	
	        _this.$scope.jurisdictions = response.data;
	        _this.$scope.jurisdiction = response.data[0].jurisdiction;
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    this.filterMessages = function (jurisdiction, policyType) {
	      if (!_this2.allMessages) {
	        _this2.allMessages = angular.copy(_this2.messages);
	      }
	
	      if (!jurisdiction && !policyType) {
	        _this2.messages = _this2.allMessages;
	        return;
	      }
	
	      if (jurisdiction && !policyType) {
	        _this2.messages = _this2.allMessages.filter(function (msg) {
	          return msg.jurisdiction === jurisdiction;
	        });
	      } else if (policyType && !jurisdiction) {
	        _this2.messages = _this2.allMessages.filter(function (msg) {
	          return msg.policy_type === policyType;
	        });
	      } else {
	        _this2.messages = _this2.allMessages.filter(function (msg) {
	          return msg.jurisdiction === jurisdiction && msg.policy_type === policyType;
	        });
	      }
	    };
	
	    this.$scope = $scope;
	    this.$state = $state;
	    this.fetch = fetch;
	    this.lookup = lookup;
	    this.$stateParams = $stateParams;
	    this.userService = userService;
	    this.currentPolicyType = null;
	    this.messages = [];
	    this.policyTypes = ["Density", "Housing Production Policy", "Housing Commercial Policy", "Parking", "Station Area Access", "Zoning"];
	
	    this.processNestedMessages = this.processNestedMessages.bind(this);
	
	    $scope.showMessages = function (row) {
	      console.log(row);
	      console.log(row);
	      $state.go('message-detail', {
	        submissionId: row.submission_id,
	        message_chain_id: row.message_chain_id,
	        messageData: 'messages',
	        data: row
	      });
	    };
	  }
	
	  _createClass(MessagesComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this3 = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	        console.log(response);
	
	        _this3.getJurisdictionList();
	        _this3.$scope.currentUser = response.data;
	        _this3.userService.setCurrentUser(response.data);
	        _this3.fetchUserMessages();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this3.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'fetchUserMessages',
	    value: function fetchUserMessages() {
	      var _this4 = this;
	
	      if (!this.$scope.currentUser || !this.$scope.currentUser.id) {
	        return Promise.reject(new Error('No user ID available'));
	      }
	
	      this.loading = true;
	
	      return Promise.all([this.fetch.getAllItems('api/messages/comments')]).then(function (messagesResponse) {
	        console.log(messagesResponse[0].data);
	        _this4.messages = _this4.processNestedMessages(messagesResponse[0].data, _this4.$scope.currentUser.organization);
	        console.log('Messages received:', _this4.messages);
	
	        _this4.messageCounts = _this4.messages.reduce(function (counts, thread) {
	          var threadUnread = thread.messages.filter(function (msg) {
	            return msg.read_at === null && msg.to_jurisdiction === _this4.$scope.currentUser.organization;
	          }).length;
	          var threadRead = thread.messages.filter(function (msg) {
	            return msg.read_at !== null;
	          }).length;
	
	          return {
	            total: counts.total + thread.messages.length,
	            unread: counts.unread + threadUnread,
	            read: counts.read + threadRead
	          };
	        }, { total: 0, unread: 0, read: 0 });
	
	        console.log('Message counts:', _this4.messageCounts);
	        _this4.error = null;
	      }).catch(function (err) {
	        console.error('Error fetching messages:', err);
	        _this4.error = 'Failed to load messages';
	        _this4.messages = [];
	        _this4.messageCounts = {
	          total: 0,
	          unread: 0,
	          read: 0
	        };
	      }).finally(function () {
	        _this4.loading = false;
	        if (!_this4.$scope.$$phase) {
	          _this4.$scope.$apply();
	        }
	      });
	    }
	  }, {
	    key: 'processNestedMessages',
	    value: function processNestedMessages(messages, organization) {
	      console.log(messages);
	      if (!messages || !messages.length) return [];
	
	      var groupedThreads = messages.reduce(function (acc, message) {
	        var chainId = message.message_chain_id;
	        var submissionId = message.submission_id;
	
	        if (!acc[submissionId]) {
	          acc[submissionId] = {
	            submission_id: submissionId,
	            message_chain_id: chainId,
	            message_type: message.message_type,
	            messages: [],
	            unreadCount: 0,
	            totalCount: 0,
	            hasUnread: false,
	            lastMessage: null,
	            lastMessageDate: null,
	            jurisdiction: message.jurisdiction,
	            policy: message.submission_policy_name,
	            policy_type: message.submission_policy_type,
	            station_name: message.station_name
	          };
	        }
	
	        console.log(message);
	        console.log('update unread');
	        console.log(organization);
	        var isUnread = message.read_at === null && message.to_jurisdiction === organization;
	        acc[submissionId].messages.push(Object.assign({}, message, {
	          isUnread: isUnread,
	          formattedDate: message.created_at ? new Date(message.created_at).toLocaleDateString() : ''
	        }));
	
	        if (isUnread) {
	          acc[submissionId].unreadCount++;
	          acc[submissionId].hasUnread = true;
	        }
	
	        acc[submissionId].totalCount++;
	
	        if (!acc[submissionId].lastMessage || new Date(message.created_at) > new Date(acc[submissionId].lastMessage.created_at)) {
	          acc[submissionId].lastMessage = message;
	          acc[submissionId].lastMessageDate = message.created_at;
	        }
	
	        return acc;
	      }, {});
	
	      var threads = Object.keys(groupedThreads).map(function (key) {
	        var thread = groupedThreads[key];
	
	        if (thread.lastMessage && thread.lastMessage.updated_at) {
	          thread.lastMessage.formattedUpdatedAt = new Date(thread.lastMessage.updated_at).toLocaleDateString();
	        }
	
	        return Object.assign({}, thread, {
	          messages: thread.messages.sort(function (a, b) {
	            return new Date(a.created_at) - new Date(b.created_at);
	          })
	        });
	      }).sort(function (a, b) {
	        return new Date(b.lastMessage.created_at) - new Date(a.lastMessage.created_at);
	      });
	
	      console.log('Processed threads:', threads);
	      return threads;
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      if (!date) {
	        return '';
	      }
	      return new Date(date).toLocaleDateString('en-US', {
	        year: 'numeric',
	        month: 'short',
	        day: 'numeric',
	        hour: '2-digit',
	        minute: '2-digit'
	      });
	    }
	  }, {
	    key: 'getMessageDate',
	    value: function getMessageDate(messageGroup) {
	      if (messageGroup && messageGroup.messages && messageGroup.messages.length > 0) {
	        return messageGroup.messages[0].date;
	      }
	      return new Date(0);
	    }
	  }, {
	    key: 'getClosedCount',
	    value: function getClosedCount() {
	      return this.messages.filter(function (msg) {
	        return msg.status === 'closed';
	      }).length;
	    }
	  }, {
	    key: 'getInProgressCount',
	    value: function getInProgressCount() {
	      return this.messages.filter(function (msg) {
	        return msg.status === 'in_progress';
	      }).length;
	    }
	  }, {
	    key: 'viewMessage',
	    value: function viewMessage(message) {
	      console.log('Viewing message:', message);
	    }
	  }, {
	    key: 'replyToMessage',
	    value: function replyToMessage(message) {
	      console.log('Replying to message:', message);
	    }
	  }, {
	    key: 'markAsRead',
	    value: function markAsRead(message) {
	      var _this5 = this;
	
	      console.log(message);
	
	      this.fetch.updateItem('api/messages/' + message.notify_id + '/read').then(function () {
	        message.status = 'read';
	
	        _this5.fetchUserMessages();
	      }).catch(function (err) {
	        console.error('Error marking message as read:', err);
	      });
	    }
	  }, {
	    key: 'getUnreadCount',
	    value: function getUnreadCount(messages) {
	      console.log('getting unread count');
	      if (!messages || !messages.length) return 0;
	      console.log(messages);
	      console.log(this.$scope.currentUser);
	      return messages.filter(function (msg) {
	        return msg.read_at === null;
	      }).length;
	    }
	  }, {
	    key: 'hasUnreadMessages',
	    value: function hasUnreadMessages(messages) {
	      console.log("checking unread messages");
	      console.log(messages);
	      if (!messages || !messages.length) return false;
	      return messages.some(function (msg) {
	        return msg.read_at === null;
	      });
	    }
	  }, {
	    key: 'isRecentMessage',
	    value: function isRecentMessage(message) {
	      var now = new Date();
	      var messageDate = new Date(message.date);
	      var hoursDiff = (now - messageDate) / (1000 * 60 * 60);
	      return hoursDiff < 24;
	    }
	  }, {
	    key: 'hasRecentUnread',
	    value: function hasRecentUnread(messages) {
	      var _this6 = this;
	
	      if (!messages || !messages.length) return false;
	      return messages.some(function (msg) {
	        return msg.status !== 'read' && _this6.isRecentMessage(msg);
	      });
	    }
	  }]);
	
	  return MessagesComponent;
	}();
	
	exports.default = angular.module('appApp.messages', [uiRouter]).config(_messages2.default).component('messages', {
	  template: __webpack_require__(315),
	  controller: MessagesComponent,
	  controllerAs: 'messagesCtrl'
	}).name;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('messages', {
	    url: '/account/messages',
	    template: '<messages></messages>',
	    authenticate: true
	  }).state('message-detail', {
	    url: '/account/message',
	    template: '<message-detail></message-detail>',
	    params: {
	      messageData: null,
	      submissionId: null,
	      message_chain_id: null,
	      data: null
	    },
	    component: 'messageDetail',
	    authenticate: true
	  });
	};
	
	var _passport = __webpack_require__(214);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var Passport = __webpack_require__(215)
	  , SessionStrategy = __webpack_require__(216);
	
	
	/**
	 * Export default singleton.
	 *
	 * @api public
	 */
	exports = module.exports = new Passport();
	
	/**
	 * Expose constructors.
	 */
	exports.Passport =
	exports.Authenticator = Passport;
	exports.Strategy = __webpack_require__(275);
	
	/**
	 * Expose strategies.
	 */
	exports.strategies = {};
	exports.strategies.SessionStrategy = SessionStrategy;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var SessionStrategy = __webpack_require__(216);
	
	
	/**
	 * `Authenticator` constructor.
	 *
	 * @api public
	 */
	function Authenticator() {
	  this._key = 'passport';
	  this._strategies = {};
	  this._serializers = [];
	  this._deserializers = [];
	  this._infoTransformers = [];
	  this._framework = null;
	  this._userProperty = 'user';
	  
	  this.init();
	}
	
	/**
	 * Initialize authenticator.
	 *
	 * @api protected
	 */
	Authenticator.prototype.init = function() {
	  this.framework(__webpack_require__(277)());
	  this.use(new SessionStrategy());
	};
	
	/**
	 * Utilize the given `strategy` with optional `name`, overridding the strategy's
	 * default name.
	 *
	 * Examples:
	 *
	 *     passport.use(new TwitterStrategy(...));
	 *
	 *     passport.use('api', new http.BasicStrategy(...));
	 *
	 * @param {String|Strategy} name
	 * @param {Strategy} strategy
	 * @return {Authenticator} for chaining
	 * @api public
	 */
	Authenticator.prototype.use = function(name, strategy) {
	  if (!strategy) {
	    strategy = name;
	    name = strategy.name;
	  }
	  if (!name) { throw new Error('Authentication strategies must have a name'); }
	  
	  this._strategies[name] = strategy;
	  return this;
	};
	
	/**
	 * Un-utilize the `strategy` with given `name`.
	 *
	 * In typical applications, the necessary authentication strategies are static,
	 * configured once and always available.  As such, there is often no need to
	 * invoke this function.
	 *
	 * However, in certain situations, applications may need dynamically configure
	 * and de-configure authentication strategies.  The `use()`/`unuse()`
	 * combination satisfies these scenarios.
	 *
	 * Examples:
	 *
	 *     passport.unuse('legacy-api');
	 *
	 * @param {String} name
	 * @return {Authenticator} for chaining
	 * @api public
	 */
	Authenticator.prototype.unuse = function(name) {
	  delete this._strategies[name];
	  return this;
	};
	
	/**
	 * Setup Passport to be used under framework.
	 *
	 * By default, Passport exposes middleware that operate using Connect-style
	 * middleware using a `fn(req, res, next)` signature.  Other popular frameworks
	 * have different expectations, and this function allows Passport to be adapted
	 * to operate within such environments.
	 *
	 * If you are using a Connect-compatible framework, including Express, there is
	 * no need to invoke this function.
	 *
	 * Examples:
	 *
	 *     passport.framework(require('hapi-passport')());
	 *
	 * @param {Object} name
	 * @return {Authenticator} for chaining
	 * @api public
	 */
	Authenticator.prototype.framework = function(fw) {
	  this._framework = fw;
	  return this;
	};
	
	/**
	 * Passport's primary initialization middleware.
	 *
	 * This middleware must be in use by the Connect/Express application for
	 * Passport to operate.
	 *
	 * Options:
	 *   - `userProperty`  Property to set on `req` upon login, defaults to _user_
	 *
	 * Examples:
	 *
	 *     app.use(passport.initialize());
	 *
	 *     app.use(passport.initialize({ userProperty: 'currentUser' }));
	 *
	 * @param {Object} options
	 * @return {Function} middleware
	 * @api public
	 */
	Authenticator.prototype.initialize = function(options) {
	  options = options || {};
	  this._userProperty = options.userProperty || 'user';
	  
	  return this._framework.initialize(this, options);
	};
	
	/**
	 * Middleware that will authenticate a request using the given `strategy` name,
	 * with optional `options` and `callback`.
	 *
	 * Examples:
	 *
	 *     passport.authenticate('local', { successRedirect: '/', failureRedirect: '/login' })(req, res);
	 *
	 *     passport.authenticate('local', function(err, user) {
	 *       if (!user) { return res.redirect('/login'); }
	 *       res.end('Authenticated!');
	 *     })(req, res);
	 *
	 *     passport.authenticate('basic', { session: false })(req, res);
	 *
	 *     app.get('/auth/twitter', passport.authenticate('twitter'), function(req, res) {
	 *       // request will be redirected to Twitter
	 *     });
	 *     app.get('/auth/twitter/callback', passport.authenticate('twitter'), function(req, res) {
	 *       res.json(req.user);
	 *     });
	 *
	 * @param {String} strategy
	 * @param {Object} options
	 * @param {Function} callback
	 * @return {Function} middleware
	 * @api public
	 */
	Authenticator.prototype.authenticate = function(strategy, options, callback) {
	  return this._framework.authenticate(this, strategy, options, callback);
	};
	
	/**
	 * Middleware that will authorize a third-party account using the given
	 * `strategy` name, with optional `options`.
	 *
	 * If authorization is successful, the result provided by the strategy's verify
	 * callback will be assigned to `req.account`.  The existing login session and
	 * `req.user` will be unaffected.
	 *
	 * This function is particularly useful when connecting third-party accounts
	 * to the local account of a user that is currently authenticated.
	 *
	 * Examples:
	 *
	 *    passport.authorize('twitter-authz', { failureRedirect: '/account' });
	 *
	 * @param {String} strategy
	 * @param {Object} options
	 * @return {Function} middleware
	 * @api public
	 */
	Authenticator.prototype.authorize = function(strategy, options, callback) {
	  options = options || {};
	  options.assignProperty = 'account';
	  
	  var fn = this._framework.authorize || this._framework.authenticate;
	  return fn(this, strategy, options, callback);
	};
	
	/**
	 * Middleware that will restore login state from a session.
	 *
	 * Web applications typically use sessions to maintain login state between
	 * requests.  For example, a user will authenticate by entering credentials into
	 * a form which is submitted to the server.  If the credentials are valid, a
	 * login session is established by setting a cookie containing a session
	 * identifier in the user's web browser.  The web browser will send this cookie
	 * in subsequent requests to the server, allowing a session to be maintained.
	 *
	 * If sessions are being utilized, and a login session has been established,
	 * this middleware will populate `req.user` with the current user.
	 *
	 * Note that sessions are not strictly required for Passport to operate.
	 * However, as a general rule, most web applications will make use of sessions.
	 * An exception to this rule would be an API server, which expects each HTTP
	 * request to provide credentials in an Authorization header.
	 *
	 * Examples:
	 *
	 *     app.use(connect.cookieParser());
	 *     app.use(connect.session({ secret: 'keyboard cat' }));
	 *     app.use(passport.initialize());
	 *     app.use(passport.session());
	 *
	 * Options:
	 *   - `pauseStream`      Pause the request stream before deserializing the user
	 *                        object from the session.  Defaults to _false_.  Should
	 *                        be set to true in cases where middleware consuming the
	 *                        request body is configured after passport and the
	 *                        deserializeUser method is asynchronous.
	 *
	 * @param {Object} options
	 * @return {Function} middleware
	 * @api public
	 */
	Authenticator.prototype.session = function(options) {
	  return this.authenticate('session', options);
	};
	
	/**
	 * Registers a function used to serialize user objects into the session.
	 *
	 * Examples:
	 *
	 *     passport.serializeUser(function(user, done) {
	 *       done(null, user.id);
	 *     });
	 *
	 * @api public
	 */
	Authenticator.prototype.serializeUser = function(fn, req, done) {
	  if (typeof fn === 'function') {
	    return this._serializers.push(fn);
	  }
	  
	  // private implementation that traverses the chain of serializers, attempting
	  // to serialize a user
	  var user = fn;
	
	  // For backwards compatibility
	  if (typeof req === 'function') {
	    done = req;
	    req = undefined;
	  }
	  
	  var stack = this._serializers;
	  (function pass(i, err, obj) {
	    // serializers use 'pass' as an error to skip processing
	    if ('pass' === err) {
	      err = undefined;
	    }
	    // an error or serialized object was obtained, done
	    if (err || obj || obj === 0) { return done(err, obj); }
	    
	    var layer = stack[i];
	    if (!layer) {
	      return done(new Error('Failed to serialize user into session'));
	    }
	    
	    
	    function serialized(e, o) {
	      pass(i + 1, e, o);
	    }
	    
	    try {
	      var arity = layer.length;
	      if (arity == 3) {
	        layer(req, user, serialized);
	      } else {
	        layer(user, serialized);
	      }
	    } catch(e) {
	      return done(e);
	    }
	  })(0);
	};
	
	/**
	 * Registers a function used to deserialize user objects out of the session.
	 *
	 * Examples:
	 *
	 *     passport.deserializeUser(function(id, done) {
	 *       User.findById(id, function (err, user) {
	 *         done(err, user);
	 *       });
	 *     });
	 *
	 * @api public
	 */
	Authenticator.prototype.deserializeUser = function(fn, req, done) {
	  if (typeof fn === 'function') {
	    return this._deserializers.push(fn);
	  }
	  
	  // private implementation that traverses the chain of deserializers,
	  // attempting to deserialize a user
	  var obj = fn;
	
	  // For backwards compatibility
	  if (typeof req === 'function') {
	    done = req;
	    req = undefined;
	  }
	  
	  var stack = this._deserializers;
	  (function pass(i, err, user) {
	    // deserializers use 'pass' as an error to skip processing
	    if ('pass' === err) {
	      err = undefined;
	    }
	    // an error or deserialized user was obtained, done
	    if (err || user) { return done(err, user); }
	    // a valid user existed when establishing the session, but that user has
	    // since been removed
	    if (user === null || user === false) { return done(null, false); }
	    
	    var layer = stack[i];
	    if (!layer) {
	      return done(new Error('Failed to deserialize user out of session'));
	    }
	    
	    
	    function deserialized(e, u) {
	      pass(i + 1, e, u);
	    }
	    
	    try {
	      var arity = layer.length;
	      if (arity == 3) {
	        layer(req, obj, deserialized);
	      } else {
	        layer(obj, deserialized);
	      }
	    } catch(e) {
	      return done(e);
	    }
	  })(0);
	};
	
	/**
	 * Registers a function used to transform auth info.
	 *
	 * In some circumstances authorization details are contained in authentication
	 * credentials or loaded as part of verification.
	 *
	 * For example, when using bearer tokens for API authentication, the tokens may
	 * encode (either directly or indirectly in a database), details such as scope
	 * of access or the client to which the token was issued.
	 *
	 * Such authorization details should be enforced separately from authentication.
	 * Because Passport deals only with the latter, this is the responsiblity of
	 * middleware or routes further along the chain.  However, it is not optimal to
	 * decode the same data or execute the same database query later.  To avoid
	 * this, Passport accepts optional `info` along with the authenticated `user`
	 * in a strategy's `success()` action.  This info is set at `req.authInfo`,
	 * where said later middlware or routes can access it.
	 *
	 * Optionally, applications can register transforms to proccess this info,
	 * which take effect prior to `req.authInfo` being set.  This is useful, for
	 * example, when the info contains a client ID.  The transform can load the
	 * client from the database and include the instance in the transformed info,
	 * allowing the full set of client properties to be convieniently accessed.
	 *
	 * If no transforms are registered, `info` supplied by the strategy will be left
	 * unmodified.
	 *
	 * Examples:
	 *
	 *     passport.transformAuthInfo(function(info, done) {
	 *       Client.findById(info.clientID, function (err, client) {
	 *         info.client = client;
	 *         done(err, info);
	 *       });
	 *     });
	 *
	 * @api public
	 */
	Authenticator.prototype.transformAuthInfo = function(fn, req, done) {
	  if (typeof fn === 'function') {
	    return this._infoTransformers.push(fn);
	  }
	  
	  // private implementation that traverses the chain of transformers,
	  // attempting to transform auth info
	  var info = fn;
	
	  // For backwards compatibility
	  if (typeof req === 'function') {
	    done = req;
	    req = undefined;
	  }
	  
	  var stack = this._infoTransformers;
	  (function pass(i, err, tinfo) {
	    // transformers use 'pass' as an error to skip processing
	    if ('pass' === err) {
	      err = undefined;
	    }
	    // an error or transformed info was obtained, done
	    if (err || tinfo) { return done(err, tinfo); }
	    
	    var layer = stack[i];
	    if (!layer) {
	      // if no transformers are registered (or they all pass), the default
	      // behavior is to use the un-transformed info as-is
	      return done(null, info);
	    }
	    
	    
	    function transformed(e, t) {
	      pass(i + 1, e, t);
	    }
	    
	    try {
	      var arity = layer.length;
	      if (arity == 1) {
	        // sync
	        var t = layer(info);
	        transformed(null, t);
	      } else if (arity == 3) {
	        layer(req, info, transformed);
	      } else {
	        layer(info, transformed);
	      }
	    } catch(e) {
	      return done(e);
	    }
	  })(0);
	};
	
	/**
	 * Return strategy with given `name`. 
	 *
	 * @param {String} name
	 * @return {Strategy}
	 * @api private
	 */
	Authenticator.prototype._strategy = function(name) {
	  return this._strategies[name];
	};
	
	
	/**
	 * Expose `Authenticator`.
	 */
	module.exports = Authenticator;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var pause = __webpack_require__(217)
	  , util = __webpack_require__(218)
	  , Strategy = __webpack_require__(275);
	
	
	/**
	 * `SessionStrategy` constructor.
	 *
	 * @api public
	 */
	function SessionStrategy() {
	  Strategy.call(this);
	  this.name = 'session';
	}
	
	/**
	 * Inherit from `Strategy`.
	 */
	util.inherits(SessionStrategy, Strategy);
	
	/**
	 * Authenticate request based on the current session state.
	 *
	 * The session authentication strategy uses the session to restore any login
	 * state across requests.  If a login session has been established, `req.user`
	 * will be populated with the current user.
	 *
	 * This strategy is registered automatically by Passport.
	 *
	 * @param {Object} req
	 * @param {Object} options
	 * @api protected
	 */
	SessionStrategy.prototype.authenticate = function(req, options) {
	  if (!req._passport) { return this.error(new Error('passport.initialize() middleware not in use')); }
	  options = options || {};
	
	  var self = this, 
	      su;
	  if (req._passport.session) {
	    su = req._passport.session.user;
	  }
	
	  if (su || su === 0) {
	    // NOTE: Stream pausing is desirable in the case where later middleware is
	    //       listening for events emitted from request.  For discussion on the
	    //       matter, refer to: https://github.com/jaredhanson/passport/pull/106
	    
	    var paused = options.pauseStream ? pause(req) : null;
	    req._passport.instance.deserializeUser(su, req, function(err, user) {
	      if (err) { return self.error(err); }
	      if (!user) {
	        delete req._passport.session.user;
	        self.pass();
	        if (paused) {
	          paused.resume();
	        }
	        return;
	      }
	      var property = req._passport.instance._userProperty || 'user';
	      req[property] = user;
	      self.pass();
	      if (paused) {
	        paused.resume();
	      }
	    });
	  } else {
	    self.pass();
	  }
	};
	
	
	/**
	 * Expose `SessionStrategy`.
	 */
	module.exports = SessionStrategy;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	
	module.exports = function(obj){
	  var onData
	    , onEnd
	    , events = [];
	
	  // buffer data
	  obj.on('data', onData = function(data, encoding){
	    events.push(['data', data, encoding]);
	  });
	
	  // buffer end
	  obj.on('end', onEnd = function(data, encoding){
	    events.push(['end', data, encoding]);
	  });
	
	  return {
	    end: function(){
	      obj.removeListener('data', onData);
	      obj.removeListener('end', onEnd);
	    },
	    resume: function(){
	      this.end();
	      for (var i = 0, len = events.length; i < len; ++i) {
	        obj.emit.apply(obj, events[i]);
	      }
	    }
	  };
	};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
	  function getOwnPropertyDescriptors(obj) {
	    var keys = Object.keys(obj);
	    var descriptors = {};
	    for (var i = 0; i < keys.length; i++) {
	      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
	    }
	    return descriptors;
	  };
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  if (typeof process !== 'undefined' && process.noDeprecation === true) {
	    return fn;
	  }
	
	  // Allow for deprecating things in the process of starting up.
	  if (typeof process === 'undefined') {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnvRegex = /^$/;
	
	if (({"NODE_ENV":"production"}).NODE_DEBUG) {
	  var debugEnv = ({"NODE_ENV":"production"}).NODE_DEBUG;
	  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
	    .replace(/\*/g, '.*')
	    .replace(/,/g, '$|^')
	    .toUpperCase();
	  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
	}
	exports.debuglog = function(set) {
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (debugEnvRegex.test(set)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').slice(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.slice(1, -1);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	exports.types = __webpack_require__(220);
	
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	exports.types.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	exports.types.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	exports.types.isNativeError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(273);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(274);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
	
	exports.promisify = function promisify(original) {
	  if (typeof original !== 'function')
	    throw new TypeError('The "original" argument must be of type Function');
	
	  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
	    var fn = original[kCustomPromisifiedSymbol];
	    if (typeof fn !== 'function') {
	      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
	    }
	    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	      value: fn, enumerable: false, writable: false, configurable: true
	    });
	    return fn;
	  }
	
	  function fn() {
	    var promiseResolve, promiseReject;
	    var promise = new Promise(function (resolve, reject) {
	      promiseResolve = resolve;
	      promiseReject = reject;
	    });
	
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	    args.push(function (err, value) {
	      if (err) {
	        promiseReject(err);
	      } else {
	        promiseResolve(value);
	      }
	    });
	
	    try {
	      original.apply(this, args);
	    } catch (err) {
	      promiseReject(err);
	    }
	
	    return promise;
	  }
	
	  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
	
	  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	    value: fn, enumerable: false, writable: false, configurable: true
	  });
	  return Object.defineProperties(
	    fn,
	    getOwnPropertyDescriptors(original)
	  );
	}
	
	exports.promisify.custom = kCustomPromisifiedSymbol
	
	function callbackifyOnRejected(reason, cb) {
	  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
	  // Because `null` is a special error value in callbacks which means "no error
	  // occurred", we error-wrap so the callback consumer can distinguish between
	  // "the promise rejected with null" or "the promise fulfilled with undefined".
	  if (!reason) {
	    var newReason = new Error('Promise was rejected with a falsy value');
	    newReason.reason = reason;
	    reason = newReason;
	  }
	  return cb(reason);
	}
	
	function callbackify(original) {
	  if (typeof original !== 'function') {
	    throw new TypeError('The "original" argument must be of type Function');
	  }
	
	  // We DO NOT return the promise as it gives the user a false sense that
	  // the promise is actually somehow related to the callback's execution
	  // and that the callback throwing will reject the promise.
	  function callbackified() {
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	
	    var maybeCb = args.pop();
	    if (typeof maybeCb !== 'function') {
	      throw new TypeError('The last argument must be of type Function');
	    }
	    var self = this;
	    var cb = function() {
	      return maybeCb.apply(self, arguments);
	    };
	    // In true node style we process the callback on `nextTick` with all the
	    // implications (stack, `uncaughtException`, `async_hooks`)
	    original.apply(this, args)
	      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
	            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
	  }
	
	  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
	  Object.defineProperties(callbackified,
	                          getOwnPropertyDescriptors(original));
	  return callbackified;
	}
	exports.callbackify = callbackify;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(219)))

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	// Currently in sync with Node.js lib/internal/util/types.js
	// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
	
	'use strict';
	
	var isArgumentsObject = __webpack_require__(221);
	var isGeneratorFunction = __webpack_require__(258);
	var whichTypedArray = __webpack_require__(262);
	var isTypedArray = __webpack_require__(272);
	
	function uncurryThis(f) {
	  return f.call.bind(f);
	}
	
	var BigIntSupported = typeof BigInt !== 'undefined';
	var SymbolSupported = typeof Symbol !== 'undefined';
	
	var ObjectToString = uncurryThis(Object.prototype.toString);
	
	var numberValue = uncurryThis(Number.prototype.valueOf);
	var stringValue = uncurryThis(String.prototype.valueOf);
	var booleanValue = uncurryThis(Boolean.prototype.valueOf);
	
	if (BigIntSupported) {
	  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
	}
	
	if (SymbolSupported) {
	  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
	}
	
	function checkBoxedPrimitive(value, prototypeValueOf) {
	  if (typeof value !== 'object') {
	    return false;
	  }
	  try {
	    prototypeValueOf(value);
	    return true;
	  } catch(e) {
	    return false;
	  }
	}
	
	exports.isArgumentsObject = isArgumentsObject;
	exports.isGeneratorFunction = isGeneratorFunction;
	exports.isTypedArray = isTypedArray;
	
	// Taken from here and modified for better browser support
	// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
	function isPromise(input) {
		return (
			(
				typeof Promise !== 'undefined' &&
				input instanceof Promise
			) ||
			(
				input !== null &&
				typeof input === 'object' &&
				typeof input.then === 'function' &&
				typeof input.catch === 'function'
			)
		);
	}
	exports.isPromise = isPromise;
	
	function isArrayBufferView(value) {
	  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
	    return ArrayBuffer.isView(value);
	  }
	
	  return (
	    isTypedArray(value) ||
	    isDataView(value)
	  );
	}
	exports.isArrayBufferView = isArrayBufferView;
	
	
	function isUint8Array(value) {
	  return whichTypedArray(value) === 'Uint8Array';
	}
	exports.isUint8Array = isUint8Array;
	
	function isUint8ClampedArray(value) {
	  return whichTypedArray(value) === 'Uint8ClampedArray';
	}
	exports.isUint8ClampedArray = isUint8ClampedArray;
	
	function isUint16Array(value) {
	  return whichTypedArray(value) === 'Uint16Array';
	}
	exports.isUint16Array = isUint16Array;
	
	function isUint32Array(value) {
	  return whichTypedArray(value) === 'Uint32Array';
	}
	exports.isUint32Array = isUint32Array;
	
	function isInt8Array(value) {
	  return whichTypedArray(value) === 'Int8Array';
	}
	exports.isInt8Array = isInt8Array;
	
	function isInt16Array(value) {
	  return whichTypedArray(value) === 'Int16Array';
	}
	exports.isInt16Array = isInt16Array;
	
	function isInt32Array(value) {
	  return whichTypedArray(value) === 'Int32Array';
	}
	exports.isInt32Array = isInt32Array;
	
	function isFloat32Array(value) {
	  return whichTypedArray(value) === 'Float32Array';
	}
	exports.isFloat32Array = isFloat32Array;
	
	function isFloat64Array(value) {
	  return whichTypedArray(value) === 'Float64Array';
	}
	exports.isFloat64Array = isFloat64Array;
	
	function isBigInt64Array(value) {
	  return whichTypedArray(value) === 'BigInt64Array';
	}
	exports.isBigInt64Array = isBigInt64Array;
	
	function isBigUint64Array(value) {
	  return whichTypedArray(value) === 'BigUint64Array';
	}
	exports.isBigUint64Array = isBigUint64Array;
	
	function isMapToString(value) {
	  return ObjectToString(value) === '[object Map]';
	}
	isMapToString.working = (
	  typeof Map !== 'undefined' &&
	  isMapToString(new Map())
	);
	
	function isMap(value) {
	  if (typeof Map === 'undefined') {
	    return false;
	  }
	
	  return isMapToString.working
	    ? isMapToString(value)
	    : value instanceof Map;
	}
	exports.isMap = isMap;
	
	function isSetToString(value) {
	  return ObjectToString(value) === '[object Set]';
	}
	isSetToString.working = (
	  typeof Set !== 'undefined' &&
	  isSetToString(new Set())
	);
	function isSet(value) {
	  if (typeof Set === 'undefined') {
	    return false;
	  }
	
	  return isSetToString.working
	    ? isSetToString(value)
	    : value instanceof Set;
	}
	exports.isSet = isSet;
	
	function isWeakMapToString(value) {
	  return ObjectToString(value) === '[object WeakMap]';
	}
	isWeakMapToString.working = (
	  typeof WeakMap !== 'undefined' &&
	  isWeakMapToString(new WeakMap())
	);
	function isWeakMap(value) {
	  if (typeof WeakMap === 'undefined') {
	    return false;
	  }
	
	  return isWeakMapToString.working
	    ? isWeakMapToString(value)
	    : value instanceof WeakMap;
	}
	exports.isWeakMap = isWeakMap;
	
	function isWeakSetToString(value) {
	  return ObjectToString(value) === '[object WeakSet]';
	}
	isWeakSetToString.working = (
	  typeof WeakSet !== 'undefined' &&
	  isWeakSetToString(new WeakSet())
	);
	function isWeakSet(value) {
	  return isWeakSetToString(value);
	}
	exports.isWeakSet = isWeakSet;
	
	function isArrayBufferToString(value) {
	  return ObjectToString(value) === '[object ArrayBuffer]';
	}
	isArrayBufferToString.working = (
	  typeof ArrayBuffer !== 'undefined' &&
	  isArrayBufferToString(new ArrayBuffer())
	);
	function isArrayBuffer(value) {
	  if (typeof ArrayBuffer === 'undefined') {
	    return false;
	  }
	
	  return isArrayBufferToString.working
	    ? isArrayBufferToString(value)
	    : value instanceof ArrayBuffer;
	}
	exports.isArrayBuffer = isArrayBuffer;
	
	function isDataViewToString(value) {
	  return ObjectToString(value) === '[object DataView]';
	}
	isDataViewToString.working = (
	  typeof ArrayBuffer !== 'undefined' &&
	  typeof DataView !== 'undefined' &&
	  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
	);
	function isDataView(value) {
	  if (typeof DataView === 'undefined') {
	    return false;
	  }
	
	  return isDataViewToString.working
	    ? isDataViewToString(value)
	    : value instanceof DataView;
	}
	exports.isDataView = isDataView;
	
	// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
	var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
	function isSharedArrayBufferToString(value) {
	  return ObjectToString(value) === '[object SharedArrayBuffer]';
	}
	function isSharedArrayBuffer(value) {
	  if (typeof SharedArrayBufferCopy === 'undefined') {
	    return false;
	  }
	
	  if (typeof isSharedArrayBufferToString.working === 'undefined') {
	    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
	  }
	
	  return isSharedArrayBufferToString.working
	    ? isSharedArrayBufferToString(value)
	    : value instanceof SharedArrayBufferCopy;
	}
	exports.isSharedArrayBuffer = isSharedArrayBuffer;
	
	function isAsyncFunction(value) {
	  return ObjectToString(value) === '[object AsyncFunction]';
	}
	exports.isAsyncFunction = isAsyncFunction;
	
	function isMapIterator(value) {
	  return ObjectToString(value) === '[object Map Iterator]';
	}
	exports.isMapIterator = isMapIterator;
	
	function isSetIterator(value) {
	  return ObjectToString(value) === '[object Set Iterator]';
	}
	exports.isSetIterator = isSetIterator;
	
	function isGeneratorObject(value) {
	  return ObjectToString(value) === '[object Generator]';
	}
	exports.isGeneratorObject = isGeneratorObject;
	
	function isWebAssemblyCompiledModule(value) {
	  return ObjectToString(value) === '[object WebAssembly.Module]';
	}
	exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
	
	function isNumberObject(value) {
	  return checkBoxedPrimitive(value, numberValue);
	}
	exports.isNumberObject = isNumberObject;
	
	function isStringObject(value) {
	  return checkBoxedPrimitive(value, stringValue);
	}
	exports.isStringObject = isStringObject;
	
	function isBooleanObject(value) {
	  return checkBoxedPrimitive(value, booleanValue);
	}
	exports.isBooleanObject = isBooleanObject;
	
	function isBigIntObject(value) {
	  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
	}
	exports.isBigIntObject = isBigIntObject;
	
	function isSymbolObject(value) {
	  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
	}
	exports.isSymbolObject = isSymbolObject;
	
	function isBoxedPrimitive(value) {
	  return (
	    isNumberObject(value) ||
	    isStringObject(value) ||
	    isBooleanObject(value) ||
	    isBigIntObject(value) ||
	    isSymbolObject(value)
	  );
	}
	exports.isBoxedPrimitive = isBoxedPrimitive;
	
	function isAnyArrayBuffer(value) {
	  return typeof Uint8Array !== 'undefined' && (
	    isArrayBuffer(value) ||
	    isSharedArrayBuffer(value)
	  );
	}
	exports.isAnyArrayBuffer = isAnyArrayBuffer;
	
	['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
	  Object.defineProperty(exports, method, {
	    enumerable: false,
	    value: function() {
	      throw new Error(method + ' is not supported in userland');
	    }
	  });
	});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(222)();
	var callBound = __webpack_require__(224);
	
	var $toString = callBound('Object.prototype.toString');
	
	/** @type {import('.')} */
	var isStandardArguments = function isArguments(value) {
		if (
			hasToStringTag
			&& value
			&& typeof value === 'object'
			&& Symbol.toStringTag in value
		) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	/** @type {import('.')} */
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null
			&& typeof value === 'object'
			&& 'length' in value
			&& typeof value.length === 'number'
			&& value.length >= 0
			&& $toString(value) !== '[object Array]'
			&& 'callee' in value
			&& $toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	// @ts-expect-error TODO make this not error
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	/** @type {import('.')} */
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(223);
	
	/** @type {import('.')} */
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./shams')} */
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		/** @type {{ [k in symbol]?: unknown }} */
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(225);
	
	var callBindBasic = __webpack_require__(250);
	
	/** @type {(thisArg: string, searchString: string, position?: number) => number} */
	var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);
	
	/** @type {import('.')} */
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		/* eslint no-extra-parens: 0 */
	
		var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBindBasic(/** @type {const} */ ([intrinsic]));
		}
		return intrinsic;
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Object = __webpack_require__(226);
	
	var $Error = __webpack_require__(227);
	var $EvalError = __webpack_require__(228);
	var $RangeError = __webpack_require__(229);
	var $ReferenceError = __webpack_require__(230);
	var $SyntaxError = __webpack_require__(231);
	var $TypeError = __webpack_require__(232);
	var $URIError = __webpack_require__(233);
	
	var abs = __webpack_require__(234);
	var floor = __webpack_require__(235);
	var max = __webpack_require__(236);
	var min = __webpack_require__(237);
	var pow = __webpack_require__(238);
	var round = __webpack_require__(239);
	var sign = __webpack_require__(240);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = __webpack_require__(242);
	var $defineProperty = __webpack_require__(244);
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(245)();
	
	var getProto = __webpack_require__(246);
	var $ObjectGPO = __webpack_require__(248);
	var $ReflectGPO = __webpack_require__(247);
	
	var $apply = __webpack_require__(255);
	var $call = __webpack_require__(253);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': $Object,
		'%Object.getOwnPropertyDescriptor%': $gOPD,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	
		'%Function.prototype.call%': $call,
		'%Function.prototype.apply%': $apply,
		'%Object.defineProperty%': $defineProperty,
		'%Object.getPrototypeOf%': $ObjectGPO,
		'%Math.abs%': abs,
		'%Math.floor%': floor,
		'%Math.max%': max,
		'%Math.min%': min,
		'%Math.pow%': pow,
		'%Math.round%': round,
		'%Math.sign%': sign,
		'%Reflect.getPrototypeOf%': $ReflectGPO
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(251);
	var hasOwn = __webpack_require__(257);
	var $concat = bind.call($call, Array.prototype.concat);
	var $spliceApply = bind.call($apply, Array.prototype.splice);
	var $replace = bind.call($call, String.prototype.replace);
	var $strSlice = bind.call($call, String.prototype.slice);
	var $exec = bind.call($call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Object;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ }),
/* 232 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./abs')} */
	module.exports = Math.abs;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./floor')} */
	module.exports = Math.floor;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./max')} */
	module.exports = Math.max;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./min')} */
	module.exports = Math.min;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./pow')} */
	module.exports = Math.pow;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./round')} */
	module.exports = Math.round;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(241);
	
	/** @type {import('./sign')} */
	module.exports = function sign(number) {
		if ($isNaN(number) || number === 0) {
			return number;
		}
		return number < 0 ? -1 : +1;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./isNaN')} */
	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/** @type {import('.')} */
	var $gOPD = __webpack_require__(243);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ }),
/* 243 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./gOPD')} */
	module.exports = Object.getOwnPropertyDescriptor;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	var $defineProperty = Object.defineProperty || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(223);
	
	/** @type {import('.')} */
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reflectGetProto = __webpack_require__(247);
	var originalGetProto = __webpack_require__(248);
	
	var getDunderProto = __webpack_require__(249);
	
	/** @type {import('.')} */
	module.exports = reflectGetProto
		? function getProto(O) {
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return reflectGetProto(O);
		}
		: originalGetProto
			? function getProto(O) {
				if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
					throw new TypeError('getProto: not an object');
				}
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return originalGetProto(O);
			}
			: getDunderProto
				? function getProto(O) {
					// @ts-expect-error TS can't narrow inside a closure, for some reason
					return getDunderProto(O);
				}
				: null;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./Reflect.getPrototypeOf')} */
	module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $Object = __webpack_require__(226);
	
	/** @type {import('./Object.getPrototypeOf')} */
	module.exports = $Object.getPrototypeOf || null;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBind = __webpack_require__(250);
	var gOPD = __webpack_require__(242);
	
	var hasProtoAccessor;
	try {
		// eslint-disable-next-line no-extra-parens, no-proto
		hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
			throw e;
		}
	}
	
	// eslint-disable-next-line no-extra-parens
	var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));
	
	var $Object = Object;
	var $getPrototypeOf = $Object.getPrototypeOf;
	
	/** @type {import('./get')} */
	module.exports = desc && typeof desc.get === 'function'
		? callBind([desc.get])
		: typeof $getPrototypeOf === 'function'
			? /** @type {import('./get')} */ function getDunder(value) {
				// eslint-disable-next-line eqeqeq
				return $getPrototypeOf(value == null ? value : $Object(value));
			}
			: false;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(251);
	var $TypeError = __webpack_require__(232);
	
	var $call = __webpack_require__(253);
	var $actualApply = __webpack_require__(254);
	
	/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
	module.exports = function callBindBasic(args) {
		if (args.length < 1 || typeof args[0] !== 'function') {
			throw new $TypeError('a function is required');
		}
		return $actualApply(bind, $call, args);
	};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(252);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./functionCall')} */
	module.exports = Function.prototype.call;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(251);
	
	var $apply = __webpack_require__(255);
	var $call = __webpack_require__(253);
	var $reflectApply = __webpack_require__(256);
	
	/** @type {import('./actualApply')} */
	module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./functionApply')} */
	module.exports = Function.prototype.apply;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./reflectApply')} */
	module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(251);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(224);
	var safeRegexTest = __webpack_require__(259);
	var isFnRegex = safeRegexTest(/^\s*(?:function)?\*/);
	var hasToStringTag = __webpack_require__(222)();
	var getProto = __webpack_require__(246);
	
	var toStr = callBound('Object.prototype.toString');
	var fnToStr = callBound('Function.prototype.toString');
	
	var getGeneratorFunction = __webpack_require__(261);
	
	/** @type {import('.')} */
	module.exports = function isGeneratorFunction(fn) {
		if (typeof fn !== 'function') {
			return false;
		}
		if (isFnRegex(fnToStr(fn))) {
			return true;
		}
		if (!hasToStringTag) {
			var str = toStr(fn);
			return str === '[object GeneratorFunction]';
		}
		if (!getProto) {
			return false;
		}
		var GeneratorFunction = getGeneratorFunction();
		return GeneratorFunction && getProto(fn) === GeneratorFunction.prototype;
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(224);
	var isRegex = __webpack_require__(260);
	
	var $exec = callBound('RegExp.prototype.exec');
	var $TypeError = __webpack_require__(232);
	
	/** @type {import('.')} */
	module.exports = function regexTester(regex) {
		if (!isRegex(regex)) {
			throw new $TypeError('`regex` must be a RegExp');
		}
		return function test(s) {
			return $exec(regex, s) !== null;
		};
	};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(224);
	var hasToStringTag = __webpack_require__(222)();
	var hasOwn = __webpack_require__(257);
	var gOPD = __webpack_require__(242);
	
	/** @type {import('.')} */
	var fn;
	
	if (hasToStringTag) {
		/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
		var $exec = callBound('RegExp.prototype.exec');
		/** @type {object} */
		var isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
		var badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	
		/** @type {import('.')} */
		// @ts-expect-error TS can't figure out that the $exec call always throws
		// eslint-disable-next-line consistent-return
		fn = function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {NonNullable<typeof gOPD>} */ (gOPD)(/** @type {{ lastIndex?: unknown }} */ (value), 'lastIndex');
			var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				// eslint-disable-next-line no-extra-parens
				$exec(value, /** @type {string} */ (/** @type {unknown} */ (badStringifier)));
			} catch (e) {
				return e === isRegexMarker;
			}
		};
	} else {
		/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
		var $toString = callBound('Object.prototype.toString');
		/** @const @type {'[object RegExp]'} */
		var regexClass = '[object RegExp]';
	
		/** @type {import('.')} */
		fn = function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};
	}
	
	module.exports = fn;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {GeneratorFunctionConstructor | false} */
	var cached;
	
	/** @type {import('./index.js')} */
	module.exports = function getGeneratorFunction() {
		if (typeof cached === 'undefined') {
			try {
				// eslint-disable-next-line no-new-func
				cached = Function('return function* () {}')().constructor;
			} catch (e) {
				cached = false;
			}
		}
		return cached;
	};
	


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var forEach = __webpack_require__(263);
	var availableTypedArrays = __webpack_require__(265);
	var callBind = __webpack_require__(267);
	var callBound = __webpack_require__(224);
	var gOPD = __webpack_require__(242);
	var getProto = __webpack_require__(246);
	
	var $toString = callBound('Object.prototype.toString');
	var hasToStringTag = __webpack_require__(222)();
	
	var g = typeof globalThis === 'undefined' ? global : globalThis;
	var typedArrays = availableTypedArrays();
	
	var $slice = callBound('String.prototype.slice');
	
	/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */
	var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
		for (var i = 0; i < array.length; i += 1) {
			if (array[i] === value) {
				return i;
			}
		}
		return -1;
	};
	
	/** @typedef {import('./types').Getter} Getter */
	/** @type {import('./types').Cache} */
	var cache = { __proto__: null };
	if (hasToStringTag && gOPD && getProto) {
		forEach(typedArrays, function (typedArray) {
			var arr = new g[typedArray]();
			if (Symbol.toStringTag in arr && getProto) {
				var proto = getProto(arr);
				// @ts-expect-error TS won't narrow inside a closure
				var descriptor = gOPD(proto, Symbol.toStringTag);
				if (!descriptor && proto) {
					var superProto = getProto(proto);
					// @ts-expect-error TS won't narrow inside a closure
					descriptor = gOPD(superProto, Symbol.toStringTag);
				}
				if (descriptor && descriptor.get) {
					var bound = callBind(descriptor.get);
					cache[
						/** @type {`$${import('.').TypedArrayName}`} */ ('$' + typedArray)
					] = bound;
				}
			}
		});
	} else {
		forEach(typedArrays, function (typedArray) {
			var arr = new g[typedArray]();
			var fn = arr.slice || arr.set;
			if (fn) {
				var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ (
					// @ts-expect-error TODO FIXME
					callBind(fn)
				);
				cache[
					/** @type {`$${import('.').TypedArrayName}`} */ ('$' + typedArray)
				] = bound;
			}
		});
	}
	
	/** @type {(value: object) => false | import('.').TypedArrayName} */
	var tryTypedArrays = function tryAllTypedArrays(value) {
		/** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
		forEach(
			/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ (cache),
			/** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
			function (getter, typedArray) {
				if (!found) {
					try {
						// @ts-expect-error a throw is fine here
						if ('$' + getter(value) === typedArray) {
							found = /** @type {import('.').TypedArrayName} */ ($slice(typedArray, 1));
						}
					} catch (e) { /**/ }
				}
			}
		);
		return found;
	};
	
	/** @type {(value: object) => false | import('.').TypedArrayName} */
	var trySlices = function tryAllSlices(value) {
		/** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
		forEach(
			/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */(cache),
			/** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function (getter, name) {
				if (!found) {
					try {
						// @ts-expect-error a throw is fine here
						getter(value);
						found = /** @type {import('.').TypedArrayName} */ ($slice(name, 1));
					} catch (e) { /**/ }
				}
			}
		);
		return found;
	};
	
	/** @type {import('.')} */
	module.exports = function whichTypedArray(value) {
		if (!value || typeof value !== 'object') { return false; }
		if (!hasToStringTag) {
			/** @type {string} */
			var tag = $slice($toString(value), 8, -1);
			if ($indexOf(typedArrays, tag) > -1) {
				return tag;
			}
			if (tag !== 'Object') {
				return false;
			}
			// node < 0.6 hits here on real Typed Arrays
			return trySlices(value);
		}
		if (!gOPD) { return null; } // unknown engine
		return tryTypedArrays(value);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isCallable = __webpack_require__(264);
	
	var toStr = Object.prototype.toString;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */
	var forEachArray = function forEachArray(array, iterator, receiver) {
	    for (var i = 0, len = array.length; i < len; i++) {
	        if (hasOwnProperty.call(array, i)) {
	            if (receiver == null) {
	                iterator(array[i], i, array);
	            } else {
	                iterator.call(receiver, array[i], i, array);
	            }
	        }
	    }
	};
	
	/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */
	var forEachString = function forEachString(string, iterator, receiver) {
	    for (var i = 0, len = string.length; i < len; i++) {
	        // no such thing as a sparse string.
	        if (receiver == null) {
	            iterator(string.charAt(i), i, string);
	        } else {
	            iterator.call(receiver, string.charAt(i), i, string);
	        }
	    }
	};
	
	/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */
	var forEachObject = function forEachObject(object, iterator, receiver) {
	    for (var k in object) {
	        if (hasOwnProperty.call(object, k)) {
	            if (receiver == null) {
	                iterator(object[k], k, object);
	            } else {
	                iterator.call(receiver, object[k], k, object);
	            }
	        }
	    }
	};
	
	/** @type {(x: unknown) => x is readonly unknown[]} */
	function isArray(x) {
	    return toStr.call(x) === '[object Array]';
	}
	
	/** @type {import('.')._internal} */
	module.exports = function forEach(list, iterator, thisArg) {
	    if (!isCallable(iterator)) {
	        throw new TypeError('iterator must be a function');
	    }
	
	    var receiver;
	    if (arguments.length >= 3) {
	        receiver = thisArg;
	    }
	
	    if (isArray(list)) {
	        forEachArray(list, iterator, receiver);
	    } else if (typeof list === 'string') {
	        forEachString(list, iterator, receiver);
	    } else {
	        forEachObject(list, iterator, receiver);
	    }
	};


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
	var badArrayLike;
	var isCallableMarker;
	if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
		try {
			badArrayLike = Object.defineProperty({}, 'length', {
				get: function () {
					throw isCallableMarker;
				}
			});
			isCallableMarker = {};
			// eslint-disable-next-line no-throw-literal
			reflectApply(function () { throw 42; }, null, badArrayLike);
		} catch (_) {
			if (_ !== isCallableMarker) {
				reflectApply = null;
			}
		}
	} else {
		reflectApply = null;
	}
	
	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var objectClass = '[object Object]';
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var ddaClass = '[object HTMLAllCollection]'; // IE 11
	var ddaClass2 = '[object HTML document.all class]';
	var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
	var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
	
	var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing
	
	var isDDA = function isDocumentDotAll() { return false; };
	if (typeof document === 'object') {
		// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
		var all = document.all;
		if (toStr.call(all) === toStr.call(document.all)) {
			isDDA = function isDocumentDotAll(value) {
				/* globals document: false */
				// in IE 6-8, typeof document.all is "object" and it's truthy
				if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
					try {
						var str = toStr.call(value);
						return (
							str === ddaClass
							|| str === ddaClass2
							|| str === ddaClass3 // opera 12.16
							|| str === objectClass // IE 6-8
						) && value('') == null; // eslint-disable-line eqeqeq
					} catch (e) { /**/ }
				}
				return false;
			};
		}
	}
	
	module.exports = reflectApply
		? function isCallable(value) {
			if (isDDA(value)) { return true; }
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			try {
				reflectApply(value, null, badArrayLike);
			} catch (e) {
				if (e !== isCallableMarker) { return false; }
			}
			return !isES6ClassFn(value) && tryFunctionObject(value);
		}
		: function isCallable(value) {
			if (isDDA(value)) { return true; }
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			if (hasToStringTag) { return tryFunctionObject(value); }
			if (isES6ClassFn(value)) { return false; }
			var strClass = toStr.call(value);
			if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
			return tryFunctionObject(value);
		};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var possibleNames = __webpack_require__(266);
	
	var g = typeof globalThis === 'undefined' ? global : globalThis;
	
	/** @type {import('.')} */
	module.exports = function availableTypedArrays() {
		var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
		for (var i = 0; i < possibleNames.length; i++) {
			if (typeof g[possibleNames[i]] === 'function') {
				// @ts-expect-error
				out[out.length] = possibleNames[i];
			}
		}
		return out;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = [
		'Float16Array',
		'Float32Array',
		'Float64Array',
		'Int8Array',
		'Int16Array',
		'Int32Array',
		'Uint8Array',
		'Uint8ClampedArray',
		'Uint16Array',
		'Uint32Array',
		'BigInt64Array',
		'BigUint64Array'
	];


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionLength = __webpack_require__(268);
	
	var $defineProperty = __webpack_require__(244);
	
	var callBindBasic = __webpack_require__(250);
	var applyBind = __webpack_require__(271);
	
	module.exports = function callBind(originalFunction) {
		var func = callBindBasic(arguments);
		var adjustedLength = originalFunction.length - (arguments.length - 1);
		return setFunctionLength(
			func,
			1 + (adjustedLength > 0 ? adjustedLength : 0),
			true
		);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(225);
	var define = __webpack_require__(269);
	var hasDescriptors = __webpack_require__(270)();
	var gOPD = __webpack_require__(242);
	
	var $TypeError = __webpack_require__(232);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(244);
	
	var $SyntaxError = __webpack_require__(231);
	var $TypeError = __webpack_require__(232);
	
	var gopd = __webpack_require__(242);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(244);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(251);
	var $apply = __webpack_require__(255);
	var actualApply = __webpack_require__(254);
	
	/** @type {import('./applyBind')} */
	module.exports = function applyBind() {
		return actualApply(bind, $apply, arguments);
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whichTypedArray = __webpack_require__(262);
	
	/** @type {import('.')} */
	module.exports = function isTypedArray(value) {
		return !!whichTypedArray(value);
	};


/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var Strategy = __webpack_require__(276);
	
	
	/**
	 * Expose `Strategy` directly from package.
	 */
	exports = module.exports = Strategy;
	
	/**
	 * Export constructors.
	 */
	exports.Strategy = Strategy;


/***/ }),
/* 276 */
/***/ (function(module, exports) {

	/**
	 * Creates an instance of `Strategy`.
	 *
	 * @constructor
	 * @api public
	 */
	function Strategy() {
	}
	
	/**
	 * Authenticate request.
	 *
	 * This function must be overridden by subclasses.  In abstract form, it always
	 * throws an exception.
	 *
	 * @param {Object} req The request to authenticate.
	 * @param {Object} [options] Strategy-specific options.
	 * @api public
	 */
	Strategy.prototype.authenticate = function(req, options) {
	  throw new Error('Strategy#authenticate must be overridden by subclass');
	};
	
	
	/**
	 * Expose `Strategy`.
	 */
	module.exports = Strategy;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var initialize = __webpack_require__(278)
	  , authenticate = __webpack_require__(279);
	  
	/**
	 * Framework support for Connect/Express.
	 *
	 * This module provides support for using Passport with Express.  It exposes
	 * middleware that conform to the `fn(req, res, next)` signature and extends
	 * Node's built-in HTTP request object with useful authentication-related
	 * functions.
	 *
	 * @return {Object}
	 * @api protected
	 */
	exports = module.exports = function() {
	  
	  // HTTP extensions.
	  exports.__monkeypatchNode();
	  
	  return {
	    initialize: initialize,
	    authenticate: authenticate
	  };
	};
	
	exports.__monkeypatchNode = function() {
	  var http = __webpack_require__(280);
	  var IncomingMessageExt = __webpack_require__(313);
	  
	  http.IncomingMessage.prototype.login =
	  http.IncomingMessage.prototype.logIn = IncomingMessageExt.logIn;
	  http.IncomingMessage.prototype.logout =
	  http.IncomingMessage.prototype.logOut = IncomingMessageExt.logOut;
	  http.IncomingMessage.prototype.isAuthenticated = IncomingMessageExt.isAuthenticated;
	  http.IncomingMessage.prototype.isUnauthenticated = IncomingMessageExt.isUnauthenticated;
	};


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	/**
	 * Passport initialization.
	 *
	 * Intializes Passport for incoming requests, allowing authentication strategies
	 * to be applied.
	 *
	 * If sessions are being utilized, applications must set up Passport with
	 * functions to serialize a user into and out of a session.  For example, a
	 * common pattern is to serialize just the user ID into the session (due to the
	 * fact that it is desirable to store the minimum amount of data in a session).
	 * When a subsequent request arrives for the session, the full User object can
	 * be loaded from the database by ID.
	 *
	 * Note that additional middleware is required to persist login state, so we
	 * must use the `connect.session()` middleware _before_ `passport.initialize()`.
	 *
	 * If sessions are being used, this middleware must be in use by the
	 * Connect/Express application for Passport to operate.  If the application is
	 * entirely stateless (not using sessions), this middleware is not necessary,
	 * but its use will not have any adverse impact.
	 *
	 * Examples:
	 *
	 *     app.use(connect.cookieParser());
	 *     app.use(connect.session({ secret: 'keyboard cat' }));
	 *     app.use(passport.initialize());
	 *     app.use(passport.session());
	 *
	 *     passport.serializeUser(function(user, done) {
	 *       done(null, user.id);
	 *     });
	 *
	 *     passport.deserializeUser(function(id, done) {
	 *       User.findById(id, function (err, user) {
	 *         done(err, user);
	 *       });
	 *     });
	 *
	 * @return {Function}
	 * @api public
	 */
	module.exports = function initialize(passport) {
	  
	  return function initialize(req, res, next) {
	    req._passport = {};
	    req._passport.instance = passport;
	
	    if (req.session && req.session[passport._key]) {
	      // load data from existing session
	      req._passport.session = req.session[passport._key];
	    }
	
	    next();
	  };
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var http = __webpack_require__(280)
	  , IncomingMessageExt = __webpack_require__(313)
	  , AuthenticationError = __webpack_require__(314);
	
	
	/**
	 * Authenticates requests.
	 *
	 * Applies the `name`ed strategy (or strategies) to the incoming request, in
	 * order to authenticate the request.  If authentication is successful, the user
	 * will be logged in and populated at `req.user` and a session will be
	 * established by default.  If authentication fails, an unauthorized response
	 * will be sent.
	 *
	 * Options:
	 *   - `session`          Save login state in session, defaults to _true_
	 *   - `successRedirect`  After successful login, redirect to given URL
	 *   - `failureRedirect`  After failed login, redirect to given URL
	 *   - `assignProperty`   Assign the object provided by the verify callback to given property
	 *
	 * An optional `callback` can be supplied to allow the application to overrride
	 * the default manner in which authentication attempts are handled.  The
	 * callback has the following signature, where `user` will be set to the
	 * authenticated user on a successful authentication attempt, or `false`
	 * otherwise.  An optional `info` argument will be passed, containing additional
	 * details provided by the strategy's verify callback.
	 *
	 *     app.get('/protected', function(req, res, next) {
	 *       passport.authenticate('local', function(err, user, info) {
	 *         if (err) { return next(err) }
	 *         if (!user) { return res.redirect('/signin') }
	 *         res.redirect('/account');
	 *       })(req, res, next);
	 *     });
	 *
	 * Note that if a callback is supplied, it becomes the application's
	 * responsibility to log-in the user, establish a session, and otherwise perform
	 * the desired operations.
	 *
	 * Examples:
	 *
	 *     passport.authenticate('local', { successRedirect: '/', failureRedirect: '/login' });
	 *
	 *     passport.authenticate('basic', { session: false });
	 *
	 *     passport.authenticate('twitter');
	 *
	 * @param {String|Array} name
	 * @param {Object} options
	 * @param {Function} callback
	 * @return {Function}
	 * @api public
	 */
	module.exports = function authenticate(passport, name, options, callback) {
	  if (typeof options == 'function') {
	    callback = options;
	    options = {};
	  }
	  options = options || {};
	  
	  var multi = true;
	  
	  // Cast `name` to an array, allowing authentication to pass through a chain of
	  // strategies.  The first strategy to succeed, redirect, or error will halt
	  // the chain.  Authentication failures will proceed through each strategy in
	  // series, ultimately failing if all strategies fail.
	  //
	  // This is typically used on API endpoints to allow clients to authenticate
	  // using their preferred choice of Basic, Digest, token-based schemes, etc.
	  // It is not feasible to construct a chain of multiple strategies that involve
	  // redirection (for example both Facebook and Twitter), since the first one to
	  // redirect will halt the chain.
	  if (!Array.isArray(name)) {
	    name = [ name ];
	    multi = false;
	  }
	  
	  return function authenticate(req, res, next) {
	    if (http.IncomingMessage.prototype.logIn
	        && http.IncomingMessage.prototype.logIn !== IncomingMessageExt.logIn) {
	      __webpack_require__(277).__monkeypatchNode();
	    }
	    
	    
	    // accumulator for failures from each strategy in the chain
	    var failures = [];
	    
	    function allFailed() {
	      if (callback) {
	        if (!multi) {
	          return callback(null, false, failures[0].challenge, failures[0].status);
	        } else {
	          var challenges = failures.map(function(f) { return f.challenge; });
	          var statuses = failures.map(function(f) { return f.status; });
	          return callback(null, false, challenges, statuses);
	        }
	      }
	      
	      // Strategies are ordered by priority.  For the purpose of flashing a
	      // message, the first failure will be displayed.
	      var failure = failures[0] || {}
	        , challenge = failure.challenge || {}
	        , msg;
	    
	      if (options.failureFlash) {
	        var flash = options.failureFlash;
	        if (typeof flash == 'string') {
	          flash = { type: 'error', message: flash };
	        }
	        flash.type = flash.type || 'error';
	      
	        var type = flash.type || challenge.type || 'error';
	        msg = flash.message || challenge.message || challenge;
	        if (typeof msg == 'string') {
	          req.flash(type, msg);
	        }
	      }
	      if (options.failureMessage) {
	        msg = options.failureMessage;
	        if (typeof msg == 'boolean') {
	          msg = challenge.message || challenge;
	        }
	        if (typeof msg == 'string') {
	          req.session.messages = req.session.messages || [];
	          req.session.messages.push(msg);
	        }
	      }
	      if (options.failureRedirect) {
	        return res.redirect(options.failureRedirect);
	      }
	    
	      // When failure handling is not delegated to the application, the default
	      // is to respond with 401 Unauthorized.  Note that the WWW-Authenticate
	      // header will be set according to the strategies in use (see
	      // actions#fail).  If multiple strategies failed, each of their challenges
	      // will be included in the response.
	      var rchallenge = []
	        , rstatus, status;
	      
	      for (var j = 0, len = failures.length; j < len; j++) {
	        failure = failures[j];
	        challenge = failure.challenge;
	        status = failure.status;
	          
	        rstatus = rstatus || status;
	        if (typeof challenge == 'string') {
	          rchallenge.push(challenge);
	        }
	      }
	    
	      res.statusCode = rstatus || 401;
	      if (res.statusCode == 401 && rchallenge.length) {
	        res.setHeader('WWW-Authenticate', rchallenge);
	      }
	      if (options.failWithError) {
	        return next(new AuthenticationError(http.STATUS_CODES[res.statusCode], rstatus));
	      }
	      res.end(http.STATUS_CODES[res.statusCode]);
	    }
	    
	    (function attempt(i) {
	      var layer = name[i];
	      // If no more strategies exist in the chain, authentication has failed.
	      if (!layer) { return allFailed(); }
	    
	      // Get the strategy, which will be used as prototype from which to create
	      // a new instance.  Action functions will then be bound to the strategy
	      // within the context of the HTTP request/response pair.
	      var prototype = passport._strategy(layer);
	      if (!prototype) { return next(new Error('Unknown authentication strategy "' + layer + '"')); }
	    
	      var strategy = Object.create(prototype);
	      
	      
	      // ----- BEGIN STRATEGY AUGMENTATION -----
	      // Augment the new strategy instance with action functions.  These action
	      // functions are bound via closure the the request/response pair.  The end
	      // goal of the strategy is to invoke *one* of these action methods, in
	      // order to indicate successful or failed authentication, redirect to a
	      // third-party identity provider, etc.
	      
	      /**
	       * Authenticate `user`, with optional `info`.
	       *
	       * Strategies should call this function to successfully authenticate a
	       * user.  `user` should be an object supplied by the application after it
	       * has been given an opportunity to verify credentials.  `info` is an
	       * optional argument containing additional user information.  This is
	       * useful for third-party authentication strategies to pass profile
	       * details.
	       *
	       * @param {Object} user
	       * @param {Object} info
	       * @api public
	       */
	      strategy.success = function(user, info) {
	        if (callback) {
	          return callback(null, user, info);
	        }
	      
	        info = info || {};
	        var msg;
	      
	        if (options.successFlash) {
	          var flash = options.successFlash;
	          if (typeof flash == 'string') {
	            flash = { type: 'success', message: flash };
	          }
	          flash.type = flash.type || 'success';
	        
	          var type = flash.type || info.type || 'success';
	          msg = flash.message || info.message || info;
	          if (typeof msg == 'string') {
	            req.flash(type, msg);
	          }
	        }
	        if (options.successMessage) {
	          msg = options.successMessage;
	          if (typeof msg == 'boolean') {
	            msg = info.message || info;
	          }
	          if (typeof msg == 'string') {
	            req.session.messages = req.session.messages || [];
	            req.session.messages.push(msg);
	          }
	        }
	        if (options.assignProperty) {
	          req[options.assignProperty] = user;
	          return next();
	        }
	      
	        req.logIn(user, options, function(err) {
	          if (err) { return next(err); }
	          
	          function complete() {
	            if (options.successReturnToOrRedirect) {
	              var url = options.successReturnToOrRedirect;
	              if (req.session && req.session.returnTo) {
	                url = req.session.returnTo;
	                delete req.session.returnTo;
	              }
	              return res.redirect(url);
	            }
	            if (options.successRedirect) {
	              return res.redirect(options.successRedirect);
	            }
	            next();
	          }
	          
	          if (options.authInfo !== false) {
	            passport.transformAuthInfo(info, req, function(err, tinfo) {
	              if (err) { return next(err); }
	              req.authInfo = tinfo;
	              complete();
	            });
	          } else {
	            complete();
	          }
	        });
	      };
	      
	      /**
	       * Fail authentication, with optional `challenge` and `status`, defaulting
	       * to 401.
	       *
	       * Strategies should call this function to fail an authentication attempt.
	       *
	       * @param {String} challenge
	       * @param {Number} status
	       * @api public
	       */
	      strategy.fail = function(challenge, status) {
	        if (typeof challenge == 'number') {
	          status = challenge;
	          challenge = undefined;
	        }
	        
	        // push this failure into the accumulator and attempt authentication
	        // using the next strategy
	        failures.push({ challenge: challenge, status: status });
	        attempt(i + 1);
	      };
	      
	      /**
	       * Redirect to `url` with optional `status`, defaulting to 302.
	       *
	       * Strategies should call this function to redirect the user (via their
	       * user agent) to a third-party website for authentication.
	       *
	       * @param {String} url
	       * @param {Number} status
	       * @api public
	       */
	      strategy.redirect = function(url, status) {
	        // NOTE: Do not use `res.redirect` from Express, because it can't decide
	        //       what it wants.
	        //
	        //       Express 2.x: res.redirect(url, status)
	        //       Express 3.x: res.redirect(status, url) -OR- res.redirect(url, status)
	        //         - as of 3.14.0, deprecated warnings are issued if res.redirect(url, status)
	        //           is used
	        //       Express 4.x: res.redirect(status, url)
	        //         - all versions (as of 4.8.7) continue to accept res.redirect(url, status)
	        //           but issue deprecated versions
	        
	        res.statusCode = status || 302;
	        res.setHeader('Location', url);
	        res.setHeader('Content-Length', '0');
	        res.end();
	      };
	      
	      /**
	       * Pass without making a success or fail decision.
	       *
	       * Under most circumstances, Strategies should not need to call this
	       * function.  It exists primarily to allow previous authentication state
	       * to be restored, for example from an HTTP session.
	       *
	       * @api public
	       */
	      strategy.pass = function() {
	        next();
	      };
	      
	      /**
	       * Internal error while performing authentication.
	       *
	       * Strategies should call this function when an internal error occurs
	       * during the process of performing authentication; for example, if the
	       * user directory is not available.
	       *
	       * @param {Error} err
	       * @api public
	       */
	      strategy.error = function(err) {
	        if (callback) {
	          return callback(err);
	        }
	        
	        next(err);
	      };
	      
	      // ----- END STRATEGY AUGMENTATION -----
	    
	      strategy.authenticate(req, options);
	    })(0); // attempt
	  };
	};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var ClientRequest = __webpack_require__(281)
	var response = __webpack_require__(287)
	var extend = __webpack_require__(306)
	var statusCodes = __webpack_require__(307)
	var url = __webpack_require__(308)
	
	var http = exports
	
	http.request = function (opts, cb) {
		if (typeof opts === 'string')
			opts = url.parse(opts)
		else
			opts = extend(opts)
	
		// Normally, the page is loaded from http or https, so not specifying a protocol
		// will result in a (valid) protocol-relative url. However, this won't work if
		// the protocol is something else, like 'file:'
		var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''
	
		var protocol = opts.protocol || defaultProtocol
		var host = opts.hostname || opts.host
		var port = opts.port
		var path = opts.path || '/'
	
		// Necessary for IPv6 addresses
		if (host && host.indexOf(':') !== -1)
			host = '[' + host + ']'
	
		// This may be a relative url. The browser should always be able to interpret it correctly.
		opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
		opts.method = (opts.method || 'GET').toUpperCase()
		opts.headers = opts.headers || {}
	
		// Also valid opts.auth, opts.mode
	
		var req = new ClientRequest(opts)
		if (cb)
			req.on('response', cb)
		return req
	}
	
	http.get = function get (opts, cb) {
		var req = http.request(opts, cb)
		req.end()
		return req
	}
	
	http.ClientRequest = ClientRequest
	http.IncomingMessage = response.IncomingMessage
	
	http.Agent = function () {}
	http.Agent.defaultMaxSockets = 4
	
	http.globalAgent = new http.Agent()
	
	http.STATUS_CODES = statusCodes
	
	http.METHODS = [
		'CHECKOUT',
		'CONNECT',
		'COPY',
		'DELETE',
		'GET',
		'HEAD',
		'LOCK',
		'M-SEARCH',
		'MERGE',
		'MKACTIVITY',
		'MKCOL',
		'MOVE',
		'NOTIFY',
		'OPTIONS',
		'PATCH',
		'POST',
		'PROPFIND',
		'PROPPATCH',
		'PURGE',
		'PUT',
		'REPORT',
		'SEARCH',
		'SUBSCRIBE',
		'TRACE',
		'UNLOCK',
		'UNSUBSCRIBE'
	]
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {var capability = __webpack_require__(286)
	var inherits = __webpack_require__(274)
	var response = __webpack_require__(287)
	var stream = __webpack_require__(288)
	var toArrayBuffer = __webpack_require__(305)
	
	var IncomingMessage = response.IncomingMessage
	var rStates = response.readyStates
	
	function decideMode (preferBinary, useFetch) {
		if (capability.fetch && useFetch) {
			return 'fetch'
		} else if (capability.mozchunkedarraybuffer) {
			return 'moz-chunked-arraybuffer'
		} else if (capability.msstream) {
			return 'ms-stream'
		} else if (capability.arraybuffer && preferBinary) {
			return 'arraybuffer'
		} else if (capability.vbArray && preferBinary) {
			return 'text:vbarray'
		} else {
			return 'text'
		}
	}
	
	var ClientRequest = module.exports = function (opts) {
		var self = this
		stream.Writable.call(self)
	
		self._opts = opts
		self._body = []
		self._headers = {}
		if (opts.auth)
			self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'))
		Object.keys(opts.headers).forEach(function (name) {
			self.setHeader(name, opts.headers[name])
		})
	
		var preferBinary
		var useFetch = true
		if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
			// If the use of XHR should be preferred. Not typically needed.
			useFetch = false
			preferBinary = true
		} else if (opts.mode === 'prefer-streaming') {
			// If streaming is a high priority but binary compatibility and
			// the accuracy of the 'content-type' header aren't
			preferBinary = false
		} else if (opts.mode === 'allow-wrong-content-type') {
			// If streaming is more important than preserving the 'content-type' header
			preferBinary = !capability.overrideMimeType
		} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
			// Use binary if text streaming may corrupt data or the content-type header, or for speed
			preferBinary = true
		} else {
			throw new Error('Invalid value for opts.mode')
		}
		self._mode = decideMode(preferBinary, useFetch)
		self._fetchTimer = null
	
		self.on('finish', function () {
			self._onFinish()
		})
	}
	
	inherits(ClientRequest, stream.Writable)
	
	ClientRequest.prototype.setHeader = function (name, value) {
		var self = this
		var lowerName = name.toLowerCase()
		// This check is not necessary, but it prevents warnings from browsers about setting unsafe
		// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
		// http-browserify did it, so I will too.
		if (unsafeHeaders.indexOf(lowerName) !== -1)
			return
	
		self._headers[lowerName] = {
			name: name,
			value: value
		}
	}
	
	ClientRequest.prototype.getHeader = function (name) {
		var header = this._headers[name.toLowerCase()]
		if (header)
			return header.value
		return null
	}
	
	ClientRequest.prototype.removeHeader = function (name) {
		var self = this
		delete self._headers[name.toLowerCase()]
	}
	
	ClientRequest.prototype._onFinish = function () {
		var self = this
	
		if (self._destroyed)
			return
		var opts = self._opts
	
		var headersObj = self._headers
		var body = null
		if (opts.method !== 'GET' && opts.method !== 'HEAD') {
			if (capability.arraybuffer) {
				body = toArrayBuffer(Buffer.concat(self._body))
			} else if (capability.blobConstructor) {
				body = new global.Blob(self._body.map(function (buffer) {
					return toArrayBuffer(buffer)
				}), {
					type: (headersObj['content-type'] || {}).value || ''
				})
			} else {
				// get utf8 string
				body = Buffer.concat(self._body).toString()
			}
		}
	
		// create flattened list of headers
		var headersList = []
		Object.keys(headersObj).forEach(function (keyName) {
			var name = headersObj[keyName].name
			var value = headersObj[keyName].value
			if (Array.isArray(value)) {
				value.forEach(function (v) {
					headersList.push([name, v])
				})
			} else {
				headersList.push([name, value])
			}
		})
	
		if (self._mode === 'fetch') {
			var signal = null
			var fetchTimer = null
			if (capability.abortController) {
				var controller = new AbortController()
				signal = controller.signal
				self._fetchAbortController = controller
	
				if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
					self._fetchTimer = global.setTimeout(function () {
						self.emit('requestTimeout')
						if (self._fetchAbortController)
							self._fetchAbortController.abort()
					}, opts.requestTimeout)
				}
			}
	
			global.fetch(self._opts.url, {
				method: self._opts.method,
				headers: headersList,
				body: body || undefined,
				mode: 'cors',
				credentials: opts.withCredentials ? 'include' : 'same-origin',
				signal: signal
			}).then(function (response) {
				self._fetchResponse = response
				self._connect()
			}, function (reason) {
				global.clearTimeout(self._fetchTimer)
				if (!self._destroyed)
					self.emit('error', reason)
			})
		} else {
			var xhr = self._xhr = new global.XMLHttpRequest()
			try {
				xhr.open(self._opts.method, self._opts.url, true)
			} catch (err) {
				process.nextTick(function () {
					self.emit('error', err)
				})
				return
			}
	
			// Can't set responseType on really old browsers
			if ('responseType' in xhr)
				xhr.responseType = self._mode.split(':')[0]
	
			if ('withCredentials' in xhr)
				xhr.withCredentials = !!opts.withCredentials
	
			if (self._mode === 'text' && 'overrideMimeType' in xhr)
				xhr.overrideMimeType('text/plain; charset=x-user-defined')
	
			if ('requestTimeout' in opts) {
				xhr.timeout = opts.requestTimeout
				xhr.ontimeout = function () {
					self.emit('requestTimeout')
				}
			}
	
			headersList.forEach(function (header) {
				xhr.setRequestHeader(header[0], header[1])
			})
	
			self._response = null
			xhr.onreadystatechange = function () {
				switch (xhr.readyState) {
					case rStates.LOADING:
					case rStates.DONE:
						self._onXHRProgress()
						break
				}
			}
			// Necessary for streaming in Firefox, since xhr.response is ONLY defined
			// in onprogress, not in onreadystatechange with xhr.readyState = 3
			if (self._mode === 'moz-chunked-arraybuffer') {
				xhr.onprogress = function () {
					self._onXHRProgress()
				}
			}
	
			xhr.onerror = function () {
				if (self._destroyed)
					return
				self.emit('error', new Error('XHR error'))
			}
	
			try {
				xhr.send(body)
			} catch (err) {
				process.nextTick(function () {
					self.emit('error', err)
				})
				return
			}
		}
	}
	
	/**
	 * Checks if xhr.status is readable and non-zero, indicating no error.
	 * Even though the spec says it should be available in readyState 3,
	 * accessing it throws an exception in IE8
	 */
	function statusValid (xhr) {
		try {
			var status = xhr.status
			return (status !== null && status !== 0)
		} catch (e) {
			return false
		}
	}
	
	ClientRequest.prototype._onXHRProgress = function () {
		var self = this
	
		if (!statusValid(self._xhr) || self._destroyed)
			return
	
		if (!self._response)
			self._connect()
	
		self._response._onXHRProgress()
	}
	
	ClientRequest.prototype._connect = function () {
		var self = this
	
		if (self._destroyed)
			return
	
		self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._fetchTimer)
		self._response.on('error', function(err) {
			self.emit('error', err)
		})
	
		self.emit('response', self._response)
	}
	
	ClientRequest.prototype._write = function (chunk, encoding, cb) {
		var self = this
	
		self._body.push(chunk)
		cb()
	}
	
	ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
		var self = this
		self._destroyed = true
		global.clearTimeout(self._fetchTimer)
		if (self._response)
			self._response._destroyed = true
		if (self._xhr)
			self._xhr.abort()
		else if (self._fetchAbortController)
			self._fetchAbortController.abort()
	}
	
	ClientRequest.prototype.end = function (data, encoding, cb) {
		var self = this
		if (typeof data === 'function') {
			cb = data
			data = undefined
		}
	
		stream.Writable.prototype.end.call(self, data, encoding, cb)
	}
	
	ClientRequest.prototype.flushHeaders = function () {}
	ClientRequest.prototype.setTimeout = function () {}
	ClientRequest.prototype.setNoDelay = function () {}
	ClientRequest.prototype.setSocketKeepAlive = function () {}
	
	// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
	var unsafeHeaders = [
		'accept-charset',
		'accept-encoding',
		'access-control-request-headers',
		'access-control-request-method',
		'connection',
		'content-length',
		'cookie',
		'cookie2',
		'date',
		'dnt',
		'expect',
		'host',
		'keep-alive',
		'origin',
		'referer',
		'te',
		'trailer',
		'transfer-encoding',
		'upgrade',
		'via'
	]
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(282).Buffer, (function() { return this; }()), __webpack_require__(219)))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(283)
	var ieee754 = __webpack_require__(284)
	var isArray = __webpack_require__(285)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 284 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 286 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)
	
	exports.writableStream = isFunction(global.WritableStream)
	
	exports.abortController = isFunction(global.AbortController)
	
	exports.blobConstructor = false
	try {
		new Blob([new ArrayBuffer(1)])
		exports.blobConstructor = true
	} catch (e) {}
	
	// The xhr request to example.com may violate some restrictive CSP configurations,
	// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
	// and assume support for certain features below.
	var xhr
	function getXHR () {
		// Cache the xhr value
		if (xhr !== undefined) return xhr
	
		if (global.XMLHttpRequest) {
			xhr = new global.XMLHttpRequest()
			// If XDomainRequest is available (ie only, where xhr might not work
			// cross domain), use the page location. Otherwise use example.com
			// Note: this doesn't actually make an http request.
			try {
				xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
			} catch(e) {
				xhr = null
			}
		} else {
			// Service workers don't have XHR
			xhr = null
		}
		return xhr
	}
	
	function checkTypeSupport (type) {
		var xhr = getXHR()
		if (!xhr) return false
		try {
			xhr.responseType = type
			return xhr.responseType === type
		} catch (e) {}
		return false
	}
	
	// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
	// Safari 7.1 appears to have fixed this bug.
	var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined'
	var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice)
	
	// If fetch is supported, then arraybuffer will be supported too. Skip calling
	// checkTypeSupport(), since that calls getXHR().
	exports.arraybuffer = exports.fetch || (haveArrayBuffer && checkTypeSupport('arraybuffer'))
	
	// These next two tests unavoidably show warnings in Chrome. Since fetch will always
	// be used if it's available, just return false for these to avoid the warnings.
	exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream')
	exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer &&
		checkTypeSupport('moz-chunked-arraybuffer')
	
	// If fetch is supported, then overrideMimeType will be supported too. Skip calling
	// getXHR().
	exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)
	
	exports.vbArray = isFunction(global.VBArray)
	
	function isFunction (value) {
		return typeof value === 'function'
	}
	
	xhr = null // Help gc
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {var capability = __webpack_require__(286)
	var inherits = __webpack_require__(274)
	var stream = __webpack_require__(288)
	
	var rStates = exports.readyStates = {
		UNSENT: 0,
		OPENED: 1,
		HEADERS_RECEIVED: 2,
		LOADING: 3,
		DONE: 4
	}
	
	var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, fetchTimer) {
		var self = this
		stream.Readable.call(self)
	
		self._mode = mode
		self.headers = {}
		self.rawHeaders = []
		self.trailers = {}
		self.rawTrailers = []
	
		// Fake the 'close' event, but only once 'end' fires
		self.on('end', function () {
			// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
			process.nextTick(function () {
				self.emit('close')
			})
		})
	
		if (mode === 'fetch') {
			self._fetchResponse = response
	
			self.url = response.url
			self.statusCode = response.status
			self.statusMessage = response.statusText
			
			response.headers.forEach(function (header, key){
				self.headers[key.toLowerCase()] = header
				self.rawHeaders.push(key, header)
			})
	
			if (capability.writableStream) {
				var writable = new WritableStream({
					write: function (chunk) {
						return new Promise(function (resolve, reject) {
							if (self._destroyed) {
								reject()
							} else if(self.push(new Buffer(chunk))) {
								resolve()
							} else {
								self._resumeFetch = resolve
							}
						})
					},
					close: function () {
						global.clearTimeout(fetchTimer)
						if (!self._destroyed)
							self.push(null)
					},
					abort: function (err) {
						if (!self._destroyed)
							self.emit('error', err)
					}
				})
	
				try {
					response.body.pipeTo(writable).catch(function (err) {
						global.clearTimeout(fetchTimer)
						if (!self._destroyed)
							self.emit('error', err)
					})
					return
				} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
			}
			// fallback for when writableStream or pipeTo aren't available
			var reader = response.body.getReader()
			function read () {
				reader.read().then(function (result) {
					if (self._destroyed)
						return
					if (result.done) {
						global.clearTimeout(fetchTimer)
						self.push(null)
						return
					}
					self.push(new Buffer(result.value))
					read()
				}).catch(function (err) {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.emit('error', err)
				})
			}
			read()
		} else {
			self._xhr = xhr
			self._pos = 0
	
			self.url = xhr.responseURL
			self.statusCode = xhr.status
			self.statusMessage = xhr.statusText
			var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
			headers.forEach(function (header) {
				var matches = header.match(/^([^:]+):\s*(.*)/)
				if (matches) {
					var key = matches[1].toLowerCase()
					if (key === 'set-cookie') {
						if (self.headers[key] === undefined) {
							self.headers[key] = []
						}
						self.headers[key].push(matches[2])
					} else if (self.headers[key] !== undefined) {
						self.headers[key] += ', ' + matches[2]
					} else {
						self.headers[key] = matches[2]
					}
					self.rawHeaders.push(matches[1], matches[2])
				}
			})
	
			self._charset = 'x-user-defined'
			if (!capability.overrideMimeType) {
				var mimeType = self.rawHeaders['mime-type']
				if (mimeType) {
					var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
					if (charsetMatch) {
						self._charset = charsetMatch[1].toLowerCase()
					}
				}
				if (!self._charset)
					self._charset = 'utf-8' // best guess
			}
		}
	}
	
	inherits(IncomingMessage, stream.Readable)
	
	IncomingMessage.prototype._read = function () {
		var self = this
	
		var resolve = self._resumeFetch
		if (resolve) {
			self._resumeFetch = null
			resolve()
		}
	}
	
	IncomingMessage.prototype._onXHRProgress = function () {
		var self = this
	
		var xhr = self._xhr
	
		var response = null
		switch (self._mode) {
			case 'text:vbarray': // For IE9
				if (xhr.readyState !== rStates.DONE)
					break
				try {
					// This fails in IE8
					response = new global.VBArray(xhr.responseBody).toArray()
				} catch (e) {}
				if (response !== null) {
					self.push(new Buffer(response))
					break
				}
				// Falls through in IE8	
			case 'text':
				try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
					response = xhr.responseText
				} catch (e) {
					self._mode = 'text:vbarray'
					break
				}
				if (response.length > self._pos) {
					var newData = response.substr(self._pos)
					if (self._charset === 'x-user-defined') {
						var buffer = new Buffer(newData.length)
						for (var i = 0; i < newData.length; i++)
							buffer[i] = newData.charCodeAt(i) & 0xff
	
						self.push(buffer)
					} else {
						self.push(newData, self._charset)
					}
					self._pos = response.length
				}
				break
			case 'arraybuffer':
				if (xhr.readyState !== rStates.DONE || !xhr.response)
					break
				response = xhr.response
				self.push(new Buffer(new Uint8Array(response)))
				break
			case 'moz-chunked-arraybuffer': // take whole
				response = xhr.response
				if (xhr.readyState !== rStates.LOADING || !response)
					break
				self.push(new Buffer(new Uint8Array(response)))
				break
			case 'ms-stream':
				response = xhr.response
				if (xhr.readyState !== rStates.LOADING)
					break
				var reader = new global.MSStreamReader()
				reader.onprogress = function () {
					if (reader.result.byteLength > self._pos) {
						self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))))
						self._pos = reader.result.byteLength
					}
				}
				reader.onload = function () {
					self.push(null)
				}
				// reader.onerror = ??? // TODO: this
				reader.readAsArrayBuffer(response)
				break
		}
	
		// The ms-stream case handles end separately in reader.onload()
		if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
			self.push(null)
		}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(219), __webpack_require__(282).Buffer, (function() { return this; }())))

/***/ }),
/* 288 */
[711, 289, 300, 299, 303, 304],
/* 289 */
[712, 292, 293, 274, 295, 296, 298, 299, 302, 299, 302],
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(219)))

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(291).EventEmitter;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(282)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(282).Buffer))

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 296 */
[713, 293, 297],
/* 297 */
295,
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(290);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err) {
	      if (!this._writableState) {
	        pna.nextTick(emitErrorNT, this, err);
	      } else if (!this._writableState.errorEmitted) {
	        this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, this, err);
	      }
	    }
	
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      if (!_this._writableState) {
	        pna.nextTick(emitErrorNT, _this, err);
	      } else if (!_this._writableState.errorEmitted) {
	        _this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, _this, err);
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finalCalled = false;
	    this._writableState.prefinished = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 299 */
[714, 274, 289, 300],
/* 300 */
[715, 274, 292, 293, 298, 299, 299],
/* 301 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 302 */
[716, 293],
/* 303 */
[717, 299, 274],
/* 304 */
[718, 303, 274],
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(282).Buffer
	
	module.exports = function (buf) {
		// If the buffer is backed by a Uint8Array, a faster version will work
		if (buf instanceof Uint8Array) {
			// If the buffer isn't a subarray, return the underlying ArrayBuffer
			if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
				return buf.buffer
			} else if (typeof buf.buffer.slice === 'function') {
				// Otherwise we need to get a proper copy
				return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength)
			}
		}
	
		if (Buffer.isBuffer(buf)) {
			// This is the slow version that will work with any Buffer
			// implementation (even in old browsers)
			var arrayCopy = new Uint8Array(buf.length)
			var len = buf.length
			for (var i = 0; i < len; i++) {
				arrayCopy[i] = buf[i]
			}
			return arrayCopy.buffer
		} else {
			throw new Error('Argument must be a Buffer')
		}
	}


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = {
	  "100": "Continue",
	  "101": "Switching Protocols",
	  "102": "Processing",
	  "200": "OK",
	  "201": "Created",
	  "202": "Accepted",
	  "203": "Non-Authoritative Information",
	  "204": "No Content",
	  "205": "Reset Content",
	  "206": "Partial Content",
	  "207": "Multi-Status",
	  "208": "Already Reported",
	  "226": "IM Used",
	  "300": "Multiple Choices",
	  "301": "Moved Permanently",
	  "302": "Found",
	  "303": "See Other",
	  "304": "Not Modified",
	  "305": "Use Proxy",
	  "307": "Temporary Redirect",
	  "308": "Permanent Redirect",
	  "400": "Bad Request",
	  "401": "Unauthorized",
	  "402": "Payment Required",
	  "403": "Forbidden",
	  "404": "Not Found",
	  "405": "Method Not Allowed",
	  "406": "Not Acceptable",
	  "407": "Proxy Authentication Required",
	  "408": "Request Timeout",
	  "409": "Conflict",
	  "410": "Gone",
	  "411": "Length Required",
	  "412": "Precondition Failed",
	  "413": "Payload Too Large",
	  "414": "URI Too Long",
	  "415": "Unsupported Media Type",
	  "416": "Range Not Satisfiable",
	  "417": "Expectation Failed",
	  "418": "I'm a teapot",
	  "421": "Misdirected Request",
	  "422": "Unprocessable Entity",
	  "423": "Locked",
	  "424": "Failed Dependency",
	  "425": "Unordered Collection",
	  "426": "Upgrade Required",
	  "428": "Precondition Required",
	  "429": "Too Many Requests",
	  "431": "Request Header Fields Too Large",
	  "451": "Unavailable For Legal Reasons",
	  "500": "Internal Server Error",
	  "501": "Not Implemented",
	  "502": "Bad Gateway",
	  "503": "Service Unavailable",
	  "504": "Gateway Timeout",
	  "505": "HTTP Version Not Supported",
	  "506": "Variant Also Negotiates",
	  "507": "Insufficient Storage",
	  "508": "Loop Detected",
	  "509": "Bandwidth Limit Exceeded",
	  "510": "Not Extended",
	  "511": "Network Authentication Required"
	}


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = __webpack_require__(309);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(310);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)(module), (function() { return this; }())))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(311);
	exports.encode = exports.stringify = __webpack_require__(312);


/***/ }),
/* 311 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 312 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 313 */
/***/ (function(module, exports) {

	/**
	 * Module dependencies.
	 */
	//var http = require('http')
	//  , req = http.IncomingMessage.prototype;
	
	
	var req = exports = module.exports = {};
	
	/**
	 * Intiate a login session for `user`.
	 *
	 * Options:
	 *   - `session`  Save login state in session, defaults to _true_
	 *
	 * Examples:
	 *
	 *     req.logIn(user, { session: false });
	 *
	 *     req.logIn(user, function(err) {
	 *       if (err) { throw err; }
	 *       // session saved
	 *     });
	 *
	 * @param {User} user
	 * @param {Object} options
	 * @param {Function} done
	 * @api public
	 */
	req.login =
	req.logIn = function(user, options, done) {
	  if (typeof options == 'function') {
	    done = options;
	    options = {};
	  }
	  options = options || {};
	  
	  var property = 'user';
	  if (this._passport && this._passport.instance) {
	    property = this._passport.instance._userProperty || 'user';
	  }
	  var session = (options.session === undefined) ? true : options.session;
	  
	  this[property] = user;
	  if (session) {
	    if (!this._passport) { throw new Error('passport.initialize() middleware not in use'); }
	    if (typeof done != 'function') { throw new Error('req#login requires a callback function'); }
	    
	    var self = this;
	    this._passport.instance.serializeUser(user, this, function(err, obj) {
	      if (err) { self[property] = null; return done(err); }
	      if (!self._passport.session) {
	        self._passport.session = {};
	      }
	      self._passport.session.user = obj;
	      if (!self.session) {
	        self.session = {};
	      }
	      self.session[self._passport.instance._key] = self._passport.session;
	      done();
	    });
	  } else {
	    done && done();
	  }
	};
	
	/**
	 * Terminate an existing login session.
	 *
	 * @api public
	 */
	req.logout =
	req.logOut = function() {
	  var property = 'user';
	  if (this._passport && this._passport.instance) {
	    property = this._passport.instance._userProperty || 'user';
	  }
	  
	  this[property] = null;
	  if (this._passport && this._passport.session) {
	    delete this._passport.session.user;
	  }
	};
	
	/**
	 * Test if request is authenticated.
	 *
	 * @return {Boolean}
	 * @api public
	 */
	req.isAuthenticated = function() {
	  var property = 'user';
	  if (this._passport && this._passport.instance) {
	    property = this._passport.instance._userProperty || 'user';
	  }
	  
	  return (this[property]) ? true : false;
	};
	
	/**
	 * Test if request is unauthenticated.
	 *
	 * @return {Boolean}
	 * @api public
	 */
	req.isUnauthenticated = function() {
	  return !this.isAuthenticated();
	};


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	/**
	 * `AuthenticationError` error.
	 *
	 * @api private
	 */
	function AuthenticationError(message, status) {
	  Error.call(this);
	  Error.captureStackTrace(this, arguments.callee);
	  this.name = 'AuthenticationError';
	  this.message = message;
	  this.status = status || 401;
	}
	
	/**
	 * Inherit from `Error`.
	 */
	AuthenticationError.prototype.__proto__ = Error.prototype;
	
	
	/**
	 * Expose `AuthenticationError`.
	 */
	module.exports = AuthenticationError;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports = "<style>\n    /* Submission title with unread indicators */\n.submission-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n\n/* Unread count badge */\n.unread-count {\n  background-color: #2196F3;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 10px;\n  min-width: 20px;\n  text-align: center;\n}\n\n/* New message dot indicator */\n.new-message-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #ff4081;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 5px;;\n}\n\n/* Optional: Highlight entire row with unread messages */\ntr:has(.unread-count) {\n  background-color: #f8f9fa;\n}\n\n/* Optional: Add subtle left border for rows with unread messages */\ntr:has(.unread-count) td:first-child {\n  border-left: 3px solid #2196F3;\n}\n\n/* Optional: Make policy name bold if has unread messages */\ntr:has(.unread-count) .submission-title {\n  font-weight: 600;\n}\n\n/* Optional: Animate new message dot */\n@keyframes pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.2); }\n  100% { transform: scale(1); }\n}\n\n.new-message-dot {\n  animation: pulse 2s infinite;\n}\n\n/* Optional: Hover state for rows with unread messages */\ntr:has(.unread-count):hover {\n  background-color: #e3f2fd;\n  transition: background-color 0.2s ease;\n}\n\n/* Optional: Style for recent messages */\n.recent-message-indicator {\n  color: #ff4081;\n  font-size: 12px;\n  margin-left: 8px;\n}\n\n    .status-pill {\n  display: inline-block;\n  padding: 0.25em 0.8em;\n  border-radius: 1em;\n  font-size: 0.875em;\n  font-weight: 500;\n  text-transform: capitalize;\n\n  &.pending {\n    background-color: #fff3cd;\n    color: #856404;\n  }\n\n  &.approved {\n    background-color: #d4edda;\n    color: #155724;\n  }\n\n  &.rejected {\n    background-color: #f8d7da;\n    color: #721c24;\n  }\n\n  &.in_progress {\n    background-color: #cce5ff;\n    color: #004085;\n  }\n\n\n}\n\n.dropdown-item {\n  i {\n    width: 1.25em;\n    text-align: center;\n    margin-right: 0.5em;\n  }\n}\n\n.message-row {\n  &.unread {\n    font-weight: 600;\n\n    td {\n      color: #000;\n    }\n  }\n}\n\n.table--data-table td {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n/*.table--data-table td:nth-child(1) { !* Type *!*/\n/*  width: 15%;*/\n/*  min-width: 120px;*/\n/*}*/\n\n/*.table--data-table td:nth-child(2) { !* Total Comments *!*/\n/*  width: 10%;*/\n/*}*/\n\n/*.table--data-table td:nth-child(3) { !* Last Comment *!*/\n/*  width: 15%;*/\n/*  max-width: 400px;*/\n/*}*/\n\n/*.table--data-table td:nth-child(4) { !* Last Updated *!*/\n/*  width: 40%;*/\n/*}*/\n\n/*.table--data-table td:nth-child(5) { !* From *!*/\n/*  width: 15%;*/\n/*  min-width: 120px;*/\n/*}*/\n\n.table--data-table td.view-message { /* View */\n  width: 6%;\n}\n\n\n\n</style>\n<section class=\"dashboard dashboard--page dashboard--message-center\">\n    <div class=\"page-wrapper\">\n      <div class=\"dashboard-header\">\n       <sidebarnav></sidebarnav>\n      </div>\n\n      <div class=\"main\">\n       <mainheaderauth></mainheaderauth>\n\n        <div id=\"maincontent\" class=\"row\">\n          <div style=\"width: 270px\"></div>\n          <div class=\"col\">\n            <div class=\"row\">\n              <div class=\"row\">\n                <div class=\"col-lg-12\">\n                  <h1 class=\"fs-1\">Message Center</h1>\n                </div>\n              </div>\n              <div class=\"row mb-4\">\n                <div class=\"col-lg-3\">\n                  <div class=\"card card--status-tile\">\n                    <div class=\"card-body\">\n                      <div class=\"status-tile\">\n                        <div\n                          class=\"status-tile__icon-container\"\n                          style=\"background-color: #336699\"\n                        >\n                          <i class=\"fa-solid fa-clock\"></i>\n                        </div>\n                        <div class=\"d-flex flex-column\">\n                          <div class=\"status-tile__label\">Total</div>\n                          <div class=\"fs-1 lh-1\">{{messagesCtrl.messageCounts.total}}</div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"col-lg-3\">\n                  <div class=\"card card--status-tile\">\n                    <div class=\"card-body\">\n                      <div class=\"status-tile\">\n                        <div\n                          class=\"status-tile__icon-container\"\n                          style=\"\n                            background: linear-gradient(\n                              90deg,\n                              #d67128,\n                              #ecac2b\n                            );\n                          \"\n                        >\n                          <i class=\"fa-solid fa-envelope\"></i>\n                        </div>\n                        <div class=\"d-flex flex-column\">\n                          <div class=\"status-tile__label\">Unread</div>\n                          <div class=\"fs-1 lh-1\">{{messagesCtrl.messageCounts.unread}}</div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"col-lg-3\">\n                  <form>\n                  <div class=\"form-item form-item--select\" ng-show=\"getCurrentUser().role !== 'User'\">\n                    <label for=\"jurisdiction\">Jurisdiction</label>\n                    <select name=\"jurisdiction\" id=\"jurisdiction\" ng-model=\"currentJurisdiction\"\n                            ng-change=\"messagesCtrl.filterMessages(currentJurisdiction, currentPolicyType)\">\n                      <option ng-value=\"\">All Jurisdictions</option>\n                      <option ng-repeat=\"item in messagesCtrl.$scope.jurisdictions\" ng-value=\"item.jurisdiction\">\n                        {{item.jurisdiction}}\n                      </option>\n                    </select>\n                  </div>\n                  </form>\n                </div>\n                <div class=\"col-lg-3\">\n                  <form>\n                    <div class=\"form-item form-item--select\">\n                      <label for=\"jurisdiction\">Policy Type</label>\n                      <select name=\"policy_type\" id=\"policy_type\" ng-model=\"currentPolicyType\"\n                              ng-change=\"messagesCtrl.filterMessages(currentJurisdiction, currentPolicyType)\">\n                        <option ng-value=\"\">All Policy Types</option>\n                        <option ng-repeat=\"item in messagesCtrl.policyTypes\" ng-value=\"item\">\n                          {{item}}\n                        </option>\n                      </select>\n                    </div>\n                  </form>\n                </div>\n<!--                <div class=\"col-lg-3\">-->\n<!--                  <div class=\"card card&#45;&#45;status-tile\">-->\n<!--                    <div class=\"card-body\">-->\n<!--                      <div class=\"status-tile\">-->\n<!--                        <div-->\n<!--                          class=\"status-tile__icon-container\"-->\n<!--                          style=\"background-color: #5ea037\"-->\n<!--                        >-->\n<!--                          <i class=\"fa-solid fa-clock\"></i>-->\n<!--                        </div>-->\n<!--                        <div class=\"d-flex flex-column\">-->\n<!--                          <div class=\"status-tile__label\">In Progress</div>-->\n<!--                          <div class=\"fs-1 lh-1\">{{messagesCtrl.messageCounts.in_progress}}</div>-->\n<!--                        </div>-->\n<!--                      </div>-->\n<!--                    </div>-->\n<!--                  </div>-->\n<!--                </div>-->\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-12\">\n                  <!-- Loading State -->\n                  <div ng-if=\"messagesCtrl.loading\" class=\"text-center p-4\">\n                    <i class=\"fa-solid fa-spinner fa-spin\"></i> Loading messages...\n                  </div>\n\n                  <!-- Error State -->\n                  <div ng-if=\"messagesCtrl.error\" class=\"alert alert-danger\">\n                    {{messagesCtrl.error}}\n                  </div>\n\n                  <!-- No Messages State -->\n                  <div ng-if=\"!messagesCtrl.loading && !messagesCtrl.messages.length\" class=\"alert alert-info\">\n                    No messages found.\n                  </div>\n\n                  <!-- Messages Table -->\n                  <table  ng-if=\"!messagesCtrl.loading && messagesCtrl.messages.length\"\n                    class=\"table table--data-table table-borderless table-striped table--messages\" st-table=\"displayedMessages\" st-safe-src=\"messagesCtrl.messages\">\n                    <thead class=\"table-dark\">\n                      <tr>\n                        <th ng-if=\"messagesCtrl.$scope.currentUser.organization === 'MTC'\">\n                          <div class=\"th-inner\" st-sort=\"jurisdiction\">\n                            Jurisdiction\n                            <tablesortbuttons></tablesortbuttons>\n                          </div>\n                        </th>\n                        <th>\n                          <div class=\"th-inner\" st-sort=\"station_name\">\n                            Station Name\n                            <tablesortbuttons></tablesortbuttons>\n                          </div>\n                        </th>\n                        <th>\n                          <div class=\"th-inner\" st-sort=\"policy_type\">\n                            Type\n                            <tablesortbuttons></tablesortbuttons>\n                          </div>\n                        </th>\n                        <th>\n                          <div class=\"th-inner\" st-sort=\"policy\">\n                            Policy\n                            <tablesortbuttons></tablesortbuttons>\n                          </div>\n                        </th>\n<!--                        <th>-->\n<!--                          <div class=\"th-inner\">-->\n<!--                            Total Messages-->\n<!--                            <tablesortbuttons></tablesortbuttons>-->\n<!--                          </div>-->\n<!--                        </th>-->\n                        <th>\n                            <div class=\"th-inner\">\n                              Last Message\n                            </div>\n                          </th>\n\n                        <th>\n                          <div class=\"th-inner\" st-sort=\"lastMessageDate\">\n                            Date\n                            <tablesortbuttons></tablesortbuttons>\n                          </div>\n                        </th>\n                        <th>\n                          <div class=\"th-inner\" st-sort=\"lastMessage.from_name\">\n                            From\n                            <tablesortbuttons></tablesortbuttons>\n                          </div>\n                        </th>\n                        <th>\n                          <div class=\"th-inner\" st-sort=\"totalCount\">\n                            Total\n                            <tablesortbuttons></tablesortbuttons>\n                          </div>\n                        </th>\n                        <th>\n                            <div class=\"th-inner\">\n                              View\n                            </div>\n                          </th>\n                        <!-- <th><span class=\"sr-only\">Actions</span></th> -->\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr ng-repeat=\"message in displayedMessages\"\n                      ng-class=\"{'unread': message.message_status === 'unread'}\">\n                        <td ng-if=\"messagesCtrl.$scope.currentUser.organization === 'MTC'\">\n                          {{message.jurisdiction}}\n                        </td>\n                        <td>\n                          {{message.station_name}}\n                        </td>\n                        <td>\n                          {{message.policy_type}}\n                        </td>\n                        <td>\n                          {{message.policy}}\n                        </td>\n                        <td>\n                              {{message.lastMessage.comment}}\n                          </td>\n\n                        <td>{{message.lastMessage.formattedUpdatedAt}}</td>\n                        <td>\n                          <a href=\"{{message.url}}\" class=\"policy-link\">\n                            {{message.lastMessage.from_name}}\n                          </a>\n                        </td>\n                        <td>\n                          <span class=\"status-pill\" ng-class=\"message.submission_status\">\n                            {{message.totalCount}}\n                          </span>\n                        </td>\n                        <td class=\"view-message\">\n                            <button class=\"btn btn-primary position-relative\" ng-click=\"showMessages(message)\">\n                                <i class=\"fa-solid fa-envelope\"></i>\n                                <span class=\"position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger\" ng-if=\"message.hasUnread\">\n                                    {{message.unreadCount}}\n                                    <span class=\"visually-hidden\">unread messages</span>\n                                </span>\n                            </button>\n                        </td>\n\n                      </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"footer\" role=\"contentinfo\">\n        <sidebarfooter></sidebarfooter>\n      </div>\n    </div>\n  </section>\n"

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessageDetailComponent = exports.MessageDetailComponent = function () {
	  /*@ngInject*/
	  function MessageDetailComponent($http, userService, $scope, $stateParams, $state, fetch, $timeout, lookup) {
	    _classCallCheck(this, MessageDetailComponent);
	
	    console.log('running init');
	    this.$http = $http;
	    this.userService = userService;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.message = $stateParams.messageData;
	    this.loading = false;
	    this.error = null;
	    this.currentUser = null;
	    this.fetch = fetch;
	    this.$timeout = $timeout;
	    this.replyMessage = '';
	    this.messageSent = false;
	    this.messageSentDialogPendingNavigation = false;
	    this.shouldNavigateAfterDialog = false;
	    this.lookup = lookup;
	    this.jurisdiction = null;
	    this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
	
	    console.log('running init');
	  }
	
	  _createClass(MessageDetailComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      console.log("state params", this.$stateParams);
	
	      if (this.$stateParams.data) {
	        this.$scope.chainData = this.$stateParams.data;
	        if (this.$scope.chainData.message_chain_id) {
	          this.$scope.message_chain_id = this.$scope.chainData.message_chain_id;
	        }
	        if (this.$scope.chainData.submission_id) {
	          this.$scope.submission_id = this.$scope.chainData.submission_id;
	        }
	      }
	
	      this.previousState = this.$stateParams.messageData || 'messages';
	      console.log(this.previousState);
	      this.loading = true;
	      this.userService.getCurrentUser().then(function (response) {
	        _this.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	
	        if (_this.$stateParams.submissionId) {
	          return _this.loadMessages(_this.$stateParams.submissionId, 'submission');
	        } else if (_this.$stateParams.message_chain_id) {
	          return _this.loadMessages(_this.$stateParams.message_chain_id, 'chain');
	        } else {
	          _this.error = 'No submission ID or message chain ID provided';
	          _this.loading = false;
	        }
	      }).catch(function (err) {
	        console.error('Error fetching current user:', err);
	        _this.error = 'Failed to load user data';
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'loadMessages',
	    value: function loadMessages(id, type) {
	      var _this2 = this;
	
	      console.log('Loading messages for ' + type + ':', id);
	      this.loading = true;
	
	      var endpoint = type === 'submission' ? 'api/messages/submission/' + id : 'api/messages/chain/' + id;
	
	      console.log("Endpoint:", endpoint);
	      return this.fetch.getAllItems(endpoint).then(function (response) {
	        console.log('Messages received:', response.data);
	        _this2.$timeout(function () {
	          if (type === 'submission') {
	            _this2.message = response.data[0];
	            if (_this2.message && _this2.message.messages) {
	              _this2.messages = _this2.message.messages;
	              _this2.jurisdiction = _this2.message.jurisdiction;
	            }
	          } else {
	            _this2.messages = response.data;
	            console.log(_this2.messages);
	          }
	          _this2.error = null;
	          _this2.loading = false;
	        });
	      }).catch(function (err) {
	        console.error('Error loading messages:', err);
	        _this2.$timeout(function () {
	          _this2.error = 'Failed to load messages';
	          _this2.loading = false;
	        });
	      });
	    }
	  }, {
	    key: 'fetchMessageDetails',
	    value: function fetchMessageDetails() {
	      var _this3 = this;
	
	      if (!this.$stateParams.submissionId) {
	        this.error = 'No message ID provided';
	        return;
	      }
	
	      this.loading = true;
	      return this.$http.get('api/messages/submission/' + this.$stateParams.submissionId).then(function (response) {
	        _this3.message = response.data;
	        _this3.error = null;
	      }).catch(function (err) {
	        console.error('Error fetching message details:', err);
	        _this3.error = 'Failed to load message details';
	      }).finally(function () {
	        _this3.loading = false;
	        if (!_this3.$scope.$$phase) {}
	      });
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.$state.go('messages');
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      if (!date) return '';
	      return new Date(date).toLocaleDateString('en-US', {
	        year: 'numeric',
	        month: 'short',
	        day: 'numeric',
	        hour: '2-digit',
	        minute: '2-digit'
	      });
	    }
	  }, {
	    key: 'submitReply',
	    value: function submitReply($event) {
	      var _this4 = this;
	
	      if ($event) {
	        $event.preventDefault();
	      }
	
	      if (!this.replyMessage) {
	        return;
	      }
	
	      var now = new Date();
	      var reply = {
	        from: this.currentUser.id,
	        comment: this.replyMessage.trim(),
	        created_at: now.toISOString(),
	        to_jurisdiction: this.jurisdiction,
	        submission_id: this.$scope.submission_id
	      };
	
	      if (this.$scope.chainData.message_chain_id) {
	        reply.message_chain_id = this.$scope.chainData.message_chain_id;
	      }
	
	      if (this.$scope.chainData.message_type) {
	        reply.message_type = this.$scope.chainData.message_type;
	      }
	
	      console.log(reply);
	
	      this.fetch.updateItem('api/messages', reply).then(function (response) {
	        console.log('Reply sent:', response.data);
	        _this4.$timeout(function () {
	          _this4.replyMessage = null;
	          _this4.messageSent = true;
	          _this4.shouldNavigateAfterDialog = true;
	        });
	      }).catch(function (err) {
	        console.error('Error sending reply:', err);
	        _this4.$timeout(function () {
	          _this4.error = 'Failed to send reply';
	        });
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.messageSent = false;
	      if (this.shouldNavigateAfterDialog) {
	        this.shouldNavigateAfterDialog = false;
	        this.$state.go(this.previousState);
	      }
	    }
	  }, {
	    key: 'handleMessageSentDialogClose',
	    value: function handleMessageSentDialogClose() {
	      this.closeModal();
	    }
	  }, {
	    key: 'groupMessagesByDate',
	    value: function groupMessagesByDate(messages) {
	      if (!messages) return {};
	
	      return messages.reduce(function (groups, message) {
	        var date = new Date(message.date).toLocaleDateString();
	        if (!groups[date]) {
	          groups[date] = [];
	        }
	        groups[date].push(message);
	        return groups;
	      }, {});
	    }
	  }, {
	    key: 'markAsRead',
	    value: function markAsRead(message) {
	      var _this5 = this;
	
	      console.log(message);
	      if (message.status === 'read') return;
	
	      return this.fetch.putItem('api/messages/' + message.notify_id + '/read', {
	        status: 'read'
	      }).then(function () {
	        message.status = 'read';
	      }).catch(function (err) {
	        console.error('Error marking message as read:', err);
	        _this5.error = 'Failed to mark message as read';
	      });
	    }
	  }, {
	    key: 'handleMarkAsRead',
	    value: function handleMarkAsRead(msg) {
	      var _this6 = this;
	
	      msg.read_at = new Date();
	
	
	      this.markAsRead(msg).catch(function () {
	        msg.read_at = null;
	        _this6.$scope.$apply();
	      });
	    }
	  }]);
	
	  return MessageDetailComponent;
	}();
	
	exports.default = angular.module('appApp.messageDetail', []).component('messageDetail', {
	  template: __webpack_require__(317),
	  controller: MessageDetailComponent
	}).name;

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  .message--section--row {\n    display: flex;\n    width: 100%;\n    align-items: flex-start;\n  margin-bottom: 1.5rem;\n}\n\n  .message--content {\n    flex: 0 0 70%;\n    max-width: 70%;\n    box-sizing: border-box;\n  }\n.message--content .message--header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n  .message--content .message--header--user {\n    display: flex;\n    justify-content: right;\n    align-items: center;\n    margin-bottom: 0.5rem;\n  }\n\n.message--content .message--from {\n  font-weight: 600;\n}\n\n.message--content .message--from span {\n  color: #666;\n  font-weight: normal;\n  margin-left: 0.5rem;\n}\n\n.message--content .message--actions .btn-link {\n  color: #336699;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n}\n\n.message--content .message--actions .btn-link:hover {\n  color: #264d73;\n  text-decoration: underline;\n}\n\n.message--content .message--actions .btn-link i {\n  margin-right: 0.25rem;\n}\n\n.message--content .message--body {\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.message--content .message--body p {\n  margin: 0;\n}\n\n/* Unread dot indicator */\n.unread-dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    background-color: #2196F3;\n    border-radius: 50%;\n    margin-right: 8px;\n}\n\n/* New badge */\n.badge-new {\n    background-color: #ff4081;\n    color: white;\n    font-size: 11px;\n    padding: 2px 6px;\n    border-radius: 12px;\n    margin-left: 8px;\n    font-weight: 500;\n    text-transform: uppercase;\n}\n\n/* Background color for unread messages directed to current user */\n.message--content.message--unread-to-me .message--body {\n    background-color: #f0f7ff;\n    border-left: 4px solid #2196F3;\n}\n\n/* Hover effect for unread messages directed to current user */\n.message--content.message--unread-to-me:hover .message--body {\n    background-color: #e3f2fd;\n    transition: background-color 0.2s ease;\n}\n\n/* Add subtle shadow to unread messages */\n.message--content.message--unread {\n    position: relative;\n}\n\n.message--content.message--unread .message--body {\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n/* Add icon indicator */\n.message--content.message--unread .message--from::after {\n    content: '\\f0e0'; /* envelope icon - requires Font Awesome */\n    font-family: 'FontAwesome';\n    color: #2196F3;\n    margin-left: 8px;\n    font-size: 14px;\n}\n\n/* Time stamp styling for unread */\n.message--content.message--unread .message--from span {\n    color: #2196F3;\n    font-weight: 500;\n}\n\n.message-form {\n    width: 100%;\n}\n\n.input-group {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n/*    max-width: 600px; */\n}\n\n.form-text {\n    width: auto;\n    flex: 1;\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.btn-submit {\n    background-color: #0056b3;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.btn-submit:hover {\n    background-color: #003d7a;\n    color: white;\n    transform: scale(1.05);\n}\n\n.btn-submit i {\n    font-size: 14px;\n}\n\n.message--content .message--date {\n    font-size: 0.75rem;  /* or 12px */\n    color: #999;\n    display: block;\n    margin-top: 0.5rem;\n    font-weight: normal;\n    font-style: italic;\n}\n\n/* Optional: Add animation for new messages */\n@keyframes highlight {\n    0% { background-color: #fff8e1; }\n    100% { background-color: #f0f7ff; }\n}\n\n.message--content.message--unread.new-message .message--body {\n    animation: highlight 1s ease-out;\n}\n\n.posted-by {\n    color: #666;\n    font-size: 0.875rem; /* or 12px */\n    font-weight: normal;\n}\n\n  .message--content.message--curr-user {\n    margin-left: auto;\n    /* ensure any old float is negated */\n    float: none !important;\n  }\n\n  .message--content.message--curr-user .message--body {\n    background-color: #eeffee;\n    margin-left: auto;\n    border-left: none;\n    border-right: 4px solid #00bd1f;\n    /* ensure any old float is negated */\n    float: none !important;\n  }\n\n  /* Hover effect for unread messages */\n  .message--content.message--curr-user:hover .message--body {\n    background-color: #e3fde3;\n    transition: background-color 0.2s ease;\n  }\n\n  /* Modal styles */\n  .modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1040;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .modal-dialog {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    max-width: 500px;\n    width: 90%;\n    z-index: 1050;\n  }\n\n  .modal-header {\n    padding: 1rem 1.5rem;\n    border-bottom: 1px solid #dee2e6;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .modal-title {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 500;\n  }\n\n  .modal-body {\n    padding: 1.5rem;\n  }\n\n  .modal-footer {\n    padding: 1rem 1.5rem;\n    border-top: 1px solid #dee2e6;\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n  }\n\n  .btn-close {\n    background: transparent;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: #000;\n    opacity: 0.5;\n  }\n\n  .btn-close:hover {\n    opacity: 1;\n  }\n\n</style>\n\n<section class=\"dashboard dashboard--page dashboard--messaging--single\">\n    <div class=\"page-wrapper\">\n      <div class=\"dashboard-header\">\n        <sidebarnav></sidebarnav>\n      </div>\n\n      <div class=\"main\">\n        <mainheaderauth></mainheaderauth>\n\n        <div id=\"maincontent\" class=\"content container\">\n          <!-- Loading State -->\n          <div ng-if=\"$ctrl.loading\" class=\"text-center p-4\">\n            <i class=\"fa-solid fa-spinner fa-spin\"></i> Loading message...\n          </div>\n\n          <!-- Error State -->\n          <div ng-if=\"$ctrl.error\" class=\"alert alert-danger\">\n            {{$ctrl.error}}\n          </div>\n\n          <div ng-if=\"!$ctrl.loading\" class=\"message-detail\">\n            <div class=\"back-to-messages col-lg-8\">\n                <a href=\"#\" class=\"link--back\"\n                ng-if=\"$ctrl.previousState === 'dashboard'\"\n                ui-sref=\"dashboard\">back to dashboard</a>\n\n                <a href=\"#\" class=\"link--back\"\n                ng-if=\"$ctrl.previousState === 'submissions'\"\n                ui-sref=\"submissions\">back to submissions</a>\n\n                <a href=\"#\" class=\"link--back\"\n                ng-if=\"$ctrl.previousState === 'messages'\"\n                ui-sref=\"messages\">back to messages</a>\n              </div>\n\n            <div class=\"message-container col-lg-8\">\n              <div class=\"message--status\">\n                <div class=\"status-pill\" ng-class=\"$ctrl.message.submission_status\">\n                  {{$ctrl.message.submission_status}}\n                </div>\n              </div>\n\n              <h1 class=\"page-title\">{{$ctrl.message.submission_policy_name}}</h1>\n\n              <!-- Message Sent Modal -->\n              <div ng-if=\"$ctrl.messageSent\" class=\"modal-backdrop\" ng-click=\"$ctrl.closeModal()\">\n                <div class=\"modal-dialog\" ng-click=\"$event.stopPropagation()\">\n                  <div class=\"modal-body\">\n                    <p>Your message has been sent</p>\n                    <button type=\"button\" class=\"btn btn-primary float-end\" ng-click=\"$ctrl.closeModal()\">OK</button>\n                  </div>\n                </div>\n              </div>\n\n              <!-- Reply Form -->\n              <div class=\"message message--submit\">\n                <form ng-submit=\"$ctrl.submitReply($event, $ctrl.messages[$ctrl.messages.length - 1])\" class=\"message-form\">\n                  <div class=\"input-group\">\n                    <input type=\"text\"\n                           ng-model=\"$ctrl.replyMessage\"\n                           size=\"50\"\n                           maxlength=\"128\"\n                           class=\"form-text\"\n                           placeholder=\"Write your message\">\n                    <button type=\"submit\" class=\"btn btn-submit\">\n                      <i class=\"fa-solid fa-paper-plane\"></i>\n                      Send\n                    </button>\n                  </div>\n                </form>\n              </div>\n\n              <!-- Group messages by date -->\n              <div class=\"message message--section\">\n                <div class=\"message--section--row\" ng-repeat=\"msg in $ctrl.messages\">\n                  <div class=\"message--content\" ng-class=\"{\n                    'message--unread': msg.read_at === null,\n                    'message--unread-to-me': msg.read_at === null && msg.to_jurisdiction === $ctrl.currentUser.organization,\n                    'message--read': msg.read_at !== null,\n                    'message--curr-user': msg.organization === $ctrl.currentUser.organization\n                  }\">\n                    <div ng-class=\"{\n                    'message--header': msg.organization !== $ctrl.currentUser.organization,\n                    'message--header--user': msg.organization === $ctrl.currentUser.organization\n                    }\">\n                      <div class=\"message--from\">\n                        {{msg.from_name}} | {{msg.organization}}\n                        <!-- Add NEW badge -->\n                        <span class=\"badge-new\" ng-if=\"msg.read_at === null && msg.to_jurisdiction === $ctrl.currentUser.organization\">New</span>\n                      </div>\n                      <div class=\"message--actions\" ng-if=\"msg.read_at === null && msg.to_jurisdiction === $ctrl.currentUser.organization\">\n                        <button class=\"btn btn-link btn-sm\"\n                                ng-click=\"$ctrl.markAsRead(msg); $ctrl.handleMarkAsRead(msg)\"\n                                title=\"Mark as Read\">\n                          <i class=\"fa-solid fa-check\"></i> Mark as Read\n                        </button>\n                      </div>\n                    </div>\n                    <div class=\"message--body\">\n                      <!-- Add left border indicator -->\n                      <p>{{msg.comment}}</p>\n                      <small class=\"message--date\">{{$ctrl.formatDate(msg.created_at)}}</small>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"footer\" role=\"contentinfo\">\n        <sidebarfooter></sidebarfooter>\n      </div>\n    </div>\n  </section>\n"

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessageComponent = undefined;
	
	var _message = __webpack_require__(319);
	
	var _message2 = _interopRequireDefault(_message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var MessageComponent =
	/*@ngInject*/
	exports.MessageComponent = function MessageComponent() {
	  _classCallCheck(this, MessageComponent);
	
	  this.message = 'Hello';
	};
	
	exports.default = angular.module('appApp.message', [uiRouter]).config(_message2.default).component('message', {
	  template: __webpack_require__(320),
	  controller: MessageComponent,
	  controllerAs: 'messageCtrl'
	}).name;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('message', {
	    url: '/account/message',
	    template: '<message></message>'
	  });
	};

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--messaging--single\">\n    <div class=\"page-wrapper\">\n    \n        <div class=\"dashboard-header\">\n            <sidebarnav></sidebarnav>\n        </div>\n    \n        <div class=\"main\">\n            <mainheaderauth></mainheaderauth>\n    \n            <div class=\"content container\">\n                <div class=\"row\">\n                    <div class=\"back-to-messages col\">\n                        <a href=\"#\" class=\"link--back\">Back to Messages</a>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-lg-8 col-md-12\">\n                        <div class=\"d-inline-flex gap-3\">\n                            <div class=\"message--status\">\n                                <b>Status:</b>\n                                &nbsp;\n                                <div class=\"status-pill status-pill--needs-work\">Needs Work</div>\n                            </div>\n                            <div class=\"message--status\">\n                                <b>Topic:</b>\n                                &nbsp;\n                                <span>Housing Policies</span>\n                            </div>\n                        </div>\n                        <h1 class=\"page-title\">Affordable Housing Production Policy</h1>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"message-container col-lg-8 col-md-12\">\n                            <div class=\"message message--section\">\n                                <div class=\"message--section--heading\">Oct 7, 2023</div>\n                                <div class=\"message--section--row\">\n                                    <div class=\"message--content\">\n                                        <div class=\"message--from\">Admin<span>11:04 am</span></div>\n                                        <div class=\"message--body\">\n                                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"message--section--row\">\n                                    <div class=\"message--content\">\n                                        <div class=\"message--from\">Ricky Smith<span>4:42 pm</span></div>\n                                        <div class=\"message--body\">\n                                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"message message--section\">\n                                <div class=\"message--section--heading\">Oct 2, 2023</div>\n                                <div class=\"message--section--row\">\n                                    <div class=\"message--content\">\n                                        <div class=\"message--from\">Admin <span>11:04 am</span></div>\n                                        <div class=\"message--body\">\n                                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"message--section--row\">\n                                    <div class=\"message--content\">\n                                        <div class=\"message--from\">Admin <span>11:04 am</span></div>\n                                        <div class=\"message--body\">\n                                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <form>\n                                <div class=\"input-group form-input form-item form-item--message\" style=\"--bs-border-color: #7F979F;\">\n                                    <input type=\"text\" id=\"reply\" name=\"reply\" size=\"60\" maxlength=\"128\" class=\"form-control form-text border-end-0\" placeholder=\"Write your message\">\n                                    <button class=\"btn border-start-0\" style=\"--bs-btn-padding-x: 24px; --bs-btn-color: #00303F; --bs-btn-bg: #FFF; --bs-btn-border-color: var(--bs-border-color); --bs-btn-hover-border-color: var(--bs-btn-border-color); --bs-btn-active-border-color: var(--bs-btn-border-color); --bs-btn-active-bg: \"><i class=\"fa-light fa-paper-plane-top\"></i></button>\n                                </div>\n                            </form>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"footer\" role=\"contentinfo\">\n            <sidebarfooter></sidebarfooter>\n        </div>\n    </div>\n    </section>"

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ZoningUpdatesComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _zoning_updates = __webpack_require__(322);
	
	var _zoning_updates2 = _interopRequireDefault(_zoning_updates);
	
	var _jszip = __webpack_require__(323);
	
	var _jszip2 = _interopRequireDefault(_jszip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ZoningUpdatesComponent = exports.ZoningUpdatesComponent = function () {
	  /*@ngInject*/
	  function ZoningUpdatesComponent($state, $scope, $rootScope, fetch, lookup, userService, $timeout, baseConfigService, $http, $stateParams) {
	    _classCallCheck(this, ZoningUpdatesComponent);
	
	    this.$scope = $scope;
	    this.fetch = fetch;
	    this.$state = $state;
	    this.lookup = lookup;
	    this.userService = userService;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$http = $http;
	    this.baseConfigService = baseConfigService;
	
	    $scope.attachmentData = $scope.attachmentData || {};
	    $scope.submissions = [];
	    $scope.savemode = null;
	    $scope.baseUrl = baseConfigService.getBaseURL();
	
	    $scope.submitmode = null;
	
	    $scope.pendingChanges = false;
	    $scope.showPanel = null;
	
	    $scope.togglePanel = function (panelName) {
	      $scope.showPanel = panelName;
	    };
	
	    $scope.setPending = function () {
	      $scope.savemode = 'zoningUpdates';
	      $scope.pendingChanges = true;
	    };
	
	    $scope.$watch('currentZoningForm', function (newVal) {
	      if (newVal) {
	        if (newVal.dataset_date_last_updated && typeof newVal.dataset_date_last_updated === 'string') {
	          $scope.currentZoningForm.dataset_date_last_updated = new Date(newVal.dataset_date_last_updated);
	        }
	
	        if (newVal.map_date_last_updated && typeof newVal.map_date_last_updated === 'string') {
	          $scope.currentZoningForm.map_date_last_updated = new Date(newVal.map_date_last_updated);
	        }
	      }
	    }, true);
	
	    $scope.addToSubmissions = function (submission) {
	      var index = $scope.submissions.indexOf(submission);
	      if (index > -1) {
	        $scope.submissions.splice(index, 1);
	      } else {
	        $scope.submissions.push(submission);
	      }
	
	      if ($scope.submissions.length > 0) {
	        $scope.submitmode = 'zoningUpdates';
	      } else {
	        $scope.submitmode = null;
	      }
	    };
	
	    $scope.getStationbyID = function (station) {
	
	      if (station) {
	        $scope.currentSelectedStationId = station;
	        lookup.setCurrentStation(station);
	      }
	      fetch.getItem('api/data/submissions/' + $scope.currentJurisdiction, 'Zoning').then(function (response) {
	
	        console.log(response.data);
	        $scope.zoningUpdates = _.filter(response.data, { submission_policy_name: 'Jurisdiction Zoning Updates' });
	        if ($scope.zoningUpdates.length > 0) {
	          $scope.zoningUpdates.forEach(function (element) {
	            if (element.submitted == true) {
	              $scope.zoningUpdatesCheck = true;
	            }
	          });
	        }
	        if ($scope.zoningUpdates.length > 0) {
	          $scope.rec_id = $scope.zoningUpdates[0].rec_id;
	          $scope.getCurrentZoningForm($scope.rec_id);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getStationAreaList = function (jurisdiction) {
	      lookup.setJurisdiction(jurisdiction);
	      fetch.getAllItems('api/data/stationareas/' + jurisdiction).then(function (response) {
	
	        $scope.stationAreas = response.data;
	        if (lookup.getCurrentStation()) {
	          $scope.currentSelectedStationId = lookup.getCurrentStation();
	          $scope.getStationbyID($scope.currentSelectedStationId);
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.getCurrentZoningForm = function (rec_id) {
	      if (rec_id) {
	        $scope.rec_id = rec_id;
	      }
	
	      fetch.getAllItems('api/data/getZoningForm/' + $scope.currentJurisdiction).then(function (response) {
	
	        $scope.currentZoningForm = response.data[0];
	
	        if ($scope.currentZoningForm && $scope.currentZoningForm.dataset_types) {
	          $scope.updateDatasetTypes();
	        }
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.updateDatasetTypes = function () {
	      var selected = [];
	      if ($scope.currentZoningForm.dataset_types.general_plan) {
	        selected.push('General Plan');
	      }
	      if ($scope.currentZoningForm.dataset_types.specific_plan) {
	        selected.push('Specific Plan');
	      }
	      if ($scope.currentZoningForm.dataset_types.zoning) {
	        selected.push('Zoning');
	      }
	      if ($scope.currentZoningForm.dataset_types.other) {
	        selected.push('Other');
	      }
	      $scope.currentZoningForm.dataset_type = selected.join(', ');
	      console.log('updateDatasetTypes called', $scope.currentZoningForm.dataset_type);
	      $scope.setPending();
	    };
	
	    $scope.hasSelectedDatasetType = function () {
	      if (!$scope.currentZoningForm || !$scope.currentZoningForm.dataset_types) {
	        return false;
	      }
	      return $scope.currentZoningForm.dataset_types.general_plan || $scope.currentZoningForm.dataset_types.specific_plan || $scope.currentZoningForm.dataset_types.zoning || $scope.currentZoningForm.dataset_types.other;
	    };
	
	    $scope.hasOtherPlusOtherOptions = function () {
	      if (!$scope.currentZoningForm || !$scope.currentZoningForm.dataset_types) {
	        return false;
	      }
	      var types = $scope.currentZoningForm.dataset_types;
	      var nonOtherCount = 0;
	
	      if (types.general_plan) nonOtherCount++;
	      if (types.specific_plan) nonOtherCount++;
	      if (types.zoning) nonOtherCount++;
	
	      return types.other && nonOtherCount >= 1;
	    };
	
	    $scope.hasMultipleNonOtherOptions = function () {
	      if (!$scope.currentZoningForm || !$scope.currentZoningForm.dataset_types) {
	        return false;
	      }
	      var types = $scope.currentZoningForm.dataset_types;
	      var nonOtherCount = 0;
	
	      if (types.general_plan) nonOtherCount++;
	      if (types.specific_plan) nonOtherCount++;
	      if (types.zoning) nonOtherCount++;
	
	      return !types.other && nonOtherCount >= 2;
	    };
	
	    $scope.hasOtherOrSingleOption = function () {
	      if (!$scope.currentZoningForm || !$scope.currentZoningForm.dataset_types) {
	        return false;
	      }
	      var types = $scope.currentZoningForm.dataset_types;
	      var totalCount = 0;
	
	      if (types.general_plan) totalCount++;
	      if (types.specific_plan) totalCount++;
	      if (types.zoning) totalCount++;
	      if (types.other) totalCount++;
	
	      return types.other || totalCount === 1;
	    };
	
	    $scope.updateMapDates = function () {
	      var dates = [];
	      if ($scope.currentZoningForm.map_date_general_plan) dates.push($scope.currentZoningForm.map_date_general_plan);
	      if ($scope.currentZoningForm.map_date_specific_plan) dates.push($scope.currentZoningForm.map_date_specific_plan);
	      if ($scope.currentZoningForm.map_date_zoning) dates.push($scope.currentZoningForm.map_date_zoning);
	      if ($scope.currentZoningForm.map_date_other) dates.push($scope.currentZoningForm.map_date_other);
	
	      $scope.currentZoningForm.map_date_last_updated = dates.join(', ');
	      $scope.setPending();
	    };
	
	    $scope.updateDatasetDates = function () {
	      var dates = [];
	      if ($scope.currentZoningForm.dataset_date_general_plan) dates.push($scope.currentZoningForm.dataset_date_general_plan);
	      if ($scope.currentZoningForm.dataset_date_specific_plan) dates.push($scope.currentZoningForm.dataset_date_specific_plan);
	      if ($scope.currentZoningForm.dataset_date_zoning) dates.push($scope.currentZoningForm.dataset_date_zoning);
	
	      $scope.currentZoningForm.dataset_date_last_updated = dates.join(', ');
	      $scope.setPending();
	    };
	
	    $scope.updateDatasetUrls = function () {
	      var dates = [];
	      if ($scope.currentZoningForm.dataset_url_general_plan) dates.push($scope.currentZoningForm.dataset_url_general_plan);
	      if ($scope.currentZoningForm.dataset_url_specific_plan) dates.push($scope.currentZoningForm.dataset_url_specific_plan);
	      if ($scope.currentZoningForm.dataset_url_zoning) dates.push($scope.currentZoningForm.dataset_url_zoning);
	      if ($scope.currentZoningForm.dataset_url_other) dates.push($scope.currentZoningForm.dataset_url_other);
	
	      $scope.currentZoningForm.dataset_url = dates.join(', ');
	      $scope.setPending();
	    };
	
	    $scope.updateZoningForm = function () {
	      console.log("Form Data Before Sending:", $scope.currentZoningForm);
	
	      $scope.formSubmitted = true;
	      if (zoningForm.$invalid) {
	        $scope.saving = false;
	        return;
	      }
	
	      Object.keys($scope.currentZoningForm).forEach(function (key) {
	        if ($scope.currentZoningForm[key] === "" || $scope.currentZoningForm[key] === undefined) {
	          $scope.currentZoningForm[key] = null;
	        }
	      });
	
	      console.log("Payload being sent:", $scope.currentZoningForm);
	      fetch.updateItem('api/data/zoning-updates/forms/update', $scope.currentZoningForm).then(function (response) {
	        $scope.saved = true;
	        $scope.saving = false;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.savemode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 4000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.submitZoningUpdates = function () {
	      $scope.formSubmitted = true;
	      $scope.saving = true;
	      var upsertData = [];
	
	      $scope.upsertData = [];
	
	      if ($scope.zoningUpdatesCheck && $scope.zoningUpdates.length > 0) {
	        $scope.zoningUpdates.forEach(function (element) {
	          if (!element.submitted) {
	            element.submitted = true;
	            upsertData.push({
	              submission_id: element.submission_id,
	              zoning_submissions_form: true,
	              submitted: true
	            });
	          }
	        });
	      }
	      fetch.updateItem('api/data/submissions/update', upsertData).then(function (response) {
	
	        $scope.saving = false;
	        $scope.submissions = [];
	        $scope.saved = true;
	        $scope.pendingChanges = false;
	        setTimeout(function () {
	          $scope.submitmode = null;
	          $scope.saved = false;
	          $scope.$apply();
	        }, 2000);
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          $state.go('login');
	        }
	      });
	    };
	
	    $scope.selectedFile = null;
	
	    $scope.handleFileSelect = function (element) {
	      console.log(element);
	      $scope.setPending();
	      $scope.$apply(function () {
	        $scope.selectedFiles = Array.from(element.files);
	        $scope.selectedFile = element.files[0];
	      });
	    };
	
	    $scope.uploadFile = function (ngmodelfile) {
	      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	      console.log(ngmodel);
	
	      if (!$scope.selectedFiles || $scope.selectedFiles.length === 0) {
	        console.error('No files selected');
	        return;
	      }
	
	      $scope['fileUploading_' + ngmodelfile] = true;
	
	      var zip = new _jszip2.default();
	
	      var promises = $scope.selectedFiles.map(function (file) {
	        return new Promise(function (resolve, reject) {
	          var reader = new FileReader();
	          reader.onload = function (e) {
	            var relativePath = file.webkitRelativePath || file.name;
	            zip.file(relativePath, e.target.result);
	            resolve();
	          };
	          reader.onerror = reject;
	          reader.readAsArrayBuffer(file);
	        });
	      });
	
	      Promise.all(promises).then(function () {
	        return zip.generateAsync({ type: 'blob' });
	      }).then(function (zipBlob) {
	        var jurisdictionName = $scope.currentJurisdiction ? $scope.currentJurisdiction.replace(/\s+/g, '_') : 'jurisdiction';
	        var zipFileName = jurisdictionName + '_' + ngmodel + '.zip';
	
	        var zipFile = new File([zipBlob], zipFileName, { type: 'application/zip' });
	
	        var fileUpload = {
	          fileName: zipFile.name,
	          fileType: zipFile.type
	        };
	
	        return fetch.updateItem('api/data/get-signed-url', fileUpload).then(function (response) {
	          console.log('Signed URL:', response.data.signedUrl);
	          console.log('Public URL:', response.data.publicUrl);
	
	          return $http({
	            method: 'PUT',
	            url: response.data.signedUrl,
	            data: zipFile,
	            headers: {
	              'Content-Type': zipFile.type
	            }
	          }).then(function () {
	            $scope.currentZoningForm[ngmodel] = response.data.publicUrl;
	            return response.data.publicUrl;
	          });
	        });
	      }).then(function (publicUrl) {
	        console.log('Upload successful');
	        console.log('Public URL:', publicUrl);
	
	        $scope['fileUploading_' + ngmodelfile] = false;
	        $scope['' + ngmodelfile] = '';
	        $scope.clearFile(ngmodelfile);
	        $scope.uploadSuccess = true;
	        $scope.selectedFiles = null;
	        $scope.selectedFile = null;
	      }).catch(function (error) {
	        console.error('Error:', error);
	        alert('Upload failed');
	        $scope['fileUploading_' + ngmodelfile] = false;
	      });
	    };
	
	    $scope.clearFile = function (ngmodelfile) {
	      var fileInput = document.getElementById(ngmodelfile);
	      if (fileInput) {
	        fileInput.value = '';
	        $scope.selectedFiles = null;
	        $scope.selectedFile = null;
	      }
	    };
	
	    $scope.checkSubstring = function (input) {
	      return input && input.length >= 4 && input.substring(0, 4) === 'http';
	    };
	
	    $scope.removeFile = function (ngmodel) {
	      console.log(ngmodel);
	      $scope.currentZoningForm[ngmodel] = '';
	      $scope.setPending();
	      $scope.savemode = 'zoningUpdates';
	      $scope.pendingChanges = true;
	    };
	  }
	
	  _createClass(ZoningUpdatesComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.userService.getCurrentUser().then(function (response) {
	
	        _this.$scope.currentUser = response.data;
	        _this.userService.setCurrentUser(response.data);
	        _this.$scope.currentZoningForm = {};
	        _this.$scope.currentZoningForm.dataset_types = {
	          general_plan: false,
	          specific_plan: false,
	          zoning: false,
	          other: false
	        };
	        return _this.getJurisdictionList();
	      }).catch(function (err) {
	        console.log(err);
	        if (err.status === 403) {
	          _this.$state.go('login');
	        }
	      });
	    }
	  }, {
	    key: 'getJurisdictionList',
	    value: function getJurisdictionList() {
	      var _this2 = this;
	
	      this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list').then(function (response) {
	        _this2.$scope.loading = false;
	        _this2.$scope.jurisdictions = response.data;
	
	        if (_this2.$scope.currentUser.role === 'Administrator') {
	          console.log("admin");
	
	          var jurisdictionParam = _this2.$stateParams.jurisdiction;
	          console.log(_this2.$stateParams);
	          if (jurisdictionParam) {
	            _this2.$scope.currentJurisdiction = jurisdictionParam;
	          } else if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        } else {
	          if (_this2.lookup.getJurisdiction()) {
	            _this2.$scope.currentJurisdiction = _this2.lookup.getJurisdiction();
	          } else {
	            _this2.$scope.currentJurisdiction = _this2.$scope.jurisdictions[0].jurisdiction;
	          }
	        }
	        console.log(_this2.$scope.currentJurisdiction);
	        _this2.lookup.setJurisdiction(_this2.$scope.currentJurisdiction);
	        _this2.$scope.getStationAreaList(_this2.$scope.currentJurisdiction);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }]);
	
	  return ZoningUpdatesComponent;
	}();
	
	exports.default = angular.module('websiteApp.zoning_updates', [uiRouter]).config(_zoning_updates2.default).component('zoningUpdates', {
	  template: __webpack_require__(396),
	  controller: ZoningUpdatesComponent,
	  controllerAs: 'zoningUpdatesCtrl'
	}).name;

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('zoning_updates', {
	    url: '/account/zoning_updates?jurisdiction&sta_recid',
	    template: '<zoning-updates></zoning-updates>',
	    authenticate: true,
	    params: {
	      jurisdiction: null,
	      sta_recid: null
	    }
	  });
	};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 */
	function JSZip() {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) {
	        return new JSZip();
	    }
	
	    if(arguments.length) {
	        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
	    }
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    // NOTE: we use a null prototype because we do not
	    // want filenames like "toString" coming from a zip file
	    // to overwrite methods and attributes in a normal Object.
	    this.files = Object.create(null);
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = __webpack_require__(324);
	JSZip.prototype.loadAsync = __webpack_require__(387);
	JSZip.support = __webpack_require__(327);
	JSZip.defaults = __webpack_require__(358);
	
	// TODO find a better way to handle this version,
	// a require('package.json').version doesn't work with webpack, see #327
	JSZip.version = "3.10.1";
	
	JSZip.loadAsync = function (content, options) {
	    return new JSZip().loadAsync(content, options);
	};
	
	JSZip.external = __webpack_require__(350);
	module.exports = JSZip;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var utf8 = __webpack_require__(325);
	var utils = __webpack_require__(326);
	var GenericWorker = __webpack_require__(354);
	var StreamHelper = __webpack_require__(355);
	var defaults = __webpack_require__(358);
	var CompressedObject = __webpack_require__(359);
	var ZipObject = __webpack_require__(364);
	var generate = __webpack_require__(365);
	var nodejsUtils = __webpack_require__(349);
	var NodejsStreamInputAdapter = __webpack_require__(386);
	
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} originalOptions the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, originalOptions) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	
	    /*
	     * Correct options.
	     */
	
	    var o = utils.extend(originalOptions || {}, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) {
	        o.compression = o.compression.toUpperCase();
	    }
	
	    if (typeof o.unixPermissions === "string") {
	        o.unixPermissions = parseInt(o.unixPermissions, 8);
	    }
	
	    // UNX_IFDIR  0040000 see zipinfo.c
	    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
	        o.dir = true;
	    }
	    // Bit 4    Directory
	    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
	        o.dir = true;
	    }
	
	    if (o.dir) {
	        name = forceTrailingSlash(name);
	    }
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
	    if (!originalOptions || typeof originalOptions.binary === "undefined") {
	        o.binary = !isUnicodeString;
	    }
	
	
	    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;
	
	    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
	        o.base64 = false;
	        o.binary = true;
	        data = "";
	        o.compression = "STORE";
	        dataType = "string";
	    }
	
	    /*
	     * Convert content to fit.
	     */
	
	    var zipObjectContent = null;
	    if (data instanceof CompressedObject || data instanceof GenericWorker) {
	        zipObjectContent = data;
	    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
	        zipObjectContent = new NodejsStreamInputAdapter(name, data);
	    } else {
	        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
	    }
	
	    var object = new ZipObject(name, zipObjectContent, o);
	    this.files[name] = object;
	    /*
	    TODO: we can't throw an exception because we have async promises
	    (we can have a promise of a Date() for example) but returning a
	    promise is useless because file(name, data) returns the JSZip
	    object for chaining. Should we break that to allow the user
	    to catch the error ?
	
	    return external.Promise.resolve(zipObjectContent)
	    .then(function () {
	        return object;
	    });
	    */
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) === "/") {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf("/");
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	/**
	 * Returns the path with a slash at the end.
	 * @private
	 * @param {String} path the path to check.
	 * @return {String} the path with a trailing slash.
	 */
	var forceTrailingSlash = function(path) {
	    // Check the name ends with a /
	    if (path.slice(-1) !== "/") {
	        path += "/"; // IE doesn't like substr(-1)
	    }
	    return path;
	};
	
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    createFolders = (typeof createFolders !== "undefined") ? createFolders : defaults.createFolders;
	
	    name = forceTrailingSlash(name);
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	function isRegExp(object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	}
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * @see loadAsync
	     */
	    load: function() {
	        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	    },
	
	
	    /**
	     * Call a callback function for each entry at this folder level.
	     * @param {Function} cb the callback function:
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     */
	    forEach: function(cb) {
	        var filename, relativePath, file;
	        // ignore warning about unwanted properties because this.files is a null prototype object
	        /* eslint-disable-next-line guard-for-in */
	        for (filename in this.files) {
	            file = this.files[filename];
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
	                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
	            }
	        }
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [];
	        this.forEach(function (relativePath, entry) {
	            if (search(relativePath, entry)) { // the file matches the function
	                result.push(entry);
	            }
	
	        });
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                var obj = this.files[this.root + name];
	                if (obj && !obj.dir) {
	                    return obj;
	                } else {
	                    return null;
	                }
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) !== "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * @deprecated This method has been removed in JSZip 3.0, please check the upgrade guide.
	     */
	    generate: function() {
	        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	    },
	
	    /**
	     * Generate the complete zip file as an internal stream.
	     * @param {Object} options the options to generate the zip file :
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {StreamHelper} the streamed zip file.
	     */
	    generateInternalStream: function(options) {
	        var worker, opts = {};
	        try {
	            opts = utils.extend(options || {}, {
	                streamFiles: false,
	                compression: "STORE",
	                compressionOptions : null,
	                type: "",
	                platform: "DOS",
	                comment: null,
	                mimeType: "application/zip",
	                encodeFileName: utf8.utf8encode
	            });
	
	            opts.type = opts.type.toLowerCase();
	            opts.compression = opts.compression.toUpperCase();
	
	            // "binarystring" is preferred but the internals use "string".
	            if(opts.type === "binarystring") {
	                opts.type = "string";
	            }
	
	            if (!opts.type) {
	                throw new Error("No output type specified.");
	            }
	
	            utils.checkSupport(opts.type);
	
	            // accept nodejs `process.platform`
	            if(
	                opts.platform === "darwin" ||
	                opts.platform === "freebsd" ||
	                opts.platform === "linux" ||
	                opts.platform === "sunos"
	            ) {
	                opts.platform = "UNIX";
	            }
	            if (opts.platform === "win32") {
	                opts.platform = "DOS";
	            }
	
	            var comment = opts.comment || this.comment || "";
	            worker = generate.generateWorker(this, opts, comment);
	        } catch (e) {
	            worker = new GenericWorker("error");
	            worker.error(e);
	        }
	        return new StreamHelper(worker, opts.type || "string", opts.mimeType);
	    },
	    /**
	     * Generate the complete zip file asynchronously.
	     * @see generateInternalStream
	     */
	    generateAsync: function(options, onUpdate) {
	        return this.generateInternalStream(options).accumulate(onUpdate);
	    },
	    /**
	     * Generate the complete zip file asynchronously.
	     * @see generateInternalStream
	     */
	    generateNodeStream: function(options, onUpdate) {
	        options = options || {};
	        if (!options.type) {
	            options.type = "nodebuffer";
	        }
	        return this.generateInternalStream(options).toNodejsStream(onUpdate);
	    }
	};
	module.exports = out;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(326);
	var support = __webpack_require__(327);
	var nodejsUtils = __webpack_require__(349);
	var GenericWorker = __webpack_require__(354);
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	    _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodejsUtils.newBufferFrom(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    return buf2string(buf);
	};
	
	/**
	 * A worker to decode utf8 encoded binary chunks into string chunks.
	 * @constructor
	 */
	function Utf8DecodeWorker() {
	    GenericWorker.call(this, "utf-8 decode");
	    // the last bytes if a chunk didn't end with a complete codepoint.
	    this.leftOver = null;
	}
	utils.inherits(Utf8DecodeWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Utf8DecodeWorker.prototype.processChunk = function (chunk) {
	
	    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);
	
	    // 1st step, re-use what's left of the previous chunk
	    if (this.leftOver && this.leftOver.length) {
	        if(support.uint8array) {
	            var previousData = data;
	            data = new Uint8Array(previousData.length + this.leftOver.length);
	            data.set(this.leftOver, 0);
	            data.set(previousData, this.leftOver.length);
	        } else {
	            data = this.leftOver.concat(data);
	        }
	        this.leftOver = null;
	    }
	
	    var nextBoundary = utf8border(data);
	    var usableData = data;
	    if (nextBoundary !== data.length) {
	        if (support.uint8array) {
	            usableData = data.subarray(0, nextBoundary);
	            this.leftOver = data.subarray(nextBoundary, data.length);
	        } else {
	            usableData = data.slice(0, nextBoundary);
	            this.leftOver = data.slice(nextBoundary, data.length);
	        }
	    }
	
	    this.push({
	        data : exports.utf8decode(usableData),
	        meta : chunk.meta
	    });
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	Utf8DecodeWorker.prototype.flush = function () {
	    if(this.leftOver && this.leftOver.length) {
	        this.push({
	            data : exports.utf8decode(this.leftOver),
	            meta : {}
	        });
	        this.leftOver = null;
	    }
	};
	exports.Utf8DecodeWorker = Utf8DecodeWorker;
	
	/**
	 * A worker to endcode string chunks into utf8 encoded binary chunks.
	 * @constructor
	 */
	function Utf8EncodeWorker() {
	    GenericWorker.call(this, "utf-8 encode");
	}
	utils.inherits(Utf8EncodeWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Utf8EncodeWorker.prototype.processChunk = function (chunk) {
	    this.push({
	        data : exports.utf8encode(chunk.data),
	        meta : chunk.meta
	    });
	};
	exports.Utf8EncodeWorker = Utf8EncodeWorker;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var support = __webpack_require__(327);
	var base64 = __webpack_require__(348);
	var nodejsUtils = __webpack_require__(349);
	var external = __webpack_require__(350);
	__webpack_require__(353);
	
	
	/**
	 * Convert a string that pass as a "binary string": it should represent a byte
	 * array but may have > 255 char codes. Be sure to take only the first byte
	 * and returns the byte array.
	 * @param {String} str the string to transform.
	 * @return {Array|Uint8Array} the string in a binary format.
	 */
	function string2binary(str) {
	    var result = null;
	    if (support.uint8array) {
	        result = new Uint8Array(str.length);
	    } else {
	        result = new Array(str.length);
	    }
	    return stringToArrayLike(str, result);
	}
	
	/**
	 * Create a new blob with the given content and the given type.
	 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
	 * an Uint8Array because the stock browser of android 4 won't accept it (it
	 * will be silently converted to a string, "[object Uint8Array]").
	 *
	 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
	 * when a large amount of Array is used to create the Blob, the amount of
	 * memory consumed is nearly 100 times the original data amount.
	 *
	 * @param {String} type the mime type of the blob.
	 * @return {Blob} the created blob.
	 */
	exports.newBlob = function(part, type) {
	    exports.checkSupport("blob");
	
	    try {
	        // Blob constructor
	        return new Blob([part], {
	            type: type
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(part);
	            return builder.getBlob(type);
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * An helper for the function arrayLikeToString.
	 * This contains static information and functions that
	 * can be optimized by the browser JIT compiler.
	 */
	var arrayToStringHelper = {
	    /**
	     * Transform an array of int into a string, chunk by chunk.
	     * See the performances notes on arrayLikeToString.
	     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	     * @param {String} type the type of the array.
	     * @param {Integer} chunk the chunk size.
	     * @return {String} the resulting string.
	     * @throws Error if the chunk is too big for the stack.
	     */
	    stringifyByChunk: function(array, type, chunk) {
	        var result = [], k = 0, len = array.length;
	        // shortcut
	        if (len <= chunk) {
	            return String.fromCharCode.apply(null, array);
	        }
	        while (k < len) {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        return result.join("");
	    },
	    /**
	     * Call String.fromCharCode on every item in the array.
	     * This is the naive implementation, which generate A LOT of intermediate string.
	     * This should be used when everything else fail.
	     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	     * @return {String} the result.
	     */
	    stringifyByChar: function(array){
	        var resultStr = "";
	        for(var i = 0; i < array.length; i++) {
	            resultStr += String.fromCharCode(array[i]);
	        }
	        return resultStr;
	    },
	    applyCanBeUsed : {
	        /**
	         * true if the browser accepts to use String.fromCharCode on Uint8Array
	         */
	        uint8array : (function () {
	            try {
	                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
	            } catch (e) {
	                return false;
	            }
	        })(),
	        /**
	         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
	         */
	        nodebuffer : (function () {
	            try {
	                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
	            } catch (e) {
	                return false;
	            }
	        })()
	    }
	};
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    // TODO : we now have workers that split the work. Do we still need that ?
	    var chunk = 65536,
	        type = exports.getTypeOf(array),
	        canUseApply = true;
	    if (type === "uint8array") {
	        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
	    } else if (type === "nodebuffer") {
	        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
	    }
	
	    if (canUseApply) {
	        while (chunk > 1) {
	            try {
	                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
	            } catch (e) {
	                chunk = Math.floor(chunk / 2);
	            }
	        }
	    }
	
	    // no apply or chunk error : slow and painful algorithm
	    // default browser on android 4.*
	    return arrayToStringHelper.stringifyByChar(array);
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Resolve all relative path components, "." and "..", in a path. If these relative components
	 * traverse above the root then the resulting path will only contain the final path component.
	 *
	 * All empty components, e.g. "//", are removed.
	 * @param {string} path A path with / or \ separators
	 * @returns {string} The path with all relative path components resolved.
	 */
	exports.resolve = function(path) {
	    var parts = path.split("/");
	    var result = [];
	    for (var index = 0; index < parts.length; index++) {
	        var part = parts[index];
	        // Allow the first and last component to be empty for trailing slashes.
	        if (part === "." || (part === "" && index !== 0 && index !== parts.length - 1)) {
	            continue;
	        } else if (part === "..") {
	            result.pop();
	        } else {
	            result.push(part);
	        }
	    }
	    return result.join("/");
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this platform");
	    }
	};
	
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = "",
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += "\\x" + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Defer the call of a function.
	 * @param {Function} callback the function to call asynchronously.
	 * @param {Array} args the arguments to give to the callback.
	 */
	exports.delay = function(callback, args, self) {
	    setImmediate(function () {
	        callback.apply(self || null, args || []);
	    });
	};
	
	/**
	 * Extends a prototype with an other, without calling a constructor with
	 * side effects. Inspired by nodejs' `utils.inherits`
	 * @param {Function} ctor the constructor to augment
	 * @param {Function} superCtor the parent constructor to use
	 */
	exports.inherits = function (ctor, superCtor) {
	    var Obj = function() {};
	    Obj.prototype = superCtor.prototype;
	    ctor.prototype = new Obj();
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	exports.extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (Object.prototype.hasOwnProperty.call(arguments[i], attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transform arbitrary content into a Promise.
	 * @param {String} name a name for the content being processed.
	 * @param {Object} inputData the content to process.
	 * @param {Boolean} isBinary true if the content is not an unicode string
	 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
	 * @param {Boolean} isBase64 true if the string content is encoded with base64.
	 * @return {Promise} a promise in a format usable by JSZip.
	 */
	exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {
	
	    // if inputData is already a promise, this flatten it.
	    var promise = external.Promise.resolve(inputData).then(function(data) {
	
	
	        var isBlob = support.blob && (data instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(data)) !== -1);
	
	        if (isBlob && typeof FileReader !== "undefined") {
	            return new external.Promise(function (resolve, reject) {
	                var reader = new FileReader();
	
	                reader.onload = function(e) {
	                    resolve(e.target.result);
	                };
	                reader.onerror = function(e) {
	                    reject(e.target.error);
	                };
	                reader.readAsArrayBuffer(data);
	            });
	        } else {
	            return data;
	        }
	    });
	
	    return promise.then(function(data) {
	        var dataType = exports.getTypeOf(data);
	
	        if (!dataType) {
	            return external.Promise.reject(
	                new Error("Can't read the data of '" + name + "'. Is it " +
	                          "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
	            );
	        }
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = exports.transformTo("uint8array", data);
	        } else if (dataType === "string") {
	            if (isBase64) {
	                data = base64.decode(data);
	            }
	            else if (isBinary) {
	                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
	                if (isOptimizedBinaryString !== true) {
	                    // this is a string, not in a base64 format.
	                    // Be sure that this is a correct "binary string"
	                    data = string2binary(data);
	                }
	            }
	        }
	        return data;
	    });
	};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob("application/zip").size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	try {
	    exports.nodestream = !!__webpack_require__(328).Readable;
	} catch(e) {
	    exports.nodestream = false;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(282).Buffer))

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * This file is used by module bundlers (browserify/webpack/etc) when
	 * including a stream implementation. We use "readable-stream" to get a
	 * consistent behavior between nodejs versions but bundlers often have a shim
	 * for "stream". Using this shim greatly improve the compatibility and greatly
	 * reduce the final size of the bundle (only one stream implementation, not
	 * two).
	 */
	module.exports = __webpack_require__(329);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(291).EventEmitter;
	var inherits = __webpack_require__(330);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(331);
	Stream.Writable = __webpack_require__(344);
	Stream.Duplex = __webpack_require__(345);
	Stream.Transform = __webpack_require__(346);
	Stream.PassThrough = __webpack_require__(347);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 331 */
[711, 332, 340, 339, 342, 343],
/* 332 */
[712, 333, 334, 330, 335, 336, 338, 339, 341, 339, 341],
/* 333 */
292,
/* 334 */
293,
/* 335 */
295,
/* 336 */
[713, 334, 337],
/* 337 */
295,
/* 338 */
298,
/* 339 */
[714, 330, 332, 340],
/* 340 */
[715, 330, 333, 334, 338, 339, 339],
/* 341 */
[716, 334],
/* 342 */
[717, 339, 330],
/* 343 */
[718, 342, 330],
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(340);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(339);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(331).Transform


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(331).PassThrough


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var utils = __webpack_require__(326);
	var support = __webpack_require__(327);
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input) {
	    var output = [];
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0, len = input.length, remainingBytes = len;
	
	    var isArray = utils.getTypeOf(input) !== "string";
	    while (i < input.length) {
	        remainingBytes = len - i;
	
	        if (!isArray) {
	            chr1 = input.charCodeAt(i++);
	            chr2 = i < len ? input.charCodeAt(i++) : 0;
	            chr3 = i < len ? input.charCodeAt(i++) : 0;
	        } else {
	            chr1 = input[i++];
	            chr2 = i < len ? input[i++] : 0;
	            chr3 = i < len ? input[i++] : 0;
	        }
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
	        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;
	
	        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));
	
	    }
	
	    return output.join("");
	};
	
	// public method for decoding
	exports.decode = function(input) {
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0, resultIndex = 0;
	
	    var dataUrlPrefix = "data:";
	
	    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
	        // This is a common error: people give a data url
	        // (data:image/png;base64,iVBOR...) with a {base64: true} and
	        // wonders why things don't work.
	        // We can detect that the string input looks like a data url but we
	        // *can't* be sure it is one: removing everything up to the comma would
	        // be too dangerous.
	        throw new Error("Invalid base64 input, it looks like a data url.");
	    }
	
	    input = input.replace(/[^A-Za-z0-9+/=]/g, "");
	
	    var totalLength = input.length * 3 / 4;
	    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
	        totalLength--;
	    }
	    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
	        totalLength--;
	    }
	    if (totalLength % 1 !== 0) {
	        // totalLength is not an integer, the length does not match a valid
	        // base64 content. That can happen if:
	        // - the input is not a base64 content
	        // - the input is *almost* a base64 content, with a extra chars at the
	        //   beginning or at the end
	        // - the input uses a base64 variant (base64url for example)
	        throw new Error("Invalid base64 input, bad content length.");
	    }
	    var output;
	    if (support.uint8array) {
	        output = new Uint8Array(totalLength|0);
	    } else {
	        output = new Array(totalLength|0);
	    }
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output[resultIndex++] = chr1;
	
	        if (enc3 !== 64) {
	            output[resultIndex++] = chr2;
	        }
	        if (enc4 !== 64) {
	            output[resultIndex++] = chr3;
	        }
	
	    }
	
	    return output;
	};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	module.exports = {
	    /**
	     * True if this is running in Nodejs, will be undefined in a browser.
	     * In a browser, browserify won't include this file and the whole module
	     * will be resolved an empty object.
	     */
	    isNode : typeof Buffer !== "undefined",
	    /**
	     * Create a new nodejs Buffer from an existing content.
	     * @param {Object} data the data to pass to the constructor.
	     * @param {String} encoding the encoding to use.
	     * @return {Buffer} a new Buffer.
	     */
	    newBufferFrom: function(data, encoding) {
	        if (Buffer.from && Buffer.from !== Uint8Array.from) {
	            return Buffer.from(data, encoding);
	        } else {
	            if (typeof data === "number") {
	                // Safeguard for old Node.js versions. On newer versions,
	                // Buffer.from(number) / Buffer(number, encoding) already throw.
	                throw new Error("The \"data\" argument must not be a number");
	            }
	            return new Buffer(data, encoding);
	        }
	    },
	    /**
	     * Create a new nodejs Buffer with the specified size.
	     * @param {Integer} size the size of the buffer.
	     * @return {Buffer} a new Buffer.
	     */
	    allocBuffer: function (size) {
	        if (Buffer.alloc) {
	            return Buffer.alloc(size);
	        } else {
	            var buf = new Buffer(size);
	            buf.fill(0);
	            return buf;
	        }
	    },
	    /**
	     * Find out if an object is a Buffer.
	     * @param {Object} b the object to test.
	     * @return {Boolean} true if the object is a Buffer, false otherwise.
	     */
	    isBuffer : function(b){
	        return Buffer.isBuffer(b);
	    },
	
	    isStream : function (obj) {
	        return obj &&
	            typeof obj.on === "function" &&
	            typeof obj.pause === "function" &&
	            typeof obj.resume === "function";
	    }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(282).Buffer))

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// load the global object first:
	// - it should be better integrated in the system (unhandledRejection in node)
	// - the environment may have a custom Promise implementation (see zone.js)
	var ES6Promise = null;
	if (typeof Promise !== "undefined") {
	    ES6Promise = Promise;
	} else {
	    ES6Promise = __webpack_require__(351);
	}
	
	/**
	 * Let the user use/change some implementations.
	 */
	module.exports = {
	    Promise: ES6Promise
	};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var immediate = __webpack_require__(352);
	
	/* istanbul ignore next */
	function INTERNAL() {}
	
	var handlers = {};
	
	var REJECTED = ['REJECTED'];
	var FULFILLED = ['FULFILLED'];
	var PENDING = ['PENDING'];
	
	module.exports = Promise;
	
	function Promise(resolver) {
	  if (typeof resolver !== 'function') {
	    throw new TypeError('resolver must be a function');
	  }
	  this.state = PENDING;
	  this.queue = [];
	  this.outcome = void 0;
	  if (resolver !== INTERNAL) {
	    safelyResolveThenable(this, resolver);
	  }
	}
	
	Promise.prototype["finally"] = function (callback) {
	  if (typeof callback !== 'function') {
	    return this;
	  }
	  var p = this.constructor;
	  return this.then(resolve, reject);
	
	  function resolve(value) {
	    function yes () {
	      return value;
	    }
	    return p.resolve(callback()).then(yes);
	  }
	  function reject(reason) {
	    function no () {
	      throw reason;
	    }
	    return p.resolve(callback()).then(no);
	  }
	};
	Promise.prototype["catch"] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
	    typeof onRejected !== 'function' && this.state === REJECTED) {
	    return this;
	  }
	  var promise = new this.constructor(INTERNAL);
	  if (this.state !== PENDING) {
	    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	    unwrap(promise, resolver, this.outcome);
	  } else {
	    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	  }
	
	  return promise;
	};
	function QueueItem(promise, onFulfilled, onRejected) {
	  this.promise = promise;
	  if (typeof onFulfilled === 'function') {
	    this.onFulfilled = onFulfilled;
	    this.callFulfilled = this.otherCallFulfilled;
	  }
	  if (typeof onRejected === 'function') {
	    this.onRejected = onRejected;
	    this.callRejected = this.otherCallRejected;
	  }
	}
	QueueItem.prototype.callFulfilled = function (value) {
	  handlers.resolve(this.promise, value);
	};
	QueueItem.prototype.otherCallFulfilled = function (value) {
	  unwrap(this.promise, this.onFulfilled, value);
	};
	QueueItem.prototype.callRejected = function (value) {
	  handlers.reject(this.promise, value);
	};
	QueueItem.prototype.otherCallRejected = function (value) {
	  unwrap(this.promise, this.onRejected, value);
	};
	
	function unwrap(promise, func, value) {
	  immediate(function () {
	    var returnValue;
	    try {
	      returnValue = func(value);
	    } catch (e) {
	      return handlers.reject(promise, e);
	    }
	    if (returnValue === promise) {
	      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	    } else {
	      handlers.resolve(promise, returnValue);
	    }
	  });
	}
	
	handlers.resolve = function (self, value) {
	  var result = tryCatch(getThen, value);
	  if (result.status === 'error') {
	    return handlers.reject(self, result.value);
	  }
	  var thenable = result.value;
	
	  if (thenable) {
	    safelyResolveThenable(self, thenable);
	  } else {
	    self.state = FULFILLED;
	    self.outcome = value;
	    var i = -1;
	    var len = self.queue.length;
	    while (++i < len) {
	      self.queue[i].callFulfilled(value);
	    }
	  }
	  return self;
	};
	handlers.reject = function (self, error) {
	  self.state = REJECTED;
	  self.outcome = error;
	  var i = -1;
	  var len = self.queue.length;
	  while (++i < len) {
	    self.queue[i].callRejected(error);
	  }
	  return self;
	};
	
	function getThen(obj) {
	  // Make sure we only access the accessor once as required by the spec
	  var then = obj && obj.then;
	  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	    return function appyThen() {
	      then.apply(obj, arguments);
	    };
	  }
	}
	
	function safelyResolveThenable(self, thenable) {
	  // Either fulfill, reject or reject with error
	  var called = false;
	  function onError(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.reject(self, value);
	  }
	
	  function onSuccess(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.resolve(self, value);
	  }
	
	  function tryToUnwrap() {
	    thenable(onSuccess, onError);
	  }
	
	  var result = tryCatch(tryToUnwrap);
	  if (result.status === 'error') {
	    onError(result.value);
	  }
	}
	
	function tryCatch(func, value) {
	  var out = {};
	  try {
	    out.value = func(value);
	    out.status = 'success';
	  } catch (e) {
	    out.status = 'error';
	    out.value = e;
	  }
	  return out;
	}
	
	Promise.resolve = resolve;
	function resolve(value) {
	  if (value instanceof this) {
	    return value;
	  }
	  return handlers.resolve(new this(INTERNAL), value);
	}
	
	Promise.reject = reject;
	function reject(reason) {
	  var promise = new this(INTERNAL);
	  return handlers.reject(promise, reason);
	}
	
	Promise.all = all;
	function all(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var values = new Array(len);
	  var resolved = 0;
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    allResolver(iterable[i], i);
	  }
	  return promise;
	  function allResolver(value, i) {
	    self.resolve(value).then(resolveFromAll, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	    function resolveFromAll(outValue) {
	      values[i] = outValue;
	      if (++resolved === len && !called) {
	        called = true;
	        handlers.resolve(promise, values);
	      }
	    }
	  }
	}
	
	Promise.race = race;
	function race(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    resolver(iterable[i]);
	  }
	  return promise;
	  function resolver(value) {
	    self.resolve(value).then(function (response) {
	      if (!called) {
	        called = true;
	        handlers.resolve(promise, response);
	      }
	    }, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	  }
	}


/***/ }),
/* 352 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;
	
	var scheduleDrain;
	
	{
	  if (Mutation) {
	    var called = 0;
	    var observer = new Mutation(nextTick);
	    var element = global.document.createTextNode('');
	    observer.observe(element, {
	      characterData: true
	    });
	    scheduleDrain = function () {
	      element.data = (called = ++called % 2);
	    };
	  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	    var channel = new global.MessageChannel();
	    channel.port1.onmessage = nextTick;
	    scheduleDrain = function () {
	      channel.port2.postMessage(0);
	    };
	  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	    scheduleDrain = function () {
	
	      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	      var scriptEl = global.document.createElement('script');
	      scriptEl.onreadystatechange = function () {
	        nextTick();
	
	        scriptEl.onreadystatechange = null;
	        scriptEl.parentNode.removeChild(scriptEl);
	        scriptEl = null;
	      };
	      global.document.documentElement.appendChild(scriptEl);
	    };
	  } else {
	    scheduleDrain = function () {
	      setTimeout(nextTick, 0);
	    };
	  }
	}
	
	var draining;
	var queue = [];
	//named nextTick for less confusing stack traces
	function nextTick() {
	  draining = true;
	  var i, oldQueue;
	  var len = queue.length;
	  while (len) {
	    oldQueue = queue;
	    queue = [];
	    i = -1;
	    while (++i < len) {
	      oldQueue[i]();
	    }
	    len = queue.length;
	  }
	  draining = false;
	}
	
	module.exports = immediate;
	function immediate(task) {
	  if (queue.push(task) === 1 && !draining) {
	    scheduleDrain();
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(219)))

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * A worker that does nothing but passing chunks to the next one. This is like
	 * a nodejs stream but with some differences. On the good side :
	 * - it works on IE 6-9 without any issue / polyfill
	 * - it weights less than the full dependencies bundled with browserify
	 * - it forwards errors (no need to declare an error handler EVERYWHERE)
	 *
	 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
	 * object containing anything (`percent` for example), see each worker for more
	 * details. The latter is the real data (String, Uint8Array, etc).
	 *
	 * @constructor
	 * @param {String} name the name of the stream (mainly used for debugging purposes)
	 */
	function GenericWorker(name) {
	    // the name of the worker
	    this.name = name || "default";
	    // an object containing metadata about the workers chain
	    this.streamInfo = {};
	    // an error which happened when the worker was paused
	    this.generatedError = null;
	    // an object containing metadata to be merged by this worker into the general metadata
	    this.extraStreamInfo = {};
	    // true if the stream is paused (and should not do anything), false otherwise
	    this.isPaused = true;
	    // true if the stream is finished (and should not do anything), false otherwise
	    this.isFinished = false;
	    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
	    this.isLocked = false;
	    // the event listeners
	    this._listeners = {
	        "data":[],
	        "end":[],
	        "error":[]
	    };
	    // the previous worker, if any
	    this.previous = null;
	}
	
	GenericWorker.prototype = {
	    /**
	     * Push a chunk to the next workers.
	     * @param {Object} chunk the chunk to push
	     */
	    push : function (chunk) {
	        this.emit("data", chunk);
	    },
	    /**
	     * End the stream.
	     * @return {Boolean} true if this call ended the worker, false otherwise.
	     */
	    end : function () {
	        if (this.isFinished) {
	            return false;
	        }
	
	        this.flush();
	        try {
	            this.emit("end");
	            this.cleanUp();
	            this.isFinished = true;
	        } catch (e) {
	            this.emit("error", e);
	        }
	        return true;
	    },
	    /**
	     * End the stream with an error.
	     * @param {Error} e the error which caused the premature end.
	     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
	     */
	    error : function (e) {
	        if (this.isFinished) {
	            return false;
	        }
	
	        if(this.isPaused) {
	            this.generatedError = e;
	        } else {
	            this.isFinished = true;
	
	            this.emit("error", e);
	
	            // in the workers chain exploded in the middle of the chain,
	            // the error event will go downward but we also need to notify
	            // workers upward that there has been an error.
	            if(this.previous) {
	                this.previous.error(e);
	            }
	
	            this.cleanUp();
	        }
	        return true;
	    },
	    /**
	     * Add a callback on an event.
	     * @param {String} name the name of the event (data, end, error)
	     * @param {Function} listener the function to call when the event is triggered
	     * @return {GenericWorker} the current object for chainability
	     */
	    on : function (name, listener) {
	        this._listeners[name].push(listener);
	        return this;
	    },
	    /**
	     * Clean any references when a worker is ending.
	     */
	    cleanUp : function () {
	        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
	        this._listeners = [];
	    },
	    /**
	     * Trigger an event. This will call registered callback with the provided arg.
	     * @param {String} name the name of the event (data, end, error)
	     * @param {Object} arg the argument to call the callback with.
	     */
	    emit : function (name, arg) {
	        if (this._listeners[name]) {
	            for(var i = 0; i < this._listeners[name].length; i++) {
	                this._listeners[name][i].call(this, arg);
	            }
	        }
	    },
	    /**
	     * Chain a worker with an other.
	     * @param {Worker} next the worker receiving events from the current one.
	     * @return {worker} the next worker for chainability
	     */
	    pipe : function (next) {
	        return next.registerPrevious(this);
	    },
	    /**
	     * Same as `pipe` in the other direction.
	     * Using an API with `pipe(next)` is very easy.
	     * Implementing the API with the point of view of the next one registering
	     * a source is easier, see the ZipFileWorker.
	     * @param {Worker} previous the previous worker, sending events to this one
	     * @return {Worker} the current worker for chainability
	     */
	    registerPrevious : function (previous) {
	        if (this.isLocked) {
	            throw new Error("The stream '" + this + "' has already been used.");
	        }
	
	        // sharing the streamInfo...
	        this.streamInfo = previous.streamInfo;
	        // ... and adding our own bits
	        this.mergeStreamInfo();
	        this.previous =  previous;
	        var self = this;
	        previous.on("data", function (chunk) {
	            self.processChunk(chunk);
	        });
	        previous.on("end", function () {
	            self.end();
	        });
	        previous.on("error", function (e) {
	            self.error(e);
	        });
	        return this;
	    },
	    /**
	     * Pause the stream so it doesn't send events anymore.
	     * @return {Boolean} true if this call paused the worker, false otherwise.
	     */
	    pause : function () {
	        if(this.isPaused || this.isFinished) {
	            return false;
	        }
	        this.isPaused = true;
	
	        if(this.previous) {
	            this.previous.pause();
	        }
	        return true;
	    },
	    /**
	     * Resume a paused stream.
	     * @return {Boolean} true if this call resumed the worker, false otherwise.
	     */
	    resume : function () {
	        if(!this.isPaused || this.isFinished) {
	            return false;
	        }
	        this.isPaused = false;
	
	        // if true, the worker tried to resume but failed
	        var withError = false;
	        if(this.generatedError) {
	            this.error(this.generatedError);
	            withError = true;
	        }
	        if(this.previous) {
	            this.previous.resume();
	        }
	
	        return !withError;
	    },
	    /**
	     * Flush any remaining bytes as the stream is ending.
	     */
	    flush : function () {},
	    /**
	     * Process a chunk. This is usually the method overridden.
	     * @param {Object} chunk the chunk to process.
	     */
	    processChunk : function(chunk) {
	        this.push(chunk);
	    },
	    /**
	     * Add a key/value to be added in the workers chain streamInfo once activated.
	     * @param {String} key the key to use
	     * @param {Object} value the associated value
	     * @return {Worker} the current worker for chainability
	     */
	    withStreamInfo : function (key, value) {
	        this.extraStreamInfo[key] = value;
	        this.mergeStreamInfo();
	        return this;
	    },
	    /**
	     * Merge this worker's streamInfo into the chain's streamInfo.
	     */
	    mergeStreamInfo : function () {
	        for(var key in this.extraStreamInfo) {
	            if (!Object.prototype.hasOwnProperty.call(this.extraStreamInfo, key)) {
	                continue;
	            }
	            this.streamInfo[key] = this.extraStreamInfo[key];
	        }
	    },
	
	    /**
	     * Lock the stream to prevent further updates on the workers chain.
	     * After calling this method, all calls to pipe will fail.
	     */
	    lock: function () {
	        if (this.isLocked) {
	            throw new Error("The stream '" + this + "' has already been used.");
	        }
	        this.isLocked = true;
	        if (this.previous) {
	            this.previous.lock();
	        }
	    },
	
	    /**
	     *
	     * Pretty print the workers chain.
	     */
	    toString : function () {
	        var me = "Worker " + this.name;
	        if (this.previous) {
	            return this.previous + " -> " + me;
	        } else {
	            return me;
	        }
	    }
	};
	
	module.exports = GenericWorker;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	var utils = __webpack_require__(326);
	var ConvertWorker = __webpack_require__(356);
	var GenericWorker = __webpack_require__(354);
	var base64 = __webpack_require__(348);
	var support = __webpack_require__(327);
	var external = __webpack_require__(350);
	
	var NodejsStreamOutputAdapter = null;
	if (support.nodestream) {
	    try {
	        NodejsStreamOutputAdapter = __webpack_require__(357);
	    } catch(e) {
	        // ignore
	    }
	}
	
	/**
	 * Apply the final transformation of the data. If the user wants a Blob for
	 * example, it's easier to work with an U8intArray and finally do the
	 * ArrayBuffer/Blob conversion.
	 * @param {String} type the name of the final type
	 * @param {String|Uint8Array|Buffer} content the content to transform
	 * @param {String} mimeType the mime type of the content, if applicable.
	 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
	 */
	function transformZipOutput(type, content, mimeType) {
	    switch(type) {
	    case "blob" :
	        return utils.newBlob(utils.transformTo("arraybuffer", content), mimeType);
	    case "base64" :
	        return base64.encode(content);
	    default :
	        return utils.transformTo(type, content);
	    }
	}
	
	/**
	 * Concatenate an array of data of the given type.
	 * @param {String} type the type of the data in the given array.
	 * @param {Array} dataArray the array containing the data chunks to concatenate
	 * @return {String|Uint8Array|Buffer} the concatenated data
	 * @throws Error if the asked type is unsupported
	 */
	function concat (type, dataArray) {
	    var i, index = 0, res = null, totalLength = 0;
	    for(i = 0; i < dataArray.length; i++) {
	        totalLength += dataArray[i].length;
	    }
	    switch(type) {
	    case "string":
	        return dataArray.join("");
	    case "array":
	        return Array.prototype.concat.apply([], dataArray);
	    case "uint8array":
	        res = new Uint8Array(totalLength);
	        for(i = 0; i < dataArray.length; i++) {
	            res.set(dataArray[i], index);
	            index += dataArray[i].length;
	        }
	        return res;
	    case "nodebuffer":
	        return Buffer.concat(dataArray);
	    default:
	        throw new Error("concat : unsupported type '"  + type + "'");
	    }
	}
	
	/**
	 * Listen a StreamHelper, accumulate its content and concatenate it into a
	 * complete block.
	 * @param {StreamHelper} helper the helper to use.
	 * @param {Function} updateCallback a callback called on each update. Called
	 * with one arg :
	 * - the metadata linked to the update received.
	 * @return Promise the promise for the accumulation.
	 */
	function accumulate(helper, updateCallback) {
	    return new external.Promise(function (resolve, reject){
	        var dataArray = [];
	        var chunkType = helper._internalType,
	            resultType = helper._outputType,
	            mimeType = helper._mimeType;
	        helper
	            .on("data", function (data, meta) {
	                dataArray.push(data);
	                if(updateCallback) {
	                    updateCallback(meta);
	                }
	            })
	            .on("error", function(err) {
	                dataArray = [];
	                reject(err);
	            })
	            .on("end", function (){
	                try {
	                    var result = transformZipOutput(resultType, concat(chunkType, dataArray), mimeType);
	                    resolve(result);
	                } catch (e) {
	                    reject(e);
	                }
	                dataArray = [];
	            })
	            .resume();
	    });
	}
	
	/**
	 * An helper to easily use workers outside of JSZip.
	 * @constructor
	 * @param {Worker} worker the worker to wrap
	 * @param {String} outputType the type of data expected by the use
	 * @param {String} mimeType the mime type of the content, if applicable.
	 */
	function StreamHelper(worker, outputType, mimeType) {
	    var internalType = outputType;
	    switch(outputType) {
	    case "blob":
	    case "arraybuffer":
	        internalType = "uint8array";
	        break;
	    case "base64":
	        internalType = "string";
	        break;
	    }
	
	    try {
	        // the type used internally
	        this._internalType = internalType;
	        // the type used to output results
	        this._outputType = outputType;
	        // the mime type
	        this._mimeType = mimeType;
	        utils.checkSupport(internalType);
	        this._worker = worker.pipe(new ConvertWorker(internalType));
	        // the last workers can be rewired without issues but we need to
	        // prevent any updates on previous workers.
	        worker.lock();
	    } catch(e) {
	        this._worker = new GenericWorker("error");
	        this._worker.error(e);
	    }
	}
	
	StreamHelper.prototype = {
	    /**
	     * Listen a StreamHelper, accumulate its content and concatenate it into a
	     * complete block.
	     * @param {Function} updateCb the update callback.
	     * @return Promise the promise for the accumulation.
	     */
	    accumulate : function (updateCb) {
	        return accumulate(this, updateCb);
	    },
	    /**
	     * Add a listener on an event triggered on a stream.
	     * @param {String} evt the name of the event
	     * @param {Function} fn the listener
	     * @return {StreamHelper} the current helper.
	     */
	    on : function (evt, fn) {
	        var self = this;
	
	        if(evt === "data") {
	            this._worker.on(evt, function (chunk) {
	                fn.call(self, chunk.data, chunk.meta);
	            });
	        } else {
	            this._worker.on(evt, function () {
	                utils.delay(fn, arguments, self);
	            });
	        }
	        return this;
	    },
	    /**
	     * Resume the flow of chunks.
	     * @return {StreamHelper} the current helper.
	     */
	    resume : function () {
	        utils.delay(this._worker.resume, [], this._worker);
	        return this;
	    },
	    /**
	     * Pause the flow of chunks.
	     * @return {StreamHelper} the current helper.
	     */
	    pause : function () {
	        this._worker.pause();
	        return this;
	    },
	    /**
	     * Return a nodejs stream for this helper.
	     * @param {Function} updateCb the update callback.
	     * @return {NodejsStreamOutputAdapter} the nodejs stream.
	     */
	    toNodejsStream : function (updateCb) {
	        utils.checkSupport("nodestream");
	        if (this._outputType !== "nodebuffer") {
	            // an object stream containing blob/arraybuffer/uint8array/string
	            // is strange and I don't know if it would be useful.
	            // I you find this comment and have a good usecase, please open a
	            // bug report !
	            throw new Error(this._outputType + " is not supported by this method");
	        }
	
	        return new NodejsStreamOutputAdapter(this, {
	            objectMode : this._outputType !== "nodebuffer"
	        }, updateCb);
	    }
	};
	
	
	module.exports = StreamHelper;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(282).Buffer))

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var GenericWorker = __webpack_require__(354);
	var utils = __webpack_require__(326);
	
	/**
	 * A worker which convert chunks to a specified type.
	 * @constructor
	 * @param {String} destType the destination type.
	 */
	function ConvertWorker(destType) {
	    GenericWorker.call(this, "ConvertWorker to " + destType);
	    this.destType = destType;
	}
	utils.inherits(ConvertWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	ConvertWorker.prototype.processChunk = function (chunk) {
	    this.push({
	        data : utils.transformTo(this.destType, chunk.data),
	        meta : chunk.meta
	    });
	};
	module.exports = ConvertWorker;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Readable = __webpack_require__(328).Readable;
	
	var utils = __webpack_require__(326);
	utils.inherits(NodejsStreamOutputAdapter, Readable);
	
	/**
	* A nodejs stream using a worker as source.
	* @see the SourceWrapper in http://nodejs.org/api/stream.html
	* @constructor
	* @param {StreamHelper} helper the helper wrapping the worker
	* @param {Object} options the nodejs stream options
	* @param {Function} updateCb the update callback.
	*/
	function NodejsStreamOutputAdapter(helper, options, updateCb) {
	    Readable.call(this, options);
	    this._helper = helper;
	
	    var self = this;
	    helper.on("data", function (data, meta) {
	        if (!self.push(data)) {
	            self._helper.pause();
	        }
	        if(updateCb) {
	            updateCb(meta);
	        }
	    })
	        .on("error", function(e) {
	            self.emit("error", e);
	        })
	        .on("end", function () {
	            self.push(null);
	        });
	}
	
	
	NodejsStreamOutputAdapter.prototype._read = function() {
	    this._helper.resume();
	};
	
	module.exports = NodejsStreamOutputAdapter;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

	"use strict";
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = true;
	exports.date = null;
	exports.compression = null;
	exports.compressionOptions = null;
	exports.comment = null;
	exports.unixPermissions = null;
	exports.dosPermissions = null;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var external = __webpack_require__(350);
	var DataWorker = __webpack_require__(360);
	var Crc32Probe = __webpack_require__(361);
	var DataLengthProbe = __webpack_require__(363);
	
	/**
	 * Represent a compressed object, with everything needed to decompress it.
	 * @constructor
	 * @param {number} compressedSize the size of the data compressed.
	 * @param {number} uncompressedSize the size of the data after decompression.
	 * @param {number} crc32 the crc32 of the decompressed file.
	 * @param {object} compression the type of compression, see lib/compressions.js.
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
	 */
	function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
	    this.compressedSize = compressedSize;
	    this.uncompressedSize = uncompressedSize;
	    this.crc32 = crc32;
	    this.compression = compression;
	    this.compressedContent = data;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Create a worker to get the uncompressed content.
	     * @return {GenericWorker} the worker.
	     */
	    getContentWorker: function () {
	        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
	            .pipe(this.compression.uncompressWorker())
	            .pipe(new DataLengthProbe("data_length"));
	
	        var that = this;
	        worker.on("end", function () {
	            if (this.streamInfo["data_length"] !== that.uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	        });
	        return worker;
	    },
	    /**
	     * Create a worker to get the compressed content.
	     * @return {GenericWorker} the worker.
	     */
	    getCompressedWorker: function () {
	        return new DataWorker(external.Promise.resolve(this.compressedContent))
	            .withStreamInfo("compressedSize", this.compressedSize)
	            .withStreamInfo("uncompressedSize", this.uncompressedSize)
	            .withStreamInfo("crc32", this.crc32)
	            .withStreamInfo("compression", this.compression)
	        ;
	    }
	};
	
	/**
	 * Chain the given worker with other workers to compress the content with the
	 * given compression.
	 * @param {GenericWorker} uncompressedWorker the worker to pipe.
	 * @param {Object} compression the compression object.
	 * @param {Object} compressionOptions the options to use when compressing.
	 * @return {GenericWorker} the new worker compressing the content.
	 */
	CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
	    return uncompressedWorker
	        .pipe(new Crc32Probe())
	        .pipe(new DataLengthProbe("uncompressedSize"))
	        .pipe(compression.compressWorker(compressionOptions))
	        .pipe(new DataLengthProbe("compressedSize"))
	        .withStreamInfo("compression", compression);
	};
	
	module.exports = CompressedObject;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(326);
	var GenericWorker = __webpack_require__(354);
	
	// the size of the generated chunks
	// TODO expose this as a public variable
	var DEFAULT_BLOCK_SIZE = 16 * 1024;
	
	/**
	 * A worker that reads a content and emits chunks.
	 * @constructor
	 * @param {Promise} dataP the promise of the data to split
	 */
	function DataWorker(dataP) {
	    GenericWorker.call(this, "DataWorker");
	    var self = this;
	    this.dataIsReady = false;
	    this.index = 0;
	    this.max = 0;
	    this.data = null;
	    this.type = "";
	
	    this._tickScheduled = false;
	
	    dataP.then(function (data) {
	        self.dataIsReady = true;
	        self.data = data;
	        self.max = data && data.length || 0;
	        self.type = utils.getTypeOf(data);
	        if(!self.isPaused) {
	            self._tickAndRepeat();
	        }
	    }, function (e) {
	        self.error(e);
	    });
	}
	
	utils.inherits(DataWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.cleanUp
	 */
	DataWorker.prototype.cleanUp = function () {
	    GenericWorker.prototype.cleanUp.call(this);
	    this.data = null;
	};
	
	/**
	 * @see GenericWorker.resume
	 */
	DataWorker.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if (!this._tickScheduled && this.dataIsReady) {
	        this._tickScheduled = true;
	        utils.delay(this._tickAndRepeat, [], this);
	    }
	    return true;
	};
	
	/**
	 * Trigger a tick a schedule an other call to this function.
	 */
	DataWorker.prototype._tickAndRepeat = function() {
	    this._tickScheduled = false;
	    if(this.isPaused || this.isFinished) {
	        return;
	    }
	    this._tick();
	    if(!this.isFinished) {
	        utils.delay(this._tickAndRepeat, [], this);
	        this._tickScheduled = true;
	    }
	};
	
	/**
	 * Read and push a chunk.
	 */
	DataWorker.prototype._tick = function() {
	
	    if(this.isPaused || this.isFinished) {
	        return false;
	    }
	
	    var size = DEFAULT_BLOCK_SIZE;
	    var data = null, nextIndex = Math.min(this.max, this.index + size);
	    if (this.index >= this.max) {
	        // EOF
	        return this.end();
	    } else {
	        switch(this.type) {
	        case "string":
	            data = this.data.substring(this.index, nextIndex);
	            break;
	        case "uint8array":
	            data = this.data.subarray(this.index, nextIndex);
	            break;
	        case "array":
	        case "nodebuffer":
	            data = this.data.slice(this.index, nextIndex);
	            break;
	        }
	        this.index = nextIndex;
	        return this.push({
	            data : data,
	            meta : {
	                percent : this.max ? this.index / this.max * 100 : 0
	            }
	        });
	    }
	};
	
	module.exports = DataWorker;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var GenericWorker = __webpack_require__(354);
	var crc32 = __webpack_require__(362);
	var utils = __webpack_require__(326);
	
	/**
	 * A worker which calculate the crc32 of the data flowing through.
	 * @constructor
	 */
	function Crc32Probe() {
	    GenericWorker.call(this, "Crc32Probe");
	    this.withStreamInfo("crc32", 0);
	}
	utils.inherits(Crc32Probe, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Crc32Probe.prototype.processChunk = function (chunk) {
	    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
	    this.push(chunk);
	};
	module.exports = Crc32Probe;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(326);
	
	/**
	 * The following functions come from pako, from pako/lib/zlib/crc32.js
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	    var c, table = [];
	
	    for(var n =0; n < 256; n++){
	        c = n;
	        for(var k =0; k < 8; k++){
	            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	        }
	        table[n] = c;
	    }
	
	    return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	    var t = crcTable, end = pos + len;
	
	    crc = crc ^ (-1);
	
	    for (var i = pos; i < end; i++ ) {
	        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	    }
	
	    return (crc ^ (-1)); // >>> 0;
	}
	
	// That's all for the pako functions.
	
	/**
	 * Compute the crc32 of a string.
	 * This is almost the same as the function crc32, but for strings. Using the
	 * same function for the two use cases leads to horrible performances.
	 * @param {Number} crc the starting value of the crc.
	 * @param {String} str the string to use.
	 * @param {Number} len the length of the string.
	 * @param {Number} pos the starting position for the crc32 computation.
	 * @return {Number} the computed crc32.
	 */
	function crc32str(crc, str, len, pos) {
	    var t = crcTable, end = pos + len;
	
	    crc = crc ^ (-1);
	
	    for (var i = pos; i < end; i++ ) {
	        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
	    }
	
	    return (crc ^ (-1)); // >>> 0;
	}
	
	module.exports = function crc32wrapper(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if(isArray) {
	        return crc32(crc|0, input, input.length, 0);
	    } else {
	        return crc32str(crc|0, input, input.length, 0);
	    }
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(326);
	var GenericWorker = __webpack_require__(354);
	
	/**
	 * A worker which calculate the total length of the data flowing through.
	 * @constructor
	 * @param {String} propName the name used to expose the length
	 */
	function DataLengthProbe(propName) {
	    GenericWorker.call(this, "DataLengthProbe for " + propName);
	    this.propName = propName;
	    this.withStreamInfo(propName, 0);
	}
	utils.inherits(DataLengthProbe, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	DataLengthProbe.prototype.processChunk = function (chunk) {
	    if(chunk) {
	        var length = this.streamInfo[this.propName] || 0;
	        this.streamInfo[this.propName] = length + chunk.data.length;
	    }
	    GenericWorker.prototype.processChunk.call(this, chunk);
	};
	module.exports = DataLengthProbe;
	


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var StreamHelper = __webpack_require__(355);
	var DataWorker = __webpack_require__(360);
	var utf8 = __webpack_require__(325);
	var CompressedObject = __webpack_require__(359);
	var GenericWorker = __webpack_require__(354);
	
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	    this.unixPermissions = options.unixPermissions;
	    this.dosPermissions = options.dosPermissions;
	
	    this._data = data;
	    this._dataBinary = options.binary;
	    // keep only the compression
	    this.options = {
	        compression : options.compression,
	        compressionOptions : options.compressionOptions
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Create an internal stream for the content of this object.
	     * @param {String} type the type of each chunk.
	     * @return StreamHelper the stream.
	     */
	    internalStream: function (type) {
	        var result = null, outputType = "string";
	        try {
	            if (!type) {
	                throw new Error("No output type specified.");
	            }
	            outputType = type.toLowerCase();
	            var askUnicodeString = outputType === "string" || outputType === "text";
	            if (outputType === "binarystring" || outputType === "text") {
	                outputType = "string";
	            }
	            result = this._decompressWorker();
	
	            var isUnicodeString = !this._dataBinary;
	
	            if (isUnicodeString && !askUnicodeString) {
	                result = result.pipe(new utf8.Utf8EncodeWorker());
	            }
	            if (!isUnicodeString && askUnicodeString) {
	                result = result.pipe(new utf8.Utf8DecodeWorker());
	            }
	        } catch (e) {
	            result = new GenericWorker("error");
	            result.error(e);
	        }
	
	        return new StreamHelper(result, outputType, "");
	    },
	
	    /**
	     * Prepare the content in the asked type.
	     * @param {String} type the type of the result.
	     * @param {Function} onUpdate a function to call on each internal update.
	     * @return Promise the promise of the result.
	     */
	    async: function (type, onUpdate) {
	        return this.internalStream(type).accumulate(onUpdate);
	    },
	
	    /**
	     * Prepare the content as a nodejs stream.
	     * @param {String} type the type of each chunk.
	     * @param {Function} onUpdate a function to call on each internal update.
	     * @return Stream the stream.
	     */
	    nodeStream: function (type, onUpdate) {
	        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
	    },
	
	    /**
	     * Return a worker for the compressed content.
	     * @private
	     * @param {Object} compression the compression object to use.
	     * @param {Object} compressionOptions the options to use when compressing.
	     * @return Worker the worker.
	     */
	    _compressWorker: function (compression, compressionOptions) {
	        if (
	            this._data instanceof CompressedObject &&
	            this._data.compression.magic === compression.magic
	        ) {
	            return this._data.getCompressedWorker();
	        } else {
	            var result = this._decompressWorker();
	            if(!this._dataBinary) {
	                result = result.pipe(new utf8.Utf8EncodeWorker());
	            }
	            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
	        }
	    },
	    /**
	     * Return a worker for the decompressed content.
	     * @private
	     * @return Worker the worker.
	     */
	    _decompressWorker : function () {
	        if (this._data instanceof CompressedObject) {
	            return this._data.getContentWorker();
	        } else if (this._data instanceof GenericWorker) {
	            return this._data;
	        } else {
	            return new DataWorker(this._data);
	        }
	    }
	};
	
	var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
	var removedFn = function () {
	    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	};
	
	for(var i = 0; i < removedMethods.length; i++) {
	    ZipObject.prototype[removedMethods[i]] = removedFn;
	}
	module.exports = ZipObject;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var compressions = __webpack_require__(366);
	var ZipFileWorker = __webpack_require__(384);
	
	/**
	 * Find the compression to use.
	 * @param {String} fileCompression the compression defined at the file level, if any.
	 * @param {String} zipCompression the compression defined at the load() level.
	 * @return {Object} the compression object to use.
	 */
	var getCompression = function (fileCompression, zipCompression) {
	
	    var compressionName = fileCompression || zipCompression;
	    var compression = compressions[compressionName];
	    if (!compression) {
	        throw new Error(compressionName + " is not a valid compression method !");
	    }
	    return compression;
	};
	
	/**
	 * Create a worker to generate a zip file.
	 * @param {JSZip} zip the JSZip instance at the right root level.
	 * @param {Object} options to generate the zip file.
	 * @param {String} comment the comment to use.
	 */
	exports.generateWorker = function (zip, options, comment) {
	
	    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
	    var entriesCount = 0;
	    try {
	
	        zip.forEach(function (relativePath, file) {
	            entriesCount++;
	            var compression = getCompression(file.options.compression, options.compression);
	            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
	            var dir = file.dir, date = file.date;
	
	            file._compressWorker(compression, compressionOptions)
	                .withStreamInfo("file", {
	                    name : relativePath,
	                    dir : dir,
	                    date : date,
	                    comment : file.comment || "",
	                    unixPermissions : file.unixPermissions,
	                    dosPermissions : file.dosPermissions
	                })
	                .pipe(zipFileWorker);
	        });
	        zipFileWorker.entriesCount = entriesCount;
	    } catch (e) {
	        zipFileWorker.error(e);
	    }
	
	    return zipFileWorker;
	};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var GenericWorker = __webpack_require__(354);
	
	exports.STORE = {
	    magic: "\x00\x00",
	    compressWorker : function () {
	        return new GenericWorker("STORE compression");
	    },
	    uncompressWorker : function () {
	        return new GenericWorker("STORE decompression");
	    }
	};
	exports.DEFLATE = __webpack_require__(367);


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var USE_TYPEDARRAY = (typeof Uint8Array !== "undefined") && (typeof Uint16Array !== "undefined") && (typeof Uint32Array !== "undefined");
	
	var pako = __webpack_require__(368);
	var utils = __webpack_require__(326);
	var GenericWorker = __webpack_require__(354);
	
	var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	
	/**
	 * Create a worker that uses pako to inflate/deflate.
	 * @constructor
	 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
	 * @param {Object} options the options to use when (de)compressing.
	 */
	function FlateWorker(action, options) {
	    GenericWorker.call(this, "FlateWorker/" + action);
	
	    this._pako = null;
	    this._pakoAction = action;
	    this._pakoOptions = options;
	    // the `meta` object from the last chunk received
	    // this allow this worker to pass around metadata
	    this.meta = {};
	}
	
	utils.inherits(FlateWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	FlateWorker.prototype.processChunk = function (chunk) {
	    this.meta = chunk.meta;
	    if (this._pako === null) {
	        this._createPako();
	    }
	    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	FlateWorker.prototype.flush = function () {
	    GenericWorker.prototype.flush.call(this);
	    if (this._pako === null) {
	        this._createPako();
	    }
	    this._pako.push([], true);
	};
	/**
	 * @see GenericWorker.cleanUp
	 */
	FlateWorker.prototype.cleanUp = function () {
	    GenericWorker.prototype.cleanUp.call(this);
	    this._pako = null;
	};
	
	/**
	 * Create the _pako object.
	 * TODO: lazy-loading this object isn't the best solution but it's the
	 * quickest. The best solution is to lazy-load the worker list. See also the
	 * issue #446.
	 */
	FlateWorker.prototype._createPako = function () {
	    this._pako = new pako[this._pakoAction]({
	        raw: true,
	        level: this._pakoOptions.level || -1 // default compression
	    });
	    var self = this;
	    this._pako.onData = function(data) {
	        self.push({
	            data : data,
	            meta : self.meta
	        });
	    };
	};
	
	exports.compressWorker = function (compressionOptions) {
	    return new FlateWorker("Deflate", compressionOptions);
	};
	exports.uncompressWorker = function () {
	    return new FlateWorker("Inflate", {});
	};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = __webpack_require__(369).assign;
	
	var deflate   = __webpack_require__(370);
	var inflate   = __webpack_require__(378);
	var constants = __webpack_require__(382);
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	function _has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (_has(source, p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_deflate = __webpack_require__(371);
	var utils        = __webpack_require__(369);
	var strings      = __webpack_require__(376);
	var msg          = __webpack_require__(375);
	var ZStream      = __webpack_require__(377);
	
	var toString = Object.prototype.toString;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overridden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	
	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }
	
	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this._dict_set = true;
	  }
	}
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils   = __webpack_require__(369);
	var trees   = __webpack_require__(372);
	var adler32 = __webpack_require__(373);
	var crc32   = __webpack_require__(374);
	var msg     = __webpack_require__(375);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	        );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	/* eslint-disable space-unary-ops */
	
	var utils = __webpack_require__(369);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It isn't worth it to make additional optimizations as in original.
	// Small size is preferable.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ }),
/* 374 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	// String encode/decode helpers
	'use strict';
	
	
	var utils = __webpack_require__(369);
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safari
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // On Chrome, the arguments in a function call that are allowed is `65534`.
	  // If the length of the buffer is smaller than that, we can use this optimization,
	  // otherwise we will take a slower path.
	  if (len < 65534) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means buffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};


/***/ }),
/* 377 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_inflate = __webpack_require__(379);
	var utils        = __webpack_require__(369);
	var strings      = __webpack_require__(376);
	var c            = __webpack_require__(382);
	var msg          = __webpack_require__(375);
	var ZStream      = __webpack_require__(377);
	var GZheader     = __webpack_require__(383);
	
	var toString = Object.prototype.toString;
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overridden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new GZheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	
	  // Setup dictionary
	  if (opt.dictionary) {
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      opt.dictionary = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      opt.dictionary = new Uint8Array(opt.dictionary);
	    }
	    if (opt.raw) { //In raw mode we need to set the dictionary early
	      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
	      if (status !== c.Z_OK) {
	        throw new Error(msg[status]);
	      }
	    }
	  }
	}
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status === c.Z_NEED_DICT && dictionary) {
	      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
	    }
	
	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	
	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }
	
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 aligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils         = __webpack_require__(369);
	var adler32       = __webpack_require__(373);
	var crc32         = __webpack_require__(374);
	var inflate_fast  = __webpack_require__(380);
	var inflate_table = __webpack_require__(381);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	      case HEAD:
	        if (state.wrap === 0) {
	          state.mode = TYPEDO;
	          break;
	        }
	        //=== NEEDBITS(16);
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = FLAGS;
	          break;
	        }
	        state.flags = 0;           /* expect zlib header */
	        if (state.head) {
	          state.head.done = false;
	        }
	        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	          strm.msg = 'incorrect header check';
	          state.mode = BAD;
	          break;
	        }
	        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	        len = (hold & 0x0f)/*BITS(4)*/ + 8;
	        if (state.wbits === 0) {
	          state.wbits = len;
	        }
	        else if (len > state.wbits) {
	          strm.msg = 'invalid window size';
	          state.mode = BAD;
	          break;
	        }
	        state.dmax = 1 << len;
	        //Tracev((stderr, "inflate:   zlib header ok\n"));
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = hold & 0x200 ? DICTID : TYPE;
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        break;
	      case FLAGS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.flags = hold;
	        if ((state.flags & 0xff) !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        if (state.flags & 0xe000) {
	          strm.msg = 'unknown header flags set';
	          state.mode = BAD;
	          break;
	        }
	        if (state.head) {
	          state.head.text = ((hold >> 8) & 1);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = TIME;
	        /* falls through */
	      case TIME:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.time = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC4(state.check, hold)
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          hbuf[2] = (hold >>> 16) & 0xff;
	          hbuf[3] = (hold >>> 24) & 0xff;
	          state.check = crc32(state.check, hbuf, 4, 0);
	          //===
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = OS;
	        /* falls through */
	      case OS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.xflags = (hold & 0xff);
	          state.head.os = (hold >> 8);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = EXLEN;
	        /* falls through */
	      case EXLEN:
	        if (state.flags & 0x0400) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length = hold;
	          if (state.head) {
	            state.head.extra_len = hold;
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        else if (state.head) {
	          state.head.extra = null/*Z_NULL*/;
	        }
	        state.mode = EXTRA;
	        /* falls through */
	      case EXTRA:
	        if (state.flags & 0x0400) {
	          copy = state.length;
	          if (copy > have) { copy = have; }
	          if (copy) {
	            if (state.head) {
	              len = state.head.extra_len - state.length;
	              if (!state.head.extra) {
	                // Use untyped array for more convenient processing later
	                state.head.extra = new Array(state.head.extra_len);
	              }
	              utils.arraySet(
	                state.head.extra,
	                input,
	                next,
	                // extra field is limited to 65536 bytes
	                // - no need for additional size check
	                copy,
	                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	                len
	              );
	              //zmemcpy(state.head.extra + len, next,
	              //        len + copy > state.head.extra_max ?
	              //        state.head.extra_max - len : copy);
	            }
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            state.length -= copy;
	          }
	          if (state.length) { break inf_leave; }
	        }
	        state.length = 0;
	        state.mode = NAME;
	        /* falls through */
	      case NAME:
	        if (state.flags & 0x0800) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            // TODO: 2 or 1 bytes?
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.name_max*/)) {
	              state.head.name += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.name = null;
	        }
	        state.length = 0;
	        state.mode = COMMENT;
	        /* falls through */
	      case COMMENT:
	        if (state.flags & 0x1000) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.comm_max*/)) {
	              state.head.comment += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.comment = null;
	        }
	        state.mode = HCRC;
	        /* falls through */
	      case HCRC:
	        if (state.flags & 0x0200) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.check & 0xffff)) {
	            strm.msg = 'header crc mismatch';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        if (state.head) {
	          state.head.hcrc = ((state.flags >> 9) & 1);
	          state.head.done = true;
	        }
	        strm.adler = state.check = 0;
	        state.mode = TYPE;
	        break;
	      case DICTID:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        strm.adler = state.check = zswap32(hold);
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = DICT;
	        /* falls through */
	      case DICT:
	        if (state.havedict === 0) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          return Z_NEED_DICT;
	        }
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = TYPE;
	        /* falls through */
	      case TYPE:
	        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case TYPEDO:
	        if (state.last) {
	          //--- BYTEBITS() ---//
	          hold >>>= bits & 7;
	          bits -= bits & 7;
	          //---//
	          state.mode = CHECK;
	          break;
	        }
	        //=== NEEDBITS(3); */
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.last = (hold & 0x01)/*BITS(1)*/;
	        //--- DROPBITS(1) ---//
	        hold >>>= 1;
	        bits -= 1;
	        //---//
	
	        switch ((hold & 0x03)/*BITS(2)*/) {
	          case 0:                             /* stored block */
	            //Tracev((stderr, "inflate:     stored block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = STORED;
	            break;
	          case 1:                             /* fixed block */
	            fixedtables(state);
	            //Tracev((stderr, "inflate:     fixed codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = LEN_;             /* decode codes */
	            if (flush === Z_TREES) {
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	              break inf_leave;
	            }
	            break;
	          case 2:                             /* dynamic block */
	            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = TABLE;
	            break;
	          case 3:
	            strm.msg = 'invalid block type';
	            state.mode = BAD;
	        }
	        //--- DROPBITS(2) ---//
	        hold >>>= 2;
	        bits -= 2;
	        //---//
	        break;
	      case STORED:
	        //--- BYTEBITS() ---// /* go to byte boundary */
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	          strm.msg = 'invalid stored block lengths';
	          state.mode = BAD;
	          break;
	        }
	        state.length = hold & 0xffff;
	        //Tracev((stderr, "inflate:       stored length %u\n",
	        //        state.length));
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = COPY_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case COPY_:
	        state.mode = COPY;
	        /* falls through */
	      case COPY:
	        copy = state.length;
	        if (copy) {
	          if (copy > have) { copy = have; }
	          if (copy > left) { copy = left; }
	          if (copy === 0) { break inf_leave; }
	          //--- zmemcpy(put, next, copy); ---
	          utils.arraySet(output, input, next, copy, put);
	          //---//
	          have -= copy;
	          next += copy;
	          left -= copy;
	          put += copy;
	          state.length -= copy;
	          break;
	        }
	        //Tracev((stderr, "inflate:       stored end\n"));
	        state.mode = TYPE;
	        break;
	      case TABLE:
	        //=== NEEDBITS(14); */
	        while (bits < 14) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	        if (state.nlen > 286 || state.ndist > 30) {
	          strm.msg = 'too many length or distance symbols';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracev((stderr, "inflate:       table sizes ok\n"));
	        state.have = 0;
	        state.mode = LENLENS;
	        /* falls through */
	      case LENLENS:
	        while (state.have < state.ncode) {
	          //=== NEEDBITS(3);
	          while (bits < 3) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	          //--- DROPBITS(3) ---//
	          hold >>>= 3;
	          bits -= 3;
	          //---//
	        }
	        while (state.have < 19) {
	          state.lens[order[state.have++]] = 0;
	        }
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        //state.next = state.codes;
	        //state.lencode = state.next;
	        // Switch to use dynamic table
	        state.lencode = state.lendyn;
	        state.lenbits = 7;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	        state.lenbits = opts.bits;
	
	        if (ret) {
	          strm.msg = 'invalid code lengths set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, "inflate:       code lengths ok\n"));
	        state.have = 0;
	        state.mode = CODELENS;
	        /* falls through */
	      case CODELENS:
	        while (state.have < state.nlen + state.ndist) {
	          for (;;) {
	            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if (here_val < 16) {
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            state.lens[state.have++] = here_val;
	          }
	          else {
	            if (here_val === 16) {
	              //=== NEEDBITS(here.bits + 2);
	              n = here_bits + 2;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              if (state.have === 0) {
	                strm.msg = 'invalid bit length repeat';
	                state.mode = BAD;
	                break;
	              }
	              len = state.lens[state.have - 1];
	              copy = 3 + (hold & 0x03);//BITS(2);
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	            }
	            else if (here_val === 17) {
	              //=== NEEDBITS(here.bits + 3);
	              n = here_bits + 3;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 3 + (hold & 0x07);//BITS(3);
	              //--- DROPBITS(3) ---//
	              hold >>>= 3;
	              bits -= 3;
	              //---//
	            }
	            else {
	              //=== NEEDBITS(here.bits + 7);
	              n = here_bits + 7;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 11 + (hold & 0x7f);//BITS(7);
	              //--- DROPBITS(7) ---//
	              hold >>>= 7;
	              bits -= 7;
	              //---//
	            }
	            if (state.have + copy > state.nlen + state.ndist) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            while (copy--) {
	              state.lens[state.have++] = len;
	            }
	          }
	        }
	
	        /* handle error breaks in while */
	        if (state.mode === BAD) { break; }
	
	        /* check for end-of-block code (better have one) */
	        if (state.lens[256] === 0) {
	          strm.msg = 'invalid code -- missing end-of-block';
	          state.mode = BAD;
	          break;
	        }
	
	        /* build code tables -- note: do not change the lenbits or distbits
	           values here (9 and 6) without reading the comments in inftrees.h
	           concerning the ENOUGH constants, which depend on those values */
	        state.lenbits = 9;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.lenbits = opts.bits;
	        // state.lencode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid literal/lengths set';
	          state.mode = BAD;
	          break;
	        }
	
	        state.distbits = 6;
	        //state.distcode.copy(state.codes);
	        // Switch to use dynamic table
	        state.distcode = state.distdyn;
	        opts = { bits: state.distbits };
	        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.distbits = opts.bits;
	        // state.distcode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid distances set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, 'inflate:       codes ok\n'));
	        state.mode = LEN_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case LEN_:
	        state.mode = LEN;
	        /* falls through */
	      case LEN:
	        if (have >= 6 && left >= 258) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          inflate_fast(strm, _out);
	          //--- LOAD() ---
	          put = strm.next_out;
	          output = strm.output;
	          left = strm.avail_out;
	          next = strm.next_in;
	          input = strm.input;
	          have = strm.avail_in;
	          hold = state.hold;
	          bits = state.bits;
	          //---
	
	          if (state.mode === TYPE) {
	            state.back = -1;
	          }
	          break;
	        }
	        state.back = 0;
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if (here_bits <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_op && (here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.lencode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        state.length = here_val;
	        if (here_op === 0) {
	          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	          //        "inflate:         literal '%c'\n" :
	          //        "inflate:         literal 0x%02x\n", here.val));
	          state.mode = LIT;
	          break;
	        }
	        if (here_op & 32) {
	          //Tracevv((stderr, "inflate:         end of block\n"));
	          state.back = -1;
	          state.mode = TYPE;
	          break;
	        }
	        if (here_op & 64) {
	          strm.msg = 'invalid literal/length code';
	          state.mode = BAD;
	          break;
	        }
	        state.extra = here_op & 15;
	        state.mode = LENEXT;
	        /* falls through */
	      case LENEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", state.length));
	        state.was = state.length;
	        state.mode = DIST;
	        /* falls through */
	      case DIST:
	        for (;;) {
	          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if ((here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.distcode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        if (here_op & 64) {
	          strm.msg = 'invalid distance code';
	          state.mode = BAD;
	          break;
	        }
	        state.offset = here_val;
	        state.extra = (here_op) & 15;
	        state.mode = DISTEXT;
	        /* falls through */
	      case DISTEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	//#ifdef INFLATE_STRICT
	        if (state.offset > state.dmax) {
	          strm.msg = 'invalid distance too far back';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	        state.mode = MATCH;
	        /* falls through */
	      case MATCH:
	        if (left === 0) { break inf_leave; }
	        copy = _out - left;
	        if (state.offset > copy) {         /* copy from window */
	          copy = state.offset - copy;
	          if (copy > state.whave) {
	            if (state.sane) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break;
	            }
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	          }
	          if (copy > state.wnext) {
	            copy -= state.wnext;
	            from = state.wsize - copy;
	          }
	          else {
	            from = state.wnext - copy;
	          }
	          if (copy > state.length) { copy = state.length; }
	          from_source = state.window;
	        }
	        else {                              /* copy from output */
	          from_source = output;
	          from = put - state.offset;
	          copy = state.length;
	        }
	        if (copy > left) { copy = left; }
	        left -= copy;
	        state.length -= copy;
	        do {
	          output[put++] = from_source[from++];
	        } while (--copy);
	        if (state.length === 0) { state.mode = LEN; }
	        break;
	      case LIT:
	        if (left === 0) { break inf_leave; }
	        output[put++] = state.length;
	        left--;
	        state.mode = LEN;
	        break;
	      case CHECK:
	        if (state.wrap) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            // Use '|' instead of '+' to make sure that result is signed
	            hold |= input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          _out -= left;
	          strm.total_out += _out;
	          state.total += _out;
	          if (_out) {
	            strm.adler = state.check =
	                /*UPDATE(state.check, put - _out, _out);*/
	                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	          }
	          _out = left;
	          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	            strm.msg = 'incorrect data check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   check matches trailer\n"));
	        }
	        state.mode = LENGTH;
	        /* falls through */
	      case LENGTH:
	        if (state.wrap && state.flags) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.total & 0xffffffff)) {
	            strm.msg = 'incorrect length check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   length matches trailer\n"));
	        }
	        state.mode = DONE;
	        /* falls through */
	      case DONE:
	        ret = Z_STREAM_END;
	        break inf_leave;
	      case BAD:
	        ret = Z_DATA_ERROR;
	        break inf_leave;
	      case MEM:
	        return Z_MEM_ERROR;
	      case SYNC:
	        /* falls through */
	      default:
	        return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = __webpack_require__(369);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  /* process all codes and make table entries */
	  for (;;) {
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),
/* 383 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(326);
	var GenericWorker = __webpack_require__(354);
	var utf8 = __webpack_require__(325);
	var crc32 = __webpack_require__(362);
	var signature = __webpack_require__(385);
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "", i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Generate the UNIX part of the external file attributes.
	 * @param {Object} unixPermissions the unix permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
	 *
	 * TTTTsstrwxrwxrwx0000000000ADVSHR
	 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
	 *     ^^^_________________________ setuid, setgid, sticky
	 *        ^^^^^^^^^________________ permissions
	 *                 ^^^^^^^^^^______ not used ?
	 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
	 */
	var generateUnixExternalFileAttr = function (unixPermissions, isDir) {
	
	    var result = unixPermissions;
	    if (!unixPermissions) {
	        // I can't use octal values in strict mode, hence the hexa.
	        //  040775 => 0x41fd
	        // 0100664 => 0x81b4
	        result = isDir ? 0x41fd : 0x81b4;
	    }
	    return (result & 0xFFFF) << 16;
	};
	
	/**
	 * Generate the DOS part of the external file attributes.
	 * @param {Object} dosPermissions the dos permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * Bit 0     Read-Only
	 * Bit 1     Hidden
	 * Bit 2     System
	 * Bit 3     Volume Label
	 * Bit 4     Directory
	 * Bit 5     Archive
	 */
	var generateDosExternalFileAttr = function (dosPermissions) {
	    // the dir flag is already set for compatibility
	    return (dosPermissions || 0)  & 0x3F;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {Object} streamInfo the hash with information about the compressed file.
	 * @param {Boolean} streamedContent is the content streamed ?
	 * @param {Boolean} streamingEnded is the stream finished ?
	 * @param {number} offset the current offset from the start of the zip file.
	 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
	 * @param {Function} encodeFileName the function to encode the file name / comment.
	 * @return {Object} the zip parts.
	 */
	var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
	    var file = streamInfo["file"],
	        compression = streamInfo["compression"],
	        useCustomEncoding = encodeFileName !== utf8.utf8encode,
	        encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment,
	        encodedComment = utils.transformTo("string", encodeFileName(comment)),
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir = file.dir,
	        date = file.date;
	
	
	    var dataInfo = {
	        crc32 : 0,
	        compressedSize : 0,
	        uncompressedSize : 0
	    };
	
	    // if the content is streamed, the sizes/crc32 are only available AFTER
	    // the end of the stream.
	    if (!streamedContent || streamingEnded) {
	        dataInfo.crc32 = streamInfo["crc32"];
	        dataInfo.compressedSize = streamInfo["compressedSize"];
	        dataInfo.uncompressedSize = streamInfo["uncompressedSize"];
	    }
	
	    var bitflag = 0;
	    if (streamedContent) {
	        // Bit 3: the sizes/crc32 are set to zero in the local header.
	        // The correct values are put in the data descriptor immediately
	        // following the compressed data.
	        bitflag |= 0x0008;
	    }
	    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
	        // Bit 11: Language encoding flag (EFS).
	        bitflag |= 0x0800;
	    }
	
	
	    var extFileAttr = 0;
	    var versionMadeBy = 0;
	    if (dir) {
	        // dos or unix, we set the dos dir flag
	        extFileAttr |= 0x00010;
	    }
	    if(platform === "UNIX") {
	        versionMadeBy = 0x031E; // UNIX, version 3.0
	        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
	    } else { // DOS or other, fallback to DOS
	        versionMadeBy = 0x0014; // DOS, version 2.0
	        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
	    }
	
	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
	
	    dosTime = date.getUTCHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getUTCMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getUTCSeconds() / 2;
	
	    dosDate = date.getUTCFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getUTCMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getUTCDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(encodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(crc32(encodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    header += decToHex(bitflag, 2);
	    // compression method
	    header += compression.magic;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(dataInfo.crc32, 4);
	    // compressed size
	    header += decToHex(dataInfo.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(dataInfo.uncompressedSize, 4);
	    // file name length
	    header += decToHex(encodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	        // version made by (00: DOS)
	        decToHex(versionMadeBy, 2) +
	        // file header (common to file and central directory)
	        header +
	        // file comment length
	        decToHex(encodedComment.length, 2) +
	        // disk number start
	        "\x00\x00" +
	        // internal file attributes TODO
	        "\x00\x00" +
	        // external file attributes
	        decToHex(extFileAttr, 4) +
	        // relative offset of local header
	        decToHex(offset, 4) +
	        // file name
	        encodedFileName +
	        // extra field
	        extraFields +
	        // file comment
	        encodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord
	    };
	};
	
	/**
	 * Generate the EOCD record.
	 * @param {Number} entriesCount the number of entries in the zip file.
	 * @param {Number} centralDirLength the length (in bytes) of the central dir.
	 * @param {Number} localDirLength the length (in bytes) of the local dir.
	 * @param {String} comment the zip file comment as a binary string.
	 * @param {Function} encodeFileName the function to encode the comment.
	 * @return {String} the EOCD record.
	 */
	var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
	    var dirEnd = "";
	    var encodedComment = utils.transformTo("string", encodeFileName(comment));
	
	    // end of central dir signature
	    dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(entriesCount, 2) +
	        // total number of entries in the central directory
	        decToHex(entriesCount, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(encodedComment.length, 2) +
	        // .ZIP file comment
	        encodedComment;
	
	    return dirEnd;
	};
	
	/**
	 * Generate data descriptors for a file entry.
	 * @param {Object} streamInfo the hash generated by a worker, containing information
	 * on the file entry.
	 * @return {String} the data descriptors.
	 */
	var generateDataDescriptors = function (streamInfo) {
	    var descriptor = "";
	    descriptor = signature.DATA_DESCRIPTOR +
	        // crc-32                          4 bytes
	        decToHex(streamInfo["crc32"], 4) +
	        // compressed size                 4 bytes
	        decToHex(streamInfo["compressedSize"], 4) +
	        // uncompressed size               4 bytes
	        decToHex(streamInfo["uncompressedSize"], 4);
	
	    return descriptor;
	};
	
	
	/**
	 * A worker to concatenate other workers to create a zip file.
	 * @param {Boolean} streamFiles `true` to stream the content of the files,
	 * `false` to accumulate it.
	 * @param {String} comment the comment to use.
	 * @param {String} platform the platform to use, "UNIX" or "DOS".
	 * @param {Function} encodeFileName the function to encode file names and comments.
	 */
	function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
	    GenericWorker.call(this, "ZipFileWorker");
	    // The number of bytes written so far. This doesn't count accumulated chunks.
	    this.bytesWritten = 0;
	    // The comment of the zip file
	    this.zipComment = comment;
	    // The platform "generating" the zip file.
	    this.zipPlatform = platform;
	    // the function to encode file names and comments.
	    this.encodeFileName = encodeFileName;
	    // Should we stream the content of the files ?
	    this.streamFiles = streamFiles;
	    // If `streamFiles` is false, we will need to accumulate the content of the
	    // files to calculate sizes / crc32 (and write them *before* the content).
	    // This boolean indicates if we are accumulating chunks (it will change a lot
	    // during the lifetime of this worker).
	    this.accumulate = false;
	    // The buffer receiving chunks when accumulating content.
	    this.contentBuffer = [];
	    // The list of generated directory records.
	    this.dirRecords = [];
	    // The offset (in bytes) from the beginning of the zip file for the current source.
	    this.currentSourceOffset = 0;
	    // The total number of entries in this zip file.
	    this.entriesCount = 0;
	    // the name of the file currently being added, null when handling the end of the zip file.
	    // Used for the emitted metadata.
	    this.currentFile = null;
	
	
	
	    this._sources = [];
	}
	utils.inherits(ZipFileWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.push
	 */
	ZipFileWorker.prototype.push = function (chunk) {
	
	    var currentFilePercent = chunk.meta.percent || 0;
	    var entriesCount = this.entriesCount;
	    var remainingFiles = this._sources.length;
	
	    if(this.accumulate) {
	        this.contentBuffer.push(chunk);
	    } else {
	        this.bytesWritten += chunk.data.length;
	
	        GenericWorker.prototype.push.call(this, {
	            data : chunk.data,
	            meta : {
	                currentFile : this.currentFile,
	                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
	            }
	        });
	    }
	};
	
	/**
	 * The worker started a new source (an other worker).
	 * @param {Object} streamInfo the streamInfo object from the new source.
	 */
	ZipFileWorker.prototype.openedSource = function (streamInfo) {
	    this.currentSourceOffset = this.bytesWritten;
	    this.currentFile = streamInfo["file"].name;
	
	    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
	
	    // don't stream folders (because they don't have any content)
	    if(streamedContent) {
	        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
	        this.push({
	            data : record.fileRecord,
	            meta : {percent:0}
	        });
	    } else {
	        // we need to wait for the whole file before pushing anything
	        this.accumulate = true;
	    }
	};
	
	/**
	 * The worker finished a source (an other worker).
	 * @param {Object} streamInfo the streamInfo object from the finished source.
	 */
	ZipFileWorker.prototype.closedSource = function (streamInfo) {
	    this.accumulate = false;
	    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
	    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
	
	    this.dirRecords.push(record.dirRecord);
	    if(streamedContent) {
	        // after the streamed file, we put data descriptors
	        this.push({
	            data : generateDataDescriptors(streamInfo),
	            meta : {percent:100}
	        });
	    } else {
	        // the content wasn't streamed, we need to push everything now
	        // first the file record, then the content
	        this.push({
	            data : record.fileRecord,
	            meta : {percent:0}
	        });
	        while(this.contentBuffer.length) {
	            this.push(this.contentBuffer.shift());
	        }
	    }
	    this.currentFile = null;
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	ZipFileWorker.prototype.flush = function () {
	
	    var localDirLength = this.bytesWritten;
	    for(var i = 0; i < this.dirRecords.length; i++) {
	        this.push({
	            data : this.dirRecords[i],
	            meta : {percent:100}
	        });
	    }
	    var centralDirLength = this.bytesWritten - localDirLength;
	
	    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);
	
	    this.push({
	        data : dirEnd,
	        meta : {percent:100}
	    });
	};
	
	/**
	 * Prepare the next source to be read.
	 */
	ZipFileWorker.prototype.prepareNextSource = function () {
	    this.previous = this._sources.shift();
	    this.openedSource(this.previous.streamInfo);
	    if (this.isPaused) {
	        this.previous.pause();
	    } else {
	        this.previous.resume();
	    }
	};
	
	/**
	 * @see GenericWorker.registerPrevious
	 */
	ZipFileWorker.prototype.registerPrevious = function (previous) {
	    this._sources.push(previous);
	    var self = this;
	
	    previous.on("data", function (chunk) {
	        self.processChunk(chunk);
	    });
	    previous.on("end", function () {
	        self.closedSource(self.previous.streamInfo);
	        if(self._sources.length) {
	            self.prepareNextSource();
	        } else {
	            self.end();
	        }
	    });
	    previous.on("error", function (e) {
	        self.error(e);
	    });
	    return this;
	};
	
	/**
	 * @see GenericWorker.resume
	 */
	ZipFileWorker.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if (!this.previous && this._sources.length) {
	        this.prepareNextSource();
	        return true;
	    }
	    if (!this.previous && !this._sources.length && !this.generatedError) {
	        this.end();
	        return true;
	    }
	};
	
	/**
	 * @see GenericWorker.error
	 */
	ZipFileWorker.prototype.error = function (e) {
	    var sources = this._sources;
	    if(!GenericWorker.prototype.error.call(this, e)) {
	        return false;
	    }
	    for(var i = 0; i < sources.length; i++) {
	        try {
	            sources[i].error(e);
	        } catch(e) {
	            // the `error` exploded, nothing to do
	        }
	    }
	    return true;
	};
	
	/**
	 * @see GenericWorker.lock
	 */
	ZipFileWorker.prototype.lock = function () {
	    GenericWorker.prototype.lock.call(this);
	    var sources = this._sources;
	    for(var i = 0; i < sources.length; i++) {
	        sources[i].lock();
	    }
	};
	
	module.exports = ZipFileWorker;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	"use strict";
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(326);
	var GenericWorker = __webpack_require__(354);
	
	/**
	 * A worker that use a nodejs stream as source.
	 * @constructor
	 * @param {String} filename the name of the file entry for this stream.
	 * @param {Readable} stream the nodejs stream.
	 */
	function NodejsStreamInputAdapter(filename, stream) {
	    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
	    this._upstreamEnded = false;
	    this._bindStream(stream);
	}
	
	utils.inherits(NodejsStreamInputAdapter, GenericWorker);
	
	/**
	 * Prepare the stream and bind the callbacks on it.
	 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
	 * @param {Stream} stream the nodejs stream to use.
	 */
	NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
	    var self = this;
	    this._stream = stream;
	    stream.pause();
	    stream
	        .on("data", function (chunk) {
	            self.push({
	                data: chunk,
	                meta : {
	                    percent : 0
	                }
	            });
	        })
	        .on("error", function (e) {
	            if(self.isPaused) {
	                this.generatedError = e;
	            } else {
	                self.error(e);
	            }
	        })
	        .on("end", function () {
	            if(self.isPaused) {
	                self._upstreamEnded = true;
	            } else {
	                self.end();
	            }
	        });
	};
	NodejsStreamInputAdapter.prototype.pause = function () {
	    if(!GenericWorker.prototype.pause.call(this)) {
	        return false;
	    }
	    this._stream.pause();
	    return true;
	};
	NodejsStreamInputAdapter.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if(this._upstreamEnded) {
	        this.end();
	    } else {
	        this._stream.resume();
	    }
	
	    return true;
	};
	
	module.exports = NodejsStreamInputAdapter;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var utils = __webpack_require__(326);
	var external = __webpack_require__(350);
	var utf8 = __webpack_require__(325);
	var ZipEntries = __webpack_require__(388);
	var Crc32Probe = __webpack_require__(361);
	var nodejsUtils = __webpack_require__(349);
	
	/**
	 * Check the CRC32 of an entry.
	 * @param {ZipEntry} zipEntry the zip entry to check.
	 * @return {Promise} the result.
	 */
	function checkEntryCRC32(zipEntry) {
	    return new external.Promise(function (resolve, reject) {
	        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
	        worker.on("error", function (e) {
	            reject(e);
	        })
	            .on("end", function () {
	                if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
	                    reject(new Error("Corrupted zip : CRC32 mismatch"));
	                } else {
	                    resolve();
	                }
	            })
	            .resume();
	    });
	}
	
	module.exports = function (data, options) {
	    var zip = this;
	    options = utils.extend(options || {}, {
	        base64: false,
	        checkCRC32: false,
	        optimizedBinaryString: false,
	        createFolders: false,
	        decodeFileName: utf8.utf8decode
	    });
	
	    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
	        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
	    }
	
	    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
	        .then(function (data) {
	            var zipEntries = new ZipEntries(options);
	            zipEntries.load(data);
	            return zipEntries;
	        }).then(function checkCRC32(zipEntries) {
	            var promises = [external.Promise.resolve(zipEntries)];
	            var files = zipEntries.files;
	            if (options.checkCRC32) {
	                for (var i = 0; i < files.length; i++) {
	                    promises.push(checkEntryCRC32(files[i]));
	                }
	            }
	            return external.Promise.all(promises);
	        }).then(function addFiles(results) {
	            var zipEntries = results.shift();
	            var files = zipEntries.files;
	            for (var i = 0; i < files.length; i++) {
	                var input = files[i];
	
	                var unsafeName = input.fileNameStr;
	                var safeName = utils.resolve(input.fileNameStr);
	
	                zip.file(safeName, input.decompressed, {
	                    binary: true,
	                    optimizedBinaryString: true,
	                    date: input.date,
	                    dir: input.dir,
	                    comment: input.fileCommentStr.length ? input.fileCommentStr : null,
	                    unixPermissions: input.unixPermissions,
	                    dosPermissions: input.dosPermissions,
	                    createFolders: options.createFolders
	                });
	                if (!input.dir) {
	                    zip.file(safeName).unsafeOriginalName = unsafeName;
	                }
	            }
	            if (zipEntries.zipComment.length) {
	                zip.comment = zipEntries.zipComment;
	            }
	
	            return zip;
	        });
	};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var readerFor = __webpack_require__(389);
	var utils = __webpack_require__(326);
	var sig = __webpack_require__(385);
	var ZipEntry = __webpack_require__(395);
	var support = __webpack_require__(327);
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the specified signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        if (!this.reader.readAndCheckSignature(expectedSignature)) {
	            this.reader.index -= 4;
	            var signature = this.reader.readString(4);
	            throw new Error("Corrupted zip or bug: unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Check if the given signature is at the given index.
	     * @param {number} askedIndex the index to check.
	     * @param {string} expectedSignature the signature to expect.
	     * @return {boolean} true if the signature is here, false otherwise.
	     */
	    isSignature: function(askedIndex, expectedSignature) {
	        var currentIndex = this.reader.index;
	        this.reader.setIndex(askedIndex);
	        var signature = this.reader.readString(4);
	        var result = signature === expectedSignature;
	        this.reader.setIndex(currentIndex);
	        return result;
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        var zipComment = this.reader.readData(this.zipCommentLength);
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded unless specified otherwise.
	        var decodeContent = utils.transformTo(decodeParamType, zipComment);
	        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.reader.skip(4);
	        // this.versionMadeBy = this.reader.readString(2);
	        // this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readData(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	            file.processAttributes();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	
	        if (this.centralDirRecords !== this.files.length) {
	            if (this.centralDirRecords !== 0 && this.files.length === 0) {
	                // We expected some records but couldn't find ANY.
	                // This is really suspicious, as if something went wrong.
	                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
	            } else {
	                // We found some records but not all.
	                // Something is wrong but we got something for the user: no error here.
	                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
	            }
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset < 0) {
	            // Check if the content is a truncated zip or complete garbage.
	            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
	            // extractible zip for example) but it can give a good hint.
	            // If an ajax request was used without responseType, we will also
	            // get unreadable data.
	            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);
	
	            if (isGarbage) {
	                throw new Error("Can't find end of central directory : is this a zip file ? " +
	                                "If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
	            } else {
	                throw new Error("Corrupted zip: can't find end of central directory");
	            }
	
	        }
	        this.reader.setIndex(offset);
	        var endOfCentralDirOffset = offset;
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset < 0) {
	                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
	                // console.warn("ZIP64 end of central directory not where expected.");
	                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
	                    throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
	                }
	            }
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	
	        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
	        if (this.zip64) {
	            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
	            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
	        }
	
	        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
	
	        if (extraBytes > 0) {
	            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
	            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
	                // The offsets seem wrong, but we have something at the specified offset.
	                // So… we keep it.
	            } else {
	                // the offset is wrong, update the "zero" of the reader
	                // this happens if data has been prepended (crx files for example)
	                this.reader.zero = extraBytes;
	            }
	        } else if (extraBytes < 0) {
	            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
	        }
	    },
	    prepareReader: function(data) {
	        this.reader = readerFor(data);
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(326);
	var support = __webpack_require__(327);
	var ArrayReader = __webpack_require__(390);
	var StringReader = __webpack_require__(392);
	var NodeBufferReader = __webpack_require__(393);
	var Uint8ArrayReader = __webpack_require__(394);
	
	/**
	 * Create a reader adapted to the data.
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
	 * @return {DataReader} the data reader.
	 */
	module.exports = function (data) {
	    var type = utils.getTypeOf(data);
	    utils.checkSupport(type);
	    if (type === "string" && !support.uint8array) {
	        return new StringReader(data);
	    }
	    if (type === "nodebuffer") {
	        return new NodeBufferReader(data);
	    }
	    if (support.uint8array) {
	        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
	    }
	    return new ArrayReader(utils.transformTo("array", data));
	};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var DataReader = __webpack_require__(391);
	var utils = __webpack_require__(326);
	
	function ArrayReader(data) {
	    DataReader.call(this, data);
	    for(var i = 0; i < this.data.length; i++) {
	        data[i] = data[i] & 0xFF;
	    }
	}
	utils.inherits(ArrayReader, DataReader);
	/**
	 * @see DataReader.byteAt
	 */
	ArrayReader.prototype.byteAt = function(i) {
	    return this.data[this.zero + i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i - this.zero;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readAndCheckSignature
	 */
	ArrayReader.prototype.readAndCheckSignature = function (sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3),
	        data = this.readData(4);
	    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
	};
	/**
	 * @see DataReader.readData
	 */
	ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        return [];
	    }
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = ArrayReader;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var utils = __webpack_require__(326);
	
	function DataReader(data) {
	    this.data = data; // type : see implementation
	    this.length = data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specified index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < this.zero + newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function() {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function() {
	        // see implementations
	    },
	    /**
	     * Find the last occurrence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurrence, -1 if not found.
	     */
	    lastIndexOfSignature: function() {
	        // see implementations
	    },
	    /**
	     * Read the signature (4 bytes) at the current position and compare it with sig.
	     * @param {string} sig the expected signature
	     * @return {boolean} true if the signature matches, false otherwise.
	     */
	    readAndCheckSignature: function() {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(Date.UTC(
	            ((dostime >> 25) & 0x7f) + 1980, // year
	            ((dostime >> 21) & 0x0f) - 1, // month
	            (dostime >> 16) & 0x1f, // day
	            (dostime >> 11) & 0x1f, // hour
	            (dostime >> 5) & 0x3f, // minute
	            (dostime & 0x1f) << 1)); // second
	    }
	};
	module.exports = DataReader;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var DataReader = __webpack_require__(391);
	var utils = __webpack_require__(326);
	
	function StringReader(data) {
	    DataReader.call(this, data);
	}
	utils.inherits(StringReader, DataReader);
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(this.zero + i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig) - this.zero;
	};
	/**
	 * @see DataReader.readAndCheckSignature
	 */
	StringReader.prototype.readAndCheckSignature = function (sig) {
	    var data = this.readData(4);
	    return sig === data;
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Uint8ArrayReader = __webpack_require__(394);
	var utils = __webpack_require__(326);
	
	function NodeBufferReader(data) {
	    Uint8ArrayReader.call(this, data);
	}
	utils.inherits(NodeBufferReader, Uint8ArrayReader);
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayReader = __webpack_require__(390);
	var utils = __webpack_require__(326);
	
	function Uint8ArrayReader(data) {
	    ArrayReader.call(this, data);
	}
	utils.inherits(Uint8ArrayReader, ArrayReader);
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var readerFor = __webpack_require__(389);
	var utils = __webpack_require__(326);
	var CompressedObject = __webpack_require__(359);
	var crc32fn = __webpack_require__(362);
	var utf8 = __webpack_require__(325);
	var compressions = __webpack_require__(366);
	var support = __webpack_require__(327);
	
	var MADE_BY_DOS = 0x00;
	var MADE_BY_UNIX = 0x03;
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	var findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!Object.prototype.hasOwnProperty.call(compressions, method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
	        this.fileName = reader.readData(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough information from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
	        }
	
	        compression = findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
	        }
	        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readInt(2);
	        reader.skip(2);
	        // this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        var fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        // will be read in the local part, see the comments there
	        reader.skip(fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readData(this.fileCommentLength);
	    },
	
	    /**
	     * Parse the external file attributes and get the unix/dos permissions.
	     */
	    processAttributes: function () {
	        this.unixPermissions = null;
	        this.dosPermissions = null;
	        var madeBy = this.versionMadeBy >> 8;
	
	        // Check if we have the DOS directory flag set.
	        // We look for it in the DOS and UNIX permissions
	        // but some unknown platform could set it as a compatibility flag.
	        this.dir = this.externalFileAttributes & 0x0010 ? true : false;
	
	        if(madeBy === MADE_BY_DOS) {
	            // first 6 bits (0 to 5)
	            this.dosPermissions = this.externalFileAttributes & 0x3F;
	        }
	
	        if(madeBy === MADE_BY_UNIX) {
	            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
	            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
	        }
	
	        // fail safe : if the name ends with a / it probably means a folder
	        if (!this.dir && this.fileNameStr.slice(-1) === "/") {
	            this.dir = true;
	        }
	    },
	
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function() {
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = readerFor(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var end = reader.index + this.extraFieldsLength,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        if (!this.extraFields) {
	            this.extraFields = {};
	        }
	
	        while (reader.index + 4 < end) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readData(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	
	        reader.setIndex(end);
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        if (this.useUTF8()) {
	            this.fileNameStr = utf8.utf8decode(this.fileName);
	            this.fileCommentStr = utf8.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileNameStr = upath;
	            } else {
	                // ASCII text or unsupported code page
	                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
	                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
	            }
	
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileCommentStr = ucomment;
	            } else {
	                // ASCII text or unsupported code page
	                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
	                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = readerFor(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = readerFor(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"dashboard dashboard--page dashboard--page--submission\">\n    <div class=\"page-wrapper\">\n        <div class=\"dashboard-header\">\n            <sidebarnav></sidebarnav>\n        </div>\n\n        <div class=\"main\">\n            <mainheaderauth></mainheaderauth>\n            <maintocselection />\n\n            <div class=\"content container\">\n\n                <h1 class=\"page-title\">Jurisdiction Zoning Updates Form</h1>\n                <p>\n                    Jurisdictions who have met with MTC staff and determined that zoning data revisions are too\n                    significant to complete in the TOC Policy submission portal can instead upload zoning data directly\n                    to the portal. In these instances, local staff will receive an email providing instructions for\n                    submitting updated zoning data to MTC. The final step in this process is to complete the form below\n                    and upload all required files. Please contact <a href=\"\">TOCPolicy@bayareametro.gov</a> with any\n                    questions about this process.\n                </p>\n\n                <div class=\"section-nav\">\n                    <div class=\"menu--section-title\">In this section:</div>\n                    <ul class=\"menu menu--section\" role=\"tablist\">\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-1\"\n                            class=\"menu-item menu-item--section active\">\n                            <span class=\"section-number\">I.</span><a href=\"#\">Jurisdiction Zoning Updates Form</a>\n                        </li>\n                        <li data-bs-toggle=\"tab\" data-bs-target=\"#section-review-submit\"\n                            class=\"menu-item menu-item--section\" ng-click=\"reviewAndSubmit\">\n                            <span class=\"section-number\"></span><a href=\"#\">Review and Submit</a>\n                        </li>\n                    </ul>\n                    <note ng-show=\"note\"></note>\n                    <furtherguidance></furtherguidance>\n                </div>\n                <div class=\"tab-content\">\n                    <!-- Jurisdiction Zoning Updates Form Section -->\n                    <div id=\"section-1\" role=\"tabpanel\" class=\"section tab-pane active\"\n                        ng-class=\"{'active show': showPanel === 'zoningUpdates'}\"\n                        ng-class=\"{'was-validated': formSubmitted}\">\n                        <h2>Jurisdiction Zoning Updates Form</h2>\n                        <p style=\"padding-top: 10px\">\n                            <strong>Provide spatial data that define the boundaries of each zoning classification</strong>\n                            <ul>\n                                <li>\n                                    Zoning data should be provided at a zoning-boundary level geography and not at a\n                                    parcel-level geography. MTC will spatially-assign zoning boundary information to our\n                                    internal parcel basemap.\n                                </li>\n                                <li>\n                                    Metadata or data dictionaries should be provided to ensure the necessary context is\n                                    available to make the data understandable and usable.\n                                </li>\n                                <li>\n                                    Please ensure that the zoning code column is included in the spatial data file and\n                                    indicated in the form below. Zoning code definition: <span style=\"font-style: italic;\">Zoning classification or code, using\n                                    a system of words, letters, figures, or other symbols used to classify and separate land\n                                    use areas, as designated in the current, adopted zoning code.</span>\n                                </li>\n                                <li>\n                                    <span style=\"font-weight: bold;\">Please only provide data in the formats listed in the format of dataset drop-down.</span>\n                                </li>\n                                <li>\n                                    Optionally, download the <a href=\"https://mtcdrive.box.com/s/c6achlbkb21fmuzlixpgbb1299tvy99s\" target=\"_blank\">Zoning Data Template</a> to easily compile data before entering\nit into the                         portal.\n                                </li>\n                            </ul>\n                        </p>\n\n                        <form class=\"row test-validation-styling\" name=\"zoningForm\" id=\"zoningForm\" novalidate>\n                            <div class=\"row\" style=\"padding-left: 15px; padding-bottom: 20px\">\n                                <div class=\"form-item col-lg-12\">\n                                    <label>What type(s) of data govern local development decisions? Select one or more from the menu below:</label>\n                                    <div class=\"checkbox-group\" style=\"padding-left: 15px;\">\n                                        <div class=\"form-check\">\n                                            <input class=\"form-check-input\" type=\"checkbox\" id=\"dataset_type_general\"\n                                                ng-model=\"currentZoningForm.dataset_types.general_plan\"\n                                                ng-change=\"updateDatasetTypes()\" required>\n                                            <label class=\"form-check-label\" for=\"dataset_type_general\">General Plan</label>\n                                        </div>\n                                        <div class=\"form-check\">\n                                            <input class=\"form-check-input\" type=\"checkbox\" id=\"dataset_type_specific\"\n                                                ng-model=\"currentZoningForm.dataset_types.specific_plan\"\n                                                ng-change=\"updateDatasetTypes()\">\n                                            <label class=\"form-check-label\" for=\"dataset_type_specific\">Specific Plan, Area Plan, Planned Development,\n                                            Etc.</label>\n                                        </div>\n                                        <div class=\"form-check\">\n                                            <input class=\"form-check-input\" type=\"checkbox\" id=\"dataset_type_zoning\"\n                                                ng-model=\"currentZoningForm.dataset_types.zoning\"\n                                                ng-change=\"updateDatasetTypes()\">\n                                            <label class=\"form-check-label\" for=\"dataset_type_zoning\">Zoning</label>\n                                        </div>\n                                        <div class=\"form-check\">\n                                            <input class=\"form-check-input\" type=\"checkbox\" id=\"dataset_type_other\"\n                                                ng-model=\"currentZoningForm.dataset_types.other\"\n                                                ng-change=\"updateDatasetTypes()\">\n                                            <label class=\"form-check-label\" for=\"dataset_type_other\">Other</label>\n                                        </div>\n                                    </div>\n                                    \n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"!hasSelectedDatasetType() && formSubmitted\">\n                                        Please select at least one option.\n                                    </div>\n                                </div>\n                                 <div class=\"form-item col-lg-12\" ng-if=\"currentZoningForm.dataset_types.other\">\n                                    <label for=\"other_dataset_type\">If 'Other' was selected above, please describe what you are providing.</label>\n                                    <input\n                                        ng-model=\"currentZoningForm.other_dataset_type\"\n                                        id=\"other_dataset_type\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"\n                                        name=\"other_dataset_type\" style=\"width: 100%\"\n                                        placeholder=\"Enter dataset type\" required/>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.other_dataset_type.$error.required && formSubmitted\">\n                                        Please provide a valid response.</div>\n                                </div>\n                                  <div class=\"form-item col-lg-12\" ng-if=\"hasOtherPlusOtherOptions()\">\n                                    <label for=\"multiple_dataset_type\">If multiple dataset types were selected, describe how these data work together to govern development decisions.</label>\n                                    <input\n                                        ng-model=\"currentZoningForm.multiple_dataset_type\"\n                                        id=\"multiple_dataset_type\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"\n                                        name=\"multiple_dataset_type\" style=\"width: 100%\"\n                                        placeholder=\"Enter dataset type\" required/>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.multiple_dataset_type.$error.required && formSubmitted\">\n                                        Please provide a valid response.</div>\n                                </div>\n                               \n                                <div class=\"form-item col-lg-12\" ng-if=\"hasOtherOrSingleOption() || currentZoningForm.multiple_dataset_type\">\n                                    <label>What format are you providing datasets in?</label>\n                                    <select id=\"dataset_format\" name=\"dataset_format\"\n                                        ng-model=\"currentZoningForm.dataset_format\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\" required>\n                                        <option selected disabled value=\"\">Choose...</option>\n                                        <option value=\"Shapefile\">Shapefile</option>\n                                        <option value=\"ESRI file geodatabase\">ESRI File Geodatabase\n                                        </option>\n                                        <option value=\"OGC Geopackage\">OGC Geopackage</option>\n                                        <option value=\"GeoJSON\">GeoJSON</option>\n                                        <option value=\"Link\">Web Map Link</option>\n\n                                    </select>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.dataset_format.$error.required && formSubmitted\">\n                                        Please choose a valid response.\n                                    </div>\n                                </div>\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentZoningForm.dataset_format == 'Link'\">\n                                    <div ng-if=\"currentZoningForm.dataset_types.general_plan\">\n                                        <label style=\"margin-top: 10px !important;\">Provide General Plan dataset URL:</label>\n                                        <input \n                                            id=\"dataset_url_general_plan\" name=\"dataset_url_general_plan\" type=\"text\"\n                                            onchange=\"angular.element(this).scope().updateDatasetUrls()\"\n                                            ng-model=\"currentZoningForm.dataset_url_general_plan\" required />\n                                    </div>\n                                    <div ng-if=\"currentZoningForm.dataset_types.specific_plan\">\n                                        <label style=\"margin-top: 10px !important;\">Provide Specific Plan dataset URL:</label>\n                                        <input \n                                            id=\"dataset_url_specific_plan\" name=\"dataset_url_specific_plan\" type=\"text\"\n                                            onchange=\"angular.element(this).scope().updateDatasetUrls()\"\n                                            ng-model=\"currentZoningForm.dataset_url_specific_plan\" required />\n                                    </div>\n                                    <div ng-if=\"currentZoningForm.dataset_types.zoning\">\n                                        <label style=\"margin-top: 10px !important;\">Provide Zoning dataset URL:</label>\n                                        <input \n                                            id=\"dataset_url_zoning\" name=\"dataset_url_zoning\" type=\"text\"\n                                            onchange=\"angular.element(this).scope().updateDatasetUrls()\"\n                                            ng-model=\"currentZoningForm.dataset_url_zoning\" required />\n                                    </div>\n                                    <div ng-if=\"currentZoningForm.dataset_types.other\">\n                                        <label style=\"margin-top: 10px !important;\">Provide Other dataset URL:</label>\n                                        <input \n                                            id=\"dataset_url_other\" name=\"dataset_url_other\" type=\"text\"\n                                            onchange=\"angular.element(this).scope().updateDatasetUrls()\"\n                                            ng-model=\"currentZoningForm.dataset_url_other\" required />\n                                    </div>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.dataset_url.$error.required && formSubmitted\">\n                                        Please provide a valid URL.</div>\n                                </div>\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentZoningForm.dataset_format == 'Link'\">\n                                    <div ng-if=\"currentZoningForm.dataset_types.general_plan\">\n                                        <label style=\"margin-top: 10px !important;\">Provide date General Plan datasets were last updated:</label>\n                                        <input \n                                            id=\"dataset_date_general_plan\" name=\"dataset_date_general_plan\" type=\"date\"\n                                            onchange=\"angular.element(this).scope().updateDatasetDates()\" style=\"margin-bottom: 15px;\"\n                                            ng-model=\"currentZoningForm.dataset_date_general_plan\" required />\n                                    </div>\n                                    <div ng-if=\"currentZoningForm.dataset_types.specific_plan\" style=\"margin-top: 15px !important;\">\n                                        <label style=\"margin-top: 10px !important;\">Provide date Specific Plan datasets were last updated:</label>\n                                        <input \n                                            id=\"dataset_date_specific_plan\" name=\"dataset_date_specific_plan\" type=\"date\"\n                                            onchange=\"angular.element(this).scope().updateDatasetDates()\"\n                                            ng-model=\"currentZoningForm.dataset_date_specific_plan\" required />\n                                    </div>\n                                    <div ng-if=\"currentZoningForm.dataset_types.zoning\" style=\"margin-top: 15px !important;\">\n                                        <label style=\"margin-top: 10px !important;\">Provide date Zoning datasets were last updated:</label>\n                                        <input \n                                            id=\"dataset_date_zoning\" name=\"dataset_date_zoning\" type=\"date\"\n                                            onchange=\"angular.element(this).scope().updateDatasetDates()\"\n                                            ng-model=\"currentZoningForm.dataset_date_zoning\" required />\n                                    </div>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"formSubmitted && !currentZoningForm.dataset_date_last_updated\">\n                                        Please provide a valid date.\n                                    </div>\n                                </div>\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentZoningForm.dataset_url || (currentZoningForm.dataset_format && currentZoningForm.dataset_format != 'Link')\">\n                                    <label for=\"land_use_code_column\">Provide land use code column that should be reflected on the Density For Residential Uses or Intensity for Commercial Uses pages (ex: R-1; C-C):</label>\n                                    <input\n                                        ng-model=\"currentZoningForm.land_use_code_column\"\n                                        id=\"land_use_code_column\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"\n                                        name=\"land_use_code_column\" style=\"width: 100%\"\n                                        placeholder=\"Enter response\" required/>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.land_use_code_column.$error.required && formSubmitted\">\n                                        Please provide a valid response.</div>\n                                </div>\n                                 \n                               \n                                <!-- File Upload dataset_url\n                                <div ng-if=\"!checkSubstring(currentZoningForm.dataset_url)\"\n                                    style=\"margin-top: 45px\" class=\"col-lg-1\"><b class=\"or-label\">OR</b></div>\n                                <div class=\"col-md-5\"\n                                    ng-if=\"checkSubstring(currentZoningForm.dataset_url)\"\n                                    style=\"padding-bottom:10px;\">\n                                    <span style=\"padding-right:10px;\"><a target=\"_blank\"\n                                            ng-href=\"{{currentZoningForm.dataset_url}}\">Uploaded\n                                            Documentation</a></span>\n                                    <button class=\"button button--attach\"\n                                        ng-click=\"removeFile('dataset_url')\"><i\n                                            ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i>\n                                        Remove</button>\n                                </div>\n                                <div class=\"row align-items-center\" style=\"padding-bottom:20px;\"\n                                    ng-if=\"!checkSubstring(currentZoningForm.dataset_url)\">\n                                    <div class=\"col-lg-2\"><label\n                                            for=\"dataset_url_file_abcd\">Dataset URL\n                                            Documentation</label></div>\n                                    <div class=\"col-lg-5 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                        <input type=\"file\" ng-model=\"dataset_url_file_abcd\"\n                                            id=\"dataset_url_file_abcd\"\n                                            name=\"dataset_url_file_abcd\"\n                                            accept=\".zip\"\n                                            onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                                            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                            ng-show=\"dataset_url_file_abcd && !dataset_url_file_abcd.name.endsWith('.zip') && formSubmitted\">\n                                            Please upload a .zip file.\n                                        </div>\n                                    </div>\n                                    <div class=\"col-md-5\">\n                                        <button class=\"button button--attach\"\n                                            ng-click=\"uploadFile('dataset_url_file_abcd')\"><i\n                                                ng-show=\"fileUploading_dataset_url_file_abcd\"\n                                                class=\"fa-solid fa-cog fa-spin\"></i>\n                                            Upload File</button>\n                                        <button type=\"button\" class=\"button button--clear\"\n                                            ng-click=\"clearFile('dataset_url_file_abcd')\">\n                                            Clear\n                                        </button>\n                                    </div>\n                                </div> -->\n                                \n                                 <p style=\"font-weight: bold;\" ng-if=\"hasMultipleNonOtherOptions()\">Please provide maps for: {{currentZoningForm.dataset_type}}</p>\n                                 \n                                <div class=\"form-item col-lg-12\" ng-if=\"hasMultipleNonOtherOptions()\">\n                                    <label>What format are you providing the maps in?</label>\n                                    <select id=\"map_format\" name=\"map_format\" ng-model=\"currentZoningForm.map_format\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\" required>\n                                        <option selected disabled value=\"\">Choose...</option>\n                                        <option value=\"PDF\">PDF</option>\n                                        <option value=\"PNG\">PNG\n                                        </option>\n                                        <option value=\"JPEG\">JPEG</option>\n                                        <option value=\"Link\">Web Map Link</option>\n                                    </select>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.map_format.$error.required && formSubmitted\">\n                                        Please choose a valid response.\n                                    </div>\n                                </div>\n\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentZoningForm.map_format == 'Link'\">\n                                    <label for=\"map_url\">Please provide Web Map link:</label>\n                                    <h4>You may only provide <b>one</b> link. Web Map must contain a representation of the following types: <b>{{currentZoningForm.dataset_type}}</b></h4>\n                                    <input\n                                        ng-model=\"currentZoningForm.map_url\"\n                                        id=\"map_url\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"\n                                        name=\"map_url\"\n                                        placeholder=\"Enter URL\" required/>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.map_url.$error.required && formSubmitted\">\n                                        Please provide a valid URL.</div>\n                                </div>\n                                 <div class=\"form-item col-lg-12\" ng-if=\"currentZoningForm.map_url && currentZoningForm.map_format == 'Link'\">\n                                    <div ng-if=\"currentZoningForm.dataset_types.general_plan\">\n                                        <label style=\"margin-top: 10px !important;\">Provide date General Plan maps were last updated:</label>\n                                        <input \n                                            id=\"map_date_general_plan\" name=\"map_date_general_plan\" type=\"date\"\n                                            onchange=\"angular.element(this).scope().updateMapDates()\"\n                                            ng-model=\"currentZoningForm.map_date_general_plan\" required />\n                                    </div>\n                                    <div ng-if=\"currentZoningForm.dataset_types.specific_plan\">\n                                        <label style=\"margin-top: 10px !important;\">Provide date Specific Plan maps were last updated:</label>\n                                        <input \n                                            id=\"map_date_specific_plan\" name=\"map_date_specific_plan\" type=\"date\"\n                                            onchange=\"angular.element(this).scope().updateMapDates()\"\n                                            ng-model=\"currentZoningForm.map_date_specific_plan\" required />\n                                    </div>\n                                    <div ng-if=\"currentZoningForm.dataset_types.zoning\">\n                                        <label style=\"margin-top: 10px !important;\">Provide date Zoning maps were last updated:</label>\n                                        <input \n                                            id=\"map_date_zoning\" name=\"map_date_zoning\" type=\"date\"\n                                            onchange=\"angular.element(this).scope().updateMapDates()\"\n                                            ng-model=\"currentZoningForm.map_date_zoning\" required />\n                                    </div>\n                                    <div ng-if=\"currentZoningForm.dataset_types.other\">\n                                        <label style=\"margin-top: 10px !important;\">Provide date Other maps were last updated:</label>\n                                        <input \n                                            id=\"map_date_other\" name=\"map_date_other\" type=\"date\"\n                                            onchange=\"angular.element(this).scope().updateMapDates()\"\n                                            ng-model=\"currentZoningForm.map_date_other\" required />\n                                    </div>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"formSubmitted && !currentZoningForm.map_date_last_updated\">\n                                        Please provide a valid date.\n                                    </div>\n                                </div>\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentZoningForm.land_use_code_column\">\n                                    <label for=\"land_use_upload\">Zip all land use data into a single, zipped/compressed file ending in .zip and upload here:</label>\n                                    <div class=\"col-md-\" ng-if=\"currentZoningForm.land_use_upload\" style=\"padding-bottom:10px;\">\n                                        <span style=\"padding-right:10px;\"><a target=\"_blank\" ng-href=\"{{currentZoningForm.land_use_upload}}\">Uploaded File</a></span>\n                                        <button class=\"button button--attach\" ng-click=\"removeFile('land_use_upload')\">\n                                            <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i> Remove\n                                        </button>\n                                    </div>\n                                    <div class=\"row align-items-center\" style=\"padding-bottom:20px;\" ng-if=\"!currentZoningForm.land_use_upload\">\n                                        <div class=\"col-lg-2\"><label for=\"land_use_uploadfile_abcd\">Upload File</label></div>\n                                        <div class=\"col-lg-4 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                            <input type=\"file\" ng-model=\"land_use_upload_file_abcd\"\n                                                id=\"land_use_upload_file_abcd\"\n                                                name=\"land_use_upload_file_abcd\"\n                                                webkitdirectory directory multiple\n                                                onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                                            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                ng-show=\"formSubmitted && !currentZoningForm.land_use_upload\">\n                                                Please upload a .zip file.\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-6\">\n                                            <button class=\"button button--attach\" ng-click=\"uploadFile('land_use_upload_file_abcd')\">\n                                                <i ng-show=\"fileUploading_land_use_upload_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i> Upload File\n                                            </button>\n                                            <button type=\"button\" class=\"button button--clear\" ng-click=\"clearFile('land_use_upload_file_abcd')\">Clear</button>\n                                        </div>\n                                    </div>\n                                </div>\n                                <!-- <div class=\"form-item col-lg-12\">\n                                    <label>Type of map:</label>\n                                    <select id=\"map_type\" name=\"map_type\" ng-model=\"currentZoningForm.map_type\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\" required>\n                                        <option selected disabled value=\"\">Choose...</option>\n                                        <option value=\"General Plan Map\">General Plan Map</option>\n                                        <option value=\"Specific Plan, Area Plan, Planned Dev Map\">Specific Plan Map,\n                                            Area Plan Map, Planned\n                                            Development\n                                            Map, Etc.\n                                        </option>\n                                        <option value=\"Zoning Map\">Zoning Map</option>\n\n\n                                    </select>\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.map_type.$error.required && formSubmitted\">\n                                        Please choose a valid response.\n                                    </div>\n                                </div> -->\n                               \n\n                                 \n                                <!-- Folder Upload files_upload -->\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentZoningForm.map_format && currentZoningForm.map_format != 'Link'\">\n                                    <label for=\"files_upload\" style=\"font-weight: bold;\">Zip all visual representation of land use data files into a single, zipped/compressed file ending in .zip and upload below:</label>\n                                    <div class=\"col-md-5\" ng-if=\"currentZoningForm.files_upload\" style=\"padding-bottom:10px;\">\n                                        <span style=\"padding-right:10px;\"><a target=\"_blank\" ng-href=\"{{currentZoningForm.files_upload}}\">Uploaded File</a></span>\n                                        <button class=\"button button--attach\" ng-click=\"removeFile('files_upload')\">\n                                            <i ng-show=\"fileUploading\" class=\"fa-solid fa-cog fa-spin\"></i> Remove\n                                        </button>\n                                    </div>\n                                    <div class=\"row align-items-center\" style=\"padding-bottom:20px;\" ng-if=\"!currentZoningForm.files_upload\">\n                                        <div class=\"col-lg-2\"><label for=\"files_uploadfile_abcd\">Upload File</label></div>\n                                        <div class=\"col-lg-4 adjust-padding\" style=\"margin-left: 0 !important;\">\n                                            <input type=\"file\" ng-model=\"files_upload_file_abcd\"\n                                                id=\"files_upload_file_abcd\"\n                                                name=\"files_upload_file_abcd\"\n                                                webkitdirectory directory multiple\n                                                onchange=\"angular.element(this).scope().handleFileSelect(this)\" />\n                                            <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                                ng-show=\"formSubmitted && !currentZoningForm.files_upload\">\n                                                Please upload a .zip file.\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-6\">\n                                            <button class=\"button button--attach\" ng-click=\"uploadFile('files_upload_file_abcd')\">\n                                                <i ng-show=\"fileUploading_files_upload_file_abcd\" class=\"fa-solid fa-cog fa-spin\"></i> Upload File\n                                            </button>\n                                            <button type=\"button\" class=\"button button--clear\" ng-click=\"clearFile('files_upload_file_abcd')\">Clear</button>\n                                        </div>\n                                    </div>\n                                </div>\n                         \n                                \n                              \n\n                               \n\n                                <p style=\"font-weight: bold;\">MTC will upload the zoning data and notify you once complete. Once the upload is complete,\n                                    the residential and commercial density form will reflect the updated zones.</p>\n                                <p>Following this update, local jurisdiction staff will need to use the Density section of the Portal to input the permitted use and minimum/maximum density and intensity for each zone in the TOC area(s). MTC staff recommend downloading the <a href=\"https://mtcdrive.box.com/s/c6achlbkb21fmuzlixpgbb1299tvy99s\" target=\"_blank\">Zoning Data Template</a> to easily compile data before entering it into the Portal. If you need assistance with entering this information, please contact <a href=\"TOCPolicy@bayareametro.gov\" target=\"_blank\">TOCPolicy@bayareametro.gov</a>.</p>\n                             \n                                <h2 ng-if=\"currentUser.role === 'Administrator'\">Data Review & Processing</h2>\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentUser.role === 'Administrator'\">\n                                    <div class=\"verification-container\">\n                                        <div class=\"form-check\">\n                                            <input class=\"form-check-input\" type=\"checkbox\" id=\"requires_follow_up\"\n                                                ng-model=\"currentZoningForm.requires_follow_up\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\" />\n                                            <label class=\"form-check-label\" for=\"requires_follow_up\"\n                                                ng-class=\"{'boldFont': requires_follow_up}\">\n                                                Jurisdiction (or other entity) requires follow-up?\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentUser.role === 'Administrator'\">\n                                    <div class=\"verification-container\">\n                                        <div class=\"form-check\">\n                                            <input class=\"form-check-input\" type=\"checkbox\" id=\"jurisdiction_follow_up\"\n                                                ng-model=\"currentZoningForm.jurisdiction_follow_up\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\"/>\n                                            <label class=\"form-check-label\" for=\"jurisdiction_follow_up\"\n                                                ng-class=\"{'boldFont': jurisdiction_follow_up}\">\n                                                Jurisdiction (or other entity) has been followed up with?\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentUser.role === 'Administrator'\">\n                                    <div class=\"verification-container\">\n                                        <div class=\"form-check\">\n                                            <input class=\"form-check-input\" type=\"checkbox\" id=\"reviewed\"\n                                                ng-model=\"currentZoningForm.reviewed\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\"/>\n                                            <label class=\"form-check-label\" for=\"reviewed\"\n                                                ng-class=\"{'boldFont': reviewed}\">\n                                                Reviewed?\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"form-item col-lg-6\" ng-if=\"currentUser.role === 'Administrator' && currentZoningForm.reviewed === true\">\n                                    <label for=\"reviewed_by\">Reviewed by:</label>\n                                    <input\n                                        ng-if=\"!checkSubstring(currentZoningForm.reviewed_by)\"\n                                        ng-model=\"currentZoningForm.reviewed_by\"\n                                        id=\"reviewed_by\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"\n                                        name=\"reviewed_by\" rows=\"4\" style=\"width: 100%\"\n                                        placeholder=\"John Smith\" required/>\n                                </div>\n                                <div class=\"form-item col-lg-6\" ng-if=\"currentUser.role === 'Administrator' && currentZoningForm.reviewed === true\">\n                                    <label>Reviewed date:</label>\n                                    <input \n                                        id=\"procreviewed_dateessed_date\" name=\"reviewed_date\" type=\"date\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"\n                                        placeholder=\"MM-DD-YYYY\" ng-model=\"currentZoningForm.reviewed_date\"\n                                        required />\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.reviewed_date.$error.required && formSubmitted\">\n                                        Please provide a valid date.\n                                    </div>\n                                </div>\n                                <div class=\"form-item col-lg-12\" ng-if=\"currentUser.role === 'Administrator'\">\n                                    <div class=\"verification-container\">\n                                        <div class=\"form-check\">\n                                            <input class=\"form-check-input\" type=\"checkbox\" id=\"processed\"\n                                                ng-model=\"currentZoningForm.processed\"\n                                                onchange=\"angular.element(this).scope().setPending(this)\"/>\n                                            <label class=\"form-check-label\" for=\"processed\"\n                                                ng-class=\"{'boldFont': processed}\">\n                                                Processed?\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"form-item col-lg-6\" ng-if=\"currentUser.role === 'Administrator' && currentZoningForm.processed === true\">\n                                    <label for=\"processed_by\">Processed by:</label>\n                                    <input\n                                        ng-if=\"!checkSubstring(currentZoningForm.processed_by)\"\n                                        ng-model=\"currentZoningForm.processed_by\"\n                                        id=\"processed_by\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"\n                                        name=\"processed_by\" rows=\"4\" style=\"width: 100%\"\n                                        placeholder=\"John Smith\" required/>\n                                </div>\n                                <div class=\"form-item col-lg-6\" ng-if=\"currentUser.role === 'Administrator' && currentZoningForm.processed === true\">\n                                    <label>Processed date:</label>\n                                    <input \n                                        id=\"processed_date\" name=\"processed_date\" type=\"date\"\n                                        onchange=\"angular.element(this).scope().setPending(this)\"\n                                        placeholder=\"MM-DD-YYYY\" ng-model=\"currentZoningForm.processed_date\"\n                                        required />\n                                    <div class=\"invalid-feedback\" ng-class=\"{'displayBlock': formSubmitted}\"\n                                        ng-show=\"zoningForm.processed_date.$error.required && formSubmitted\">\n                                        Please provide a valid date.\n                                    </div>\n                                </div>\n                            </div>\n                            <submissionsectionsubmit></submissionsectionsubmit>\n                        </form>\n                    </div>\n\n                    <!-- Review and submit  -->\n                    <div id=\"section-review-submit\" role=\"tabpanel\" class=\"section tab-pane\"\n                        ng-class=\"{'active show': reviewAndSubmit}\">\n                        <h2>Review and Submit</h2>\n                        <p>\n                            <span style=\"font-style: italic\">\n                                Select the form below to submit to MTC for review.</span>\n                        </p>\n\n                        <form class=\"row test-validation-styling\" novalidate style=\"margin-left: 2px\">\n                            <!-- Complete Streets  -->\n                            <div class=\"verification-container\">\n                                <div class=\"form-check\">\n                                    <input class=\"form-check-input\" type=\"checkbox\" value=\"\"\n                                        ng-model=\"zoningUpdatesCheck\" ng-click=\"addToSubmissions('zoningUpdates')\"\n                                        ng-disabled=\"zoningUpdates[0].submitted\" />\n                                    <label class=\"form-check-label\" for=\"foo\"\n                                        ng-class=\"{'boldFont': zoningUpdatesCheck}\">\n                                        Jurisdiction Zoning Updates Form\n                                    </label>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"zoningUpdatesCheck\">\n                                    <p>\n                                        I have completed the\n                                        <a href=\"#\" ng-click=\"togglePanel('zoningUpdates')\">Jurisdiction\n                                            Zoning Updates Form</a>\n                                        and uploaded any relevant documentation.\n                                    </p>\n                                </div>\n                                <div class=\"row align-items-center\" ng-show=\"zoningUpdates[0].submitted\">\n                                    <div class=\"row\" style=\"padding-top: 5px; padding-bottom: 5px\">\n                                        <div class=\"col\">\n                                            <div class=\"alert alert-success fade show\" role=\"alert\">\n                                                This form has been submitted and is under review.\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </form>\n                        <submissionsectionsubmit></submissionsectionsubmit>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"footer\" role=\"contentinfo\">\n        <sidebarfooter></sidebarfooter>\n    </div>\n</section>\n\n<messagesidebar></messagesidebar>"

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.baseConfigService = baseConfigService;
	var angular = __webpack_require__(1);
	
	var baseUrl = 'https://jsapi.mtcanalytics.org/tocstaging';
	var adminBaseURL = 'https://jsapi.mtcanalytics.org/authstaging';
	
	/*@ngInject*/
	function baseConfigService() {
	  this.getBaseURL = function () {
	    return baseUrl;
	  };
	
	  this.getAdminBaseURL = function () {
	    return adminBaseURL;
	  };
	}
	
	exports.default = angular.module('appApp.baseConfig', []).service('baseConfigService', baseConfigService).name;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.userService = userService;
	
	
	var angular = __webpack_require__(1);
	
	var adminBaseURL;
	var currentUser;
	
	/*@ngInject*/
	function userService($http, baseConfigService) {
	    adminBaseURL = baseConfigService.getAdminBaseURL();
	
	    this.getAllUsers = function () {
	        return $http.get(adminBaseURL + '/users');
	    };
	
	    this.getUser = function (id) {
	        return $http.get(adminBaseURL + '/users/' + id);
	    };
	
	    this.createUser = function () {
	        return $http.post(adminBaseURL + '/users');
	    };
	
	    this.updateUser = function (id) {
	        return $http.post(adminBaseURL + '/users/' + id);
	    };
	
	    this.deleteUser = function (id) {
	        return $http.delete(adminBaseURL + '/users/' + id);
	    };
	
	    this.getCurrentUser = function () {
	        return $http.get(adminBaseURL + '/users/me/toc_app');
	    };
	
	    this.setCurrentUser = function (user) {
	        currentUser = user;
	    };
	}
	
	exports.default = angular.module('appApp.users', []).service('userService', userService).name;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.feedbackServiceService = feedbackServiceService;
	var angular = __webpack_require__(1);
	
	
	var adminBaseURL;
	
	/*@ngInject*/
	function feedbackServiceService(baseConfigService, $http) {
	    adminBaseURL = baseConfigService.getAdminBaseURL();
	
	    this.getAllFeedback = function () {
	        return $http.get(adminBaseURL + '/feedback');
	    };
	
	    this.getFeedback = function (id) {
	        return $http.get(adminBaseURL + '/feedback/' + id);
	    };
	
	    this.createFeedback = function () {
	        return $http.post(adminBaseURL + '/feedback');
	    };
	
	    this.updateFeedback = function (id) {
	        return $http.post(adminBaseURL + '/feedback/' + id);
	    };
	
	    this.deleteFeedback = function (id) {
	        return $http.delete(adminBaseURL + '/feedback/' + id);
	    };
	
	    this.addFeedbackTo = function (id, type) {
	        return $http.post(adminBaseURL + '/feedback/' + type + '/' + id);
	    };
	}
	
	exports.default = angular.module('appApp.feedbackService', []).service('feedbackService', feedbackServiceService).name;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.navServiceService = navServiceService;
	var angular = __webpack_require__(1);
	
	var page = {};
	var breadcrumb = [];
	
	var sideBarNav = [{
	  title: 'Dashboard',
	  url: '/account/dashboard',
	  dropdown: false,
	  navLinkIconClass: 'nav-link--dashboard',
	  show: 'loggedIn'
	}, {
	  title: 'Compliance',
	  url: '/account/compliance',
	  dropdown: true,
	  navLinkIconClass: 'nav-link--compliance',
	  show: 'loggedIn',
	  role: 'Administrator',
	  subItem1: [{
	    title: 'Submissions',
	    url: '/account/compliance/submissions'
	  }, {
	    title: 'Jurisdictions',
	    url: '/account/compliance/jurisdictions'
	  }, {
	    title: 'Station Areas',
	    url: '/account/compliance/stationareas'
	  }]
	}, {
	  title: 'TOC Policy',
	  url: '/account/toc_policy',
	  dropdown: false,
	  navLinkIconClass: 'nav-link--policy',
	  show: 'loggedIn'
	}, {
	  title: 'Density',
	  url: '/account/density',
	  dropdown: true,
	  navLinkIconClass: 'nav-link--density',
	  show: 'loggedIn',
	  subItem1: [{
	    title: 'Density for Residential Uses',
	    url: '/account/density/residential_uses'
	  }, {
	    title: 'Intensity for Commercial Office Uses',
	    url: '/account/density/commercial_uses',
	    active: false
	  }]
	}, {
	  title: 'Affordable Housing',
	  url: '/account/housing',
	  dropdown: true,
	  navLinkIconClass: 'nav-link--housing',
	  show: 'loggedIn',
	  subItem1: [{
	    title: 'Affordable Housing Production',
	    url: '/account/housing/housing_production'
	  }, {
	    title: 'Affordable Housing Preservation',
	    url: '/account/housing/housing_preservation'
	  }, {
	    title: 'Affordable Housing Protection',
	    url: '/account/housing/housing_protection'
	  }, {
	    title: 'Commercial Stabilization',
	    url: '/account/housing/commercial_stabilization'
	  }]
	}, {
	  title: 'Parking',
	  url: '/account/parking',
	  dropdown: true,
	  navLinkIconClass: 'nav-link--parking',
	  show: 'loggedIn',
	  subItem1: [{
	    title: 'Vehicle Parking',
	    url: '/account/parking/vehicle_parking'
	  }, {
	    title: 'Bicycle Parking',
	    url: '/account/parking/bicycle_parking'
	  }, {
	    title: 'Parking Policies',
	    url: '/account/parking/parking_policies'
	  }]
	}, {
	  title: 'Station Access',
	  url: '/account/stationaccess',
	  dropdown: true,
	  navLinkIconClass: 'nav-link--station',
	  show: 'loggedIn',
	  subItem1: [{
	    title: 'Complete Streets and Active Transportation',
	    url: '/account/stationaccess/complete_streets'
	  }, {
	    title: 'Project Prioritization and Implementation',
	    url: '/account/stationaccess/project_prioritization'
	  }, {
	    title: 'Access Gap Analysis',
	    url: '/account/stationaccess/analysis_improvement_program'
	  }, {
	    title: 'Mobility Hub Planning and Implementation',
	    url: '/account/stationaccess/mobility_hub'
	  }]
	}, {
	  title: 'Map',
	  url: '/account/map',
	  dropdown: false,
	  navLinkIconClass: 'nav-link--map',
	  show: 'loggedIn'
	}];
	/*@ngInject*/
	function navServiceService() {
	  this.getSideBarNav = function () {
	    return sideBarNav;
	  };
	
	  this.getPage = function () {
	    return page;
	  };
	
	  this.setPage = function (page) {
	    page = page;
	  };
	
	  this.getBreadCrumb = function () {
	    return breadcrumb;
	  };
	
	  this.setBreadCrumb = function (page, subItem1, subItem2) {
	    breadcrumb = [];
	    if (page) {
	      breadcrumb.push({
	        linkTitle: page.title,
	        link1: page.url
	      });
	    }
	
	    if (subItem1) {
	      breadcrumb.push({
	        linkTitle1: subItem1.title,
	        link: subItem1.url
	      });
	    }
	    if (subItem2) {
	      breadcrumb.push({
	        linkTitle2: subItem2.title,
	        link: subItem2.url
	      });
	    }
	  };
	}
	
	exports.default = angular.module('appApp.navService', []).service('navService', navServiceService).name;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchService = fetchService;
	var angular = __webpack_require__(1);
	
	var baseUrl;
	
	/*@ngInject*/
	function fetchService($http, baseConfigService) {
	    baseUrl = baseConfigService.getBaseURL();
	
	    this.getAllItems = function (url) {
	        return $http.get(baseUrl + '/' + url);
	    };
	
	    this.getItem = function (url, id) {
	        return $http.get(baseUrl + '/' + url + '/' + id);
	    };
	
	    this.createItem = function (url, data) {
	        return $http.post(baseUrl + '/' + url, data);
	    };
	
	    this.updateItem = function (url, data) {
	        return $http.post(baseUrl + '/' + url, data);
	    };
	
	    this.putItem = function (url) {
	        return $http.put(baseUrl + '/' + url);
	    };
	
	    this.deleteItem = function (url, id) {
	        return $http.delete(baseUrl + '/' + url + '/' + id);
	    };
	}
	
	exports.default = angular.module('appApp.fetch', []).service('fetch', fetchService).name;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lookupService = lookupService;
	var angular = __webpack_require__(1);
	var currentStation;
	var jurisdiction;
	var submissionPolicies = [];
	var tierOverrideStations = ['Belmont Caltrain', 'Bayshore Caltrain', 'Lafayette BART', 'Orinda BART', 'San Carlos Caltrain'];
	
	var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
	
	/*@ngInject*/
	function lookupService() {
	  this.getCurrentStation = function () {
	    return currentStation;
	  };
	
	  this.setCurrentStation = function (station) {
	    currentStation = station;
	  };
	
	  this.getJurisdiction = function () {
	    return jurisdiction;
	  };
	
	  this.setJurisdiction = function (juris) {
	    jurisdiction = juris;
	  };
	
	  this.getSubmissionPolicies = function () {
	    return submissionPolicies;
	  };
	
	  this.setSubmissionPolicies = function (policies) {
	    submissionPolicies = policies;
	  };
	
	  this.getUUID = function () {
	    var d = new Date().getTime();
	
	    uuid = uuid.replace(/[xy]/g, function (c) {
	      var r = (d + Math.random() * 16) % 16 | 0;
	
	      d = Math.floor(d / 16);
	
	      return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
	    });
	
	    return uuid;
	  };
	
	  this.getOverrideStations = function () {
	    return tierOverrideStations;
	  };
	}
	
	exports.default = angular.module('appApp.lookup', []).service('lookup', lookupService).name;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapService = mapService;
	var angular = __webpack_require__(1);
	
	/*@ngInject*/
	function mapService() {
	  this.getMapLayers = function () {
	    return [{
	      'source': 'tpaLayerSource',
	      'type': 'mapbox',
	      'name': 'tpaLayer',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckm6px6vtc03717o0j1xjrwc5/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'urbanLayerSource',
	      'type': 'mapbox',
	      'name': 'urbanLayer',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjukbyho05x11art2x1str4h/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'fireRiskLayerSource',
	      'type': 'mapbox',
	      'name': 'fireRiskLayer',
	      'full_name': 'Fire Responsibility Areas and Wildfire Risk (2007)',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjui7hfy03w719qucbydh9y5/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'seaLevelRise77LayerSource',
	      'type': 'mapbox',
	      'name': 'seaLevelRise77Layer',
	      'full_name': 'BCDC Sea Level Rise - 77 Inch Sea Level Rise Scenario',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjujnnlo05b41amo0l7njch4/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'seaLevelRise36LayerSource',
	      'type': 'mapbox',
	      'name': 'seaLevelRise36Layer',
	      'full_name': 'BCDC Sea Level Rise - 36 Inch Sea Level Rise Scenario',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjujkq5t03n719vv2l3u3fbh/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'liquefactionLayerSource',
	      'type': 'mapbox',
	      'name': 'liquefactionLayer',
	      'full_name': 'Liquefaction Susceptibility (2006)',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjuj8zh104sz1alekhiwiiyo/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'earthquakeLayerSource',
	      'type': 'mapbox',
	      'name': 'earthquakeLayer',
	      'full_name': 'Alquist-Priolo Fault Zones (2019)',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjujck6u04vy1alezfd73deo/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'floodplainLayerSource',
	      'type': 'mapbox',
	      'name': 'floodplainLayer',
	      'full_name': 'Flood Zones (2020)',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjukxff106h719ta36ulg71p/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'landslideLayerSource',
	      'type': 'mapbox',
	      'name': 'landslideLayer',
	      'full_name': 'Existing Landslide Areas (1998)',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjuij5a2045y19s3qetvxx49/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'riparianLayerSource',
	      'type': 'mapbox',
	      'name': 'riparianLayer',
	      'full_name': 'Riparian Areas--The Natural Communities Commonly Associated with Groundwater',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjumo3bt087n19qz702x4d6f/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'wildlifeLayerSource',
	      'type': 'mapbox',
	      'name': 'wildlifeLayer',
	      'full_name': 'Critical Habitat (2020)',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjvvwe2h08i21amom6q1c0wu/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'sphereofinfluenceLayerSource',
	      'type': 'mapbox',
	      'name': 'sphereofinfluenceLayer',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckuokp0n7gbob17l7250180iw/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'hcdtcacLayerSource',
	      'type': 'mapbox',
	      'name': 'hcdtcacLayer',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjukod8004rs19pjcv12g62p/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'cpadLayerSource',
	      'type': 'mapbox',
	      'name': 'cpadLayer',
	      'full_name': 'California Protected Area Database (2020)',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjvuu75606d419peichzdfkt/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'ggLayerSource',
	      'type': 'mapbox',
	      'name': 'ggLayer',
	      'full_name': 'Plan Bay Area 2050 Growth Geographies',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckm6pr3cr04uu17k4fw9ktaf0/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'ppaLayerSource',
	      'type': 'mapbox',
	      'name': 'ppaLayer',
	      'full_name': 'Priority Production Areas',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckr57ass815lt17podifl01a7/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'tcacLayerSource',
	      'type': 'mapbox',
	      'name': 'tcacLayer',
	      'full_name': 'HCD/TCAC Opportunity Areas (2020)',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckr57l1bu15w817r99jpsk1qw/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'znLayerSource',
	      'type': 'mapbox',
	      'name': 'znLayer',
	      'full_name': 'Regional Zoning 2021',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/cktes74h72lvv17qtabrf91il/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'gpLayerSource',
	      'type': 'mapbox',
	      'name': 'gpLayer',
	      'full_name': 'Regional General Plan 2021',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckter6p98114i18oc0ieswft5/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'pdaLayerSource',
	      'type': 'mapbox',
	      'name': 'pdaLayer',
	      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckuecztk019tp17kvam3ztny5/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
	    }, {
	      'source': 'poshLayerSource',
	      'type': 'socrata',
	      'name': 'poshLayer',
	      'url': 'https://data.bayareametro.gov/resource/87zs-ng2p.geojson?$select=shape,affrdunits&$limit=10000',
	      'style': 'circle',
	      'property': 'affrdunits',
	      'paint': {
	        'circle-color': '#dd502c',
	        'circle-stroke-width': 1,
	        'circle-stroke-color': '#dd502c',
	        'circle-opacity': 0.5,
	        "circle-radius": {
	          property: 'affrdunits',
	          stops: [[75, 5], [150, 10], [250, 20]]
	        }
	      }
	    }, {
	      'source': 'phLayerSource',
	      'type': 'socrata',
	      'name': 'phLayer',
	      'url': 'https://data.bayareametro.gov/resource/3bj7-zyaq.geojson?$select=shape,total_units&$limit=10000',
	      'style': 'circle',
	      'property': 'total_units',
	      'paint': {
	        'circle-color': '#dd502c',
	        'circle-stroke-width': 1,
	        'circle-stroke-color': '#dd502c',
	        'circle-opacity': 0.5,
	        "circle-radius": {
	          property: 'total_units',
	          stops: [[2, 5], [5, 10], [10, 20]]
	        }
	      }
	    }, {
	      'source': 'hcvLayerSource',
	      'type': 'socrata',
	      'name': 'hcvLayer',
	      'url': 'https://data.bayareametro.gov/resource/m8gt-nc4r.json?$select=tract_geoid,hcv_pct&$limit=10000',
	      'style': 'numerical',
	      'property': 'hcv_pct',
	      'paint': {
	        'fill-color': {
	          property: 'hcv_pct',
	          stops: [[5, '#ffffcc'], [10, '#a1dab4'], [40, '#41b6c4'], [70, '#2c7fb8'], [100, '#253494']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'disabilityStatusLayerSource',
	      'type': 'socrata',
	      'name': 'disabilityStatusLayer',
	      'url': 'https://data.bayareametro.gov/resource/bxi4-cbn7.json?$select=tract_geoid,tpop_wdp*100&$limit=10000',
	      'style': 'numerical',
	      'property': 'tpop_wdp_100',
	      'paint': {
	        'fill-color': {
	          property: 'tpop_wdp_100',
	          stops: [[5, '#ffffcc'], [10, '#a1dab4'], [20, '#41b6c4'], [40, '#2c7fb8'], [80, '#253494']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'householdIncomeLayerSource',
	      'type': 'socrata',
	      'name': 'householdIncomeLayer',
	      'url': 'https://data.bayareametro.gov/resource/q89j-amyf.json?$select=tract_geoid,med_inc&$limit=100000',
	      'style': 'numerical',
	      'property': 'med_inc',
	      'paint': {
	        'fill-color': {
	          property: 'med_inc',
	          stops: [[25000, '#ffffcc'], [83000, '#a1dab4'], [167000, '#41b6c4'], [250001, '#225ea8']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'raceEthnicityLayerSource',
	      'type': 'socrata',
	      'name': 'raceEthnicityLayer',
	      'url': 'https://data.bayareametro.gov/resource/bty8-8dei.json?$select=blkgp_geoid,pred_race&$limit=100000',
	      'style': 'categorical',
	      'property': 'pred_race',
	      'paint': {
	        'fill-color': {
	          'property': 'pred_race',
	          'type': 'categorical',
	          'stops': [['Hispanic/Latinx', '#e41a1c'], ['Non-Hispanic Asian or Pacific Islander', '#377eb8'], ['Non-Hispanic Black', '#4daf4a'], ['Non-Hispanic Other', '#ff7f00'], ['Non-Hispanic White', '#f0d6a8'], ['Missing or Insufficient Data', '#adaba6']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	
	    }, {
	      'source': 'sphLayerSource',
	      'type': 'socrata',
	      'name': 'sphLayer',
	      'url': 'https://data.bayareametro.gov/resource/d3uu-dvsm.json?$select=tract_geoid,nfam_singp*100&$limit=10000',
	      'style': 'numerical',
	      'property': 'nfam_singp_100',
	      'paint': {
	        'fill-color': {
	          property: 'nfam_singp_100',
	          stops: [[10, '#ffffcc'], [30, '#a1dab4'], [50, '#41b6c4'], [80, '#2c7fb8'], [100, '#253494']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'hwcLayerSource',
	      'type': 'socrata',
	      'name': 'hwcLayer',
	      'url': 'https://data.bayareametro.gov/resource/sw8g-na7z.json?$select=tract_geoid,hh_wc_p*100&$limit=10000',
	      'style': 'numerical',
	      'property': 'hh_wc_p_100',
	      'paint': {
	        'fill-color': {
	          property: 'hh_wc_p_100',
	          stops: [[5, '#ffffcc'], [10, '#a1dab4'], [20, '#41b6c4'], [40, '#2c7fb8'], [80, '#253494']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'recapLayerSource',
	      'type': 'socrata',
	      'name': 'recapLayer',
	      'url': 'https://data.bayareametro.gov/resource/tsz4-2bqi.json?rcap_current=1&$select=tract_geoid,rcap_current&$limit=2000',
	      'style': 'single',
	      'paint': {
	        'fill-color': "#1b9e77",
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'rcaaLayerSource',
	      'type': 'socrata',
	      'name': 'rcaaLayer',
	      'url': 'https://data.bayareametro.gov/resource/q89j-amyf.json?rcaa=1&$select=tract_geoid,rcaa',
	      'style': 'single',
	      'paint': {
	        'fill-color': '#1b9e77',
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'hcdaffhtcacLayerSource',
	      'type': 'socrata',
	      'name': 'hcdaffhtcacLayer',
	      'url': 'https://data.bayareametro.gov/resource/vr7h-smni.geojson?$limit=20000&$select=oppcat,geometry',
	      'style': 'categorical',
	      'property': 'oppcat',
	      'paint': {
	        'fill-color': {
	          'property': 'oppcat',
	          'type': 'categorical',
	          'stops': [['Highest Resource', '#253494'], ['High Resource', '#2c7fb8'], ['Moderate Resource', '#41b6c4'], ['Low Resource', '#a1dab4'], ['High Segregation & Poverty', '#ffffcc'], ['Missing or Insufficient Data', '#adaba6']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'cbhLayerSource',
	      'type': 'socrata',
	      'name': 'cbhLayer',
	      'url': 'https://data.bayareametro.gov/resource/m8gt-nc4r.json?$select=tract_geoid,hcv_pct&$limit=10000',
	      'style': 'numerical',
	      'property': 'hcv_pct',
	      'paint': {
	        'fill-color': {
	          property: 'hcv_pct',
	          stops: [[5, '#ffffcc'], [10, '#a1dab4'], [40, '#41b6c4'], [70, '#2c7fb8'], [100, '#253494']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'dispriskLayerSource',
	      'type': 'socrata',
	      'name': 'dispriskLayer',
	      'url': 'https://data.bayareametro.gov/resource/juq7-jgnr.json?$select=tract_geoid,typology&$limit=10000',
	      'style': 'categorical',
	      'property': 'typology',
	      'paint': {
	        'fill-color': {
	          'property': 'typology',
	          'type': 'categorical',
	          'stops': [["Low-Income/Susceptible to Displacement", "#87CEFA"], ["Ongoing Displacement", "#6495ED"], ['At Risk of Gentrification', '#9E9AC8'], ["Early/Ongoing Gentrification", "#756BB1"], ['Advanced Gentrification', '#54278F'], ["Stable Moderate/Mixed Income", "#FBEDE0"], ['At Risk of Becoming Exclusive', '#F4C08D'], ["Becoming Exclusive", "#EE924F"], ["Stable/Advanced Exclusive", "#C95123"], ["High Student Population", "#B5B6B7"], ["Unavailable or Unreliable Data", "#DEDCD9"]],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'ochLayerSource',
	      'type': 'socrata',
	      'name': 'ochLayer',
	      'url': 'https://data.bayareametro.gov/resource/cq4u-4hkv.json?$select=tract_geoid,rrm_gt15p&$limit=10000',
	      'style': 'numerical',
	      'property': 'rrm_gt15p',
	      'paint': {
	        'fill-color': {
	          property: 'rrm_gt15p',
	          stops: [[5, '#ffffcc'], [10, '#a1dab4'], [20, '#41b6c4'], [40, '#2c7fb8'], [80, '#253494']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }, {
	      'source': 'subhouseLayerSource',
	      'type': 'socrata',
	      'name': 'subhouseLayer',
	      'url': 'https://data.bayareametro.gov/resource/8myp-xcdf.json?$select=tract_geoid,pren_ncomp*1000&$limit=10000',
	      'style': 'numerical',
	      'property': 'pren_ncomp_1000',
	      'paint': {
	        'fill-color': {
	          property: 'pren_ncomp_1000',
	          stops: [[5, '#ffffcc'], [10, '#a1dab4'], [15, '#41b6c4'], [20, '#2c7fb8'], [30, '#253494']],
	          'default': 'white'
	        },
	        'fill-opacity': 0.5
	      }
	    }];
	  };
	}
	
	exports.default = angular.module('appApp.mapService', []).service('mapService', mapService).name;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FileUploadServiceService = FileUploadServiceService;
	var angular = __webpack_require__(1);
	
	var adminBaseURL;
	
	/*@ngInject*/
	function FileUploadServiceService(baseConfigService, $http, $q) {
	  adminBaseURL = baseConfigService.getAdminBaseURL();
	
	  this.uploadFile = function (ngmodelfile, currentPolicy) {
	    var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
	    var deferred = $q.defer();
	    var file = document.getElementById('' + ngmodelfile).files[0];
	
	    if (!file) {
	      console.error('No file selected');
	      deferred.reject('No file selected');
	      return deferred.promise;
	    }
	
	    return $http({
	      method: 'POST',
	      url: '/tocdev/api/data/get-signed-url',
	      headers: {
	        'Content-Type': 'application/json'
	      },
	      data: {
	        fileName: file.name,
	        fileType: file.type
	      }
	    }).then(function (response) {
	      console.log('Signed URL:', response.data.url);
	
	      return $http({
	        method: 'PUT',
	        url: response.data.url,
	        data: file,
	        headers: {
	          'Content-Type': file.type,
	          'x-amz-acl': 'public-read'
	        },
	        transformRequest: [function (data) {
	          return data;
	        }]
	      });
	    }).then(function (uploadResult) {
	
	      var publicUrl = 'https://gis-main-site.s3.us-west-2.amazonaws.com/' + fileName;
	      return {
	        url: publicUrl,
	        ngmodel: ngmodel,
	        ngmodelfile: ngmodelfile
	      };
	    });
	  };
	
	  this.clearFile = function (ngmodelfile) {
	    var fileInput = document.getElementById(ngmodelfile);
	    if (fileInput) {
	      fileInput.value = '';
	    }
	  };
	}
	
	exports.default = angular.module('appApp.FileUploadService', []).service('FileUploadService', FileUploadServiceService).name;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	// Make sure dependencies are loaded on the window
	__webpack_require__(1);
	__webpack_require__(406);
	
	// Load the Angular module which uses window.angular and window.Firebase
	__webpack_require__(412);
	
	// Export the module name from the Angular module
	module.exports = 'firebase';


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/*! @license Firebase v3.9.0
	Build: rev-cc77c9e
	Terms: https://firebase.google.com/terms/ */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var firebase = __webpack_require__(407);
	__webpack_require__(408);
	var Storage, XMLHttpRequest;
	
	__webpack_require__(409);
	__webpack_require__(410);
	var AsyncStorage;
	
	__webpack_require__(411);
	exports.default = firebase;
	module.exports = exports['default'];
	//# sourceMappingURL=firebase.js.map


/***/ }),
/* 407 */
/***/ (function(module, exports) {

	/*! @license Firebase v3.9.0
	Build: rev-cc77c9e
	Terms: https://firebase.google.com/terms/ */
	
	var firebase=function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=11)}([function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var r=void 0;if(void 0!==e)r=e;else if("undefined"!=typeof self)r=self;else try{r=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var i=r.Promise||n(8);t.local={Promise:i,GoogPromise:i}}).call(t,n(1))},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(5),i=(0,r.createFirebaseNamespace)();t.default=i,e.exports=t.default},function(e,t,n){"use strict";function r(e){return i(void 0,e)}function i(e,t){if(!(t instanceof Object))return t;switch(t.constructor){case Date:return new Date(t.getTime());case Object:void 0===e&&(e={});break;case Array:e=[];break;default:return t}for(var n in t)t.hasOwnProperty(n)&&(e[n]=i(e[n],t[n]));return e}function o(e,t,n){e[t]=n}Object.defineProperty(t,"__esModule",{value:!0}),t.deepCopy=r,t.deepExtend=i,t.patchProperty=o},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e){var t=a;return a=e,t}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.patchCapture=i;var a=Error.captureStackTrace,c=function e(t,n){if(r(this,e),this.code=t,this.message=n,a)a(this,s.prototype.create);else{var i=Error.apply(this,arguments);this.name="FirebaseError",Object.defineProperty(this,"stack",{get:function(){return i.stack}})}};c.prototype=Object.create(Error.prototype),c.prototype.constructor=c,c.prototype.name="FirebaseError";var s=t.ErrorFactory=function(){function e(t,n,i){r(this,e),this.service=t,this.serviceName=n,this.errors=i,this.pattern=/\{\$([^}]+)}/g}return o(e,[{key:"create",value:function(e,t){void 0===t&&(t={});var n=this.errors[e],r=this.service+"/"+e,i=void 0;i=void 0===n?"Error":n.replace(this.pattern,function(e,n){var r=t[n];return void 0!==r?r.toString():"<"+n+"?>"}),i=this.serviceName+": "+i+" ("+r+").";var o=new c(r,i);for(var a in t)t.hasOwnProperty(a)&&"_"!==a.slice(-1)&&(o[a]=t[a]);return o}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){function e(e){e=e||d;var t=r[e];return void 0===t&&o("no-app",{name:e}),t}function t(e,t){Object.keys(a).forEach(function(r){var i=n(e,r);null!==i&&h[i]&&h[i](t,e)})}function n(e,t){if("serverAuth"===t)return null;var n=t,r=e.options;return"auth"===t&&(r.serviceAccount||r.credential)&&(n="serverAuth","serverAuth"in a||o("sa-not-supported")),n}var r={},a={},h={},v={__esModule:!0,initializeApp:function(e,n){void 0===n?n=d:"string"==typeof n&&""!==n||o("bad-app-name",{name:n+""}),void 0!==r[n]&&o("duplicate-app",{name:n});var i=new p(e,n,v);return r[n]=i,t(i,"create"),void 0!=i.INTERNAL&&void 0!=i.INTERNAL.getToken||(0,c.deepExtend)(i,{INTERNAL:{getUid:function(){return null},getToken:function(){return l.resolve(null)},addAuthTokenListener:function(){},removeAuthTokenListener:function(){}}}),i},app:e,apps:null,Promise:l,SDK_VERSION:"3.9.0",INTERNAL:{registerService:function(t,n,r,i,s){a[t]&&o("duplicate-service",{name:t}),a[t]=s?n:function(e,t){return n(e,t,d)},i&&(h[t]=i);var u=void 0;return u=function(n){return void 0===n&&(n=e()),"function"!=typeof n[t]&&o("invalid-app-argument",{name:t}),n[t]()},void 0!==r&&(0,c.deepExtend)(u,r),v[t]=u,u},createFirebaseNamespace:i,extendNamespace:function(e){(0,c.deepExtend)(v,e)},createSubscribe:s.createSubscribe,ErrorFactory:u.ErrorFactory,removeApp:function(e){t(r[e],"delete"),delete r[e]},factories:a,useAsService:n,Promise:f.local.GoogPromise,deepExtend:c.deepExtend}};return(0,c.patchProperty)(v,"default",v),Object.defineProperty(v,"apps",{get:function(){return Object.keys(r).map(function(e){return r[e]})}}),(0,c.patchProperty)(e,"App",p),v}function o(e,t){throw v.create(e,t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.createFirebaseNamespace=i;var c=n(3),s=n(6),u=n(4),f=n(0),l=f.local.Promise,d="[DEFAULT]",p=function(){function e(t,n,i){var o=this;r(this,e),this.firebase_=i,this.isDeleted_=!1,this.services_={},this.name_=n,this.options_=(0,c.deepCopy)(t);var a="credential"in this.options_,s="serviceAccount"in this.options_;if(a||s){var u=s?"serviceAccount":"credential";"undefined"!=typeof console&&console.log("The '"+u+"' property specified in the first argument to initializeApp() is deprecated and will be removed in the next major version. You should instead use the 'firebase-admin' package. See https://firebase.google.com/docs/admin/setup for details on how to get started.")}Object.keys(i.INTERNAL.factories).forEach(function(e){var t=i.INTERNAL.useAsService(o,e);if(null!==t){var n=o.getService.bind(o,t);(0,c.patchProperty)(o,e,n)}})}return a(e,[{key:"delete",value:function(){var e=this;return new l(function(t){e.checkDestroyed_(),t()}).then(function(){e.firebase_.INTERNAL.removeApp(e.name_);var t=[];return Object.keys(e.services_).forEach(function(n){Object.keys(e.services_[n]).forEach(function(r){t.push(e.services_[n][r])})}),l.all(t.map(function(e){return e.INTERNAL.delete()}))}).then(function(){e.isDeleted_=!0,e.services_={}})}},{key:"getService",value:function(e,t){this.checkDestroyed_(),void 0===this.services_[e]&&(this.services_[e]={});var n=t||d;if(void 0===this.services_[e][n]){var r=this.firebase_.INTERNAL.factories[e](this,this.extendApp.bind(this),t);return this.services_[e][n]=r,r}return this.services_[e][n]}},{key:"extendApp",value:function(e){(0,c.deepExtend)(this,e)}},{key:"checkDestroyed_",value:function(){this.isDeleted_&&o("app-deleted",{name:this.name_})}},{key:"name",get:function(){return this.checkDestroyed_(),this.name_}},{key:"options",get:function(){return this.checkDestroyed_(),this.options_}}]),e}();p.prototype.name&&p.prototype.options||p.prototype.delete||console.log("dc");var h={"no-app":"No Firebase App '{$name}' has been created - call Firebase App.initializeApp()","bad-app-name":"Illegal App name: '{$name}","duplicate-app":"Firebase App named '{$name}' already exists","app-deleted":"Firebase App named '{$name}' already deleted","duplicate-service":"Firebase service named '{$name}' already registered","sa-not-supported":"Initializing the Firebase SDK with a service account is only allowed in a Node.js environment. On client devices, you should instead initialize the SDK with an api key and auth domain","invalid-app-argument":"firebase.{$name}() takes either no argument or a Firebase App instance."},v=new u.ErrorFactory("app","Firebase",h)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){var n=new d(e,t);return n.subscribe.bind(n)}function o(e,t){return function(){for(var n=arguments.length,r=Array(n),i=0;i<n;i++)r[i]=arguments[i];l.resolve(!0).then(function(){e.apply(void 0,r)}).catch(function(e){t&&t(e)})}}function a(e,t){if("object"!==(void 0===e?"undefined":s(e))||null===e)return!1;var n=!0,r=!1,i=void 0;try{for(var o,a=t[Symbol.iterator]();!(n=(o=a.next()).done);n=!0){var c=o.value;if(c in e&&"function"==typeof e[c])return!0}}catch(e){r=!0,i=e}finally{try{!n&&a.return&&a.return()}finally{if(r)throw i}}return!1}function c(){}Object.defineProperty(t,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.createSubscribe=i,t.async=o;var f=n(0),l=f.local.Promise,d=function(){function e(t,n){var i=this;r(this,e),this.observers=[],this.unsubscribes=[],this.observerCount=0,this.task=l.resolve(),this.finalized=!1,this.onNoObservers=n,this.task.then(function(){t(i)}).catch(function(e){i.error(e)})}return u(e,[{key:"next",value:function(e){this.forEachObserver(function(t){t.next(e)})}},{key:"error",value:function(e){this.forEachObserver(function(t){t.error(e)}),this.close(e)}},{key:"complete",value:function(){this.forEachObserver(function(e){e.complete()}),this.close()}},{key:"subscribe",value:function(e,t,n){var r=this,i=void 0;if(void 0===e&&void 0===t&&void 0===n)throw new Error("Missing Observer.");i=a(e,["next","error","complete"])?e:{next:e,error:t,complete:n},void 0===i.next&&(i.next=c),void 0===i.error&&(i.error=c),void 0===i.complete&&(i.complete=c);var o=this.unsubscribeOne.bind(this,this.observers.length);return this.finalized&&this.task.then(function(){try{r.finalError?i.error(r.finalError):i.complete()}catch(e){}}),this.observers.push(i),o}},{key:"unsubscribeOne",value:function(e){void 0!==this.observers&&void 0!==this.observers[e]&&(delete this.observers[e],this.observerCount-=1,0===this.observerCount&&void 0!==this.onNoObservers&&this.onNoObservers(this))}},{key:"forEachObserver",value:function(e){if(!this.finalized)for(var t=0;t<this.observers.length;t++)this.sendOne(t,e)}},{key:"sendOne",value:function(e,t){var n=this;this.task.then(function(){if(void 0!==n.observers&&void 0!==n.observers[e])try{t(n.observers[e])}catch(e){"undefined"!=typeof console&&console.error&&console.error(e)}})}},{key:"close",value:function(e){var t=this;this.finalized||(this.finalized=!0,void 0!==e&&(this.finalError=e),this.task.then(function(){t.observers=void 0,t.onNoObservers=void 0}))}}]),e}()},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function i(e){if(f===setTimeout)return setTimeout(e,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(e,0);try{return f(e,0)}catch(t){try{return f.call(null,e,0)}catch(t){return f.call(this,e,0)}}}function o(e){if(l===clearTimeout)return clearTimeout(e);if((l===r||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(e);try{return l(e)}catch(t){try{return l.call(null,e)}catch(t){return l.call(this,e)}}}function a(){v&&p&&(v=!1,p.length?h=p.concat(h):m=-1,h.length&&c())}function c(){if(!v){var e=i(a);v=!0;for(var t=h.length;t;){for(p=h,h=[];++m<t;)p&&p[m].run();m=-1,t=h.length}p=null,v=!1,o(e)}}function s(e,t){this.fun=e,this.array=t}function u(){}var f,l,d=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(e){f=n}try{l="function"==typeof clearTimeout?clearTimeout:r}catch(e){l=r}}();var p,h=[],v=!1,m=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new s(e,t)),1!==h.length||v||i(c)},s.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=u,d.addListener=u,d.once=u,d.off=u,d.removeListener=u,d.removeAllListeners=u,d.emit=u,d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){(function(t){!function(n){function r(){}function i(e,t){return function(){e.apply(t,arguments)}}function o(e){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],l(e,this)}function a(e,t){for(;3===e._state;)e=e._value;if(0===e._state)return void e._deferreds.push(t);e._handled=!0,o._immediateFn(function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null===n)return void(1===e._state?c:s)(t.promise,e._value);var r;try{r=n(e._value)}catch(e){return void s(t.promise,e)}c(t.promise,r)})}function c(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var n=t.then;if(t instanceof o)return e._state=3,e._value=t,void u(e);if("function"==typeof n)return void l(i(n,t),e)}e._state=1,e._value=t,u(e)}catch(t){s(e,t)}}function s(e,t){e._state=2,e._value=t,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var t=0,n=e._deferreds.length;t<n;t++)a(e,e._deferreds[t]);e._deferreds=null}function f(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}function l(e,t){var n=!1;try{e(function(e){n||(n=!0,c(t,e))},function(e){n||(n=!0,s(t,e))})}catch(e){if(n)return;n=!0,s(t,e)}}var d=setTimeout;o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){var n=new this.constructor(r);return a(this,new f(e,t,n)),n},o.all=function(e){var t=Array.prototype.slice.call(e);return new o(function(e,n){function r(o,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void c.call(a,function(e){r(o,e)},n)}t[o]=a,0==--i&&e(t)}catch(e){n(e)}}if(0===t.length)return e([]);for(var i=t.length,o=0;o<t.length;o++)r(o,t[o])})},o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o(function(t){t(e)})},o.reject=function(e){return new o(function(t,n){n(e)})},o.race=function(e){return new o(function(t,n){for(var r=0,i=e.length;r<i;r++)e[r].then(t,n)})},o._immediateFn="function"==typeof t&&function(e){t(e)}||function(e){d(e,0)},o._unhandledRejectionFn=function(e){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)},o._setImmediateFn=function(e){o._immediateFn=e},o._setUnhandledRejectionFn=function(e){o._unhandledRejectionFn=e},void 0!==e&&e.exports?e.exports=o:n.Promise||(n.Promise=o)}(this)}).call(t,n(10).setImmediate)},function(e,t,n){(function(e,t){!function(e,n){"use strict";function r(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),n=0;n<t.length;n++)t[n]=arguments[n+1];var r={callback:e,args:t};return u[s]=r,c(s),s++}function i(e){delete u[e]}function o(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}function a(e){if(f)setTimeout(a,0,e);else{var t=u[e];if(t){f=!0;try{o(t)}finally{i(e),f=!1}}}}if(!e.setImmediate){var c,s=1,u={},f=!1,l=e.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(e);d=d&&d.setTimeout?d:e,"[object process]"==={}.toString.call(e.process)?function(){c=function(e){t.nextTick(function(){a(e)})}}():function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?function(){var t="setImmediate$"+Math.random()+"$",n=function(n){n.source===e&&"string"==typeof n.data&&0===n.data.indexOf(t)&&a(+n.data.slice(t.length))};e.addEventListener?e.addEventListener("message",n,!1):e.attachEvent("onmessage",n),c=function(n){e.postMessage(t+n,"*")}}():e.MessageChannel?function(){var e=new MessageChannel;e.port1.onmessage=function(e){a(e.data)},c=function(t){e.port2.postMessage(t)}}():l&&"onreadystatechange"in l.createElement("script")?function(){var e=l.documentElement;c=function(t){var n=l.createElement("script");n.onreadystatechange=function(){a(t),n.onreadystatechange=null,e.removeChild(n),n=null},e.appendChild(n)}}():function(){c=function(e){setTimeout(a,0,e)}}(),d.setImmediate=r,d.clearImmediate=i}}("undefined"==typeof self?void 0===e?this:e:self)}).call(t,n(1),n(7))},function(e,t,n){function r(e,t){this._id=e,this._clearFn=t}var i=Function.prototype.apply;t.setTimeout=function(){return new r(i.call(setTimeout,window,arguments),clearTimeout)},t.setInterval=function(){return new r(i.call(setInterval,window,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(window,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout(function(){e._onTimeout&&e._onTimeout()},t))},n(9),t.setImmediate=setImmediate,t.clearImmediate=clearImmediate},function(e,t,n){e.exports=n(2)}]);module.exports=firebase;
	//# sourceMappingURL=app.js.map


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
	Build: rev-cc77c9e
	Terms: https://firebase.google.com/terms/ */
	
	var firebase = __webpack_require__(407);
	(function(){
	(function(){var h,aa=aa||{},l=this,ba=function(){},ca=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&
	!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},da=function(a){return null===a},ea=function(a){return"array"==ca(a)},fa=function(a){var b=ca(a);return"array"==b||"object"==b&&"number"==typeof a.length},m=function(a){return"string"==typeof a},ga=function(a){return"number"==typeof a},p=function(a){return"function"==ca(a)},ha=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b},ia=function(a,
	b,c){return a.call.apply(a.bind,arguments)},ja=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}},q=function(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ia:ja;return q.apply(null,arguments)},ka=function(a,b){var c=Array.prototype.slice.call(arguments,
	1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}},la=Date.now||function(){return+new Date},r=function(a,b){function c(){}c.prototype=b.prototype;a.xd=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Tf=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};var t=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,t);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};r(t,Error);t.prototype.name="CustomError";var ma=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")},na=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},oa=/&/g,pa=/</g,qa=/>/g,ra=/"/g,sa=/'/g,ta=/\x00/g,ua=/[\x00&<>"']/,u=function(a,b){return-1!=a.indexOf(b)},va=function(a,b){return a<b?-1:a>b?1:0};var wa=function(a,b){b.unshift(a);t.call(this,ma.apply(null,b));b.shift()};r(wa,t);wa.prototype.name="AssertionError";
	var xa=function(a,b,c,d){var e="Assertion failed";if(c)var e=e+(": "+c),f=d;else a&&(e+=": "+a,f=b);throw new wa(""+e,f||[]);},v=function(a,b,c){a||xa("",null,b,Array.prototype.slice.call(arguments,2))},ya=function(a,b){throw new wa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));},za=function(a,b,c){ga(a)||xa("Expected number but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,2));return a},Aa=function(a,b,c){m(a)||xa("Expected string but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,
	2))},Ba=function(a,b,c){p(a)||xa("Expected function but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,2))};var Ca=Array.prototype.indexOf?function(a,b,c){v(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(m(a))return m(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){v(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},Da=function(a,b){for(var c=m(a)?
	a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)},Ea=Array.prototype.map?function(a,b,c){v(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=m(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Fa=Array.prototype.some?function(a,b,c){v(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1},
	Ha=function(a){var b;a:{b=Ga;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:m(a)?a.charAt(b):a[b]},Ia=function(a,b){return 0<=Ca(a,b)},Ka=function(a,b){b=Ca(a,b);var c;(c=0<=b)&&Ja(a,b);return c},Ja=function(a,b){v(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length},La=function(a,b){var c=0;Da(a,function(d,e){b.call(void 0,d,e,a)&&Ja(a,e)&&c++})},Ma=function(a){return Array.prototype.concat.apply([],arguments)},
	Na=function(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Oa=function(a){return Ea(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var Pa;a:{var Qa=l.navigator;if(Qa){var Ra=Qa.userAgent;if(Ra){Pa=Ra;break a}}Pa=""}var x=function(a){return u(Pa,a)};var Sa=function(a,b){for(var c in a)b.call(void 0,a[c],c,a)},Ta=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b},Ua=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b},Va=function(a){for(var b in a)return!1;return!0},Wa=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0},Xa=function(a){var b={},c;for(c in a)b[c]=a[c];return b},Ya="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
	Za=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Ya.length;f++)c=Ya[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};var $a=function(a){$a[" "](a);return a};$a[" "]=ba;var bb=function(a,b){var c=ab;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var cb=x("Opera"),y=x("Trident")||x("MSIE"),eb=x("Edge"),fb=eb||y,gb=x("Gecko")&&!(u(Pa.toLowerCase(),"webkit")&&!x("Edge"))&&!(x("Trident")||x("MSIE"))&&!x("Edge"),hb=u(Pa.toLowerCase(),"webkit")&&!x("Edge"),ib=function(){var a=l.document;return a?a.documentMode:void 0},jb;
	a:{var kb="",lb=function(){var a=Pa;if(gb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(eb)return/Edge\/([\d\.]+)/.exec(a);if(y)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(hb)return/WebKit\/(\S+)/.exec(a);if(cb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();lb&&(kb=lb?lb[1]:"");if(y){var mb=ib();if(null!=mb&&mb>parseFloat(kb)){jb=String(mb);break a}}jb=kb}
	var nb=jb,ab={},z=function(a){return bb(a,function(){for(var b=0,c=na(String(nb)).split("."),d=na(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",k=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==g[0].length&&0==k[0].length)break;b=va(0==g[1].length?0:parseInt(g[1],10),0==k[1].length?0:parseInt(k[1],10))||va(0==g[2].length,0==k[2].length)||va(g[2],k[2]);g=g[3];k=k[3]}while(0==b)}return 0<=b})},ob;var pb=l.document;
	ob=pb&&y?ib()||("CSS1Compat"==pb.compatMode?parseInt(nb,10):5):void 0;var qb=null,rb=null,tb=function(a){var b="";sb(a,function(a){b+=String.fromCharCode(a)});return b},sb=function(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=rb[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}ub();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),k=c(64);if(64===k&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=k&&b(g<<6&192|k))}},ub=function(){if(!qb){qb={};rb={};for(var a=0;65>a;a++)qb[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),
	rb[qb[a]]=a,62<=a&&(rb["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};var vb=function(){this.Da=-1};var yb=function(a,b){this.Da=64;this.ec=l.Uint8Array?new Uint8Array(this.Da):Array(this.Da);this.Fc=this.hb=0;this.h=[];this.lf=a;this.Wd=b;this.Mf=l.Int32Array?new Int32Array(64):Array(64);void 0!==wb||(wb=l.Int32Array?new Int32Array(xb):xb);this.reset()},wb;r(yb,vb);for(var zb=[],Ab=0;63>Ab;Ab++)zb[Ab]=0;var Bb=Ma(128,zb);yb.prototype.reset=function(){this.Fc=this.hb=0;this.h=l.Int32Array?new Int32Array(this.Wd):Na(this.Wd)};
	var Cb=function(a){var b=a.ec;v(b.length==a.Da);for(var c=a.Mf,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){var e=c[b-15]|0,d=c[b-2]|0,f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}for(var d=a.h[0]|0,e=a.h[1]|0,k=a.h[2]|0,n=a.h[3]|0,C=a.h[4]|0,db=a.h[5]|0,Pb=a.h[6]|0,f=a.h[7]|0,b=0;64>b;b++)var Ah=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&k^e&k)|0,g=C&db^~C&Pb,f=f+((C>>>6|
	C<<26)^(C>>>11|C<<21)^(C>>>25|C<<7))|0,g=g+(wb[b]|0)|0,g=f+(g+(c[b]|0)|0)|0,f=Pb,Pb=db,db=C,C=n+g|0,n=k,k=e,e=d,d=g+Ah|0;a.h[0]=a.h[0]+d|0;a.h[1]=a.h[1]+e|0;a.h[2]=a.h[2]+k|0;a.h[3]=a.h[3]+n|0;a.h[4]=a.h[4]+C|0;a.h[5]=a.h[5]+db|0;a.h[6]=a.h[6]+Pb|0;a.h[7]=a.h[7]+f|0};
	yb.prototype.update=function(a,b){void 0===b&&(b=a.length);var c=0,d=this.hb;if(m(a))for(;c<b;)this.ec[d++]=a.charCodeAt(c++),d==this.Da&&(Cb(this),d=0);else if(fa(a))for(;c<b;){var e=a[c++];if(!("number"==typeof e&&0<=e&&255>=e&&e==(e|0)))throw Error("message must be a byte array");this.ec[d++]=e;d==this.Da&&(Cb(this),d=0)}else throw Error("message must be string or array");this.hb=d;this.Fc+=b};
	yb.prototype.digest=function(){var a=[],b=8*this.Fc;56>this.hb?this.update(Bb,56-this.hb):this.update(Bb,this.Da-(this.hb-56));for(var c=63;56<=c;c--)this.ec[c]=b&255,b/=256;Cb(this);for(c=b=0;c<this.lf;c++)for(var d=24;0<=d;d-=8)a[b++]=this.h[c]>>d&255;return a};
	var xb=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var Eb=function(){yb.call(this,8,Db)};r(Eb,yb);var Db=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];var Fb=function(){this.Ga=this.Ga;this.tc=this.tc};Fb.prototype.Ga=!1;Fb.prototype.isDisposed=function(){return this.Ga};Fb.prototype.cb=function(){if(this.tc)for(;this.tc.length;)this.tc.shift()()};var Gb=!y||9<=Number(ob),Hb=y&&!z("9");!hb||z("528");gb&&z("1.9b")||y&&z("8")||cb&&z("9.5")||hb&&z("528");gb&&!z("8")||y&&z("9");var Ib=function(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.nb=!1;this.ee=!0};Ib.prototype.preventDefault=function(){this.defaultPrevented=!0;this.ee=!1};var Jb=function(a,b){Ib.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.eb=this.state=null;a&&this.init(a,b)};r(Jb,Ib);
	Jb.prototype.init=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;if(b=a.relatedTarget){if(gb){var e;a:{try{$a(b.nodeName);e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.offsetX=hb||void 0!==a.offsetX?a.offsetX:a.layerX,this.offsetY=hb||void 0!==a.offsetY?a.offsetY:a.layerY,this.clientX=void 0!==a.clientX?a.clientX:
	a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.state=a.state;this.eb=
	a;a.defaultPrevented&&this.preventDefault()};Jb.prototype.preventDefault=function(){Jb.xd.preventDefault.call(this);var a=this.eb;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Hb)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Jb.prototype.Pe=function(){return this.eb};var Kb="closure_listenable_"+(1E6*Math.random()|0),Lb=0;var Mb=function(a,b,c,d,e){this.listener=a;this.xc=null;this.src=b;this.type=c;this.capture=!!d;this.kc=e;this.key=++Lb;this.rb=this.dc=!1},Nb=function(a){a.rb=!0;a.listener=null;a.xc=null;a.src=null;a.kc=null};var Ob=function(a){this.src=a;this.G={};this.$b=0};Ob.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.G[f];a||(a=this.G[f]=[],this.$b++);var g=Qb(a,b,d,e);-1<g?(b=a[g],c||(b.dc=!1)):(b=new Mb(b,this.src,f,!!d,e),b.dc=c,a.push(b));return b};Ob.prototype.remove=function(a,b,c,d){a=a.toString();if(!(a in this.G))return!1;var e=this.G[a];b=Qb(e,b,c,d);return-1<b?(Nb(e[b]),Ja(e,b),0==e.length&&(delete this.G[a],this.$b--),!0):!1};
	var Rb=function(a,b){var c=b.type;c in a.G&&Ka(a.G[c],b)&&(Nb(b),0==a.G[c].length&&(delete a.G[c],a.$b--))};Ob.prototype.Uc=function(a,b,c,d){a=this.G[a.toString()];var e=-1;a&&(e=Qb(a,b,c,d));return-1<e?a[e]:null};var Qb=function(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.rb&&f.listener==b&&f.capture==!!c&&f.kc==d)return e}return-1};var Sb="closure_lm_"+(1E6*Math.random()|0),Tb={},Ub=0,Vb=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)Vb(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?a.listen(b,c,d,e):Xb(a,b,c,!1,d,e)},Xb=function(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=!!e,k=Yb(a);k||(a[Sb]=k=new Ob(a));c=k.add(b,c,d,e,f);if(!c.xc){d=Zb();c.xc=d;d.src=a;d.listener=c;if(a.addEventListener)a.addEventListener(b.toString(),d,g);else if(a.attachEvent)a.attachEvent($b(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");
	Ub++}},Zb=function(){var a=ac,b=Gb?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b},bc=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)bc(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?cc(a,b,c,d,e):Xb(a,b,c,!0,d,e)},dc=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)dc(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?a.fa.remove(String(b),c,d,e):a&&(a=Yb(a))&&(b=a.Uc(b,c,!!d,e))&&ec(b)},ec=function(a){if(!ga(a)&&a&&!a.rb){var b=a.src;if(b&&
	b[Kb])Rb(b.fa,a);else{var c=a.type,d=a.xc;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent&&b.detachEvent($b(c),d);Ub--;(c=Yb(b))?(Rb(c,a),0==c.$b&&(c.src=null,b[Sb]=null)):Nb(a)}}},$b=function(a){return a in Tb?Tb[a]:Tb[a]="on"+a},gc=function(a,b,c,d){var e=!0;if(a=Yb(a))if(b=a.G[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.rb&&(f=fc(f,d),e=e&&!1!==f)}return e},fc=function(a,b){var c=a.listener,d=a.kc||a.src;a.dc&&ec(a);return c.call(d,
	b)},ac=function(a,b){if(a.rb)return!0;if(!Gb){if(!b)a:{b=["window","event"];for(var c=l,d;d=b.shift();)if(null!=c[d])c=c[d];else{b=null;break a}b=c}d=b;b=new Jb(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.currentTarget;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;!b.nb&&0<=e;e--){b.currentTarget=d[e];var f=gc(d[e],a,!0,b),c=c&&f}for(e=0;!b.nb&&e<d.length;e++)b.currentTarget=
	d[e],f=gc(d[e],a,!1,b),c=c&&f}return c}return fc(a,new Jb(b,this))},Yb=function(a){a=a[Sb];return a instanceof Ob?a:null},hc="__closure_events_fn_"+(1E9*Math.random()>>>0),Wb=function(a){v(a,"Listener can not be null.");if(p(a))return a;v(a.handleEvent,"An object listener must have handleEvent method.");a[hc]||(a[hc]=function(b){return a.handleEvent(b)});return a[hc]};var ic=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;var kc=function(){this.Cc="";this.we=jc};kc.prototype.Eb=!0;kc.prototype.Bb=function(){return this.Cc};kc.prototype.toString=function(){return"Const{"+this.Cc+"}"};var lc=function(a){if(a instanceof kc&&a.constructor===kc&&a.we===jc)return a.Cc;ya("expected object of type Const, got '"+a+"'");return"type_error:Const"},jc={},mc=function(a){var b=new kc;b.Cc=a;return b};mc("");var oc=function(){this.wc="";this.xe=nc};oc.prototype.Eb=!0;oc.prototype.Bb=function(){return this.wc};oc.prototype.toString=function(){return"TrustedResourceUrl{"+this.wc+"}"};var nc={};var qc=function(){this.pa="";this.ve=pc};qc.prototype.Eb=!0;qc.prototype.Bb=function(){return this.pa};qc.prototype.toString=function(){return"SafeUrl{"+this.pa+"}"};
	var rc=function(a){if(a instanceof qc&&a.constructor===qc&&a.ve===pc)return a.pa;ya("expected object of type SafeUrl, got '"+a+"' of type "+ca(a));return"type_error:SafeUrl"},sc=/^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i,uc=function(a){if(a instanceof qc)return a;a=a.Eb?a.Bb():String(a);sc.test(a)||(a="about:invalid#zClosurez");return tc(a)},pc={},tc=function(a){var b=new qc;b.pa=a;return b};tc("about:blank");var xc=function(a){var b=[];vc(new wc,a,b);return b.join("")},wc=function(){this.yc=void 0},vc=function(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(ea(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),e=d[f],vc(a,a.yc?a.yc.call(d,String(f),e):e,c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");f="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(e=b[d],"function"!=typeof e&&(c.push(f),
	yc(d,c),c.push(":"),vc(a,a.yc?a.yc.call(b,d,e):e,c),f=","));c.push("}");return}}switch(typeof b){case "string":yc(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}},zc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ac=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g,
	yc=function(a,b){b.push('"',a.replace(Ac,function(a){var b=zc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),zc[a]=b);return b}),'"')};var Bc=function(){};Bc.prototype.Dd=null;var Cc=function(a){return a.Dd||(a.Dd=a.$c())};var Dc,Ec=function(){};r(Ec,Bc);Ec.prototype.fc=function(){var a=Fc(this);return a?new ActiveXObject(a):new XMLHttpRequest};Ec.prototype.$c=function(){var a={};Fc(this)&&(a[0]=!0,a[1]=!0);return a};
	var Fc=function(a){if(!a.Vd&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.Vd=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.Vd};Dc=new Ec;var Gc=function(){};r(Gc,Bc);Gc.prototype.fc=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Hc;throw Error("Unsupported browser");};Gc.prototype.$c=function(){return{}};
	var Hc=function(){this.ua=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.ua.onload=q(this.Re,this);this.ua.onerror=q(this.Sd,this);this.ua.onprogress=q(this.Se,this);this.ua.ontimeout=q(this.Te,this)};h=Hc.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.ua.open(a,b)};
	h.send=function(a){if(a)if("string"==typeof a)this.ua.send(a);else throw Error("Only string data is supported");else this.ua.send()};h.abort=function(){this.ua.abort()};h.setRequestHeader=function(){};h.Re=function(){this.status=200;this.responseText=this.ua.responseText;Ic(this,4)};h.Sd=function(){this.status=500;this.responseText="";Ic(this,4)};h.Te=function(){this.Sd()};h.Se=function(){this.status=200;Ic(this,1)};var Ic=function(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()};var Jc=function(a,b,c){this.ef=c;this.Fe=a;this.wf=b;this.sc=0;this.lc=null};Jc.prototype.get=function(){var a;0<this.sc?(this.sc--,a=this.lc,this.lc=a.next,a.next=null):a=this.Fe();return a};Jc.prototype.put=function(a){this.wf(a);this.sc<this.ef&&(this.sc++,a.next=this.lc,this.lc=a)};var Kc=function(a){l.setTimeout(function(){throw a;},0)},Lc,Mc=function(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!x("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host,
	a=q(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!x("Trident")&&!x("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.Gd;c.Gd=null;a()}};return function(a){d.next={Gd:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?
	function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){l.setTimeout(a,0)}};var Nc=function(){this.Jc=this.Za=null},Pc=new Jc(function(){return new Oc},function(a){a.reset()},100);Nc.prototype.add=function(a,b){var c=Pc.get();c.set(a,b);this.Jc?this.Jc.next=c:(v(!this.Za),this.Za=c);this.Jc=c};Nc.prototype.remove=function(){var a=null;this.Za&&(a=this.Za,this.Za=this.Za.next,this.Za||(this.Jc=null),a.next=null);return a};var Oc=function(){this.next=this.scope=this.Tc=null};Oc.prototype.set=function(a,b){this.Tc=a;this.scope=b;this.next=null};
	Oc.prototype.reset=function(){this.next=this.scope=this.Tc=null};var Uc=function(a,b){Qc||Rc();Sc||(Qc(),Sc=!0);Tc.add(a,b)},Qc,Rc=function(){if(-1!=String(l.Promise).indexOf("[native code]")){var a=l.Promise.resolve(void 0);Qc=function(){a.then(Vc)}}else Qc=function(){var a=Vc;!p(l.setImmediate)||l.Window&&l.Window.prototype&&!x("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(Lc||(Lc=Mc()),Lc(a)):l.setImmediate(a)}},Sc=!1,Tc=new Nc,Vc=function(){for(var a;a=Tc.remove();){try{a.Tc.call(a.scope)}catch(b){Kc(b)}Pc.put(a)}Sc=!1};!gb&&!y||y&&9<=Number(ob)||gb&&z("1.9.1");y&&z("9");var Xc=function(){this.pa="";this.ue=Wc};Xc.prototype.Eb=!0;Xc.prototype.Bb=function(){return this.pa};Xc.prototype.toString=function(){return"SafeHtml{"+this.pa+"}"};var Yc=function(a){if(a instanceof Xc&&a.constructor===Xc&&a.ue===Wc)return a.pa;ya("expected object of type SafeHtml, got '"+a+"' of type "+ca(a));return"type_error:SafeHtml"},Wc={};Xc.prototype.$e=function(a){this.pa=a;return this};var $c=function(a,b){Sa(b,function(b,d){b&&b.Eb&&(b=b.Bb());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Zc.hasOwnProperty(d)?a.setAttribute(Zc[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})},Zc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};var ad=function(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0},bd=function(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};var A=function(a,b){this.N=0;this.ra=void 0;this.bb=this.na=this.s=null;this.jc=this.Sc=!1;if(a!=ba)try{var c=this;a.call(b,function(a){cd(c,2,a)},function(a){if(!(a instanceof dd))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}cd(c,3,a)})}catch(d){cd(this,3,d)}},ed=function(){this.next=this.context=this.jb=this.Oa=this.child=null;this.xb=!1};ed.prototype.reset=function(){this.context=this.jb=this.Oa=this.child=null;this.xb=!1};
	var fd=new Jc(function(){return new ed},function(a){a.reset()},100),gd=function(a,b,c){var d=fd.get();d.Oa=a;d.jb=b;d.context=c;return d},B=function(a){if(a instanceof A)return a;var b=new A(ba);cd(b,2,a);return b},D=function(a){return new A(function(b,c){c(a)})},id=function(a,b,c){hd(a,b,c,null)||Uc(ka(b,a))},jd=function(a){return new A(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Ne:!0,value:f}:{Ne:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],id(g,ka(e,f,!0),
	ka(e,f,!1));else b(d)})};A.prototype.then=function(a,b,c){null!=a&&Ba(a,"opt_onFulfilled should be a function.");null!=b&&Ba(b,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return kd(this,p(a)?a:null,p(b)?b:null,c)};ad(A);var md=function(a,b){b=gd(b,b,void 0);b.xb=!0;ld(a,b);return a};A.prototype.f=function(a,b){return kd(this,null,a,b)};A.prototype.cancel=function(a){0==this.N&&Uc(function(){var b=new dd(a);nd(this,b)},this)};
	var nd=function(a,b){if(0==a.N)if(a.s){var c=a.s;if(c.na){for(var d=0,e=null,f=null,g=c.na;g&&(g.xb||(d++,g.child==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(0==c.N&&1==d?nd(c,b):(f?(d=f,v(c.na),v(null!=d),d.next==c.bb&&(c.bb=d),d.next=d.next.next):od(c),pd(c,e,3,b)))}a.s=null}else cd(a,3,b)},ld=function(a,b){a.na||2!=a.N&&3!=a.N||qd(a);v(null!=b.Oa);a.bb?a.bb.next=b:a.na=b;a.bb=b},kd=function(a,b,c,d){var e=gd(null,null,null);e.child=new A(function(a,g){e.Oa=b?function(c){try{var e=b.call(d,c);a(e)}catch(C){g(C)}}:
	a;e.jb=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof dd?g(b):a(e)}catch(C){g(C)}}:g});e.child.s=a;ld(a,e);return e.child};A.prototype.Jf=function(a){v(1==this.N);this.N=0;cd(this,2,a)};A.prototype.Kf=function(a){v(1==this.N);this.N=0;cd(this,3,a)};
	var cd=function(a,b,c){0==a.N&&(a===c&&(b=3,c=new TypeError("Promise cannot resolve to itself")),a.N=1,hd(c,a.Jf,a.Kf,a)||(a.ra=c,a.N=b,a.s=null,qd(a),3!=b||c instanceof dd||rd(a,c)))},hd=function(a,b,c,d){if(a instanceof A)return null!=b&&Ba(b,"opt_onFulfilled should be a function."),null!=c&&Ba(c,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"),ld(a,gd(b||ba,c||null,d)),!0;if(bd(a))return a.then(b,c,d),!0;if(ha(a))try{var e=a.then;if(p(e))return sd(a,
	e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1},sd=function(a,b,c,d,e){var f=!1,g=function(a){f||(f=!0,c.call(e,a))},k=function(a){f||(f=!0,d.call(e,a))};try{b.call(a,g,k)}catch(n){k(n)}},qd=function(a){a.Sc||(a.Sc=!0,Uc(a.Je,a))},od=function(a){var b=null;a.na&&(b=a.na,a.na=b.next,b.next=null);a.na||(a.bb=null);null!=b&&v(null!=b.Oa);return b};A.prototype.Je=function(){for(var a;a=od(this);)pd(this,a,this.N,this.ra);this.Sc=!1};
	var pd=function(a,b,c,d){if(3==c&&b.jb&&!b.xb)for(;a&&a.jc;a=a.s)a.jc=!1;if(b.child)b.child.s=null,td(b,c,d);else try{b.xb?b.Oa.call(b.context):td(b,c,d)}catch(e){ud.call(null,e)}fd.put(b)},td=function(a,b,c){2==b?a.Oa.call(a.context,c):a.jb&&a.jb.call(a.context,c)},rd=function(a,b){a.jc=!0;Uc(function(){a.jc&&ud.call(null,b)})},ud=Kc,dd=function(a){t.call(this,a)};r(dd,t);dd.prototype.name="cancel";
	var vd=function(a,b){this.zc=[];this.$d=a;this.Jd=b||null;this.Cb=this.fb=!1;this.ra=void 0;this.ud=this.Cd=this.Nc=!1;this.Gc=0;this.s=null;this.Oc=0};vd.prototype.cancel=function(a){if(this.fb)this.ra instanceof vd&&this.ra.cancel();else{if(this.s){var b=this.s;delete this.s;a?b.cancel(a):(b.Oc--,0>=b.Oc&&b.cancel())}this.$d?this.$d.call(this.Jd,this):this.ud=!0;this.fb||wd(this,new xd)}};vd.prototype.Hd=function(a,b){this.Nc=!1;yd(this,a,b)};
	var yd=function(a,b,c){a.fb=!0;a.ra=c;a.Cb=!b;zd(a)},Bd=function(a){if(a.fb){if(!a.ud)throw new Ad;a.ud=!1}};vd.prototype.callback=function(a){Bd(this);Cd(a);yd(this,!0,a)};
	var wd=function(a,b){Bd(a);Cd(b);yd(a,!1,b)},Cd=function(a){v(!(a instanceof vd),"An execution sequence may not be initiated with a blocking Deferred.")},Gd=function(a){var b=Dd("https://apis.google.com/js/client.js?onload="+Ed);Fd(b,null,a,void 0)},Fd=function(a,b,c,d){v(!a.Cd,"Blocking Deferreds can not be re-used");a.zc.push([b,c,d]);a.fb&&zd(a)};vd.prototype.then=function(a,b,c){var d,e,f=new A(function(a,b){d=a;e=b});Fd(this,d,function(a){a instanceof xd?f.cancel():e(a)});return f.then(a,b,c)};
	ad(vd);
	var Hd=function(a){return Fa(a.zc,function(a){return p(a[1])})},zd=function(a){if(a.Gc&&a.fb&&Hd(a)){var b=a.Gc,c=Id[b];c&&(l.clearTimeout(c.Db),delete Id[b]);a.Gc=0}a.s&&(a.s.Oc--,delete a.s);for(var b=a.ra,d=c=!1;a.zc.length&&!a.Nc;){var e=a.zc.shift(),f=e[0],g=e[1],e=e[2];if(f=a.Cb?g:f)try{var k=f.call(e||a.Jd,b);void 0!==k&&(a.Cb=a.Cb&&(k==b||k instanceof Error),a.ra=b=k);if(bd(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.Nc=!0}catch(n){b=n,a.Cb=!0,Hd(a)||(c=!0)}}a.ra=b;d&&
	(k=q(a.Hd,a,!0),d=q(a.Hd,a,!1),b instanceof vd?(Fd(b,k,d),b.Cd=!0):b.then(k,d));c&&(b=new Jd(b),Id[b.Db]=b,a.Gc=b.Db)},Ad=function(){t.call(this)};r(Ad,t);Ad.prototype.message="Deferred has already fired";Ad.prototype.name="AlreadyCalledError";var xd=function(){t.call(this)};r(xd,t);xd.prototype.message="Deferred was canceled";xd.prototype.name="CanceledError";var Jd=function(a){this.Db=l.setTimeout(q(this.If,this),0);this.P=a};
	Jd.prototype.If=function(){v(Id[this.Db],"Cannot throw an error that is not scheduled.");delete Id[this.Db];throw this.P;};var Id={};var Dd=function(a){var b=new oc;b.wc=a;return Kd(b)},Kd=function(a){var b={},c=b.document||document,d;a instanceof oc&&a.constructor===oc&&a.xe===nc?d=a.wc:(ya("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ca(a)),d="type_error:TrustedResourceUrl");var e=document.createElement("SCRIPT");a={fe:e,Zb:void 0};var f=new vd(Ld,a),g=null,k=null!=b.timeout?b.timeout:5E3;0<k&&(g=window.setTimeout(function(){Md(e,!0);wd(f,new Nd(1,"Timeout reached for loading script "+d))},k),a.Zb=g);e.onload=
	e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Md(e,b.Uf||!1,g),f.callback(null))};e.onerror=function(){Md(e,!0,g);wd(f,new Nd(0,"Error while loading script "+d))};a=b.attributes||{};Za(a,{type:"text/javascript",charset:"UTF-8",src:d});$c(e,a);Od(c).appendChild(e);return f},Od=function(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement},Ld=function(){if(this&&this.fe){var a=this.fe;a&&"SCRIPT"==a.tagName&&
	Md(a,!0,this.Zb)}},Md=function(a,b,c){null!=c&&l.clearTimeout(c);a.onload=ba;a.onerror=ba;a.onreadystatechange=ba;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)},Nd=function(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);t.call(this,c);this.code=a};r(Nd,t);var Pd="StopIteration"in l?l.StopIteration:{message:"StopIteration",stack:""},Qd=function(){};Qd.prototype.next=function(){throw Pd;};Qd.prototype.ye=function(){return this};var Rd=function(a,b){this.ga={};this.w=[];this.wb=this.o=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.addAll(a)};Rd.prototype.Z=function(){Sd(this);for(var a=[],b=0;b<this.w.length;b++)a.push(this.ga[this.w[b]]);return a};Rd.prototype.oa=function(){Sd(this);return this.w.concat()};Rd.prototype.yb=function(a){return Td(this.ga,a)};
	Rd.prototype.remove=function(a){return Td(this.ga,a)?(delete this.ga[a],this.o--,this.wb++,this.w.length>2*this.o&&Sd(this),!0):!1};var Sd=function(a){if(a.o!=a.w.length){for(var b=0,c=0;b<a.w.length;){var d=a.w[b];Td(a.ga,d)&&(a.w[c++]=d);b++}a.w.length=c}if(a.o!=a.w.length){for(var e={},c=b=0;b<a.w.length;)d=a.w[b],Td(e,d)||(a.w[c++]=d,e[d]=1),b++;a.w.length=c}};h=Rd.prototype;h.get=function(a,b){return Td(this.ga,a)?this.ga[a]:b};
	h.set=function(a,b){Td(this.ga,a)||(this.o++,this.w.push(a),this.wb++);this.ga[a]=b};h.addAll=function(a){var b;a instanceof Rd?(b=a.oa(),a=a.Z()):(b=Ua(a),a=Ta(a));for(var c=0;c<b.length;c++)this.set(b[c],a[c])};h.forEach=function(a,b){for(var c=this.oa(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};h.clone=function(){return new Rd(this)};
	h.ye=function(a){Sd(this);var b=0,c=this.wb,d=this,e=new Qd;e.next=function(){if(c!=d.wb)throw Error("The map has changed since the iterator was created");if(b>=d.w.length)throw Pd;var e=d.w[b++];return a?e:d.ga[e]};return e};var Td=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Ud=function(a){if(a.Z&&"function"==typeof a.Z)return a.Z();if(m(a))return a.split("");if(fa(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ta(a)},Vd=function(a){if(a.oa&&"function"==typeof a.oa)return a.oa();if(!a.Z||"function"!=typeof a.Z){if(fa(a)||m(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return Ua(a)}},Wd=function(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(fa(a)||m(a))w(a,b,void 0);else for(var c=Vd(a),d=Ud(a),e=
	d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};var Xd=function(a,b,c,d,e){this.reset(a,b,c,d,e)};Xd.prototype.Md=null;var Yd=0;Xd.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Yd++;d||la();this.Ib=a;this.hf=b;delete this.Md};Xd.prototype.ie=function(a){this.Ib=a};var Zd=function(a){this.jf=a;this.Td=this.Pc=this.Ib=this.s=null},$d=function(a,b){this.name=a;this.value=b};$d.prototype.toString=function(){return this.name};var ae=new $d("SEVERE",1E3),be=new $d("CONFIG",700),ce=new $d("FINE",500);Zd.prototype.getParent=function(){return this.s};Zd.prototype.ie=function(a){this.Ib=a};var de=function(a){if(a.Ib)return a.Ib;if(a.s)return de(a.s);ya("Root logger has no level set.");return null};
	Zd.prototype.log=function(a,b,c){if(a.value>=de(this).value)for(p(b)&&(b=b()),a=new Xd(a,String(b),this.jf),c&&(a.Md=c),c="log:"+a.hf,l.console&&(l.console.timeStamp?l.console.timeStamp(c):l.console.markTimeline&&l.console.markTimeline(c)),l.msWriteProfilerMark&&l.msWriteProfilerMark(c),c=this;c;){var d=c,e=a;if(d.Td)for(var f=0;b=d.Td[f];f++)b(e);c=c.getParent()}};
	var ee={},fe=null,ge=function(a){fe||(fe=new Zd(""),ee[""]=fe,fe.ie(be));var b;if(!(b=ee[a])){b=new Zd(a);var c=a.lastIndexOf("."),d=a.substr(c+1),c=ge(a.substr(0,c));c.Pc||(c.Pc={});c.Pc[d]=b;b.s=c;ee[a]=b}return b};var he=function(){Fb.call(this);this.fa=new Ob(this);this.ze=this;this.hd=null};r(he,Fb);he.prototype[Kb]=!0;h=he.prototype;h.addEventListener=function(a,b,c,d){Vb(this,a,b,c,d)};h.removeEventListener=function(a,b,c,d){dc(this,a,b,c,d)};
	h.dispatchEvent=function(a){ie(this);var b,c=this.hd;if(c){b=[];for(var d=1;c;c=c.hd)b.push(c),v(1E3>++d,"infinite loop")}c=this.ze;d=a.type||a;if(m(a))a=new Ib(a,c);else if(a instanceof Ib)a.target=a.target||c;else{var e=a;a=new Ib(d,c);Za(a,e)}var e=!0,f;if(b)for(var g=b.length-1;!a.nb&&0<=g;g--)f=a.currentTarget=b[g],e=je(f,d,!0,a)&&e;a.nb||(f=a.currentTarget=c,e=je(f,d,!0,a)&&e,a.nb||(e=je(f,d,!1,a)&&e));if(b)for(g=0;!a.nb&&g<b.length;g++)f=a.currentTarget=b[g],e=je(f,d,!1,a)&&e;return e};
	h.cb=function(){he.xd.cb.call(this);if(this.fa){var a=this.fa,b=0,c;for(c in a.G){for(var d=a.G[c],e=0;e<d.length;e++)++b,Nb(d[e]);delete a.G[c];a.$b--}}this.hd=null};h.listen=function(a,b,c,d){ie(this);return this.fa.add(String(a),b,!1,c,d)};
	var cc=function(a,b,c,d,e){a.fa.add(String(b),c,!0,d,e)},je=function(a,b,c,d){b=a.fa.G[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.rb&&g.capture==c){var k=g.listener,n=g.kc||g.src;g.dc&&Rb(a.fa,g);e=!1!==k.call(n,d)&&e}}return e&&0!=d.ee};he.prototype.Uc=function(a,b,c,d){return this.fa.Uc(String(a),b,c,d)};var ie=function(a){v(a.fa,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?")};var E=function(a,b){a&&a.log(ce,b,void 0)};var ke=function(a,b,c){if(p(a))c&&(a=q(a,c));else if(a&&"function"==typeof a.handleEvent)a=q(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)},le=function(a){var b=null;return(new A(function(c,d){b=ke(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).f(function(a){l.clearTimeout(b);throw a;})};var me=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/,ne=function(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e,f=null;0<=d?(e=a[c].substring(0,d),f=a[c].substring(d+1)):e=a[c];b(e,f?decodeURIComponent(f.replace(/\+/g," ")):"")}}};var F=function(a){he.call(this);this.headers=new Rd;this.Lc=a||null;this.va=!1;this.Kc=this.b=null;this.Hb=this.Zd=this.qc="";this.Ka=this.Yc=this.oc=this.Rc=!1;this.sb=0;this.Ec=null;this.de="";this.Hc=this.sf=this.te=!1};r(F,he);var oe=F.prototype,pe=ge("goog.net.XhrIo");oe.U=pe;var qe=/^https?$/i,re=["POST","PUT"];
	F.prototype.send=function(a,b,c,d){if(this.b)throw Error("[goog.net.XhrIo] Object is active with another request="+this.qc+"; newUri="+a);b=b?b.toUpperCase():"GET";this.qc=a;this.Hb="";this.Zd=b;this.Rc=!1;this.va=!0;this.b=this.Lc?this.Lc.fc():Dc.fc();this.Kc=this.Lc?Cc(this.Lc):Cc(Dc);this.b.onreadystatechange=q(this.be,this);this.sf&&"onprogress"in this.b&&(this.b.onprogress=q(function(a){this.ae(a,!0)},this),this.b.upload&&(this.b.upload.onprogress=q(this.ae,this)));try{E(this.U,se(this,"Opening Xhr")),
	this.Yc=!0,this.b.open(b,String(a),!0),this.Yc=!1}catch(f){E(this.U,se(this,"Error opening Xhr: "+f.message));this.P(5,f);return}a=c||"";var e=this.headers.clone();d&&Wd(d,function(a,b){e.set(b,a)});d=Ha(e.oa());c=l.FormData&&a instanceof l.FormData;!Ia(re,b)||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.b.setRequestHeader(b,a)},this);this.de&&(this.b.responseType=this.de);"withCredentials"in this.b&&this.b.withCredentials!==this.te&&(this.b.withCredentials=
	this.te);try{te(this),0<this.sb&&(this.Hc=ue(this.b),E(this.U,se(this,"Will abort after "+this.sb+"ms if incomplete, xhr2 "+this.Hc)),this.Hc?(this.b.timeout=this.sb,this.b.ontimeout=q(this.Zb,this)):this.Ec=ke(this.Zb,this.sb,this)),E(this.U,se(this,"Sending request")),this.oc=!0,this.b.send(a),this.oc=!1}catch(f){E(this.U,se(this,"Send error: "+f.message)),this.P(5,f)}};var ue=function(a){return y&&z(9)&&ga(a.timeout)&&void 0!==a.ontimeout},Ga=function(a){return"content-type"==a.toLowerCase()};
	F.prototype.Zb=function(){"undefined"!=typeof aa&&this.b&&(this.Hb="Timed out after "+this.sb+"ms, aborting",E(this.U,se(this,this.Hb)),this.dispatchEvent("timeout"),this.abort(8))};F.prototype.P=function(a,b){this.va=!1;this.b&&(this.Ka=!0,this.b.abort(),this.Ka=!1);this.Hb=b;ve(this);we(this)};var ve=function(a){a.Rc||(a.Rc=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))};
	F.prototype.abort=function(){this.b&&this.va&&(E(this.U,se(this,"Aborting")),this.va=!1,this.Ka=!0,this.b.abort(),this.Ka=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),we(this))};F.prototype.cb=function(){this.b&&(this.va&&(this.va=!1,this.Ka=!0,this.b.abort(),this.Ka=!1),we(this,!0));F.xd.cb.call(this)};F.prototype.be=function(){this.isDisposed()||(this.Yc||this.oc||this.Ka?xe(this):this.nf())};F.prototype.nf=function(){xe(this)};
	var xe=function(a){if(a.va&&"undefined"!=typeof aa)if(a.Kc[1]&&4==ye(a)&&2==ze(a))E(a.U,se(a,"Local request error detected and ignored"));else if(a.oc&&4==ye(a))ke(a.be,0,a);else if(a.dispatchEvent("readystatechange"),4==ye(a)){E(a.U,se(a,"Request complete"));a.va=!1;try{var b=ze(a),c;a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.qc).match(me)[1]||null;if(!f&&l.self&&l.self.location)var g=l.self.location.protocol,
	f=g.substr(0,g.length-1);e=!qe.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{var k;try{k=2<ye(a)?a.b.statusText:""}catch(n){E(a.U,"Can not get status: "+n.message),k=""}a.Hb=k+" ["+ze(a)+"]";ve(a)}}finally{we(a)}}};F.prototype.ae=function(a,b){v("progress"===a.type,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(Ae(a,"progress"));this.dispatchEvent(Ae(a,b?"downloadprogress":"uploadprogress"))};
	var Ae=function(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}},we=function(a,b){if(a.b){te(a);var c=a.b,d=a.Kc[0]?ba:null;a.b=null;a.Kc=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.U)&&a.log(ae,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}},te=function(a){a.b&&a.Hc&&(a.b.ontimeout=null);ga(a.Ec)&&(l.clearTimeout(a.Ec),a.Ec=null)},ye=function(a){return a.b?a.b.readyState:0},ze=function(a){try{return 2<ye(a)?
	a.b.status:-1}catch(b){return-1}},Be=function(a){try{return a.b?a.b.responseText:""}catch(b){return E(a.U,"Can not get responseText: "+b.message),""}},se=function(a,b){return b+" ["+a.Zd+" "+a.qc+" "+ze(a)+"]"};var G=function(a,b){this.ea=this.Xa=this.ha="";this.lb=null;this.Ja=this.xa="";this.S=this.df=!1;var c;a instanceof G?(this.S=void 0!==b?b:a.S,Ce(this,a.ha),c=a.Xa,H(this),this.Xa=c,De(this,a.ea),Ee(this,a.lb),Fe(this,a.xa),Ge(this,a.W.clone()),a=a.Ja,H(this),this.Ja=a):a&&(c=String(a).match(me))?(this.S=!!b,Ce(this,c[1]||"",!0),a=c[2]||"",H(this),this.Xa=He(a),De(this,c[3]||"",!0),Ee(this,c[4]),Fe(this,c[5]||"",!0),Ge(this,c[6]||"",!0),a=c[7]||"",H(this),this.Ja=He(a)):(this.S=!!b,this.W=new I(null,
	0,this.S))};G.prototype.toString=function(){var a=[],b=this.ha;b&&a.push(Ie(b,Je,!0),":");var c=this.ea;if(c||"file"==b)a.push("//"),(b=this.Xa)&&a.push(Ie(b,Je,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.lb,null!=c&&a.push(":",String(c));if(c=this.xa)this.ea&&"/"!=c.charAt(0)&&a.push("/"),a.push(Ie(c,"/"==c.charAt(0)?Ke:Le,!0));(c=this.W.toString())&&a.push("?",c);(c=this.Ja)&&a.push("#",Ie(c,Me));return a.join("")};
	G.prototype.resolve=function(a){var b=this.clone(),c=!!a.ha;c?Ce(b,a.ha):c=!!a.Xa;if(c){var d=a.Xa;H(b);b.Xa=d}else c=!!a.ea;c?De(b,a.ea):c=null!=a.lb;d=a.xa;if(c)Ee(b,a.lb);else if(c=!!a.xa){if("/"!=d.charAt(0))if(this.ea&&!this.xa)d="/"+d;else{var e=b.xa.lastIndexOf("/");-1!=e&&(d=b.xa.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(u(e,"./")||u(e,"/.")){for(var d=0==e.lastIndexOf("/",0),e=e.split("/"),f=[],g=0;g<e.length;){var k=e[g++];"."==k?d&&g==e.length&&f.push(""):".."==k?((1<f.length||
	1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(k),d=!0)}d=f.join("/")}else d=e}c?Fe(b,d):c=""!==a.W.toString();c?Ge(b,a.W.clone()):c=!!a.Ja;c&&(a=a.Ja,H(b),b.Ja=a);return b};G.prototype.clone=function(){return new G(this)};
	var Ce=function(a,b,c){H(a);a.ha=c?He(b,!0):b;a.ha&&(a.ha=a.ha.replace(/:$/,""))},De=function(a,b,c){H(a);a.ea=c?He(b,!0):b},Ee=function(a,b){H(a);if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.lb=b}else a.lb=null},Fe=function(a,b,c){H(a);a.xa=c?He(b,!0):b},Ge=function(a,b,c){H(a);b instanceof I?(a.W=b,a.W.td(a.S)):(c||(b=Ie(b,Ne)),a.W=new I(b,0,a.S))},J=function(a,b,c){H(a);a.W.set(b,c)},Oe=function(a,b){return a.W.get(b)};
	G.prototype.removeParameter=function(a){H(this);this.W.remove(a);return this};var H=function(a){if(a.df)throw Error("Tried to modify a read-only Uri");};G.prototype.td=function(a){this.S=a;this.W&&this.W.td(a);return this};
	var Pe=function(a){return a instanceof G?a.clone():new G(a,void 0)},Qe=function(a,b){var c=new G(null,void 0);Ce(c,"https");a&&De(c,a);b&&Fe(c,b);return c},He=function(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""},Ie=function(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Re),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null},Re=function(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)},Je=/[#\/\?@]/g,Le=/[\#\?:]/g,Ke=/[\#\?]/g,Ne=/[\#\?@]/g,
	Me=/#/g,I=function(a,b,c){this.o=this.l=null;this.O=a||null;this.S=!!c},Se=function(a){a.l||(a.l=new Rd,a.o=0,a.O&&ne(a.O,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))},Ue=function(a){var b=Vd(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new I(null,0,void 0);a=Ud(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];ea(f)?Te(c,e,f):c.add(e,f)}return c};h=I.prototype;
	h.add=function(a,b){Se(this);this.O=null;a=this.R(a);var c=this.l.get(a);c||this.l.set(a,c=[]);c.push(b);this.o=za(this.o)+1;return this};h.remove=function(a){Se(this);a=this.R(a);return this.l.yb(a)?(this.O=null,this.o=za(this.o)-this.l.get(a).length,this.l.remove(a)):!1};h.yb=function(a){Se(this);a=this.R(a);return this.l.yb(a)};h.oa=function(){Se(this);for(var a=this.l.Z(),b=this.l.oa(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
	h.Z=function(a){Se(this);var b=[];if(m(a))this.yb(a)&&(b=Ma(b,this.l.get(this.R(a))));else{a=this.l.Z();for(var c=0;c<a.length;c++)b=Ma(b,a[c])}return b};h.set=function(a,b){Se(this);this.O=null;a=this.R(a);this.yb(a)&&(this.o=za(this.o)-this.l.get(a).length);this.l.set(a,[b]);this.o=za(this.o)+1;return this};h.get=function(a,b){a=a?this.Z(a):[];return 0<a.length?String(a[0]):b};var Te=function(a,b,c){a.remove(b);0<c.length&&(a.O=null,a.l.set(a.R(b),Na(c)),a.o=za(a.o)+c.length)};
	I.prototype.toString=function(){if(this.O)return this.O;if(!this.l)return"";for(var a=[],b=this.l.oa(),c=0;c<b.length;c++)for(var d=b[c],e=encodeURIComponent(String(d)),d=this.Z(d),f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}return this.O=a.join("&")};I.prototype.clone=function(){var a=new I;a.O=this.O;this.l&&(a.l=this.l.clone(),a.o=this.o);return a};I.prototype.R=function(a){a=String(a);this.S&&(a=a.toLowerCase());return a};
	I.prototype.td=function(a){a&&!this.S&&(Se(this),this.O=null,this.l.forEach(function(a,c){var b=c.toLowerCase();c!=b&&(this.remove(c),Te(this,b,a))},this));this.S=a};var Ve=function(){var a=K();return y&&!!ob&&11==ob||/Edge\/\d+/.test(a)},We=function(){return l.window&&l.window.location.href||""},Xe=function(a,b){b=b||l.window;var c="about:blank";a&&(c=rc(uc(a)));b.location.href=c},Ye=function(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):ea(a[d])?Wa(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<Ye(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c},$e=function(){var a;
	a=K();a="Chrome"!=Ze(a)?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!y||!ob||9<ob},af=function(a){a=(a||K()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1},bf=function(a){a=a||l.window;try{a.close()}catch(b){}},cf=function(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-
	b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=K().toLowerCase();d&&(b.target=d,u(c,"crios/")&&(b.target="_blank"));"Firefox"==Ze(K())&&(a=a||"http://localhost",b.scrollbars=!0);var g;c=a||"about:blank";(d=b)||(d={});a=window;b=c instanceof qc?c:uc("undefined"!=typeof c.href?c.href:String(c));c=d.target||c.target;e=[];for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;
	default:e.push(g+"="+(d[g]?1:0))}g=e.join(",");(x("iPhone")&&!x("iPod")&&!x("iPad")||x("iPad")||x("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),"undefined"!=typeof HTMLAnchorElement&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&(e=g&&(g instanceof HTMLAnchorElement||!(g instanceof Location||g instanceof Element)),f=ha(g)?g.constructor.displayName||g.constructor.name||Object.prototype.toString.call(g):void 0===g?"undefined":null===g?"null":
	typeof g,v(e,"Argument is not a HTMLAnchorElement (or a non-Element mock); got: %s",f)),b=b instanceof qc?b:uc(b),g.href=rc(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel","noreferrer"),d=document.createEvent("MouseEvent"),d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),d=rc(b),g&&(fb&&u(d,";")&&(d="'"+d.replace(/'/g,"%27")+"'"),g.opener=null,a=mc("b/12014412, meta tag with sanitized URL"),ua.test(d)&&(-1!=d.indexOf("&")&&(d=d.replace(oa,
	"&amp;")),-1!=d.indexOf("<")&&(d=d.replace(pa,"&lt;")),-1!=d.indexOf(">")&&(d=d.replace(qa,"&gt;")),-1!=d.indexOf('"')&&(d=d.replace(ra,"&quot;")),-1!=d.indexOf("'")&&(d=d.replace(sa,"&#39;")),-1!=d.indexOf("\x00")&&(d=d.replace(ta,"&#0;"))),d='<META HTTP-EQUIV="refresh" content="0; url='+d+'">',Aa(lc(a),"must provide justification"),v(!/^[\s\xa0]*$/.test(lc(a)),"must provide non-empty justification"),g.document.write(Yc((new Xc).$e(d))),g.document.close())):g=a.open(rc(b),c,g);if(g)try{g.focus()}catch(k){}return g},
	df=function(a){return new A(function(b){var c=function(){le(2E3).then(function(){if(!a||a.closed)b();else return c()})};return c()})},ef=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,ff=function(){var a=null;return(new A(function(b){"complete"==l.document.readyState?b():(a=function(){b()},bc(window,"load",a))})).f(function(b){dc(window,"load",a);throw b;})},hf=function(){return gf(void 0)?ff().then(function(){return new A(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},
	1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):D(Error("Cordova must run in an Android or iOS file scheme."))},gf=function(a){a=a||K();return!("file:"!==jf()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))},kf=function(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}},L=function(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":"Browser"},lf=function(){var a=L();return"ReactNative"===
	a||"Node"===a},Ze=function(a){var b=a.toLowerCase();if(u(b,"opera/")||u(b,"opr/")||u(b,"opios/"))return"Opera";if(u(b,"iemobile"))return"IEMobile";if(u(b,"msie")||u(b,"trident/"))return"IE";if(u(b,"edge/"))return"Edge";if(u(b,"firefox/"))return"Firefox";if(u(b,"silk/"))return"Silk";if(u(b,"blackberry"))return"Blackberry";if(u(b,"webos"))return"Webos";if(!u(b,"safari/")||u(b,"chrome/")||u(b,"crios/")||u(b,"android"))if(!u(b,"chrome/")&&!u(b,"crios/")||u(b,"edge/")){if(u(b,"android"))return"Android";
	if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&2==a.length)return a[1]}else return"Chrome";else return"Safari";return"Other"},mf=function(a){var b=L();return("Browser"===b?Ze(K()):b)+"/JsCore/"+a},K=function(){return l.navigator&&l.navigator.userAgent||""},M=function(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b},pf=function(){var a;if(a=(nf()||"chrome-extension:"===jf()||gf())&&!lf())a:{try{var b=l.localStorage,c=
	of();if(b){b.setItem(c,"1");b.removeItem(c);a=Ve()?!!l.indexedDB:!0;break a}}catch(d){}a=!1}return a},nf=function(){return"http:"===jf()||"https:"===jf()},jf=function(){return l.location&&l.location.protocol||null},qf=function(a){a=a||K();return af(a)||"Firefox"==Ze(a)?!1:!0},rf=function(a){return"undefined"===typeof a?null:xc(a)},sf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b},tf=function(a){if(null!==a)return JSON.parse(a)},of=function(a){return a?
	a:""+Math.floor(1E9*Math.random()).toString()},uf=function(a){a=a||K();return"Safari"==Ze(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0},vf=function(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null},wf=function(){return l.navigator&&"boolean"===typeof l.navigator.onLine?l.navigator.onLine:!0},xf=function(a,b,c,d){if(a>b)throw Error("Short delay should be less than long delay!");
	this.Ff=a;this.gf=b;a=c||K();d=d||L();this.cf=af(a)||"ReactNative"===d};xf.prototype.get=function(){return this.cf?this.gf:this.Ff};
	var yf=function(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0},zf=function(){var a=l.document,b=null;return yf()||!a?B():(new A(function(c){b=function(){yf()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).f(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})};var Af={},Bf=function(a){Af[a]||(Af[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Cf;try{var Df={};Object.defineProperty(Df,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Df,"abcd",{configurable:!0,enumerable:!0,value:2});Cf=2==Df.abcd}catch(a){Cf=!1}
	var N=function(a,b,c){Cf?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c},Ef=function(a,b){Cf?Object.defineProperty(a,"provider",{configurable:!0,enumerable:!0,get:function(){Bf("firebase.auth.AuthCredential.provider is deprecated. Please use the providerId field instead.");return b}}):a.provider=b},Ff=function(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&N(a,c,b[c])},Gf=function(a){var b={};Ff(b,a);return b},Hf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=
	a[c]);return b},If=function(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0},Jf=function(a){var b=a;if("object"==typeof a&&null!=a){var b="length"in a?[]:{},c;for(c in a)N(b,c,Jf(a[c]))}return b};var Kf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Lf=["client_id","response_type","scope","redirect_uri","state"],Mf={Pf:{Mb:500,Lb:600,providerId:"facebook.com",qd:Lf},Qf:{Mb:500,Lb:620,providerId:"github.com",qd:Lf},Rf:{Mb:515,Lb:680,providerId:"google.com",qd:Lf},Sf:{Mb:485,Lb:705,providerId:"twitter.com",qd:Kf}},Nf=function(a){for(var b in Mf)if(Mf[b].providerId==a)return Mf[b];return null};var O=function(a,b){this.code="auth/"+a;this.message=b||Of[a]||""};r(O,Error);O.prototype.C=function(){return{code:this.code,message:this.message}};O.prototype.toJSON=function(){return this.C()};
	var Pf=function(a){var b=a&&a.code;return b?new O(b.substring(5),a.message):null},Of={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"",
	"code-expired":"","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
	"email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.",
	"invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.",
	"invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
	"invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-identifier-number":"","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
	"invalid-verification-id":"","missing-iframe-start":"An internal error has occurred.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"","missing-verification-code":"","missing-identifier-number":"","missing-verification-id":"","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
	"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
	"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",timeout:"The operation has timed out.",
	"user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.",
	"user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};var P=function(a,b,c,d,e){this.da=a;this.J=b||null;this.tb=c||null;this.sd=d||null;this.P=e||null;if(this.tb||this.P){if(this.tb&&this.P)throw new O("invalid-auth-event");if(this.tb&&!this.sd)throw new O("invalid-auth-event");}else throw new O("invalid-auth-event");};P.prototype.ic=function(){return this.sd};P.prototype.getError=function(){return this.P};P.prototype.C=function(){return{type:this.da,eventId:this.J,urlResponse:this.tb,sessionId:this.sd,error:this.P&&this.P.C()}};
	var Qf=function(a){a=a||{};return a.type?new P(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&Pf(a.error)):null};var Rf=function(a){var b="unauthorized-domain",c=void 0,d=Pe(a);a=d.ea;d=d.ha;"chrome-extension"==d?c=ma("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=ma("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b=
	"operation-not-supported-in-this-environment";O.call(this,b,c)};r(Rf,O);var Sf=function(a){this.ff=a.sub;la();this.gc=a.email||null};var Tf=function(a,b){return a.then(function(a){if(a.idToken){var c;a:{var e=a.idToken.split(".");if(3==e.length){for(var e=e[1],f=(4-e.length%4)%4,g=0;g<f;g++)e+=".";try{var k=JSON.parse(tb(e));if(k.sub&&k.iss&&k.aud&&k.exp){c=new Sf(k);break a}}catch(n){}}c=null}if(!c||b!=c.ff)throw new O("user-mismatch");return a}throw new O("user-mismatch");}).f(function(a){throw a&&a.code&&"auth/user-not-found"==a.code?new O("user-mismatch"):a;})},Uf=function(a,b){if(b.idToken||b.accessToken)b.idToken&&N(this,
	"idToken",b.idToken),b.accessToken&&N(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)N(this,"accessToken",b.oauthToken),N(this,"secret",b.oauthTokenSecret);else throw new O("internal-error","failed to construct a credential");Ef(this,a);N(this,"providerId",a)};Uf.prototype.Ab=function(a){return Vf(a,Wf(this))};Uf.prototype.cd=function(a,b){var c=Wf(this);c.idToken=b;return Xf(a,c)};Uf.prototype.ed=function(a,b){var c=Wf(this);return Tf(Yf(a,c),b)};
	var Wf=function(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:Ue(b).toString(),requestUri:"http://localhost"}};Uf.prototype.C=function(){var a={providerId:this.providerId};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};
	var Zf=function(a,b){this.vf=b||[];Ff(this,{providerId:a,isOAuthProvider:!0});this.Id={}};Zf.prototype.setCustomParameters=function(a){this.Id=Xa(a);return this};var Q=function(a){Zf.call(this,a,Lf);this.rd=[]};r(Q,Zf);Q.prototype.addScope=function(a){Ia(this.rd,a)||this.rd.push(a);return this};Q.prototype.Rd=function(){return Na(this.rd)};
	Q.prototype.credential=function(a,b){if(!a&&!b)throw new O("argument-error","credential failed: must provide the ID token and/or the access token.");return new Uf(this.providerId,{idToken:a||null,accessToken:b||null})};var $f=function(){Q.call(this,"facebook.com")};r($f,Q);N($f,"PROVIDER_ID","facebook.com");
	var ag=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;ha(a)&&(b=a.accessToken);return(new $f).credential(null,b)},bg=function(){Q.call(this,"github.com")};r(bg,Q);N(bg,"PROVIDER_ID","github.com");
	var cg=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;ha(a)&&(b=a.accessToken);return(new bg).credential(null,b)},dg=function(){Q.call(this,"google.com");this.addScope("profile")};r(dg,Q);N(dg,"PROVIDER_ID","google.com");var eg=function(a,b){var c=a;ha(a)&&(c=a.idToken,b=a.accessToken);return(new dg).credential(c,b)},fg=function(){Zf.call(this,"twitter.com",Kf)};r(fg,Zf);N(fg,"PROVIDER_ID","twitter.com");
	var gg=function(a,b){var c=a;ha(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new O("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Uf("twitter.com",c)},hg=function(a,b){this.gc=a;this.jd=b;Ef(this,"password");N(this,"providerId","password")};hg.prototype.Ab=function(a){return R(a,ig,{email:this.gc,password:this.jd})};hg.prototype.cd=function(a,b){return R(a,jg,{idToken:b,email:this.gc,password:this.jd})};
	hg.prototype.ed=function(a,b){return Tf(this.Ab(a),b)};hg.prototype.C=function(){return{email:this.gc,password:this.jd}};var kg=function(){Ff(this,{providerId:"password",isOAuthProvider:!1})};Ff(kg,{PROVIDER_ID:"password"});var lg=function(a){if(!(a.Bd&&a.Ad||a.Yb&&a.ya))throw new O("internal-error");this.I=a;N(this,"providerId","identifier")};lg.prototype.Ab=function(a){return a.se(mg(this))};lg.prototype.cd=function(a,b){var c=mg(this);c.idToken=b;return R(a,ng,c)};
	lg.prototype.ed=function(a,b){var c=mg(this);c.operation="REAUTH";a=R(a,og,c);return Tf(a,b)};lg.prototype.C=function(){var a={providerId:"identifier"};this.I.Bd&&(a.verificationId=this.I.Bd);this.I.Ad&&(a.verificationCode=this.I.Ad);this.I.Yb&&(a.temporaryProof=this.I.Yb);this.I.ya&&(a.identifierNumber=this.I.ya);return a};
	var mg=function(a){return a.I.Yb&&a.I.ya?{temporaryProof:a.I.Yb,identifierNumber:a.I.ya}:{sessionInfo:a.I.Bd,code:a.I.Ad}},pg=function(a){try{this.Ce=a||firebase.auth()}catch(b){throw new O("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.identifierAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}Ff(this,{providerId:"identifier",isOAuthProvider:!1})};
	pg.prototype.se=function(a,b){var c=this.Ce.g;return B(b.verify()).then(function(d){if(!m(d))throw new O("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return R(c,qg,{identifierNumber:a,recaptchaToken:d});default:throw new O("argument-error",'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};Ff(pg,{PROVIDER_ID:"identifier"});
	var rg=function(a){if(a.temporaryProof&&a.identifierNumber)return new lg({Yb:a.temporaryProof,ya:a.identifierNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return eg(a,c);case "facebook.com":return ag(c);case "github.com":return cg(c);case "twitter.com":return gg(c,d);default:return(new Q(b)).credential(a,c)}}catch(e){return null}},sg=function(a){if(!a.isOAuthProvider)throw new O("invalid-oauth-provider");
	};var tg=function(a,b,c){O.call(this,a,c);a=b||{};a.email&&N(this,"email",a.email);a.ya&&N(this,"identifierNumber",a.ya);a.credential&&N(this,"credential",a.credential)};r(tg,O);tg.prototype.C=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.identifierNumber&&(a.identifierNumber=this.identifierNumber);var b=this.credential&&this.credential.C();b&&Za(a,b);return a};tg.prototype.toJSON=function(){return this.C()};
	var ug=function(a){if(a.code){var b=a.code||"";0==b.indexOf("auth/")&&(b=b.substring(5));var c={credential:rg(a)};if(a.email)c.email=a.email;else if(a.identifierNumber)c.ya=a.identifierNumber;else return new O(b,a.message||void 0);return new tg(b,c,a.message)}return null};var vg=function(a){this.Of=a};r(vg,Bc);vg.prototype.fc=function(){return new this.Of};vg.prototype.$c=function(){return{}};
	var S=function(a,b,c){var d;d="Node"==L();d=l.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new O("internal-error","The XMLHttpRequest compatibility library was not found.");this.j=a;a=b||{};this.Bf=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.Cf=a.secureTokenTimeout||wg;this.ge=Xa(a.secureTokenHeaders||xg);this.Le=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.Me=a.firebaseTimeout||
	yg;this.Pd=Xa(a.firebaseHeaders||zg);c&&(this.Pd["X-Client-Version"]=c,this.ge["X-Client-Version"]=c);this.Ee=new Gc;this.Nf=new vg(d)},Ag,wg=new xf(3E4,6E4),xg={"Content-Type":"application/x-www-form-urlencoded"},yg=new xf(3E4,6E4),zg={"Content-Type":"application/json"},Cg=function(a,b,c,d,e,f,g){wf()?($e()?a=q(a.Ef,a):(Ag||(Ag=new A(function(a,b){Bg(a,b)})),a=q(a.Df,a)),a(b,c,d,e,f,g)):c&&c(null)};
	S.prototype.Ef=function(a,b,c,d,e,f){var g="Node"==L(),k=lf()?g?new F(this.Nf):new F:new F(this.Ee),n;f&&(k.sb=Math.max(0,f),n=setTimeout(function(){k.dispatchEvent("timeout")},f));k.listen("complete",function(){n&&clearTimeout(n);var a=null;try{a=JSON.parse(Be(this))||null}catch(db){a=null}b&&b(a)});cc(k,"ready",function(){n&&clearTimeout(n);this.Ga||(this.Ga=!0,this.cb())});cc(k,"timeout",function(){n&&clearTimeout(n);this.Ga||(this.Ga=!0,this.cb());b&&b(null)});k.send(a,c,d,e)};
	var Ed="__fcb"+Math.floor(1E6*Math.random()).toString(),Bg=function(a,b){((window.gapi||{}).client||{}).request?a():(l[Ed]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))},Gd(function(){b(Error("CORS_UNSUPPORTED"))}))};
	S.prototype.Df=function(a,b,c,d,e){var f=this;Ag.then(function(){window.gapi.client.setApiKey(f.j);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).f(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
	var Eg=function(a,b){return new A(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Cg(a,a.Bf+"?key="+encodeURIComponent(a.j),function(a){a?a.error?d(Dg(a)):a.access_token&&a.refresh_token?c(a):d(new O("internal-error")):d(new O("network-request-failed"))},"POST",Ue(b).toString(),a.ge,a.Cf.get()):d(new O("internal-error"))})},Fg=function(a,b,c,d,e,f){var g=Pe(a.Le+b);J(g,"key",a.j);f&&J(g,"cb",la().toString());var k="GET"==c;if(k)for(var n in d)d.hasOwnProperty(n)&&
	J(g,n,d[n]);return new A(function(b,f){Cg(a,g.toString(),function(a){a?a.error?f(Dg(a,e||{})):b(a):f(new O("network-request-failed"))},c,k?void 0:xc(sf(d)),a.Pd,a.Me.get())})},Gg=function(a){if(!ic.test(a.email))throw new O("invalid-email");},Hg=function(a){"email"in a&&Gg(a)},Jg=function(a,b){return R(a,Ig,{identifier:b,continueUri:nf()?We():"http://localhost"}).then(function(a){return a.allProviders||[]})},Lg=function(a){return R(a,Kg,{}).then(function(a){return a.authorizedDomains||[]})},Mg=function(a){if(!a.idToken)throw new O("internal-error");
	},Ng=function(a){if(a.identifierNumber||a.temporaryProof){if(!a.identifierNumber||!a.temporaryProof)throw new O("internal-error");}else{if(!a.sessionInfo)throw new O("missing-verification-id");if(!a.code)throw new O("missing-verification-code");}};S.prototype.signInAnonymously=function(){return R(this,Og,{})};S.prototype.updateEmail=function(a,b){return R(this,Pg,{idToken:a,email:b})};S.prototype.updatePassword=function(a,b){return R(this,jg,{idToken:a,password:b})};var Qg={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};
	S.prototype.updateProfile=function(a,b){var c={idToken:a},d=[];Sa(Qg,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return R(this,Pg,c)};S.prototype.sendPasswordResetEmail=function(a){return R(this,Rg,{requestType:"PASSWORD_RESET",email:a})};S.prototype.sendEmailVerification=function(a){return R(this,Sg,{requestType:"VERIFY_EMAIL",idToken:a})};S.prototype.se=function(a){return R(this,Tg,a)};
	var Vg=function(a,b,c){return R(a,Ug,{idToken:b,deleteProvider:c})},Wg=function(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new O("internal-error");},Xg=function(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=ug(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=ug(a)):"EMAIL_EXISTS"==a.errorMessage&&(a.code="email-already-in-use",b=ug(a));if(b)throw b;if(!a.idToken)throw new O("internal-error");},Vf=function(a,
	b){b.returnIdpCredential=!0;return R(a,Yg,b)},Xf=function(a,b){b.returnIdpCredential=!0;return R(a,Zg,b)},Yf=function(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return R(a,$g,b)},ah=function(a){if(!a.oobCode)throw new O("invalid-action-code");};S.prototype.confirmPasswordReset=function(a,b){return R(this,bh,{oobCode:a,newPassword:b})};S.prototype.checkActionCode=function(a){return R(this,ch,{oobCode:a})};S.prototype.applyActionCode=function(a){return R(this,dh,{oobCode:a})};
	var dh={endpoint:"setAccountInfo",A:ah,Wa:"email"},ch={endpoint:"resetPassword",A:ah,Y:function(a){if(!a.email||!a.requestType)throw new O("internal-error");}},eh={endpoint:"signupNewUser",A:function(a){Gg(a);if(!a.password)throw new O("weak-password");},Y:Mg,sa:!0},Ig={endpoint:"createAuthUri"},fh={endpoint:"deleteAccount",Ua:["idToken"]},Ug={endpoint:"setAccountInfo",Ua:["idToken","deleteProvider"],A:function(a){if(!ea(a.deleteProvider))throw new O("internal-error");}},gh={endpoint:"getAccountInfo"},
	Sg={endpoint:"getOobConfirmationCode",Ua:["idToken","requestType"],A:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new O("internal-error");},Wa:"email"},Rg={endpoint:"getOobConfirmationCode",Ua:["requestType"],A:function(a){if("PASSWORD_RESET"!=a.requestType)throw new O("internal-error");Gg(a)},Wa:"email"},Kg={De:!0,endpoint:"getProjectConfig",We:"GET"},bh={endpoint:"resetPassword",A:ah,Wa:"email"},qg={endpoint:"sendVerificationCode",Ua:["identifierNumber","recaptchaToken"],Wa:"sessionInfo"},Pg={endpoint:"setAccountInfo",
	Ua:["idToken"],A:Hg,sa:!0},jg={endpoint:"setAccountInfo",Ua:["idToken"],A:function(a){Hg(a);if(!a.password)throw new O("weak-password");},Y:Mg,sa:!0},Og={endpoint:"signupNewUser",Y:Mg,sa:!0},Yg={endpoint:"verifyAssertion",A:Wg,Y:Xg,sa:!0},$g={endpoint:"verifyAssertion",A:Wg,Y:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new O("user-not-found");if(!a.idToken)throw new O("internal-error");},sa:!0},Zg={endpoint:"verifyAssertion",A:function(a){Wg(a);if(!a.idToken)throw new O("internal-error");
	},Y:Xg,sa:!0},hh={endpoint:"verifyCustomToken",A:function(a){if(!a.token)throw new O("invalid-custom-token");},Y:Mg,sa:!0},ig={endpoint:"verifyPassword",A:function(a){Gg(a);if(!a.password)throw new O("wrong-password");},Y:Mg,sa:!0},Tg={endpoint:"verifyidentifierNumber",A:Ng,Y:Mg},ng={endpoint:"verifyidentifierNumber",A:function(a){if(!a.idToken)throw new O("internal-error");Ng(a)},Y:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",ug(a);Mg(a)}},og={Ge:{USER_NOT_FOUND:"user-not-found"},
	endpoint:"verifyidentifierNumber",A:Ng,Y:Mg},R=function(a,b,c){if(!If(c,b.Ua))return D(new O("internal-error"));var d=b.We||"POST",e;return B(c).then(b.A).then(function(){b.sa&&(c.returnSecureToken=!0);return Fg(a,b.endpoint,d,c,b.Ge,b.De||!1)}).then(function(a){return e=a}).then(b.Y).then(function(){if(!b.Wa)return e;if(!(b.Wa in e))throw new O("internal-error");return e[b.Wa]})},Dg=function(a,b){var c;c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};
	if(c=d[c]?new O(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",
	FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",
	CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_identifier_NUMBER:"invalid-identifier-number",INVALID_SESSION_INFO:"invalid-verification-id",
	INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_identifier_NUMBER:"missing-identifier-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired"};Za(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new O(d[e],b);!b&&a&&(b=rf(a));return new O("internal-error",b)};var ih=function(a){this.V=a};ih.prototype.value=function(){return this.V};ih.prototype.je=function(a){this.V.style=a;return this};var jh=function(a){this.V=a||{}};jh.prototype.value=function(){return this.V};jh.prototype.je=function(a){this.V.style=a;return this};var lh=function(a){this.Lf=a;this.nc=null;this.gd=kh(this)},mh=function(a){var b=new jh;b.V.where=document.body;b.V.url=a.Lf;b.V.messageHandlersFilter=M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER");b.V.attributes=b.V.attributes||{};(new ih(b.V.attributes)).je({position:"absolute",top:"-100px",width:"1px",height:"1px"});b.V.dontclear=!0;return b},kh=function(a){return nh().then(function(){return new A(function(b,c){M("gapi.iframes.getContext")().open(mh(a).value(),function(d){a.nc=d;a.nc.restyle({setHideOnLeave:!1});
	var e=setTimeout(function(){c(Error("Network Error"))},oh.get()),f=function(){clearTimeout(e);b()};d.ping(f).then(f,function(){c(Error("Network Error"))})})})})};lh.prototype.sendMessage=function(a){var b=this;return this.gd.then(function(){return new A(function(c){b.nc.send(a.type,a,c,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})};
	var ph=function(a,b){a.gd.then(function(){a.nc.register("authEvent",b,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})},qh=new xf(3E4,6E4),oh=new xf(5E3,15E3),nh=function(){return new A(function(a,b){if(wf()){var c=function(){vf();M("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){vf();b(Error("Network Error"))},timeout:qh.get()})};if(M("gapi.iframes.Iframe"))a();else if(M("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){M("gapi.load")?
	c():b(Error("Network Error"))};B(Dd("https://apis.google.com/js/api.js?onload="+d)).f(function(){b(Error("Network Error"))})}}else b(Error("Network Error"))})};var rh=function(a,b,c){this.v=a;this.j=b;this.D=c;this.Ya=null;this.ac=Qe(this.v,"/__/auth/iframe");J(this.ac,"apiKey",this.j);J(this.ac,"appName",this.D)};rh.prototype.setVersion=function(a){this.Ya=a;return this};rh.prototype.toString=function(){this.Ya?J(this.ac,"v",this.Ya):this.ac.removeParameter("v");return this.ac.toString()};var sh=function(a,b,c,d,e){this.v=a;this.j=b;this.D=c;this.Be=d;this.Ya=this.J=this.pd=null;this.Pb=e};sh.prototype.setVersion=function(a){this.Ya=a;return this};
	sh.prototype.toString=function(){var a=Qe(this.v,"/__/auth/handler");J(a,"apiKey",this.j);J(a,"appName",this.D);J(a,"authType",this.Be);if(this.Pb.isOAuthProvider){J(a,"providerId",this.Pb.providerId);var b=this.Pb,c=sf(b.Id),d;for(d in c)c[d]=c[d].toString();b=b.vf;c=Xa(c);for(d=0;d<b.length;d++){var e=b[d];e in c&&delete c[e]}Va(c)||J(a,"customParameters",rf(c))}"function"===typeof this.Pb.Rd&&(b=this.Pb.Rd(),b.length&&J(a,"scopes",b.join(",")));this.pd?J(a,"redirectUrl",this.pd):a.removeParameter("redirectUrl");
	this.J?J(a,"eventId",this.J):a.removeParameter("eventId");this.Ya?J(a,"v",this.Ya):a.removeParameter("v");if(this.bc)for(var f in this.bc)this.bc.hasOwnProperty(f)&&!Oe(a,f)&&J(a,f,this.bc[f]);return a.toString()};
	var th=function(a,b,c,d){this.v=a;this.j=b;this.D=c;this.Oe=(this.Ea=d||null)?mf(this.Ea):null;d=this.Ea;this.Xe=(new rh(a,b,c)).setVersion(d).toString();this.ma=[];this.g=new S(b,null,this.Oe);this.pc=this.wa=null},uh=function(a){var b=We();return Lg(a).then(function(a){a:{for(var c=Pe(b),e=c.ha,c=c.ea,f=0;f<a.length;f++){var g;var k=a[f];g=c;var n=e;0==k.indexOf("chrome-extension://")?g=Pe(k).ea==g&&"chrome-extension"==n:"http"!=n&&"https"!=n?g=!1:ef.test(k)?g=g==k:(k=k.split(".").join("\\."),g=
	(new RegExp("^(.+\\."+k+"|"+k+")$","i")).test(g));if(g){a=!0;break a}}a=!1}if(!a)throw new Rf(We());})};h=th.prototype;h.Gb=function(){if(this.pc)return this.pc;var a=this;return this.pc=ff().then(function(){a.mc=new lh(a.Xe);vh(a)})};h.Vb=function(a,b,c){var d=new O("popup-closed-by-user"),e=new O("web-storage-unsupported"),f=this,g=!1;return this.La().then(function(){wh(f).then(function(c){c||(a&&bf(a),b(e),g=!0)})}).f(function(){}).then(function(){if(!g)return df(a)}).then(function(){if(!g)return le(c).then(function(){b(d)})})};
	h.ke=function(){var a=K();return!qf(a)&&!uf(a)};h.Ud=function(){return!1};h.Nb=function(a,b,c,d,e,f,g){if(!a)return D(new O("popup-blocked"));if(g&&!qf())return this.La().f(function(b){bf(a);e(b)}),d(),B();this.wa||(this.wa=uh(this.g));var k=this;return this.wa.then(function(){var b=k.La().f(function(b){bf(a);e(b);throw b;});d();return b}).then(function(){sg(c);if(!g){var d=xh(k.v,k.j,k.D,b,c,null,f,k.Ea);Xe(d,a)}}).f(function(a){"auth/network-request-failed"==a.code&&(k.wa=null);throw a;})};
	h.Ob=function(a,b,c){this.wa||(this.wa=uh(this.g));var d=this;return this.wa.then(function(){sg(b);var e=xh(d.v,d.j,d.D,a,b,We(),c,d.Ea);Xe(e)})};h.La=function(){var a=this;return this.Gb().then(function(){return a.mc.gd}).f(function(){a.wa=null;throw new O("network-request-failed");})};h.ne=function(){return!0};
	var xh=function(a,b,c,d,e,f,g,k,n){a=new sh(a,b,c,d,e);a.pd=f;a.J=g;f=a.setVersion(k);f.bc=Xa(n||null);return f.toString()},vh=function(a){if(!a.mc)throw Error("IfcHandler must be initialized!");ph(a.mc,function(b){var c={};if(b&&b.authEvent){var d=!1;b=Qf(b.authEvent);for(c=0;c<a.ma.length;c++)d=a.ma[c](b)||d;c={};c.status=d?"ACK":"ERROR";return B(c)}c.status="ERROR";return B(c)})},wh=function(a){var b={type:"webStorageSupport"};return a.Gb().then(function(){return a.mc.sendMessage(b)}).then(function(a){if(a&&
	a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})};th.prototype.$a=function(a){this.ma.push(a)};th.prototype.Tb=function(a){La(this.ma,function(b){return b==a})};var yh=function(a){this.B=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.B)throw new O("internal-error","The React Native compatibility library was not found.");};h=yh.prototype;h.get=function(a){return B(this.B.getItem(a)).then(function(a){return a&&tf(a)})};h.set=function(a,b){return B(this.B.setItem(a,rf(b)))};h.remove=function(a){return B(this.B.removeItem(a))};h.ab=function(){};h.Ta=function(){};var zh=function(){this.B={}};h=zh.prototype;h.get=function(a){return B(this.B[a])};h.set=function(a,b){this.B[a]=b;return B()};h.remove=function(a){delete this.B[a];return B()};h.ab=function(){};h.Ta=function(){};var Ch=function(){if(!Bh()){if("Node"==L())throw new O("internal-error","The LocalStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.B=l.localStorage||firebase.INTERNAL.node.localStorage},Bh=function(){var a="Node"==L(),a=l.localStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=Ch.prototype;
	h.get=function(a){var b=this;return B().then(function(){var c=b.B.getItem(a);return tf(c)})};h.set=function(a,b){var c=this;return B().then(function(){var d=rf(b);null===d?c.remove(a):c.B.setItem(a,d)})};h.remove=function(a){var b=this;return B().then(function(){b.B.removeItem(a)})};h.ab=function(a){l.window&&Vb(l.window,"storage",a)};h.Ta=function(a){l.window&&dc(l.window,"storage",a)};var Dh=function(){this.B={}};h=Dh.prototype;h.get=function(){return B(null)};h.set=function(){return B()};h.remove=function(){return B()};h.ab=function(){};h.Ta=function(){};var Fh=function(){if(!Eh()){if("Node"==L())throw new O("internal-error","The SessionStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.B=l.sessionStorage||firebase.INTERNAL.node.sessionStorage},Eh=function(){var a="Node"==L(),a=l.sessionStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=Fh.prototype;
	h.get=function(a){var b=this;return B().then(function(){var c=b.B.getItem(a);return tf(c)})};h.set=function(a,b){var c=this;return B().then(function(){var d=rf(b);null===d?c.remove(a):c.B.setItem(a,d)})};h.remove=function(a){var b=this;return B().then(function(){b.B.removeItem(a)})};h.ab=function(){};h.Ta=function(){};var Gh=function(a,b,c,d,e,f){if(!window.indexedDB)throw new O("web-storage-unsupported");this.He=a;this.fd=b;this.Qc=c;this.re=d;this.wb=e;this.$={};this.Wb=[];this.Jb=0;this.Ye=f||l.indexedDB},Hh,Ih=function(a){return new A(function(b,c){var d=a.Ye.open(a.He,a.wb);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.fd,{keyPath:a.Qc})}catch(f){c(f)}};d.onsuccess=function(a){b(a.target.result)}})},Jh=function(a){a.Xd||(a.Xd=
	Ih(a));return a.Xd},Kh=function(a,b){return b.objectStore(a.fd)},Lh=function(a,b,c){return b.transaction([a.fd],c?"readwrite":"readonly")},Mh=function(a){return new A(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})};h=Gh.prototype;
	h.set=function(a,b){var c=!1,d,e=this;return md(Jh(this).then(function(b){d=b;b=Kh(e,Lh(e,d,!0));return Mh(b.get(a))}).then(function(f){var g=Kh(e,Lh(e,d,!0));if(f)return f.value=b,Mh(g.put(f));e.Jb++;c=!0;f={};f[e.Qc]=a;f[e.re]=b;return Mh(g.add(f))}).then(function(){e.$[a]=b}),function(){c&&e.Jb--})};h.get=function(a){var b=this;return Jh(this).then(function(c){return Mh(Kh(b,Lh(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
	h.remove=function(a){var b=!1,c=this;return md(Jh(this).then(function(d){b=!0;c.Jb++;return Mh(Kh(c,Lh(c,d,!0))["delete"](a))}).then(function(){delete c.$[a]}),function(){b&&c.Jb--})};
	h.Hf=function(){var a=this;return Jh(this).then(function(b){var c=Kh(a,Lh(a,b,!1));return c.getAll?Mh(c.getAll()):new A(function(a,b){var d=[],e=c.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.Jb){for(d=0;d<b.length;d++)c[b[d][a.Qc]]=b[d][a.re];d=Ye(a.$,c);a.$=c}return d})};h.ab=function(a){0==this.Wb.length&&this.vd();this.Wb.push(a)};
	h.Ta=function(a){La(this.Wb,function(b){return b==a});0==this.Wb.length&&this.Bc()};h.vd=function(){var a=this;this.Bc();var b=function(){a.kd=le(800).then(q(a.Hf,a)).then(function(b){0<b.length&&w(a.Wb,function(a){a(b)})}).then(b).f(function(a){"STOP_EVENT"!=a.message&&b()});return a.kd};b()};h.Bc=function(){this.kd&&this.kd.cancel("STOP_EVENT")};var Qh=function(){this.Ld={Browser:Nh,Node:Oh,ReactNative:Ph}[L()]},Rh,Nh={M:Ch,yd:Fh},Oh={M:Ch,yd:Fh},Ph={M:yh,yd:Dh};var Sh=function(a){var b={},c=a.email,d=a.newEmail;a=a.requestType;if(!c||!a)throw Error("Invalid provider user info!");b.fromEmail=d||null;b.email=c;N(this,"operation",a);N(this,"data",Jf(b))};var Th=function(a,b,c,d,e,f){this.pf=a;this.xf=b;this.Qe=c;this.rc=d;this.zd=e;this.yf=!!f;this.kb=null;this.Ma=this.rc;if(this.zd<this.rc)throw Error("Proactive refresh lower bound greater than upper bound!");};Th.prototype.start=function(){this.Ma=this.rc;Uh(this,!0)};
	var Vh=function(a,b){if(b)return a.Ma=a.rc,a.Qe();b=a.Ma;a.Ma*=2;a.Ma>a.zd&&(a.Ma=a.zd);return b},Uh=function(a,b){a.stop();a.kb=le(Vh(a,b)).then(function(){return a.yf?B():zf()}).then(function(){return a.pf()}).then(function(){Uh(a,!0)}).f(function(b){a.xf(b)&&Uh(a,!1)})};Th.prototype.stop=function(){this.kb&&(this.kb.cancel(),this.kb=null)};var ai=function(a){var b={};b["facebook.com"]=Wh;b["google.com"]=Xh;b["github.com"]=Yh;b["twitter.com"]=Zh;var c=a&&a.providerId;return c?b[c]?new b[c](a):new $h(a):null},$h=function(a){var b=tf(a.rawUserInfo||"{}");a=a.providerId;if(!a)throw Error("Invalid additional user info!");N(this,"profile",Jf(b||{}));N(this,"providerId",a)},Wh=function(a){$h.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider id!");};r(Wh,$h);
	var Yh=function(a){$h.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",this.profile&&this.profile.login||null)};r(Yh,$h);var Xh=function(a){$h.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider id!");};r(Xh,$h);var Zh=function(a){$h.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",a.screenName||null)};r(Zh,$h);var bi=function(a,b,c,d){this.kf=a;this.he=b;this.zf=c;this.Ub=d;this.T={};Rh||(Rh=new Qh);a=Rh;try{var e;Ve()?(Hh||(Hh=new Gh("firebaseLocalStorageDb","firebaseLocalStorage","fbase_key","value",1)),e=Hh):e=new a.Ld.M;this.Qa=e}catch(f){this.Qa=new zh,this.Ub=!0}try{this.Dc=new a.Ld.yd}catch(f){this.Dc=new zh}this.wd=q(this.le,this);this.$={}},ci,di=function(){ci||(ci=new bi("firebase",":",!uf(K())&&kf()?!0:!1,qf()));return ci};h=bi.prototype;
	h.R=function(a,b){return this.kf+this.he+a.name+(b?this.he+b:"")};h.get=function(a,b){return(a.M?this.Qa:this.Dc).get(this.R(a,b))};h.remove=function(a,b){b=this.R(a,b);a.M&&!this.Ub&&(this.$[b]=null);return(a.M?this.Qa:this.Dc).remove(b)};h.set=function(a,b,c){var d=this.R(a,c),e=this,f=a.M?this.Qa:this.Dc;return f.set(d,b).then(function(){return f.get(d)}).then(function(b){a.M&&!this.Ub&&(e.$[d]=b)})};
	h.addListener=function(a,b,c){a=this.R(a,b);this.Ub||(this.$[a]=l.localStorage.getItem(a));Va(this.T)&&this.vd();this.T[a]||(this.T[a]=[]);this.T[a].push(c)};h.removeListener=function(a,b,c){a=this.R(a,b);this.T[a]&&(La(this.T[a],function(a){return a==c}),0==this.T[a].length&&delete this.T[a]);Va(this.T)&&this.Bc()};h.vd=function(){this.Qa.ab(this.wd);this.Ub||Ve()||ei(this)};
	var ei=function(a){fi(a);a.dd=setInterval(function(){for(var b in a.T){var c=l.localStorage.getItem(b),d=a.$[b];c!=d&&(a.$[b]=c,c=new Jb({type:"storage",key:b,target:window,oldValue:d,newValue:c,rf:!0}),a.le(c))}},1E3)},fi=function(a){a.dd&&(clearInterval(a.dd),a.dd=null)};bi.prototype.Bc=function(){this.Qa.Ta(this.wd);fi(this)};
	bi.prototype.le=function(a){if(a&&a.Pe){var b=a.eb.key;"undefined"!==typeof a.eb.rf?this.Qa.Ta(this.wd):fi(this);if(this.zf){var c=l.localStorage.getItem(b);a=a.eb.newValue;a!=c&&(a?l.localStorage.setItem(b,a):a||l.localStorage.removeItem(b))}this.$[b]=l.localStorage.getItem(b);this.Ed(b)}else w(a,q(this.Ed,this))};bi.prototype.Ed=function(a){this.T[a]&&w(this.T[a],function(a){a()})};var gi=function(a,b){this.u=a;this.i=b||di()},hi={name:"authEvent",M:!0},ii=function(a){return a.i.get(hi,a.u).then(function(a){return Qf(a)})};gi.prototype.$a=function(a){this.i.addListener(hi,this.u,a)};gi.prototype.Tb=function(a){this.i.removeListener(hi,this.u,a)};var ji=function(a){this.i=a||di()},ki={name:"sessionId",M:!1};ji.prototype.ic=function(a){return this.i.get(ki,a)};var li=function(a,b,c,d,e,f){this.v=a;this.j=b;this.D=c;this.Ea=d||null;this.me=b+":"+c;this.Af=new ji;this.Qd=new gi(this.me);this.Zc=null;this.ma=[];this.bf=e||500;this.tf=f||2E3;this.Fb=this.uc=null},mi=function(a){return new O("invalid-cordova-configuration",a)};
	li.prototype.La=function(){return this.ad?this.ad:this.ad=hf().then(function(){if("function"!==typeof M("universalLinks.subscribe",l))throw mi("cordova-universal-links-plugin is not installed");if("undefined"===typeof M("BuildInfo.packageName",l))throw mi("cordova-plugin-buildinfo is not installed");if("function"!==typeof M("cordova.plugins.browsertab.openUrl",l))throw mi("cordova-plugin-browsertab is not installed");if("function"!==typeof M("cordova.InAppBrowser.open",l))throw mi("cordova-plugin-inappbrowser is not installed");
	},function(){throw new O("cordova-not-ready");})};var ni=function(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")},oi=function(a){var b=new Eb;b.update(a);return Oa(b.digest())};h=li.prototype;h.Vb=function(a,b){b(new O("operation-not-supported-in-this-environment"));return B()};h.Nb=function(){return D(new O("operation-not-supported-in-this-environment"))};h.ne=function(){return!1};h.ke=function(){return!0};
	h.Ud=function(){return!0};
	h.Ob=function(a,b,c){if(this.uc)return D(new O("redirect-operation-pending"));var d=this,e=l.document,f=null,g=null,k=null,n=null;return this.uc=md(B().then(function(){sg(b);return pi(d)}).then(function(){return qi(d,a,b,c)}).then(function(){return(new A(function(a,b){g=function(){var b=M("cordova.plugins.browsertab.close",l);a();"function"===typeof b&&b();d.Fb&&"function"===typeof d.Fb.close&&(d.Fb.close(),d.Fb=null);return!1};d.$a(g);k=function(){f||(f=le(d.tf).then(function(){b(new O("redirect-cancelled-by-user"))}))};n=
	function(){yf()&&k()};e.addEventListener("resume",k,!1);K().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).f(function(a){return ri(d).then(function(){throw a;})})}),function(){k&&e.removeEventListener("resume",k,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.Tb(g);d.uc=null})};
	var qi=function(a,b,c,d){var e=ni(),f=new P(b,d,null,e,new O("no-auth-event")),g=M("BuildInfo.packageName",l);if("string"!==typeof g)throw new O("invalid-cordova-configuration");var k=M("BuildInfo.displayName",l),n={};if(K().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(K().toLowerCase().match(/android/))n.apn=g;else return D(new O("operation-not-supported-in-this-environment"));k&&(n.appDisplayName=k);e=oi(e);n.sessionId=e;var C=xh(a.v,a.j,a.D,b,c,null,d,a.Ea,n);return a.La().then(function(){var b=
	a.me;return a.Af.i.set(hi,f.C(),b)}).then(function(){var b=M("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof b)throw new O("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=M("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof c)throw new O("invalid-cordova-configuration");c(C)}else{c=M("cordova.InAppBrowser.open",l);if("function"!==typeof c)throw new O("invalid-cordova-configuration");b=c;var d;d=K();d=!(!d.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!d.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
	a.Fb=b(C,d?"_blank":"_system","location=yes")}})})},si=function(a,b){for(var c=0;c<a.ma.length;c++)try{a.ma[c](b)}catch(d){}},pi=function(a){a.Zc||(a.Zc=a.La().then(function(){return new A(function(b){var c=function(d){b(d);a.Tb(c);return!1};a.$a(c);ti(a)})}));return a.Zc},ri=function(a){var b=null;return ii(a.Qd).then(function(c){b=c;c=a.Qd;return c.i.remove(hi,c.u)}).then(function(){return b})},ti=function(a){var b=M("universalLinks.subscribe",l);if("function"!==typeof b)throw new O("invalid-cordova-configuration");
	var c=new P("unknown",null,null,null,new O("no-auth-event")),d=!1,e=le(a.bf).then(function(){return ri(a).then(function(){d||si(a,c)})}),f=function(b){d=!0;e&&e.cancel();ri(a).then(function(d){var e=c;if(d&&b&&b.url){var e=null,f;f=b.url;var g=Pe(f),k=Oe(g,"link"),n=Oe(Pe(k),"link"),g=Oe(g,"deep_link_id");f=Oe(Pe(g),"link")||g||n||k||f;-1!=f.indexOf("/__/auth/callback")&&(e=Pe(f),e=tf(Oe(e,"firebaseError")||null),e=(e="object"===typeof e?Pf(e):null)?new P(d.da,d.J,null,null,e):new P(d.da,d.J,f,d.ic()));
	e=e||c}si(a,e)})},g=l.handleOpenURL;l.handleOpenURL=function(a){0==a.indexOf(M("BuildInfo.packageName",l)+"://")&&f({url:a});if("function"===typeof g)try{g(a)}catch(n){console.error(n)}};b(null,f)};li.prototype.$a=function(a){this.ma.push(a);pi(this).f(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new P("unknown",null,null,null,new O("no-auth-event")),a(b))})};li.prototype.Tb=function(a){La(this.ma,function(b){return b==a})};var ui=function(a){this.u=a;this.i=di()},vi={name:"pendingRedirect",M:!1},wi=function(a){return a.i.set(vi,"pending",a.u)},xi=function(a){return a.i.remove(vi,a.u)},yi=function(a){return a.i.get(vi,a.u).then(function(a){return"pending"==a})};var T=function(a,b,c){this.v=a;this.j=b;this.D=c;this.Xb=[];this.ib=!1;this.Mc=q(this.Wc,this);this.Ra=new zi(this);this.ld=new Ai(this);this.Kb=new ui(this.j+":"+this.D);this.Aa={};this.Aa.unknown=this.Ra;this.Aa.signInViaRedirect=this.Ra;this.Aa.linkViaRedirect=this.Ra;this.Aa.reauthViaRedirect=this.Ra;this.Aa.signInViaPopup=this.ld;this.Aa.linkViaPopup=this.ld;this.Aa.reauthViaPopup=this.ld;this.K=Bi(this.v,this.j,this.D)},Bi=function(a,b,c){var d=firebase.SDK_VERSION||null;return gf()?new li(a,
	b,c,d):new th(a,b,c,d)};T.prototype.reset=function(){this.ib=!1;this.K.Tb(this.Mc);this.K=Bi(this.v,this.j,this.D)};T.prototype.Gb=function(){var a=this;this.ib||(this.ib=!0,this.K.$a(this.Mc));var b=this.K;return this.K.La().f(function(c){a.K==b&&a.reset();throw c;})};var Ei=function(a){a.K.ke()&&a.Gb().f(function(b){var c=new P("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));Ci(b)&&a.Wc(c)});a.K.Ud()||Di(a.Ra)};
	T.prototype.subscribe=function(a){Ia(this.Xb,a)||this.Xb.push(a);if(!this.ib){var b=this;yi(this.Kb).then(function(a){a?xi(b.Kb).then(function(){b.Gb().f(function(a){var c=new P("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));Ci(a)&&b.Wc(c)})}):Ei(b)}).f(function(){Ei(b)})}};T.prototype.unsubscribe=function(a){La(this.Xb,function(b){return b==a})};
	T.prototype.Wc=function(a){if(!a)throw new O("invalid-auth-event");for(var b=!1,c=0;c<this.Xb.length;c++){var d=this.Xb[c];if(d.Fd(a.da,a.J)){(b=this.Aa[a.da])&&b.ce(a,d);b=!0;break}}Di(this.Ra);return b};var Fi=new xf(2E3,1E4),Gi=new xf(3E4,6E4);T.prototype.getRedirectResult=function(){return this.Ra.getRedirectResult()};T.prototype.Nb=function(a,b,c,d,e){var f=this;return this.K.Nb(a,b,c,function(){f.ib||(f.ib=!0,f.K.$a(f.Mc))},function(){f.reset()},d,e)};
	var Ci=function(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1};T.prototype.Ob=function(a,b,c){var d=this,e;return wi(this.Kb).then(function(){return d.K.Ob(a,b,c).f(function(a){if(Ci(a))throw new O("operation-not-supported-in-this-environment");e=a;return xi(d.Kb).then(function(){throw e;})}).then(function(){return d.K.ne()?new A(function(){}):xi(d.Kb).then(function(){return d.getRedirectResult()}).then(function(){}).f(function(){})})})};
	T.prototype.Vb=function(a,b,c,d){return this.K.Vb(c,function(c){a.Va(b,null,c,d)},Fi.get())};var Hi={},Ii=function(a,b,c){var d=b+":"+c;Hi[d]||(Hi[d]=new T(a,b,c));return Hi[d]},zi=function(a){this.i=a;this.qb=null;this.Rb=[];this.Qb=[];this.ob=null;this.od=!1};zi.prototype.reset=function(){this.qb=null;this.ob&&(this.ob.cancel(),this.ob=null)};
	zi.prototype.ce=function(a,b){if(!a)return D(new O("invalid-auth-event"));this.reset();this.od=!0;var c=a.da,d=a.J,e=a.getError()&&"auth/web-storage-unsupported"==a.getError().code,f=a.getError()&&"auth/operation-not-supported-in-this-environment"==a.getError().code;"unknown"!=c||e||f?a=a.P?this.md(a,b):b.zb(c,d)?this.nd(a,b):D(new O("invalid-auth-event")):(Ji(this,!1,null,null),a=B());return a};var Di=function(a){a.od||(a.od=!0,Ji(a,!1,null,null))};
	zi.prototype.md=function(a){Ji(this,!0,null,a.getError());return B()};zi.prototype.nd=function(a,b){var c=this;b=b.zb(a.da,a.J);var d=a.tb,e=a.ic(),f=!!a.da.match(/Redirect$/);return b(d,e).then(function(a){Ji(c,f,a,null)}).f(function(a){Ji(c,f,null,a)})};
	var Ki=function(a,b){a.qb=function(){return D(b)};if(a.Qb.length)for(var c=0;c<a.Qb.length;c++)a.Qb[c](b)},Li=function(a,b){a.qb=function(){return B(b)};if(a.Rb.length)for(var c=0;c<a.Rb.length;c++)a.Rb[c](b)},Ji=function(a,b,c,d){b?d?Ki(a,d):Li(a,c):Li(a,{user:null});a.Rb=[];a.Qb=[]};zi.prototype.getRedirectResult=function(){var a=this;return new A(function(b,c){a.qb?a.qb().then(b,c):(a.Rb.push(b),a.Qb.push(c),Mi(a))})};
	var Mi=function(a){var b=new O("timeout");a.ob&&a.ob.cancel();a.ob=le(Gi.get()).then(function(){a.qb||Ji(a,!0,null,b)})},Ai=function(a){this.i=a};Ai.prototype.ce=function(a,b){if(!a)return D(new O("invalid-auth-event"));var c=a.da,d=a.J;return a.P?this.md(a,b):b.zb(c,d)?this.nd(a,b):D(new O("invalid-auth-event"))};Ai.prototype.md=function(a,b){b.Va(a.da,null,a.getError(),a.J);return B()};
	Ai.prototype.nd=function(a,b){var c=a.J,d=a.da,e=b.zb(d,c),f=a.tb;a=a.ic();return e(f,a).then(function(a){b.Va(d,a,null,c)}).f(function(a){b.Va(d,null,a,c)})};var Ni=function(a){this.g=a;this.Ba=this.X=null;this.Ha=0};Ni.prototype.C=function(){return{apiKey:this.g.j,refreshToken:this.X,accessToken:this.Ba,expirationTime:this.Ha}};
	var Pi=function(a,b){var c=b.idToken,d=b.refreshToken;b=Oi(b.expiresIn);a.Ba=c;a.Ha=b;a.X=d},Oi=function(a){return la()+1E3*parseInt(a,10)},Qi=function(a,b){return Eg(a.g,b).then(function(b){a.Ba=b.access_token;a.Ha=Oi(b.expires_in);a.X=b.refresh_token;return{accessToken:a.Ba,expirationTime:a.Ha,refreshToken:a.X}}).f(function(b){"auth/user-token-expired"==b.code&&(a.X=null);throw b;})};
	Ni.prototype.getToken=function(a){a=!!a;return this.Ba&&!this.X?D(new O("user-token-expired")):a||!this.Ba||la()>this.Ha-3E4?this.X?Qi(this,{grant_type:"refresh_token",refresh_token:this.X}):B(null):B({accessToken:this.Ba,expirationTime:this.Ha,refreshToken:this.X})};var Ri=function(a,b,c,d,e){Ff(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,providerId:b})},Si=function(a,b){Ib.call(this,a);for(var c in b)this[c]=b[c]};r(Si,Ib);
	var U=function(a,b,c){this.ba=[];this.j=a.apiKey;this.D=a.appName;this.v=a.authDomain||null;a=firebase.SDK_VERSION?mf(firebase.SDK_VERSION):null;this.g=new S(this.j,null,a);this.ia=new Ni(this.g);Ti(this,b.idToken);Pi(this.ia,b);N(this,"refreshToken",this.ia.X);Ui(this,c||{});he.call(this);this.vc=!1;this.v&&pf()&&(this.m=Ii(this.v,this.j,this.D));this.Ac=[];this.ka=null;this.mb=Vi(this);this.vb=q(this.Xc,this)};r(U,he);U.prototype.Xc=function(){this.mb.kb&&(this.mb.stop(),this.mb.start())};
	var Vi=function(a){return new Th(function(){return a.getToken(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.ia.Ha-la()-3E5;return 0<b?b:0},3E4,96E4,!1)},Wi=function(a){a.Kd||a.mb.kb||(a.mb.start(),dc(a,"tokenChanged",a.vb),Vb(a,"tokenChanged",a.vb))},Xi=function(a){dc(a,"tokenChanged",a.vb);a.mb.stop()},Ti=function(a,b){a.Yd=b;N(a,"_lat",b)},Yi=function(a,b){La(a.Ac,function(a){return a==b})},Zi=function(a){for(var b=[],c=0;c<a.Ac.length;c++)b.push(a.Ac[c](a));
	return jd(b).then(function(){return a})},$i=function(a){a.m&&!a.vc&&(a.vc=!0,a.m.subscribe(a))},Ui=function(a,b){Ff(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,identifierNumber:b.identifierNumber||null,isAnonymous:b.isAnonymous||!1,providerData:[]})};N(U.prototype,"providerId","firebase");
	var aj=function(){},bj=function(a){return B().then(function(){if(a.Kd)throw new O("app-deleted");})},cj=function(a){return Ea(a.providerData,function(a){return a.providerId})},ej=function(a,b){b&&(dj(a,b.providerId),a.providerData.push(b))},dj=function(a,b){La(a.providerData,function(a){return a.providerId==b})},fj=function(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&N(a,b,c)};
	U.prototype.copy=function(a){var b=this;b!=a&&(Ff(this,{uid:a.uid,displayName:a.displayName,photoURL:a.photoURL,email:a.email,emailVerified:a.emailVerified,identifierNumber:a.identifierNumber,isAnonymous:a.isAnonymous,providerData:[]}),w(a.providerData,function(a){ej(b,a)}),this.ia=a.ia,N(this,"refreshToken",this.ia.X))};U.prototype.reload=function(){var a=this;return this.c(bj(this).then(function(){return gj(a).then(function(){return Zi(a)}).then(aj)}))};
	var gj=function(a){return a.getToken().then(function(b){var c=a.isAnonymous;return hj(a,b).then(function(){c||fj(a,"isAnonymous",!1);return b})})};U.prototype.getToken=function(a){var b=this;return this.c(bj(this).then(function(){return b.ia.getToken(a)}).then(function(a){if(!a)throw new O("internal-error");a.accessToken!=b.Yd&&(Ti(b,a.accessToken),b.Na());fj(b,"refreshToken",a.refreshToken);return a.accessToken}))};
	var ij=function(a,b){b.idToken&&a.Yd!=b.idToken&&(Pi(a.ia,b),a.Na(),Ti(a,b.idToken),fj(a,"refreshToken",a.ia.X))};U.prototype.Na=function(){this.dispatchEvent(new Si("tokenChanged"))};var hj=function(a,b){return R(a.g,gh,{idToken:b}).then(q(a.qf,a))};
	U.prototype.qf=function(a){a=a.users;if(!a||!a.length)throw new O("internal-error");a=a[0];Ui(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,identifierNumber:a.identifierNumber});for(var b=jj(a),c=0;c<b.length;c++)ej(this,b[c]);fj(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
	var jj=function(a){return(a=a.providerUserInfo)&&a.length?Ea(a,function(a){return new Ri(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl)}):[]},lj=function(a,b){var c=null;return a.c(b.ed(a.g,a.uid).then(function(b){ij(a,b);c=kj(a,b,"reauthenticate");a.ka=null;return a.reload()}).then(function(){return c}),!0)};U.prototype.reauthenticate=function(a){Bf("firebase.User.prototype.reauthenticate is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.reauthenticateWithCredential(a)};
	U.prototype.reauthenticateWithCredential=function(a){return lj(this,a).then(function(){})};var mj=function(a,b){return gj(a).then(function(){if(Ia(cj(a),b))return Zi(a).then(function(){throw new O("provider-already-linked");})})},oj=function(a,b){var c=null;return a.c(mj(a,b.providerId).then(function(){return a.getToken()}).then(function(c){return b.cd(a.g,c)}).then(function(b){c=kj(a,b,"link");return nj(a,b)}).then(function(){return c}))};
	U.prototype.link=function(a){Bf("firebase.User.prototype.link is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.linkWithCredential(a)};U.prototype.linkWithCredential=function(a){return oj(this,a).then(function(a){return a.user})};var kj=function(a,b,c){var d=rg(b);b=ai(b);return Gf({user:a,credential:d,additionalUserInfo:b,operationType:c})},nj=function(a,b){ij(a,b);return a.reload().then(function(){return a})};h=U.prototype;
	h.updateEmail=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.g.updateEmail(c,a)}).then(function(a){ij(b,a);return b.reload()}))};h.updatePassword=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.g.updatePassword(c,a)}).then(function(a){ij(b,a);return b.reload()}))};
	h.updateProfile=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return bj(this);var b=this;return this.c(this.getToken().then(function(c){return b.g.updateProfile(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){ij(b,a);fj(b,"displayName",a.displayName||null);fj(b,"photoURL",a.photoUrl||null);return Zi(b)}).then(aj))};
	h.unlink=function(a){var b=this;return this.c(gj(this).then(function(c){return Ia(cj(b),a)?Vg(b.g,c,[a]).then(function(a){var c={};w(a.providerUserInfo||[],function(a){c[a.providerId]=!0});w(cj(b),function(a){c[a]||dj(b,a)});return Zi(b)}):Zi(b).then(function(){throw new O("no-such-provider");})}))};
	h["delete"]=function(){var a=this;return this.c(this.getToken().then(function(b){return R(a.g,fh,{idToken:b})}).then(function(){a.dispatchEvent(new Si("userDeleted"))})).then(function(){for(var b=0;b<a.ba.length;b++)a.ba[b].cancel("app-deleted");a.ba=[];a.Kd=!0;Xi(a);N(a,"refreshToken",null);a.m&&a.m.unsubscribe(a)})};
	h.Fd=function(a,b){return"linkViaPopup"==a&&(this.ca||null)==b&&this.aa||"reauthViaPopup"==a&&(this.ca||null)==b&&this.aa||"linkViaRedirect"==a&&(this.za||null)==b||"reauthViaRedirect"==a&&(this.za||null)==b?!0:!1};h.Va=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.ca||null)||(c&&this.Pa?this.Pa(c):b&&!c&&this.aa&&this.aa(b),this.F&&(this.F.cancel(),this.F=null),delete this.aa,delete this.Pa)};
	h.zb=function(a,b){return"linkViaPopup"==a&&b==(this.ca||null)?q(this.Nd,this):"reauthViaPopup"==a&&b==(this.ca||null)?q(this.Od,this):"linkViaRedirect"==a&&(this.za||null)==b?q(this.Nd,this):"reauthViaRedirect"==a&&(this.za||null)==b?q(this.Od,this):null};h.hc=function(){return of(this.uid+":::")};var qj=function(a,b){return pj(a,"linkViaPopup",b,function(){return mj(a,b.providerId).then(function(){return Zi(a)})},!1)};
	U.prototype.linkWithPopup=function(a){return qj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};var rj=function(a,b){return pj(a,"reauthViaPopup",b,function(){return B()},!0)};U.prototype.reauthenticateWithPopup=function(a){return rj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};
	var pj=function(a,b,c,d,e){if(!pf())return D(new O("operation-not-supported-in-this-environment"));if(a.ka&&!e)return D(a.ka);var f=Nf(c.providerId),g=a.hc(),k=null;(!qf()||kf())&&a.v&&c.isOAuthProvider&&(k=xh(a.v,a.j,a.D,b,c,null,g,firebase.SDK_VERSION||null));var n=cf(k,f&&f.Mb,f&&f.Lb);d=d().then(function(){sj(a);if(!e)return a.getToken().then(function(){})}).then(function(){return a.m.Nb(n,b,c,g,!!k)}).then(function(){return new A(function(c,d){a.Va(b,null,new O("cancelled-popup-request"),a.ca||
	null);a.aa=c;a.Pa=d;a.ca=g;a.F=a.m.Vb(a,b,n,g)})}).then(function(a){n&&bf(n);return a}).f(function(a){n&&bf(n);throw a;});return a.c(d,e)};U.prototype.linkWithRedirect=function(a){var b=this;return tj(this,"linkViaRedirect",a,function(){return mj(b,a.providerId)},!1)};U.prototype.reauthenticateWithRedirect=function(a){return tj(this,"reauthViaRedirect",a,function(){return B()},!0)};
	var tj=function(a,b,c,d,e){if(!pf())return D(new O("operation-not-supported-in-this-environment"));if(a.ka&&!e)return D(a.ka);var f=null,g=a.hc();d=d().then(function(){sj(a);if(!e)return a.getToken().then(function(){})}).then(function(){a.za=g;return Zi(a)}).then(function(b){a.Sa&&(b=a.Sa,b=b.i.set(uj,a.C(),b.u));return b}).then(function(){return a.m.Ob(b,c,g)}).f(function(b){f=b;if(a.Sa)return vj(a.Sa);throw f;}).then(function(){if(f)throw f;});return a.c(d,e)},sj=function(a){if(!a.m||!a.vc){if(a.m&&
	!a.vc)throw new O("internal-error");throw new O("auth-domain-config-required");}};U.prototype.Nd=function(a,b){var c=this;this.F&&(this.F.cancel(),this.F=null);var d=null,e=this.getToken().then(function(d){return Xf(c.g,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=kj(c,a,"link");return nj(c,a)}).then(function(){return d});return this.c(e)};
	U.prototype.Od=function(a,b){var c=this;this.F&&(this.F.cancel(),this.F=null);var d=null,e=B().then(function(){return Tf(Yf(c.g,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=kj(c,a,"reauthenticate");ij(c,a);c.ka=null;return c.reload()}).then(function(){return d});return this.c(e,!0)};U.prototype.sendEmailVerification=function(){var a=this;return this.c(this.getToken().then(function(b){return a.g.sendEmailVerification(b)}).then(function(b){if(a.email!=b)return a.reload()}).then(function(){}))};
	U.prototype.c=function(a,b){var c=this,d=wj(this,a,b);this.ba.push(d);md(d,function(){Ka(c.ba,d)});return d};var wj=function(a,b,c){return a.ka&&!c?(b.cancel(),D(a.ka)):b.f(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.ka||a.dispatchEvent(new Si("userInvalidated")),a.ka=b);throw b;})};U.prototype.toJSON=function(){return this.C()};
	U.prototype.C=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,identifierNumber:this.identifierNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.j,appName:this.D,authDomain:this.v,stsTokenManager:this.ia.C(),redirectEventId:this.za||null};w(this.providerData,function(b){a.providerData.push(Hf(b))});return a};
	var xj=function(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c.idToken=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-la())/1E3;else return null;var d=new U(b,c,a);a.providerData&&w(a.providerData,function(a){a&&ej(d,Gf(a))});a.redirectEventId&&(d.za=a.redirectEventId);return d},
	yj=function(a,b,c){var d=new U(a,b);c&&(d.Sa=c);return d.reload().then(function(){return d})};var zj=function(a){this.u=a;this.i=di()},uj={name:"redirectUser",M:!1},vj=function(a){return a.i.remove(uj,a.u)},Aj=function(a,b){return a.i.get(uj,a.u).then(function(a){a&&b&&(a.authDomain=b);return xj(a||{})})};var Bj=function(a){this.u=a;this.i=di()},Cj={name:"authUser",M:!0},Dj=function(a,b){return a.i.set(Cj,b.C(),a.u)},Ej=function(a){return a.i.remove(Cj,a.u)},Fj=function(a,b){return a.i.get(Cj,a.u).then(function(a){a&&b&&(a.authDomain=b);return xj(a||{})})};var W=function(a){this.Fa=!1;N(this,"app",a);if(V(this).options&&V(this).options.apiKey)a=firebase.SDK_VERSION?mf(firebase.SDK_VERSION):null,this.g=new S(V(this).options&&V(this).options.apiKey,null,a);else throw new O("invalid-api-key");this.ba=[];this.Ca=[];this.ub=[];this.mf=firebase.INTERNAL.createSubscribe(q(this.Ze,this));this.Ic=void 0;firebase.INTERNAL.createSubscribe(q(this.af,this));Gj(this,null);this.ta=new Bj(V(this).options.apiKey+":"+V(this).name);this.pb=new zj(V(this).options.apiKey+
	":"+V(this).name);this.cc=this.c(Hj(this));this.qa=this.c(Ij(this));this.bd=!1;this.Vc=q(this.Gf,this);this.qe=q(this.gb,this);this.vb=q(this.Xc,this);this.oe=q(this.Ue,this);this.pe=q(this.Ve,this);Jj(this);this.INTERNAL={};this.INTERNAL["delete"]=q(this["delete"],this);this.Ia=0};W.prototype.toJSON=function(){return{apiKey:V(this).options.apiKey,authDomain:V(this).options.authDomain,appName:V(this).name,currentUser:X(this)&&X(this).C()}};
	var Kj=function(a){return a.Ie||D(new O("auth-domain-config-required"))},Jj=function(a){var b=V(a).options.authDomain,c=V(a).options.apiKey;b&&pf()&&(a.Ie=a.cc.then(function(){if(!a.Fa)return a.m=Ii(b,c,V(a).name),a.m.subscribe(a),X(a)&&$i(X(a)),a.Sb&&($i(a.Sb),a.Sb=null),a.m}))};h=W.prototype;h.Fd=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.ca==b&&!!this.aa;default:return!1}};
	h.Va=function(a,b,c,d){"signInViaPopup"==a&&this.ca==d&&(c&&this.Pa?this.Pa(c):b&&!c&&this.aa&&this.aa(b),this.F&&(this.F.cancel(),this.F=null),delete this.aa,delete this.Pa)};h.zb=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.ca==b&&this.aa?q(this.Ke,this):null};
	h.Ke=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.F&&(this.F.cancel(),this.F=null);var d=null,e=null,f=Vf(c.g,a).then(function(a){d=rg(a);e=ai(a);return a});a=c.cc.then(function(){return f}).then(function(a){return Lj(c,a)}).then(function(){return Gf({user:X(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return this.c(a)};h.hc=function(){return of()};
	var Mj=function(a,b){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var c=Nf(b.providerId),d=a.hc(),e=null;(!qf()||kf())&&V(a).options.authDomain&&b.isOAuthProvider&&(e=xh(V(a).options.authDomain,V(a).options.apiKey,V(a).name,"signInViaPopup",b,null,d,firebase.SDK_VERSION||null));var f=cf(e,c&&c.Mb,c&&c.Lb),c=Kj(a).then(function(a){return a.Nb(f,"signInViaPopup",b,d,!!e)}).then(function(){return new A(function(b,c){a.Va("signInViaPopup",null,new O("cancelled-popup-request"),
	a.ca);a.aa=b;a.Pa=c;a.ca=d;a.F=a.m.Vb(a,"signInViaPopup",f,d)})}).then(function(a){f&&bf(f);return a}).f(function(a){f&&bf(f);throw a;});return a.c(c)};W.prototype.signInWithPopup=function(a){return Mj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};W.prototype.getRedirectResult=function(){return Nj(this).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};
	W.prototype.signInWithRedirect=function(a){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var b=this,c=Kj(this).then(function(){return b.m.Ob("signInViaRedirect",a)});return this.c(c)};
	var Nj=function(a){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var b=Kj(a).then(function(){return a.m.getRedirectResult()});return a.c(b)},Lj=function(a,b){var c={};c.apiKey=V(a).options.apiKey;c.authDomain=V(a).options.authDomain;c.appName=V(a).name;return a.cc.then(function(){return yj(c,b,a.pb)}).then(function(b){if(X(a)&&b.uid==X(a).uid)return X(a).copy(b),a.gb(b);Gj(a,b);$i(b);return a.gb(b)}).then(function(){a.Na()})},Gj=function(a,b){X(a)&&(Yi(X(a),a.qe),dc(X(a),
	"tokenChanged",a.vb),dc(X(a),"userDeleted",a.oe),dc(X(a),"userInvalidated",a.pe),Xi(X(a)));b&&(b.Ac.push(a.qe),Vb(b,"tokenChanged",a.vb),Vb(b,"userDeleted",a.oe),Vb(b,"userInvalidated",a.pe),0<a.Ia&&Wi(b));N(a,"currentUser",b)};W.prototype.signOut=function(){var a=this,b=this.qa.then(function(){if(!X(a))return B();Gj(a,null);return Ej(a.ta).then(function(){a.Na()})});return this.c(b)};
	var Oj=function(a){var b=Aj(a.pb,V(a).options.authDomain).then(function(b){if(a.Sb=b)b.Sa=a.pb;return vj(a.pb)});return a.c(b)},Hj=function(a){var b=V(a).options.authDomain,c=Oj(a).then(function(){return Fj(a.ta,b)}).then(function(b){return b?(b.Sa=a.pb,a.Sb&&(a.Sb.za||null)==(b.za||null)?b:b.reload().then(function(){return Dj(a.ta,b).then(function(){return b})}).f(function(c){return"auth/network-request-failed"==c.code?b:Ej(a.ta)})):null}).then(function(b){Gj(a,b||null)});return a.c(c)},Ij=function(a){return a.cc.then(function(){return a.getRedirectResult()}).f(function(){}).then(function(){if(!a.Fa)return a.Vc()}).f(function(){}).then(function(){if(!a.Fa){a.bd=
	!0;var b=a.ta;b.i.addListener(Cj,b.u,a.Vc)}})};h=W.prototype;h.Gf=function(){var a=this;return Fj(this.ta,V(this).options.authDomain).then(function(b){if(!a.Fa){var c;if(c=X(a)&&b){c=X(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return X(a).copy(b),X(a).getToken();if(X(a)||b)Gj(a,b),b&&($i(b),b.Sa=a.pb),a.m&&a.m.subscribe(a),a.Na()}})};h.gb=function(a){return Dj(this.ta,a)};h.Xc=function(){this.Na();this.gb(X(this))};h.Ue=function(){this.signOut()};
	h.Ve=function(){this.signOut()};var Pj=function(a,b){var c=null,d=null;return a.c(b.then(function(b){c=rg(b);d=ai(b);return Lj(a,b)}).then(function(){return Gf({user:X(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))};h=W.prototype;h.Ze=function(a){var b=this;this.addAuthTokenListener(function(){a.next(X(b))})};h.af=function(a){var b=this;Qj(this,function(){a.next(X(b))})};
	h.onAuthStateChanged=function(a,b,c){var d=this;this.bd&&firebase.Promise.resolve().then(function(){p(a)?a(X(d)):p(a.next)&&a.next(X(d))});return this.mf(a,b,c)};h.getToken=function(a){var b=this,c=this.qa.then(function(){return X(b)?X(b).getToken(a).then(function(a){return{accessToken:a}}):null});return this.c(c)};h.signInWithCustomToken=function(a){var b=this;return this.qa.then(function(){return Pj(b,R(b.g,hh,{token:a}))}).then(function(a){a=a.user;fj(a,"isAnonymous",!1);return b.gb(a)}).then(function(){return X(b)})};
	h.signInWithEmailAndPassword=function(a,b){var c=this;return this.qa.then(function(){return Pj(c,R(c.g,ig,{email:a,password:b}))}).then(function(a){return a.user})};h.createUserWithEmailAndPassword=function(a,b){var c=this;return this.qa.then(function(){return Pj(c,R(c.g,eh,{email:a,password:b}))}).then(function(a){return a.user})};h.signInWithCredential=function(a){return Rj(this,a).then(function(a){return a.user})};var Rj=function(a,b){return a.qa.then(function(){return Pj(a,b.Ab(a.g))})};
	W.prototype.signInAnonymously=function(){var a=X(this),b=this;return a&&a.isAnonymous?B(a):this.qa.then(function(){return Pj(b,b.g.signInAnonymously())}).then(function(a){a=a.user;fj(a,"isAnonymous",!0);return b.gb(a)}).then(function(){return X(b)})};var V=function(a){return a.app},X=function(a){return a.currentUser};W.prototype.getUid=function(){return X(this)&&X(this).uid||null};var Sj=function(a){return X(a)&&X(a)._lat||null};h=W.prototype;
	h.Na=function(){if(this.bd){for(var a=0;a<this.Ca.length;a++)if(this.Ca[a])this.Ca[a](Sj(this));if(this.Ic!==this.getUid()&&this.ub.length)for(this.Ic=this.getUid(),a=0;a<this.ub.length;a++)if(this.ub[a])this.ub[a](Sj(this))}};h.Ae=function(a){this.addAuthTokenListener(a);this.Ia++;0<this.Ia&&X(this)&&Wi(X(this))};h.uf=function(a){var b=this;w(this.Ca,function(c){c==a&&b.Ia--});0>this.Ia&&(this.Ia=0);0==this.Ia&&X(this)&&Xi(X(this));this.removeAuthTokenListener(a)};
	h.addAuthTokenListener=function(a){var b=this;this.Ca.push(a);this.c(this.qa.then(function(){b.Fa||Ia(b.Ca,a)&&a(Sj(b))}))};h.removeAuthTokenListener=function(a){La(this.Ca,function(b){return b==a})};var Qj=function(a,b){a.ub.push(b);a.c(a.qa.then(function(){!a.Fa&&Ia(a.ub,b)&&a.Ic!==a.getUid()&&(a.Ic=a.getUid(),b(Sj(a)))}))};h=W.prototype;
	h["delete"]=function(){this.Fa=!0;for(var a=0;a<this.ba.length;a++)this.ba[a].cancel("app-deleted");this.ba=[];this.ta&&(a=this.ta,a.i.removeListener(Cj,a.u,this.Vc));this.m&&this.m.unsubscribe(this);return firebase.Promise.resolve()};h.c=function(a){var b=this;this.ba.push(a);md(a,function(){Ka(b.ba,a)});return a};h.fetchProvidersForEmail=function(a){return this.c(Jg(this.g,a))};h.verifyPasswordResetCode=function(a){return this.checkActionCode(a).then(function(a){return a.data.email})};
	h.confirmPasswordReset=function(a,b){return this.c(this.g.confirmPasswordReset(a,b).then(function(){}))};h.checkActionCode=function(a){return this.c(this.g.checkActionCode(a).then(function(a){return new Sh(a)}))};h.applyActionCode=function(a){return this.c(this.g.applyActionCode(a).then(function(){}))};h.sendPasswordResetEmail=function(a){return this.c(this.g.sendPasswordResetEmail(a).then(function(){}))};var Tj="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" "),Y=function(a,b){return{name:a||"",ja:"a valid string",optional:!!b,la:m}},Z=function(a){return{name:a||"",ja:"a valid object",optional:!1,la:ha}},Uj=function(a,b){return{name:a||"",ja:"a function",optional:!!b,la:p}},Vj=function(){return{name:"",ja:"null",optional:!1,la:da}},Wj=function(){return{name:"credential",ja:"a valid credential",optional:!1,la:function(a){return a?!!a.Ab:!1}}},Xj=function(){return{name:"authProvider",
	ja:"a valid Auth provider",optional:!1,la:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}},Yj=function(a,b,c,d){return{name:c||"",ja:a.ja+" or "+b.ja,optional:!!d,la:function(c){return a.la(c)||b.la(c)}}};var ak=function(a,b){for(var c in b){var d=b[c].name;a[d]=Zj(d,a[c],b[c].a)}},bk=function(a,b,c,d){a[b]=Zj(b,c,d)},Zj=function(a,b,c){if(!c)return b;var d=ck(a);a=function(){var a=Array.prototype.slice.call(arguments),e;a:{e=Array.prototype.slice.call(a);var k;k=0;for(var n=!1,C=0;C<c.length;C++)if(c[C].optional)n=!0;else{if(n)throw new O("internal-error","Argument validator encountered a required argument after an optional argument.");k++}n=c.length;if(e.length<k||n<e.length)e="Expected "+(k==n?
	1==k?"1 argument":k+" arguments":k+"-"+n+" arguments")+" but got "+e.length+".";else{for(k=0;k<e.length;k++)if(n=c[k].optional&&void 0===e[k],!c[k].la(e[k])&&!n){e=c[k];if(0>k||k>=Tj.length)throw new O("internal-error","Argument validator received an unsupported number of arguments.");e=Tj[k]+" argument "+(e.name?'"'+e.name+'" ':"")+"must be "+e.ja+".";break a}e=null}}if(e)throw new O("argument-error",d+" failed: "+e);return b.apply(this,a)};for(var e in b)a[e]=b[e];for(e in b.prototype)a.prototype[e]=
	b.prototype[e];return a},ck=function(a){a=a.split(".");return a[a.length-1]};ak(W.prototype,{applyActionCode:{name:"applyActionCode",a:[Y("code")]},checkActionCode:{name:"checkActionCode",a:[Y("code")]},confirmPasswordReset:{name:"confirmPasswordReset",a:[Y("code"),Y("newPassword")]},createUserWithEmailAndPassword:{name:"createUserWithEmailAndPassword",a:[Y("email"),Y("password")]},fetchProvidersForEmail:{name:"fetchProvidersForEmail",a:[Y("email")]},getRedirectResult:{name:"getRedirectResult",a:[]},onAuthStateChanged:{name:"onAuthStateChanged",a:[Yj(Z(),Uj(),"nextOrObserver"),
	Uj("opt_error",!0),Uj("opt_completed",!0)]},sendPasswordResetEmail:{name:"sendPasswordResetEmail",a:[Y("email")]},signInAnonymously:{name:"signInAnonymously",a:[]},signInWithCredential:{name:"signInWithCredential",a:[Wj()]},signInWithCustomToken:{name:"signInWithCustomToken",a:[Y("token")]},signInWithEmailAndPassword:{name:"signInWithEmailAndPassword",a:[Y("email"),Y("password")]},signInWithPopup:{name:"signInWithPopup",a:[Xj()]},signInWithRedirect:{name:"signInWithRedirect",a:[Xj()]},signOut:{name:"signOut",
	a:[]},toJSON:{name:"toJSON",a:[Y(null,!0)]},verifyPasswordResetCode:{name:"verifyPasswordResetCode",a:[Y("code")]}});
	ak(U.prototype,{"delete":{name:"delete",a:[]},getToken:{name:"getToken",a:[{name:"opt_forceRefresh",ja:"a boolean",optional:!0,la:function(a){return"boolean"==typeof a}}]},link:{name:"link",a:[Wj()]},linkWithCredential:{name:"linkWithCredential",a:[Wj()]},linkWithPopup:{name:"linkWithPopup",a:[Xj()]},linkWithRedirect:{name:"linkWithRedirect",a:[Xj()]},reauthenticate:{name:"reauthenticate",a:[Wj()]},reauthenticateWithCredential:{name:"reauthenticateWithCredential",a:[Wj()]},reauthenticateWithPopup:{name:"reauthenticateWithPopup",
	a:[Xj()]},reauthenticateWithRedirect:{name:"reauthenticateWithRedirect",a:[Xj()]},reload:{name:"reload",a:[]},sendEmailVerification:{name:"sendEmailVerification",a:[]},toJSON:{name:"toJSON",a:[Y(null,!0)]},unlink:{name:"unlink",a:[Y("provider")]},updateEmail:{name:"updateEmail",a:[Y("email")]},updatePassword:{name:"updatePassword",a:[Y("password")]},updateProfile:{name:"updateProfile",a:[Z("profile")]}});ak(A.prototype,{f:{name:"catch"},then:{name:"then"}});
	bk(kg,"credential",function(a,b){return new hg(a,b)},[Y("email"),Y("password")]);ak($f.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk($f,"credential",ag,[Yj(Y(),Z(),"token")]);ak(bg.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(bg,"credential",cg,[Yj(Y(),Z(),"token")]);
	ak(dg.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(dg,"credential",eg,[Yj(Y(),Yj(Z(),Vj()),"idToken"),Yj(Y(),Vj(),"accessToken",!0)]);ak(fg.prototype,{setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(fg,"credential",gg,[Yj(Y(),Z(),"token"),Y("secret",!0)]);ak(O.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});ak(tg.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});
	ak(Rf.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:W,Error:O};bk(a,"EmailAuthProvider",kg,[]);bk(a,"FacebookAuthProvider",$f,[]);bk(a,"GithubAuthProvider",bg,[]);bk(a,"GoogleAuthProvider",dg,[]);bk(a,"TwitterAuthProvider",fg,[]);firebase.INTERNAL.registerService("auth",function(a,c){a=new W(a);c({INTERNAL:{getUid:q(a.getUid,a),getToken:q(a.getToken,a),addAuthTokenListener:q(a.Ae,a),removeAuthTokenListener:q(a.uf,a)}});return a},a,function(a,
	c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:U})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).call(this);
	}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
	module.exports = firebase.auth;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
	Build: rev-cc77c9e
	Terms: https://firebase.google.com/terms/
	
	---
	
	typedarray.js
	Copyright (c) 2010, Linden Research, Inc.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var firebase = __webpack_require__(407);
	(function(){
	(function() {var g,aa=this;function n(a){return void 0!==a}function ba(){}function ca(a){a.Vb=function(){return a.Ye?a.Ye:a.Ye=new a}}
	function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return"array"==da(a)}function fa(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function p(a){return"string"==typeof a}function ga(a){return"number"==typeof a}function ha(a){return"function"==da(a)}function ia(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}function ja(a,b,c){return a.call.apply(a.bind,arguments)}
	function ka(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function q(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ja:ka;return q.apply(null,arguments)}
	function la(a,b){function c(){}c.prototype=b.prototype;a.wg=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.sg=function(a,c,f){for(var h=Array(arguments.length-2),k=2;k<arguments.length;k++)h[k-2]=arguments[k];return b.prototype[c].apply(a,h)}};function ma(a){a=String(a);if(/^\s*$/.test(a)?0:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,"")))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function na(){this.Fd=void 0}
	function oa(a,b,c){switch(typeof b){case "string":pa(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?b:"null");break;case "boolean":c.push(b);break;case "undefined":c.push("null");break;case "object":if(null==b){c.push("null");break}if(ea(b)){var d=b.length;c.push("[");for(var e="",f=0;f<d;f++)c.push(e),e=b[f],oa(a,a.Fd?a.Fd.call(b,String(f),e):e,c),e=",";c.push("]");break}c.push("{");d="";for(f in b)Object.prototype.hasOwnProperty.call(b,f)&&(e=b[f],"function"!=typeof e&&(c.push(d),pa(f,c),
	c.push(":"),oa(a,a.Fd?a.Fd.call(b,f,e):e,c),d=","));c.push("}");break;case "function":break;default:throw Error("Unknown type: "+typeof b);}}var qa={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},ra=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
	function pa(a,b){b.push('"',a.replace(ra,function(a){if(a in qa)return qa[a];var b=a.charCodeAt(0),e="\\u";16>b?e+="000":256>b?e+="00":4096>b&&(e+="0");return qa[a]=e+b.toString(16)}),'"')};function sa(){this.Wa=-1};function ta(){this.Wa=-1;this.Wa=64;this.M=[];this.Wd=[];this.Af=[];this.zd=[];this.zd[0]=128;for(var a=1;a<this.Wa;++a)this.zd[a]=0;this.Pd=this.$b=0;this.reset()}la(ta,sa);ta.prototype.reset=function(){this.M[0]=1732584193;this.M[1]=4023233417;this.M[2]=2562383102;this.M[3]=271733878;this.M[4]=3285377520;this.Pd=this.$b=0};
	function ua(a,b,c){c||(c=0);var d=a.Af;if(p(b))for(var e=0;16>e;e++)d[e]=b.charCodeAt(c)<<24|b.charCodeAt(c+1)<<16|b.charCodeAt(c+2)<<8|b.charCodeAt(c+3),c+=4;else for(e=0;16>e;e++)d[e]=b[c]<<24|b[c+1]<<16|b[c+2]<<8|b[c+3],c+=4;for(e=16;80>e;e++){var f=d[e-3]^d[e-8]^d[e-14]^d[e-16];d[e]=(f<<1|f>>>31)&4294967295}b=a.M[0];c=a.M[1];for(var h=a.M[2],k=a.M[3],m=a.M[4],l,e=0;80>e;e++)40>e?20>e?(f=k^c&(h^k),l=1518500249):(f=c^h^k,l=1859775393):60>e?(f=c&h|k&(c|h),l=2400959708):(f=c^h^k,l=3395469782),f=(b<<
	5|b>>>27)+f+m+l+d[e]&4294967295,m=k,k=h,h=(c<<30|c>>>2)&4294967295,c=b,b=f;a.M[0]=a.M[0]+b&4294967295;a.M[1]=a.M[1]+c&4294967295;a.M[2]=a.M[2]+h&4294967295;a.M[3]=a.M[3]+k&4294967295;a.M[4]=a.M[4]+m&4294967295}
	ta.prototype.update=function(a,b){if(null!=a){n(b)||(b=a.length);for(var c=b-this.Wa,d=0,e=this.Wd,f=this.$b;d<b;){if(0==f)for(;d<=c;)ua(this,a,d),d+=this.Wa;if(p(a))for(;d<b;){if(e[f]=a.charCodeAt(d),++f,++d,f==this.Wa){ua(this,e);f=0;break}}else for(;d<b;)if(e[f]=a[d],++f,++d,f==this.Wa){ua(this,e);f=0;break}}this.$b=f;this.Pd+=b}};var r;a:{var va=aa.navigator;if(va){var wa=va.userAgent;if(wa){r=wa;break a}}r=""};var t=Array.prototype,xa=t.indexOf?function(a,b,c){return t.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(p(a))return p(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ya=t.forEach?function(a,b,c){t.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},za=t.filter?function(a,b,c){return t.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,h=p(a)?
	a.split(""):a,k=0;k<d;k++)if(k in h){var m=h[k];b.call(c,m,k,a)&&(e[f++]=m)}return e},Aa=t.map?function(a,b,c){return t.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=p(a)?a.split(""):a,h=0;h<d;h++)h in f&&(e[h]=b.call(c,f[h],h,a));return e},Ba=t.reduce?function(a,b,c,d){for(var e=[],f=1,h=arguments.length;f<h;f++)e.push(arguments[f]);d&&(e[0]=q(b,d));return t.reduce.apply(a,e)}:function(a,b,c,d){var e=c;ya(a,function(c,h){e=b.call(d,e,c,h,a)});return e},Ca=t.every?function(a,b,
	c){return t.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};function Da(a,b){var c=Ea(a,b,void 0);return 0>c?null:p(a)?a.charAt(c):a[c]}function Ea(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}function Fa(a,b){var c=xa(a,b);0<=c&&t.splice.call(a,c,1)}function Ga(a,b,c){return 2>=arguments.length?t.slice.call(a,b):t.slice.call(a,b,c)}
	function Ha(a,b){a.sort(b||Ia)}function Ia(a,b){return a>b?1:a<b?-1:0};function v(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Ja(a,b){var c={},d;for(d in a)c[d]=b.call(void 0,a[d],d,a);return c}function Ka(a,b){for(var c in a)if(!b.call(void 0,a[c],c,a))return!1;return!0}function La(a){var b=0,c;for(c in a)b++;return b}function Ma(a){for(var b in a)return b}function Na(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Oa(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Pa(a,b){for(var c in a)if(a[c]==b)return!0;return!1}
	function Qa(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d}function Ra(a,b){var c=Qa(a,b,void 0);return c&&a[c]}function Sa(a){for(var b in a)return!1;return!0}function Ta(a){var b={},c;for(c in a)b[c]=a[c];return b};var Ua=-1!=r.indexOf("Opera")||-1!=r.indexOf("OPR"),Va=-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE"),Wa=-1!=r.indexOf("Gecko")&&-1==r.toLowerCase().indexOf("webkit")&&!(-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE")),Xa=-1!=r.toLowerCase().indexOf("webkit");
	(function(){var a="",b;if(Ua&&aa.opera)return a=aa.opera.version,ha(a)?a():a;Wa?b=/rv\:([^\);]+)(\)|;)/:Va?b=/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/:Xa&&(b=/WebKit\/(\S+)/);b&&(a=(a=b.exec(r))?a[1]:"");return Va&&(b=(b=aa.document)?b.documentMode:void 0,b>parseFloat(a))?String(b):a})();var Ya=null,Za=null,$a=null;function ab(a,b){if(!fa(a))throw Error("encodeByteArray takes an array as a parameter");bb();for(var c=b?Za:Ya,d=[],e=0;e<a.length;e+=3){var f=a[e],h=e+1<a.length,k=h?a[e+1]:0,m=e+2<a.length,l=m?a[e+2]:0,u=f>>2,f=(f&3)<<4|k>>4,k=(k&15)<<2|l>>6,l=l&63;m||(l=64,h||(k=64));d.push(c[u],c[f],c[k],c[l])}return d.join("")}
	function bb(){if(!Ya){Ya={};Za={};$a={};for(var a=0;65>a;a++)Ya[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Za[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a),$a[Za[a]]=a,62<=a&&($a["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a)]=a)}};function cb(a,b){if(!a)throw db(b);}function db(a){return Error("Firebase Database ("+firebase.SDK_VERSION+") INTERNAL ASSERT FAILED: "+a)};function eb(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function w(a,b){if(Object.prototype.hasOwnProperty.call(a,b))return a[b]}function fb(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])};function gb(a){var b=[];fb(a,function(a,d){ea(d)?ya(d,function(d){b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))}):b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))});return b.length?"&"+b.join("&"):""};var hb=firebase.Promise;function ib(){var a=this;this.reject=this.resolve=null;this.ra=new hb(function(b,c){a.resolve=b;a.reject=c})}function jb(a,b){return function(c,d){c?a.reject(c):a.resolve(d);ha(b)&&(kb(a.ra),1===b.length?b(c):b(c,d))}}function kb(a){a.then(void 0,ba)};function lb(a){return"undefined"!==typeof JSON&&n(JSON.parse)?JSON.parse(a):ma(a)}function x(a){if("undefined"!==typeof JSON&&n(JSON.stringify))a=JSON.stringify(a);else{var b=[];oa(new na,a,b);a=b.join("")}return a};function mb(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);55296<=e&&56319>=e&&(e-=55296,d++,cb(d<a.length,"Surrogate pair missing trail surrogate."),e=65536+(e<<10)+(a.charCodeAt(d)-56320));128>e?b[c++]=e:(2048>e?b[c++]=e>>6|192:(65536>e?b[c++]=e>>12|224:(b[c++]=e>>18|240,b[c++]=e>>12&63|128),b[c++]=e>>6&63|128),b[c++]=e&63|128)}return b}function nb(a){for(var b=0,c=0;c<a.length;c++){var d=a.charCodeAt(c);128>d?b++:2048>d?b+=2:55296<=d&&56319>=d?(b+=4,c++):b+=3}return b};function y(a,b,c,d){var e;d<b?e="at least "+b:d>c&&(e=0===c?"none":"no more than "+c);if(e)throw Error(a+" failed: Was called with "+d+(1===d?" argument.":" arguments.")+" Expects "+e+".");}function A(a,b,c){var d="";switch(b){case 1:d=c?"first":"First";break;case 2:d=c?"second":"Second";break;case 3:d=c?"third":"Third";break;case 4:d=c?"fourth":"Fourth";break;default:throw Error("errorPrefix called with argumentNumber > 4.  Need to update it?");}return a=a+" failed: "+(d+" argument ")}
	function B(a,b,c,d){if((!d||n(c))&&!ha(c))throw Error(A(a,b,d)+"must be a valid function.");}function ob(a,b,c){if(n(c)&&(!ia(c)||null===c))throw Error(A(a,b,!0)+"must be a valid context object.");};function pb(){return"undefined"!==typeof window&&!!(window.cordova||window.phonegap||window.PhoneGap)&&/ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test("undefined"!==typeof navigator&&"string"===typeof navigator.userAgent?navigator.userAgent:"")};function C(a,b){this.name=a;this.R=b}function qb(a,b){return new C(a,b)};function rb(a,b){return sb(a.name,b.name)}function tb(a,b){return sb(a,b)};function ub(a){this.uc=a;this.Cd="firebase:"}g=ub.prototype;g.set=function(a,b){null==b?this.uc.removeItem(this.Cd+a):this.uc.setItem(this.Cd+a,x(b))};g.get=function(a){a=this.uc.getItem(this.Cd+a);return null==a?null:lb(a)};g.remove=function(a){this.uc.removeItem(this.Cd+a)};g.Ze=!1;g.toString=function(){return this.uc.toString()};function vb(){this.pc={}}vb.prototype.set=function(a,b){null==b?delete this.pc[a]:this.pc[a]=b};vb.prototype.get=function(a){return eb(this.pc,a)?this.pc[a]:null};vb.prototype.remove=function(a){delete this.pc[a]};vb.prototype.Ze=!0;function wb(a){try{if("undefined"!==typeof window&&"undefined"!==typeof window[a]){var b=window[a];b.setItem("firebase:sentinel","cache");b.removeItem("firebase:sentinel");return new ub(b)}}catch(c){}return new vb}var xb=wb("localStorage"),yb=wb("sessionStorage");function zb(a,b,c,d,e){this.host=a.toLowerCase();this.domain=this.host.substr(this.host.indexOf(".")+1);this.Sc=b;this.pe=c;this.qg=d;this.gf=e||"";this.$a=xb.get("host:"+a)||this.host}function Ab(a,b){b!==a.$a&&(a.$a=b,"s-"===a.$a.substr(0,2)&&xb.set("host:"+a.host,a.$a))}
	function Bb(a,b,c){D("string"===typeof b,"typeof type must == string");D("object"===typeof c,"typeof params must == object");if(b===Cb)b=(a.Sc?"wss://":"ws://")+a.$a+"/.ws?";else if(b===Db)b=(a.Sc?"https://":"http://")+a.$a+"/.lp?";else throw Error("Unknown connection type: "+b);a.host!==a.$a&&(c.ns=a.pe);var d=[];v(c,function(a,b){d.push(b+"="+a)});return b+d.join("&")}zb.prototype.toString=function(){var a=(this.Sc?"https://":"http://")+this.host;this.gf&&(a+="<"+this.gf+">");return a};function Eb(a,b){return a&&"object"===typeof a?(D(".sv"in a,"Unexpected leaf node or priority contents"),b[a[".sv"]]):a}function Fb(a,b){var c=new Gb;Hb(a,new E(""),function(a,e){Ib(c,a,Jb(e,b))});return c}function Jb(a,b){var c=a.C().H(),c=Eb(c,b),d;if(a.J()){var e=Eb(a.Ca(),b);return e!==a.Ca()||c!==a.C().H()?new Kb(e,G(c)):a}d=a;c!==a.C().H()&&(d=d.fa(new Kb(c)));a.O(H,function(a,c){var e=Jb(c,b);e!==c&&(d=d.T(a,e))});return d};var Lb=function(){var a=1;return function(){return a++}}(),D=cb,Mb=db;
	function Nb(a){try{var b;bb();for(var c=$a,d=[],e=0;e<a.length;){var f=c[a.charAt(e++)],h=e<a.length?c[a.charAt(e)]:0;++e;var k=e<a.length?c[a.charAt(e)]:64;++e;var m=e<a.length?c[a.charAt(e)]:64;++e;if(null==f||null==h||null==k||null==m)throw Error();d.push(f<<2|h>>4);64!=k&&(d.push(h<<4&240|k>>2),64!=m&&d.push(k<<6&192|m))}if(8192>d.length)b=String.fromCharCode.apply(null,d);else{a="";for(c=0;c<d.length;c+=8192)a+=String.fromCharCode.apply(null,Ga(d,c,c+8192));b=a}return b}catch(l){I("base64Decode failed: ",
	l)}return null}function Ob(a){var b=mb(a);a=new ta;a.update(b);var b=[],c=8*a.Pd;56>a.$b?a.update(a.zd,56-a.$b):a.update(a.zd,a.Wa-(a.$b-56));for(var d=a.Wa-1;56<=d;d--)a.Wd[d]=c&255,c/=256;ua(a,a.Wd);for(d=c=0;5>d;d++)for(var e=24;0<=e;e-=8)b[c]=a.M[d]>>e&255,++c;return ab(b)}function Pb(a){for(var b="",c=0;c<arguments.length;c++)b=fa(arguments[c])?b+Pb.apply(null,arguments[c]):"object"===typeof arguments[c]?b+x(arguments[c]):b+arguments[c],b+=" ";return b}var Qb=null,Rb=!0;
	function Sb(a,b){cb(!b||!0===a||!1===a,"Can't turn on custom loggers persistently.");!0===a?("undefined"!==typeof console&&("function"===typeof console.log?Qb=q(console.log,console):"object"===typeof console.log&&(Qb=function(a){console.log(a)})),b&&yb.set("logging_enabled",!0)):ha(a)?Qb=a:(Qb=null,yb.remove("logging_enabled"))}function I(a){!0===Rb&&(Rb=!1,null===Qb&&!0===yb.get("logging_enabled")&&Sb(!0));if(Qb){var b=Pb.apply(null,arguments);Qb(b)}}
	function Tb(a){return function(){I(a,arguments)}}function Ub(a){if("undefined"!==typeof console){var b="FIREBASE INTERNAL ERROR: "+Pb.apply(null,arguments);"undefined"!==typeof console.error?console.error(b):console.log(b)}}function Vb(a){var b=Pb.apply(null,arguments);throw Error("FIREBASE FATAL ERROR: "+b);}function J(a){if("undefined"!==typeof console){var b="FIREBASE WARNING: "+Pb.apply(null,arguments);"undefined"!==typeof console.warn?console.warn(b):console.log(b)}}
	function Wb(a){var b,c,d,e,f,h=a;f=c=a=b="";d=!0;e="https";if(p(h)){var k=h.indexOf("//");0<=k&&(e=h.substring(0,k-1),h=h.substring(k+2));k=h.indexOf("/");-1===k&&(k=h.length);b=h.substring(0,k);f="";h=h.substring(k).split("/");for(k=0;k<h.length;k++)if(0<h[k].length){var m=h[k];try{m=decodeURIComponent(m.replace(/\+/g," "))}catch(l){}f+="/"+m}h=b.split(".");3===h.length?(a=h[1],c=h[0].toLowerCase()):2===h.length&&(a=h[0]);k=b.indexOf(":");0<=k&&(d="https"===e||"wss"===e)}"firebase"===a&&Vb(b+" is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead");
	c&&"undefined"!=c||Vb("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");d||"undefined"!==typeof window&&window.location&&window.location.protocol&&-1!==window.location.protocol.indexOf("https:")&&J("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");return{jc:new zb(b,d,c,"ws"===e||"wss"===e),path:new E(f)}}function Xb(a){return ga(a)&&(a!=a||a==Number.POSITIVE_INFINITY||a==Number.NEGATIVE_INFINITY)}
	function Yb(a){if("complete"===document.readyState)a();else{var b=!1,c=function(){document.body?b||(b=!0,a()):setTimeout(c,Math.floor(10))};document.addEventListener?(document.addEventListener("DOMContentLoaded",c,!1),window.addEventListener("load",c,!1)):document.attachEvent&&(document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&c()}),window.attachEvent("onload",c))}}
	function sb(a,b){if(a===b)return 0;if("[MIN_NAME]"===a||"[MAX_NAME]"===b)return-1;if("[MIN_NAME]"===b||"[MAX_NAME]"===a)return 1;var c=Zb(a),d=Zb(b);return null!==c?null!==d?0==c-d?a.length-b.length:c-d:-1:null!==d?1:a<b?-1:1}function $b(a,b){if(b&&a in b)return b[a];throw Error("Missing required key ("+a+") in object: "+x(b));}
	function ac(a){if("object"!==typeof a||null===a)return x(a);var b=[],c;for(c in a)b.push(c);b.sort();c="{";for(var d=0;d<b.length;d++)0!==d&&(c+=","),c+=x(b[d]),c+=":",c+=ac(a[b[d]]);return c+"}"}function bc(a,b){if(a.length<=b)return[a];for(var c=[],d=0;d<a.length;d+=b)d+b>a?c.push(a.substring(d,a.length)):c.push(a.substring(d,d+b));return c}function cc(a,b){if(ea(a))for(var c=0;c<a.length;++c)b(c,a[c]);else v(a,b)}
	function dc(a){D(!Xb(a),"Invalid JSON number");var b,c,d,e;0===a?(d=c=0,b=-Infinity===1/a?1:0):(b=0>a,a=Math.abs(a),a>=Math.pow(2,-1022)?(d=Math.min(Math.floor(Math.log(a)/Math.LN2),1023),c=d+1023,d=Math.round(a*Math.pow(2,52-d)-Math.pow(2,52))):(c=0,d=Math.round(a/Math.pow(2,-1074))));e=[];for(a=52;a;--a)e.push(d%2?1:0),d=Math.floor(d/2);for(a=11;a;--a)e.push(c%2?1:0),c=Math.floor(c/2);e.push(b?1:0);e.reverse();b=e.join("");c="";for(a=0;64>a;a+=8)d=parseInt(b.substr(a,8),2).toString(16),1===d.length&&
	(d="0"+d),c+=d;return c.toLowerCase()}var ec=/^-?\d{1,10}$/;function Zb(a){return ec.test(a)&&(a=Number(a),-2147483648<=a&&2147483647>=a)?a:null}function fc(a){try{a()}catch(b){setTimeout(function(){J("Exception was thrown by user callback.",b.stack||"");throw b;},Math.floor(0))}}function gc(a,b,c){Object.defineProperty(a,b,{get:c})}function hc(a,b){var c=setTimeout(a,b);"object"===typeof c&&c.unref&&c.unref();return c};function ic(a){var b={},c={},d={},e="";try{var f=a.split("."),b=lb(Nb(f[0])||""),c=lb(Nb(f[1])||""),e=f[2],d=c.d||{};delete c.d}catch(h){}return{tg:b,Je:c,data:d,mg:e}}function jc(a){a=ic(a);var b=a.Je;return!!a.mg&&!!b&&"object"===typeof b&&b.hasOwnProperty("iat")}function kc(a){a=ic(a).Je;return"object"===typeof a&&!0===w(a,"admin")};function lc(){}var mc={};function nc(a){return q(a.compare,a)}lc.prototype.nd=function(a,b){return 0!==this.compare(new C("[MIN_NAME]",a),new C("[MIN_NAME]",b))};lc.prototype.Hc=function(){return oc};function pc(a){D(!a.e()&&".priority"!==K(a),"Can't create PathIndex with empty path or .priority key");this.bc=a}la(pc,lc);g=pc.prototype;g.xc=function(a){return!a.P(this.bc).e()};g.compare=function(a,b){var c=a.R.P(this.bc),d=b.R.P(this.bc),c=c.sc(d);return 0===c?sb(a.name,b.name):c};
	g.Ec=function(a,b){var c=G(a),c=L.F(this.bc,c);return new C(b,c)};g.Fc=function(){var a=L.F(this.bc,qc);return new C("[MAX_NAME]",a)};g.toString=function(){return this.bc.slice().join("/")};function rc(){}la(rc,lc);g=rc.prototype;g.compare=function(a,b){var c=a.R.C(),d=b.R.C(),c=c.sc(d);return 0===c?sb(a.name,b.name):c};g.xc=function(a){return!a.C().e()};g.nd=function(a,b){return!a.C().Z(b.C())};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",new Kb("[PRIORITY-POST]",qc))};
	g.Ec=function(a,b){var c=G(a);return new C(b,new Kb("[PRIORITY-POST]",c))};g.toString=function(){return".priority"};var H=new rc;function sc(){}la(sc,lc);g=sc.prototype;g.compare=function(a,b){return sb(a.name,b.name)};g.xc=function(){throw Mb("KeyIndex.isDefinedOn not expected to be called.");};g.nd=function(){return!1};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",L)};g.Ec=function(a){D(p(a),"KeyIndex indexValue must always be a string.");return new C(a,L)};g.toString=function(){return".key"};
	var tc=new sc;function uc(){}la(uc,lc);g=uc.prototype;g.compare=function(a,b){var c=a.R.sc(b.R);return 0===c?sb(a.name,b.name):c};g.xc=function(){return!0};g.nd=function(a,b){return!a.Z(b)};g.Hc=function(){return oc};g.Fc=function(){return vc};g.Ec=function(a,b){var c=G(a);return new C(b,c)};g.toString=function(){return".value"};var wc=new uc;function xc(a,b){this.od=a;this.cc=b}xc.prototype.get=function(a){var b=w(this.od,a);if(!b)throw Error("No index defined for "+a);return b===mc?null:b};function yc(a,b,c){var d=Ja(a.od,function(d,f){var h=w(a.cc,f);D(h,"Missing index implementation for "+f);if(d===mc){if(h.xc(b.R)){for(var k=[],m=c.Wb(qb),l=M(m);l;)l.name!=b.name&&k.push(l),l=M(m);k.push(b);return zc(k,nc(h))}return mc}h=c.get(b.name);k=d;h&&(k=k.remove(new C(b.name,h)));return k.Oa(b,b.R)});return new xc(d,a.cc)}
	function Ac(a,b,c){var d=Ja(a.od,function(a){if(a===mc)return a;var d=c.get(b.name);return d?a.remove(new C(b.name,d)):a});return new xc(d,a.cc)}var Bc=new xc({".priority":mc},{".priority":H});function Kb(a,b){this.B=a;D(n(this.B)&&null!==this.B,"LeafNode shouldn't be created with null/undefined value.");this.aa=b||L;Cc(this.aa);this.Db=null}var Dc=["object","boolean","number","string"];g=Kb.prototype;g.J=function(){return!0};g.C=function(){return this.aa};g.fa=function(a){return new Kb(this.B,a)};g.Q=function(a){return".priority"===a?this.aa:L};g.P=function(a){return a.e()?this:".priority"===K(a)?this.aa:L};g.Da=function(){return!1};g.Ve=function(){return null};
	g.T=function(a,b){return".priority"===a?this.fa(b):b.e()&&".priority"!==a?this:L.T(a,b).fa(this.aa)};g.F=function(a,b){var c=K(a);if(null===c)return b;if(b.e()&&".priority"!==c)return this;D(".priority"!==c||1===Ec(a),".priority must be the last token in a path");return this.T(c,L.F(N(a),b))};g.e=function(){return!1};g.Eb=function(){return 0};g.O=function(){return!1};g.H=function(a){return a&&!this.C().e()?{".value":this.Ca(),".priority":this.C().H()}:this.Ca()};
	g.hash=function(){if(null===this.Db){var a="";this.aa.e()||(a+="priority:"+Fc(this.aa.H())+":");var b=typeof this.B,a=a+(b+":"),a="number"===b?a+dc(this.B):a+this.B;this.Db=Ob(a)}return this.Db};g.Ca=function(){return this.B};g.sc=function(a){if(a===L)return 1;if(a instanceof O)return-1;D(a.J(),"Unknown node type");var b=typeof a.B,c=typeof this.B,d=xa(Dc,b),e=xa(Dc,c);D(0<=d,"Unknown leaf type: "+b);D(0<=e,"Unknown leaf type: "+c);return d===e?"object"===c?0:this.B<a.B?-1:this.B===a.B?0:1:e-d};
	g.nb=function(){return this};g.yc=function(){return!0};g.Z=function(a){return a===this?!0:a.J()?this.B===a.B&&this.aa.Z(a.aa):!1};g.toString=function(){return x(this.H(!0))};function Gc(){this.set={}}g=Gc.prototype;g.add=function(a,b){this.set[a]=null!==b?b:!0};g.contains=function(a){return eb(this.set,a)};g.get=function(a){return this.contains(a)?this.set[a]:void 0};g.remove=function(a){delete this.set[a]};g.clear=function(){this.set={}};g.e=function(){return Sa(this.set)};g.count=function(){return La(this.set)};function Hc(a,b){v(a.set,function(a,d){b(d,a)})}g.keys=function(){var a=[];v(this.set,function(b,c){a.push(c)});return a};function Ic(a){D(ea(a)&&0<a.length,"Requires a non-empty array");this.Bf=a;this.Dc={}}Ic.prototype.Ge=function(a,b){var c;c=this.Dc[a]||[];var d=c.length;if(0<d){for(var e=Array(d),f=0;f<d;f++)e[f]=c[f];c=e}else c=[];for(d=0;d<c.length;d++)c[d].Ie.apply(c[d].Ma,Array.prototype.slice.call(arguments,1))};Ic.prototype.gc=function(a,b,c){Jc(this,a);this.Dc[a]=this.Dc[a]||[];this.Dc[a].push({Ie:b,Ma:c});(a=this.Ue(a))&&b.apply(c,a)};
	Ic.prototype.Ic=function(a,b,c){Jc(this,a);a=this.Dc[a]||[];for(var d=0;d<a.length;d++)if(a[d].Ie===b&&(!c||c===a[d].Ma)){a.splice(d,1);break}};function Jc(a,b){D(Da(a.Bf,function(a){return a===b}),"Unknown event: "+b)};var Kc=function(){var a=0,b=[];return function(c){var d=c===a;a=c;for(var e=Array(8),f=7;0<=f;f--)e[f]="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(c%64),c=Math.floor(c/64);D(0===c,"Cannot push at time == 0");c=e.join("");if(d){for(f=11;0<=f&&63===b[f];f--)b[f]=0;b[f]++}else for(f=0;12>f;f++)b[f]=Math.floor(64*Math.random());for(f=0;12>f;f++)c+="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(b[f]);D(20===c.length,"nextPushId: Length should be 20.");
	return c}}();function Lc(){Ic.call(this,["online"]);this.hc=!0;if("undefined"!==typeof window&&"undefined"!==typeof window.addEventListener&&!pb()){var a=this;window.addEventListener("online",function(){a.hc||(a.hc=!0,a.Ge("online",!0))},!1);window.addEventListener("offline",function(){a.hc&&(a.hc=!1,a.Ge("online",!1))},!1)}}la(Lc,Ic);Lc.prototype.Ue=function(a){D("online"===a,"Unknown event type: "+a);return[this.hc]};ca(Lc);function Mc(){Ic.call(this,["visible"]);var a,b;"undefined"!==typeof document&&"undefined"!==typeof document.addEventListener&&("undefined"!==typeof document.hidden?(b="visibilitychange",a="hidden"):"undefined"!==typeof document.mozHidden?(b="mozvisibilitychange",a="mozHidden"):"undefined"!==typeof document.msHidden?(b="msvisibilitychange",a="msHidden"):"undefined"!==typeof document.webkitHidden&&(b="webkitvisibilitychange",a="webkitHidden"));this.Mb=!0;if(b){var c=this;document.addEventListener(b,
	function(){var b=!document[a];b!==c.Mb&&(c.Mb=b,c.Ge("visible",b))},!1)}}la(Mc,Ic);Mc.prototype.Ue=function(a){D("visible"===a,"Unknown event type: "+a);return[this.Mb]};ca(Mc);function E(a,b){if(1==arguments.length){this.o=a.split("/");for(var c=0,d=0;d<this.o.length;d++)0<this.o[d].length&&(this.o[c]=this.o[d],c++);this.o.length=c;this.Y=0}else this.o=a,this.Y=b}function P(a,b){var c=K(a);if(null===c)return b;if(c===K(b))return P(N(a),N(b));throw Error("INTERNAL ERROR: innerPath ("+b+") is not within outerPath ("+a+")");}
	function Nc(a,b){for(var c=a.slice(),d=b.slice(),e=0;e<c.length&&e<d.length;e++){var f=sb(c[e],d[e]);if(0!==f)return f}return c.length===d.length?0:c.length<d.length?-1:1}function K(a){return a.Y>=a.o.length?null:a.o[a.Y]}function Ec(a){return a.o.length-a.Y}function N(a){var b=a.Y;b<a.o.length&&b++;return new E(a.o,b)}function Oc(a){return a.Y<a.o.length?a.o[a.o.length-1]:null}g=E.prototype;
	g.toString=function(){for(var a="",b=this.Y;b<this.o.length;b++)""!==this.o[b]&&(a+="/"+this.o[b]);return a||"/"};g.slice=function(a){return this.o.slice(this.Y+(a||0))};g.parent=function(){if(this.Y>=this.o.length)return null;for(var a=[],b=this.Y;b<this.o.length-1;b++)a.push(this.o[b]);return new E(a,0)};
	g.n=function(a){for(var b=[],c=this.Y;c<this.o.length;c++)b.push(this.o[c]);if(a instanceof E)for(c=a.Y;c<a.o.length;c++)b.push(a.o[c]);else for(a=a.split("/"),c=0;c<a.length;c++)0<a[c].length&&b.push(a[c]);return new E(b,0)};g.e=function(){return this.Y>=this.o.length};g.Z=function(a){if(Ec(this)!==Ec(a))return!1;for(var b=this.Y,c=a.Y;b<=this.o.length;b++,c++)if(this.o[b]!==a.o[c])return!1;return!0};
	g.contains=function(a){var b=this.Y,c=a.Y;if(Ec(this)>Ec(a))return!1;for(;b<this.o.length;){if(this.o[b]!==a.o[c])return!1;++b;++c}return!0};var Q=new E("");function Pc(a,b){this.Qa=a.slice();this.Ha=Math.max(1,this.Qa.length);this.Qe=b;for(var c=0;c<this.Qa.length;c++)this.Ha+=nb(this.Qa[c]);Qc(this)}Pc.prototype.push=function(a){0<this.Qa.length&&(this.Ha+=1);this.Qa.push(a);this.Ha+=nb(a);Qc(this)};Pc.prototype.pop=function(){var a=this.Qa.pop();this.Ha-=nb(a);0<this.Qa.length&&--this.Ha};
	function Qc(a){if(768<a.Ha)throw Error(a.Qe+"has a key path longer than 768 bytes ("+a.Ha+").");if(32<a.Qa.length)throw Error(a.Qe+"path specified exceeds the maximum depth that can be written (32) or object contains a cycle "+Rc(a));}function Rc(a){return 0==a.Qa.length?"":"in property '"+a.Qa.join(".")+"'"};function Sc(){this.children={};this.bd=0;this.value=null}function Tc(a,b,c){this.ud=a?a:"";this.Pc=b?b:null;this.A=c?c:new Sc}function Uc(a,b){for(var c=b instanceof E?b:new E(b),d=a,e;null!==(e=K(c));)d=new Tc(e,d,w(d.A.children,e)||new Sc),c=N(c);return d}g=Tc.prototype;g.Ca=function(){return this.A.value};function Vc(a,b){D("undefined"!==typeof b,"Cannot set value to undefined");a.A.value=b;Wc(a)}g.clear=function(){this.A.value=null;this.A.children={};this.A.bd=0;Wc(this)};
	g.kd=function(){return 0<this.A.bd};g.e=function(){return null===this.Ca()&&!this.kd()};g.O=function(a){var b=this;v(this.A.children,function(c,d){a(new Tc(d,b,c))})};function Xc(a,b,c,d){c&&!d&&b(a);a.O(function(a){Xc(a,b,!0,d)});c&&d&&b(a)}function Yc(a,b){for(var c=a.parent();null!==c&&!b(c);)c=c.parent()}g.path=function(){return new E(null===this.Pc?this.ud:this.Pc.path()+"/"+this.ud)};g.name=function(){return this.ud};g.parent=function(){return this.Pc};
	function Wc(a){if(null!==a.Pc){var b=a.Pc,c=a.ud,d=a.e(),e=eb(b.A.children,c);d&&e?(delete b.A.children[c],b.A.bd--,Wc(b)):d||e||(b.A.children[c]=a.A,b.A.bd++,Wc(b))}};function Zc(a,b){this.La=a;this.ba=b?b:$c}g=Zc.prototype;g.Oa=function(a,b){return new Zc(this.La,this.ba.Oa(a,b,this.La).X(null,null,!1,null,null))};g.remove=function(a){return new Zc(this.La,this.ba.remove(a,this.La).X(null,null,!1,null,null))};g.get=function(a){for(var b,c=this.ba;!c.e();){b=this.La(a,c.key);if(0===b)return c.value;0>b?c=c.left:0<b&&(c=c.right)}return null};
	function ad(a,b){for(var c,d=a.ba,e=null;!d.e();){c=a.La(b,d.key);if(0===c){if(d.left.e())return e?e.key:null;for(d=d.left;!d.right.e();)d=d.right;return d.key}0>c?d=d.left:0<c&&(e=d,d=d.right)}throw Error("Attempted to find predecessor key for a nonexistent key.  What gives?");}g.e=function(){return this.ba.e()};g.count=function(){return this.ba.count()};g.Gc=function(){return this.ba.Gc()};g.ec=function(){return this.ba.ec()};g.ha=function(a){return this.ba.ha(a)};
	g.Wb=function(a){return new bd(this.ba,null,this.La,!1,a)};g.Xb=function(a,b){return new bd(this.ba,a,this.La,!1,b)};g.Zb=function(a,b){return new bd(this.ba,a,this.La,!0,b)};g.We=function(a){return new bd(this.ba,null,this.La,!0,a)};function bd(a,b,c,d,e){this.Hd=e||null;this.le=d;this.Pa=[];for(e=1;!a.e();)if(e=b?c(a.key,b):1,d&&(e*=-1),0>e)a=this.le?a.left:a.right;else if(0===e){this.Pa.push(a);break}else this.Pa.push(a),a=this.le?a.right:a.left}
	function M(a){if(0===a.Pa.length)return null;var b=a.Pa.pop(),c;c=a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value};if(a.le)for(b=b.left;!b.e();)a.Pa.push(b),b=b.right;else for(b=b.right;!b.e();)a.Pa.push(b),b=b.left;return c}function cd(a){if(0===a.Pa.length)return null;var b;b=a.Pa;b=b[b.length-1];return a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value}}function dd(a,b,c,d,e){this.key=a;this.value=b;this.color=null!=c?c:!0;this.left=null!=d?d:$c;this.right=null!=e?e:$c}g=dd.prototype;
	g.X=function(a,b,c,d,e){return new dd(null!=a?a:this.key,null!=b?b:this.value,null!=c?c:this.color,null!=d?d:this.left,null!=e?e:this.right)};g.count=function(){return this.left.count()+1+this.right.count()};g.e=function(){return!1};g.ha=function(a){return this.left.ha(a)||a(this.key,this.value)||this.right.ha(a)};function ed(a){return a.left.e()?a:ed(a.left)}g.Gc=function(){return ed(this).key};g.ec=function(){return this.right.e()?this.key:this.right.ec()};
	g.Oa=function(a,b,c){var d,e;e=this;d=c(a,e.key);e=0>d?e.X(null,null,null,e.left.Oa(a,b,c),null):0===d?e.X(null,b,null,null,null):e.X(null,null,null,null,e.right.Oa(a,b,c));return gd(e)};function hd(a){if(a.left.e())return $c;a.left.ea()||a.left.left.ea()||(a=id(a));a=a.X(null,null,null,hd(a.left),null);return gd(a)}
	g.remove=function(a,b){var c,d;c=this;if(0>b(a,c.key))c.left.e()||c.left.ea()||c.left.left.ea()||(c=id(c)),c=c.X(null,null,null,c.left.remove(a,b),null);else{c.left.ea()&&(c=jd(c));c.right.e()||c.right.ea()||c.right.left.ea()||(c=kd(c),c.left.left.ea()&&(c=jd(c),c=kd(c)));if(0===b(a,c.key)){if(c.right.e())return $c;d=ed(c.right);c=c.X(d.key,d.value,null,null,hd(c.right))}c=c.X(null,null,null,null,c.right.remove(a,b))}return gd(c)};g.ea=function(){return this.color};
	function gd(a){a.right.ea()&&!a.left.ea()&&(a=ld(a));a.left.ea()&&a.left.left.ea()&&(a=jd(a));a.left.ea()&&a.right.ea()&&(a=kd(a));return a}function id(a){a=kd(a);a.right.left.ea()&&(a=a.X(null,null,null,null,jd(a.right)),a=ld(a),a=kd(a));return a}function ld(a){return a.right.X(null,null,a.color,a.X(null,null,!0,null,a.right.left),null)}function jd(a){return a.left.X(null,null,a.color,null,a.X(null,null,!0,a.left.right,null))}
	function kd(a){return a.X(null,null,!a.color,a.left.X(null,null,!a.left.color,null,null),a.right.X(null,null,!a.right.color,null,null))}function md(){}g=md.prototype;g.X=function(){return this};g.Oa=function(a,b){return new dd(a,b,null)};g.remove=function(){return this};g.count=function(){return 0};g.e=function(){return!0};g.ha=function(){return!1};g.Gc=function(){return null};g.ec=function(){return null};g.ea=function(){return!1};var $c=new md;function O(a,b,c){this.k=a;(this.aa=b)&&Cc(this.aa);a.e()&&D(!this.aa||this.aa.e(),"An empty node cannot have a priority");this.yb=c;this.Db=null}g=O.prototype;g.J=function(){return!1};g.C=function(){return this.aa||L};g.fa=function(a){return this.k.e()?this:new O(this.k,a,this.yb)};g.Q=function(a){if(".priority"===a)return this.C();a=this.k.get(a);return null===a?L:a};g.P=function(a){var b=K(a);return null===b?this:this.Q(b).P(N(a))};g.Da=function(a){return null!==this.k.get(a)};
	g.T=function(a,b){D(b,"We should always be passing snapshot nodes");if(".priority"===a)return this.fa(b);var c=new C(a,b),d,e;b.e()?(d=this.k.remove(a),c=Ac(this.yb,c,this.k)):(d=this.k.Oa(a,b),c=yc(this.yb,c,this.k));e=d.e()?L:this.aa;return new O(d,e,c)};g.F=function(a,b){var c=K(a);if(null===c)return b;D(".priority"!==K(a)||1===Ec(a),".priority must be the last token in a path");var d=this.Q(c).F(N(a),b);return this.T(c,d)};g.e=function(){return this.k.e()};g.Eb=function(){return this.k.count()};
	var nd=/^(0|[1-9]\d*)$/;g=O.prototype;g.H=function(a){if(this.e())return null;var b={},c=0,d=0,e=!0;this.O(H,function(f,h){b[f]=h.H(a);c++;e&&nd.test(f)?d=Math.max(d,Number(f)):e=!1});if(!a&&e&&d<2*c){var f=[],h;for(h in b)f[h]=b[h];return f}a&&!this.C().e()&&(b[".priority"]=this.C().H());return b};g.hash=function(){if(null===this.Db){var a="";this.C().e()||(a+="priority:"+Fc(this.C().H())+":");this.O(H,function(b,c){var d=c.hash();""!==d&&(a+=":"+b+":"+d)});this.Db=""===a?"":Ob(a)}return this.Db};
	g.Ve=function(a,b,c){return(c=od(this,c))?(a=ad(c,new C(a,b)))?a.name:null:ad(this.k,a)};function pd(a,b){var c;c=(c=od(a,b))?(c=c.Gc())&&c.name:a.k.Gc();return c?new C(c,a.k.get(c)):null}function qd(a,b){var c;c=(c=od(a,b))?(c=c.ec())&&c.name:a.k.ec();return c?new C(c,a.k.get(c)):null}g.O=function(a,b){var c=od(this,a);return c?c.ha(function(a){return b(a.name,a.R)}):this.k.ha(b)};g.Wb=function(a){return this.Xb(a.Hc(),a)};
	g.Xb=function(a,b){var c=od(this,b);if(c)return c.Xb(a,function(a){return a});for(var c=this.k.Xb(a.name,qb),d=cd(c);null!=d&&0>b.compare(d,a);)M(c),d=cd(c);return c};g.We=function(a){return this.Zb(a.Fc(),a)};g.Zb=function(a,b){var c=od(this,b);if(c)return c.Zb(a,function(a){return a});for(var c=this.k.Zb(a.name,qb),d=cd(c);null!=d&&0<b.compare(d,a);)M(c),d=cd(c);return c};g.sc=function(a){return this.e()?a.e()?0:-1:a.J()||a.e()?1:a===qc?-1:0};
	g.nb=function(a){if(a===tc||Pa(this.yb.cc,a.toString()))return this;var b=this.yb,c=this.k;D(a!==tc,"KeyIndex always exists and isn't meant to be added to the IndexMap.");for(var d=[],e=!1,c=c.Wb(qb),f=M(c);f;)e=e||a.xc(f.R),d.push(f),f=M(c);d=e?zc(d,nc(a)):mc;e=a.toString();c=Ta(b.cc);c[e]=a;a=Ta(b.od);a[e]=d;return new O(this.k,this.aa,new xc(a,c))};g.yc=function(a){return a===tc||Pa(this.yb.cc,a.toString())};
	g.Z=function(a){if(a===this)return!0;if(a.J())return!1;if(this.C().Z(a.C())&&this.k.count()===a.k.count()){var b=this.Wb(H);a=a.Wb(H);for(var c=M(b),d=M(a);c&&d;){if(c.name!==d.name||!c.R.Z(d.R))return!1;c=M(b);d=M(a)}return null===c&&null===d}return!1};function od(a,b){return b===tc?null:a.yb.get(b.toString())}g.toString=function(){return x(this.H(!0))};function G(a,b){if(null===a)return L;var c=null;"object"===typeof a&&".priority"in a?c=a[".priority"]:"undefined"!==typeof b&&(c=b);D(null===c||"string"===typeof c||"number"===typeof c||"object"===typeof c&&".sv"in c,"Invalid priority type found: "+typeof c);"object"===typeof a&&".value"in a&&null!==a[".value"]&&(a=a[".value"]);if("object"!==typeof a||".sv"in a)return new Kb(a,G(c));if(a instanceof Array){var d=L,e=a;v(e,function(a,b){if(eb(e,b)&&"."!==b.substring(0,1)){var c=G(a);if(c.J()||!c.e())d=
	d.T(b,c)}});return d.fa(G(c))}var f=[],h=!1,k=a;fb(k,function(a){if("string"!==typeof a||"."!==a.substring(0,1)){var b=G(k[a]);b.e()||(h=h||!b.C().e(),f.push(new C(a,b)))}});if(0==f.length)return L;var m=zc(f,rb,function(a){return a.name},tb);if(h){var l=zc(f,nc(H));return new O(m,G(c),new xc({".priority":l},{".priority":H}))}return new O(m,G(c),Bc)}var rd=Math.log(2);
	function sd(a){this.count=parseInt(Math.log(a+1)/rd,10);this.Oe=this.count-1;this.Cf=a+1&parseInt(Array(this.count+1).join("1"),2)}function td(a){var b=!(a.Cf&1<<a.Oe);a.Oe--;return b}
	function zc(a,b,c,d){function e(b,d){var f=d-b;if(0==f)return null;if(1==f){var l=a[b],u=c?c(l):l;return new dd(u,l.R,!1,null,null)}var l=parseInt(f/2,10)+b,f=e(b,l),z=e(l+1,d),l=a[l],u=c?c(l):l;return new dd(u,l.R,!1,f,z)}a.sort(b);var f=function(b){function d(b,h){var k=u-b,z=u;u-=b;var z=e(k+1,z),k=a[k],F=c?c(k):k,z=new dd(F,k.R,h,null,z);f?f.left=z:l=z;f=z}for(var f=null,l=null,u=a.length,z=0;z<b.count;++z){var F=td(b),fd=Math.pow(2,b.count-(z+1));F?d(fd,!1):(d(fd,!1),d(fd,!0))}return l}(new sd(a.length));
	return null!==f?new Zc(d||b,f):new Zc(d||b)}function Fc(a){return"number"===typeof a?"number:"+dc(a):"string:"+a}function Cc(a){if(a.J()){var b=a.H();D("string"===typeof b||"number"===typeof b||"object"===typeof b&&eb(b,".sv"),"Priority must be a string or number.")}else D(a===qc||a.e(),"priority of unexpected type.");D(a===qc||a.C().e(),"Priority nodes can't have a priority of their own.")}var L=new O(new Zc(tb),null,Bc);function ud(){O.call(this,new Zc(tb),L,Bc)}la(ud,O);g=ud.prototype;
	g.sc=function(a){return a===this?0:1};g.Z=function(a){return a===this};g.C=function(){return this};g.Q=function(){return L};g.e=function(){return!1};var qc=new ud,oc=new C("[MIN_NAME]",L),vc=new C("[MAX_NAME]",qc);function vd(a,b){this.value=a;this.children=b||wd}var wd=new Zc(function(a,b){return a===b?0:a<b?-1:1});function xd(a){var b=R;v(a,function(a,d){b=b.set(new E(d),a)});return b}g=vd.prototype;g.e=function(){return null===this.value&&this.children.e()};function yd(a,b,c){if(null!=a.value&&c(a.value))return{path:Q,value:a.value};if(b.e())return null;var d=K(b);a=a.children.get(d);return null!==a?(b=yd(a,N(b),c),null!=b?{path:(new E(d)).n(b.path),value:b.value}:null):null}
	function zd(a,b){return yd(a,b,function(){return!0})}g.subtree=function(a){if(a.e())return this;var b=this.children.get(K(a));return null!==b?b.subtree(N(a)):R};g.set=function(a,b){if(a.e())return new vd(b,this.children);var c=K(a),d=(this.children.get(c)||R).set(N(a),b),c=this.children.Oa(c,d);return new vd(this.value,c)};
	g.remove=function(a){if(a.e())return this.children.e()?R:new vd(null,this.children);var b=K(a),c=this.children.get(b);return c?(a=c.remove(N(a)),b=a.e()?this.children.remove(b):this.children.Oa(b,a),null===this.value&&b.e()?R:new vd(this.value,b)):this};g.get=function(a){if(a.e())return this.value;var b=this.children.get(K(a));return b?b.get(N(a)):null};
	function Ad(a,b,c){if(b.e())return c;var d=K(b);b=Ad(a.children.get(d)||R,N(b),c);d=b.e()?a.children.remove(d):a.children.Oa(d,b);return new vd(a.value,d)}function Bd(a,b){return Cd(a,Q,b)}function Cd(a,b,c){var d={};a.children.ha(function(a,f){d[a]=Cd(f,b.n(a),c)});return c(b,a.value,d)}function Dd(a,b,c){return Ed(a,b,Q,c)}function Ed(a,b,c,d){var e=a.value?d(c,a.value):!1;if(e)return e;if(b.e())return null;e=K(b);return(a=a.children.get(e))?Ed(a,N(b),c.n(e),d):null}
	function Fd(a,b,c){Gd(a,b,Q,c)}function Gd(a,b,c,d){if(b.e())return a;a.value&&d(c,a.value);var e=K(b);return(a=a.children.get(e))?Gd(a,N(b),c.n(e),d):R}function Hd(a,b){Id(a,Q,b)}function Id(a,b,c){a.children.ha(function(a,e){Id(e,b.n(a),c)});a.value&&c(b,a.value)}function Jd(a,b){a.children.ha(function(a,d){d.value&&b(a,d.value)})}var R=new vd(null);vd.prototype.toString=function(){var a={};Hd(this,function(b,c){a[b.toString()]=c.toString()});return x(a)};var Kd=/[\[\].#$\/\u0000-\u001F\u007F]/,Ld=/[\[\].#$\u0000-\u001F\u007F]/;function Md(a){return p(a)&&0!==a.length&&!Kd.test(a)}function Nd(a){return null===a||p(a)||ga(a)&&!Xb(a)||ia(a)&&eb(a,".sv")}function Od(a,b,c,d){d&&!n(b)||Pd(A(a,1,d),b,c)}
	function Pd(a,b,c){c instanceof E&&(c=new Pc(c,a));if(!n(b))throw Error(a+"contains undefined "+Rc(c));if(ha(b))throw Error(a+"contains a function "+Rc(c)+" with contents: "+b.toString());if(Xb(b))throw Error(a+"contains "+b.toString()+" "+Rc(c));if(p(b)&&b.length>10485760/3&&10485760<nb(b))throw Error(a+"contains a string greater than 10485760 utf8 bytes "+Rc(c)+" ('"+b.substring(0,50)+"...')");if(ia(b)){var d=!1,e=!1;fb(b,function(b,h){if(".value"===b)d=!0;else if(".priority"!==b&&".sv"!==b&&(e=
	!0,!Md(b)))throw Error(a+" contains an invalid key ("+b+") "+Rc(c)+'.  Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');c.push(b);Pd(a,h,c);c.pop()});if(d&&e)throw Error(a+' contains ".value" child '+Rc(c)+" in addition to actual children.");}}
	function Qd(a,b){var c,d;for(c=0;c<b.length;c++){d=b[c];for(var e=d.slice(),f=0;f<e.length;f++)if((".priority"!==e[f]||f!==e.length-1)&&!Md(e[f]))throw Error(a+"contains an invalid key ("+e[f]+") in path "+d.toString()+'. Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');}b.sort(Nc);e=null;for(c=0;c<b.length;c++){d=b[c];if(null!==e&&e.contains(d))throw Error(a+"contains a path "+e.toString()+" that is ancestor of another path "+d.toString());e=d}}
	function Rd(a,b,c){var d=A(a,1,!1);if(!ia(b)||ea(b))throw Error(d+" must be an object containing the children to replace.");var e=[];fb(b,function(a,b){var k=new E(a);Pd(d,b,c.n(k));if(".priority"===Oc(k)&&!Nd(b))throw Error(d+"contains an invalid value for '"+k.toString()+"', which must be a valid Firebase priority (a string, finite number, server value, or null).");e.push(k)});Qd(d,e)}
	function Sd(a,b,c){if(Xb(c))throw Error(A(a,b,!1)+"is "+c.toString()+", but must be a valid Firebase priority (a string, finite number, server value, or null).");if(!Nd(c))throw Error(A(a,b,!1)+"must be a valid Firebase priority (a string, finite number, server value, or null).");}
	function Td(a,b,c){if(!c||n(b))switch(b){case "value":case "child_added":case "child_removed":case "child_changed":case "child_moved":break;default:throw Error(A(a,1,c)+'must be a valid event type: "value", "child_added", "child_removed", "child_changed", or "child_moved".');}}function Ud(a,b){if(n(b)&&!Md(b))throw Error(A(a,2,!0)+'was an invalid key: "'+b+'".  Firebase keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]").');}
	function Vd(a,b){if(!p(b)||0===b.length||Ld.test(b))throw Error(A(a,1,!1)+'was an invalid path: "'+b+'". Paths must be non-empty strings and can\'t contain ".", "#", "$", "[", or "]"');}function Wd(a,b){if(".info"===K(b))throw Error(a+" failed: Can't modify data under /.info/");}
	function Xd(a,b){var c=b.path.toString(),d;!(d=!p(b.jc.host)||0===b.jc.host.length||!Md(b.jc.pe))&&(d=0!==c.length)&&(c&&(c=c.replace(/^\/*\.info(\/|$)/,"/")),d=!(p(c)&&0!==c.length&&!Ld.test(c)));if(d)throw Error(A(a,1,!1)+'must be a valid firebase URL and the path can\'t contain ".", "#", "$", "[", or "]".');};function Gb(){this.k=this.B=null}Gb.prototype.find=function(a){if(null!=this.B)return this.B.P(a);if(a.e()||null==this.k)return null;var b=K(a);a=N(a);return this.k.contains(b)?this.k.get(b).find(a):null};function Ib(a,b,c){if(b.e())a.B=c,a.k=null;else if(null!==a.B)a.B=a.B.F(b,c);else{null==a.k&&(a.k=new Gc);var d=K(b);a.k.contains(d)||a.k.add(d,new Gb);a=a.k.get(d);b=N(b);Ib(a,b,c)}}
	function Yd(a,b){if(b.e())return a.B=null,a.k=null,!0;if(null!==a.B){if(a.B.J())return!1;var c=a.B;a.B=null;c.O(H,function(b,c){Ib(a,new E(b),c)});return Yd(a,b)}return null!==a.k?(c=K(b),b=N(b),a.k.contains(c)&&Yd(a.k.get(c),b)&&a.k.remove(c),a.k.e()?(a.k=null,!0):!1):!0}function Hb(a,b,c){null!==a.B?c(b,a.B):a.O(function(a,e){var f=new E(b.toString()+"/"+a);Hb(e,f,c)})}Gb.prototype.O=function(a){null!==this.k&&Hc(this.k,function(b,c){a(b,c)})};function Zd(a,b){this.type=$d;this.source=a;this.path=b}Zd.prototype.Mc=function(){return this.path.e()?new Zd(this.source,Q):new Zd(this.source,N(this.path))};Zd.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" listen_complete)"};function ae(a,b,c){this.type=be;this.source=a;this.path=b;this.children=c}ae.prototype.Mc=function(a){if(this.path.e())return a=this.children.subtree(new E(a)),a.e()?null:a.value?new ce(this.source,Q,a.value):new ae(this.source,Q,a);D(K(this.path)===a,"Can't get a merge for a child not on the path of the operation");return new ae(this.source,N(this.path),this.children)};ae.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" merge: "+this.children.toString()+")"};function de(a,b,c){this.type=ee;this.source=fe;this.path=a;this.Ob=b;this.Id=c}de.prototype.Mc=function(a){if(this.path.e()){if(null!=this.Ob.value)return D(this.Ob.children.e(),"affectedTree should not have overlapping affected paths."),this;a=this.Ob.subtree(new E(a));return new de(Q,a,this.Id)}D(K(this.path)===a,"operationForChild called for unrelated child.");return new de(N(this.path),this.Ob,this.Id)};
	de.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" ack write revert="+this.Id+" affectedTree="+this.Ob+")"};function ce(a,b,c){this.type=ge;this.source=a;this.path=b;this.Ga=c}ce.prototype.Mc=function(a){return this.path.e()?new ce(this.source,Q,this.Ga.Q(a)):new ce(this.source,N(this.path),this.Ga)};ce.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" overwrite: "+this.Ga.toString()+")"};var ge=0,be=1,ee=2,$d=3;function he(a,b,c,d){this.ee=a;this.Se=b;this.Hb=c;this.Ee=d;D(!d||b,"Tagged queries must be from server.")}var fe=new he(!0,!1,null,!1),ie=new he(!1,!0,null,!1);he.prototype.toString=function(){return this.ee?"user":this.Ee?"server(queryID="+this.Hb+")":"server"};function je(a,b,c){this.A=a;this.da=b;this.Sb=c}function ke(a){return a.da}function le(a){return a.Sb}function me(a,b){return b.e()?a.da&&!a.Sb:ne(a,K(b))}function ne(a,b){return a.da&&!a.Sb||a.A.Da(b)}je.prototype.j=function(){return this.A};function oe(a,b){this.N=a;this.Ld=b}function pe(a,b,c,d){return new oe(new je(b,c,d),a.Ld)}function qe(a){return a.N.da?a.N.j():null}oe.prototype.w=function(){return this.Ld};function re(a){return a.Ld.da?a.Ld.j():null};function se(){}se.prototype.Te=function(){return null};se.prototype.fe=function(){return null};var te=new se;function ue(a,b,c){this.xf=a;this.Ka=b;this.yd=c}ue.prototype.Te=function(a){var b=this.Ka.N;if(ne(b,a))return b.j().Q(a);b=null!=this.yd?new je(this.yd,!0,!1):this.Ka.w();return this.xf.qc(a,b)};ue.prototype.fe=function(a,b,c){var d=null!=this.yd?this.yd:re(this.Ka);a=this.xf.Xd(d,b,1,c,a);return 0===a.length?null:a[0]};function ve(a,b){this.Sd=a;this.Df=b}function we(a){this.U=a}
	we.prototype.eb=function(a,b,c,d){var e=new xe,f;if(b.type===ge)b.source.ee?c=ye(this,a,b.path,b.Ga,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w())&&!b.path.e(),c=ze(this,a,b.path,b.Ga,c,d,f,e));else if(b.type===be)b.source.ee?c=Ae(this,a,b.path,b.children,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w()),c=Be(this,a,b.path,b.children,c,d,f,e));else if(b.type===ee)if(b.Id)if(b=b.path,null!=c.lc(b))c=a;else{f=new ue(c,a,d);d=a.N.j();if(b.e()||".priority"===K(b))ke(a.w())?
	b=c.Aa(re(a)):(b=a.w().j(),D(b instanceof O,"serverChildren would be complete if leaf node"),b=c.rc(b)),b=this.U.ya(d,b,e);else{var h=K(b),k=c.qc(h,a.w());null==k&&ne(a.w(),h)&&(k=d.Q(h));b=null!=k?this.U.F(d,h,k,N(b),f,e):a.N.j().Da(h)?this.U.F(d,h,L,N(b),f,e):d;b.e()&&ke(a.w())&&(d=c.Aa(re(a)),d.J()&&(b=this.U.ya(b,d,e)))}d=ke(a.w())||null!=c.lc(Q);c=pe(a,b,d,this.U.Na())}else c=Ce(this,a,b.path,b.Ob,c,d,e);else if(b.type===$d)d=b.path,b=a.w(),f=b.j(),h=b.da||d.e(),c=De(this,new oe(a.N,new je(f,
	h,b.Sb)),d,c,te,e);else throw Mb("Unknown operation type: "+b.type);e=Na(e.fb);d=c;b=d.N;b.da&&(f=b.j().J()||b.j().e(),h=qe(a),(0<e.length||!a.N.da||f&&!b.j().Z(h)||!b.j().C().Z(h.C()))&&e.push(Ee(qe(d))));return new ve(c,e)};
	function De(a,b,c,d,e,f){var h=b.N;if(null!=d.lc(c))return b;var k;if(c.e())D(ke(b.w()),"If change path is empty, we must have complete server data"),le(b.w())?(e=re(b),d=d.rc(e instanceof O?e:L)):d=d.Aa(re(b)),f=a.U.ya(b.N.j(),d,f);else{var m=K(c);if(".priority"==m)D(1==Ec(c),"Can't have a priority with additional path components"),f=h.j(),k=b.w().j(),d=d.ad(c,f,k),f=null!=d?a.U.fa(f,d):h.j();else{var l=N(c);ne(h,m)?(k=b.w().j(),d=d.ad(c,h.j(),k),d=null!=d?h.j().Q(m).F(l,d):h.j().Q(m)):d=d.qc(m,
	b.w());f=null!=d?a.U.F(h.j(),m,d,l,e,f):h.j()}}return pe(b,f,h.da||c.e(),a.U.Na())}function ze(a,b,c,d,e,f,h,k){var m=b.w();h=h?a.U:a.U.Ub();if(c.e())d=h.ya(m.j(),d,null);else if(h.Na()&&!m.Sb)d=m.j().F(c,d),d=h.ya(m.j(),d,null);else{var l=K(c);if(!me(m,c)&&1<Ec(c))return b;var u=N(c);d=m.j().Q(l).F(u,d);d=".priority"==l?h.fa(m.j(),d):h.F(m.j(),l,d,u,te,null)}m=m.da||c.e();b=new oe(b.N,new je(d,m,h.Na()));return De(a,b,c,e,new ue(e,b,f),k)}
	function ye(a,b,c,d,e,f,h){var k=b.N;e=new ue(e,b,f);if(c.e())h=a.U.ya(b.N.j(),d,h),a=pe(b,h,!0,a.U.Na());else if(f=K(c),".priority"===f)h=a.U.fa(b.N.j(),d),a=pe(b,h,k.da,k.Sb);else{c=N(c);var m=k.j().Q(f);if(!c.e()){var l=e.Te(f);d=null!=l?".priority"===Oc(c)&&l.P(c.parent()).e()?l:l.F(c,d):L}m.Z(d)?a=b:(h=a.U.F(k.j(),f,d,c,e,h),a=pe(b,h,k.da,a.U.Na()))}return a}
	function Ae(a,b,c,d,e,f,h){var k=b;Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))&&(k=ye(a,k,u,l,e,f,h))});Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))||(k=ye(a,k,u,l,e,f,h))});return k}function Fe(a,b){Hd(b,function(b,d){a=a.F(b,d)});return a}
	function Be(a,b,c,d,e,f,h,k){if(b.w().j().e()&&!ke(b.w()))return b;var m=b;c=c.e()?d:Ad(R,c,d);var l=b.w().j();c.children.ha(function(c,d){if(l.Da(c)){var F=b.w().j().Q(c),F=Fe(F,d);m=ze(a,m,new E(c),F,e,f,h,k)}});c.children.ha(function(c,d){var F=!ne(b.w(),c)&&null==d.value;l.Da(c)||F||(F=b.w().j().Q(c),F=Fe(F,d),m=ze(a,m,new E(c),F,e,f,h,k))});return m}
	function Ce(a,b,c,d,e,f,h){if(null!=e.lc(c))return b;var k=le(b.w()),m=b.w();if(null!=d.value){if(c.e()&&m.da||me(m,c))return ze(a,b,c,m.j().P(c),e,f,k,h);if(c.e()){var l=R;m.j().O(tc,function(a,b){l=l.set(new E(a),b)});return Be(a,b,c,l,e,f,k,h)}return b}l=R;Hd(d,function(a){var b=c.n(a);me(m,b)&&(l=l.set(a,m.j().P(b)))});return Be(a,b,c,l,e,f,k,h)};function Ge(a){this.V=a;this.g=a.m.g}function He(a,b,c,d){var e=[],f=[];ya(b,function(b){b.type===Ie&&a.g.nd(b.qe,b.Ja)&&f.push(new S(Je,b.Ja,b.Xa))});Ke(a,e,Le,b,d,c);Ke(a,e,Me,b,d,c);Ke(a,e,Je,f,d,c);Ke(a,e,Ie,b,d,c);Ke(a,e,Ne,b,d,c);return e}function Ke(a,b,c,d,e,f){d=za(d,function(a){return a.type===c});Ha(d,q(a.Ff,a));ya(d,function(c){var d=Oe(a,c,f);ya(e,function(e){e.nf(c.type)&&b.push(e.createEvent(d,a.V))})})}
	function Oe(a,b,c){"value"!==b.type&&"child_removed"!==b.type&&(b.Dd=c.Ve(b.Xa,b.Ja,a.g));return b}Ge.prototype.Ff=function(a,b){if(null==a.Xa||null==b.Xa)throw Mb("Should only compare child_ events.");return this.g.compare(new C(a.Xa,a.Ja),new C(b.Xa,b.Ja))};function Pe(a,b){this.V=a;var c=a.m,d=new Qe(c.g),c=T(c)?new Qe(c.g):c.xa?new Re(c):new Se(c);this.hf=new we(c);var e=b.w(),f=b.N,h=d.ya(L,e.j(),null),k=c.ya(L,f.j(),null);this.Ka=new oe(new je(k,f.da,c.Na()),new je(h,e.da,d.Na()));this.Za=[];this.Jf=new Ge(a)}function Te(a){return a.V}g=Pe.prototype;g.w=function(){return this.Ka.w().j()};g.hb=function(a){var b=re(this.Ka);return b&&(T(this.V.m)||!a.e()&&!b.Q(K(a)).e())?b.P(a):null};g.e=function(){return 0===this.Za.length};g.Nb=function(a){this.Za.push(a)};
	g.kb=function(a,b){var c=[];if(b){D(null==a,"A cancel should cancel all event registrations.");var d=this.V.path;ya(this.Za,function(a){(a=a.Me(b,d))&&c.push(a)})}if(a){for(var e=[],f=0;f<this.Za.length;++f){var h=this.Za[f];if(!h.matches(a))e.push(h);else if(a.Xe()){e=e.concat(this.Za.slice(f+1));break}}this.Za=e}else this.Za=[];return c};
	g.eb=function(a,b,c){a.type===be&&null!==a.source.Hb&&(D(re(this.Ka),"We should always have a full cache before handling merges"),D(qe(this.Ka),"Missing event cache, even though we have a server cache"));var d=this.Ka;a=this.hf.eb(d,a,b,c);b=this.hf;c=a.Sd;D(c.N.j().yc(b.U.g),"Event snap not indexed");D(c.w().j().yc(b.U.g),"Server snap not indexed");D(ke(a.Sd.w())||!ke(d.w()),"Once a server snap is complete, it should never go back");this.Ka=a.Sd;return Ue(this,a.Df,a.Sd.N.j(),null)};
	function Ve(a,b){var c=a.Ka.N,d=[];c.j().J()||c.j().O(H,function(a,b){d.push(new S(Me,b,a))});c.da&&d.push(Ee(c.j()));return Ue(a,d,c.j(),b)}function Ue(a,b,c,d){return He(a.Jf,b,c,d?[d]:a.Za)};function We(a,b,c,d){this.ae=b;this.Md=c;this.Dd=d;this.hd=a}We.prototype.Yb=function(){var a=this.Md.wb();return"value"===this.hd?a.path:a.getParent().path};We.prototype.ge=function(){return this.hd};We.prototype.Tb=function(){return this.ae.Tb(this)};We.prototype.toString=function(){return this.Yb().toString()+":"+this.hd+":"+x(this.Md.be())};function Xe(a,b,c){this.ae=a;this.error=b;this.path=c}Xe.prototype.Yb=function(){return this.path};Xe.prototype.ge=function(){return"cancel"};
	Xe.prototype.Tb=function(){return this.ae.Tb(this)};Xe.prototype.toString=function(){return this.path.toString()+":cancel"};function Ye(){this.vb=[]}function Ze(a,b){for(var c=null,d=0;d<b.length;d++){var e=b[d],f=e.Yb();null===c||f.Z(c.Yb())||(a.vb.push(c),c=null);null===c&&(c=new $e(f));c.add(e)}c&&a.vb.push(c)}function af(a,b,c){Ze(a,c);bf(a,function(a){return a.Z(b)})}function cf(a,b,c){Ze(a,c);bf(a,function(a){return a.contains(b)||b.contains(a)})}
	function bf(a,b){for(var c=!0,d=0;d<a.vb.length;d++){var e=a.vb[d];if(e)if(e=e.Yb(),b(e)){for(var e=a.vb[d],f=0;f<e.jd.length;f++){var h=e.jd[f];if(null!==h){e.jd[f]=null;var k=h.Tb();Qb&&I("event: "+h.toString());fc(k)}}a.vb[d]=null}else c=!1}c&&(a.vb=[])}function $e(a){this.qa=a;this.jd=[]}$e.prototype.add=function(a){this.jd.push(a)};$e.prototype.Yb=function(){return this.qa};function Qe(a){this.g=a}g=Qe.prototype;g.F=function(a,b,c,d,e,f){D(a.yc(this.g),"A node must be indexed if only a child is updated");e=a.Q(b);if(e.P(d).Z(c.P(d))&&e.e()==c.e())return a;null!=f&&(c.e()?a.Da(b)?df(f,new S(Le,e,b)):D(a.J(),"A child remove without an old child only makes sense on a leaf node"):e.e()?df(f,new S(Me,c,b)):df(f,new S(Ie,c,b,e)));return a.J()&&c.e()?a:a.T(b,c).nb(this.g)};
	g.ya=function(a,b,c){null!=c&&(a.J()||a.O(H,function(a,e){b.Da(a)||df(c,new S(Le,e,a))}),b.J()||b.O(H,function(b,e){if(a.Da(b)){var f=a.Q(b);f.Z(e)||df(c,new S(Ie,e,b,f))}else df(c,new S(Me,e,b))}));return b.nb(this.g)};g.fa=function(a,b){return a.e()?L:a.fa(b)};g.Na=function(){return!1};g.Ub=function(){return this};function Se(a){this.he=new Qe(a.g);this.g=a.g;var b;a.ka?(b=ef(a),b=a.g.Ec(ff(a),b)):b=a.g.Hc();this.Uc=b;a.na?(b=gf(a),a=a.g.Ec(hf(a),b)):a=a.g.Fc();this.vc=a}g=Se.prototype;g.matches=function(a){return 0>=this.g.compare(this.Uc,a)&&0>=this.g.compare(a,this.vc)};g.F=function(a,b,c,d,e,f){this.matches(new C(b,c))||(c=L);return this.he.F(a,b,c,d,e,f)};
	g.ya=function(a,b,c){b.J()&&(b=L);var d=b.nb(this.g),d=d.fa(L),e=this;b.O(H,function(a,b){e.matches(new C(a,b))||(d=d.T(a,L))});return this.he.ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.he};function Re(a){this.sa=new Se(a);this.g=a.g;D(a.xa,"Only valid if limit has been set");this.oa=a.oa;this.Ib=!jf(a)}g=Re.prototype;g.F=function(a,b,c,d,e,f){this.sa.matches(new C(b,c))||(c=L);return a.Q(b).Z(c)?a:a.Eb()<this.oa?this.sa.Ub().F(a,b,c,d,e,f):kf(this,a,b,c,e,f)};
	g.ya=function(a,b,c){var d;if(b.J()||b.e())d=L.nb(this.g);else if(2*this.oa<b.Eb()&&b.yc(this.g)){d=L.nb(this.g);b=this.Ib?b.Zb(this.sa.vc,this.g):b.Xb(this.sa.Uc,this.g);for(var e=0;0<b.Pa.length&&e<this.oa;){var f=M(b),h;if(h=this.Ib?0>=this.g.compare(this.sa.Uc,f):0>=this.g.compare(f,this.sa.vc))d=d.T(f.name,f.R),e++;else break}}else{d=b.nb(this.g);d=d.fa(L);var k,m,l;if(this.Ib){b=d.We(this.g);k=this.sa.vc;m=this.sa.Uc;var u=nc(this.g);l=function(a,b){return u(b,a)}}else b=d.Wb(this.g),k=this.sa.Uc,
	m=this.sa.vc,l=nc(this.g);for(var e=0,z=!1;0<b.Pa.length;)f=M(b),!z&&0>=l(k,f)&&(z=!0),(h=z&&e<this.oa&&0>=l(f,m))?e++:d=d.T(f.name,L)}return this.sa.Ub().ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.sa.Ub()};
	function kf(a,b,c,d,e,f){var h;if(a.Ib){var k=nc(a.g);h=function(a,b){return k(b,a)}}else h=nc(a.g);D(b.Eb()==a.oa,"");var m=new C(c,d),l=a.Ib?pd(b,a.g):qd(b,a.g),u=a.sa.matches(m);if(b.Da(c)){for(var z=b.Q(c),l=e.fe(a.g,l,a.Ib);null!=l&&(l.name==c||b.Da(l.name));)l=e.fe(a.g,l,a.Ib);e=null==l?1:h(l,m);if(u&&!d.e()&&0<=e)return null!=f&&df(f,new S(Ie,d,c,z)),b.T(c,d);null!=f&&df(f,new S(Le,z,c));b=b.T(c,L);return null!=l&&a.sa.matches(l)?(null!=f&&df(f,new S(Me,l.R,l.name)),b.T(l.name,l.R)):b}return d.e()?
	b:u&&0<=h(l,m)?(null!=f&&(df(f,new S(Le,l.R,l.name)),df(f,new S(Me,d,c))),b.T(c,d).T(l.name,L)):b};function S(a,b,c,d){this.type=a;this.Ja=b;this.Xa=c;this.qe=d;this.Dd=void 0}function Ee(a){return new S(Ne,a)}var Me="child_added",Le="child_removed",Ie="child_changed",Je="child_moved",Ne="value";function xe(){this.fb={}}
	function df(a,b){var c=b.type,d=b.Xa;D(c==Me||c==Ie||c==Le,"Only child changes supported for tracking");D(".priority"!==d,"Only non-priority child changes can be tracked.");var e=w(a.fb,d);if(e){var f=e.type;if(c==Me&&f==Le)a.fb[d]=new S(Ie,b.Ja,d,e.Ja);else if(c==Le&&f==Me)delete a.fb[d];else if(c==Le&&f==Ie)a.fb[d]=new S(Le,e.qe,d);else if(c==Ie&&f==Me)a.fb[d]=new S(Me,b.Ja,d);else if(c==Ie&&f==Ie)a.fb[d]=new S(Ie,b.Ja,d,e.qe);else throw Mb("Illegal combination of changes: "+b+" occurred after "+
	e);}else a.fb[d]=b};function lf(){this.Rb=this.na=this.Kb=this.ka=this.xa=!1;this.oa=0;this.mb="";this.dc=null;this.zb="";this.ac=null;this.xb="";this.g=H}var mf=new lf;function jf(a){return""===a.mb?a.ka:"l"===a.mb}function ff(a){D(a.ka,"Only valid if start has been set");return a.dc}function ef(a){D(a.ka,"Only valid if start has been set");return a.Kb?a.zb:"[MIN_NAME]"}function hf(a){D(a.na,"Only valid if end has been set");return a.ac}
	function gf(a){D(a.na,"Only valid if end has been set");return a.Rb?a.xb:"[MAX_NAME]"}function nf(a){var b=new lf;b.xa=a.xa;b.oa=a.oa;b.ka=a.ka;b.dc=a.dc;b.Kb=a.Kb;b.zb=a.zb;b.na=a.na;b.ac=a.ac;b.Rb=a.Rb;b.xb=a.xb;b.g=a.g;b.mb=a.mb;return b}g=lf.prototype;g.ne=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="l";return b};g.oe=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="r";return b};g.Nd=function(a,b){var c=nf(this);c.ka=!0;n(a)||(a=null);c.dc=a;null!=b?(c.Kb=!0,c.zb=b):(c.Kb=!1,c.zb="");return c};
	g.gd=function(a,b){var c=nf(this);c.na=!0;n(a)||(a=null);c.ac=a;n(b)?(c.Rb=!0,c.xb=b):(c.vg=!1,c.xb="");return c};function of(a,b){var c=nf(a);c.g=b;return c}function pf(a){var b={};a.ka&&(b.sp=a.dc,a.Kb&&(b.sn=a.zb));a.na&&(b.ep=a.ac,a.Rb&&(b.en=a.xb));if(a.xa){b.l=a.oa;var c=a.mb;""===c&&(c=jf(a)?"l":"r");b.vf=c}a.g!==H&&(b.i=a.g.toString());return b}function T(a){return!(a.ka||a.na||a.xa)}function qf(a){return T(a)&&a.g==H}
	function rf(a){var b={};if(qf(a))return b;var c;a.g===H?c="$priority":a.g===wc?c="$value":a.g===tc?c="$key":(D(a.g instanceof pc,"Unrecognized index type!"),c=a.g.toString());b.orderBy=x(c);a.ka&&(b.startAt=x(a.dc),a.Kb&&(b.startAt+=","+x(a.zb)));a.na&&(b.endAt=x(a.ac),a.Rb&&(b.endAt+=","+x(a.xb)));a.xa&&(jf(a)?b.limitToFirst=a.oa:b.limitToLast=a.oa);return b}g.toString=function(){return x(pf(this))};function sf(a){this.W=a}var tf=new sf(new vd(null));function uf(a,b,c){if(b.e())return new sf(new vd(c));var d=zd(a.W,b);if(null!=d){var e=d.path,d=d.value;b=P(e,b);d=d.F(b,c);return new sf(a.W.set(e,d))}a=Ad(a.W,b,new vd(c));return new sf(a)}function vf(a,b,c){var d=a;fb(c,function(a,c){d=uf(d,b.n(a),c)});return d}sf.prototype.Ed=function(a){if(a.e())return tf;a=Ad(this.W,a,R);return new sf(a)};function wf(a,b){var c=zd(a.W,b);return null!=c?a.W.get(c.path).P(P(c.path,b)):null}
	function xf(a){var b=[],c=a.W.value;null!=c?c.J()||c.O(H,function(a,c){b.push(new C(a,c))}):a.W.children.ha(function(a,c){null!=c.value&&b.push(new C(a,c.value))});return b}function yf(a,b){if(b.e())return a;var c=wf(a,b);return null!=c?new sf(new vd(c)):new sf(a.W.subtree(b))}sf.prototype.e=function(){return this.W.e()};sf.prototype.apply=function(a){return zf(Q,this.W,a)};
	function zf(a,b,c){if(null!=b.value)return c.F(a,b.value);var d=null;b.children.ha(function(b,f){".priority"===b?(D(null!==f.value,"Priority writes must always be leaf nodes"),d=f.value):c=zf(a.n(b),f,c)});c.P(a).e()||null===d||(c=c.F(a.n(".priority"),d));return c};function Af(){this.Jd=L}Af.prototype.j=function(a){return this.Jd.P(a)};Af.prototype.toString=function(){return this.Jd.toString()};function Bf(a){this.oc=a}Bf.prototype.getToken=function(a){return this.oc.INTERNAL.getToken(a).then(null,function(a){return a&&"auth/token-not-initialized"===a.code?(I("Got auth/token-not-initialized error.  Treating as null token."),null):Promise.reject(a)})};function Cf(a,b){a.oc.INTERNAL.addAuthTokenListener(b)};function Df(){this.S=tf;this.la=[];this.Bc=-1}function Ef(a,b){for(var c=0;c<a.la.length;c++){var d=a.la[c];if(d.Zc===b)return d}return null}g=Df.prototype;
	g.Ed=function(a){var b=Ea(this.la,function(b){return b.Zc===a});D(0<=b,"removeWrite called with nonexistent writeId.");var c=this.la[b];this.la.splice(b,1);for(var d=c.visible,e=!1,f=this.la.length-1;d&&0<=f;){var h=this.la[f];h.visible&&(f>=b&&Ff(h,c.path)?d=!1:c.path.contains(h.path)&&(e=!0));f--}if(d){if(e)this.S=Gf(this.la,Hf,Q),this.Bc=0<this.la.length?this.la[this.la.length-1].Zc:-1;else if(c.Ga)this.S=this.S.Ed(c.path);else{var k=this;v(c.children,function(a,b){k.S=k.S.Ed(c.path.n(b))})}return!0}return!1};
	g.Aa=function(a,b,c,d){if(c||d){var e=yf(this.S,a);return!d&&e.e()?b:d||null!=b||null!=wf(e,Q)?(e=Gf(this.la,function(b){return(b.visible||d)&&(!c||!(0<=xa(c,b.Zc)))&&(b.path.contains(a)||a.contains(b.path))},a),b=b||L,e.apply(b)):null}e=wf(this.S,a);if(null!=e)return e;e=yf(this.S,a);return e.e()?b:null!=b||null!=wf(e,Q)?(b=b||L,e.apply(b)):null};
	g.rc=function(a,b){var c=L,d=wf(this.S,a);if(d)d.J()||d.O(H,function(a,b){c=c.T(a,b)});else if(b){var e=yf(this.S,a);b.O(H,function(a,b){var d=yf(e,new E(a)).apply(b);c=c.T(a,d)});ya(xf(e),function(a){c=c.T(a.name,a.R)})}else e=yf(this.S,a),ya(xf(e),function(a){c=c.T(a.name,a.R)});return c};g.ad=function(a,b,c,d){D(c||d,"Either existingEventSnap or existingServerSnap must exist");a=a.n(b);if(null!=wf(this.S,a))return null;a=yf(this.S,a);return a.e()?d.P(b):a.apply(d.P(b))};
	g.qc=function(a,b,c){a=a.n(b);var d=wf(this.S,a);return null!=d?d:ne(c,b)?yf(this.S,a).apply(c.j().Q(b)):null};g.lc=function(a){return wf(this.S,a)};g.Xd=function(a,b,c,d,e,f){var h;a=yf(this.S,a);h=wf(a,Q);if(null==h)if(null!=b)h=a.apply(b);else return[];h=h.nb(f);if(h.e()||h.J())return[];b=[];a=nc(f);e=e?h.Zb(c,f):h.Xb(c,f);for(f=M(e);f&&b.length<d;)0!==a(f,c)&&b.push(f),f=M(e);return b};
	function Ff(a,b){return a.Ga?a.path.contains(b):!!Qa(a.children,function(c,d){return a.path.n(d).contains(b)})}function Hf(a){return a.visible}
	function Gf(a,b,c){for(var d=tf,e=0;e<a.length;++e){var f=a[e];if(b(f)){var h=f.path;if(f.Ga)c.contains(h)?(h=P(c,h),d=uf(d,h,f.Ga)):h.contains(c)&&(h=P(h,c),d=uf(d,Q,f.Ga.P(h)));else if(f.children)if(c.contains(h))h=P(c,h),d=vf(d,h,f.children);else{if(h.contains(c))if(h=P(h,c),h.e())d=vf(d,Q,f.children);else if(f=w(f.children,K(h)))f=f.P(N(h)),d=uf(d,Q,f)}else throw Mb("WriteRecord should have .snap or .children");}}return d}function If(a,b){this.Lb=a;this.W=b}g=If.prototype;
	g.Aa=function(a,b,c){return this.W.Aa(this.Lb,a,b,c)};g.rc=function(a){return this.W.rc(this.Lb,a)};g.ad=function(a,b,c){return this.W.ad(this.Lb,a,b,c)};g.lc=function(a){return this.W.lc(this.Lb.n(a))};g.Xd=function(a,b,c,d,e){return this.W.Xd(this.Lb,a,b,c,d,e)};g.qc=function(a,b){return this.W.qc(this.Lb,a,b)};g.n=function(a){return new If(this.Lb.n(a),this.W)};function Jf(a,b){this.rf={};this.Vc=new Kf(a);this.va=b;var c=1E4+2E4*Math.random();hc(q(this.lf,this),Math.floor(c))}Jf.prototype.lf=function(){var a=this.Vc.get(),b={},c=!1,d;for(d in a)0<a[d]&&eb(this.rf,d)&&(b[d]=a[d],c=!0);c&&this.va.ye(b);hc(q(this.lf,this),Math.floor(6E5*Math.random()))};function Lf(){this.tc={}}function Mf(a,b,c){n(c)||(c=1);eb(a.tc,b)||(a.tc[b]=0);a.tc[b]+=c}Lf.prototype.get=function(){return Ta(this.tc)};function Kf(a){this.Ef=a;this.rd=null}Kf.prototype.get=function(){var a=this.Ef.get(),b=Ta(a);if(this.rd)for(var c in this.rd)b[c]-=this.rd[c];this.rd=a;return b};var Nf={},Of={};function Pf(a){a=a.toString();Nf[a]||(Nf[a]=new Lf);return Nf[a]}function Qf(a,b){var c=a.toString();Of[c]||(Of[c]=b());return Of[c]};function Rf(a,b,c){this.f=Tb("p:rest:");this.L=a;this.Gb=b;this.$c=c;this.$={}}function Sf(a,b){if(n(b))return"tag$"+b;D(qf(a.m),"should have a tag if it's not a default query.");return a.path.toString()}g=Rf.prototype;
	g.$e=function(a,b,c,d){var e=a.path.toString();this.f("Listen called for "+e+" "+a.ja());var f=Sf(a,c),h={};this.$[f]=h;a=rf(a.m);var k=this;Tf(this,e+".json",a,function(a,b){var u=b;404===a&&(a=u=null);null===a&&k.Gb(e,u,!1,c);w(k.$,f)===h&&d(a?401==a?"permission_denied":"rest_error:"+a:"ok",null)})};g.uf=function(a,b){var c=Sf(a,b);delete this.$[c]};g.kf=function(){};g.re=function(){};g.cf=function(){};g.xd=function(){};g.put=function(){};g.af=function(){};g.ye=function(){};
	function Tf(a,b,c,d){c=c||{};c.format="export";a.$c.getToken(!1).then(function(e){(e=e&&e.accessToken)&&(c.auth=e);var f=(a.L.Sc?"https://":"http://")+a.L.host+b+"?"+gb(c);a.f("Sending REST request for "+f);var h=new XMLHttpRequest;h.onreadystatechange=function(){if(d&&4===h.readyState){a.f("REST Response for "+f+" received. status:",h.status,"response:",h.responseText);var b=null;if(200<=h.status&&300>h.status){try{b=lb(h.responseText)}catch(c){J("Failed to parse JSON response for "+f+": "+h.responseText)}d(null,
	b)}else 401!==h.status&&404!==h.status&&J("Got unsuccessful REST response for "+f+" Status: "+h.status),d(h.status);d=null}};h.open("GET",f,!0);h.send()})};function Uf(a){this.te=a;this.Bd=[];this.Qb=0;this.Yd=-1;this.Fb=null}function Vf(a,b,c){a.Yd=b;a.Fb=c;a.Yd<a.Qb&&(a.Fb(),a.Fb=null)}function Wf(a,b,c){for(a.Bd[b]=c;a.Bd[a.Qb];){var d=a.Bd[a.Qb];delete a.Bd[a.Qb];for(var e=0;e<d.length;++e)if(d[e]){var f=a;fc(function(){f.te(d[e])})}if(a.Qb===a.Yd){a.Fb&&(clearTimeout(a.Fb),a.Fb(),a.Fb=null);break}a.Qb++}};var Cb="websocket",Db="long_polling";var Xf=null;"undefined"!==typeof MozWebSocket?Xf=MozWebSocket:"undefined"!==typeof WebSocket&&(Xf=WebSocket);function Yf(a,b,c,d){this.Zd=a;this.f=Tb(this.Zd);this.frames=this.zc=null;this.pb=this.qb=this.Fe=0;this.Va=Pf(b);a={v:"5"};"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");c&&(a.s=c);d&&(a.ls=d);this.Ke=Bb(b,Cb,a)}var Zf;
	Yf.prototype.open=function(a,b){this.ib=b;this.Xf=a;this.f("Websocket connecting to "+this.Ke);this.wc=!1;xb.set("previous_websocket_failure",!0);try{this.Ia=new Xf(this.Ke)}catch(c){this.f("Error instantiating WebSocket.");var d=c.message||c.data;d&&this.f(d);this.bb();return}var e=this;this.Ia.onopen=function(){e.f("Websocket connected.");e.wc=!0};this.Ia.onclose=function(){e.f("Websocket connection was disconnected.");e.Ia=null;e.bb()};this.Ia.onmessage=function(a){if(null!==e.Ia)if(a=a.data,e.pb+=
	a.length,Mf(e.Va,"bytes_received",a.length),$f(e),null!==e.frames)ag(e,a);else{a:{D(null===e.frames,"We already have a frame buffer");if(6>=a.length){var b=Number(a);if(!isNaN(b)){e.Fe=b;e.frames=[];a=null;break a}}e.Fe=1;e.frames=[]}null!==a&&ag(e,a)}};this.Ia.onerror=function(a){e.f("WebSocket error.  Closing connection.");(a=a.message||a.data)&&e.f(a);e.bb()}};Yf.prototype.start=function(){};
	Yf.isAvailable=function(){var a=!1;if("undefined"!==typeof navigator&&navigator.userAgent){var b=navigator.userAgent.match(/Android ([0-9]{0,}\.[0-9]{0,})/);b&&1<b.length&&4.4>parseFloat(b[1])&&(a=!0)}return!a&&null!==Xf&&!Zf};Yf.responsesRequiredToBeHealthy=2;Yf.healthyTimeout=3E4;g=Yf.prototype;g.sd=function(){xb.remove("previous_websocket_failure")};function ag(a,b){a.frames.push(b);if(a.frames.length==a.Fe){var c=a.frames.join("");a.frames=null;c=lb(c);a.Xf(c)}}
	g.send=function(a){$f(this);a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=bc(a,16384);1<a.length&&bg(this,String(a.length));for(var b=0;b<a.length;b++)bg(this,a[b])};g.Tc=function(){this.Ab=!0;this.zc&&(clearInterval(this.zc),this.zc=null);this.Ia&&(this.Ia.close(),this.Ia=null)};g.bb=function(){this.Ab||(this.f("WebSocket is closing itself"),this.Tc(),this.ib&&(this.ib(this.wc),this.ib=null))};g.close=function(){this.Ab||(this.f("WebSocket is being closed"),this.Tc())};
	function $f(a){clearInterval(a.zc);a.zc=setInterval(function(){a.Ia&&bg(a,"0");$f(a)},Math.floor(45E3))}function bg(a,b){try{a.Ia.send(b)}catch(c){a.f("Exception thrown from WebSocket.send():",c.message||c.data,"Closing connection."),setTimeout(q(a.bb,a),0)}};function cg(a,b,c,d){this.Zd=a;this.f=Tb(a);this.jc=b;this.pb=this.qb=0;this.Va=Pf(b);this.tf=c;this.wc=!1;this.Cb=d;this.Yc=function(a){return Bb(b,Db,a)}}var dg,eg;
	cg.prototype.open=function(a,b){this.Ne=0;this.ia=b;this.bf=new Uf(a);this.Ab=!1;var c=this;this.sb=setTimeout(function(){c.f("Timed out trying to connect.");c.bb();c.sb=null},Math.floor(3E4));Yb(function(){if(!c.Ab){c.Ta=new fg(function(a,b,d,k,m){gg(c,arguments);if(c.Ta)if(c.sb&&(clearTimeout(c.sb),c.sb=null),c.wc=!0,"start"==a)c.id=b,c.ff=d;else if("close"===a)b?(c.Ta.Kd=!1,Vf(c.bf,b,function(){c.bb()})):c.bb();else throw Error("Unrecognized command received: "+a);},function(a,b){gg(c,arguments);
	Wf(c.bf,a,b)},function(){c.bb()},c.Yc);var a={start:"t"};a.ser=Math.floor(1E8*Math.random());c.Ta.Qd&&(a.cb=c.Ta.Qd);a.v="5";c.tf&&(a.s=c.tf);c.Cb&&(a.ls=c.Cb);"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");a=c.Yc(a);c.f("Connecting via long-poll to "+a);hg(c.Ta,a,function(){})}})};
	cg.prototype.start=function(){var a=this.Ta,b=this.ff;a.Vf=this.id;a.Wf=b;for(a.Ud=!0;ig(a););a=this.id;b=this.ff;this.fc=document.createElement("iframe");var c={dframe:"t"};c.id=a;c.pw=b;this.fc.src=this.Yc(c);this.fc.style.display="none";document.body.appendChild(this.fc)};
	cg.isAvailable=function(){return dg||!eg&&"undefined"!==typeof document&&null!=document.createElement&&!("object"===typeof window&&window.chrome&&window.chrome.extension&&!/^chrome/.test(window.location.href))&&!("object"===typeof Windows&&"object"===typeof Windows.rg)&&!0};g=cg.prototype;g.sd=function(){};g.Tc=function(){this.Ab=!0;this.Ta&&(this.Ta.close(),this.Ta=null);this.fc&&(document.body.removeChild(this.fc),this.fc=null);this.sb&&(clearTimeout(this.sb),this.sb=null)};
	g.bb=function(){this.Ab||(this.f("Longpoll is closing itself"),this.Tc(),this.ia&&(this.ia(this.wc),this.ia=null))};g.close=function(){this.Ab||(this.f("Longpoll is being closed."),this.Tc())};g.send=function(a){a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=mb(a);a=ab(a,!0);a=bc(a,1840);for(var b=0;b<a.length;b++){var c=this.Ta;c.Qc.push({jg:this.Ne,pg:a.length,Pe:a[b]});c.Ud&&ig(c);this.Ne++}};function gg(a,b){var c=x(b).length;a.pb+=c;Mf(a.Va,"bytes_received",c)}
	function fg(a,b,c,d){this.Yc=d;this.ib=c;this.ve=new Gc;this.Qc=[];this.$d=Math.floor(1E8*Math.random());this.Kd=!0;this.Qd=Lb();window["pLPCommand"+this.Qd]=a;window["pRTLPCB"+this.Qd]=b;a=document.createElement("iframe");a.style.display="none";if(document.body){document.body.appendChild(a);try{a.contentWindow.document||I("No IE domain setting required")}catch(e){a.src="javascript:void((function(){document.open();document.domain='"+document.domain+"';document.close();})())"}}else throw"Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
	a.contentDocument?a.gb=a.contentDocument:a.contentWindow?a.gb=a.contentWindow.document:a.document&&(a.gb=a.document);this.Ea=a;a="";this.Ea.src&&"javascript:"===this.Ea.src.substr(0,11)&&(a='<script>document.domain="'+document.domain+'";\x3c/script>');a="<html><body>"+a+"</body></html>";try{this.Ea.gb.open(),this.Ea.gb.write(a),this.Ea.gb.close()}catch(f){I("frame writing exception"),f.stack&&I(f.stack),I(f)}}
	fg.prototype.close=function(){this.Ud=!1;if(this.Ea){this.Ea.gb.body.innerHTML="";var a=this;setTimeout(function(){null!==a.Ea&&(document.body.removeChild(a.Ea),a.Ea=null)},Math.floor(0))}var b=this.ib;b&&(this.ib=null,b())};
	function ig(a){if(a.Ud&&a.Kd&&a.ve.count()<(0<a.Qc.length?2:1)){a.$d++;var b={};b.id=a.Vf;b.pw=a.Wf;b.ser=a.$d;for(var b=a.Yc(b),c="",d=0;0<a.Qc.length;)if(1870>=a.Qc[0].Pe.length+30+c.length){var e=a.Qc.shift(),c=c+"&seg"+d+"="+e.jg+"&ts"+d+"="+e.pg+"&d"+d+"="+e.Pe;d++}else break;jg(a,b+c,a.$d);return!0}return!1}function jg(a,b,c){function d(){a.ve.remove(c);ig(a)}a.ve.add(c,1);var e=setTimeout(d,Math.floor(25E3));hg(a,b,function(){clearTimeout(e);d()})}
	function hg(a,b,c){setTimeout(function(){try{if(a.Kd){var d=a.Ea.gb.createElement("script");d.type="text/javascript";d.async=!0;d.src=b;d.onload=d.onreadystatechange=function(){var a=d.readyState;a&&"loaded"!==a&&"complete"!==a||(d.onload=d.onreadystatechange=null,d.parentNode&&d.parentNode.removeChild(d),c())};d.onerror=function(){I("Long-poll script failed to load: "+b);a.Kd=!1;a.close()};a.Ea.gb.body.appendChild(d)}}catch(e){}},Math.floor(1))};function kg(a){lg(this,a)}var mg=[cg,Yf];function lg(a,b){var c=Yf&&Yf.isAvailable(),d=c&&!(xb.Ze||!0===xb.get("previous_websocket_failure"));b.qg&&(c||J("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."),d=!0);if(d)a.Wc=[Yf];else{var e=a.Wc=[];cc(mg,function(a,b){b&&b.isAvailable()&&e.push(b)})}}function ng(a){if(0<a.Wc.length)return a.Wc[0];throw Error("No transports available");};function og(a,b,c,d,e,f,h){this.id=a;this.f=Tb("c:"+this.id+":");this.te=c;this.Lc=d;this.ia=e;this.se=f;this.L=b;this.Ad=[];this.Le=0;this.sf=new kg(b);this.Ua=0;this.Cb=h;this.f("Connection created");pg(this)}
	function pg(a){var b=ng(a.sf);a.I=new b("c:"+a.id+":"+a.Le++,a.L,void 0,a.Cb);a.xe=b.responsesRequiredToBeHealthy||0;var c=qg(a,a.I),d=rg(a,a.I);a.Xc=a.I;a.Rc=a.I;a.D=null;a.Bb=!1;setTimeout(function(){a.I&&a.I.open(c,d)},Math.floor(0));b=b.healthyTimeout||0;0<b&&(a.md=hc(function(){a.md=null;a.Bb||(a.I&&102400<a.I.pb?(a.f("Connection exceeded healthy timeout but has received "+a.I.pb+" bytes.  Marking connection healthy."),a.Bb=!0,a.I.sd()):a.I&&10240<a.I.qb?a.f("Connection exceeded healthy timeout but has sent "+
	a.I.qb+" bytes.  Leaving connection alive."):(a.f("Closing unhealthy connection after timeout."),a.close()))},Math.floor(b)))}function rg(a,b){return function(c){b===a.I?(a.I=null,c||0!==a.Ua?1===a.Ua&&a.f("Realtime connection lost."):(a.f("Realtime connection failed."),"s-"===a.L.$a.substr(0,2)&&(xb.remove("host:"+a.L.host),a.L.$a=a.L.host)),a.close()):b===a.D?(a.f("Secondary connection lost."),c=a.D,a.D=null,a.Xc!==c&&a.Rc!==c||a.close()):a.f("closing an old connection")}}
	function qg(a,b){return function(c){if(2!=a.Ua)if(b===a.Rc){var d=$b("t",c);c=$b("d",c);if("c"==d){if(d=$b("t",c),"d"in c)if(c=c.d,"h"===d){var d=c.ts,e=c.v,f=c.h;a.qf=c.s;Ab(a.L,f);0==a.Ua&&(a.I.start(),sg(a,a.I,d),"5"!==e&&J("Protocol version mismatch detected"),c=a.sf,(c=1<c.Wc.length?c.Wc[1]:null)&&tg(a,c))}else if("n"===d){a.f("recvd end transmission on primary");a.Rc=a.D;for(c=0;c<a.Ad.length;++c)a.wd(a.Ad[c]);a.Ad=[];ug(a)}else"s"===d?(a.f("Connection shutdown command received. Shutting down..."),
	a.se&&(a.se(c),a.se=null),a.ia=null,a.close()):"r"===d?(a.f("Reset packet received.  New host: "+c),Ab(a.L,c),1===a.Ua?a.close():(vg(a),pg(a))):"e"===d?Ub("Server Error: "+c):"o"===d?(a.f("got pong on primary."),wg(a),xg(a)):Ub("Unknown control packet command: "+d)}else"d"==d&&a.wd(c)}else if(b===a.D)if(d=$b("t",c),c=$b("d",c),"c"==d)"t"in c&&(c=c.t,"a"===c?yg(a):"r"===c?(a.f("Got a reset on secondary, closing it"),a.D.close(),a.Xc!==a.D&&a.Rc!==a.D||a.close()):"o"===c&&(a.f("got pong on secondary."),
	a.pf--,yg(a)));else if("d"==d)a.Ad.push(c);else throw Error("Unknown protocol layer: "+d);else a.f("message on old connection")}}og.prototype.ua=function(a){zg(this,{t:"d",d:a})};function ug(a){a.Xc===a.D&&a.Rc===a.D&&(a.f("cleaning up and promoting a connection: "+a.D.Zd),a.I=a.D,a.D=null)}
	function yg(a){0>=a.pf?(a.f("Secondary connection is healthy."),a.Bb=!0,a.D.sd(),a.D.start(),a.f("sending client ack on secondary"),a.D.send({t:"c",d:{t:"a",d:{}}}),a.f("Ending transmission on primary"),a.I.send({t:"c",d:{t:"n",d:{}}}),a.Xc=a.D,ug(a)):(a.f("sending ping on secondary."),a.D.send({t:"c",d:{t:"p",d:{}}}))}og.prototype.wd=function(a){wg(this);this.te(a)};function wg(a){a.Bb||(a.xe--,0>=a.xe&&(a.f("Primary connection is healthy."),a.Bb=!0,a.I.sd()))}
	function tg(a,b){a.D=new b("c:"+a.id+":"+a.Le++,a.L,a.qf);a.pf=b.responsesRequiredToBeHealthy||0;a.D.open(qg(a,a.D),rg(a,a.D));hc(function(){a.D&&(a.f("Timed out trying to upgrade."),a.D.close())},Math.floor(6E4))}function sg(a,b,c){a.f("Realtime connection established.");a.I=b;a.Ua=1;a.Lc&&(a.Lc(c,a.qf),a.Lc=null);0===a.xe?(a.f("Primary connection is healthy."),a.Bb=!0):hc(function(){xg(a)},Math.floor(5E3))}
	function xg(a){a.Bb||1!==a.Ua||(a.f("sending ping on primary."),zg(a,{t:"c",d:{t:"p",d:{}}}))}function zg(a,b){if(1!==a.Ua)throw"Connection is not connected";a.Xc.send(b)}og.prototype.close=function(){2!==this.Ua&&(this.f("Closing realtime connection."),this.Ua=2,vg(this),this.ia&&(this.ia(),this.ia=null))};function vg(a){a.f("Shutting down all connections");a.I&&(a.I.close(),a.I=null);a.D&&(a.D.close(),a.D=null);a.md&&(clearTimeout(a.md),a.md=null)};function Ag(a,b,c,d,e,f){this.id=Bg++;this.f=Tb("p:"+this.id+":");this.qd={};this.$={};this.pa=[];this.Oc=0;this.Kc=[];this.ma=!1;this.Sa=1E3;this.td=3E5;this.Gb=b;this.Jc=c;this.ue=d;this.L=a;this.ob=this.Fa=this.Cb=this.ze=null;this.$c=e;this.de=!1;this.ke=0;if(f)throw Error("Auth override specified in options, but not supported on non Node.js platforms");this.Vd=f;this.ub=null;this.Mb=!1;this.Gd={};this.ig=0;this.Re=!0;this.Ac=this.me=null;Cg(this,0);Mc.Vb().gc("visible",this.Zf,this);-1===a.host.indexOf("fblocal")&&
	Lc.Vb().gc("online",this.Yf,this)}var Bg=0,Dg=0;g=Ag.prototype;g.ua=function(a,b,c){var d=++this.ig;a={r:d,a:a,b:b};this.f(x(a));D(this.ma,"sendRequest call when we're not connected not allowed.");this.Fa.ua(a);c&&(this.Gd[d]=c)};
	g.$e=function(a,b,c,d){var e=a.ja(),f=a.path.toString();this.f("Listen called for "+f+" "+e);this.$[f]=this.$[f]||{};D(qf(a.m)||!T(a.m),"listen() called for non-default but complete query");D(!this.$[f][e],"listen() called twice for same path/queryId.");a={G:d,ld:b,eg:a,tag:c};this.$[f][e]=a;this.ma&&Eg(this,a)};
	function Eg(a,b){var c=b.eg,d=c.path.toString(),e=c.ja();a.f("Listen on "+d+" for "+e);var f={p:d};b.tag&&(f.q=pf(c.m),f.t=b.tag);f.h=b.ld();a.ua("q",f,function(f){var k=f.d,m=f.s;if(k&&"object"===typeof k&&eb(k,"w")){var l=w(k,"w");ea(l)&&0<=xa(l,"no_index")&&J("Using an unspecified index. Consider adding "+('".indexOn": "'+c.m.g.toString()+'"')+" at "+c.path.toString()+" to your security rules for better performance")}(a.$[d]&&a.$[d][e])===b&&(a.f("listen response",f),"ok"!==m&&Fg(a,d,e),b.G&&b.G(m,
	k))})}g.kf=function(a){this.ob=a;this.f("Auth token refreshed");this.ob?Gg(this):this.ma&&this.ua("unauth",{},function(){});if(a&&40===a.length||kc(a))this.f("Admin auth credential detected.  Reducing max reconnect time."),this.td=3E4};function Gg(a){if(a.ma&&a.ob){var b=a.ob,c=jc(b)?"auth":"gauth",d={cred:b};null===a.Vd?d.noauth=!0:"object"===typeof a.Vd&&(d.authvar=a.Vd);a.ua(c,d,function(c){var d=c.s;c=c.d||"error";a.ob===b&&("ok"===d?a.ke=0:Hg(a,d,c))})}}
	g.uf=function(a,b){var c=a.path.toString(),d=a.ja();this.f("Unlisten called for "+c+" "+d);D(qf(a.m)||!T(a.m),"unlisten() called for non-default but complete query");if(Fg(this,c,d)&&this.ma){var e=pf(a.m);this.f("Unlisten on "+c+" for "+d);c={p:c};b&&(c.q=e,c.t=b);this.ua("n",c)}};g.re=function(a,b,c){this.ma?Ig(this,"o",a,b,c):this.Kc.push({we:a,action:"o",data:b,G:c})};g.cf=function(a,b,c){this.ma?Ig(this,"om",a,b,c):this.Kc.push({we:a,action:"om",data:b,G:c})};
	g.xd=function(a,b){this.ma?Ig(this,"oc",a,null,b):this.Kc.push({we:a,action:"oc",data:null,G:b})};function Ig(a,b,c,d,e){c={p:c,d:d};a.f("onDisconnect "+b,c);a.ua(b,c,function(a){e&&setTimeout(function(){e(a.s,a.d)},Math.floor(0))})}g.put=function(a,b,c,d){Jg(this,"p",a,b,c,d)};g.af=function(a,b,c,d){Jg(this,"m",a,b,c,d)};function Jg(a,b,c,d,e,f){d={p:c,d:d};n(f)&&(d.h=f);a.pa.push({action:b,mf:d,G:e});a.Oc++;b=a.pa.length-1;a.ma?Kg(a,b):a.f("Buffering put: "+c)}
	function Kg(a,b){var c=a.pa[b].action,d=a.pa[b].mf,e=a.pa[b].G;a.pa[b].fg=a.ma;a.ua(c,d,function(d){a.f(c+" response",d);delete a.pa[b];a.Oc--;0===a.Oc&&(a.pa=[]);e&&e(d.s,d.d)})}g.ye=function(a){this.ma&&(a={c:a},this.f("reportStats",a),this.ua("s",a,function(a){"ok"!==a.s&&this.f("reportStats","Error sending stats: "+a.d)}))};
	g.wd=function(a){if("r"in a){this.f("from server: "+x(a));var b=a.r,c=this.Gd[b];c&&(delete this.Gd[b],c(a.b))}else{if("error"in a)throw"A server-side error has occurred: "+a.error;"a"in a&&(b=a.a,a=a.b,this.f("handleServerMessage",b,a),"d"===b?this.Gb(a.p,a.d,!1,a.t):"m"===b?this.Gb(a.p,a.d,!0,a.t):"c"===b?Lg(this,a.p,a.q):"ac"===b?Hg(this,a.s,a.d):"sd"===b?this.ze?this.ze(a):"msg"in a&&"undefined"!==typeof console&&console.log("FIREBASE: "+a.msg.replace("\n","\nFIREBASE: ")):Ub("Unrecognized action received from server: "+
	x(b)+"\nAre you using the latest client?"))}};g.Lc=function(a,b){this.f("connection ready");this.ma=!0;this.Ac=(new Date).getTime();this.ue({serverTimeOffset:a-(new Date).getTime()});this.Cb=b;if(this.Re){var c={};c["sdk.js."+firebase.SDK_VERSION.replace(/\./g,"-")]=1;pb()?c["framework.cordova"]=1:"object"===typeof navigator&&"ReactNative"===navigator.product&&(c["framework.reactnative"]=1);this.ye(c)}Mg(this);this.Re=!1;this.Jc(!0)};
	function Cg(a,b){D(!a.Fa,"Scheduling a connect when we're already connected/ing?");a.ub&&clearTimeout(a.ub);a.ub=setTimeout(function(){a.ub=null;Ng(a)},Math.floor(b))}g.Zf=function(a){a&&!this.Mb&&this.Sa===this.td&&(this.f("Window became visible.  Reducing delay."),this.Sa=1E3,this.Fa||Cg(this,0));this.Mb=a};g.Yf=function(a){a?(this.f("Browser went online."),this.Sa=1E3,this.Fa||Cg(this,0)):(this.f("Browser went offline.  Killing connection."),this.Fa&&this.Fa.close())};
	g.df=function(){this.f("data client disconnected");this.ma=!1;this.Fa=null;for(var a=0;a<this.pa.length;a++){var b=this.pa[a];b&&"h"in b.mf&&b.fg&&(b.G&&b.G("disconnect"),delete this.pa[a],this.Oc--)}0===this.Oc&&(this.pa=[]);this.Gd={};Og(this)&&(this.Mb?this.Ac&&(3E4<(new Date).getTime()-this.Ac&&(this.Sa=1E3),this.Ac=null):(this.f("Window isn't visible.  Delaying reconnect."),this.Sa=this.td,this.me=(new Date).getTime()),a=Math.max(0,this.Sa-((new Date).getTime()-this.me)),a*=Math.random(),this.f("Trying to reconnect in "+
	a+"ms"),Cg(this,a),this.Sa=Math.min(this.td,1.3*this.Sa));this.Jc(!1)};
	function Ng(a){if(Og(a)){a.f("Making a connection attempt");a.me=(new Date).getTime();a.Ac=null;var b=q(a.wd,a),c=q(a.Lc,a),d=q(a.df,a),e=a.id+":"+Dg++,f=a.Cb,h=!1,k=null,m=function(){k?k.close():(h=!0,d())};a.Fa={close:m,ua:function(a){D(k,"sendRequest call when we're not connected not allowed.");k.ua(a)}};var l=a.de;a.de=!1;a.$c.getToken(l).then(function(l){h?I("getToken() completed but was canceled"):(I("getToken() completed. Creating connection."),a.ob=l&&l.accessToken,k=new og(e,a.L,b,c,d,function(b){J(b+
	" ("+a.L.toString()+")");a.ab("server_kill")},f))}).then(null,function(b){a.f("Failed to get token: "+b);h||m()})}}g.ab=function(a){I("Interrupting connection for reason: "+a);this.qd[a]=!0;this.Fa?this.Fa.close():(this.ub&&(clearTimeout(this.ub),this.ub=null),this.ma&&this.df())};g.kc=function(a){I("Resuming connection for reason: "+a);delete this.qd[a];Sa(this.qd)&&(this.Sa=1E3,this.Fa||Cg(this,0))};
	function Lg(a,b,c){c=c?Aa(c,function(a){return ac(a)}).join("$"):"default";(a=Fg(a,b,c))&&a.G&&a.G("permission_denied")}function Fg(a,b,c){b=(new E(b)).toString();var d;n(a.$[b])?(d=a.$[b][c],delete a.$[b][c],0===La(a.$[b])&&delete a.$[b]):d=void 0;return d}
	function Hg(a,b,c){I("Auth token revoked: "+b+"/"+c);a.ob=null;a.de=!0;a.Fa.close();if("invalid_token"===b||"permission_denied"===b)a.ke++,3<=a.ke&&(a.Sa=3E4,a=a.$c,b='Provided authentication credentials for the app named "'+a.oc.name+'" are invalid. This usually indicates your app was not initialized correctly. ',b="credential"in a.oc.options?b+'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':"serviceAccount"in
	a.oc.options?b+'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':b+'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.',J(b))}
	function Mg(a){Gg(a);v(a.$,function(b){v(b,function(b){Eg(a,b)})});for(var b=0;b<a.pa.length;b++)a.pa[b]&&Kg(a,b);for(;a.Kc.length;)b=a.Kc.shift(),Ig(a,b.action,b.we,b.data,b.G)}function Og(a){var b;b=Lc.Vb().hc;return Sa(a.qd)&&b};function Pg(a){a instanceof Qg||Vb("Don't call new Database() directly - please use firebase.database().");this.ta=a;this.ba=new U(a,Q);this.INTERNAL=new Rg(this)}var Sg={TIMESTAMP:{".sv":"timestamp"}};g=Pg.prototype;g.app=null;g.jf=function(a){Tg(this,"ref");y("database.ref",0,1,arguments.length);return n(a)?this.ba.n(a):this.ba};
	g.gg=function(a){Tg(this,"database.refFromURL");y("database.refFromURL",1,1,arguments.length);var b=Wb(a);Xd("database.refFromURL",b);var c=b.jc;c.host!==this.ta.L.host&&Vb("database.refFromURL: Host name does not match the current database: (found "+c.host+" but expected "+this.ta.L.host+")");return this.jf(b.path.toString())};function Tg(a,b){null===a.ta&&Vb("Cannot call "+b+" on a deleted database.")}g.Pf=function(){y("database.goOffline",0,0,arguments.length);Tg(this,"goOffline");this.ta.ab()};
	g.Qf=function(){y("database.goOnline",0,0,arguments.length);Tg(this,"goOnline");this.ta.kc()};Object.defineProperty(Pg.prototype,"app",{get:function(){return this.ta.app}});function Rg(a){this.Ya=a}Rg.prototype.delete=function(){Tg(this.Ya,"delete");var a=Ug.Vb(),b=this.Ya.ta;w(a.lb,b.app.name)!==b&&Vb("Database "+b.app.name+" has already been deleted.");b.ab();delete a.lb[b.app.name];this.Ya.ta=null;this.Ya.ba=null;this.Ya=this.Ya.INTERNAL=null;return firebase.Promise.resolve()};
	Pg.prototype.ref=Pg.prototype.jf;Pg.prototype.refFromURL=Pg.prototype.gg;Pg.prototype.goOnline=Pg.prototype.Qf;Pg.prototype.goOffline=Pg.prototype.Pf;Rg.prototype["delete"]=Rg.prototype.delete;function V(a,b,c){this.A=a;this.V=b;this.g=c}V.prototype.H=function(){y("Firebase.DataSnapshot.val",0,0,arguments.length);return this.A.H()};V.prototype.val=V.prototype.H;V.prototype.be=function(){y("Firebase.DataSnapshot.exportVal",0,0,arguments.length);return this.A.H(!0)};V.prototype.exportVal=V.prototype.be;V.prototype.toJSON=function(){y("Firebase.DataSnapshot.toJSON",0,1,arguments.length);return this.be()};V.prototype.toJSON=V.prototype.toJSON;
	V.prototype.Lf=function(){y("Firebase.DataSnapshot.exists",0,0,arguments.length);return!this.A.e()};V.prototype.exists=V.prototype.Lf;V.prototype.n=function(a){y("Firebase.DataSnapshot.child",0,1,arguments.length);ga(a)&&(a=String(a));Vd("Firebase.DataSnapshot.child",a);var b=new E(a),c=this.V.n(b);return new V(this.A.P(b),c,H)};V.prototype.child=V.prototype.n;
	V.prototype.Da=function(a){y("Firebase.DataSnapshot.hasChild",1,1,arguments.length);Vd("Firebase.DataSnapshot.hasChild",a);var b=new E(a);return!this.A.P(b).e()};V.prototype.hasChild=V.prototype.Da;V.prototype.C=function(){y("Firebase.DataSnapshot.getPriority",0,0,arguments.length);return this.A.C().H()};V.prototype.getPriority=V.prototype.C;
	V.prototype.forEach=function(a){y("Firebase.DataSnapshot.forEach",1,1,arguments.length);B("Firebase.DataSnapshot.forEach",1,a,!1);if(this.A.J())return!1;var b=this;return!!this.A.O(this.g,function(c,d){return a(new V(d,b.V.n(c),H))})};V.prototype.forEach=V.prototype.forEach;V.prototype.kd=function(){y("Firebase.DataSnapshot.hasChildren",0,0,arguments.length);return this.A.J()?!1:!this.A.e()};V.prototype.hasChildren=V.prototype.kd;
	V.prototype.getKey=function(){y("Firebase.DataSnapshot.key",0,0,arguments.length);return this.V.getKey()};gc(V.prototype,"key",V.prototype.getKey);V.prototype.Eb=function(){y("Firebase.DataSnapshot.numChildren",0,0,arguments.length);return this.A.Eb()};V.prototype.numChildren=V.prototype.Eb;V.prototype.wb=function(){y("Firebase.DataSnapshot.ref",0,0,arguments.length);return this.V};gc(V.prototype,"ref",V.prototype.wb);function Vg(a,b,c){this.Pb=a;this.rb=b;this.tb=c||null}g=Vg.prototype;g.nf=function(a){return"value"===a};g.createEvent=function(a,b){var c=b.m.g;return new We("value",this,new V(a.Ja,b.wb(),c))};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.Pb;return function(){d.call(b,a.Md)}};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
	g.matches=function(a){return a instanceof Vg?a.Pb&&this.Pb?a.Pb===this.Pb&&a.tb===this.tb:!0:!1};g.Xe=function(){return null!==this.Pb};function Wg(a,b,c){this.ga=a;this.rb=b;this.tb=c}g=Wg.prototype;g.nf=function(a){a="children_added"===a?"child_added":a;return("children_removed"===a?"child_removed":a)in this.ga};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
	g.createEvent=function(a,b){D(null!=a.Xa,"Child events should have a childName.");var c=b.wb().n(a.Xa);return new We(a.type,this,new V(a.Ja,c,b.m.g),a.Dd)};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.ga[a.hd];return function(){d.call(b,a.Md,a.Dd)}};
	g.matches=function(a){if(a instanceof Wg){if(!this.ga||!a.ga)return!0;if(this.tb===a.tb){var b=La(a.ga);if(b===La(this.ga)){if(1===b){var b=Ma(a.ga),c=Ma(this.ga);return c===b&&(!a.ga[b]||!this.ga[c]||a.ga[b]===this.ga[c])}return Ka(this.ga,function(b,c){return a.ga[c]===b})}}}return!1};g.Xe=function(){return null!==this.ga};function Xg(){this.za={}}g=Xg.prototype;g.e=function(){return Sa(this.za)};g.eb=function(a,b,c){var d=a.source.Hb;if(null!==d)return d=w(this.za,d),D(null!=d,"SyncTree gave us an op for an invalid query."),d.eb(a,b,c);var e=[];v(this.za,function(d){e=e.concat(d.eb(a,b,c))});return e};g.Nb=function(a,b,c,d,e){var f=a.ja(),h=w(this.za,f);if(!h){var h=c.Aa(e?d:null),k=!1;h?k=!0:(h=d instanceof O?c.rc(d):L,k=!1);h=new Pe(a,new oe(new je(h,k,!1),new je(d,e,!1)));this.za[f]=h}h.Nb(b);return Ve(h,b)};
	g.kb=function(a,b,c){var d=a.ja(),e=[],f=[],h=null!=Yg(this);if("default"===d){var k=this;v(this.za,function(a,d){f=f.concat(a.kb(b,c));a.e()&&(delete k.za[d],T(a.V.m)||e.push(a.V))})}else{var m=w(this.za,d);m&&(f=f.concat(m.kb(b,c)),m.e()&&(delete this.za[d],T(m.V.m)||e.push(m.V)))}h&&null==Yg(this)&&e.push(new U(a.u,a.path));return{hg:e,Kf:f}};function Zg(a){return za(Na(a.za),function(a){return!T(a.V.m)})}g.hb=function(a){var b=null;v(this.za,function(c){b=b||c.hb(a)});return b};
	function $g(a,b){if(T(b.m))return Yg(a);var c=b.ja();return w(a.za,c)}function Yg(a){return Ra(a.za,function(a){return T(a.V.m)})||null};function ah(a){this.wa=R;this.jb=new Df;this.De={};this.ic={};this.Cc=a}function bh(a,b,c,d,e){var f=a.jb,h=e;D(d>f.Bc,"Stacking an older write on top of newer ones");n(h)||(h=!0);f.la.push({path:b,Ga:c,Zc:d,visible:h});h&&(f.S=uf(f.S,b,c));f.Bc=d;return e?ch(a,new ce(fe,b,c)):[]}function dh(a,b,c,d){var e=a.jb;D(d>e.Bc,"Stacking an older merge on top of newer ones");e.la.push({path:b,children:c,Zc:d,visible:!0});e.S=vf(e.S,b,c);e.Bc=d;c=xd(c);return ch(a,new ae(fe,b,c))}
	function eh(a,b,c){c=c||!1;var d=Ef(a.jb,b);if(a.jb.Ed(b)){var e=R;null!=d.Ga?e=e.set(Q,!0):fb(d.children,function(a,b){e=e.set(new E(a),b)});return ch(a,new de(d.path,e,c))}return[]}function fh(a,b,c){c=xd(c);return ch(a,new ae(ie,b,c))}function gh(a,b,c,d){d=hh(a,d);if(null!=d){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=new ce(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
	function kh(a,b,c,d){if(d=hh(a,d)){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=xd(c);c=new ae(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
	ah.prototype.Nb=function(a,b){var c=a.path,d=null,e=!1;Fd(this.wa,c,function(a,b){var f=P(a,c);d=d||b.hb(f);e=e||null!=Yg(b)});var f=this.wa.get(c);f?(e=e||null!=Yg(f),d=d||f.hb(Q)):(f=new Xg,this.wa=this.wa.set(c,f));var h;null!=d?h=!0:(h=!1,d=L,Jd(this.wa.subtree(c),function(a,b){var c=b.hb(Q);c&&(d=d.T(a,c))}));var k=null!=$g(f,a);if(!k&&!T(a.m)){var m=lh(a);D(!(m in this.ic),"View does not exist, but we have a tag");var l=mh++;this.ic[m]=l;this.De["_"+l]=m}h=f.Nb(a,b,new If(c,this.jb),d,h);k||
	e||(f=$g(f,a),h=h.concat(nh(this,a,f)));return h};
	ah.prototype.kb=function(a,b,c){var d=a.path,e=this.wa.get(d),f=[];if(e&&("default"===a.ja()||null!=$g(e,a))){f=e.kb(a,b,c);e.e()&&(this.wa=this.wa.remove(d));e=f.hg;f=f.Kf;b=-1!==Ea(e,function(a){return T(a.m)});var h=Dd(this.wa,d,function(a,b){return null!=Yg(b)});if(b&&!h&&(d=this.wa.subtree(d),!d.e()))for(var d=oh(d),k=0;k<d.length;++k){var m=d[k],l=m.V,m=ph(this,m);this.Cc.Ae(qh(l),rh(this,l),m.ld,m.G)}if(!h&&0<e.length&&!c)if(b)this.Cc.Od(qh(a),null);else{var u=this;ya(e,function(a){a.ja();
	var b=u.ic[lh(a)];u.Cc.Od(qh(a),b)})}sh(this,e)}return f};ah.prototype.Aa=function(a,b){var c=this.jb,d=Dd(this.wa,a,function(b,c){var d=P(b,a);if(d=c.hb(d))return d});return c.Aa(a,d,b,!0)};function oh(a){return Bd(a,function(a,c,d){if(c&&null!=Yg(c))return[Yg(c)];var e=[];c&&(e=Zg(c));v(d,function(a){e=e.concat(a)});return e})}function sh(a,b){for(var c=0;c<b.length;++c){var d=b[c];if(!T(d.m)){var d=lh(d),e=a.ic[d];delete a.ic[d];delete a.De["_"+e]}}}
	function qh(a){return T(a.m)&&!qf(a.m)?a.wb():a}function nh(a,b,c){var d=b.path,e=rh(a,b);c=ph(a,c);b=a.Cc.Ae(qh(b),e,c.ld,c.G);d=a.wa.subtree(d);if(e)D(null==Yg(d.value),"If we're adding a query, it shouldn't be shadowed");else for(e=Bd(d,function(a,b,c){if(!a.e()&&b&&null!=Yg(b))return[Te(Yg(b))];var d=[];b&&(d=d.concat(Aa(Zg(b),function(a){return a.V})));v(c,function(a){d=d.concat(a)});return d}),d=0;d<e.length;++d)c=e[d],a.Cc.Od(qh(c),rh(a,c));return b}
	function ph(a,b){var c=b.V,d=rh(a,c);return{ld:function(){return(b.w()||L).hash()},G:function(b){if("ok"===b){if(d){var f=c.path;if(b=hh(a,d)){var h=ih(b);b=h.path;h=h.Hb;f=P(b,f);f=new Zd(new he(!1,!0,h,!0),f);b=jh(a,b,f)}else b=[]}else b=ch(a,new Zd(ie,c.path));return b}f="Unknown Error";"too_big"===b?f="The data requested exceeds the maximum size that can be accessed with a single request.":"permission_denied"==b?f="Client doesn't have permission to access the desired data.":"unavailable"==b&&
	(f="The service is unavailable");f=Error(b+" at "+c.path.toString()+": "+f);f.code=b.toUpperCase();return a.kb(c,null,f)}}}function lh(a){return a.path.toString()+"$"+a.ja()}function ih(a){var b=a.indexOf("$");D(-1!==b&&b<a.length-1,"Bad queryKey.");return{Hb:a.substr(b+1),path:new E(a.substr(0,b))}}function hh(a,b){var c=a.De,d="_"+b;return d in c?c[d]:void 0}function rh(a,b){var c=lh(b);return w(a.ic,c)}var mh=1;
	function jh(a,b,c){var d=a.wa.get(b);D(d,"Missing sync point for query tag that we're tracking");return d.eb(c,new If(b,a.jb),null)}function ch(a,b){return th(a,b,a.wa,null,new If(Q,a.jb))}function th(a,b,c,d,e){if(b.path.e())return uh(a,b,c,d,e);var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[],k=K(b.path),m=b.Mc(k);if((c=c.children.get(k))&&m)var l=d?d.Q(k):null,k=e.n(k),h=h.concat(th(a,m,c,l,k));f&&(h=h.concat(f.eb(b,e,d)));return h}
	function uh(a,b,c,d,e){var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[];c.children.ha(function(c,f){var l=d?d.Q(c):null,u=e.n(c),z=b.Mc(c);z&&(h=h.concat(uh(a,z,f,l,u)))});f&&(h=h.concat(f.eb(b,e,d)));return h};function Qg(a,b,c){this.app=c;var d=new Bf(c);this.L=a;this.Va=Pf(a);this.Vc=null;this.ca=new Ye;this.vd=1;this.Ra=null;if(b||0<=("object"===typeof window&&window.navigator&&window.navigator.userAgent||"").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i))this.va=new Rf(this.L,q(this.Gb,this),d),setTimeout(q(this.Jc,this,!0),0);else{b=c.options.databaseAuthVariableOverride;if("undefined"!==da(b)&&null!==b){if("object"!==da(b))throw Error("Only objects are supported for option databaseAuthVariableOverride");
	try{x(b)}catch(e){throw Error("Invalid authOverride provided: "+e);}}this.va=this.Ra=new Ag(this.L,q(this.Gb,this),q(this.Jc,this),q(this.ue,this),d,b)}var f=this;Cf(d,function(a){f.va.kf(a)});this.og=Qf(a,q(function(){return new Jf(this.Va,this.va)},this));this.mc=new Tc;this.ie=new Af;this.pd=new ah({Ae:function(a,b,c,d){b=[];c=f.ie.j(a.path);c.e()||(b=ch(f.pd,new ce(ie,a.path,c)),setTimeout(function(){d("ok")},0));return b},Od:ba});vh(this,"connected",!1);this.ia=new Gb;this.Ya=new Pg(this);this.fd=
	0;this.je=null;this.K=new ah({Ae:function(a,b,c,d){f.va.$e(a,c,b,function(b,c){var e=d(b,c);cf(f.ca,a.path,e)});return[]},Od:function(a,b){f.va.uf(a,b)}})}g=Qg.prototype;g.toString=function(){return(this.L.Sc?"https://":"http://")+this.L.host};g.name=function(){return this.L.pe};function wh(a){a=a.ie.j(new E(".info/serverTimeOffset")).H()||0;return(new Date).getTime()+a}function xh(a){a=a={timestamp:wh(a)};a.timestamp=a.timestamp||(new Date).getTime();return a}
	g.Gb=function(a,b,c,d){this.fd++;var e=new E(a);b=this.je?this.je(a,b):b;a=[];d?c?(b=Ja(b,function(a){return G(a)}),a=kh(this.K,e,b,d)):(b=G(b),a=gh(this.K,e,b,d)):c?(d=Ja(b,function(a){return G(a)}),a=fh(this.K,e,d)):(d=G(b),a=ch(this.K,new ce(ie,e,d)));d=e;0<a.length&&(d=yh(this,e));cf(this.ca,d,a)};g.Jc=function(a){vh(this,"connected",a);!1===a&&zh(this)};g.ue=function(a){var b=this;cc(a,function(a,d){vh(b,d,a)})};
	function vh(a,b,c){b=new E("/.info/"+b);c=G(c);var d=a.ie;d.Jd=d.Jd.F(b,c);c=ch(a.pd,new ce(ie,b,c));cf(a.ca,b,c)}g.Jb=function(a,b,c,d){this.f("set",{path:a.toString(),value:b,ug:c});var e=xh(this);b=G(b,c);var e=Jb(b,e),f=this.vd++,e=bh(this.K,a,e,f,!0);Ze(this.ca,e);var h=this;this.va.put(a.toString(),b.H(!0),function(b,c){var e="ok"===b;e||J("set at "+a+" failed: "+b);e=eh(h.K,f,!e);cf(h.ca,a,e);Ah(d,b,c)});e=Bh(this,a);yh(this,e);cf(this.ca,e,[])};
	g.update=function(a,b,c){this.f("update",{path:a.toString(),value:b});var d=!0,e=xh(this),f={};v(b,function(a,b){d=!1;var c=G(a);f[b]=Jb(c,e)});if(d)I("update() called with empty data.  Don't do anything."),Ah(c,"ok");else{var h=this.vd++,k=dh(this.K,a,f,h);Ze(this.ca,k);var m=this;this.va.af(a.toString(),b,function(b,d){var e="ok"===b;e||J("update at "+a+" failed: "+b);var e=eh(m.K,h,!e),f=a;0<e.length&&(f=yh(m,a));cf(m.ca,f,e);Ah(c,b,d)});v(b,function(b,c){var d=Bh(m,a.n(c));yh(m,d)});cf(this.ca,
	a,[])}};function zh(a){a.f("onDisconnectEvents");var b=xh(a),c=[];Hb(Fb(a.ia,b),Q,function(b,e){c=c.concat(ch(a.K,new ce(ie,b,e)));var f=Bh(a,b);yh(a,f)});a.ia=new Gb;cf(a.ca,Q,c)}g.xd=function(a,b){var c=this;this.va.xd(a.toString(),function(d,e){"ok"===d&&Yd(c.ia,a);Ah(b,d,e)})};function Ch(a,b,c,d){var e=G(c);a.va.re(b.toString(),e.H(!0),function(c,h){"ok"===c&&Ib(a.ia,b,e);Ah(d,c,h)})}
	function Dh(a,b,c,d,e){var f=G(c,d);a.va.re(b.toString(),f.H(!0),function(c,d){"ok"===c&&Ib(a.ia,b,f);Ah(e,c,d)})}function Eh(a,b,c,d){var e=!0,f;for(f in c)e=!1;e?(I("onDisconnect().update() called with empty data.  Don't do anything."),Ah(d,"ok")):a.va.cf(b.toString(),c,function(e,f){if("ok"===e)for(var m in c){var l=G(c[m]);Ib(a.ia,b.n(m),l)}Ah(d,e,f)})}function Fh(a,b,c){c=".info"===K(b.path)?a.pd.Nb(b,c):a.K.Nb(b,c);af(a.ca,b.path,c)}g.ab=function(){this.Ra&&this.Ra.ab("repo_interrupt")};
	g.kc=function(){this.Ra&&this.Ra.kc("repo_interrupt")};g.Be=function(a){if("undefined"!==typeof console){a?(this.Vc||(this.Vc=new Kf(this.Va)),a=this.Vc.get()):a=this.Va.get();var b=Ba(Oa(a),function(a,b){return Math.max(b.length,a)},0),c;for(c in a){for(var d=a[c],e=c.length;e<b+2;e++)c+=" ";console.log(c+d)}}};g.Ce=function(a){Mf(this.Va,a);this.og.rf[a]=!0};g.f=function(a){var b="";this.Ra&&(b=this.Ra.id+":");I(b,arguments)};
	function Ah(a,b,c){a&&fc(function(){if("ok"==b)a(null);else{var d=(b||"error").toUpperCase(),e=d;c&&(e+=": "+c);e=Error(e);e.code=d;a(e)}})};function Gh(a,b,c,d,e){function f(){}a.f("transaction on "+b);var h=new U(a,b);h.gc("value",f);c={path:b,update:c,G:d,status:null,ef:Lb(),He:e,of:0,Rd:function(){h.Ic("value",f)},Td:null,Ba:null,cd:null,dd:null,ed:null};d=a.K.Aa(b,void 0)||L;c.cd=d;d=c.update(d.H());if(n(d)){Pd("transaction failed: Data returned ",d,c.path);c.status=1;e=Uc(a.mc,b);var k=e.Ca()||[];k.push(c);Vc(e,k);"object"===typeof d&&null!==d&&eb(d,".priority")?(k=w(d,".priority"),D(Nd(k),"Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.")):
	k=(a.K.Aa(b)||L).C().H();e=xh(a);d=G(d,k);e=Jb(d,e);c.dd=d;c.ed=e;c.Ba=a.vd++;c=bh(a.K,b,e,c.Ba,c.He);cf(a.ca,b,c);Hh(a)}else c.Rd(),c.dd=null,c.ed=null,c.G&&(a=new V(c.cd,new U(a,c.path),H),c.G(null,!1,a))}function Hh(a,b){var c=b||a.mc;b||Ih(a,c);if(null!==c.Ca()){var d=Jh(a,c);D(0<d.length,"Sending zero length transaction queue");Ca(d,function(a){return 1===a.status})&&Kh(a,c.path(),d)}else c.kd()&&c.O(function(b){Hh(a,b)})}
	function Kh(a,b,c){for(var d=Aa(c,function(a){return a.Ba}),e=a.K.Aa(b,d)||L,d=e,e=e.hash(),f=0;f<c.length;f++){var h=c[f];D(1===h.status,"tryToSendTransactionQueue_: items in queue should all be run.");h.status=2;h.of++;var k=P(b,h.path),d=d.F(k,h.dd)}d=d.H(!0);a.va.put(b.toString(),d,function(d){a.f("transaction put response",{path:b.toString(),status:d});var e=[];if("ok"===d){d=[];for(f=0;f<c.length;f++){c[f].status=3;e=e.concat(eh(a.K,c[f].Ba));if(c[f].G){var h=c[f].ed,k=new U(a,c[f].path);d.push(q(c[f].G,
	null,null,!0,new V(h,k,H)))}c[f].Rd()}Ih(a,Uc(a.mc,b));Hh(a);cf(a.ca,b,e);for(f=0;f<d.length;f++)fc(d[f])}else{if("datastale"===d)for(f=0;f<c.length;f++)c[f].status=4===c[f].status?5:1;else for(J("transaction at "+b.toString()+" failed: "+d),f=0;f<c.length;f++)c[f].status=5,c[f].Td=d;yh(a,b)}},e)}function yh(a,b){var c=Lh(a,b),d=c.path(),c=Jh(a,c);Mh(a,c,d);return d}
	function Mh(a,b,c){if(0!==b.length){for(var d=[],e=[],f=za(b,function(a){return 1===a.status}),f=Aa(f,function(a){return a.Ba}),h=0;h<b.length;h++){var k=b[h],m=P(c,k.path),l=!1,u;D(null!==m,"rerunTransactionsUnderNode_: relativePath should not be null.");if(5===k.status)l=!0,u=k.Td,e=e.concat(eh(a.K,k.Ba,!0));else if(1===k.status)if(25<=k.of)l=!0,u="maxretry",e=e.concat(eh(a.K,k.Ba,!0));else{var z=a.K.Aa(k.path,f)||L;k.cd=z;var F=b[h].update(z.H());n(F)?(Pd("transaction failed: Data returned ",F,
	k.path),m=G(F),"object"===typeof F&&null!=F&&eb(F,".priority")||(m=m.fa(z.C())),z=k.Ba,F=xh(a),F=Jb(m,F),k.dd=m,k.ed=F,k.Ba=a.vd++,Fa(f,z),e=e.concat(bh(a.K,k.path,F,k.Ba,k.He)),e=e.concat(eh(a.K,z,!0))):(l=!0,u="nodata",e=e.concat(eh(a.K,k.Ba,!0)))}cf(a.ca,c,e);e=[];l&&(b[h].status=3,setTimeout(b[h].Rd,Math.floor(0)),b[h].G&&("nodata"===u?(k=new U(a,b[h].path),d.push(q(b[h].G,null,null,!1,new V(b[h].cd,k,H)))):d.push(q(b[h].G,null,Error(u),!1,null))))}Ih(a,a.mc);for(h=0;h<d.length;h++)fc(d[h]);Hh(a)}}
	function Lh(a,b){for(var c,d=a.mc;null!==(c=K(b))&&null===d.Ca();)d=Uc(d,c),b=N(b);return d}function Jh(a,b){var c=[];Nh(a,b,c);c.sort(function(a,b){return a.ef-b.ef});return c}function Nh(a,b,c){var d=b.Ca();if(null!==d)for(var e=0;e<d.length;e++)c.push(d[e]);b.O(function(b){Nh(a,b,c)})}function Ih(a,b){var c=b.Ca();if(c){for(var d=0,e=0;e<c.length;e++)3!==c[e].status&&(c[d]=c[e],d++);c.length=d;Vc(b,0<c.length?c:null)}b.O(function(b){Ih(a,b)})}
	function Bh(a,b){var c=Lh(a,b).path(),d=Uc(a.mc,b);Yc(d,function(b){Oh(a,b)});Oh(a,d);Xc(d,function(b){Oh(a,b)});return c}
	function Oh(a,b){var c=b.Ca();if(null!==c){for(var d=[],e=[],f=-1,h=0;h<c.length;h++)4!==c[h].status&&(2===c[h].status?(D(f===h-1,"All SENT items should be at beginning of queue."),f=h,c[h].status=4,c[h].Td="set"):(D(1===c[h].status,"Unexpected transaction status in abort"),c[h].Rd(),e=e.concat(eh(a.K,c[h].Ba,!0)),c[h].G&&d.push(q(c[h].G,null,Error("set"),!1,null))));-1===f?Vc(b,null):c.length=f+1;cf(a.ca,b.path(),e);for(h=0;h<d.length;h++)fc(d[h])}};function Ug(){this.lb={};this.wf=!1}Ug.prototype.ab=function(){for(var a in this.lb)this.lb[a].ab()};Ug.prototype.kc=function(){for(var a in this.lb)this.lb[a].kc()};Ug.prototype.ce=function(a){this.wf=a};ca(Ug);Ug.prototype.interrupt=Ug.prototype.ab;Ug.prototype.resume=Ug.prototype.kc;var W={};W.nc=Ag;W.DataConnection=W.nc;Ag.prototype.ng=function(a,b){this.ua("q",{p:a},b)};W.nc.prototype.simpleListen=W.nc.prototype.ng;Ag.prototype.Hf=function(a,b){this.ua("echo",{d:a},b)};W.nc.prototype.echo=W.nc.prototype.Hf;Ag.prototype.interrupt=Ag.prototype.ab;W.zf=og;W.RealTimeConnection=W.zf;og.prototype.sendRequest=og.prototype.ua;og.prototype.close=og.prototype.close;
	W.Rf=function(a){var b=Ag.prototype.put;Ag.prototype.put=function(c,d,e,f){n(f)&&(f=a());b.call(this,c,d,e,f)};return function(){Ag.prototype.put=b}};W.hijackHash=W.Rf;W.yf=zb;W.ConnectionTarget=W.yf;W.ja=function(a){return a.ja()};W.queryIdentifier=W.ja;W.Uf=function(a){return a.u.Ra.$};W.listens=W.Uf;W.ce=function(a){Ug.Vb().ce(a)};W.forceRestClient=W.ce;W.Context=Ug;function Ph(a,b){this.committed=a;this.snapshot=b};function X(a,b,c,d){this.u=a;this.path=b;this.m=c;this.Nc=d}
	function Qh(a){var b=null,c=null;a.ka&&(b=ff(a));a.na&&(c=hf(a));if(a.g===tc){if(a.ka){if("[MIN_NAME]"!=ef(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==typeof b)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}if(a.na){if("[MAX_NAME]"!=gf(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==
	typeof c)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}}else if(a.g===H){if(null!=b&&!Nd(b)||null!=c&&!Nd(c))throw Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");}else if(D(a.g instanceof pc||a.g===wc,"unknown index type."),null!=b&&"object"===typeof b||null!=c&&"object"===typeof c)throw Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
	}function Rh(a){if(a.ka&&a.na&&a.xa&&(!a.xa||""===a.mb))throw Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");}function Sh(a,b){if(!0===a.Nc)throw Error(b+": You can't combine multiple orderBy calls.");}g=X.prototype;g.wb=function(){y("Query.ref",0,0,arguments.length);return new U(this.u,this.path)};
	g.gc=function(a,b,c,d){y("Query.on",2,4,arguments.length);Td("Query.on",a,!1);B("Query.on",2,b,!1);var e=Th("Query.on",c,d);if("value"===a)Fh(this.u,this,new Vg(b,e.cancel||null,e.Ma||null));else{var f={};f[a]=b;Fh(this.u,this,new Wg(f,e.cancel,e.Ma))}return b};
	g.Ic=function(a,b,c){y("Query.off",0,3,arguments.length);Td("Query.off",a,!0);B("Query.off",2,b,!0);ob("Query.off",3,c);var d=null,e=null;"value"===a?d=new Vg(b||null,null,c||null):a&&(b&&(e={},e[a]=b),d=new Wg(e,null,c||null));e=this.u;d=".info"===K(this.path)?e.pd.kb(this,d):e.K.kb(this,d);af(e.ca,this.path,d)};
	g.$f=function(a,b){function c(k){f&&(f=!1,e.Ic(a,c),b&&b.call(d.Ma,k),h.resolve(k))}y("Query.once",1,4,arguments.length);Td("Query.once",a,!1);B("Query.once",2,b,!0);var d=Th("Query.once",arguments[2],arguments[3]),e=this,f=!0,h=new ib;kb(h.ra);this.gc(a,c,function(b){e.Ic(a,c);d.cancel&&d.cancel.call(d.Ma,b);h.reject(b)});return h.ra};
	g.ne=function(a){y("Query.limitToFirst",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToFirst: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.ne(a),this.Nc)};
	g.oe=function(a){y("Query.limitToLast",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToLast: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.oe(a),this.Nc)};
	g.ag=function(a){y("Query.orderByChild",1,1,arguments.length);if("$key"===a)throw Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');if("$priority"===a)throw Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');if("$value"===a)throw Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');Vd("Query.orderByChild",a);Sh(this,"Query.orderByChild");var b=new E(a);if(b.e())throw Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
	b=new pc(b);b=of(this.m,b);Qh(b);return new X(this.u,this.path,b,!0)};g.bg=function(){y("Query.orderByKey",0,0,arguments.length);Sh(this,"Query.orderByKey");var a=of(this.m,tc);Qh(a);return new X(this.u,this.path,a,!0)};g.cg=function(){y("Query.orderByPriority",0,0,arguments.length);Sh(this,"Query.orderByPriority");var a=of(this.m,H);Qh(a);return new X(this.u,this.path,a,!0)};
	g.dg=function(){y("Query.orderByValue",0,0,arguments.length);Sh(this,"Query.orderByValue");var a=of(this.m,wc);Qh(a);return new X(this.u,this.path,a,!0)};g.Nd=function(a,b){y("Query.startAt",0,2,arguments.length);Od("Query.startAt",a,this.path,!0);Ud("Query.startAt",b);var c=this.m.Nd(a,b);Rh(c);Qh(c);if(this.m.ka)throw Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");n(a)||(b=a=null);return new X(this.u,this.path,c,this.Nc)};
	g.gd=function(a,b){y("Query.endAt",0,2,arguments.length);Od("Query.endAt",a,this.path,!0);Ud("Query.endAt",b);var c=this.m.gd(a,b);Rh(c);Qh(c);if(this.m.na)throw Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");return new X(this.u,this.path,c,this.Nc)};
	g.If=function(a,b){y("Query.equalTo",1,2,arguments.length);Od("Query.equalTo",a,this.path,!1);Ud("Query.equalTo",b);if(this.m.ka)throw Error("Query.equalTo: Starting point was already set (by another call to startAt or equalTo).");if(this.m.na)throw Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");return this.Nd(a,b).gd(a,b)};
	g.toString=function(){y("Query.toString",0,0,arguments.length);for(var a=this.path,b="",c=a.Y;c<a.o.length;c++)""!==a.o[c]&&(b+="/"+encodeURIComponent(String(a.o[c])));return this.u.toString()+(b||"/")};g.toJSON=function(){y("Query.toJSON",0,1,arguments.length);return this.toString()};g.ja=function(){var a=ac(pf(this.m));return"{}"===a?"default":a};
	g.isEqual=function(a){y("Query.isEqual",1,1,arguments.length);if(!(a instanceof X))throw Error("Query.isEqual failed: First argument must be an instance of firebase.database.Query.");var b=this.u===a.u,c=this.path.Z(a.path),d=this.ja()===a.ja();return b&&c&&d};
	function Th(a,b,c){var d={cancel:null,Ma:null};if(b&&c)d.cancel=b,B(a,3,d.cancel,!0),d.Ma=c,ob(a,4,d.Ma);else if(b)if("object"===typeof b&&null!==b)d.Ma=b;else if("function"===typeof b)d.cancel=b;else throw Error(A(a,3,!0)+" must either be a cancel callback or a context object.");return d}X.prototype.on=X.prototype.gc;X.prototype.off=X.prototype.Ic;X.prototype.once=X.prototype.$f;X.prototype.limitToFirst=X.prototype.ne;X.prototype.limitToLast=X.prototype.oe;X.prototype.orderByChild=X.prototype.ag;
	X.prototype.orderByKey=X.prototype.bg;X.prototype.orderByPriority=X.prototype.cg;X.prototype.orderByValue=X.prototype.dg;X.prototype.startAt=X.prototype.Nd;X.prototype.endAt=X.prototype.gd;X.prototype.equalTo=X.prototype.If;X.prototype.toString=X.prototype.toString;X.prototype.isEqual=X.prototype.isEqual;gc(X.prototype,"ref",X.prototype.wb);function Y(a,b){this.ta=a;this.qa=b}Y.prototype.cancel=function(a){y("Firebase.onDisconnect().cancel",0,1,arguments.length);B("Firebase.onDisconnect().cancel",1,a,!0);var b=new ib;this.ta.xd(this.qa,jb(b,a));return b.ra};Y.prototype.cancel=Y.prototype.cancel;Y.prototype.remove=function(a){y("Firebase.onDisconnect().remove",0,1,arguments.length);Wd("Firebase.onDisconnect().remove",this.qa);B("Firebase.onDisconnect().remove",1,a,!0);var b=new ib;Ch(this.ta,this.qa,null,jb(b,a));return b.ra};
	Y.prototype.remove=Y.prototype.remove;Y.prototype.set=function(a,b){y("Firebase.onDisconnect().set",1,2,arguments.length);Wd("Firebase.onDisconnect().set",this.qa);Od("Firebase.onDisconnect().set",a,this.qa,!1);B("Firebase.onDisconnect().set",2,b,!0);var c=new ib;Ch(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.set=Y.prototype.set;
	Y.prototype.Jb=function(a,b,c){y("Firebase.onDisconnect().setWithPriority",2,3,arguments.length);Wd("Firebase.onDisconnect().setWithPriority",this.qa);Od("Firebase.onDisconnect().setWithPriority",a,this.qa,!1);Sd("Firebase.onDisconnect().setWithPriority",2,b);B("Firebase.onDisconnect().setWithPriority",3,c,!0);var d=new ib;Dh(this.ta,this.qa,a,b,jb(d,c));return d.ra};Y.prototype.setWithPriority=Y.prototype.Jb;
	Y.prototype.update=function(a,b){y("Firebase.onDisconnect().update",1,2,arguments.length);Wd("Firebase.onDisconnect().update",this.qa);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.onDisconnect().update",a,this.qa);B("Firebase.onDisconnect().update",2,b,!0);
	c=new ib;Eh(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.update=Y.prototype.update;var Z={Mf:function(){dg=Zf=!0}};Z.forceLongPolling=Z.Mf;Z.Nf=function(){eg=!0};Z.forceWebSockets=Z.Nf;Z.Tf=function(){return Yf.isAvailable()};Z.isWebSocketsAvailable=Z.Tf;Z.lg=function(a,b){a.u.Ra.ze=b};Z.setSecurityDebugCallback=Z.lg;Z.Be=function(a,b){a.u.Be(b)};Z.stats=Z.Be;Z.Ce=function(a,b){a.u.Ce(b)};Z.statsIncrementCounter=Z.Ce;Z.fd=function(a){return a.u.fd};Z.dataUpdateCount=Z.fd;Z.Sf=function(a,b){a.u.je=b};Z.interceptServerData=Z.Sf;function U(a,b){if(!(a instanceof Qg))throw Error("new Firebase() no longer supported - use app.database().");X.call(this,a,b,mf,!1);this.then=void 0;this["catch"]=void 0}la(U,X);g=U.prototype;g.getKey=function(){y("Firebase.key",0,0,arguments.length);return this.path.e()?null:Oc(this.path)};
	g.n=function(a){y("Firebase.child",1,1,arguments.length);if(ga(a))a=String(a);else if(!(a instanceof E))if(null===K(this.path)){var b=a;b&&(b=b.replace(/^\/*\.info(\/|$)/,"/"));Vd("Firebase.child",b)}else Vd("Firebase.child",a);return new U(this.u,this.path.n(a))};g.getParent=function(){y("Firebase.parent",0,0,arguments.length);var a=this.path.parent();return null===a?null:new U(this.u,a)};
	g.Of=function(){y("Firebase.ref",0,0,arguments.length);for(var a=this;null!==a.getParent();)a=a.getParent();return a};g.Gf=function(){return this.u.Ya};g.set=function(a,b){y("Firebase.set",1,2,arguments.length);Wd("Firebase.set",this.path);Od("Firebase.set",a,this.path,!1);B("Firebase.set",2,b,!0);var c=new ib;this.u.Jb(this.path,a,null,jb(c,b));return c.ra};
	g.update=function(a,b){y("Firebase.update",1,2,arguments.length);Wd("Firebase.update",this.path);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.update",a,this.path);B("Firebase.update",2,b,!0);c=new ib;this.u.update(this.path,a,jb(c,b));return c.ra};
	g.Jb=function(a,b,c){y("Firebase.setWithPriority",2,3,arguments.length);Wd("Firebase.setWithPriority",this.path);Od("Firebase.setWithPriority",a,this.path,!1);Sd("Firebase.setWithPriority",2,b);B("Firebase.setWithPriority",3,c,!0);if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.setWithPriority failed: "+this.getKey()+" is a read-only object.";var d=new ib;this.u.Jb(this.path,a,b,jb(d,c));return d.ra};
	g.remove=function(a){y("Firebase.remove",0,1,arguments.length);Wd("Firebase.remove",this.path);B("Firebase.remove",1,a,!0);return this.set(null,a)};
	g.transaction=function(a,b,c){y("Firebase.transaction",1,3,arguments.length);Wd("Firebase.transaction",this.path);B("Firebase.transaction",1,a,!1);B("Firebase.transaction",2,b,!0);if(n(c)&&"boolean"!=typeof c)throw Error(A("Firebase.transaction",3,!0)+"must be a boolean.");if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.transaction failed: "+this.getKey()+" is a read-only object.";"undefined"===typeof c&&(c=!0);var d=new ib;ha(b)&&kb(d.ra);Gh(this.u,this.path,a,function(a,c,h){a?
	d.reject(a):d.resolve(new Ph(c,h));ha(b)&&b(a,c,h)},c);return d.ra};g.kg=function(a,b){y("Firebase.setPriority",1,2,arguments.length);Wd("Firebase.setPriority",this.path);Sd("Firebase.setPriority",1,a);B("Firebase.setPriority",2,b,!0);var c=new ib;this.u.Jb(this.path.n(".priority"),a,null,jb(c,b));return c.ra};
	g.push=function(a,b){y("Firebase.push",0,2,arguments.length);Wd("Firebase.push",this.path);Od("Firebase.push",a,this.path,!0);B("Firebase.push",2,b,!0);var c=wh(this.u),d=Kc(c),c=this.n(d),e=this.n(d),d=null!=a?c.set(a,b).then(function(){return e}):hb.resolve(e);c.then=q(d.then,d);c["catch"]=q(d.then,d,void 0);ha(b)&&kb(d);return c};g.ib=function(){Wd("Firebase.onDisconnect",this.path);return new Y(this.u,this.path)};U.prototype.child=U.prototype.n;U.prototype.set=U.prototype.set;
	U.prototype.update=U.prototype.update;U.prototype.setWithPriority=U.prototype.Jb;U.prototype.remove=U.prototype.remove;U.prototype.transaction=U.prototype.transaction;U.prototype.setPriority=U.prototype.kg;U.prototype.push=U.prototype.push;U.prototype.onDisconnect=U.prototype.ib;gc(U.prototype,"database",U.prototype.Gf);gc(U.prototype,"key",U.prototype.getKey);gc(U.prototype,"parent",U.prototype.getParent);gc(U.prototype,"root",U.prototype.Of);if("undefined"===typeof firebase)throw Error("Cannot install Firebase Database - be sure to load firebase-app.js first.");
	try{firebase.INTERNAL.registerService("database",function(a){var b=Ug.Vb(),c=a.options.databaseURL;n(c)||Vb("Can't determine Firebase Database URL.  Be sure to include databaseURL option when calling firebase.intializeApp().");var d=Wb(c),c=d.jc;Xd("Invalid Firebase Database URL",d);d.path.e()||Vb("Database URL must point to the root of a Firebase Database (not including a child path).");(d=w(b.lb,a.name))&&Vb("FIREBASE INTERNAL ERROR: Database initialized multiple times.");d=new Qg(c,b.wf,a);b.lb[a.name]=
	d;return d.Ya},{Reference:U,Query:X,Database:Pg,enableLogging:Sb,INTERNAL:Z,TEST_ACCESS:W,ServerValue:Sg})}catch(Uh){Vb("Failed to register the Firebase Database Service ("+Uh+")")};})();
	
	}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
	module.exports = firebase.database;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
	Build: rev-cc77c9e
	Terms: https://firebase.google.com/terms/ */
	
	var firebase = __webpack_require__(407);
	(function(){
	(function(){for(var h,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},l="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this,n=["Number","MIN_SAFE_INTEGER"],ba=0;ba<n.length-1;ba++){var ca=n[ba];ca in l||(l[ca]={});l=l[ca]}var da=n[n.length-1];-9007199254740991!=l[da]&&aa(l,da,{configurable:!0,writable:!0,value:-9007199254740991});
	var p=this,q=function(a){return void 0!==a},ea=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&
	!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b};var r=function(a,b){this.code="storage/"+a;this.message="Firebase Storage: "+b;this.serverResponse=null;this.name="FirebaseError"};(function(){var a=Error;function b(){}b.prototype=a.prototype;r.b=a.prototype;r.prototype=new b;r.a=function(b,d,e){for(var c=Array(arguments.length-2),f=2;f<arguments.length;f++)c[f-2]=arguments[f];return a.prototype[d].apply(b,c)}})();
	var fa=function(){return new r("unknown","An unknown error occurred, please check the error payload for server response.")},ga=function(){return new r("canceled","User canceled the upload/download.")},ha=function(){return new r("cannot-slice-blob","Cannot slice blob for upload. Please retry the upload.")},ia=function(a,b,c){return new r("invalid-argument","Invalid argument in `"+b+"` at index "+a+": "+c)},ja=function(){return new r("app-deleted","The Firebase app was deleted.")},t=function(a,b){return new r("invalid-format",
	"String does not match format '"+a+"': "+b)},u=function(a){throw new r("internal-error","Internal error: "+a);};var v="https://firebasestorage.googleapis.com";var ka=function(a){if("undefined"!==typeof firebase)return new firebase.Promise(a);throw Error("Error in Firebase Storage - be sure to load firebase-app.js first.");};var la=function(a,b){return-1!==a.indexOf(b)};var ma=function(a,b,c){function d(){C||(C=!0,b.apply(null,arguments))}function e(b){m=setTimeout(function(){m=null;a(g,2===y)},b)}function g(a,b){if(!C)if(a)d.apply(null,arguments);else if(2===y||z)d.apply(null,arguments);else{64>k&&(k*=2);var c;1===y?(y=2,c=0):c=1E3*(k+Math.random());e(c)}}function f(a){Pa||(Pa=!0,C||(null!==m?(a||(y=2),clearTimeout(m),e(0)):a||(y=1)))}var k=1,m=null,z=!1,y=0,C=!1,Pa=!1;e(0);setTimeout(function(){z=!0;f(!0)},c);return f};var na=function(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])},oa=function(a){var b={};na(a,function(a,d){b[a]=d});return b};var w=function(a,b,c,d){this.l=a;this.b={};this.method=b;this.headers={};this.body=null;this.m=c;this.c=this.a=null;this.f=[200];this.i=[];this.timeout=d;this.g=!0};var pa=function(a){var b=encodeURIComponent,c="?";na(a,function(a,e){a=b(a)+"="+b(e);c=c+a+"&"});return c=c.slice(0,-1)};var ra=function(a,b,c,d,e,g,f,k,m,z,y){this.F=a;this.D=b;this.A=c;this.u=d;this.B=e.slice();this.s=g.slice();this.m=this.o=this.c=this.b=null;this.g=this.i=!1;this.v=f;this.l=k;this.f=z;this.G=y;this.C=m;var C=this;this.w=ka(function(a,b){C.o=a;C.m=b;qa(C)})},sa=function(a,b,c){this.b=a;this.c=b;this.a=!!c},qa=function(a){function b(a,b){function c(a){d.f(a.loaded,a.lengthComputable?a.total:-1)}b?a(!1,new sa(!1,null,!0)):(b=new ta,b.h.withCredentials=d.G,d.b=b,null!==d.f&&q(b.h.upload)&&b.h.upload.addEventListener("progress",
	c),ua(b,d.F,d.D,d.u,d.A).then(function(b){null!==d.f&&q(b.h.upload)&&b.h.upload.removeEventListener("progress",c);d.b=null;var e=0===va(b),f=x(b);if(!(e=!e))var e=la([408,429],f),g=la(d.s,f),e=500<=f&&600>f||e||g;e?(b=2===va(b),a(!1,new sa(!1,null,b))):a(!0,new sa(la(d.B,f),b))}))}function c(a,b){var c=d.o;a=d.m;var e=b.c;if(b.b)try{var g=d.v(e,wa(e));q(g)?c(g):c()}catch(z){a(z)}else null!==e?(b=fa(),g=wa(e),b.serverResponse=g,d.l?a(d.l(e,b)):a(b)):(b=b.a?d.g?ja():ga():new r("retry-limit-exceeded",
	"Max retry time for operation exceeded, please try again."),a(b))}var d=a;a.i?c(0,new sa(!1,null,!0)):a.c=ma(b,c,a.C)};ra.prototype.a=function(){return this.w};ra.prototype.cancel=function(a){this.i=!0;this.g=a||!1;null!==this.c&&(0,this.c)(!1);null!==this.b&&this.b.abort()};
	var xa=function(a,b,c){var d=pa(a.b),d=a.l+d,e=a.headers?oa(a.headers):{};null!==b&&0<b.length&&(e.Authorization="Firebase "+b);e["X-Firebase-Storage-Version"]="webjs/"+("undefined"!==typeof firebase?firebase.SDK_VERSION:"AppManager");return new ra(d,a.method,e,a.body,a.f,a.i,a.m,a.a,a.timeout,a.c,c)};var ya=function(a){this.b=firebase.Promise.reject(a)};ya.prototype.a=function(){return this.b};ya.prototype.cancel=function(){};var A=function(a,b){this.bucket=a;this.path=b},za=function(a){var b=encodeURIComponent;return"/b/"+b(a.bucket)+"/o/"+b(a.path)},Ba=function(a){var b;try{b=Aa(a)}catch(c){return new A(a,"")}if(""===b.path)return b;throw new r("invalid-default-bucket","Invalid default bucket '"+a+"'.");},Aa=function(a){for(var b=null,c=[{M:/^gs:\/\/([A-Za-z0-9.\-]+)(\/(.*))?$/i,H:{bucket:1,path:3},L:function(a){"/"===a.path.charAt(a.path.length-1)&&(a.path=a.path.slice(0,-1))}},{M:/^https?:\/\/firebasestorage\.googleapis\.com\/v[A-Za-z0-9_]+\/b\/([A-Za-z0-9.\-]+)\/o(\/([^?#]*).*)?$/i,
	H:{bucket:1,path:3},L:function(a){a.path=decodeURIComponent(a.path)}}],d=0;d<c.length;d++){var e=c[d],g=e.M.exec(a);if(g){b=g[e.H.bucket];(g=g[e.H.path])||(g="");b=new A(b,g);e.L(b);break}}if(null==b)throw new r("invalid-url","Invalid URL '"+a+"'.");return b};var Ca=function(){this.a={};this.b=Number.MIN_SAFE_INTEGER},Da=function(a,b){function c(){delete e.a[d]}var d=a.b;a.b++;a.a[d]=b;var e=a;b.a().then(c,c)},Ea=function(a){na(a.a,function(a,c){c&&c.cancel(!0)});a.a={}};var B=function(a){return q(a)&&null!==a},Fa=function(a){return"string"===typeof a||a instanceof String},Ga=function(){return"undefined"!==typeof Blob};var Ha=function(a,b,c,d,e){this.a=a;this.g=null;null!==this.a&&(a=this.a.options,B(a)&&(a=a.storageBucket||null,this.g=null==a?null:Ba(a).bucket));this.s=b;this.o=c;this.l=e;this.m=d;this.c=12E4;this.b=6E4;this.i=new Ca;this.f=!1},Ia=function(a){return null!==a.a&&B(a.a.INTERNAL)&&B(a.a.INTERNAL.getToken)?a.a.INTERNAL.getToken().then(function(a){return B(a)?a.accessToken:null},function(){return null}):firebase.Promise.resolve(null)};Ha.prototype.bucket=function(){if(this.f)throw ja();return this.g};
	var D=function(a,b,c){if(a.f)return new ya(ja());b=a.o(b,c,null===a.a,a.l);Da(a.i,b);return b};var Ja=function(a,b){b=b.split("/").filter(function(a){return 0<a.length}).join("/");return 0===a.length?b:a+"/"+b},Ka=function(a){var b=a.lastIndexOf("/",a.length-2);return-1===b?a:a.slice(b+1)};var La=function(a,b){return b},E=function(a,b,c,d){this.c=a;this.b=b||a;this.writable=!!c;this.a=d||La},Ma=null,Na=function(){if(Ma)return Ma;var a=[];a.push(new E("bucket"));a.push(new E("generation"));a.push(new E("metageneration"));a.push(new E("name","fullPath",!0));var b=new E("name");b.a=function(a,b){return!Fa(b)||2>b.length?b:Ka(b)};a.push(b);b=new E("size");b.a=function(a,b){return B(b)?+b:b};a.push(b);a.push(new E("timeCreated"));a.push(new E("updated"));a.push(new E("md5Hash",null,!0));
	a.push(new E("cacheControl",null,!0));a.push(new E("contentDisposition",null,!0));a.push(new E("contentEncoding",null,!0));a.push(new E("contentLanguage",null,!0));a.push(new E("contentType",null,!0));a.push(new E("metadata","customMetadata",!0));a.push(new E("downloadTokens","downloadURLs",!1,function(a,b){if(!(Fa(b)&&0<b.length))return[];var c=encodeURIComponent;return b.split(",").map(function(b){var d=a.fullPath,d="https://firebasestorage.googleapis.com/v0"+("/b/"+c(a.bucket)+"/o/"+c(d));b=pa({alt:"media",
	token:b});return d+b})}));return Ma=a},Oa=function(a,b){Object.defineProperty(a,"ref",{get:function(){return b.s(b,new A(a.bucket,a.fullPath))}})},Qa=function(a,b){for(var c={},d=b.length,e=0;e<d;e++){var g=b[e];g.writable&&(c[g.c]=a[g.b])}return JSON.stringify(c)},Ra=function(a){if(!a||"object"!==typeof a)throw"Expected Metadata object.";for(var b in a){var c=a[b];if("customMetadata"===b){if("object"!==typeof c)throw"Expected object for 'customMetadata' mapping.";}else if(null!=c&&"object"===typeof c)throw"Mapping for '"+
	b+"' cannot be an object.";}};var F=function(a,b,c){for(var d=b.length,e=b.length,g=0;g<b.length;g++)if(b[g].b){d=g;break}if(!(d<=c.length&&c.length<=e))throw d===e?(b=d,d=1===d?"argument":"arguments"):(b="between "+d+" and "+e,d="arguments"),new r("invalid-argument-count","Invalid argument count in `"+a+"`: Expected "+b+" "+d+", received "+c.length+".");for(g=0;g<c.length;g++)try{b[g].a(c[g])}catch(f){if(f instanceof Error)throw ia(g,a,f.message);throw ia(g,a,f);}},G=function(a,b){var c=this;this.a=function(b){c.b&&!q(b)||a(b)};
	this.b=!!b},Sa=function(a,b){return function(c){a(c);b(c)}},H=function(a,b){function c(a){if(!("string"===typeof a||a instanceof String))throw"Expected string.";}var d;a?d=Sa(c,a):d=c;return new G(d,b)},Ta=function(){return new G(function(a){if(!(a instanceof Uint8Array||a instanceof ArrayBuffer||Ga()&&a instanceof Blob))throw"Expected Blob or File.";})},Ua=function(){return new G(function(a){if(!(("number"===typeof a||a instanceof Number)&&0<=a))throw"Expected a number 0 or greater.";})},Va=function(a,
	b){return new G(function(b){if(!(null===b||B(b)&&b instanceof Object))throw"Expected an Object.";B(a)&&a(b)},b)},I=function(){return new G(function(a){if(null!==a&&"function"!=ea(a))throw"Expected a Function.";},!0)};var J=function(a){return function(){var b=[];Array.prototype.push.apply(b,arguments);firebase.Promise.resolve(!0).then(function(){a.apply(null,b)})}};var Wa=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},Xa=function(a,b){return a<b?-1:a>b?1:0};var K;a:{var Ya=p.navigator;if(Ya){var Za=Ya.userAgent;if(Za){K=Za;break a}}K=""};var ab=function(a,b){var c=$a;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var bb=-1!=K.indexOf("Opera"),cb=-1!=K.indexOf("Trident")||-1!=K.indexOf("MSIE"),db=-1!=K.indexOf("Edge"),eb=-1!=K.indexOf("Gecko")&&!(-1!=K.toLowerCase().indexOf("webkit")&&-1==K.indexOf("Edge"))&&!(-1!=K.indexOf("Trident")||-1!=K.indexOf("MSIE"))&&-1==K.indexOf("Edge"),fb=-1!=K.toLowerCase().indexOf("webkit")&&-1==K.indexOf("Edge"),gb;
	a:{var hb="",ib=function(){var a=K;if(eb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(db)return/Edge\/([\d\.]+)/.exec(a);if(cb)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(fb)return/WebKit\/(\S+)/.exec(a);if(bb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();ib&&(hb=ib?ib[1]:"");if(cb){var jb,kb=p.document;jb=kb?kb.documentMode:void 0;if(null!=jb&&jb>parseFloat(hb)){gb=String(jb);break a}}gb=hb}
	var lb=gb,$a={},mb=function(a){return ab(a,function(){for(var b=0,c=Wa(String(lb)).split("."),d=Wa(String(a)).split("."),e=Math.max(c.length,d.length),g=0;0==b&&g<e;g++){var f=c[g]||"",k=d[g]||"";do{f=/(\d*)(\D*)(.*)/.exec(f)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==f[0].length&&0==k[0].length)break;b=Xa(0==f[1].length?0:parseInt(f[1],10),0==k[1].length?0:parseInt(k[1],10))||Xa(0==f[2].length,0==k[2].length)||Xa(f[2],k[2]);f=f[3];k=k[3]}while(0==b)}return 0<=b})};var nb=function(a){var b=p.BlobBuilder||p.WebKitBlobBuilder;if(q(b)){for(var b=new b,c=0;c<arguments.length;c++)b.append(arguments[c]);return b.getBlob()}b=Array.prototype.slice.call(arguments);c=p.BlobBuilder||p.WebKitBlobBuilder;if(q(c)){for(var c=new c,d=0;d<b.length;d++)c.append(b[d],void 0);b=c.getBlob(void 0)}else if(q(p.Blob))b=new Blob(b,{});else throw Error("This browser doesn't seem to support creating Blobs");return b},ob=function(a,b,c){q(c)||(c=a.size);return a.webkitSlice?a.webkitSlice(b,
	c):a.mozSlice?a.mozSlice(b,c):a.slice?eb&&!mb("13.0")||fb&&!mb("537.1")?(0>b&&(b+=a.size),0>b&&(b=0),0>c&&(c+=a.size),c<b&&(c=b),a.slice(b,c-b)):a.slice(b,c):null};var L={RAW:"raw",BASE64:"base64",BASE64URL:"base64url",DATA_URL:"data_url"},pb=function(a){switch(a){case "raw":case "base64":case "base64url":case "data_url":break;default:throw"Expected one of the event types: [raw, base64, base64url, data_url].";}},qb=function(a,b){this.data=a;this.a=b||null},ub=function(a,b){switch(a){case "raw":return new qb(rb(b));case "base64":case "base64url":return new qb(sb(a,b));case "data_url":a=new tb(b);var c;if(a.a)c=sb("base64",a.c);else{try{c=decodeURIComponent(a.c)}catch(d){throw t("data_url",
	"Malformed data URL.");}c=rb(c)}return new qb(c,(new tb(b)).b)}throw fa();},rb=function(a){for(var b=[],c=0;c<a.length;c++){var d=a.charCodeAt(c);if(127>=d)b.push(d);else if(2047>=d)b.push(192|d>>6,128|d&63);else if(55296==(d&64512))if(c<a.length-1&&56320==(a.charCodeAt(c+1)&64512)){var e=a.charCodeAt(++c),d=65536|(d&1023)<<10|e&1023;b.push(240|d>>18,128|d>>12&63,128|d>>6&63,128|d&63)}else b.push(239,191,189);else 56320==(d&64512)?b.push(239,191,189):b.push(224|d>>12,128|d>>6&63,128|d&63)}return new Uint8Array(b)},
	sb=function(a,b){switch(a){case "base64":var c=-1!==b.indexOf("-"),d=-1!==b.indexOf("_");if(c||d)throw t(a,"Invalid character '"+(c?"-":"_")+"' found: is it base64url encoded?");break;case "base64url":c=-1!==b.indexOf("+");d=-1!==b.indexOf("/");if(c||d)throw t(a,"Invalid character '"+(c?"+":"/")+"' found: is it base64 encoded?");b=b.replace(/-/g,"+").replace(/_/g,"/")}var e;try{e=atob(b)}catch(g){throw t(a,"Invalid character found");}a=new Uint8Array(e.length);for(b=0;b<e.length;b++)a[b]=e.charCodeAt(b);
	return a},tb=function(a){var b=a.match(/^data:([^,]+)?,/);if(null===b)throw t("data_url","Must be formatted 'data:[<mediatype>][;base64],<data>");b=b[1]||null;this.a=!1;this.b=null;if(null!=b){var c=b.length-7;this.b=(this.a=0<=c&&b.indexOf(";base64",c)==c)?b.substring(0,b.length-7):b}this.c=a.substring(a.indexOf(",")+1)};var M=function(a,b){Ga()&&a instanceof Blob?(this.j=a,b=a.size,a=a.type):(a instanceof ArrayBuffer?(b?this.j=new Uint8Array(a):(this.j=new Uint8Array(a.byteLength),this.j.set(new Uint8Array(a))),b=this.j.length):(b?this.j=a:(this.j=new Uint8Array(a.length),this.j.set(a)),b=a.length),a="");this.a=b;this.b=a};M.prototype.type=function(){return this.b};
	M.prototype.slice=function(a,b){if(Ga()&&this.j instanceof Blob)return a=ob(this.j,a,b),null===a?null:new M(a);a=new Uint8Array(this.j.buffer,a,b-a);return new M(a,!0)};
	var vb=function(a){var b=[];Array.prototype.push.apply(b,arguments);if(Ga())return b=b.map(function(a){return a instanceof M?a.j:a}),new M(nb.apply(null,b));var b=b.map(function(a){return Fa(a)?ub("raw",a).data:a.j}),c=0;b.forEach(function(a){c+=a.byteLength});var d=new Uint8Array(c),e=0;b.forEach(function(a){for(var b=0;b<a.length;b++)d[e++]=a[b]});return new M(d,!0)};var wb=function(a,b,c){"function"==ea(a)||B(b)||B(c)?(this.b=a,this.error=b||null,this.a=c||null):(this.b=a.next||null,this.error=a.error||null,this.a=a.complete||null)};var N=function(a){if(!a)throw fa();},xb=function(a,b){return function(c,d){var e;a:{try{e=JSON.parse(d)}catch(k){e=null;break a}c=typeof e;e="object"==c&&null!=e||"function"==c?e:null}if(null===e)e=null;else{c={type:"file"};d=b.length;for(var g=0;g<d;g++){var f=b[g];c[f.b]=f.a(c,e[f.c])}Oa(c,a);e=c}N(null!==e);return e}},O=function(a){return function(b,c){b=401===x(b)?new r("unauthenticated","User is not authenticated, please authenticate using Firebase Authentication and try again."):402===x(b)?
	new r("quota-exceeded","Quota for bucket '"+a.bucket+"' exceeded, please view quota on https://firebase.google.com/pricing/."):403===x(b)?new r("unauthorized","User does not have permission to access '"+a.path+"'."):c;b.serverResponse=c.serverResponse;return b}},yb=function(a){var b=O(a);return function(c,d){var e=b(c,d);404===x(c)&&(e=new r("object-not-found","Object '"+a.path+"' does not exist."));e.serverResponse=d.serverResponse;return e}},zb=function(a,b,c){var d=za(b);a=new w(v+"/v0"+d,"GET",
	xb(a,c),a.c);a.a=yb(b);return a},Ab=function(a,b){var c=za(b);a=new w(v+"/v0"+c,"DELETE",function(){},a.c);a.f=[200,204];a.a=yb(b);return a},Bb=function(a,b,c){c=c?oa(c):{};c.fullPath=a.path;c.size=b.a;c.contentType||(a=b&&b.type()||"application/octet-stream",c.contentType=a);return c},Cb=function(a,b,c,d,e){var g="/b/"+encodeURIComponent(b.bucket)+"/o",f={"X-Goog-Upload-Protocol":"multipart"},k;k="";for(var m=0;2>m;m++)k+=Math.random().toString().slice(2);f["Content-Type"]="multipart/related; boundary="+
	k;e=Bb(b,d,e);m=Qa(e,c);d=vb("--"+k+"\r\nContent-Type: application/json; charset=utf-8\r\n\r\n"+m+"\r\n--"+k+"\r\nContent-Type: "+e.contentType+"\r\n\r\n",d,"\r\n--"+k+"--");if(null===d)throw ha();a=new w(v+"/v0"+g,"POST",xb(a,c),a.b);a.b={name:e.fullPath};a.headers=f;a.body=d.j;a.a=O(b);return a},Db=function(a,b,c,d){this.current=a;this.total=b;this.I=!!c;this.metadata=d||null},Eb=function(a,b){var c;try{c=a.h.getResponseHeader("X-Goog-Upload-Status")}catch(d){N(!1)}N(la(b||["active"],c));return c},
	Fb=function(a,b,c,d,e){var g="/b/"+encodeURIComponent(b.bucket)+"/o",f=Bb(b,d,e);e={name:f.fullPath};g=v+"/v0"+g;d={"X-Goog-Upload-Protocol":"resumable","X-Goog-Upload-Command":"start","X-Goog-Upload-Header-Content-Length":d.a,"X-Goog-Upload-Header-Content-Type":f.contentType,"Content-Type":"application/json; charset=utf-8"};c=Qa(f,c);a=new w(g,"POST",function(a){Eb(a);var b;try{b=a.h.getResponseHeader("X-Goog-Upload-URL")}catch(z){N(!1)}N(Fa(b));return b},a.b);a.b=e;a.headers=d;a.body=c;a.a=O(b);
	return a},Gb=function(a,b,c,d){a=new w(c,"POST",function(a){var b=Eb(a,["active","final"]),c;try{c=a.h.getResponseHeader("X-Goog-Upload-Size-Received")}catch(k){N(!1)}a=c;isFinite(a)&&(a=String(a));a="string"==typeof a?/^\s*-?0x/i.test(a)?parseInt(a,16):parseInt(a,10):NaN;N(!isNaN(a));return new Db(a,d.a,"final"===b)},a.b);a.headers={"X-Goog-Upload-Command":"query"};a.a=O(b);a.g=!1;return a},Hb=function(a,b,c,d,e,g,f,k){var m=new Db(0,0);f?(m.current=f.current,m.total=f.total):(m.current=0,m.total=
	d.a);if(d.a!==m.total)throw new r("server-file-wrong-size","Server recorded incorrect upload file size, please retry the upload.");var z=f=m.total-m.current;0<e&&(z=Math.min(z,e));var y=m.current;e={"X-Goog-Upload-Command":z===f?"upload, finalize":"upload","X-Goog-Upload-Offset":m.current};f=d.slice(y,y+z);if(null===f)throw ha();c=new w(c,"POST",function(a,c){var e=Eb(a,["active","final"]),f=m.current+z,k=d.a,y;"final"===e?y=xb(b,g)(a,c):y=null;return new Db(f,k,"final"===e,y)},b.b);c.headers=e;c.body=
	f.j;c.c=k||null;c.a=O(a);c.g=!1;return c};var Ib={STATE_CHANGED:"state_changed"},P={RUNNING:"running",PAUSED:"paused",SUCCESS:"success",CANCELED:"canceled",ERROR:"error"},Jb=function(a){switch(a){case "running":case "pausing":case "canceling":return"running";case "paused":return"paused";case "success":return"success";case "canceled":return"canceled";case "error":return"error";default:return"error"}};var ta=function(){var a=this;this.h=new XMLHttpRequest;this.b=0;this.c=ka(function(b){a.h.addEventListener("abort",function(){a.b=2;b(a)});a.h.addEventListener("error",function(){a.b=1;b(a)});a.h.addEventListener("load",function(){b(a)})});this.a=!1},ua=function(a,b,c,d,e){if(a.a)throw u("cannot .send() more than once");a.a=!0;a.h.open(c,b,!0);B(e)&&na(e,function(b,c){a.h.setRequestHeader(b,c.toString())});B(d)?a.h.send(d):a.h.send();return a.c},va=function(a){if(!a.a)throw u("cannot .getErrorCode() before sending");
	return a.b},x=function(a){if(!a.a)throw u("cannot .getStatus() before sending");try{return a.h.status}catch(b){return-1}},wa=function(a){if(!a.a)throw u("cannot .getResponseText() before sending");return a.h.responseText};ta.prototype.abort=function(){this.h.abort()};var Kb=function(){};var Q=function(a,b,c,d,e,g){this.b=a;this.i=b;this.f=c;this.a=d;this.g=e;this.c=g};h=Q.prototype;h.X=function(){return this.b};h.sa=function(){return this.i};h.pa=function(){return this.f};h.ka=function(){return this.a};h.Y=function(){if(B(this.a)){var a=this.a.downloadURLs;return B(a)&&B(a[0])?a[0]:null}return null};h.ra=function(){return this.g};h.na=function(){return this.c};var T=function(a,b,c,d,e,g){var f=this;this.O=a;this.c=b;this.o=c;this.f=e;this.i=void 0===g?null:g;this.u=d;this.l=0;this.G=this.w=!1;this.B=[];this.U=262144<this.f.a;this.b="running";this.a=this.A=this.g=null;this.m=1;this.s=function(a){f.a=null;f.m=1;"storage/canceled"===a.code?(f.w=!0,R(f)):(f.g=a,S(f,"error"))};this.N=function(a){f.a=null;"storage/canceled"===a.code?R(f):(f.g=a,S(f,"error"))};this.D=this.v=null;this.F=ka(function(a,b){f.v=a;f.D=b;Lb(f)});this.F.then(null,function(){})},Nb=function(a){var b=
	a.l;return function(c){Mb(a,b+c)}},Lb=function(a){"running"===a.b&&null===a.a&&(a.U?null===a.A?Ob(a):a.w?Pb(a):a.G?Qb(a):Rb(a):Sb(a))},U=function(a,b){Ia(a.c).then(function(c){switch(a.b){case "running":b(c);break;case "canceling":S(a,"canceled");break;case "pausing":S(a,"paused")}})},Ob=function(a){U(a,function(b){var c=Fb(a.c,a.o,a.u,a.f,a.i);a.a=D(a.c,c,b);a.a.a().then(function(b){a.a=null;a.A=b;a.w=!1;R(a)},a.s)})},Pb=function(a){var b=a.A;U(a,function(c){var d=Gb(a.c,a.o,b,a.f);a.a=D(a.c,d,c);
	a.a.a().then(function(b){a.a=null;Mb(a,b.current);a.w=!1;b.I&&(a.G=!0);R(a)},a.s)})},Rb=function(a){var b=262144*a.m,c=new Db(a.l,a.f.a),d=a.A;U(a,function(e){var g;try{g=Hb(a.o,a.c,d,a.f,b,a.u,c,Nb(a))}catch(f){a.g=f;S(a,"error");return}a.a=D(a.c,g,e);a.a.a().then(function(b){33554432>262144*a.m&&(a.m*=2);a.a=null;Mb(a,b.current);b.I?(a.i=b.metadata,S(a,"success")):R(a)},a.s)})},Qb=function(a){U(a,function(b){var c=zb(a.c,a.o,a.u);a.a=D(a.c,c,b);a.a.a().then(function(b){a.a=null;a.i=b;S(a,"success")},
	a.N)})},Sb=function(a){U(a,function(b){var c=Cb(a.c,a.o,a.u,a.f,a.i);a.a=D(a.c,c,b);a.a.a().then(function(b){a.a=null;a.i=b;Mb(a,a.f.a);S(a,"success")},a.s)})},Mb=function(a,b){var c=a.l;a.l=b;a.l!==c&&V(a)},S=function(a,b){if(a.b!==b)switch(b){case "canceling":a.b=b;null!==a.a&&a.a.cancel();break;case "pausing":a.b=b;null!==a.a&&a.a.cancel();break;case "running":var c="paused"===a.b;a.b=b;c&&(V(a),Lb(a));break;case "paused":a.b=b;V(a);break;case "canceled":a.g=ga();a.b=b;V(a);break;case "error":a.b=
	b;V(a);break;case "success":a.b=b,V(a)}},R=function(a){switch(a.b){case "pausing":S(a,"paused");break;case "canceling":S(a,"canceled");break;case "running":Lb(a)}};T.prototype.C=function(){return new Q(this.l,this.f.a,Jb(this.b),this.i,this,this.O)};
	T.prototype.P=function(a,b,c,d){function e(a){try{f(a);return}catch(C){}try{if(k(a),!(q(a.next)||q(a.error)||q(a.complete)))throw"";}catch(C){throw"Expected a function or an Object with one of `next`, `error`, `complete` properties.";}}function g(a){return function(b,c,d){null!==a&&F("on",a,arguments);var e=new wb(b,c,d);m.B.push(e);Tb(m,e);return function(){var a=m.B,b=a.indexOf(e);-1!==b&&a.splice(b,1)}}}var f=I().a,k=Va(null,!0).a;F("on",[H(function(){if("state_changed"!==a)throw"Expected one of the event types: [state_changed].";
	}),Va(e,!0),I(),I()],arguments);var m=this,z=[Va(function(a){if(null===a)throw"Expected a function or an Object with one of `next`, `error`, `complete` properties.";e(a)}),I(),I()];return q(b)||q(c)||q(d)?g(null)(b,c,d):g(z)};T.prototype.then=function(a,b){return this.F.then(void 0===a?null:a,void 0===b?null:b)};T.prototype["catch"]=function(a){return this.then(null,a)};
	var V=function(a){Ub(a);Array.prototype.slice.call(a.B).forEach(function(b){Tb(a,b)})},Ub=function(a){if(null!==a.v){var b=!0;switch(Jb(a.b)){case "success":J(a.v.bind(null,a.C()))();break;case "canceled":case "error":J(a.D.bind(null,a.g))();break;default:b=!1}b&&(a.v=null,a.D=null)}},Tb=function(a,b){switch(Jb(a.b)){case "running":case "paused":null!==b.b&&J(b.b.bind(b,a.C()))();break;case "success":null!==b.a&&J(b.a.bind(b))();break;case "canceled":case "error":null!==b.error&&J(b.error.bind(b,
	a.g))();break;default:null!==b.error&&J(b.error.bind(b,a.g))()}};T.prototype.T=function(){F("resume",[],arguments);var a="paused"===this.b||"pausing"===this.b;a&&S(this,"running");return a};T.prototype.R=function(){F("pause",[],arguments);var a="running"===this.b;a&&S(this,"pausing");return a};T.prototype.cancel=function(){F("cancel",[],arguments);var a="running"===this.b||"pausing"===this.b;a&&S(this,"canceling");return a};var W=function(a,b){this.a=a;this.location=b instanceof A?b:Aa(b)};W.prototype.toString=function(){F("toString",[],arguments);return"gs://"+this.location.bucket+"/"+this.location.path};var Vb=function(a,b){return new W(a,b)};h=W.prototype;h.J=function(a){F("child",[H()],arguments);var b=Ja(this.location.path,a);return Vb(this.a,new A(this.location.bucket,b))};
	h.ma=function(){var a;a=this.location.path;if(0==a.length)a=null;else{var b=a.lastIndexOf("/");a=-1===b?"":a.slice(0,b)}return null===a?null:Vb(this.a,new A(this.location.bucket,a))};h.oa=function(){return Vb(this.a,new A(this.location.bucket,""))};h.W=function(){return this.location.bucket};h.ha=function(){return this.location.path};h.la=function(){return Ka(this.location.path)};h.qa=function(){return this.a.m};
	h.aa=function(a,b){F("put",[Ta(),new G(Ra,!0)],arguments);X(this,"put");return new T(this,this.a,this.location,Na(),new M(a),b)};h.ba=function(a,b,c){F("putString",[H(),H(pb,!0),new G(Ra,!0)],arguments);X(this,"putString");var d=ub(B(b)?b:"raw",a),e=c?oa(c):{};!B(e.contentType)&&B(d.a)&&(e.contentType=d.a);return new T(this,this.a,this.location,Na(),new M(d.data,!0),e)};
	h.Z=function(){F("delete",[],arguments);X(this,"delete");var a=this;return Ia(this.a).then(function(b){var c=Ab(a.a,a.location);return D(a.a,c,b).a()})};h.K=function(){F("getMetadata",[],arguments);X(this,"getMetadata");var a=this;return Ia(this.a).then(function(b){var c=zb(a.a,a.location,Na());return D(a.a,c,b).a()})};
	h.ca=function(a){F("updateMetadata",[new G(Ra,void 0)],arguments);X(this,"updateMetadata");var b=this;return Ia(this.a).then(function(c){var d=b.a,e=b.location,g=a,f=Na(),k=za(e),k=v+"/v0"+k,g=Qa(g,f),d=new w(k,"PATCH",xb(d,f),d.c);d.headers={"Content-Type":"application/json; charset=utf-8"};d.body=g;d.a=yb(e);return D(b.a,d,c).a()})};
	h.$=function(){F("getDownloadURL",[],arguments);X(this,"getDownloadURL");return this.K().then(function(a){a=a.downloadURLs[0];if(B(a))return a;throw new r("no-download-url","The given file does not have any download URLs.");})};var X=function(a,b){if(""===a.location.path)throw new r("invalid-root-operation","The operation '"+b+"' cannot be performed on a root reference, create a non-root reference using child, such as .child('file.png').");};var Y=function(a,b,c){this.a=new Ha(a,function(a,b){return new W(a,b)},xa,this,b);this.c=a;q(c)?this.b=Ba(c):null!=this.a.bucket()&&(this.b=new A(this.a.bucket(),""));this.f=new Wb(this)};h=Y.prototype;h.da=function(a){F("ref",[H(function(a){if(/^[A-Za-z]+:\/\//.test(a))throw"Expected child path but got a URL, use refFromURL instead.";},!0)],arguments);if(null===this.b)throw Error("No Storage Bucket defined in Firebase Options.");var b=new W(this.a,this.b);return q(a)?b.J(a):b};
	h.ea=function(a){F("refFromURL",[H(function(a){if(!/^[A-Za-z]+:\/\//.test(a))throw"Expected full URL but got a child path, use ref instead.";try{Aa(a)}catch(c){throw"Expected valid full URL but got an invalid one.";}},!1)],arguments);return new W(this.a,a)};h.ja=function(){return this.a.b};h.ga=function(a){F("setMaxUploadRetryTime",[Ua()],arguments);this.a.b=a};h.ia=function(){return this.a.c};h.fa=function(a){F("setMaxOperationRetryTime",[Ua()],arguments);this.a.c=a};h.V=function(){return this.c};
	h.S=function(){return this.f};var Wb=function(a){this.a=a};Wb.prototype.b=function(){var a=this.a.a;a.f=!0;a.a=null;Ea(a.i)};var Z=function(a,b,c){Object.defineProperty(a,b,{get:c})};W.prototype.toString=W.prototype.toString;W.prototype.child=W.prototype.J;W.prototype.put=W.prototype.aa;W.prototype.putString=W.prototype.ba;W.prototype["delete"]=W.prototype.Z;W.prototype.getMetadata=W.prototype.K;W.prototype.updateMetadata=W.prototype.ca;W.prototype.getDownloadURL=W.prototype.$;Z(W.prototype,"parent",W.prototype.ma);Z(W.prototype,"root",W.prototype.oa);Z(W.prototype,"bucket",W.prototype.W);Z(W.prototype,"fullPath",W.prototype.ha);
	Z(W.prototype,"name",W.prototype.la);Z(W.prototype,"storage",W.prototype.qa);Y.prototype.ref=Y.prototype.da;Y.prototype.refFromURL=Y.prototype.ea;Z(Y.prototype,"maxOperationRetryTime",Y.prototype.ia);Y.prototype.setMaxOperationRetryTime=Y.prototype.fa;Z(Y.prototype,"maxUploadRetryTime",Y.prototype.ja);Y.prototype.setMaxUploadRetryTime=Y.prototype.ga;Z(Y.prototype,"app",Y.prototype.V);Z(Y.prototype,"INTERNAL",Y.prototype.S);Wb.prototype["delete"]=Wb.prototype.b;Y.prototype.capi_=function(a){v=a};
	T.prototype.on=T.prototype.P;T.prototype.resume=T.prototype.T;T.prototype.pause=T.prototype.R;T.prototype.cancel=T.prototype.cancel;T.prototype.then=T.prototype.then;T.prototype["catch"]=T.prototype["catch"];Z(T.prototype,"snapshot",T.prototype.C);Z(Q.prototype,"bytesTransferred",Q.prototype.X);Z(Q.prototype,"totalBytes",Q.prototype.sa);Z(Q.prototype,"state",Q.prototype.pa);Z(Q.prototype,"metadata",Q.prototype.ka);Z(Q.prototype,"downloadURL",Q.prototype.Y);Z(Q.prototype,"task",Q.prototype.ra);
	Z(Q.prototype,"ref",Q.prototype.na);Ib.STATE_CHANGED="state_changed";P.RUNNING="running";P.PAUSED="paused";P.SUCCESS="success";P.CANCELED="canceled";P.ERROR="error";L.RAW="raw";L.BASE64="base64";L.BASE64URL="base64url";L.DATA_URL="data_url";
	(function(){function a(a,b,e){return new Y(a,new Kb,e)}var b={TaskState:P,TaskEvent:Ib,StringFormat:L,Storage:Y,Reference:W};if("undefined"!==typeof firebase)firebase.INTERNAL.registerService("storage",a,b,void 0,!0);else throw Error("Cannot install Firebase Storage - be sure to load firebase-app.js first.");})();}).call(this);
	}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
	module.exports = firebase.storage;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
	Build: rev-cc77c9e
	Terms: https://firebase.google.com/terms/ */
	
	var firebase = __webpack_require__(407);
	(function(){
	(function(){var f=function(a,b){function c(){}c.prototype=b.prototype;a.u=b.prototype;a.prototype=new c;for(var d in b)if(Object.defineProperties){var e=Object.getOwnPropertyDescriptor(b,d);e&&Object.defineProperty(a,d,e)}else a[d]=b[d]},g=this,h=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&
	"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},k=function(a,b){function c(){}c.prototype=b.prototype;a.u=b.prototype;a.prototype=new c;a.v=function(a,c,n){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-
	2]=arguments[e];return b.prototype[c].apply(a,d)}};var m=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,m);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};k(m,Error);var p=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")};var q=function(a,b){b.unshift(a);m.call(this,p.apply(null,b));b.shift()};k(q,m);var r=function(a,b,c){if(!a){var d="Assertion failed";if(b)var d=d+(": "+b),e=Array.prototype.slice.call(arguments,2);throw new q(""+d,e||[]);}};var t=null;var v=function(a){a=new Uint8Array(a);var b=h(a);r("array"==b||"object"==b&&"number"==typeof a.length,"encodeByteArray takes an array as a parameter");if(!t)for(t={},b=0;65>b;b++)t[b]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(b);for(var b=t,c=[],d=0;d<a.length;d+=3){var e=a[d],n=d+1<a.length,l=n?a[d+1]:0,z=d+2<a.length,u=z?a[d+2]:0,M=e>>2,e=(e&3)<<4|l>>4,l=(l&15)<<2|u>>6,u=u&63;z||(u=64,n||(l=64));c.push(b[M],b[e],b[l],b[u])}return c.join("").replace(/\+/g,"-").replace(/\//g,
	"_").replace(/=+$/,"")};var w={},x=(w["only-available-in-window"]="This method is available in a Window context.",w["only-available-in-sw"]="This method is available in a service worker context.",w["should-be-overriden"]="This method should be overriden by extended classes.",w["bad-sender-id"]="Please ensure that 'messagingSenderId' is set correctly in the options passed into firebase.initializeApp().",w["permission-default"]="The required permissions were not granted and dismissed instead.",w["permission-blocked"]="The required permissions were not granted and blocked instead.",
	w["unsupported-browser"]="This browser doesn't support the API's required to use the firebase SDK.",w["notifications-blocked"]="Notifications have been blocked.",w["failed-serviceworker-registration"]="We are unable to register the default service worker. {$browserErrorMessage}",w["sw-registration-expected"]="A service worker registration was the expected input.",w["get-subscription-failed"]="There was an error when trying to get any existing Push Subscriptions.",w["invalid-saved-token"]="Unable to access details of the saved token.",
	w["sw-reg-redundant"]="The service worker being used for push was made redundant.",w["token-subscribe-failed"]="A problem occured while subscribing the user to FCM: {$message}",w["token-subscribe-no-token"]="FCM returned no token when subscribing the user to push.",w["token-subscribe-no-push-set"]="FCM returned an invalid response when getting an FCM token.",w["use-sw-before-get-token"]="You must call useServiceWorker() before calling getToken() to ensure your service worker is used.",w["invalid-delete-token"]=
	"You must pass a valid token into deleteToken(), i.e. the token from getToken().",w["delete-token-not-found"]="The deletion attempt for token could not be performed as the token was not found.",w["delete-scope-not-found"]="The deletion attempt for service worker scope could not be performed as the scope was not found.",w["bg-handler-function-expected"]="The input to setBackgroundMessageHandler() must be a function.",w["no-window-client-to-msg"]="An attempt was made to message a non-existant window client.",
	w["unable-to-resubscribe"]="There was an error while re-subscribing the FCM token for push messaging. Will have to resubscribe the user on next visit. {$message}",w["no-fcm-token-for-resubscribe"]="Could not find an FCM token and as a result, unable to resubscribe. Will have to resubscribe the user on next visit.",w["failed-to-delete-token"]="Unable to delete the currently saved token.",w["no-sw-in-reg"]="Even though the service worker registration was successful, there was a problem accessing the service worker itself.",
	w["incorrect-gcm-sender-id"]="Please change your web app manifest's 'gcm_sender_id' value to '103953800507' to use Firebase messaging.",w["bad-scope"]="The service worker scope must be a string with at least one character.",w["bad-vapid-key"]="The public VAPID key must be a string with at least one character.",w["bad-subscription"]="The subscription must be a valid PushSubscription.",w["bad-token"]="The FCM Token used for storage / lookup was not a valid token string.",w["bad-push-set"]="The FCM push set used for storage / lookup was not not a valid push set string.",
	w["failed-delete-vapid-key"]="The VAPID key could not be deleted.",w);var y={userVisibleOnly:!0,applicationServerKey:new Uint8Array([4,51,148,247,223,161,235,177,220,3,162,94,21,113,219,72,211,46,237,237,178,52,219,183,71,58,12,143,196,204,225,111,60,140,132,223,171,182,102,62,242,12,212,139,254,227,249,118,47,20,28,99,8,106,111,45,177,26,149,176,206,55,192,156,110])};var A=new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x),B=function(){this.a=null},C=function(a){if(a.a)return a.a;a.a=new Promise(function(a,c){var b=g.indexedDB.open("fcm_token_details_db",1);b.onerror=function(a){c(a.target.error)};b.onsuccess=function(b){a(b.target.result)};b.onupgradeneeded=function(a){a=a.target.result.createObjectStore("fcm_token_object_Store",{keyPath:"swScope"});a.createIndex("fcmSenderId","fcmSenderId",{unique:!1});a.createIndex("fcmToken","fcmToken",{unique:!0})}});
	return a.a},D=function(a){a.a?a.a.then(function(b){b.close();a.a=null}):Promise.resolve()},E=function(a,b){return C(a).then(function(a){return new Promise(function(c,e){var d=a.transaction(["fcm_token_object_Store"]).objectStore("fcm_token_object_Store").index("fcmToken").get(b);d.onerror=function(a){e(a.target.error)};d.onsuccess=function(a){c(a.target.result)}})})},F=function(a,b){return C(a).then(function(a){return new Promise(function(c,e){var d=[],l=a.transaction(["fcm_token_object_Store"]).objectStore("fcm_token_object_Store").openCursor();
	l.onerror=function(a){e(a.target.error)};l.onsuccess=function(a){(a=a.target.result)?(a.value.fcmSenderId===b&&d.push(a.value),a.continue()):c(d)}})})},G=function(a,b,c){var d=v(b.getKey("p256dh")),e=v(b.getKey("auth"));a="authorized_entity="+a+"&"+("endpoint="+b.endpoint+"&")+("encryption_key="+d+"&")+("encryption_auth="+e);c&&(a+="&pushSet="+c);c=new Headers;c.append("Content-Type","application/x-www-form-urlencoded");return fetch("https://fcm.googleapis.com/fcm/connect/subscribe",{method:"POST",
	headers:c,body:a}).then(function(a){return a.json()}).then(function(a){if(a.error)throw A.create("token-subscribe-failed",{message:a.error.message});if(!a.token)throw A.create("token-subscribe-no-token");if(!a.pushSet)throw A.create("token-subscribe-no-push-set");return{token:a.token,pushSet:a.pushSet}})},H=function(a,b,c,d,e,n){var l={swScope:c.scope,endpoint:d.endpoint,auth:v(d.getKey("auth")),p256dh:v(d.getKey("p256dh")),fcmToken:e,fcmPushSet:n,fcmSenderId:b};return C(a).then(function(a){return new Promise(function(b,
	c){var d=a.transaction(["fcm_token_object_Store"],"readwrite").objectStore("fcm_token_object_Store").put(l);d.onerror=function(a){c(a.target.error)};d.onsuccess=function(){b()}})})};
	B.prototype.i=function(a,b){return b instanceof ServiceWorkerRegistration?"string"!==typeof a||0===a.length?Promise.reject(A.create("bad-sender-id")):F(this,a).then(function(c){if(0!==c.length){var d=c.findIndex(function(c){return b.scope===c.swScope&&a===c.fcmSenderId});if(-1!==d)return c[d]}}).then(function(a){if(a)return b.pushManager.getSubscription().catch(function(){throw A.create("get-subscription-failed");}).then(function(b){var c;if(c=b)c=b.endpoint===a.endpoint&&v(b.getKey("auth"))===a.auth&&
	v(b.getKey("p256dh"))===a.p256dh;if(c)return a.fcmToken})}):Promise.reject(A.create("sw-registration-expected"))};B.prototype.getSavedToken=B.prototype.i;
	B.prototype.h=function(a,b){var c=this;return"string"!==typeof a||0===a.length?Promise.reject(A.create("bad-sender-id")):b instanceof ServiceWorkerRegistration?b.pushManager.getSubscription().then(function(a){return a?a:b.pushManager.subscribe(y)}).then(function(d){return G(a,d).then(function(e){return H(c,a,b,d,e.token,e.pushSet).then(function(){return e.token})})}):Promise.reject(A.create("sw-registration-expected"))};B.prototype.createToken=B.prototype.h;
	B.prototype.deleteToken=function(a){var b=this;return"string"!==typeof a||0===a.length?Promise.reject(A.create("invalid-delete-token")):E(this,a).then(function(a){if(!a)throw A.create("delete-token-not-found");return C(b).then(function(b){return new Promise(function(c,d){var e=b.transaction(["fcm_token_object_Store"],"readwrite").objectStore("fcm_token_object_Store").delete(a.swScope);e.onerror=function(a){d(a.target.error)};e.onsuccess=function(b){0===b.target.result?d(A.create("failed-to-delete-token")):
	c(a)}})})})};var I=function(a){var b=this;this.a=new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);if(!a.options.messagingSenderId||"string"!==typeof a.options.messagingSenderId)throw this.a.create("bad-sender-id");this.l=a.options.messagingSenderId;this.c=new B;this.app=a;this.INTERNAL={};this.INTERNAL.delete=function(){return b.delete}};
	I.prototype.getToken=function(){var a=this,b=Notification.permission;return"granted"!==b?"denied"===b?Promise.reject(this.a.create("notifications-blocked")):Promise.resolve(null):this.f().then(function(b){return a.c.i(a.l,b).then(function(c){return c?c:a.c.h(a.l,b)})})};I.prototype.getToken=I.prototype.getToken;I.prototype.deleteToken=function(a){var b=this;return this.c.deleteToken(a).then(function(){return b.f()}).then(function(a){return a?a.pushManager.getSubscription():null}).then(function(a){if(a)return a.unsubscribe()})};
	I.prototype.deleteToken=I.prototype.deleteToken;I.prototype.f=function(){throw this.a.create("should-be-overriden");};I.prototype.requestPermission=function(){throw this.a.create("only-available-in-window");};I.prototype.useServiceWorker=function(){throw this.a.create("only-available-in-window");};I.prototype.useServiceWorker=I.prototype.useServiceWorker;I.prototype.onMessage=function(){throw this.a.create("only-available-in-window");};I.prototype.onMessage=I.prototype.onMessage;
	I.prototype.onTokenRefresh=function(){throw this.a.create("only-available-in-window");};I.prototype.onTokenRefresh=I.prototype.onTokenRefresh;I.prototype.setBackgroundMessageHandler=function(){throw this.a.create("only-available-in-sw");};I.prototype.setBackgroundMessageHandler=I.prototype.setBackgroundMessageHandler;I.prototype.delete=function(){D(this.c)};var J=function(a,b){var c={};return c["firebase-messaging-msg-type"]=a,c["firebase-messaging-msg-data"]=b,c};var K=self,P=function(a){I.call(this,a);var b=this;this.a=new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);K.addEventListener("push",function(a){return L(b,a)},!1);K.addEventListener("pushsubscriptionchange",function(a){return N(b,a)},!1);K.addEventListener("notificationclick",function(a){return O(b,a)},!1);this.b=null};f(P,I);
	var L=function(a,b){var c;try{c=b.data.json()}catch(e){return}var d=Q().then(function(b){if(b){if(c.notification||a.b)return R(a,c)}else{if((b=c)&&"object"===typeof b.notification){var d=Object.assign({},b.notification),e={};d.data=(e.FCM_MSG=b,e);b=d}else b=void 0;if(b)return K.registration.showNotification(b.title||"",b);if(a.b)return a.b(c)}});b.waitUntil(d)},N=function(a,b){var c=a.getToken().then(function(b){if(!b)throw a.a.create("no-fcm-token-for-resubscribe");var c=a.c;return E(c,b).then(function(b){if(!b)throw a.a.create("invalid-saved-token");
	return K.registration.pushManager.subscribe(y).then(function(a){return G(b.A,a,b.w)}).catch(function(d){return c.deleteToken(b.B).then(function(){throw a.a.create("unable-to-resubscribe",{message:d});})})})});b.waitUntil(c)},O=function(a,b){if(b.notification&&b.notification.data&&b.notification.data.FCM_MSG){b.stopImmediatePropagation();b.notification.close();var c=b.notification.data.FCM_MSG,d=c.notification.click_action;if(d){var e=S(d).then(function(a){return a?a:K.clients.openWindow(d)}).then(function(b){if(b)return delete c.notification,
	T(a,b,J("notification-clicked",c))});b.waitUntil(e)}}};P.prototype.setBackgroundMessageHandler=function(a){if(a&&"function"!==typeof a)throw this.a.create("bg-handler-function-expected");this.b=a};P.prototype.setBackgroundMessageHandler=P.prototype.setBackgroundMessageHandler;
	var S=function(a){var b=(new URL(a)).href;return K.clients.matchAll({type:"window",includeUncontrolled:!0}).then(function(a){for(var c=null,e=0;e<a.length;e++)if((new URL(a[e].url)).href===b){c=a[e];break}if(c)return c.focus(),c})},T=function(a,b,c){return new Promise(function(d,e){if(!b)return e(a.a.create("no-window-client-to-msg"));b.postMessage(c);d()})},Q=function(){return K.clients.matchAll({type:"window",includeUncontrolled:!0}).then(function(a){return a.some(function(a){return"visible"===
	a.visibilityState})})},R=function(a,b){return K.clients.matchAll({type:"window",includeUncontrolled:!0}).then(function(c){var d=J("push-msg-received",b);return Promise.all(c.map(function(b){return T(a,b,d)}))})};P.prototype.f=function(){return Promise.resolve(K.registration)};var V=function(a){I.call(this,a);var b=this;this.j=null;this.m=firebase.INTERNAL.createSubscribe(function(a){b.j=a});this.s=null;this.o=firebase.INTERNAL.createSubscribe(function(a){b.s=a});U(this)};f(V,I);
	V.prototype.getToken=function(){var a=this;return"serviceWorker"in navigator&&"PushManager"in window&&"Notification"in window&&ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification")&&PushSubscription.prototype.hasOwnProperty("getKey")?W(this).then(function(){return I.prototype.getToken.call(a)}):Promise.reject(this.a.create("unsupported-browser"))};V.prototype.getToken=V.prototype.getToken;
	var W=function(a){if(a.g)return a.g;var b=document.querySelector('link[rel="manifest"]');b?a.g=fetch(b.href).then(function(a){return a.json()}).catch(function(){return Promise.resolve()}).then(function(b){if(b&&b.gcm_sender_id&&"103953800507"!==b.gcm_sender_id)throw a.a.create("incorrect-gcm-sender-id");}):a.g=Promise.resolve();return a.g};
	V.prototype.requestPermission=function(){var a=this;return"granted"===Notification.permission?Promise.resolve():new Promise(function(b,c){var d=function(d){return"granted"===d?b():"denied"===d?c(a.a.create("permission-blocked")):c(a.a.create("permission-default"))},e=Notification.requestPermission(function(a){e||d(a)});e&&e.then(d)})};V.prototype.requestPermission=V.prototype.requestPermission;
	V.prototype.useServiceWorker=function(a){if(!(a instanceof ServiceWorkerRegistration))throw this.a.create("sw-registration-expected");if("undefined"!==typeof this.b)throw this.a.create("use-sw-before-get-token");this.b=a};V.prototype.useServiceWorker=V.prototype.useServiceWorker;V.prototype.onMessage=function(a,b,c){return this.m(a,b,c)};V.prototype.onMessage=V.prototype.onMessage;V.prototype.onTokenRefresh=function(a,b,c){return this.o(a,b,c)};V.prototype.onTokenRefresh=V.prototype.onTokenRefresh;
	var X=function(a,b){var c=b.installing||b.waiting||b.active;return new Promise(function(d,e){if(c)if("activated"===c.state)d(b);else if("redundant"===c.state)e(a.a.create("sw-reg-redundant"));else{var n=function(){if("activated"===c.state)d(b);else if("redundant"===c.state)e(a.a.create("sw-reg-redundant"));else return;c.removeEventListener("statechange",n)};c.addEventListener("statechange",n)}else e(a.a.create("no-sw-in-reg"))})};
	V.prototype.f=function(){var a=this;if(this.b)return X(this,this.b);this.b=null;return navigator.serviceWorker.register("/firebase-messaging-sw.js",{scope:"/firebase-cloud-messaging-push-scope"}).catch(function(b){throw a.a.create("failed-serviceworker-registration",{browserErrorMessage:b.message});}).then(function(b){return X(a,b).then(function(){a.b=b;b.update();return b})})};
	var U=function(a){"serviceWorker"in navigator&&navigator.serviceWorker.addEventListener("message",function(b){if(b.data&&b.data["firebase-messaging-msg-type"])switch(b=b.data,b["firebase-messaging-msg-type"]){case "push-msg-received":case "notification-clicked":a.j.next(b["firebase-messaging-msg-data"])}},!1)};if(!(firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService))throw Error("Cannot install Firebase Messaging - be sure to load firebase-app.js first.");firebase.INTERNAL.registerService("messaging",function(a){return self&&"ServiceWorkerGlobalScope"in self?new P(a):new V(a)},{Messaging:V});new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);}).call(this);
	}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
	module.exports = firebase.messaging;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	/*!
	 * AngularFire is the officially supported AngularJS binding for Firebase. Firebase
	 * is a full backend so you don't need servers to build your Angular app. AngularFire
	 * provides you with the $firebase service which allows you to easily keep your $scope
	 * variables in sync with your Firebase backend.
	 *
	 * AngularFire 0.0.0
	 * https://github.com/firebase/angularfire/
	 * Date: 01/23/2017
	 * License: MIT
	 */
	(function(exports) {
	  "use strict";
	
	  angular.module("firebase.utils", []);
	  angular.module("firebase.config", []);
	  angular.module("firebase.auth", ["firebase.utils"]);
	  angular.module("firebase.database", ["firebase.utils"]);
	  angular.module("firebase.storage", ["firebase.utils"]);
	
	  // Define the `firebase` module under which all AngularFire
	  // services will live.
	  angular.module("firebase", [
	    "firebase.utils",
	    "firebase.config",
	    "firebase.auth",
	    "firebase.database",
	    "firebase.storage"
	  ])
	    //TODO: use $window
	    .value("Firebase", exports.firebase)
	    .value("firebase", exports.firebase);
	})(window);
	
	(function() {
	  'use strict';
	  var FirebaseAuth;
	
	  // Define a service which provides user authentication and management.
	  angular.module('firebase.auth').factory('$firebaseAuth', [
	    '$q', '$firebaseUtils', function($q, $firebaseUtils) {
	      /**
	       * This factory returns an object allowing you to manage the client's authentication state.
	       *
	       * @param {Firebase.auth.Auth} auth A Firebase auth instance to authenticate.
	       * @return {object} An object containing methods for authenticating clients, retrieving
	       * authentication state, and managing users.
	       */
	      return function(auth) {
	        auth = auth || firebase.auth();
	
	        var firebaseAuth = new FirebaseAuth($q, $firebaseUtils, auth);
	        return firebaseAuth.construct();
	      };
	    }
	  ]);
	
	  FirebaseAuth = function($q, $firebaseUtils, auth) {
	    this._q = $q;
	    this._utils = $firebaseUtils;
	
	    if (typeof auth === 'string') {
	      throw new Error('The $firebaseAuth service accepts a Firebase auth instance (or nothing) instead of a URL.');
	    } else if (typeof auth.ref !== 'undefined') {
	      throw new Error('The $firebaseAuth service accepts a Firebase auth instance (or nothing) instead of a Database reference.');
	    }
	
	    this._auth = auth;
	    this._initialAuthResolver = this._initAuthResolver();
	  };
	
	  FirebaseAuth.prototype = {
	    construct: function() {
	      this._object = {
	        // Authentication methods
	        $signInWithCustomToken: this.signInWithCustomToken.bind(this),
	        $signInAnonymously: this.signInAnonymously.bind(this),
	        $signInWithEmailAndPassword: this.signInWithEmailAndPassword.bind(this),
	        $signInWithPopup: this.signInWithPopup.bind(this),
	        $signInWithRedirect: this.signInWithRedirect.bind(this),
	        $signInWithCredential: this.signInWithCredential.bind(this),
	        $signOut: this.signOut.bind(this),
	
	        // Authentication state methods
	        $onAuthStateChanged: this.onAuthStateChanged.bind(this),
	        $getAuth: this.getAuth.bind(this),
	        $requireSignIn: this.requireSignIn.bind(this),
	        $waitForSignIn: this.waitForSignIn.bind(this),
	
	        // User management methods
	        $createUserWithEmailAndPassword: this.createUserWithEmailAndPassword.bind(this),
	        $updatePassword: this.updatePassword.bind(this),
	        $updateEmail: this.updateEmail.bind(this),
	        $deleteUser: this.deleteUser.bind(this),
	        $sendPasswordResetEmail: this.sendPasswordResetEmail.bind(this),
	
	        // Hack: needed for tests
	        _: this
	      };
	
	      return this._object;
	    },
	
	
	    /********************/
	    /*  Authentication  */
	    /********************/
	
	    /**
	     * Authenticates the Firebase reference with a custom authentication token.
	     *
	     * @param {string} authToken An authentication token or a Firebase Secret. A Firebase Secret
	     * should only be used for authenticating a server process and provides full read / write
	     * access to the entire Firebase.
	     * @return {Promise<Object>} A promise fulfilled with an object containing authentication data.
	     */
	    signInWithCustomToken: function(authToken) {
	      return this._q.when(this._auth.signInWithCustomToken(authToken));
	    },
	
	    /**
	     * Authenticates the Firebase reference anonymously.
	     *
	     * @return {Promise<Object>} A promise fulfilled with an object containing authentication data.
	     */
	    signInAnonymously: function() {
	      return this._q.when(this._auth.signInAnonymously());
	    },
	
	    /**
	     * Authenticates the Firebase reference with an email/password user.
	     *
	     * @param {String} email An email address for the new user.
	     * @param {String} password A password for the new email.
	     * @return {Promise<Object>} A promise fulfilled with an object containing authentication data.
	     */
	    signInWithEmailAndPassword: function(email, password) {
	      return this._q.when(this._auth.signInWithEmailAndPassword(email, password));
	    },
	
	    /**
	     * Authenticates the Firebase reference with the OAuth popup flow.
	     *
	     * @param {object|string} provider A firebase.auth.AuthProvider or a unique provider ID like 'facebook'.
	     * @return {Promise<Object>} A promise fulfilled with an object containing authentication data.
	     */
	    signInWithPopup: function(provider) {
	      return this._q.when(this._auth.signInWithPopup(this._getProvider(provider)));
	    },
	
	    /**
	     * Authenticates the Firebase reference with the OAuth redirect flow.
	     *
	     * @param {object|string} provider A firebase.auth.AuthProvider or a unique provider ID like 'facebook'.
	     * @return {Promise<Object>} A promise fulfilled with an object containing authentication data.
	     */
	    signInWithRedirect: function(provider) {
	      return this._q.when(this._auth.signInWithRedirect(this._getProvider(provider)));
	    },
	
	    /**
	     * Authenticates the Firebase reference with an OAuth token.
	     *
	     * @param {firebase.auth.AuthCredential} credential The Firebase credential.
	     * @return {Promise<Object>} A promise fulfilled with an object containing authentication data.
	     */
	    signInWithCredential: function(credential) {
	      return this._q.when(this._auth.signInWithCredential(credential));
	    },
	
	    /**
	     * Unauthenticates the Firebase reference.
	     */
	    signOut: function() {
	      if (this.getAuth() !== null) {
	        return this._q.when(this._auth.signOut());
	      } else {
	        return this._q.when();
	      }
	    },
	
	
	    /**************************/
	    /*  Authentication State  */
	    /**************************/
	    /**
	     * Asynchronously fires the provided callback with the current authentication data every time
	     * the authentication data changes. It also fires as soon as the authentication data is
	     * retrieved from the server.
	     *
	     * @param {function} callback A callback that fires when the client's authenticate state
	     * changes. If authenticated, the callback will be passed an object containing authentication
	     * data according to the provider used to authenticate. Otherwise, it will be passed null.
	     * @param {string} [context] If provided, this object will be used as this when calling your
	     * callback.
	     * @return {Promise<Function>} A promised fulfilled with a function which can be used to
	     * deregister the provided callback.
	     */
	    onAuthStateChanged: function(callback, context) {
	      var fn = this._utils.debounce(callback, context, 0);
	      var off = this._auth.onAuthStateChanged(fn);
	
	      // Return a method to detach the `onAuthStateChanged()` callback.
	      return off;
	    },
	
	    /**
	     * Synchronously retrieves the current authentication data.
	     *
	     * @return {Object} The client's authentication data.
	     */
	    getAuth: function() {
	      return this._auth.currentUser;
	    },
	
	    /**
	     * Helper onAuthStateChanged() callback method for the two router-related methods.
	     *
	     * @param {boolean} rejectIfAuthDataIsNull Determines if the returned promise should be
	     * resolved or rejected upon an unauthenticated client.
	     * @param {boolean} rejectIfEmailNotVerified Determines if the returned promise should be 
	     * resolved or rejected upon a client without a verified email address.
	     * @return {Promise<Object>} A promise fulfilled with the client's authentication state or
	     * rejected if the client is unauthenticated and rejectIfAuthDataIsNull is true.
	     */
	    _routerMethodOnAuthPromise: function(rejectIfAuthDataIsNull, rejectIfEmailNotVerified) {
	      var self = this;
	
	      // wait for the initial auth state to resolve; on page load we have to request auth state
	      // asynchronously so we don't want to resolve router methods or flash the wrong state
	      return this._initialAuthResolver.then(function() {
	        // auth state may change in the future so rather than depend on the initially resolved state
	        // we also check the auth data (synchronously) if a new promise is requested, ensuring we resolve
	        // to the current auth state and not a stale/initial state
	        var authData = self.getAuth(), res = null;
	        if (rejectIfAuthDataIsNull && authData === null) {
	          res = self._q.reject("AUTH_REQUIRED");
	        }
	        else if (rejectIfEmailNotVerified && !authData.emailVerified) {
	            res = self._q.reject("EMAIL_VERIFICATION_REQUIRED");
	        }
	        else {
	          res = self._q.when(authData);
	        }
	        return res;
	      });
	    },
	
	    /**
	     * Helper method to turn provider names into AuthProvider instances
	     *
	     * @param {object} stringOrProvider Provider ID string to AuthProvider instance
	     * @return {firebdase.auth.AuthProvider} A valid AuthProvider instance
	     */
	    _getProvider: function (stringOrProvider) {
	      var provider;
	      if (typeof stringOrProvider == "string") {
	        var providerID = stringOrProvider.slice(0, 1).toUpperCase() + stringOrProvider.slice(1);
	        provider = new firebase.auth[providerID+"AuthProvider"]();
	      } else {
	        provider = stringOrProvider;
	      }
	      return provider;
	    },
	
	    /**
	     * Helper that returns a promise which resolves when the initial auth state has been
	     * fetched from the Firebase server. This never rejects and resolves to undefined.
	     *
	     * @return {Promise<Object>} A promise fulfilled when the server returns initial auth state.
	     */
	    _initAuthResolver: function() {
	      var auth = this._auth;
	
	      return this._q(function(resolve) {
	        var off;
	        function callback() {
	          // Turn off this onAuthStateChanged() callback since we just needed to get the authentication data once.
	          off();
	          resolve();
	        }
	        off = auth.onAuthStateChanged(callback);
	      });
	    },
	
	    /**
	     * Utility method which can be used in a route's resolve() method to require that a route has
	     * a logged in client.
	     *
	     * @param {boolean} requireEmailVerification Determines if the route requires a client with a 
	     * verified email address.
	     * @returns {Promise<Object>} A promise fulfilled with the client's current authentication
	     * state or rejected if the client is not authenticated.
	     */
	    requireSignIn: function(requireEmailVerification) {
	      return this._routerMethodOnAuthPromise(true, requireEmailVerification);
	    },
	
	    /**
	     * Utility method which can be used in a route's resolve() method to grab the current
	     * authentication data.
	     *
	     * @returns {Promise<Object|null>} A promise fulfilled with the client's current authentication
	     * state, which will be null if the client is not authenticated.
	     */
	    waitForSignIn: function() {
	      return this._routerMethodOnAuthPromise(false, false);
	    },
		
	    /*********************/
	    /*  User Management  */
	    /*********************/
	    /**
	     * Creates a new email/password user. Note that this function only creates the user, if you
	     * wish to log in as the newly created user, call $authWithPassword() after the promise for
	     * this method has been resolved.
	     *
	     * @param {string} email An email for this user.
	     * @param {string} password A password for this user.
	     * @return {Promise<Object>} A promise fulfilled with the user object, which contains the
	     * uid of the created user.
	     */
	    createUserWithEmailAndPassword: function(email, password) {
	      return this._q.when(this._auth.createUserWithEmailAndPassword(email, password));
	    },
	
	    /**
	     * Changes the password for an email/password user.
	     *
	     * @param {string} password A new password for the current user.
	     * @return {Promise<>} An empty promise fulfilled once the password change is complete.
	     */
	    updatePassword: function(password) {
	      var user = this.getAuth();
	      if (user) {
	        return this._q.when(user.updatePassword(password));
	      } else {
	        return this._q.reject("Cannot update password since there is no logged in user.");
	      }
	    },
	
	    /**
	     * Changes the email for an email/password user.
	     *
	     * @param {String} email The new email for the currently logged in user.
	     * @return {Promise<>} An empty promise fulfilled once the email change is complete.
	     */
	    updateEmail: function(email) {
	      var user = this.getAuth();
	      if (user) {
	        return this._q.when(user.updateEmail(email));
	      } else {
	        return this._q.reject("Cannot update email since there is no logged in user.");
	      }
	    },
	
	    /**
	     * Deletes the currently logged in user.
	     *
	     * @return {Promise<>} An empty promise fulfilled once the user is removed.
	     */
	    deleteUser: function() {
	      var user = this.getAuth();
	      if (user) {
	        return this._q.when(user.delete());
	      } else {
	        return this._q.reject("Cannot delete user since there is no logged in user.");
	      }
	    },
	
	
	    /**
	     * Sends a password reset email to an email/password user.
	     *
	     * @param {string} email An email address to send a password reset to.
	     * @return {Promise<>} An empty promise fulfilled once the reset password email is sent.
	     */
	    sendPasswordResetEmail: function(email) {
	      return this._q.when(this._auth.sendPasswordResetEmail(email));
	    }
	  };
	})();
	
	(function() {
	  "use strict";
	
	  function FirebaseAuthService($firebaseAuth) {
	    return $firebaseAuth();
	  }
	  FirebaseAuthService.$inject = ['$firebaseAuth'];
	
	  angular.module('firebase.auth')
	    .factory('$firebaseAuthService', FirebaseAuthService);
	
	})();
	
	(function() {
	  'use strict';
	  /**
	   * Creates and maintains a synchronized list of data. This is a pseudo-read-only array. One should
	   * not call splice(), push(), pop(), et al directly on this array, but should instead use the
	   * $remove and $add methods.
	   *
	   * It is acceptable to .sort() this array, but it is important to use this in conjunction with
	   * $watch(), so that it will be re-sorted any time the server data changes. Examples of this are
	   * included in the $watch documentation.
	   *
	   * Internally, the $firebase object depends on this class to provide several $$ (i.e. protected)
	   * methods, which it invokes to notify the array whenever a change has been made at the server:
	   *    $$added - called whenever a child_added event occurs
	   *    $$updated - called whenever a child_changed event occurs
	   *    $$moved - called whenever a child_moved event occurs
	   *    $$removed - called whenever a child_removed event occurs
	   *    $$error - called when listeners are canceled due to a security error
	   *    $$process - called immediately after $$added/$$updated/$$moved/$$removed
	   *                (assuming that these methods do not abort by returning false or null)
	   *                to splice/manipulate the array and invoke $$notify
	   *
	   * Additionally, these methods may be of interest to devs extending this class:
	   *    $$notify - triggers notifications to any $watch listeners, called by $$process
	   *    $$getKey - determines how to look up a record's key (returns $id by default)
	   *
	   * Instead of directly modifying this class, one should generally use the $extend
	   * method to add or change how methods behave. $extend modifies the prototype of
	   * the array class by returning a clone of $firebaseArray.
	   *
	   * <pre><code>
	   * var ExtendedArray = $firebaseArray.$extend({
	   *    // add a new method to the prototype
	   *    foo: function() { return 'bar'; },
	   *
	   *    // change how records are created
	   *    $$added: function(snap, prevChild) {
	   *       return new Widget(snap, prevChild);
	   *    },
	   *
	   *    // change how records are updated
	   *    $$updated: function(snap) {
	   *      return this.$getRecord(snap.key()).update(snap);
	   *    }
	   * });
	   *
	   * var list = new ExtendedArray(ref);
	   * </code></pre>
	   */
	  angular.module('firebase.database').factory('$firebaseArray', ["$log", "$firebaseUtils", "$q",
	    function($log, $firebaseUtils, $q) {
	      /**
	       * This constructor should probably never be called manually. It is used internally by
	       * <code>$firebase.$asArray()</code>.
	       *
	       * @param {Firebase} ref
	       * @returns {Array}
	       * @constructor
	       */
	      function FirebaseArray(ref) {
	        if( !(this instanceof FirebaseArray) ) {
	          return new FirebaseArray(ref);
	        }
	        var self = this;
	        this._observers = [];
	        this.$list = [];
	        this._ref = ref;
	        this._sync = new ArraySyncManager(this);
	
	        $firebaseUtils.assertValidRef(ref, 'Must pass a valid Firebase reference ' +
	        'to $firebaseArray (not a string or URL)');
	
	        // indexCache is a weak hashmap (a lazy list) of keys to array indices,
	        // items are not guaranteed to stay up to date in this list (since the data
	        // array can be manually edited without calling the $ methods) and it should
	        // always be used with skepticism regarding whether it is accurate
	        // (see $indexFor() below for proper usage)
	        this._indexCache = {};
	
	        // Array.isArray will not work on objects which extend the Array class.
	        // So instead of extending the Array class, we just return an actual array.
	        // However, it's still possible to extend FirebaseArray and have the public methods
	        // appear on the array object. We do this by iterating the prototype and binding
	        // any method that is not prefixed with an underscore onto the final array.
	        $firebaseUtils.getPublicMethods(self, function(fn, key) {
	          self.$list[key] = fn.bind(self);
	        });
	
	        this._sync.init(this.$list);
	
	        // $resolved provides quick access to the current state of the $loaded() promise.
	        // This is useful in data-binding when needing to delay the rendering or visibilty
	        // of the data until is has been loaded from firebase.
	        this.$list.$resolved = false;
	        this.$loaded().finally(function() {
	          self.$list.$resolved = true;
	        });
	
	        return this.$list;
	      }
	
	      FirebaseArray.prototype = {
	        /**
	         * Create a new record with a unique ID and add it to the end of the array.
	         * This should be used instead of Array.prototype.push, since those changes will not be
	         * synchronized with the server.
	         *
	         * Any value, including a primitive, can be added in this way. Note that when the record
	         * is created, the primitive value would be stored in $value (records are always objects
	         * by default).
	         *
	         * Returns a future which is resolved when the data has successfully saved to the server.
	         * The resolve callback will be passed a Firebase ref representing the new data element.
	         *
	         * @param data
	         * @returns a promise resolved after data is added
	         */
	        $add: function(data) {
	          this._assertNotDestroyed('$add');
	          var self = this;
	          var def = $q.defer();
	          var ref = this.$ref().ref.push();
	          var dataJSON;
	
	          try {
	            dataJSON = $firebaseUtils.toJSON(data);
	          } catch (err) {
	            def.reject(err);
	          }
	
	          if (typeof dataJSON !== 'undefined') {
	            $firebaseUtils.doSet(ref, dataJSON).then(function() {
	              self.$$notify('child_added', ref.key);
	              def.resolve(ref);
	            }).catch(def.reject);
	          }
	
	          return def.promise;
	        },
	
	        /**
	         * Pass either an item in the array or the index of an item and it will be saved back
	         * to Firebase. While the array is read-only and its structure should not be changed,
	         * it is okay to modify properties on the objects it contains and then save those back
	         * individually.
	         *
	         * Returns a future which is resolved when the data has successfully saved to the server.
	         * The resolve callback will be passed a Firebase ref representing the saved element.
	         * If passed an invalid index or an object which is not a record in this array,
	         * the promise will be rejected.
	         *
	         * @param {int|object} indexOrItem
	         * @returns a promise resolved after data is saved
	         */
	        $save: function(indexOrItem) {
	          this._assertNotDestroyed('$save');
	          var self = this;
	          var item = self._resolveItem(indexOrItem);
	          var key = self.$keyAt(item);
	          var def = $q.defer();
	
	          if( key !== null ) {
	            var ref = self.$ref().ref.child(key);
	            var dataJSON;
	
	            try {
	              dataJSON = $firebaseUtils.toJSON(item);
	            } catch (err) {
	              def.reject(err);
	            }
	
	            if (typeof dataJSON !== 'undefined') {
	              $firebaseUtils.doSet(ref, dataJSON).then(function() {
	                self.$$notify('child_changed', key);
	                def.resolve(ref);
	              }).catch(def.reject);
	            }
	          }
	          else {
	            def.reject('Invalid record; could not determine key for '+indexOrItem);
	          }
	
	          return def.promise;
	        },
	
	        /**
	         * Pass either an existing item in this array or the index of that item and it will
	         * be removed both locally and in Firebase. This should be used in place of
	         * Array.prototype.splice for removing items out of the array, as calling splice
	         * will not update the value on the server.
	         *
	         * Returns a future which is resolved when the data has successfully removed from the
	         * server. The resolve callback will be passed a Firebase ref representing the deleted
	         * element. If passed an invalid index or an object which is not a record in this array,
	         * the promise will be rejected.
	         *
	         * @param {int|object} indexOrItem
	         * @returns a promise which resolves after data is removed
	         */
	        $remove: function(indexOrItem) {
	          this._assertNotDestroyed('$remove');
	          var key = this.$keyAt(indexOrItem);
	          if( key !== null ) {
	            var ref = this.$ref().ref.child(key);
	            return $firebaseUtils.doRemove(ref).then(function() {
	              return ref;
	            });
	          }
	          else {
	            return $q.reject('Invalid record; could not determine key for '+indexOrItem);
	          }
	        },
	
	        /**
	         * Given an item in this array or the index of an item in the array, this returns the
	         * Firebase key (record.$id) for that record. If passed an invalid key or an item which
	         * does not exist in this array, it will return null.
	         *
	         * @param {int|object} indexOrItem
	         * @returns {null|string}
	         */
	        $keyAt: function(indexOrItem) {
	          var item = this._resolveItem(indexOrItem);
	          return this.$$getKey(item);
	        },
	
	        /**
	         * The inverse of $keyAt, this method takes a Firebase key (record.$id) and returns the
	         * index in the array where that record is stored. If the record is not in the array,
	         * this method returns -1.
	         *
	         * @param {String} key
	         * @returns {int} -1 if not found
	         */
	        $indexFor: function(key) {
	          var self = this;
	          var cache = self._indexCache;
	          // evaluate whether our key is cached and, if so, whether it is up to date
	          if( !cache.hasOwnProperty(key) || self.$keyAt(cache[key]) !== key ) {
	            // update the hashmap
	            var pos = self.$list.findIndex(function(rec) { return self.$$getKey(rec) === key; });
	            if( pos !== -1 ) {
	              cache[key] = pos;
	            }
	          }
	          return cache.hasOwnProperty(key)? cache[key] : -1;
	        },
	
	        /**
	         * The loaded method is invoked after the initial batch of data arrives from the server.
	         * When this resolves, all data which existed prior to calling $asArray() is now cached
	         * locally in the array.
	         *
	         * As a shortcut is also possible to pass resolve/reject methods directly into this
	         * method just as they would be passed to .then()
	         *
	         * @param {Function} [resolve]
	         * @param {Function} [reject]
	         * @returns a promise
	         */
	        $loaded: function(resolve, reject) {
	          var promise = this._sync.ready();
	          if( arguments.length ) {
	            // allow this method to be called just like .then
	            // by passing any arguments on to .then
	            promise = promise.then.call(promise, resolve, reject);
	          }
	          return promise;
	        },
	
	        /**
	         * @returns {Firebase} the original Firebase ref used to create this object.
	         */
	        $ref: function() { return this._ref; },
	
	        /**
	         * Listeners passed into this method are notified whenever a new change (add, updated,
	         * move, remove) is received from the server. Each invocation is sent an object
	         * containing <code>{ type: 'child_added|child_updated|child_moved|child_removed',
	         * key: 'key_of_item_affected'}</code>
	         *
	         * Additionally, added and moved events receive a prevChild parameter, containing the
	         * key of the item before this one in the array.
	         *
	         * This method returns a function which can be invoked to stop observing events.
	         *
	         * @param {Function} cb
	         * @param {Object} [context]
	         * @returns {Function} used to stop observing
	         */
	        $watch: function(cb, context) {
	          var list = this._observers;
	          list.push([cb, context]);
	          // an off function for cancelling the listener
	          return function() {
	            var i = list.findIndex(function(parts) {
	              return parts[0] === cb && parts[1] === context;
	            });
	            if( i > -1 ) {
	              list.splice(i, 1);
	            }
	          };
	        },
	
	        /**
	         * Informs $firebase to stop sending events and clears memory being used
	         * by this array (delete's its local content).
	         */
	        $destroy: function(err) {
	          if( !this._isDestroyed ) {
	            this._isDestroyed = true;
	            this._sync.destroy(err);
	            this.$list.length = 0;
	          }
	        },
	
	        /**
	         * Returns the record for a given Firebase key (record.$id). If the record is not found
	         * then returns null.
	         *
	         * @param {string} key
	         * @returns {Object|null} a record in this array
	         */
	        $getRecord: function(key) {
	          var i = this.$indexFor(key);
	          return i > -1? this.$list[i] : null;
	        },
	
	        /**
	         * Called to inform the array when a new item has been added at the server.
	         * This method should return the record (an object) that will be passed into $$process
	         * along with the add event. Alternately, the record will be skipped if this method returns
	         * a falsey value.
	         *
	         * @param {object} snap a Firebase snapshot
	         * @param {string} prevChild
	         * @return {object} the record to be inserted into the array
	         * @protected
	         */
	        $$added: function(snap/*, prevChild*/) {
	          // check to make sure record does not exist
	          var i = this.$indexFor(snap.key);
	          if( i === -1 ) {
	            // parse data and create record
	            var rec = snap.val();
	            if( !angular.isObject(rec) ) {
	              rec = { $value: rec };
	            }
	            rec.$id = snap.key;
	            rec.$priority = snap.getPriority();
	            $firebaseUtils.applyDefaults(rec, this.$$defaults);
	
	            return rec;
	          }
	          return false;
	        },
	
	        /**
	         * Called whenever an item is removed at the server.
	         * This method does not physically remove the objects, but instead
	         * returns a boolean indicating whether it should be removed (and
	         * taking any other desired actions before the remove completes).
	         *
	         * @param {object} snap a Firebase snapshot
	         * @return {boolean} true if item should be removed
	         * @protected
	         */
	        $$removed: function(snap) {
	          return this.$indexFor(snap.key) > -1;
	        },
	
	        /**
	         * Called whenever an item is changed at the server.
	         * This method should apply the changes, including changes to data
	         * and to $priority, and then return true if any changes were made.
	         *
	         * If this method returns false, then $$process will not be invoked,
	         * which means that $$notify will not take place and no $watch events
	         * will be triggered.
	         *
	         * @param {object} snap a Firebase snapshot
	         * @return {boolean} true if any data changed
	         * @protected
	         */
	        $$updated: function(snap) {
	          var changed = false;
	          var rec = this.$getRecord(snap.key);
	          if( angular.isObject(rec) ) {
	            // apply changes to the record
	            changed = $firebaseUtils.updateRec(rec, snap);
	            $firebaseUtils.applyDefaults(rec, this.$$defaults);
	          }
	          return changed;
	        },
	
	        /**
	         * Called whenever an item changes order (moves) on the server.
	         * This method should set $priority to the updated value and return true if
	         * the record should actually be moved. It should not actually apply the move
	         * operation.
	         *
	         * If this method returns false, then the record will not be moved in the array
	         * and no $watch listeners will be notified. (When true, $$process is invoked
	         * which invokes $$notify)
	         *
	         * @param {object} snap a Firebase snapshot
	         * @param {string} prevChild
	         * @protected
	         */
	        $$moved: function(snap/*, prevChild*/) {
	          var rec = this.$getRecord(snap.key);
	          if( angular.isObject(rec) ) {
	            rec.$priority = snap.getPriority();
	            return true;
	          }
	          return false;
	        },
	
	        /**
	         * Called whenever a security error or other problem causes the listeners to become
	         * invalid. This is generally an unrecoverable error.
	         *
	         * @param {Object} err which will have a `code` property and possibly a `message`
	         * @protected
	         */
	        $$error: function(err) {
	          $log.error(err);
	          this.$destroy(err);
	        },
	
	        /**
	         * Returns ID for a given record
	         * @param {object} rec
	         * @returns {string||null}
	         * @protected
	         */
	        $$getKey: function(rec) {
	          return angular.isObject(rec)? rec.$id : null;
	        },
	
	        /**
	         * Handles placement of recs in the array, sending notifications,
	         * and other internals. Called by the synchronization process
	         * after $$added, $$updated, $$moved, and $$removed return a truthy value.
	         *
	         * @param {string} event one of child_added, child_removed, child_moved, or child_changed
	         * @param {object} rec
	         * @param {string} [prevChild]
	         * @protected
	         */
	        $$process: function(event, rec, prevChild) {
	          var key = this.$$getKey(rec);
	          var changed = false;
	          var curPos;
	          switch(event) {
	            case 'child_added':
	              curPos = this.$indexFor(key);
	              break;
	            case 'child_moved':
	              curPos = this.$indexFor(key);
	              this._spliceOut(key);
	              break;
	            case 'child_removed':
	              // remove record from the array
	              changed = this._spliceOut(key) !== null;
	              break;
	            case 'child_changed':
	              changed = true;
	              break;
	            default:
	              throw new Error('Invalid event type: ' + event);
	          }
	          if( angular.isDefined(curPos) ) {
	            // add it to the array
	            changed = this._addAfter(rec, prevChild) !== curPos;
	          }
	          if( changed ) {
	            // send notifications to anybody monitoring $watch
	            this.$$notify(event, key, prevChild);
	          }
	          return changed;
	        },
	
	        /**
	         * Used to trigger notifications for listeners registered using $watch. This method is
	         * typically invoked internally by the $$process method.
	         *
	         * @param {string} event
	         * @param {string} key
	         * @param {string} [prevChild]
	         * @protected
	         */
	        $$notify: function(event, key, prevChild) {
	          var eventData = {event: event, key: key};
	          if( angular.isDefined(prevChild) ) {
	            eventData.prevChild = prevChild;
	          }
	          angular.forEach(this._observers, function(parts) {
	            parts[0].call(parts[1], eventData);
	          });
	        },
	
	        /**
	         * Used to insert a new record into the array at a specific position. If prevChild is
	         * null, is inserted first, if prevChild is not found, it is inserted last, otherwise,
	         * it goes immediately after prevChild.
	         *
	         * @param {object} rec
	         * @param {string|null} prevChild
	         * @private
	         */
	        _addAfter: function(rec, prevChild) {
	          var i;
	          if( prevChild === null ) {
	            i = 0;
	          }
	          else {
	            i = this.$indexFor(prevChild)+1;
	            if( i === 0 ) { i = this.$list.length; }
	          }
	          this.$list.splice(i, 0, rec);
	          this._indexCache[this.$$getKey(rec)] = i;
	          return i;
	        },
	
	        /**
	         * Removes a record from the array by calling splice. If the item is found
	         * this method returns it. Otherwise, this method returns null.
	         *
	         * @param {string} key
	         * @returns {object|null}
	         * @private
	         */
	        _spliceOut: function(key) {
	          var i = this.$indexFor(key);
	          if( i > -1 ) {
	            delete this._indexCache[key];
	            return this.$list.splice(i, 1)[0];
	          }
	          return null;
	        },
	
	        /**
	         * Resolves a variable which may contain an integer or an item that exists in this array.
	         * Returns the item or null if it does not exist.
	         *
	         * @param indexOrItem
	         * @returns {*}
	         * @private
	         */
	        _resolveItem: function(indexOrItem) {
	          var list = this.$list;
	          if( angular.isNumber(indexOrItem) && indexOrItem >= 0 && list.length >= indexOrItem ) {
	            return list[indexOrItem];
	          }
	          else if( angular.isObject(indexOrItem) ) {
	            // it must be an item in this array; it's not sufficient for it just to have
	            // a $id or even a $id that is in the array, it must be an actual record
	            // the fastest way to determine this is to use $getRecord (to avoid iterating all recs)
	            // and compare the two
	            var key = this.$$getKey(indexOrItem);
	            var rec = this.$getRecord(key);
	            return rec === indexOrItem? rec : null;
	          }
	          return null;
	        },
	
	        /**
	         * Throws an error if $destroy has been called. Should be used for any function
	         * which tries to write data back to $firebase.
	         * @param {string} method
	         * @private
	         */
	        _assertNotDestroyed: function(method) {
	          if( this._isDestroyed ) {
	            throw new Error('Cannot call ' + method + ' method on a destroyed $firebaseArray object');
	          }
	        }
	      };
	
	      /**
	       * This method allows FirebaseArray to be inherited by child classes. Methods passed into this
	       * function will be added onto the array's prototype. They can override existing methods as
	       * well.
	       *
	       * In addition to passing additional methods, it is also possible to pass in a class function.
	       * The prototype on that class function will be preserved, and it will inherit from
	       * FirebaseArray. It's also possible to do both, passing a class to inherit and additional
	       * methods to add onto the prototype.
	       *
	       *  <pre><code>
	       * var ExtendedArray = $firebaseArray.$extend({
	       *    // add a method onto the prototype that sums all items in the array
	       *    getSum: function() {
	       *       var ct = 0;
	       *       angular.forEach(this.$list, function(rec) { ct += rec.x; });
	        *      return ct;
	       *    }
	       * });
	       *
	       * // use our new factory in place of $firebaseArray
	       * var list = new ExtendedArray(ref);
	       * </code></pre>
	       *
	       * @param {Function} [ChildClass] a child class which should inherit FirebaseArray
	       * @param {Object} [methods] a list of functions to add onto the prototype
	       * @returns {Function} a child class suitable for use with $firebase (this will be ChildClass if provided)
	       * @static
	       */
	      FirebaseArray.$extend = function(ChildClass, methods) {
	        if( arguments.length === 1 && angular.isObject(ChildClass) ) {
	          methods = ChildClass;
	          ChildClass = function(ref) {
	            if( !(this instanceof ChildClass) ) {
	              return new ChildClass(ref);
	            }
	            FirebaseArray.apply(this, arguments);
	            return this.$list;
	          };
	        }
	        return $firebaseUtils.inherit(ChildClass, FirebaseArray, methods);
	      };
	
	      function ArraySyncManager(firebaseArray) {
	        function destroy(err) {
	          if( !sync.isDestroyed ) {
	            sync.isDestroyed = true;
	            var ref = firebaseArray.$ref();
	            ref.off('child_added', created);
	            ref.off('child_moved', moved);
	            ref.off('child_changed', updated);
	            ref.off('child_removed', removed);
	            firebaseArray = null;
	            initComplete(err||'destroyed');
	          }
	        }
	
	        function init($list) {
	          var ref = firebaseArray.$ref();
	
	          // listen for changes at the Firebase instance
	          ref.on('child_added', created, error);
	          ref.on('child_moved', moved, error);
	          ref.on('child_changed', updated, error);
	          ref.on('child_removed', removed, error);
	
	          // determine when initial load is completed
	          ref.once('value', function(snap) {
	            if (angular.isArray(snap.val())) {
	              $log.warn('Storing data using array indices in Firebase can result in unexpected behavior. See https://firebase.google.com/docs/database/web/structure-data for more information.');
	            }
	
	            initComplete(null, $list);
	          }, initComplete);
	        }
	
	        // call initComplete(), do not call this directly
	        function _initComplete(err, result) {
	          if( !isResolved ) {
	            isResolved = true;
	            if( err ) { def.reject(err); }
	            else { def.resolve(result); }
	          }
	        }
	
	        var def = $q.defer();
	        var created = function(snap, prevChild) {
	          if (!firebaseArray) {
	            return;
	          }
	          waitForResolution(firebaseArray.$$added(snap, prevChild), function(rec) {
	            firebaseArray.$$process('child_added', rec, prevChild);
	          });
	        };
	        var updated = function(snap) {
	          if (!firebaseArray) {
	            return;
	          }
	          var rec = firebaseArray.$getRecord(snap.key);
	          if( rec ) {
	            waitForResolution(firebaseArray.$$updated(snap), function() {
	              firebaseArray.$$process('child_changed', rec);
	            });
	          }
	        };
	        var moved   = function(snap, prevChild) {
	          if (!firebaseArray) {
	            return;
	          }
	          var rec = firebaseArray.$getRecord(snap.key);
	          if( rec ) {
	            waitForResolution(firebaseArray.$$moved(snap, prevChild), function() {
	              firebaseArray.$$process('child_moved', rec, prevChild);
	            });
	          }
	        };
	        var removed = function(snap) {
	          if (!firebaseArray) {
	            return;
	          }
	          var rec = firebaseArray.$getRecord(snap.key);
	          if( rec ) {
	            waitForResolution(firebaseArray.$$removed(snap), function() {
	               firebaseArray.$$process('child_removed', rec);
	            });
	          }
	        };
	
	        function waitForResolution(maybePromise, callback) {
	          var promise = $q.when(maybePromise);
	          promise.then(function(result){
	            if (result) {
	              callback(result);
	            }
	          });
	          if (!isResolved) {
	            resolutionPromises.push(promise);
	          }
	        }
	
	        var resolutionPromises = [];
	        var isResolved = false;
	        var error   = $firebaseUtils.batch(function(err) {
	          _initComplete(err);
	          if( firebaseArray ) {
	            firebaseArray.$$error(err);
	          }
	        });
	        var initComplete = $firebaseUtils.batch(_initComplete);
	
	        var sync = {
	          destroy: destroy,
	          isDestroyed: false,
	          init: init,
	          ready: function() { return def.promise.then(function(result){
	            return $q.all(resolutionPromises).then(function(){
	              return result;
	            });
	          }); }
	        };
	
	        return sync;
	      }
	
	      return FirebaseArray;
	    }
	  ]);
	
	  /** @deprecated */
	  angular.module('firebase').factory('$FirebaseArray', ['$log', '$firebaseArray',
	    function($log, $firebaseArray) {
	      return function() {
	        $log.warn('$FirebaseArray has been renamed. Use $firebaseArray instead.');
	        return $firebaseArray.apply(null, arguments);
	      };
	    }
	  ]);
	})();
	
	(function() {
	  'use strict';
	  /**
	   * Creates and maintains a synchronized object, with 2-way bindings between Angular and Firebase.
	   *
	   * Implementations of this class are contracted to provide the following internal methods,
	   * which are used by the synchronization process and 3-way bindings:
	   *    $$updated - called whenever a change occurs (a value event from Firebase)
	   *    $$error - called when listeners are canceled due to a security error
	   *    $$notify - called to update $watch listeners and trigger updates to 3-way bindings
	   *    $ref - called to obtain the underlying Firebase reference
	   *
	   * Instead of directly modifying this class, one should generally use the $extend
	   * method to add or change how methods behave:
	   *
	   * <pre><code>
	   * var ExtendedObject = $firebaseObject.$extend({
	   *    // add a new method to the prototype
	   *    foo: function() { return 'bar'; },
	   * });
	   *
	   * var obj = new ExtendedObject(ref);
	   * </code></pre>
	   */
	  angular.module('firebase.database').factory('$firebaseObject', [
	    '$parse', '$firebaseUtils', '$log', '$q',
	    function($parse, $firebaseUtils, $log, $q) {
	      /**
	       * Creates a synchronized object with 2-way bindings between Angular and Firebase.
	       *
	       * @param {Firebase} ref
	       * @returns {FirebaseObject}
	       * @constructor
	       */
	      function FirebaseObject(ref) {
	        if( !(this instanceof FirebaseObject) ) {
	          return new FirebaseObject(ref);
	        }
	        var self = this;
	        // These are private config props and functions used internally
	        // they are collected here to reduce clutter in console.log and forEach
	        this.$$conf = {
	          // synchronizes data to Firebase
	          sync: new ObjectSyncManager(this, ref),
	          // stores the Firebase ref
	          ref: ref,
	          // synchronizes $scope variables with this object
	          binding: new ThreeWayBinding(this),
	          // stores observers registered with $watch
	          listeners: []
	        };
	
	        // this bit of magic makes $$conf non-enumerable and non-configurable
	        // and non-writable (its properties are still writable but the ref cannot be replaced)
	        // we redundantly assign it above so the IDE can relax
	        Object.defineProperty(this, '$$conf', {
	          value: this.$$conf
	        });
	
	        this.$id = ref.ref.key;
	        this.$priority = null;
	
	        $firebaseUtils.applyDefaults(this, this.$$defaults);
	
	        // start synchronizing data with Firebase
	        this.$$conf.sync.init();
	
	        // $resolved provides quick access to the current state of the $loaded() promise.
	        // This is useful in data-binding when needing to delay the rendering or visibilty
	        // of the data until is has been loaded from firebase.
	        this.$resolved = false;
	        this.$loaded().finally(function() {
	          self.$resolved = true;
	        });
	      }
	
	      FirebaseObject.prototype = {
	        /**
	         * Saves all data on the FirebaseObject back to Firebase.
	         * @returns a promise which will resolve after the save is completed.
	         */
	        $save: function () {
	          var self = this;
	          var ref = self.$ref();
	          var def = $q.defer();
	          var dataJSON;
	
	          try {
	            dataJSON = $firebaseUtils.toJSON(self);
	          } catch (e) {
	            def.reject(e);
	          }
	
	          if (typeof dataJSON !== 'undefined') {
	            $firebaseUtils.doSet(ref, dataJSON).then(function() {
	              self.$$notify();
	              def.resolve(self.$ref());
	            }).catch(def.reject);
	          }
	
	          return def.promise;
	        },
	
	        /**
	         * Removes all keys from the FirebaseObject and also removes
	         * the remote data from the server.
	         *
	         * @returns a promise which will resolve after the op completes
	         */
	        $remove: function() {
	          var self = this;
	          $firebaseUtils.trimKeys(self, {});
	          self.$value = null;
	          return $firebaseUtils.doRemove(self.$ref()).then(function() {
	            self.$$notify();
	            return self.$ref();
	          });
	        },
	
	        /**
	         * The loaded method is invoked after the initial batch of data arrives from the server.
	         * When this resolves, all data which existed prior to calling $asObject() is now cached
	         * locally in the object.
	         *
	         * As a shortcut is also possible to pass resolve/reject methods directly into this
	         * method just as they would be passed to .then()
	         *
	         * @param {Function} resolve
	         * @param {Function} reject
	         * @returns a promise which resolves after initial data is downloaded from Firebase
	         */
	        $loaded: function(resolve, reject) {
	          var promise = this.$$conf.sync.ready();
	          if (arguments.length) {
	            // allow this method to be called just like .then
	            // by passing any arguments on to .then
	            promise = promise.then.call(promise, resolve, reject);
	          }
	          return promise;
	        },
	
	        /**
	         * @returns {Firebase} the original Firebase instance used to create this object.
	         */
	        $ref: function () {
	          return this.$$conf.ref;
	        },
	
	        /**
	         * Creates a 3-way data sync between this object, the Firebase server, and a
	         * scope variable. This means that any changes made to the scope variable are
	         * pushed to Firebase, and vice versa.
	         *
	         * If scope emits a $destroy event, the binding is automatically severed. Otherwise,
	         * it is possible to unbind the scope variable by using the `unbind` function
	         * passed into the resolve method.
	         *
	         * Can only be bound to one scope variable at a time. If a second is attempted,
	         * the promise will be rejected with an error.
	         *
	         * @param {object} scope
	         * @param {string} varName
	         * @returns a promise which resolves to an unbind method after data is set in scope
	         */
	        $bindTo: function (scope, varName) {
	          var self = this;
	          return self.$loaded().then(function () {
	            return self.$$conf.binding.bindTo(scope, varName);
	          });
	        },
	
	        /**
	         * Listeners passed into this method are notified whenever a new change is received
	         * from the server. Each invocation is sent an object containing
	         * <code>{ type: 'value', key: 'my_firebase_id' }</code>
	         *
	         * This method returns an unbind function that can be used to detach the listener.
	         *
	         * @param {Function} cb
	         * @param {Object} [context]
	         * @returns {Function} invoke to stop observing events
	         */
	        $watch: function (cb, context) {
	          var list = this.$$conf.listeners;
	          list.push([cb, context]);
	          // an off function for cancelling the listener
	          return function () {
	            var i = list.findIndex(function (parts) {
	              return parts[0] === cb && parts[1] === context;
	            });
	            if (i > -1) {
	              list.splice(i, 1);
	            }
	          };
	        },
	
	        /**
	         * Informs $firebase to stop sending events and clears memory being used
	         * by this object (delete's its local content).
	         */
	        $destroy: function(err) {
	          var self = this;
	          if (!self.$isDestroyed) {
	            self.$isDestroyed = true;
	            self.$$conf.sync.destroy(err);
	            self.$$conf.binding.destroy();
	            $firebaseUtils.each(self, function (v, k) {
	              delete self[k];
	            });
	          }
	        },
	
	        /**
	         * Called by $firebase whenever an item is changed at the server.
	         * This method must exist on any objectFactory passed into $firebase.
	         *
	         * It should return true if any changes were made, otherwise `$$notify` will
	         * not be invoked.
	         *
	         * @param {object} snap a Firebase snapshot
	         * @return {boolean} true if any changes were made.
	         */
	        $$updated: function (snap) {
	          // applies new data to this object
	          var changed = $firebaseUtils.updateRec(this, snap);
	          // applies any defaults set using $$defaults
	          $firebaseUtils.applyDefaults(this, this.$$defaults);
	          // returning true here causes $$notify to be triggered
	          return changed;
	        },
	
	        /**
	         * Called whenever a security error or other problem causes the listeners to become
	         * invalid. This is generally an unrecoverable error.
	         * @param {Object} err which will have a `code` property and possibly a `message`
	         */
	        $$error: function (err) {
	          // prints an error to the console (via Angular's logger)
	          $log.error(err);
	          // frees memory and cancels any remaining listeners
	          this.$destroy(err);
	        },
	
	        /**
	         * Called internally by $bindTo when data is changed in $scope.
	         * Should apply updates to this record but should not call
	         * notify().
	         */
	        $$scopeUpdated: function(newData) {
	          // we use a one-directional loop to avoid feedback with 3-way bindings
	          // since set() is applied locally anyway, this is still performant
	          var def = $q.defer();
	          this.$ref().set($firebaseUtils.toJSON(newData), $firebaseUtils.makeNodeResolver(def));
	          return def.promise;
	        },
	
	        /**
	         * Updates any bound scope variables and
	         * notifies listeners registered with $watch
	         */
	        $$notify: function() {
	          var self = this, list = this.$$conf.listeners.slice();
	          // be sure to do this after setting up data and init state
	          angular.forEach(list, function (parts) {
	            parts[0].call(parts[1], {event: 'value', key: self.$id});
	          });
	        },
	
	        /**
	         * Overrides how Angular.forEach iterates records on this object so that only
	         * fields stored in Firebase are part of the iteration. To include meta fields like
	         * $id and $priority in the iteration, utilize for(key in obj) instead.
	         */
	        forEach: function(iterator, context) {
	          return $firebaseUtils.each(this, iterator, context);
	        }
	      };
	
	      /**
	       * This method allows FirebaseObject to be copied into a new factory. Methods passed into this
	       * function will be added onto the object's prototype. They can override existing methods as
	       * well.
	       *
	       * In addition to passing additional methods, it is also possible to pass in a class function.
	       * The prototype on that class function will be preserved, and it will inherit from
	       * FirebaseObject. It's also possible to do both, passing a class to inherit and additional
	       * methods to add onto the prototype.
	       *
	       * Once a factory is obtained by this method, it can be passed into $firebase as the
	       * `objectFactory` parameter:
	       *
	       * <pre><code>
	       * var MyFactory = $firebaseObject.$extend({
	       *    // add a method onto the prototype that prints a greeting
	       *    getGreeting: function() {
	       *       return 'Hello ' + this.first_name + ' ' + this.last_name + '!';
	       *    }
	       * });
	       *
	       * // use our new factory in place of $firebaseObject
	       * var obj = $firebase(ref, {objectFactory: MyFactory}).$asObject();
	       * </code></pre>
	       *
	       * @param {Function} [ChildClass] a child class which should inherit FirebaseObject
	       * @param {Object} [methods] a list of functions to add onto the prototype
	       * @returns {Function} a new factory suitable for use with $firebase
	       */
	      FirebaseObject.$extend = function(ChildClass, methods) {
	        if( arguments.length === 1 && angular.isObject(ChildClass) ) {
	          methods = ChildClass;
	          ChildClass = function(ref) {
	            if( !(this instanceof ChildClass) ) {
	              return new ChildClass(ref);
	            }
	            FirebaseObject.apply(this, arguments);
	          };
	        }
	        return $firebaseUtils.inherit(ChildClass, FirebaseObject, methods);
	      };
	
	      /**
	       * Creates a three-way data binding on a scope variable.
	       *
	       * @param {FirebaseObject} rec
	       * @returns {*}
	       * @constructor
	       */
	      function ThreeWayBinding(rec) {
	        this.subs = [];
	        this.scope = null;
	        this.key = null;
	        this.rec = rec;
	      }
	
	      ThreeWayBinding.prototype = {
	        assertNotBound: function(varName) {
	          if( this.scope ) {
	            var msg = 'Cannot bind to ' + varName + ' because this instance is already bound to ' +
	              this.key + '; one binding per instance ' +
	              '(call unbind method or create another FirebaseObject instance)';
	            $log.error(msg);
	            return $q.reject(msg);
	          }
	        },
	
	        bindTo: function(scope, varName) {
	          function _bind(self) {
	            var sending = false;
	            var parsed = $parse(varName);
	            var rec = self.rec;
	            self.scope = scope;
	            self.varName = varName;
	
	            function equals(scopeValue) {
	              return angular.equals(scopeValue, rec) &&
	                scopeValue.$priority === rec.$priority &&
	                scopeValue.$value === rec.$value;
	            }
	
	            function setScope(rec) {
	              parsed.assign(scope, $firebaseUtils.scopeData(rec));
	            }
	
	            var send = $firebaseUtils.debounce(function(val) {
	              var scopeData = $firebaseUtils.scopeData(val);
	              rec.$$scopeUpdated(scopeData)
	                ['finally'](function() {
	                  sending = false;
	                  if(!scopeData.hasOwnProperty('$value')){
	                    delete rec.$value;
	                    delete parsed(scope).$value;
	                  }
	                  setScope(rec);
	                }
	              );
	            }, 50, 500);
	
	            var scopeUpdated = function(newVal) {
	              newVal = newVal[0];
	              if( !equals(newVal) ) {
	                sending = true;
	                send(newVal);
	              }
	            };
	
	            var recUpdated = function() {
	              if( !sending && !equals(parsed(scope)) ) {
	                setScope(rec);
	              }
	            };
	
	            // $watch will not check any vars prefixed with $, so we
	            // manually check $priority and $value using this method
	            function watchExp(){
	              var obj = parsed(scope);
	              return [obj, obj.$priority, obj.$value];
	            }
	
	            setScope(rec);
	            self.subs.push(scope.$on('$destroy', self.unbind.bind(self)));
	
	            // monitor scope for any changes
	            self.subs.push(scope.$watch(watchExp, scopeUpdated, true));
	
	            // monitor the object for changes
	            self.subs.push(rec.$watch(recUpdated));
	
	            return self.unbind.bind(self);
	          }
	
	          return this.assertNotBound(varName) || _bind(this);
	        },
	
	        unbind: function() {
	          if( this.scope ) {
	            angular.forEach(this.subs, function(unbind) {
	              unbind();
	            });
	            this.subs = [];
	            this.scope = null;
	            this.key = null;
	          }
	        },
	
	        destroy: function() {
	          this.unbind();
	          this.rec = null;
	        }
	      };
	
	      function ObjectSyncManager(firebaseObject, ref) {
	        function destroy(err) {
	          if( !sync.isDestroyed ) {
	            sync.isDestroyed = true;
	            ref.off('value', applyUpdate);
	            firebaseObject = null;
	            initComplete(err||'destroyed');
	          }
	        }
	
	        function init() {
	          ref.on('value', applyUpdate, error);
	          ref.once('value', function(snap) {
	            if (angular.isArray(snap.val())) {
	              $log.warn('Storing data using array indices in Firebase can result in unexpected behavior. See https://firebase.google.com/docs/database/web/structure-data for more information. Also note that you probably wanted $firebaseArray and not $firebaseObject.');
	            }
	
	            initComplete(null);
	          }, initComplete);
	        }
	
	        // call initComplete(); do not call this directly
	        function _initComplete(err) {
	          if( !isResolved ) {
	            isResolved = true;
	            if( err ) { def.reject(err); }
	            else { def.resolve(firebaseObject); }
	          }
	        }
	
	        var isResolved = false;
	        var def = $q.defer();
	        var applyUpdate = $firebaseUtils.batch(function(snap) {
	          if (firebaseObject) {
	            var changed = firebaseObject.$$updated(snap);
	            if( changed ) {
	              // notifies $watch listeners and
	              // updates $scope if bound to a variable
	              firebaseObject.$$notify();
	            }
	          }
	        });
	        var error = $firebaseUtils.batch(function(err) {
	          _initComplete(err);
	          if( firebaseObject ) {
	            firebaseObject.$$error(err);
	          }
	        });
	        var initComplete = $firebaseUtils.batch(_initComplete);
	
	        var sync = {
	          isDestroyed: false,
	          destroy: destroy,
	          init: init,
	          ready: function() { return def.promise; }
	        };
	        return sync;
	      }
	
	      return FirebaseObject;
	    }
	  ]);
	
	  /** @deprecated */
	  angular.module('firebase').factory('$FirebaseObject', ['$log', '$firebaseObject',
	    function($log, $firebaseObject) {
	      return function() {
	        $log.warn('$FirebaseObject has been renamed. Use $firebaseObject instead.');
	        return $firebaseObject.apply(null, arguments);
	      };
	    }
	  ]);
	})();
	
	(function() {
	  "use strict";
	
	  function FirebaseRef() {
	    this.urls = null;
	    this.registerUrl = function registerUrl(urlOrConfig) {
	
	      if (typeof urlOrConfig === 'string') {
	        this.urls = {};
	        this.urls.default = urlOrConfig;
	      }
	
	      if (angular.isObject(urlOrConfig)) {
	        this.urls = urlOrConfig;
	      }
	
	    };
	
	    this.$$checkUrls = function $$checkUrls(urlConfig) {
	      if (!urlConfig) {
	        return new Error('No Firebase URL registered. Use firebaseRefProvider.registerUrl() in the config phase. This is required if you are using $firebaseAuthService.');
	      }
	      if (!urlConfig.default) {
	        return new Error('No default Firebase URL registered. Use firebaseRefProvider.registerUrl({ default: "https://<my-firebase-app>.firebaseio.com/"}).');
	      }
	    };
	
	    this.$$createRefsFromUrlConfig = function $$createMultipleRefs(urlConfig) {
	      var refs = {};
	      var error = this.$$checkUrls(urlConfig);
	      if (error) { throw error; }
	      angular.forEach(urlConfig, function(value, key) {
	        refs[key] = firebase.database().refFromURL(value);
	      });
	      return refs;
	    };
	
	    this.$get = function FirebaseRef_$get() {
	      return this.$$createRefsFromUrlConfig(this.urls);
	    };
	  }
	
	  angular.module('firebase.database')
	    .provider('$firebaseRef', FirebaseRef);
	
	})();
	
	(function() {
	  'use strict';
	
	  angular.module("firebase")
	
	    /** @deprecated */
	    .factory("$firebase", function() {
	      return function() {
	        //TODO: Update this error to speak about new module stuff
	        throw new Error('$firebase has been removed. You may instantiate $firebaseArray and $firebaseObject ' +
	        'directly now. For simple write operations, just use the Firebase ref directly. ' +
	        'See the AngularFire 1.0.0 changelog for details: https://github.com/firebase/angularfire/releases/tag/v1.0.0');
	      };
	    });
	
	})();
	
	'use strict';
	
	// Shim Array.indexOf for IE compatibility.
	if (!Array.prototype.indexOf) {
	  Array.prototype.indexOf = function (searchElement, fromIndex) {
	    if (this === undefined || this === null) {
	      throw new TypeError("'this' is null or not defined");
	    }
	    // Hack to convert object.length to a UInt32
	    // jshint -W016
	    var length = this.length >>> 0;
	    fromIndex = +fromIndex || 0;
	    // jshint +W016
	
	    if (Math.abs(fromIndex) === Infinity) {
	      fromIndex = 0;
	    }
	
	    if (fromIndex < 0) {
	      fromIndex += length;
	      if (fromIndex < 0) {
	        fromIndex = 0;
	      }
	    }
	
	    for (;fromIndex < length; fromIndex++) {
	      if (this[fromIndex] === searchElement) {
	        return fromIndex;
	      }
	    }
	
	    return -1;
	  };
	}
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
	if (!Function.prototype.bind) {
	  Function.prototype.bind = function (oThis) {
	    if (typeof this !== "function") {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
	    }
	
	    var aArgs = Array.prototype.slice.call(arguments, 1),
	      fToBind = this,
	      fNOP = function () {},
	      fBound = function () {
	        return fToBind.apply(this instanceof fNOP && oThis
	            ? this
	            : oThis,
	          aArgs.concat(Array.prototype.slice.call(arguments)));
	      };
	
	    fNOP.prototype = this.prototype;
	    fBound.prototype = new fNOP();
	
	    return fBound;
	  };
	}
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	if (!Array.prototype.findIndex) {
	  Object.defineProperty(Array.prototype, 'findIndex', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: function(predicate) {
	      if (this == null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        if (i in list) {
	          value = list[i];
	          if (predicate.call(thisArg, value, i, list)) {
	            return i;
	          }
	        }
	      }
	      return -1;
	    }
	  });
	}
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
	if (typeof Object.create != 'function') {
	  (function () {
	    var F = function () {};
	    Object.create = function (o) {
	      if (arguments.length > 1) {
	        throw new Error('Second argument not supported');
	      }
	      if (o === null) {
	        throw new Error('Cannot set a null [[Prototype]]');
	      }
	      if (typeof o != 'object') {
	        throw new TypeError('Argument must be an object');
	      }
	      F.prototype = o;
	      return new F();
	    };
	  })();
	}
	
	// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
	if (!Object.keys) {
	  Object.keys = (function () {
	    'use strict';
	    var hasOwnProperty = Object.prototype.hasOwnProperty,
	      hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
	      dontEnums = [
	        'toString',
	        'toLocaleString',
	        'valueOf',
	        'hasOwnProperty',
	        'isPrototypeOf',
	        'propertyIsEnumerable',
	        'constructor'
	      ],
	      dontEnumsLength = dontEnums.length;
	
	    return function (obj) {
	      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
	        throw new TypeError('Object.keys called on non-object');
	      }
	
	      var result = [], prop, i;
	
	      for (prop in obj) {
	        if (hasOwnProperty.call(obj, prop)) {
	          result.push(prop);
	        }
	      }
	
	      if (hasDontEnumBug) {
	        for (i = 0; i < dontEnumsLength; i++) {
	          if (hasOwnProperty.call(obj, dontEnums[i])) {
	            result.push(dontEnums[i]);
	          }
	        }
	      }
	      return result;
	    };
	  }());
	}
	
	// http://ejohn.org/blog/objectgetprototypeof/
	if ( typeof Object.getPrototypeOf !== "function" ) {
	  if ( typeof "test".__proto__ === "object" ) {
	    Object.getPrototypeOf = function(object){
	      return object.__proto__;
	    };
	  } else {
	    Object.getPrototypeOf = function(object){
	      // May break if the constructor has been tampered with
	      return object.constructor.prototype;
	    };
	  }
	}
	
	(function() {
	  "use strict";
	
	  /**
	   * Take an UploadTask and create an interface for the user to monitor the
	   * file's upload. The $progress, $error, and $complete methods are provided
	   * to work with the $digest cycle.
	   *
	   * @param task
	   * @param $firebaseUtils
	   * @returns A converted task, which contains methods for monitoring the
	   * upload progress.
	   */
	  function _convertTask(task, $firebaseUtils) {
	    return {
	      $progress: function $progress(callback) {
	        task.on('state_changed', function () {
	          $firebaseUtils.compile(function () {
	            callback(_unwrapStorageSnapshot(task.snapshot));
	          });
	        });
	      },
	      $error: function $error(callback) {
	        task.on('state_changed', null, function (err) {
	          $firebaseUtils.compile(function () {
	            callback(err);
	          });
	        });
	      },
	      $complete: function $complete(callback) {
	        task.on('state_changed', null, null, function () {
	          $firebaseUtils.compile(function () {
	            callback(_unwrapStorageSnapshot(task.snapshot));
	          });
	        });
	      },
	      $cancel: task.cancel,
	      $resume: task.resume,
	      $pause: task.pause,
	      then: task.then,
	      catch: task.catch,
	      $snapshot: task.snapshot
	    };
	  }
	
	  /**
	   * Take an Firebase Storage snapshot and unwrap only the needed properties.
	   *
	   * @param snapshot
	   * @returns An object containing the unwrapped values.
	   */
	  function _unwrapStorageSnapshot(storageSnapshot) {
	    return {
	      bytesTransferred: storageSnapshot.bytesTransferred,
	      downloadURL: storageSnapshot.downloadURL,
	      metadata: storageSnapshot.metadata,
	      ref: storageSnapshot.ref,
	      state: storageSnapshot.state,
	      task: storageSnapshot.task,
	      totalBytes: storageSnapshot.totalBytes
	    };
	  }
	
	  /**
	   * Determines if the value passed in is a Firebase Storage Reference. The
	   * put method is used for the check.
	   *
	   * @param value
	   * @returns A boolean that indicates if the value is a Firebase Storage
	   * Reference.
	   */
	  function _isStorageRef(value) {
	    value = value || {};
	    return typeof value.put === 'function';
	  }
	
	  /**
	   * Checks if the parameter is a Firebase Storage Reference, and throws an
	   * error if it is not.
	   *
	   * @param storageRef
	   */
	  function _assertStorageRef(storageRef) {
	    if (!_isStorageRef(storageRef)) {
	      throw new Error('$firebaseStorage expects a Storage reference');
	    }
	  }
	
	  /**
	   * This constructor should probably never be called manually. It is setup
	   * for dependecy injection of the $firebaseUtils and $q service.
	   *
	   * @param {Object} $firebaseUtils
	   * @param {Object} $q
	   * @returns {Object}
	   * @constructor
	   */
	  function FirebaseStorage($firebaseUtils, $q) {
	
	    /**
	     * This inner constructor `Storage` allows for exporting of private methods
	     * like _assertStorageRef, _isStorageRef, _convertTask, and _unwrapStorageSnapshot.
	     */
	    var Storage = function Storage(storageRef) {
	      _assertStorageRef(storageRef);
	      return {
	        $put: function $put(file, metadata) {
	          var task = storageRef.put(file, metadata);
	          return _convertTask(task, $firebaseUtils);
	        },
	        $putString: function $putString(data, format, metadata) {
	          var task = storageRef.putString(data, format, metadata);
	          return _convertTask(task, $firebaseUtils);
	        },
	        $getDownloadURL: function $getDownloadURL() {
	          return $q.when(storageRef.getDownloadURL());
	        },
	        $delete: function $delete() {
	          return $q.when(storageRef.delete());
	        },
	        $getMetadata: function $getMetadata() {
	          return $q.when(storageRef.getMetadata());
	        },
	        $updateMetadata: function $updateMetadata(object) {
	          return $q.when(storageRef.updateMetadata(object));
	        },
	        $toString: function $toString() {
	          return storageRef.toString();
	        }
	      };
	    };
	
	    Storage.utils = {
	      _unwrapStorageSnapshot: _unwrapStorageSnapshot,
	      _isStorageRef: _isStorageRef,
	      _assertStorageRef: _assertStorageRef
	    };
	
	    return Storage;
	  }
	
	  /**
	   * Creates a wrapper for the firebase.storage() object. This factory allows
	   * you to upload files and monitor their progress and the callbacks are
	   * wrapped in the $digest cycle.
	   */
	  angular.module('firebase.storage')
	    .factory('$firebaseStorage', ["$firebaseUtils", "$q", FirebaseStorage]);
	
	})();
	
	/* istanbul ignore next */
	(function () {
	  "use strict";
	
	  function FirebaseStorageDirective($firebaseStorage, firebase) {
	    return {
	      restrict: 'A',
	      priority: 99, // run after the attributes are interpolated
	      scope: {},
	      link: function (scope, element, attrs) {
	        // $observe is like $watch but it waits for interpolation
	        // any value passed as an attribute is converted to a string
	        // if null or undefined is passed, it is converted to an empty string
	        // Ex: <img firebase-src="{{ myUrl }}"/>
	        attrs.$observe('firebaseSrc', function (newFirebaseSrcVal) {
	          if (newFirebaseSrcVal !== '') {
	            var storageRef = firebase.storage().ref(newFirebaseSrcVal);
	            var storage = $firebaseStorage(storageRef);
	            storage.$getDownloadURL().then(function getDownloadURL(url) {
	              element[0].src = url;
	            });
	          }
	        });
	      }
	    };
	  }
	  FirebaseStorageDirective.$inject = ['$firebaseStorage', 'firebase'];
	
	  angular.module('firebase.storage')
	    .directive('firebaseSrc', FirebaseStorageDirective);
	})();
	
	(function() {
	  'use strict';
	
	  angular.module('firebase.utils')
	    .factory('$firebaseConfig', ["$firebaseArray", "$firebaseObject", "$injector",
	      function($firebaseArray, $firebaseObject, $injector) {
	        return function(configOpts) {
	          // make a copy we can modify
	          var opts = angular.extend({}, configOpts);
	          // look up factories if passed as string names
	          if( typeof opts.objectFactory === 'string' ) {
	            opts.objectFactory = $injector.get(opts.objectFactory);
	          }
	          if( typeof opts.arrayFactory === 'string' ) {
	            opts.arrayFactory = $injector.get(opts.arrayFactory);
	          }
	          // extend defaults and return
	          return angular.extend({
	            arrayFactory: $firebaseArray,
	            objectFactory: $firebaseObject
	          }, opts);
	        };
	      }
	    ])
	
	    .factory('$firebaseUtils', ["$q", "$timeout", "$rootScope",
	      function($q, $timeout, $rootScope) {
	        var utils = {
	          /**
	           * Returns a function which, each time it is invoked, will gather up the values until
	           * the next "tick" in the Angular compiler process. Then they are all run at the same
	           * time to avoid multiple cycles of the digest loop. Internally, this is done using $evalAsync()
	           *
	           * @param {Function} action
	           * @param {Object} [context]
	           * @returns {Function}
	           */
	          batch: function(action, context) {
	            return function() {
	              var args = Array.prototype.slice.call(arguments, 0);
	              utils.compile(function() {
	                action.apply(context, args);
	              });
	            };
	          },
	
	          /**
	           * A rudimentary debounce method
	           * @param {function} fn the function to debounce
	           * @param {object} [ctx] the `this` context to set in fn
	           * @param {int} wait number of milliseconds to pause before sending out after each invocation
	           * @param {int} [maxWait] max milliseconds to wait before sending out, defaults to wait * 10 or 100
	           */
	          debounce: function(fn, ctx, wait, maxWait) {
	            var start, cancelTimer, args, runScheduledForNextTick;
	            if( typeof(ctx) === 'number' ) {
	              maxWait = wait;
	              wait = ctx;
	              ctx = null;
	            }
	
	            if( typeof wait !== 'number' ) {
	              throw new Error('Must provide a valid integer for wait. Try 0 for a default');
	            }
	            if( typeof(fn) !== 'function' ) {
	              throw new Error('Must provide a valid function to debounce');
	            }
	            if( !maxWait ) { maxWait = wait*10 || 100; }
	
	            // clears the current wait timer and creates a new one
	            // however, if maxWait is exceeded, calls runNow() on the next tick.
	            function resetTimer() {
	              if( cancelTimer ) {
	                cancelTimer();
	                cancelTimer = null;
	              }
	              if( start && Date.now() - start > maxWait ) {
	                if(!runScheduledForNextTick){
	                  runScheduledForNextTick = true;
	                  utils.compile(runNow);
	                }
	              }
	              else {
	                if( !start ) { start = Date.now(); }
	                cancelTimer = utils.wait(runNow, wait);
	              }
	            }
	
	            // Clears the queue and invokes the debounced function with the most recent arguments
	            function runNow() {
	              cancelTimer = null;
	              start = null;
	              runScheduledForNextTick = false;
	              fn.apply(ctx, args);
	            }
	
	            function debounced() {
	              args = Array.prototype.slice.call(arguments, 0);
	              resetTimer();
	            }
	            debounced.running = function() {
	              return start > 0;
	            };
	
	            return debounced;
	          },
	
	          assertValidRef: function(ref, msg) {
	            if( !angular.isObject(ref) ||
	              typeof(ref.ref) !== 'object' ||
	              typeof(ref.ref.transaction) !== 'function' ) {
	              throw new Error(msg || 'Invalid Firebase reference');
	            }
	          },
	
	          // http://stackoverflow.com/questions/7509831/alternative-for-the-deprecated-proto
	          // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
	          inherit: function(ChildClass, ParentClass, methods) {
	            var childMethods = ChildClass.prototype;
	            ChildClass.prototype = Object.create(ParentClass.prototype);
	            ChildClass.prototype.constructor = ChildClass; // restoring proper constructor for child class
	            angular.forEach(Object.keys(childMethods), function(k) {
	              ChildClass.prototype[k] = childMethods[k];
	            });
	            if( angular.isObject(methods) ) {
	              angular.extend(ChildClass.prototype, methods);
	            }
	            return ChildClass;
	          },
	
	          getPrototypeMethods: function(inst, iterator, context) {
	            var methods = {};
	            var objProto = Object.getPrototypeOf({});
	            var proto = angular.isFunction(inst) && angular.isObject(inst.prototype)?
	              inst.prototype : Object.getPrototypeOf(inst);
	            while(proto && proto !== objProto) {
	              for (var key in proto) {
	                // we only invoke each key once; if a super is overridden it's skipped here
	                if (proto.hasOwnProperty(key) && !methods.hasOwnProperty(key)) {
	                  methods[key] = true;
	                  iterator.call(context, proto[key], key, proto);
	                }
	              }
	              proto = Object.getPrototypeOf(proto);
	            }
	          },
	
	          getPublicMethods: function(inst, iterator, context) {
	            utils.getPrototypeMethods(inst, function(m, k) {
	              if( typeof(m) === 'function' && k.charAt(0) !== '_' ) {
	                iterator.call(context, m, k);
	              }
	            });
	          },
	
	          makeNodeResolver:function(deferred){
	            return function(err,result){
	              if(err === null){
	                if(arguments.length > 2){
	                  result = Array.prototype.slice.call(arguments,1);
	                }
	
	                deferred.resolve(result);
	              }
	              else {
	                deferred.reject(err);
	              }
	            };
	          },
	
	          wait: function(fn, wait) {
	            var to = $timeout(fn, wait||0);
	            return function() {
	              if( to ) {
	                $timeout.cancel(to);
	                to = null;
	              }
	            };
	          },
	
	          compile: function(fn) {
	            return $rootScope.$evalAsync(fn||function() {});
	          },
	
	          deepCopy: function(obj) {
	            if( !angular.isObject(obj) ) { return obj; }
	            var newCopy = angular.isArray(obj) ? obj.slice() : angular.extend({}, obj);
	            for (var key in newCopy) {
	              if (newCopy.hasOwnProperty(key)) {
	                if (angular.isObject(newCopy[key])) {
	                  newCopy[key] = utils.deepCopy(newCopy[key]);
	                }
	              }
	            }
	            return newCopy;
	          },
	
	          trimKeys: function(dest, source) {
	            utils.each(dest, function(v,k) {
	              if( !source.hasOwnProperty(k) ) {
	                delete dest[k];
	              }
	            });
	          },
	
	          scopeData: function(dataOrRec) {
	            var data = {
	              $id: dataOrRec.$id,
	              $priority: dataOrRec.$priority
	            };
	            var hasPublicProp = false;
	            utils.each(dataOrRec, function(v,k) {
	              hasPublicProp = true;
	              data[k] = utils.deepCopy(v);
	            });
	            if(!hasPublicProp && dataOrRec.hasOwnProperty('$value')){
	              data.$value = dataOrRec.$value;
	            }
	            return data;
	          },
	
	          updateRec: function(rec, snap) {
	            var data = snap.val();
	            var oldData = angular.extend({}, rec);
	
	            // deal with primitives
	            if( !angular.isObject(data) ) {
	              rec.$value = data;
	              data = {};
	            }
	            else {
	              delete rec.$value;
	            }
	
	            // apply changes: remove old keys, insert new data, set priority
	            utils.trimKeys(rec, data);
	            angular.extend(rec, data);
	            rec.$priority = snap.getPriority();
	
	            return !angular.equals(oldData, rec) ||
	              oldData.$value !== rec.$value ||
	              oldData.$priority !== rec.$priority;
	          },
	
	          applyDefaults: function(rec, defaults) {
	            if( angular.isObject(defaults) ) {
	              angular.forEach(defaults, function(v,k) {
	                if( !rec.hasOwnProperty(k) ) {
	                  rec[k] = v;
	                }
	              });
	            }
	            return rec;
	          },
	
	          dataKeys: function(obj) {
	            var out = [];
	            utils.each(obj, function(v,k) {
	              out.push(k);
	            });
	            return out;
	          },
	
	          each: function(obj, iterator, context) {
	            if(angular.isObject(obj)) {
	              for (var k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                  var c = k.charAt(0);
	                  if( c !== '_' && c !== '$' && c !== '.' ) {
	                    iterator.call(context, obj[k], k, obj);
	                  }
	                }
	              }
	            }
	            else if(angular.isArray(obj)) {
	              for(var i = 0, len = obj.length; i < len; i++) {
	                iterator.call(context, obj[i], i, obj);
	              }
	            }
	            return obj;
	          },
	
	          /**
	           * A utility for converting records to JSON objects
	           * which we can save into Firebase. It asserts valid
	           * keys and strips off any items prefixed with $.
	           *
	           * If the rec passed into this method has a toJSON()
	           * method, that will be used in place of the custom
	           * functionality here.
	           *
	           * @param rec
	           * @returns {*}
	           */
	          toJSON: function(rec) {
	            var dat;
	            if( !angular.isObject(rec) ) {
	              rec = {$value: rec};
	            }
	            if (angular.isFunction(rec.toJSON)) {
	              dat = rec.toJSON();
	            }
	            else {
	              dat = {};
	              utils.each(rec, function (v, k) {
	                dat[k] = stripDollarPrefixedKeys(v);
	              });
	            }
	            if( angular.isDefined(rec.$value) && Object.keys(dat).length === 0 && rec.$value !== null ) {
	              dat['.value'] = rec.$value;
	            }
	            if( angular.isDefined(rec.$priority) && Object.keys(dat).length > 0 && rec.$priority !== null ) {
	              dat['.priority'] = rec.$priority;
	            }
	            angular.forEach(dat, function(v,k) {
	              if (k.match(/[.$\[\]#\/]/) && k !== '.value' && k !== '.priority' ) {
	                throw new Error('Invalid key ' + k + ' (cannot contain .$[]#/)');
	              }
	              else if( angular.isUndefined(v) ) {
	                throw new Error('Key '+k+' was undefined. Cannot pass undefined in JSON. Use null instead.');
	              }
	            });
	            return dat;
	          },
	
	          doSet: function(ref, data) {
	            var def = $q.defer();
	            if( angular.isFunction(ref.set) || !angular.isObject(data) ) {
	              // this is not a query, just do a flat set
	              // Use try / catch to handle being passed data which is undefined or has invalid keys
	              try {
	                ref.set(data, utils.makeNodeResolver(def));
	              } catch (err) {
	                def.reject(err);
	              }
	            }
	            else {
	              var dataCopy = angular.extend({}, data);
	              // this is a query, so we will replace all the elements
	              // of this query with the value provided, but not blow away
	              // the entire Firebase path
	              ref.once('value', function(snap) {
	                snap.forEach(function(ss) {
	                  if( !dataCopy.hasOwnProperty(ss.key) ) {
	                    dataCopy[ss.key] = null;
	                  }
	                });
	                ref.ref.update(dataCopy, utils.makeNodeResolver(def));
	              }, function(err) {
	                def.reject(err);
	              });
	            }
	            return def.promise;
	          },
	
	          doRemove: function(ref) {
	            var def = $q.defer();
	            if( angular.isFunction(ref.remove) ) {
	              // ref is not a query, just do a flat remove
	              ref.remove(utils.makeNodeResolver(def));
	            }
	            else {
	              // ref is a query so let's only remove the
	              // items in the query and not the entire path
	              ref.once('value', function(snap) {
	                var promises = [];
	                snap.forEach(function(ss) {
	                  promises.push(ss.ref.remove());
	                });
	                utils.allPromises(promises)
	                  .then(function() {
	                    def.resolve(ref);
	                  },
	                  function(err){
	                    def.reject(err);
	                  }
	                );
	              }, function(err) {
	                def.reject(err);
	              });
	            }
	            return def.promise;
	          },
	
	          /**
	           * AngularFire version number.
	           */
	          VERSION: '0.0.0',
	
	          allPromises: $q.all.bind($q)
	        };
	
	        return utils;
	      }
	    ]);
	
	    function stripDollarPrefixedKeys(data) {
	      if( !angular.isObject(data) ) { return data; }
	      var out = angular.isArray(data)? [] : {};
	      angular.forEach(data, function(v,k) {
	        if(typeof k !== 'string' || k.charAt(0) !== '$') {
	          out[k] = stripDollarPrefixedKeys(v);
	        }
	      });
	      return out;
	    }
	})();


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(414);
	module.exports = 'smart-table';

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	/** 
	* @version 2.1.10
	* @license MIT
	*/
	(function (ng, undefined){
	    'use strict';
	
	ng.module('smart-table', []).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('template/smart-table/pagination.html',
	        '<nav ng-if="numPages && pages.length >= 2"><ul class="pagination">' +
	        '<li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="#" ng-click="selectPage(page); $event.preventDefault(); $event.stopPropagation();">{{page}}</a></li>' +
	        '</ul></nav>');
	}]);
	
	
	ng.module('smart-table')
	  .constant('stConfig', {
	    pagination: {
	      template: 'template/smart-table/pagination.html',
	      itemsByPage: 10,
	      displayedPages: 5
	    },
	    search: {
	      delay: 400, // ms
	      inputEvent: 'input',
	      trimSearch: false
	    },
	    select: {
	      mode: 'single',
	      selectedClass: 'st-selected'
	    },
	    sort: {
	      ascentClass: 'st-sort-ascent',
	      descentClass: 'st-sort-descent',
	      descendingFirst: false,
	      skipNatural: false,
	      delay:300
	    },
	    pipe: {
	      delay: 100 //ms
	    }
	  });
	ng.module('smart-table').controller('stTableController', [
	  '$scope',
	  '$parse',
	  '$filter',
	  '$attrs',
	  function StTableController($scope, $parse, $filter, $attrs) {
	    var propertyName = $attrs.stTable;
	    var displayGetter = $parse(propertyName);
	    var displaySetter = displayGetter.assign;
	    var safeGetter;
	    var orderBy = $filter('orderBy');
	    var filter = $filter('filter');
	    var safeCopy = copyRefs(displayGetter($scope));
	    var tableState = {
	      sort: {},
	      search: {},
	      pagination: { start: 0, totalItemCount: 0 }
	    };
	    var filtered;
	    var pipeAfterSafeCopy = true;
	    var ctrl = this;
	    var lastSelected;
	
	    function copyRefs(src) {
	      return src ? [].concat(src) : [];
	    }
	
	    function updateSafeCopy() {
	      safeCopy = copyRefs(safeGetter($scope));
	      if (pipeAfterSafeCopy === true) {
	        ctrl.pipe();
	      }
	    }
	
	    function deepDelete(object, path) {
	      if (path.indexOf('.') != -1) {
	        var partials = path.split('.');
	        var key = partials.pop();
	        var parentPath = partials.join('.');
	        var parentObject = $parse(parentPath)(object);
	        delete parentObject[key];
	        if (Object.keys(parentObject).length == 0) {
	          deepDelete(object, parentPath);
	        }
	      } else {
	        delete object[path];
	      }
	    }
	
	    if ($attrs.stSafeSrc) {
	      safeGetter = $parse($attrs.stSafeSrc);
	      $scope.$watch(
	        function() {
	          var safeSrc = safeGetter($scope);
	          return safeSrc && safeSrc.length ? safeSrc[0] : undefined;
	        },
	        function(newValue, oldValue) {
	          if (newValue !== oldValue) {
	            updateSafeCopy();
	          }
	        }
	      );
	      $scope.$watch(
	        function() {
	          var safeSrc = safeGetter($scope);
	          return safeSrc ? safeSrc.length : 0;
	        },
	        function(newValue, oldValue) {
	          if (newValue !== safeCopy.length) {
	            updateSafeCopy();
	          }
	        }
	      );
	      $scope.$watch(
	        function() {
	          return safeGetter($scope);
	        },
	        function(newValue, oldValue) {
	          if (newValue !== oldValue) {
	            tableState.pagination.start = 0;
	            updateSafeCopy();
	          }
	        }
	      );
	    }
	
	    /**
	     * sort the rows
	     * @param {Function | String} predicate - function or string which will be used as predicate for the sorting
	     * @param [reverse] - if you want to reverse the order
	     */
	    this.sortBy = function sortBy(predicate, reverse) {
	      tableState.sort.predicate = predicate;
	      tableState.sort.reverse = reverse === true;
	
	      if (ng.isFunction(predicate)) {
	        tableState.sort.functionName = predicate.name;
	      } else {
	        delete tableState.sort.functionName;
	      }
	
	      tableState.pagination.start = 0;
	      return this.pipe();
	    };
	
	    /**
	     * search matching rows
	     * @param {String} input - the input string
	     * @param {String} [predicate] - the property name against you want to check the match, otherwise it will search on all properties
	     * @param {String | Function } [comparator] - a comparator to pass to the filter for the (pass true for stric mode)
	     */
	    this.search = function search(input, predicate, comparator) {
	      var predicateObject = tableState.search.predicateObject || {};
	      var prop = predicate ? predicate : '$';
	
	      $parse(prop).assign(predicateObject, input);
	      // to avoid to filter out null value
	      if (!input) {
	        deepDelete(predicateObject, prop);
	      }
	      tableState.search.predicateObject = predicateObject;
	      tableState.pagination.start = 0;
	      return this.pipe();
	    };
	
	    /**
	     * this will chain the operations of sorting and filtering based on the current table state (sort options, filtering, ect)
	     */
	    this.pipe = function pipe() {
	      var pagination = tableState.pagination;
	      var output;
	      filtered = tableState.search.predicateObject
	        ? filter(safeCopy, tableState.search.predicateObject)
	        : safeCopy;
	      if (tableState.sort.predicate) {
	        filtered = orderBy(
	          filtered,
	          tableState.sort.predicate,
	          tableState.sort.reverse
	        );
	      }
	      pagination.totalItemCount = filtered.length;
	      if (pagination.number !== undefined) {
	        pagination.numberOfPages = filtered.length > 0
	          ? Math.ceil(filtered.length / pagination.number)
	          : 1;
	        pagination.start = pagination.start >= filtered.length
	          ? (pagination.numberOfPages - 1) * pagination.number
	          : pagination.start;
	        output = filtered.slice(
	          pagination.start,
	          pagination.start + parseInt(pagination.number)
	        );
	      }
	      displaySetter($scope, output || filtered);
	    };
	
	    /**
	     * select a dataRow (it will add the attribute isSelected to the row object)
	     * @param {Object} row - the row to select
	     * @param {String} [mode] - "single" or "multiple" (multiple by default)
	     */
	    this.select = function select(row, mode) {
	      var rows = copyRefs(displayGetter($scope));
	      var index = rows.indexOf(row);
	      if (index !== -1) {
	        if (mode === 'single') {
	          row.isSelected = row.isSelected !== true;
	          if (lastSelected) {
	            lastSelected.isSelected = false;
	          }
	          lastSelected = row.isSelected === true ? row : undefined;
	        } else {
	          rows[index].isSelected = !rows[index].isSelected;
	        }
	      }
	    };
	
	    /**
	     * take a slice of the current sorted/filtered collection (pagination)
	     *
	     * @param {Number} start - start index of the slice
	     * @param {Number} number - the number of item in the slice
	     */
	    this.slice = function splice(start, number) {
	      tableState.pagination.start = start;
	      tableState.pagination.number = number;
	      return this.pipe();
	    };
	
	    /**
	     * return the current state of the table
	     * @returns {{sort: {}, search: {}, pagination: {start: number}}}
	     */
	    this.tableState = function getTableState() {
	      return tableState;
	    };
	
	    this.getFilteredCollection = function getFilteredCollection() {
	      return filtered || safeCopy;
	    };
	
	    /**
	     * Use a different filter function than the angular FilterFilter
	     * @param filterName the name under which the custom filter is registered
	     */
	    this.setFilterFunction = function setFilterFunction(filterName) {
	      filter = $filter(filterName);
	    };
	
	    /**
	     * Use a different function than the angular orderBy
	     * @param sortFunctionName the name under which the custom order function is registered
	     */
	    this.setSortFunction = function setSortFunction(sortFunctionName) {
	      orderBy = $filter(sortFunctionName);
	    };
	
	    /**
	     * Usually when the safe copy is updated the pipe function is called.
	     * Calling this method will prevent it, which is something required when using a custom pipe function
	     */
	    this.preventPipeOnWatch = function preventPipe() {
	      pipeAfterSafeCopy = false;
	    };
	  }
	]).directive('stTable', function() {
	  return {
	    restrict: 'A',
	    controller: 'stTableController',
	    link: function(scope, element, attr, ctrl) {
	      if (attr.stSetFilter) {
	        ctrl.setFilterFunction(attr.stSetFilter);
	      }
	
	      if (attr.stSetSort) {
	        ctrl.setSortFunction(attr.stSetSort);
	      }
	    }
	  };
	});
	
	ng.module('smart-table')
	  .directive('stSearch', ['stConfig', '$timeout','$parse', function (stConfig, $timeout, $parse) {
	    return {
	      require: '^stTable',
	      link: function (scope, element, attr, ctrl) {
	        var tableCtrl = ctrl;
	        var promise = null;
	        var throttle = attr.stDelay || stConfig.search.delay;
	        var event = attr.stInputEvent || stConfig.search.inputEvent;
	        var trimSearch = attr.trimSearch || stConfig.search.trimSearch;
	
	        attr.$observe('stSearch', function (newValue, oldValue) {
	          var input = element[0].value;
	          if (newValue !== oldValue && input) {
	            ctrl.tableState().search = {};
	            input = ng.isString(input) && trimSearch ? input.trim() : input;
	            tableCtrl.search(input, newValue);
	          }
	        });
	
	        //table state -> view
	        scope.$watch(function () {
	          return ctrl.tableState().search;
	        }, function (newValue, oldValue) {
	          var predicateExpression = attr.stSearch || '$';
	          if (newValue.predicateObject && $parse(predicateExpression)(newValue.predicateObject) !== element[0].value) {
	            element[0].value = $parse(predicateExpression)(newValue.predicateObject) || '';
	          }
	        }, true);
	
	        // view -> table state
	        element.bind(event, function (evt) {
	          evt = evt.originalEvent || evt;
	          if (promise !== null) {
	            $timeout.cancel(promise);
	          }
	
	          promise = $timeout(function () {
	            var input = evt.target.value;
	            input = ng.isString(input) && trimSearch ? input.trim() : input;
	            tableCtrl.search(input, attr.stSearch || '');
	            promise = null;
	          }, throttle);
	        });
	      }
	    };
	  }]);
	
	ng.module('smart-table')
	  .directive('stSelectRow', ['stConfig', function (stConfig) {
	    return {
	      restrict: 'A',
	      require: '^stTable',
	      scope: {
	        row: '=stSelectRow'
	      },
	      link: function (scope, element, attr, ctrl) {
	        var mode = attr.stSelectMode || stConfig.select.mode;
	        element.bind('click', function () {
	          scope.$apply(function () {
	            ctrl.select(scope.row, mode);
	          });
	        });
	
	        scope.$watch('row.isSelected', function (newValue) {
	          if (newValue === true) {
	            element.addClass(stConfig.select.selectedClass);
	          } else {
	            element.removeClass(stConfig.select.selectedClass);
	          }
	        });
	      }
	    };
	  }]);
	
	ng.module('smart-table')
	  .directive('stSort', ['stConfig', '$parse', '$timeout', function (stConfig, $parse, $timeout) {
	    return {
	      restrict: 'A',
	      require: '^stTable',
	      link: function (scope, element, attr, ctrl) {
	
	        var predicate = attr.stSort;
	        var getter = $parse(predicate);
	        var index = 0;
	        var classAscent = attr.stClassAscent || stConfig.sort.ascentClass;
	        var classDescent = attr.stClassDescent || stConfig.sort.descentClass;
	        var stateClasses = [classAscent, classDescent];
	        var sortDefault;
	        var skipNatural = attr.stSkipNatural !== undefined ? attr.stSkipNatural : stConfig.sort.skipNatural;
	        var descendingFirst = attr.stDescendingFirst !== undefined ? attr.stDescendingFirst : stConfig.sort.descendingFirst;
	        var promise = null;
	        var throttle = attr.stDelay || stConfig.sort.delay;
	
	        // set aria attributes
	        var ariaSort = 'aria-sort';
	        var ariaSortNone = 'none';
	        var ariaSortAscending = 'ascending';
	        var ariaSortDescending = 'descending';
	        element
	          .attr('role', 'columnheader')
	          .attr(ariaSort, ariaSortNone);
	
	        if (attr.stSortDefault) {
	          sortDefault = scope.$eval(attr.stSortDefault) !== undefined ? scope.$eval(attr.stSortDefault) : attr.stSortDefault;
	        }
	
	        //view --> table state
	        function sort () {
	          if (descendingFirst) {
	            index = index === 0 ? 2 : index - 1;
	          } else {
	            index++;
	          }
	
	          var func;
	          predicate = ng.isFunction(getter(scope)) || ng.isArray(getter(scope)) ? getter(scope) : attr.stSort;
	          if (index % 3 === 0 && !!skipNatural !== true) {
	            //manual reset
	            index = 0;
	            ctrl.tableState().sort = {};
	            ctrl.tableState().pagination.start = 0;
	            func = ctrl.pipe.bind(ctrl);
	          } else {
	            func = ctrl.sortBy.bind(ctrl, predicate, index % 2 === 0);
	          }
	          if (promise !== null) {
	            $timeout.cancel(promise);
	          }
	          if (throttle < 0) {
	            func();
	          } else {
	            promise = $timeout(function(){
	              func();
	            }, throttle);
	          }
	        }
	
	        element.bind('click', function sortClick () {
	          if (predicate) {
	            scope.$apply(sort);
	          }
	        });
	
	        if (sortDefault) {
	          index = sortDefault === 'reverse' ? 1 : 0;
	          sort();
	        }
	
	        //table state --> view
	        scope.$watch(function () {
	          return ctrl.tableState().sort;
	        }, function (newValue) {
	          if (newValue.predicate !== predicate) {
	            index = 0;
	            element
	              .removeClass(classAscent)
	              .removeClass(classDescent)
	              .attr(ariaSort, ariaSortNone);
	          } else {
	            index = newValue.reverse === true ? 2 : 1;
	            element
	              .removeClass(stateClasses[index % 2])
	              .addClass(stateClasses[index - 1])
	              .attr(ariaSort, newValue.reverse ? ariaSortAscending : ariaSortDescending);
	          }
	        }, true);
	      }
	    };
	  }]);
	
	ng.module('smart-table')
	  .directive('stPagination', ['stConfig', function (stConfig) {
	    return {
	      restrict: 'EA',
	      require: '^stTable',
	      scope: {
	        stItemsByPage: '=?',
	        stDisplayedPages: '=?',
	        stPageChange: '&'
	      },
	      templateUrl: function (element, attrs) {
	        if (attrs.stTemplate) {
	          return attrs.stTemplate;
	        }
	        return stConfig.pagination.template;
	      },
	      link: function (scope, element, attrs, ctrl) {
	
	        scope.stItemsByPage = scope.stItemsByPage ? +(scope.stItemsByPage) : stConfig.pagination.itemsByPage;
	        scope.stDisplayedPages = scope.stDisplayedPages ? +(scope.stDisplayedPages) : stConfig.pagination.displayedPages;
	
	        scope.currentPage = 1;
	        scope.pages = [];
	
	        function redraw () {
	          var paginationState = ctrl.tableState().pagination;
	          var start = 1;
	          var end;
	          var i;
	          var prevPage = scope.currentPage;
	          scope.totalItemCount = paginationState.totalItemCount;
	          scope.currentPage = Math.floor(paginationState.start / paginationState.number) + 1;
	
	          start = Math.max(start, scope.currentPage - Math.abs(Math.floor(scope.stDisplayedPages / 2)));
	          end = start + scope.stDisplayedPages;
	
	          if (end > paginationState.numberOfPages) {
	            end = paginationState.numberOfPages + 1;
	            start = Math.max(1, end - scope.stDisplayedPages);
	          }
	
	          scope.pages = [];
	          scope.numPages = paginationState.numberOfPages;
	
	          for (i = start; i < end; i++) {
	            scope.pages.push(i);
	          }
	
	          if (prevPage !== scope.currentPage) {
	            scope.stPageChange({newPage: scope.currentPage});
	          }
	        }
	
	        //table state --> view
	        scope.$watch(function () {
	          return ctrl.tableState().pagination;
	        }, redraw, true);
	
	        //scope --> table state  (--> view)
	        scope.$watch('stItemsByPage', function (newValue, oldValue) {
	          if (newValue !== oldValue) {
	            scope.selectPage(1);
	          }
	        });
	
	        scope.$watch('stDisplayedPages', redraw);
	
	        //view -> table state
	        scope.selectPage = function (page) {
	          if (page > 0 && page <= scope.numPages) {
	            ctrl.slice((page - 1) * scope.stItemsByPage, scope.stItemsByPage);
	          }
	        };
	
	        if (!ctrl.tableState().pagination.number) {
	          ctrl.slice(0, scope.stItemsByPage);
	        }
	      }
	    };
	  }]);
	
	ng.module('smart-table')
	  .directive('stPipe', ['stConfig', '$timeout', function (config, $timeout) {
	    return {
	      require: 'stTable',
	      scope: {
	        stPipe: '='
	      },
	      link: {
	
	        pre: function (scope, element, attrs, ctrl) {
	
	          var pipePromise = null;
	
	          if (ng.isFunction(scope.stPipe)) {
	            ctrl.preventPipeOnWatch();
	            ctrl.pipe = function () {
	
	              if (pipePromise !== null) {
	                $timeout.cancel(pipePromise)
	              }
	
	              pipePromise = $timeout(function () {
	                scope.stPipe(ctrl.tableState(), ctrl);
	              }, config.pipe.delay);
	
	              return pipePromise;
	            }
	          }
	        },
	
	        post: function (scope, element, attrs, ctrl) {
	          ctrl.pipe();
	        }
	      }
	    };
	  }]);
	
	})(angular);

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */
415,
/* 434 */,
/* 435 */
415,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(__webpack_module_template_argument_1__);
	exports.Duplex = __webpack_require__(__webpack_module_template_argument_2__);
	exports.Transform = __webpack_require__(__webpack_module_template_argument_3__);
	exports.PassThrough = __webpack_require__(__webpack_module_template_argument_4__);


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(290);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(285);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(291).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(__webpack_module_template_argument_0__);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(__webpack_module_template_argument_1__).Buffer;
	var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(294));
	util.inherits = __webpack_require__(__webpack_module_template_argument_2__);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(__webpack_module_template_argument_3__);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(__webpack_module_template_argument_4__);
	var destroyImpl = __webpack_require__(__webpack_module_template_argument_5__);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(__webpack_module_template_argument_6__);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(__webpack_module_template_argument_7__).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(__webpack_module_template_argument_8__);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(__webpack_module_template_argument_9__).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', state.awaitDrain);
	        state.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, { hasUnpiped: false });
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(219)))

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(__webpack_module_template_argument_0__).Buffer;
	var util = __webpack_require__(__webpack_module_template_argument_1__);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(290);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(294));
	util.inherits = __webpack_require__(__webpack_module_template_argument_0__);
	/*</replacement>*/
	
	var Readable = __webpack_require__(__webpack_module_template_argument_1__);
	var Writable = __webpack_require__(__webpack_module_template_argument_2__);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(290);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(294));
	util.inherits = __webpack_require__(__webpack_module_template_argument_0__);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(301)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(__webpack_module_template_argument_1__);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(__webpack_module_template_argument_2__).Buffer;
	var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(__webpack_module_template_argument_3__);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(__webpack_module_template_argument_4__);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(__webpack_module_template_argument_5__);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	
	  // reuse the free corkReq.
	  state.corkedRequestsFree.next = corkReq;
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(219), (function() { return this; }())))

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(__webpack_module_template_argument_0__).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(__webpack_module_template_argument_0__);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(294));
	util.inherits = __webpack_require__(__webpack_module_template_argument_1__);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(__webpack_module_template_argument_0__);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(294));
	util.inherits = __webpack_require__(__webpack_module_template_argument_1__);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ })
]);


// WEBPACK FOOTER //
// app.c8a2e54a78e71066fdf8.js